/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_controllers_1 = __webpack_require__(1);
	var index_services_1 = __webpack_require__(135);
	var index_directives_1 = __webpack_require__(257);
	var index_filters_1 = __webpack_require__(308);
	var index_config_1 = __webpack_require__(322);
	var index_run_1 = __webpack_require__(335);
	var index_plugins_1 = __webpack_require__(339);
	var armsWeb;
	(function (armsWeb) {
	    'use strict';
	    angular.module('armsWeb', [
	        'ngCookies',
	        'ngTouch',
	        'ngSanitize',
	        'ngMessages',
	        'ngAria',
	        'restangular',
	        'ui.router',
	        'ui.bootstrap',
	        'gridshore.c3js.chart',
	        'satellizer',
	        'angularjs-dropdown-multiselect',
	        'ngFileUpload',
	        'angularCesium',
	        'angular-loading-bar',
	        'pascalprecht.translate',
	        'vcRecaptcha',
	        'angular.filter',
	        index_controllers_1.default.name,
	        index_services_1.default.name,
	        index_directives_1.default.name,
	        index_filters_1.default.name,
	        index_config_1.default.name,
	        index_run_1.default.name,
	        index_plugins_1.default.name
	    ]);
	})(armsWeb || (armsWeb = {}));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** controllerInject */
	var sc_report_generation_controller_1 = __webpack_require__(2);
	var sc_flight_search_controller_1 = __webpack_require__(12);
	var sc_inactivity_expiry_notice_controller_1 = __webpack_require__(13);
	var aerodrome_operational_hours_controller_1 = __webpack_require__(14);
	var interest_rates_controller_1 = __webpack_require__(15);
	var service_outages_controller_1 = __webpack_require__(16);
	var sc_approval_request_controller_1 = __webpack_require__(17);
	var sc_credit_payment_controller_1 = __webpack_require__(18);
	var password_change_controller_1 = __webpack_require__(20);
	var aircraft_flights_exemptions_controller_1 = __webpack_require__(21);
	var sc_passenger_service_charge_return_controller_1 = __webpack_require__(22);
	var sc_invoices_controller_1 = __webpack_require__(25);
	var sc_transactions_controller_1 = __webpack_require__(27);
	var sc_flight_schedules_controller_1 = __webpack_require__(28);
	var sc_aircraft_registration_controller_1 = __webpack_require__(29);
	var sc_user_management_controller_1 = __webpack_require__(30);
	var sc_user_registration_controller_1 = __webpack_require__(31);
	var sc_account_management_controller_1 = __webpack_require__(32);
	var sc_flight_cost_calculation_controller_1 = __webpack_require__(33);
	var sc_query_submission_controller_1 = __webpack_require__(34);
	var sc_login_controller_1 = __webpack_require__(35);
	var sc_home_page_controller_1 = __webpack_require__(37);
	var cached_events_controller_1 = __webpack_require__(38);
	var flight_schedule_management_controller_1 = __webpack_require__(39);
	var local_aircraft_registry_controller_1 = __webpack_require__(40);
	var user_event_log_controller_1 = __webpack_require__(41);
	var help_controller_1 = __webpack_require__(42);
	var application_management_controller_1 = __webpack_require__(43);
	var non_aviation_billing_engine_controller_1 = __webpack_require__(44);
	var revenue_data_controller_1 = __webpack_require__(45);
	var rejected_items_controller_1 = __webpack_require__(46);
	var recurring_charges_controller_1 = __webpack_require__(49);
	var report_generation_controller_1 = __webpack_require__(50);
	var air_traffic_data_controller_1 = __webpack_require__(51);
	var report_templates_controller_1 = __webpack_require__(52);
	var repositioning_aerodrome_clusters_controller_1 = __webpack_require__(53);
	var system_summary_controller_1 = __webpack_require__(54);
	var tower_movement_logs_controller_1 = __webpack_require__(55);
	var atc_movement_log_controller_1 = __webpack_require__(56);
	var billing_centre_management_controller_1 = __webpack_require__(58);
	var unspecified_dep_dest_locations_controller_1 = __webpack_require__(59);
	var nominal_routes_controller_1 = __webpack_require__(62);
	var flight_status_exemptions_controller_1 = __webpack_require__(63);
	var flight_route_exemptions_controller_1 = __webpack_require__(64);
	var aircraft_unspecified_management_controller_1 = __webpack_require__(65);
	var radar_summary_controller_1 = __webpack_require__(66);
	var invoice_template_management_controller_1 = __webpack_require__(67);
	var enroute_air_navigation_charges_management_controller_1 = __webpack_require__(68);
	var catalogue_service_charge_controller_1 = __webpack_require__(69);
	var invoice_generation_controller_1 = __webpack_require__(70);
	var flight_movement_management_controller_1 = __webpack_require__(74);
	var airspace_management_controller_1 = __webpack_require__(78);
	var account_exempt_management_controller_1 = __webpack_require__(79);
	var utilities_towns_controller_1 = __webpack_require__(80);
	var utilities_schedules_controller_1 = __webpack_require__(81);
	var regional_country_management_controller_1 = __webpack_require__(82);
	var map_controller_1 = __webpack_require__(83);
	var aircraft_exempt_management_controller_1 = __webpack_require__(88);
	var crco_certificates_controller_1 = __webpack_require__(89);
	var crco_reporting_responsabilities_controller_1 = __webpack_require__(90);
	var crco_archive_controller_1 = __webpack_require__(91);
	var crco_cor_request_controller_1 = __webpack_require__(92);
	var crco_connections_controller_1 = __webpack_require__(93);
	var crco_messages_controller_1 = __webpack_require__(94);
	var crco_claims_controller_1 = __webpack_require__(95);
	var mtow_controller_1 = __webpack_require__(96);
	var invoices_controller_1 = __webpack_require__(97);
	var aviation_billing_engine_controller_1 = __webpack_require__(99);
	var air_navigation_charges_controller_1 = __webpack_require__(100);
	var system_configuration_controller_1 = __webpack_require__(101);
	var passenger_service_charge_return_controller_1 = __webpack_require__(102);
	var transactions_controller_1 = __webpack_require__(103);
	var aircraft_registration_controller_1 = __webpack_require__(105);
	var currency_management_controller_1 = __webpack_require__(106);
	var accounts_controller_1 = __webpack_require__(107);
	var aerodrome_category_management_controller_1 = __webpack_require__(108);
	var aerodromes_controller_1 = __webpack_require__(109);
	var main_controller_1 = __webpack_require__(110);
	var users_controller_1 = __webpack_require__(113);
	var login_controller_1 = __webpack_require__(114);
	var amhs_connection_controller_1 = __webpack_require__(115);
	var amhs_accounts_controller_1 = __webpack_require__(116);
	var aircraft_type_management_controller_1 = __webpack_require__(117);
	var group_management_controller_1 = __webpack_require__(118);
	var about_controller_1 = __webpack_require__(119);
	var flight_movement_table_controller_1 = __webpack_require__(120);
	var country_management_controller_1 = __webpack_require__(121);
	var plugins_controller_1 = __webpack_require__(122);
	var system_configuration_item_controller_1 = __webpack_require__(123);
	var passenger_revenue_reconciliation_controller_1 = __webpack_require__(124);
	var tableSort_controller_1 = __webpack_require__(125);
	var transactions_pending_controller_1 = __webpack_require__(126);
	var transactions_workflow_controller_1 = __webpack_require__(127);
	var revenue_projection_controller_1 = __webpack_require__(128);
	var current_user_controller_1 = __webpack_require__(129);
	var flight_reassignment_controller_1 = __webpack_require__(130);
	var bank_account_management_controller_1 = __webpack_require__(131);
	var unified_tax_management_controller_1 = __webpack_require__(132);
	var sso_providers_controller_1 = __webpack_require__(133);
	var aodb_controller_1 = __webpack_require__(134);
	// controller module
	exports.default = angular.module('armsWeb.controllers', [])
	    .controller('ScReportGenerationController', sc_report_generation_controller_1.ScReportGenerationController)
	    .controller('ScFlightSearchController', sc_flight_search_controller_1.ScFlightSearchController)
	    .controller('ScInactivityExpiryNoticeController', sc_inactivity_expiry_notice_controller_1.ScInactivityExpiryNoticeController)
	    .controller('AerodromeOperationalHoursController', aerodrome_operational_hours_controller_1.AerodromeOperationalHoursController)
	    .controller('InterestRatesController', interest_rates_controller_1.InterestRatesController)
	    .controller('ServiceOutagesController', service_outages_controller_1.ServiceOutagesController)
	    .controller('ScApprovalRequestController', sc_approval_request_controller_1.ScApprovalRequestController)
	    .controller('PasswordChangeController', password_change_controller_1.PasswordChangeController)
	    .controller('AircraftFlightsExemptionsController', aircraft_flights_exemptions_controller_1.AircraftFlightsExemptionsController)
	    .controller('ScPassengerServiceChargeReturnController', sc_passenger_service_charge_return_controller_1.ScPassengerServiceChargeReturnController)
	    .controller('ScCreditPaymentController', sc_credit_payment_controller_1.ScCreditPaymentController)
	    .controller('ScInvoicesController', sc_invoices_controller_1.ScInvoicesController)
	    .controller('ScTransactionsController', sc_transactions_controller_1.ScTransactionsController)
	    .controller('ScFlightSchedulesController', sc_flight_schedules_controller_1.ScFlightSchedulesController)
	    .controller('ScAircraftRegistrationController', sc_aircraft_registration_controller_1.ScAircraftRegistrationController)
	    .controller('ScUserManagementController', sc_user_management_controller_1.ScUserManagementController)
	    .controller('ScUserRegistrationController', sc_user_registration_controller_1.ScUserRegistrationController)
	    .controller('ScAccountManagementController', sc_account_management_controller_1.ScAccountManagementController)
	    .controller('ScFlightCostCalculationController', sc_flight_cost_calculation_controller_1.ScFlightCostCalculationController)
	    .controller('ScQuerySubmissionController', sc_query_submission_controller_1.ScQuerySubmissionController)
	    .controller('ScLoginController', sc_login_controller_1.ScLoginController)
	    .controller('ScHomePageController', sc_home_page_controller_1.ScHomePageController)
	    .controller('CachedEventsController', cached_events_controller_1.CachedEventsController)
	    .controller('FlightScheduleManagementController', flight_schedule_management_controller_1.FlightScheduleManagementController)
	    .controller('LocalAircraftRegistryController', local_aircraft_registry_controller_1.LocalAircraftRegistryController)
	    .controller('UserEventLogController', user_event_log_controller_1.UserEventLogController)
	    .controller('HelpController', help_controller_1.HelpController)
	    .controller('ApplicationManagementController', application_management_controller_1.ApplicationManagementController)
	    .controller('NonAviationBillingEngineController', non_aviation_billing_engine_controller_1.NonAviationBillingEngineController)
	    .controller('RevenueDataController', revenue_data_controller_1.RevenueDataController)
	    .controller('RejectedItemsController', rejected_items_controller_1.RejectedItemsController)
	    .controller('RecurringChargesController', recurring_charges_controller_1.RecurringChargesController)
	    .controller('ReportGenerationController', report_generation_controller_1.ReportGenerationController)
	    .controller('AirTrafficDataController', air_traffic_data_controller_1.AirTrafficDataController)
	    .controller('ReportTemplatesController', report_templates_controller_1.ReportTemplatesController)
	    .controller('TowerMovementLogsController', tower_movement_logs_controller_1.TowerMovementLogsController)
	    .controller('RepositioningAerodromeClustersController', repositioning_aerodrome_clusters_controller_1.RepositioningAerodromeClustersController)
	    .controller('SystemSummaryController', system_summary_controller_1.SystemSummaryController)
	    .controller('AtcMovementLogController', atc_movement_log_controller_1.AtcMovementLogController)
	    .controller('BillingCentreManagementController', billing_centre_management_controller_1.BillingCentreManagementController)
	    .controller('UnspecifiedDepDestLocationsController', unspecified_dep_dest_locations_controller_1.UnspecifiedDepDestLocationsController)
	    .controller('NominalRoutesController', nominal_routes_controller_1.NominalRoutesController)
	    .controller('FlightStatusExemptionsController', flight_status_exemptions_controller_1.FlightStatusExemptionsController)
	    .controller('FlightRouteExemptionsController', flight_route_exemptions_controller_1.FlightRouteExemptionsController)
	    .controller('AircraftUnspecifiedManagementController', aircraft_unspecified_management_controller_1.AircraftUnspecifiedManagementController)
	    .controller('RadarSummaryController', radar_summary_controller_1.RadarSummaryController)
	    .controller('InvoiceTemplateManagementController', invoice_template_management_controller_1.InvoiceTemplateManagementController)
	    .controller('EnrouteAirNavigationChargesManagementController', enroute_air_navigation_charges_management_controller_1.EnrouteAirNavigationChargesManagementController)
	    .controller('CatalogueServiceChargeController', catalogue_service_charge_controller_1.CatalogueServiceChargeController)
	    .controller('InvoiceGenerationController', invoice_generation_controller_1.InvoiceGenerationController)
	    .controller('FlightMovementManagementController', flight_movement_management_controller_1.FlightMovementManagementController)
	    .controller('AirspaceManagementController', airspace_management_controller_1.AirspaceManagementController)
	    .controller('AccountExemptManagementController', account_exempt_management_controller_1.AccountExemptManagementController)
	    .controller('UtilitiesTownsController', utilities_towns_controller_1.UtilitiesTownsController)
	    .controller('UtilitiesSchedulesController', utilities_schedules_controller_1.UtilitiesSchedulesController)
	    .controller('RegionalCountryManagementController', regional_country_management_controller_1.RegionalCountryManagementController)
	    .controller('MapController', map_controller_1.MapController)
	    .controller('AircraftExemptManagementController', aircraft_exempt_management_controller_1.AircraftExemptManagementController)
	    .controller('CrcoCertificatesController', crco_certificates_controller_1.CrcoCertificatesController)
	    .controller('CrcoReportingResponsabilitiesController', crco_reporting_responsabilities_controller_1.CrcoReportingResponsabilitiesController)
	    .controller('CrcoArchiveController', crco_archive_controller_1.CrcoArchiveController)
	    .controller('CrcoConnectionController', crco_connections_controller_1.CrcoConnectionController)
	    .controller('CrcoMessagesController', crco_messages_controller_1.CrcoMessagesController)
	    .controller('CrcoClaimsController', crco_claims_controller_1.CrcoClaimsController)
	    .controller('CrcoCorRequestController', crco_cor_request_controller_1.CrcoCorRequestController)
	    .controller('MtowController', mtow_controller_1.MtowController)
	    .controller('InvoicesController', invoices_controller_1.InvoicesController)
	    .controller('AviationBillingEngineController', aviation_billing_engine_controller_1.AviationBillingEngineController)
	    .controller('AirNavigationChargesController', air_navigation_charges_controller_1.AirNavigationChargesController)
	    .controller('SystemConfigurationController', system_configuration_controller_1.SystemConfigurationController)
	    .controller('PassengerServiceChargeReturnController', passenger_service_charge_return_controller_1.PassengerServiceChargeReturnController)
	    .controller('TransactionsController', transactions_controller_1.TransactionsController)
	    .controller('AircraftRegistrationController', aircraft_registration_controller_1.AircraftRegistrationController)
	    .controller('CurrencyManagementController', currency_management_controller_1.CurrencyManagementController)
	    .controller('AccountsController', accounts_controller_1.AccountsController)
	    .controller('AerodromeCategoryManagementController', aerodrome_category_management_controller_1.AerodromeCategoryManagementController)
	    .controller('AerodromesController', aerodromes_controller_1.AerodromesController)
	    .controller('MainController', main_controller_1.MainController)
	    .controller('UsersController', users_controller_1.UsersController)
	    .controller('LoginController', login_controller_1.LoginController)
	    .controller('AMHSConnectionController', amhs_connection_controller_1.AMHSConnectionController)
	    .controller('AMHSAccountsController', amhs_accounts_controller_1.AMHSAccountsController)
	    .controller('AircraftTypeManagementController', aircraft_type_management_controller_1.AircraftTypeManagementController)
	    .controller('GroupManagementController', group_management_controller_1.GroupManagementController)
	    .controller('AboutController', about_controller_1.AboutController)
	    .controller('FlightMovementTableController', flight_movement_table_controller_1.FlightMovementTableController)
	    .controller('CountryManagementController', country_management_controller_1.CountryManagementController)
	    .controller('PluginsController', plugins_controller_1.PluginsController)
	    .controller('SystemConfigurationItemController', system_configuration_item_controller_1.SystemConfigurationItemController)
	    .controller('PassengerRevenueReconciliationController', passenger_revenue_reconciliation_controller_1.PassengerRevenueReconciliationController)
	    .controller('TableSortController', tableSort_controller_1.TableSortController)
	    .controller('TransactionsPendingController', transactions_pending_controller_1.TransactionsPendingController)
	    .controller('TransactionsWorkflowController', transactions_workflow_controller_1.TransactionsWorkflowController)
	    .controller('RevenueProjectionController', revenue_projection_controller_1.RevenueProjectionController)
	    .controller('CurrentUserController', current_user_controller_1.CurrentUserController)
	    .controller('FlightReassignmentScopeController', flight_reassignment_controller_1.FlightReassignmentScopeController)
	    .controller('BankAccountManagementController', bank_account_management_controller_1.BankAccountManagementController)
	    .controller('UnifiedTaxManagementController', unified_tax_management_controller_1.UnifiedTaxManagementController)
	    .controller('SSOProvidersController', sso_providers_controller_1.SSOProvidersController)
	    .controller('AodbController', aodb_controller_1.AodbController);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var ScReportGenerationController = (function (_super) {
	    __extends(ScReportGenerationController, _super);
	    /* @ngInject */
	    ScReportGenerationController.$inject = ["$scope", "$rootScope", "scReportGenerationService", "customDate", "scAccountManagementService", "$timeout"];
	    function ScReportGenerationController($scope, $rootScope, scReportGenerationService, customDate, scAccountManagementService, $timeout) {
	        var _this = _super.call(this, $scope, scReportGenerationService) || this;
	        _this.$scope = $scope;
	        _this.scReportGenerationService = scReportGenerationService;
	        _this.customDate = customDate;
	        _this.scAccountManagementService = scAccountManagementService;
	        _this.$timeout = $timeout;
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        // multiselect for accounts
	        scAccountManagementService.getSCAccounts().then(function (data) { return $scope.accountsList = data; });
	        _this.$scope.selectedAccounts = [];
	        $scope.addAccountToList = function () { return _this.addAccountToList($scope.selectedAccounts); };
	        $scope.setClear = function (report) { return _this.setClear(report); };
	        $scope.returnFilteredDate = function (date) { return _this.returnFilteredDate(date); };
	        $scope.returnFilteredActiveStatus = function (status) { return _this.returnFilteredActiveStatus(status); };
	        $scope.preview = function (report) { return _this.preview(report); };
	        $scope.$watch('control', function () {
	            if ($scope.control) {
	                _this.setDefaultDate();
	            }
	        });
	        return _this;
	    }
	    ScReportGenerationController.prototype.setClear = function (report) {
	        this.setDefaultDate();
	        this.$scope.selectedAccounts = [];
	        this.$scope.accountIds = null;
	        this.$scope.editable = this.scReportGenerationService.getModel();
	        this.$scope.editable.report = report.report;
	        this.$scope.reportResult = null;
	    };
	    ScReportGenerationController.prototype.preview = function (report) {
	        var _this = this;
	        var params = {
	            text: 'Preview',
	            report: this.$scope.editable.report,
	            startDate: this.returnFilteredDate(this.$scope.control.getUTCStartDate()),
	            endDate: this.returnFilteredDate(this.$scope.control.getUTCEndDate())
	        };
	        this.scReportGenerationService.getPreview(params, this.$scope.accountIds).then(function (data) {
	            _this.$scope.reportResult = data;
	        });
	    };
	    ScReportGenerationController.prototype.setDefaultDate = function () {
	        if (this.$scope.control) {
	            var date = new Date();
	            var startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
	            var endDate = new Date(date.getFullYear(), date.getMonth(), 0);
	            this.$scope.control.setUTCStartDate(startDate);
	            this.$scope.control.setUTCEndDate(endDate);
	        }
	    };
	    /**
	     * Adds accounts, selected
	     * from the multiselect,
	     * to a comma separated string
	     *
	     * @param  {Array<any>} selectedAccounts
	     */
	    ScReportGenerationController.prototype.addAccountToList = function (selectedAccounts) {
	        var accounts = selectedAccounts.map(function (account) { return account.id; });
	        this.$scope.accountIds = accounts.join(',');
	        this.$scope.accountIdsWithBrackets = accounts.length ? "{" + this.$scope.accountIds + "}" : '';
	    };
	    ScReportGenerationController.prototype.returnFilteredDate = function (date) {
	        if (date === undefined || date === null) {
	            return;
	        }
	        return date.toISOString().slice(0, 19) + "Z";
	    };
	    ScReportGenerationController.prototype.returnFilteredActiveStatus = function (status) {
	        return status.length ? "{" + status + "}" : '';
	    };
	    return ScReportGenerationController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScReportGenerationController = ScReportGenerationController;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_controller_1 = __webpack_require__(4);
	// services
	var users_service_1 = __webpack_require__(7);
	// decorators
	var inject_1 = __webpack_require__(11);
	// extends CRUDFormController to also include User Service (due to permissions that most controllers need)
	var CRUDFormControllerUserService = (function (_super) {
	    __extends(CRUDFormControllerUserService, _super);
	    // because we don't know what the $scope or service will be from, it has to be of type `any`
	    function CRUDFormControllerUserService($scope, service) {
	        var services = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            services[_i - 2] = arguments[_i];
	        }
	        var _this = _super.call(this, service) || this;
	        _this.$scope = $scope;
	        _this.service = service;
	        _this.permissions = [];
	        new services[0](service.restangular).current.then(function (user) {
	            if (user) {
	                _this.permissions = user.permissions;
	                $scope.hasPermission = function (permission) { return _this.hasPermission(permission); };
	            }
	            else {
	                _this.permissions = null;
	            }
	        });
	        return _this;
	    }
	    // returns whether the current user has this permission
	    CRUDFormControllerUserService.prototype.hasPermission = function (permission) {
	        return this.permissions.indexOf(permission) > -1;
	    };
	    return CRUDFormControllerUserService;
	}(crud_form_controller_1.CRUDFormController));
	CRUDFormControllerUserService = __decorate([
	    inject_1.Inject(users_service_1.UsersService)
	], CRUDFormControllerUserService);
	exports.CRUDFormControllerUserService = CRUDFormControllerUserService;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var input_constants_1 = __webpack_require__(5);
	// has basic form functionality as well as CRUD operations
	var crud_controller_1 = __webpack_require__(6);
	var CRUDFormController = (function (_super) {
	    __extends(CRUDFormController, _super);
	    function CRUDFormController(service) {
	        var _this = _super.call(this) || this;
	        _this.queryString = '';
	        _this.service = service;
	        return _this;
	    }
	    CRUDFormController.prototype.setup = function (obj) {
	        var _this = this;
	        var data = obj === undefined ? {} : obj;
	        data.refresh = data.refresh === undefined ? true : data.refresh;
	        this.$scope.create = function (obj) { return _this.create(obj); };
	        this.$scope.delete = function (id) { return _this.delete(id); };
	        this.$scope.update = function (obj, id) { return _this.update(obj, id); };
	        this.$scope.edit = function (obj) { return _this.edit(obj); };
	        this.$scope.reset = function () { return _this.reset(); };
	        this.reset(); // will set up initial model
	        this.$scope.refresh = function (data, queryString) { return _this.list(data, queryString); };
	        data.filter = data.filter = undefined ? '' : data.filter;
	        if (data.refresh) {
	            this.$scope.refresh({ filter: data.filter });
	        }
	        ;
	    };
	    CRUDFormController.prototype.create = function (data) {
	        var _this = this;
	        return _super.prototype.create.call(this, data).then(function (newObject) {
	            if (newObject.warnings && _this.$scope.verifyRouteEnabled) {
	                _this.$scope.showWarnings = true;
	                _this.$scope.warningsList = newObject.warnings;
	            }
	            _this.reset();
	            _this.filterObj = _this.filterObj || {};
	            _this.filterObj.page++; // fake the number one higher because it will be decreased in crud.service.ts
	            _this.list(_this.filterObj, _this.queryString);
	            return newObject;
	        }, function (error) { return _this.bindErrorAndThrow(error); });
	    };
	    CRUDFormController.prototype.createFromCopy = function (data) {
	        var _this = this;
	        data.id = null;
	        return _super.prototype.create.call(this, data).then(function (newObject) {
	            if (newObject.warnings && _this.$scope.verifyRouteEnabled) {
	                _this.$scope.showWarnings = true;
	                _this.$scope.warningsList = newObject.warnings;
	            }
	            _this.reset();
	            _this.filterObj = _this.filterObj || {};
	            _this.filterObj.page++; // fake the number one higher because it will be decreased in crud.service.ts
	            _this.list(_this.filterObj, _this.queryString);
	            return newObject;
	        }, function (error) { return _this.bindErrorAndThrow(error); });
	    };
	    CRUDFormController.prototype.update = function (data, id) {
	        var _this = this;
	        return _super.prototype.update.call(this, data, id).then(function (result) {
	            _this.reset();
	            _this.filterObj.page++; // fake the number one higher because it will be decreased in crud.service.ts
	            _this.list(_this.filterObj, _this.queryString);
	            return result;
	        }, function (error) { return _this.bindErrorAndThrow(error); });
	    };
	    /**
	     * Sets the form to edit the single entry
	     * @param {Object} data   entity to edit
	     */
	    CRUDFormController.prototype.edit = function (data) {
	        this.$scope.error = null;
	        this.$scope.editable = angular.copy(data);
	    };
	    CRUDFormController.prototype.list = function (data, queryString, endpoint) {
	        var _this = this;
	        this.filterObj = data; // set the filterObj, so we can reuse
	        this.queryString = queryString; // set the queryString, so we can reuse
	        return _super.prototype.list.call(this, this.filterObj, queryString, endpoint).then(function (data) {
	            _this.$scope.list = data.content;
	            var pagination = angular.copy(data);
	            delete pagination.content;
	            _this.$scope.pagination = pagination;
	            // scrolls the respective table to the top
	            _this.$scope.$broadcast('scrollToTop');
	            return data;
	        });
	    };
	    /**
	     * Resets the form
	     */
	    CRUDFormController.prototype.reset = function () {
	        this.$scope.error = null;
	        this.$scope.editable = angular.copy(this.service.model);
	        if (this.$scope.form) {
	            this.$scope.form.$setUntouched();
	        }
	    };
	    /**
	     * Calls the service delete method then resets the form
	     * @param {number} id  the id to delete
	     */
	    CRUDFormController.prototype.delete = function (id) {
	        var _this = this;
	        return _super.prototype.delete.call(this, id)
	            .then(function () {
	            _this.reset();
	            _this.filterObj.page++; // fake the number one higher because it will be decreased in crud.service.ts
	            _this.list(_this.filterObj, _this.queryString);
	        }, function (error) { return _this.bindErrorAndThrow(error); });
	    };
	    /**
	     * Set error in scope from error object using default error hanlding.
	     *
	     * @param error error object
	     */
	    CRUDFormController.prototype.setError = function (error) {
	        this.$scope.error = {};
	        this.$scope.error.error = { data: error };
	    };
	    /**
	     * Set error in scope from message using default error handling.
	     *
	     * @param message error message
	     * @param description error message description
	     */
	    CRUDFormController.prototype.setErrorMessage = function (message, description) {
	        // ties into default error handling
	        this.$scope.error = {};
	        this.$scope.error.error = {
	            data: {
	                error: message,
	                error_description: description
	            }
	        };
	    };
	    /**
	     * Set error in scope from response error using default error handling.
	     *
	     * @param response restangluar error response
	     * @returns response for chaining
	     */
	    CRUDFormController.prototype.setErrorResponse = function (response) {
	        this.$scope.error = {};
	        this.$scope.error.error = response;
	        // in this order because if something were to fail it would be highlightFieldsWithError
	        this.highlightFieldsWithError(response);
	        return response;
	    };
	    Object.defineProperty(CRUDFormController.prototype, "filterObj", {
	        get: function () {
	            return this._filterObj;
	        },
	        set: function (filterObj) {
	            this._filterObj = filterObj;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // if Spring returns `field_errors`, this will try to set the validity to the corresponding inputs as false
	    CRUDFormController.prototype.highlightFieldsWithError = function (error) {
	        if (typeof error.data.field_errors !== 'undefined' && error.data.field_errors !== null) {
	            // api response MUST throw error with rejected reason "ALREADY_EXISTS"
	            var errorKey = error.data.rejected_reasons === 'ALREADY_EXISTS'
	                ? input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS : input_constants_1.DISPLAY.API_RESPONSE_CLASS;
	            for (var i = 0; i < error.data.field_errors.length; i++) {
	                if (this.$scope.form[error.data.field_errors[i].field] !== undefined) {
	                    this.$scope.form[error.data.field_errors[i].field].$setValidity(errorKey, false);
	                }
	                else {
	                    console.warn('issue with backend sending input binding that does not exist on $scope');
	                }
	            }
	        }
	    };
	    CRUDFormController.prototype.bindErrorAndThrow = function (response) {
	        throw this.setErrorResponse(response);
	    };
	    return CRUDFormController;
	}(crud_controller_1.CRUDController));
	exports.CRUDFormController = CRUDFormController;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DISPLAY = {
	    LABEL_CLASS: 'label-error',
	    INPUT_CLASS: 'input-error',
	    ICON_CLASS: 'fa fa-exclamation-circle',
	    DATE_RANGE_FORM: 'dateRangeForm',
	    API_RESPONSE_CLASS: 'api-response',
	    API_RESPONSE_EXISTS_CLASS: 'api-response-exists'
	};
	exports.MESSAGES = {
	    'patternFormat': 'Eligible patterns include',
	    'email': 'This field requires a valid email address',
	    'max': 'Your value for this field is too high',
	    'maxlength': 'This field is too long',
	    'min': 'Your value for this field is too low',
	    'minlength': 'This field is too short',
	    'number': 'This field requires a valid number',
	    'pattern': 'This field does not match the recommended pattern',
	    'required': 'This is a required field',
	    'url': 'This field should be a URL',
	    'date': 'This field does not follow the system date format',
	    'datetimelocal': 'This field does not follow the system date format',
	    'time': 'This field does not follow the system date format',
	    'week': 'This field does not follow the system date format',
	    'month': 'This field does not follow the system date format',
	    'pwcheck-required': 'Password is required',
	    'pwcheck-minlength': 'Password does not meet minimum length',
	    'pwcheck-confirm': 'Passwords do not match',
	    'pwcheck-lowercase': 'Password requires a lowercase character',
	    'pwcheck-uppercase': 'Password requires a uppercase character',
	    'pwcheck-numeric': 'Password requires a numeric character',
	    'pwcheck-special': 'Password requires a special character'
	};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	// class with basic crud operations
	Object.defineProperty(exports, "__esModule", { value: true });
	var CRUDController = (function () {
	    function CRUDController() {
	    }
	    CRUDController.prototype.create = function (data) {
	        return this.service.create(data);
	    };
	    CRUDController.prototype.list = function (data, queryString, endpoint) {
	        if (data === void 0) { data = {}; }
	        if (queryString === void 0) { queryString = ''; }
	        return this.service.list(data, queryString, endpoint);
	    };
	    CRUDController.prototype.update = function (data, id) {
	        return this.service.update(data, id);
	    };
	    CRUDController.prototype.delete = function (id) {
	        return this.service.delete(id);
	    };
	    return CRUDController;
	}());
	exports.CRUDController = CRUDController;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'users';
	var UsersService = (function (_super) {
	    __extends(UsersService, _super);
	    /** @ngInject */
	    UsersService.$inject = ["Restangular", "$location", "windowLocationService", "oAuthService"];
	    function UsersService(Restangular, $location, windowLocationService, oAuthService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$location = $location;
	        _this.windowLocationService = windowLocationService;
	        _this.oAuthService = oAuthService;
	        _this.userModel = {
	            email: null,
	            id: null,
	            login: null,
	            job_title: null,
	            name: null,
	            permissions: [],
	            roles: [],
	            contact_information: null,
	            sms_number: null,
	            billing_center: null,
	            language: null,
	            is_selfcare_user: false,
	            is_provider_user: false,
	            force_password_change: false,
	            registration_status: true
	        };
	        _this.model = angular.copy(_this.userModel);
	        return _this;
	    }
	    Object.defineProperty(UsersService.prototype, "current", {
	        get: function () {
	            var _this = this;
	            return this.restangular.one(exports.endpoint + "/current").get()
	                .catch(function (error) {
	                if (_this.$location) {
	                    if (_this.$location.path().startsWith('/sc-') || _this.windowLocationService.pathname.endsWith('/selfcare/')) {
	                        if (_this.$location.path() === '/sc-user-registration-activate') {
	                            _this.$location.path('sc-user-registration-activate');
	                        }
	                        else if (_this.$location.path() !== '/sc-home-page') {
	                            _this.oAuthService.logout(false, true);
	                        }
	                    }
	                    else {
	                        _this.oAuthService.logout(false, true);
	                    }
	                }
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    UsersService.prototype.update = function (user, id) {
	        var _this = this;
	        return _super.prototype.update.call(this, user, id)
	            .then(function () { return _this.updateRoles(id, user.roles); });
	    };
	    UsersService.prototype.create = function (user) {
	        var _this = this;
	        var roles = user.roles; // the user object is lost, therefore we set a variable.  this seems to only be an issue with create
	        return _super.prototype.create.call(this, user)
	            .then(function (newUser) { return _this.updateRoles(newUser.id, roles); });
	    };
	    UsersService.prototype.setCurrentUserLanguage = function (language) {
	        var _this = this;
	        this.restangular.one(exports.endpoint + "/current").get().then(function (resp) {
	            _this.restangular.one(exports.endpoint + "/setCurrentUserLanguage/" + resp.id + "/" + language).put();
	        });
	    };
	    UsersService.prototype.updateRoles = function (userId, roles) {
	        return this.restangular.one(exports.endpoint + "/" + userId + "/roles").customPUT(roles);
	    };
	    UsersService.prototype.recoverPassword = function (email) {
	        return this.restangular.one(exports.endpoint + "/passwordRecovery").customPOST(email);
	    };
	    UsersService.prototype.updatePassword = function (changePassword) {
	        return this.restangular.one(exports.endpoint + "/updatePassword").customPUT(changePassword);
	    };
	    UsersService.prototype.getListInternalUsers = function () {
	        return this.restangular.one(exports.endpoint + "/list?selfCareUser=false").get();
	    };
	    UsersService.prototype.getListLightInternalUsers = function () {
	        return this.restangular.one(exports.endpoint + "/listLight?selfCareUser=false").get();
	    };
	    UsersService.prototype.getListWebUsers = function () {
	        return this.restangular.one(exports.endpoint + "/list?selfCareUser=true").get();
	    };
	    UsersService.prototype.getListLightWebUsers = function () {
	        return this.restangular.one(exports.endpoint + "/listLight?selfCareUser=true").get();
	    };
	    return UsersService;
	}(crud_service_1.CRUDService));
	exports.UsersService = UsersService;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// class with basic crud operations
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var CRUDService = (function () {
	    function CRUDService(Restangular, endpoint) {
	        this.Restangular = Restangular;
	        this.endpoint = endpoint;
	        this.restangular = Restangular;
	        this.endpoint = endpoint;
	    }
	    Object.defineProperty(CRUDService.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (obj) { this._model = obj; },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    ;
	    CRUDService.prototype.create = function (obj) {
	        return this.restangular.all(this.endpoint).customPOST(obj, '', undefined, { 'Content-Type': 'application/json' }); // todo should be handled better without forcing the content type
	    };
	    /**
	     * Makes a GET request to the endpoint
	     *
	     * Note: This is kind of set up with Spring in mind
	     *
	     * @param params        is an Object that will be converted to GET parameters
	     * @param queryString   is GET parameters that will be appended to the URL
	     * @returns {IPromise<ISpringPageableParams>}
	     */
	    CRUDService.prototype.list = function (params, queryString, endpoint) {
	        var _this = this;
	        if (params === void 0) { params = {}; }
	        if (queryString === void 0) { queryString = ''; }
	        if (endpoint === void 0) { endpoint = ''; }
	        if (queryString !== '') {
	            queryString = "?" + queryString;
	        }
	        // if not set to 'get all / -1' add the system config page size
	        if (!params.size) {
	            params.size = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE) || 20;
	        }
	        ;
	        // the uib-pagination starts at `1` but Spring Framework starts at `0`, therefore we fake it
	        if (params.page) {
	            params.page--;
	        }
	        return this.restangular.one("" + (endpoint ? endpoint : this.endpoint) + queryString).get(params)
	            .then(function (response) { return _this.rectifyPageableParams(response); });
	    };
	    // sends size=-1 with parameters, returning all rows
	    CRUDService.prototype.listAll = function (params) {
	        if (!params) {
	            params = {};
	        }
	        params.size = -1; // override and ensure get all results
	        return this.list(params); // calls list method since it's the same
	    };
	    CRUDService.prototype.update = function (obj, id) {
	        return this.restangular.one(this.endpoint, id).customPUT(obj);
	    };
	    CRUDService.prototype.delete = function (id) {
	        return this.restangular.one(this.endpoint, id).remove();
	    };
	    CRUDService.prototype.get = function (id) {
	        return this.restangular.one(this.endpoint, id).get();
	    };
	    /**
	     * To not screw up the uib-pagination directive, we fake the number one higher.
	     *
	     * @param response from spring
	     */
	    CRUDService.prototype.rectifyPageableParams = function (response) {
	        if (response.number) {
	            response.number++;
	        }
	        return response;
	    };
	    return CRUDService;
	}());
	exports.CRUDService = CRUDService;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var system_configuration_constants_1 = __webpack_require__(10);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	    }
	    /** @ngInject */
	    LocalStorageService.isLocalStorageDefined = function () {
	        return typeof window.localStorage !== 'undefined';
	    };
	    LocalStorageService.get = function (key) {
	        var value = window.localStorage.getItem(key);
	        if (this.IsJsonString(value)) {
	            return angular.fromJson(JSON.parse(value)); // handles quotes added by server when data is transferred via API
	        }
	        else {
	            return value;
	        }
	        ;
	    };
	    LocalStorageService.getBooleanFromValueByName = function (name) {
	        return this.get(name) === system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_TRUE;
	    };
	    LocalStorageService.set = function (key, value) {
	        if (typeof value === 'object') {
	            window.localStorage.setItem(key, JSON.stringify(value));
	        }
	        else {
	            window.localStorage.setItem(key, value);
	        }
	        ;
	    };
	    LocalStorageService.delete = function (key) {
	        window.localStorage.removeItem(key);
	    };
	    LocalStorageService.destroy = function (items) {
	        var saved = [];
	        for (var i = 0, len = items.length; i < len; i++) {
	            saved.push(window.localStorage.getItem(items[i]));
	        }
	        ;
	        window.localStorage.clear();
	        for (var i = 0, len = saved.length; i < len; i++) {
	            window.localStorage.setItem(items[i], saved[i]);
	        }
	        ;
	    };
	    LocalStorageService.IsJsonString = function (str) {
	        try {
	            JSON.parse(str);
	        }
	        catch (e) {
	            return false;
	        }
	        return true;
	    };
	    return LocalStorageService;
	}());
	exports.LocalStorageService = LocalStorageService;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SysConfigConstants;
	(function (SysConfigConstants) {
	    SysConfigConstants[SysConfigConstants["ANSP_CURRENCY"] = 'ANSP currency'] = "ANSP_CURRENCY";
	    SysConfigConstants[SysConfigConstants["DOM_PAX_CURRENCY"] = 'Domestic passenger fee currency'] = "DOM_PAX_CURRENCY";
	    SysConfigConstants[SysConfigConstants["INTL_PAX_CURRENCY"] = 'International passenger fee currency'] = "INTL_PAX_CURRENCY";
	    SysConfigConstants[SysConfigConstants["DEFAULT_AIRLINE_ACCOUNT_CREDIT_LIMIT"] = 'Default airline account credit limit'] = "DEFAULT_AIRLINE_ACCOUNT_CREDIT_LIMIT";
	    SysConfigConstants[SysConfigConstants["DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE"] = 'Default airline account minimum credit note amount'] = "DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE";
	    SysConfigConstants[SysConfigConstants["DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE"] = 'Default airline account maximum credit note amount'] = "DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE";
	    SysConfigConstants[SysConfigConstants["DEFAULT_AIRLINE_ACCOUNT_PAYMENT_TERMS"] = 'Default airline account payment terms'] = "DEFAULT_AIRLINE_ACCOUNT_PAYMENT_TERMS";
	    SysConfigConstants[SysConfigConstants["DEFAULT_AIRLINE_ACCOUNT_MONTHLY_PENALTY"] = 'Default airline account monthly penalty rate'] = "DEFAULT_AIRLINE_ACCOUNT_MONTHLY_PENALTY";
	    SysConfigConstants[SysConfigConstants["DEFAULT_AIRLINE_ACCOUNT_PARKING_EXEMPTION"] = 'Default airline account parking exemption'] = "DEFAULT_AIRLINE_ACCOUNT_PARKING_EXEMPTION";
	    SysConfigConstants[SysConfigConstants["DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT"] = 'Default general aviation account credit limit'] = "DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT";
	    SysConfigConstants[SysConfigConstants["DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE"] = 'Default general aviation account minimum credit note amount'] = "DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE";
	    SysConfigConstants[SysConfigConstants["DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE"] = 'Default general aviation account maximum credit note amount'] = "DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE";
	    SysConfigConstants[SysConfigConstants["DEFAULT_GENERAL_AVIATION_ACCOUNT_PAYMENT_TERMS"] = 'Default general aviation account payment terms'] = "DEFAULT_GENERAL_AVIATION_ACCOUNT_PAYMENT_TERMS";
	    SysConfigConstants[SysConfigConstants["DEFAULT_GENERAL_AVIATION_ACCOUNT_MONTHLY_PENALTY"] = 'Default general aviation account monthly penalty rate'] = "DEFAULT_GENERAL_AVIATION_ACCOUNT_MONTHLY_PENALTY";
	    SysConfigConstants[SysConfigConstants["DEFAULT_GENERAL_AVIATION_ACCOUNT_PARKING_EXEMPTION"] = 'Default general aviation account parking exemption'] = "DEFAULT_GENERAL_AVIATION_ACCOUNT_PARKING_EXEMPTION";
	    SysConfigConstants[SysConfigConstants["DEFAULT_UNIFIED_TAX_ACCOUNT_CREDIT_LIMIT"] = 'Default unified tax account credit limit'] = "DEFAULT_UNIFIED_TAX_ACCOUNT_CREDIT_LIMIT";
	    SysConfigConstants[SysConfigConstants["DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE"] = 'Default unified tax account minimum credit note amount'] = "DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE";
	    SysConfigConstants[SysConfigConstants["DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE"] = 'Default unified tax account maximum credit note amount'] = "DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE";
	    SysConfigConstants[SysConfigConstants["DEFAULT_UNIFIED_TAX_ACCOUNT_PAYMENT_TERMS"] = 'Default unified tax account payment terms'] = "DEFAULT_UNIFIED_TAX_ACCOUNT_PAYMENT_TERMS";
	    SysConfigConstants[SysConfigConstants["DEFAULT_UNIFIED_TAX_ACCOUNT_MONTHLY_PENALTY"] = 'Default unified tax account monthly penalty rate'] = "DEFAULT_UNIFIED_TAX_ACCOUNT_MONTHLY_PENALTY";
	    SysConfigConstants[SysConfigConstants["DEFAULT_UNIFIED_TAX_ACCOUNT_PARKING_EXEMPTION"] = 'Default unified tax account parking exemption'] = "DEFAULT_UNIFIED_TAX_ACCOUNT_PARKING_EXEMPTION";
	    SysConfigConstants[SysConfigConstants["DEFAULT_BILLING_PERIOD_NON_IATA"] = 'Default billing period for NON-IATA invoices'] = "DEFAULT_BILLING_PERIOD_NON_IATA";
	    SysConfigConstants[SysConfigConstants["FIRST_DAY_OF_WEEK_NON_IATA"] = 'First day of week for NON-IATA invoices'] = "FIRST_DAY_OF_WEEK_NON_IATA";
	    SysConfigConstants[SysConfigConstants["DEFAULT_BILLING_PERIOD_IATA"] = 'Default billing period for IATA invoices'] = "DEFAULT_BILLING_PERIOD_IATA";
	    SysConfigConstants[SysConfigConstants["FIRST_DAY_OF_WEEK_IATA"] = 'First day of week for IATA invoices'] = "FIRST_DAY_OF_WEEK_IATA";
	    SysConfigConstants[SysConfigConstants["DATE_FORMAT"] = 'Date format'] = "DATE_FORMAT";
	    SysConfigConstants[SysConfigConstants["DEP_TIME_RANGE_MIN"] = 'Minimum range for flight match'] = "DEP_TIME_RANGE_MIN";
	    SysConfigConstants[SysConfigConstants["DEP_TIME_RANGE_EET_PERCENTAGE"] = 'Percentage of EET to be used for flight match'] = "DEP_TIME_RANGE_EET_PERCENTAGE";
	    SysConfigConstants[SysConfigConstants["RADAR_SUMMARY_REQUIRED"] = 'Radar summary is required'] = "RADAR_SUMMARY_REQUIRED";
	    SysConfigConstants[SysConfigConstants["SYSTEM_CONFIG_TRUE"] = 't'] = "SYSTEM_CONFIG_TRUE";
	    SysConfigConstants[SysConfigConstants["RADAR_FLOOR_LEVEL"] = 'Radar floor level'] = "RADAR_FLOOR_LEVEL";
	    SysConfigConstants[SysConfigConstants["ATC_LOG_REQUIRED"] = 'ATC log is required'] = "ATC_LOG_REQUIRED";
	    SysConfigConstants[SysConfigConstants["TOWER_LOG_REQUIRED"] = 'Tower aircraft/passenger movement log is required'] = "TOWER_LOG_REQUIRED";
	    SysConfigConstants[SysConfigConstants["FLIGHT_PLAN_REQUIRED"] = 'Flight plan is required'] = "FLIGHT_PLAN_REQUIRED";
	    SysConfigConstants[SysConfigConstants["PASSENGER_SERVICE_CHARGE_REQUIRED"] = 'Passenger service charge return is required'] = "PASSENGER_SERVICE_CHARGE_REQUIRED";
	    SysConfigConstants[SysConfigConstants["CROSSING_DISTANCE_PRECEDENCE"] = 'Crossing distance precedence'] = "CROSSING_DISTANCE_PRECEDENCE";
	    SysConfigConstants[SysConfigConstants["SEPARATE_INVOICE_NUMBERS_PER_BILLING_CENTER"] = 'Use separate invoice number sequence for each billing centre'] = "SEPARATE_INVOICE_NUMBERS_PER_BILLING_CENTER";
	    SysConfigConstants[SysConfigConstants["SEPARATE_RECEIPT_NUMBERS_PER_BILLING_CENTER"] = 'Use separate receipt number sequence for each billing centre'] = "SEPARATE_RECEIPT_NUMBERS_PER_BILLING_CENTER";
	    SysConfigConstants[SysConfigConstants["EXEMPT_FLIGHTS_DISTANCE"] = 'Exempt flights shorter than distance'] = "EXEMPT_FLIGHTS_DISTANCE";
	    SysConfigConstants[SysConfigConstants["MIN_DOMESTIC_CROSSING_DISTANCE"] = 'Minimum domestic crossing distance'] = "MIN_DOMESTIC_CROSSING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["MIN_REGIONAL_CROSSING_DISTANCE"] = 'Minimum regional crossing distance'] = "MIN_REGIONAL_CROSSING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["MIN_INTERNATIONAL_CROSSING_DISTANCE"] = 'Minimum international crossing distance'] = "MIN_INTERNATIONAL_CROSSING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["MIN_RANGE_FOR_FLIGHT_MATCH"] = 'Minimum range for flight match'] = "MIN_RANGE_FOR_FLIGHT_MATCH";
	    SysConfigConstants[SysConfigConstants["MAX_DOMESTIC_CROSSING_DISTANCE"] = 'Maximum domestic crossing distance'] = "MAX_DOMESTIC_CROSSING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["MAX_REGIONAL_CROSSING_DISTANCE"] = 'Maximum regional crossing distance'] = "MAX_REGIONAL_CROSSING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["MAX_INTERNATIONAL_CROSSING_DISTANCE"] = 'Maximum international crossing distance'] = "MAX_INTERNATIONAL_CROSSING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["DOMESTIC_PASSENGER_FEE_PERCENTAGE"] = 'Domestic passenger fee percentage'] = "DOMESTIC_PASSENGER_FEE_PERCENTAGE";
	    SysConfigConstants[SysConfigConstants["INTERNATIONAL_PASSENGER_FEE_PERCENTAGE"] = 'International passenger fee percentage'] = "INTERNATIONAL_PASSENGER_FEE_PERCENTAGE";
	    SysConfigConstants[SysConfigConstants["ROUTE_CACHE_COUNT"] = 'Route caching retention'] = "ROUTE_CACHE_COUNT";
	    SysConfigConstants[SysConfigConstants["PASSWORD_MINIMUM_LENGTH"] = 'Password minimum length'] = "PASSWORD_MINIMUM_LENGTH";
	    SysConfigConstants[SysConfigConstants["PASSWORD_LOWERCASE"] = 'Password lowercase required'] = "PASSWORD_LOWERCASE";
	    SysConfigConstants[SysConfigConstants["PASSWORD_UPPERCASE"] = 'Password uppercase required'] = "PASSWORD_UPPERCASE";
	    SysConfigConstants[SysConfigConstants["PASSWORD_NUMERIC"] = 'Password numeric required'] = "PASSWORD_NUMERIC";
	    SysConfigConstants[SysConfigConstants["PASSWORD_SPECIAL"] = 'Password special character required'] = "PASSWORD_SPECIAL";
	    SysConfigConstants[SysConfigConstants["ENTRY_EXIT_POINT_ROUNDING_DISTANCE"] = 'Entry/exit point rounding distance'] = "ENTRY_EXIT_POINT_ROUNDING_DISTANCE";
	    SysConfigConstants[SysConfigConstants["PERCENT_EET_USED_FOR_FLIGHT_MATCH"] = 'Percentage of EET to be used for flight match'] = "PERCENT_EET_USED_FOR_FLIGHT_MATCH";
	    SysConfigConstants[SysConfigConstants["ATC_MOVEMENT_RETENTION"] = 'ATC movement logs retention'] = "ATC_MOVEMENT_RETENTION";
	    SysConfigConstants[SysConfigConstants["FLIGHT_MOVEMENT_RETENTION"] = 'Flight movement retention'] = "FLIGHT_MOVEMENT_RETENTION";
	    SysConfigConstants[SysConfigConstants["RADAR_TRACK_FILES_RETENTION"] = 'Radar track files retention'] = "RADAR_TRACK_FILES_RETENTION";
	    SysConfigConstants[SysConfigConstants["LINE_ITEM_RETENTION"] = 'Line item retention'] = "LINE_ITEM_RETENTION";
	    SysConfigConstants[SysConfigConstants["USER_EVENT_LOG_RETENTION"] = 'User event log retention'] = "USER_EVENT_LOG_RETENTION";
	    SysConfigConstants[SysConfigConstants["MTOW_UNIT_OF_MEASURE"] = 'MTOW unit of measure'] = "MTOW_UNIT_OF_MEASURE";
	    SysConfigConstants[SysConfigConstants["AUTOMATED_UPLOAD_SCHEDULING"] = 'Automated upload scheduling'] = "AUTOMATED_UPLOAD_SCHEDULING";
	    SysConfigConstants[SysConfigConstants["USE_MTOW_FACTOR_CLASS"] = 'Use MTOW factor class'] = "USE_MTOW_FACTOR_CLASS";
	    SysConfigConstants[SysConfigConstants["COORDINATE_FORMAT"] = 'Format coordinates'] = "COORDINATE_FORMAT";
	    SysConfigConstants[SysConfigConstants["DEGREES_MINUTES_SECONDS"] = 'degrees minutes seconds'] = "DEGREES_MINUTES_SECONDS";
	    SysConfigConstants[SysConfigConstants["AIR_NAVIGATION_CHARGES_CURRENCY"] = 'Air navigation charges currency'] = "AIR_NAVIGATION_CHARGES_CURRENCY";
	    SysConfigConstants[SysConfigConstants["CALCULATE_PARKING_CHARGES"] = 'Calculate parking charges'] = "CALCULATE_PARKING_CHARGES";
	    SysConfigConstants[SysConfigConstants["CALCULATE_TASP_CHARGES"] = 'TASP charges support'] = "CALCULATE_TASP_CHARGES";
	    SysConfigConstants[SysConfigConstants["CALCULATE_ARRIVAL_CHARGES"] = 'Late arrival charges support'] = "CALCULATE_ARRIVAL_CHARGES";
	    SysConfigConstants[SysConfigConstants["CALCULATE_DEPARTURE_CHARGES"] = 'Late departures charges support'] = "CALCULATE_DEPARTURE_CHARGES";
	    SysConfigConstants[SysConfigConstants["ORGANIZATION"] = 'Organisation name.  Used to determine site-specific processing.'] = "ORGANIZATION";
	    SysConfigConstants[SysConfigConstants["RADAR_SUMMARY_FORMAT"] = 'Radar flight strip format'] = "RADAR_SUMMARY_FORMAT";
	    SysConfigConstants[SysConfigConstants["CACHED_EVENT_RETRY_INTERVAL"] = 'Cached event retry interval'] = "CACHED_EVENT_RETRY_INTERVAL";
	    SysConfigConstants[SysConfigConstants["DISTANCE_UNIT_OF_MEASURE"] = 'Distance unit of measure'] = "DISTANCE_UNIT_OF_MEASURE";
	    SysConfigConstants[SysConfigConstants["APPROACH_FEES_LABEL"] = 'Approach fees label'] = "APPROACH_FEES_LABEL";
	    SysConfigConstants[SysConfigConstants["MOCK_FATAL_ERROR_OCCURRENCE_FREQUENCY"] = 'Mock fatal error occurrence frequency'] = "MOCK_FATAL_ERROR_OCCURRENCE_FREQUENCY";
	    SysConfigConstants[SysConfigConstants["LANGUAGE_ENABLED"] = 'Language enabled'] = "LANGUAGE_ENABLED";
	    SysConfigConstants[SysConfigConstants["LANGUAGE_SELECTION"] = 'Language selection'] = "LANGUAGE_SELECTION";
	    SysConfigConstants[SysConfigConstants["LANGUAGE_SUPPORTED"] = 'Language supported'] = "LANGUAGE_SUPPORTED";
	    SysConfigConstants[SysConfigConstants["SYSTEM_CONFIG_FALSE"] = 'f'] = "SYSTEM_CONFIG_FALSE";
	    SysConfigConstants[SysConfigConstants["DUPL_OR_MISS_FLIGHTS_MIN_WIND"] = 'Minimum window to detect duplicate flights'] = "DUPL_OR_MISS_FLIGHTS_MIN_WIND";
	    SysConfigConstants[SysConfigConstants["DUPL_OR_MISS_FLIGHTS_EET_PERC"] = 'Percentage of EET to detect duplicate flights'] = "DUPL_OR_MISS_FLIGHTS_EET_PERC";
	    SysConfigConstants[SysConfigConstants["FIRST_DAY_OF_FISCAL_YEAR"] = 'First day of fiscal year'] = "FIRST_DAY_OF_FISCAL_YEAR";
	    SysConfigConstants[SysConfigConstants["REQUIRE_AERODROME_EXTERNAL_SYSTEM_ID"] = 'Require aerodrome external system id'] = "REQUIRE_AERODROME_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["REQUIRE_ACCOUNT_EXTERNAL_SYSTEM_ID"] = 'Require account external system id'] = "REQUIRE_ACCOUNT_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["REQUIRE_BANK_ACCOUNT_EXTERNAL_SYSTEM_ID"] = 'Require bank account external system id'] = "REQUIRE_BANK_ACCOUNT_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["REQUIRE_UNIFIED_TAX_EXTERNAL_SYSTEM_ID"] = 'Require unified text external system id'] = "REQUIRE_UNIFIED_TAX_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["REQUIRE_BILLING_CENTRE_EXTERNAL_SYSTEM_ID"] = 'Require billing centre external system id'] = "REQUIRE_BILLING_CENTRE_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["REQUIRE_CURRENCY_EXTERNAL_SYSTEM_ID"] = 'Require currency external system id'] = "REQUIRE_CURRENCY_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["REQUIRE_SERVICE_CHARGE_CATALOGUE_EXTERNAL_SYSTEM_ID"] = 'Require service charge catalogue external system id'] = "REQUIRE_SERVICE_CHARGE_CATALOGUE_EXTERNAL_SYSTEM_ID";
	    SysConfigConstants[SysConfigConstants["INVERSE_CURRENCY_RATE"] = 'Display inverse currency exchange rate'] = "INVERSE_CURRENCY_RATE";
	    SysConfigConstants[SysConfigConstants["ROW_FOR_PAGE"] = 'Number of rows per page'] = "ROW_FOR_PAGE";
	    SysConfigConstants[SysConfigConstants["POINT_OF_SALE_WORKFLOW"] = 'Point-of-sale workflow'] = "POINT_OF_SALE_WORKFLOW";
	    SysConfigConstants[SysConfigConstants["MAP_NORTH_LATITUDE"] = 'Map north latitude'] = "MAP_NORTH_LATITUDE";
	    SysConfigConstants[SysConfigConstants["MAP_SOUTH_LATITUDE"] = 'Map south latitude'] = "MAP_SOUTH_LATITUDE";
	    SysConfigConstants[SysConfigConstants["MAP_EAST_LONGITUDE"] = 'Map east longitude'] = "MAP_EAST_LONGITUDE";
	    SysConfigConstants[SysConfigConstants["MAP_WEST_LONGITUDE"] = 'Map west longitude'] = "MAP_WEST_LONGITUDE";
	    SysConfigConstants[SysConfigConstants["MAX_USERS_PER_ACCOUNT"] = 'Maximum web users per account'] = "MAX_USERS_PER_ACCOUNT";
	    SysConfigConstants[SysConfigConstants["MAX_ACCOUNTS_PER_USER"] = 'Maximum accounts per web user'] = "MAX_ACCOUNTS_PER_USER";
	    SysConfigConstants[SysConfigConstants["REQUIRE_ADMIN_APPROVAL_FOR_SC_ACCOUNTS"] = 'Require admin approval for self-care accounts'] = "REQUIRE_ADMIN_APPROVAL_FOR_SC_ACCOUNTS";
	    SysConfigConstants[SysConfigConstants["REQUIRE_ADMIN_APPROVAL_FOR_SC_AIRCRAFT_REGISTRATION"] = 'Require admin approval for self-care aircraft registration'] = "REQUIRE_ADMIN_APPROVAL_FOR_SC_AIRCRAFT_REGISTRATION";
	    SysConfigConstants[SysConfigConstants["REQUIRE_ADMIN_APPROVAL_FOR_SC_FLIGHT_SCHEDULES"] = 'Require admin approval for self-care flight schedules'] = "REQUIRE_ADMIN_APPROVAL_FOR_SC_FLIGHT_SCHEDULES";
	    SysConfigConstants[SysConfigConstants["APPROVAL_REQUEST_APPROVAL_RESPONSE"] = 'Approval request approval response'] = "APPROVAL_REQUEST_APPROVAL_RESPONSE";
	    SysConfigConstants[SysConfigConstants["APPROVAL_REQUEST_REJECTION_RESPONSE"] = 'Approval request rejection response'] = "APPROVAL_REQUEST_REJECTION_RESPONSE";
	    SysConfigConstants[SysConfigConstants["AVIATION_ROUNDING"] = 'Aviation invoice total rounding'] = "AVIATION_ROUNDING";
	    SysConfigConstants[SysConfigConstants["NONAVIATION_ROUNDING"] = 'Non-aviation invoice total rounding'] = "NONAVIATION_ROUNDING";
	    SysConfigConstants[SysConfigConstants["REQUIRE_CAPTCHA"] = 'Require captcha for verification'] = "REQUIRE_CAPTCHA";
	    SysConfigConstants[SysConfigConstants["REQUIRE_EMAIL_VERIFICATION"] = 'Require email verification on user registration'] = "REQUIRE_EMAIL_VERIFICATION";
	    SysConfigConstants[SysConfigConstants["REQUIRE_INVOICE_MANUAL_APPROVAL"] = 'Require invoice manual approval'] = "REQUIRE_INVOICE_MANUAL_APPROVAL";
	    SysConfigConstants[SysConfigConstants["REQUIRE_INVOICE_MANUAL_PUBLISHING"] = 'Require invoice manual publishing'] = "REQUIRE_INVOICE_MANUAL_PUBLISHING";
	    SysConfigConstants[SysConfigConstants["NUMBER_OF_DAYS_OF_FLIGHT_DATA"] = 'Number of days of flight data'] = "NUMBER_OF_DAYS_OF_FLIGHT_DATA";
	    SysConfigConstants[SysConfigConstants["IATA_INVOICE_SUPPORT"] = 'IATA invoicing support'] = "IATA_INVOICE_SUPPORT";
	    SysConfigConstants[SysConfigConstants["CRCO_INVOICE_SUPPORT"] = 'CRCO workflow'] = "CRCO_INVOICE_SUPPORT";
	    SysConfigConstants[SysConfigConstants["TASP_FEES_LABEL"] = 'TASP fees label'] = "TASP_FEES_LABEL";
	    SysConfigConstants[SysConfigConstants["PASSENGER_CHARGES_SUPPORT"] = 'Passenger charges support'] = "PASSENGER_CHARGES_SUPPORT";
	    SysConfigConstants[SysConfigConstants["INCLUDE_PASSENGER_CHARGES_ON_INVOICE"] = 'Include passenger charges on invoice'] = "INCLUDE_PASSENGER_CHARGES_ON_INVOICE";
	    SysConfigConstants[SysConfigConstants["ANSP_COUNTRY_CODE"] = 'Country code'] = "ANSP_COUNTRY_CODE";
	    SysConfigConstants[SysConfigConstants["CREDIT_CONVERSTION_DATE"] = 'Aviation credit invoice currency conversion date'] = "CREDIT_CONVERSTION_DATE";
	    SysConfigConstants[SysConfigConstants["CASH_CONVERSION_DATE"] = 'Aviation cash invoice currency conversion date'] = "CASH_CONVERSION_DATE";
	    SysConfigConstants[SysConfigConstants["INVOICE_FM_CATEGORY"] = 'Invoice by flight movement category'] = "INVOICE_FM_CATEGORY";
	    SysConfigConstants[SysConfigConstants["INVOICE_CURRENCY_ENROUTE"] = 'Invoice currency for enroute charges'] = "INVOICE_CURRENCY_ENROUTE";
	    SysConfigConstants[SysConfigConstants["BACKDATE_PAYMENT_ALLOWED"] = 'Backdate payment allowed'] = "BACKDATE_PAYMENT_ALLOWED";
	    SysConfigConstants[SysConfigConstants["EXTENDED_PSCR_PASSENGER_INFORMATION_SUPPORT"] = 'Extended PSCR passenger information support'] = "EXTENDED_PSCR_PASSENGER_INFORMATION_SUPPORT";
	    SysConfigConstants[SysConfigConstants["EXTENDED_PSCR_CARGO_INFORMATION_SUPPORT"] = 'Extended PSCR cargo information support'] = "EXTENDED_PSCR_CARGO_INFORMATION_SUPPORT";
	    SysConfigConstants[SysConfigConstants["CARGO_DISPLAY_UNITS"] = 'Cargo display units'] = "CARGO_DISPLAY_UNITS";
	    SysConfigConstants[SysConfigConstants["SMALL_AIRCRAFT_MAXIMUM_WEIGHT"] = 'Small aircraft maximum weight'] = "SMALL_AIRCRAFT_MAXIMUM_WEIGHT";
	    SysConfigConstants[SysConfigConstants["SMALL_AIRCRAFT_MINIMUN_WEIGHT"] = 'Small aircraft minimum weight'] = "SMALL_AIRCRAFT_MINIMUN_WEIGHT";
	    SysConfigConstants[SysConfigConstants["MARK_ZERO_FLIGHT_COSTS_AS_PAID"] = 'Mark zero flight costs as paid'] = "MARK_ZERO_FLIGHT_COSTS_AS_PAID";
	    SysConfigConstants[SysConfigConstants["EXTENDED_HOURS_SURCHARGE_SUPPORT"] = 'Extended hours surcharge support'] = "EXTENDED_HOURS_SURCHARGE_SUPPORT";
	    SysConfigConstants[SysConfigConstants["PROFORMA_INVOICE_SUPPORT"] = 'Proforma invoice support'] = "PROFORMA_INVOICE_SUPPORT";
	    SysConfigConstants[SysConfigConstants["POINT_OF_SALE_DEFAULT_ACCOUNT_SELECTION"] = 'Point of sale default account selection'] = "POINT_OF_SALE_DEFAULT_ACCOUNT_SELECTION";
	    SysConfigConstants[SysConfigConstants["WL_ENABLED"] = 'Whitelisting enabled'] = "WL_ENABLED";
	    SysConfigConstants[SysConfigConstants["WL_START_DATE"] = 'Whitelisting start date'] = "WL_START_DATE";
	    SysConfigConstants[SysConfigConstants["WL_INACTIVITY_PERIOD"] = 'Inactivity period'] = "WL_INACTIVITY_PERIOD";
	    SysConfigConstants[SysConfigConstants["WL_EXPIRY_PERIOD"] = 'Expiry period'] = "WL_EXPIRY_PERIOD";
	    SysConfigConstants[SysConfigConstants["WL_INACTIVITY_NOTICE_TEXT"] = 'Inactivity notice text'] = "WL_INACTIVITY_NOTICE_TEXT";
	    SysConfigConstants[SysConfigConstants["WL_EXPIRY_NOTICE_TEXT"] = 'Expiry notice text'] = "WL_EXPIRY_NOTICE_TEXT";
	    SysConfigConstants[SysConfigConstants["WL_AC_REG_NOTICE_TEXT"] = 'Aircraft registration notice text'] = "WL_AC_REG_NOTICE_TEXT";
	    SysConfigConstants[SysConfigConstants["WL_PREPAYMENT_NOTICE_TEXT"] = 'Prepayment notice text'] = "WL_PREPAYMENT_NOTICE_TEXT";
	    SysConfigConstants[SysConfigConstants["WL_ACCEPTED_FLIGHT_NOTICE_TEXT"] = 'Accepted flight notice text'] = "WL_ACCEPTED_FLIGHT_NOTICE_TEXT";
	    SysConfigConstants[SysConfigConstants["WL_DECLINED_FLIGHT_NOTICE_TEXT"] = 'Declined flight notice text'] = "WL_DECLINED_FLIGHT_NOTICE_TEXT";
	    SysConfigConstants[SysConfigConstants["WL_ORIGINATOR_AFTN_ADDRESS"] = 'Originator AFTN address'] = "WL_ORIGINATOR_AFTN_ADDRESS";
	    SysConfigConstants[SysConfigConstants["WL_ACCEPTED_FLIGHT_NOTICE_ADDRESS"] = 'Accepted flight notice addresses'] = "WL_ACCEPTED_FLIGHT_NOTICE_ADDRESS";
	    SysConfigConstants[SysConfigConstants["WL_DECLINED_FLIGHT_NOTICE_ADDRESS"] = 'Declined flight notice addresses'] = "WL_DECLINED_FLIGHT_NOTICE_ADDRESS";
	    SysConfigConstants[SysConfigConstants["WL_FLIGHT_NOTICE_PRIORITY"] = 'Flight notice priority'] = "WL_FLIGHT_NOTICE_PRIORITY";
	    SysConfigConstants[SysConfigConstants["CC_PROCESSOR"] = 'Credit card processor'] = "CC_PROCESSOR";
	    SysConfigConstants[SysConfigConstants["CC_PROCESSOR_URL"] = 'Credit card processor URL'] = "CC_PROCESSOR_URL";
	    SysConfigConstants[SysConfigConstants["CC_PROCESSOR_CONFIGURED"] = 'Credit card processor configured'] = "CC_PROCESSOR_CONFIGURED";
	    SysConfigConstants[SysConfigConstants["CC_PROCESSOR_PUBLIC_KEY"] = 'Credit card processor public key'] = "CC_PROCESSOR_PUBLIC_KEY";
	    SysConfigConstants[SysConfigConstants["CC_PROCESSOR_PRIVATE_KEY"] = 'Credit card processor private key'] = "CC_PROCESSOR_PRIVATE_KEY";
	    SysConfigConstants[SysConfigConstants["VALIDATE_FLIGHT_LEVEL_AIRSPACE"] = 'Validate flight level on airspace'] = "VALIDATE_FLIGHT_LEVEL_AIRSPACE";
	    SysConfigConstants[SysConfigConstants["USE_ADDITIONAL_INVOICES_NUMBER"] = 'Use additional invoice number sequence'] = "USE_ADDITIONAL_INVOICES_NUMBER";
	    SysConfigConstants[SysConfigConstants["USE_RECEIPT_NUMBER_BY_PAYMENT_MECHANISM"] = 'Use receipt number sequence by payment mechanism'] = "USE_RECEIPT_NUMBER_BY_PAYMENT_MECHANISM";
	    SysConfigConstants[SysConfigConstants["INCLUDE_ROUTE_SEGMENTS_FOR_EANA"] = 'Exempt Flight Routes: include route segments'] = "INCLUDE_ROUTE_SEGMENTS_FOR_EANA";
	    SysConfigConstants[SysConfigConstants["LOGO_ORGANISATION"] = 'Logo'] = "LOGO_ORGANISATION";
	    SysConfigConstants[SysConfigConstants["KCAA_RECEIPT_PROCESSOR_ENABLED"] = 'Receipt processor starting timestamp enabled'] = "KCAA_RECEIPT_PROCESSOR_ENABLED";
	    SysConfigConstants[SysConfigConstants["ALL_AERODROMES_FM_FILTERS"] = 'All aerodromes in Flight Movements filters'] = "ALL_AERODROMES_FM_FILTERS";
	    SysConfigConstants[SysConfigConstants["ENABLED_VALIDATE_ROUTE_SDO_DATA"] = 'Validate route against SDO data'] = "ENABLED_VALIDATE_ROUTE_SDO_DATA";
	    SysConfigConstants[SysConfigConstants["ENABLED_VALIDATION_ROUTE"] = 'Validation route enabled'] = "ENABLED_VALIDATION_ROUTE";
	})(SysConfigConstants = exports.SysConfigConstants || (exports.SysConfigConstants = {}));


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 *
	 *
	 * this is a decorator, functionality is subject to change (https://www.typescriptlang.org/docs/handbook/decorators.html)
	 *
	 * Inject
	 * @param dependencies  Passed Services to give to the assigne controllers constructor
	 * @constructor
	 *
	 * Purpose:
	 *
	 * This allows a parent class to have services that do not require to be accessible to the child class
	 *
	 * How to use:
	 *
	 * If you have a constructor that is like this
	 *
	 * constructor(accountsService: AccountsService)
	 *
	 * You can use the decorator to make the 2nd (or last) parameter an Array of other objects
	 *
	 * @InjectDecorator(UsersService)
	 *
	 * The constructor now has another parameter
	 *
	 * constructor(accountsService: AccountsService, ... dependencies: Array<any>) {
	 *  dependencies[0] // is UsersService
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Inject = function () {
	    var dependencies = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        dependencies[_i] = arguments[_i];
	    }
	    return function (t) {
	        var original = t;
	        var newConstructor = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            for (var i = 0; i < dependencies.length; i++) {
	                args.push(dependencies[i]);
	            }
	            return original.apply(this, args);
	        };
	        newConstructor.prototype = original.prototype;
	        return newConstructor; // if this was not reusable `undefined` would actually be the Controller that this is decorating
	    };
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var ScFlightSearchController = (function (_super) {
	    __extends(ScFlightSearchController, _super);
	    /* @ngInject */
	    ScFlightSearchController.$inject = ["$scope", "scFlightSearchService", "customDate", "$filter"];
	    function ScFlightSearchController($scope, scFlightSearchService, customDate, $filter) {
	        var _this = _super.call(this, $scope, scFlightSearchService) || this;
	        _this.$scope = $scope;
	        _this.scFlightSearchService = scFlightSearchService;
	        _this.customDate = customDate;
	        _this.$filter = $filter;
	        _super.prototype.setup.call(_this);
	        _this.getFilterParameters();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.$watch('list', function () {
	            _this.getAccountBalance();
	        });
	        return _this;
	    }
	    ScFlightSearchController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            flightId: this.$scope.flightIdFilter,
	            icaoCode: this.$scope.icaoCodeFilter,
	            account: this.$scope.accountFilter,
	            startDate: startDate,
	            endDate: endDate,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ScFlightSearchController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return this.$scope.refresh(this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    ScFlightSearchController.prototype.getAccountBalance = function () {
	        this.$scope.accountBalance = null;
	        if (this.$scope.accountFilter && this.$scope.list.length) {
	            this.$scope.accountBalance = this.$filter('number')(this.$scope.list[0].associated_account_usd_balance, 2);
	        }
	    };
	    return ScFlightSearchController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScFlightSearchController = ScFlightSearchController;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var ScInactivityExpiryNoticeController = (function (_super) {
	    __extends(ScInactivityExpiryNoticeController, _super);
	    /* @ngInject */
	    ScInactivityExpiryNoticeController.$inject = ["$scope", "scInactivityExpiryNoticeService", "$filter", "$translate"];
	    function ScInactivityExpiryNoticeController($scope, scInactivityExpiryNoticeService, $filter, $translate) {
	        var _this = _super.call(this, $scope, scInactivityExpiryNoticeService) || this;
	        _this.$scope = $scope;
	        _this.scInactivityExpiryNoticeService = scInactivityExpiryNoticeService;
	        _this.$filter = $filter;
	        _this.$translate = $translate;
	        _super.prototype.setup.call(_this);
	        _this.getFilterParameters();
	        _this.$scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.$scope.editOverride = function (item) { return _this.editOverride(item); };
	        return _this;
	    }
	    ScInactivityExpiryNoticeController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    ScInactivityExpiryNoticeController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ScInactivityExpiryNoticeController.prototype.editOverride = function (item) {
	        _super.prototype.edit.call(this, item);
	        this.$scope.dateTime = this.$filter('dateConverter')(item.date_time, 'HH:mm');
	        this.$scope.noticeType = this.$translate.instant(item.notice_type);
	    };
	    return ScInactivityExpiryNoticeController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScInactivityExpiryNoticeController = ScInactivityExpiryNoticeController;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var AerodromeOperationalHoursController = (function (_super) {
	    __extends(AerodromeOperationalHoursController, _super);
	    /* @ngInject */
	    AerodromeOperationalHoursController.$inject = ["$scope", "aerodromeOperationalHoursService", "customDate", "aerodromesService"];
	    function AerodromeOperationalHoursController($scope, aerodromeOperationalHoursService, customDate, aerodromesService) {
	        var _this = _super.call(this, $scope, aerodromeOperationalHoursService) || this;
	        _this.$scope = $scope;
	        _this.aerodromeOperationalHoursService = aerodromeOperationalHoursService;
	        _this.customDate = customDate;
	        _this.aerodromesService = aerodromesService;
	        _super.prototype.setup.call(_this);
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.showTimeErrorMessage = [];
	        $scope.fromTimeIsAfterEndHours = [];
	        $scope.timeIsAlreadyExist = [];
	        $scope.showDateErrorMessage = [];
	        $scope.dateIsAlreadyExist = [];
	        $scope.timeFormatErrorMessage = 'Please enter valid hours (01-23) and minutes (01-59), each range should be separated by a semicolon';
	        $scope.timeIsAlreadyExistErrorMessage = 'Time is overlapping';
	        $scope.timeStartEndErrorMessage = 'From hours should be before end hours';
	        $scope.dateFormatErrorMessage = 'Please enter valid month (01-12) and date (01-31), each range should be separated by a semicolon';
	        $scope.dateIsAlreadyExistErrorMessage = 'Duplicate dates';
	        _this.aerodromesService.getAerodromesByBillingCentre().then(function (aerodromes) { return $scope.aerodromeWithServices = aerodromes.filter(function (e) { return e.aerodrome_name !== 'EANA'; }).map(function (e) { return e.aerodrome_name; }); });
	        _this.getFilterParameters();
	        $scope.$watch('list', function () { return _this.setCopyFromAerodromeList(); });
	        $scope.copyDataFromAerodrome = function (aerodrome) { return _this.copyDataFromAerodrome(aerodrome); };
	        $scope.timeValidate = function (time, fieldName, editableFieldName) { return _this.timeValidate(time, fieldName, editableFieldName); };
	        $scope.dateValidate = function (date, fieldName, editableFieldName) { return _this.dateValidate(date, fieldName, editableFieldName); };
	        $scope.create = function (editable, startDate, startTime, endDate, endTime) { return _this.createOverride(editable, startDate, startTime, endDate, endTime); };
	        $scope.update = function (editable, id, startDate, startTime, endDate, endTime) { return _this.updateOverride(editable, id, startDate, startTime, endDate, endTime); };
	        $scope.delete = function (id) { return _this.deleteOverride(id); };
	        $scope.edit = function (editable) { return _this.editOverride(editable); };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.showAerodromeOperationalHours = function (item, index) { return _this.showAerodromeOperationalHours(item, index); };
	        $scope.editAerodromeOperationalHours = function (item, index) { return _this.editAerodromeOperationalHours(item, index); };
	        _this.aerodromeOperationalHoursService.getAllDistinctAerodrome().then(function (aerodromes) {
	            $scope.copiedAerodromes = aerodromes.map(function (e) { return e.aerodrome; });
	        });
	        _this.aerodromeOperationalHoursService.getAllAerodromeOperationalHours().then(function (aerodromes) {
	            $scope.AerodromeOperationalHours = aerodromes;
	        });
	        return _this;
	    }
	    AerodromeOperationalHoursController.prototype.editAerodromeOperationalHours = function (item, index) {
	        _super.prototype.edit.call(this, item);
	        var startDay = moment(item.start_date_time).utc();
	        var endDay = moment(item.end_date_time).utc();
	        this.$scope.start_date = item.start_date_time;
	        this.$scope.end_date = item.end_date_time;
	        if (startDay.isValid())
	            this.$scope.start_time = startDay.format('HH').toString().concat(startDay.format('mm').toString());
	        if (endDay.isValid())
	            this.$scope.end_time = endDay.format('HH').toString().concat(endDay.format('mm').toString());
	        this.$scope.aerodromeSelected = this.$scope.editable.aerodrome;
	        this.$scope.editableIndex = index;
	    };
	    AerodromeOperationalHoursController.prototype.createOverride = function (editable, startDate, startTime, endDate, endTime) {
	        var _this = this;
	        this.$scope.editable.start_date_time = this.setDateTime(startDate, startTime);
	        this.$scope.editable.end_date_time = this.setDateTime(endDate, endTime);
	        _super.prototype.create.call(this, editable).then(function () { return _this.resetOverride(); });
	    };
	    AerodromeOperationalHoursController.prototype.setDateTime = function (date, time) {
	        var hoursMinutes = {
	            hours: parseInt(time.substring(0, 2), 10),
	            minutes: parseInt(time.substring(2), 10)
	        };
	        var hours = hoursMinutes.hours, minutes = hoursMinutes.minutes;
	        return moment(date).utc().startOf('day').hours(hours).minutes(minutes).toISOString();
	    };
	    AerodromeOperationalHoursController.prototype.updateOverride = function (editable, id, startDate, startTime, endDate, endTime) {
	        var _this = this;
	        this.$scope.editable.start_date_time = this.setDateTime(startDate, startTime);
	        this.$scope.editable.end_date_time = this.setDateTime(endDate, endTime);
	        _super.prototype.update.call(this, editable, id).then(function () { _this.resetOverride(); _this.refreshOverride(); });
	    };
	    AerodromeOperationalHoursController.prototype.showAerodromeOperationalHours = function (item, index) {
	        this.resetOverride();
	        this.$scope.editable = this.aerodromeOperationalHoursService.getModel();
	        this.$scope.editableIndexAerodrome = index;
	        this.$scope.editableIndex = null;
	        this.$scope.aerodromeOperationalHours = item.aerodrome_operational_hours;
	    };
	    AerodromeOperationalHoursController.prototype.deleteOverride = function (id) {
	        var _this = this;
	        _super.prototype.delete.call(this, id).then(function () { return _this.resetOverride(); });
	    };
	    AerodromeOperationalHoursController.prototype.editOverride = function (editable) {
	        this.resetOverride();
	        _super.prototype.edit.call(this, editable);
	    };
	    AerodromeOperationalHoursController.prototype.resetErrors = function () {
	        var _this = this;
	        var errors = ['showTimeErrorMessage',
	            'fromTimeIsAfterEndHours',
	            'timeIsAlreadyExist',
	            'showDateErrorMessage',
	            'dateIsAlreadyExist'];
	        errors.forEach(function (element) {
	            if (_this.$scope[element]) {
	                for (var item in _this.$scope[element]) {
	                    if (_this.$scope[element].hasOwnProperty(item)) {
	                        _this.$scope[element][item] = null;
	                    }
	                }
	            }
	        });
	    };
	    AerodromeOperationalHoursController.prototype.setCopyFromAerodromeList = function () {
	        this.$scope.copyFromAerodromeList = [];
	    };
	    AerodromeOperationalHoursController.prototype.copyDataFromAerodrome = function (aerodrome) {
	        var items = this.$scope.AerodromeOperationalHours
	            .filter(function (wrapper) {
	            return wrapper.aerodrome.aerodrome_name === aerodrome.aerodrome_name;
	        })
	            .sort(function (a, b) { return new Date(b.end_date_time).getTime() - new Date(a.end_date_time).getTime(); });
	        if (items.length === 0)
	            return;
	        var item = items[0]; // seleziono l'item con end_date_time maggiore
	        if (item) {
	            var keys = Object.keys(this.$scope.editable);
	            for (var j = 0; j < keys.length; j++) {
	                var key = keys[j];
	                if (key !== 'id' && key !== 'notes') {
	                    var value = item[key];
	                    if (key === 'start_date_time' && value) {
	                        var _a = value.split('T'), date = _a[0], time = _a[1];
	                        var timeClean = time.slice(0, 5).replace(':', '') || '';
	                        this.$scope.start_date = date;
	                        this.$scope.start_time = timeClean;
	                    }
	                    else if (key === 'end_date_time' && value) {
	                        var _b = value.split('T'), date = _b[0], time = _b[1];
	                        var timeClean = time.slice(0, 5).replace(':', '') || '';
	                        this.$scope.end_date = date;
	                        this.$scope.end_time = timeClean;
	                    }
	                    else if (key === 'aerodrome' && value) {
	                        this.$scope.editable[key] = value.aerodrome_name;
	                    }
	                    else {
	                        this.$scope.editable[key] = value;
	                    }
	                }
	            }
	        }
	    };
	    AerodromeOperationalHoursController.prototype.dateValidate = function (date, fieldName, editableFieldName) {
	        if (date) {
	            var array = date.split(';').filter(function (element) { return element; }).sort();
	            if (this.checkIfDateValid(array, fieldName)) {
	                this.setDateFieldError(fieldName, true, false);
	                this.$scope.editable[editableFieldName] = array.join(';');
	            }
	        }
	        else {
	            this.setDateFieldError(fieldName, true, false);
	        }
	    };
	    AerodromeOperationalHoursController.prototype.checkIfDateValid = function (array, fieldName) {
	        for (var index in array) {
	            if (array.hasOwnProperty(index)) {
	                if (this.checkIfDateIsAlreadyExist(array, array[index], fieldName, parseInt(index, 10))) {
	                    if (!moment(array[index], 'MM/DD', true).isValid() && array[index] !== '02/29') {
	                        this.$scope.form[fieldName].$setValidity('valid', false);
	                        this.$scope.showDateErrorMessage[fieldName] = true;
	                        return false;
	                    }
	                }
	                else {
	                    return false;
	                }
	            }
	        }
	        return true;
	    };
	    AerodromeOperationalHoursController.prototype.checkIfDateIsAlreadyExist = function (array, date, fieldName, index) {
	        if (array.includes(date) && array.indexOf(date) !== index) {
	            this.$scope.form[fieldName].$setValidity('valid', false);
	            this.$scope.dateIsAlreadyExist[fieldName] = true;
	            this.$scope.showDateErrorMessage[fieldName] = false;
	            return false;
	        }
	        return true;
	    };
	    AerodromeOperationalHoursController.prototype.timeValidate = function (time, fieldName, editableFieldName) {
	        if (time) {
	            var array = time.split(';').filter(function (element) { return element; }).sort();
	            if (this.checkIfTimeValid(array, fieldName) && this.checkIfTimeOverlapping(array, fieldName)) {
	                this.setTimeFieldError(fieldName, true, false);
	                this.$scope.editable[editableFieldName] = array.join(';');
	            }
	        }
	        else {
	            this.setTimeFieldError(fieldName, true, false);
	        }
	    };
	    AerodromeOperationalHoursController.prototype.checkIfTimeValid = function (array, fieldName) {
	        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	            var element = array_1[_i];
	            var hours = element.split('-');
	            var startTime = moment(hours[0], 'HHmm', true);
	            var endTime = moment(hours[1], 'HHmm', true);
	            if (startTime.isValid() && endTime.isValid() && hours[0] !== '2400' && hours[1] !== '2400' && hours.length === 2) {
	                if (!startTime.isBefore(endTime)) {
	                    this.$scope.form[fieldName].$setValidity('valid', false);
	                    this.$scope.fromTimeIsAfterEndHours[fieldName] = true;
	                    return false;
	                }
	            }
	            else {
	                this.$scope.form[fieldName].$setValidity('valid', false);
	                this.$scope.showTimeErrorMessage[fieldName] = true;
	                return false;
	            }
	        }
	        return true;
	    };
	    AerodromeOperationalHoursController.prototype.checkIfTimeOverlapping = function (array, fieldName) {
	        for (var element in array) {
	            if (array.hasOwnProperty(element)) {
	                if (!this.checkIfTimeIsAlreadyExist(array, array[element], parseInt(element, 10))) {
	                    this.$scope.form[fieldName].$setValidity('valid', false);
	                    this.$scope.timeIsAlreadyExist[fieldName] = true;
	                    return false;
	                }
	            }
	        }
	        return true;
	    };
	    AerodromeOperationalHoursController.prototype.checkIfTimeIsAlreadyExist = function (array, time, index) {
	        var exist = this.includesTime(array, time, index);
	        if (exist) {
	            return false;
	        }
	        return true;
	    };
	    AerodromeOperationalHoursController.prototype.includesTime = function (array, time, index) {
	        var hours = time.split('-');
	        var startTime = moment(hours[0], 'HHmm', true);
	        var endTime = moment(hours[1], 'HHmm', true);
	        return array
	            .filter(function (element, elementIndex) { return elementIndex !== index; })
	            .some(function (element) {
	            var existingHours = element.split('-');
	            var existingStartTime = moment(existingHours[0], 'HHmm', true);
	            var existingEndTime = moment(existingHours[1], 'HHmm', true);
	            return startTime.isBetween(existingStartTime, existingEndTime) || endTime.isBetween(existingStartTime, existingEndTime) ||
	                existingStartTime.isBetween(startTime, endTime) || existingEndTime.isBetween(startTime, endTime) ||
	                startTime.isSame(existingStartTime) || startTime.isSame(existingEndTime) ||
	                endTime.isSame(existingStartTime) || endTime.isSame(existingEndTime);
	        });
	    };
	    AerodromeOperationalHoursController.prototype.setTimeFieldError = function (fieldName, valid, error) {
	        this.$scope.form[fieldName].$setValidity('valid', valid);
	        this.$scope.showTimeErrorMessage[fieldName] = error;
	        this.$scope.fromTimeIsAfterEndHours[fieldName] = error;
	        this.$scope.timeIsAlreadyExist[fieldName] = error;
	    };
	    AerodromeOperationalHoursController.prototype.setDateFieldError = function (fieldName, valid, error) {
	        this.$scope.form[fieldName].$setValidity('valid', valid);
	        this.$scope.showDateErrorMessage[fieldName] = error;
	        this.$scope.dateIsAlreadyExist[fieldName] = error;
	    };
	    AerodromeOperationalHoursController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            'size': this.$scope.pagination && this.$scope.pagination.size || localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE) || 20,
	            'search': this.$scope.search,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0,
	            'aerodromeName': this.$scope.aerodromeName
	        };
	    };
	    AerodromeOperationalHoursController.prototype.refreshOverride = function () {
	        this.$scope.aerodromeOperationalHours = null;
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AerodromeOperationalHoursController.prototype.resetOverride = function () {
	        _super.prototype.reset.call(this);
	        this.$scope.start_date = null;
	        this.$scope.end_date = null;
	        this.$scope.start_time = null;
	        this.$scope.end_time = null;
	        this.resetErrors();
	        this.$scope.copyFromAerodrome = null;
	        this.$scope.editableIndexAerodrome = null;
	        this.$scope.editableIndex = null;
	    };
	    return AerodromeOperationalHoursController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AerodromeOperationalHoursController = AerodromeOperationalHoursController;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var InterestRatesController = (function (_super) {
	    __extends(InterestRatesController, _super);
	    /* @ngInject */
	    InterestRatesController.$inject = ["$scope", "$rootScope", "interestRatesService", "customDate"];
	    function InterestRatesController($scope, $rootScope, interestRatesService, customDate) {
	        var _this = _super.call(this, $scope, interestRatesService) || this;
	        _this.$scope = $scope;
	        _this.interestRatesService = interestRatesService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.create = function (editable) { return _this.createOverride(editable); };
	        $scope.update = function (editable, id) { return _this.updateOverride(editable, id); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    InterestRatesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    InterestRatesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    InterestRatesController.prototype.createOverride = function (editable) {
	        var _this = this;
	        this.setEditable(editable);
	        _super.prototype.create.call(this, editable).then(function () { return _this.$scope.control ? _this.$scope.control.reset() : ''; });
	    };
	    InterestRatesController.prototype.updateOverride = function (editable, id) {
	        var _this = this;
	        this.setEditable(editable);
	        _super.prototype.update.call(this, editable, id).then(function () { return _this.$scope.control ? _this.$scope.control.reset() : ''; });
	    };
	    InterestRatesController.prototype.setEditable = function (editable) {
	        var item = editable;
	        var default_interest_specification = item.default_interest_specification, default_interest_application = item.default_interest_application, default_foreign_interest_specified_percentage = item.default_foreign_interest_specified_percentage, default_national_interest_specified_percentage = item.default_national_interest_specified_percentage, punitive_interest_specification = item.punitive_interest_specification, punitive_interest_application = item.punitive_interest_application, punitive_interest_specified_percentage = item.punitive_interest_specified_percentage;
	        editable.default_foreign_interest_applied_percentage =
	            this.getAppliedPercentage(default_interest_specification, default_interest_application, default_foreign_interest_specified_percentage);
	        editable.default_national_interest_applied_percentage =
	            this.getAppliedPercentage(default_interest_specification, default_interest_application, default_national_interest_specified_percentage);
	        editable.punitive_interest_applied_percentage =
	            this.getAppliedPercentage(punitive_interest_specification, punitive_interest_application, punitive_interest_specified_percentage);
	    };
	    InterestRatesController.prototype.getAppliedPercentage = function (specification, application, percent) {
	        if (application === 'MONTHLY') {
	            switch (specification) {
	                case 'YEARLY': return percent / 12;
	                case 'MONTHLY': return percent;
	                case 'DAILY': return percent * 30;
	            }
	        }
	        if (application === 'DAILY') {
	            switch (specification) {
	                case 'YEARLY': return percent / 365;
	                case 'MONTHLY': return percent / 30;
	                case 'DAILY': return percent;
	            }
	        }
	        return null;
	    };
	    return InterestRatesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.InterestRatesController = InterestRatesController;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var localStorage_service_1 = __webpack_require__(9);
	// contants
	var system_configuration_constants_1 = __webpack_require__(10);
	var ServiceOutagesController = (function (_super) {
	    __extends(ServiceOutagesController, _super);
	    /* @ngInject */
	    ServiceOutagesController.$inject = ["$scope", "serviceOutagesService", "customDate", "aerodromesService"];
	    function ServiceOutagesController($scope, serviceOutagesService, customDate, aerodromesService) {
	        var _this = _super.call(this, $scope, serviceOutagesService) || this;
	        _this.$scope = $scope;
	        _this.serviceOutagesService = serviceOutagesService;
	        _this.customDate = customDate;
	        _this.aerodromesService = aerodromesService;
	        _super.prototype.setup.call(_this);
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.$watchGroup(['serviceType', 'aerodromeStatus'], function () { return _this.getFilterParameters(); });
	        _this.aerodromesService.getAllAerodromeServices().then(function (aerodromes) { return $scope.aerodromeWithServices = aerodromes; });
	        _this.aerodromesService.getAerodromeServiceTypes().then(function (serviceTypes) { return $scope.aerodromeServiceTypes = serviceTypes; });
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.create = function (item, startDate, startTime, endDate, endTime) {
	            return _this.createOverride(item, startDate, startTime, endDate, endTime);
	        };
	        $scope.update = function (item, id, startDate, startTime, endDate, endTime) {
	            return _this.updateOverride(item, id, startDate, startTime, endDate, endTime);
	        };
	        $scope.delete = function (id) { return _this.deleteOverride(id); };
	        $scope.editOutages = function (item, index) { return _this.editOutages(item, index); };
	        $scope.showOutages = function (item, index) { return _this.showOutages(item, index); };
	        $scope.getAerodromeServiceTypes = function (aerodrome) { return _this.getAerodromeServiceTypes(aerodrome); };
	        $scope.setDefaultData = function (aerodromeServiceType) { return _this.setDefaultData(aerodromeServiceType); };
	        $scope.clearTime = function (field, date) { return _this.clearTime(field, date); };
	        return _this;
	    }
	    ServiceOutagesController.prototype.showOutages = function (item, index) {
	        this.resetOverride();
	        this.$scope.editable = this.serviceOutagesService.getModel();
	        this.$scope.outages = item.aerodrome_service_outages;
	        this.$scope.editableIndexAerodrome = index;
	        this.$scope.editableIndex = null;
	    };
	    ServiceOutagesController.prototype.editOutages = function (item, index) {
	        _super.prototype.edit.call(this, item);
	        this.$scope.editableIndex = index;
	        var startDay = moment(item.start_date_time).utc();
	        var endDay = moment(item.end_date_time).utc();
	        this.$scope.start_date = item.start_date_time;
	        this.$scope.end_date = item.end_date_time;
	        this.$scope.start_time = startDay.format('HH').toString().concat(startDay.format('mm').toString());
	        this.$scope.end_time = endDay.format('HH').toString().concat(endDay.format('mm').toString());
	        this.$scope.editable.aerodrome = this.$scope.aerodromeWithServices.find(function (aerodrome) {
	            return aerodrome.aerodrome_name === item.aerodrome;
	        }).aerodrome_name;
	        this.$scope.editable.aerodrome_service_type = this.$scope.aerodromeServiceTypes.find(function (serviveType) {
	            return item.aerodrome_service_type === serviveType.service_name;
	        }).service_name;
	    };
	    ServiceOutagesController.prototype.getFilterParameters = function () {
	        this.$scope.startDateTimeFilter = null;
	        this.$scope.endDateTimeFilter = null;
	        if (this.$scope.startDateFilter) {
	            this.$scope.startDateTimeFilter = moment(this.$scope.startDateFilter).utc().startOf('day').toISOString();
	        }
	        if (this.$scope.endDateFilter) {
	            this.$scope.endDateTimeFilter = moment(this.$scope.endDateFilter).utc().endOf('day').toISOString();
	        }
	        if (this.$scope.startTimeFilter) {
	            this.$scope.startDateTimeFilter = this.setDateTime(this.$scope.startDateFilter, this.$scope.startTimeFilter);
	        }
	        if (this.$scope.endTimeFilter) {
	            this.$scope.endDateTimeFilter = this.setDateTime(this.$scope.endDateFilter, this.$scope.endTimeFilter);
	        }
	        this.$scope.filterParameters = {
	            'size': this.$scope.pagination && this.$scope.pagination.size || localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE) || 20,
	            'search': this.$scope.search,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0,
	            'serviceType': this.$scope.serviceType,
	            'aerodromeStatus': this.$scope.aerodromeStatus,
	            'aerodromeName': this.$scope.aerodromeName,
	            'startDateTime': this.$scope.startDateTimeFilter,
	            'endDateTime': this.$scope.endDateTimeFilter
	        };
	    };
	    ServiceOutagesController.prototype.refreshOverride = function () {
	        this.$scope.outages = null;
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    ServiceOutagesController.prototype.resetOverride = function () {
	        _super.prototype.reset.call(this);
	        this.$scope.start_date = null;
	        this.$scope.end_date = null;
	        this.$scope.start_time = null;
	        this.$scope.end_time = null;
	        this.$scope.editableIndexAerodrome = null;
	        this.$scope.editableIndex = null;
	    };
	    ServiceOutagesController.prototype.createOverride = function (item, startDate, startTime, endDate, endTime) {
	        var _this = this;
	        this.$scope.editable.start_date_time = this.setDateTime(startDate, startTime);
	        this.$scope.editable.end_date_time = this.setDateTime(endDate, endTime);
	        _super.prototype.create.call(this, item).then(function () { _this.resetOverride(); _this.refreshOverride(); });
	    };
	    ServiceOutagesController.prototype.updateOverride = function (item, id, startDate, startTime, endDate, endTime) {
	        var _this = this;
	        this.$scope.editable.start_date_time = this.setDateTime(startDate, startTime);
	        this.$scope.editable.end_date_time = this.setDateTime(endDate, endTime);
	        _super.prototype.update.call(this, item, id).then(function () { _this.resetOverride(); _this.refreshOverride(); });
	    };
	    ServiceOutagesController.prototype.deleteOverride = function (id) {
	        var _this = this;
	        _super.prototype.delete.call(this, id).then(function () { _this.resetOverride(); _this.refreshOverride(); });
	    };
	    ServiceOutagesController.prototype.setDateTime = function (date, time) {
	        var hoursMinutes = { hours: parseInt(time.substring(0, 2), 10),
	            minutes: parseInt(time.substring(2), 10) };
	        var hours = hoursMinutes.hours, minutes = hoursMinutes.minutes;
	        return moment(date).utc().startOf('day').hours(hours).minutes(minutes).toISOString();
	    };
	    ServiceOutagesController.prototype.getAerodromeServiceTypes = function (selectedAerodrome) {
	        this.$scope.aerodromeServiceTypes = this.$scope.aerodromeWithServices.find(function (aerodrome) {
	            return aerodrome.aerodrome_name === selectedAerodrome;
	        }).aerodrome_services;
	        this.$scope.editable.aerodrome_service_type = this.$scope.aerodromeServiceTypes[0].service_name;
	        this.setDefaultData(this.$scope.editable.aerodrome_service_type);
	    };
	    ServiceOutagesController.prototype.setDefaultData = function (aerodromeServiceType) {
	        var selectedServiceType = this.$scope.aerodromeServiceTypes.find(function (serviceType) {
	            return serviceType.service_name === aerodromeServiceType;
	        });
	        var service_outage_approach_discount_type = selectedServiceType.service_outage_approach_discount_type, service_outage_approach_amount = selectedServiceType.service_outage_approach_amount, service_outage_aerodrome_discount_type = selectedServiceType.service_outage_aerodrome_discount_type, service_outage_aerodrome_amount = selectedServiceType.service_outage_aerodrome_amount, default_flight_notes = selectedServiceType.default_flight_notes;
	        this.$scope.editable.approach_discount_type = service_outage_approach_discount_type;
	        this.$scope.editable.approach_discount_amount = service_outage_approach_amount;
	        this.$scope.editable.aerodrome_discount_type = service_outage_aerodrome_discount_type;
	        this.$scope.editable.aerodrome_discount_amount = service_outage_aerodrome_amount;
	        this.$scope.editable.flight_notes = default_flight_notes;
	    };
	    ServiceOutagesController.prototype.clearTime = function (field, date) {
	        if (!date) {
	            if (field === 'start') {
	                this.$scope.startTimeFilter = null;
	            }
	            if (field === 'end') {
	                this.$scope.endTimeFilter = null;
	            }
	        }
	    };
	    return ServiceOutagesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ServiceOutagesController = ServiceOutagesController;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var ScApprovalRequestController = (function (_super) {
	    __extends(ScApprovalRequestController, _super);
	    /* @ngInject */
	    ScApprovalRequestController.$inject = ["$scope", "scApprovalRequestService", "systemConfigurationService", "customDate", "$filter", "$translate"];
	    function ScApprovalRequestController($scope, scApprovalRequestService, systemConfigurationService, customDate, $filter, $translate) {
	        var _this = _super.call(this, $scope, scApprovalRequestService) || this;
	        _this.$scope = $scope;
	        _this.scApprovalRequestService = scApprovalRequestService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _this.$filter = $filter;
	        _this.$translate = $translate;
	        _super.prototype.setup.call(_this);
	        $scope.customDate = customDate.returnDateFormatStr(false);
	        _this.defaultApprovalResponse = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.APPROVAL_REQUEST_APPROVAL_RESPONSE);
	        _this.defaultRejectionResponse = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.APPROVAL_REQUEST_REJECTION_RESPONSE);
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        _this.getFilterParameters();
	        $scope.selectedRequests = [];
	        $scope.edit = function (item) { return _this.editOverride(item); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.approve = function (item, text) { return _this.approve(item, text); };
	        $scope.reject = function (item, text) { return _this.reject(item, text); };
	        $scope.approveSelected = function (text) { return _this.approveSelected(text); };
	        $scope.rejectSelected = function (text) { return _this.rejectSelected(text); };
	        $scope.getSelected = function () { return $scope.selected = _this.getIdsFromCheckboxes(); };
	        $scope.formatNameAndTranslate = function (name) { return _this.formatNameAndTranslate(name); };
	        return _this;
	    }
	    ScApprovalRequestController.prototype.editOverride = function (item) {
	        _super.prototype.edit.call(this, item);
	        this.$scope.date = this.$filter('dateConverter')(item.created_at, 'HHmm');
	        this.$scope.responseDate = this.$filter('dateConverter')(item.response_date, 'HHmm');
	        this.$scope.requestText = JSON.parse(this.$scope.editable.request_text);
	        this.$scope.approvalResponse = this.defaultApprovalResponse;
	        this.$scope.rejectionResponse = this.defaultRejectionResponse;
	        if (item.request_dataset === 'account') {
	            this.$scope.requestText.invoice_currency = this.$scope.requestText.invoice_currency.currency_name;
	            this.$scope.requestText.account_type = this.$scope.requestText.account_type.name;
	        }
	        if (item.request_dataset === 'aircraft registration') {
	            this.$scope.requestText.account = this.$scope.requestText.account.name;
	            this.$scope.requestText.mtow_override = this.$filter('weightConverter')(this.$scope.requestText.mtow_override);
	            this.$scope.requestText.aircraft_type = this.$scope.requestText.aircraft_type.aircraft_type;
	            this.$scope.requestText.country_of_registration = this.$scope.requestText.country_of_registration.country_name;
	            this.$scope.requestText.registration_expiry_date = this.$filter('dateConverter')(this.$scope.requestText.registration_expiry_date);
	            this.$scope.requestText.registration_start_date = this.$filter('dateConverter')(this.$scope.requestText.registration_start_date);
	        }
	        if (item.request_dataset === 'flight schedule') {
	            this.$scope.requestText.account = this.$scope.requestText.account.name;
	            this.$scope.requestText.start_date = this.$filter('dateConverter')(this.$scope.requestText.start_date);
	        }
	        if (this.$scope.requestText.account_users) {
	            var names = [];
	            for (var i = 0, len = this.$scope.requestText.account_users.length; i < len; i++) {
	                names.push(this.$scope.requestText.account_users[i].name);
	            }
	            ;
	            this.$scope.requestText.account_users = names.join(',');
	        }
	    };
	    ScApprovalRequestController.prototype.resetOverride = function () {
	        _super.prototype.reset.call(this);
	        this.$scope.requestText = null;
	        this.$scope.date = null;
	        this.$scope.selectedRequests = [];
	        this.$scope.selected = [];
	    };
	    ScApprovalRequestController.prototype.approve = function (item, text) {
	        var _this = this;
	        item.response_text = text;
	        this.$scope.showErrorOnTableForm = false;
	        this.$scope.showErrorOnDataForm = true;
	        this.scApprovalRequestService.approve(item, item.id).then(function () {
	            _this.resetOverride();
	            _this.refreshOverride();
	        }).catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    ScApprovalRequestController.prototype.reject = function (item, text) {
	        var _this = this;
	        item.response_text = text;
	        this.scApprovalRequestService.reject(item, item.id).then(function () {
	            _this.resetOverride();
	            _this.refreshOverride();
	        }).catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    ScApprovalRequestController.prototype.approveSelected = function (text) {
	        var _this = this;
	        this.$scope.showErrorOnDataForm = false;
	        this.$scope.showErrorOnTableForm = true;
	        this.scApprovalRequestService.approveSelected(this.$scope.selected, text).then(function () {
	            _this.resetOverride();
	            _this.refreshOverride();
	        }).catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    ScApprovalRequestController.prototype.rejectSelected = function (text) {
	        var _this = this;
	        this.scApprovalRequestService.rejectSelected(this.$scope.selected, text).then(function () {
	            _this.resetOverride();
	            _this.refreshOverride();
	        }).catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    ScApprovalRequestController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            account: this.$scope.account,
	            objectType: this.$scope.objectType,
	            status: this.$scope.status,
	            startDate: startDate,
	            endDate: endDate,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ScApprovalRequestController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return this.$scope.refresh(this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    ScApprovalRequestController.prototype.getIdsFromCheckboxes = function () {
	        var _this = this;
	        var keys = Object.keys(this.$scope.selectedRequests);
	        return keys.filter(function (key) { return _this.$scope.selectedRequests[key]; }).map(Number);
	    };
	    /**
	     * Formate and translate dynamic field label.
	     */
	    ScApprovalRequestController.prototype.formatNameAndTranslate = function (name) {
	        // return empty string if no name provided, nothing to translate
	        if (!name) {
	            return '';
	        }
	        // translate name instantly with underscores as spaces
	        var result = this.$translate.instant(name.replace(/_/g, ' '));
	        // if untranslated label contained 'mtow' include units
	        return result && name.includes('mtow')
	            ? result + " (" + this.$scope.mtowUnitOfMeasure + ")"
	            : result;
	    };
	    return ScApprovalRequestController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScApprovalRequestController = ScApprovalRequestController;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var helpers_service_1 = __webpack_require__(19);
	var ScCreditPaymentController = (function (_super) {
	    __extends(ScCreditPaymentController, _super);
	    /* @ngInject */
	    ScCreditPaymentController.$inject = ["$scope", "scCreditPaymentService", "systemConfigurationService", "$sce", "$state"];
	    function ScCreditPaymentController($scope, scCreditPaymentService, systemConfigurationService, $sce, $state) {
	        var _this = _super.call(this, $scope, scCreditPaymentService) || this;
	        _this.$scope = $scope;
	        _this.scCreditPaymentService = scCreditPaymentService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$sce = $sce;
	        _this.$state = $state;
	        _super.prototype.setup.call(_this);
	        _this.setCreditDefaults();
	        _this.validateCreditDefaults();
	        _this.getFilterParameters();
	        $scope.trustSrc = function (src) { return $sce.trustAsResourceUrl(src); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        // step 1 of cxPay system
	        $scope.sendNonSensitiveDataToCreditGateway = function (amount, accountId) { return _this.sendNonSensitiveDataToCreditGateway(amount, accountId); };
	        // step 3 of cxPay system
	        _this.checkTokenId();
	        return _this;
	    }
	    ScCreditPaymentController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    ScCreditPaymentController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ScCreditPaymentController.prototype.setCreditDefaults = function () {
	        this.configured = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.CC_PROCESSOR_CONFIGURED);
	        this.apiKey = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CC_PROCESSOR_PUBLIC_KEY);
	        this.url = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CC_PROCESSOR_URL);
	        this.processor = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CC_PROCESSOR);
	    };
	    ScCreditPaymentController.prototype.validateCreditDefaults = function () {
	        this.$scope.configurationWarning = false;
	        var isConfigured = function (v) {
	            if (v === null || v === undefined || v.length === 0) {
	                return false;
	            }
	            return true;
	        };
	        if (!this.configured || !isConfigured(this.apiKey) || !isConfigured(this.url) || !isConfigured(this.processor)) {
	            this.$scope.configurationWarning = true;
	        }
	    };
	    // send amount to be paid to BE, which sends it to cxPay
	    // and returns an object with a formUrl prop
	    ScCreditPaymentController.prototype.sendNonSensitiveDataToCreditGateway = function (amount, accountId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var cxPayStep1, error_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // if the amout or accound id is cleared by the user
	                        if (!amount || !accountId) {
	                            // set the formUrl back to null as he will
	                            // need a new one. This disables the subit button
	                            this.$scope.formUrl = null;
	                            return [2 /*return*/];
	                        }
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, this.scCreditPaymentService.sendNonSensitiveDataToCreditGateway(amount, accountId)];
	                    case 2:
	                        cxPayStep1 = _a.sent();
	                        // step 2 is an HTML form submission to the URL
	                        this.$scope.formUrl = cxPayStep1.response['form-url'];
	                        // if the response code is not success
	                        if (cxPayStep1.response.result !== 1) {
	                            // display the error from the gateway
	                            this.$scope.payment = cxPayStep1.response;
	                            this.$scope.paymentDeclinedMessage = true;
	                        }
	                        else {
	                            // success
	                            // update the amount to be paid var in the UI with
	                            // the user entered amount
	                            this.$scope.amountToBePaid = this.$scope.payment_amount;
	                        }
	                        return [3 /*break*/, 4];
	                    case 3:
	                        error_1 = _a.sent();
	                        console.error(error_1);
	                        return [3 /*break*/, 4];
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // step 3 of cxPay system
	    ScCreditPaymentController.prototype.checkTokenId = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var token, completed;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        token = helpers_service_1.HelperService.getUrlParamValueByName('token-id');
	                        if (!token) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.scCreditPaymentService.sendTokenIdToCreditGateway(token)];
	                    case 1:
	                        completed = _a.sent();
	                        // as step 3 is finished, remove the token from the URL
	                        this.$state.go('main.sc-credit-payment');
	                        // toggle the form open
	                        this.$scope.toggle = true;
	                        // refresh to update the table
	                        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	                        // parse and display gateway response
	                        this.displayTransactionCompletedResponse(completed.response);
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ScCreditPaymentController.prototype.displayTransactionCompletedResponse = function (response) {
	        this.$scope.paymentSuccessMessage = false;
	        this.$scope.paymentDeclinedMessage = false;
	        this.$scope.payment = response;
	        if (this.$scope.payment.result === 1) {
	            this.$scope.paymentSuccessMessage = true;
	        }
	        else {
	            this.$scope.paymentDeclinedMessage = true;
	        }
	    };
	    return ScCreditPaymentController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScCreditPaymentController = ScCreditPaymentController;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var HelperService = (function () {
	    function HelperService() {
	    }
	    /** @ngInject */
	    /**
	     * Takes the datepicker date/time (which would be the users local time) and converts and returns the date object in GMT
	     * It throws errors without converting the getTime() to string?
	     */
	    HelperService.convertLocalTimeToUTC = function (dateObj) {
	        var d = parseInt((dateObj.getTime() / 1000) + '', 10) - (dateObj.getTimezoneOffset() * 60); // returns date object
	        return new Date(d * 1000);
	    };
	    HelperService.convertLocalTimeToUTC.$inject = ["dateObj"];
	    /**
	     * Random number, both min/max included
	     *
	     * @param min
	     * @param max
	     * @returns {number}
	     */
	    HelperService.getRandomNumber = function (min, max) {
	        return Math.floor(Math.random() * (max - min + 1) + min);
	    };
	    /**
	     * Takes an date object, gets the ISO string from it but strips off the milliseconds
	     * @param dateObj
	     * @returns {*}
	     */
	    HelperService.dateToISOString = function (dateObj) {
	        var str = dateObj.toISOString();
	        return str.replace(/(.+)\.\d{3}\Z$/, '$1Z');
	    };
	    /**
	     * Inserting date objects returns it into a date ISO style string (without milliseconds) inside an object
	     *
	     * @param date JS Date Object
	     * @returns string
	     */
	    HelperService.getStartEndStrings = function (date) {
	        date = this.convertLocalTimeToUTC(date);
	        return this.dateToISOString(date);
	    };
	    /**
	     * Generates random characters/string
	     * @param num
	     * @returns {string}
	     */
	    HelperService.getRandomChar = function (num) {
	        if (num === void 0) { num = 1; }
	        var text = '';
	        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	        for (var i = 0; i < num; i++) {
	            text += possible.charAt(Math.floor(Math.random() * possible.length));
	        }
	        return text;
	    };
	    /**
	     * Returns a random hex color
	     * @returns {string}
	     */
	    HelperService.generateRandomHexColor = function () {
	        return ('000000' + Math.random().toString(16).slice(2, 8).toUpperCase()).slice(-6); // http://www.paulirish.com/2009/random-hex-color-code-snippets/
	    };
	    /**
	     * Returns result of banker's rounding. Even rounds up and odd rounds down.
	     * @param num number to round
	     * @param decimals decimals places to round (default 0)
	     * @returns {number}
	     */
	    HelperService.evenRound = function (num, decimals) {
	        if (decimals === void 0) { decimals = 0; }
	        if (num !== null && !isNaN(num)) {
	            var m = Math.pow(10, decimals);
	            var n = +(decimals ? num * m : num).toFixed(8); // avoid rounding errors
	            var i = Math.floor(n), f = n - i;
	            var e = 1e-8; // allow for rounding errors in f
	            var r = (f > 0.5 - e && f < 0.5 + e) ?
	                ((i % 2 === 0) ? i : i + 1) : Math.round(n);
	            return decimals ? r / m : r;
	        }
	    };
	    /**
	     * Returns object property in comma seperated string form from array of objects.
	     * @param array array of objects to loop through
	     * @param property property in object to comma seperate
	     * @param max max comma seperated values before eclipsed
	     * @returns {string}
	     */
	    HelperService.commaSeperate = function (array, property, max) {
	        var length = array.length;
	        max = max || length;
	        var result = '';
	        for (var i = 0; i < length; i++) {
	            result += array[i][property];
	            if (max < length && i >= max - 1) {
	                result += ', ...';
	                break;
	            }
	            else if (i !== length - 1) {
	                result += ', ';
	            }
	        }
	        return result;
	    };
	    /**
	     * Copies the contents of an element to the user's clipboard.
	     * @param element element to copy
	     */
	    HelperService.copyToClipboard = function (element) {
	        if (element !== null) {
	            var hide = false;
	            if (element.classList.contains('ng-hide')) {
	                element.classList.remove('ng-hide');
	                hide = true;
	            }
	            var range = document.createRange();
	            range.selectNodeContents(element);
	            var selection = window.getSelection();
	            selection.removeAllRanges();
	            selection.addRange(range);
	            document.execCommand('Copy');
	            if (hide) {
	                element.classList.add('ng-hide');
	            }
	        }
	    };
	    /**
	     * Check if valid JSON before setting value
	     * Useful for handling case where translation is not available
	     * Returns the Object corresponding to the given JSON text
	     * @param value a JSON string
	     * @returns {object}
	     */
	    HelperService.valueToJSON = function (value) {
	        try {
	            return JSON.parse(value);
	        }
	        catch (e) {
	            return null;
	        }
	    };
	    /**
	     * Get a url param value by url param name
	     * @param paramName string param
	     * @param defaultvalue any
	     * @returns {any}
	     */
	    HelperService.getUrlParamValueByName = function (paramName, defaultvalue) {
	        if (defaultvalue === void 0) { defaultvalue = false; }
	        var urlparameter = defaultvalue;
	        var getUrlVars = function () {
	            var vars = {};
	            window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
	                return vars[key] = value;
	            });
	            return vars;
	        };
	        if (window.location.href.indexOf(paramName) > -1) {
	            urlparameter = getUrlVars()[paramName];
	        }
	        return urlparameter;
	    };
	    return HelperService;
	}());
	exports.HelperService = HelperService;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var PasswordChangeController = (function (_super) {
	    __extends(PasswordChangeController, _super);
	    /* @ngInject */
	    PasswordChangeController.$inject = ["$scope", "usersService", "passwordChangeService", "$window"];
	    function PasswordChangeController($scope, usersService, passwordChangeService, $window) {
	        var _this = _super.call(this, $scope, passwordChangeService) || this;
	        _this.$scope = $scope;
	        _this.usersService = usersService;
	        _this.passwordChangeService = passwordChangeService;
	        _this.$window = $window;
	        _super.prototype.setup.call(_this, { refresh: false });
	        $scope.notificationText = 'Enter your current password, type a new password, and then type in again to confirm it. </br> After saving, you might need to re-enter your user name and password and sign in again.';
	        $scope.forcePasswordChange = JSON.parse(_this.$window.localStorage.getItem('forcePasswordChange'));
	        _this.usersService.current.then(function (user) {
	            var email = user.email, login = user.login;
	            $scope.email = email;
	            $scope.login = login;
	            $scope.editable.new_password = null;
	        });
	        $scope.updatePassword = function (changePassword) {
	            passwordChangeService.updatePassword(changePassword)
	                .then(function () { return _this.passwordChangeService.passwordChangedMessage(true); })
	                .catch(function (error) { return _this.$scope.error = { error: error }; });
	        };
	        return _this;
	    }
	    return PasswordChangeController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.PasswordChangeController = PasswordChangeController;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AircraftFlightsExemptionsController = (function (_super) {
	    __extends(AircraftFlightsExemptionsController, _super);
	    /* @ngInject */
	    AircraftFlightsExemptionsController.$inject = ["$scope", "aircraftFlightsExemptionsService", "systemConfigurationService", "customDate"];
	    function AircraftFlightsExemptionsController($scope, aircraftFlightsExemptionsService, systemConfigurationService, customDate) {
	        var _this = _super.call(this, $scope, aircraftFlightsExemptionsService) || this;
	        _this.$scope = $scope;
	        _this.aircraftFlightsExemptionsService = aircraftFlightsExemptionsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.getFilterParameters();
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.createOverride = function (editable, startDate, endDate) { return _this.createOverride(editable, startDate, endDate); };
	        $scope.updateOverride = function (editable, id, startDate, endDate) { return _this.updateOverride(editable, id, startDate, endDate); };
	        $scope.edit = function (item) { return _this.edit(item); };
	        return _this;
	    }
	    AircraftFlightsExemptionsController.prototype.edit = function (item) {
	        _super.prototype.edit.call(this, item);
	        if (item.exemption_start_date) {
	            this.$scope.control.setUTCStartDate(new Date(item.exemption_start_date));
	        }
	        if (item.exemption_end_date) {
	            this.$scope.control.setUTCEndDate(new Date(item.exemption_end_date));
	        }
	    };
	    AircraftFlightsExemptionsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AircraftFlightsExemptionsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AircraftFlightsExemptionsController.prototype.createOverride = function (editable, startDate, endDate) {
	        var _this = this;
	        editable.exemption_start_date = startDate;
	        editable.exemption_end_date = endDate;
	        _super.prototype.create.call(this, editable).then(function () {
	            if (typeof _this.$scope.control !== 'undefined') {
	                _this.$scope.control.reset();
	            }
	        });
	    };
	    AircraftFlightsExemptionsController.prototype.updateOverride = function (editable, id, startDate, endDate) {
	        var _this = this;
	        editable.exemption_start_date = startDate;
	        editable.exemption_end_date = endDate;
	        _super.prototype.update.call(this, editable, id).then(function () {
	            if (typeof _this.$scope.control !== 'undefined') {
	                _this.$scope.control.reset();
	            }
	        });
	    };
	    return AircraftFlightsExemptionsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AircraftFlightsExemptionsController = AircraftFlightsExemptionsController;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var ScPassengerServiceChargeReturnController = (function (_super) {
	    __extends(ScPassengerServiceChargeReturnController, _super);
	    /* @ngInject */
	    ScPassengerServiceChargeReturnController.$inject = ["$scope", "scPassengerServiceChargeReturnService", "$uibModal", "saveLocalTemplateService", "systemConfigurationService"];
	    function ScPassengerServiceChargeReturnController($scope, scPassengerServiceChargeReturnService, $uibModal, saveLocalTemplateService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, scPassengerServiceChargeReturnService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.scPassengerServiceChargeReturnService = scPassengerServiceChargeReturnService;
	        _this.$uibModal = $uibModal;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.uploadNew = function (item, id) { return _this.uploadNew(item, id); };
	        _this.saveLocalTemplate();
	        $scope.$watchGroup(['search', 'chargeReturnFilter'], function () { return _this.getFilterParameters(); });
	        $scope.cargoDisplayUnits = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CARGO_DISPLAY_UNITS);
	        $scope.extendedPassengerInformation = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.EXTENDED_PSCR_PASSENGER_INFORMATION_SUPPORT);
	        $scope.extendedCargoInformation = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.EXTENDED_PSCR_CARGO_INFORMATION_SUPPORT);
	        $scope.pageSize = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE);
	        $scope.edit = function (item) {
	            return _super.prototype.edit.call(_this, systemConfigurationService.convertCargoProperty(item, 'loaded_goods,discharged_goods,loaded_mail,discharged_mail'));
	        };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        return _this;
	    }
	    ScPassengerServiceChargeReturnController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search'], ['chargeReturnFilter', 'filter-orphan-returns']];
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'passenger-service-charge-return', filterPairs);
	    };
	    ScPassengerServiceChargeReturnController.prototype.uploadNew = function (item, id) {
	        var _this = this;
	        var path = [];
	        item.day_of_flight = new Date(item.day_of_flight).toISOString().replace('00.000Z', '00Z');
	        item.document_filename = item.document_filename2;
	        // sending id, instead of account, as part of multipart form
	        item.account_id = item.account.id;
	        if (id) {
	            path.push(id);
	        }
	        else {
	            path.push('new');
	        }
	        this.upload('PUT', path, item, null, null, true).then(function () {
	            _this.$scope.uploadJob = null;
	            _this.reset();
	            _this.refreshOverride();
	        }).catch(function (error) {
	            _this.$scope.error = {};
	            _this.$scope.error.error = { data: error };
	        });
	    };
	    ScPassengerServiceChargeReturnController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0,
	            'filter-orphan-returns': this.$scope.chargeReturnFilter
	        };
	    };
	    ScPassengerServiceChargeReturnController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return ScPassengerServiceChargeReturnController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.ScPassengerServiceChargeReturnController = ScPassengerServiceChargeReturnController;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// enums
	var crud_file_handler_type_1 = __webpack_require__(24);
	// controllers
	var crud_form_controller_1 = __webpack_require__(4);
	var CRUDFileUploadController = (function (_super) {
	    __extends(CRUDFileUploadController, _super);
	    function CRUDFileUploadController($scope, service, $uibModal, fileUploadLabel, propertyType) {
	        if (fileUploadLabel === void 0) { fileUploadLabel = 'Template Document'; }
	        if (propertyType === void 0) { propertyType = crud_file_handler_type_1.CrudFileHandlerPropertyType.Param; }
	        var _this = _super.call(this, service) || this;
	        _this.$scope = $scope;
	        _this.service = service;
	        _this.$uibModal = $uibModal;
	        _this.propertyType = propertyType;
	        $scope.pattern = '.csv';
	        $scope.patternSc = '.jpg, .gif, .png, .pdf';
	        $scope.multiple = 'false';
	        $scope.fileUploadLabel = fileUploadLabel;
	        $scope.fileUploadRequired = true;
	        $scope.fileUploadDisabled = false;
	        $scope.acceptedFileType = true;
	        $scope.acceptedFileTypeAircraftRegistration = true;
	        // added because the 'editable' object on the $scope does not exist until something is changed in the data entry form,
	        // however, some file uploads have no fields to enter and thus when a file is selected $scope.editable is undefined
	        // which causes an error
	        if (_this.$scope.editable === undefined || !_this.$scope.editable.hasOwnProperty('id')) {
	            _this.$scope.editable = {
	                id: null
	            };
	        }
	        return _this;
	    }
	    CRUDFileUploadController.prototype.createFormData = function (data) {
	        var fd = new FormData();
	        if (this.$scope.editable.document) {
	            fd.append('file', this.$scope.editable.document, this.$scope.editable.document_filename);
	        }
	        // add data properties to form data
	        if (data && this.propertyType === crud_file_handler_type_1.CrudFileHandlerPropertyType.Param) {
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    fd.append(key, data[key]);
	                }
	            }
	        }
	        else if (data && this.propertyType === crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) {
	            fd.append('properties', new Blob([angular.toJson(data)], { type: 'application/json' }));
	        }
	        return fd;
	    };
	    CRUDFileUploadController.prototype.setup = function (obj) {
	        var _this = this;
	        // add all functions from the service to this scope so they can be accessed
	        this.$scope.parse = function (file, filename) { return _this.parse(file, filename); };
	        this.$scope.parseSc = function (file, filename) { return _this.parseSc(file, filename); };
	        this.$scope.upload = function (method, dest, data, callback, params) { return _this.upload(method, dest, data, callback, params); };
	        this.$scope.preview = function (dest) { return _this.preview(dest); };
	        this.$scope.deleteFile = function (dest) { return _this.deleteFile(dest); };
	        // call setup in CRUDFormController
	        _super.prototype.setup.call(this, obj);
	    };
	    CRUDFileUploadController.prototype.upload = function (method, dest, data, callBack, params, preventCallback) {
	        var _this = this;
	        return this.service.upload(method, this.createFormData(data), dest, params).then(function (resp) {
	            _this.$scope.error = null;
	            if (method === 'PUT') {
	                _this.$scope.uploadJob = resp;
	            }
	            if (resp.error) {
	                return Promise.reject(resp);
	            }
	            if (callBack && callBack === 'list') {
	                return _this.service.list(params).then(function (resp) {
	                    _this.$scope.list = resp.content;
	                    var pagination = angular.copy(resp);
	                    delete pagination.content;
	                    _this.$scope.pagination = pagination;
	                });
	            }
	            if (!preventCallback) {
	                callBack ? _this.$scope[callBack](resp) : _this.service.listAll(params).then(function (resp) { return _this.$scope.list = resp.content; });
	            }
	        }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    CRUDFileUploadController.prototype.createFormDataScAccount = function (data) {
	        var fd = new FormData();
	        if (this.$scope.editable.document) {
	            fd.append('file', this.$scope.editable.document, this.$scope.editable.document_filename);
	        }
	        // add data properties to form data
	        if (data && this.propertyType === crud_file_handler_type_1.CrudFileHandlerPropertyType.Param) {
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    fd.append(key, data[key]);
	                }
	            }
	        }
	        else if (data && this.propertyType === crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) {
	            fd.append('accountDto', new Blob([angular.toJson(data)], { type: 'application/json' }));
	        }
	        return fd;
	    };
	    CRUDFileUploadController.prototype.createFormDataScAircraftRegistration = function (data) {
	        var fd = new FormData();
	        if (this.$scope.editable.document) {
	            fd.append('file', this.$scope.editable.document, this.$scope.editable.uploaded_document_name);
	        }
	        // add data properties to form data
	        if (data && this.propertyType === crud_file_handler_type_1.CrudFileHandlerPropertyType.Param) {
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    fd.append(key, data[key]);
	                }
	            }
	        }
	        else if (data && this.propertyType === crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) {
	            fd.append('aircraftRegistration', new Blob([angular.toJson(data)], { type: 'application/json' }));
	        }
	        return fd;
	    };
	    CRUDFileUploadController.prototype.uploadFileUpdateScAccount = function (method, dest, data, callBack, params, preventCallback) {
	        var _this = this;
	        return this.service.uploadFile(method, this.createFormDataScAccount(data), dest, params).then(function (resp) {
	            _this.$scope.error = null;
	            if (resp.error) {
	                return Promise.reject(resp);
	            }
	            if (callBack && callBack === 'list') {
	                return _this.service.list(params).then(function (resp) {
	                    _this.$scope.list = resp.content;
	                    var pagination = angular.copy(resp);
	                    delete pagination.content;
	                    _this.$scope.pagination = pagination;
	                });
	            }
	            if (!preventCallback) {
	                callBack ? _this.$scope[callBack](resp) : _this.service.listAll(params).then(function (resp) { return _this.$scope.list = resp.content; });
	            }
	        }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    CRUDFileUploadController.prototype.uploadFileCreateScAccount = function (method, dest, data, callBack, params, preventCallback) {
	        var _this = this;
	        return this.service.uploadFile(method, this.createFormDataScAccount(data), dest, params).then(function (resp) {
	            _this.$scope.error = null;
	            if (resp.error) {
	                return Promise.reject(resp);
	            }
	            if (callBack && callBack === 'list') {
	                return _this.service.list(params).then(function (resp) {
	                    _this.$scope.list = resp.content;
	                    var pagination = angular.copy(resp);
	                    delete pagination.content;
	                    _this.$scope.pagination = pagination;
	                });
	            }
	            if (!preventCallback) {
	                callBack ? _this.$scope[callBack](resp) : _this.service.listAll(params).then(function (resp) { return _this.$scope.list = resp.content; });
	            }
	        }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    CRUDFileUploadController.prototype.uploadFileUpdateScAircraftRegistration = function (method, dest, data, callBack, params, preventCallback) {
	        var _this = this;
	        return this.service.uploadFile(method, this.createFormDataScAircraftRegistration(data), dest, params).then(function (resp) {
	            _this.$scope.error = null;
	            if (resp.error) {
	                return Promise.reject(resp);
	            }
	            if (callBack && callBack === 'list') {
	                return _this.service.list(params).then(function (resp) {
	                    _this.$scope.list = resp.content;
	                    var pagination = angular.copy(resp);
	                    delete pagination.content;
	                    _this.$scope.pagination = pagination;
	                });
	            }
	            if (!preventCallback) {
	                callBack ? _this.$scope[callBack](resp) : _this.service.listAll(params).then(function (resp) { return _this.$scope.list = resp.content; });
	            }
	        }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    CRUDFileUploadController.prototype.uploadFileCreateScAircraftRegistration = function (method, dest, data, callBack, params, preventCallback) {
	        var _this = this;
	        return this.service.uploadFile(method, this.createFormDataScAircraftRegistration(data), dest, params).then(function (resp) {
	            _this.$scope.error = null;
	            if (resp.error) {
	                return Promise.reject(resp);
	            }
	            if (callBack && callBack === 'list') {
	                return _this.service.list(params).then(function (resp) {
	                    _this.$scope.list = resp.content;
	                    var pagination = angular.copy(resp);
	                    delete pagination.content;
	                    _this.$scope.pagination = pagination;
	                });
	            }
	            if (!preventCallback) {
	                callBack ? _this.$scope[callBack](resp) : _this.service.listAll(params).then(function (resp) { return _this.$scope.list = resp.content; });
	            }
	        }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    // sets the required file information to the scope to be used when the user
	    // uploads the file and any related fields of data
	    CRUDFileUploadController.prototype.parse = function (file, filename) {
	        var _this = this;
	        if (filename === void 0) { filename = 'document_filename'; }
	        var r = new FileReader();
	        if (file) {
	            r.onload = function (readerEvt) {
	                var binaryString = readerEvt.target.result;
	                var type = (file.name.substr(file.name.lastIndexOf('.') + 1) === 'csv' ? 'text/plain' : file.type);
	                var array = new Uint8Array(binaryString.length);
	                for (var i = 0, len = binaryString.length; i < len; i++) {
	                    array[i] = binaryString.charCodeAt(i);
	                }
	                _this.$scope.editable[filename] = file.name;
	                _this.$scope.editable.mime_type = type;
	                _this.$scope.editable.document = new Blob([array], { type: type });
	                // grab file extension and compare with pattern of acceptable types
	                // compare lower case version of file ext to list of valid extensions
	                var fileNameSplit = _this.$scope.editable[filename].split('.');
	                _this.$scope.acceptedFileType = _this.$scope.pattern === '.*' || _this.$scope.pattern.includes(fileNameSplit[fileNameSplit.length - 1].toLowerCase());
	            };
	            r.readAsBinaryString(file);
	        }
	    };
	    CRUDFileUploadController.prototype.parseSc = function (file, filename) {
	        var _this = this;
	        if (filename === void 0) { filename = 'uploaded_document_name'; }
	        var r = new FileReader();
	        if (file) {
	            r.onload = function (readerEvt) {
	                var binaryString = readerEvt.target.result;
	                var type = (file.name.substr(file.name.lastIndexOf('.') + 1) === 'csv' ? 'text/plain' : file.type);
	                var array = new Uint8Array(binaryString.length);
	                for (var i = 0, len = binaryString.length; i < len; i++) {
	                    array[i] = binaryString.charCodeAt(i);
	                }
	                _this.$scope.editable[filename] = file.name;
	                _this.$scope.editable.mime_type = type;
	                _this.$scope.editable.document = new Blob([array], { type: type });
	                // grab file extension and compare with pattern of acceptable types
	                // compare lower case version of file ext to list of valid extensions
	                var fileNameSplit = _this.$scope.editable[filename].split('.');
	                _this.$scope.acceptedFileTypeAircraftRegistration = _this.$scope.patternSc === '.*' || _this.$scope.patternSc.includes(fileNameSplit[fileNameSplit.length - 1].toLowerCase());
	            };
	            r.readAsBinaryString(file);
	        }
	    };
	    CRUDFileUploadController.prototype.deleteFile = function (dest) {
	        var _this = this;
	        return this.service.deleteFile(dest).then(function () { return _this.service.listAll().then(function (resp) { _this.$scope.list = resp.content; _this.reset(); }); }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    CRUDFileUploadController.prototype.preview = function (dest) {
	        var _this = this;
	        return this.service.preview(dest).then(function (resp) {
	            _this.createPreviewTable(resp.data);
	        }, function (error) { return _this.handleErrorResponse(error); });
	    };
	    CRUDFileUploadController.prototype.createPreviewTable = function (data) {
	        var _this = this;
	        var modal = this.$uibModal.open({
	            templateUrl: 'app/angular-ids-project/src/helpers/controllers/crud-file-handler/preview.template.html',
	            controller: ['$scope', function ($scope) {
	                    $scope.text = data;
	                    $scope.close = function () { return modal.close(); };
	                    _this.$scope.confirm = function () {
	                        modal.close();
	                    };
	                }]
	        });
	    };
	    CRUDFileUploadController.prototype.handleErrorResponse = function (error) {
	        this.$scope.error = {
	            error: error
	        };
	    };
	    return CRUDFileUploadController;
	}(crud_form_controller_1.CRUDFormController));
	exports.CRUDFileUploadController = CRUDFileUploadController;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CrudFileHandlerPropertyType;
	(function (CrudFileHandlerPropertyType) {
	    CrudFileHandlerPropertyType[CrudFileHandlerPropertyType["Param"] = 0] = "Param";
	    CrudFileHandlerPropertyType[CrudFileHandlerPropertyType["Part"] = 1] = "Part";
	    CrudFileHandlerPropertyType[CrudFileHandlerPropertyType["None"] = 2] = "None";
	})(CrudFileHandlerPropertyType = exports.CrudFileHandlerPropertyType || (exports.CrudFileHandlerPropertyType = {}));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var map_constants_1 = __webpack_require__(26);
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var ScInvoicesController = (function (_super) {
	    __extends(ScInvoicesController, _super);
	    /* @ngInject */
	    ScInvoicesController.$inject = ["$scope", "scInvoicesService", "invoicesService", "transactionsService", "flightMovementManagementService", "$uibModal", "$rootScope", "customDate", "systemConfigurationService", "usersService"];
	    function ScInvoicesController($scope, scInvoicesService, invoicesService, transactionsService, flightMovementManagementService, $uibModal, $rootScope, customDate, systemConfigurationService, usersService) {
	        var _this = _super.call(this, $scope, scInvoicesService, $uibModal) || this;
	        _this.$scope = $scope;
	        _this.scInvoicesService = scInvoicesService;
	        _this.invoicesService = invoicesService;
	        _this.transactionsService = transactionsService;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.$uibModal = $uibModal;
	        _this.$rootScope = $rootScope;
	        _this.customDate = customDate;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.usersService = usersService;
	        _super.prototype.setup.call(_this);
	        $scope.inverseExchange = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE);
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.usersService.getListLightWebUsers().then(function (users) {
	            $scope.usersList = users;
	            _this.getFilterParameters();
	        });
	        $scope.showFlightMovementOnMap = function (flightMovement) { return _this.showFlightMovementOnMap(flightMovement); };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.edit = function (invoice) { return _this.editOverride(invoice); };
	        $scope.getFlightMovementsByInvoiceId = function (invoiceId, page, size) { return _this.getFlightMovementsByInvoiceId(invoiceId, page, size)
	            .then(function (listFlightMovements) {
	            $scope.listFlightMovements = listFlightMovements;
	            $scope.listFlightMovements.number++; // fake the number one higher because it will be decreased in crud.service.ts
	            if (!page) {
	                _this.getTransactionPaymentsByInvoiceId(invoiceId)
	                    .then(function (listTransactionPayments) { return $scope.listTransactionPayments = listTransactionPayments; });
	            }
	        }); };
	        return _this;
	    }
	    // for non-aviation invoices, returns associated line items and transactions
	    ScInvoicesController.prototype.getLineItemsByInvoiceId = function (invoiceId) {
	        var _this = this;
	        this.invoicesService.getLineItemsByInvoiceId(invoiceId)
	            .then(function (lineItems) { return _this.$scope.lineItems = lineItems; });
	        this.getTransactionPaymentsByInvoiceId(invoiceId)
	            .then(function (listTransactionPayments) { return _this.$scope.listTransactionPayments = listTransactionPayments; });
	    };
	    // for aviation invoices, returns a list of flight movements by related invoice id
	    ScInvoicesController.prototype.getFlightMovementsByInvoiceId = function (invoiceId, page, size) {
	        return this.flightMovementManagementService.findAllFlightMovementsByAssociatedInvoiceId(invoiceId, page, size);
	    };
	    ScInvoicesController.prototype.getTransactionPaymentsByInvoiceId = function (invoiceId) {
	        return this.transactionsService.getTransactionPaymentsByInvoiceId(invoiceId);
	    };
	    ScInvoicesController.prototype.showFlightMovementOnMap = function (flightMovement) {
	        this.$rootScope.$broadcast('map.flyToEntity', map_constants_1.MapFlyToEntityType.SINGLE_FLIGHT_MOVEMENT, [flightMovement]);
	    };
	    ScInvoicesController.prototype.editOverride = function (invoice) {
	        // call parent edit method
	        _super.prototype.edit.call(this, invoice);
	        // get appropriate line items or flight movements based on type
	        invoice.invoice_type !== 'non-aviation'
	            ? this.$scope.getFlightMovementsByInvoiceId(invoice.id)
	            : this.getLineItemsByInvoiceId(invoice.id);
	    };
	    ScInvoicesController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            status: this.$scope.filter,
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            startDate: startDate,
	            endDate: endDate,
	            account: this.$scope.accountFilter,
	            createdByUserId: this.$scope.userFilter,
	            flightIdOrRegistration: this.$scope.flightIdOrRegistration,
	            billingCentre: this.$scope.billingCentreFilter
	        };
	    };
	    ScInvoicesController.prototype.refreshOverride = function () {
	        this.$scope.listFlightMovements = null;
	        this.$scope.listTransactionPayments = null;
	        this.$scope.lineItems = null;
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return ScInvoicesController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.ScInvoicesController = ScInvoicesController;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var MapFlyToEntityType;
	(function (MapFlyToEntityType) {
	    MapFlyToEntityType[MapFlyToEntityType["AIRSPACES"] = 'Airspaces'] = "AIRSPACES";
	    MapFlyToEntityType[MapFlyToEntityType["SINGLE_AIRSPACE"] = 'Single Airspace'] = "SINGLE_AIRSPACE";
	    MapFlyToEntityType[MapFlyToEntityType["SINGLE_FLIGHT_MOVEMENT"] = 'Single Flight Movement'] = "SINGLE_FLIGHT_MOVEMENT";
	    MapFlyToEntityType[MapFlyToEntityType["FLIGHT_MOVEMENT_INTERSECTION"] = 'Flight Movement Intersection'] = "FLIGHT_MOVEMENT_INTERSECTION";
	    MapFlyToEntityType[MapFlyToEntityType["SELECT_AIRSPACE"] = 'Select Airspace'] = "SELECT_AIRSPACE";
	    MapFlyToEntityType[MapFlyToEntityType["SELECT_AIRSPACE_NAVDB"] = 'Select Airspace NavDb'] = "SELECT_AIRSPACE_NAVDB";
	})(MapFlyToEntityType = exports.MapFlyToEntityType || (exports.MapFlyToEntityType = {}));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var ScTransactionsController = (function (_super) {
	    __extends(ScTransactionsController, _super);
	    /* @ngInject */
	    ScTransactionsController.$inject = ["$scope", "scTransactionsService", "transactionsService", "sysConfigBoolean", "systemConfigurationService", "customDate"];
	    function ScTransactionsController($scope, scTransactionsService, transactionsService, sysConfigBoolean, systemConfigurationService, customDate) {
	        var _this = _super.call(this, $scope, scTransactionsService) || this;
	        _this.$scope = $scope;
	        _this.scTransactionsService = scTransactionsService;
	        _this.transactionsService = transactionsService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.getInvoicesByTransactionId = function (id) { return scTransactionsService.getInvoicesByTransactionId(id).then(function (data) { return $scope.listOfInvoices = data; }); };
	        $scope.inverseExchange = sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE));
	        _this.getFilterParameters();
	        $scope.refreshList = function () { return _this.refreshList(); };
	        return _this;
	    }
	    ScTransactionsController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            exportedFilter: this.$scope.exportedFilter === true ? false : null,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            startDate: startDate,
	            endDate: endDate,
	            account: this.$scope.accountFilter
	        };
	    };
	    ScTransactionsController.prototype.refreshList = function () {
	        this.getFilterParameters();
	        return this.$scope.refresh(this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return ScTransactionsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScTransactionsController = ScTransactionsController;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var ScFlightSchedulesController = (function (_super) {
	    __extends(ScFlightSchedulesController, _super);
	    /* @ngInject */
	    ScFlightSchedulesController.$inject = ["$scope", "$uibModal", "scFlightSchedulesService", "flightScheduleManagementService", "systemConfigurationService", "scAccountManagementService", "$translate"];
	    function ScFlightSchedulesController($scope, $uibModal, scFlightSchedulesService, flightScheduleManagementService, systemConfigurationService, scAccountManagementService, $translate) {
	        var _this = _super.call(this, $scope, scFlightSchedulesService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.$uibModal = $uibModal;
	        _this.scFlightSchedulesService = scFlightSchedulesService;
	        _this.flightScheduleManagementService = flightScheduleManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.scAccountManagementService = scAccountManagementService;
	        _this.$translate = $translate;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.getAccountsWithFlightSchedule();
	        $scope.needAdminApproval = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_ADMIN_APPROVAL_FOR_SC_FLIGHT_SCHEDULES);
	        // for daily schedule
	        $scope.days = []; // initialize model for multiselect
	        $scope.listOfDays = flightScheduleManagementService.getDaysOfWeek();
	        $scope.addDaysToSchedule = function () { return _this.addDaysToSchedule($scope.days); };
	        $scope.formatDailySchedules = function (schedules, separator) { return _this.formatDailySchedules(schedules, separator); };
	        $scope.preUploadSchedules = function (startDate, document) { return _this.preUploadSchedules(startDate, document); };
	        $scope.edit = function (schedule) { return _this.editOverride(schedule); };
	        $scope.setStatus = function (item) { return _this.setStatus(item); };
	        $scope.update = function (editable, id) { return _super.prototype.update.call(_this, editable, id).then(function () { return _this.getAccountsWithFlightSchedule(); }); };
	        $scope.create = function (editable) { return _super.prototype.create.call(_this, editable).then(function () { return _this.getAccountsWithFlightSchedule(); }); };
	        $scope.delete = function (id) { return _super.prototype.delete.call(_this, id).then(function () { return _this.getAccountsWithFlightSchedule(); }); };
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        // override list, should only
	        // call if accountId is present
	        _this.list = function () { return _this.refreshOverride(); };
	        // because refresh:false is
	        // in super.setup, we need to
	        // init the pagination object
	        $scope.pagination = {};
	        // do not make a call for flight schedules until an account has been
	        // selected in the dropdown service
	        $scope.$watch('accountId', function () {
	            _this.refreshOverride();
	        });
	        return _this;
	    }
	    /**
	     * Checks the CSV and warns the user
	     * if any schedules will be set
	     * to inactive
	     *
	     * @param  {string} startDate
	     * @param  {any} document
	     */
	    ScFlightSchedulesController.prototype.preUploadSchedules = function (startDate, document) {
	        var _this = this;
	        this.scFlightSchedulesService.preUploadSchedules(startDate, document)
	            .then(function (data) {
	            var changedSchedulesSet = new Set();
	            var changedSchedulesArray = [];
	            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
	                var item = data_1[_i];
	                changedSchedulesSet.add(item.id + " " + item.details);
	            }
	            changedSchedulesArray = Array.from(changedSchedulesSet);
	            var warning = changedSchedulesArray.join('\n');
	            // only create model if ther
	            // is a warning to show
	            if (warning && warning.length) {
	                _this.createWarningModel(warning);
	            }
	            else {
	                _super.prototype.upload.call(_this, 'PUT', null, null, 'refreshOverride', { 'startDate': _this.$scope.start.toISOString() })
	                    .then(function () { return _this.getAccountsWithFlightSchedule(); });
	            }
	        }, function (error) {
	            _this.$scope.error = { error: error };
	        });
	    };
	    /**
	     * Modal to warn user of schedule
	     * overriding
	     */
	    ScFlightSchedulesController.prototype.createWarningModel = function (warning) {
	        var _this = this;
	        var modal = this.$uibModal.open({
	            templateUrl: 'app/partials/flight-schedule-management/schedule-warning.template.html',
	            controller: ['$scope', function ($scope) {
	                    $scope.warning = warning;
	                    $scope.close = function () { return modal.close(); };
	                    $scope.confirm = function () {
	                        modal.close();
	                        _super.prototype.upload.call(_this, 'PUT', null, null, 'refreshOverride', { 'startDate': _this.$scope.start.toISOString() })
	                            .then(function () { return _this.getAccountsWithFlightSchedule(); });
	                    };
	                }]
	        });
	    };
	    /**
	     * Adds days of week selected from
	     * multiselect to a comma separated
	     * string of values
	     *
	     * @param  {Array<any>} days
	     */
	    ScFlightSchedulesController.prototype.addDaysToSchedule = function (days) {
	        var dailySchedule = days.map(function (day) {
	            return day.value;
	        });
	        // send daily schedule as comma
	        // separated string
	        // eg. 1,5,7
	        this.$scope.editable.daily_schedule = dailySchedule.join(',');
	    };
	    ScFlightSchedulesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            accountId: this.$scope.accountId,
	            search: this.$scope.search,
	            page: this.$scope.pagination.number
	        };
	    };
	    /**
	     * Calls list with applied filters and create object for download
	     *
	     * @returns promise
	     */
	    ScFlightSchedulesController.prototype.refreshOverride = function () {
	        var _this = this;
	        this.getFilterParameters();
	        if (this.$scope.accountId) {
	            return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString()).then(function (schedules) {
	                _this.$scope.accountSchedules = schedules.content.map(function (schedule) {
	                    return {
	                        'flight_service_number': schedule.flight_service_number,
	                        'dep_ad': schedule.dep_ad,
	                        'dep_time': schedule.dep_time,
	                        'dest_ad': schedule.dest_ad,
	                        'dest_time': schedule.dest_time,
	                        'daily_schedule': _this.formatDailySchedules(schedule.daily_schedule, '/')
	                    };
	                });
	            });
	        }
	    };
	    // override reset to also
	    // clear the multiselect
	    ScFlightSchedulesController.prototype.resetOverride = function () {
	        this.$scope.days = [];
	        _super.prototype.reset.call(this);
	    };
	    // override edit to add the
	    // days to the multiselect
	    // upon clicking a record
	    ScFlightSchedulesController.prototype.editOverride = function (schedule) {
	        var days = schedule.daily_schedule.split(',');
	        this.$scope.days = []; // clear out current selections
	        // match each sched number to the value
	        // of the days in listOfDays
	        for (var _i = 0, days_1 = days; _i < days_1.length; _i++) {
	            var day = days_1[_i];
	            for (var _a = 0, _b = this.$scope.listOfDays; _a < _b.length; _a++) {
	                var item = _b[_a];
	                if (day === item.value) {
	                    this.$scope.days.push(item);
	                }
	            }
	        }
	        _super.prototype.edit.call(this, schedule);
	    };
	    /**
	     * Format days from CSV for
	     * data-grid display
	     *
	     * @param  {string} days
	     * @returns string
	     */
	    ScFlightSchedulesController.prototype.formatDailySchedules = function (days, separator) {
	        var arrOfDays = days.split(',');
	        var daysInNumbers = [];
	        for (var _i = 0, arrOfDays_1 = arrOfDays; _i < arrOfDays_1.length; _i++) {
	            var day = arrOfDays_1[_i];
	            switch (day) {
	                case '1':
	                    daysInNumbers.push(" " + this.$translate.instant('SUNDAY'));
	                    break;
	                case '2':
	                    daysInNumbers.push(" " + this.$translate.instant('MONDAY'));
	                    break;
	                case '3':
	                    daysInNumbers.push(" " + this.$translate.instant('TUESDAY'));
	                    break;
	                case '4':
	                    daysInNumbers.push(" " + this.$translate.instant('WEDNESDAY'));
	                    break;
	                case '5':
	                    daysInNumbers.push(" " + this.$translate.instant('THURSDAY'));
	                    break;
	                case '6':
	                    daysInNumbers.push(" " + this.$translate.instant('FRIDAY'));
	                    break;
	                case '7':
	                    daysInNumbers.push(" " + this.$translate.instant('SATURDAY'));
	                    break;
	            }
	            ;
	        }
	        ;
	        return daysInNumbers.join(separator).trim();
	    };
	    ScFlightSchedulesController.prototype.getAccountsWithFlightSchedule = function () {
	        var _this = this;
	        this.scAccountManagementService.getAccountsWithFlightSchedules().then(function (list) {
	            _this.$scope.accountsWithFlightSchedules = list;
	            if (!_this.$scope.accountId && _this.$scope.accountsWithFlightSchedules[0]) {
	                _this.$scope.accountId = _this.$scope.accountsWithFlightSchedules[0].id;
	            }
	        });
	    };
	    ScFlightSchedulesController.prototype.setStatus = function (item) {
	        if (item.sc_request_type === 'create') {
	            return 'create pending';
	        }
	        else if (item.sc_request_type === 'update') {
	            return 'update pending';
	        }
	        else if (item.sc_request_type === 'delete') {
	            return 'delete pending';
	        }
	        else if (!item.sc_request_type) {
	            return 'approved';
	        }
	        else {
	            return '';
	        }
	    };
	    return ScFlightSchedulesController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.ScFlightSchedulesController = ScFlightSchedulesController;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var crud_file_handler_type_1 = __webpack_require__(24);
	var ScAircraftRegistrationController = (function (_super) {
	    __extends(ScAircraftRegistrationController, _super);
	    /* @ngInject */
	    ScAircraftRegistrationController.$inject = ["$scope", "flightMovementManagementService", "scAircraftRegistrationService", "aircraftTypeManagementService", "systemConfigurationService", "$state", "$translate", "customDate"];
	    function ScAircraftRegistrationController($scope, flightMovementManagementService, scAircraftRegistrationService, aircraftTypeManagementService, systemConfigurationService, $state, $translate, customDate) {
	        var _this = 
	        // setup
	        _super.call(this, $scope, scAircraftRegistrationService, null, 'File Name', crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) || this;
	        _this.$scope = $scope;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.scAircraftRegistrationService = scAircraftRegistrationService;
	        _this.aircraftTypeManagementService = aircraftTypeManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$state = $state;
	        _this.$translate = $translate;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        $scope.patternSc = '.jpg, .gif, .png, .pdf';
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        aircraftTypeManagementService.listAll().then(function (data) { return _this.$scope.aircraftTypesList = data.content; });
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.needAdminApproval = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_ADMIN_APPROVAL_FOR_SC_AIRCRAFT_REGISTRATION);
	        $scope.notification_text = 'I am accepting responsibility for all aviation charges for that aircraft over the ANSP’s FIR for the period of the registration';
	        $scope.fileUploadRequired = true;
	        $scope.getAircraftTypeByLatestRegistrationNumber = function (registrationNumber) { return _this.getAircraftTypeByLatestRegistrationNumber(registrationNumber); };
	        $scope.getCountryByRegistrationNumberPrefix = function (prefix) { return _this.getCountryByRegistrationNumberPrefix(prefix); };
	        _this.getFilterParameters();
	        // functions
	        $scope.addDate = function (aircraft) { return _this.addDate(aircraft); }; // avoid using edit function to prevent table from automatically updating
	        $scope.convertMtowProperty = function (aircraftType) { return _this.convertMtowProperty(aircraftType); };
	        $scope.create = function (aircraft, control, controlCoa) { return _this.createOverride(aircraft, control, controlCoa); };
	        $scope.edit = function (item) { _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(item, 'mtow_override')); };
	        $scope.setEditable = function (aircraft, index) { return _this.setEditable(aircraft, index); };
	        $scope.update = function (aircraft, control, controlCoa) { return _this.updateOverride(aircraft, control, controlCoa); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.setStatus = function (item) { return _this.setStatus(item); };
	        $scope.setLocal = function (country) { return _this.setLocal(country); };
	        // matching
	        $scope.country = null;
	        $scope.countryMatch = false;
	        $scope.error = null;
	        // if country override field is modified, check if form is valid
	        $scope.$watch('editable.country_override', function () { return _this.handleOverrideError(); });
	        $scope.$watch('editable.country_of_registration', function () {
	            var country = _this.$scope.country;
	            // if a country is returned from the registration number and its name matches the country of registration
	            if (country && country.country_name === _this.$scope.editable.country_of_registration.country_name) {
	                _this.$scope.editable.country_override = false;
	                _this.$scope.countryMatch = true;
	            }
	            else {
	                _this.$scope.countryMatch = false;
	                _this.handleOverrideError();
	            }
	        });
	        return _this;
	    }
	    ScAircraftRegistrationController.prototype.reset = function () {
	        if (typeof this.$scope.control !== 'undefined') {
	            this.$scope.control.reset();
	            this.$scope.countryMatch = false;
	        }
	        if (this.$scope.control_coa) {
	            this.$scope.control_coa.reset();
	        }
	        _super.prototype.reset.call(this);
	        this.$scope.editableIndex = null;
	    };
	    ScAircraftRegistrationController.prototype.createOverride = function (aircraft, control, controlCoa) {
	        var _this = this;
	        this.setDates(aircraft, control, controlCoa);
	        return _super.prototype.uploadFileCreateScAircraftRegistration.call(this, 'POST', null, aircraft, null).then(function (createdAircraft) {
	            if (_this.$state && _this.$state.params.after) {
	                _this.$state.go(_this.$state.params.after.create.goTo.state, {
	                    accountId: createdAircraft.account.id
	                });
	            }
	            _this.reset();
	        });
	    };
	    ScAircraftRegistrationController.prototype.updateOverride = function (aircraft, control, controlCoa) {
	        var _this = this;
	        this.setDates(aircraft, control, controlCoa);
	        return _super.prototype.uploadFileUpdateScAircraftRegistration.call(this, 'PUT', null, aircraft, 'refreshOverride', aircraft.id).then(function () {
	            _this.reset();
	        });
	    };
	    ScAircraftRegistrationController.prototype.addDate = function (aircraftRegistration) {
	        if (aircraftRegistration.registration_start_date) {
	            var startDate = new Date(aircraftRegistration.registration_start_date);
	            this.$scope.control.setUTCStartDate(startDate);
	        }
	        if (aircraftRegistration.registration_expiry_date) {
	            var endDate = new Date(aircraftRegistration.registration_expiry_date);
	            this.$scope.control.setUTCEndDate(endDate);
	        }
	        if (aircraftRegistration.coa_issue_date && aircraftRegistration.coa_expiry_date) {
	            var coaStartDate = new Date(aircraftRegistration.coa_issue_date);
	            this.$scope.control_coa.setUTCStartDate(coaStartDate);
	            var coaEndDate = new Date(aircraftRegistration.coa_expiry_date);
	            this.$scope.control_coa.setUTCEndDate(coaEndDate);
	        }
	        else {
	            this.$scope.control_coa.reset();
	        }
	    };
	    ScAircraftRegistrationController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ScAircraftRegistrationController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    // when a user chooses an entry to edit
	    ScAircraftRegistrationController.prototype.setEditable = function (aircraft, index) {
	        var _this = this;
	        // await API call for reg number to check for country match
	        this.scAircraftRegistrationService.getCountryByRegistrationNumberPrefix(aircraft.registration_number).then(function (country) {
	            _this.$scope.countryMatch = true;
	            _this.$scope.country = country;
	        }).catch(function () {
	            _this.$scope.countryMatch = false;
	            _this.$scope.country = null;
	        }).finally(function () {
	            _this.$scope.edit(aircraft);
	            _this.$scope.editableIndex = index;
	            _this.$scope.addDate(aircraft);
	            _this.$scope.form.$setUntouched();
	        });
	    };
	    ScAircraftRegistrationController.prototype.convertMtowProperty = function (aircraftType) {
	        this.$scope.editable.mtow_override = this.systemConfigurationService
	            .convertMtowProperty(aircraftType, 'maximum_takeoff_weight')
	            .maximum_takeoff_weight;
	    };
	    ScAircraftRegistrationController.prototype.getAircraftTypeByLatestRegistrationNumber = function (registrationNumber) {
	        var _this = this;
	        if (registrationNumber && registrationNumber.length >= 2) {
	            this.flightMovementManagementService.getAircraftTypeByLatestRegistrationNumber(registrationNumber).then(function (aircraftType) {
	                if (aircraftType) {
	                    _this.$scope.editable.mtow_override = aircraftType.maximum_takeoff_weight;
	                    _this.$scope.editable = _this.systemConfigurationService.convertMtowProperty(_this.$scope.editable, 'mtow_override');
	                    // we have to search to see if we can find the right aircraft type
	                    for (var _i = 0, _a = _this.$scope.aircraftTypesList; _i < _a.length; _i++) {
	                        var value = _a[_i];
	                        if (value.aircraft_type === aircraftType.aircraft_type) {
	                            // update the aircraft type field
	                            _this.$scope.editable.aircraft_type = value;
	                        }
	                    }
	                }
	            });
	        }
	    };
	    // if not overridden, attempts to find a
	    // country by the registration number prefix
	    ScAircraftRegistrationController.prototype.getCountryByRegistrationNumberPrefix = function (prefix) {
	        var _this = this;
	        if (prefix && prefix.length >= 2 && !this.$scope.editable.country_override) {
	            this.scAircraftRegistrationService.getCountryByRegistrationNumberPrefix(prefix).then(function (country) {
	                if (country) {
	                    _this.setLocal(country);
	                    _this.$scope.editable.country_of_registration = country;
	                    _this.$scope.countryMatch = true;
	                    _this.$scope.country = country;
	                }
	            }).catch(function () {
	                if (!_this.$scope.editable.country_override) {
	                    _this.$scope.editable.country_of_registration = null;
	                }
	                _this.$scope.countryMatch = false;
	                _this.$scope.country = null;
	            }).finally(function () {
	                _this.handleOverrideError();
	            });
	        }
	    };
	    ScAircraftRegistrationController.prototype.handleOverrideError = function () {
	        var _a = this.$scope, country = _a.country, countryMatch = _a.countryMatch, editable = _a.editable;
	        var registration_number = editable.registration_number, country_of_registration = editable.country_of_registration, country_override = editable.country_override;
	        // if country is overriden or there is a country match
	        if (country_override || (country && countryMatch)) {
	            this.$scope.error = null;
	            // if no country match or override but the user has entered in registration number and country
	        }
	        else if (registration_number && country_of_registration && country_of_registration.id) {
	            this.$scope.error = {
	                error: {
	                    data: {
	                        error: this.$translate.instant('Override country of registration'),
	                        error_description: this.$translate.instant('Registration number and country of registration match error. Override country of registration to continue.'),
	                        field_errors: null
	                    }
	                }
	            };
	        }
	    };
	    ScAircraftRegistrationController.prototype.setStatus = function (item) {
	        if (item.sc_request_type === 'create') {
	            return 'create pending';
	        }
	        else if (item.sc_request_type === 'update') {
	            return 'update pending';
	        }
	        else if (item.sc_request_type === 'delete') {
	            return 'delete pending';
	        }
	        else if (!item.sc_request_type) {
	            return 'approved';
	        }
	        else {
	            return '';
	        }
	    };
	    ScAircraftRegistrationController.prototype.setDates = function (aircraft, control, controlCoa) {
	        aircraft.registration_start_date = control.getUTCStartDate();
	        aircraft.registration_expiry_date = control.getUTCEndDate();
	        aircraft.coa_issue_date = controlCoa.getUTCStartDate();
	        aircraft.coa_expiry_date = controlCoa.getUTCEndDate();
	    };
	    ScAircraftRegistrationController.prototype.setLocal = function (country) {
	        var countryANSP = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_COUNTRY_CODE);
	        this.$scope.editable.is_local = country.country_code === countryANSP;
	    };
	    return ScAircraftRegistrationController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.ScAircraftRegistrationController = ScAircraftRegistrationController;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var ScUserManagementController = (function (_super) {
	    __extends(ScUserManagementController, _super);
	    /* @ngInject */
	    ScUserManagementController.$inject = ["$scope", "$rootScope", "scUserManagementService"];
	    function ScUserManagementController($scope, $rootScope, scUserManagementService) {
	        var _this = _super.call(this, $scope, scUserManagementService) || this;
	        _this.$scope = $scope;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _super.prototype.list.call(_this, {}, "selfCareUser=true");
	        // used to call password directive resetPass method
	        // this will clean password fields and validatin flags/messages
	        $scope.resetPassword = function () { return _this.$scope.resetPass = new Date().getTime(); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    ScUserManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            selfCareUser: true,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ScUserManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return this.$scope.refresh(this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return ScUserManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScUserManagementController = ScUserManagementController;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// services
	var localStorage_service_1 = __webpack_require__(9);
	var ScUserRegistrationController = (function (_super) {
	    __extends(ScUserRegistrationController, _super);
	    /* @ngInject */
	    ScUserRegistrationController.$inject = ["$scope", "scUserRegistrationService", "recaptchaService", "$location", "selfCareHelper"];
	    function ScUserRegistrationController($scope, scUserRegistrationService, recaptchaService, $location, selfCareHelper) {
	        var _this = _super.call(this, $scope, scUserRegistrationService) || this;
	        _this.$scope = $scope;
	        _this.recaptchaService = recaptchaService;
	        _this.$location = $location;
	        _this.selfCareHelper = selfCareHelper;
	        _this.PASSWORD_MINIMUM_LENGTH = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.PASSWORD_MINIMUM_LENGTH;
	        _this.REQUIRE_EMAIL_VERIFICATION = system_configuration_constants_1.SysConfigConstants.REQUIRE_EMAIL_VERIFICATION.toString();
	        _super.prototype.setup.call(_this, { refresh: false });
	        if (!$scope.requireEmail) {
	            _this.selfCareHelper.fetchConfig(_this.REQUIRE_EMAIL_VERIFICATION).then(function (resp) {
	                $scope.requireEmail = localStorage_service_1.LocalStorageService.get(_this.REQUIRE_EMAIL_VERIFICATION);
	            });
	        }
	        ;
	        // initialization
	        $scope.showButton = null;
	        $scope.processing = null;
	        // test to see if password configurations are available
	        // if not download them and add to localstorage
	        if (!localStorage_service_1.LocalStorageService.get(_this.PASSWORD_MINIMUM_LENGTH)) {
	            _this.getPasswordSettings();
	        }
	        // functions exposed to the template
	        $scope.createOverride = function (editable) { return _this.createOverride(editable); };
	        $scope.resetPassword = function () { return _this.resetPassword(); };
	        $scope.activate = function () { return _this.activate(); };
	        return _this;
	    }
	    // used to call password directive resetPass method
	    // this will clean password fields and validatin flags/messages
	    ScUserRegistrationController.prototype.resetPassword = function () {
	        this.$scope.resetPass = new Date().getTime();
	        this.recaptchaService.reload();
	        this.$scope.showButton = null;
	    };
	    ScUserRegistrationController.prototype.activate = function () {
	        var _this = this;
	        if (this.$location.search().key) {
	            this.service.activate(this.$location.search().key).then(function (response) {
	                if (response) {
	                    _this.$scope.activated = true;
	                }
	                else {
	                    _this.$scope.activated = false;
	                }
	            }, function (error) {
	                _this.$scope.error = { error: error };
	            });
	        }
	        ;
	    };
	    ScUserRegistrationController.prototype.createOverride = function (editable) {
	        var _this = this;
	        editable.url = this.$location.absUrl();
	        this.$scope.processing = true;
	        this.service.create(editable).then(function () {
	            _this.$scope.userCreated = true;
	            _this.$scope.processing = false;
	            _this.reset();
	            _this.$scope.resetPassword();
	        }, function (error) {
	            _this.$scope.processing = false;
	            _this.$scope.error = { error: error };
	        });
	    };
	    ScUserRegistrationController.prototype.getPasswordSettings = function () {
	        this.service.getSettings().then(function (resp) {
	            for (var i = 0, len = resp.length; i < len; i++) {
	                localStorage_service_1.LocalStorageService.set("SystemConfiguration:" + resp[i].item_name, resp[i].current_value);
	            }
	            ;
	        });
	    };
	    return ScUserRegistrationController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScUserRegistrationController = ScUserRegistrationController;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var crud_file_handler_type_1 = __webpack_require__(24);
	var ScAccountManagementController = (function (_super) {
	    __extends(ScAccountManagementController, _super);
	    /* @ngInject */
	    ScAccountManagementController.$inject = ["$scope", "$rootScope", "scAccountManagementService", "systemConfigurationService", "typesService", "usersService", "$anchorScroll", "$location", "$state"];
	    function ScAccountManagementController($scope, $rootScope, scAccountManagementService, systemConfigurationService, typesService, usersService, $anchorScroll, $location, $state) {
	        var _this = _super.call(this, $scope, scAccountManagementService, null, 'Supporting Document', crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) || this;
	        _this.$scope = $scope;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.typesService = typesService;
	        _this.usersService = usersService;
	        _this.$anchorScroll = $anchorScroll;
	        _this.$location = $location;
	        _this.$state = $state;
	        _super.prototype.setup.call(_this);
	        $scope.pattern = '.jpg, .gif, .png, .pdf';
	        _super.prototype.setup.call(_this, { refresh: false });
	        _super.prototype.list.call(_this, {}, "filter=true&selfCareAccounts=true");
	        _this.typesService.listAll().then(function (types) {
	            types.forEach(function (element) {
	                if (element.name === 'GeneralAviation') {
	                    _this.$scope.accountType = element;
	                }
	            });
	            _this.setDefaultFields();
	        });
	        $scope.editOverride = function (item) { return _this.editOverride(item); };
	        $scope.updateOverride = function (editable, id) { return _this.updateOverride(editable, id); };
	        $scope.$watch('filter', function () { return _this.getFilterParameters(); });
	        $scope.needAdminApproval =
	            _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_ADMIN_APPROVAL_FOR_SC_ACCOUNTS);
	        $scope.selfCareUserList = [];
	        usersService.listAll().then(function (users) {
	            users.content.forEach(function (user) {
	                if (user.is_selfcare_user && user.registration_status) {
	                    $scope.selfCareUserList.push(user);
	                }
	            });
	        });
	        $scope.checkCreditLimit = function () { return _this.checkCreditLimit(); };
	        $scope.setDefaultFields = function () { return _this.setDefaultFields(); };
	        // $scope.create = (account: IAccount) => super.create(account).then(() => this.setDefaultFields());
	        $scope.update = function (account, id) { return _super.prototype.update.call(_this, account, id).then(function () { return _this.setDefaultFields(); }); };
	        // $scope.create = (account: IAccount) => this.create(account);
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    // protected create(account: IAccount): ng.IPromise<void> {
	    //   return super.create(account).then((createdAccount: IAccount) => {
	    //     this.$scope.accountCreated = true;
	    //     this.$location.hash('top');
	    //     this.$anchorScroll();
	    //     if (this.$state && this.$state.params.after) { // go back to previous page (if state params exist)
	    //       this.$state.go(this.$state.params.after.create.goTo.state, {
	    //         accountId: createdAccount.id
	    //       });
	    //     }
	    //   });
	    // }
	    ScAccountManagementController.prototype.updateOverride = function (editable, id) {
	        var _this = this;
	        return _super.prototype.uploadFileUpdateScAccount.call(this, 'PUT', null, editable, 'refreshOverride', id).then(function () {
	            _this.$scope.isDisabled = false;
	            _this.$scope.transactionFromInvoice = false;
	            _this.reset();
	        });
	    };
	    ScAccountManagementController.prototype.create = function (account) {
	        var _this = this;
	        return _super.prototype.uploadFileCreateScAccount.call(this, 'POST', null, account, null).then(function (createdAccount) {
	            if (_this.$state && _this.$state.params.after) {
	                _this.$state.go(_this.$state.params.after.create.goTo.state, {
	                    accountId: createdAccount.id
	                });
	            }
	            _this.$scope.accountCreated = true;
	            _this.reset();
	        });
	    };
	    ScAccountManagementController.prototype.reset = function () {
	        this.$scope.resetPass = {}; // to reset pass2
	        _super.prototype.reset.call(this);
	        this.setDefaultFields();
	    };
	    ScAccountManagementController.prototype.setDefaultFields = function () {
	        this.checkCreditLimit();
	        //  this.$scope.editable.payment_terms = <number>this.systemConfigurationService.getValueByName(<any>SysConfigConstants.DEFAULT_ACCOUNT_PAYMENT_TERMS);
	        //    this.$scope.editable.monthly_overdue_penalty_rate = <number>this.systemConfigurationService.getValueByName(<any>SysConfigConstants.DEFAULT_ACCOUNT_MONTHLY_PENALTY);
	        this.$scope.anspCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        this.$scope.editable.account_type = this.$scope.accountType;
	        //this.$scope.editable.nationality = 'NA';
	    };
	    ScAccountManagementController.prototype.checkCreditLimit = function () {
	        if (this.$scope.editable.cash_account === true) {
	            this.$scope.editable.credit_limit = 0;
	            this.$scope.minCreditLimit = 0;
	            this.$scope.maxCreditLimit = 0;
	        }
	        else {
	            //      this.$scope.editable.credit_limit = <number>this.systemConfigurationService.getValueByName(<any>SysConfigConstants.DEFAULT_ACCOUNT_CREDIT_LIMIT);
	            //     this.$scope.minCreditLimit = <number>this.systemConfigurationService.getValueByName(<any>SysConfigConstants.DEFAULT_ACCOUNT_MIN_CREDIT_NOTE);
	            //      this.$scope.maxCreditLimit = <number>this.systemConfigurationService.getValueByName(<any>SysConfigConstants.DEFAULT_ACCOUNT_MAX_CREDIT_NOTE);
	        }
	    };
	    ScAccountManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            filter: this.$scope.filter,
	            cash: this.$scope.accountTypeFilter,
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            selfCareAccounts: this.$scope.selfCareAccounts,
	            invoices: this.$scope.accountFilter,
	            nationality: this.$scope.nationality
	        };
	    };
	    ScAccountManagementController.prototype.refreshOverride = function () {
	        var request;
	        this.getFilterParameters();
	        request = _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	        return request;
	    };
	    ScAccountManagementController.prototype.editOverride = function (item) {
	        _super.prototype.edit.call(this, item);
	        this.$scope.editable.document_filename = item.uploaded_document_name;
	    };
	    return ScAccountManagementController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.ScAccountManagementController = ScAccountManagementController;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var DISTANCE_UNIT_OF_MEASURE = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE;
	var MTOW_UNIT_OF_MEASURE = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE;
	var AIR_NAVIGATION_CHARGES_CURRENCY = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.AIR_NAVIGATION_CHARGES_CURRENCY;
	var ANSP_CURRENCY = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY;
	var ScFlightCostCalculationController = (function (_super) {
	    __extends(ScFlightCostCalculationController, _super);
	    /* @ngInject */
	    ScFlightCostCalculationController.$inject = ["$scope", "recaptchaService", "scFlightCostCalculationService", "systemConfigurationService", "currencyExchangeRatesService"];
	    function ScFlightCostCalculationController($scope, recaptchaService, scFlightCostCalculationService, systemConfigurationService, currencyExchangeRatesService) {
	        var _this = _super.call(this, $scope, scFlightCostCalculationService) || this;
	        _this.$scope = $scope;
	        _this.recaptchaService = recaptchaService;
	        _this.scFlightCostCalculationService = scFlightCostCalculationService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.currencyExchangeRatesService = currencyExchangeRatesService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        if (!localStorage_service_1.LocalStorageService.get(DISTANCE_UNIT_OF_MEASURE)) {
	            _this.getUnitsOfMeasureConfiguration();
	        }
	        if (!localStorage_service_1.LocalStorageService.get(AIR_NAVIGATION_CHARGES_CURRENCY)) {
	            _this.getAirNavigationChargesCurrency();
	        }
	        if (!localStorage_service_1.LocalStorageService.get(ANSP_CURRENCY)) {
	            _this.getANSPCurrency();
	        }
	        $scope.distanceUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE);
	        $scope.mtowUnitsOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.airNavigationChargesCurrency = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.AIR_NAVIGATION_CHARGES_CURRENCY);
	        $scope.anspCurrency = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        $scope.calculate = function (flightCostCalculation) {
	            $scope.cost = null;
	            scFlightCostCalculationService.calculate(flightCostCalculation).then(function (response) {
	                $scope.cost = response;
	                $scope.adapCharges = _this.getAdapCharges($scope.cost);
	                $scope.totalCostUSD = $scope.cost.enroute_charges + $scope.adapCharges;
	                if ($scope.anspCurrency && $scope.anspCurrency !== 'USD') {
	                    currencyExchangeRatesService.getCurrentExchangeRatesByCurrencyCode($scope.anspCurrency).then(function (rate) {
	                        $scope.totalCostAnsp = $scope.totalCostUSD / rate;
	                    });
	                }
	                ;
	                $scope.noBillableRoute = $scope.cost.resolution_errors.includes('ZERO_LENGTH_BILLABLE_TRACK');
	                if ($scope.widgetId) {
	                    recaptchaService.reload($scope.widgetId);
	                }
	                _this.reset();
	            }, function (error) {
	                $scope.error = { error: error };
	                recaptchaService.reload($scope.widgetId);
	            });
	        };
	        return _this;
	    }
	    ScFlightCostCalculationController.prototype.getUnitsOfMeasureConfiguration = function () {
	        var _this = this;
	        this.systemConfigurationService.getUnitsOfMeasureConfiguration().then(function (resp) {
	            if (resp) {
	                localStorage_service_1.LocalStorageService.set(DISTANCE_UNIT_OF_MEASURE, resp[0].current_value);
	                localStorage_service_1.LocalStorageService.set(MTOW_UNIT_OF_MEASURE, resp[1].current_value);
	                _this.$scope.distanceUnitOfMeasure = resp[0].current_value;
	                _this.$scope.mtowUnitsOfMeasure = resp[1].current_value;
	            }
	        });
	    };
	    ScFlightCostCalculationController.prototype.getAirNavigationChargesCurrency = function () {
	        var _this = this;
	        this.systemConfigurationService.getAirNavigationChargesCurrency().then(function (resp) {
	            if (resp) {
	                localStorage_service_1.LocalStorageService.set(AIR_NAVIGATION_CHARGES_CURRENCY, resp.current_value);
	                _this.$scope.airNavigationChargesCurrency = resp.current_value;
	            }
	        });
	    };
	    ScFlightCostCalculationController.prototype.getANSPCurrency = function () {
	        var _this = this;
	        this.systemConfigurationService.getANSPCurrency().then(function (resp) {
	            if (resp) {
	                localStorage_service_1.LocalStorageService.set(ANSP_CURRENCY, resp.current_value);
	                _this.$scope.anspCurrency = resp.current_value;
	                _this.$scope.exchangeRateANSPtoUSD = _this.currencyExchangeRatesService.getCurrentExchangeRatesByCurrencyCode(_this.$scope.anspCurrency);
	            }
	        });
	    };
	    ScFlightCostCalculationController.prototype.getAdapCharges = function (data) {
	        if (this.$scope.airNavigationChargesCurrency !== 'USD') {
	            return (data.approach_charges || 0) / this.$scope.exchangeRateANSPtoUSD;
	        }
	        else {
	            return data.approach_charges || 0;
	        }
	    };
	    return ScFlightCostCalculationController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScFlightCostCalculationController = ScFlightCostCalculationController;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var ScQuerySubmissionController = (function (_super) {
	    __extends(ScQuerySubmissionController, _super);
	    /* @ngInject */
	    ScQuerySubmissionController.$inject = ["$scope", "scQuerySubmissionService", "recaptchaService"];
	    function ScQuerySubmissionController($scope, scQuerySubmissionService, recaptchaService) {
	        var _this = _super.call(this, $scope, scQuerySubmissionService) || this;
	        _this.$scope = $scope;
	        _this.scQuerySubmissionService = scQuerySubmissionService;
	        _this.recaptchaService = recaptchaService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        $scope.discard = function () { return $scope.editable = _this.scQuerySubmissionService.getModel(); };
	        $scope.send = function (editable) { return scQuerySubmissionService.send(editable).then(function () {
	            _this.$scope.messageSent = true;
	            if (_this.$scope.widgetId) {
	                recaptchaService.reload(_this.$scope.widgetId);
	            }
	            _this.reset();
	        }, function (error) {
	            _this.$scope.error = { error: error };
	            recaptchaService.reload(_this.$scope.widgetId);
	        }); };
	        return _this;
	    }
	    return ScQuerySubmissionController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ScQuerySubmissionController = ScQuerySubmissionController;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var login_constants_1 = __webpack_require__(36);
	var ScLoginController = (function () {
	    /* @ngInject */
	    ScLoginController.$inject = ["$scope", "scLoginService", "$state", "$interval", "$window", "usersService"];
	    function ScLoginController($scope, scLoginService, $state, $interval, $window, usersService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.scLoginService = scLoginService;
	        this.$state = $state;
	        this.$interval = $interval;
	        this.$window = $window;
	        this.usersService = usersService;
	        this.failedAttempts = 0;
	        $scope.passwordRecoveryForm = function () { $scope.recoveryForm = true; $scope.error = null; };
	        $scope.closeRecoveryForm = function () { return $scope.recoveryForm = false; };
	        $scope.showLogin = function () { $scope.recoveryForm = false; $scope.tempPaswordSent = false; $scope.error = null; };
	        $scope.recoverPassword = function (email) { return usersService.recoverPassword(email).then(function () {
	            $scope.error = null;
	            $scope.tempPaswordSent = true;
	        }, function (error) {
	            $scope.error = { error: error.data };
	        }); };
	        this.interval = null;
	        $scope.offlineServerError = $scope.language && $scope.language.selected && $scope.language.selected.code
	            ? login_constants_1.LOGIN_ERROR.SERVER[$scope.language.selected.code]
	            : login_constants_1.LOGIN_ERROR.SERVER.en;
	        $scope.timeoutDelay = 0;
	        $scope.warning = false;
	        $scope.submit = function (username, password) { return _this.submit(username, password); };
	        if (!bowser.chrome && !bowser.firefox && !bowser.msedge) {
	            $scope.browserWarning = true;
	        }
	        else if (bowser.chrome && bowser.version < 52 || bowser.firefox && bowser.version < 47) {
	            $scope.browserWarning = true;
	        }
	    }
	    ScLoginController.prototype.submit = function (username, password) {
	        var _this = this;
	        if (this.$scope.timeoutDelay > 0) {
	            return; // prevents spamming
	        }
	        this.$scope.warning = false;
	        this.$scope.error = null;
	        this.scLoginService.login(username, password).then(function () {
	            _this.$state.go('main.sc-home-page', {}, { reload: true });
	        }, function (data) {
	            _this.$scope.error = data.status;
	            if (data.status === 400 || data.status === 401) {
	                if (_this.failedAttempts > 2) {
	                    _this.countdown(5 * _this.failedAttempts);
	                    _this.$scope.error = null;
	                }
	                else {
	                    _this.$scope.warning = true;
	                }
	                _this.failedAttempts++;
	            }
	            ;
	        });
	    };
	    ScLoginController.prototype.countdown = function (time) {
	        var _this = this;
	        this.$scope.timeoutDelay = time;
	        this.interval = this.$interval(function () {
	            _this.$scope.timeoutDelay--;
	            if (_this.$scope.timeoutDelay <= 0) {
	                _this.$interval.cancel(_this.interval);
	            }
	        }, 1000);
	    };
	    return ScLoginController;
	}());
	exports.ScLoginController = ScLoginController;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LOGIN_ERROR = {
	    SERVER: {
	        en: 'Service not available. Please contact the system administrator',
	        es: 'Servicio no disponible. Póngase en contacto con el administrador del sistema'
	    }
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ScHomePageController = (function () {
	    /* @ngInject */
	    ScHomePageController.$inject = ["$scope"];
	    function ScHomePageController($scope) {
	        this.$scope = $scope;
	        $scope.loginFromBilling = JSON.parse(window.localStorage.getItem('loginFromBilling'));
	    }
	    return ScHomePageController;
	}());
	exports.ScHomePageController = ScHomePageController;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var helpers_service_1 = __webpack_require__(19);
	var CachedEventsController = (function (_super) {
	    __extends(CachedEventsController, _super);
	    /* @ngInject */
	    CachedEventsController.$inject = ["$scope", "cachedEventsService"];
	    function CachedEventsController($scope, cachedEventsService) {
	        var _this = 
	        // define and setup super class
	        _super.call(this, $scope, cachedEventsService) || this;
	        _this.$scope = $scope;
	        _this.cachedEventsService = cachedEventsService;
	        _super.prototype.setup.call(_this);
	        // define necessary defaults to scope
	        _this.$scope.message = null;
	        _this.$scope.pagination = {};
	        _this.$scope.retryInProgress = false;
	        // expose necessary methods to scope
	        _this.$scope.commaSeperate = function (array, property) { return helpers_service_1.HelperService.commaSeperate(array, property, 2); };
	        _this.$scope.delete = function (id) { return _this.delete(id); };
	        _this.$scope.refresh = function () { return _this.refresh(); };
	        _this.$scope.retry = function (id) { return _this.retry(id); };
	        // get and update next retry cycle date
	        _this.updateNextRetryCycle();
	        _this.getFilterParameters();
	        return _this;
	    }
	    CachedEventsController.prototype.delete = function (id) {
	        var _this = this;
	        this.$scope.retryInProgress = true;
	        return this.cachedEventsService.delete(id)
	            .then(function (response) { return _this.refresh(); })
	            .catch(function (response) { return _this.displayErrorResponse(response); })
	            .finally(function () { return _this.$scope.retryInProgress = false; });
	    };
	    CachedEventsController.prototype.refresh = function () {
	        var _this = this;
	        this.getFilterParameters();
	        // hold search value to update highlight text after promise returned
	        // this forces highlighting to use the same search value even if the
	        // search value changes after the promise was sent
	        // and finally update next retry cycle
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString())
	            .then(function () {
	            _this.updateCachedEventResults();
	            _this.updateHighlight(_this.$scope.search);
	            _this.updateNextRetryCycle();
	        });
	    };
	    CachedEventsController.prototype.retry = function (id) {
	        var _this = this;
	        this.$scope.retryInProgress = true;
	        return this.cachedEventsService.retry(id)
	            .then(function (response) {
	            _this.displayRetryResponse(response);
	            _this.refresh();
	        })
	            .catch(function (response) { return _this.displayErrorResponse(response); })
	            .finally(function () { return _this.$scope.retryInProgress = false; });
	    };
	    CachedEventsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Display error message of restangular response.
	     *
	     * @param response restangular response with error
	     */
	    CachedEventsController.prototype.displayErrorResponse = function (response) {
	        this.$scope.error = {
	            error: response
	        };
	    };
	    /**
	     * Display status of a cached event's latest result.
	     *
	     * @param response cached event to display
	     */
	    CachedEventsController.prototype.displayRetryResponse = function (response) {
	        var cachedEventResult = response.results[response.results.length - 1];
	        this.$scope.message = {
	            title: cachedEventResult.clazz,
	            description: cachedEventResult.result,
	            thrown: cachedEventResult.clazz !== null || cachedEventResult.result !== null
	        };
	    };
	    /**
	     * Update the editable cached event results value from list
	     * if editable item still exists in the list.
	     *
	     * If editable item no longer exists, the editable item is reset.
	     */
	    CachedEventsController.prototype.updateCachedEventResults = function () {
	        // flag to indicate if editable item has been refreshed
	        var refreshed = false;
	        // if editable item, loop through refreshed list for match and update editable item
	        var editable = this.$scope.editable;
	        if (editable !== null && editable.id !== null) {
	            var items = this.$scope.list;
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].id === editable.id) {
	                    this.$scope.editable = items[i];
	                    refreshed = true;
	                    break;
	                }
	            }
	        }
	        // if editable item is NOT updated, clear it out as it is no longer visible in the list
	        if (!refreshed) {
	            this.$scope.editable = angular.copy(this.service.model);
	        }
	    };
	    /**
	     * Update scope highlight search with new search value.
	     *
	     * @param search search text
	     */
	    CachedEventsController.prototype.updateHighlight = function (search) {
	        this.$scope.highlightSearch = search;
	    };
	    /**
	     * Gets the next retry cycle date and sets scope value.
	     */
	    CachedEventsController.prototype.updateNextRetryCycle = function () {
	        var _this = this;
	        this.cachedEventsService.getNextRetryCycle()
	            .then(function (response) { return _this.$scope.nextRetryCycle = moment.utc(response).toDate(); });
	    };
	    return CachedEventsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CachedEventsController = CachedEventsController;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var FlightScheduleManagementController = (function (_super) {
	    __extends(FlightScheduleManagementController, _super);
	    /* @ngInject */
	    FlightScheduleManagementController.$inject = ["$scope", "$rootScope", "$uibModal", "flightScheduleManagementService", "accountsService", "$translate"];
	    function FlightScheduleManagementController($scope, $rootScope, $uibModal, flightScheduleManagementService, accountsService, $translate) {
	        var _this = _super.call(this, $scope, flightScheduleManagementService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.$uibModal = $uibModal;
	        _this.flightScheduleManagementService = flightScheduleManagementService;
	        _this.accountsService = accountsService;
	        _this.$translate = $translate;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.getAccountsWithFlightSchedule();
	        // functions exposed to the template
	        $scope.preUploadSchedules = function (startDate, document) { return _this.preUploadSchedules(startDate, document); };
	        $scope.formatDailySchedules = function (schedules, separator) { return _this.formatDailySchedules(schedules, separator); };
	        $scope.addDaysToSchedule = function () { return _this.addDaysToSchedule($scope.days); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.clearFilters = function () { return _this.clearFilters(); };
	        $scope.edit = function (schedule) { return _this.editOverride(schedule); };
	        $scope.update = function (editable, id) { return _super.prototype.update.call(_this, editable, id).then(function () { return _this.getAccountsWithFlightSchedule(); }); };
	        $scope.create = function (editable) { return _super.prototype.create.call(_this, editable).then(function () { return _this.getAccountsWithFlightSchedule(); }); };
	        $scope.delete = function (id) { return _super.prototype.delete.call(_this, id).then(function () { return _this.getAccountsWithFlightSchedule(); }); };
	        // get formatted list of days for multiselect
	        $scope.listOfDays = flightScheduleManagementService.getDaysOfWeek();
	        // default objects required because super.setup() is called without refresh
	        $scope.pagination = {};
	        $scope.days = [];
	        // do not make a call for flight schedules until an account has been
	        // selected in the dropdown service
	        $scope.$watch('accountId', function () {
	            _this.refreshOverride();
	        });
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    /**
	     * Checks the CSV and warns the user
	     * if any schedules will be set
	     * to inactive
	     *
	     * @param  {string} startDate
	     * @param  {any} document
	     */
	    FlightScheduleManagementController.prototype.preUploadSchedules = function (startDate, document) {
	        var _this = this;
	        this.flightScheduleManagementService.preUploadSchedules(startDate, document).then(function (data) {
	            var changedSchedulesSet = new Set();
	            var changedSchedulesArray = [];
	            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
	                var item = data_1[_i];
	                changedSchedulesSet.add(item.id + " " + item.details);
	            }
	            changedSchedulesArray = Array.from(changedSchedulesSet);
	            var warning = changedSchedulesArray.join('\n');
	            // only create model if ther
	            // is a warning to show
	            if (warning && warning.length) {
	                _this.createWarningModel(warning);
	            }
	            else {
	                _super.prototype.upload.call(_this, 'PUT', null, null, 'refreshOverride', { 'startDate': _this.$scope.start.toISOString() })
	                    .then(function () { return _this.getAccountsWithFlightSchedule(); });
	            }
	        });
	    };
	    /**
	     * Override edit to add the
	     * days to the multiselect
	     * upon clicking a record
	     */
	    FlightScheduleManagementController.prototype.editOverride = function (schedule) {
	        var days = schedule.daily_schedule.split(',');
	        this.$scope.days = []; // clear out current selections
	        // match each sched number to the value
	        // of the days in listOfDays
	        for (var _i = 0, days_1 = days; _i < days_1.length; _i++) {
	            var day = days_1[_i];
	            for (var _a = 0, _b = this.$scope.listOfDays; _a < _b.length; _a++) {
	                var item = _b[_a];
	                if (day === item.value) {
	                    this.$scope.days.push(item);
	                }
	            }
	        }
	        _super.prototype.edit.call(this, schedule);
	    };
	    /**
	     * Modal to warn user of schedule
	     * overriding
	     */
	    FlightScheduleManagementController.prototype.createWarningModel = function (warning) {
	        var _this = this;
	        var modal = this.$uibModal.open({
	            templateUrl: 'app/partials/flight-schedule-management/schedule-warning.template.html',
	            controller: ['$scope', function ($scope) {
	                    $scope.warning = warning;
	                    $scope.close = function () { return modal.close(); };
	                    $scope.confirm = function () {
	                        modal.close();
	                        _super.prototype.upload.call(_this, 'PUT', null, null, 'refreshOverride', { 'startDate': _this.$scope.start.toISOString() })
	                            .then(function () { return _this.getAccountsWithFlightSchedule(); });
	                    };
	                }]
	        });
	    };
	    /**
	     * Format days from CSV for
	     * data-grid display
	     *
	     * @param  {string} days
	     * @returns string
	     */
	    FlightScheduleManagementController.prototype.formatDailySchedules = function (days, separator) {
	        var arrOfDays = days.split(',');
	        var daysInNumbers = [];
	        for (var _i = 0, arrOfDays_1 = arrOfDays; _i < arrOfDays_1.length; _i++) {
	            var day = arrOfDays_1[_i];
	            switch (day) {
	                case '1':
	                    daysInNumbers.push(" " + this.$translate.instant('SUNDAY'));
	                    break;
	                case '2':
	                    daysInNumbers.push(" " + this.$translate.instant('MONDAY'));
	                    break;
	                case '3':
	                    daysInNumbers.push(" " + this.$translate.instant('TUESDAY'));
	                    break;
	                case '4':
	                    daysInNumbers.push(" " + this.$translate.instant('WEDNESDAY'));
	                    break;
	                case '5':
	                    daysInNumbers.push(" " + this.$translate.instant('THURSDAY'));
	                    break;
	                case '6':
	                    daysInNumbers.push(" " + this.$translate.instant('FRIDAY'));
	                    break;
	                case '7':
	                    daysInNumbers.push(" " + this.$translate.instant('SATURDAY'));
	                    break;
	            }
	            ;
	        }
	        ;
	        return daysInNumbers.join(separator).trim();
	    };
	    /**
	     * Adds days of week selected from
	     * multiselect to a comma separated
	     * string of values
	     *
	     * @param  {Array<any>} days
	     */
	    FlightScheduleManagementController.prototype.addDaysToSchedule = function (days) {
	        var dailySchedule = days.map(function (day) {
	            return day.value;
	        });
	        // send daily schedule as comma separated string (eg. 1,5,7)
	        // empty array of daily schedules will be set to null
	        this.$scope.editable.daily_schedule = dailySchedule.length > 0
	            ? dailySchedule.join(',') : null;
	    };
	    FlightScheduleManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            'accountId': this.$scope.accountId,
	            'search': this.$scope.textFilter,
	            'page': this.$scope.pagination.number
	        };
	    };
	    /**
	     * Calls list with applied filters and create object for download
	     *
	     * @returns promise
	     */
	    FlightScheduleManagementController.prototype.refreshOverride = function () {
	        var _this = this;
	        this.getFilterParameters();
	        if (this.$scope.accountId) {
	            return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString()).then(function (schedules) {
	                _this.$scope.accountSchedules = schedules.content.map(function (schedule) {
	                    return {
	                        'flight_service_number': schedule.flight_service_number,
	                        'dep_ad': schedule.dep_ad,
	                        'dep_time': schedule.dep_time,
	                        'dest_ad': schedule.dest_ad,
	                        'dest_time': schedule.dest_time,
	                        'daily_schedule': _this.formatDailySchedules(schedule.daily_schedule, '/')
	                    };
	                });
	            });
	        }
	    };
	    /**
	     * Clears filters
	     *
	     * @returns void
	     */
	    FlightScheduleManagementController.prototype.clearFilters = function () {
	        this.reset();
	        this.$scope.textFilter = null;
	        this.$scope.days = [];
	        this.$scope.editable = this.flightScheduleManagementService.getModel();
	    };
	    FlightScheduleManagementController.prototype.getAccountsWithFlightSchedule = function () {
	        var _this = this;
	        this.accountsService.findSchedMinimalReturn().then(function (list) {
	            _this.$scope.accountsWithFlightSchedules = list;
	            if (!_this.$scope.accountId && _this.$scope.accountsWithFlightSchedules[0]) {
	                _this.$scope.accountId = _this.$scope.accountsWithFlightSchedules[0].id;
	            }
	        });
	    };
	    return FlightScheduleManagementController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.FlightScheduleManagementController = FlightScheduleManagementController;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var LocalAircraftRegistryController = (function (_super) {
	    __extends(LocalAircraftRegistryController, _super);
	    /* @ngInject */
	    LocalAircraftRegistryController.$inject = ["localAircraftRegistryService", "systemConfigurationService", "$scope", "$rootScope", "$uibModal", "customDate"];
	    function LocalAircraftRegistryController(localAircraftRegistryService, systemConfigurationService, $scope, $rootScope, $uibModal, customDate) {
	        var _this = 
	        // setup
	        _super.call(this, $scope, localAircraftRegistryService, $uibModal, 'File Name') || this;
	        _this.localAircraftRegistryService = localAircraftRegistryService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$scope = $scope;
	        _this.$uibModal = $uibModal;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.getFilterParameters();
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.organizationName = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION);
	        $scope.addDate = function (localAircraftRegistry) { return _this.addDate(localAircraftRegistry); };
	        $scope.create = function (localAircraftRegistry, renewal, expiry) { return _this.createOverride(localAircraftRegistry, renewal, expiry); };
	        $scope.convertMtowProperty = function (localAircraftRegistry) {
	            $scope.editable.mtow_weight = systemConfigurationService.convertMtowProperty(localAircraftRegistry, 'mtow_weight').mtow_weight;
	        };
	        $scope.edit = function (localAircraftRegistry) { _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(localAircraftRegistry, 'mtow_weight')); };
	        $scope.update = function (localAircraftRegistry, renewal, expiry) { return _this.updateOverride(localAircraftRegistry, renewal, expiry); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    LocalAircraftRegistryController.prototype.edit = function (localAircraftRegistry) {
	        var d = new Date(localAircraftRegistry.coa_date_of_renewal);
	        this.$scope.control.setUTCStartDate(d);
	        var e = new Date(localAircraftRegistry.coa_date_of_expiry);
	        this.$scope.control.setUTCEndDate(e);
	        _super.prototype.edit.call(this, localAircraftRegistry);
	    };
	    LocalAircraftRegistryController.prototype.createOverride = function (localAircraftRegistry, renewal, expiry) {
	        var _this = this;
	        localAircraftRegistry.coa_date_of_renewal = renewal;
	        localAircraftRegistry.coa_date_of_expiry = expiry;
	        return _super.prototype.create.call(this, localAircraftRegistry).then(function () { return _this.$scope.control.reset(); });
	    };
	    LocalAircraftRegistryController.prototype.updateOverride = function (localAircraftRegistry, renewal, expiry) {
	        localAircraftRegistry.coa_date_of_renewal = renewal;
	        localAircraftRegistry.coa_date_of_expiry = expiry;
	        return _super.prototype.update.call(this, localAircraftRegistry, localAircraftRegistry.id);
	    };
	    LocalAircraftRegistryController.prototype.addDate = function (localAircraftRegistry) {
	        if (localAircraftRegistry.coa_date_of_renewal !== null) {
	            var d = new Date(localAircraftRegistry.coa_date_of_renewal);
	            this.$scope.control.setUTCStartDate(d);
	        }
	        if (localAircraftRegistry.coa_date_of_expiry !== null) {
	            var e = new Date(localAircraftRegistry.coa_date_of_expiry);
	            this.$scope.control.setUTCEndDate(e);
	        }
	    };
	    LocalAircraftRegistryController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            filter: this.$scope.registrationFilter
	        };
	    };
	    LocalAircraftRegistryController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return LocalAircraftRegistryController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.LocalAircraftRegistryController = LocalAircraftRegistryController;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var UserEventLogController = (function (_super) {
	    __extends(UserEventLogController, _super);
	    /* @ngInject */
	    UserEventLogController.$inject = ["$scope", "userEventLogService", "usersService", "customDate"];
	    function UserEventLogController($scope, userEventLogService, usersService, customDate) {
	        var _this = _super.call(this, $scope, userEventLogService) || this;
	        _this.$scope = $scope;
	        _this.userEventLogService = userEventLogService;
	        _this.usersService = usersService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        $scope.formatStringWithLineBreaks = function (input) {
	            if (input) {
	                var isoDateRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/; // format data (es. 2099-11-30T00:00:00Z)
	                input = input.replace(/,/g, ',<br>');
	                input = input.replace(isoDateRegex, function (match) {
	                    var date = new Date(match);
	                    return date.toISOString().split('T')[0]; // Return YYYY-MM-DD
	                });
	                return input;
	            }
	            return input;
	        };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.getFilterParameters();
	        _this.loadUsersAndInit();
	        return _this;
	    }
	    UserEventLogController.prototype.getFilterParameters = function () {
	        var startDate = null;
	        var endDate = null;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            search: this.$scope.search || null,
	            startDate: startDate,
	            endDate: endDate,
	            createdByUserId: this.$scope.userFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	   * Carica utenti, imposta l’utente corrente come filtro e richiama il caricamento iniziale dei dati
	   */
	    UserEventLogController.prototype.loadUsersAndInit = function () {
	        var _this = this;
	        this.usersService.getListLightInternalUsers().then(function (users) {
	            _this.$scope.usersList = users;
	            _this.usersService.current.then(function (user) {
	                var match = _this.$scope.usersList.find(function (item) { return item.name === user.name; });
	                if (match) {
	                    _this.$scope.userFilter = match.id;
	                }
	                _super.prototype.list.call(_this, {}, "createdByUserId=" + user.id);
	                _this.getFilterParameters();
	            });
	        });
	    };
	    /**
	     * Calls list with applied filters
	     *
	     * @returns void
	     */
	    UserEventLogController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return UserEventLogController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.UserEventLogController = UserEventLogController;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// services
	var localStorage_service_1 = __webpack_require__(9);
	var HelpController = (function () {
	    /* @ngInject */
	    HelpController.$inject = ["$scope", "$location"];
	    function HelpController($scope, $location) {
	        this.$scope = $scope;
	        this.$location = $location;
	        var lang = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_SELECTION);
	        $scope.url = $location.absUrl().split('#')[0] + "assets/guide." + (lang && lang.code ? lang.code : 'en') + ".pdf#page=1";
	    }
	    return HelpController;
	}());
	exports.HelpController = HelpController;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var ApplicationManagementController = (function (_super) {
	    __extends(ApplicationManagementController, _super);
	    /* @ngInject */
	    ApplicationManagementController.$inject = ["$scope", "applicationManagementService"];
	    function ApplicationManagementController($scope, applicationManagementService) {
	        var _this = _super.call(this, $scope, applicationManagementService) || this;
	        _this.$scope = $scope;
	        _this.applicationManagementService = applicationManagementService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.getCurrentEntries();
	        _this.getNumberToRetain();
	        $scope.clearCache = function () { return applicationManagementService.clearCurrentCache().then(function () { return _this.getCurrentEntries(); }); };
	        $scope.updateNumberToRetain = function (numberToRetain) { return applicationManagementService.updateNumberToRetain(numberToRetain)
	            .then(function (data) { return $scope.numberToRetain = data.number_of_retention; }); };
	        return _this;
	    }
	    ApplicationManagementController.prototype.getCurrentEntries = function () {
	        var _this = this;
	        _super.prototype.list.call(this).then(function (data) {
	            _this.$scope.currentEntries = data.count;
	        });
	    };
	    ApplicationManagementController.prototype.getNumberToRetain = function () {
	        var _this = this;
	        this.applicationManagementService.getNumberToRetain()
	            .then(function (data) { return _this.$scope.numberToRetain = data.number_of_retention; });
	    };
	    return ApplicationManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ApplicationManagementController = ApplicationManagementController;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var NonAviationBillingEngineController = (function (_super) {
	    __extends(NonAviationBillingEngineController, _super);
	    /* @ngInject */
	    NonAviationBillingEngineController.$inject = ["$scope", "nonAviationBillingEngineService", "reportsService", "customDate", "externalChargeCategoryService", "systemConfigurationService", "accountsService"];
	    function NonAviationBillingEngineController($scope, nonAviationBillingEngineService, reportsService, customDate, externalChargeCategoryService, systemConfigurationService, accountsService) {
	        var _this = _super.call(this, $scope, nonAviationBillingEngineService) || this;
	        _this.$scope = $scope;
	        _this.nonAviationBillingEngineService = nonAviationBillingEngineService;
	        _this.reportsService = reportsService;
	        _this.customDate = customDate;
	        _this.externalChargeCategoryService = externalChargeCategoryService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.accountsService = accountsService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        $scope.getLineItems = function (nonAviation) { return _this.getLineItems(nonAviation); };
	        $scope.startOfCurrentMonth = moment().startOf('month');
	        _this.setDefaultDate();
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(true);
	        $scope.$watchGroup(['editable.month', 'editable.year'], function () {
	            $scope.isBillingPeriodValid = _this.validateBillingPeriod();
	        });
	        // watch for account change and get invoice currency for selected account
	        // this is required as we only pull the minified account list for account dropdown selection
	        $scope.$watch('editable.accountId', function (accountId) { return _this.updateAccountCurrencyCode(accountId); });
	        $scope.generateNonAviationInvoice = function (format, preview, accountId, year, month, lineItems) { return _this.generateNonAviationInvoice(format, preview, accountId, year, month, lineItems); };
	        externalChargeCategoryService.getNonAviationCategories()
	            .then(function (response) { return _this.setExternalChargeCategories(response); })
	            .catch(function (error) { return _this.setErrorResponse(error); });
	        return _this;
	    }
	    ;
	    /**
	     * Generate a Non-Aviation invoice with the status "new"
	     */
	    NonAviationBillingEngineController.prototype.generateNonAviationInvoice = function (format, preview, accountId, year, month, lineItems) {
	        var _this = this;
	        this.reportsService.generateNonAviationInvoice(format, preview, accountId, year, month, lineItems).then(function () {
	            _this.generateSuccess();
	        })
	            .catch(function (error) { return _this.setErrorResponse(error); });
	    };
	    /**
	     * Validate billing period
	     */
	    NonAviationBillingEngineController.prototype.validateBillingPeriod = function () {
	        return this.$scope.startOfCurrentMonth.isAfter(this.$scope.dateObject);
	    };
	    /**
	     * Populates line items table once month, year, and
	     * account have been selected
	     *
	     * @param  {INonAviationBillingEngine} nonAviation
	     * @returns void
	     */
	    NonAviationBillingEngineController.prototype.getLineItems = function (nonAviation) {
	        var _this = this;
	        this.$scope.editable.month = this.$scope.dateObject.getMonth() + 1;
	        this.$scope.editable.year = this.$scope.dateObject.getFullYear();
	        if (!(this.$scope.dateObject.getMonth() + 1) || !this.$scope.dateObject.getFullYear() || !nonAviation.accountId
	            || (!nonAviation.externalChargeCategory && this.$scope.externalChargeCategories.length > 0)) {
	            return;
	        }
	        this.reportsService.getLineItemsByMonth(this.$scope.dateObject.getMonth() + 1, this.$scope.dateObject.getFullYear(), nonAviation.accountId, nonAviation.externalChargeCategory ? nonAviation.externalChargeCategory.id : null)
	            .then(function (data) {
	            for (var i = 0; i < data.length; i++) {
	                if (data[i].service_charge_catalogue.charge_basis === 'discount') {
	                    data.push(data.splice(i, 1)[0]); // set discount to be the last of array
	                }
	            }
	            _this.$scope.lineItems = data;
	        })
	            .catch(function (error) { return _this.setErrorResponse(error); });
	    };
	    NonAviationBillingEngineController.prototype.setDefaultDate = function () {
	        var today = new Date();
	        var month = today.getMonth();
	        this.$scope.dateObject = new Date(today.getFullYear(), month - 1);
	    };
	    // callback for successful invoice generation
	    NonAviationBillingEngineController.prototype.generateSuccess = function () {
	        this.$scope.invoiceCreated = true;
	        this.$scope.lineItems = null;
	        this.$scope.editable.accountId = null;
	        this.$scope.editable.currencyCode = null;
	    };
	    NonAviationBillingEngineController.prototype.setExternalChargeCategories = function (items) {
	        if (!items || items.length === 0) {
	            this.$scope.externalChargeCategories = [];
	            this.$scope.editable.externalChargeCategory = null;
	        }
	        else if (items.length === 1) {
	            this.$scope.externalChargeCategories = items;
	            this.$scope.editable.externalChargeCategory = items[0];
	        }
	        else {
	            this.$scope.externalChargeCategories = items;
	            this.$scope.editable.externalChargeCategory = null;
	        }
	    };
	    NonAviationBillingEngineController.prototype.updateAccountCurrencyCode = function (accountId) {
	        var _this = this;
	        if (accountId) {
	            this.accountsService.get(accountId)
	                .then(function (account) { return _this.$scope.editable.currencyCode = account.invoice_currency.currency_code; });
	        }
	        else {
	            this.$scope.editable.currencyCode = null;
	        }
	    };
	    return NonAviationBillingEngineController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.NonAviationBillingEngineController = NonAviationBillingEngineController;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var RevenueDataController = (function (_super) {
	    __extends(RevenueDataController, _super);
	    /* @ngInject */
	    RevenueDataController.$inject = ["$scope", "revenueDataService", "aerodromesService", "accountsService", "billingCentreManagementService", "catalogueServiceChargeService", "systemConfigurationService", "$timeout", "dbqueryService", "customDate"];
	    function RevenueDataController($scope, revenueDataService, aerodromesService, accountsService, billingCentreManagementService, catalogueServiceChargeService, systemConfigurationService, $timeout, dbqueryService, customDate) {
	        var _this = _super.call(this, $scope, revenueDataService) || this;
	        _this.$scope = $scope;
	        _this.revenueDataService = revenueDataService;
	        _this.aerodromesService = aerodromesService;
	        _this.accountsService = accountsService;
	        _this.billingCentreManagementService = billingCentreManagementService;
	        _this.catalogueServiceChargeService = catalogueServiceChargeService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$timeout = $timeout;
	        _this.dbqueryService = dbqueryService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        // retrieve organization to show different reports
	        var organization = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION);
	        $scope[organization] = organization;
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.$watchGroup(['editable.temporal_group', 'editable.group_by'], function () {
	            _this.createSortList();
	        });
	        $timeout(function () {
	            // add sortable to <ul>
	            $scope.newSortIndexes = [];
	            var mySort = document.getElementById('my-sort');
	            var sortable = function () {
	                return new Sortable(mySort, {
	                    onUpdate: function (evt) {
	                        // get new sort order based on indexes
	                        var newSortIndexes = [];
	                        var liElements = Array.from(mySort.getElementsByTagName('li'));
	                        for (var _i = 0, liElements_1 = liElements; _i < liElements_1.length; _i++) {
	                            var element = liElements_1[_i];
	                            newSortIndexes.push(element.getAttribute('data-index'));
	                        }
	                        $scope.newSortIndexes = newSortIndexes;
	                        $scope.sortList = _this.getSorted($scope.sortList, newSortIndexes);
	                        $scope.editable.sort = _this.getEditableSort($scope.sortList);
	                    }
	                });
	            };
	            sortable();
	        });
	        // services
	        aerodromesService.listAll().then(function (aerodromes) { return $scope.aerodromesList = aerodromes.content; });
	        accountsService.findAllCreditMinimalReturn().then(function (accounts) { return $scope.accountsList = accounts; });
	        billingCentreManagementService.listAll().then(function (billingCentres) { return $scope.billingCentresList = billingCentres.content; });
	        catalogueServiceChargeService.listAll().then(function (charges) {
	            _this.$scope.serviceChargeList = charges.content;
	            _this.getClasses(_this.$scope.serviceChargeList);
	        });
	        $scope.displayValues = _this.service.displayValues();
	        $scope.groupByValues = _this.service.groupByValues().sort(function (a, b) {
	            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
	            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
	            if (nameA < nameB) {
	                return -1;
	            }
	            if (nameA > nameB) {
	                return 1;
	            }
	            return 0; // names must be equal
	        });
	        // default chart variables
	        $scope.datapoints = [];
	        $scope.datacolumns = [];
	        $scope.ylabel = [];
	        $scope.datax = { 'id': 'x' };
	        $scope.getEmptyModels = function () { return _this.getEmptyModels(); };
	        _this.getEmptyModels();
	        $scope.addGroupToList = function () {
	            _this.$scope.editable.group_by = _this.addToList(_this.$scope.groupByModel, 'value');
	        };
	        $scope.addBillingCentreToList = function () {
	            _this.$scope.editable.billing_centres = _this.addToList(_this.$scope.billingCentresModel, 'name');
	        };
	        $scope.addAccountToList = function () {
	            _this.$scope.editable.accounts = _this.addToList(_this.$scope.accountsModel, 'name');
	        };
	        $scope.addAerodromeToList = function () {
	            _this.$scope.editable.aerodromes = _this.addToList(_this.$scope.aerodromesModel, 'aerodrome_name');
	        };
	        // functions
	        _this.getTemplateNames();
	        $scope.saveTemplate = function (name) { return _this.saveTemplate(name); };
	        $scope.deleteTemplate = function (name) { return _this.deleteTemplate(name); };
	        $scope.updateTemplate = function (name) { return _this.updateTemplate(name); };
	        $scope.selectTemplate = function (name) { return _this.selectTemplate(name); };
	        $scope.getCategories = function (chargeClass) { return _this.getCategories(chargeClass); };
	        $scope.getTypes = function (chargeClass, chargeCategory) { return _this.getTypes(chargeClass, chargeCategory); };
	        $scope.generate = function (revenueData, startDate, endDate, groupBy, chartType) { return _this.generate(revenueData, startDate, endDate, groupBy, chartType)
	            .then(function (data) {
	            if (data.length === 0) {
	                _this.$scope.noData = true;
	            }
	            else {
	                _this.$scope.data = data; // re-used if chart type changes
	                _this.$scope.datapoints = _this.getDataPoints(_this.$scope.data);
	                _this.$scope.datacolumns = _this.getColumnLabels(_this.$scope.data, _this.$scope.datapoints, revenueData.group_by, chartType);
	                _this.$scope.csvData = _this.createCSVdata(_this.$scope.datapoints);
	                $scope.editable = revenueData;
	            }
	        })
	            .catch(function (error) {
	            _this.$scope.error = {};
	            _this.$scope.error.error = { data: error.data };
	        }); };
	        $scope.labelFormat = function (value) {
	            if (!_this.$scope.display_values) {
	                return null;
	            }
	            if (!value) {
	                return value;
	            }
	            if ($scope.display_value !== 'count') {
	                return '$' + value.toLocaleString();
	            }
	            else {
	                return value.toLocaleString();
	            }
	        };
	        return _this;
	    }
	    RevenueDataController.prototype.getDataPoints = function (data) {
	        return this.dbqueryService.getDataPoints(data, this.$scope.display_value, this.$scope.sortList);
	    };
	    RevenueDataController.prototype.getColumnLabels = function (data, dataPoints, labelKey, chartType) {
	        return this.dbqueryService.getColumnsLabels(data, dataPoints, labelKey, chartType); // sets up column labels
	    };
	    /**
	     * Turns field arrays into comma separated
	     * strings that are used with the dbquery IN
	     * clause
	     *
	     * @param  {IRevenueData} revenueData
	     * @param  {string} startDate
	     * @param  {string} endDate
	     * @param  {string} groupBy
	     * @returns IPromise<IRevenueResponse[]>
	     */
	    RevenueDataController.prototype.generate = function (revenueData, startDate, endDate, groupBy, chartType) {
	        var _this = this;
	        this.$scope.noData = false;
	        this.$scope.ylabel = this.$scope.displayValues.find(function (x) { return x.value === _this.$scope.display_value; }).name;
	        var obj = angular.copy(revenueData);
	        obj.start_date = startDate.toISOString().substr(0, 10); // must send in format yyyy-mm-dd
	        obj.end_date = endDate.toISOString().substr(0, 10);
	        if (groupBy) {
	            obj[groupBy] = true;
	        }
	        return this.revenueDataService.query(obj);
	    };
	    /**
	     * Creates an array of unique classes from the
	     * service charge catalogue
	     *
	     * @param  {ICatalogueServiceChargeType[]} serviceChargeList
	     * @returns void
	     */
	    RevenueDataController.prototype.getClasses = function (serviceChargeList) {
	        var classes = serviceChargeList.map((function (item) { return item.charge_class; }));
	        this.$scope.chargeClasses = Array.from(new Set(classes));
	    };
	    /**
	     * Creates an array of unique categories from the
	     * service charge catalogue for specific charge class
	     *
	     * @param  {string} chargeClass
	     * @returns void
	     */
	    RevenueDataController.prototype.getCategories = function (chargeClass) {
	        var categories = this.$scope.serviceChargeList.filter(function (item) { return item.charge_class === chargeClass; })
	            .map(function (item) { return item.category; });
	        this.$scope.chargeCategories = Array.from(new Set(categories));
	    };
	    /**
	     * Creates an array of unique types from the
	     * service charge catalogue for specific category and charge class
	     *
	     * @param  {string} chargeClass
	     * @param  {string} chargeCategory
	     * @returns void
	     */
	    RevenueDataController.prototype.getTypes = function (chargeClass, chargeCategory) {
	        var types = this.$scope.serviceChargeList.filter(function (item) { return item.charge_class === chargeClass; })
	            .filter(function (item) { return item.category === chargeCategory; })
	            .map(function (item) { return item.type; });
	        this.$scope.chargeTypes = Array.from(new Set(types));
	    };
	    RevenueDataController.prototype.createSortList = function () {
	        this.$scope.sortList = [];
	        var idNumber = 0;
	        if (this.$scope.editable.temporal_group) {
	            this.$scope.sortList.push({ id: idNumber, name: 'Temporal Group', value: 'date' });
	            idNumber++;
	        }
	        if (this.$scope.editable.group_by) {
	            for (var _i = 0, _a = this.$scope.editable.group_by.split(','); _i < _a.length; _i++) {
	                var item = _a[_i];
	                this.$scope.sortList.push({ id: idNumber, name: this.toUpperCase(item.replace(/_/g, ' ')), value: item });
	                idNumber++;
	            }
	        }
	        this.$scope.editable.sort = this.getEditableSort(this.$scope.sortList);
	    };
	    RevenueDataController.prototype.toUpperCase = function (str) {
	        var splitStr = str.split(' ');
	        for (var i = 0; i < splitStr.length; i++) {
	            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
	        }
	        return splitStr.join(' ');
	    };
	    RevenueDataController.prototype.getEditableSort = function (arr) {
	        var array = [];
	        arr.forEach(function (item) {
	            array.push(item.name);
	        });
	        return array.join(',');
	    };
	    // sort by indexes
	    RevenueDataController.prototype.getSorted = function (arr, sortArr) {
	        var result = [];
	        for (var i = 0; i < arr.length; i++) {
	            result[i] = arr[sortArr[i]];
	        }
	        return result;
	    };
	    RevenueDataController.prototype.addToList = function (model, prop) {
	        var items = null;
	        var neededProp = null;
	        if (model.length > 0) {
	            items = model.map(function (item) {
	                Object.getOwnPropertyNames(item).forEach(function (val, idx, array) {
	                    if (val === prop) {
	                        neededProp = item[val];
	                    }
	                });
	                return neededProp;
	            }).join(',');
	        }
	        return items;
	    };
	    RevenueDataController.prototype.getEmptyModels = function () {
	        // multi-selects
	        this.$scope.billingCentresModel = [];
	        this.$scope.accountsModel = [];
	        this.$scope.aerodromesModel = [];
	        this.$scope.groupByModel = [];
	        this.$scope.sortList = [];
	        this.$scope.display_value = null;
	        this.$scope.chartType = null;
	        // editable
	        this.$scope.editable = this.revenueDataService.getModel();
	    };
	    // template
	    RevenueDataController.prototype.collectDataForTemplate = function (name) {
	        var template = angular.copy(this.$scope.editable);
	        template.name = name;
	        template.value = this.$scope.display_value;
	        template.chart_type = this.$scope.chartType;
	        return template;
	    };
	    RevenueDataController.prototype.saveTemplate = function (name) {
	        var _this = this;
	        var template = this.collectDataForTemplate(name);
	        this.revenueDataService.createTemplate(template).then(function () { _this.getTemplateNames(); _this.getEmptyModels(); })
	            .catch(function (error) {
	            _this.$scope.error = {};
	            _this.$scope.error.error = { data: error.data };
	        });
	    };
	    RevenueDataController.prototype.updateTemplate = function (name) {
	        var _this = this;
	        var template = this.collectDataForTemplate(name);
	        this.revenueDataService.getTemplateByName(name).then(function (data) {
	            template.id = data.id;
	            _this.revenueDataService.updateTemplate(template, template.id).then(function () { return _this.selectTemplate(name); })
	                .catch(function (error) {
	                _this.$scope.error = {};
	                _this.$scope.error.error = { data: error.data };
	            });
	        });
	    };
	    RevenueDataController.prototype.deleteTemplate = function (name) {
	        var _this = this;
	        this.revenueDataService.getTemplateByName(name).then(function (template) {
	            _this.revenueDataService.deleteTemplate(template.id).then(function () { return _this.getTemplateNames(); })
	                .catch(function (error) {
	                _this.$scope.error = {};
	                _this.$scope.error.error = { data: error.data };
	            });
	        });
	    };
	    // return template names
	    RevenueDataController.prototype.getTemplateNames = function () {
	        var _this = this;
	        this.revenueDataService.getAllNames().then(function (names) { return _this.$scope.templatesList = names; });
	    };
	    // populate the form
	    RevenueDataController.prototype.selectTemplate = function (name) {
	        var _this = this;
	        this.getEmptyModels();
	        if (name) {
	            this.revenueDataService.getTemplateByName(name).then(function (template) {
	                _this.setModelFromTemplate(_this.$scope.billingCentresList, template.billing_centres, _this.$scope.billingCentresModel, 'name', 'billing_centres');
	                _this.setModelFromTemplate(_this.$scope.accountsList, template.accounts, _this.$scope.accountsModel, 'name', 'accounts');
	                _this.setModelFromTemplate(_this.$scope.aerodromesList, template.aerodromes, _this.$scope.aerodromesModel, 'aerodrome_name', 'aerodromes');
	                _this.setModelFromTemplate(_this.$scope.groupByValues, template.group_by, _this.$scope.groupByModel, 'value', 'group_by');
	                _this.$scope.display_value = template.value;
	                _this.$scope.chartType = template.chart_type;
	                _this.$scope.editable.temporal_group = template.temporal_group;
	                _this.$scope.editable.fiscal_year = template.fiscal_year;
	                _this.$scope.editable.payment_mode = template.payment_mode;
	                _this.$scope.editable.analysis_type = template.analysis_type;
	                _this.$scope.editable.charge_class = template.charge_class;
	                _this.getCategories(_this.$scope.editable.charge_class);
	                _this.$scope.editable.charge_category = template.charge_category;
	                _this.getTypes(_this.$scope.editable.charge_class, _this.$scope.editable.charge_category);
	                _this.$scope.editable.charge_type = template.charge_type;
	                _this.$timeout(function () {
	                    _this.$scope.sortList = [];
	                    _this.$scope.editable.sort = null;
	                    if (template.sort) {
	                        var sort = template.sort.split(',');
	                        var idNumber_1 = 0;
	                        sort.forEach(function (element) {
	                            idNumber_1++;
	                            var value;
	                            if (element === 'Temporal Group') {
	                                value = 'date';
	                            }
	                            else {
	                                var existingGroupByValue = _this.$scope.groupByValues.find(function (item) { return item.value === element.replace(/ /g, '_').toLowerCase(); });
	                                value = existingGroupByValue ? existingGroupByValue.value : null;
	                            }
	                            _this.$scope.sortList.push({ id: idNumber_1, name: element, value: value });
	                        });
	                        _this.$scope.editable.sort = _this.getEditableSort(_this.$scope.sortList);
	                    }
	                });
	            });
	        }
	    };
	    RevenueDataController.prototype.setModelFromTemplate = function (list, template, model, prop, item) {
	        var _this = this;
	        if (template) {
	            list.forEach(function (element) {
	                var neededProp = null;
	                Object.getOwnPropertyNames(element).forEach(function (val, idx, array) {
	                    if (!(val === prop)) {
	                        return;
	                    }
	                    neededProp = element[val];
	                    if (typeof (template) === 'object' && template.includes(neededProp)) {
	                        model.push(element);
	                    }
	                    else if (template.split(',').includes(neededProp)) {
	                        model.push(element);
	                    }
	                    _this.$scope.editable[item] = template;
	                });
	            });
	        }
	    };
	    RevenueDataController.prototype.createCSVdata = function (data) {
	        var headers = data.map(function (entry) {
	            return Object.keys(entry);
	        }).reduce(function (accumulator, currentValue) {
	            if (!Object.keys(accumulator).length) {
	                var key = 'x';
	                accumulator[key] = 'Date';
	            }
	            currentValue.map(function (value) {
	                if (!accumulator[value] && value !== 'x') {
	                    accumulator[value] = value;
	                }
	            });
	            return accumulator;
	        }, {});
	        var csvData = [headers];
	        data.forEach(function (item) {
	            var row = {};
	            Object.keys(headers).forEach(function (key) { return row[key] = item[key] || 0; });
	            csvData.push(row);
	        });
	        return csvData;
	    };
	    return RevenueDataController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.RevenueDataController = RevenueDataController;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// services
	var rejected_items_service_1 = __webpack_require__(47);
	var convert_item_type_service_1 = __webpack_require__(48);
	// no need for the user service as there are no permissions
	var RejectedItemsController = (function (_super) {
	    __extends(RejectedItemsController, _super);
	    /* @ngInject */
	    RejectedItemsController.$inject = ["$scope", "$state", "rejectedItemsService", "saveLocalTemplateService", "convertItemTypeService", "customDate"];
	    function RejectedItemsController($scope, $state, rejectedItemsService, saveLocalTemplateService, convertItemTypeService, customDate) {
	        var _this = _super.call(this, $scope, rejectedItemsService) || this;
	        _this.$scope = $scope;
	        _this.$state = $state;
	        _this.rejectedItemsService = rejectedItemsService;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _this.convertItemTypeService = convertItemTypeService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.$scope.toggle = true;
	        $scope.$watchGroup(['search', 'control', 'filter-by-record-type', 'filter-by-status', 'filter-by-originator', 'filter-by-file-name'], function () { return _this.getFilterParameters(); });
	        _this.$state = $state;
	        $scope.update = function () { return _this.updateOverride(); };
	        $scope.delete = function () { return _super.prototype.delete.call(_this, _this.$scope.id).then(function () { return _this.$scope.displayed_data = []; }); };
	        $scope.reset = function () { return _this.$scope.displayed_data = []; };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.selectFirstIfNoSelection = function () {
	            if (!$scope.displayed_data) {
	                _this.edit($scope.list[0]);
	            }
	        };
	        _this.saveLocalTemplate();
	        return _this;
	    }
	    /**
	     * For 'Flight Movement' and 'Radar Summary' types:
	     * This function create an object from decoded
	     * 'json_text' field reterned from server
	     *
	     * Loops through the data in this object to fix
	     * value type in key/value pair (date, string, number and null)
	     *
	     * Compare keys of this object with an array that containes names of fields need to be shown
	     * and create an new array (header/value) with data that need to be shown for user
	     *
	     * Convert 'Flight Movement'.'dayOfFlight' field in the new array from milliseconds to date
	     *
	     * For other types:
	     * This function splits 'header' and 'raw_text'
	     * fields reterned from server into arrays
	     *
	     * These arrays are used as key/value to populate
	     * a new array (header/value) to display information for user
	     *
	     * @param  {IRejectedItem} item
	     * @returns void
	     */
	    RejectedItemsController.prototype.edit = function (item) {
	        this.$scope.reset();
	        this.$scope.data = [];
	        this.$scope.userInput = []; // callect changed data by user
	        this.$scope.item = item;
	        this.$scope.id = item.id;
	        this.$scope.error = null; // clear error when selecting a new item
	        var displayed_data = []; // used to display data from server
	        if (item.record_type === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV]
	            || item.record_type === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM]) {
	            // get decoded json object
	            var decodedJson = this.decodeToObject(item.json_text);
	            // get fields to show based on record type
	            var showData = this.visibleFields(item.record_type, decodedJson.format);
	            // get convert item properties base on record type
	            var convertProperties = this.convertItemTypeProperties(item.record_type);
	            // loop through each object property, fix
	            // data types and add to displayed data
	            // if it exists in showData list
	            for (var value in decodedJson) {
	                if (decodedJson.hasOwnProperty(value)) {
	                    // set data value from decoded object
	                    var dataValue = decodedJson[value];
	                    // run additional data parsing if exists
	                    if (dataValue) {
	                        // check if type of custom date from api
	                        // or in the format of toISOString
	                        // deprecated: for outdated json_text data
	                        if (dataValue.hasOwnProperty('chronology')) {
	                            dataValue = new Date(Date.UTC(dataValue.year, dataValue.monthValue - 1, dataValue.dayOfMonth, dataValue.hour, dataValue.minute, dataValue.second));
	                        }
	                        else if (moment(dataValue, moment.ISO_8601).isValid()) {
	                            dataValue = new Date(dataValue);
	                        }
	                        // convert item format if exists in convert properties
	                        if (convertProperties[value]) {
	                            dataValue = this.convertItemTypeService.itemTo(dataValue, convertProperties[value]);
	                        }
	                        // update decodedJson object with new value type
	                        decodedJson[value] = dataValue;
	                    }
	                    // push data value to displayed data
	                    if (showData.indexOf(value) > -1) {
	                        var type = Object.prototype.toString.call(dataValue);
	                        if (value === 'day_of_flight') {
	                            type = '[object Date]';
	                        }
	                        displayed_data.push({
	                            header: this.headerToText(value, item.record_type),
	                            data: dataValue,
	                            type: type,
	                            isMultiLineField: this.isMultilineField(item.record_type, value)
	                        });
	                    }
	                }
	            }
	            // set scope resutls from decoded json
	            this.$scope.result = decodedJson;
	        }
	        else {
	            // split header and raw_text on comma characters
	            var header = item.header.split(',');
	            this.$scope.data = item.raw_text.split(',');
	            // add data from 'header' and 'raw_text' to display
	            for (var i = 0; i < header.length; i++) {
	                // all Unknowns fields are hidden
	                if (header[i] === '') {
	                    header[i] = '-Unknown-';
	                }
	                // push item to displayed data
	                displayed_data.push({
	                    header: this.headerToText(header[i], item.record_type),
	                    data: this.$scope.data[i],
	                    type: Object.prototype.toString.call(this.$scope.data[i]),
	                    isMultiLineField: false
	                });
	            }
	        }
	        // update merge upload checkbox based on init logic
	        this.$scope.merge_upload = this.$scope.result && this.$scope.result.format === 'INDRA_REC';
	        // push dispalyed data to scope
	        this.$scope.displayed_data = displayed_data;
	    };
	    /**
	     * For 'Flight Movement' and 'Radar Summary' types:
	     * Insert new value from user into decoded object;
	     * Convert 'Flight Movement'.'dayOfFlight' field in this object from date to milliseconds;
	     * Call update method with this object
	     *
	     * For other types:
	     * This function create an object from data that entered by user
	     * Call update method with this object
	     *
	     * @returns void
	     */
	    RejectedItemsController.prototype.updateOverride = function () {
	        var _this = this;
	        // used as data trasfer object
	        var obj = new Object();
	        if (this.$scope.item.record_type === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV]
	            || this.$scope.item.record_type === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM]) {
	            // loop through each user defined input and updated displayed data
	            for (var i = 0; i < this.$scope.userInput.length; i++) {
	                // set displayed data from user input
	                this.$scope.displayed_data[i].data = this.$scope.userInput[i];
	                // convert 'object Date' types to ISO string
	                // or header value is 'day of flight' and item type is 'Flight Movement'
	                if (this.$scope.displayed_data[i].type === '[object Date]'
	                    || (this.$scope.displayed_data[i].header === 'day of flight' && this.$scope.item.record_type === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV])) {
	                    var date = new Date(this.$scope.displayed_data[i].data);
	                    if (!isNaN(date.getTime())) {
	                        this.$scope.displayed_data[i].data = date.toISOString();
	                    }
	                }
	            }
	            // for each result, updated from displayed data
	            for (var res in this.$scope.result) {
	                if (this.$scope.result.hasOwnProperty(res)) {
	                    for (var _i = 0, _a = this.$scope.displayed_data; _i < _a.length; _i++) {
	                        var data = _a[_i];
	                        if (res === this.headerToProperty(data.header, this.$scope.item.record_type)) {
	                            this.$scope.result[res] = data.data;
	                            if (res === 'date' && this.$scope.item.record_type === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM]) {
	                                //we have to even set 'dayOfFlight' property with value of 'date' property
	                                if (this.$scope.result.hasOwnProperty(this.getDayOfFlightPropertyName())) {
	                                    this.$scope.result[this.getDayOfFlightPropertyName()] = data.data;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            // set 'json_text' as base-64 encoded string
	            obj.json_text = this.encodeToString(this.$scope.result);
	        }
	        else {
	            // set user input based on data if length is less
	            if (this.$scope.userInput.length < this.$scope.data.length) {
	                this.$scope.userInput = this.$scope.userInput.concat(this.$scope.data.slice(this.$scope.userInput.length));
	            }
	            // set 'raw_text' based on user input
	            obj.raw_text = this.$scope.userInput.join();
	        }
	        // set merge upload flag based on scope
	        obj.merge_upload = this.$scope.merge_upload;
	        // update rejected item object based on item id
	        this.rejectedItemsService
	            .updateOverride(obj, this.$scope.id, this.$scope.merge_upload).then(function () {
	            _super.prototype.reset.call(_this);
	            _this.refreshOverride();
	        }, function (error) {
	            throw _super.prototype.setErrorResponse.call(_this, error);
	        });
	    };
	    RejectedItemsController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'filter-by-record-type': this.$scope.filter_by_record_type,
	            'filter-by-status': this.$scope.filter_by_status,
	            'filter-by-originator': this.$scope.filter_by_originator,
	            'filter-by-file-name': this.$scope.filter_by_file_name,
	            'start': startDate,
	            'end': endDate,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Calls list with applied filters
	     *
	     * @returns void
	     */
	    RejectedItemsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    /**
	     * Use to decode base-64 encoded string as an object.
	     *
	     * @param {string} baseString base-64 encoded string
	     * @returns {object} decoded string as an object
	     */
	    RejectedItemsController.prototype.decodeToObject = function (baseString) {
	        // decodes string that has been encoded using base-64 encoding
	        var value = atob(baseString);
	        // return decoded string as an object
	        return JSON.parse(value);
	    };
	    /**
	     * Use to encode an object as a base-64 encoded string.
	     *
	     * @param {object} baseObject object to be encoded
	     * @return {string} encoded object as a string
	     */
	    RejectedItemsController.prototype.encodeToString = function (baseObject) {
	        // stringify object that is to be encoded
	        var value = JSON.stringify(baseObject);
	        // return encoded object as a base-64 encoding
	        return btoa(value);
	    };
	    /**
	     * Returns a list of visiable fields based on
	     * the supplied rejected item type value.
	     *
	     * @param {string} itemType rejected item type
	     * @param {string} itemFormat rejected item format (ie: INDRA_REC for radar)
	     * @returns {string[]} list of visiable fields
	     */
	    RejectedItemsController.prototype.visibleFields = function (itemType, itemFormat) {
	        if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV]) {
	            return this.visibleFieldsFlightMov();
	        }
	        else if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM]) {
	            return this.visibleFieldsRadarSumm(itemFormat);
	        }
	        else {
	            return [];
	        }
	    };
	    /**
	     * Returns a string with property name dayOfFlight
	     * flight movement/radar summary rejectable item.
	     *
	     * @returns {string} dayOfFlight property name
	     */
	    RejectedItemsController.prototype.getDayOfFlightPropertyName = function () {
	        return 'dayOfFlight';
	    };
	    /**
	     * Returns a list of visiable fields based on
	     * flight movement rejectable item.
	     *
	     * @returns {string[]} list of visiable fields
	     */
	    RejectedItemsController.prototype.visibleFieldsFlightMov = function () {
	        return [
	            'flight_id', 'flight_rules', 'flight_type', 'aircraft_type', 'departure_ad', 'departure_time', 'route',
	            'destination_ad', 'total_eet', 'day_of_flight', 'other_info', 'speed', 'flight_level'
	        ];
	    };
	    /**
	     * Returns a list of visiable fields based on radara summary
	     * rejectable item format.
	     *
	     * @param {string} itemFormat radar summary format (ie: INDRA_REC for radar)
	     * @returns {string[]} list of visiable fields
	     */
	    RejectedItemsController.prototype.visibleFieldsRadarSumm = function (itemFormat) {
	        var fields = [
	            'flightTravelCategory', 'flightIdentifier', 'date', 'registration', 'flightType', 'flightRule', 'aircraftType', 'wakeTurb',
	            'destinationAeroDrome', 'destTime', 'departureAeroDrome', 'departureTime', 'cruisingSpeed', 'flightLevel', 'firEntryPoint', 'firEntryTime',
	            'firEntryFlightLevel', 'firExitPoint', 'firExitTime', 'firExitFlightLevel'
	        ];
	        if (itemFormat === 'INDRA_REC') {
	            fields.push('fixes');
	        }
	        else {
	            fields.push('route');
	        }
	        return fields;
	    };
	    /**
	     * @param itemType Returns true if the given field should be displayed as a text area
	     */
	    RejectedItemsController.prototype.isMultilineField = function (itemType, fieldId) {
	        if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV]) {
	            return this.isMultilineFieldFlightMov(fieldId);
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * @param itemType Returns true if the given Flight Movement field should be displayed as a text area
	     */
	    RejectedItemsController.prototype.isMultilineFieldFlightMov = function (fieldId) {
	        if (fieldId === 'other_info') {
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Returns an object of converstion properties for each
	     * item based on the supplied rejected item type value.
	     *
	     * This is used in conjunction with convertItemTo method.
	     *
	     * It is used here only to correct json_text field types.
	     *
	     * @param {string} itemType rejected item type
	     * @returns {Object} conversion properties
	     */
	    RejectedItemsController.prototype.convertItemTypeProperties = function (itemType) {
	        if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM]) {
	            return {
	                date: { source: convert_item_type_service_1.ConvertItemType.DATE, target: convert_item_type_service_1.ConvertItemType.STRING, format: 'YYMMDD', utc: true }
	            };
	        }
	        else {
	            return {};
	        }
	    };
	    /**
	     * Returns use friendly readable text value of header property
	     * based on the rejected item type.
	     *
	     * 'Flight Moevemnts' are broken on underscore characters.
	     * All other ttypes are broken on capitalized letters.
	     *
	     * Exception made for AeroDrome under RADAR_SUMM.
	     *
	     * @param {string} value property header value
	     * @param {string} itemType rejected item type
	     * @return {string} readable header value
	     */
	    RejectedItemsController.prototype.headerToText = function (value, itemType) {
	        // 'Flight Movements' are broken on underscore characters
	        if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV]) {
	            return value.replace(/_/g, ' ').trim();
	        }
	        else if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM] && /AeroDrome/i.test(value)) {
	            return value.replace(/AeroDrome/, 'Aerodrome').replace(/([A-Z])/g, ' $1').trim();
	        }
	        else if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.ATS_MOV] && /Fl(Entry|Mid|Exit)Time/i.test(value)) {
	            return value.replace(/fl(Entry|Mid|Exit)Time/, 'fir$1FlightLevel').replace(/([A-Z])/g, ' $1').trim();
	        }
	        else {
	            return value.replace(/([A-Z])/g, ' $1').trim();
	        }
	    };
	    /**
	     * Returns property value used within the dto based on the
	     * rejected item type.
	     *
	     * 'Flight Moevemnts' are combined on underscore characters.
	     * All other ttypes are combined on capitalized letters.
	     *
	     * Exception made for AeroDrome under RADAR_SUMM.
	     *
	     * @param {string} value readable header value
	     * @param {string} itemType rejceted item type
	     * @return {string} property header value
	     */
	    RejectedItemsController.prototype.headerToProperty = function (value, itemType) {
	        if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.FLIGHT_MOV]) {
	            return value.replace(/ /g, '_').trim();
	        }
	        else if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.RADAR_SUMM] && /Aerodrome/i.test(value)) {
	            return value.replace(/ /g, '').replace(/Aerodrome/, 'AeroDrome').trim();
	        }
	        else if (itemType === rejected_items_service_1.RejectedItemType[rejected_items_service_1.RejectedItemType.ATS_MOV] && /fir(Entry|Mid|Exit)FlightLevel/i.test(value)) {
	            return value.replace(/ /g, '').replace(/fir(Entry|Mid|Exit)FlightLevel/, 'fl$1Time').trim();
	        }
	        else {
	            return value.replace(/ /g, '').trim();
	        }
	    };
	    RejectedItemsController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search'], ['filter_by_record_type', 'filter-by-record-type'], ['filter_by_status', 'filter-by-status'],
	            ['filter_by_originator', 'filter-by-originator'], ['filter_by_file_name', 'filter-by-file-name']];
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'rejected-items', filterPairs);
	    };
	    return RejectedItemsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.RejectedItemsController = RejectedItemsController;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'rejected-items';
	var RejectedItemType;
	(function (RejectedItemType) {
	    RejectedItemType[RejectedItemType["FLIGHT_MOV"] = 'Flight Movement'] = "FLIGHT_MOV";
	    RejectedItemType[RejectedItemType["ATS_MESS"] = 'ATS Message'] = "ATS_MESS";
	    RejectedItemType[RejectedItemType["ATS_MOV"] = 'ATC Movement Log'] = "ATS_MOV";
	    RejectedItemType[RejectedItemType["TOWER_AIRC"] = 'Tower Movement Log'] = "TOWER_AIRC";
	    RejectedItemType[RejectedItemType["PASSENGER_SERV"] = 'Passenger Service Charge Return'] = "PASSENGER_SERV";
	    RejectedItemType[RejectedItemType["RADAR_SUMM"] = 'Radar Summary'] = "RADAR_SUMM";
	    RejectedItemType[RejectedItemType["OTHER"] = 'Other'] = "OTHER";
	})(RejectedItemType = exports.RejectedItemType || (exports.RejectedItemType = {}));
	var RejectedItemsService = (function (_super) {
	    __extends(RejectedItemsService, _super);
	    /** @ngInject */
	    RejectedItemsService.$inject = ["Restangular"];
	    function RejectedItemsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            filter_by: null,
	            filter_by_record_type: null,
	            filter_by_date: null,
	            filter_by_status: null,
	            filter_by_originator: null,
	            filter_by_file_name: null,
	            record_type: null,
	            rejected_date_time: null,
	            error_message: null,
	            error_details: null,
	            rejected_reason: null,
	            raw_text: null,
	            header: null,
	            json_text: null,
	            originator: null,
	            status: null,
	            file_name: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    RejectedItemsService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    RejectedItemsService.prototype.updateOverride = function (obj, id, merge) {
	        return this.restangular.one(this.endpoint, id).customPUT(obj, undefined, { 'merge': merge });
	    };
	    return RejectedItemsService;
	}(crud_service_1.CRUDService));
	exports.RejectedItemsService = RejectedItemsService;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ConvertItemType;
	(function (ConvertItemType) {
	    ConvertItemType[ConvertItemType["ARGUMENTS"] = '[object Arguments]'] = "ARGUMENTS";
	    ConvertItemType[ConvertItemType["ARRAY"] = '[object Array]'] = "ARRAY";
	    ConvertItemType[ConvertItemType["BOOLEAN"] = '[object Boolean]'] = "BOOLEAN";
	    ConvertItemType[ConvertItemType["DATE"] = '[object Date]'] = "DATE";
	    ConvertItemType[ConvertItemType["ERROR"] = '[object Error]'] = "ERROR";
	    ConvertItemType[ConvertItemType["FUNCTION"] = '[object Function]'] = "FUNCTION";
	    ConvertItemType[ConvertItemType["JSON"] = '[object JSON]'] = "JSON";
	    ConvertItemType[ConvertItemType["MATH"] = '[object Math]'] = "MATH";
	    ConvertItemType[ConvertItemType["NULL"] = '[object Null]'] = "NULL";
	    ConvertItemType[ConvertItemType["NUMBER"] = '[object Number]'] = "NUMBER";
	    ConvertItemType[ConvertItemType["OBJECT"] = '[object Object]'] = "OBJECT";
	    ConvertItemType[ConvertItemType["REGEXP"] = '[object RegExp]'] = "REGEXP";
	    ConvertItemType[ConvertItemType["STRING"] = '[object String]'] = "STRING";
	    ConvertItemType[ConvertItemType["UNDEFINED"] = '[object Undefined]'] = "UNDEFINED";
	})(ConvertItemType = exports.ConvertItemType || (exports.ConvertItemType = {}));
	var ConvertItemTypeService = (function () {
	    function ConvertItemTypeService() {
	    }
	    /**
	     * Accepts an item and converts it to a specific type based
	     * on properties supplied.
	     *
	     * Currently only DATE, NUMBER, and STRING convert item types
	     * are implemented.
	     *
	     * @param item item to convert
	     * @param properties convert item properties
	     */
	    ConvertItemTypeService.prototype.itemTo = function (item, properties) {
	        // get item type value
	        var type = Object.prototype.toString.call(item);
	        // validate that item exists and 
	        // source type equals item type
	        if (!item || properties.source !== type) {
	            return item;
	        }
	        // send to appropriate handler based on target type
	        if (properties.target === ConvertItemType.DATE) {
	            return this.itemToDate(item, type, properties.format, properties.utc);
	        }
	        else if (properties.source === ConvertItemType.NUMBER) {
	            return this.itemToNumber(item, type, properties.format, properties.utc);
	        }
	        else if (properties.target === ConvertItemType.STRING) {
	            return this.itemToString(item, type, properties.format, properties.utc);
	        }
	        // if unhandled, return supplied value
	        return item;
	    };
	    /**
	     * Accepts an item and converts it to a Date based on an
	     * optional format.
	     *
	     * @param item item to convert
	     * @param type item type
	     * @param format optional item format (default: null)
	     * @param utc optional utc mode if applicable (default: localtime)
	     */
	    ConvertItemTypeService.prototype.itemToDate = function (item, type, format, utc) {
	        if (type === ConvertItemType.STRING && format && utc) {
	            return moment.utc(item, format).toDate();
	        }
	        else if (type === ConvertItemType.STRING && format) {
	            return moment(item, format).toDate();
	        }
	        else if ((type === ConvertItemType.STRING || type === ConvertItemType.NUMBER) && utc) {
	            return moment.utc(item).toDate();
	        }
	        return moment(item).toDate();
	    };
	    /**
	     * Accepts an item and converts it to a Number.
	     *
	     * @param item item to convert
	     * @param type item type
	     * @param format optional item format (default: null)
	     * @param utc optional utc mode if applicable (default: localtime)
	     */
	    ConvertItemTypeService.prototype.itemToNumber = function (item, type, format, utc) {
	        if (type === ConvertItemType.DATE && utc) {
	            return moment(item).utc().unix();
	        }
	        else if (type === ConvertItemType.DATE) {
	            return moment(item).unix();
	        }
	        else if (type === ConvertItemType.STRING && format) {
	            return parseInt(item, format);
	        }
	        return parseInt(item, 0);
	    };
	    /**
	     * Accepts an item and converts it to a string.
	     *
	     * @param item item to convert
	     * @param type item type
	     * @param format optional string format (default: null)
	     * @param utc optional utc mode if applicable (default: localtime)
	     */
	    ConvertItemTypeService.prototype.itemToString = function (item, type, format, utc) {
	        if (type === ConvertItemType.DATE && format && utc) {
	            return moment(item).utc().format(format);
	        }
	        else if (type === ConvertItemType.DATE && format) {
	            return moment(item).format(format);
	        }
	        else if (type === ConvertItemType.DATE && utc) {
	            return moment(item).utc().toISOString();
	        }
	        else if (type === ConvertItemType.DATE) {
	            return moment(item).toISOString();
	        }
	        else if (type === ConvertItemType.NUMBER && format) {
	            return item.toString(format);
	        }
	        return item.toString();
	    };
	    return ConvertItemTypeService;
	}());
	exports.ConvertItemTypeService = ConvertItemTypeService;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var RecurringChargesController = (function (_super) {
	    __extends(RecurringChargesController, _super);
	    /* @ngInject */
	    RecurringChargesController.$inject = ["$scope", "$rootScope", "recurringChargesService", "catalogueServiceChargeService", "customDate"];
	    function RecurringChargesController($scope, $rootScope, recurringChargesService, catalogueServiceChargeService, customDate) {
	        var _this = _super.call(this, $scope, recurringChargesService) || this;
	        _this.$scope = $scope;
	        _this.recurringChargesService = recurringChargesService;
	        _this.catalogueServiceChargeService = catalogueServiceChargeService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this, { filter: 'all' });
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.create = function (recurringCharge, startDate, endDate) { return _this.createOverride(recurringCharge, startDate, endDate); };
	        $scope.update = function (recurringCharge, startDate, endDate) { return _this.updateOverride(recurringCharge, startDate, endDate); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        catalogueServiceChargeService.listAll().then(function (results) { return $scope.catalogueServiceChargeListFiltered = _this.setUpFilteredServiceCharges(results.content); });
	        return _this;
	    }
	    RecurringChargesController.prototype.reset = function () {
	        if (typeof this.$scope.control !== 'undefined') {
	            this.$scope.control.reset();
	        }
	        _super.prototype.reset.call(this);
	    };
	    RecurringChargesController.prototype.edit = function (recurringCharge) {
	        var d = new Date(recurringCharge.start_date);
	        this.$scope.control.setUTCStartDate(d);
	        var e = new Date(recurringCharge.end_date);
	        this.$scope.control.setUTCEndDate(e);
	        _super.prototype.edit.call(this, recurringCharge);
	    };
	    RecurringChargesController.prototype.createOverride = function (recurringCharge, startDate, endDate) {
	        recurringCharge.start_date = startDate;
	        recurringCharge.end_date = endDate;
	        return _super.prototype.create.call(this, recurringCharge);
	    };
	    RecurringChargesController.prototype.updateOverride = function (recurringCharge, startDate, endDate) {
	        recurringCharge.start_date = startDate;
	        recurringCharge.end_date = endDate;
	        return _super.prototype.update.call(this, recurringCharge, recurringCharge.id);
	    };
	    RecurringChargesController.prototype.setUpFilteredServiceCharges = function (serviceCharges) {
	        var allowable = ['non-avi', 'utility', 'lease', 'concession'];
	        var allowableValues = [];
	        for (var i in serviceCharges) {
	            if (allowable.indexOf(serviceCharges[i].invoice_category) !== -1) {
	                allowableValues.push(serviceCharges[i]);
	            }
	        }
	        return allowableValues;
	    };
	    RecurringChargesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            textFilter: this.$scope.textFilter,
	            accountFilter: this.$scope.accountFilter,
	            statusFilter: this.$scope.statusFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    RecurringChargesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return RecurringChargesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.RecurringChargesController = RecurringChargesController;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var localStorage_service_1 = __webpack_require__(9);
	var system_configuration_constants_1 = __webpack_require__(10);
	var reportsWithDatePicker = [
	    'accountStatementReport',
	    'revenueLostToExemptionsReport',
	    'summarisedInvoiceTotalsReport',
	    'aircraftTypesReport',
	    'creditAndDebitNotesReport',
	    'aircraftRegistrationReport',
	    'missingBillingInformationReport',
	    'aircraftRegistrationTrackingReport',
	    'kcaaAccountStatementReport',
	    'kcaaPassengerReport',
	    'passengerReport',
	    'revenueReport',
	    'unifiedTaxReport'
	];
	var ReportGenerationController = (function (_super) {
	    __extends(ReportGenerationController, _super);
	    /* @ngInject */
	    ReportGenerationController.$inject = ["$scope", "reportGenerationService", "accountsService", "aerodromesService", "flightMovementManagementService", "$timeout", "customDate", "organizationService", "currencyManagementService", "usersService"];
	    function ReportGenerationController($scope, reportGenerationService, accountsService, aerodromesService, flightMovementManagementService, $timeout, customDate, organizationService, currencyManagementService, usersService) {
	        var _this = _super.call(this, $scope, reportGenerationService) || this;
	        _this.$scope = $scope;
	        _this.reportGenerationService = reportGenerationService;
	        _this.accountsService = accountsService;
	        _this.aerodromesService = aerodromesService;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.$timeout = $timeout;
	        _this.customDate = customDate;
	        _this.organizationService = organizationService;
	        _this.currencyManagementService = currencyManagementService;
	        _this.usersService = usersService;
	        // retrieve active organization flags from system configuration settings
	        _this.activeOrg = _this.organizationService.active();
	        // set shortcut organization flags to show different reports
	        $scope.CAAB = _this.activeOrg.isCaab;
	        $scope.DC_ANSP = _this.activeOrg.isDcAnsp;
	        $scope.EANA = _this.activeOrg.isEana;
	        $scope.INAC = _this.activeOrg.isInac;
	        $scope.KCAA = _this.activeOrg.isKcaa;
	        $scope.ZACL = _this.activeOrg.isZacl;
	        $scope.TTCAA = _this.activeOrg.isTTCAA;
	        // select initial report
	        $timeout(function () { $scope.editable.report = $scope.CAAB ? 'accountStatusReport' : 'kcaaDebtorReport'; });
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        // multiselect for accounts
	        accountsService.findAllCreditMinimalReturn().then(function (data) { return $scope.accountsList = data; });
	        accountsService.findAllMinimalReturn().then(function (data) { return $scope.accountsListWithCash = data; });
	        $scope.selectedAccounts = [];
	        $scope.addAccountToList = function () { return _this.addAccountToList($scope.selectedAccounts); };
	        // multiselect for aerodromes
	        aerodromesService.listAll().then(function (data) {
	            $scope.aerodromesList = data.content;
	            var zzzzAd = { aerodrome_name: 'ZZZZ' };
	            $scope.aerodromesList.push(zzzzAd);
	        });
	        usersService.current.then(function (user) { return $scope.userName = user.name; });
	        $scope.selectedAerodromes = [];
	        $scope.addAerodromeToList = function () { return _this.addAerodromeToList($scope.selectedAerodromes); };
	        $scope.setClear = function (report) { return _this.setClear(report); };
	        $scope.getFilterType = function (report) { return _this.getFilterType(report); };
	        $scope.returnFilteredDate = function (date) { return _this.returnFilteredDate(date); };
	        $scope.returnEndOfMonth = function (date) { return _this.returnEndOfMonth(date); };
	        // multiselect for missing billing errors
	        $scope.missingInfo = []; // initialize model
	        $scope.listOfMissingInfo = reportGenerationService.getMissingInfoErrors();
	        $scope.formatMissingInfo = function () { return _this.formatMissingInfo($scope.missingInfo); };
	        // multiselect for aircraft registrations
	        $scope.aircraftRegistrations = []; // initialize model
	        flightMovementManagementService.getDistinctRegNum().then(function (registrations) {
	            var regs = registrations.map(function (element, index) { return { id: index, name: element }; });
	            $scope.listOfAirRegs = _this.reduceAirRegs(regs);
	        });
	        // if accounts or aircraft reg numbers are not selected, need to be send as empty string that means 'all'
	        $scope.accountIdsWithBrackets = '';
	        $scope.aircraftRegs = '';
	        _this.currencyManagementService.getListCurrencyANSPAndUSD().then(function (currencies) {
	            $scope.currenciesList = currencies;
	        });
	        $scope.formatAircraftRegistrations = function () { return _this.formatAircraftRegistrations($scope.aircraftRegistrations); };
	        $scope.getFiscalYear = function () { return _this.getFiscalYear(); };
	        $scope.requiresDatePicker = function (reportType) { return reportsWithDatePicker.find(function (report) { return report === reportType; }); };
	        $scope.report_format = 'pdf';
	        _this.setDefaultDate();
	        return _this;
	    }
	    ReportGenerationController.prototype.setDefaultDate = function () {
	        if (this.$scope.control) {
	            var date = new Date();
	            var startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
	            var endDate = new Date(date.getFullYear(), date.getMonth(), 0);
	            this.$scope.control.setUTCStartDate(startDate);
	            this.$scope.control.setUTCEndDate(endDate);
	        }
	    };
	    ReportGenerationController.prototype.getFilterType = function (report) {
	        if (report.used_defined && !report.used_undefined) {
	            report.filter_type = 3;
	        }
	        else if (!report.used_defined && report.used_undefined) {
	            report.filter_type = 2;
	        }
	        else if (report.used_defined && report.used_undefined) {
	            report.filter_type = 1;
	        }
	        return report.filter_type;
	    };
	    ReportGenerationController.prototype.setClear = function (report) {
	        this.setDefaultDate();
	        this.$scope.selectedAccounts = [];
	        this.$scope.missingInfo = [];
	        this.$scope.editable = this.reportGenerationService.getModel();
	        this.$scope.editable.report = report.report;
	        this.$scope.editable.account_new_page = false;
	    };
	    ReportGenerationController.prototype.returnFilteredDate = function (date) {
	        if (date === undefined || date === null) {
	            return;
	        }
	        return date.toISOString().slice(0, 19) + "Z";
	    };
	    ReportGenerationController.prototype.returnEndOfMonth = function (date) {
	        if (date === undefined || date === null) {
	            return;
	        }
	        var endDate = new Date(date.getFullYear(), date.getMonth() + 2, 0);
	        return endDate.toISOString().slice(0, 11) + "23:59:59Z";
	    };
	    /**
	     * Adds resolution errors selected from
	     * multiselect to a comma separated
	     * string of values
	     *
	     * @param  {Array<any>} missingInfo
	     */
	    ReportGenerationController.prototype.formatMissingInfo = function (missingInfo) {
	        var resolutionErrors = missingInfo.map(function (resolutionError) {
	            return resolutionError.value;
	        });
	        // send resolution
	        // errors as comma
	        // separated string
	        // eg. atc-log,tower-log
	        this.$scope.billingErrors = "{" + resolutionErrors.join(',') + "}";
	    };
	    /**
	     * Adds aircraft registrations,
	     * selected from the multiselect,
	     * to a comma separated string
	     *
	     * @param  {Array<any>} regs
	     */
	    ReportGenerationController.prototype.formatAircraftRegistrations = function (regs) {
	        var registrations = regs.map(function (registration) {
	            return registration.name;
	        });
	        this.$scope.aircraftRegs = registrations.length ? "{" + registrations.join(',') + "}" : '';
	    };
	    /**
	     * Remove invalid registrations from the list
	     * These invalid registrations contains special characters that break BIRT SQL
	     *
	     * @param  {Array<any>} regs
	     * @return {Array<any>} regs
	     */
	    ReportGenerationController.prototype.reduceAirRegs = function (regs) {
	        var regex = /[^A-Za-z0-9]+/g;
	        return regs.reduce((function (result, reg) {
	            if (reg && reg.name && !reg.name.match(regex)) {
	                result.push(reg);
	            }
	            ;
	            return result;
	        }), []);
	    };
	    /**
	     * Adds accounts, selected
	     * from the multiselect,
	     * to a comma separated string
	     *
	     * @param  {Array<any>} selectedAccounts
	     */
	    ReportGenerationController.prototype.addAccountToList = function (selectedAccounts) {
	        var accounts = selectedAccounts.map(function (account) { return account.id; });
	        // send account ids as
	        // comma separated string
	        // eg. 1,2,3
	        this.$scope.accountIds = accounts.join(',');
	        this.$scope.accountIdsWithBrackets = accounts.length ? "{" + this.$scope.accountIds + "}" : '';
	        // if report is aircraft reg tracking
	        // and accounts are selected,
	        // group by account is default true
	        if (this.$scope.editable.report === 'aircraftRegistrationTrackingReport') {
	            this.$scope.editable.group_by_account = selectedAccounts.length ? true : false;
	        }
	    };
	    /**
	     * Adds aerodromes, selected
	     * from the multiselect, to a comma separated string
	     * @param  {Array<any>} selectedAerodromes
	     */
	    ReportGenerationController.prototype.addAerodromeToList = function (selectedAerodromes) {
	        var aerodromes = selectedAerodromes.map(function (aerodrome) { return aerodrome.aerodrome_name; });
	        this.$scope.aerodromesIds = aerodromes.join(',');
	        this.$scope.aerodromeIdsWithBrackets = aerodromes.length ? "{" + this.$scope.aerodromesIds + "}" : '';
	    };
	    ReportGenerationController.prototype.getFiscalYear = function () {
	        if (this.$scope.editable.fiscal_year) {
	            var fiscal = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.FIRST_DAY_OF_FISCAL_YEAR).replace('/', '-');
	            var year = new Date().getFullYear();
	            this.$scope.fiscalYear = year + "-" + fiscal;
	        }
	        else {
	            this.$scope.fiscalYear = null;
	        }
	    };
	    return ReportGenerationController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.ReportGenerationController = ReportGenerationController;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var AirTrafficDataController = (function (_super) {
	    __extends(AirTrafficDataController, _super);
	    /* @ngInject */
	    AirTrafficDataController.$inject = ["$scope", "airTrafficDataService", "aerodromesService", "aircraftTypeManagementService", "billingCentreManagementService", "accountsService", "mtowService", "flightMovementManagementService", "systemConfigurationService", "$filter", "dbqueryService", "$timeout", "customDate"];
	    function AirTrafficDataController($scope, airTrafficDataService, aerodromesService, aircraftTypeManagementService, billingCentreManagementService, accountsService, mtowService, flightMovementManagementService, systemConfigurationService, $filter, dbqueryService, $timeout, customDate) {
	        var _this = _super.call(this, $scope, airTrafficDataService) || this;
	        _this.$scope = $scope;
	        _this.airTrafficDataService = airTrafficDataService;
	        _this.aerodromesService = aerodromesService;
	        _this.aircraftTypeManagementService = aircraftTypeManagementService;
	        _this.billingCentreManagementService = billingCentreManagementService;
	        _this.accountsService = accountsService;
	        _this.mtowService = mtowService;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$filter = $filter;
	        _this.dbqueryService = dbqueryService;
	        _this.$timeout = $timeout;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(true);
	        // retrieve organization to show different reports
	        var organization = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION);
	        $scope[organization] = organization;
	        // configuration for MTOW Units (tons/kg)
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.$watchGroup(['editable.temporal_group', 'editable.group_by'], function () {
	            _this.createSortList();
	        });
	        $scope.cashAccounts = {};
	        $scope.cashAccounts.name = 'CASH ACCOUNTS';
	        $timeout(function () {
	            // add sortable to <ul>
	            $scope.newSortIndexes = [];
	            var mySort = document.getElementById('my-sort');
	            var sortable = function () {
	                return new Sortable(mySort, {
	                    onUpdate: function (evt) {
	                        // get new sort order based on indexes
	                        var newSortIndexes = [];
	                        var liElements = Array.from(mySort.getElementsByTagName('li'));
	                        for (var _i = 0, liElements_1 = liElements; _i < liElements_1.length; _i++) {
	                            var element = liElements_1[_i];
	                            newSortIndexes.push(element.getAttribute('data-index'));
	                        }
	                        $scope.newSortIndexes = newSortIndexes;
	                        $scope.sortList = _this.getSorted($scope.sortList, newSortIndexes);
	                        $scope.editable.sort = _this.getEditableSort($scope.sortList);
	                    }
	                });
	            };
	            sortable();
	        });
	        // services
	        billingCentreManagementService.listAll().then(function (billingCentres) { return $scope.billingCentresList = billingCentres.content; });
	        accountsService.findAllCreditMinimalReturn().then(function (account) { $scope.accountsList = account; $scope.accountsList.push($scope.cashAccounts); });
	        aerodromesService.listAll().then(function (aerodromes) { return $scope.aerodromesList = aerodromes.content; });
	        aircraftTypeManagementService.listAll().then(function (aircraftType) { return $scope.aircraftTypeList = aircraftType.content; });
	        mtowService.listAll().then(function (mtow) {
	            $scope.mtowListAll = mtow.content;
	            if (!$scope.KCAA) {
	                $scope.mtow_factor_class = 'DOMESTIC';
	                _this.showMTOWList($scope.mtow_factor_class);
	            }
	        });
	        $scope.showMTOWList = function (mtowFactorClass) { return _this.showMTOWList(mtowFactorClass); };
	        flightMovementManagementService.getDistinctRoutes().then(function (routes) {
	            $scope.routeList = [];
	            _this.setListForMultiselect($scope.routeList, routes, true);
	        });
	        flightMovementManagementService.getDistinctFlightLevels().then(function (flightlevels) {
	            $scope.flightLevelList = [];
	            _this.setListForMultiselect($scope.flightLevelList, flightlevels, false);
	        });
	        $scope.displayValues = _this.service.displayValues();
	        $scope.groupByValues = _this.service.groupByValues().sort(function (a, b) {
	            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
	            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
	            if (nameA < nameB) {
	                return -1;
	            }
	            if (nameA > nameB) {
	                return 1;
	            }
	            return 0; // names must be equal
	        });
	        if (!$scope.KCAA) {
	            $scope.groupByValues = $scope.groupByValues.filter(function (values) { return values.name !== 'Flight Level'; });
	        }
	        // default chart variables
	        $scope.datapoints = [];
	        $scope.datacolumns = [];
	        $scope.ylabel = [];
	        $scope.datax = { 'id': 'x' };
	        $scope.xlabel = "Air Traffic Data";
	        $scope.getEmptyModels = function () { return _this.getEmptyModels(); };
	        _this.getEmptyModels();
	        $scope.addGroupToList = function () {
	            _this.$scope.editable.group_by = _this.addToList(_this.$scope.groupByModel, 'value');
	        };
	        $scope.addBillingCentreToList = function () {
	            _this.$scope.editable.billing_centres = _this.addToList(_this.$scope.billingCentresModel, 'name');
	        };
	        $scope.addAccountToList = function () {
	            _this.$scope.editable.accounts = _this.addToList(_this.$scope.accountsModel, 'name');
	        };
	        $scope.addAerodromeToList = function () {
	            _this.$scope.editable.aerodromes = _this.addToList(_this.$scope.aerodromesModel, 'aerodrome_name');
	        };
	        $scope.addAircraftToList = function () {
	            _this.$scope.editable.aircraft_types = _this.addToList(_this.$scope.aircraftTypeModel, 'aircraft_type');
	        };
	        $scope.addMTOWToList = function () {
	            var mtowID = _this.addToList(_this.$scope.mtowModel, 'id');
	            var selectedMtow = [];
	            _this.$scope.editable.mtow_categories = null;
	            $scope.mtowListAll.forEach(function (element) {
	                if (mtowID !== null && mtowID.split(',').indexOf(element.id.toString()) > -1) {
	                    selectedMtow.push(element.upper_limit);
	                }
	            });
	            if (selectedMtow.length > 0) {
	                _this.$scope.editable.mtow_categories = selectedMtow.join(',');
	            }
	        };
	        $scope.addRouteToList = function () {
	            _this.$scope.editable.routes = _this.addToList(_this.$scope.routeModel, 'name');
	        };
	        $scope.addFlightLevelToList = function () {
	            _this.$scope.editable.flight_levels = _this.addToList(_this.$scope.flightLevelModel, 'name');
	        };
	        // functions
	        _this.getTemplateNames();
	        $scope.saveTemplate = function (name) { return _this.saveTemplate(name); };
	        $scope.deleteTemplate = function (name) { return _this.deleteTemplate(name); };
	        $scope.updateTemplate = function (name) { return _this.updateTemplate(name); };
	        $scope.selectTemplate = function (name) { return _this.selectTemplate(name); };
	        $scope.generate = function (airTrafficData, startDate, endDate, groupBy, chartType) {
	            return _this.generate(airTrafficData, startDate, endDate, groupBy, chartType)
	                .then(function (data) {
	                var selectedValue = _this.$scope.display_value;
	                var keyToCheck = selectedValue === 'revenue_category'
	                    ? _this.$scope.revenue_category
	                    : selectedValue;
	                var hasValidData = data.some(function (item) {
	                    var val = item[keyToCheck];
	                    return Array.isArray(val) ? val.length > 0 : !!val;
	                });
	                if (!hasValidData) {
	                    _this.$scope.noData = true;
	                }
	                else {
	                    _this.$scope.data = data; // reused if chart type changes
	                    _this.$scope.datapoints = _this.getDataPoints(_this.$scope.data);
	                    _this.$scope.datacolumns = _this.getColumnLabels(_this.$scope.data, _this.$scope.datapoints, airTrafficData.group_by, chartType);
	                    var contentDivWidth = document.getElementById("content").offsetWidth;
	                    //controllo il numero di elementi per impostare l'altezza del grafico
	                    if (_this.$scope.datacolumns.length <= 40) {
	                        _this.$scope.chartHeight = contentDivWidth * 0.3;
	                    }
	                    else {
	                        _this.$scope.chartHeight = contentDivWidth * 0.5;
	                    }
	                    _this.$scope.csvData = _this.createCSVdata(_this.$scope.datapoints);
	                    $scope.editable = airTrafficData;
	                }
	            })
	                .catch(function (error) {
	                _this.$scope.error = {};
	                _this.$scope.error.error = { data: error.data };
	            });
	        };
	        $scope.labelFormat = function (value) {
	            if (!_this.$scope.display_values) {
	                return null;
	            }
	            if (!value) {
	                return value;
	            }
	            if ($scope.display_value === 'sum_total_charges' || $scope.display_value === 'revenue_category') {
	                return '$' + value.toLocaleString();
	            }
	            else {
	                return value.toLocaleString();
	            }
	        };
	        $scope.valueFormat = function (value) {
	            return value.toFixed(2);
	        };
	        return _this;
	    }
	    AirTrafficDataController.prototype.setListForMultiselect = function (list, array, pairElement) {
	        var i = 0;
	        array.forEach(function (element) {
	            if (pairElement) {
	                var item = element[0] + "-" + element[1];
	                list.push({ id: i, name: item });
	            }
	            else {
	                list.push({ id: i, name: element });
	            }
	            i++;
	        });
	    };
	    AirTrafficDataController.prototype.showMTOWList = function (mtowFactorClass) {
	        var _this = this;
	        this.$scope.editable.mtow_categories = null;
	        if (mtowFactorClass !== '') {
	            this.$scope.mtowList = [];
	            this.$scope.mtowModel = [];
	            var list = angular.copy(this.$scope.mtowListAll);
	            list.forEach(function (element) {
	                if (element.factor_class === mtowFactorClass) {
	                    if (_this.$scope.mtowUnitOfMeasure === 'kg') {
	                        element.upper_limit = _this.$filter('number')(element.upper_limit * 907.185, 0); // us ton
	                    }
	                    else {
	                        element.upper_limit = _this.$filter('number')(element.upper_limit, 2);
	                    }
	                    _this.$scope.mtowList.push(element);
	                }
	            });
	        }
	        else {
	            this.$scope.mtow_factor_class = null;
	        }
	    };
	    AirTrafficDataController.prototype.getEmptyModels = function () {
	        // multi-selects
	        this.$scope.billingCentresModel = [];
	        this.$scope.accountsModel = [];
	        this.$scope.aerodromesModel = [];
	        this.$scope.aircraftTypeModel = [];
	        this.$scope.mtowModel = [];
	        this.$scope.routeModel = [];
	        this.$scope.flightLevelModel = [];
	        this.$scope.groupByModel = [];
	        this.$scope.sortList = [];
	        this.$scope.display_value = null;
	        this.$scope.revenue_category = null;
	        this.$scope.chartType = null;
	        this.$scope.mtow_factor_class = null;
	        // checkboxes
	        this.$scope.flight_type = null;
	        this.$scope.flight_scope = null;
	        this.$scope.flight_category = null;
	        this.$scope.flight_rules = null;
	        // editable
	        this.$scope.editable = this.airTrafficDataService.getModel();
	    };
	    AirTrafficDataController.prototype.addToList = function (model, prop) {
	        var items = null;
	        var neededProp = null;
	        if (model.length > 0) {
	            items = model.map(function (item) {
	                Object.getOwnPropertyNames(item).forEach(function (val, idx, array) {
	                    if (val === prop) {
	                        neededProp = item[val];
	                    }
	                });
	                return neededProp;
	            }).join(',');
	        }
	        return items;
	    };
	    AirTrafficDataController.prototype.createSortList = function () {
	        this.$scope.sortList = [];
	        var idNumber = 0;
	        var value;
	        if (this.$scope.editable.temporal_group) {
	            this.$scope.sortList.push({ id: idNumber, name: 'Temporal Group', value: 'date' });
	            idNumber++;
	        }
	        if (this.$scope.editable.group_by) {
	            for (var _i = 0, _a = this.$scope.editable.group_by.split(','); _i < _a.length; _i++) {
	                var item = _a[_i];
	                value = item;
	                if (item.includes('mtow')) {
	                    item = 'MTOW Category';
	                }
	                if (item.includes('aerodromes')) {
	                    item = 'Aerodromes';
	                }
	                this.$scope.sortList.push({ id: idNumber, name: this.toUpperCase(item.replace(/_/g, ' ')).trim(), value: value });
	                idNumber++;
	            }
	        }
	        this.$scope.editable.sort = this.getEditableSort(this.$scope.sortList);
	    };
	    AirTrafficDataController.prototype.toUpperCase = function (str) {
	        var splitStr = str.split(' ');
	        for (var i = 0; i < splitStr.length; i++) {
	            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
	        }
	        return splitStr.join(' ');
	    };
	    AirTrafficDataController.prototype.getDataPoints = function (data) {
	        var yaxis = this.$scope.display_value === 'revenue_category' ? this.$scope.revenue_category : this.$scope.display_value; // value to compare data against
	        if (this.$scope.chartType === 'pie')
	            return this.dbqueryService.formatDataPointsForPie(data, yaxis, this.$scope.sortList);
	        else
	            return this.dbqueryService.getDataPoints(data, yaxis, this.$scope.sortList);
	    };
	    AirTrafficDataController.prototype.getColumnLabels = function (data, dataPoints, labelKey, chartType) {
	        return this.dbqueryService.getColumnsLabels(data, dataPoints, labelKey, chartType); // sets up column labels
	    };
	    /**
	     * Turns field arrays into comma separated
	     * strings that are used with the dbquery IN
	     * clause
	     *
	     * @param  {IAirTrafficData} airTrafficData
	     * @param  {string} startDate
	     * @param  {string} endDate
	     * @param  {string} groupBy
	     * @returns IPromise<IAirTrafficResponse[]>
	     */
	    AirTrafficDataController.prototype.generate = function (airTrafficData, startDate, endDate, groupBy, chartType) {
	        var _this = this;
	        this.$scope.noData = false;
	        this.$scope.ylabel = this.$scope.displayValues.find(function (x) { return x.value === _this.$scope.display_value; }).name;
	        var obj = angular.copy(airTrafficData);
	        if (startDate && endDate) {
	            obj.start_date = startDate.toISOString().substr(0, 10); // must send in format yyyy-mm-dd
	            obj.end_date = endDate.toISOString().substr(0, 10);
	        }
	        this.filterArray(obj);
	        if (groupBy !== null) {
	            obj[groupBy] = true;
	        }
	        return this.airTrafficDataService.query(obj);
	    };
	    // filter out all bad values
	    AirTrafficDataController.prototype.filterArray = function (obj) {
	        // filters out values that are null or undefined
	        function hasValue(val) {
	            return val && val !== null;
	        }
	        for (var _i = 0, _a = ['flight_rules', 'flight_types', 'flight_scopes', 'flight_categories']; _i < _a.length; _i++) {
	            var field = _a[_i];
	            var arr = this.$scope.editable[field].filter(hasValue);
	            obj[field] = arr.length > 0 ? arr.toString() : null; // creates a comma delimited string || null
	        }
	    };
	    // sort by indexes
	    AirTrafficDataController.prototype.getSorted = function (arr, sortArr) {
	        var result = [];
	        for (var i = 0; i < arr.length; i++) {
	            result[i] = arr[sortArr[i]];
	        }
	        return result;
	    };
	    AirTrafficDataController.prototype.getEditableSort = function (arr) {
	        var array = [];
	        arr.forEach(function (item) {
	            array.push(item.name);
	        });
	        return array.join(',');
	    };
	    // template
	    AirTrafficDataController.prototype.collectDataForTemplate = function (name) {
	        var template = angular.copy(this.$scope.editable);
	        this.filterArray(template);
	        template.name = name;
	        template.value = this.$scope.display_value;
	        template.revenue_category = this.$scope.revenue_category;
	        template.chart_type = this.$scope.chartType;
	        template.mtow_factor_class = this.$scope.mtow_factor_class;
	        return template;
	    };
	    AirTrafficDataController.prototype.saveTemplate = function (name) {
	        var _this = this;
	        var template = this.collectDataForTemplate(name);
	        this.airTrafficDataService.createTemplate(template).then(function () { _this.getTemplateNames(); _this.getEmptyModels(); })
	            .catch(function (error) {
	            _this.$scope.error = {};
	            _this.$scope.error.error = { data: error.data };
	        });
	    };
	    AirTrafficDataController.prototype.updateTemplate = function (name) {
	        var _this = this;
	        var template = this.collectDataForTemplate(name);
	        this.airTrafficDataService.getTemplateByName(name).then(function (data) {
	            template.id = data.id;
	            _this.airTrafficDataService.updateTemplate(template, template.id).then(function () { return _this.selectTemplate(name); })
	                .catch(function (error) {
	                _this.$scope.error = {};
	                _this.$scope.error.error = { data: error.data };
	            });
	        });
	    };
	    AirTrafficDataController.prototype.deleteTemplate = function (name) {
	        var _this = this;
	        this.airTrafficDataService.getTemplateByName(name).then(function (template) {
	            _this.airTrafficDataService.deleteTemplate(template.id).then(function () { return _this.getTemplateNames(); })
	                .catch(function (error) {
	                _this.$scope.error = {};
	                _this.$scope.error.error = { data: error.data };
	            });
	        });
	    };
	    // return template names
	    AirTrafficDataController.prototype.getTemplateNames = function () {
	        var _this = this;
	        this.airTrafficDataService.getAllNames().then(function (names) { return _this.$scope.templatesList = names; });
	    };
	    // populate the form
	    AirTrafficDataController.prototype.selectTemplate = function (name) {
	        var _this = this;
	        this.getEmptyModels();
	        if (name) {
	            this.airTrafficDataService.getTemplateByName(name).then(function (template) {
	                _this.setModelFromTemplate(_this.$scope.billingCentresList, template.billing_centres, _this.$scope.billingCentresModel, 'name', 'billing_centres');
	                _this.setModelFromTemplate(_this.$scope.accountsList, template.accounts, _this.$scope.accountsModel, 'name', 'accounts');
	                _this.setModelFromTemplate(_this.$scope.aerodromesList, template.aerodromes, _this.$scope.aerodromesModel, 'aerodrome_name', 'aerodromes');
	                _this.setModelFromTemplate(_this.$scope.aircraftTypeList, template.aircraft_types, _this.$scope.aircraftTypeModel, 'aircraft_type', 'aircraft_types');
	                _this.setModelFromTemplate(_this.$scope.routeList, template.routes, _this.$scope.routeModel, 'name', 'routes');
	                _this.setModelFromTemplate(_this.$scope.flightLevelList, template.flight_levels, _this.$scope.flightLevelModel, 'name', 'flight_levels');
	                _this.setModelFromTemplate(_this.$scope.groupByValues, template.group_by, _this.$scope.groupByModel, 'value', 'group_by');
	                _this.$scope.mtow_factor_class = template.mtow_factor_class;
	                _this.$scope.showMTOWList(_this.$scope.mtow_factor_class);
	                var mtowID = [];
	                _this.$scope.mtowListAll.forEach(function (element) {
	                    if (element.factor_class === _this.$scope.mtow_factor_class) {
	                        if (template.mtow_categories !== null && template.mtow_categories.includes(element.upper_limit.toString())) {
	                            mtowID.push(element.id);
	                        }
	                    }
	                });
	                _this.setModelFromTemplate(_this.$scope.mtowList, mtowID, _this.$scope.mtowModel, 'id', null);
	                _this.$scope.editable.mtow_categories = template.mtow_categories;
	                _this.$scope.display_value = template.value;
	                _this.$scope.revenue_category = template.revenue_category;
	                _this.$scope.chartType = template.chart_type;
	                _this.$scope.editable.temporal_group = template.temporal_group;
	                _this.$scope.editable.fiscal_year = template.fiscal_year;
	                _this.$timeout(function () {
	                    _this.$scope.sortList = [];
	                    _this.$scope.editable.sort = null;
	                    if (template.sort) {
	                        var sort = template.sort.split(',');
	                        var idNumber_1 = 0;
	                        sort.forEach(function (element) {
	                            idNumber_1++;
	                            var value;
	                            if (element === 'Temporal Group') {
	                                value = 'date';
	                            }
	                            else {
	                                var existingGroupByValue = _this.$scope.groupByValues.find(function (item) { return item.value === element.replace(/ /g, '_').toLowerCase(); });
	                                value = existingGroupByValue ? existingGroupByValue.value : null;
	                            }
	                            _this.$scope.sortList.push({ id: idNumber_1, name: element, value: value });
	                        });
	                        _this.$scope.editable.sort = _this.getEditableSort(_this.$scope.sortList);
	                    }
	                });
	                _this.setCheckBoxFromTemplate('flight_types', template.flight_types, 'flight_type', 'DEPARTURE', 'ARRIVAL', 'OVERFLIGHT');
	                _this.setCheckBoxFromTemplate('flight_scopes', template.flight_scopes, 'flight_scope', 'DOMESTIC', 'REGIONAL', 'INTERNATIONAL');
	                _this.setCheckBoxFromTemplate('flight_categories', template.flight_categories, 'flight_category', 'SCH', 'NONSCH', null);
	                _this.setCheckBoxFromTemplate('flight_rules', template.flight_rules, 'flight_rules', 'I', 'V', null);
	            });
	        }
	    };
	    AirTrafficDataController.prototype.setModelFromTemplate = function (list, template, model, prop, item) {
	        var _this = this;
	        if (template) {
	            list.forEach(function (element) {
	                var neededProp = null;
	                Object.getOwnPropertyNames(element).forEach(function (val, idx, array) {
	                    if (!(val === prop)) {
	                        return;
	                    }
	                    neededProp = element[val];
	                    if (typeof (template) === 'object') {
	                        if (template.includes(neededProp)) {
	                            model.push(element);
	                        }
	                    }
	                    else {
	                        if (template.split(',').includes(neededProp)) {
	                            model.push(element);
	                        }
	                        _this.$scope.editable[item] = template;
	                    }
	                });
	            });
	        }
	    };
	    AirTrafficDataController.prototype.setCheckBoxFromTemplate = function (editable, template, checkBox, index0, index1, index2) {
	        if (template) {
	            this.$scope[checkBox] = true;
	            if (template.includes(index0) && template.indexOf(index0, 0) === 0) {
	                this.$scope.editable[editable][0] = index0;
	            }
	            else {
	                this.$scope.editable[editable][0] = null;
	            }
	            if (template.includes(index1)) {
	                this.$scope.editable[editable][1] = index1;
	            }
	            else {
	                this.$scope.editable[editable][1] = null;
	            }
	            if (index2) {
	                if (template.includes(index2)) {
	                    this.$scope.editable[editable][2] = index2;
	                }
	                else {
	                    this.$scope.editable[editable][2] = null;
	                }
	            }
	        }
	    };
	    AirTrafficDataController.prototype.createCSVdata = function (data) {
	        var headers = data.map(function (entry) {
	            return Object.keys(entry);
	        }).reduce(function (accumulator, currentValue) {
	            if (!Object.keys(accumulator).length) {
	                var key = 'x';
	                accumulator[key] = 'Date';
	            }
	            currentValue.map(function (value) {
	                if (!accumulator[value] && value !== 'x') {
	                    accumulator[value] = value;
	                }
	            });
	            return accumulator;
	        }, {});
	        var csvData = [headers];
	        data.forEach(function (item) {
	            var row = {};
	            Object.keys(headers).forEach(function (key) { return row[key] = item[key] || 0; });
	            csvData.push(row);
	        });
	        return csvData;
	    };
	    return AirTrafficDataController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AirTrafficDataController = AirTrafficDataController;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var ReportTemplatesController = (function (_super) {
	    __extends(ReportTemplatesController, _super);
	    /* @ngInject */
	    ReportTemplatesController.$inject = ["$scope", "reportTemplatesService", "$uibModal"];
	    function ReportTemplatesController($scope, reportTemplatesService, $uibModal) {
	        var _this = _super.call(this, $scope, reportTemplatesService, $uibModal) || this;
	        _this.$scope = $scope;
	        _this.reportTemplatesService = reportTemplatesService;
	        _this.$uibModal = $uibModal;
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        return _this;
	    }
	    ReportTemplatesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    ReportTemplatesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return ReportTemplatesController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.ReportTemplatesController = ReportTemplatesController;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var RepositioningAerodromeClustersController = (function (_super) {
	    __extends(RepositioningAerodromeClustersController, _super);
	    /* @ngInject */
	    RepositioningAerodromeClustersController.$inject = ["$scope", "$rootScope", "unspecifiedDepDestLocationsService", "repositioningAerodromeClustersService", "aerodromesService", "systemConfigurationService"];
	    function RepositioningAerodromeClustersController($scope, $rootScope, unspecifiedDepDestLocationsService, repositioningAerodromeClustersService, aerodromesService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, repositioningAerodromeClustersService) || this;
	        _this.$scope = $scope;
	        _this.unspecifiedDepDestLocationsService = unspecifiedDepDestLocationsService;
	        _this.repositioningAerodromeClustersService = repositioningAerodromeClustersService;
	        _this.aerodromesService = aerodromesService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        _this.getFilterParameters();
	        aerodromesService.listAll().then(function (aerodromes) { return $scope.aerodromesList = aerodromes.content; });
	        unspecifiedDepDestLocationsService.listAll().then(function (aerodromes) { return $scope.unknownAerodromesList = aerodromes.content; });
	        $scope.createOverride = function (clust) { return _this.createOverride(clust); };
	        $scope.updateOverride = function (clust, id) { return _this.updateOverride(clust, id); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.reset = function () { return _this.reset(); };
	        _this.$scope.unknownAerodromesModel = [];
	        _this.$scope.aerodromesModel = [];
	        $scope.populateDropdowns = function () { return _this.populateDropdowns(); };
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    RepositioningAerodromeClustersController.prototype.createOverride = function (clust) {
	        _super.prototype.create.call(this, this.getAllAerodromeIdentifiers(clust));
	    };
	    RepositioningAerodromeClustersController.prototype.updateOverride = function (clust, id) {
	        _super.prototype.update.call(this, this.getAllAerodromeIdentifiers(clust), id);
	    };
	    RepositioningAerodromeClustersController.prototype.reset = function () {
	        this.$scope.unknownAerodromesModel = [];
	        this.$scope.aerodromesModel = [];
	        this.$scope.enteredAerodromes = null;
	        _super.prototype.reset.call(this);
	    };
	    RepositioningAerodromeClustersController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    RepositioningAerodromeClustersController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    RepositioningAerodromeClustersController.prototype.populateDropdowns = function () {
	        var knowns = [];
	        var unknowns = [];
	        var typed = [];
	        for (var _i = 0, _a = this.$scope.aerodromesList; _i < _a.length; _i++) {
	            var aerodrome = _a[_i];
	            for (var _b = 0, _c = this.$scope.editable.aerodrome_identifiers; _b < _c.length; _b++) {
	                var editedAerodrome = _c[_b];
	                if (aerodrome.aerodrome_name === editedAerodrome) {
	                    typed.push(editedAerodrome);
	                    knowns.push(aerodrome);
	                }
	            }
	        }
	        for (var _d = 0, _e = this.$scope.unknownAerodromesList; _d < _e.length; _d++) {
	            var aerodrome = _e[_d];
	            for (var _f = 0, _g = this.$scope.editable.aerodrome_identifiers; _f < _g.length; _f++) {
	                var editedAerodrome = _g[_f];
	                if (aerodrome.text_identifier === editedAerodrome) {
	                    typed.push(editedAerodrome);
	                    unknowns.push(aerodrome);
	                }
	            }
	        }
	        this.$scope.enteredAerodromes = this.$scope.editable.aerodrome_identifiers.filter(function (x) { return typed.indexOf(x) === -1; }); // aerodromes not in dropdowns will be added to the 'enter aerodrome' input field
	        this.$scope.unknownAerodromesModel = unknowns;
	        this.$scope.aerodromesModel = knowns;
	    };
	    RepositioningAerodromeClustersController.prototype.getAllAerodromeIdentifiers = function (clust) {
	        var aerodromesSet = new Set(''); // using a set to keep aerodromes unique
	        if (typeof this.$scope.enteredAerodromes === 'string') {
	            aerodromesSet = new Set(this.$scope.enteredAerodromes.split(/[ ,]+/));
	        }
	        else {
	            aerodromesSet = new Set(this.$scope.enteredAerodromes);
	        }
	        this.$scope.aerodromesModel.forEach(function (v) { return aerodromesSet.add(v.aerodrome_name); }); // add identifiers from aerodromes to set
	        this.$scope.unknownAerodromesModel.forEach(function (v) { return aerodromesSet.add(v.text_identifier); }); // add identifiers from unknown aerodromes to set
	        var aerodromesArray = Array.from(aerodromesSet);
	        clust.aerodrome_identifiers = aerodromesArray.filter(Boolean); // remove any manually typed then deleted aerodromes, otherwise it will send ""
	        return clust;
	    };
	    return RepositioningAerodromeClustersController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.RepositioningAerodromeClustersController = RepositioningAerodromeClustersController;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_controller_1 = __webpack_require__(4);
	var SystemSummaryController = (function (_super) {
	    __extends(SystemSummaryController, _super);
	    /* @ngInject */
	    SystemSummaryController.$inject = ["$scope", "systemSummaryService", "systemConfigurationService"];
	    function SystemSummaryController($scope, systemSummaryService, systemConfigurationService) {
	        var _this = _super.call(this, systemSummaryService) || this;
	        _this.$scope = $scope;
	        _this.systemSummaryService = systemSummaryService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.setup();
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.formatName = function (name) {
	            if (name) {
	                return name.replace(/_/g, ' ').toLocaleLowerCase();
	            }
	            return;
	        };
	        return _this;
	    }
	    SystemSummaryController.prototype.list = function () {
	        var _this = this;
	        return _super.prototype.list.call(this).then(function (data) {
	            _this.$scope.data = data;
	            _this.$scope.list = Object.keys(data).map(function (k) { return data[k]; });
	        });
	    };
	    return SystemSummaryController;
	}(crud_form_controller_1.CRUDFormController));
	exports.SystemSummaryController = SystemSummaryController;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var TowerMovementLogsController = (function (_super) {
	    __extends(TowerMovementLogsController, _super);
	    /* @ngInject */
	    TowerMovementLogsController.$inject = ["$scope", "$rootScope", "towerMovementLogsService", "aircraftRegistrationService", "$uibModal", "customDate", "saveLocalTemplateService"];
	    function TowerMovementLogsController($scope, $rootScope, towerMovementLogsService, aircraftRegistrationService, $uibModal, customDate, saveLocalTemplateService) {
	        var _this = _super.call(this, $scope, towerMovementLogsService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.towerMovementLogsService = towerMovementLogsService;
	        _this.aircraftRegistrationService = aircraftRegistrationService;
	        _this.$uibModal = $uibModal;
	        _this.customDate = customDate;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.$watchGroup(['search', 'control'], function () { return _this.getFilterParameters(); });
	        $scope.flightCategories = _this.service.listFlightCategories();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.matchCategoryToCategoryListValue = function (category) { return _this.service.listFlightCategories().find(function (item) { return item.value === category; }).name; };
	        _this.saveLocalTemplate();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        $scope.resolveAircraftType = function (regNum, dateOfContact) { return _this.resolveAircraftType(regNum, dateOfContact); };
	        return _this;
	    }
	    TowerMovementLogsController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search']];
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'tower-movement-logs', filterPairs);
	    };
	    TowerMovementLogsController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'start': startDate,
	            'end': endDate,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Calls list with applied filters
	     *
	     * @returns void
	     */
	    TowerMovementLogsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    /**
	     * Find aircraft type by registration number and date of contact.
	     *
	     * @param regNum registration number for movement log
	     * @param dateOfContact date of contact for movement log
	     */
	    TowerMovementLogsController.prototype.resolveAircraftType = function (regNum, dateOfContact) {
	        var _this = this;
	        this.aircraftRegistrationService.getAircraftType(regNum, dateOfContact)
	            .then(function (aircraftType) {
	            if (aircraftType) {
	                _this.$scope.editable.aircraft_type = aircraftType.aircraft_type;
	            }
	        });
	    };
	    return TowerMovementLogsController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.TowerMovementLogsController = TowerMovementLogsController;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var system_configuration_constants_1 = __webpack_require__(10);
	var organization_constants_1 = __webpack_require__(57);
	var AtcMovementLogController = (function (_super) {
	    __extends(AtcMovementLogController, _super);
	    /* @ngInject */
	    AtcMovementLogController.$inject = ["$scope", "$rootScope", "atcMovementLogService", "aircraftRegistrationService", "$uibModal", "saveLocalTemplateService", "customDate", "systemConfigurationService"];
	    function AtcMovementLogController($scope, $rootScope, atcMovementLogService, aircraftRegistrationService, $uibModal, saveLocalTemplateService, customDate, systemConfigurationService) {
	        var _this = _super.call(this, $scope, atcMovementLogService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.atcMovementLogService = atcMovementLogService;
	        _this.aircraftRegistrationService = aircraftRegistrationService;
	        _this.$uibModal = $uibModal;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _this.customDate = customDate;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.isEANS = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANS;
	        $scope.pattern = '.csv,.lst';
	        $scope.flightTypes = _this.service.listFlightTypes();
	        $scope.flightCategories = _this.service.listFlightCategories();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        _this.saveLocalTemplate();
	        $scope.$watchGroup(['search', 'control'], function () { return _this.getFilterParameters(); });
	        $scope.resolveAircraftType = function (regNum, dateOfContact) { return _this.resolveAircraftType(regNum, dateOfContact); };
	        return _this;
	    }
	    AtcMovementLogController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search']];
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'atc-movement-log', filterPairs);
	    };
	    AtcMovementLogController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'start': startDate,
	            'end': endDate,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Calls list with applied filters
	     *
	     * @returns void
	     */
	    AtcMovementLogController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    /**
	     * Find aircraft type by registration number and date of contact.
	     *
	     * @param regNum registration number for movement log
	     * @param dateOfContact date of contact for movement log
	     */
	    AtcMovementLogController.prototype.resolveAircraftType = function (regNum, dateOfContact) {
	        var _this = this;
	        this.aircraftRegistrationService.getAircraftType(regNum, dateOfContact)
	            .then(function (aircraftType) {
	            if (aircraftType) {
	                _this.$scope.editable.aircraft_type = aircraftType.aircraft_type;
	            }
	        });
	    };
	    return AtcMovementLogController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.AtcMovementLogController = AtcMovementLogController;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var OrganizationName;
	(function (OrganizationName) {
	    OrganizationName[OrganizationName["CAAB"] = 'CAAB'] = "CAAB";
	    OrganizationName[OrganizationName["DC_ANSP"] = 'DC_ANSP'] = "DC_ANSP";
	    OrganizationName[OrganizationName["EANA"] = 'EANA'] = "EANA";
	    OrganizationName[OrganizationName["INAC"] = 'INAC'] = "INAC";
	    OrganizationName[OrganizationName["KCAA"] = 'KCAA'] = "KCAA";
	    OrganizationName[OrganizationName["ZACL"] = 'ZACL'] = "ZACL";
	    OrganizationName[OrganizationName["TTCAA"] = 'TTCAA'] = "TTCAA";
	    OrganizationName[OrganizationName["EANS"] = 'EANS'] = "EANS";
	})(OrganizationName = exports.OrganizationName || (exports.OrganizationName = {}));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var BillingCentreManagementController = (function (_super) {
	    __extends(BillingCentreManagementController, _super);
	    /* @ngInject */
	    BillingCentreManagementController.$inject = ["$scope", "$rootScope", "billingCentreManagementService", "systemConfigurationService"];
	    function BillingCentreManagementController($scope, $rootScope, billingCentreManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, billingCentreManagementService) || this;
	        _this.$scope = $scope;
	        _this.billingCentreManagementService = billingCentreManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        billingCentreManagementService.listAll().then(function (data) { return $scope.hqIsSet = _this.isHeadquarterSet(data.content); }); // finds out if there is currently an hq
	        $scope.checkHq = function (editable) { return billingCentreManagementService.listAll().then(function (data) {
	            $scope.hqIsSet = _this.isHeadquarterSet(data.content);
	            _this.checkHq(editable);
	        }); };
	        $scope.edit = function (editable) {
	            _super.prototype.edit.call(_this, editable);
	            $scope.original = angular.copy(editable);
	            $scope.checkHq($scope.original);
	        };
	        // set scope value for require external system identifier
	        $scope.requireExternalSystemId = _this.requireExternalSystemId();
	        $scope.iataInvoiceSeparatedSeqNumber = _this.iataInvoiceSeparatedSeqNumber();
	        $scope.receiptSeqNumberByPayMechanism = _this.receiptSeqNumberByPayMechanism();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    BillingCentreManagementController.prototype.isBillingCentre = function (centre) {
	        return centre.id !== undefined; // this typeguard is used for validation below
	    };
	    BillingCentreManagementController.prototype.isHeadquarterSet = function (billingCentres) {
	        for (var _i = 0, billingCentres_1 = billingCentres; _i < billingCentres_1.length; _i++) {
	            var centre = billingCentres_1[_i];
	            if (centre.hq) {
	                return centre;
	            }
	        }
	        return false;
	    };
	    BillingCentreManagementController.prototype.checkHq = function (centre) {
	        this.$scope.updateWarning = null;
	        this.$scope.createWarning = null;
	        this.$scope.deleteWarning = null;
	        if ((this.$scope.hqIsSet && centre.hq && this.$scope.original && this.isBillingCentre(this.$scope.hqIsSet) && this.$scope.original.id !== this.$scope.hqIsSet.id) ||
	            (!this.$scope.original && centre.id === null && centre.hq) ||
	            (this.$scope.original && !this.$scope.hqIsSet && centre.hq)) {
	            this.$scope.updateWarning = 'The billing centre headquarters designation is being changed to this centre.';
	        }
	        if (!this.$scope.hqIsSet && !centre.hq) {
	            this.$scope.createWarning = 'A billing centre headquarter is not defined.';
	        }
	        if (this.$scope.hqIsSet && this.$scope.original && this.isBillingCentre(this.$scope.hqIsSet) && this.$scope.original.id === this.$scope.hqIsSet.id) {
	            this.$scope.deleteWarning = 'Are you sure you want to delete the headquarters billing centre?';
	        }
	        if (this.$scope.hqIsSet && this.$scope.original && this.isBillingCentre(this.$scope.hqIsSet) && this.$scope.original.id === this.$scope.hqIsSet.id && !centre.hq) {
	            this.$scope.updateWarning = 'Are you sure you want change this centre so that it is no longer headquarters?';
	        }
	    };
	    /**
	     * Get required external system id flag from system configuration.
	     *
	     * @returns boolean true if required
	     */
	    BillingCentreManagementController.prototype.requireExternalSystemId = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_BILLING_CENTRE_EXTERNAL_SYSTEM_ID);
	    };
	    /**
	     * Get IATA Invoice sequence number flag from system configuration.
	     *
	     * @returns boolean true if required
	     */
	    BillingCentreManagementController.prototype.iataInvoiceSeparatedSeqNumber = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.USE_ADDITIONAL_INVOICES_NUMBER);
	    };
	    /**
	     * Get flag from system configuration to use or not receipts sequence number by payment mechanism .
	     *
	     * @returns boolean true if required
	     */
	    BillingCentreManagementController.prototype.receiptSeqNumberByPayMechanism = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.USE_RECEIPT_NUMBER_BY_PAYMENT_MECHANISM);
	    };
	    BillingCentreManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    BillingCentreManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return BillingCentreManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.BillingCentreManagementController = BillingCentreManagementController;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var aerodromes_constants_1 = __webpack_require__(60);
	// classes
	var convertCoordinates_class_1 = __webpack_require__(61);
	var UnspecifiedDepDestLocationsController = (function (_super) {
	    __extends(UnspecifiedDepDestLocationsController, _super);
	    /* @ngInject */
	    UnspecifiedDepDestLocationsController.$inject = ["$scope", "$rootScope", "unspecifiedDepDestLocationsService", "systemConfigurationService", "$filter", "$translate"];
	    function UnspecifiedDepDestLocationsController($scope, $rootScope, unspecifiedDepDestLocationsService, systemConfigurationService, $filter, $translate) {
	        var _this = 
	        // define and setup super class
	        _super.call(this, $scope, unspecifiedDepDestLocationsService) || this;
	        _this.$scope = $scope;
	        _this.unspecifiedDepDestLocationsService = unspecifiedDepDestLocationsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$filter = $filter;
	        _super.prototype.setup.call(_this);
	        $scope.country = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_COUNTRY_CODE);
	        // expose necessary method to scope
	        $scope.edit = function (editable) { return _this.editOverride(editable); };
	        $scope.refresh = function () { return _this.refresh(); };
	        $scope.reset = function () { return _this.reset(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // translate
	        $scope.booleanList = [
	            { n: $translate.instant('True'), v: true },
	            { n: $translate.instant('False'), v: false }
	        ];
	        // formats: DD.dddd or DD°MM′SS″L or DD MM SS L
	        $scope.latitudeRegex = aerodromes_constants_1.CoordinateValidation.LATREGEX;
	        $scope.longitudeRegex = aerodromes_constants_1.CoordinateValidation.LONREGEX;
	        // get the current coordinate formant from system configurations
	        $scope.format = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.COORDINATE_FORMAT);
	        // setup functions to get the lat/lon label
	        $scope.getLatLabel = function () { return _this.getLatLabel(); };
	        $scope.getLonLabel = function () { return _this.getLonLabel(); };
	        return _this;
	    }
	    UnspecifiedDepDestLocationsController.prototype.reset = function () {
	        _super.prototype.reset.call(this);
	        this.$scope.editable.country_code = this.$scope.defaultCounty;
	    };
	    /**
	     * This will add appropriate filters from scope
	     * for parent refresh parameters.
	     */
	    UnspecifiedDepDestLocationsController.prototype.refresh = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    UnspecifiedDepDestLocationsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * This will display the coordinates in the form as
	     * Degrees-Minutes-Seconds, provided the system
	     * is configured to DMS
	     *
	     * @param  {IUnspecifiedDepartureLocationType} editable
	     * @returns void
	     */
	    UnspecifiedDepDestLocationsController.prototype.editOverride = function (editable) {
	        var coordinates = new convertCoordinates_class_1.Coordinates();
	        var editableCopy = angular.copy(editable);
	        if (this.$scope.format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS) {
	            editableCopy.latitude = coordinates.toLat(editableCopy.latitude, 'dms', 0);
	            editableCopy.longitude = coordinates.toLon(editableCopy.longitude, 'dms', 0);
	        }
	        else {
	            // else display lon / lat
	            // with 5 decimal points
	            editableCopy.latitude = this.$filter('number')(editableCopy.latitude, 5);
	            editableCopy.longitude = this.$filter('number')(editableCopy.longitude, 5);
	        }
	        _super.prototype.edit.call(this, editableCopy);
	    };
	    // return the latitude label,
	    // based on the coordinate format
	    UnspecifiedDepDestLocationsController.prototype.getLatLabel = function () {
	        return this.$scope.format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS ?
	            aerodromes_constants_1.CoordinateLabels.DMSLAT : aerodromes_constants_1.CoordinateLabels.DECIMALLAT;
	    };
	    // return the longitude label,
	    // based on the coordinate formant
	    UnspecifiedDepDestLocationsController.prototype.getLonLabel = function () {
	        return this.$scope.format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS ?
	            aerodromes_constants_1.CoordinateLabels.DMSLON : aerodromes_constants_1.CoordinateLabels.DECIMALLON;
	    };
	    return UnspecifiedDepDestLocationsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.UnspecifiedDepDestLocationsController = UnspecifiedDepDestLocationsController;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CoordinateLabels;
	(function (CoordinateLabels) {
	    CoordinateLabels[CoordinateLabels["DECIMALLAT"] = '[-]DD.ddddd'] = "DECIMALLAT";
	    CoordinateLabels[CoordinateLabels["DECIMALLON"] = '[-]DDD.ddddd'] = "DECIMALLON";
	    CoordinateLabels[CoordinateLabels["DMSLAT"] = 'DD MM SS[N|S]'] = "DMSLAT";
	    CoordinateLabels[CoordinateLabels["DMSLON"] = 'DDD MM SS[E|W]'] = "DMSLON";
	})(CoordinateLabels = exports.CoordinateLabels || (exports.CoordinateLabels = {}));
	var CoordinateValidation;
	(function (CoordinateValidation) {
	    CoordinateValidation[CoordinateValidation["LATREGEX"] = /(^[-0-9]{0,3})+(\.[0-9]{0,5})$|^([0-9]{2,3}(°|\s))([0-9]{2}(′|\'|\s))([0-9]{2}(″|\")?)(\.[0-9]{1,2})?(N|S)$/] = "LATREGEX";
	    CoordinateValidation[CoordinateValidation["LONREGEX"] = /(^[-0-9]{0,3})+(\.[0-9]{0,5})$|^([0-9]{3}(°|\s)?)([0-9]{2}(′|\'|\s)?)([0-9]{2}(″|\")?)(\.[0-9]{1,2})?(E|W)$/] = "LONREGEX";
	})(CoordinateValidation = exports.CoordinateValidation || (exports.CoordinateValidation = {}));


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
	/* This class contains methods used to convert lat/long coordinates between decimal degrees and   */
	/* degrees-minutes-seconds formats. (DDD.dddd or DDD MM SS). Most of the funtionality was found   */
	/* from the MIT Licenced link below.                                                              */
	/*                                                                                                */
	/* www.movable-type.co.uk/scripts/latlong.html                                                    */
	/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
	Object.defineProperty(exports, "__esModule", { value: true });
	var Coordinates = (function () {
	    function Coordinates() {
	        /**
	         * Separator character to be used to separate degrees, minutes, seconds
	         */
	        this.separator = '';
	    }
	    /**
	     * Parses string representing degrees/minutes/seconds into numeric degrees.
	     *
	     * This is very flexible on formats, allowing signed decimal degrees, or deg-min-sec optionally
	     * suffixed by compass direction (NSEW). A variety of separators are accepted (eg 3° 37′ 09″W).
	     * Seconds and minutes may be omitted.
	     *
	     * @param   {string|number} dmsStr - Degrees or deg/min/sec in variety of formats.
	     * @returns {number} Degrees as decimal number.
	     *
	     * @example
	     *     let lat = Dms.parseDMS('51° 28′ 40.12″ N');
	     *     let lon = Dms.parseDMS('000° 00′ 05.31″ W');
	     *     let p1 = new LatLon(lat, lon); // 51.4778°N, 000.0015°W
	     */
	    Coordinates.prototype.parseDMS = function (dmsStr) {
	        // check for signed decimal degrees without NSEW, if so return it directly
	        if (typeof dmsStr === 'number' && isFinite(dmsStr)) {
	            return Number(dmsStr);
	        }
	        ;
	        // find the number of spaces in the string
	        var numberOfSpaces = (dmsStr.match(/ /g) || []).length;
	        // if only one space, the user has entered
	        // an invalid format and we remove it for the
	        // the subsequent algorithms
	        if (numberOfSpaces === 1) {
	            dmsStr = dmsStr.replace(' ', '');
	        }
	        // if DMS without spaces, add them to the correct
	        // indexes to make DDD MM SS. Currently, only 
	        // longitute is allowed without spaces.
	        if (/^([0-9]{7})/.test(dmsStr)) {
	            // split all chars
	            var splitDMS = dmsStr.split('');
	            // insert spaces at 3 and 6
	            splitDMS.splice(3, 0, ' ');
	            splitDMS.splice(6, 0, ' ');
	            // join chars back to string
	            dmsStr = splitDMS.join('');
	        }
	        // strip off any sign or compass dir'n & split out separate d/m/s
	        var dms = String(dmsStr).trim().replace(/^-/, '').replace(/[NSEW]$/i, '').split(/[^0-9.,]+/);
	        if (dms[dms.length - 1] === '') {
	            dms.splice(dms.length - 1);
	        }
	        ; // from trailing symbol
	        if (dms === '') {
	            return NaN;
	        }
	        ;
	        // and convert to decimal degrees
	        var deg;
	        switch (dms.length) {
	            case 3:
	                deg = dms[0] / 1 + dms[1] / 60 + dms[2] / 3600;
	                break;
	            case 2:
	                deg = dms[0] / 1 + dms[1] / 60;
	                break;
	            case 1:
	                deg = dms[0];
	                break;
	            default:
	                return NaN;
	        }
	        if (/^-|[WS]$/i.test(dmsStr.trim())) {
	            deg = -deg;
	        }
	        ; // take '-', west and south as -ve
	        deg = Number(deg);
	        return deg.toString();
	    };
	    /**
	     * Converts numeric degrees to deg/min/sec latitude (2-digit degrees, suffixed with N/S).
	     *
	     * @param   {number} deg - Degrees to be formatted as specified.
	     * @param   {string} [format=dms] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
	     * @param   {number} [dp=0|2|4] - Number of decimal places to use – default 0 for dms, 2 for dm, 4 for d.
	     * @returns {string} Degrees formatted as deg/min/secs according to specified format.
	     */
	    Coordinates.prototype.toLat = function (deg, format, dp) {
	        this.separator = ' '; // we separate DD MM SS with a space
	        var lat = this.toDMS(deg, format, dp);
	        this.separator = ''; // revert separator
	        return lat === null ? '–' : lat.slice(1) + this.separator + (deg < 0 ? 'S' : 'N'); // knock off initial '0' for lat!
	    };
	    /**
	     * Convert numeric degrees to deg/min/sec longitude (3-digit degrees, suffixed with E/W)
	     *
	     * @param   {number} deg - Degrees to be formatted as specified.
	     * @param   {string} [format=dms] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
	     * @param   {number} [dp=0|2|4] - Number of decimal places to use – default 0 for dms, 2 for dm, 4 for d.
	     * @returns {string} Degrees formatted as deg/min/secs according to specified format.
	     */
	    Coordinates.prototype.toLon = function (deg, format, dp) {
	        this.separator = ' '; // we separate DD MM SS with a space
	        var lon = this.toDMS(deg, format, dp);
	        this.separator = ''; // revert separator
	        return lon === null ? '–' : lon + this.separator + (deg < 0 ? 'W' : 'E');
	    };
	    /**
	     * Converts decimal degrees to deg/min/sec format
	     *
	     * @private
	     * @param   {number} deg - Degrees to be formatted as specified.
	     * @param   {string} [format=dms] - Return value as 'd', 'dm', 'dms' for deg, deg+min, deg+min+sec.
	     * @param   {number} [dp=0|2|4] - Number of decimal places to use – default 0 for dms, 2 for dm, 4 for d.
	     * @returns {string} Degrees formatted as deg/min/secs according to specified format.
	     */
	    Coordinates.prototype.toDMS = function (deg, format, dp) {
	        if (isNaN(deg)) {
	            return null;
	        }
	        ; // give up here if we can't make a number from deg
	        // default values
	        if (format === undefined) {
	            format = 'dms';
	        }
	        ;
	        if (dp === undefined) {
	            switch (format) {
	                case 'd':
	                case 'deg':
	                    dp = 4;
	                    break;
	                case 'dm':
	                case 'deg+min':
	                    dp = 2;
	                    break;
	                case 'dms':
	                case 'deg+min+sec':
	                    dp = 0;
	                    break;
	                default:
	                    format = 'dms';
	                    dp = 0; // be forgiving on invalid format
	            }
	        }
	        deg = Math.abs(deg); // (unsigned result ready for appending compass dir'n)
	        var dms, d, m, s;
	        switch (format) {
	            default: // invalid format spec!
	            case 'd':
	            case 'deg':
	                d = deg.toFixed(dp); // round/right-pad degrees
	                if (d < 100) {
	                    d = '0' + d;
	                }
	                ; // left-pad with leading zeros (note may include decimals)
	                if (d < 10) {
	                    d = '0' + d;
	                }
	                ;
	                dms = d + '°';
	                break;
	            case 'dm':
	            case 'deg+min':
	                d = Math.floor(deg); // get component deg
	                m = ((deg * 60) % 60).toFixed(dp); // get component min & round/right-pad
	                if (m === 60) {
	                    m = 0;
	                    d++;
	                } // check for rounding up
	                d = ('000' + d).slice(-3); // left-pad with leading zeros
	                if (m < 10) {
	                    m = '0' + m;
	                }
	                ; // left-pad with leading zeros (note may include decimals)
	                dms = d + '°' + this.separator + m + '′';
	                break;
	            case 'dms':
	            case 'deg+min+sec':
	                d = Math.floor(deg); // get component deg
	                m = Math.floor((deg * 3600) / 60) % 60; // get component min
	                s = (deg * 3600 % 60).toFixed(dp); // get component sec & round/right-pad
	                if (Math.round(s) === 60) {
	                    s = (0).toFixed(dp);
	                    m++;
	                }
	                if (m === 60) {
	                    m = 0;
	                    d++;
	                } // check for rounding up
	                d = ('000' + d).slice(-3); // left-pad with leading zeros
	                m = ('00' + m).slice(-2); // left-pad with leading zeros
	                if (s < 10) {
	                    s = '0' + s;
	                }
	                ; // left-pad with leading zeros (note may include decimals)
	                // 90159 join with or without spaces, depending on lat/lon (this.separator)
	                dms = d + this.separator + m + this.separator + s;
	                break;
	        }
	        return dms;
	    };
	    return Coordinates;
	}());
	exports.Coordinates = Coordinates;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var NominalRoutesController = (function (_super) {
	    __extends(NominalRoutesController, _super);
	    /* @ngInject */
	    NominalRoutesController.$inject = ["$scope", "$rootScope", "nominalRoutesService", "$translate"];
	    function NominalRoutesController($scope, $rootScope, nominalRoutesService, $translate) {
	        var _this = _super.call(this, $scope, nominalRoutesService) || this;
	        _this.$scope = $scope;
	        _this.nominalRoutesService = nominalRoutesService;
	        _super.prototype.setup.call(_this);
	        $scope.routeTypes = nominalRoutesService.listRouteTypes();
	        _this.getFilterParameters();
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    NominalRoutesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    NominalRoutesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return NominalRoutesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.NominalRoutesController = NominalRoutesController;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var FlightStatusExemptionsController = (function (_super) {
	    __extends(FlightStatusExemptionsController, _super);
	    /* @ngInject */
	    FlightStatusExemptionsController.$inject = ["$scope", "$rootScope", "flightStatusExemptionsService", "systemConfigurationService"];
	    function FlightStatusExemptionsController($scope, $rootScope, flightStatusExemptionsService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, flightStatusExemptionsService) || this;
	        _this.$scope = $scope;
	        _this.flightStatusExemptionsService = flightStatusExemptionsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        _this.getFilterParameters();
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    FlightStatusExemptionsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    FlightStatusExemptionsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return FlightStatusExemptionsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.FlightStatusExemptionsController = FlightStatusExemptionsController;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var organization_constants_1 = __webpack_require__(57);
	var FlightRouteExemptionsController = (function (_super) {
	    __extends(FlightRouteExemptionsController, _super);
	    /* @ngInject */
	    FlightRouteExemptionsController.$inject = ["$scope", "$rootScope", "flightRouteExemptionsService", "systemConfigurationService"];
	    function FlightRouteExemptionsController($scope, $rootScope, flightRouteExemptionsService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, flightRouteExemptionsService) || this;
	        _this.$scope = $scope;
	        _this.flightRouteExemptionsService = flightRouteExemptionsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.loadEanaAirways = function () { return _this.loadEanaAirways(); };
	        $scope.loadEanaWaypoints = function () { return _this.loadEanaWaypoints(); };
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.isEANA = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANA;
	        $scope.isExemptRouteForEana = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INCLUDE_ROUTE_SEGMENTS_FOR_EANA) === 't';
	        _this.getFilterParameters();
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        _this.loadEanaAirways();
	        _this.loadEanaWaypoints();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    FlightRouteExemptionsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    FlightRouteExemptionsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    FlightRouteExemptionsController.prototype.loadEanaAirways = function () {
	        var _this = this;
	        this.service.getEanaAirwaysFromNavDB().then(function (response) {
	            _this.$scope.listEanaAirways = response;
	        }, function () { return _this.$scope.navDBError = true; }); // error when trying to get airways from navDB
	    };
	    FlightRouteExemptionsController.prototype.loadEanaWaypoints = function () {
	        var _this = this;
	        this.service.getEanaWaypointsFromNavDB().then(function (response) {
	            _this.$scope.listEanaWaypoints = response;
	        }, function () { return _this.$scope.navDBError = true; }); // error when trying to get waypoints from navDB
	    };
	    return FlightRouteExemptionsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.FlightRouteExemptionsController = FlightRouteExemptionsController;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var AircraftUnspecifiedManagementController = (function (_super) {
	    __extends(AircraftUnspecifiedManagementController, _super);
	    /* @ngInject */
	    AircraftUnspecifiedManagementController.$inject = ["$scope", "$rootScope", "aircraftUnspecifiedManagementService", "aircraftTypeManagementService", "systemConfigurationService"];
	    function AircraftUnspecifiedManagementController($scope, $rootScope, aircraftUnspecifiedManagementService, aircraftTypeManagementService, systemConfigurationService) {
	        var _this = 
	        // define and setup super class
	        _super.call(this, $scope, aircraftUnspecifiedManagementService) || this;
	        _this.$scope = $scope;
	        _this.aircraftUnspecifiedManagementService = aircraftUnspecifiedManagementService;
	        _this.aircraftTypeManagementService = aircraftTypeManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // expose necessary method to scope
	        $scope.edit = function (item) { _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(item, 'mtow')); };
	        $scope.refresh = function () { return _this.refresh(); };
	        _this.getFilterParameters();
	        $scope.getMTOWByAircraftType = function (ac) { return _this.getMTOWByAircraftType(ac); };
	        // expose necessary fields to scope
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        return _this;
	    }
	    /**
	     * This will add appropriate filters from scope
	     * for parent refresh parameters.
	     */
	    AircraftUnspecifiedManagementController.prototype.refresh = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AircraftUnspecifiedManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AircraftUnspecifiedManagementController.prototype.getMTOWByAircraftType = function (ac) {
	        var _this = this;
	        if (ac !== undefined) {
	            this.aircraftTypeManagementService.listAll().then(function (aircraftType) {
	                for (var i = 0; i < aircraftType.content.length; i++) {
	                    if (ac === aircraftType.content[i].aircraft_type) {
	                        _this.$scope.editable.mtow = aircraftType.content[i].maximum_takeoff_weight; // update the mtow field
	                        break;
	                    }
	                    else {
	                        _this.$scope.editable.mtow = null;
	                    }
	                }
	            });
	        }
	        else {
	            this.$scope.editable.mtow = null;
	        }
	    };
	    return AircraftUnspecifiedManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AircraftUnspecifiedManagementController = AircraftUnspecifiedManagementController;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var RadarSummaryController = (function (_super) {
	    __extends(RadarSummaryController, _super);
	    /* @ngInject */
	    RadarSummaryController.$inject = ["$scope", "$rootScope", "radarSummaryService", "saveLocalTemplateService", "$uibModal", "systemConfigurationService", "customDate"];
	    function RadarSummaryController($scope, $rootScope, radarSummaryService, saveLocalTemplateService, $uibModal, systemConfigurationService, customDate) {
	        var _this = _super.call(this, $scope, radarSummaryService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.radarSummaryService = radarSummaryService;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _this.$uibModal = $uibModal;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _this.eurocatFormat = 'EUROCAT-A';
	        _this.intelcanFormat = 'INTELCAN-A';
	        _super.prototype.setup.call(_this);
	        $scope.$watchGroup(['search', 'control'], function () { return _this.getFilterParameters(); });
	        $scope.format = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.RADAR_SUMMARY_FORMAT);
	        $scope.flightLevelRequired = systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.VALIDATE_FLIGHT_LEVEL_AIRSPACE);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        // overwrite default '.csv' file upload pattern based on radar format
	        if ($scope.format === _this.eurocatFormat) {
	            $scope.pattern = '.print';
	        }
	        else if ($scope.format === _this.intelcanFormat) {
	            $scope.pattern = null;
	        }
	        _this.saveLocalTemplate();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    RadarSummaryController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search']];
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'radar-summary', filterPairs);
	    };
	    RadarSummaryController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'start': startDate,
	            'end': endDate,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Calls list with applied filters
	     *
	     * @returns void
	     */
	    RadarSummaryController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return RadarSummaryController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.RadarSummaryController = RadarSummaryController;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var InvoiceTemplateManagementController = (function (_super) {
	    __extends(InvoiceTemplateManagementController, _super);
	    /* @ngInject */
	    InvoiceTemplateManagementController.$inject = ["$scope", "invoiceTemplateManagementService", "$uibModal"];
	    function InvoiceTemplateManagementController($scope, invoiceTemplateManagementService, $uibModal) {
	        var _this = _super.call(this, $scope, invoiceTemplateManagementService, $uibModal) || this;
	        _this.$scope = $scope;
	        _this.invoiceTemplateManagementService = invoiceTemplateManagementService;
	        _this.$uibModal = $uibModal;
	        _super.prototype.setup.call(_this);
	        $scope.pattern = '.rptdesign'; // currently only accepts .rptdesign file types
	        $scope.resetTemplate = function (invoiceCategory) { return invoiceTemplateManagementService.resetTemplate(invoiceCategory)
	            .then(function () { return _this.list(); })
	            .then(function () { return _super.prototype.reset.call(_this); }); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        return _this;
	    }
	    InvoiceTemplateManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    InvoiceTemplateManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return InvoiceTemplateManagementController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.InvoiceTemplateManagementController = InvoiceTemplateManagementController;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var EnrouteAirNavigationChargesManagementController = (function (_super) {
	    __extends(EnrouteAirNavigationChargesManagementController, _super);
	    /* @ngInject */
	    EnrouteAirNavigationChargesManagementController.$inject = ["$scope", "enrouteAirNavigationChargesManagementService", "systemConfigurationService", "flightMovementCategoryService"];
	    function EnrouteAirNavigationChargesManagementController($scope, enrouteAirNavigationChargesManagementService, systemConfigurationService, flightMovementCategoryService) {
	        var _this = _super.call(this, $scope, enrouteAirNavigationChargesManagementService) || this;
	        _this.$scope = $scope;
	        _this.enrouteAirNavigationChargesManagementService = enrouteAirNavigationChargesManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.flightMovementCategoryService = flightMovementCategoryService;
	        _super.prototype.setup.call(_this);
	        $scope.showDWFactor = true;
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        flightMovementCategoryService.listAll().then(function (categories) {
	            _this.$scope.categories = categories;
	            _this.getEditable();
	        });
	        $scope.reset = function () { return _this.reset(); };
	        $scope.validate = function () { return _this.validate(); };
	        $scope.isValidate = function () { return _this.$scope.ifValidate = true; };
	        $scope.edit = function (item) { _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(item, 'mtow_category_upper_limit')); };
	        $scope.addToFormula = function (text) { return _this.addToFormula(text); };
	        $scope.setField = function (index, field) { return _this.setField(index, field); };
	        _this.getFilterParameters();
	        return _this;
	    }
	    EnrouteAirNavigationChargesManagementController.prototype.reset = function () {
	        _super.prototype.reset.call(this);
	        this.getEditable();
	        this.$scope.error = {};
	    };
	    EnrouteAirNavigationChargesManagementController.prototype.getEditable = function () {
	        var _this = this;
	        this.$scope.editable.enroute_air_navigation_charge_formulas = [];
	        if (this.$scope.categories) {
	            this.$scope.categories.forEach(function (category) {
	                if (category.name !== 'OTHER') {
	                    _this.$scope.editable.enroute_air_navigation_charge_formulas.push({ flightmovement_category: category, formula: null, d_factor_formula: null });
	                }
	                else {
	                    _this.$scope.editable.enroute_air_navigation_charge_formulas.push({ flightmovement_category: category, formula: 0, d_factor_formula: 0 });
	                }
	            });
	        }
	    };
	    EnrouteAirNavigationChargesManagementController.prototype.validate = function () {
	        var _this = this;
	        this.service.validate(this.$scope.editable).then(function (data) {
	            for (var i = 0; i < data.length; i++) {
	                if (data[i].formula_valid === false) {
	                    _this.$scope.error = {};
	                    var errorObj = {};
	                    _this.$scope.error.error = { data: errorObj };
	                    _this.$scope.error.error.data.error = data[i].formula;
	                    _this.$scope.error.error.data.error_description = data[i].issue;
	                    return;
	                }
	            }
	            _this.$scope.ifValidate = false;
	        });
	    };
	    EnrouteAirNavigationChargesManagementController.prototype.addToFormula = function (text) {
	        this.$scope.ifValidate = true;
	        if (!this.$scope.formula) {
	            this.$scope.formula = text;
	        }
	        else {
	            this.$scope.formula += text;
	        }
	        if (this.$scope.index >= 0 && this.$scope.field) {
	            this.$scope.editable.enroute_air_navigation_charge_formulas[this.$scope.index][this.$scope.field] = this.$scope.formula;
	        }
	        else {
	            this.$scope.editable.w_factor_formula = this.$scope.formula;
	        }
	    };
	    EnrouteAirNavigationChargesManagementController.prototype.setField = function (index, field) {
	        this.$scope.showDWFactor = field === 'formula';
	        this.$scope.index = index;
	        this.$scope.field = field;
	        if (index >= 0 && field) {
	            this.$scope.formula = this.$scope.editable.enroute_air_navigation_charge_formulas[index][field];
	        }
	        else {
	            this.$scope.formula = this.$scope.editable.w_factor_formula;
	        }
	    };
	    EnrouteAirNavigationChargesManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    return EnrouteAirNavigationChargesManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.EnrouteAirNavigationChargesManagementController = EnrouteAirNavigationChargesManagementController;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var CatalogueServiceChargeController = (function (_super) {
	    __extends(CatalogueServiceChargeController, _super);
	    /* @ngInject */
	    CatalogueServiceChargeController.$inject = ["$scope", "$rootScope", "catalogueServiceChargeService", "invoiceTemplateManagementService", "currencyManagementService", "systemConfigurationService"];
	    function CatalogueServiceChargeController($scope, $rootScope, catalogueServiceChargeService, invoiceTemplateManagementService, currencyManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, catalogueServiceChargeService) || this;
	        _this.$scope = $scope;
	        _this.catalogueServiceChargeService = catalogueServiceChargeService;
	        _this.invoiceTemplateManagementService = invoiceTemplateManagementService;
	        _this.currencyManagementService = currencyManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this, { filter: true });
	        $scope.basisList = catalogueServiceChargeService.getBasisList();
	        $scope.categoryList = catalogueServiceChargeService.listCategories();
	        $scope.externalDatabaseList = [
	            {
	                name: 'AATIS',
	                value: 'AATIS'
	            },
	            {
	                name: 'EAIP',
	                value: 'EAIP'
	            }
	        ];
	        // set scope value for require external system identifier
	        $scope.requireExternalSystemId = _this.requireExternalSystemId();
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // get the ANSP currency
	        currencyManagementService.getANSPCurrencyAndUSD().then(function (currencies) {
	            $scope.currencies = currencies;
	        });
	        return _this;
	    }
	    /**
	     * Get required external system id flag from system configuration.
	     *
	     * @returns boolean true if required
	     */
	    CatalogueServiceChargeController.prototype.requireExternalSystemId = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_SERVICE_CHARGE_CATALOGUE_EXTERNAL_SYSTEM_ID);
	    };
	    CatalogueServiceChargeController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            textFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Refresh data list in scope.
	     */
	    CatalogueServiceChargeController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return CatalogueServiceChargeController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CatalogueServiceChargeController = CatalogueServiceChargeController;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	// objects
	var line_item_1 = __webpack_require__(71);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// lodash
	var lodash_1 = __webpack_require__(72);
	var InvoiceGenerationController = (function () {
	    /* @ngInject */
	    InvoiceGenerationController.$inject = ["$scope", "$uibModal", "$state", "aerodromesService", "accountsService", "systemConfigurationService", "reportsService", "$translate", "aircraftTypeManagementService", "externalDatabaseInputService", "pluginsService", "flightMovementCategoryService", "sysConfigBoolean", "currencyManagementService"];
	    function InvoiceGenerationController($scope, $uibModal, $state, aerodromesService, accountsService, systemConfigurationService, reportsService, $translate, aircraftTypeManagementService, externalDatabaseInputService, pluginsService, flightMovementCategoryService, sysConfigBoolean, currencyManagementService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$state = $state;
	        this.aerodromesService = aerodromesService;
	        this.accountsService = accountsService;
	        this.systemConfigurationService = systemConfigurationService;
	        this.reportsService = reportsService;
	        this.$translate = $translate;
	        this.aircraftTypeManagementService = aircraftTypeManagementService;
	        this.externalDatabaseInputService = externalDatabaseInputService;
	        this.pluginsService = pluginsService;
	        this.flightMovementCategoryService = flightMovementCategoryService;
	        this.sysConfigBoolean = sysConfigBoolean;
	        this.currencyManagementService = currencyManagementService;
	        $scope.workflow = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.POINT_OF_SALE_WORKFLOW);
	        $scope.showProforma = localStorage_service_1.LocalStorageService.getBooleanFromValueByName("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.PROFORMA_INVOICE_SUPPORT);
	        aircraftTypeManagementService.findAllMinimalReturn().then(function (data) { return _this.$scope.aircraftTypesList = data; });
	        $scope.invoiceByFmCategory = sysConfigBoolean.parse(this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INVOICE_FM_CATEGORY) || 'f');
	        // $scope.showDisclaimer = () => this.showDisclaimer();
	        $scope.generateButtonIsDisabled = function () { return _this.generateButtonIsDisabled(); };
	        $scope.invoiceByFMCategory = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVOICE_FM_CATEGORY);
	        if ($scope.invoiceByFMCategory) {
	            $scope.notification_text = 'Note: Cannot generate an invoice when the selected flights are not pending';
	        }
	        if ($scope.invoiceByFmCategory) {
	            flightMovementCategoryService.getFlightMovementCategoryForAviationInvoice().then(function (resp) {
	                $scope.flightCategories = resp;
	                $scope.editable = {
	                    flightCategory: resp[0].id
	                };
	            });
	        }
	        // options
	        $scope.saleTypes = [
	            {
	                n: 'Aviation', v: 'aviation'
	            },
	            {
	                n: 'General', v: 'general'
	            }
	        ];
	        // generic
	        $scope.createAccount = function () { return $state.go('main.accounts', {
	            after: {
	                create: {
	                    goTo: {
	                        state: 'main.invoice-generation',
	                        params: null
	                    }
	                }
	            }
	        }); };
	        // generic
	        $scope.createAircraftRegistration = function () { return $state.go('main.aircraft-registration', {
	            after: {
	                create: {
	                    goTo: {
	                        state: 'main.invoice-generation',
	                        params: null
	                    }
	                }
	            }
	        }); };
	        // watch for account change and get invoice currency for selected account
	        // this is required as we only pull the minified account list for account dropdown selection
	        $scope.$watch('account', function (account) { return _this.updateAccountCurrencyCode(account); });
	        // if coming back from `account` page after creating an account, will pre-populate the form
	        if ($state.params.accountId && !isNaN($state.params.accountId)) {
	            accountsService.get($state.params.accountId).then(function (account) { return $scope.account = account; });
	        }
	        $scope.defaultAccountSelection = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.POINT_OF_SALE_DEFAULT_ACCOUNT_SELECTION);
	        $scope.$watch('defaultAccountSelection', function (accountSelection) {
	            if (accountSelection === 'Credit Accounts') {
	                $scope.accounts_type = 'credit';
	            }
	            else if (accountSelection === 'Cash Accounts') {
	                $scope.accounts_type = 'cash';
	            }
	            else {
	                $scope.accounts_type = 'all';
	            }
	        });
	        accountsService.findAllCashMinimalReturn(true).then(function (accounts) {
	            $scope.accountsListCash = accounts;
	            accountsService.findAllCreditMinimalReturn(true).then(function (accounts) {
	                $scope.accountsListCredit = accounts;
	                $scope.accountsListAll = $scope.accountsListCash.concat($scope.accountsListCredit);
	                $scope.accountsListAll = lodash_1.sortBy($scope.accountsListAll, function (item) {
	                    return item.name.toLowerCase();
	                });
	                _this.getAccounts();
	            });
	        });
	        $scope.getAccounts = function () { return _this.getAccounts(); };
	        $scope.removePreview = function () { return _this.removePreview(); };
	        $scope.recalculateInvoiceAmount = function () { return _this.recalculateInvoiceAmount(); };
	        // aviation related
	        $scope.getNonInvoicedFlightMovementsByAccount = function (account, typeOfSale, userBillingCenterOnly, flightCategory, page, queryString) {
	            return _this.getNonInvoicedFlightMovementsByAccount(account, typeOfSale, userBillingCenterOnly, flightCategory, page, queryString);
	        };
	        $scope.previewAviationInvoiceJSON = function (accountId, flightIdList, flightMovementList, flightCategory, invoiceCurrency) {
	            return _this.previewAviationInvoiceJSON(accountId, flightIdList, flightMovementList, flightCategory, invoiceCurrency);
	        };
	        $scope.createFlightMovement = function (account) { return _this.createFlightMovement(account); };
	        $scope.editFlightMovement = function (account, flightMovement, index) { return _this.editFlightMovement(account, flightMovement, index); };
	        $scope.removeFlightMovement = function (index) { return $scope.tempFlightMovementList.splice(index, 1); };
	        $scope.removeError = function () { return $scope.error = null; };
	        $scope.flightToggleSelection = function (id) { return _this.flightToggleSelection(id); };
	        $scope.generateSuccess = function () { return _this.generateSuccess(); };
	        $scope.generateError = function () { return _this.generateError(); };
	        $scope.generateAviationInvoicePaySuccess = function () { return _this.generateAviationInvoicePaySuccess(); };
	        $scope.setEmptyObjects = function () { return _this.setEmptyObjects(); };
	        $scope.selectedFlights = [];
	        $scope.results = [];
	        $scope.tempFlightMovementList = [];
	        $scope.modal = $uibModal;
	        $scope.payment = {};
	        $scope.aviationInvoices = {};
	        // getting USD currency
	        this.currencyManagementService.getByCurrencyCode('USD').then(function (currency) {
	            $scope.usdCurrency = $scope.defaultTaspCurrency = currency;
	        });
	        // getting ANSP currency
	        var anspCode = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        if (anspCode) {
	            this.currencyManagementService.getByCurrencyCode(anspCode).then(function (currency) {
	                $scope.anspCurrency = currency;
	            });
	        }
	        // non-aviation related
	        reportsService.getApplicablePosServiceCharges().then(function (response) { _this.catalogueServiceChargeTypes = response; _this.$scope.serviceChargeList = response; _this.getCategories(response); });
	        aerodromesService.listAll().then(function (response) { return $scope.aerodromesList = response; });
	        $scope.chargeProps = { categories: [], types: [], descriptions: [] };
	        $scope.getTypes = function (category) { return _this.getTypes(category); };
	        $scope.getDescriptions = function (type) { return _this.getDescriptions(type); };
	        $scope.addChargeItem = function (description) { return _this.addChargeItem(description); };
	        $scope.lineItemError = [];
	        $scope.lineItems = [];
	        $scope.calculatedAmount = [];
	        $scope.previewNonAviationInvoiceJSON = function (accountId, lineItems, invoiceCurrency) {
	            return _this.previewNonAviationInvoiceJSON(accountId, lineItems, invoiceCurrency);
	        };
	        $scope.nonAviationInvoices = {};
	        $scope.removeChargeItem = function (index) { return _this.$scope.lineItems.splice(index, 1); };
	        $scope.generateNonAviSuccess = function () { return _this.generateNonAviSuccess(); };
	        $scope.generateNonAviError = function () { return _this.generateNonAviError(); };
	        $scope.generateNonAviationInvoicePaySuccess = function () { return _this.generateNonAviationInvoicePaySuccess(); };
	        $scope.generateNonAviationInvoice = function (accountId, preview, format, lineItems, invoiceCurrency) {
	            return _this.generateNonAviationInvoice(accountId, preview, format, lineItems, invoiceCurrency);
	        };
	        $scope.generateAviationInvoice = function (accountId, flightIdList, format, preview, tempFlightMovementList, flightCategory, invoiceCurrency) {
	            return _this.generateAviationInvoice(accountId, flightIdList, format, preview, tempFlightMovementList, flightCategory, invoiceCurrency);
	        };
	        // reset charge props if line items is less then 0
	        $scope.$watch('lineItems.length', function (newLineItems) {
	            $scope.nonAviationInvoices = {};
	            if (_this.catalogueServiceChargeTypes && (!newLineItems || newLineItems.length < 1)) {
	                _this.$scope.serviceChargeList = _this.catalogueServiceChargeTypes;
	                _this.resetChargeProps(null);
	            }
	        });
	        $scope.$on('lineItem amount changed', function () {
	            $scope.nonAviationInvoices = {};
	        });
	        $scope.clearChargeItemForm = function (chargeItemForm) { return _this.clearChargeItemForm(chargeItemForm); };
	        $scope.isGenerateDisabled = function (isPayment, isItemsValid, isPaymentValid) { return _this.isGenerateDisabled(isPayment, isItemsValid, isPaymentValid); };
	        $scope.lineItemsValid = false;
	        // adhoc fee related
	        $scope.organizationName = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION);
	        $scope.approachLabel = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.APPROACH_FEES_LABEL);
	        pluginsService.getPluginEnabled('kcaa', 'aatis').then(function (isEnabled) {
	            if (isEnabled && systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_TASP_CHARGES)) {
	                $scope.isAATISEnabled = true;
	            }
	            else {
	                $scope.isAATISEnabled = false;
	            }
	        });
	        $scope.taspLabel = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.TASP_FEES_LABEL);
	        $scope.adhocFees = [];
	        $scope.addAdhocFeeToList = function (newAdhocFee) { return _this.addAdhocFeeToList(newAdhocFee); };
	        $scope.$watchGroup(['selectedFlights.length', 'adhocFees.length'], function () { return _this.findFlightsMissingAdhocFee(); });
	        $scope.$watch('tempFlightMovementList', function () { return _this.findFlightsMissingAdhocFee(); }, true);
	        // click generate and pay button from 'fake' button that includes popup functionality
	        $scope.clickGenerateAndPay = function () { return setTimeout(function () { return document.getElementById('generate-pay-button').click(); }); };
	        // click preview button from 'fake' button that includes popup functionality
	        $scope.clickPreview = function () { return setTimeout(function () { return document.getElementById('preview-button').click(); }); };
	        // used by the flight creation form
	        $scope.showPassengerCounts = systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INCLUDE_PASSENGER_CHARGES_ON_INVOICE);
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.nonAviationInvoicePayload = function (parms) { return reportsService.nonAviationInvoicePayload(parms.line_items, parms.payment); };
	    }
	    InvoiceGenerationController.prototype.getAccounts = function () {
	        if (this.$scope.accounts_type === 'cash') {
	            this.$scope.accountsList = this.$scope.accountsListCash;
	        }
	        else if (this.$scope.accounts_type === 'credit') {
	            this.$scope.accountsList = this.$scope.accountsListCredit;
	        }
	        else {
	            this.$scope.accountsList = this.$scope.accountsListAll;
	        }
	    };
	    // aviation Related methods
	    InvoiceGenerationController.prototype.createFlightMovement = function (account) {
	        this.openFlightPlanModal(account);
	    };
	    InvoiceGenerationController.prototype.editFlightMovement = function (account, flightMovement, index) {
	        var disableTaspFees = false;
	        if (this.$scope.selectedAdhocFees) {
	            disableTaspFees = this.$scope.selectedAdhocFees.some(function (item) { return item.flight_movement.id === flightMovement.id; });
	        }
	        this.openFlightPlanModal(account, angular.copy(flightMovement), index, disableTaspFees);
	    };
	    InvoiceGenerationController.prototype.setEmptyObjects = function () {
	        this.$scope.results = [];
	        if (this.$scope.aviationInvoices) {
	            this.$scope.aviationInvoices.generating = false;
	            this.$scope.aviationInvoices.generatePay = false;
	            this.$scope.aviationInvoices.preview = null;
	        }
	        this.$scope.tempFlightMovementList = [];
	        this.$scope.invoiceCreatedAndPaid = false;
	        this.$scope.lineItems = [];
	        this.$scope.selectedFlights = [];
	        this.$scope.invoiceCreated = null;
	        this.$scope.currenciesList = [];
	        this.$scope.invoiceCurrency = null;
	    };
	    // create/edit a flight plan
	    InvoiceGenerationController.prototype.openFlightPlanModal = function (account, flightMovement, index, disableTaspFees) {
	        if (account === void 0) { account = null; }
	        if (flightMovement === void 0) { flightMovement = null; }
	        if (index === void 0) { index = null; }
	        if (disableTaspFees === void 0) { disableTaspFees = false; }
	        var modal = this.$scope.modal.open({
	            templateUrl: 'app/partials/invoice-generation/invoice-generation.flight-modal.html',
	            scope: this.$scope,
	            controller: ['$scope', '$timeout', 'reportsService', function (scope, $timeout, reportsService) {
	                    scope.error = null;
	                    modal.rendered.then(function () {
	                        $timeout(function () {
	                            if (flightMovement && !isNaN(index)) {
	                                scope.editable = flightMovement;
	                                scope.index = index;
	                                scope.editable.disableTaspFees = disableTaspFees;
	                            }
	                            else {
	                                scope.editable = { source: 'manual' };
	                                scope.editable.associated_account_id = account.id; // pre-selects the account
	                                scope.editable.date_of_flight = moment.utc().startOf('day').toISOString(); // pre-selects the date of flight
	                                if (!scope.editable.tasp_charge_currency) {
	                                    scope.editable.tasp_charge_currency = scope.defaultTaspCurrency;
	                                }
	                                scope.index = null;
	                            }
	                            function validateFlightMovement(flightMovement) {
	                                scope.flightMovementButtonDisabled = true;
	                                return reportsService.validateFlight(account.id, flightMovement, scope.$parent.tempFlightMovementList);
	                            }
	                            scope.addFlightMovement = function (flightMovement) { return validateFlightMovement(flightMovement).then(function (validatedFlightMovement) {
	                                // shows warning if FM has mismatching billing center
	                                scope.$parent.tempFlightMovementList.push(validatedFlightMovement);
	                                scope.flightMovementButtonDisabled = false;
	                                modal.close();
	                            }, function (error) {
	                                scope.error = { error: error };
	                                scope.flightMovementButtonDisabled = false;
	                            }); };
	                            scope.updateFlightMovement = function (flightMovement, index) { return validateFlightMovement(flightMovement).then(function (validatedFlightMovement) {
	                                // shows warning if FM has mismatching billing center
	                                scope.$parent.tempFlightMovementList[index] = validatedFlightMovement;
	                                modal.close();
	                            }, function (error) {
	                                scope.error = { error: error };
	                                scope.flightMovementButtonDisabled = false;
	                            }); };
	                            scope.manual = {};
	                            scope.flightForm.$setPristine();
	                            scope.flightForm.$setUntouched();
	                        }, 0);
	                    });
	                }],
	            appendTo: angular.element(document.querySelector('#flight-modal-holder'))
	        });
	    };
	    InvoiceGenerationController.prototype.reset = function () {
	        // general
	        this.$scope.account = null;
	        this.$scope.accountCurrencyCode = null;
	        this.$scope.typeOfSaleSelection = null;
	        this.$scope.invoiceCurrency = null;
	        this.$scope.paymentReset = new Date(); // resets payment
	        // non-aviation
	        this.$scope.nonAviationInvoices.preview = null;
	        this.$scope.nonAviationInvoices.totalCurrency = null;
	    };
	    // generate a non-aviation invoice with the status "new"
	    InvoiceGenerationController.prototype.generateNonAviationInvoice = function (accountId, preview, format, lineItems, invoiceCurrency) {
	        var _this = this;
	        this.$scope.proforma = this.$scope.typeOfSaleSelection === 'general-proforma';
	        this.reportsService.generateNonAviationInvoicePOS(accountId, preview, format, lineItems, invoiceCurrency, this.$scope.proforma).then(function () {
	            _this.generateNonAviSuccess();
	        }, function (error) { _this.$scope.error = { error: error }; _this.generateNonAviError(); });
	    };
	    // generate an aviation invoice with the status "new"
	    InvoiceGenerationController.prototype.generateAviationInvoice = function (accountId, flightIdList, format, preview, tempFlightMovementList, flightCategory, invoiceCurrency) {
	        var _this = this;
	        this.findSelectedAdhocFees();
	        this.reportsService.generateAviationInvoice(accountId, flightIdList, this.$scope.selectedAdhocFees, format, preview, tempFlightMovementList, flightCategory, invoiceCurrency).then(function () {
	            _this.generateSuccess();
	        }, function (error) { _this.$scope.error = { error: error }; _this.generateError(); });
	    };
	    InvoiceGenerationController.prototype.getNonInvoicedFlightMovementsByAccount = function (account, typeOfSale, userBillingCenterOnly, flightCategory, page, queryString) {
	        var _this = this;
	        if (page === void 0) { page = 1; }
	        this.$scope.results = [];
	        if (typeOfSale === 'aviation' && account) {
	            this.reportsService.getNonInvoicedFlightMovementsByAccount(account, userBillingCenterOnly, page - 1, queryString, flightCategory).then(function (response) {
	                response.number++;
	                _this.$scope.flightMovementList = response;
	            }, function (error) { return _this.$scope.error = { error: error }; });
	        }
	    };
	    InvoiceGenerationController.prototype.flightToggleSelection = function (id) {
	        var idx = this.$scope.selectedFlights.indexOf(id);
	        if (idx > -1) {
	            this.$scope.selectedFlights.splice(idx, 1);
	        }
	        else {
	            this.$scope.selectedFlights.push(id);
	        }
	        this.$scope.aviationInvoices.preview = null;
	        this.removePreview();
	        this.findSelectedAdhocFees();
	    };
	    InvoiceGenerationController.prototype.removePreview = function () {
	        this.$scope.$broadcast('hidePreview');
	    };
	    // returns JSON of Aviation Invoice
	    InvoiceGenerationController.prototype.previewAviationInvoiceJSON = function (accountId, flightIdList, flightMovementList, flightCategory, invoiceCurrency) {
	        var _this = this;
	        this.findSelectedAdhocFees();
	        return this.reportsService
	            .aviationInvoice(accountId, flightIdList, flightMovementList, this.$scope.selectedAdhocFees, flightCategory, 1, 'json', invoiceCurrency)
	            .then(function (data) { return _this.$scope.aviationInvoices.preview = data; }, function (error) { return _this.$scope.error = { error: error }; });
	    };
	    InvoiceGenerationController.prototype.enableButtons = function () {
	        this.$scope.aviationInvoices.generating = false;
	        this.$scope.aviationInvoices.generatePay = false;
	        this.$scope.nonAviationInvoices.generating = false;
	        this.$scope.nonAviationInvoices.generatePay = false;
	    };
	    InvoiceGenerationController.prototype.generateSuccess = function () {
	        this.$scope.invoiceCreated = true;
	        this.reset();
	        this.enableButtons();
	    };
	    InvoiceGenerationController.prototype.generateAviationInvoicePaySuccess = function () {
	        this.generateSuccess();
	        this.$scope.invoiceCreatedAndPaid = true;
	    };
	    InvoiceGenerationController.prototype.generateError = function () {
	        this.enableButtons();
	    };
	    // returns JSON of Non-Aviation Invoice
	    InvoiceGenerationController.prototype.previewNonAviationInvoiceJSON = function (accountId, lineItems, invoiceCurrency) {
	        var _this = this;
	        this.$scope.nonAviationInvoices.preview = null;
	        this.$scope.nonAviationInvoices.totalCurrency = null;
	        this.$scope.proforma = this.$scope.typeOfSaleSelection === 'general-proforma';
	        return this.reportsService.nonAviationInvoice(accountId, lineItems, 1, 'json', invoiceCurrency, this.$scope.proforma).then(function (data) {
	            if (data.global.invoice_currency_code === data.global.invoice_currency_ansp_code) {
	                _this.$scope.nonAviationInvoices.preview = data.global.total_amount_ansp;
	            }
	            else {
	                _this.$scope.nonAviationInvoices.preview = data.global.total_amount;
	            }
	            ;
	            _this.$scope.nonAviationInvoices.totalCurrency = data.global.invoice_currency_code;
	        }, function (error) { return _this.$scope.error = { error: error }; });
	    };
	    InvoiceGenerationController.prototype.generateNonAviSuccess = function () {
	        this.$scope.invoiceCreated = true;
	        this.enableButtons();
	        this.reset();
	    };
	    InvoiceGenerationController.prototype.generateNonAviationInvoicePaySuccess = function () {
	        this.generateSuccess();
	        this.$scope.invoiceCreatedAndPaid = true;
	    };
	    InvoiceGenerationController.prototype.generateNonAviError = function () {
	        this.enableButtons();
	    };
	    /**
	     * Creates an array of unique categories from the
	     * service charge catalogue
	     *
	     * @param  {ICatalogueServiceChargeType[]} serviceChargeList
	     * @returns void
	     */
	    InvoiceGenerationController.prototype.getCategories = function (serviceChargeList) {
	        var _this = this;
	        var categories = serviceChargeList.map(function (item) { return _this.toTitleCase(item.category); });
	        this.$scope.chargeProps.categories = Array.from(new Set(categories));
	    };
	    /**
	     * Creates an array of unique types associated
	     * with the selected category
	     *
	     * @param  {string} category
	     * @returns void
	     */
	    InvoiceGenerationController.prototype.getTypes = function (category) {
	        var _this = this;
	        var types = this.$scope.serviceChargeList
	            .filter(function (item) { return _this.toTitleCase(item.category) === _this.toTitleCase(category); })
	            .map(function (item) { return _this.toTitleCase(item.type); });
	        this.$scope.chargeProps.types = Array.from(new Set(types));
	    };
	    /**
	     * Creates an array of unique descriptions associated
	     * with the selected type
	     *
	     * @param  {string} type
	     * @returns void
	     */
	    InvoiceGenerationController.prototype.getDescriptions = function (type) {
	        var _this = this;
	        var descriptions = this.$scope.serviceChargeList
	            .filter(function (item) { return _this.toTitleCase(item.type) === _this.toTitleCase(type); })
	            .map(function (item) { return item.description; });
	        this.$scope.chargeProps.descriptions = Array.from(new Set(descriptions));
	    };
	    /**
	     * Finds the service charge item by the unique description
	     * and adds it to the line items table
	     *
	     * @param  {string} description - Mandatory / Unique
	     * @returns void
	     */
	    InvoiceGenerationController.prototype.addChargeItem = function (description) {
	        if (!description) {
	            return;
	        }
	        ;
	        var chargeItem = this.$scope.serviceChargeList.find(function (item) { return item.description === description; });
	        this.$scope.lineItems.push(angular.copy(line_item_1.LineItem)); // push new line item
	        this.$scope.lineItems[this.$scope.lineItems.length - 1].service_charge_catalogue = chargeItem; // update line item service charge
	        // limit charge props to only of the same external charge category
	        this.resetChargeProps(chargeItem.external_charge_category);
	    };
	    /**
	     * This prevents duplicate categories/types created
	     * by minor differences in capitalization or whitespace.
	     *
	     * eg:
	     * "Trade Concessions" and "Trade concessions"
	     * "Regulatory Charges" and "Regulatory  Charges"
	     *
	     * @param  {string} str
	     * @returns string
	     */
	    InvoiceGenerationController.prototype.toTitleCase = function (str) {
	        if (!str) {
	            return str;
	        }
	        ;
	        var wordsToIgnore = ['and', 'a', 'or', 'for', 'in'];
	        var wordsInString = str.split(' ').filter(String); // filters out empty "" strings
	        var parsedWords = wordsInString.map(function (word) {
	            return wordsToIgnore.includes(word) ? word.trim() : word.replace(/\w\S*/g, function (txt) {
	                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	            }).trim();
	        });
	        return parsedWords.join(' ');
	    };
	    /**
	     * Limit selectable charge categories based on external charge category provided.
	     *
	     * @param externalChargeCateogry category to limit list, null if no limitation
	     */
	    InvoiceGenerationController.prototype.resetChargeProps = function (externalChargeCateogry) {
	        // set external charge category and limit service charge list
	        if (externalChargeCateogry) {
	            this.$scope.serviceChargeList = this.catalogueServiceChargeTypes.filter(function (item) {
	                return item.external_charge_category !== null && item.external_charge_category.id === externalChargeCateogry.id;
	            });
	        }
	        else {
	            this.$scope.serviceChargeList = this.catalogueServiceChargeTypes;
	        }
	        // update selectable dropdown list
	        this.getCategories(this.$scope.serviceChargeList);
	        this.getTypes(this.$scope.form.chargeItemForm.category);
	        this.getDescriptions(this.$scope.form.chargeItemForm.type);
	    };
	    /**
	     * Clear general charge item form selection.
	     */
	    InvoiceGenerationController.prototype.clearChargeItemForm = function (chargeItemForm) {
	        chargeItemForm.category = '';
	        chargeItemForm.type = '';
	        chargeItemForm.description = '';
	        chargeItemForm.$setPristine();
	        chargeItemForm.$setUntouched();
	        this.$scope.chargeProps.types = [];
	        this.$scope.chargeProps.descriptions = [];
	    };
	    InvoiceGenerationController.prototype.isGenerateDisabled = function (isPayment, isItemsValid, isPaymentValid) {
	        // return true if no account or sale selection
	        if (!this.$scope.typeOfSaleSelection || !this.$scope.account) {
	            return true;
	        }
	        // generic conditions
	        var isDisabled = !isItemsValid;
	        // sale type specific conditions
	        if (this.$scope.typeOfSaleSelection === 'aviation') {
	            isDisabled = isDisabled
	                || this.$scope.aviationInvoices.generating
	                || this.$scope.aviationInvoices.generatePay;
	        }
	        else if (this.$scope.typeOfSaleSelection === 'general') {
	            isDisabled = isDisabled
	                || this.$scope.nonAviationInvoices.generating
	                || this.$scope.nonAviationInvoices.generatePay;
	        }
	        // payment specific conditions
	        if (isPayment) {
	            isDisabled = isDisabled
	                || !isPaymentValid
	                || this.$scope.workflow === 'credit';
	        }
	        else {
	            isDisabled = isDisabled
	                || this.$scope.workflow === 'cash'
	                || (this.$scope.workflow === 'mixed' && this.$scope.account.cash_account);
	        }
	        if (!isDisabled && this.$scope.typeOfSaleSelection === 'aviation') {
	            return this.generateButtonIsDisabled();
	        }
	        return isDisabled;
	    };
	    /*
	     * Add adhoc fee returned from external database.
	     * Adhoc fee is unique to flight movement and must have non-null charge amount
	     */
	    InvoiceGenerationController.prototype.addAdhocFeeToList = function (newAdhocFee) {
	        // remove adhoc fee if it already exists for flight
	        this.$scope.adhocFees = this.$scope.adhocFees.filter(function (adhocFee) { return adhocFee.flight_movement.id !== newAdhocFee.flight_movement.id; });
	        // add new adhoc fee to list if it is valid and has non-null charge amount
	        if (newAdhocFee.adhoc_total_fee_payment_amount !== null) {
	            this.$scope.adhocFees.push(newAdhocFee);
	        }
	        this.findSelectedAdhocFees();
	    };
	    // filter adhoc fees by those that belong to a selected flight
	    InvoiceGenerationController.prototype.findSelectedAdhocFees = function () {
	        var _this = this;
	        this.$scope.selectedAdhocFees = this.$scope.adhocFees.filter(function (adhocFee) { return _this.$scope.selectedFlights.includes(adhocFee.flight_movement.id)
	            || _this.$scope.tempFlightMovementList.includes(adhocFee.flight_movement); });
	    };
	    // used to check if any selected flights still require an adhoc fee
	    InvoiceGenerationController.prototype.findFlightsMissingAdhocFee = function () {
	        var flightMovements = this.$scope.flightMovementList ? this.$scope.flightMovementList.content : null;
	        var selectedAdhocFeeFlightIds = this.$scope.adhocFees.map(function (adhocFee) { return adhocFee.flight_movement.id; });
	        this.$scope.flightsRequiringAdhocFee = [];
	        if (flightMovements && this.$scope.selectedFlights.length) {
	            this.$scope.flightsRequiringAdhocFee = this.$scope.selectedFlights.reduce(function (acc, selectedFlightId) {
	                var flight = flightMovements.find(function (flight) { return flight.id === selectedFlightId; });
	                if (flight && flight.adhoc_charge_required && !selectedAdhocFeeFlightIds.includes(flight.id)) {
	                    acc.push(selectedFlightId);
	                }
	                return acc;
	            }, []);
	        }
	        if (this.$scope.tempFlightMovementList.length) {
	            var flights = this.$scope.tempFlightMovementList.filter(function (item) {
	                return item.adhoc_charge_required && !selectedAdhocFeeFlightIds.includes(item.id);
	            }).map(function (item) { return item.id; });
	            this.$scope.flightsRequiringAdhocFee = this.$scope.flightsRequiringAdhocFee.concat(flights);
	        }
	    };
	    InvoiceGenerationController.prototype.updateAccountCurrencyCode = function (account) {
	        var _this = this;
	        if (account && account.id) {
	            this.accountsService.get(account.id)
	                .then(function (account) {
	                _this.$scope.accountCurrencyCode = account.invoice_currency.currency_code;
	                _this.setDefaultCurrency(account.invoice_currency);
	            });
	        }
	        else {
	            this.$scope.accountCurrencyCode = null;
	        }
	    };
	    InvoiceGenerationController.prototype.setDefaultCurrency = function (accountCurrency) {
	        this.$scope.currenciesList = [];
	        this.$scope.currenciesList.push(accountCurrency);
	        // default invoice currency is account currency
	        this.$scope.invoiceCurrency = accountCurrency;
	        if (accountCurrency.currency_code !== this.$scope.anspCurrency.currency_code) {
	            this.$scope.currenciesList.push(this.$scope.anspCurrency);
	        }
	        if (accountCurrency.currency_code !== this.$scope.usdCurrency.currency_code) {
	            this.$scope.currenciesList.push(this.$scope.usdCurrency);
	        }
	    };
	    InvoiceGenerationController.prototype.recalculateInvoiceAmount = function () {
	        this.$scope.accountCurrencyCode = this.$scope.invoiceCurrency.currency_code;
	    };
	    InvoiceGenerationController.prototype.generateButtonIsDisabled = function () {
	        var _this = this;
	        if (this.$scope.flightMovementList == null)
	            return true;
	        var flightMovementIncomplete = this.$scope.flightMovementList.content.filter(function (item) {
	            return item.status == 'INCOMPLETE';
	        }).filter(function (item) { return _this.$scope.selectedFlights.indexOf(item.id) > -1; });
	        return flightMovementIncomplete.length != 0;
	    };
	    return InvoiceGenerationController;
	}());
	exports.InvoiceGenerationController = InvoiceGenerationController;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.LineItem = {
	    aerodrome: {
	        id: null,
	        aerodrome_name: null,
	        extended_aerodrome_name: null,
	        aixm_flag: null,
	        is_default_billing_center: null,
	        external_accounting_system_identifier: null,
	        geometry: {
	            type: null,
	            coordinates: [
	                null,
	                null
	            ]
	        },
	        aerodrome_category: {
	            id: null,
	            category_name: null,
	            international_passenger_fee_adult: null,
	            international_passenger_fee_child: null,
	            domestic_passenger_fee_adult: null,
	            domestic_passenger_fee_child: null,
	            international_fees_currency: {
	                id: null,
	                currency_code: null,
	                currency_name: null,
	                country_code: {
	                    id: null,
	                    country_code: null,
	                    country_name: null,
	                    aircraft_registration_prefixes: null,
	                    aerodrome_prefixes: null,
	                    crco_member: false
	                },
	                decimal_places: null,
	                symbol: null,
	                active: null,
	                allow_updated_from_web: null,
	                external_accounting_system_identifier: null,
	                exchange_rate_target_currency_id: null
	            },
	            domestic_fees_currency: {
	                id: null,
	                currency_code: null,
	                currency_name: null,
	                country_code: {
	                    id: null,
	                    country_code: null,
	                    country_name: null,
	                    aircraft_registration_prefixes: null,
	                    aerodrome_prefixes: null,
	                    crco_member: false
	                },
	                decimal_places: null,
	                symbol: null,
	                active: null,
	                allow_updated_from_web: null,
	                external_accounting_system_identifier: null,
	                exchange_rate_target_currency_id: null
	            }
	        },
	        billing_center: {
	            aerodromes: [],
	            hq: null,
	            id: null,
	            invoice_sequence_number: null,
	            name: null,
	            prefix_invoice_number: null,
	            prefix_receipt_number: null,
	            receipt_sequence_number: null,
	            users: [],
	            external_accounting_system_identifier: null,
	            iata_invoice_sequence_number: null,
	            receipt_cheque_sequence_number: null,
	            receipt_wire_sequence_number: null
	        },
	        aerodrome_services: null
	    },
	    service_charge_catalogue: {
	        id: null,
	        charge_class: null,
	        category: null,
	        type: null,
	        subtype: null,
	        description: null,
	        charge_basis: null,
	        minimum_amount: null,
	        maximum_amount: null,
	        amount: null,
	        invoice_category: null,
	        external_accounting_system_identifier: null,
	        external_charge_category: null,
	        currency: null
	    },
	    recurring_charge: null,
	    account_external_system_identifier: null,
	    amount: null,
	    user_unit_amount: null,
	    user_markup_amount: null,
	    user_price: null,
	    user_electricity_meter_reading: null,
	    user_electricity_charge_type: null,
	    user_water_meter_reading: null,
	    user_discount_percentage: null,
	    user_town: {
	        id: null,
	        town_or_village_name: null,
	        water_utility_schedule: null,
	        residential_electricity_utility_schedule: null,
	        commercial_electricity_utility_schedule: null
	    },
	    price_per_unit: null,
	    any_aerodrome: null,
	    invoice_permit: {
	        invoice_permit_number: null,
	        external_database_for_charge: null,
	        adhoc_total_fee_payment_amount: null
	    },
	    requisition: {
	        req_number: null,
	        external_database_for_charge: null,
	        req_currency: null,
	        req_total_amount: null,
	        req_ar_id: null,
	        req_country_id: null,
	        req_id: null,
	        req_maninfo_id: null
	    }
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';

	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;

	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;

	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);

	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;

	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;

	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };

	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };

	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;

	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;

	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }

	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }

	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;

	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;

	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }

	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;

	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }

	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }

	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }

	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];

	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;

	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;

	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;

	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;

	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');

	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;

	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }

	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }

	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }

	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }

	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }

	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;

	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }

	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

	      return result ? 0 : -1;
	    }

	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);

	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;

	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;

	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);

	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }

	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;

	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }

	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;

	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }

	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }

	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;

	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }

	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }

	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;

	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);

	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);

	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }

	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;

	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);

	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);

	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }

	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];

	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;

	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];

	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;

	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;

	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);

	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }

	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;

	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);

	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);

	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

	      stackA.pop();
	      stackB.pop();

	      return result;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];

	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');

	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);

	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;

	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];

	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;

	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);

	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }

	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }

	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;

	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;

	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];

	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;

	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);

	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;

	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }

	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);

	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;

	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }

	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);

	      view.set(new Uint8Array(buffer));
	      return result;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);

	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);

	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;

	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;

	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;

	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }

	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';

	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }

	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }

	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }

	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }

	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);

	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;

	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }

	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }

	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }

	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }

	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);

	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }

	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }

	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }

	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);

	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);

	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;

	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);

	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;

	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }

	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);

	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);

	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }

	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');

	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;

	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }

	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }

	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }

	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;

	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }

	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);

	      var index = -1,
	          length = props.length,
	          result = {};

	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;

	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());

	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;

	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));

	      var index = -1,
	          result = [];

	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }

	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }

	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }

	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }

	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }

	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];

	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];

	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];

	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;

	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];

	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);

	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;

	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }

	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;

	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }

	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);

	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};

	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;

	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }

	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });

	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;

	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }

	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }

	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);

	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }

	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });

	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }

	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;

	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];

	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);

	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }

	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });

	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }

	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

	      var index = -1,
	          length = methodNames.length;

	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }

	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }

	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }

	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }

	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);

	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;

	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });

	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }

	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);

	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }

	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }

	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }

	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }

	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }

	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }

	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;

	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);

	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });

	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }

	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);

	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);

	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);

	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};

	      while (++index < length) {
	        var key = props[index],
	            value = object[key];

	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;

	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;

	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);

	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });

	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);

	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);

	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }

	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });

	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }

	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);

	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }

	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;

	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });

	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }

	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');

	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);

	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }

	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;

	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);

	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);

	      return result;
	    }

	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

	      return string.lastIndexOf(target, position) == position;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);

	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }

	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }

	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;

	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];

	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);

	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }

	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);

	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);

	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }

	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }

	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);

	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);

	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }

	    /*------------------------------------------------------------------------*/

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;

	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;

	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;

	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;

	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;

	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);

	    /*------------------------------------------------------------------------*/

	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;

	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;

	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };

	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;

	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });

	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });

	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);

	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;

	    return lodash;
	  }

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;

	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)(module), (function() { return this; }())))

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var map_constants_1 = __webpack_require__(26);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var localStorage_service_1 = __webpack_require__(9);
	var flight_types_service_1 = __webpack_require__(75);
	// constants
	var organization_constants_1 = __webpack_require__(57);
	var system_configuration_constants_1 = __webpack_require__(10);
	// classes
	var calculation_1 = __webpack_require__(77);
	var FlightMovementManagementController = (function (_super) {
	    __extends(FlightMovementManagementController, _super);
	    /* @ngInject */
	    FlightMovementManagementController.$inject = ["$scope", "$rootScope", "routeSegmentsService", "flightMovementManagementService", "aviationBillingEngineService", "aircraftTypeManagementService", "aircraftUnspecifiedManagementService", "$interval", "saveLocalTemplateService", "$uibModal", "systemConfigurationService", "reportsService", "$translate", "customDate", "$timeout", "serverDatetimeService", "$state", "flightMovementCategoryService", "$filter", "sysConfigBoolean"];
	    function FlightMovementManagementController($scope, $rootScope, routeSegmentsService, flightMovementManagementService, aviationBillingEngineService, aircraftTypeManagementService, aircraftUnspecifiedManagementService, $interval, saveLocalTemplateService, $uibModal, systemConfigurationService, reportsService, $translate, customDate, $timeout, serverDatetimeService, $state, flightMovementCategoryService, $filter, sysConfigBoolean) {
	        var _this = _super.call(this, $scope, flightMovementManagementService) || this;
	        _this.$scope = $scope;
	        _this.$rootScope = $rootScope;
	        _this.routeSegmentsService = routeSegmentsService;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.aviationBillingEngineService = aviationBillingEngineService;
	        _this.aircraftTypeManagementService = aircraftTypeManagementService;
	        _this.aircraftUnspecifiedManagementService = aircraftUnspecifiedManagementService;
	        _this.$interval = $interval;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.reportsService = reportsService;
	        _this.customDate = customDate;
	        _this.$timeout = $timeout;
	        _this.serverDatetimeService = serverDatetimeService;
	        _this.$state = $state;
	        _this.flightMovementCategoryService = flightMovementCategoryService;
	        _this.$filter = $filter;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        // used to save previous filter and sort state when disabling and reenabling
	        _this.previousFilterSort = {};
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.invoiceByFMCategory = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVOICE_FM_CATEGORY);
	        if ($scope.invoiceByFMCategory) {
	            $scope.notification_text = 'Note: Cannot generate an invoice when the selected flights are ' +
	                'from multiple accounts, are not pending, or have different flight movement categories';
	        }
	        else {
	            $scope.notification_text = 'Note: Cannot generate an invoice when the selected flights are ' +
	                'from multiple accounts or are not pending';
	        }
	        $scope.notification_text_mark_as_paid = 'Note: Some of the selected Flight Movements have charges associated. Mark as Paid not allowed.';
	        $scope.notification_no_aircraft_registration = 'Note: Some of the selected Flight Movements have Aircraft Registration for date does not exist';
	        $scope.verifyRouteEnabled = _this.sysConfigBoolean.parse(systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ENABLED_VALIDATION_ROUTE));
	        _this.$scope.selectedFlightCategories = [];
	        _this.$scope.selectedDepAerodromes = [];
	        _this.$scope.selectedDestAerodromes = [];
	        _this.$scope.selectedAircraftsTypes = [];
	        $scope.loadFlightCategoriesOptions = [];
	        _this.$scope.isAllCategoriesDeselected = false;
	        _this.$scope.isAllDepAerodromesDeselected = false;
	        _this.$scope.isAllDestAerodromesDeselected = false;
	        _this.$scope.isAllAircraftTypesDeselected = false;
	        _this.$rootScope.isFmCopied = false;
	        _this.$scope.isBalanceNegative = false;
	        _this.$scope.multiselectEvents = {
	            onItemSelect: _this.onItemSelect.bind(_this),
	            onItemDeselect: _this.onItemDeselect.bind(_this),
	            onSelectAll: _this.onSelectAll.bind(_this),
	            onDeselectAll: _this.onDeselectAll.bind(_this)
	        };
	        _this.$scope.multiselectEventsDepAerodromes = {
	            onItemSelect: _this.onItemSelectDepAerodrome.bind(_this),
	            onItemDeselect: _this.onItemDeselectDepAerodrome.bind(_this),
	            onSelectAll: _this.onSelectAllDepAerodrome.bind(_this),
	            onDeselectAll: _this.onDeselectAllDepAerodrome.bind(_this)
	        };
	        _this.$scope.multiselectEventsDestAerodromes = {
	            onItemSelect: _this.onItemSelectDestAerodrome.bind(_this),
	            onItemDeselect: _this.onItemDeselectDestAerodrome.bind(_this),
	            onSelectAll: _this.onSelectAllDestAerodrome.bind(_this),
	            onDeselectAll: _this.onDeselectAllDestAerodrome.bind(_this)
	        };
	        _this.$scope.multiselectEventsAircraftTypes = {
	            onItemSelect: _this.onItemSelectAircraftType.bind(_this),
	            onItemDeselect: _this.onItemDeselectAircraftType.bind(_this),
	            onSelectAll: _this.onSelectAllAircraftType.bind(_this),
	            onDeselectAll: _this.onDeselectAllAircraftType.bind(_this)
	        };
	        $scope.loadFlightCategoriesOptions = _this.flightMovementCategoryService.getFlightMovementCategoryForAviationInvoice().then(function (categories) {
	            _this.$scope.flightCategoryOptions = categories;
	        }).catch(function (error) {
	            console.error("Failed to load flight movement categories:", error);
	        });
	        $scope.loadAerodromesOptions = _this.flightMovementManagementService.getAerodromesByBillingCentre().then(function (aerodromes) {
	            _this.$scope.aerodromesOptions = aerodromes;
	        }).catch(function (error) {
	            console.error("Failed to load aerodromes:", error);
	        });
	        $scope.loadAircraftTypesOptions = _this.aircraftTypeManagementService.findAllMinimalReturn().then(function (aircraftsTypes) {
	            _this.$scope.aircraftTypesOptions = aircraftsTypes;
	        }).catch(function (error) {
	            console.error("Failed to load aircraft types:", error);
	        });
	        $scope.clearVerify = function () {
	            $scope.verifyResult = null;
	            $scope.verifyInProgress = false;
	            $scope.$broadcast('resetVerifyResult');
	        };
	        // duplicate|missing flight properties, functions
	        $scope.showDuplicateMissing = false;
	        $scope.showAllFlights = true;
	        $scope.locateDuplicateMissingFlights = function (enable) { return _this.locateDuplicateMissingFlights(enable); };
	        $scope.isEANS = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANS;
	        // if flight was called from Crco Message
	        if ($state.params.flightId) {
	            $timeout(function () { _this.$scope.toggle = true; });
	            flightMovementManagementService.listAll().then(function (data) { return _this.findFlightMovement(data.content, $state.params.flightId); });
	        }
	        flightMovementCategoryService.listAll().then(function (resp) {
	            $scope.flightCategories = resp;
	        });
	        // actual dep|dest ad properties, functions, events
	        /*
	          Use local template incase sort saved, need this in constructor as saveLocalTemplate.service
	          will trigger cannedSort watch on tableSort.directive which checks the sort attribute of each
	          th element. Even though this is set correctly by saveLocalTemplate.service, tableSort.directive
	          is unaware of the change as no digest has finished to update the sort attribute by the time the
	          cannedSort watcher is fired.
	        */
	        $scope.showActualDepDestAd = _this.localTemplateQueryStringActualAd();
	        $scope.showActualDepAd = $scope.showActualDepDestAd;
	        $scope.showActualDestAd = $scope.showActualDepDestAd;
	        $scope.$on('table-sort-item-value-changed', function (event, newValue, oldValue, isSorted) {
	            return _this.tableSortItemValueChanged(event, newValue, oldValue, isSorted);
	        });
	        $scope.refreshOverride = function (reset, sort) { return _this.refreshOverride(reset, sort); };
	        $scope.selectedFlightMovements = [];
	        $scope.getFlightType = function (flightType) { return flight_types_service_1.FlightType[flightType]; };
	        $scope.showFlightMovementOnMap = function (flightMovement) { return _this.showFlightMovementOnMap(flightMovement); };
	        $scope.checkboxesSelected = function () { return _this.getIdsFromCheckboxes(); }; // checks if any flightmovements selected and then enables / disables buttons
	        $scope.allowInvoice = function () { return _this.allowInvoice(_this.getIdsFromCheckboxes()); };
	        $scope.markManualInputs = function (flightMovement) { return _this.markManualInputs(flightMovement); };
	        $scope.addFlightMovementToPlan = function (flightMovement) { return _this.addFlightMovementToPlan(flightMovement); }; // get flight movement
	        $scope.copyFlightMovementToForm = function (flightMovement) { return _this.copyFlightMovementToForm(flightMovement); };
	        $scope.countSelected = function () {
	            var flights = _this.getIdsFromCheckboxes();
	            var filterFlights = _this.$scope.list.filter(function (item) { return flights.indexOf(item.id) > -1; });
	            var flagDisableButton = false;
	            var showAircraftRegistrationWarning = false;
	            var filterNoAircraftRegistration = filterFlights.filter(function (item) { return item.item18_reg_num === ''; });
	            if (filterNoAircraftRegistration.length > 0) {
	                showAircraftRegistrationWarning = true;
	            }
	            else {
	                showAircraftRegistrationWarning = false;
	            }
	            var filterstatus = filterFlights.filter(function (item) { return item.status != 'PENDING'; });
	            var filterenroutecharges = filterFlights.filter(function (item) { return item.enroute_charges != 0 && item.enroute_charges !== null; });
	            var filterLanding = filterFlights.filter(function (item) { return item.approach_charges !== 0 && item.late_arrival_charges !== null; });
	            var filterLatArr = filterFlights.filter(function (item) { return item.late_arrival_charges !== 0 && item.late_arrival_charges !== null; });
	            var filterLateDep = filterFlights.filter(function (item) { return item.late_departure_charges !== 0 && item.late_departure_charges !== null; });
	            var filterExtendedHours = filterFlights.filter(function (item) { return item.extended_hours_surcharge !== 0 && item.extended_hours_surcharge !== null; });
	            var filterDomestic = filterFlights.filter(function (item) { return item.domestic_passenger_charges !== 0 && item.domestic_passenger_charges !== null; });
	            var filterInternational = filterFlights.filter(function (item) { return item.international_passenger_charges !== 0 && item.international_passenger_charges !== null; });
	            if (filterenroutecharges.length > 0 || filterstatus.length > 0 || filterLanding.length > 0 || filterLatArr.length > 0 || filterLateDep.length > 0 || filterExtendedHours.length > 0
	                || filterDomestic.length > 0 || filterInternational.length > 0) {
	                flagDisableButton = true;
	            }
	            else {
	                flagDisableButton = false;
	            }
	            $scope.flagDisableButton = flagDisableButton;
	            $scope.showAircraftRegistrationWarning = showAircraftRegistrationWarning;
	            $scope.numberOfSelectedMovements = $scope.selectedRecords = flights.length;
	            $scope.isAllowedInvoice = _this.allowInvoice(flights);
	            $scope.notAllowedRecalculate = _this.allowInvoiceRecalculation(flights);
	            $scope.allFlightsSelected = _this.areAllFlightsSelected();
	        };
	        $scope.numberOfSelectedMovements = 0;
	        $scope.numberOfDaysOfFlightData = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.NUMBER_OF_DAYS_OF_FLIGHT_DATA);
	        $scope.distanceUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE);
	        $scope.isKCAA = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.KCAA;
	        $scope.translateResolutionErrors = function (resolutionErrors) {
	            if (resolutionErrors) {
	                return resolutionErrors.map(function (rE) { return $translate.instant(rE); });
	            }
	        };
	        aircraftTypeManagementService.findAllMinimalReturn().then(function (data) { return _this.updateAircraftTypeList(data); });
	        $scope.modal = $uibModal;
	        $scope.open = function () { return _this.open(); };
	        $scope.$on('$destroy', function () { return $rootScope.$broadcast('map.toggle', 'Layers Off', []); });
	        var recalculate = new calculation_1.Calculation('recalculateJob', 'executeSpecificRecalculation', 'cancelSpecificRecalculation', 'getStatusForSpecificRecalculate', null, $scope, aviationBillingEngineService, $interval, serverDatetimeService, $rootScope);
	        var reconcile = new calculation_1.Calculation('reconcileJob', 'executeSpecificReconciliation', 'cancelSpecificReconciliation', 'getStatusForSpecificReconciliation', null, $scope, aviationBillingEngineService, $interval, serverDatetimeService, $rootScope);
	        // specific recalculate methods
	        $scope.executeRecalculation = function () {
	            recalculate.executeCalculation(_this.getIdsFromCheckboxes().join(','));
	            _this.resetSelectedFlightMovements();
	        };
	        $scope.cancelRecalculation = function () { return recalculate.cancelCalculation(); };
	        recalculate.checkStatusOnPageLoad();
	        // specific reconcile methods
	        $scope.executeReconciliation = function () { return reconcile.executeCalculation(_this.getIdsFromCheckboxes().join(',')); };
	        $scope.cancelReconciliation = function () { return reconcile.cancelCalculation(); };
	        $scope.generateInvoice = function (accountId, flightIdList) { return _this.generateInvoice(accountId, flightIdList); };
	        reconcile.checkStatusOnPageLoad();
	        // override edit to get sys config distance
	        $scope.edit = function (fm) { return _this.editOverride(fm); };
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.incompleteReasons = flightMovementManagementService.getAllIncompleteReasons();
	        $scope.fmGenerateError = 0;
	        // $timeout called without a delay specified waits for the next digest cycle before firing callback
	        $timeout(function () { return _this.saveLocalTemplate(); });
	        $scope.deleteOverride = function (id, reason) { return flightMovementManagementService.deleteOverride(id, reason)
	            .then(function () { return _this.refreshOverride(); })
	            .catch(function (error) {
	            _this.$scope.error = { error: error };
	        }); };
	        $scope.updateOverride = function (flightMovement, id, undeletionReason) { return _this.updateOverride(flightMovement, id, undeletionReason); };
	        $scope.showWarning = function (actionOne, actionTwo) { return _this.$scope.error = flightMovementManagementService.showWarning(actionOne, actionTwo); };
	        $scope.resetFilters = function () { return _this.resetFilters(); };
	        $scope.parseSecondLine = function (initialFplData, aircraftType) { return _this.parseSecondLine(initialFplData, aircraftType); };
	        $scope.extractInitialDigits = function (inputString, aircraftType) { return _this.extractInitialDigits(inputString, aircraftType); };
	        // use to initialise pagination display
	        $scope.selectedRecords = 0;
	        $scope.toggleAllFlights = function () { return _this.toggleAllFlights(); };
	        //Gestione All Aerodromes in FM Filter
	        $scope.isAllAerodromesActive = systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.ALL_AERODROMES_FM_FILTERS) === true;
	        _this.$scope.listSelectedDepAerodromes = [];
	        _this.$scope.listSelectedDestAerodromes = [];
	        flightMovementManagementService.getAirportFromNavDBByQuery(null).then(function (res) {
	            _this.$scope.allAerodromes = res.content || [];
	        });
	        _this.$scope.toggleDropdown = function (dropdownName, $event) {
	            if ($event)
	                $event.stopPropagation();
	            var relatedQuery = dropdownName === "dropdownDepAerodromesOpen"
	                ? _this.$scope.searchQueryDep
	                : _this.$scope.searchQueryDest;
	            if (!relatedQuery || !relatedQuery.trim()) {
	                return;
	            }
	            var otherDropdown = dropdownName === "dropdownDepAerodromesOpen"
	                ? "dropdownDestAerodromesOpen"
	                : "dropdownDepAerodromesOpen";
	            var justOpenedFlag = dropdownName + "JustOpened";
	            _this.$scope[dropdownName] = true;
	            _this.$scope[justOpenedFlag] = true;
	            _this.$scope[otherDropdown] = false;
	            setTimeout(function () {
	                _this.$scope[justOpenedFlag] = false;
	            }, 200);
	        };
	        document.addEventListener("click", function () {
	            _this.$scope.$apply(function () {
	                _this.$scope.dropdownDepAerodromesOpen = false;
	                _this.$scope.dropdownDestAerodromesOpen = false;
	            });
	        });
	        _this.$scope.isSelected = function (aero, type) {
	            var listField = "listSelected" + type + "Aerodromes";
	            var list = _this.$scope[listField] || [];
	            return list.some(function (a) {
	                if (!a)
	                    return false;
	                if (typeof a === "object" && a.ident)
	                    return a.ident === aero.ident;
	                if (typeof a === "string")
	                    return a === aero.ident;
	                return false;
	            });
	        };
	        _this.$scope.toggleSelection = function (aero, listName, $event) {
	            if ($event)
	                $event.stopPropagation();
	            var list = _this.$scope[listName] || [];
	            var idx = list.findIndex(function (a) {
	                if (typeof a === "object" && a.ident)
	                    return a.ident === aero.ident;
	                if (typeof a === "string")
	                    return a === aero.ident;
	                return false;
	            });
	            if (idx >= 0) {
	                list.splice(idx, 1);
	            }
	            else {
	                list.push(aero);
	            }
	            _this.$scope[listName] = list;
	            _this.refreshOverride();
	        };
	        _this.$scope.removeSelection = function (aero, type, $event) {
	            $event.stopPropagation();
	            var listName = type === "dep" ? "listSelectedDepAerodromes" : "listSelectedDestAerodromes";
	            var searchField = type === "dep" ? "searchQueryDep" : "searchQueryDest";
	            var aeroIdent = typeof aero === "object" && aero.ident ? aero.ident : aero;
	            _this.$scope[listName] = (_this.$scope[listName] || []).filter(function (a) {
	                var aIdent = typeof a === "object" && a.ident ? a.ident : a;
	                return aIdent !== aeroIdent;
	            });
	            if (_this.$scope[listName].length === 0) {
	                _this.$scope[searchField] = "";
	            }
	            _this.refreshOverride();
	        };
	        $scope.selectAll = function (type) {
	            if (type === 'dep') {
	                $scope.listSelectedDepAerodromes = $scope.filteredDepAerodromes.slice();
	            }
	            else if (type === 'dest') {
	                $scope.listSelectedDestAerodromes = $scope.filteredDestAerodromes.slice();
	            }
	            $scope.refreshOverride();
	        };
	        $scope.deselectAll = function (type) {
	            if (type === 'dep') {
	                $scope.listSelectedDepAerodromes = [];
	                $scope.searchQueryDep = '';
	            }
	            else if (type === 'dest') {
	                $scope.listSelectedDestAerodromes = [];
	                $scope.searchQueryDest = '';
	            }
	            $scope.refreshOverride();
	        };
	        _this.$scope.onSearchChange = function (type) {
	            var queryField = "searchQuery" + type;
	            var filteredField = "filtered" + type + "Aerodromes";
	            var dropdownField = "dropdown" + type + "AerodromesOpen";
	            var timeoutField = "typingTimeout" + type;
	            var rawValue = _this.$scope[queryField] || "";
	            var query = rawValue.split(",").pop().trim();
	            if (!query) {
	                _this.$scope[filteredField] = [];
	                _this.$scope[dropdownField] = false;
	                return;
	            }
	            if (_this.$scope[timeoutField]) {
	                clearTimeout(_this.$scope[timeoutField]);
	            }
	            _this.$scope[timeoutField] = setTimeout(function () {
	                flightMovementManagementService.getAirportFromNavDBByQuery(query)
	                    .then(function (res) {
	                    _this.$scope[filteredField] = res || [];
	                    _this.$scope[dropdownField] = _this.$scope[filteredField].length > 0;
	                });
	            }, 300);
	        };
	        // selected flights should be reset whenever filters are changed
	        $scope.$watchGroup([
	            'search',
	            'selectedFlightCategories',
	            'selectedDepAerodromes',
	            'selectedDestAerodromes',
	            'flightMovementStatusFilter',
	            'incompleteFlightReason',
	            'accountTypeFilter',
	            'invoiceStatusFilter',
	            'showDuplicateMissing',
	            'showActualDepDestAd',
	            'control.start.date',
	            'control.end.date',
	            'showAllFlights',
	            'fmStatusFilter',
	            'flightRulesFilter',
	            'flightTypeFilter',
	            'crcoFlightFilter',
	            'flightIdFilter',
	            'selectedAircraftsTypes'
	        ], function () {
	            _this.resetSelectedFlightMovements();
	            _this.getFilterParameters();
	        });
	        $scope.$watch('list', function () {
	            if ($scope.list) {
	                $scope.currentFlightIds = $scope.list.map(function (flight) { return flight.id; });
	            }
	        });
	        $scope.$watch('reconcileJob.job_execution_status', function (newStatus) {
	            if (newStatus === 'COMPLETED' || newStatus === 'CANCELED') {
	                $rootScope.isIconDisabled = false; // Abilita l'icona
	                $rootScope.isBlinking = true; //
	            }
	            else {
	                $rootScope.isIconDisabled = true; // Disabilita l'icona
	                $rootScope.isBlinking = false; //
	            }
	        });
	        // watch for tasp_charge_currency is set and apply it to the scope variable, remove watch once complete
	        var setDefaultTaspCurrency = $scope.$watch('editable.tasp_charge_currency', function () {
	            if ($scope.editable.tasp_charge_currency) {
	                $scope.defaultTaspCurrency = $scope.editable.tasp_charge_currency;
	                setDefaultTaspCurrency();
	            }
	        });
	        $scope.resetSelectedFlightMovements = function () { return _this.resetSelectedFlightMovements(); };
	        _this.setDefaultFields();
	        $scope.markZeroFlightCostsAsPaid = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MARK_ZERO_FLIGHT_COSTS_AS_PAID);
	        $scope.markAsPaid = function (flightIdList) { return _this.markAsPaid(flightIdList); };
	        $scope.checkBalance = function (flightMovement) { return _this.checkBalance(flightMovement); };
	        return _this;
	    }
	    FlightMovementManagementController.prototype.triggerPopup = function (flightMovement, popupText) {
	        // Manually show the popup using the existing directive
	        this.$scope.popupText = popupText;
	        this.$scope.$broadcast('triggerPopup');
	    };
	    FlightMovementManagementController.prototype.checkBalance = function (flightMovement) {
	        var _this = this;
	        this.flightMovementManagementService.checkBalance(flightMovement)
	            .then(function (response) {
	            _this.$scope.showPopup = response;
	            if (_this.$scope.showPopup === true) {
	                // Show the popup manually
	                var popupText = "Balance is negative. Are you sure you want to create?";
	                _this.triggerPopup(flightMovement, popupText);
	            }
	            else {
	                // Directly create if balance is not negative
	                _this.createFromCopy(flightMovement);
	            }
	        })
	            .catch(function (error) {
	            _this.$scope.error = error;
	        });
	    };
	    FlightMovementManagementController.prototype.onItemSelect = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onItemDeselect = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onSelectAll = function (items) {
	        this.$scope.selectedFlightCategories = this.$scope.flightCategoryOptions.slice();
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onDeselectAll = function (items) {
	        this.$scope.isAllCategoriesDeselected = true;
	        this.refreshOverride();
	        this.$scope.isAllCategoriesDeselected = false;
	    };
	    FlightMovementManagementController.prototype.onItemSelectDepAerodrome = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onItemDeselectDepAerodrome = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onSelectAllDepAerodrome = function (items) {
	        this.$scope.selectedDepAerodromes = this.$scope.aerodromesOptions.slice();
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onDeselectAllDepAerodrome = function (items) {
	        this.$scope.isAllDepAerodromesDeselected = true;
	        this.refreshOverride();
	        this.$scope.isAllDepAerodromesDeselected = false;
	    };
	    FlightMovementManagementController.prototype.onItemSelectDestAerodrome = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onItemDeselectDestAerodrome = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onSelectAllDestAerodrome = function (items) {
	        this.$scope.selectedDestAerodromes = this.$scope.aerodromesOptions.slice();
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onDeselectAllDestAerodrome = function (items) {
	        this.$scope.isAllDestAerodromesDeselected = true;
	        this.refreshOverride();
	        this.$scope.isAllDestAerodromesDeselected = false;
	    };
	    FlightMovementManagementController.prototype.onItemSelectAircraftType = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onItemDeselectAircraftType = function (item) {
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onSelectAllAircraftType = function (items) {
	        this.$scope.selectedAircraftsTypes = this.$scope.aircraftTypesOptions.slice();
	        this.refreshOverride();
	    };
	    FlightMovementManagementController.prototype.onDeselectAllAircraftType = function (items) {
	        this.$scope.isAllAircraftTypesDeselected = true;
	        this.refreshOverride();
	        this.$scope.isAllAircraftTypesDeselected = false;
	    };
	    FlightMovementManagementController.prototype.parseSecondLine = function (initialFplData, aircrafType) {
	        if (initialFplData) {
	            var lines = initialFplData.split('\n');
	            // Seleziona la seconda riga estraendola dalla stringa
	            var secondLine = lines.length > 1 ? lines[1] : '';
	            var parts = secondLine.split('/');
	            // Seleziona la prima parte prima del primo "/"
	            var aircraftType = parts.length > 0 ? parts[0] : '';
	            // Rimuovi eventuali trattini iniziali
	            var cleanAircraftType = aircraftType.replace(/^-/, '');
	            return this.extractInitialDigits(cleanAircraftType.trim(), aircrafType.trim());
	        }
	        return "";
	    };
	    FlightMovementManagementController.prototype.create = function (flightMovement) {
	        if (this.$rootScope.isFmCopied)
	            return _super.prototype.createFromCopy.call(this, this.trackManualInputs(flightMovement));
	        else
	            return _super.prototype.create.call(this, this.trackManualInputs(flightMovement));
	    };
	    FlightMovementManagementController.prototype.updateOverride = function (flightMovement, id, undeletionReason) {
	        var _this = this;
	        var originalStatusNotes = flightMovement.status_notes;
	        if (undeletionReason) {
	            var reason = (flightMovement.status_notes ? flightMovement.status_notes : '') + " Undeleted: " + undeletionReason + "; ";
	            flightMovement.status_notes = reason.substring(0, Math.min(reason.length, 300));
	        }
	        return _super.prototype.update.call(this, this.trackManualInputs(flightMovement), id)
	            .then(function (result) {
	            if (result.warnings && _this.$scope.verifyRouteEnabled) {
	                _this.$scope.showWarnings = true;
	                _this.$scope.warningsList = result.warnings;
	            }
	            return result;
	        })
	            .catch(function (error) {
	            _this.$scope.error = { error: error };
	            flightMovement.status_notes = originalStatusNotes;
	        });
	    };
	    FlightMovementManagementController.prototype.reset = function () {
	        this.$scope.manual = {};
	        _super.prototype.reset.call(this);
	        this.setDefaultFields();
	    };
	    FlightMovementManagementController.prototype.convertSelectedIdsFlightCategoriesToIntegerArray = function () {
	        var maxSize = 0;
	        if (this.$scope.flightCategoryOptions) {
	            maxSize = this.$scope.flightCategoryOptions.length;
	        }
	        if (Array.isArray(this.$scope.selectedFlightCategories) && Array.isArray(this.$scope.flightCategoryOptions)) {
	            if (this.$scope.isAllCategoriesDeselected === true) {
	                // When all categories are deselected
	                this.$scope.selectedFlightCategories = [];
	                return [];
	            }
	            if (this.$scope.selectedFlightCategories.length === 0) {
	                // When the list is empty after deselecting the last item
	                return [];
	            }
	            else {
	                // Normal case, map selected items to their IDs
	                return this.$scope.selectedFlightCategories.map(function (item) { return parseInt(item.id, 10); });
	            }
	        }
	        // Default to an empty array if the conditions are not met
	        return [];
	    };
	    FlightMovementManagementController.prototype.convertSelectedIdsDepAerodromesToIntegerArray = function () {
	        if (this.$scope.isAllDepAerodromesDeselected) {
	            return [];
	        }
	        if (!this.$scope.isAllAerodromesActive && Array.isArray(this.$scope.selectedDepAerodromes)) {
	            return this.$scope.selectedDepAerodromes.map(function (item) { return item.aerodrome_name.toString(); });
	        }
	        if (Array.isArray(this.$scope.listSelectedDepAerodromes)) {
	            return this.$scope.listSelectedDepAerodromes.map(function (item) {
	                // Se item è oggetto, usa item.ident
	                if (item && typeof item === "object" && item.ident) {
	                    return item.ident.toString();
	                }
	                // Se è una stringa, la restituisco direttamente
	                if (typeof item === "string") {
	                    return item;
	                }
	                return ""; // fallback sicuro
	            }).filter(Boolean); // rimuove eventuali stringhe vuote
	        }
	        return [];
	    };
	    FlightMovementManagementController.prototype.convertSelectedIdsDestAerodromesToIntegerArray = function () {
	        if (this.$scope.isAllDestAerodromesDeselected) {
	            return [];
	        }
	        if (!this.$scope.isAllAerodromesActive && Array.isArray(this.$scope.selectedDestAerodromes)) {
	            return this.$scope.selectedDestAerodromes.map(function (item) { return item.aerodrome_name.toString(); });
	        }
	        if (Array.isArray(this.$scope.listSelectedDestAerodromes)) {
	            return this.$scope.listSelectedDestAerodromes.map(function (item) {
	                // Se item è oggetto, usa item.ident
	                if (item && typeof item === "object" && item.ident) {
	                    return item.ident.toString();
	                }
	                // Se è una stringa, la restituisco direttamente
	                if (typeof item === "string") {
	                    return item;
	                }
	                return ""; // fallback sicuro
	            }).filter(Boolean); // rimuove eventuali stringhe vuote
	        }
	        return [];
	    };
	    FlightMovementManagementController.prototype.convertSelectedAircfartTypesToIntegerArray = function () {
	        if (this.$scope.isAllAircraftTypesDeselected) {
	            return [];
	        }
	        if (Array.isArray(this.$scope.selectedAircraftsTypes)) {
	            return this.$scope.selectedAircraftsTypes.map(function (item) { return item.aircraft_type.toString(); });
	        }
	        return [];
	    };
	    // returns the selected fligth id from Crco Message
	    FlightMovementManagementController.prototype.findFlightMovement = function (accountList, params) {
	        for (var i = 0; i < accountList.length; i++) {
	            if (accountList[i].id === parseInt(params, 10)) {
	                this.$scope.editable = accountList[i];
	                break;
	            }
	        }
	    };
	    /**
	     * Override edit to show the distance based on the system config value.
	     *
	     * @param fm flight movement editing
	     */
	    FlightMovementManagementController.prototype.editOverride = function (fm) {
	        var _this = this;
	        this.$scope.showErrorOnlyOnForm = false;
	        var flightMovement = this.systemConfigurationService.convertDistanceProperty(angular.copy(fm), 'user_crossing_distance', this.$scope.distanceUnitOfMeasure);
	        _super.prototype.edit.call(this, flightMovement);
	        this.$timeout(function () {
	            if (flightMovement.source !== 'manual') {
	                for (var i in _this.$scope.form) {
	                    if (_this.$scope.form[i] && _this.$scope.form[i].$name && !_this.$scope.form[i].$valid) {
	                        _this.$scope.form[i].$setDirty(); // sets the input as dirty, for scss reasons
	                        _this.$scope.form[i].$setTouched(); // sets the input as touched, for scss reasons
	                        _this.$scope.showErrorOnlyOnForm = true;
	                    }
	                }
	            }
	        });
	    };
	    /**
	     * Define current Data, Filter, and QueryString for use the next time the page is loaded.
	     */
	    FlightMovementManagementController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search'], ['flightCategoryFilter', 'type'], ['flightMovementStatusFilter', 'status'],
	            ['incompleteFlightReason', 'issue'], ['accountTypeFilter', 'iata'], ['invoiceStatusFilter', 'invoice'],
	            ['showDuplicateMissing', 'duplicatesOrMissing'], ['showAllFlights', 'showAllFlights'],
	            ['showActualDepDestAd', 'showActualDepDest'], ['fmStatusFilter', 'fmStatusFilter'],
	            ['flightRulesFilter', 'flight_rules'], ['flightTypeFilter', 'flight_type'], ['crcoFlightFilter', 'crco_flight'], ['flightIdFilter', 'flight_id']];
	        if (!localStorage_service_1.LocalStorageService.get('flight-movement-managementFilters')) {
	            // reset the filters to their default settings
	            this.resetFilters();
	        }
	        else {
	            this.$scope.list = [];
	        }
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'flight-movement-management', filterPairs);
	    };
	    /**
	     * Return true if actualDepAd or actualDestAd exists in local QueryString template.
	     *
	     * @returns true if exists in local QueryString
	     */
	    FlightMovementManagementController.prototype.localTemplateQueryStringActualAd = function () {
	        var queryString = localStorage_service_1.LocalStorageService.get('flight-movement-managementQueryString');
	        return queryString && (queryString.indexOf('actualDepAd') !== -1 || queryString.indexOf('actualDestAd') !== -1);
	    };
	    FlightMovementManagementController.prototype.trackManualInputs = function (editableFlightMovement) {
	        var trackableFields = this.service.getTrackableFields();
	        var originalFlightMovement;
	        var changedFieldsArray;
	        for (var _i = 0, _a = this.$scope.list; _i < _a.length; _i++) {
	            var flightMovement = _a[_i];
	            if (flightMovement.id === editableFlightMovement.id) {
	                originalFlightMovement = Object.assign({}, flightMovement);
	            }
	        }
	        if (originalFlightMovement === undefined || originalFlightMovement === null) {
	            editableFlightMovement.manually_changed_fields = '';
	            for (var key in editableFlightMovement) {
	                if (editableFlightMovement[key] !== null && editableFlightMovement[key] !== '') {
	                    if (trackableFields.includes(key)) {
	                        editableFlightMovement.manually_changed_fields += key + ",";
	                    }
	                }
	            }
	            editableFlightMovement.manually_changed_fields = editableFlightMovement.manually_changed_fields.slice(0, -1);
	            return editableFlightMovement;
	        }
	        // check NON manually created flights
	        changedFieldsArray = this.trackNonManualFlights(originalFlightMovement, editableFlightMovement);
	        for (var _b = 0, changedFieldsArray_1 = changedFieldsArray; _b < changedFieldsArray_1.length; _b++) {
	            var changedField = changedFieldsArray_1[_b];
	            if (!trackableFields.includes(changedField)) {
	                changedFieldsArray.splice(changedFieldsArray.indexOf(changedField), 1);
	            }
	        }
	        if (editableFlightMovement.manually_changed_fields) {
	            var set = new Set(editableFlightMovement.manually_changed_fields.split(',').concat(changedFieldsArray));
	            editableFlightMovement.manually_changed_fields = Array.from(set).join(',');
	        }
	        else {
	            editableFlightMovement.manually_changed_fields = changedFieldsArray.join(',');
	        }
	        return editableFlightMovement;
	    };
	    FlightMovementManagementController.prototype.markManualInputs = function (_a) {
	        var manually_changed_fields = _a.manually_changed_fields;
	        var manuallyChangedFields = {};
	        var fieldsArray = [];
	        if (manually_changed_fields) {
	            fieldsArray = manually_changed_fields.split(',');
	            for (var _i = 0, fieldsArray_1 = fieldsArray; _i < fieldsArray_1.length; _i++) {
	                var field = fieldsArray_1[_i];
	                manuallyChangedFields[field] = true;
	            }
	        }
	        this.$scope.manual = manuallyChangedFields;
	        this.$rootScope.isFmCopied = false;
	    };
	    // tracks modified inputs for non-manual flights
	    FlightMovementManagementController.prototype.trackNonManualFlights = function (originalFlightMovement, editableFlightMovement) {
	        var diff = {};
	        for (var key in originalFlightMovement) {
	            if (originalFlightMovement[key] === null && editableFlightMovement[key] === '') {
	                editableFlightMovement[key] = null;
	            }
	            else if (originalFlightMovement[key] !== editableFlightMovement[key] && editableFlightMovement[key] !== undefined) {
	                // we must make sure that DOF compares with the same time zone
	                if (key === 'date_of_flight') {
	                    if (originalFlightMovement[key].slice(0, 10) !== editableFlightMovement[key].toISOString().slice(0, 10)) {
	                        diff[key] = editableFlightMovement[key];
	                    }
	                    else {
	                        continue;
	                    }
	                }
	                diff[key] = editableFlightMovement[key];
	            }
	        }
	        return Object.keys(diff);
	    };
	    /**
	     * All selected flights must have a status of pending
	     * All selected flights must belong to the same account
	     * All selected flights must have same fm category if INVOICE_FM_CATEGORY = 't'
	     * @param  {Array<number>} ids
	     * @returns boolean
	     */
	    FlightMovementManagementController.prototype.allowInvoice = function (ids) {
	        var accountSet = new Set();
	        var categorySet = new Set();
	        var output = true;
	        this.$scope.fmGenerateError = 0;
	        this.$scope.fmFlightCategory = null;
	        this.$scope.selectedFlights = this.getIdsFromCheckboxes();
	        for (var i = 0; i < this.$scope.list.length; i++) {
	            if (ids.includes(this.$scope.list[i].id)) {
	                if (this.$scope.selectedFlights !== undefined && this.$scope.selectedFlights.length === 1) {
	                    if (this.$scope.list[i].total_charges === 0)
	                        return false;
	                }
	                if (this.$scope.list[i].status === 'PENDING') {
	                    accountSet.add(this.$scope.list[i].associated_account_id);
	                }
	                else {
	                    this.$scope.fmGenerateError = 2;
	                    return false;
	                }
	                ;
	                categorySet.add(this.$scope.list[i].flightmovement_category_name);
	            }
	            ;
	        }
	        ;
	        if (this.$scope.invoiceByFMCategory && categorySet.size > 1) {
	            this.$scope.fmGenerateError = 3;
	            output = false;
	        }
	        ;
	        if (accountSet.size > 1) {
	            if (this.$scope.fmGenerateError === 0) {
	                this.$scope.fmGenerateError = 1;
	            }
	            ;
	            return false;
	        }
	        else {
	            this.$scope.accountId = accountSet.values().next().value;
	        }
	        ;
	        // check if 'Invoice by flight movement category' in sys config set to true and
	        // flights have a 'pending' status and
	        // belong to the same account with the same flight category
	        if (this.$scope.invoiceByFMCategory && output && categorySet.size === 1) {
	            this.getFmFlightCategory(categorySet.values().next().value.toString());
	        }
	        if (this.$scope.selectedFlights !== undefined && this.$scope.selectedFlights.length > 1) {
	            var allAreZero = this.$scope.list
	                .filter(function (item) { return ids.includes(item.id); }) // Filtra solo gli elementi con id presenti in `ids`
	                .every(function (item) { return item.total_charges === 0; });
	            return !allAreZero;
	        }
	        return output;
	    };
	    FlightMovementManagementController.prototype.getFmFlightCategory = function (name) {
	        var flightCategory = this.$scope.flightCategories.find(function (element) { return element.name === name; });
	        this.$scope.fmFlightCategory = flightCategory ? flightCategory.id : null;
	    };
	    /**
	     * All selected flights must not have a status of DELETED
	     * @param  {Array<number>} ids
	     * @returns boolean
	     */
	    FlightMovementManagementController.prototype.allowInvoiceRecalculation = function (ids) {
	        return this.$scope.list
	            .filter(function (flight) { return ids.includes(flight.id); })
	            .some(function (flight) { return flight.status === 'DELETED'; });
	    };
	    FlightMovementManagementController.prototype.addFlightMovementToPlan = function (flightMovement) {
	        var _this = this;
	        this.$scope.fpl = null;
	        for (var _i = 0, _a = this.$scope.list; _i < _a.length; _i++) {
	            var flight = _a[_i];
	            if (flightMovement.id === flight.id) {
	                flightMovement = flight;
	                break;
	            }
	        }
	        this.$scope.editable = flightMovement;
	        var segmentType = this.findType(flightMovement);
	        this.routeSegmentsService.getRouteSegmentsByTypeAndFlightMovementId(flightMovement.id, segmentType) // get segments for movement
	            .then(function (data) { return _this.$scope.specificRouteSegments = _this.parseRouteSegments(data.content, flightMovement); }, // parse segments
	        function (error) { return _this.$scope.specificRouteSegments = []; }); // this ensures that previous segments will be cleared if there is an error
	        this.flightMovementManagementService.findInitialFpl(flightMovement.id).then(function (response) {
	            _this.$scope.fpl = response;
	        });
	        ;
	    };
	    FlightMovementManagementController.prototype.copyFlightMovementToForm = function (flightMovement) {
	        this.edit(flightMovement);
	        this.$rootScope.isFmCopied = true;
	    };
	    FlightMovementManagementController.prototype.findType = function (flightMovement) {
	        var source = flightMovement.source.toUpperCase();
	        var type = 'SCHED'; // default segment type for manual, aftn, amhs, and spatia flight movements
	        this.$scope.dynamicRoute = flightMovement.fpl_route; // default sched route
	        if (source === 'RADAR-SUMMARY') {
	            type = 'RADAR';
	            this.$scope.dynamicRoute = flightMovement.radar_route_text;
	        }
	        else if (source === 'ATC-LOG') {
	            type = 'ATC';
	            this.$scope.dynamicRoute = flightMovement.atc_log_route_text;
	        }
	        else if (source === 'TOWER-LOG') {
	            type = 'TOWER';
	            this.$scope.dynamicRoute = flightMovement.tower_log_route_text;
	        }
	        return type;
	    };
	    FlightMovementManagementController.prototype.open = function () {
	        var _this = this;
	        var modalContent = angular.element(document.querySelector('.modal-content'));
	        var modal = angular.element(document.querySelector('.modal-movable'));
	        if (modalContent.length > 0 && modal.length > 0) {
	            modal.css('height', modalContent[0].offsetHeight + 'px');
	        }
	        setTimeout(function () {
	            _this.$scope.modal.open({
	                templateUrl: 'app/partials/flight-movement-management/flight-plan.template.html',
	                controller: FlightMovementManagementController,
	                windowClass: 'app-modal-window',
	                scope: _this.$scope,
	                appendTo: angular.element(document.querySelector('#flight-plan-modal-holder'))
	            });
	        }, 140);
	    };
	    FlightMovementManagementController.prototype.getIdsFromCheckboxes = function () {
	        var _this = this;
	        var keys = Object.keys(this.$scope.selectedFlightMovements);
	        return keys.filter(function (key) { return _this.$scope.selectedFlightMovements[key]; }).map(Number);
	    };
	    FlightMovementManagementController.prototype.showFlightMovementOnMap = function (flightMovement) {
	        this.$rootScope.$broadcast('map.flyToEntity', map_constants_1.MapFlyToEntityType.SINGLE_FLIGHT_MOVEMENT, [flightMovement]);
	    };
	    FlightMovementManagementController.prototype.parseRouteSegments = function (segments, flightMovement) {
	        var flightRouteDestination = flightMovement.dest_ad.toUpperCase() === 'ZZZZ' ? flightMovement.item18_dest : flightMovement.dest_ad;
	        var distances = [];
	        var costs = [];
	        for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
	            var segment = segments_1[_i];
	            distances.push(segment.segment_length);
	            costs.push(segment.segment_cost);
	        }
	        segments.sort(function (a, b) { return a.segment_number - b.segment_number; }); // sort by segment number ascending
	        if (segments.length > 0) {
	            segments[segments.length - 1].destination = flightRouteDestination; // add final destination
	            for (var i = 0, j = 1; j < segments.length; j++, i++) {
	                segments[i].destination = segments[j].segment_start_label; // add starting label as destination of previous segment
	            }
	        }
	        this.$scope.totalDistance = distances.reduce(function (a, b) { return a + b; }, 0);
	        this.$scope.totalCost = costs.reduce(function (a, b) { return a + b; }, 0);
	        return segments;
	    };
	    FlightMovementManagementController.prototype.getFilterParameters = function (reset) {
	        // default to true for legacy support when not params provided
	        reset = reset === false ? false : true;
	        // force start and end date to UTC ISO string
	        var startDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        // not sure why we want to reset on refresh.. but remains for legecy support
	        if (reset) {
	            this.reset();
	        }
	        this.$scope.listSelectedFlightCategories = this.convertSelectedIdsFlightCategoriesToIntegerArray();
	        this.$scope.listSelectedDepAerodromes = this.convertSelectedIdsDepAerodromesToIntegerArray();
	        this.$scope.listSelectedDestAerodromes = this.convertSelectedIdsDestAerodromesToIntegerArray();
	        this.$scope.listSelectedAircraftsTypes = this.convertSelectedAircfartTypesToIntegerArray();
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'type': this.$scope.listSelectedFlightCategories,
	            'status': this.$scope.flightMovementStatusFilter,
	            'issue': this.$scope.incompleteFlightReason,
	            'iata': this.$scope.accountTypeFilter,
	            'invoice': this.$scope.invoiceStatusFilter,
	            'start': startDate,
	            'end': endDate,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0,
	            'duplicatesOrMissing': this.$scope.showDuplicateMissing,
	            'showActualDepDest': this.$scope.showActualDepDestAd,
	            'showAllFlights': this.$scope.showAllFlights,
	            'fmStatusFilter': this.$scope.fmStatusFilter,
	            'flight_rules': this.$scope.flightRulesFilter,
	            'flight_type': this.$scope.flightTypeFilter,
	            'crco_flight': this.$scope.crcoFlightFilter,
	            'depAerodromes': this.$scope.listSelectedDepAerodromes,
	            'destAerodromes': this.$scope.listSelectedDestAerodromes,
	            'flight_id': this.$scope.flightIdFilter,
	            'aircraftTypes': this.$scope.listSelectedAircraftsTypes
	        };
	    };
	    /**
	     * Calls list with applied filters and sort.
	     *
	     * @param reset default to true for legecy support
	     * @param sort default to scope's getSortQueryString
	     */
	    FlightMovementManagementController.prototype.refreshOverride = function (reset, sort) {
	        var _this = this;
	        this.getFilterParameters(reset);
	        // default sort to user selected columns if undefined, null, or empty
	        if (!sort) {
	            sort = this.$scope.getSortQueryString ? this.$scope.getSortQueryString() : '';
	        }
	        return _super.prototype.list.call(this, this.$scope.filterParameters, sort).then(function (data) {
	            // this is done to prevent flashing of ZZZZ/'actual' aerodrome value when
	            // sorting by departure or destination aerodromes
	            _this.$scope.showActualDepAd = _this.$scope.showActualDepDestAd;
	            _this.$scope.showActualDestAd = _this.$scope.showActualDepDestAd;
	            _this.$scope.allFlightsSelected = _this.areAllFlightsSelected();
	            // continue promise chaining
	            return data;
	        });
	    };
	    /**
	     * Generate an Aviation invoice with the status "new"
	     */
	    FlightMovementManagementController.prototype.generateInvoice = function (accountId, flightIdList) {
	        var _this = this;
	        this.reportsService.generateAviationInvoiceFM(accountId, flightIdList, this.$scope.fmFlightCategory).then(function () { _this.refreshOverride(); _this.$scope.invoiceCreated = true; })
	            .catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    /**
	     * Disables appropriate filters and fixes sort option if enable is true else reset
	     * showAllFlights to true. Finally refresh data table list.
	     *
	     * @param enable locate duplicate or missing function
	     */
	    FlightMovementManagementController.prototype.locateDuplicateMissingFlights = function (enable) {
	        if (enable) {
	            // save current filter state before clearing and disabling affected fields
	            this.previousFilterSort.invoiceStatusFilter = this.$scope.invoiceStatusFilter;
	            this.previousFilterSort.flightCategoryFilter = this.$scope.flightCategoryFilter;
	            this.previousFilterSort.flightMovementStatusFilter = this.$scope.flightMovementStatusFilter;
	            this.previousFilterSort.incompleteFlightReason = this.$scope.incompleteFlightReason;
	            this.previousFilterSort.fmStatusFilter = this.$scope.fmStatusFilter;
	            this.previousFilterSort.showActualDepDestAd = this.$scope.showActualDepDestAd;
	            this.previousFilterSort.flightRulesFilter = this.$scope.flight_rules;
	            this.previousFilterSort.flightTypeFilter = this.$scope.flight_type;
	            this.previousFilterSort.crcoFlightFilter = this.$scope.crco_flight;
	            // clear filter field since they will be disabled in view
	            this.$scope.invoiceStatusFilter = null;
	            this.$scope.flightCategoryFilter = null;
	            this.$scope.flightMovementStatusFilter = null;
	            this.$scope.incompleteFlightReason = null;
	            this.$scope.fmStatusFilter = null;
	            this.$scope.flightRulesFilter = null;
	            this.$scope.flightTypeFilter = null;
	            this.$scope.crcoFlightFilter = null;
	            // this is required so that the find duplicate/missing flights feature can work with THRU plans
	            this.$scope.showActualDepDestAd = true;
	            // set sort to locate duplicate/missing flights (Aircraft)
	            // this is overwritten on backend when duplicatesOrMissing param true
	            this.$scope.cannedSort = 'sort=item18RegNum,asc&sort=dateOfFlight,asc&sort=depTime,asc';
	        }
	        else {
	            // resort affect filterfields to previous state
	            this.$scope.invoiceStatusFilter = this.previousFilterSort.invoiceStatusFilter;
	            this.$scope.flightCategoryFilter = this.previousFilterSort.flightCategoryFilter;
	            this.$scope.flightMovementStatusFilter = this.previousFilterSort.flightMovementStatusFilter;
	            this.$scope.incompleteFlightReason = this.previousFilterSort.incompleteFlightReason;
	            this.$scope.fmStatusFilter = this.previousFilterSort.fmStatusFilter;
	            this.$scope.showActualDepDestAd = this.previousFilterSort.showActualDepDestAd;
	            this.$scope.flightRulesFilter = this.previousFilterSort.flightRulesFilter;
	            this.$scope.flightTypeFilter = this.previousFilterSort.flightTypeFilter;
	            this.$scope.crcoFlightFilter = this.previousFilterSort.crcoFlightFilter;
	            // always return cannedSort value back to default
	            this.$scope.cannedSort = null;
	            // when locate duplicate/missing flights disabled,
	            // showAllFlights is redundent and should always be true
	            this.$scope.showAllFlights = true;
	        }
	        this.refreshOverride(false, this.$scope.cannedSort);
	    };
	    /**
	     * When table sort item value changes, updated show actual dep|dest ad flags accordingly.
	     *
	     * @param event angular event
	     * @param newValue new table sort value
	     * @param oldValue old table sort value
	     * @param isSorted true if table sorted by value
	     */
	    FlightMovementManagementController.prototype.tableSortItemValueChanged = function (event, newValue, oldValue, isSorted) {
	        // only set flags immeditality if isSorted is false, otherwise refreshOverride() will handle it when promise returned
	        // this is done to prevent column value "flickering" table list refresh required after a table sort value change
	        if (!isSorted && (newValue === 'depAd' || newValue === 'actualDepAd')) {
	            this.$scope.showActualDepAd = this.$scope.showActualDepDestAd;
	        }
	        else if (!isSorted && (newValue === 'destAd' || newValue === 'actualDestAd')) {
	            this.$scope.showActualDestAd = this.$scope.showActualDepDestAd;
	        }
	    };
	    /**
	     * Update view model with list of aircraft types.
	     *
	     * @param aircraftTypes list of aircraft types
	     */
	    FlightMovementManagementController.prototype.updateAircraftTypeList = function (aircraftTypes) {
	        this.$scope.aircraftTypesList = aircraftTypes;
	        // add 'ZZZZ' as a placeholder for item18
	        this.$scope.aircraftTypesList.push({
	            aircraft_type: 'ZZZZ'
	        });
	    };
	    /**
	     * Reset the filters to their default settings:
	     * flight movement status - active
	     * date filter - the last N days depending on system setting
	     */
	    FlightMovementManagementController.prototype.resetFilters = function () {
	        this.$scope.search = null;
	        this.$scope.flightCategoryFilter = null;
	        this.$scope.flightMovementStatusFilter = 'ACTIVE';
	        this.$scope.incompleteFlightReason = null;
	        this.$scope.accountTypeFilter = null;
	        this.$scope.invoiceStatusFilter = null;
	        this.$scope.showDuplicateMissing = null;
	        this.$scope.showActualDepDestAd = null;
	        this.$scope.cannedSort = null;
	        this.$scope.flightRulesFilter = null;
	        this.$scope.flightTypeFilter = null;
	        this.$scope.crcoFlightFilter = null;
	        this.$scope.flightIdFilter = null;
	        this.resetSelectedFlightMovements();
	        if (this.$scope.numberOfDaysOfFlightData && this.$scope.control) {
	            var startDateFilter = new Date(moment().subtract(this.$scope.numberOfDaysOfFlightData - 1, 'days').format('l'));
	            var endDateFilter = new Date(Date.now());
	            this.$scope.control.setUTCStartDate(startDateFilter);
	            this.$scope.control.setUTCEndDate(endDateFilter);
	        }
	        this.refreshOverride();
	    };
	    // select or deselect all flights in page
	    FlightMovementManagementController.prototype.toggleAllFlights = function () {
	        var _this = this;
	        var allSelectedInverse = !this.areAllFlightsSelected();
	        this.$scope.currentFlightIds.map(function (id) { return _this.$scope.selectedFlightMovements[id] = allSelectedInverse; });
	        this.$scope.allFlightsSelected = allSelectedInverse;
	        this.$scope.countSelected();
	    };
	    FlightMovementManagementController.prototype.areAllFlightsSelected = function () {
	        var _this = this;
	        return this.$scope.currentFlightIds
	            && this.$scope.currentFlightIds.every(function (id) { return _this.$scope.selectedFlightMovements[id]; });
	    };
	    // deselect selected flights
	    FlightMovementManagementController.prototype.resetSelectedFlightMovements = function () {
	        this.$scope.selectedFlightMovements = [];
	        this.$scope.numberOfSelectedMovements = this.$scope.selectedRecords = 0;
	    };
	    FlightMovementManagementController.prototype.setDefaultFields = function () {
	        this.$scope.editable.date_of_flight = moment.utc().startOf('day').toDate();
	        if (this.$scope.defaultTaspCurrency && !this.$scope.editable.tasp_charge_currency) {
	            this.$scope.editable.tasp_charge_currency = this.$scope.defaultTaspCurrency;
	        }
	    };
	    /**
	     * Mark flight movements as paid, only PENDING zero cost flights will be processed.
	     *
	     * @param flightIdList list of flight movements to mark as paid
	     */
	    FlightMovementManagementController.prototype.markAsPaid = function (flightIdList) {
	        var _this = this;
	        this.flightMovementManagementService.markAsPaid(flightIdList)
	            .then(function () { _this.refreshOverride(); _this.$scope.markedAsPaid = true; })
	            .catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    FlightMovementManagementController.prototype.extractInitialDigits = function (inputString, aircrafType) {
	        // Trim la stringa per rimuovere eventuali spazi vuoti
	        var trimmedString = inputString.trim();
	        // Verifica la lunghezza della stringa
	        if (trimmedString.length === aircrafType.length) {
	            return "01";
	        }
	        else if (trimmedString.length === 0) {
	            return "";
	        }
	        else if (trimmedString.length === 4) {
	            // Se la lunghezza è 4, controlla la prima cifra
	            var firstChar = trimmedString.charAt(0);
	            if (isNaN(parseInt(firstChar))) {
	                // Se la prima cifra è una lettera
	                return "01";
	            }
	            else if (trimmedString.substring(0, 2) === "00") {
	                // Se la stringa inizia con "00"
	                return "01";
	            }
	        }
	        else if (trimmedString.length > 4) {
	            // Se la lunghezza è maggiore di 4, controlla le prime due cifre
	            var firstTwoChars = trimmedString.substring(0, 2);
	            if (!isNaN(parseInt(firstTwoChars)) && firstTwoChars.length === 2) {
	                // Se le prime due cifre sono un numero
	                var number = parseInt(firstTwoChars);
	                return number !== 1 ? "0" + number : "01"; // Aggiungi '0' se il numero è diverso da 1
	            }
	            else if (firstChar.length === 1 && !isNaN(parseInt(firstChar))) {
	                // Se c'è solo un numero
	                var number = parseInt(firstChar);
	                return number !== 1 ? "0" + number : "01"; // Aggiungi '0' se il numero è diverso da 1
	            }
	        }
	        return "";
	    };
	    return FlightMovementManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.FlightMovementManagementController = FlightMovementManagementController;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var enum_service_1 = __webpack_require__(76);
	var FlightType;
	(function (FlightType) {
	    FlightType[FlightType["DOMESTIC"] = 'Domestic'] = "DOMESTIC";
	    FlightType[FlightType["REG_OVERFLIGHT"] = 'Regional Overflight'] = "REG_OVERFLIGHT";
	    FlightType[FlightType["REG_ARRIVAL"] = 'Regional Arrival'] = "REG_ARRIVAL";
	    FlightType[FlightType["REG_DEPARTURE"] = 'Regional Departure'] = "REG_DEPARTURE";
	    FlightType[FlightType["INT_OVERFLIGHT"] = 'International Overflight'] = "INT_OVERFLIGHT";
	    FlightType[FlightType["INT_ARRIVAL"] = 'International Arrival'] = "INT_ARRIVAL";
	    FlightType[FlightType["INT_DEPARTURE"] = 'International Departure'] = "INT_DEPARTURE";
	    FlightType[FlightType["OTHER"] = 'Other'] = "OTHER";
	    // this is only for KCAA only - INT_OVERFLIGHT = <any>'Overflight'
	})(FlightType = exports.FlightType || (exports.FlightType = {}));
	var FlightTypeService = (function (_super) {
	    __extends(FlightTypeService, _super);
	    /** @ngInject */
	    FlightTypeService.$inject = ["$q"];
	    function FlightTypeService($q) {
	        var _this = _super.call(this) || this;
	        _this.$q = $q;
	        _this.$q = $q;
	        return _this;
	    }
	    FlightTypeService.prototype.list = function () {
	        return _super.prototype.list.call(this, FlightType);
	    };
	    return FlightTypeService;
	}(enum_service_1.EnumService));
	exports.FlightTypeService = FlightTypeService;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// note this is not an angular service, it's just extended by the services that use enumerators
	var EnumService = (function () {
	    function EnumService() {
	    }
	    /**
	     * Takes an Enum Object and returns a new object with every other value
	     * @param enumObject
	     *
	     * It skips every other because of the way typescript builds enum objects
	     *
	     * @returns {Array}
	     */
	    EnumService.prototype.list = function (enumObject) {
	        var list = [];
	        Object.keys(enumObject).filter(function (value, index, array) {
	            if (index % 2 === 0) {
	                list[value] = array[index + 1];
	            }
	        });
	        return list;
	    };
	    return EnumService;
	}());
	exports.EnumService = EnumService;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	var Calculation = (function () {
	    Calculation.$inject = ["job", "execute", "cancel", "status", "complete", "$scope", "service", "$interval", "serverDatetimeService", "$rootScope"];
	    function Calculation(job, execute, cancel, status, complete, $scope, service, $interval, serverDatetimeService, $rootScope) {
	        var _this = this;
	        this.job = job;
	        this.execute = execute;
	        this.cancel = cancel;
	        this.status = status;
	        this.complete = complete;
	        this.$scope = $scope;
	        this.service = service;
	        this.$interval = $interval;
	        this.serverDatetimeService = serverDatetimeService;
	        this.$rootScope = $rootScope;
	        this.queued = 'QUEUED';
	        this.started = 'STARTED';
	        this.completed = 'COMPLETED';
	        this.failed = 'FAILED';
	        this.currentTime = null;
	        serverDatetimeService.getCurrentDateTime('util/current-datetime').then(function (serverDateTime) {
	            _this.currentTime = serverDateTime ? new Date(serverDateTime) : Date.now();
	            $interval(function () { _this.currentTime.setSeconds(_this.currentTime.getSeconds() + 1); }, 1000);
	        });
	    }
	    Calculation.prototype.checkStatusOnPageLoad = function () {
	        var _this = this;
	        return this.service[this.status]().then(function (job) {
	            var inProgress = job.job_execution_status === _this.started || job.job_execution_status === _this.queued;
	            if (inProgress) {
	                _this.updateCalculationStatus();
	            }
	            return inProgress;
	        });
	    };
	    Calculation.prototype.executeCalculation = function (data) {
	        var _this = this;
	        this.service[this.execute](data)
	            .then(function () {
	            _this.$scope[_this.job] = {
	                job_execution_status: 'STARTING',
	                job_parameters: '...',
	                start_time: '...',
	                remaining: '...',
	                steps_to_process: '...',
	                steps_completed: '...',
	                total_steps: '...',
	                etc_time: '...',
	                rate: '...'
	            };
	            _this.clearAndStartInterval();
	        })
	            .catch(function (error) {
	            if (!error.data) {
	                _this.$scope.error = {
	                    error: {
	                        data: {
	                            error: 'Asynchronous job failed',
	                            error_description: 'Unknown reason'
	                        }
	                    }
	                };
	            }
	            else {
	                _this.$scope.error = { error: error };
	            }
	            _this.$scope.processing = false;
	        });
	    };
	    Calculation.prototype.cancelCalculation = function () {
	        var _this = this;
	        this.$scope.processing = false;
	        return this.service[this.cancel]()
	            .catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    // safety to avoid two intervals
	    Calculation.prototype.updateCalculationStatus = function () {
	        var _this = this;
	        this.service[this.status]()
	            .then(function (job) {
	            _this.$scope[_this.job] = _this.parseJob(job);
	            _this.clearAndStartInterval();
	        })
	            .catch(function (error) { return _this.$scope.error = { error: error }; });
	    };
	    Calculation.prototype.clearAndStartInterval = function () {
	        this.$interval.cancel(this.$scope.calculatePromise);
	        this.startRefreshCalculationStatus();
	    };
	    Calculation.prototype.startRefreshCalculationStatus = function () {
	        var _this = this;
	        this.$scope.calculatePromise = this.$interval(function () {
	            _this.service[_this.status]()
	                .then(function (job) {
	                _this.$scope[_this.job] = _this.parseJob(job);
	                // cancels the timer function
	                if (job.job_execution_status !== _this.started && job.job_execution_status !== _this.queued) {
	                    _this.$interval.cancel(_this.$scope.calculatePromise);
	                }
	                // update processing flag
	                if (job.job_execution_status === _this.completed || job.job_execution_status === _this.failed) {
	                    _this.$scope.processing = false;
	                }
	                // runs a function after complete if one is provided (can be null if no post-processing required)
	                if (job.job_execution_status === _this.completed && _this.complete) {
	                    _this.service[_this.complete](_this.$scope.editable.preview, _this.$scope.editable.iataInvoice)
	                        .then(function (resp) { return _this.$scope.preview = resp; });
	                }
	            })
	                .catch(function (error) {
	                _this.$scope.error = { error: error };
	                _this.$interval.cancel(_this.$scope.calculatePromise);
	            });
	        }, 3000);
	    };
	    /**
	     * The params of the job comes back as a string.
	     * This extracts either the flight ID/s or the month
	     * and year from that string, to display to the user
	     *
	     * @param  {IJobStatus} job
	     * @returns IJobStatus
	     */
	    Calculation.prototype.parseJob = function (job) {
	        if (job.variables) {
	            var paramsArr = job.variables.split(';');
	            job.unifiedTaxErrors = new Array();
	            for (var i = 0, len = paramsArr.length; i < len; i++) {
	                var obj = paramsArr[i].split('=');
	                if (obj[0] === 'unifiedTaxInvoiceError') {
	                    var items = obj[1].split('#');
	                    var err = { 'account_name': items[0], 'registration': items[1], 'reason': items[2] };
	                    job.unifiedTaxErrors.push(err);
	                }
	                else {
	                    job[obj[0]] = obj[1];
	                }
	            }
	        }
	        var startTime = new Date(job.start_time);
	        var runningTime = (this.currentTime - startTime) / 1000;
	        var recordsPerSecond = job.steps_completed / runningTime;
	        var secondsLeft = job.steps_to_process / recordsPerSecond;
	        if (isFinite(secondsLeft)) {
	            job.seconds_left = this.convertSecondsToDHMS(secondsLeft);
	        }
	        else {
	            secondsLeft = 0;
	        }
	        // set Estimated Time of Completion
	        var etcTime = new Date(this.currentTime);
	        etcTime.setSeconds(etcTime.getSeconds() + secondsLeft);
	        job.etc_time = etcTime.toISOString();
	        job.rate = recordsPerSecond.toFixed(2) + " rec/sec (or " + (recordsPerSecond * 60).toFixed(2) + " records / minute)";
	        if (job.job_parameters) {
	            if (job.job_parameters.indexOf('flightId') !== -1) {
	                job.job_parameters = this.parseJobParams(job.job_parameters, 'Id');
	            }
	            else if (job.job_parameters.indexOf('startDate') !== -1 && job.job_parameters.indexOf('endDate') !== -1) {
	                var startDate = this.parseJobParams(job.job_parameters, 'startDate');
	                var endDate = this.parseJobParams(job.job_parameters, 'endDate');
	                job.job_parameters = startDate + " - " + endDate;
	            }
	        }
	        if (job.message && job.message.includes('{{flights}}') && job.variables.includes('flights=')) {
	            job.message = job.message.replace('{{flights}}', job.flights);
	        }
	        this.$rootScope.jobForNotification = job;
	        return job;
	    };
	    Calculation.prototype.convertSecondsToDHMS = function (seconds) {
	        seconds = Number(seconds);
	        var d = this.str_pad(Math.floor(seconds / (3600 * 24)));
	        var h = this.str_pad(Math.floor(seconds % (3600 * 24) / 3600));
	        var m = this.str_pad(Math.floor(seconds % 3600 / 60));
	        var s = this.str_pad(Math.floor(seconds % 60));
	        return d + ":" + h + ":" + m + ":" + s;
	    };
	    /**
	     * Prepends `0` to a
	     * single digit number
	     *
	     * @param  {number} n
	     * @returns string
	     */
	    Calculation.prototype.str_pad = function (n) {
	        return String('0' + n).slice(-2);
	    };
	    /**
	     * This will parse IJobStatus.job_parameters for the value of the key supplied.
	     * This assumes that the supplied params is a list of key/value pairs seperated
	     * by a semicolon in the form of a string.
	     *
	     * Lastly, it will ignore any array (square bracket) characters and simply return
	     * the comma seperated value without the square bracket characters.
	     *
	     * @param params key/value list to parse
	     * @param key key of value to return
	     */
	    Calculation.prototype.parseJobParams = function (params, key) {
	        var paramsList = params.split(';');
	        for (var i = 0; i < paramsList.length; i++) {
	            if (paramsList[i].indexOf(key) !== -1) {
	                var param = paramsList[i].replace(/\[|]/g, '').split('=')[1];
	                if (paramsList[i].includes('startDate')) {
	                    return moment(param, 'YYYY-MM-DDHH').format('L');
	                }
	                else if (paramsList[i].includes('endDate')) {
	                    var endDate = moment(param, 'YYYY-MM-DDHH');
	                    // api returns increemted day when RECALCULATING but not when GENERATING or PREVIEWING
	                    if (params.toLowerCase().includes('invoice')) {
	                        return endDate.format('L');
	                    }
	                    else {
	                        return endDate.subtract(1, 'days').format('L');
	                    }
	                }
	                else {
	                    return param;
	                }
	            }
	        }
	        return null;
	    };
	    return Calculation;
	}());
	exports.Calculation = Calculation;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var map_constants_1 = __webpack_require__(26);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AirspaceManagementController = (function (_super) {
	    __extends(AirspaceManagementController, _super);
	    /* @ngInject */
	    AirspaceManagementController.$inject = ["$scope", "$rootScope", "airspaceManagementService"];
	    function AirspaceManagementController($scope, $rootScope, airspaceManagementService) {
	        var _this = _super.call(this, $scope, airspaceManagementService) || this;
	        _this.$scope = $scope;
	        _this.$rootScope = $rootScope;
	        _this.airspaceManagementService = airspaceManagementService;
	        _super.prototype.setup.call(_this);
	        _this.getFilterParameters();
	        $scope.loadAirspaces = function () { return _this.loadAirspaces(); };
	        $scope.edit = function (item) {
	            _this.$scope.openForm = true;
	            _this.$scope.selectedItemId = item.id;
	            _super.prototype.edit.call(_this, item);
	        };
	        $scope.delete = function (id) {
	            _super.prototype.delete.call(_this, id).then(function () { return _this.$rootScope.$broadcast('map.refreshLayer', 'Airspaces'); });
	            _this.$scope.selectedItemId = null;
	        };
	        $scope.create = function (id) { return _super.prototype.create.call(_this, id).then(function () {
	            _this.$rootScope.$broadcast('map.refreshLayer', 'Airspaces');
	            _this.resetOverride();
	        }); };
	        $scope.showAirspaceOnMap = function (airspace) { return _this.$rootScope.$broadcast('map.flyToEntity', map_constants_1.MapFlyToEntityType.SELECT_AIRSPACE, [airspace]); };
	        $scope.showAirspaceOnMapNavDb = function (airspace) { return _this.$rootScope.$broadcast('map.flyToEntity', map_constants_1.MapFlyToEntityType.SELECT_AIRSPACE_NAVDB, [airspace]); };
	        $scope.filterAirspaceType = function (airspaceType) { return _this.$scope.listFromNavDB = _this.filterAirspaceType(airspaceType); };
	        $scope.checkIfAirspaceAdded = function (airspaceName) { return _this.$scope.airspaceAlreadyExists = _this.checkIfAirspaceAdded(airspaceName); };
	        $scope.$on('$destroy', function () { return $rootScope.$broadcast('map.toggle', 'Layers Off', []); });
	        _this.loadAirspaces();
	        $scope.refresh = function () {
	            _this.$scope.selectedItemId = null;
	            _this.refreshOverride();
	        };
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    // returns filtered airspaces on whether they are FIR, FIR_P, TMA or all airspaces
	    AirspaceManagementController.prototype.filterAirspaceType = function (airspaceType) {
	        if (airspaceType === null) {
	            return this.listFromNavDB;
	        }
	        var listOfAirspaces = [];
	        for (var i in this.listFromNavDB) {
	            if (this.listFromNavDB[i].airspace_type === airspaceType) {
	                listOfAirspaces.push(this.listFromNavDB[i]);
	            }
	        }
	        return listOfAirspaces;
	    };
	    // returns whether an airspace has already been added
	    AirspaceManagementController.prototype.checkIfAirspaceAdded = function (airspaceName) {
	        for (var i in this.$scope.list) {
	            if (airspaceName === this.$scope.list[i].airspace_name) {
	                return true;
	            }
	        }
	        return false;
	    };
	    AirspaceManagementController.prototype.loadAirspaces = function () {
	        var _this = this;
	        this.service.getAirspacesFromNavDB().then(function (response) {
	            _this.listFromNavDB = response.content;
	            _this.$scope.listFromNavDB = response.content;
	        }, function () { return _this.$scope.navDBError = true; }); // error when trying to get airspaces from navDB
	    };
	    AirspaceManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AirspaceManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AirspaceManagementController.prototype.resetOverride = function () {
	        this.$scope.openForm = false;
	        this.$scope.airspaceType = null;
	        this.$scope.navDBeditable = null;
	    };
	    return AirspaceManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AirspaceManagementController = AirspaceManagementController;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AccountExemptManagementController = (function (_super) {
	    __extends(AccountExemptManagementController, _super);
	    /* @ngInject */
	    AccountExemptManagementController.$inject = ["$scope", "$rootScope", "accountExemptManagementService", "systemConfigurationService"];
	    function AccountExemptManagementController($scope, $rootScope, accountExemptManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, accountExemptManagementService) || this;
	        _this.$scope = $scope;
	        _this.accountExemptManagementService = accountExemptManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        _this.getFilterParameters();
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    AccountExemptManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AccountExemptManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return AccountExemptManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AccountExemptManagementController = AccountExemptManagementController;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var UtilitiesTownsController = (function (_super) {
	    __extends(UtilitiesTownsController, _super);
	    /* @ngInject */
	    UtilitiesTownsController.$inject = ["$scope", "utilitiesTownsService", "utilitiesSchedulesService", "$translate"];
	    function UtilitiesTownsController($scope, utilitiesTownsService, utilitiesSchedulesService, $translate) {
	        var _this = _super.call(this, $scope, utilitiesTownsService) || this;
	        _this.$scope = $scope;
	        _this.utilitiesTownsService = utilitiesTownsService;
	        _this.utilitiesSchedulesService = utilitiesSchedulesService;
	        _super.prototype.setup.call(_this);
	        _this.getFilterParameters();
	        $scope.waterSchedules = [];
	        $scope.commElectricitySchedules = [];
	        $scope.resElectricitySchedules = [];
	        $scope.optionLabel = function (schedule) {
	            if (schedule) {
	                return $translate.instant('Schedule') + ": " + schedule.schedule_id + " / " + $translate.instant('Charge:') + " " + schedule.minimum_charge;
	            }
	        };
	        utilitiesSchedulesService.list()
	            .then(function (data) { $scope.schedules = data; _this.separateWaterAndElectricSchedules(data); });
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        return _this;
	    }
	    UtilitiesTownsController.prototype.separateWaterAndElectricSchedules = function (schedules) {
	        for (var _i = 0, _a = schedules.content; _i < _a.length; _i++) {
	            var schedule = _a[_i];
	            if (schedule.schedule_type === 'WATER') {
	                this.$scope.waterSchedules.push(schedule);
	            }
	            else if (schedule.schedule_type === 'ELECTRIC_COMM') {
	                this.$scope.commElectricitySchedules.push(schedule);
	            }
	            else if (schedule.schedule_type === 'ELECTRIC_RES') {
	                this.$scope.resElectricitySchedules.push(schedule);
	            }
	            else {
	                console.error('Found `schedule_type` that does not exist', schedule);
	            }
	        }
	    };
	    ;
	    UtilitiesTownsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            textFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    UtilitiesTownsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return UtilitiesTownsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.UtilitiesTownsController = UtilitiesTownsController;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var UtilitiesSchedulesController = (function (_super) {
	    __extends(UtilitiesSchedulesController, _super);
	    /* @ngInject */
	    UtilitiesSchedulesController.$inject = ["$scope", "utilitiesSchedulesService"];
	    function UtilitiesSchedulesController($scope, utilitiesSchedulesService) {
	        var _this = _super.call(this, $scope, utilitiesSchedulesService) || this;
	        _this.$scope = $scope;
	        _this.utilitiesSchedulesService = utilitiesSchedulesService;
	        _super.prototype.setup.call(_this);
	        $scope.scheduleTypes = utilitiesSchedulesService.listScheduleTypes();
	        $scope.getScheduleTypeName = function (scheduleValue) { return _this.getScheduleTypeName(scheduleValue); };
	        $scope.editRange = function (item) { return _this.editRange(item); };
	        $scope.resetRange = function (item) { return _this.resetRange(item); };
	        $scope.createRange = function (schedule_id, range) { return _this.createRange(schedule_id, range); };
	        $scope.updateRange = function (range) { return _this.updateRange(range); };
	        $scope.deleteRange = function (id) { return _this.deleteRange(id); };
	        $scope.deleteEditableRangeBracket = function (id) { return _this.deleteEditableRangeBracket(id); };
	        $scope.updateEditableRangeBracket = function (range) { return _this.updateEditableRangeBracket(range); };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        _this.$scope = $scope;
	        return _this;
	    }
	    UtilitiesSchedulesController.prototype.getScheduleTypeName = function (scheduleValue) {
	        for (var i in this.$scope.scheduleTypes) {
	            if (this.$scope.scheduleTypes[i].value === scheduleValue) {
	                return this.$scope.scheduleTypes[i].name;
	            }
	        }
	    };
	    UtilitiesSchedulesController.prototype.editRange = function (item) {
	        this.$scope.editableRangeBracket = angular.copy(item);
	    };
	    UtilitiesSchedulesController.prototype.resetRange = function (item) {
	        if (item) {
	            this.$scope.ranges = angular.copy(item.utilities_range_bracket);
	        }
	        this.$scope.editableRangeBracket = {
	            id: null,
	            schedule_id: null,
	            range_top_end: null,
	            unit_price: null
	        };
	    };
	    UtilitiesSchedulesController.prototype.createRange = function (schedule_id, range) {
	        var _this = this;
	        this.service.createRange(schedule_id, range).then(function (range) {
	            _this.resetRange();
	            _this.$scope.ranges.push(range);
	            _this.list({ filter: _this.$scope.filter });
	        });
	    };
	    UtilitiesSchedulesController.prototype.updateRange = function (range) {
	        var _this = this;
	        this.service.updateRange(range).then(function (range) {
	            _this.resetRange();
	            _this.updateEditableRangeBracket(range);
	            _this.list({ filter: _this.$scope.filter });
	        });
	    };
	    UtilitiesSchedulesController.prototype.updateEditableRangeBracket = function (range) {
	        for (var i = 0; i < this.$scope.ranges.length; i++) {
	            if (range.id === this.$scope.ranges[i].id) {
	                this.$scope.ranges[i] = range;
	                break;
	            }
	            ;
	        }
	        ;
	    };
	    UtilitiesSchedulesController.prototype.deleteRange = function (id) {
	        var _this = this;
	        this.service.deleteRange(id).then(function () {
	            _this.resetRange();
	            _this.deleteEditableRangeBracket(id);
	            _this.list({ filter: _this.$scope.filter });
	        });
	    };
	    UtilitiesSchedulesController.prototype.deleteEditableRangeBracket = function (id) {
	        for (var i = 0; i < this.$scope.ranges.length; i++) {
	            if (id === this.$scope.ranges[i].id) {
	                this.$scope.ranges.splice(i, 1);
	                break;
	            }
	            ;
	        }
	        ;
	    };
	    UtilitiesSchedulesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            filter: this.$scope.filter,
	            textFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Refresh data list in scope.
	     */
	    UtilitiesSchedulesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return UtilitiesSchedulesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.UtilitiesSchedulesController = UtilitiesSchedulesController;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var RegionalCountryManagementController = (function (_super) {
	    __extends(RegionalCountryManagementController, _super);
	    /* @ngInject */
	    RegionalCountryManagementController.$inject = ["$scope", "regionalCountryManagementService", "countryManagementService"];
	    function RegionalCountryManagementController($scope, regionalCountryManagementService, countryManagementService) {
	        var _this = _super.call(this, $scope, regionalCountryManagementService) || this;
	        _this.$scope = $scope;
	        _this.regionalCountryManagementService = regionalCountryManagementService;
	        _this.countryManagementService = countryManagementService;
	        // setupParams needed so params can be applied from outside controller
	        _super.prototype.setup.call(_this, { refresh: false });
	        $scope.editableCountryList = {
	            content: []
	        };
	        $scope.regionalCountryList = {
	            content: []
	        };
	        countryManagementService.listAll().then(function (listOfCountries) { return $scope.countryList = listOfCountries.content; }); // retrieve total country list
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        _this.list({});
	        return _this;
	    }
	    RegionalCountryManagementController.prototype.list = function (params, queryString) {
	        var _this = this;
	        return _super.prototype.list.call(this, params, queryString).then(function (data) {
	            _this.$scope.regionalCountryList = angular.copy(data);
	            _this.$scope.editableCountryList = angular.copy(data);
	        });
	    };
	    RegionalCountryManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    RegionalCountryManagementController.prototype.refreshOverride = function () {
	        var _this = this;
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString()).then(function (data) {
	            _this.$scope.regionalCountryList = angular.copy(data);
	            _this.$scope.editableCountryList = angular.copy(data);
	        });
	    };
	    return RegionalCountryManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.RegionalCountryManagementController = RegionalCountryManagementController;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// note: this Map Controller should be for Angular related code
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var map_constants_1 = __webpack_require__(26);
	// controllers
	var cesium_class_1 = __webpack_require__(84);
	// utils
	var cancellable_class_1 = __webpack_require__(85);
	var map_utils_1 = __webpack_require__(86);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var map_buttons_1 = __webpack_require__(87);
	var cesium = new cesium_class_1.CesiumClass({
	    flytoDuration: 0.8,
	    flytoPadding: 0.1,
	    flytoMaxZoom: 0.05
	});
	var MapController = (function () {
	    /* @ngInject */
	    MapController.$inject = ["$scope", "$rootScope", "$compile", "configService", "$q", "systemConfigurationService"];
	    function MapController($scope, $rootScope, $compile, configService, $q, systemConfigurationService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$compile = $compile;
	        this.configService = configService;
	        this.$q = $q;
	        this.systemConfigurationService = systemConfigurationService;
	        /**
	         * Used to cancel in-flight flight movement layer requests.
	         */
	        this.flightMovementRequest = null;
	        /**
	         * Cesium map layer display options.
	         */
	        this.layers = {
	            airports: {
	                layerName: 'V_AIRPORT_SP',
	                displayName: 'Airports NavDB',
	                options: {
	                    markerSymbol: 'airport',
	                    markerColor: cesium.fromColorString('#435888', 1.0),
	                    strokeWidth: 3,
	                    stroke: cesium.getColor('WHITE'),
	                    fill: cesium.getColor('WHITE')
	                }
	            },
	            aerodromes: {
	                layerName: 'V_Aerodromes',
	                displayName: 'Aerodromes',
	                options: {
	                    markerSymbol: 'airport',
	                    markerColor: cesium.getColor('CORNFLOWERBLUE'),
	                    strokeWidth: 3,
	                    stroke: cesium.getColor('CORNFLOWERBLUE'),
	                    fill: cesium.getColor('WHITE')
	                }
	            },
	            airspacesNavDB: {
	                layerName: 'V_AIRSPACE_SP',
	                displayName: 'Airspaces NavDB',
	                options: {
	                    stroke: cesium.fromColorString('#734388', 0.5),
	                    fill: cesium.fromColorString('#734388', 0.5),
	                    strokeWidth: 3,
	                    fillOpacity: 0.5
	                }
	            },
	            airspaces: {
	                layerName: 'V_Airspaces',
	                displayName: 'Airspaces',
	                options: {
	                    // styling is done on imagery layer by geoserver
	                    // this is used only to calculate viewport and shouldn't
	                    // be used to display airspace as features due to issue
	                    // https://github.com/AnalyticalGraphicsInc/cesium/issues/4871
	                    stroke: cesium.getColor('TRANSPARENT'),
	                    fill: cesium.getColor('TRANSPARENT'),
	                    strokeWidth: 0,
	                    fillOpacity: 0,
	                    show: false
	                }
	            },
	            airspaceCurrent: {
	                layerName: 'V_Airspace_Current',
	                displayName: 'Current Airspace',
	                options: {
	                    // styling is done on imagery layer by geoserver
	                    // this is used only to calculate viewport and shouldn't
	                    // be used to display airspace as features due to issue
	                    // https://github.com/AnalyticalGraphicsInc/cesium/issues/4871
	                    stroke: cesium.getColor('TRANSPARENT'),
	                    fill: cesium.getColor('TRANSPARENT'),
	                    strokeWidth: 0,
	                    fillOpacity: 0,
	                    show: false
	                }
	            },
	            airspaceSelect: {
	                layerName: 'V_Airspace_Select',
	                displayName: 'Selected Airspace',
	                options: {
	                    // styling is done on imagery layer by geoserver
	                    // this is used only to calculate viewport and shouldn't
	                    // be used to display airspace as features due to issue
	                    // https://github.com/AnalyticalGraphicsInc/cesium/issues/4871
	                    stroke: cesium.getColor('TRANSPARENT'),
	                    fill: cesium.getColor('TRANSPARENT'),
	                    strokeWidth: 0,
	                    fillOpacity: 0,
	                    show: false
	                }
	            },
	            routeSegments: {
	                layerName: 'V_RouteSegments',
	                displayName: 'Billed',
	                options: {
	                    show: true,
	                    stroke: cesium.getColor('RED'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovements: {
	                layerName: 'V_FlightMovement',
	                displayName: 'Flight Movements',
	                options: {
	                    stroke: cesium.fromColor(1.0, 0.55, 0, 1),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsInsideSP: {
	                layerName: 'V_FlightMovementInside_SP',
	                displayName: 'Billed',
	                options: {
	                    show: false,
	                    stroke: cesium.getColor('DARKRED'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsOutsideSP: {
	                layerName: 'V_FlightMovementOutside_SP',
	                displayName: 'Not Billed',
	                options: {
	                    stroke: cesium.getColor('BLUE'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsRadar: {
	                layerName: 'V_FlightMovementRadar',
	                displayName: 'FM Radar',
	                options: {
	                    show: false,
	                    stroke: cesium.getColor('DARKORANGE'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsATC: {
	                layerName: 'V_FlightMovementATC',
	                displayName: 'FM ATC',
	                options: {
	                    show: false,
	                    stroke: cesium.getColor('YELLOW'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsTower: {
	                layerName: 'V_FlightMovementTower',
	                displayName: 'FM Tower',
	                options: {
	                    show: false,
	                    stroke: cesium.getColor('DARKVIOLET'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsScheduled: {
	                layerName: 'V_FlightMovementScheduled',
	                displayName: 'FM Scheduled (FPL)',
	                options: {
	                    show: false,
	                    stroke: cesium.getColor('GREEN'),
	                    strokeWidth: 2
	                }
	            },
	            flightMovementsI: {
	                layerName: 'G_FlightMovement_I',
	                displayName: 'Route Segment, Waypoint',
	                options: {}
	            }
	        };
	        this.cesium = cesium;
	        var container = 'cesiumContainer';
	        var toolbarEl = '.cesium-viewer-toolbar';
	        var imageryProvider = this.cesium.createOpenStreetMap(configService.get('BASE_LOCAL_URL'), 'base_map', 'Base Map');
	        var sceneMode = this.cesium.getSceneMode(configService.get('SCENE_MODE')); // 2D, 3D or Columbus View (default)
	        this.cesium.cesiumKey = configService.get('CESIUM_KEY');
	        // base widget - contains all standard cesium widgets
	        this.cesium.createViewer(container, {
	            timeline: false,
	            selectionIndicator: true,
	            animation: false,
	            fullscreenButton: false,
	            baseLayerPicker: false,
	            imageryProvider: imageryProvider,
	            sceneMode: sceneMode
	        });
	        // ensure the base layer has a name so it displays in the template
	        if (this.cesium.viewer.imageryLayers.get(0).imageryProvider.displayName) {
	            this.cesium.viewer.imageryLayers.get(0).displayName = this.cesium.viewer.imageryLayers.get(0).imageryProvider.displayName;
	        }
	        // listening on airspaces or flight movements to display
	        $scope.$on('map.flyToEntity', function (broadcastedEvent, type, objectsToDisplay) {
	            if (objectsToDisplay.length > 0) {
	                $rootScope.$broadcast('contentModeChange', 'split-mode'); // changes map to split-mode viewing
	            }
	            switch (type) {
	                case map_constants_1.MapFlyToEntityType.AIRSPACES:
	                    _this.showAirspaces(objectsToDisplay);
	                    break;
	                case map_constants_1.MapFlyToEntityType.SINGLE_AIRSPACE:
	                    _this.showSingleAirspace(objectsToDisplay);
	                    break;
	                case map_constants_1.MapFlyToEntityType.SINGLE_FLIGHT_MOVEMENT:
	                case map_constants_1.MapFlyToEntityType.FLIGHT_MOVEMENT_INTERSECTION:
	                    _this.showSingleFlightMovement(objectsToDisplay);
	                    break;
	                case map_constants_1.MapFlyToEntityType.SELECT_AIRSPACE:
	                    _this.showSelectedAirspace(objectsToDisplay);
	                    break;
	                case map_constants_1.MapFlyToEntityType.SELECT_AIRSPACE_NAVDB:
	                    _this.showSelectedAirspace(objectsToDisplay, true);
	                    break;
	            }
	        });
	        $scope.$on('map.toggle', function (broadcastedEvent, type, objectsToDisplay) {
	            switch (type) {
	                case 'Layers Off':
	                    _this.removeAll();
	                    $rootScope.$broadcast('contentModeChange', 'content-mode'); // changes map to content-mode since nothing will be showing
	                    break;
	                default:
	                    $rootScope.$broadcast('contentModeChange', 'split-mode'); // changes map to split-mode viewing
	            }
	        });
	        $scope.aerodromesLayerName = this.layers.aerodromes.layerName;
	        $scope.flightDisplayed = false;
	        $scope.useLocalBase = (imageryProvider !== null); // set up of checkbox
	        $scope.layers = this.cesium.dataSources; // connects layers to dataSources of Cesium Controller
	        $scope.imgLayers = this.cesium.imageryLayers; // connects layers to imagery layers of Cesium Controller
	        $scope.changeLayerAlpha = function (layer) { return _this.cesium.changeLayerAlpha(layer); };
	        $scope.closeMapWindow = function () { return $rootScope.$broadcast('contentModeChange', 'content-mode'); };
	        $scope.measureMap = function () { return _this.cesium.toggleRuler(); };
	        $scope.cesiumVersion = function () { return _this.cesium.version; };
	        // replace home button functionality with own flyhome action
	        // reason being, flyhome only works on 3D scene - https://cesiumjs.org/Cesium/Build/Documentation/Camera.html#flyHome
	        angular.element(document.querySelectorAll(toolbarEl + ' .cesium-home-button')).bind('click', function (event) {
	            _this.cesium.flyHome();
	            event.preventDefault();
	        });
	        // appends buttons to the cesium toolbar
	        angular.element(document.querySelectorAll(toolbarEl)).append($compile(map_buttons_1.MapButton)($scope));
	        angular.element(document.querySelectorAll(toolbarEl)).append($compile(map_buttons_1.MapRulerButton)($scope));
	        angular.element(document.querySelectorAll(toolbarEl)).append($compile(map_buttons_1.MapCloseButton)($scope));
	        var evtStart = this.cesium.viewer.camera.moveStart.addEventListener(function () {
	            _this.setDefaultCamera();
	            evtStart();
	        });
	    }
	    MapController.prototype.setDefaultCamera = function () {
	        var west = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MAP_WEST_LONGITUDE) || -180;
	        var south = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MAP_SOUTH_LATITUDE) || -90;
	        var east = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MAP_EAST_LONGITUDE) || 180;
	        var north = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MAP_NORTH_LATITUDE) || 90;
	        this.cesium.setDefaultCameraPosition(west, south, east, north);
	    };
	    // display airspace(s)
	    MapController.prototype.showAirspaces = function (airspacesToDisplay) {
	        var _this = this;
	        // airspacesNavDB
	        var navdb = this.configService.get('GEOSERVER_ABMSDB'); // geoserver navdb url
	        // remove previously loaded airspace layer
	        this.cesium.removeDataSourceByName(this.layers.airspaces.layerName);
	        // add all airsapces from geoserver abmsdb
	        this.cesium.addLayer(navdb, null, this.layers.airspaces.layerName, this.layers.airspaces.displayName, this.layers.airspaces.options)
	            .then(function (layer) { return _this.showEntitiesAndFlyTo(layer); });
	    };
	    MapController.prototype.showSelectedAirspace = function (airspacesToDisplay, isNavdb) {
	        var _this = this;
	        if (isNavdb === void 0) { isNavdb = false; }
	        // airspace to select identity
	        var airspaceId = airspacesToDisplay[0].id;
	        var airspaceIdent = airspacesToDisplay[0].airspace_name;
	        var airspaceType = airspacesToDisplay[0].airspace_type;
	        // current airsapce geoserver parameters
	        var currentDb = this.configService.get('GEOSERVER_ABMSDB');
	        var currentDbParams = "condition:id<>'" + airspaceId + "';";
	        // selected airsapce geoserver parameters
	        var selectDb;
	        var selectDbParams;
	        var selectLayerNameDb;
	        // determine based on provided setting (default to abmsdb geosever)
	        if (isNavdb) {
	            selectDb = this.configService.get('GEOSERVER_NAVDB');
	            selectDbParams = airspaceType
	                ? "where:IDENT='" + airspaceIdent + "' AND TYP='" + airspaceType + "';"
	                : "where:IDENT='" + airspaceIdent + "';";
	            selectLayerNameDb = this.layers.airspacesNavDB.layerName;
	        }
	        else {
	            selectDb = currentDb;
	            selectDbParams = "condition:id='" + airspaceId + "';";
	            selectLayerNameDb = this.layers.airspaces.layerName;
	        }
	        var dbBase = this.configService.get('GEOSERVER_BASE_PT1');
	        var selectWorkspace = isNavdb ? 'NAVDB' : 'ABMSDB';
	        // remove previously loaded airspace layers
	        this.cesium.removeImageryLayerByName(this.layers.airspaceCurrent.layerName);
	        this.cesium.removeImageryLayerByName(this.layers.airspaceSelect.layerName);
	        // add airsapce imagry layers from geoserver
	        // we must use imagery layers as Cesium has issues rendering large polygons with fill and out lines near the polls
	        this.cesium.addWMSLayer(dbBase, 'ABMSDB', this.layers.airspaceCurrent.layerName, this.layers.airspaceCurrent.displayName, currentDbParams, this.layers.airspaces.layerName, this.layers.airspaceCurrent.layerName);
	        this.cesium.addWMSLayer(dbBase, selectWorkspace, this.layers.airspaceSelect.layerName, this.layers.airspaceSelect.displayName, selectDbParams, selectLayerNameDb, this.layers.airspaceSelect.layerName);
	        // load layer features and fly to without displaying
	        // required to calculate visible location of airspace in imagry layer
	        this.$q.all([
	            this.cesium.loadLayer(currentDb, null, this.layers.airspaceCurrent.layerName, this.layers.airspaceCurrent.options, currentDbParams, this.layers.airspaces.layerName),
	            this.cesium.loadLayer(selectDb, null, this.layers.airspaceSelect.layerName, this.layers.airspaceSelect.options, selectDbParams, selectLayerNameDb)
	        ]).then(function (layers) { return _this.flyToEntities.apply(_this, layers); });
	    };
	    // remove all loaded datasources & imagery layers
	    MapController.prototype.removeAll = function () {
	        var ds = this.cesium.dataSourcesInstance;
	        // remove any loaded map entities which were from datasources (geojson)
	        for (var i = ds.length - 1; i >= 0; i--) {
	            ds.remove(ds.get(i), true);
	        }
	        // remove any loaded map layers which where from imagery providers (WMS)
	        for (var i = this.cesium.viewer.imageryLayers.length - 1; i >= 0; i--) {
	            var imgLayer = this.cesium.viewer.imageryLayers.get(i);
	            // only imagery layer that is not the base map layer
	            if (imgLayer.imageryProvider.layerName !== 'base_map') {
	                this.cesium.viewer.imageryLayers.remove(imgLayer);
	            }
	        }
	    };
	    // routeSegment layer should only return segments that are used for billing
	    MapController.prototype.viewParamsForSegmentLayer = function (fmID, enrouteChargeBasis) {
	        var segmentTypes = ['SCHED', 'RADAR', 'ATC', 'TOWER', 'USER', 'NOMINAL'];
	        // use the flight movement's enroute charge basis to match to an expected segment type
	        var segmentType = enrouteChargeBasis
	            ? segmentTypes.find(function (sT) { return enrouteChargeBasis.toLowerCase().includes(sT.toLowerCase()); })
	            : null;
	        // pass segment type to geoserver to return filtered route segments by segment type
	        return "i_condition:flight_movement='" + fmID + "'" + (segmentType ? " AND segment_type='" + segmentType + "'" : "") + ";";
	    };
	    // todo does not flyTo
	    MapController.prototype.showSingleAirspace = function (airspacesToDisplay) {
	        var _this = this;
	        // airspacesNavDB
	        var airspaceID = airspacesToDisplay[0].id;
	        var viewParams = "condition:id='" + airspaceID + "';";
	        var abmsdb = this.configService.get('GEOSERVER_ABMSDB'); // geoserver navdb url
	        // remove previously loaded airspace layer
	        this.cesium.removeDataSourceByName(this.layers.airspaces.layerName);
	        // add airsapce from geoserver abmsdb
	        this.cesium.addLayer(abmsdb, null, this.layers.airspaces.layerName, this.layers.airspaces.displayName, this.layers.airspaces.options, viewParams)
	            .then(function (layer) { return _this.showEntitiesAndFlyTo(layer); });
	    };
	    /**
	     * Loads and formats a single flight movement display and fly to.
	     *
	     * @param flightMovementsToDisplay flight movement to display
	     */
	    MapController.prototype.showSingleFlightMovement = function (flightMovementsToDisplay) {
	        var _this = this;
	        // clear out any previous flight movement loaded flag
	        this.$scope.flightMovementLoaded = false;
	        var cesiumBase = this.configService.get('GEOSERVER_BASE_PT1');
	        var fmID = flightMovementsToDisplay[0].id;
	        var abmsdb = this.configService.get('GEOSERVER_ABMSDB'); // geoserver navdb url
	        var viewParams = "where:id='" + fmID + "';";
	        var viewParamsCond = "i_condition:flight_movement='" + fmID + "';";
	        var enrouteChargeBasis = flightMovementsToDisplay[0].enroute_charges_basis;
	        var viewParamsForSegmentLayer = this.viewParamsForSegmentLayer(fmID, enrouteChargeBasis);
	        // airspaces WMS Layer
	        // load and display the imagery layer if it has not yet already been loaded
	        // this layer never changes so it only needs to be loaded once
	        if (!this.cesium.getImageryLayersByLayerName(this.layers.airspaces.layerName)) {
	            this.cesium.addWMSLayer(cesiumBase, 'ABMSDB', this.layers.airspaces.layerName, this.layers.airspaces.displayName, viewParamsCond);
	        }
	        // aerodromes WFS Layer
	        // load and display the imagery layer if it has not yet already been loaded
	        // this layer never changes so it only needs to be loaded once
	        if (!this.cesium.getDataSourceByLayerName(this.layers.aerodromes.layerName)) {
	            this.cesium.addLayer(abmsdb, null, this.layers.aerodromes.layerName, this.layers.aerodromes.displayName, this.layers.aerodromes.options, viewParams)
	                .then(function (layer) {
	                var that = _this;
	                var entities = layer.entities.values;
	                /**
	                 * Shortcut method to create the new label and pin billboard entity
	                 * @param ent Cesium entity
	                 * @param pin Generated pin marker image
	                 */
	                var updateEnt = function (ent, pin) {
	                    if (ent === void 0) { ent = {}; }
	                    ent.billboard.image = pin;
	                    ent.label = new that.cesium.mainCesium.LabelGraphics({
	                        text: ent.name,
	                        font: '13px sans-serif',
	                        fillColor: cesium.getColor('BLACK'),
	                        horizontalOrigin: that.cesium.mainCesium.HorizontalOrigin.LEFT,
	                        pixelOffset: new that.cesium.mainCesium.Cartesian2(15, -5),
	                        pixelOffsetScaleByDistance: new that.cesium.mainCesium.NearFarScalar(1.4e9, 0.3, 1.5e5, 0.4),
	                        translucencyByDistance: new that.cesium.mainCesium.NearFarScalar(1.0e6, 1.0, 1.3e6, 0.0)
	                    });
	                };
	                var _loop_1 = function () {
	                    var ent = entities[i];
	                    // check for the an existing custom pin image
	                    if (!_this.cesium.customPins.get('airport')) {
	                        // create the custom pin image
	                        _this.cesium.labelMaker('airport', window.location.pathname + 'assets/images/map/airport_30x30.png', cesium.getColor('CORNFLOWERBLUE'))
	                            .then(function (pin) {
	                            // the pin image is not generated, update the entity image now with it
	                            updateEnt(ent, pin);
	                        });
	                    }
	                    else {
	                        // the pin image already exists, go ahead and update the entity image with it
	                        updateEnt(ent, _this.cesium.customPins.get('airport'));
	                    }
	                };
	                // iterate over each aerodrome entity to update its image
	                for (var i = entities.length - 1; i >= 0; i--) {
	                    _loop_1();
	                }
	            });
	        }
	        // cancel pending flight movement request, only one flight movement can be disabled at one time
	        if (this.flightMovementRequest !== null && this.flightMovementRequest.pending()) {
	            this.flightMovementRequest.cancel();
	        }
	        // flight Movement WFS Layers
	        // ensure the previously loaded dataSource layers are removed
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsRadar.layerName);
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsATC.layerName);
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsTower.layerName);
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsScheduled.layerName);
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsInsideSP.layerName);
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsOutsideSP.layerName);
	        this.cesium.removeDataSourceByName(this.layers.routeSegments.layerName);
	        this.cesium.removeDataSourceByName('waypoints');
	        // build single flight movement cancelable promise request
	        this.flightMovementRequest = cancellable_class_1.Cancellable.promise(this.$q.all([
	            this.cesium.addLayer(abmsdb, null, this.layers.flightMovementsRadar.layerName, this.layers.flightMovementsRadar.displayName, this.layers.flightMovementsRadar.options, viewParams),
	            this.cesium.addLayer(abmsdb, null, this.layers.flightMovementsATC.layerName, this.layers.flightMovementsATC.displayName, this.layers.flightMovementsATC.options, viewParams),
	            this.cesium.addLayer(abmsdb, null, this.layers.flightMovementsTower.layerName, this.layers.flightMovementsTower.displayName, this.layers.flightMovementsTower.options, viewParams),
	            this.cesium.addLayer(abmsdb, null, this.layers.flightMovementsScheduled.layerName, this.layers.flightMovementsScheduled.displayName, this.layers.flightMovementsScheduled.options, viewParams),
	            this.cesium.addLayer(abmsdb, null, this.layers.flightMovementsInsideSP.layerName, this.layers.flightMovementsInsideSP.displayName, this.layers.flightMovementsInsideSP.options, viewParams),
	            this.cesium.addLayer(abmsdb, null, this.layers.flightMovementsOutsideSP.layerName, this.layers.flightMovementsOutsideSP.displayName, this.layers.flightMovementsOutsideSP.options, viewParams),
	            this.cesium.addLayer(abmsdb, null, this.layers.routeSegments.layerName, this.layers.routeSegments.displayName, this.layers.routeSegments.options, viewParamsForSegmentLayer)
	        ]));
	        // invoke promise and format single flight movement display if successful
	        // if error and layers supplied, remove layers from viewer
	        this.flightMovementRequest.promise
	            .then(function (layers) { return _this.formatSingleFlightMovement(layers, enrouteChargeBasis); })
	            .catch(function (exception) {
	            console.error('Could not format single flight movment layers: ', exception);
	            _this.removeSingleFlightMovement(exception.response);
	        });
	    };
	    MapController.prototype.flyToEntities = function () {
	        var layers = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            layers[_i] = arguments[_i];
	        }
	        // list of entities to fly to
	        var flytoEntities = [];
	        // loop through each layer and get entities that are defined
	        layers.forEach(function (layer) {
	            if (layer && layer.entities && layer.entities.values) {
	                flytoEntities = flytoEntities.concat(layer.entities.values);
	            }
	        });
	        // change ma viewport to layer entities
	        this.cesium.flyToEntities(flytoEntities);
	    };
	    MapController.prototype.showEntitiesAndFlyTo = function () {
	        var _this = this;
	        var layers = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            layers[_i] = arguments[_i];
	        }
	        // show all layer entities
	        layers.forEach(function (layer) {
	            _this.cesium.showEntitiesByDataSource(layer.layerName, null, false);
	        });
	        // change map viewport to layer entities
	        this.flyToEntities.apply(this, layers);
	    };
	    MapController.prototype.displayLayer = function (layer) {
	        if (layer.entities.values[0].polyline) {
	            this.cesium.showEntitiesByDataSource(layer.layerName, null, false);
	            return true;
	        }
	        else {
	            this.cesium.removeDataSourceByName(layer.layerName);
	            return false;
	        }
	    };
	    /**
	     * Format single flight movemet in cesium view.
	     */
	    MapController.prototype.formatSingleFlightMovement = function (layers, enrouteChargeBasis) {
	        var _this = this;
	        // loop through each added layer and display
	        // if inside/outside billing layers, skip and use route segments instead
	        var routeLayer = null;
	        layers.forEach(function (layer) {
	            switch (layer.layerName) {
	                case _this.layers.flightMovementsInsideSP.layerName:
	                case _this.layers.flightMovementsOutsideSP.layerName:
	                    break;
	                case _this.layers.routeSegments.layerName:
	                    routeLayer = layer;
	                    break;
	                default:
	                    _this.displayLayer(layer);
	                    break;
	            }
	        });
	        // if no 'not billable' portion, remove the layer
	        var notBillableDS = this.cesium.getDataSourceByLayerName(this.layers.flightMovementsOutsideSP.layerName);
	        if (!notBillableDS.entities.values[0] || !notBillableDS.entities.values[0].polyline) {
	            notBillableDS = null;
	            this.cesium.removeDataSourceByName(this.layers.flightMovementsOutsideSP.layerName);
	        }
	        // parse and resolve route segment layer as billable layer with waypoints if exists
	        var that = this;
	        this.cesium.showEntitiesByDataSource(routeLayer.layerName, null, false);
	        // create a new data custom source to manage the new custom waypoints
	        var customWaypointsLayer = new this.cesium.mainCesium.CustomDataSource('Custom Waypoints');
	        // set the usual map route layer properties
	        customWaypointsLayer.displayName = 'Waypoints';
	        customWaypointsLayer.layerName = 'waypoints';
	        customWaypointsLayer.cssValue = cesium.getCSSColor(cesium.getColor('ORANGE'));
	        // billable route segments
	        var trueBillableDS = this.cesium.getDataSourceByLayerName(this.layers.flightMovementsInsideSP.layerName);
	        var trueBillableEnts = trueBillableDS.entities.values;
	        var firstBillableEnt = trueBillableEnts[0];
	        // if no 'billable' portion, show all source layers instead
	        if (!trueBillableDS.entities.values[0] || !trueBillableDS.entities.values[0].polyline) {
	            this.cesium.toggleDataSourceLayers([
	                this.layers.flightMovementsATC.layerName,
	                this.layers.flightMovementsRadar.layerName,
	                this.layers.flightMovementsScheduled.layerName,
	                this.layers.flightMovementsTower.layerName
	            ]);
	        }
	        // not billable route segments
	        var notBillableEnts = notBillableDS ? notBillableDS.entities.values : null;
	        var firstNotBillableEnt = notBillableEnts ? notBillableEnts[0] : null;
	        var lastNotBillableEnt = notBillableEnts ? notBillableEnts[notBillableEnts.length - 1] : null;
	        var firstNotBillableEntPosition = firstNotBillableEnt && firstNotBillableEnt.polyline
	            ? firstNotBillableEnt.polyline.positions.getValue()[0] : null;
	        var lastNotBillableEntPosition = lastNotBillableEnt && lastNotBillableEnt.polyline
	            ? lastNotBillableEnt.polyline.positions.getValue()[lastNotBillableEnt.polyline.positions.getValue().length - 1] : null;
	        // all segments of enrouteChargeBasis type (ie. radar-summary)
	        var segEntities = routeLayer.entities.values;
	        var lastSegment = segEntities[segEntities.length - 1];
	        // radar route (used when enrouteChargeBasis is radar-summary and flight is international)
	        var firstbillableRadarRouteText = this.propertyValueOf(firstBillableEnt, 'radar_route_text');
	        var radarRouteList = firstbillableRadarRouteText ? firstbillableRadarRouteText.split(' ') : null;
	        var radarRouteFirstWaypoint = radarRouteList ? radarRouteList[0] : null;
	        var radarRouteFinalWaypoint = radarRouteList ? radarRouteList[radarRouteList.length - 1] : null;
	        var movementType = this.propertyValueOf(trueBillableDS.entities.values[0], 'movement_type');
	        // if there are no returned route segments
	        if (segEntities.length === 0) {
	            // hide the route segments route layer as there is nothing to show
	            // that.cesium.getDataSourceByLayerName(this.layers.routeSegments.layerName).show = false;
	            this.cesium.removeDataSourceByName(this.layers.routeSegments.layerName);
	        }
	        for (var i = segEntities.length - 1; i >= 0; i--) {
	            var currentSegment = segEntities[i];
	            // skip if segment polyline value does not exists
	            if (!currentSegment.polyline) {
	                continue;
	            }
	            var id = this.propertyValueOf(currentSegment, 'id');
	            var startlabel = this.propertyValueOf(currentSegment, 'startlabel');
	            var endlabel = this.propertyValueOf(currentSegment, 'endlabel');
	            var segment_number = this.propertyValueOf(currentSegment, 'segment_number');
	            var firstCurrentSegmentPosition = currentSegment.polyline.positions.getValue()[0];
	            var secondCurrentSegmentPosition = currentSegment.polyline.positions.getValue()[1];
	            // flight movement: destination inside FIR (arrival)
	            if (movementType === 'INT_ARRIVAL' || movementType === 'REG_ARRIVAL') {
	                // this is a arrival flight movement, the last route segement will be the ending segment
	                // verify if the last segements endlabel matches the billable exit point of the flight movement. IT SHOULD MATCH
	                // verify if the the segment number property matches the total number of segments to indicate it is the last segement.
	                if (endlabel === this.propertyValueOf(firstBillableEnt, 'billable_exit_point') && segment_number === segEntities.length) {
	                    // we can assume that the this is the ending of the route segement and therefore
	                    // the ending segment should be used for the destination (arrival)
	                    //          0   1  (2)
	                    //  depart --- --- ---> destination (use this end)
	                    // use the last position point in the segment polyline as the destination point position
	                    // make the end point (red arrival/dest)(inside FIR)
	                    map_utils_1.makePointEntity({
	                        id: id + 'e',
	                        label: endlabel,
	                        position: lastSegment.polyline.positions.getValue()[1],
	                        point: i
	                    }, { pointColor: 'RED', visible: movementType === 'REG_ARRIVAL' }, customWaypointsLayer, that);
	                    if (enrouteChargeBasis.includes('radar')) {
	                        map_utils_1.makePointEntity({
	                            id: id + 's',
	                            label: notBillableEnts ? radarRouteFirstWaypoint : startlabel,
	                            position: notBillableEnts ? firstNotBillableEntPosition : firstCurrentSegmentPosition,
	                            point: i
	                        }, { pointColor: 'ORANGE', visible: true }, customWaypointsLayer, that);
	                    }
	                    else {
	                        // make the start point (green departure)(outside FIR)
	                        map_utils_1.makePointEntity({
	                            id: id + 's',
	                            label: notBillableEnts ? this.propertyValueOf(firstNotBillableEnt, 'dep_ad') : startlabel,
	                            position: notBillableEnts ? firstNotBillableEntPosition : firstCurrentSegmentPosition,
	                            point: i
	                        }, { pointColor: 'GREEN', visible: true }, customWaypointsLayer, that);
	                    }
	                }
	                /* **middle point creation** */
	                map_utils_1.middlePointCreation(segEntities, customWaypointsLayer, i, that);
	                // flight movement: destination outside FIR (departure)
	            }
	            else if (movementType === 'INT_DEPARTURE' || movementType === 'REG_DEPARTURE') {
	                // this is a departure flight movement, the first route segment will be the starting segment.
	                // verify the start label with the billable entry point. THEY SHOULD MATCH.
	                // verify the segment number property as it should be 1 which indicates its the first segment
	                if (segment_number === 1 && startlabel === this.propertyValueOf(firstBillableEnt, 'billable_entry_point')) {
	                    if (enrouteChargeBasis.includes('radar')) {
	                        map_utils_1.makePointEntity({
	                            id: id + 'e',
	                            label: notBillableEnts ? radarRouteFinalWaypoint : endlabel,
	                            position: notBillableEnts ? lastNotBillableEntPosition : secondCurrentSegmentPosition,
	                            point: i
	                        }, { pointColor: 'ORANGE', visible: true }, customWaypointsLayer, that);
	                    }
	                    else {
	                        // we can assume that the this is the start of the route segement and therefore
	                        // the starting segment should be used for the departure
	                        //                       (0)  1   2
	                        // (use this end) depart --- --- ---> destination
	                        // use the first position point in the segment polyline as the departure point position
	                        // make the end point (red arrival/destination) (outside FIR)
	                        map_utils_1.makePointEntity({
	                            id: id + 'e',
	                            label: notBillableEnts ? this.propertyValueOf(firstNotBillableEnt, 'dest_ad') : endlabel,
	                            position: notBillableEnts ? lastNotBillableEntPosition : secondCurrentSegmentPosition,
	                            point: i
	                        }, { pointColor: 'RED', visible: true }, customWaypointsLayer, that);
	                    }
	                    // make the start point (green departure) (inside FIR)
	                    map_utils_1.makePointEntity({
	                        id: id + 's',
	                        label: startlabel,
	                        position: firstCurrentSegmentPosition,
	                        point: i
	                    }, { pointColor: 'GREEN', visible: movementType === 'REG_DEPARTURE' }, customWaypointsLayer, that);
	                }
	                /* **middle point creation** */
	                map_utils_1.middlePointCreation(segEntities, customWaypointsLayer, i, that);
	                // flight movement: destination & departure outside FIR
	            }
	            else if (movementType === 'OVERFLIGHT') {
	                if (enrouteChargeBasis.includes('radar')) {
	                    if (segment_number === 1) {
	                        if (radarRouteFirstWaypoint !== startlabel) {
	                            // start
	                            map_utils_1.makePointEntity({
	                                id: id + 'e',
	                                label: radarRouteFirstWaypoint,
	                                position: notBillableEnts ? firstNotBillableEntPosition : firstCurrentSegmentPosition,
	                                point: i
	                            }, { pointColor: 'ORANGE', visible: true }, customWaypointsLayer, that);
	                        }
	                        if (radarRouteFinalWaypoint !== this.propertyValueOf(lastSegment, 'endlabel') && radarRouteFinalWaypoint !== radarRouteFirstWaypoint) {
	                            // end
	                            map_utils_1.makePointEntity({
	                                id: id + 'e',
	                                label: radarRouteList.length > 1 ? radarRouteFinalWaypoint : '',
	                                position: notBillableEnts ? lastNotBillableEntPosition : secondCurrentSegmentPosition,
	                                point: i
	                            }, { pointColor: 'ORANGE', visible: true }, customWaypointsLayer, that);
	                        }
	                    }
	                }
	                else if (startlabel === this.propertyValueOf(firstBillableEnt, 'billable_entry_point') && segment_number === 1) {
	                    // if the segments start label matches the billable entry point
	                    // then the first point in the first flight movement outside (not billed) first position point is the departure (start point)
	                    // and the last flight movement outside (not billed) last position point is the destination (end point)
	                    // start
	                    map_utils_1.makePointEntity({
	                        id: id + 's',
	                        label: notBillableEnts ? this.propertyValueOf(firstNotBillableEnt, 'dep_ad') : startlabel,
	                        position: notBillableEnts ? firstNotBillableEntPosition : firstCurrentSegmentPosition,
	                        point: i
	                    }, { pointColor: 'GREEN', visible: true }, customWaypointsLayer, that);
	                    // end
	                    map_utils_1.makePointEntity({
	                        id: id + 'e',
	                        label: notBillableEnts ? this.propertyValueOf(firstNotBillableEnt, 'dest_ad') : endlabel,
	                        position: notBillableEnts ? lastNotBillableEntPosition : secondCurrentSegmentPosition,
	                        point: i
	                    }, { pointColor: 'RED', visible: true }, customWaypointsLayer, that);
	                }
	                /* **middle point creation** */
	                map_utils_1.middlePointCreation(segEntities, customWaypointsLayer, i, that);
	            }
	            else if (movementType === 'DOMESTIC') {
	                if (segment_number === 1) {
	                    // make the start point (green departure)(inside FIR)
	                    var firstSegmentStartLabel = this.propertyValueOf(currentSegment, 'startlabel');
	                    map_utils_1.makePointEntity({
	                        id: id + 's',
	                        label: firstSegmentStartLabel === 'ZZZZ' || firstSegmentStartLabel === 'AFIL'
	                            ? this.propertyValueOf(firstBillableEnt, 'item18_dep') : firstSegmentStartLabel,
	                        position: currentSegment.polyline.positions.getValue()[0],
	                        point: i
	                    }, { pointColor: 'GREEN', visible: true }, customWaypointsLayer, that);
	                }
	                else if (segment_number === segEntities.length) {
	                    // we can assume that the this is the ending of the route segement and therefore
	                    // the ending segment should be used for the destination (arrival)
	                    //          0   1  (2)
	                    //  depart --- --- ---> destination (use this end)
	                    // use the last position point in the segment polyline as the destination point position
	                    // make the end point (red arrival/dest)(inside FIR)
	                    map_utils_1.makePointEntity({
	                        id: id + 'e',
	                        label: endlabel === 'ZZZZ' ? this.propertyValueOf(firstBillableEnt, 'arrival_ad') : endlabel,
	                        position: currentSegment.polyline.positions.getValue()[1],
	                        point: i
	                    }, { pointColor: 'RED', visible: true }, customWaypointsLayer, that);
	                }
	                /* **middle point creation** */
	                map_utils_1.middlePointCreation(segEntities, customWaypointsLayer, i, that);
	            }
	            else {
	                // flight movement: unknown waypoints, movement_type === 'OTHER'
	                // if we are at the end of the segments then also add the end waypoint
	                if (segment_number === segEntities.length) {
	                    map_utils_1.makePointEntity({
	                        id: id + 'e',
	                        label: endlabel,
	                        position: secondCurrentSegmentPosition,
	                        point: i
	                    }, { pointColor: 'RED', visible: true }, customWaypointsLayer, that);
	                }
	                else if (i === 0) {
	                    // add the waypoint from the start of the segments
	                    map_utils_1.makePointEntity({
	                        id: id + 's',
	                        label: startlabel,
	                        position: firstCurrentSegmentPosition,
	                        point: i
	                    }, { pointColor: 'GREEN', visible: true }, customWaypointsLayer, that);
	                }
	                /* **middle point creation** */
	                map_utils_1.middlePointCreation(segEntities, customWaypointsLayer, i, that);
	            } // end if
	        } // end for loop
	        if (segEntities.length > 0) {
	            // add the list of waypoints to the new custom waypoint datasource instance which will then add to the map and display
	            that.cesium.viewer.dataSources.add(customWaypointsLayer);
	        }
	        else {
	            customWaypointsLayer = null;
	        }
	        // remove unnessary inside layer as route segments replaces it
	        this.cesium.removeDataSourceByName(this.layers.flightMovementsInsideSP.layerName);
	        // remove and readd outside layer if it exists
	        // this is necessary so route segments is displayed overtop
	        if (notBillableDS) {
	            this.cesium.removeDataSourceByName(this.layers.flightMovementsOutsideSP.layerName);
	            this.cesium.addDataSource(notBillableDS);
	        }
	        // sort data source by display name
	        this.cesium.sortDateSourceByDisplayName();
	        // update flight movement loaded flag
	        this.$scope.flightMovementLoaded = true;
	        // fly display to newly added layers that are visible
	        this.flyToEntities.apply(this, layers.filter(function (layer) { return layer.show; }));
	    };
	    /**
	     * Removes flight movement layers from cesium view.
	     */
	    MapController.prototype.removeSingleFlightMovement = function (layers) {
	        if (layers) {
	            for (var _i = 0, layers_1 = layers; _i < layers_1.length; _i++) {
	                var layer = layers_1[_i];
	                this.cesium.removeDataSourceLayer(layer);
	            }
	        }
	    };
	    /**
	     * Entiry property values are no longer raw values as of Cesium v1.32. This checks
	     * the entitry properties for the value safely with proper null checks and then
	     * returns the value if found, else returns null.
	     */
	    MapController.prototype.propertyValueOf = function (entity, name) {
	        return entity && entity.properties && entity.properties[name] && entity.properties[name].valueOf()
	            ? entity.properties[name].valueOf() : null;
	    };
	    return MapController;
	}());
	exports.MapController = MapController;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	// this class should contain NO FRAMEWORK SPECIFIC CODE
	// we want to continue using this for future projects
	Object.defineProperty(exports, "__esModule", { value: true });
	var CesiumClass = (function () {
	    function CesiumClass(params) {
	        if (params === void 0) { params = {}; }
	        this._viewer = null;
	        this._cesiumKey = null;
	        this._debug = false;
	        this._customPins = new Map();
	        this._flytoDuration = null;
	        this._flytoPadding = null;
	        this._flytoMaxZoom = null;
	        this.debug = params.debug;
	        this.flytoDuration = params.flytoDuration || null;
	        this.flytoPadding = params.flytoPadding || null;
	        this.flytoMaxZoom = params.flytoMaxZoom || null;
	    }
	    CesiumClass.prototype.toggleRuler = function () {
	        if (!this._viewer.drawToolPolyline) {
	            this._viewer.extend(DrawToolPolyline.viewerCesiumDrawPoly, {});
	            this._viewer.drawToolPolyline.startDrawing();
	        }
	        else {
	            this._viewer.drawToolPolyline.destroy();
	        }
	    };
	    // returns cesium color object from hexadecimal string
	    CesiumClass.prototype.fromColorString = function (hexColor, alpha) {
	        if (hexColor === void 0) { hexColor = '#000000'; }
	        if (alpha === void 0) { alpha = 1.0; }
	        return new Cesium.Color.fromCssColorString(hexColor).withAlpha(alpha);
	    };
	    // returns cesium color object
	    CesiumClass.prototype.fromColor = function (red, green, blue, alpha) {
	        if (red === void 0) { red = 0; }
	        if (green === void 0) { green = 0; }
	        if (blue === void 0) { blue = 0; }
	        if (alpha === void 0) { alpha = 1.0; }
	        return new Cesium.Color(red, green, blue, alpha);
	    };
	    // returns a matching predefined cesium color object
	    CesiumClass.prototype.getColor = function (theColor) {
	        if (theColor === void 0) { theColor = 'WHITE'; }
	        return Cesium.Color[theColor];
	    };
	    // returns a matching predefined cesium color object
	    CesiumClass.prototype.getCSSColor = function (theColor) {
	        return theColor.toCssColorString();
	    };
	    Object.defineProperty(CesiumClass.prototype, "cesiumKey", {
	        set: function (key) {
	            // we do not use Ion, must remove default access token
	            // https://groups.google.com/d/msg/cesium-dev/OPYLmP4iCe8/Uy788PJqDwAJ
	            Cesium.Ion.defaultAccessToken = null;
	            // setup cesium key with bing maps only
	            Cesium.BingMapsApi.defaultKey = key;
	            this._cesiumKey = key;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "customPins", {
	        get: function () {
	            return this._customPins;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CesiumClass.prototype.createViewer = function (cesiumContainerElement, cesiumViewerParameters) {
	        if (cesiumViewerParameters === void 0) { cesiumViewerParameters = {}; }
	        this.viewer = new Cesium.Viewer(cesiumContainerElement, cesiumViewerParameters);
	    };
	    // set the default camera position for the viwer based on the position defined in .env
	    CesiumClass.prototype.setDefaultCameraPosition = function (west, south, east, north) {
	        if (west === void 0) { west = 0; }
	        if (south === void 0) { south = 0; }
	        if (east === void 0) { east = 0; }
	        if (north === void 0) { north = 0; }
	        // if longitude values are too small for max zoom
	        // find midpoint and add/minus max zoom
	        if (east - west < this.flytoMaxZoom) {
	            var midpoint = (east + west) / 2;
	            east = midpoint + this.flytoMaxZoom / 2;
	            west = midpoint - this.flytoMaxZoom / 2;
	        }
	        // if latitude values are too small for max zoom
	        // find midpoint and add/minus max zoom
	        if (north - south < this.flytoMaxZoom) {
	            var midpoint = (north + south) / 2;
	            north = midpoint + this.flytoMaxZoom / 2;
	            south = midpoint - this.flytoMaxZoom / 2;
	        }
	        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = new Cesium.Rectangle.fromDegrees(west, south, east, north);
	        this.viewer.scene.camera.setView({
	            destination: Cesium.Camera.DEFAULT_VIEW_RECTANGLE
	        });
	    };
	    /**
	     * Adds a layer and makes an AJAX call to navdb/geoserver
	     *
	     * @param navdb         URL to navdb/geoserver
	     * @param boundingBox   if it's only to a certain section of the map (bounding box)
	     * @param layerName         the layer to add
	     * @param displayName   display name to give layer
	     * @param opts          options used for the datasource
	     * @param layerNameDb   geoserver layer name, if null uses layerName
	     */
	    CesiumClass.prototype.addLayer = function (navdb, boundingBox, layerName, displayName, opts, viewParams, layerNameDb) {
	        var _this = this;
	        if (navdb === void 0) { navdb = null; }
	        if (boundingBox === void 0) { boundingBox = null; }
	        if (layerName === void 0) { layerName = ''; }
	        if (displayName === void 0) { displayName = ''; }
	        if (opts === void 0) { opts = {}; }
	        if (viewParams === void 0) { viewParams = ''; }
	        if (layerNameDb === void 0) { layerNameDb = null; }
	        return this.loadLayer(navdb, boundingBox, layerName, opts, viewParams, layerNameDb)
	            .then(function (layer) {
	            layer.layerName = layerName;
	            layer.displayName = displayName;
	            layer.cssValue = _this.getCSSColor(opts.markerColor || opts.stroke);
	            layer.alpha = opts.fillOpacity;
	            layer.show = opts.show === undefined ? true : opts.show;
	            _this.addDataSource(layer);
	            return layer;
	        });
	    };
	    /**
	     * Loads a layer and makes an AJAX call to navdb/geoserver
	     *
	     * @param navdb         URL to navdb/geoserver
	     * @param boundingBox   if it's only to a certain section of the map (bounding box)
	     * @param layerName     the layer to add
	     * @param opts          options used for the datasource
	     * @param layerNameDb   geoserver layer name, if null uses layerName
	     */
	    CesiumClass.prototype.loadLayer = function (navdb, boundingBox, layerName, opts, viewParams, layerNameDb) {
	        if (navdb === void 0) { navdb = null; }
	        if (boundingBox === void 0) { boundingBox = null; }
	        if (layerName === void 0) { layerName = ''; }
	        if (opts === void 0) { opts = {}; }
	        if (viewParams === void 0) { viewParams = ''; }
	        if (layerNameDb === void 0) { layerNameDb = null; }
	        var url = "" + navdb + (layerNameDb || layerName);
	        var dataSource = new Cesium.GeoJsonDataSource(layerName);
	        if (boundingBox !== null) {
	            url += "&bbox=" + encodeURIComponent(boundingBox) + "&";
	        }
	        if (viewParams !== null) {
	            url += '&viewparams=' + encodeURIComponent(viewParams);
	        }
	        return dataSource.load(url, opts);
	    };
	    /**
	     *
	     * @param db The database name for part of the request url in Geosever
	     * @param workspace The name of the workspace for part of the request url in Geoserver
	     * @param layerName The layer name to load from Geoserver
	     * @param displayName The display name used for tracking purposes
	     * @param viewParams Any view paramaters used for querying against Geoserver
	     */
	    CesiumClass.prototype.addWMSLayer = function (db, workspace, layerName, displayName, viewParams, layerDbName, layerDbStyle) {
	        if (db === void 0) { db = null; }
	        if (workspace === void 0) { workspace = ''; }
	        if (layerName === void 0) { layerName = ''; }
	        if (displayName === void 0) { displayName = ''; }
	        if (viewParams === void 0) { viewParams = ''; }
	        if (layerDbName === void 0) { layerDbName = null; }
	        if (layerDbStyle === void 0) { layerDbStyle = null; }
	        // the request url
	        var url = "" + db + workspace + "/wms";
	        // the WMS request params
	        var params = {
	            service: 'WMS',
	            version: '1.1.1',
	            request: 'GetMap',
	            styles: layerDbStyle || 'V_Airspaces',
	            // format_options : "antialiasing:false",
	            tiled: true,
	            transparent: true,
	            format: 'image/png',
	            viewParams: viewParams || ''
	        };
	        // construct the imagery provider with the new url and params
	        var provider = new Cesium.WebMapServiceImageryProvider({
	            url: url,
	            layers: workspace + ":" + (layerDbName || layerName),
	            parameters: params,
	            getFeatureInfoParameters: {}
	        });
	        // add the imagery layer to the collection
	        var imageryLayers = this.viewer.imageryLayers.addImageryProvider(provider);
	        // set the display name property to the new imagery layer
	        imageryLayers.displayName = displayName;
	        imageryLayers.layerName = layerName;
	        // return the new imagery layer
	        return imageryLayers;
	    };
	    /**
	     * Tries to match an `id` with the `entities` property `id` and fly viewer camera
	     * to found entities. If none found, viewer camera will fly home.
	     *
	     * Note: `options.destination` is ignored and overwritten with layer entities as a rectangle.
	     */
	    CesiumClass.prototype.flyToFindByID = function (layerName, id, options) {
	        if (options === void 0) { options = { destination: null }; }
	        var entities = this.getEntityValuesByLayerName(layerName);
	        var flyToTarget = entities.find(function (entity) { return entity.properties.id === id; });
	        // fly to found target entities
	        this.flyToEntities(flyToTarget, options);
	    };
	    /**
	     * Fly viewer camera to list of cesium entities, padding and max/min zoom is applied. If no entity points found,
	     * viewer camera will fly home.
	     *
	     * Note: `options.destination` is ignored and overwritten with entities as a rectangle.
	     */
	    CesiumClass.prototype.flyToEntities = function (target, options) {
	        var _this = this;
	        if (options === void 0) { options = { destination: null }; }
	        // get all points from each target
	        var points = [];
	        target.forEach(function (entity) {
	            if (entity.polygon) {
	                points = points.concat(entity.polygon.hierarchy.getValue(_this.viewer.clock.currentTime).positions);
	            }
	            else if (entity.polyline) {
	                points = points.concat(entity.polyline.positions.getValue(_this.viewer.clock.currentTime));
	            }
	        });
	        // if no points found, fly home
	        if (points.length === 0) {
	            this.flyHome();
	            return;
	        }
	        // create rectangular viewpoint from each point and fly to resulting viewport
	        this.flyToViewport(Cesium.Rectangle.fromCartesianArray(points, Cesium.Ellipsoid.WGS84), options);
	    };
	    /**
	     * Fly viewer camera to visiable viewport. Padding and max/min zoom is applied.
	     *
	     * Note: `options.destination` is ignored and overwritten with viewport.
	     */
	    CesiumClass.prototype.flyToViewport = function (viewport, options) {
	        if (options === void 0) { options = { destination: null }; }
	        // get viewport computed height and width
	        var viewportHeight = Cesium.Rectangle.computeHeight(viewport);
	        var viewportWidth = Cesium.Rectangle.computeWidth(viewport);
	        // if viewport dimensions are less then max zoom level
	        // set to max zoom level
	        viewportHeight = viewportHeight > this.flytoMaxZoom ? viewportHeight : this.flytoMaxZoom;
	        viewportWidth = viewportWidth > this.flytoMaxZoom ? viewportWidth : this.flytoMaxZoom;
	        // calculate padding from height and width
	        var horizontalPadding = viewportHeight * this.flytoPadding;
	        var verticalPadding = viewportWidth * this.flytoPadding;
	        // add padding to viewpoint
	        viewport.west = viewport.west - horizontalPadding;
	        viewport.north = viewport.north + verticalPadding;
	        viewport.east = viewport.east + horizontalPadding;
	        viewport.south = viewport.south - verticalPadding;
	        // ensure viewport does not exceed valid range - https://cesiumjs.org/Cesium/Build/Documentation/Rectangle.html
	        // valid range [west, east]: [-Pi, Pi]
	        // valid range [south, north]: [-Pi/2, Pi/2]
	        viewport.west = viewport.west < -Math.PI ? -Math.PI : viewport.west;
	        viewport.north = viewport.north > Math.PI / 2 ? Math.PI / 2 : viewport.north;
	        viewport.east = viewport.east > Math.PI ? Math.PI : viewport.east;
	        viewport.south = viewport.south < -Math.PI / 2 ? -Math.PI / 2 : viewport.south;
	        // set options destination to viewport
	        options.destination = viewport;
	        // move camera using defined fly to options
	        this.flyTo(options);
	    };
	    /**
	     * Fly viewer camera home using system configuration settings.
	     *
	     * Note: `options.destination` is ignored and overwritten with default view rectangle.
	     */
	    CesiumClass.prototype.flyHome = function (options) {
	        if (options === void 0) { options = { destination: null }; }
	        // set destination to default view rectangle defined from system configuration settings
	        options.destination = Cesium.Camera.DEFAULT_VIEW_RECTANGLE;
	        // move camera using defined fly to options
	        this.flyTo(options);
	    };
	    /**
	     * Fly viewer camera to destination using provided fly to options or default values. No
	     * padding or max/min zoom is applied. If no `options.destination` value supplied, viewer
	     * camera will fly home.
	     *
	     * https://cesiumjs.org/Cesium/Build/Documentation/Viewer.html?classFilter=viewer#flyTo
	     */
	    CesiumClass.prototype.flyTo = function (options) {
	        if (options === void 0) { options = { destination: null }; }
	        // if no destination provided, fly to default view rectangle defined from system configuration settings
	        if (!options.destination) {
	            options.destination = Cesium.Camera.DEFAULT_VIEW_RECTANGLE;
	        }
	        // default option duration to 800 milliseconds
	        if (!options.duration) {
	            options.duration = this.flytoDuration;
	        }
	        // move camera to viewpoint
	        this.viewer.camera.flyTo(options);
	    };
	    /**
	     * Returns the index of the imagery layer from the list.
	     * @param layerName Name of the imagery layer
	     */
	    CesiumClass.prototype.getImageryLayersIndexByLayerName = function (layerName) {
	        for (var i = 0; i < this.viewer.imageryLayers.length; i++) {
	            if (layerName === this.viewer.imageryLayers.get(i).layerName) {
	                return i;
	            }
	        }
	    };
	    /**
	     * Returns the matching imagery layer if it exists in the list.
	     * @param layerName Name of the imagery layer
	     */
	    CesiumClass.prototype.getImageryLayersByLayerName = function (layerName) {
	        var index = this.getImageryLayersIndexByLayerName(layerName);
	        return this.viewer.imageryLayers.get(index);
	    };
	    CesiumClass.prototype.sortDateSourceByDisplayName = function (asc) {
	        if (asc === void 0) { asc = true; }
	        this.dataSources.sort(function (a, b) {
	            if (asc) {
	                return a.displayName > b.displayName;
	            }
	            else {
	                return a.displayName < b.displayName;
	            }
	        });
	    };
	    // returns the index of a dataSource from it's `layerName`
	    CesiumClass.prototype.getDataSourceIndexByLayerName = function (layerName) {
	        this.sortDateSourceByDisplayName();
	        for (var i = 0; i < this.dataSources.length; i++) {
	            if (layerName === this.dataSources[i].layerName) {
	                return i;
	            }
	        }
	    };
	    CesiumClass.prototype.getDataSourceByLayerName = function (layerName) {
	        var index = this.getDataSourceIndexByLayerName(layerName);
	        return this.dataSources[index];
	    };
	    CesiumClass.prototype.getEntityValuesByLayerName = function (layerName) {
	        var ds = this.getDataSourceByLayerName(layerName);
	        return ds ? ds.entities.values : [];
	    };
	    // changes the layer opacity
	    CesiumClass.prototype.changeLayerAlpha = function (layer) {
	        if (layer === void 0) { layer = null; }
	        var entities = layer.entities.values;
	        for (var i = 0, len = entities.length; i < len; i++) {
	            var entity = entities[i];
	            var alpha = layer.alpha;
	            if (alpha >= 1) {
	                alpha = 1.00;
	            }
	            if (entity.polyline) {
	                var color = entity.polyline.material.color.getValue();
	                entity.polyline.material.color.setValue(new Cesium.Color(color.red, color.green, color.blue, alpha));
	            }
	            else if (entity.polygon) {
	                var color = entity.polygon.material.color.getValue();
	                entity.polygon.material = this.fromColor(color.red, color.green, color.blue, alpha);
	            }
	            else if (entity.billboard) {
	                entity.billboard.color = this.fromColorString('#435888', alpha); // todo can't find key to retrieve entity color
	            }
	        }
	    };
	    CesiumClass.prototype.getSceneMode = function (scene) {
	        if (scene === void 0) { scene = null; }
	        return Cesium.SceneMode[scene];
	    };
	    Object.defineProperty(CesiumClass.prototype, "dataSources", {
	        // static datasources list. BAD
	        get: function () {
	            return this.viewer.dataSources._dataSources;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "dataSourcesInstance", {
	        // datasources instance. GOOD
	        // todo: set proper interface
	        get: function () {
	            return this.viewer.dataSources;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // remove a loaded data source by name if it exists
	    CesiumClass.prototype.removeDataSourceByName = function (layerName) {
	        if (layerName === void 0) { layerName = null; }
	        var layer = null;
	        do {
	            layer = this.getDataSourceByLayerName(layerName);
	            if (layer) {
	                this.viewer.dataSources.remove(layer);
	            }
	        } while (layer);
	    };
	    // remove a loaded imagery layer by layer name if present
	    CesiumClass.prototype.removeImageryLayerByName = function (layerName) {
	        if (layerName === void 0) { layerName = null; }
	        for (var i = this.viewer.imageryLayers.length - 1; i >= 0; i--) {
	            if (this.viewer.imageryLayers.get(i).layerName === layerName) {
	                return this.viewer.imageryLayers.remove(this.viewer.imageryLayers.get(i));
	            }
	        }
	    };
	    // if objectsToDisplay is `null`, will display/hide ALL
	    CesiumClass.prototype.showEntitiesByDataSource = function (layerName, objectsToDisplay, hide) {
	        if (layerName === void 0) { layerName = null; }
	        if (hide === void 0) { hide = false; }
	        var entities = this.getEntityValuesByLayerName(layerName);
	        for (var i = 0; i < entities.length; i++) {
	            if (objectsToDisplay !== null) {
	                for (var o = 0; o < objectsToDisplay.length; o++) {
	                    if (objectsToDisplay[o].id === entities[i].properties.id) {
	                        entities[i].show = !hide;
	                    }
	                }
	            }
	            else {
	                entities[i].show = !hide; // show/hide ALL
	            }
	        }
	    };
	    /**
	     * Custom label creation util.
	     * @param name Easy lookup name
	     * @param assetUrl Url for which the asset can be located
	     * @param color The background color of the new custom pin
	     */
	    CesiumClass.prototype.labelMaker = function (name, assetUrl, color) {
	        if (name === void 0) { name = null; }
	        if (assetUrl === void 0) { assetUrl = null; }
	        var self = this;
	        if (!this.customPins.get(name)) {
	            var pinBuilder = new Cesium.PinBuilder();
	            return Cesium.when(pinBuilder.fromUrl(assetUrl, color, 40), function (canvas) {
	                // once canvas image is generated, set it to the map object by key name
	                self.customPins.set(name, canvas.toDataURL());
	                return canvas.toDataURL();
	            });
	        }
	    };
	    /**
	     * Shows/hides layers
	     * null means show/hide all
	     * array length of zero means do nothing
	     *
	     * @param layersToShow
	     * @param layersToHide
	     */
	    CesiumClass.prototype.toggleDataSourceLayers = function (layersToShow, layersToHide) {
	        if (layersToShow === void 0) { layersToShow = []; }
	        if (layersToHide === void 0) { layersToHide = []; }
	        // ensures that there are no duplicates, priority given to `layersToShow`
	        if (layersToShow !== null && layersToHide !== null) {
	            layersToHide = layersToHide.filter(function (val) { return layersToShow.indexOf(val) !== -1; });
	        }
	        for (var i = 0; i < this.dataSources.length; i++) {
	            var show = false; // ensures we do not hide layers, we have just toggled to show
	            if (layersToShow === null || layersToShow.indexOf(this.dataSources[i].layerName) !== -1) {
	                show = true;
	                this.dataSources[i].show = true;
	            }
	            if (!show && (layersToHide === null || layersToHide.indexOf(this.dataSources[i].layerName) !== -1)) {
	                this.dataSources[i].show = false;
	            }
	        }
	    };
	    CesiumClass.prototype.createOpenStreetMap = function (url, layerName, displayName) {
	        if (url === void 0) { url = null; }
	        if (layerName === void 0) { layerName = null; }
	        if (displayName === void 0) { displayName = null; }
	        if (url === null) {
	            url = 'https://a.tile.openstreetmap.org/';
	        }
	        var osmProvider = new Cesium.createOpenStreetMapImageryProvider({
	            url: url
	        });
	        osmProvider.layerName = layerName;
	        osmProvider.displayName = displayName;
	        return osmProvider;
	    };
	    CesiumClass.prototype.removeDataSource = function (layerName) {
	        if (layerName === void 0) { layerName = null; }
	        var dataSource = this.getDataSourceByLayerName(layerName);
	        this.viewer.dataSources.remove(dataSource);
	    };
	    CesiumClass.prototype.removeDataSourceLayer = function (layer) {
	        this.viewer.dataSources.remove(layer);
	    };
	    Object.defineProperty(CesiumClass.prototype, "imageryLayers", {
	        get: function () {
	            /* var arr = [];
	             for (var i = this.viewer.imageryLayers.length - 1; i >= 0; i--) {
	               arr.push(this.viewer.imageryLayers.get(i));
	             }
	             //return arr; */
	            return this.viewer.imageryLayers._layers;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CesiumClass.prototype.addDataSource = function (layer) {
	        if (layer === void 0) { layer = null; }
	        this.viewer.dataSources.add(layer);
	    };
	    Object.defineProperty(CesiumClass.prototype, "viewer", {
	        get: function () {
	            return this._viewer;
	        },
	        set: function (viewer) {
	            this._viewer = viewer;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "version", {
	        get: function () {
	            return Cesium.VERSION;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "mainCesium", {
	        // the main Cesium accessor
	        get: function () {
	            return Cesium;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "debug", {
	        get: function () {
	            return this._debug;
	        },
	        set: function (debug) {
	            this._debug = debug;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "flytoDuration", {
	        get: function () {
	            return this._flytoDuration;
	        },
	        set: function (flytoDuration) {
	            this._flytoDuration = flytoDuration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "flytoPadding", {
	        get: function () {
	            return this._flytoPadding;
	        },
	        set: function (flytoPadding) {
	            this._flytoPadding = flytoPadding;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CesiumClass.prototype, "flytoMaxZoom", {
	        get: function () {
	            return this._flytoMaxZoom;
	        },
	        set: function (flytoMaxZoom) {
	            this._flytoMaxZoom = flytoMaxZoom;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CesiumClass;
	}());
	exports.CesiumClass = CesiumClass;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Utility class for creating cancellable requests.
	 */
	var Cancellable = (function () {
	    function Cancellable() {
	    }
	    /**
	     * Wraps AngularJS Promise in a cancellable promise.
	     *
	     * @param promise promise to make cancellable
	     */
	    Cancellable.promise = function (promise) {
	        var hasCancelled = false;
	        var isPending = true;
	        var wrappedPromise = new Promise(function (resolve, reject) {
	            // handle promise fulfillment
	            promise.then(function (val) {
	                isPending = false;
	                hasCancelled
	                    ? reject({ isCancelled: true, response: val })
	                    : resolve(val);
	            });
	            // handle promise rejection
	            promise.catch(function (err) {
	                isPending = false;
	                hasCancelled
	                    ? reject({ isCancelled: true, error: err })
	                    : reject({ isCancelled: false, error: err });
	            });
	        });
	        return {
	            cancel: function () { return hasCancelled = true; },
	            pending: function () { return isPending; },
	            promise: wrappedPromise
	        };
	    };
	    return Cancellable;
	}());
	exports.Cancellable = Cancellable;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Util to create point entities easily and add to the customWaypointsLayer collection
	 * @param label Text to use for the label
	 * @param pos Cartesian3 position to use
	 * @param pointColor Display color to use
	 * @param visible To display it once loaded
	 * @param i The integer used to created unique Ids and names
	 */
	var PIXEL_OFFSET = [15, -5];
	var PIXEL_OFFSET_SCALE_BY_DISTANCE = [1.4e9, 0.3, 1.5e5, 0.4];
	var TRANSLUCENCY_BY_DISTANCE = [1.0e6, 1.0, 1.3e6, 0.0];
	exports.makePointEntity = function (segment, options, customWaypointsLayer, that) {
	    var id = segment.id, label = segment.label, position = segment.position, point = segment.point;
	    // visible defaults to true
	    var pointColor = options.pointColor, _a = options.visible, visible = _a === void 0 ? true : _a;
	    var aerodromeNames = that.cesium.getEntityValuesByLayerName(that.layers.aerodromes.layerName).map(function (aerodrome) { return aerodrome.name; });
	    // skip if waypoint is already in the customWaypointsLayer
	    if (customWaypointsLayer.entities.values.find(function (entity) { return entity.name.endsWith(label); })
	        || customWaypointsLayer.entities.getById('waypoint_' + point + '_' + label + '_' + id)) {
	        return;
	    }
	    ;
	    customWaypointsLayer.entities.add({
	        id: 'waypoint_' + point + '_' + label + '_' + id,
	        name: 'waypoint_' + point + '_' + label,
	        position: position,
	        point: {
	            color: that.cesium.getColor(pointColor),
	            outlineColor: that.cesium.getColor('WHITE'),
	            pixelSize: 8
	        },
	        label: {
	            text: label,
	            font: '13px sans-serif',
	            fillColor: that.cesium.getColor('BLACK'),
	            horizontalOrigin: that.cesium.mainCesium.HorizontalOrigin.LEFT,
	            pixelOffset: new ((_b = that.cesium.mainCesium.Cartesian2).bind.apply(_b, [void 0].concat(PIXEL_OFFSET)))(),
	            pixelOffsetScaleByDistance: new ((_c = that.cesium.mainCesium.NearFarScalar).bind.apply(_c, [void 0].concat(PIXEL_OFFSET_SCALE_BY_DISTANCE)))(),
	            translucencyByDistance: new ((_d = that.cesium.mainCesium.NearFarScalar).bind.apply(_d, [void 0].concat(TRANSLUCENCY_BY_DISTANCE)))(),
	            show: (aerodromeNames.includes(label) || label === 'ZZZZ') ? false : visible
	        }
	    });
	    var _b, _c, _d;
	};
	exports.middlePointCreation = function (segments, customWaypointsLayer, i, that) {
	    var _a = segments[i].properties, id = _a.id, startlabel = _a.startlabel, endlabel = _a.endlabel, segment_number = _a.segment_number;
	    var polyline = segments[i].polyline;
	    var segmentOptions = { pointColor: 'ORANGE', visible: true };
	    var nextSegment = segments[i + 1];
	    var customWaypointByStartlabel = customWaypointsLayer.entities.getById('waypoint_' + i + '_' + startlabel + '_' + id + 's');
	    var customWaypointByEndlabel = customWaypointsLayer.entities.getById('waypoint_' + i + '_' + endlabel + '_' + id + 'e');
	    var polylinePosition1 = polyline.positions.getValue()[0];
	    var polylinePosition2 = polyline.positions.getValue()[1];
	    // if we are at the end of the segments then also add the end waypoint
	    if (segment_number === segments.length && segments.length > 1 && !customWaypointByEndlabel) {
	        exports.makePointEntity({
	            id: id + 'e',
	            label: endlabel,
	            position: polylinePosition2,
	            point: i
	        }, segmentOptions, customWaypointsLayer, that);
	    }
	    // if the route segments are split (crossing FIR), add the other waypoint to show crossing
	    if (nextSegment && (!nextSegment.polyline || !polylinePosition2.equals(nextSegment.polyline.positions.getValue()[0]))) {
	        exports.makePointEntity({
	            id: id + 'e',
	            label: endlabel,
	            position: polylinePosition2,
	            point: i
	        }, segmentOptions, customWaypointsLayer, that);
	    }
	    // if the point doesn't match any in the current set that could already exist
	    if (!customWaypointByStartlabel) {
	        // add the middle waypoints from the start of the segments
	        exports.makePointEntity({
	            id: id + 's',
	            label: startlabel,
	            position: polylinePosition1,
	            point: i
	        }, segmentOptions, customWaypointsLayer, that);
	    }
	    // if there is only one segment, make sure that its not the same as the end
	    if (segments.length === 1 && !polylinePosition2.equals(customWaypointByEndlabel)) {
	        exports.makePointEntity({
	            id: id + 'e',
	            label: endlabel,
	            position: polylinePosition2,
	            point: i
	        }, segmentOptions, customWaypointsLayer, that);
	    }
	};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MapButton = "<button type=\"button\" id=\"cesium_layers_button\" ng-click=\"showDetails = !showDetails\"\n      class=\"cesium-button cesium-toolbar-button\"\n      title=\"Cesium v{{ cesiumVersion() }}\">\n        <i class=\"fa fa-cog\"></i>\n      </button>";
	exports.MapCloseButton = "<button type=\"button\" id=\"cesium_close_button\" ng-click=\"closeMapWindow()\"\n    class=\"cesium-button cesium-toolbar-button\" title=\"{{ 'Close Map' | translate }}\">\n      <i class=\"fa fa-close\"></i>\n    </button>";
	exports.MapRulerButton = "<button type=\"button\" id=\"cesium_close_button\" ng-click=\"measureMap()\"\n    class=\"cesium-button cesium-toolbar-button\" title=\"{{ 'Map Measurment Tool' | translate }}\">\n    <i class=\"fa fa-fw icon-ruler\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64.73 64.7\">\n    <defs><style>.cls-1{fill:#fff;}</style></defs><title>icon-ruler</title><path class=\"cls-1\"\n    d=\"M68.72,21.58l-15-15a3.07,3.07,0,0,0-4.24,0L5.75,50.36a3,3,0,0,0,0,4.24l15,15a3,3,0,0,0,4.24,0L68.72,\n    25.82A3,3,0,0,0,68.72,21.58ZM22.85,66,9.28,52.48l2.53-2.53,4.86,4.86A2,2,0,0,0,19.5,52l-4.86-4.86,2.65-2.65,\n    9.28,9.28a2,2,0,0,0,2.83-2.83l-9.28-9.28,3-3L28,43.49a2,2,0,0,0,2.83-2.83L26,35.8l2.65-2.65,9.28,9.28a2,2,0,0,\n    0,2.83-2.83l-9.28-9.28,3-3,4.86,4.86a2,2,0,0,0,2.83-2.83l-4.86-4.86,2.65-2.65,9.37,9.37a2,2,0,0,0,2.83-2.83L42.75,\n    19l2.92-2.92L50.53,21a2,2,0,0,0,2.83-2.83l-4.86-4.86,3.13-3.13L65.19,23.7Z\" transform=\"translate(-4.87 -5.75)\"/></svg>\n    </i>\n  </button>";


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AircraftExemptManagementController = (function (_super) {
	    __extends(AircraftExemptManagementController, _super);
	    /* @ngInject */
	    AircraftExemptManagementController.$inject = ["$scope", "aircraftExemptManagementService", "systemConfigurationService"];
	    function AircraftExemptManagementController($scope, aircraftExemptManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, aircraftExemptManagementService) || this;
	        _this.$scope = $scope;
	        _this.aircraftExemptManagementService = aircraftExemptManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        _this.getFilterParameters();
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        return _this;
	    }
	    AircraftExemptManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AircraftExemptManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return AircraftExemptManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AircraftExemptManagementController = AircraftExemptManagementController;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var system_configuration_constants_1 = __webpack_require__(10);
	// classes
	var CrcoCertificatesController = (function (_super) {
	    __extends(CrcoCertificatesController, _super);
	    /* @ngInject */
	    CrcoCertificatesController.$inject = ["$scope", "$rootScope", "$uibModal", "crcoCertificatesService", "sysConfigBoolean", "systemConfigurationService"];
	    function CrcoCertificatesController($scope, $rootScope, $uibModal, crcoCertificatesService, sysConfigBoolean, systemConfigurationService) {
	        var _this = _super.call(this, $scope, crcoCertificatesService, $uibModal, 'Certificate Format') || this;
	        _this.$scope = $scope;
	        _this.$rootScope = $rootScope;
	        _this.$uibModal = $uibModal;
	        _this.crcoCertificatesService = crcoCertificatesService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        $scope.pattern = '.p12';
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.reset = function () { return _this.reset(); };
	        _this.$scope.crco_invoice_support = _this.sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CRCO_INVOICE_SUPPORT));
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.executeMessage = function (preview) { return _this.executeMessage(preview); };
	        $scope.deleteCertificate = function (id) { return _this.deleteCertificate(id); };
	        $scope.showCertificate = function (item) { return _this.showCertificate(item); };
	        return _this;
	    }
	    CrcoCertificatesController.prototype.showCertificate = function (item) {
	        _super.prototype.edit.call(this, item);
	    };
	    CrcoCertificatesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CrcoCertificatesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    //metodo che genera un flightMessage
	    CrcoCertificatesController.prototype.executeMessage = function (preview) {
	        this.$scope.processing = true;
	        this.$scope.preview = preview;
	        //this.setProcessDates();
	        this.$scope.generate.executeCalculation(this.$scope.editable);
	    };
	    CrcoCertificatesController.prototype.getMaskedPassword = function (password) {
	        return '*'.repeat(password.length);
	    };
	    CrcoCertificatesController.prototype.deleteCertificate = function (id) {
	        _super.prototype.delete.call(this, id);
	    };
	    return CrcoCertificatesController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.CrcoCertificatesController = CrcoCertificatesController;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var CrcoReportingResponsabilitiesController = (function (_super) {
	    __extends(CrcoReportingResponsabilitiesController, _super);
	    /* @ngInject */
	    CrcoReportingResponsabilitiesController.$inject = ["$scope", "crcoReportingResponsabilitiesService", "$filter", "sysConfigBoolean", "systemConfigurationService"];
	    function CrcoReportingResponsabilitiesController($scope, crcoReportingResponsabilitiesService, $filter, sysConfigBoolean, systemConfigurationService) {
	        var _this = _super.call(this, $scope, crcoReportingResponsabilitiesService) || this;
	        _this.$scope = $scope;
	        _this.crcoReportingResponsabilitiesService = crcoReportingResponsabilitiesService;
	        _this.$filter = $filter;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.nameMap = {
	            applies_to_type_arrival: 'ARR',
	            applies_to_type_departure: 'DEP',
	            applies_to_type_domestic: 'DOM',
	            applies_to_type_overflight: 'OVF',
	            applies_to_scope_domestic: 'DOM',
	            applies_to_scope_regional: 'REG',
	            applies_to_scope_international: 'INT',
	            applies_to_rule_ifr: 'IFR',
	            applies_to_rule_vfr: 'VFR'
	        };
	        _this.addToListEntering = function (selected, action, type) {
	            _this.$scope.validationErrors.listFirEntering = false;
	            selected.forEach(function (item) {
	                _this.$scope.listEnteringIncludedExcluded.push({
	                    item: angular.copy(item),
	                    action: action,
	                    type: type
	                });
	            });
	            // Rimuovi le opzioni appena incluse/escluse dal multiselect
	            if (type === 'FIR') {
	                selected.forEach(function (sel) {
	                    for (var i = 0; i < _this.$scope.listFirEntering.length; i++) {
	                        if (_this.$scope.listFirEntering[i].id === sel.id) {
	                            _this.$scope.listFirEntering.splice(i, 1);
	                            break; // esce subito dal ciclo, non continua
	                        }
	                    }
	                });
	            }
	            else {
	                //rimozione viene fatto nel filterAirportsByInitial('entering')">
	                _this.$scope.filterAirportsByInitial('entering');
	                _this.$scope.editable.airportInitialsEntering = '';
	            }
	            // Svuota il multiselect
	            _this.$scope.selectedFirEntering = [];
	            _this.$scope.selectedAirportsEntering = [];
	        };
	        _this.deleteEntering = function (id) {
	            var removedItem = null;
	            _this.$scope.validationErrors.listEnteringIncludedExcluded = false;
	            // rimuovi dalla tabella e reinserisci subito in listFirEntering
	            for (var i = 0; i < _this.$scope.listEnteringIncludedExcluded.length; i++) {
	                if (_this.$scope.listEnteringIncludedExcluded[i].item.id === id) {
	                    removedItem = _this.$scope.listEnteringIncludedExcluded[i].item;
	                    _this.$scope.listEnteringIncludedExcluded.splice(i, 1);
	                    if (_this.$scope.editable.typ_entering === 'FIR') {
	                        // reinserisci subito in listFirEntering
	                        _this.$scope.listFirEntering.push(removedItem);
	                        _this.$scope.listFirEntering.sort(function (a, b) {
	                            return a.airspace_name.localeCompare(b.airspace_name);
	                        });
	                        break; // esce subito dal ciclo
	                    }
	                    else {
	                        _this.$scope.editable.airportInitialsEntering = '';
	                    }
	                }
	            }
	            if (_this.$scope.editable.typ_entering === 'FIR') {
	                _this.$scope.editable.entering_include = _this.$scope.editable.entering_include
	                    .split(",")
	                    .map(function (s) { return s.trim(); })
	                    .filter(function (v) { return v !== removedItem.airspace_name; })
	                    .join(", ");
	                _this.$scope.editable.entering_exclude = _this.$scope.editable.entering_exclude
	                    .split(",")
	                    .map(function (s) { return s.trim(); })
	                    .filter(function (v) { return v !== removedItem.airspace_name; })
	                    .join(", ");
	            }
	            else {
	                _this.$scope.editable.entering_include = _this.$scope.editable.entering_include
	                    .split(",")
	                    .map(function (s) { return s.trim(); })
	                    .filter(function (v) { return v !== removedItem.ident; })
	                    .join(", ");
	                _this.$scope.editable.entering_exclude = _this.$scope.editable.entering_exclude
	                    .split(",")
	                    .map(function (s) { return s.trim(); })
	                    .filter(function (v) { return v !== removedItem.ident; })
	                    .join(", ");
	            }
	        };
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.reset = function () { return _this.reset(); };
	        crcoReportingResponsabilitiesService.listAll().then(function (aerodromes) { return $scope.listAirportFromNavDb = aerodromes.content; });
	        _this.$scope.crco_invoice_support = _this.sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CRCO_INVOICE_SUPPORT));
	        $scope.createReportingResponsability = function (rep_resp) {
	            /**   if (!$scope.validateFIRList(rep_resp)) {
	                   return;
	               }*/
	            return _this.createOverride(rep_resp).then(function () {
	                $scope.setEmpty();
	                $scope.form.$setUntouched();
	            });
	        };
	        $scope.showReportingResponsability = function (item) { return _this.showReportingResponsability(item); };
	        _this.$scope.deleteEntering = function (id) { return _this.deleteEntering(id); };
	        $scope.updateReportingResponsability = function (item, id) {
	            /**  if (!$scope.validateFIRList(item)) {
	                  return;
	              }*/
	            _this.updateReportingResponsability(item, id).then(function () {
	                // dopo che update + refresh della lista sono completati
	                $scope.setEmpty();
	                $scope.form.$setUntouched();
	            });
	        };
	        $scope.checkIfAirspaceAdded = function (airspaceName) { return _this.$scope.airspaceAlreadyExists = _this.checkIfAirspaceAdded(airspaceName); };
	        $scope.filterAirspaceType = function (airspaceType) { return _this.$scope.listFromNavDB = _this.filterAirspaceType(airspaceType); };
	        $scope.filteredListFromNavDB = [];
	        $scope.filteredAirportFromNavDb = [];
	        $scope.airportInitials = [];
	        $scope.selectedAirportsDeparture = [];
	        $scope.selectedAirportsDepartureGroup = [];
	        $scope.selectedFirDeparture = [];
	        $scope.airportInitialsEntering = [];
	        $scope.listFirEntering = [];
	        $scope.listAirportEntering = [];
	        $scope.selectedFirEntering = [];
	        $scope.selectedAirportsEntering = [];
	        $scope.listEnteringIncludedExcluded = [];
	        $scope.validationErrors = {
	            departure_include: false,
	            listEnteringIncludedExcluded: false,
	            listFirEntering: false
	        };
	        $scope.setDropdownDepartureToNull = function () { return _this.setDropdownDepartureToNull(); };
	        $scope.setDropdownEnteringToNull = function () { return _this.setDropdownEnteringToNull(); };
	        $scope.getApplication = function (item, type) { return _this.getApplication(item, type); };
	        _this.loadAirport();
	        _this.loadAirspaces();
	        $scope.addAirportToListDeparture = function () {
	            if (_this.$scope.editable.selectionType === 'Group') {
	                _this.$scope.editable.departure_include = _this.addToList(_this.$scope.selectedAirportsDepartureGroup, 'label');
	            }
	            else {
	                _this.$scope.editable.departure_include = _this.addToList(_this.$scope.selectedAirportsDeparture, 'ident');
	            }
	        };
	        /** funzione che filtra la lista degli aeroporti recuperata da navDB in base a una lettera scelta.
	         in caso di entering vengono esclusi gli aeroporti gia inclusi/esclusi */
	        $scope.filterAirportsByInitial = function (source) {
	            var selectedInitial = source === 'departure' ? $scope.editable.airportInitials : $scope.editable.airportInitialsEntering;
	            var filtered = $scope.listAirportFromNavDb.filter(function (a) {
	                var sameInitial = _this.isSameInitial(a.ident, selectedInitial);
	                if (source === 'departure') {
	                    return sameInitial;
	                }
	                else {
	                    var notAlreadyUsed = !$scope.listEnteringIncludedExcluded.some(function (e) { return e.item.ident === a.ident; });
	                    return sameInitial && notAlreadyUsed;
	                }
	            });
	            if (source === 'departure') {
	                $scope.filteredAirportFromNavDb = filtered.sort(function (a, b) { return a.ident.localeCompare(b.ident); });
	            }
	            else {
	                $scope.listAirportEntering = filtered;
	            }
	        };
	        /** Gestione selezione departure per FIR/ALL FLIGHT -> in base alla selezione viene filtrata la lista da mostrare
	        in caso di ALL FLIGHT la selezione di un opzione include la selezione anche di tutte le opzioni con la stessa iniziale*/
	        $scope.addFirToListDeparture = function () {
	            _this.$scope.validationErrors.departure_include = false;
	            _this.$scope.editable.departure_include = _this.addToList($scope.selectedFirDeparture, 'airspace_name');
	            if ($scope.selectedFirDeparture && $scope.selectedFirDeparture.length > 0) {
	                // prendi la prima selezionata
	                var firstSelected = $scope.selectedFirDeparture[0];
	                var initial_1 = firstSelected.displayLabel.charAt(0).toUpperCase();
	                // filtra in base a quella lettera
	                $scope.filteredListFromNavDB = $scope.listFromNavDB.filter(function (item) { return _this.isSameInitial(item.displayLabel, initial_1); });
	                if ($scope.editable.typ_departure === 'ALL FLIGHTS') {
	                    $scope.selectedFirDeparture = angular.copy($scope.filteredListFromNavDB);
	                    $scope.editable.departure_include = _this.addToList($scope.selectedFirDeparture, 'airspace_name');
	                }
	            }
	            else {
	                // nessuna selezione → reset alla lista completa
	                $scope.filteredListFromNavDB = angular.copy($scope.listFromNavDB);
	            }
	        };
	        $scope.include = function () {
	            if ($scope.editable.typ_entering === 'FIR') {
	                _this.addToListEntering($scope.selectedFirEntering, 'include', $scope.editable.typ_entering);
	            }
	            else {
	                _this.addToListEntering($scope.selectedAirportsEntering, 'include', $scope.editable.typ_entering);
	            }
	        };
	        $scope.exclude = function () {
	            if ($scope.editable.typ_entering === 'FIR') {
	                _this.addToListEntering($scope.selectedFirEntering, 'exclude', $scope.editable.typ_entering);
	            }
	            else {
	                _this.addToListEntering($scope.selectedAirportsEntering, 'exclude', $scope.editable.typ_entering);
	            }
	        };
	        $scope.prepareFields = function () {
	            $scope.prepareDepartureFields();
	            $scope.prepareEnteringFields();
	        };
	        $scope.prepareDepartureFields = function () {
	            if ($scope.editable.typ_departure === 'ALL FLIGHTS' && $scope.selectedFirDeparture && $scope.selectedFirDeparture.length !== 0) {
	                _this.$scope.editable.departure_exclude = _this.addToList($scope.selectedFirDeparture, 'airspace_name');
	                _this.$scope.editable.departure_include = '';
	            }
	            if ($scope.editable.typ_departure === 'FIR' && $scope.selectedFirDeparture && $scope.selectedFirDeparture.length !== 0) {
	                var firstLetter_1 = $scope.selectedFirDeparture[0].airspace_name.charAt(0).toUpperCase();
	                // Filtra tutti gli elementi che iniziano con la stessa lettera
	                var departureArray = $scope.listFromNavDB.filter(function (item) { return _this.isSameInitial(item.airspace_name, firstLetter_1); });
	                // Per l'exclude, togli quelli selezionati dall'utente
	                var excludeArray = departureArray.filter(function (item) { return !$scope.selectedFirDeparture.some(function (f) { return f.airspace_name === item.airspace_name; }); });
	                $scope.editable.departure_exclude = _this.addToList(excludeArray, 'airspace_name');
	            }
	        };
	        $scope.prepareEnteringFields = function () {
	            if ($scope.listEnteringIncludedExcluded && $scope.listEnteringIncludedExcluded.length !== 0) {
	                var tempInclude_1 = [];
	                var tempExclude_1 = [];
	                $scope.listEnteringIncludedExcluded.forEach(function (entry) {
	                    if (entry.action === 'include') {
	                        tempInclude_1.push(entry.item);
	                    }
	                    if (entry.action === 'exclude') {
	                        tempExclude_1.push(entry.item);
	                    }
	                });
	                if ($scope.editable.typ_entering === 'FIR') {
	                    _this.$scope.editable.entering_include = _this.addToList(tempInclude_1, 'airspace_name');
	                    _this.$scope.editable.entering_exclude = _this.addToList(tempExclude_1, 'airspace_name');
	                }
	                else {
	                    _this.$scope.editable.entering_include = _this.addToList(tempInclude_1, 'ident');
	                    _this.$scope.editable.entering_exclude = _this.addToList(tempExclude_1, 'ident');
	                }
	            }
	        };
	        $scope.setEmpty = function () {
	            // FIR e Airport multiselect
	            $scope.validationErrors = {
	                departure_include: false,
	                listEnteringIncludedExcluded: false,
	                listFirEntering: false
	            };
	            $scope.selectedFirDeparture = [];
	            $scope.selectedAirportsDeparture = [];
	            $scope.selectedAirportsDepartureGroup = [];
	            $scope.filteredListFromNavDB = angular.copy($scope.listFromNavDB);
	            $scope.editable.airportInitials = 'A';
	            $scope.filteredAirportFromNavDb = _this.$filter('orderBy')($scope.listAirportFromNavDb.filter(function (a) { return _this.isSameInitial(a.ident, "A"); }), 'ident');
	            // Entering FIR
	            $scope.selectedFirEntering = [];
	            $scope.selectedAirportsEntering = [];
	            $scope.listFirEntering = angular.copy($scope.listFromNavDB);
	            $scope.editable.airportInitialsEntering = 'A';
	            $scope.listAirportEntering = angular.copy($scope.filteredAirportFromNavDb);
	            $scope.listEnteringIncludedExcluded = [];
	            // Reset dei campi di editable legati ai multiselect
	            $scope.editable.departure_include = '';
	            $scope.editable.departure_exclude = '';
	            $scope.editable.entering_include = '';
	            $scope.editable.entering_exclude = '';
	        };
	        /** funzione per mostrare il form gia precompilato in caso di update */
	        $scope.updateAerodromeMultiselect = function () {
	            $scope.updateDeparture();
	            $scope.updateEntering();
	        };
	        $scope.updateDeparture = function () {
	            $scope.editable.airportInitials = '';
	            $scope.editable.selectionType = 'Default';
	            $scope.selectedAirportsDeparture = [];
	            $scope.selectedAirportsDepartureGroup = [];
	            $scope.selectedFirDeparture = [];
	            $scope.airportInitials = _this.initAirportInitials();
	            $scope.airportInitialsGroup = _this.initAirportInitialsGroup();
	            var departure;
	            if (($scope.editable.typ_departure).toUpperCase() === 'ALL FLIGHTS') {
	                departure = $scope.editable.departure_exclude;
	            }
	            if (($scope.editable.typ_departure).toUpperCase() === 'FIR') {
	                departure = $scope.editable.departure_include;
	            }
	            if (departure) {
	                var includeList_1 = departure.split(',').map(function (s) { return s.trim(); });
	                $scope.selectedFirDeparture = $scope.listFromNavDB.filter(function (aerodrome) { return includeList_1.includes(aerodrome.airspace_name); });
	                $scope.selectedAirportsDeparture = [];
	                $scope.selectedAirportsDepartureGroup = [];
	                var initial_2 = departure.charAt(0);
	                // filtra in base a quella lettera
	                $scope.filteredListFromNavDB = $scope.listFromNavDB.filter(function (item) { return _this.isSameInitial(item.displayLabel, initial_2); });
	                if (($scope.editable.typ_departure).toUpperCase() === 'ALL FLIGHTS') {
	                    $scope.editable.departure_include = $scope.editable.departure_exclude;
	                    $scope.editable.departure_exclude = '';
	                }
	            }
	            if (($scope.editable.typ_departure).toUpperCase() === 'AIRPORT' && $scope.editable.departure_include) {
	                var includeList_2 = $scope.editable.departure_include.split(',').map(function (s) { return s.trim(); });
	                $scope.editable.departure_includeList = includeList_2;
	                $scope.editable.selectionType = 'Default';
	                if (includeList_2[0].length > 2) {
	                    $scope.selectedAirportsDeparture = $scope.listAirportFromNavDb.filter(function (aerodrome) { return includeList_2.includes(aerodrome.ident); });
	                    $scope.editable.airportInitials = $scope.editable.departure_include.charAt(0).toUpperCase();
	                    $scope.filterAirportsByInitial('departure');
	                }
	                else {
	                    $scope.selectedAirportsDepartureGroup = $scope.airportInitialsGroup.filter(function (group) {
	                        return includeList_2.includes(group.id.toUpperCase());
	                    });
	                    $scope.editable.selectionType = 'Group';
	                }
	                $scope.selectedFirDeparture = [];
	            }
	        };
	        $scope.updateEntering = function () {
	            $scope.editable.airportInitialsEntering = '';
	            $scope.airportInitialsEntering = _this.initAirportInitials();
	            $scope.listEnteringIncludedExcluded = [];
	            if (($scope.editable.typ_entering).toUpperCase() === 'FIR') {
	                ['include', 'exclude'].forEach(function (actionType) {
	                    var csv = actionType === 'include' ? $scope.editable.entering_include : $scope.editable.entering_exclude;
	                    if (csv) {
	                        var list_1 = csv.split(',').map(function (s) { return s.trim(); });
	                        var items = $scope.listFromNavDB
	                            .filter(function (aerodrome) { return list_1.includes(aerodrome.airspace_name); })
	                            .map(function (item) { return ({
	                            item: item,
	                            action: actionType,
	                            type: 'FIR'
	                        }); });
	                        $scope.listEnteringIncludedExcluded = $scope.listEnteringIncludedExcluded.concat(items);
	                        items.forEach(function (e) {
	                            var index = $scope.listFirEntering.findIndex(function (f) { return f.id === e.item.id; });
	                            if (index !== -1)
	                                $scope.listFirEntering.splice(index, 1);
	                        });
	                    }
	                });
	            }
	            if (($scope.editable.typ_entering).toUpperCase() === 'AIRPORT') {
	                ['include', 'exclude'].forEach(function (actionType) {
	                    var csv = actionType === 'include' ? $scope.editable.entering_include : $scope.editable.entering_exclude;
	                    if (csv) {
	                        var list_2 = csv.split(',').map(function (s) { return s.trim(); });
	                        var items = $scope.listAirportFromNavDb
	                            .filter(function (aerodrome) { return list_2.includes(aerodrome.ident); })
	                            .map(function (item) { return ({
	                            item: item,
	                            action: actionType,
	                            type: 'AIRPORT'
	                        }); });
	                        $scope.listEnteringIncludedExcluded = $scope.listEnteringIncludedExcluded.concat(items);
	                        $scope.filterAirportsByInitial('entering');
	                        $scope.editable.airportInitialsEntering = '';
	                    }
	                });
	            }
	        };
	        $scope.isValidMultiselect = function () {
	            if ($scope.editable.typ_departure === 'FIR' || $scope.editable.typ_departure === 'ALL FLIGHTS') {
	                return $scope.selectedFirDeparture && $scope.selectedFirDeparture.length > 0;
	            }
	            else {
	                if ($scope.editable.selectionType === 'Default') {
	                    return $scope.selectedAirportsDeparture && $scope.selectedAirportsDeparture.length > 0;
	                }
	                else {
	                    return $scope.selectedAirportsDepartureGroup && $scope.selectedAirportsDepartureGroup.length > 0;
	                }
	            }
	        };
	        return _this;
	        /**   $scope.validateFIRList = (rep_resp: IReportingResponsabilities) => {
	              $scope.validationErrors = {
	                  departure_include: false,
	                  listEnteringIncludedExcluded: false,
	                  listFirEntering: false,
	                  departure_conflicts : ''
	              }; // reset
	  
	              let valid = true;
	  
	  
	              if (['FIR'].indexOf(rep_resp.typ_departure) !== -1) {
	                  if (rep_resp.departure_include && rep_resp.departure_exclude) {
	                      // Ottieni i prefissi (prime due lettere) delle opzioni da exclude
	                      const includeArr = rep_resp.departure_include.split(',').map(s => s.trim().toUpperCase());
	                      const excludeArr = rep_resp.departure_exclude.split(',').map(s => s.trim().toUpperCase());
	  
	                      // Ottieni i prefissi (prime due lettere) di exclude e include
	                      const includePrefixes = Array.from(new Set(includeArr.map(item => item.slice(0, 2))));
	                      const excludePrefixes = Array.from(new Set(excludeArr.map(item => item.slice(0, 2))));
	  
	  
	                      // Controlla se qualche prefisso di include è presente in exclude
	                      const commonPrefixes = includePrefixes.filter(prefix => excludePrefixes.indexOf(prefix) !== -1);
	  
	                      if (commonPrefixes.length>0) {
	                          $scope.validationErrors.departure_include = true;
	                          $scope.validationErrors.departure_exclude = true;
	                          valid = false;
	                          // salvo i prefissi in una variabile accessibile dal template
	                          $scope.validationErrors.departure_conflicts = commonPrefixes.join(', ');
	                      }else{
	                         $scope.validationErrors.departure_conflicts = '';
	                        }
	                  }
	              }
	              return valid;
	          };*/
	    }
	    CrcoReportingResponsabilitiesController.prototype.addToList = function (model, prop) {
	        var items = null;
	        var neededProp = null;
	        if (model.length > 0) {
	            items = model.map(function (item) {
	                Object.getOwnPropertyNames(item).forEach(function (val, idx, array) {
	                    if (val === prop) {
	                        neededProp = item[val];
	                    }
	                });
	                return neededProp;
	            }).join(',');
	        }
	        return items;
	    };
	    CrcoReportingResponsabilitiesController.prototype.selectAirports = function (newValue) {
	        this.$scope.editable.departure_include = newValue[0].departure_include;
	    };
	    CrcoReportingResponsabilitiesController.prototype.createOverride = function (reportingResponsability) {
	        this.service = this.crcoReportingResponsabilitiesService;
	        this.refreshOverride();
	        return _super.prototype.create.call(this, reportingResponsability);
	    };
	    CrcoReportingResponsabilitiesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    CrcoReportingResponsabilitiesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CrcoReportingResponsabilitiesController.prototype.showReportingResponsability = function (item) {
	        _super.prototype.edit.call(this, item);
	    };
	    CrcoReportingResponsabilitiesController.prototype.updateReportingResponsability = function (item, id) {
	        return _super.prototype.update.call(this, item, id); // ritorna una promise
	    };
	    CrcoReportingResponsabilitiesController.prototype.checkIfAirspaceAdded = function (airspaceName) {
	        for (var i in this.$scope.list) {
	            if (airspaceName === this.$scope.list[i].airspace_name) {
	                return true;
	            }
	        }
	        return false;
	    };
	    CrcoReportingResponsabilitiesController.prototype.setDropdownDepartureToNull = function () {
	        this.$scope.editable.departure_include = '';
	        this.$scope.editable.departure_exclude = '';
	        this.$scope.selectedAirportsDeparture = [];
	        this.$scope.selectedAirportsDepartureGroup = [];
	        this.$scope.selectedFirDeparture = [];
	        this.$scope.filteredListFromNavDB = angular.copy(this.$scope.listFromNavDB);
	        if (this.$scope.editable.typ_departure === null) {
	            this.$scope.editable.typ_departure = '';
	        }
	    };
	    CrcoReportingResponsabilitiesController.prototype.setDropdownEnteringToNull = function () {
	        this.$scope.editable.entering_include = '';
	        this.$scope.editable.entering_exclude = '';
	        this.$scope.selectedFirEntering = [];
	        this.$scope.selectedAirportsEntering = [];
	    };
	    // returns filtered airspaces on whether they are FIR, FIR_P, TMA or all airspaces
	    CrcoReportingResponsabilitiesController.prototype.filterAirspaceType = function (airspaceType) {
	        if (airspaceType === null) {
	            return null;
	        }
	        var listOfAirspaces = [];
	        for (var i in this.listFromNavDB) {
	            if (this.listFromNavDB[i].airspace_type === airspaceType) {
	                listOfAirspaces.push(this.listFromNavDB[i]);
	            }
	        }
	        return listOfAirspaces;
	    };
	    CrcoReportingResponsabilitiesController.prototype.loadAirspaces = function () {
	        var _this = this;
	        this.service.getAirspacesFromNavDB().then(function (response) {
	            _this.$scope.listFromNavDB = _this.$filter('filter')(response.content, function (item) { return item.airspace_type === 'FIR'; });
	            _this.$scope.listFromNavDB = _this.$filter('orderBy')(_this.$scope.listFromNavDB, 'airspace_name');
	            _this.$scope.listFromNavDB.forEach(function (item) {
	                item.displayLabel = item.airspace_name + " (" + item.airspace_type + ")";
	            });
	            _this.$scope.listFirEntering = angular.copy(_this.$scope.listFromNavDB);
	            _this.$scope.filteredListFromNavDB = angular.copy(_this.$scope.listFromNavDB);
	        }, function () { return _this.$scope.navDBError = true; }); // error when trying to get airspaces from navDB
	    };
	    CrcoReportingResponsabilitiesController.prototype.loadAirport = function () {
	        var _this = this;
	        this.service.getAirportFromNavDB().then(function (response) {
	            _this.$scope.listAirportFromNavDb = response.content;
	            _this.$scope.filteredAirportFromNavDb = angular.copy(_this.$filter('orderBy')(_this.$scope.listAirportFromNavDb.filter(function (a) { return a.ident.charAt(0).toUpperCase() === 'A'; }), 'ident'));
	            _this.$scope.airportInitials = _this.initAirportInitials();
	            _this.$scope.editable.airportInitials = '';
	            _this.$scope.listAirportEntering = angular.copy(_this.$scope.filteredAirportFromNavDb);
	            _this.$scope.editable.airportInitialsEntering = '';
	            _this.$scope.airportInitialsEntering = _this.initAirportInitials();
	            _this.$scope.airportInitialsGroup = _this.initAirportInitialsGroup();
	            _this.$scope.editable.selectionType = 'Default';
	        }, function () { return _this.$scope.navDBError = true; }); // error when trying to get airport from navDB
	    };
	    CrcoReportingResponsabilitiesController.prototype.getApplication = function (item, type) {
	        var output = '';
	        for (var p in item) {
	            if (item.hasOwnProperty(p)) {
	                if (p.indexOf(type) !== -1 && item[p]) {
	                    output += this.nameMap[p] + ', ';
	                }
	                ;
	            }
	        }
	        ;
	        return output.replace(/(^\s*,)|(,\s*$)/g, '');
	    };
	    CrcoReportingResponsabilitiesController.prototype.initAirportInitials = function () {
	        var initialsSet = new Set();
	        this.$scope.listAirportFromNavDb.forEach(function (a) {
	            if (a.ident && a.ident.length > 0) {
	                initialsSet.add(a.ident.charAt(0).toUpperCase());
	            }
	        });
	        return Array.from(initialsSet).sort();
	    };
	    CrcoReportingResponsabilitiesController.prototype.initAirportInitialsGroup = function () {
	        var initialsSet = new Set();
	        this.$scope.listAirportFromNavDb.forEach(function (a) {
	            if (a.ident && a.ident.length > 0) {
	                initialsSet.add(a.ident.substring(0, 2).toUpperCase());
	            }
	        });
	        return Array.from(initialsSet).sort().map(function (i) { return ({ label: i, id: i }); });
	    };
	    CrcoReportingResponsabilitiesController.prototype.isSameInitial = function (value, initial) {
	        return value.charAt(0).toUpperCase() === initial.toUpperCase();
	    };
	    return CrcoReportingResponsabilitiesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CrcoReportingResponsabilitiesController = CrcoReportingResponsabilitiesController;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// classes
	var CrcoArchiveController = (function (_super) {
	    __extends(CrcoArchiveController, _super);
	    /* @ngInject */
	    CrcoArchiveController.$inject = ["$scope", "crcoArchiveService", "typesService", "accountsService", "sysConfigBoolean", "systemConfigurationService"];
	    function CrcoArchiveController($scope, crcoArchiveService, typesService, accountsService, sysConfigBoolean, systemConfigurationService) {
	        var _this = _super.call(this, $scope, crcoArchiveService) || this;
	        _this.$scope = $scope;
	        _this.crcoArchiveService = crcoArchiveService;
	        _this.typesService = typesService;
	        _this.accountsService = accountsService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.reset = function () { return _this.reset(); };
	        $scope.getMessagesById = function (packetId) { return _this.getMessagesById(packetId); };
	        _this.typesService.listAll().then(function (types) {
	            var allAccounts = { id: 'all', name: 'All Accounts' };
	            $scope.accountTypes = types.filter(function (type) {
	                return type.name === 'Airline' || type.name === 'GeneralAviation' || type.name === 'Charter' || type.name === 'Unified Tax';
	            });
	            $scope.accountTypes.unshift(allAccounts);
	            _this.getAccount();
	        });
	        $scope.getFlightMessages = function (packetId) { return _this.getFlightMessages(packetId); };
	        _this.crcoArchiveService.getMessagesById('EE').then(function (message) {
	            _this.$scope.flightMessageById = message;
	            _this.createArchive(_this.$scope.flightMessageById);
	        });
	        $scope.selectedAccounts = [];
	        $scope.getAccount = function () { return _this.getAccount(); };
	        $scope.showCompletenessCheckMessages = function (item) { return _this.showCompletenessCheckMessages(item); };
	        $scope.createArchive = function (crco_archive) { return _this.createArchive(crco_archive); };
	        _this.list({});
	        return _this;
	    }
	    CrcoArchiveController.prototype.getAccount = function () {
	        var _this = this;
	        return this.accountsService.findAllCreditMinimalActiveReturn().then(function (accounts) { return _this.$scope.listOfAccounts = accounts; });
	    };
	    CrcoArchiveController.prototype.getFlightMessages = function (packetId) {
	        var _this = this;
	        this.crcoArchiveService.getFlightMessage(packetId).then(function (res) {
	            _this.$scope.flightMessage = res;
	        });
	    };
	    CrcoArchiveController.prototype.getMessagesById = function (packetId) {
	        var _this = this;
	        this.crcoArchiveService.getMessagesById(packetId).then(function (res) {
	            _this.$scope.flightMessageById = res;
	        });
	    };
	    CrcoArchiveController.prototype.refreshOverride = function () {
	        var _this = this;
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString()).then(function (data) {
	            _this.$scope.editableArchiveList = angular.copy(data);
	        });
	    };
	    CrcoArchiveController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CrcoArchiveController.prototype.showCompletenessCheckMessages = function (item) {
	        _super.prototype.edit.call(this, item);
	    };
	    CrcoArchiveController.prototype.createArchive = function (crcoArchive) {
	        this.refreshOverride();
	        return _super.prototype.create.call(this, crcoArchive);
	    };
	    return CrcoArchiveController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CrcoArchiveController = CrcoArchiveController;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// classes
	var CrcoCorRequestController = (function (_super) {
	    __extends(CrcoCorRequestController, _super);
	    /* @ngInject */
	    CrcoCorRequestController.$inject = ["$scope", "crcoCorRequestService", "typesService", "accountsService", "sysConfigBoolean", "systemConfigurationService"];
	    function CrcoCorRequestController($scope, crcoCorRequestService, typesService, accountsService, sysConfigBoolean, systemConfigurationService) {
	        var _this = _super.call(this, $scope, crcoCorRequestService) || this;
	        _this.$scope = $scope;
	        _this.crcoCorRequestService = crcoCorRequestService;
	        _this.typesService = typesService;
	        _this.accountsService = accountsService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.reset = function () { return _this.reset(); };
	        $scope.showCorRequest = function (item) { return _this.showCorRequest(item); };
	        //$scope.getMessagesById = (packetId: string) => this.getMessagesById(packetId);
	        $scope.getCrcoCorRequest = function (packetId) { return _this.getCrcoCorRequest(packetId); };
	        _this.typesService.listAll().then(function (types) {
	            var allAccounts = { id: 'all', name: 'All Accounts' };
	            $scope.accountTypes = types.filter(function (type) {
	                return type.name === 'Airline' || type.name === 'GeneralAviation' || type.name === 'Charter' || type.name === 'Unified Tax';
	            });
	            $scope.accountTypes.unshift(allAccounts);
	            _this.getAccount();
	        });
	        _this.crcoCorRequestService.getCrcoCorRequestById('EE').then(function (claRequestId) {
	            claRequestId.forEach(function (item) {
	                _this.crcoCorRequestService.getCrcoCorRequest(item.packet_id).then(function (messages) {
	                    _this.$scope.listclaRequestMessages = messages;
	                    _this.createCorReply(_this.$scope.listclaRequestMessages.CLARequestMessage);
	                });
	            });
	        });
	        // this.crcoCorRequestService.getMessagesById('EE').then((message: string) => {
	        //   this.$scope.flightMessageById = message;
	        //   this.createArchive(this.$scope.flightMessageById);
	        // })
	        $scope.selectedAccounts = [];
	        $scope.getAccount = function () { return _this.getAccount(); };
	        $scope.updateFormattedDate = function (date) { return _this.updateFormattedDate(date); };
	        $scope.sendCorReply = function (editable) { return _this.sendCorReply(editable); };
	        $scope.showCompletenessCheckMessages = function (item) { return _this.showCompletenessCheckMessages(item); };
	        $scope.createArchive = function (crco_archive) { return _this.createArchive(crco_archive); };
	        _this.list({});
	        return _this;
	    }
	    CrcoCorRequestController.prototype.getAccount = function () {
	        var _this = this;
	        return this.accountsService.findAllCreditMinimalActiveReturn().then(function (accounts) { return _this.$scope.listOfAccounts = accounts; });
	    };
	    CrcoCorRequestController.prototype.getCrcoCorRequest = function (packetId) {
	        var _this = this;
	        this.crcoCorRequestService.getCrcoCorRequest(packetId).then(function (res) {
	            _this.$scope.flightMessage = res;
	        });
	    };
	    CrcoCorRequestController.prototype.createCorReply = function (crcoCorReply) {
	        this.refreshOverride();
	        return _super.prototype.create.call(this, crcoCorReply);
	    };
	    // private getMessagesById(packetId): void {
	    //   this.crcoCorRequestService.getMessagesById(packetId).then((res: any) => {
	    //     this.$scope.flightMessageById = res;
	    //   });
	    // }
	    CrcoCorRequestController.prototype.refreshOverride = function () {
	        var _this = this;
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString()).then(function (data) {
	            _this.$scope.editableArchiveList = angular.copy(data);
	        });
	    };
	    CrcoCorRequestController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CrcoCorRequestController.prototype.showCompletenessCheckMessages = function (item) {
	        _super.prototype.edit.call(this, item);
	    };
	    CrcoCorRequestController.prototype.createArchive = function (crcoArchive) {
	        this.refreshOverride();
	        return _super.prototype.create.call(this, crcoArchive);
	    };
	    CrcoCorRequestController.prototype.showCorRequest = function (editable) {
	        this.$scope.editable = editable;
	        this.$scope.editableReply.CRCOCLARequestReference = editable.UserClaim;
	        this.$scope.editableReply.OriginalRCOMessageData = editable.OriginalRcoMessageData;
	    };
	    CrcoCorRequestController.prototype.updateFormattedDate = function (datetime) {
	        if (datetime) {
	            var datePart = datetime.split('T')[0]; // Extracts YYYY-MM-DD
	            this.$scope.formattedFlightDate = datePart;
	        }
	    };
	    CrcoCorRequestController.prototype.sendCorReply = function (editableReply) {
	        this.crcoCorRequestService.sendCrcoCorReply(editableReply);
	    };
	    return CrcoCorRequestController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CrcoCorRequestController = CrcoCorRequestController;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var CrcoConnectionController = (function (_super) {
	    __extends(CrcoConnectionController, _super);
	    /* @ngInject */
	    CrcoConnectionController.$inject = ["$scope", "crcoConnectionService", "sysConfigBoolean", "systemConfigurationService"];
	    function CrcoConnectionController($scope, crcoConnectionService, sysConfigBoolean, systemConfigurationService) {
	        var _this = _super.call(this, $scope, crcoConnectionService) || this;
	        _this.$scope = $scope;
	        _this.crcoConnectionService = crcoConnectionService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.reset = function () { return _this.reset(); };
	        _this.$scope.crco_invoice_support = _this.sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CRCO_INVOICE_SUPPORT));
	        $scope.createConnection = function (crco_connection) { return _this.createConnection(crco_connection); };
	        $scope.updateConnection = function (item, id) { return _this.updateConnection(item, id); };
	        $scope.deleteConnection = function (id) { return _this.deleteConnection(id); };
	        $scope.showConnection = function (item) { return _this.showConnection(item); };
	        $scope.getMaskedPassword = function (password) { return _this.getMaskedPassword(password); };
	        return _this;
	    }
	    CrcoConnectionController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    CrcoConnectionController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CrcoConnectionController.prototype.createConnection = function (crcoConnection) {
	        this.refreshOverride();
	        return _super.prototype.create.call(this, crcoConnection);
	    };
	    CrcoConnectionController.prototype.updateConnection = function (data, id) {
	        this.service = this.crcoConnectionService;
	        var toRet = _super.prototype.update.call(this, data, id);
	        return toRet;
	    };
	    CrcoConnectionController.prototype.deleteConnection = function (id) {
	        this.service = this.crcoConnectionService;
	        _super.prototype.delete.call(this, id);
	    };
	    CrcoConnectionController.prototype.showConnection = function (item) {
	        _super.prototype.edit.call(this, item);
	    };
	    CrcoConnectionController.prototype.getMaskedPassword = function (password) {
	        return '*'.repeat(password.length);
	    };
	    return CrcoConnectionController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CrcoConnectionController = CrcoConnectionController;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	//service
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var calculation_1 = __webpack_require__(77);
	var system_configuration_constants_1 = __webpack_require__(10);
	var CrcoMessagesController = (function (_super) {
	    __extends(CrcoMessagesController, _super);
	    /* @ngInject */
	    CrcoMessagesController.$inject = ["$scope", "$rootScope", "crcoMessagesService", "typesService", "$interval", "accountsService", "$state", "sysConfigBoolean", "systemConfigurationService", "serverDatetimeService", "customDate", "crcoReportingResponsabilitiesService"];
	    function CrcoMessagesController($scope, $rootScope, crcoMessagesService, typesService, $interval, accountsService, $state, sysConfigBoolean, systemConfigurationService, serverDatetimeService, customDate, crcoReportingResponsabilitiesService) {
	        var _this = _super.call(this, $scope, crcoMessagesService) || this;
	        _this.$scope = $scope;
	        _this.$rootScope = $rootScope;
	        _this.crcoMessagesService = crcoMessagesService;
	        _this.typesService = typesService;
	        _this.$interval = $interval;
	        _this.accountsService = accountsService;
	        _this.$state = $state;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.serverDatetimeService = serverDatetimeService;
	        _this.customDate = customDate;
	        _this.crcoReportingResponsabilitiesService = crcoReportingResponsabilitiesService;
	        $scope.processing = false;
	        _this.typesService.listAll().then(function (types) {
	            var allAccounts = { id: 'all', name: 'All Accounts' };
	            $scope.accountTypes = types.filter(function (type) {
	                return type.name === 'Airline' || type.name === 'GeneralAviation' || type.name === 'Charter' || type.name === 'Unified Tax';
	            });
	            $scope.accountTypes.unshift(allAccounts);
	            _this.getAccount();
	            _this.getReportingResponsabilities();
	        });
	        $scope.openFlight = function (id, permission) {
	            if (permission) {
	                _this.$state.go('main.flight-movement-management', { flightId: id });
	            }
	        };
	        _this.setDefaultDateDaily();
	        _this.setBillingInterval();
	        $scope.selectedAccounts = [];
	        $scope.isChbChecked = false;
	        _this.$scope.previewJson = false;
	        $scope.previewText = true;
	        _this.$scope.crco_invoice_support = _this.sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CRCO_INVOICE_SUPPORT));
	        $scope.getAccount = function () { return _this.getAccount(); };
	        $scope.getReportingResponsabilities = function () { return _this.getReportingResponsabilities(); };
	        $scope.validate = function () { return _this.validate(); };
	        $scope.toggleText = function () { return _this.toggleText(); };
	        $scope.toggleJson = function () { return _this.toggleJson(); };
	        $scope.showJsonText = function () { return _this.showJsonText(); };
	        $scope.setWeekStartDate = function () { return _this.setWeekStartDate(); };
	        $scope.setDailyStartDate = function () { return _this.setDailyStartDate(); };
	        $scope.changeComment = function () { return _this.changeComment(); };
	        $scope.executeGeneration = function (preview) { return _this.executeGeneration(preview); };
	        $scope.closeHeader = function () { return _this.closeHeader(); };
	        $scope.getCrcoMessagePreview = function (packetId) { return _this.getCrcoMessagePreview(packetId); };
	        $scope.resetSelectedFlightMovements = function () { return _this.resetSelectedFlightMovements(); };
	        $scope.today = function () { return moment(); };
	        $scope.startOfCurrentMonth = $scope.today().startOf('month');
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.$scope.progressBarValue = 0;
	        $scope.selectedFlightMovements = [];
	        $scope.countSelected = function () {
	            var flights = _this.getIdsFromCheckboxes();
	            //let filterFlights = this.$scope.list.filter((item: ICrcoMessages) => flights.indexOf(item.id) > -1);
	            //this.$scope.isChbChecked = false;
	            $scope.numberOfSelectedMovements = $scope.selectedRecords = flights.length;
	        };
	        $scope.toggleAll = function () {
	            if ($scope.isChbChecked && $scope.editable.crcoFlights) {
	                for (var i = 0; i < $scope.editable.crcoFlights.length; i++) {
	                    var flightMovement = $scope.editable.crcoFlights[i];
	                    if (flightMovement.crco_seq_num === 0 && $scope.editable.message_code === 'F') {
	                        $scope.selectedFlightMovements[flightMovement.flight_movement_id] = true;
	                    }
	                    else if (flightMovement.crco_seq_num > 0 && $scope.editable.message_code === 'F') {
	                        $scope.selectedFlightMovements[flightMovement.flight_movement_id] = false;
	                    }
	                    else if (flightMovement.crco_seq_num === 0 && (($scope.editable.message_code === 'C') || $scope.editable.message_code === 'I')) {
	                        $scope.selectedFlightMovements[flightMovement.flight_movement_id] = false;
	                    }
	                    else if (flightMovement.crco_seq_num > 0 && (($scope.editable.message_code === 'C') || $scope.editable.message_code === 'I')) {
	                        $scope.selectedFlightMovements[flightMovement.flight_movement_id] = true;
	                    }
	                }
	                var keys = Object.keys($scope.selectedFlightMovements);
	                $scope.editable.flight_movement_id_list = keys.filter(function (key) { return $scope.selectedFlightMovements[key]; }).map(Number);
	            }
	            else {
	                if ($scope.editable.crcoFlights) {
	                    for (var i = 0; i < $scope.editable.crcoFlights.length; i++) {
	                        var flightMovement = $scope.editable.crcoFlights[i];
	                        $scope.selectedFlightMovements[flightMovement.flight_movement_id] = false;
	                    }
	                    $scope.editable.flight_movement_id_list = [];
	                }
	            }
	        };
	        $scope.numberOfSelectedMovements = 0;
	        // calculation class initialization
	        $scope.recalculate = new calculation_1.Calculation('recalculateJob', 'executeRecalulation', 'cancelRecalculation', 'getStatusForRecalulations', null, $scope, crcoMessagesService, $interval, serverDatetimeService, $rootScope);
	        $scope.generate = new calculation_1.Calculation('generateJob', 'executeGeneration', 'cancelGeneration', 'getStatusForGeneration', 'downloadInvoice', $scope, crcoMessagesService, $interval, serverDatetimeService, $rootScope);
	        // this.checkRecalculationStatusOnPageLoad();
	        // this.checkGenerationStatusOnPageLoad();
	        $scope.$watchGroup(['dateObject', 'editable.end_date', 'editable.billing_interval', 'editable.iata_status'], function () {
	            return $scope.isBillingPeriodValid = _this.validateBillingPeriod();
	        });
	        $scope.showCompletenessCheckMessages = function (item) { return _this.showCompletenessCheckMessages(item); };
	        // use to initialise pagination display
	        $scope.selectedRecords = 0;
	        $scope.resetComments = function () {
	            if ($scope.editable.fmcrco) {
	                angular.forEach($scope.editable.fmcrco.FlightMessages, function (message) {
	                    message.Comment = "";
	                    message.AdditionalComment = "";
	                });
	            }
	        };
	        return _this;
	    }
	    CrcoMessagesController.prototype.changeComment = function () {
	        this.$scope.editable.comments = this.$scope.x.comment_to_crco;
	    };
	    CrcoMessagesController.prototype.getCrcoMessagePreview = function (packetId) {
	        var _this = this;
	        this.$scope.editable.account_id_list = this.$scope.selectedAccounts && this.$scope.selectedAccounts.length > 0
	            ? this.$scope.selectedAccounts.map(function (account) { return account.id; })
	            : null;
	        this.$scope.editable.reporting_responsabilities_id_list = this.$scope.listRep.map(function (rep) { return rep.id; });
	        var editable = this.$scope.editable;
	        var processStartDate = this.$scope.editable.processStartDate;
	        var processEndDate = this.$scope.editable.processEndDate;
	        var messageType = this.$scope.editable.messageType;
	        var messageCode = this.$scope.editable.messageCode;
	        var commentToCrco = this.$scope.editable.commentToCrco;
	        var additionalCommentToCrco = this.$scope.editable.additionalCommentToCrco;
	        this.crcoMessagesService.getCrcoMessagePreview(editable, processStartDate, processEndDate, messageType, messageCode, commentToCrco, additionalCommentToCrco).then(function (data) {
	            _this.$scope.processing = false;
	            _this.$scope.editable.crcoFlights = data;
	            _this.$scope.editable.flights = "" + data.length;
	            _this.$scope.flightMessage = data;
	        }).catch(function (error) {
	            _this.$scope.processing = false;
	            _this.setErrorResponse(error);
	        });
	    };
	    CrcoMessagesController.prototype.getAccount = function () {
	        var _this = this;
	        return this.accountsService.findAllCreditMinimalActiveReturn().then(function (accounts) { return _this.$scope.listOfAccounts = accounts; });
	    };
	    CrcoMessagesController.prototype.getReportingResponsabilities = function () {
	        var _this = this;
	        return this.crcoReportingResponsabilitiesService.getReportingResponsabilities().then(function (rep) { return _this.$scope.listRep = rep; });
	    };
	    CrcoMessagesController.prototype.getIdsFromCheckboxes = function () {
	        var _this = this;
	        var keys = Object.keys(this.$scope.selectedFlightMovements);
	        this.$scope.editable.flight_movement_id_list = keys.filter(function (key) { return _this.$scope.selectedFlightMovements[key]; }).map(Number);
	        return this.$scope.editable.flight_movement_id_list;
	    };
	    CrcoMessagesController.prototype.closeHeader = function () {
	        this.$scope.editable.crcoFlights = null;
	        this.$scope.recalculateJob = null;
	        this.$scope.generateJob = null;
	        this.$scope.preview = null;
	    };
	    // check to see if calculation async already in progress
	    CrcoMessagesController.prototype.checkRecalculationStatusOnPageLoad = function () {
	        var _this = this;
	        this.$scope.recalculate.checkStatusOnPageLoad().then(function (data) {
	            if (!_this.$scope.processing) {
	                _this.$scope.processing = data;
	            }
	        });
	    };
	    // check to see if generation async already in progress
	    CrcoMessagesController.prototype.checkGenerationStatusOnPageLoad = function () {
	        var _this = this;
	        this.$scope.generate.checkStatusOnPageLoad().then(function (data) {
	            if (!_this.$scope.processing) {
	                _this.$scope.processing = data;
	            }
	            ;
	        });
	    };
	    // deselect selected flights
	    CrcoMessagesController.prototype.resetSelectedFlightMovements = function () {
	        this.$scope.selectedFlightMovements = [];
	        this.$scope.numberOfSelectedMovements = this.$scope.selectedRecords = 0;
	        this.$scope.numberOfSelectedMovements = 0;
	        this.$scope.isChbChecked = false;
	        this.$scope.editable.flight_movement_id_list = [];
	    };
	    CrcoMessagesController.prototype.setWeekStartDate = function () {
	        this.$scope.editable.start_date = moment(this.$scope.editable.end_date).subtract(6, 'days').toISOString();
	    };
	    CrcoMessagesController.prototype.setDailyStartDate = function () {
	        this.$scope.editable.start_date = moment(this.$scope.editable.end_date).subtract(1, 'days').toISOString();
	    };
	    // start a generate or preview invoice async task
	    CrcoMessagesController.prototype.executeGeneration = function (preview) {
	        this.$scope.processing = true;
	        this.$scope.editable.preview = preview;
	        this.$scope.editable.messageType = this.$scope.editable.message_type;
	        this.$scope.editable.messageCode = this.$scope.editable.message_code;
	        if (this.$scope.editable.fmcrco != undefined) {
	            this.$scope.editable.commentToCrco = this.$scope.editable.fmcrco.FlightMessages.map(function (message) {
	                return message.Comment;
	            });
	            this.$scope.editable.additionalCommentToCrco = this.$scope.editable.fmcrco.FlightMessages.map(function (message) {
	                return message.AdditionalComment;
	            });
	        }
	        this.setProcessDates();
	        // apply all account ids if non selected (only applies to IATA as buttons disabled for non-iata)
	        // otherwise apply only selected account ids
	        if (!this.$scope.selectedAccounts || this.$scope.selectedAccounts.length === 0) {
	            this.$scope.editable.account_id_list = this.$scope.listOfAccounts.map(function (account) { return account.id; });
	        }
	        else {
	            this.$scope.editable.account_id_list = this.$scope.selectedAccounts.map(function (account) { return account.id; });
	        }
	        this.$scope.generate.executeCalculation(this.$scope.editable);
	    };
	    CrcoMessagesController.prototype.toggleJson = function () {
	        this.$scope.previewJson = true;
	        this.$scope.previewText = false;
	    };
	    CrcoMessagesController.prototype.toggleText = function () {
	        this.$scope.previewJson = false;
	        this.$scope.previewText = true;
	    };
	    CrcoMessagesController.prototype.showJsonText = function () {
	        this.$scope.previewJson = true;
	        this.$scope.previewText = true;
	    };
	    CrcoMessagesController.prototype.validate = function () {
	        var _this = this;
	        this.$scope.processing = true;
	        this.setProcessDates();
	        // if accounts are selected, validate selected only
	        this.$scope.editable.account_id_list = this.$scope.selectedAccounts && this.$scope.selectedAccounts.length > 0
	            ? this.$scope.selectedAccounts.map(function (account) { return account.id; })
	            : null;
	        this.$scope.editable.reporting_responsabilities_id_list = this.$scope.listRep.map(function (rep) { return rep.id; });
	        this.$scope.editable.flight_movement_id_list = this.$scope.listRep.map(function (flightMessage) { return flightMessage.id; });
	        var editable = this.$scope.editable;
	        var processStartDate = this.$scope.editable.processStartDate;
	        var processEndDate = this.$scope.editable.processEndDate;
	        this.crcoMessagesService.validate(editable, processStartDate, processEndDate).then(function (data) {
	            _this.$scope.processing = false;
	            _this.$scope.editable.crcoFlights = data;
	            _this.$scope.editable.flights = "" + data.length;
	        }).catch(function (error) {
	            _this.$scope.processing = false;
	            _this.setErrorResponse(error);
	        });
	    };
	    CrcoMessagesController.prototype.setProcessDates = function () {
	        if (this.$scope.editable.billing_interval === 'MONTHLY') {
	            this.$scope.editable.processStartDate = this.firstDateOfMonth();
	            this.$scope.editable.processEndDate = this.lastDateOfMonth();
	            this.$scope.editable.endDateInclusive = this.lastDateOfMonth();
	        }
	        else if (this.$scope.editable.billing_interval === 'DAILY') {
	            this.$scope.editable.processEndDate = new Date(this.$scope.todayDate).toISOString();
	            this.$scope.editable.processStartDate = moment(this.$scope.todayDate).subtract(1, 'days').utc().startOf('day').toISOString();
	            this.$scope.editable.endDateInclusive = this.$scope.editable.processEndDate;
	        }
	        else if (this.$scope.editable.billing_interval === 'OPEN') {
	            this.$scope.editable.processStartDate = new Date(this.$scope.control.start.date).toISOString();
	            this.$scope.editable.processEndDate = new Date(this.$scope.control.end.date).toISOString();
	            this.$scope.editable.endDateInclusive = new Date(this.$scope.control.end.date).toISOString();
	        }
	        else {
	            this.$scope.editable.processStartDate = new Date(this.$scope.editable.start_date).toISOString();
	            this.$scope.editable.processEndDate = new Date(this.$scope.editable.end_date).toISOString();
	            this.$scope.editable.endDateInclusive = new Date(this.$scope.editable.end_date).toISOString();
	        }
	    };
	    CrcoMessagesController.prototype.setMonthlyDates = function () {
	        if (this.$scope.editable.billing_interval === 'MONTHLY') {
	            this.$scope.editable.start_date = this.firstDateOfMonth();
	            this.$scope.editable.end_date = this.lastDateOfMonth();
	        }
	        else {
	            this.setWeeklyDefaultDate();
	        }
	    };
	    /**
	     * Return the first date of the dateObject (selected month)
	     */
	    CrcoMessagesController.prototype.firstDateOfMonth = function () {
	        var d = angular.copy(this.$scope.dateObject);
	        var yyyy = d.getFullYear();
	        var mm = this.str_pad(d.getMonth() + 1);
	        return moment().format(yyyy + "-" + mm + "-01[T]00:00:00.000[Z]");
	    };
	    CrcoMessagesController.prototype.str_pad = function (n) {
	        return String('0' + n).slice(-2);
	    };
	    /**
	     * Return the last date of the dateObject (selected month)
	     */
	    CrcoMessagesController.prototype.lastDateOfMonth = function () {
	        var d = new Date(this.$scope.dateObject.getFullYear(), this.$scope.dateObject.getMonth() + 1, 0);
	        var yyyy = d.getFullYear();
	        var mm = this.str_pad(d.getMonth() + 1);
	        var dd = this.str_pad(d.getDate());
	        return moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	    };
	    /**
	      * Return the first date of the dateObject (selected annually)
	      */
	    CrcoMessagesController.prototype.firstDateOfYear = function () {
	        var d = angular.copy(this.$scope.dateObject);
	        var yyyy = d.getFullYear();
	        return moment().format(yyyy + "-01-01[T]00:00:00.000[Z]");
	    };
	    /**
	     * Return the last date of the dateObject (selected annually)
	     */
	    CrcoMessagesController.prototype.lastDateOfYear = function () {
	        var d = angular.copy(this.$scope.dateObject);
	        var yyyy = d.getFullYear();
	        return moment().format(yyyy + "-12-31[T]23:59:59.999[Z]");
	    };
	    /**
	   * Set default date for daily billing interval
	   */
	    CrcoMessagesController.prototype.setDefaultDateDaily = function () {
	        var today = new Date();
	        var month = today.getMonth();
	        this.$scope.dateObject = new Date(today.getFullYear(), month - 1);
	        this.$scope.todayDate = moment().subtract(1, 'day').toISOString();
	        this.dateOptions();
	    };
	    /**
	     * Set default date for monthly billing interval
	     */
	    CrcoMessagesController.prototype.setDefaultDate = function () {
	        var today = new Date();
	        var month = today.getMonth();
	        this.$scope.dateObject = new Date(today.getFullYear(), month - 1);
	    };
	    /**
	      * Set default date for partially billing interval
	      */
	    CrcoMessagesController.prototype.setDefaultPartiallyDate = function () {
	        var today = new Date();
	        var month = today.getMonth();
	        this.$scope.dateObject = new Date(today.getFullYear(), month);
	    };
	    /**
	     * Set default date for weekly billing interval
	     */
	    CrcoMessagesController.prototype.setWeeklyDefaultDate = function () {
	        if (this.$scope.startingDay !== undefined) {
	            var diff = moment().day() - this.$scope.startingDay;
	            var end = moment().subtract(diff + 1 + (diff < 0 ? 7 : 0), 'days');
	            var yyyy = end.year();
	            var mm = this.str_pad(end.month() + 1);
	            var dd = this.str_pad(end.date());
	            this.$scope.editable.end_date = moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	            this.setWeekStartDate();
	            this.$scope.maxDate = moment().add(6, 'days').toISOString();
	            this.dateOptions();
	        }
	    };
	    CrcoMessagesController.prototype.dateOptions = function () {
	        var _this = this;
	        this.$scope.dateOptions = {
	            startingDay: 0,
	            showWeeks: false,
	            maxDate: new Date(this.$scope.maxDate),
	            dateDisabled: function (data) {
	                var date = data.date, mode = data.mode;
	                var startingDay = _this.$scope.startingDay === 0 ? 6 : _this.$scope.startingDay - 1;
	                return mode === 'day' && (date.getDay() !== startingDay);
	            }
	        };
	    };
	    CrcoMessagesController.prototype.validateBillingPeriod = function () {
	        if (this.$scope.editable.billing_interval === 'WEEKLY') {
	            var end = moment(this.$scope.editable.end_date);
	            var yyyy = end.year();
	            var mm = this.str_pad(end.month() + 1);
	            var dd = void 0;
	            if (end.utcOffset() < 0) {
	                dd = this.str_pad(end.date() + 1);
	            }
	            else {
	                dd = this.str_pad(end.date());
	            }
	            var end_date = moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	            var today = moment();
	            yyyy = today.year();
	            mm = this.str_pad(today.month() + 1);
	            dd = this.str_pad(today.date());
	            var today_date = moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	            return moment(today_date).isAfter(moment(end_date));
	        }
	        else {
	            return this.$scope.startOfCurrentMonth.isAfter(this.$scope.dateObject);
	        }
	    };
	    /**
	     * Set default billing interval from SystemConfiguration 'Default billing period...' and 'First day of week...'
	     */
	    CrcoMessagesController.prototype.setBillingInterval = function () {
	        var _this = this;
	        var firstDay;
	        this.systemConfigurationService.listAll().then(function (data) {
	            // if (this.$scope.editable.iata_status === 'iata') {
	            //   this.$scope.editable.billing_interval = this.getSystemConfigurationItem(data, <any>SysConfigConstants.DEFAULT_BILLING_PERIOD_IATA).toUpperCase();
	            //   firstDay = this.getSystemConfigurationItem(data, <any>SysConfigConstants.FIRST_DAY_OF_WEEK_IATA);
	            // } else {
	            //   this.$scope.editable.billing_interval = this.getSystemConfigurationItem(data, <any>SysConfigConstants.DEFAULT_BILLING_PERIOD_NON_IATA).toUpperCase();
	            firstDay = _this.getSystemConfigurationItem(data, system_configuration_constants_1.SysConfigConstants.FIRST_DAY_OF_WEEK_NON_IATA);
	            // }
	            _this.$scope.editable.billing_interval = 'DAILY';
	            var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	            for (var _i = 0, weekDays_1 = weekDays; _i < weekDays_1.length; _i++) {
	                var day = weekDays_1[_i];
	                if (firstDay === day) {
	                    _this.$scope.startingDay = weekDays.indexOf(day);
	                }
	            }
	            if (_this.$scope.editable.billing_interval === 'MONTHLY') {
	                _this.setMonthlyDates();
	            }
	            else {
	                _this.setWeeklyDefaultDate();
	            }
	            _this.dateOptions();
	            _this.dateOptionsAnnually();
	            _this.dateOptionsPartially();
	            _this.dateOptionsDueDate();
	        });
	    };
	    CrcoMessagesController.prototype.dateOptionsAnnually = function () {
	        this.$scope.dateOptionsAnnually = {
	            maxDate: new Date(this.$scope.maxDate),
	            minMode: 'year',
	            dateDisabled: function (data) {
	                var date = data.date, mode = data.mode;
	                var previusYear = (moment().year() - 1);
	                var nextYear = (moment().year() + 1);
	                return mode === 'year' && (date.getFullYear() > nextYear || date.getFullYear() < previusYear);
	            }
	        };
	    };
	    CrcoMessagesController.prototype.getSystemConfigurationItem = function (data, itemName) {
	        for (var _i = 0, _a = data.content; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (item.item_name === itemName) {
	                if (typeof (item.current_value) === 'string') {
	                    return item.current_value;
	                }
	                else {
	                    return item.default_value;
	                }
	            }
	        }
	    };
	    /**
	       * Set date options Partially
	       */
	    CrcoMessagesController.prototype.dateOptionsPartially = function () {
	        this.$scope.dateOptionsPartially = {
	            minMode: 'month',
	            dateDisabled: function (data) {
	                var date = data.date, mode = data.mode;
	                var currentYear = moment().year();
	                return mode === 'month' && (date.getFullYear() > currentYear);
	            }
	        };
	    };
	    /**
	        * Set date options Partially
	        */
	    CrcoMessagesController.prototype.dateOptionsDueDate = function () {
	        this.$scope.dateOptionsDueDate = {
	            minMode: 'day',
	            dateDisabled: function (data) {
	                var date = data.date;
	                return date < new Date();
	            }
	        };
	    };
	    CrcoMessagesController.prototype.showCompletenessCheckMessages = function (item) {
	        _super.prototype.edit.call(this, item);
	    };
	    return CrcoMessagesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CrcoMessagesController = CrcoMessagesController;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var CrcoClaimsController = (function (_super) {
	    __extends(CrcoClaimsController, _super);
	    /* @ngInject */
	    CrcoClaimsController.$inject = ["$scope", "crcoClaimsService", "sysConfigBoolean", "systemConfigurationService"];
	    function CrcoClaimsController($scope, crcoClaimsService, sysConfigBoolean, systemConfigurationService) {
	        var _this = _super.call(this, $scope, crcoClaimsService) || this;
	        _this.$scope = $scope;
	        _this.crcoClaimsService = crcoClaimsService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.updateFormattedDate = function (date) { return _this.updateFormattedDate(date); };
	        $scope.editableReply = JSON;
	        _this.setDefaultDateDaily();
	        $scope.getFilterParameters = function () { return _this.getFilterParameters(); };
	        $scope.resetReply = function () { return _this.resetReply(); };
	        _this.$scope.crco_invoice_support = _this.sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CRCO_INVOICE_SUPPORT));
	        $scope.showClaim = function (item) { return _this.showClaim(item); };
	        $scope.getClaimsRequestMessages = function (packetId) { return _this.getClaimsRequestMessages(packetId); };
	        $scope.sendClaimReply = function (editable) { return _this.sendClaimReply(editable); };
	        _this.crcoClaimsService.getCrcoClaimsRequestById('EE').then(function (claRequestId) {
	            claRequestId.forEach(function (item) {
	                _this.crcoClaimsService.getCrcoClaimRequest(item.packet_id).then(function (messages) {
	                    _this.$scope.listclaRequestMessages = messages;
	                    _this.createClaimsRequest(_this.$scope.listclaRequestMessages.CLARequestMessage);
	                });
	            });
	        });
	        return _this;
	    }
	    CrcoClaimsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    CrcoClaimsController.prototype.updateFormattedDate = function (datetime) {
	        if (datetime) {
	            var datePart = datetime.split('T')[0]; // Extracts YYYY-MM-DD
	            this.$scope.formattedFlightDate = datePart;
	        }
	    };
	    ;
	    CrcoClaimsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CrcoClaimsController.prototype.showClaim = function (editable) {
	        this.$scope.editable = editable;
	        this.$scope.editableReply.CRCOCLARequestReference = editable.UserClaim;
	        this.$scope.editableReply.OriginalRCOMessageData = editable.OriginalRcoMessageData;
	    };
	    CrcoClaimsController.prototype.sendClaimReply = function (editableReply) {
	        this.crcoClaimsService.sendCrcoClaimsReply(editableReply);
	    };
	    CrcoClaimsController.prototype.getCrcoClaimRequest = function (packetId) {
	        var _this = this;
	        this.crcoClaimsService.getCrcoClaimRequest(packetId).then(function (res) {
	            _this.$scope.claRequestMessage = res;
	        });
	    };
	    // private getCrcoClaimRequestById(packetId): void {
	    //   this.crcoClaimsService.getCrcoClaimsRequestById(packetId).then((res: any) => {
	    //     this.$scope.claRequestMessagebyId = res;
	    //   });
	    // }
	    CrcoClaimsController.prototype.getClaimsRequestMessages = function (packetId) {
	        var _this = this;
	        this.crcoClaimsService.getCrcoClaimRequest(packetId).then(function (res) {
	            _this.$scope.flightMessage = res;
	        });
	    };
	    // metodo che popola tabella
	    CrcoClaimsController.prototype.createClaimsRequest = function (crcoClaimRequest) {
	        this.refreshOverride();
	        return _super.prototype.create.call(this, crcoClaimRequest);
	    };
	    /**
	   * Set default date for CLAReplyDate
	   */
	    CrcoClaimsController.prototype.setDefaultDateDaily = function () {
	        this.$scope.dateClaReply = moment().toISOString().split('T')[0]; // Extracts YYYY-MM-DD
	    };
	    /**
	   * Resets the form crco claimreply
	   */
	    CrcoClaimsController.prototype.resetReply = function () {
	        this.$scope.error = null;
	        this.$scope.editableReply = angular.copy(this.service.model);
	        this.$scope.formattedFlightDate = null;
	        if (this.$scope.form) {
	            this.$scope.form.$setUntouched();
	        }
	    };
	    return CrcoClaimsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CrcoClaimsController = CrcoClaimsController;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var MtowController = (function (_super) {
	    __extends(MtowController, _super);
	    /* @ngInject */
	    MtowController.$inject = ["$scope", "$rootScope", "mtowService", "systemConfigurationService"];
	    function MtowController($scope, $rootScope, mtowService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, mtowService) || this;
	        _this.$scope = $scope;
	        _this.mtowService = mtowService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this, { filter: 'DOMESTIC' });
	        $scope.$watch('factorClassFilter.value', function () { return _this.getFilterParameters(); });
	        // configuration for MTOW Factor Class (t/f)
	        var mtowSystemConfigValue = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.USE_MTOW_FACTOR_CLASS);
	        $scope.useMTOWFactorClass = mtowSystemConfigValue === system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_TRUE;
	        // configuration for MTOW Units (tons/kg)
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.edit = function (item) { _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(item, 'upper_limit')); };
	        $scope.factorClass = _this.service.listMtowFactorClass();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.factorClassFilter = {
	            value: 'DOMESTIC'
	        };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    MtowController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    MtowController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            filter: this.$scope.factorClassFilter.value,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    return MtowController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.MtowController = MtowController;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var map_constants_1 = __webpack_require__(26);
	var invoices_constants_1 = __webpack_require__(98);
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var flight_types_service_1 = __webpack_require__(75);
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var InvoicesController = (function (_super) {
	    __extends(InvoicesController, _super);
	    /* @ngInject */
	    InvoicesController.$inject = ["$scope", "invoicesService", "invoiceStateTypeService", "transactionsService", "flightMovementManagementService", "$uibModal", "$rootScope", "$state", "systemConfigurationService", "customDate", "usersService"];
	    function InvoicesController($scope, invoicesService, invoiceStateTypeService, transactionsService, flightMovementManagementService, $uibModal, $rootScope, $state, systemConfigurationService, customDate, usersService) {
	        var _this = _super.call(this, $scope, invoicesService, $uibModal) || this;
	        _this.$scope = $scope;
	        _this.invoicesService = invoicesService;
	        _this.invoiceStateTypeService = invoiceStateTypeService;
	        _this.transactionsService = transactionsService;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.$uibModal = $uibModal;
	        _this.$rootScope = $rootScope;
	        _this.$state = $state;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _this.usersService = usersService;
	        _this.exportSupportType = {};
	        _super.prototype.setup.call(_this, { refresh: false });
	        $scope.inverseExchange = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE);
	        $scope.manualApproval = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_INVOICE_MANUAL_APPROVAL);
	        $scope.manualPublishing = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_INVOICE_MANUAL_PUBLISHING);
	        $scope.showProforma = localStorage_service_1.LocalStorageService.getBooleanFromValueByName("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.PROFORMA_INVOICE_SUPPORT);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.usersService.getListLightInternalUsers().then(function (users) {
	            $scope.usersList = users;
	            _this.usersService.current.then(function (user) {
	                $scope.userFilter = $scope.usersList.find(function (item) { return item.name === user.name; }).id;
	                _super.prototype.list.call(_this, {}, "createdByUserId=" + user.id);
	                _this.getFilterParameters();
	            });
	        });
	        invoiceStateTypeService.listAll().then(function (listInvoiceTypes) { return $scope.statesList = listInvoiceTypes; }); // retrieve list of states
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.transactionsService = transactionsService;
	        $scope.getFlightType = function (flightType) { return flight_types_service_1.FlightType[flightType]; };
	        $scope.updateState = function (id, invoiceStatus) { return _this.updateState(id, invoiceStatus); };
	        $scope.showFlightMovementOnMap = function (flightMovement) { return _this.showFlightMovementOnMap(flightMovement); };
	        $scope.getFlightMovementsByInvoiceId = function (invoiceId, page, size) { return _this.getFlightMovementsByInvoiceId(invoiceId, page, size)
	            .then(function (listFlightMovements) {
	            $scope.listFlightMovements = listFlightMovements;
	            $scope.listFlightMovements.number++; // fake the number one higher because it will be decreased in crud.service.ts
	            if (!page) {
	                _this.getTransactionPaymentsByInvoiceId(invoiceId)
	                    .then(function (listTransactionPayments) { return $scope.listTransactionPayments = listTransactionPayments; });
	                _this.getTransactionByInvoiceId(invoiceId)
	                    .then(function (listTransactions) { return _this.$scope.listTransactions = listTransactions; });
	            }
	        }); };
	        $scope.openAccount = function (id, permission) {
	            if (permission) {
	                _this.$state.go('main.accounts', { accountId: id });
	            }
	        };
	        $scope.exportSupport = false;
	        $scope.exportInProcess = false;
	        $scope.selectedItems = {};
	        $scope.exportAllInvoices = function () { return _this.exportAllInvoices(); };
	        $scope.exportSelectedInvoices = function (selected) { return _this.exportSelectedInvoices(selected); };
	        $scope.isExportSupport = function (invoice) { return _this.isExportSupport(invoice); };
	        $scope.isSelectedItems = function (selected) { return _this.isSelectedItems(selected); };
	        $scope.setExportSupportType = function (type) { return _this.setExportSupportType(type); };
	        $scope.refreshList = function () { return _this.refreshList(); };
	        $scope.openVoidReasonPopup = function (invoice) { return _this.openVoidReasonPopup(invoice); };
	        // default to FLIGHT_MOVEMENT type due to flight movement table directive selection logic
	        $scope.edit = function (data, type) {
	            if (type === void 0) { type = invoices_constants_1.EditableType.FLIGHT_MOVEMENT; }
	            return _this.editOverride(data, type);
	        };
	        _this.invoicesService.exportSupport()
	            .then(function (response) { return $scope.exportSupport = response; });
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.payInvoice = function (invoice) { return _this.payInvoice(invoice); };
	        $scope.enableVoid = function (invoice) { return _this.enableVoid(invoice); };
	        $scope.voidInvoice = function (invoice, motivation) { return _this.voidInvoice(invoice, motivation); };
	        return _this;
	    }
	    InvoicesController.prototype.openVoidReasonPopup = function (invoice) {
	        var _this = this;
	        this.$uibModal.open({
	            template: "\n      <div class=\"modal-header\">\n        <h3 class=\"modal-title\" translate>Void Reason</h3>\n      </div>\n      <div class=\"modal-body\">\n        <label translate>Please enter the reason for voiding this invoice:</label>\n        <input class=\"form-control\" type=\"text\" ng-model=\"reason\" />\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" ng-click=\"ok()\" ng-disabled=\"!reason\" translate>Confirm</button>\n        <button class=\"btn btn-default\" ng-click=\"cancel()\" translate>Cancel</button>\n      </div>\n    ",
	            windowClass: 'void-reason-modal-centered',
	            controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	                    $scope.reason = '';
	                    $scope.ok = function () { return $uibModalInstance.close($scope.reason); };
	                    $scope.cancel = function () { return $uibModalInstance.dismiss(); };
	                }]
	        }).result.then(function (reason) {
	            _this.voidInvoice(invoice, reason);
	        });
	    };
	    /**
	     * Edit override as flight movement form directive expects 'edit' to be specfiically for
	     * flight movement selection only.
	     *
	     * @param data date for object being editted
	     * @param type data object type
	     */
	    InvoicesController.prototype.editOverride = function (data, type) {
	        if (type === void 0) { type = invoices_constants_1.EditableType.INVOICE; }
	        // only call parent edit method if INVOICE data type
	        // the rest of the data types are ignored
	        if (type === invoices_constants_1.EditableType.INVOICE) {
	            this.editInvoice(data);
	        }
	    };
	    /**
	     * Edit method for selecting an invoice object.
	     *
	     * @param data data for invoice object being editted
	     */
	    InvoicesController.prototype.editInvoice = function (invoice) {
	        // call parent edit method
	        _super.prototype.edit.call(this, invoice);
	        // get appropriate line items or flight movements based on type
	        invoice.invoice_type !== 'non-aviation'
	            ? this.$scope.getFlightMovementsByInvoiceId(invoice.id)
	            : this.getLineItemsByInvoiceId(invoice.id);
	    };
	    InvoicesController.prototype.updateState = function (id, invoiceStatus) {
	        var _this = this;
	        return this.invoicesService.updateInvoiceStatus(id, invoiceStatus)
	            .then(function () { return _this.refreshList().then(function () {
	            _this.updateEditable();
	            if (invoiceStatus === 'void') {
	                _this.getFlightMovementsByInvoiceId(id);
	            }
	        }); })
	            .catch(function (response) { return _this.setErrorResponse(response); });
	    };
	    InvoicesController.prototype.voidInvoice = function (invoice, motivation) {
	        if (invoice.invoice_state_type === 'PUBLISHED' || invoice.invoice_state_type === 'PAID') {
	            return this.voidPublishedInvoice(invoice.id, motivation);
	        }
	        return this.updateState(invoice.id, 'void');
	    };
	    InvoicesController.prototype.voidPublishedInvoice = function (id, motivation) {
	        var _this = this;
	        return this.invoicesService.voidPublishedInvoice(id, motivation)
	            .then(function () { return _this.refreshList().then(function () {
	            _this.updateEditable();
	            _this.getFlightMovementsByInvoiceId(id);
	        }); })
	            .catch(function (response) { return _this.setErrorResponse(response); });
	    };
	    // for non-aviation invoices, returns associated line items, transaction payments and transactions
	    InvoicesController.prototype.getLineItemsByInvoiceId = function (invoiceId) {
	        var _this = this;
	        this.invoicesService.getLineItemsByInvoiceId(invoiceId)
	            .then(function (lineItems) { return _this.$scope.lineItems = lineItems; });
	        this.getTransactionPaymentsByInvoiceId(invoiceId)
	            .then(function (listTransactionPayments) { return _this.$scope.listTransactionPayments = listTransactionPayments; });
	        this.getTransactionByInvoiceId(invoiceId)
	            .then(function (listTransactions) { return _this.$scope.listTransactions = listTransactions; });
	    };
	    // for aviation invoices, returns a list of flight movements by related invoice id
	    InvoicesController.prototype.getFlightMovementsByInvoiceId = function (invoiceId, page, size) {
	        return this.flightMovementManagementService.findAllFlightMovementsByAssociatedInvoiceId(invoiceId, page, size);
	    };
	    InvoicesController.prototype.getTransactionPaymentsByInvoiceId = function (invoiceId) {
	        return this.transactionsService.getTransactionPaymentsByInvoiceId(invoiceId);
	    };
	    InvoicesController.prototype.getTransactionByInvoiceId = function (invoiceId) {
	        return this.transactionsService.getTransactionByInvoiceId(invoiceId);
	    };
	    InvoicesController.prototype.showFlightMovementOnMap = function (flightMovement) {
	        this.$rootScope.$broadcast('map.flyToEntity', map_constants_1.MapFlyToEntityType.SINGLE_FLIGHT_MOVEMENT, [flightMovement]);
	    };
	    InvoicesController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            statusFilter: this.$scope.statusFilter,
	            exportedFilter: this.$scope.exportedFilter === true ? false : null,
	            search: this.$scope.invoiceTextFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            startDate: startDate,
	            endDate: endDate,
	            account: this.$scope.accountFilter,
	            createdByUserId: this.$scope.userFilter,
	            flightIdOrRegistration: this.$scope.flightIdOrRegistration,
	            billingCentre: this.$scope.billingCentreFilter
	        };
	    };
	    /**
	     * Refresh data list in scope.
	     */
	    InvoicesController.prototype.refreshList = function () {
	        this.$scope.listFlightMovements = null;
	        this.$scope.listTransactionPayments = null;
	        this.$scope.lineItems = null;
	        this.getFilterParameters();
	        return this.$scope.refresh(this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    /**
	     * Update the editable item from list if editable item still exists
	     * in the list.
	     *
	     * If editable item no longer exists, the editable item is reset.
	     */
	    InvoicesController.prototype.updateEditable = function () {
	        // flag to indicate if editable item has been refreshed
	        var refreshed = false;
	        // if editable item, loop through refreshed list for match and update editable item
	        var editable = this.$scope.editable;
	        if (editable !== null && editable.id !== null) {
	            var items = this.$scope.list;
	            for (var i = 0; i < items.length; i++) {
	                if (items[i].id === editable.id) {
	                    this.$scope.editable = items[i];
	                    refreshed = true;
	                    break;
	                }
	            }
	        }
	        // if editable item is NOT updated, clear it out as it is no longer visible in the list
	        if (!refreshed) {
	            this.$scope.editable = angular.copy(this.service.model);
	        }
	    };
	    /**
	     * Determine if any invoice items are selected.
	     *
	     * @param selectedItems invoice id items selected
	     */
	    InvoicesController.prototype.isSelectedItems = function (selectedItems) {
	        return Object.keys(selectedItems)
	            .filter(function (key) { return selectedItems[key]; })
	            .length > 0;
	    };
	    /**
	     * Export all non-exported invoices.
	     */
	    InvoicesController.prototype.exportAllInvoices = function () {
	        var _this = this;
	        this.$scope.exportInProcess = true;
	        this.invoicesService.exportAllInvoices()
	            .then(function (response) { return _this.handleExportSuccess(response); })
	            .catch(function (response) { return _this.handleExportError(response); })
	            .finally(function () { return _this.handleExportFinished(_this.$scope.selectedItems); });
	    };
	    /**
	     * Export a list of invoice ids.
	     *
	     * @param item invoice ids to export
	     */
	    InvoicesController.prototype.exportSelectedInvoices = function (selectedItems) {
	        var _this = this;
	        this.$scope.exportInProcess = true;
	        var ids = Object.keys(selectedItems)
	            .filter(function (key) { return selectedItems[key]; })
	            .map(Number);
	        this.invoicesService.exportSelectedInvoices(ids)
	            .then(function (response) { return _this.handleExportSuccess(response); })
	            .catch(function (response) { return _this.handleExportError(response); })
	            .finally(function () { return _this.handleExportFinished(selectedItems); });
	    };
	    /**
	     * Clear any error messages away and display success message.
	     */
	    InvoicesController.prototype.handleExportSuccess = function (response) {
	        this.$scope.exportSuccess = true;
	        this.$scope.error = null;
	    };
	    /**
	     * Clear success message and display error message without subtitle.
	     *
	     * @param response error response
	     */
	    InvoicesController.prototype.handleExportError = function (response) {
	        this.$scope.exportSuccess = false;
	        response.data.hide_subtitle = true;
	        this.setErrorResponse(response);
	    };
	    /**
	     * Reset view and makr export in process as false.
	     *
	     * @param selectedItems items to uncheck
	     */
	    InvoicesController.prototype.handleExportFinished = function (selectedItems) {
	        var _this = this;
	        // deselect ALL items
	        if (selectedItems) {
	            Object.keys(selectedItems).forEach(function (key) { return _this.$scope.selectedItems[key] = false; });
	        }
	        // reset view list
	        this.$scope.exportInProcess = false;
	        this.refreshList();
	    };
	    /**
	     * Validate if invoice is available for exproting.
	     *
	     * @param invoice invioce item to validate
	     */
	    InvoicesController.prototype.isExportSupport = function (invoice) {
	        var support = !invoice.exported
	            && (invoice.invoice_state_type === 'PUBLISHED' || invoice.invoice_state_type === 'PAID')
	            && this.exportSupportType[invoice.invoice_type];
	        // make sure item is not already selected if support is false
	        if (!support && this.$scope.selectedItems[invoice.id]) {
	            this.$scope.selectedItems[invoice.id] = false;
	        }
	        return support;
	    };
	    /**
	     * Set export support for invoice type and cache for resuse. Should
	     * reset on page change/reload.
	     *
	     * @param type invoice type support to set
	     */
	    InvoicesController.prototype.setExportSupportType = function (type) {
	        var _this = this;
	        if (this.exportSupportType[type] !== false && this.exportSupportType[type] !== true) {
	            this.exportSupportType[type] = false;
	            this.invoicesService.exportSupportType(type)
	                .then(function (result) { return _this.exportSupportType[type] = result; });
	        }
	    };
	    InvoicesController.prototype.payInvoice = function (invoice) {
	        var transaction = {
	            account: invoice.account,
	            description: "Payment of " + invoice.invoice_number,
	            payment_currency: invoice.invoice_currency,
	            currency: invoice.invoice_currency,
	            payment_amount: invoice.amount_owing,
	            amount: invoice.amount_owing,
	            billing_ledger_ids: [invoice.id]
	        };
	        this.$state.go('main.transactions', { transaction: transaction });
	    };
	    InvoicesController.prototype.enableVoid = function (invoice) {
	        return (invoice.point_of_sale && invoice.invoice_state_type === 'PUBLISHED'
	            && invoice.invoice_amount === invoice.amount_owing) ||
	            (invoice.invoice_state_type === 'PAID')
	            ||
	                (!invoice.point_of_sale && invoice.invoice_state_type === 'NEW' || invoice.invoice_state_type === 'APPROVED');
	    };
	    return InvoicesController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.InvoicesController = InvoicesController;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var EditableType;
	(function (EditableType) {
	    EditableType[EditableType["FLIGHT_MOVEMENT"] = 'FLIGHT_MOVEMENT'] = "FLIGHT_MOVEMENT";
	    EditableType[EditableType["INVOICE"] = 'INVOICE'] = "INVOICE";
	    EditableType[EditableType["LINE_ITEM"] = 'LINE_ITEM'] = "LINE_ITEM";
	    EditableType[EditableType["TRANSACTION"] = 'TRANSACTION'] = "TRANSACTION";
	    EditableType[EditableType["TRANSACTION_PAYMENT"] = 'TRANSACTION_PAYMENT'] = "TRANSACTION_PAYMENT";
	})(EditableType = exports.EditableType || (exports.EditableType = {}));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// classes
	var calculation_1 = __webpack_require__(77);
	var organization_constants_1 = __webpack_require__(57);
	var AviationBillingEngineController = (function (_super) {
	    __extends(AviationBillingEngineController, _super);
	    /* @ngInject */
	    AviationBillingEngineController.$inject = ["$scope", "$rootScope", "aviationBillingEngineService", "customDate", "accountsService", "systemConfigurationService", "$interval", "reportsService", "$translate", "sysConfigBoolean", "serverDatetimeService", "typesService", "$timeout"];
	    function AviationBillingEngineController($scope, $rootScope, aviationBillingEngineService, customDate, accountsService, systemConfigurationService, $interval, reportsService, $translate, sysConfigBoolean, serverDatetimeService, typesService, $timeout) {
	        var _this = 
	        // setup service and generate scope
	        _super.call(this, $scope, aviationBillingEngineService) || this;
	        _this.$scope = $scope;
	        _this.aviationBillingEngineService = aviationBillingEngineService;
	        _this.customDate = customDate;
	        _this.accountsService = accountsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$interval = $interval;
	        _this.reportsService = reportsService;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.serverDatetimeService = serverDatetimeService;
	        _this.typesService = typesService;
	        _this.$timeout = $timeout;
	        _super.prototype.setup.call(_this, { refresh: false });
	        // default settings
	        $scope.processing = false;
	        $scope.selectedAccounts = [];
	        $scope.today = function () { return moment(); };
	        $scope.startOfCurrentMonth = $scope.today().startOf('month');
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        _this.$scope.progressBarValue = 0;
	        _this.setDefaultDate();
	        _this.setBillingInterval();
	        //scope for popup recalculation
	        $scope.showRecalculationPopup = false;
	        $scope.$parent.selectAll = true;
	        $scope.selectAllIndex = 0;
	        $scope.$watch('selectAll', function (newVal) {
	            console.log('[DEBUG] $watch: selectAll changed to', newVal);
	            _this.$scope.selectAllIndex = $scope.selectAllIndex + 1;
	            console.log('[DEBUG] $watch: selectAllIndex changed to', _this.$scope.selectAllIndex);
	        });
	        $scope.isEANA = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANA;
	        $scope.recalculationOptions = [
	            { name: 'ILS out of service', selected: true },
	            { name: 'Airport Change Time', selected: true }
	        ];
	        if ($scope.isEANA) {
	            $scope.recalculationOptions.push({ name: 'Art 17 (200 Km)', selected: true });
	        }
	        $scope.recalculationOptions = $scope.recalculationOptions.concat([
	            { name: 'ABM Exemptions', selected: true },
	            { name: 'ABM Airport', selected: true },
	            { name: 'ABM Customer', selected: true },
	            { name: 'ABM Aircraft Type', selected: true },
	            { name: 'Exchange Rate', selected: true },
	            { name: 'TAX Coefficients', selected: true }
	        ]);
	        $scope.isAnyOptionSelected = function () {
	            return $scope.recalculationOptions.some(function (option) {
	                return option.selected;
	            });
	        };
	        // get required system configurations
	        $scope.invoiceByFmCategory = sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INVOICE_FM_CATEGORY));
	        $scope.iataSupported = sysConfigBoolean.parse(systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.IATA_INVOICE_SUPPORT));
	        _this.typesService.listAll().then(function (types) {
	            var allAccounts = { id: 'all', name: 'All Accounts' };
	            $scope.accountTypes = types.filter(function (type) {
	                return type.name === 'Airline' || type.name === 'GeneralAviation' || type.name === 'Charter' || type.name === 'Unified Tax';
	            });
	            $scope.accountTypes.unshift(allAccounts);
	            _this.updateAccounts($scope.editable.account_type);
	        });
	        if ($scope.iataSupported) {
	            $scope.editable.iata_status = 'iata';
	        }
	        else {
	            $scope.editable.iata_status = 'non-iata';
	        }
	        $scope.$watch('reconcileJob.job_execution_status', function (newStatus) {
	            if (newStatus === 'COMPLETED' || newStatus === 'CANCELED') {
	                $rootScope.isBlinking = true; // Abilita l'icona
	            }
	            else {
	                $rootScope.isBlinking = false; // Disabilita l'icona
	            }
	        });
	        // functions accessible by the template
	        $scope.clear = function () { return _this.clear(); };
	        $scope.validate = function () { return _this.validate(); };
	        $scope.addIdToList = function () { return _this.addIdToList(); };
	        $scope.closeHeader = function () { return _this.closeHeader(); };
	        $scope.setMonthlyDates = function () { return _this.setMonthlyDates(); };
	        $scope.setAnnuallyDates = function () { return _this.setAnnuallyDates(); };
	        $scope.setPartiallyDates = function () { return _this.setPartiallyDates(); };
	        $scope.cancelGeneration = function () { return _this.cancelGeneration(); };
	        $scope.setWeekStartDate = function () { return _this.setWeekStartDate(); };
	        $scope.setBillingInterval = function () { return _this.setBillingInterval(); };
	        $scope.cancelRecalculation = function () { return _this.cancelRecalculation(); };
	        $scope.executeRecalculation = function () { return _this.executeRecalculation(); };
	        $scope.executeGeneration = function (preview) { return _this.executeGeneration(preview); };
	        $scope.setDefaultFlights = function (iataStatus) { return _this.setDefaultFlights(iataStatus); };
	        $scope.incompleteFlightSort = function (orderBy) { return _this.incompleteFlightSort(orderBy); };
	        $scope.updateAccounts = function (accountType) { return _this.updateAccounts(accountType); };
	        $scope.setIntervalPeriodForUnifiedTax = function (accountType) { return _this.setIntervalPeriodForUnifiedTax(accountType); };
	        $scope.setFlightMovementCategory = function (accountType) { return _this.setFlightMovementCategory(accountType); };
	        $scope.openRecalculationPopup = function () { return _this.openRecalculationPopup(); };
	        $scope.closeRecalculationPopup = function () { return _this.closeRecalculationPopup(); };
	        $scope.toggleSelectAll = function () { return _this.toggleSelectAll(); };
	        $scope.updateSelectAll = function () { return _this.updateSelectAll(); };
	        $scope.areAllOptionsDeselected = function () { return $scope.recalculationOptions.every(function (option) { return !option.selected; }); };
	        $scope.getProgressBarValue = function (accountsTotal, accountNumber, flightsTotal, flightNumber) {
	            return _this.getProgressBarValue(accountsTotal, accountNumber, flightsTotal, flightNumber);
	        };
	        // calculation class initialization
	        $scope.recalculate = new calculation_1.Calculation('recalculateJob', 'executeRecalulation', 'cancelRecalculation', 'getStatusForRecalulations', null, $scope, aviationBillingEngineService, $interval, serverDatetimeService, $rootScope);
	        $scope.generate = new calculation_1.Calculation('generateJob', 'executeGeneration', 'cancelGeneration', 'getStatusForGeneration', 'downloadInvoice', $scope, aviationBillingEngineService, $interval, serverDatetimeService, $rootScope);
	        // check to see if any async processes already running
	        _this.checkRecalculationStatusOnPageLoad();
	        _this.checkGenerationStatusOnPageLoad();
	        // listeners
	        $scope.$watchGroup(['dateObject', 'editable.end_date', 'editable.billing_interval', 'editable.iata_status'], function () {
	            return $scope.isBillingPeriodValid = _this.validateBillingPeriod();
	        });
	        return _this;
	        //$scope.control_open: IStartEndDates;
	    }
	    AviationBillingEngineController.prototype.updateAccounts = function (accountType) {
	        var _this = this;
	        if (typeof accountType === 'string') {
	            accountType = null;
	        }
	        // get required external data from the backend
	        this.accountsService.findAllActiveCreditMinimalAviationReturn(accountType).then(function (accounts) { return _this.$scope.listOfAccounts = accounts; });
	    };
	    // close the incomplete flights content box
	    AviationBillingEngineController.prototype.closeHeader = function () {
	        this.$scope.editable.incompleteFlights = null;
	        this.$scope.recalculateJob = null;
	        this.$scope.generateJob = null;
	        this.$scope.preview = null;
	    };
	    // check to see if calculation async already in progress
	    AviationBillingEngineController.prototype.checkRecalculationStatusOnPageLoad = function () {
	        var _this = this;
	        this.$scope.recalculate.checkStatusOnPageLoad().then(function (data) {
	            if (!_this.$scope.processing) {
	                _this.$scope.processing = data;
	            }
	        });
	    };
	    // begin a recalculation async task
	    AviationBillingEngineController.prototype.executeRecalculation = function () {
	        this.$scope.processing = true;
	        this.setProcessDates();
	        // if accounts are selected, recalculate selected only
	        this.$scope.editable.account_id_list = this.$scope.selectedAccounts && this.$scope.selectedAccounts.length > 0
	            ? this.$scope.selectedAccounts.map(function (account) { return account.id; })
	            : null;
	        // Recupera le opzioni selezionate dal popup
	        var selectedOptions = this.$scope.recalculationOptions
	            .filter(function (option) { return option.selected; })
	            .map(function (option) { return option.name; }); // Usa il `key` se necessario
	        console.log(selectedOptions);
	        // Aggiunge le opzioni selezionate all'oggetto `editable`
	        this.$scope.editable.selected_options = selectedOptions;
	        this.$scope.recalculate.executeCalculation(this.$scope.editable);
	    };
	    // cancel a recalculation async task
	    AviationBillingEngineController.prototype.cancelRecalculation = function () {
	        this.$scope.recalculate.cancelCalculation();
	    };
	    // check to see if generation async already in progress
	    AviationBillingEngineController.prototype.checkGenerationStatusOnPageLoad = function () {
	        var _this = this;
	        this.$scope.generate.checkStatusOnPageLoad().then(function (data) {
	            if (!_this.$scope.processing) {
	                _this.$scope.processing = data;
	            }
	            ;
	        });
	    };
	    // start a generate or preview invoice async task
	    AviationBillingEngineController.prototype.executeGeneration = function (preview) {
	        this.$scope.processing = true;
	        this.$scope.editable.preview = preview;
	        this.setProcessDates();
	        this.$scope.editable.iataInvoice = this.$scope.editable.iata_status === 'iata';
	        // apply all account ids if non selected (only applies to IATA as buttons disabled for non-iata)
	        // otherwise apply only selected account ids
	        if (!this.$scope.selectedAccounts || this.$scope.selectedAccounts.length === 0) {
	            this.$scope.editable.account_id_list = this.$scope.listOfAccounts.map(function (account) { return account.id; });
	        }
	        else {
	            this.$scope.editable.account_id_list = this.$scope.selectedAccounts.map(function (account) { return account.id; });
	        }
	        this.$scope.generate.executeCalculation(this.$scope.editable);
	    };
	    // cancel a generate or preview invoice async task
	    AviationBillingEngineController.prototype.cancelGeneration = function () {
	        this.$scope.generateJob.job_execution_status = 'CANCELED';
	        this.$scope.generate.cancelCalculation();
	    };
	    ;
	    /**
	     * Set default flight flag based on iata_status
	     */
	    AviationBillingEngineController.prototype.setDefaultFlights = function (iataStatus) {
	        this.$scope.editable.userBillingCenterOnly = iataStatus === 'iata' ? 'false' : 'true';
	    };
	    /**
	     * Create list of selected accounts ids
	     */
	    AviationBillingEngineController.prototype.addIdToList = function () {
	        var idList = this.$scope.selectedAccounts.map(function (account) {
	            return account.id;
	        });
	        return this.$scope.editable.account_id_list = idList;
	    };
	    /**
	     * Clear the preview from the screen
	     */
	    AviationBillingEngineController.prototype.clear = function () {
	        angular.element(document.querySelector('#preview')).html('');
	        return true;
	    };
	    /**
	     * Validate billing period
	     */
	    AviationBillingEngineController.prototype.validateBillingPeriod = function () {
	        if (this.$scope.editable.billing_interval === 'WEEKLY') {
	            var end = moment(this.$scope.editable.end_date);
	            var yyyy = end.year();
	            var mm = this.str_pad(end.month() + 1);
	            var dd = void 0;
	            if (end.utcOffset() < 0) {
	                dd = this.str_pad(end.date() + 1);
	            }
	            else {
	                dd = this.str_pad(end.date());
	            }
	            var end_date = moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	            var today = moment();
	            yyyy = today.year();
	            mm = this.str_pad(today.month() + 1);
	            dd = this.str_pad(today.date());
	            var today_date = moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	            return moment(today_date).isAfter(moment(end_date));
	        }
	        else {
	            return this.$scope.startOfCurrentMonth.isAfter(this.$scope.dateObject);
	        }
	    };
	    /**
	     * Set start date for weekly invoice
	     */
	    AviationBillingEngineController.prototype.setWeekStartDate = function () {
	        this.$scope.editable.start_date = moment(this.$scope.editable.end_date).subtract(6, 'days').toISOString();
	    };
	    /**
	     * Show flights for the selected perion where flight status is PENDING, INCOMPLETE or CANCELED
	     */
	    AviationBillingEngineController.prototype.validate = function () {
	        var _this = this;
	        this.$scope.processing = true;
	        this.setProcessDates();
	        // if accounts are selected, validate selected only
	        this.$scope.editable.account_id_list = this.$scope.selectedAccounts && this.$scope.selectedAccounts.length > 0
	            ? this.$scope.selectedAccounts.map(function (account) { return account.id; })
	            : null;
	        var editable = this.$scope.editable;
	        var processStartDate = this.$scope.editable.processStartDate;
	        var processEndDate = this.$scope.editable.processEndDate;
	        this.aviationBillingEngineService.validate(editable, processStartDate, processEndDate).then(function (data) {
	            _this.$scope.processing = false;
	            _this.$scope.editable.incompleteFlights = data;
	            _this.$scope.editable.flights = "" + data.length;
	        }).catch(function (error) {
	            _this.$scope.processing = false;
	            _this.setErrorResponse(error);
	        });
	    };
	    /**
	     * Incomplete Flight sort order by editable sort field value.
	     *
	     * @param orderBy editable.sort value
	     */
	    AviationBillingEngineController.prototype.incompleteFlightSort = function (orderBy) {
	        var sort;
	        switch (orderBy) {
	            case 'dateTime,account':
	                sort = ['-day_of_flight', '-departure_time', '+account_name', '+flight_id'];
	                break;
	            case 'account,dateTime':
	                sort = ['+account_name', '-day_of_flight', '-departure_time', '+flight_id'];
	                break;
	            default:
	                sort = ['-day_of_flight', '-departure_time', '+flight_id'];
	        }
	        return sort;
	    };
	    /**
	     * Set dates for validate/recalculate/recalculate methods
	     */
	    AviationBillingEngineController.prototype.setProcessDates = function () {
	        if (this.$scope.editable.billing_interval === 'MONTHLY') {
	            this.$scope.editable.processStartDate = this.firstDateOfMonth();
	            this.$scope.editable.processEndDate = this.lastDateOfMonth();
	            this.$scope.editable.endDateInclusive = this.lastDateOfMonth();
	        }
	        else if (this.$scope.editable.billing_interval === 'UNIFIED_TAX_ANNUALLY') {
	            this.$scope.editable.processStartDate = this.firstDateOfYear();
	            this.$scope.editable.processEndDate = this.lastDateOfYear();
	            this.$scope.editable.endDateInclusive = this.lastDateOfYear();
	        }
	        else if (this.$scope.editable.billing_interval === 'UNIFIED_TAX_PARTIALLY') {
	            this.$scope.editable.processStartDate = this.firstDateOfMonth();
	            this.$scope.editable.processEndDate = this.lastDateOfYear();
	            this.$scope.editable.endDateInclusive = this.lastDateOfYear();
	        }
	        else if (this.$scope.editable.billing_interval === 'OPEN') {
	            this.$scope.editable.processStartDate = new Date(this.$scope.control.start.date).toISOString();
	            this.$scope.editable.processEndDate = new Date(this.$scope.control.end.date).toISOString();
	            this.$scope.editable.endDateInclusive = new Date(this.$scope.control.end.date).toISOString();
	        }
	        else {
	            this.$scope.editable.processStartDate = new Date(this.$scope.editable.start_date).toISOString();
	            this.$scope.editable.processEndDate = new Date(this.$scope.editable.end_date).toISOString();
	            this.$scope.editable.endDateInclusive = new Date(this.$scope.editable.end_date).toISOString();
	        }
	    };
	    /**
	     * Set start/end dates for monthly,annually,partially interval for previewing and generating
	     */
	    AviationBillingEngineController.prototype.setMonthlyDates = function () {
	        if (this.$scope.editable.billing_interval === 'MONTHLY') {
	            this.$scope.editable.start_date = this.firstDateOfMonth();
	            this.$scope.editable.end_date = this.lastDateOfMonth();
	        }
	        else if (this.$scope.editable.billing_interval === 'UNIFIED_TAX_ANNUALLY') {
	            this.setAnnuallyDates();
	        }
	        else if (this.$scope.editable.billing_interval === 'UNIFIED_TAX_PARTIALLY') {
	            this.setPartiallyDates();
	            this.setDefaultPartiallyDate();
	        }
	        else {
	            this.setWeeklyDefaultDate();
	        }
	    };
	    /**
	     * Set start/end dates for annually interval for previewing and generating
	     */
	    AviationBillingEngineController.prototype.setAnnuallyDates = function () {
	        this.$scope.editable.start_date = this.firstDateOfYear();
	        this.$scope.editable.end_date = this.lastDateOfYear();
	    };
	    /**
	     * Set start/end dates for partially interval for previewing and generating
	     */
	    AviationBillingEngineController.prototype.setPartiallyDates = function () {
	        this.$scope.editable.start_date = this.firstDateOfMonth();
	        this.$scope.editable.end_date = this.lastDateOfYear();
	    };
	    // private onChangeDueDates(value: any): void {
	    //   var testDate = this.$scope.editable.due_date.toString();
	    //   console.log("value"+value);
	    //  console.log("test" + testDate);
	    // }
	    /**
	     * Return the first date of the dateObject (selected month)
	     */
	    AviationBillingEngineController.prototype.firstDateOfMonth = function () {
	        var d = angular.copy(this.$scope.dateObject);
	        var yyyy = d.getFullYear();
	        var mm = this.str_pad(d.getMonth() + 1);
	        return moment().format(yyyy + "-" + mm + "-01[T]00:00:00.000[Z]");
	    };
	    /**
	     * Return the last date of the dateObject (selected month)
	     */
	    AviationBillingEngineController.prototype.lastDateOfMonth = function () {
	        var d = new Date(this.$scope.dateObject.getFullYear(), this.$scope.dateObject.getMonth() + 1, 0);
	        var yyyy = d.getFullYear();
	        var mm = this.str_pad(d.getMonth() + 1);
	        var dd = this.str_pad(d.getDate());
	        return moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	    };
	    /**
	      * Return the first date of the dateObject (selected annually)
	      */
	    AviationBillingEngineController.prototype.firstDateOfYear = function () {
	        var d = angular.copy(this.$scope.dateObject);
	        var yyyy = d.getFullYear();
	        return moment().format(yyyy + "-01-01[T]00:00:00.000[Z]");
	    };
	    /**
	     * Return the last date of the dateObject (selected annually)
	     */
	    AviationBillingEngineController.prototype.lastDateOfYear = function () {
	        var d = angular.copy(this.$scope.dateObject);
	        var yyyy = d.getFullYear();
	        return moment().format(yyyy + "-12-31[T]23:59:59.999[Z]");
	    };
	    /**
	     * Set default date for monthly billing interval
	     */
	    AviationBillingEngineController.prototype.setDefaultDate = function () {
	        var today = new Date();
	        var month = today.getMonth();
	        this.$scope.dateObject = new Date(today.getFullYear(), month - 1);
	    };
	    /**
	      * Set default date for partially billing interval
	      */
	    AviationBillingEngineController.prototype.setDefaultPartiallyDate = function () {
	        var today = new Date();
	        var month = today.getMonth();
	        this.$scope.dateObject = new Date(today.getFullYear(), month);
	    };
	    /**
	     * Set default date for weekly billing interval
	     */
	    AviationBillingEngineController.prototype.setWeeklyDefaultDate = function () {
	        if (this.$scope.startingDay !== undefined) {
	            var diff = moment().day() - this.$scope.startingDay;
	            var end = moment().subtract(diff + 1 + (diff < 0 ? 7 : 0), 'days');
	            var yyyy = end.year();
	            var mm = this.str_pad(end.month() + 1);
	            var dd = this.str_pad(end.date());
	            this.$scope.editable.end_date = moment().format(yyyy + "-" + mm + "-" + dd + "[T]00:00:00.000[Z]");
	            this.setWeekStartDate();
	            this.$scope.maxDate = moment().add(6, 'days').toISOString();
	            this.dateOptions();
	        }
	    };
	    /**
	     * Set default billing interval from SystemConfiguration 'Default billing period...' and 'First day of week...'
	     */
	    AviationBillingEngineController.prototype.setBillingInterval = function () {
	        var _this = this;
	        var firstDay;
	        this.systemConfigurationService.listAll().then(function (data) {
	            if (_this.$scope.editable.iata_status === 'iata') {
	                _this.$scope.editable.billing_interval = _this.getSystemConfigurationItem(data, system_configuration_constants_1.SysConfigConstants.DEFAULT_BILLING_PERIOD_IATA).toUpperCase();
	                firstDay = _this.getSystemConfigurationItem(data, system_configuration_constants_1.SysConfigConstants.FIRST_DAY_OF_WEEK_IATA);
	            }
	            else {
	                _this.$scope.editable.billing_interval = _this.getSystemConfigurationItem(data, system_configuration_constants_1.SysConfigConstants.DEFAULT_BILLING_PERIOD_NON_IATA).toUpperCase();
	                firstDay = _this.getSystemConfigurationItem(data, system_configuration_constants_1.SysConfigConstants.FIRST_DAY_OF_WEEK_NON_IATA);
	            }
	            var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	            for (var _i = 0, weekDays_1 = weekDays; _i < weekDays_1.length; _i++) {
	                var day = weekDays_1[_i];
	                if (firstDay === day) {
	                    _this.$scope.startingDay = weekDays.indexOf(day);
	                }
	            }
	            if (_this.$scope.editable.billing_interval === 'MONTHLY') {
	                _this.setMonthlyDates();
	            }
	            else if (_this.$scope.editable.billing_interval === 'UNIFIED_TAX_ANNUALLY') {
	                _this.setAnnuallyDates();
	            }
	            else if (_this.$scope.editable.billing_interval === 'UNIFIED_TAX_PARTIALLY') {
	                _this.setPartiallyDates();
	            } /*else if (this.$scope.editable.billing_interval === 'OPEN') {
	              this.setOpenDates();
	            }*/
	            else {
	                _this.setWeeklyDefaultDate();
	            }
	            _this.dateOptions();
	            _this.dateOptionsAnnually();
	            _this.dateOptionsPartially();
	            _this.dateOptionsDueDate();
	        });
	    };
	    /**
	     * Set billing interval default in accountType UnifiedTax
	     */
	    AviationBillingEngineController.prototype.setIntervalPeriodForUnifiedTax = function (accountType) {
	        if (accountType === 8) {
	            this.$scope.editable.billing_interval = 'UNIFIED_TAX_ANNUALLY';
	        }
	    };
	    /**
	       * Set Flight Movement Category default in accountType UnifiedTax
	       */
	    AviationBillingEngineController.prototype.setFlightMovementCategory = function (accountType) {
	        if (accountType === 8) {
	            this.$scope.editable.flightCategory = null;
	        }
	    };
	    AviationBillingEngineController.prototype.openRecalculationPopup = function () {
	        this.$scope.showRecalculationPopup = true;
	    };
	    ;
	    AviationBillingEngineController.prototype.closeRecalculationPopup = function () {
	        this.$scope.showRecalculationPopup = false;
	        this.$scope.recalculationOptions.forEach(function (option) { return option.selected = true; });
	        this.$scope.selectAll = true;
	    };
	    AviationBillingEngineController.prototype.toggleSelectAll = function () {
	        var _this = this;
	        this.$scope.$parent.selectAll = !this.$scope.$parent.selectAll;
	        this.$timeout(function () {
	            _this.$scope.recalculationOptions.forEach(function (option) {
	                option.selected = _this.$scope.selectAll;
	            });
	        });
	    };
	    ;
	    AviationBillingEngineController.prototype.updateSelectAll = function () {
	        var allSelected = this.$scope.recalculationOptions.every(function (option) { return option.selected; });
	        this.$scope.selectAll = allSelected;
	    };
	    /**
	     * Set date options
	     */
	    AviationBillingEngineController.prototype.dateOptions = function () {
	        var _this = this;
	        this.$scope.dateOptions = {
	            startingDay: 0,
	            showWeeks: false,
	            maxDate: new Date(this.$scope.maxDate),
	            dateDisabled: function (data) {
	                var date = data.date, mode = data.mode;
	                var startingDay = _this.$scope.startingDay === 0 ? 6 : _this.$scope.startingDay - 1;
	                return mode === 'day' && (date.getDay() !== startingDay);
	            }
	        };
	    };
	    /**
	      * Set date options Annually
	      */
	    AviationBillingEngineController.prototype.dateOptionsAnnually = function () {
	        this.$scope.dateOptionsAnnually = {
	            maxDate: new Date(this.$scope.maxDate),
	            minMode: 'year',
	            dateDisabled: function (data) {
	                var date = data.date, mode = data.mode;
	                var previusYear = (moment().year() - 1);
	                var nextYear = (moment().year() + 1);
	                return mode === 'year' && (date.getFullYear() > nextYear || date.getFullYear() < previusYear);
	            }
	        };
	    };
	    /**
	       * Set date options Partially
	       */
	    AviationBillingEngineController.prototype.dateOptionsPartially = function () {
	        this.$scope.dateOptionsPartially = {
	            minMode: 'month',
	            dateDisabled: function (data) {
	                var date = data.date, mode = data.mode;
	                var currentYear = moment().year();
	                return mode === 'month' && (date.getFullYear() > currentYear);
	            }
	        };
	    };
	    /**
	        * Set date options Partially
	        */
	    AviationBillingEngineController.prototype.dateOptionsDueDate = function () {
	        this.$scope.dateOptionsDueDate = {
	            minMode: 'day',
	            dateDisabled: function (data) {
	                var date = data.date;
	                return date < new Date();
	            }
	        };
	    };
	    /**
	     * @param  {ISystemConfigurationSpring} data
	     * @returns default or current value for itemName parameter
	     */
	    AviationBillingEngineController.prototype.getSystemConfigurationItem = function (data, itemName) {
	        for (var _i = 0, _a = data.content; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (item.item_name === itemName) {
	                if (typeof (item.current_value) === 'string') {
	                    return item.current_value;
	                }
	                else {
	                    return item.default_value;
	                }
	            }
	        }
	    };
	    /**
	     * Prepends `0` to a
	     * single digit number
	     *
	     * @param  {number} n
	     * @returns string
	     */
	    AviationBillingEngineController.prototype.str_pad = function (n) {
	        return String('0' + n).slice(-2);
	    };
	    AviationBillingEngineController.prototype.getProgressBarValue = function (accountsTotal, accountNumber, flightsTotal, flightNumber) {
	        if (accountsTotal && flightsTotal && flightNumber) {
	            if (accountsTotal === accountNumber) {
	                this.$scope.progressBarValue = accountsTotal - 1 + flightNumber / flightsTotal;
	            }
	            else {
	                this.$scope.progressBarValue = accountNumber;
	            }
	        }
	        return this.$scope.progressBarValue;
	    };
	    return AviationBillingEngineController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AviationBillingEngineController = AviationBillingEngineController;
	function maxDate(maxDate) {
	    throw new Error('Function not implemented.');
	}


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var AirNavigationChargesController = (function (_super) {
	    __extends(AirNavigationChargesController, _super);
	    /* @ngInject */
	    AirNavigationChargesController.$inject = ["$scope", "airNavigationChargesService", "systemConfigurationService", "$uibModal", "aerodromeCategoryManagementService"];
	    function AirNavigationChargesController($scope, airNavigationChargesService, systemConfigurationService, $uibModal, aerodromeCategoryManagementService) {
	        var _this = _super.call(this, $scope, airNavigationChargesService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.airNavigationChargesService = airNavigationChargesService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$uibModal = $uibModal;
	        _this.aerodromeCategoryManagementService = aerodromeCategoryManagementService;
	        $scope.pattern = '.xls, .xlsx';
	        $scope.chargeTypes = airNavigationChargesService.listChargeTypes();
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        aerodromeCategoryManagementService.listAll().then(function (resp) {
	            $scope.aerodromeCategoryList = resp.content;
	            _super.prototype.setup.call(_this);
	        });
	        return _this;
	    }
	    AirNavigationChargesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AirNavigationChargesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            textFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    return AirNavigationChargesController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.AirNavigationChargesController = AirNavigationChargesController;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var SystemConfigurationController = (function (_super) {
	    __extends(SystemConfigurationController, _super);
	    /* @ngInject */
	    SystemConfigurationController.$inject = ["$scope", "systemConfigurationService", "translateService"];
	    function SystemConfigurationController($scope, systemConfigurationService, translateService) {
	        var _this = _super.call(this, $scope, systemConfigurationService) || this;
	        _this.$scope = $scope;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.translateService = translateService;
	        _super.prototype.setup.call(_this);
	        $scope.textFilter = '';
	        $scope.shouldBeFilteredCategory = function (textFilter, list, id, firstInCategory) { return SystemConfigurationController.shouldBeFilteredCategory(textFilter, list, id, firstInCategory); };
	        $scope.shouldBeFilteredItem = function (textFilter, itemName) { return SystemConfigurationController.shouldBeFilteredItem(textFilter, itemName); };
	        $scope.reloadLanguageConfiguration = function () { return translateService.run(); };
	        $scope.updateAndReloadLang = function (data) { return _this.updateAndReloadLang(data); };
	        $scope.isDisabledWL = function () { return _this.isDisabledWL(); };
	        $scope.systemConfigurationUpdated = null;
	        $scope.activeNotificationUpdated = function () { return _this.activeNotificationUpdated(); };
	        $scope.blob_url_string = '';
	        $scope.cachedBlobValues = {};
	        $scope.groupedItems = {};
	        $scope.collapsed = {};
	        $scope.groupItemsByCategory = function () {
	            $scope.groupedItems = {};
	            if (!$scope.list)
	                return;
	            $scope.list.forEach(function (item) {
	                var className = item.item_class.name;
	                if (item.blob_value) {
	                    $scope.cachedBlobValues[item.item_name] = item.blob_value;
	                }
	                else if ($scope.cachedBlobValues[item.item_name]) {
	                    item.blob_value = $scope.cachedBlobValues[item.item_name];
	                }
	                if (!$scope.groupedItems[className]) {
	                    $scope.groupedItems[className] = [];
	                    $scope.collapsed[className] = false;
	                }
	                $scope.groupedItems[className].push(item);
	            });
	        };
	        $scope.$watch("list", function (newVal) {
	            if (newVal) {
	                $scope.groupItemsByCategory();
	            }
	        });
	        $scope.filteredItems = function (items) {
	            return items.filter(function (item) {
	                var isMatching = $scope.shouldBeFilteredItem($scope.textFilter, item.item_name);
	                if ($scope.cachedBlobValues[item.item_name]) {
	                    item.blob_value = $scope.cachedBlobValues[item.item_name];
	                }
	                return isMatching ? item : null;
	            });
	        };
	        $scope.toggleAccordion = function (className) {
	            Object.keys($scope.collapsed).forEach(function (key) {
	                if (key === className) {
	                    $scope.collapsed[key] = !$scope.collapsed[key];
	                }
	                else {
	                    $scope.collapsed[key] = false;
	                }
	            });
	        };
	        $scope.$watch("textFilter", function (newVal) {
	            var hasFilter = newVal && newVal.length > 0;
	            Object.keys($scope.groupedItems).forEach(function (className) {
	                var filteredItems = $scope.filteredItems($scope.groupedItems[className]);
	                if (hasFilter && filteredItems.length > 0) {
	                    $scope.collapsed[className] = true;
	                }
	                else {
	                    $scope.collapsed[className] = false;
	                }
	            });
	        });
	        return _this;
	    }
	    // controllo abilitazione checkbox White List Enabled
	    SystemConfigurationController.prototype.isDisabledWL = function () {
	        // Verifica se la lista è un array valida
	        if (!Array.isArray(this.$scope.list)) {
	            return false;
	        }
	        // Trova l'elemento WL_ENABLED con current_value 't'
	        var wlEnabled = this.$scope.list.find(function (it) { return it.item_name === system_configuration_constants_1.SysConfigConstants.WL_ENABLED.toString() && it.current_value === 't'; });
	        // Se WL_ENABLED è 't', cerca WL_START_DATE e verifica il suo valore
	        if (wlEnabled) {
	            var startDateItem = this.$scope.list.find(function (it) { return it.item_name === system_configuration_constants_1.SysConfigConstants.WL_START_DATE.toString(); });
	            if (startDateItem) {
	                // Se il valore è non nullo, non undefined e non vuoto, disabilita
	                if (startDateItem.current_value) {
	                    return true;
	                }
	                // Altrimenti, svuota il valore
	                startDateItem.current_value = '';
	                return false;
	            }
	        }
	        // Trova l'elemento WL_ENABLED con current_value 'f'
	        var wlDisabled = this.$scope.list.find(function (it) { return it.item_name === system_configuration_constants_1.SysConfigConstants.WL_ENABLED.toString() && it.current_value === 'f'; });
	        // Se WL_ENABLED è 'f', svuota il valore di WL_START_DATE e disabilita
	        if (wlDisabled) {
	            var startDateItem = this.$scope.list.find(function (it) { return it.item_name === system_configuration_constants_1.SysConfigConstants.WL_START_DATE.toString(); });
	            if (startDateItem) {
	                startDateItem.current_value = '';
	                return true;
	            }
	        }
	        return true; // Disabilita per default
	    };
	    /**
	     * Filters the category name with these conditions
	     * - if it's the first one of that category id
	     * - if at least one item matches the textFilter (so we also go ahead and show it
	     *
	     * @param textFilter        the text entered into the input
	     * @param list              returned list of system configurations (ordered by orderBy filter)
	     * @param id                the class id for that item
	     * @param firstInCategory   if it's the first one in that particular category
	     * @returns {boolean}
	     */
	    SystemConfigurationController.shouldBeFilteredCategory = function (textFilter, list, id, firstInCategory) {
	        for (var i = 0; i < list.length; i++) {
	            if (list[i].item_class.id === id && list[i].item_name.toLowerCase().indexOf(textFilter.toLowerCase()) !== -1 && firstInCategory) {
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * Filters the individual item to see if includes
	     * NOTE: This can be removed and replace with a simple .includes() in the HTML when we support ES7
	     *
	     * @param textFilter    the text entered into the input
	     * @param itemName      the name of the current item to check against
	     * @returns {boolean}
	     */
	    SystemConfigurationController.shouldBeFilteredItem = function (textFilter, itemName) {
	        return itemName.toLowerCase().indexOf(textFilter.toLowerCase()) !== -1;
	    };
	    SystemConfigurationController.prototype.updateAndReloadLang = function (data) {
	        var _this = this;
	        _super.prototype.update.call(this, data, null).then(function () {
	            _this.$scope.reloadLanguageConfiguration();
	            _this.$scope.textFilter = '';
	            _this.$scope.activeNotificationUpdated();
	            _this.systemConfigurationService.reloadLogoOrganisation();
	            window.dispatchEvent(new Event('storage'));
	            _this.$scope.$applyAsync();
	        });
	    };
	    SystemConfigurationController.prototype.activeNotificationUpdated = function () {
	        this.$scope.systemConfigurationUpdated = true;
	    };
	    return SystemConfigurationController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.SystemConfigurationController = SystemConfigurationController;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var PassengerServiceChargeReturnController = (function (_super) {
	    __extends(PassengerServiceChargeReturnController, _super);
	    /* @ngInject */
	    PassengerServiceChargeReturnController.$inject = ["$scope", "$rootScope", "passengerServiceChargeReturnService", "$uibModal", "saveLocalTemplateService", "systemConfigurationService"];
	    function PassengerServiceChargeReturnController($scope, $rootScope, passengerServiceChargeReturnService, $uibModal, saveLocalTemplateService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, passengerServiceChargeReturnService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.passengerServiceChargeReturnService = passengerServiceChargeReturnService;
	        _this.$uibModal = $uibModal;
	        _this.saveLocalTemplateService = saveLocalTemplateService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.uploadNew = function (item, id) { return _this.uploadNew(item, id); };
	        _this.saveLocalTemplate();
	        $scope.$watchGroup(['search', 'chargeReturnFilter'], function () { return _this.getFilterParameters(); });
	        $scope.cargoDisplayUnits = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CARGO_DISPLAY_UNITS);
	        $scope.extendedPassengerInformation = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.EXTENDED_PSCR_PASSENGER_INFORMATION_SUPPORT);
	        $scope.extendedCargoInformation = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.EXTENDED_PSCR_CARGO_INFORMATION_SUPPORT);
	        $scope.pageSize = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE);
	        $scope.edit = function (item) {
	            return _super.prototype.edit.call(_this, systemConfigurationService.convertCargoProperty(item, 'loaded_goods,discharged_goods,loaded_mail,discharged_mail'));
	        };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    PassengerServiceChargeReturnController.prototype.saveLocalTemplate = function () {
	        var filterPairs = [['search', 'search'], ['chargeReturnFilter', 'filter-orphan-returns']];
	        this.saveLocalTemplateService.saveLocalTemplate(this.$scope, 'passenger-service-charge-return', filterPairs);
	    };
	    PassengerServiceChargeReturnController.prototype.uploadNew = function (item, id) {
	        var _this = this;
	        var path = [];
	        item.day_of_flight = new Date(item.day_of_flight).toISOString().replace('00.000Z', '00Z');
	        item.document_filename = item.document_filename2;
	        // sending id, instead of account, as part of multipart form
	        if (item.account && item.account.id) {
	            item.account_id = item.account.id;
	        }
	        if (id) {
	            path.push(id);
	        }
	        else {
	            path.push('new');
	        }
	        this.upload('PUT', path, item, null, null, true).then(function () {
	            _this.$scope.uploadJob = null;
	            _this.reset();
	            _this.refreshOverride();
	        }).catch(function (error) {
	            _this.$scope.error = {};
	            _this.$scope.error.error = { data: error };
	        });
	    };
	    PassengerServiceChargeReturnController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0,
	            'filter-orphan-returns': this.$scope.chargeReturnFilter
	        };
	    };
	    PassengerServiceChargeReturnController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return PassengerServiceChargeReturnController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.PassengerServiceChargeReturnController = PassengerServiceChargeReturnController;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// enums
	var crud_file_handler_type_1 = __webpack_require__(24);
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var helpers_service_1 = __webpack_require__(19);
	var charge_adjustments_service_1 = __webpack_require__(104);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var TransactionsController = (function (_super) {
	    __extends(TransactionsController, _super);
	    /* @ngInject */
	    TransactionsController.$inject = ["$scope", "transactionsService", "aircraftRegistrationService", "currencyManagementService", "invoicesService", "currencyExchangeRatesService", "$timeout", "catalogueServiceChargeService", "systemConfigurationService", "customDate", "sysConfigBoolean", "$filter", "flightMovementManagementService", "chargeAdjustmentsService", "organizationService", "bankAccountManagementService", "unifiedTaxManagementService", "$state", "transactionTypesService", "$q"];
	    function TransactionsController($scope, transactionsService, aircraftRegistrationService, currencyManagementService, invoicesService, currencyExchangeRatesService, $timeout, catalogueServiceChargeService, systemConfigurationService, customDate, sysConfigBoolean, $filter, flightMovementManagementService, chargeAdjustmentsService, organizationService, bankAccountManagementService, unifiedTaxManagementService, $state, transactionTypesService, $q) {
	        var _this = _super.call(this, $scope, transactionsService, null, 'Supporting Document', crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) || this;
	        _this.$scope = $scope;
	        _this.transactionsService = transactionsService;
	        _this.aircraftRegistrationService = aircraftRegistrationService;
	        _this.currencyManagementService = currencyManagementService;
	        _this.invoicesService = invoicesService;
	        _this.currencyExchangeRatesService = currencyExchangeRatesService;
	        _this.$timeout = $timeout;
	        _this.catalogueServiceChargeService = catalogueServiceChargeService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _this.sysConfigBoolean = sysConfigBoolean;
	        _this.$filter = $filter;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.chargeAdjustmentsService = chargeAdjustmentsService;
	        _this.organizationService = organizationService;
	        _this.bankAccountManagementService = bankAccountManagementService;
	        _this.unifiedTaxManagementService = unifiedTaxManagementService;
	        _this.$state = $state;
	        _this.transactionTypesService = transactionTypesService;
	        _this.$q = $q;
	        _this.exportSupport = { credit_notes: false, payments: false };
	        _this.exportSupportMechanism = {};
	        _super.prototype.setup.call(_this);
	        $scope.pattern = '.jpg, .gif, .png, .pdf';
	        $scope.fileUploadRequired = false;
	        $scope.fileUploadDisabled = true;
	        _this.getFilterParameters();
	        $scope.inverseExchange = sysConfigBoolean.parse(_this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE));
	        $scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.edit = function (item) { return _this.editTransaction(item); };
	        $scope.refreshList = function () { return _this.refreshList(); };
	        $scope.refreshInvoiceList = function (accountId, currencyId, page) { return _this.refreshInvoiceList(accountId, currencyId, page); };
	        $scope.refreshAndHideCreateWizard = function (transaction) { return _this.refreshAndHideCreateWizard(transaction); };
	        $scope.hideCreateWizard = function (transaction) { return _this.hideCreateWizard(transaction); };
	        $scope.showChargeWizard = function (editable) { return _this.showChargeWizard(editable); };
	        $scope.showCreateWizard = function (editable) { return _this.showCreateWizard(editable); };
	        $scope.showExcessWizard = function (editable) { return _this.showExcessWizard(editable); };
	        $scope.activeOrg = _this.organizationService.active();
	        $scope.taspLabel = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.TASP_FEES_LABEL);
	        $scope.selectedInvoiceIds = [];
	        $scope.charges = [];
	        $scope.calculatePayments = function (id, amount) { return _this.calculatePayments(id, amount); };
	        $scope.create = function (transaction) { return _this.create(transaction); };
	        $scope.reset = function () { return _this.reset(); };
	        $scope.showPaymentMechanism = (function (item) { return $scope.transactionFromInvoice ? item !== 'adjustment' : item; });
	        $scope.getCurrencyListByAccountId = function (id) { return _this.service.getCurrencyListByAccountId(id).then(function (data) {
	            return $scope.currencyList = data;
	        }); };
	        $scope.getInvoicesByTransactionId = function (id) { return _this.service.getInvoicesByTransactionId(id).then(function (data) {
	            return _this.$scope.listOfInvoices = data;
	        }); };
	        $scope.getTransactionPaymentsByTransactionId = function (id) { return _this.service.getTransactionPaymentsByTransactionId(id).then(function (data) {
	            return _this.$scope.listOfTransactionPayments = data;
	        }); };
	        $scope.updateExchangeRate = function (transaction, prioritizePayment) { return _this.updateExchangeRate(transaction, prioritizePayment); };
	        $scope.updateLocalAmount = function () { return _this.updateLocalAmount(); };
	        $scope.updatePaymentAmount = function () { return _this.updatePaymentAmount(); };
	        // default exchange rate to null and add watch to update from editable value
	        // this is here to limit exchange rate in view to 5 decimal places
	        $scope.paymentExchangeRate = null;
	        $scope.$watch('editable.payment_exchange_rate', function (value) { return _this.updatePaymentExchangeRate(value); });
	        $scope.invoiceChecked = false;
	        $scope.excessToBePaid = false;
	        $scope.addCharges = function (charge) { return _this.addCharges(charge); };
	        $scope.editCharges = function (charge, index) { return _this.editCharges(charge, index); };
	        $scope.resetCharges = function () { return _this.resetCharges(); };
	        $scope.updateCharges = function (charge) { return _this.updateCharges(charge); };
	        $scope.deleteCharges = function () { return _this.deleteCharges(); };
	        $scope.getCheckbox = function (index, id, checked, amountOwed) { return _this.getCheckbox(index, id, checked, amountOwed); };
	        $scope.getInvoiceAdjusted = function (id) { return _this.getInvoiceAdjusted(id); };
	        $scope.createNote = function (transaction, charges) { return _this.createNote(transaction, charges); };
	        $scope.disableCreateNote = function (charges) { return _this.disableCreateNote(charges); };
	        $scope.getTotal = function () { return _this.getTotal(); };
	        $scope.cancelCharges = function () { $scope.charges = []; _this.resetCharges(); };
	        $scope.setExternalSystemIdentifiers = function (chargeDescription) { return _this.setExternalSystemIdentifiers(chargeDescription); };
	        $scope.charge = {
	            transaction_id: null,
	            date: null,
	            aerodrome: null,
	            flight_id: null,
	            charge_description: null,
	            other_description: null,
	            charge_amount: null,
	            registration_number: null
	        };
	        $scope.aircraftRegistration = {
	            registration_number: null,
	            registration_start_date: null,
	            registration_expiry_date: null,
	            mtow_override: null,
	            country_override: null,
	            account: null,
	            aircraft_type: null,
	            country_of_registration: null,
	            created_by_self_care: null,
	            coa_expiry_date: null,
	            coa_issue_date: null,
	            aircraft_service_date: null,
	            is_local: null,
	            aircraft_scope: null,
	            document: null,
	            document_filename: null,
	            uploaded_document_name: null,
	            uploaded_document_type: null,
	            has_uploaded_document: null
	        };
	        $scope.exportSupport = false;
	        $scope.exportInProcess = false;
	        $scope.selectedItems = {};
	        $scope.exportAllTransactions = function () { return _this.exportAllTransactions(); };
	        $scope.exportSelectedTransactions = function (selected) { return _this.exportSelectedTransactions(selected); };
	        $scope.isExported = function (transaction) { return _this.isExported(transaction); };
	        $scope.isExportSupport = function (transaction) { return _this.isExportSupport(transaction); };
	        $scope.isSelectedItems = function (selected) { return _this.isSelectedItems(selected); };
	        $scope.setExportSupportMechanism = function (mechanism) { return _this.setExportSupportMechanism(mechanism); };
	        $scope.getUnifiedTaxChargesByRegistrationNumberAndByBillingLedgerId = function (aircraftRegistrationId, billingLedgerId) { return _this.unifiedTaxManagementService.getUnifiedTaxChargesByAircraftRegistationNumberAndBillingLedgerdId(aircraftRegistrationId, billingLedgerId); };
	        $scope.invoiceMatchFirst = function (invoice) {
	            // Confronta i valori arrotondati
	            var editableAmount = Math.abs($scope.editable.amount);
	            var invoiceAmount = invoice.amount_owing;
	            var decimals = $scope.editable.currency ? $scope.editable.currency.decimal_places : 2;
	            // Arrotonda entrambi i valori
	            var round = function (val) { return Number(Number(val).toFixed(decimals)); };
	            return round(editableAmount) === round(invoiceAmount) ? 0 : 1;
	        };
	        $scope.isInvoiceHighlighted = function (invoice) {
	            var editableAmount = Math.abs($scope.editable.amount);
	            var invoiceAmount = invoice.amount_owing;
	            var decimals = $scope.editable.currency ? $scope.editable.currency.decimal_places : 2;
	            var round = function (val) { return Number(Number(val).toFixed(decimals)); };
	            return round(editableAmount) === round(invoiceAmount);
	        };
	        $scope.openedNoteRow = null;
	        $scope.toggleNoteRow = function (item) {
	            $scope.openedNoteRow = ($scope.openedNoteRow === item.id) ? null : item.id;
	        };
	        $scope.setFlightId = function (item) {
	            var flight_id = item.flight_id, date_of_flight = item.date_of_flight, dep_time = item.dep_time, item18_reg_num = item.item18_reg_num, dep_ad = item.dep_ad, dest_ad = item.dest_ad, enroute_charges = item.enroute_charges, aerodrome_charges = item.aerodrome_charges, approach_charges = item.approach_charges, late_arrival_charges = item.late_arrival_charges, late_departure_charges = item.late_departure_charges, tasp_charge = item.tasp_charge, domestic_passenger_charges = item.domestic_passenger_charges, international_passenger_charges = item.international_passenger_charges, parking_charges = item.parking_charges;
	            var regNum = item18_reg_num ? item18_reg_num : '-';
	            var dateOfFlight = _this.$filter('dateConverter')(date_of_flight);
	            $scope.charge.flight_id = flight_id + "/" + dateOfFlight + "/" + dep_time + "/" + regNum + "/" + dep_ad + "-" + dest_ad;
	            $scope.chargeFlight = item;
	            if (_this.$scope.editable.payment_mechanism === 'adjustment' && _this.$scope.editable.transaction_type.name === 'credit' && _this.$scope.invoiceAdjusted) {
	                // reselect chargeTypes
	                _this.getInvoiceAdjusted(_this.$scope.invoiceAdjusted.id);
	                // filter chargeTypes based on flight movement's charges
	                var showEnrouteCharges = !!enroute_charges;
	                var showLandingCharges = !!aerodrome_charges || !!approach_charges || !!late_arrival_charges || !!late_departure_charges || !!tasp_charge;
	                var showTaspCharges = !!tasp_charge;
	                var showPassengerCharges = !!domestic_passenger_charges || !!international_passenger_charges;
	                var showParkingCharges = !!parking_charges;
	                if (!showEnrouteCharges) {
	                    _this.$scope.chargeTypes = _this.$scope.chargeTypes.filter(function (chargeType) { return !chargeType.description.toLowerCase().includes('enroute'); });
	                }
	                if (!showLandingCharges) {
	                    _this.$scope.chargeTypes = _this.$scope.chargeTypes.filter(function (chargeType) { return !chargeType.description.toLowerCase().includes('landing'); });
	                }
	                if (!showTaspCharges) {
	                    _this.$scope.chargeTypes = _this.$scope.chargeTypes.filter(function (chargeType) { return !chargeType.description.toLowerCase().includes(_this.$scope.taspLabel.toLowerCase()); });
	                }
	                if (!showPassengerCharges) {
	                    _this.$scope.chargeTypes = _this.$scope.chargeTypes.filter(function (chargeType) { return !chargeType.description.toLowerCase().includes('passenger'); });
	                }
	                if (!showParkingCharges) {
	                    _this.$scope.chargeTypes = _this.$scope.chargeTypes.filter(function (chargeType) { return !chargeType.description.toLowerCase().includes('parking'); });
	                }
	            }
	        };
	        $scope.setAircraftRegistration = function (item) {
	            $scope.aircraftRegistration = item;
	            $scope.charge.registration_number = item.registration_number;
	            //   let unifiedTaxCharges;
	            //   this.unifiedTaxManagementService.getUnifiedTaxChargesByAircraftRegistationNumberAndBillingLedgerdId(item.id,this.$scope.adjustmentInvoiceId).then((x) =>{
	            //     unifiedTaxCharges = x;
	            //      $scope.charge.charge_amount = unifiedTaxCharges.amount;
	            //  });
	        };
	        $scope.setAerodrome = function (item) {
	            $scope.charge.aerodrome = item.aerodrome.aerodrome_name;
	            $scope.charge.charge_description = item.service_charge_catalogue.description;
	            _this.setExternalSystemIdentifiers($scope.charge.charge_description);
	        };
	        $scope.getLineItemsByInvoiceId = function (invoiceId) { return _this.getLineItemsByInvoiceId(invoiceId); };
	        $scope.getFlightMovementsByInvoiceId = function (invoiceId) { return _this.getFlightMovementsByInvoiceId(invoiceId); };
	        $scope.getAircraftRegistrationByBillingLedgerId = function (invoiceId) { return _this.getAircraftRegistrationByBillingLedgerId(invoiceId); };
	        // define scope payment mechanism functions
	        $scope.isPaymentMechanism = function () {
	            var mechanisms = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                mechanisms[_i] = arguments[_i];
	            }
	            return _this.isPaymentMechanism(mechanisms);
	        };
	        // define scope bank account properties and functions
	        $scope.getBankAccountLabel = function (name, number) { return _this.bankAccountManagementService.getLabel(name, number); };
	        $scope.setEditableBankAccount = function (bankAccount) { return _this.setEditableBankAccount(bankAccount); };
	        // define scope payment date properties
	        $scope.isPaymentDateSupported = _this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.BACKDATE_PAYMENT_ALLOWED);
	        // define on change event functions
	        $scope.onPaymentMechanismChange = function (editable) { return _this.onPaymentMechanismChange(editable); };
	        $scope.onTransactionTypeChange = function (editable) { return _this.onTransactionTypeChange(editable); };
	        // initialize all data requests and trigger on load method once complete
	        _this.initialize();
	        return _this;
	    }
	    TransactionsController.prototype.create = function (transaction) {
	        var _this = this;
	        // clone so any changes made to transaction is not flashed to the view
	        var data = angular.copy(transaction);
	        // change amount values to negative for the backend
	        if (this.$scope.transactionFromInvoice) {
	            data.amount = -Math.abs(data.amount);
	            data.payment_amount = -Math.abs(data.payment_amount);
	        }
	        // disable form to prevent multiple clicks
	        this.$scope.isDisabled = true;
	        // use upload method as multiplePart type is used to upload optional file
	        // always undo disabling of form after promise complete
	        return _super.prototype.upload.call(this, 'POST', null, data, 'refreshAndHideCreateWizard').finally(function () {
	            _this.$scope.isDisabled = false;
	            _this.$scope.transactionFromInvoice = false;
	        });
	    };
	    TransactionsController.prototype.reset = function () {
	        _super.prototype.reset.call(this);
	        this.resetInvoices();
	        this.$scope.currencyList = this.$scope.fullCurrencyList;
	        this.$scope.transactionFromInvoice = false;
	    };
	    TransactionsController.prototype.resetInvoices = function () {
	        this.$scope.amounts = null;
	        this.$scope.selectedInvoiceIds = [];
	        this.$scope.isDisabled = false;
	    };
	    /**
	     * Populate transaction form using provided transaction parameter genearted from an invoice.
	     * This is used on the Billing -> Invoices view to pay a selected invoice.
	     *
	     * @param transaction transaction to populate
	     */
	    TransactionsController.prototype.setTransactionFromInvoice = function (transaction) {
	        var _this = this;
	        this.$scope.toggle = true;
	        this.$scope.transactionFromInvoice = true;
	        this.$scope.editable = this.transactionsService.getModel();
	        Object.keys(this.$scope.editable).forEach(function (item) { return _this.$scope.editable[item] = transaction[item] ? transaction[item] : _this.$scope.editable[item]; });
	        this.transactionTypesService.listAll().then(function (types) {
	            return _this.$scope.editable.transaction_type = types.find(function (type) { return type.name === 'credit'; });
	        });
	        this.$scope.editable.payment_mechanism = this.$scope.paymentMechanisms.find(function (mechanism) { return mechanism === 'cash'; });
	        this.onPaymentMechanismChange(this.$scope.editable);
	        this.updateExchangeRate(this.$scope.editable, true);
	    };
	    /**
	     *
	     * This takes all payable invoices and calculates
	     * the total amount owed.
	     *
	     * Additionally, if an invoice amount is exactly
	     * equal to the transaction amount added by the user,
	     * that invoice will be automatically selected for payment.
	     *
	     * @param  {Array<IInvoice>} invoices
	     * @returns void
	     */
	    TransactionsController.prototype.addInvoices = function (invoices) {
	        var _this = this;
	        // if populating a list of unpaid invoices
	        // to apply the excess adjustment amount,
	        // remove the already adjusted invoice
	        if (this.$scope.excessToBePaid) {
	            invoices = invoices.filter(function (invoice) {
	                // if adjustment invoice, correct pagenation settings
	                if (invoice.id === _this.$scope.adjustmentInvoiceId) {
	                    _this.$scope.data.number_of_elements--;
	                    _this.$scope.data.total_elements--;
	                    _this.$scope.data.total_items--;
	                    return false;
	                }
	                else {
	                    return true;
	                }
	            });
	            // set the excess amount to the total of the charges
	            // added, minus the amount owed from the invoice
	            // selected for adjustment
	            this.$scope.editable.amount = this.$scope.total - this.$scope.amountOwed;
	            // for adjustment, exchange rate is always 1
	            this.$scope.editable.payment_exchange_rate = 1;
	        }
	        this.$scope.invoices = invoices;
	        var exactMatchId = null;
	        for (var _i = 0, _a = this.$scope.invoices; _i < _a.length; _i++) {
	            var invoice = _a[_i];
	            if (Math.abs(this.$scope.editable.amount) === invoice.amount_owing && invoice.amount_owing !== 0 &&
	                exactMatchId === null && this.$scope.selectedInvoiceIds.length === 0) {
	                exactMatchId = invoice.id;
	                break;
	            }
	        }
	        if (this.$scope.editable.transaction_type.name === 'credit') {
	            this.$scope.editable.amount = -Math.abs(this.$scope.editable.amount); // convert amount to a negative for the back-end
	            this.$scope.editable.payment_amount = -Math.abs(this.$scope.editable.payment_amount); // convert amount to a negative for the back-end
	        }
	        // if exact match between amount and invoice, calculate for that invoice
	        if (exactMatchId) {
	            this.calculatePayments(exactMatchId, this.$scope.editable.amount);
	        }
	    };
	    TransactionsController.prototype.calculatePayments = function (id, amount) {
	        var ids = this.$scope.selectedInvoiceIds;
	        var index = ids.indexOf(id);
	        index === -1 ? ids.push(id) : ids.splice(ids.indexOf(id), 1); // add/remove id from array
	        this.$scope.editable.billing_ledger_ids = ids; // ids of selected invoices
	        this.validateSelectedInvoice(ids, id, amount, index === -1);
	    };
	    TransactionsController.prototype.validateSelectedInvoice = function (ids, id, amount, subtract) {
	        var _this = this;
	        if (ids.length > 0) {
	            this.service.validateSelectedInvoice(this.$scope.editable).then(function (resp) {
	                _this.$scope.amounts = resp;
	                _this.updateAmountAvailable(amount, subtract);
	            }).catch(function (response) { return _this.rejectSelectedInvoice(response, id); });
	        }
	        else {
	            this.$scope.amounts = null;
	            this.updateAmountAvailable(amount, subtract);
	        }
	    };
	    TransactionsController.prototype.rejectSelectedInvoice = function (response, id) {
	        // handle rejection response appropriately
	        this.setErrorResponse(response);
	        // remove id from selected billing ledger ids if exists
	        var ids = this.$scope.editable.billing_ledger_ids;
	        var index = ids.indexOf(id);
	        if (index !== -1) {
	            ids.splice(index, 1);
	        }
	        // remove id from amounts if exists, must be undefined
	        if (this.$scope.amounts && this.$scope.amounts[id] !== undefined) {
	            delete (this.$scope.amounts[id]);
	        }
	        // uncheck invoice if selected
	        for (var _i = 0, _a = this.$scope.invoices; _i < _a.length; _i++) {
	            var invoice = _a[_i];
	            if (invoice.id === id) {
	                invoice.checked = false; // type <any> as checked is not an expected IInvoice property
	            }
	        }
	    };
	    TransactionsController.prototype.updateAmountAvailable = function (amount, subtract) {
	        this.$scope.amountAvailable += (subtract ? -Math.abs(amount) : Math.abs(amount));
	    };
	    /**
	     * Update payment exchange rate by even rounding supplied value.
	     *
	     * @param value exchange rate value
	     */
	    TransactionsController.prototype.updatePaymentExchangeRate = function (value) {
	        // even round exchange rate to 5 decimal places of value
	        if (value) {
	            if (this.$scope.inverseExchange) {
	                this.$scope.paymentExchangeRate = helpers_service_1.HelperService.evenRound((1 / value), 5).toFixed(5);
	            }
	            else {
	                this.$scope.paymentExchangeRate = helpers_service_1.HelperService.evenRound(value, 5).toFixed(5);
	            }
	        }
	        else {
	            this.$scope.paymentExchangeRate = null;
	        }
	        ;
	    };
	    /**
	     * Calcualte exchange amount. Rounding decimal points is defined by supplied `currency`.
	     *
	     * @param amount amount to exchange
	     * @param exchangeRate exchange rate
	     * @param currency currency to use for formatting
	     * @param inverse inverse exchange rate (divide instead of multiple)
	     */
	    TransactionsController.prototype.calculateAmount = function (amount, exchangeRate, currency, inverse) {
	        if (inverse === void 0) { inverse = false; }
	        // if amount, exchange and currency are null, return null
	        if (amount === null || exchangeRate === null || currency === null) {
	            return null;
	        }
	        // calculate exchange from amount and exchange rate (inverse if true)
	        var exchange;
	        if (inverse) {
	            exchange = amount / exchangeRate;
	        }
	        else {
	            exchange = amount * exchangeRate;
	        }
	        // value should be even rounded to currency decimal points
	        return helpers_service_1.HelperService.evenRound(exchange, currency.decimal_places || 2);
	    };
	    /**
	     * Update exchange rate from payment currency into local currency. This method will
	     * set currency fields to invalid if no exchange rate is found.
	     *
	     * @param transaction transaction to update exchange rate
	     * @param prioritizePayment priority payment value over local value when updating
	     */
	    TransactionsController.prototype.updateExchangeRate = function (transaction, prioritizePayment) {
	        var _this = this;
	        if (prioritizePayment === void 0) { prioritizePayment = true; }
	        if (this.$scope.transactionFromInvoice) {
	            prioritizePayment = false;
	        }
	        // validate that provided transaction is defined as it is required
	        // return immediately if transaction is not defined
	        if (!transaction) {
	            return;
	        }
	        // define from and to currencies based on provided transaction
	        var fromCurrency = transaction.payment_currency;
	        var toCurrency = transaction.currency;
	        // if fromCurrency exists, toCurrency null and fromCurrency in currencyList
	        // set toCurrency to fromCurrency for better user experience
	        if (fromCurrency && !toCurrency && this.$scope.currencyList.filter(function (currency) { return currency.id === fromCurrency.id; }).length > 0) {
	            toCurrency = fromCurrency;
	            this.$scope.editable.currency = fromCurrency;
	        }
	        // if currency values are empty, return
	        // else find exchange rate between currencies
	        if (!fromCurrency || !fromCurrency.id || !toCurrency || !toCurrency.id) {
	            this.$scope.editable.payment_exchange_rate = null;
	            prioritizePayment ? this.updateLocalAmount() : this.updatePaymentAmount();
	        }
	        else {
	            this.currencyExchangeRatesService.getExchangeRateByCurrencyId(fromCurrency.id, toCurrency.id, transaction.payment_date || null)
	                .then(function (data) {
	                _this.$scope.editable.payment_exchange_rate = data;
	                _this.$scope.form.currency.$setValidity('valid_exchange_rate', true);
	                _this.$scope.form.paymentCurrency.$setValidity('valid_exchange_rate', true);
	            }).catch(function (error) {
	                _this.$scope.editable.payment_exchange_rate = null;
	                _this.$scope.form.currency.$setValidity('valid_exchange_rate', false);
	                _this.$scope.form.paymentCurrency.$setValidity('valid_exchange_rate', false);
	                _this.$scope.error = { error: error };
	            }).finally(function () {
	                prioritizePayment ? _this.updateLocalAmount() : _this.updatePaymentAmount();
	            });
	        }
	    };
	    /**
	     * Update local amount from payment amount and exchange rate.
	     */
	    TransactionsController.prototype.updateLocalAmount = function () {
	        var _this = this;
	        // if exchange call to service already pending, cancel and send another
	        // use one timeout for both local and payment amounts so that if user
	        // switches input controls and updates before result is returned, their new value
	        // isn't overwritten
	        if (this._exchangeTimeout) {
	            this.$timeout.cancel(this._exchangeTimeout);
	        }
	        // get all values from editable form
	        var amount = this.$scope.editable.payment_amount;
	        var rate = this.$scope.editable.payment_exchange_rate;
	        var currency = this.$scope.editable.currency;
	        var inverse = false;
	        // if amount, exchange and currency are null, return
	        // else calculate exchange in browser (emulated banker's rounding)
	        // and after custom debounce of 800 milliseconds, get calcualtion from service (so that banker's rounding is consistent)
	        if (!amount && amount !== 0 || !rate || !currency) {
	            this.$scope.editable.amount = null;
	        }
	        else {
	            // initially get amount from emulated banker's rounding in browser
	            // this will provide immediate feedback to the user
	            this.$scope.editable.amount = this.calculateAmount(amount, rate, currency, inverse);
	            // send call to service to get calcualted exchange amount
	            // wait 800 milliseconds before sending
	            this._exchangeTimeout = this.$timeout(function () {
	                _this.currencyExchangeRatesService.getExchangeAmount(amount, rate, currency.decimal_places || 2, inverse)
	                    .then(function (data) {
	                    _this.$scope.editable.amount = data;
	                }).catch(function (Error) {
	                    // fallback to manual calculations
	                    _this.$scope.editable.amount = _this.calculateAmount(amount, rate, currency, inverse);
	                });
	            }, 800);
	        }
	    };
	    /**
	     * Update payment amount from local amount and exchange rate.
	     */
	    TransactionsController.prototype.updatePaymentAmount = function () {
	        var _this = this;
	        // if exchange call to service already pending, cancel and send another
	        // use one timeout for both local and payment amounts so that if user
	        // switches input controls and updates before result is returned, their new value
	        // isn't overwritten
	        if (this._exchangeTimeout) {
	            this.$timeout.cancel(this._exchangeTimeout);
	        }
	        // get all values from editable form
	        var amount = this.$scope.editable.amount;
	        var rate = this.$scope.editable.payment_exchange_rate;
	        var currency = this.$scope.editable.payment_currency;
	        var inverse = true;
	        // if amount, exchange and currency are null, return
	        // else calculate exchange in browser (emulated banker's rounding)
	        // and after custom debounce of 800 milliseconds, get calcualtion from service (so that banker's rounding is consistent)
	        if (!amount && amount !== 0 || !rate || !currency) {
	            this.$scope.editable.payment_amount = null;
	        }
	        else {
	            // initially get amount from emulated banker's rounding in browser
	            // this will provide immediate feedback to the user
	            this.$scope.editable.payment_amount = this.calculateAmount(amount, rate, currency, inverse);
	            // send call to service to get calcualted exchange amount
	            // wait 800 milliseconds before sending
	            this._exchangeTimeout = this.$timeout(function () {
	                _this.currencyExchangeRatesService.getExchangeAmount(amount, rate, currency.decimal_places || 2, inverse)
	                    .then(function (data) {
	                    _this.$scope.editable.payment_amount = data;
	                }).catch(function (Error) {
	                    // fallback to manual calculations
	                    _this.$scope.editable.payment_amount = _this.calculateAmount(amount, rate, currency, inverse);
	                });
	            }, 800);
	        }
	    };
	    /**
	     * This runs when clicking a checkbox to select
	     * an invoice for adjustment
	     * @param  {number} position - index of selected invoice for adjustment
	     * @param  {number} id - id of invoice to adjust
	     * @param  {boolean} checked - used to indicate of an invoice has been selected
	     * @param  {number} amountOwed - amount owed on selected invoice
	     * @returns void
	     */
	    TransactionsController.prototype.getCheckbox = function (position, id, checked, amountOwed) {
	        // user may only select one invoice to adjust
	        // after, if there is excess credit, the user
	        // may select any number of 'unpaid' invoices to pay
	        this.$scope.editable.billing_ledger_ids = [];
	        this.$scope.amountOwed = amountOwed;
	        angular.forEach(this.$scope.invoices, function (subscription, index) {
	            if (position !== index) {
	                subscription.checked = false;
	            }
	        });
	        // capture invoice to be adjusted
	        this.$scope.adjustmentInvoiceId = id;
	        this.$scope.invoiceChecked = checked;
	    };
	    TransactionsController.prototype.addCharges = function (charge) {
	        // resolve flight movement external charge values
	        this.chargeAdjustmentsService.resolveFlightAdjustmentExternal(charge, this.$scope.chargeFlight, this.$scope.invoiceAdjusted.invoice_type);
	        // store charge flight for editing purposes
	        this.$scope.chargeFlights = this.$scope.chargeFlights || [];
	        this.$scope.chargeFlights.push(angular.copy(this.$scope.chargeFlight || {}));
	        var copyCharge = angular.copy(charge);
	        this.$scope.charges.push(copyCharge);
	        // get charge type from scope using description supplied
	        var chargeType = this.$scope.chargeTypes
	            ? this.$scope.chargeTypes.find(function (item) { return item.external_accounting_system_identifier && item.description === charge.charge_description; })
	            : null;
	        // limit subsequent charge types to similiar externalChargeCategory
	        if (chargeType && chargeType.external_charge_category && this.$scope.invoiceAdjusted && this.$scope.invoiceAdjusted.invoice_type === 'non-aviation') {
	            this.$scope.chargeTypes = this.$scope.catalogueCharges.filter(function (item) {
	                return item.external_charge_category && item.external_charge_category.id === chargeType.external_charge_category.id;
	            });
	        }
	        else if (this.$scope.invoiceAdjusted && this.$scope.invoiceAdjusted.invoice_type === 'non-aviation') {
	            this.$scope.chargeTypes = this.$scope.catalogueCharges;
	        }
	        this.resetCharges();
	    };
	    /**
	     * For adjustment transactions,
	     * Clears the add charges form
	     * @returns void
	     */
	    TransactionsController.prototype.resetCharges = function () {
	        this.$scope.charge = {
	            date: null,
	            aerodrome: null,
	            flight_id: null,
	            charge_description: null,
	            other_description: null,
	            charge_amount: null,
	            transaction_id: null,
	            external_accounting_system_identifier: null
	        };
	        this.$scope.chargeIndex = undefined;
	        this.$scope.chargeFlight = undefined;
	    };
	    TransactionsController.prototype.editCharges = function (data, index) {
	        this.$scope.charge = angular.copy(data);
	        this.$scope.chargeFlight = angular.copy(this.$scope.chargeFlights[index]);
	        this.$scope.chargeIndex = index;
	    };
	    /**
	     * For adjustment transactions
	     * Updates charges
	     * @param  {IAdjustmentCharge} charge
	     * @returns void
	     */
	    TransactionsController.prototype.updateCharges = function (charge) {
	        // resolve flight movement external charge values
	        this.chargeAdjustmentsService.resolveFlightAdjustmentExternal(charge, this.$scope.chargeFlight, this.$scope.invoiceAdjusted.invoice_type);
	        for (var item in this.$scope.charges) {
	            if (this.$scope.chargeIndex === parseInt(item, 10)) {
	                this.$scope.charges[parseInt(item, 10)] = angular.copy(charge);
	            }
	        }
	        this.resetCharges();
	    };
	    /**
	     * For adjustment transactions
	     * Deletes charges
	     * @returns void
	     */
	    TransactionsController.prototype.deleteCharges = function () {
	        this.$scope.charges.splice(this.$scope.chargeIndex, 1);
	        this.$scope.chargeFlights.splice(this.$scope.chargeIndex, 1);
	        // reset catalogue charges if no charges left
	        if (this.$scope.charges.length < 1 && this.$scope.invoiceAdjusted && this.$scope.invoiceAdjusted.invoice_type === 'non-aviation') {
	            this.$scope.chargeTypes = this.$scope.catalogueCharges;
	        }
	        this.resetCharges();
	    };
	    /**
	     * For adjustment transactions, this sets the
	     * different available charge types, depending
	     * on the type of invoice
	     *
	     * @param  {number} id
	     * @returns void
	     */
	    TransactionsController.prototype.getInvoiceAdjusted = function (id) {
	        for (var _i = 0, _a = this.$scope.invoices; _i < _a.length; _i++) {
	            var invoice = _a[_i];
	            if (invoice.id === id) {
	                this.$scope.invoiceAdjusted = invoice;
	                switch (invoice.invoice_type) {
	                    case 'aviation-iata':
	                        this.$scope.chargeTypes = this.chargeAdjustmentsService.iataChargeTypes();
	                        break;
	                    case 'aviation-noniata':
	                        this.$scope.chargeTypes = this.chargeAdjustmentsService.nonIataChargeTypes();
	                        break;
	                    case 'unified-tax':
	                        this.$scope.chargeTypes = this.chargeAdjustmentsService.unifiedTaxChargeTypes();
	                        break;
	                    case 'non-aviation':
	                        this.$scope.chargeTypes = this.$scope.catalogueCharges;
	                        break;
	                    case 'debit-note':
	                        this.$scope.chargeTypes = [{ description: charge_adjustments_service_1.ChargesAdjustmentType.OTHER_CHARGES }];
	                        break;
	                    default:
	                        this.$scope.chargeTypes = [];
	                }
	            }
	        }
	    };
	    /**
	     * Returns the total amount of all
	     * the added adjustment charges
	     * @returns number
	     */
	    TransactionsController.prototype.getTotal = function () {
	        this.$scope.total = 0;
	        for (var i = 0; i < this.$scope.charges.length; i++) {
	            var item = this.$scope.charges[i];
	            this.$scope.total += (item.charge_amount);
	        }
	        // perform rounding due to floating point percision issue in JavaScript
	        var percision = this.$scope.editable && this.$scope.editable.currency
	            ? this.$scope.editable.currency.decimal_places : 2;
	        this.$scope.total = helpers_service_1.HelperService.evenRound(this.$scope.total, percision);
	        return this.$scope.total;
	    };
	    /**
	     * Adds adjustment charges to the editable
	     * object and creates a credit or debit note
	     *
	     * @param  {ITransaction} transaction
	     * @param  {IAdjustmentCharge} charges
	     * @returns ng
	     */
	    TransactionsController.prototype.createNote = function (transaction, charges) {
	        var _this = this;
	        this.$scope.isDisabledCreateNote = true;
	        this.$scope.editable.charges_adjustment = [];
	        for (var _i = 0, _a = angular.copy(this.$scope.charges); _i < _a.length; _i++) {
	            var item = _a[_i];
	            // the charge amount must be equal to the local amount
	            // as the local amount is a negative, here we convert
	            // the charge amounts to negatives
	            if (this.$scope.editable.transaction_type.name === 'credit') {
	                item.charge_amount = -Math.abs(item.charge_amount);
	            }
	            if (item.other_description !== null) {
	                item.charge_description = item.other_description;
	            }
	            this.$scope.editable.charges_adjustment.push(item);
	        }
	        // here we add the id of the invoice to be adjusted
	        // to the beginning of the array. This must be done
	        // only *after* unpaid invoices (if any) are selected
	        // for payment with surplus credit charges
	        if (!this.$scope.editable.billing_ledger_ids.includes(this.$scope.adjustmentInvoiceId)) {
	            this.$scope.editable.billing_ledger_ids.unshift(this.$scope.adjustmentInvoiceId);
	        }
	        // set the amount and payment_amount
	        // to the added total of the adjustment charges
	        // currently there are no exchange rate conversions
	        // applied to adjustement charges, the invoice
	        // must be paid in the invoice currency
	        this.$scope.editable.amount = this.getTotal();
	        this.$scope.editable.payment_amount = this.getTotal();
	        // no ability to adjust in other other currencies,
	        // set the payment_currency to the local currency
	        this.$scope.editable.payment_currency = this.$scope.editable.currency;
	        // for adjustment, exchange rate is always 1
	        this.$scope.editable.payment_exchange_rate = 1;
	        // if crediting, convert local/payment amounts to
	        // a negative, to reduce the balance (owed)
	        if (this.$scope.editable.transaction_type.name === 'credit') {
	            this.$scope.editable.amount = -Math.abs(this.$scope.editable.amount);
	            this.$scope.editable.payment_amount = -Math.abs(this.$scope.editable.payment_amount);
	        }
	        // create transaction and return promise
	        return this.create(transaction).then(function () { return _this.$scope.isDisabledCreateNote = false; });
	    };
	    /**
	     * Set scope charge external system identifiers from selected
	     * charge type.
	     *
	     * @param chargeDescription description of charge adjustement
	     */
	    TransactionsController.prototype.setExternalSystemIdentifiers = function (chargeDescription) {
	        // get charge type from scope using description supplied
	        var chargeType = this.$scope.chargeTypes
	            ? this.$scope.chargeTypes.find(function (item) { return item.description === chargeDescription; })
	            : null;
	        // set by charge type found with external account system identifier if exists
	        this.$scope.charge.external_accounting_system_identifier = chargeType && chargeType.external_accounting_system_identifier
	            ? chargeType.external_accounting_system_identifier
	            : null;
	        // set by charge type found with external charge category if exsits
	        this.$scope.charge.external_charge_category_name = chargeType && chargeType.external_charge_category
	            ? chargeType.external_charge_category.name
	            : null;
	    };
	    TransactionsController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            exportedFilter: this.$scope.exportedFilter === true ? false : null,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            startDate: startDate,
	            endDate: endDate,
	            account: this.$scope.accountFilter
	        };
	    };
	    /**
	     * Refresh data list in scope.
	     */
	    TransactionsController.prototype.refreshList = function () {
	        this.getFilterParameters();
	        return this.$scope.refresh(this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    /**
	     * Determine if any transaction items are selected.
	     *
	     * @param selectedItems transaction id items selected
	     */
	    TransactionsController.prototype.isSelectedItems = function (selectedItems) {
	        return Object.keys(selectedItems)
	            .filter(function (key) { return selectedItems[key]; })
	            .length > 0;
	    };
	    /**
	     * Export all non-exported transactions.
	     */
	    TransactionsController.prototype.exportAllTransactions = function () {
	        var _this = this;
	        this.$scope.exportInProcess = true;
	        this.transactionsService.exportAllTransactions()
	            .then(function (response) { return _this.handleExportSuccess(response); })
	            .catch(function (response) { return _this.handleExportError(response); })
	            .finally(function () { return _this.handleExportFinished(_this.$scope.selectedItems); });
	    };
	    /**
	     * Export a list of transaction ids.
	     *
	     * @param selectedItems transaction ids to export
	     */
	    TransactionsController.prototype.exportSelectedTransactions = function (selectedItems) {
	        var _this = this;
	        this.$scope.exportInProcess = true;
	        var ids = Object.keys(selectedItems)
	            .filter(function (key) { return selectedItems[key]; })
	            .map(Number);
	        this.transactionsService.exportSelectedTransactions(ids)
	            .then(function (response) { return _this.handleExportSuccess(response); })
	            .catch(function (response) { return _this.handleExportError(response); })
	            .finally(function () { return _this.handleExportFinished(selectedItems); });
	    };
	    /**
	     * Clear any error messages away and display success message.
	     */
	    TransactionsController.prototype.handleExportSuccess = function (response) {
	        this.$scope.exportSuccess = true;
	        this.$scope.error = null;
	    };
	    /**
	     * Clear success message and display error message without subtitle.
	     *
	     * @param response error response
	     */
	    TransactionsController.prototype.handleExportError = function (response) {
	        this.$scope.exportSuccess = false;
	        response.data.hide_subtitle = true;
	        this.setErrorResponse(response);
	    };
	    /**
	     * Reset view and makr export in process as false.
	     *
	     * @param selectedItems items to uncheck
	     */
	    TransactionsController.prototype.handleExportFinished = function (selectedItems) {
	        var _this = this;
	        // deselect ALL items
	        if (selectedItems) {
	            Object.keys(selectedItems).forEach(function (key) { return _this.$scope.selectedItems[key] = false; });
	        }
	        // reset view list
	        this.$scope.exportInProcess = false;
	        this.refreshList();
	    };
	    TransactionsController.prototype.isExported = function (transaction) {
	        var result = false;
	        if (this.exportSupportMechanism[transaction.payment_mechanism] === true) {
	            result = transaction.payment_mechanism === 'adjustment'
	                ? this.isExportedAdjustment(transaction)
	                : this.isExportedPayment(transaction);
	        }
	        return result;
	    };
	    TransactionsController.prototype.isExportedAdjustment = function (transaction) {
	        var result = false;
	        if (this.exportSupport.credit_notes === true && this.exportSupport.payments === true) {
	            result = transaction.exported && transaction.payments_exported;
	        }
	        else if (this.exportSupport.credit_notes === true) {
	            result = transaction.exported;
	        }
	        else if (this.exportSupport.payments === true) {
	            result = transaction.payments_exported;
	        }
	        return result;
	    };
	    TransactionsController.prototype.isExportedPayment = function (transaction) {
	        var result = false;
	        if (this.exportSupport.payments === true) {
	            result = transaction.payments_exported;
	        }
	        return result;
	    };
	    /**
	     * Validate if transaction is available for exporting.
	     *
	     * @param transaction transaction item to validate
	     */
	    TransactionsController.prototype.isExportSupport = function (transaction) {
	        var exportSupport = transaction.payment_mechanism === 'adjustment'
	            ? this.exportSupport.credit_notes || this.exportSupport.payments
	            : this.exportSupport.payments;
	        // supported for export if credit type, export supported, and mechanism is supported
	        var result = transaction.transaction_type.name === 'credit' && exportSupport &&
	            this.exportSupportMechanism[transaction.payment_mechanism];
	        // make sure item is not already selected if support is false
	        if (!result && this.$scope.selectedItems[transaction.id]) {
	            this.$scope.selectedItems[transaction.id] = false;
	        }
	        return result;
	    };
	    /**
	     * Set export support for transaction mechansim and cache for reuse. Should
	     * reset on page change/reload.
	     *
	     * @param mechanism transaction mechansim support to set
	     */
	    TransactionsController.prototype.setExportSupportMechanism = function (mechanism) {
	        var _this = this;
	        if (this.exportSupportMechanism[mechanism] !== false && this.exportSupportMechanism[mechanism] !== true) {
	            this.exportSupportMechanism[mechanism] = false;
	            this.transactionsService.exportSupportMechanism(mechanism)
	                .then(function (result) { return _this.exportSupportMechanism[mechanism] = result; });
	        }
	    };
	    /**
	     * Refresh list and then hide create wizard.
	     */
	    TransactionsController.prototype.refreshAndHideCreateWizard = function (result) {
	        var _this = this;
	        return this.refreshList().then(function () { return _this.hideCreateWizard(result); });
	    };
	    /**
	     * Hide and reset transaction creation wizard.
	     */
	    TransactionsController.prototype.hideCreateWizard = function (result) {
	        this.$scope.invoiceAdjustedTextFilter = null;
	        this.$scope.excessToBePaid = false;
	        this.$scope.invoiceChecked = false;
	        this.$scope.showInvoices = false;
	        this.$scope.showCharges = false;
	        this.$scope.cancelCharges();
	        this.$scope.reset();
	        this.$scope.form.$setUntouched();
	        if (result && result.interest_invoice_error) {
	            this.$scope.interestInvoiceError = result.interest_invoice_error;
	        }
	    };
	    /**
	     * Show transaction charge wizard for adjustments.
	     *
	     * @param editable transaction to create
	     */
	    TransactionsController.prototype.showChargeWizard = function (editable) {
	        this.$scope.showCharges = true;
	    };
	    /**
	     * Show transcation creation wizard.
	     *
	     * @param editable transaction to create
	     */
	    TransactionsController.prototype.showCreateWizard = function (editable) {
	        if (editable.payment_mechanism === 'adjustment') {
	            this.getAllInvoicesByAccountIdAndCurrency(editable.account.id, editable.currency.id);
	        }
	        else {
	            this.getUnpaidInvoicesByAccountIdAndCurrency(editable.account.id, editable.currency.id);
	        }
	        this.getTotalAmount(editable.account.id, editable.currency.id);
	        this.$scope.amountAvailable = Math.abs(editable.amount) || 0;
	        this.$scope.showInvoices = true;
	        this.$scope.showCharges = false;
	    };
	    /**
	     * Show transaction excess wizard for adjustments.
	     *
	     * @param editable adjustment transaction with excess
	     */
	    TransactionsController.prototype.showExcessWizard = function (editable) {
	        this.getUnpaidInvoicesByAccountIdAndCurrency(editable.account.id, editable.currency.id, true);
	        this.$scope.amountAvailable = Math.abs(this.$scope.total - this.$scope.amountOwed) || 0;
	        this.$scope.showInvoices = true;
	        this.$scope.showCharges = false;
	        this.$scope.invoiceAdjustedTextFilter = null;
	    };
	    /**
	     * Get all unpaid invoices by account and currency.
	     *
	     * @param accountId account id
	     * @param currencyId currency id
	     * @param excessTobePaid excess to be paid
	     * @param page page number
	     */
	    TransactionsController.prototype.getUnpaidInvoicesByAccountIdAndCurrency = function (accountId, currencyId, excessTobePaid, page, sort) {
	        var _this = this;
	        return this.invoicesService.getUnpaidInvoices(accountId, currencyId, page, sort)
	            .then(function (data) {
	            _this.$scope.excessToBePaid = excessTobePaid || false;
	            _this.$scope.data = data;
	            _this.addInvoices(data.content);
	            return data;
	        });
	    };
	    /**
	     * Get all invoices by account id and currency.
	     *
	     * @param accountId acount id
	     * @param currencyId currency id
	     * @param page page number
	     */
	    TransactionsController.prototype.getAllInvoicesByAccountIdAndCurrency = function (accountId, currencyId, page, sort) {
	        var _this = this;
	        return this.invoicesService.getAllInvoicesByAccountIdAndCurrency(accountId, currencyId, page, sort)
	            .then(function (data) {
	            _this.$scope.data = data;
	            _this.addInvoices(data.content);
	            return data;
	        });
	    };
	    /**
	     * Refresh invoice list depending create wizard editable state.
	     *
	     * @param accountId account id
	     * @param currencyId currency id
	     * @param page page number
	     */
	    TransactionsController.prototype.refreshInvoiceList = function (accountId, currencyId, page) {
	        if (this.$scope.editable.payment_mechanism === 'adjustment' && !this.$scope.excessToBePaid) {
	            this.$scope.invoiceChecked = false;
	            return this.getAllInvoicesByAccountIdAndCurrency(accountId, currencyId, page, this.$scope.getInvoiceListSortQueryString());
	        }
	        else if (this.$scope.editable.payment_mechanism !== 'adjustment' || this.$scope.excessToBePaid) {
	            return this.getUnpaidInvoicesByAccountIdAndCurrency(accountId, currencyId, this.$scope.excessToBePaid, page, this.$scope.getInvoiceListSortQueryString());
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Get total amount owned amount from all invoices.
	     *
	     * @param accountId account id
	     * @param currencyId currency id
	     */
	    TransactionsController.prototype.getTotalAmount = function (accountId, currencyId) {
	        var _this = this;
	        this.invoicesService.getTotalAmountForInvoices(accountId, currencyId)
	            .then(function (amount) { return _this.$scope.totalAmountForAllInvoices = amount; });
	    };
	    // for aviation invoices, returns a list of flight movements by related invoice id
	    TransactionsController.prototype.getFlightMovementsByInvoiceId = function (invoiceId) {
	        var _this = this;
	        return this.flightMovementManagementService.findAllFlightMovementsListByAssociatedInvoiceId(invoiceId)
	            .then(function (listFlightMovements) { return _this.$scope.listFlightMovements = listFlightMovements; });
	    };
	    // for non-aviation invoices, returns associated line items by related invoice id
	    TransactionsController.prototype.getLineItemsByInvoiceId = function (invoiceId) {
	        var _this = this;
	        return this.invoicesService.getLineItemsByInvoiceId(invoiceId)
	            .then(function (lineItems) { return _this.$scope.lineItems = lineItems; });
	    };
	    // for unified-tax invoices
	    TransactionsController.prototype.getAircraftRegistrationByBillingLedgerId = function (invoiceId) {
	        var _this = this;
	        this.$scope.billingLedgedIdSelected = invoiceId;
	        return this.aircraftRegistrationService.getAircraftRegistrationByBillingLedgerId(invoiceId)
	            .then(function (listAircraftRegstration) { return _this.$scope.listAircraftRegstration = listAircraftRegstration; });
	    };
	    /**
	     * Edit override for transactions.
	     */
	    TransactionsController.prototype.editTransaction = function (item) {
	        _super.prototype.edit.call(this, item);
	        // force editable amounts to absolute value
	        this.$scope.editable.amount = Math.abs(item.amount);
	        this.$scope.editable.payment_amount = Math.abs(item.payment_amount);
	        this.$scope.listOfApprovals = item.transaction_approvals;
	        // define crud file upload file name to suppporting document name if exists
	        this.$scope.editable.document_filename = item.supporting_document_name;
	        // get all invoices related to transaction
	        this.$scope.getInvoicesByTransactionId(item.id);
	        // get all transaction payments related to transaction
	        this.$scope.getTransactionPaymentsByTransactionId(item.id);
	    };
	    /**
	     * Verify if any provided payment mechanisms are selected.
	     *
	     * @param mechanisms payment mechanisms to verify
	     */
	    TransactionsController.prototype.isPaymentMechanism = function (mechanisms) {
	        // mechanisms parameter is required, return false if not valid
	        if (!mechanisms) {
	            return false;
	        }
	        var mechanism = this.$scope.editable
	            ? this.$scope.editable.payment_mechanism : null;
	        return mechanisms.indexOf(mechanism) > -1;
	    };
	    /**
	     * Set editable transaction's bank account name, number, externalId from
	     * provided bank account object.
	     *
	     * @param bankAccount bank account info to use
	     */
	    TransactionsController.prototype.setEditableBankAccount = function (bankAccount) {
	        if (bankAccount) {
	            this.$scope.editable.bank_account_name = bankAccount.name;
	            this.$scope.editable.bank_account_number = bankAccount.number;
	            this.$scope.editable.bank_account_external_accounting_system_id = bankAccount.external_accounting_system_id;
	        }
	        else {
	            this.$scope.editable.bank_account_name = null;
	            this.$scope.editable.bank_account_number = null;
	            this.$scope.editable.bank_account_external_accounting_system_id = null;
	        }
	    };
	    /**
	     * On payment mechanism change event, updated editable transaction properties.
	     *
	     * @param editable editable transaction
	     */
	    TransactionsController.prototype.onPaymentMechanismChange = function (editable) {
	        // set payment reference number to 'N/A' if payment mechanism is cash or adjustment
	        editable.payment_reference_number = this.isPaymentMechanism(['adjustment', 'cash'])
	            ? 'N/A' : editable.payment_reference_number !== 'N/A' ? editable.payment_reference_number : null;
	        // on payment amount adjustment, updated amounts and currecy related properties
	        if (this.isPaymentMechanism(['adjustment'])) {
	            editable.amount = null;
	            editable.payment_amount = null;
	            editable.payment_currency = null;
	            editable.payment_exchange_rate = null;
	        }
	        // set file upload disbaled status based on payment mechanism
	        this.$scope.fileUploadDisabled = !(editable.transaction_type.name === 'credit');
	        // on payment mechanism other than cheque or wire, clear bank account and payment date
	        if (!this.isPaymentMechanism(['cheque', 'wire'])) {
	            editable.bank_account = null; // type <any> as bank_account is not an expected ITransaction property
	            editable.bank_account_name = null;
	            editable.bank_account_number = null;
	            editable.bank_account_external_accounting_system_id = null;
	            editable.payment_date = null;
	        }
	    };
	    /**
	     * On transaction type change event, updated editable transaction properties
	     *
	     * @param editable editable transaction
	     */
	    TransactionsController.prototype.onTransactionTypeChange = function (editable) {
	        // set payment reference number to 'N/A' if transaction type is 'debit' or
	        // transaction type is 'credit' and payment mechanism is 'adjustment' or 'cash'
	        editable.payment_reference_number = editable.transaction_type.name === 'debit' ||
	            editable.transaction_type.name === 'credit' && this.isPaymentMechanism(['adjustment', 'cash'])
	            ? 'N/A' : null;
	        editable.payment_mechanism = editable.transaction_type.name === 'debit' ? 'adjustment' : editable.payment_mechanism = "";
	        // set file upload disbaled status based on payment mechanism
	        //this.$scope.fileUploadDisabled = !(this.isPaymentMechanism(['adjustment']) && editable.transaction_type.name === 'credit');
	        //mod. a seguito richiesta LVPalocci
	        this.$scope.fileUploadDisabled = !(editable.transaction_type.name === 'credit');
	    };
	    /**
	     * Request and load bank acounts into scope.
	     */
	    TransactionsController.prototype.loadBankAccounts = function () {
	        var _this = this;
	        // get bank account support and define in scope
	        return this.bankAccountManagementService.getIsSupported()
	            .then(function (isSupported) { return _this.$scope.isBankAccountSupported = isSupported; });
	    };
	    /**
	     * Request and load catalogue service charges into scope.
	     */
	    TransactionsController.prototype.loadCatagolueCharges = function () {
	        var _this = this;
	        this.$scope.catalogueCharges = [];
	        return this.catalogueServiceChargeService.listAll().then(function (catalogue) {
	            catalogue.content.forEach(function (item) {
	                _this.$scope.catalogueCharges.push({
	                    description: item.description,
	                    external_accounting_system_identifier: item.external_accounting_system_identifier,
	                    external_charge_category: item.external_charge_category
	                });
	            });
	            _this.$scope.catalogueCharges.push({ description: 'All charges' });
	        });
	    };
	    /**
	     * Request and load currencies into scope.
	     */
	    TransactionsController.prototype.loadCurrencies = function () {
	        var _this = this;
	        // initially display all currencies until an account is selected
	        return this.currencyManagementService.listAll()
	            .then(function (data) {
	            _this.$scope.fullCurrencyList = data.content;
	            _this.$scope.currencyList = data.content;
	        });
	    };
	    /**
	     * Set export support for transaction credit note and payment types. Should be set on
	     * page load.
	     */
	    TransactionsController.prototype.loadExportSupport = function () {
	        var _this = this;
	        return this.transactionsService.exportSupport().then(function (response) {
	            _this.exportSupport = response;
	            _this.$scope.exportSupport = _this.exportSupport.credit_notes === true || _this.exportSupport.payments === true;
	        });
	    };
	    /**
	     * Request and load payment mechanisms into scope.
	     */
	    TransactionsController.prototype.loadPaymentMechanisms = function () {
	        var _this = this;
	        return this.transactionsService.getPaymentMechanismList()
	            .then(function (data) { return _this.$scope.paymentMechanisms = data; });
	    };
	    /**
	     * Initialize all data requests and trigger on load method.
	     */
	    TransactionsController.prototype.initialize = function () {
	        var _this = this;
	        return this.$q.all([
	            this.loadPaymentMechanisms(), this.loadCurrencies(), this.loadCatagolueCharges(),
	            this.loadExportSupport(), this.loadBankAccounts()
	        ]).then(function () { return _this.onLoad(); });
	    };
	    /**
	     * Called after all data requests have been loaded into the scope.
	     */
	    TransactionsController.prototype.onLoad = function () {
	        // if transactions was called from Invoices
	        if (this.$state.params.transaction) {
	            this.setTransactionFromInvoice(this.$state.params.transaction);
	        }
	    };
	    TransactionsController.prototype.disableCreateNote = function (charges) {
	        return !charges.length || (this.$scope.amountOwed === 0 && this.$scope.editable.transaction_type.name === 'credit') ||
	            (this.$scope.total > this.$scope.amountOwed && this.$scope.editable.transaction_type.name === 'credit') || this.$scope.isDisabledCreateNote;
	    };
	    return TransactionsController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.TransactionsController = TransactionsController;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var organization_constants_1 = __webpack_require__(57);
	var system_configuration_constants_1 = __webpack_require__(10);
	var ChargesAdjustmentType;
	(function (ChargesAdjustmentType) {
	    ChargesAdjustmentType[ChargesAdjustmentType["ALL_CHARGES"] = 'All charges'] = "ALL_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["ENROUTE_CHARGES"] = 'Enroute charges'] = "ENROUTE_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["LANDING_CHARGES"] = 'Landing charges'] = "LANDING_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["UNIFIED_TAX_CHARGES"] = 'Unified Tax'] = "UNIFIED_TAX_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["OTHER_CHARGES"] = 'Other charges'] = "OTHER_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["PARKING_CHARGES"] = 'Parking charges'] = "PARKING_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["PASSENGER_CHARGES"] = 'Passenger charges'] = "PASSENGER_CHARGES";
	    ChargesAdjustmentType[ChargesAdjustmentType["TASP_CHARGES"] = 'TASP charges'] = "TASP_CHARGES";
	})(ChargesAdjustmentType = exports.ChargesAdjustmentType || (exports.ChargesAdjustmentType = {}));
	var ChargeAdjustmentsService = (function () {
	    /** @ngInject */
	    ChargeAdjustmentsService.$inject = ["sysConfigBoolean", "systemConfigurationService", "caabSageChargeAdjustmentsService"];
	    function ChargeAdjustmentsService(sysConfigBoolean, systemConfigurationService, caabSageChargeAdjustmentsService) {
	        this.sysConfigBoolean = sysConfigBoolean;
	        this.systemConfigurationService = systemConfigurationService;
	        this.caabSageChargeAdjustmentsService = caabSageChargeAdjustmentsService;
	    }
	    /**
	     * Retreive iata aviation charges based on system configuration settings.
	     */
	    ChargeAdjustmentsService.prototype.iataChargeTypes = function () {
	        return [
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.ENROUTE_CHARGES) },
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.OTHER_CHARGES) },
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.ALL_CHARGES) }
	        ];
	    };
	    ChargeAdjustmentsService.prototype.unifiedTaxChargeTypes = function () {
	        return [
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.UNIFIED_TAX_CHARGES) }
	        ];
	    };
	    /**
	     * Retreive non iata aviation charges based on system configuration settings.
	     */
	    ChargeAdjustmentsService.prototype.nonIataChargeTypes = function () {
	        var charges = [
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.ENROUTE_CHARGES) },
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.LANDING_CHARGES) },
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.OTHER_CHARGES) },
	            { description: this.getChargesAdjustment(ChargesAdjustmentType.ALL_CHARGES) }
	        ];
	        if (this.getChargesAdjustmentSupport(ChargesAdjustmentType.TASP_CHARGES)) {
	            charges.splice(2, 0, { description: this.getChargesAdjustment(ChargesAdjustmentType.TASP_CHARGES) });
	        }
	        if (this.getChargesAdjustmentSupport(ChargesAdjustmentType.PASSENGER_CHARGES)) {
	            charges.splice(2, 0, { description: this.getChargesAdjustment(ChargesAdjustmentType.PASSENGER_CHARGES) });
	        }
	        if (this.getChargesAdjustmentSupport(ChargesAdjustmentType.PARKING_CHARGES)) {
	            charges.splice(2, 0, { description: this.getChargesAdjustment(ChargesAdjustmentType.PARKING_CHARGES) });
	        }
	        return charges;
	    };
	    /**
	     * Resolve flight adjustment external properties based on organization system settings.
	     *
	     * @param charge charge adjustment details
	     * @param flight flight movement being adjusted
	     */
	    ChargeAdjustmentsService.prototype.resolveFlightAdjustmentExternal = function (charge, flight, invoiceType) {
	        // only resolve if flight is not null
	        if (!charge || !flight) {
	            return;
	        }
	        // retrieve organization to resolve by different customizations
	        var organization = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION);
	        // perform necessary organization specific logic, no default implementation
	        if (organization_constants_1.OrganizationName.CAAB === organization) {
	            this.caabSageChargeAdjustmentsService.resolveFlightAdjustementExternal(charge, flight, invoiceType);
	        }
	    };
	    /**
	     * Get charge adjustment type value.
	     *
	     * @param type charge adjustment type
	     */
	    ChargeAdjustmentsService.prototype.getChargesAdjustment = function (type) {
	        // override tasp charge value based on system configuration setting
	        if (type === ChargesAdjustmentType.TASP_CHARGES) {
	            return this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.TASP_FEES_LABEL) + " charges";
	        }
	        else if (type === ChargesAdjustmentType.LANDING_CHARGES) {
	            return this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.APPROACH_FEES_LABEL) + " charges";
	        }
	        else {
	            return type;
	        }
	    };
	    /**
	     * Get charge adjustment type support based on system configuration settings.
	     *
	     * @param type charge adjustment type
	     */
	    ChargeAdjustmentsService.prototype.getChargesAdjustmentSupport = function (type) {
	        var support;
	        switch (type) {
	            case ChargesAdjustmentType.PARKING_CHARGES:
	                support = this.sysConfigBoolean.parse(this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_PARKING_CHARGES));
	                break;
	            case ChargesAdjustmentType.PASSENGER_CHARGES:
	                support = this.sysConfigBoolean.parse(this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.PASSENGER_CHARGES_SUPPORT));
	                break;
	            case ChargesAdjustmentType.TASP_CHARGES:
	                support = this.sysConfigBoolean.parse(this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_TASP_CHARGES));
	                break;
	            default:
	                support = true;
	        }
	        return support;
	    };
	    return ChargeAdjustmentsService;
	}());
	exports.ChargeAdjustmentsService = ChargeAdjustmentsService;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var AircraftRegistrationController = (function (_super) {
	    __extends(AircraftRegistrationController, _super);
	    /* @ngInject */
	    AircraftRegistrationController.$inject = ["$scope", "$rootScope", "flightMovementManagementService", "aircraftRegistrationService", "aircraftTypeManagementService", "systemConfigurationService", "$state", "$uibModal", "$translate", "customDate"];
	    function AircraftRegistrationController($scope, $rootScope, flightMovementManagementService, aircraftRegistrationService, aircraftTypeManagementService, systemConfigurationService, $state, $uibModal, $translate, customDate) {
	        var _this = 
	        // setup
	        _super.call(this, $scope, aircraftRegistrationService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.flightMovementManagementService = flightMovementManagementService;
	        _this.aircraftRegistrationService = aircraftRegistrationService;
	        _this.aircraftTypeManagementService = aircraftTypeManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$state = $state;
	        _this.$uibModal = $uibModal;
	        _this.$translate = $translate;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.organizationName = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION);
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.getAircraftTypeByLatestRegistrationNumber = function (registrationNumber) { return _this.getAircraftTypeByLatestRegistrationNumber(registrationNumber); };
	        $scope.getCountryByRegistrationNumberPrefix = function (prefix) { return _this.getCountryByRegistrationNumberPrefix(prefix); };
	        // functions
	        $scope.addDate = function (aircraft) { return _this.addDate(aircraft); }; // avoid using edit function to prevent table from automatically updating
	        $scope.convertMtowProperty = function (aircraft_type) { return $scope.editable.mtow_override = systemConfigurationService.convertMtowProperty(aircraft_type, 'maximum_takeoff_weight').maximum_takeoff_weight; };
	        $scope.create = function (aircraft, control, controlCoa) { return _this.createOverride(aircraft, control, controlCoa); };
	        $scope.edit = function (item) { _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(item, 'mtow_override')); };
	        $scope.setEditable = function (aircraft) { return _this.setEditable(aircraft); };
	        $scope.update = function (aircraft, control, controlCoa) { return _this.updateOverride(aircraft, control, controlCoa); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.setLocal = function (country) { return _this.setLocal(country); };
	        // matching
	        $scope.country = null;
	        $scope.countryMatch = false;
	        $scope.error = null;
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        _this.getFilterParameters();
	        // if country override field is modified, check if form is valid
	        $scope.$watch('editable.country_override', function () { return _this.handleOverrideError(); });
	        $scope.$watch('editable.country_of_registration', function () {
	            var country = _this.$scope.country;
	            // if a country is returned from the registration number and its name matches the country of registration
	            if (country && country.country_name === _this.$scope.editable.country_of_registration.country_name) {
	                _this.$scope.editable.country_override = false;
	                _this.$scope.countryMatch = true;
	            }
	            else {
	                _this.$scope.countryMatch = false;
	                _this.handleOverrideError();
	            }
	        });
	        return _this;
	    }
	    AircraftRegistrationController.prototype.reset = function () {
	        if (typeof this.$scope.control !== 'undefined') {
	            this.$scope.control.reset();
	            this.$scope.countryMatch = false;
	        }
	        if (this.$scope.control_coa) {
	            this.$scope.control_coa.reset();
	        }
	        _super.prototype.reset.call(this);
	    };
	    AircraftRegistrationController.prototype.createOverride = function (aircraft, control, controlCoa) {
	        var _this = this;
	        this.setDates(aircraft, control, controlCoa);
	        _super.prototype.create.call(this, aircraft).then(function (createdAircraft) {
	            if (_this.$state && _this.$state.params.after) {
	                _this.$state.go(_this.$state.params.after.create.goTo.state, {
	                    accountId: createdAircraft.account.id
	                });
	            }
	        });
	    };
	    AircraftRegistrationController.prototype.updateOverride = function (aircraft, control, controlCoa) {
	        this.setDates(aircraft, control, controlCoa);
	        _super.prototype.update.call(this, aircraft, aircraft.id);
	    };
	    AircraftRegistrationController.prototype.addDate = function (aircraftRegistration) {
	        if (aircraftRegistration.registration_start_date) {
	            var startDate = new Date(aircraftRegistration.registration_start_date);
	            this.$scope.control.setUTCStartDate(startDate);
	        }
	        if (aircraftRegistration.registration_expiry_date) {
	            var endDate = new Date(aircraftRegistration.registration_expiry_date);
	            this.$scope.control.setUTCEndDate(endDate);
	        }
	        if (aircraftRegistration.coa_issue_date && aircraftRegistration.coa_expiry_date) {
	            var coaStartDate = new Date(aircraftRegistration.coa_issue_date);
	            this.$scope.control_coa.setUTCStartDate(coaStartDate);
	            var coaEndDate = new Date(aircraftRegistration.coa_expiry_date);
	            this.$scope.control_coa.setUTCEndDate(coaEndDate);
	        }
	        else {
	            this.$scope.control_coa.reset();
	        }
	    };
	    // when a user chooses an entry to edit
	    AircraftRegistrationController.prototype.setEditable = function (aircraft) {
	        var _this = this;
	        // await API call for reg number to check for country match
	        this.aircraftRegistrationService.getCountryByRegistrationNumberPrefix(aircraft.registration_number).then(function (country) {
	            _this.$scope.countryMatch = true;
	            _this.$scope.country = country;
	        }).catch(function () {
	            _this.$scope.countryMatch = false;
	            _this.$scope.country = null;
	        }).finally(function () {
	            _this.$scope.edit(aircraft);
	            _this.$scope.addDate(aircraft);
	            _this.$scope.form.$setUntouched();
	        });
	    };
	    AircraftRegistrationController.prototype.getAircraftTypeByLatestRegistrationNumber = function (registrationNumber) {
	        var _this = this;
	        if (registrationNumber && registrationNumber.length >= 2) {
	            this.flightMovementManagementService.getAircraftTypeByLatestRegistrationNumber(registrationNumber).then(function (aircraftType) {
	                if (aircraftType) {
	                    _this.$scope.editable.aircraft_type = aircraftType; // update the aircraft type field
	                    _this.$scope.editable.mtow_override = aircraftType.maximum_takeoff_weight;
	                    _this.$scope.editable = _this.systemConfigurationService.convertMtowProperty(_this.$scope.editable, 'mtow_override');
	                }
	                else {
	                    _this.$scope.editable.aircraft_type = null;
	                    _this.$scope.editable.mtow_override = null;
	                }
	            });
	        }
	    };
	    // if not overridden, attempts to find a
	    // country by the registration number prefix
	    AircraftRegistrationController.prototype.getCountryByRegistrationNumberPrefix = function (prefix) {
	        var _this = this;
	        if (prefix && prefix.length >= 2 && !this.$scope.editable.country_override) {
	            this.aircraftRegistrationService.getCountryByRegistrationNumberPrefix(prefix).then(function (country) {
	                if (country) {
	                    _this.setLocal(country);
	                    _this.$scope.editable.country_of_registration = country;
	                    _this.$scope.countryMatch = true;
	                    _this.$scope.country = country;
	                }
	            }).catch(function () {
	                if (!_this.$scope.editable.country_override) {
	                    _this.$scope.editable.country_of_registration = null;
	                }
	                _this.$scope.countryMatch = false;
	                _this.$scope.country = null;
	            }).finally(function () {
	                _this.handleOverrideError();
	            });
	        }
	    };
	    AircraftRegistrationController.prototype.handleOverrideError = function () {
	        var _a = this.$scope, country = _a.country, countryMatch = _a.countryMatch, editable = _a.editable;
	        var registration_number = editable.registration_number, country_of_registration = editable.country_of_registration, country_override = editable.country_override;
	        // if country is overriden or there is a country match
	        if (country_override || (country && countryMatch)) {
	            this.$scope.error = null;
	            // if no country match or override but the user has entered in registration number and country
	        }
	        else if (registration_number && country_of_registration && country_of_registration.id) {
	            this.$scope.error = {
	                error: {
	                    data: {
	                        error: this.$translate.instant('Override country of registration'),
	                        error_description: this.$translate.instant('Registration number and country of registration match error. Override country of registration to continue.'),
	                        field_errors: null
	                    }
	                }
	            };
	        }
	    };
	    AircraftRegistrationController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AircraftRegistrationController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AircraftRegistrationController.prototype.setDates = function (aircraft, control, controlCoa) {
	        aircraft.registration_start_date = control.getUTCStartDate();
	        aircraft.registration_expiry_date = control.getUTCEndDate();
	        aircraft.coa_issue_date = controlCoa.getUTCStartDate();
	        aircraft.coa_expiry_date = controlCoa.getUTCEndDate();
	    };
	    AircraftRegistrationController.prototype.setLocal = function (country) {
	        var countryANSP = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_COUNTRY_CODE);
	        this.$scope.editable.is_local = country.country_code === countryANSP;
	    };
	    return AircraftRegistrationController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.AircraftRegistrationController = AircraftRegistrationController;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var CurrencyManagementController = (function (_super) {
	    __extends(CurrencyManagementController, _super);
	    /* @ngInject */
	    CurrencyManagementController.$inject = ["$scope", "$rootScope", "currencyManagementService", "currencyExchangeRatesService", "accountsService", "systemConfigurationService", "userEventLogService", "customDate"];
	    function CurrencyManagementController($scope, $rootScope, currencyManagementService, currencyExchangeRatesService, accountsService, systemConfigurationService, userEventLogService, customDate) {
	        var _this = 
	        // setup
	        _super.call(this, $scope, currencyManagementService) || this;
	        _this.$scope = $scope;
	        _this.currencyManagementService = currencyManagementService;
	        _this.currencyExchangeRatesService = currencyExchangeRatesService;
	        _this.accountsService = accountsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.userEventLogService = userEventLogService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        currencyExchangeRatesService.listAll().then(function (rates) { return _this.$scope.allExchangeRates = rates; }); // get all exchange rates
	        _this.$rootScope = $rootScope;
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.$watchGroup(['currencyFilter', 'textSearch'], function () { return _this.getFilterParameters(); });
	        // functions
	        $scope.reset = function () { return _this.reset(); };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.updateFromWeb = function () { return _this.updateFromWeb(); }; // updates currency list, with new exchange rates from the web
	        $scope.updateDisplay = function (id) { return currencyExchangeRatesService.listAll().then(function (rates) {
	            return _this.$scope.allExchangeRates = rates;
	        }).then(function () { return _this.displayCurrencyRate(id); }); };
	        $scope.getExchangeRates = function (currencyId, queryString) {
	            currencyExchangeRatesService.getAllExchangeRatesByCurrencyId(currencyId, queryString)
	                .then(function (data) { return $scope.exchangeRates = data; });
	        };
	        $scope.addExchangeRate = function (currencyId, exchangeRate, startDate, endDate) {
	            return _this.addExchangeRate(currencyId, exchangeRate, startDate, endDate);
	        };
	        $scope.updateExchangeRate = function (exchangeRate, startDate, endDate) {
	            return _this.updateExchangeRate(exchangeRate, startDate, endDate);
	        };
	        $scope.deleteExchangeRate = function (exchangeRate) { return _this.deleteExchangeRate(exchangeRate); };
	        $scope.editExchangeRate = function (exchangeRate) { return _this.editExchangeRate(exchangeRate); };
	        $scope.resetExchangeRate = function () { return _this.resetExchangeRate(); };
	        $scope.getActiveCurrencyList = function () { return _this.getActiveCurrencyList(); };
	        $scope.inverseExchange = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE);
	        // ansp currency
	        $scope.anspCurrency = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        $scope.isAnspCurrency = false;
	        // set scope value for require external system identifier
	        $scope.requireExternalSystemId = _this.requireExternalSystemId();
	        $scope.canDeleteOrDeactivateCurrency = function () { return _this.canDeleteOrDeactivateCurrency(); };
	        return _this;
	        // $scope.saveOldValue = () => {
	        //  salva il valore precedente
	        //  $rootScope.oldFormData = angular.copy($scope.editable);
	        //  
	        // }
	    }
	    CurrencyManagementController.prototype.edit = function (currency) {
	        this.$scope.editable = angular.copy(currency);
	        console.log("EDIT ACCOUNT ");
	        this.$rootScope.oldFormData = angular.copy(this.$scope.editable);
	        this.resetExchangeRate();
	        this.loadCurrencyInfo();
	    };
	    /**
	     * We need to override this, because we really need the list of all currencies, not just the first page.
	     * We need it to resolve currency IDs to currency codes.
	     */
	    CurrencyManagementController.prototype.list = function (data, queryString) {
	        var _this = this;
	        if (data === void 0) { data = {}; }
	        if (queryString === void 0) { queryString = ''; }
	        var filterKey = 'filter';
	        var textSearchKey = 'textSearch';
	        data = (data || {});
	        data[filterKey] = this.$scope.currencyFilter || 'active';
	        data[textSearchKey] = this.$scope.textSearch;
	        return _super.prototype.list.call(this, data, queryString).then(function () {
	            // load all currencies into a separate list after loading the current page
	            _this.loadAllCurrencies();
	        });
	    };
	    CurrencyManagementController.prototype.reset = function () {
	        this.resetExchangeRate();
	        _super.prototype.reset.call(this);
	        this.$scope.isAnspCurrency = false;
	        this.$scope.currencyInfo = null;
	    };
	    CurrencyManagementController.prototype.displayCurrencyRate = function (currencyId) {
	        if (this.$scope.allExchangeRates) {
	            for (var _i = 0, _a = this.$scope.allExchangeRates; _i < _a.length; _i++) {
	                var rate = _a[_i];
	                if (currencyId === rate.currency.id) {
	                    return this.toUSDInverse(rate.exchange_rate);
	                }
	            }
	        }
	        return null;
	    };
	    CurrencyManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            filter: this.$scope.currencyFilter,
	            textSearch: this.$scope.textSearch,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    CurrencyManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    CurrencyManagementController.prototype.resetExchangeRate = function () {
	        this.$scope.exchangeRate = {
	            id: null,
	            currency: {
	                id: null
	            },
	            currency_code: null,
	            exchange_rate: null,
	            exchange_rate_valid_from_date: null,
	            exchange_rate_valid_to_date: null,
	            target_currency: {
	                id: this.$scope.editable ? this.$scope.editable.exchange_rate_target_currency_id : null
	            }
	        };
	        if (typeof this.$scope.control !== 'undefined') {
	            this.$scope.control.reset();
	            this.editExchangeRate(this.$scope.exchangeRate);
	        }
	    };
	    // exchange rate related methods that update the UI
	    CurrencyManagementController.prototype.editExchangeRate = function (rate) {
	        this.$scope.exchangeRate = angular.copy(rate);
	        this.$scope.exchangeRate.exchange_rate = this.toUSDInverse(rate.exchange_rate);
	        var targetCurrencyId = this.$scope.exchangeRate.target_currency.id;
	        this.$scope.exchangeRate.target_currency = this.$scope.currencyList.find(function (element) { return element.id === targetCurrencyId; });
	        if (rate.exchange_rate_valid_from_date) {
	            this.$scope.control.setUTCStartDate(new Date(rate.exchange_rate_valid_from_date));
	        }
	        if (rate.exchange_rate_valid_to_date) {
	            this.$scope.control.setUTCEndDate(new Date(rate.exchange_rate_valid_to_date));
	        }
	    };
	    CurrencyManagementController.prototype.addExchangeRate = function (currencyId, exchangeRate, startDate, endDate) {
	        var _this = this;
	        exchangeRate.currency.id = currencyId;
	        exchangeRate.exchange_rate_valid_from_date = startDate;
	        exchangeRate.exchange_rate_valid_to_date = endDate;
	        exchangeRate.exchange_rate = this.toUSDInverse(exchangeRate.exchange_rate);
	        this.currencyExchangeRatesService.create(exchangeRate)
	            .then(function () {
	            _this.$scope.getExchangeRates(currencyId);
	            _this.$scope.updateDisplay(currencyId);
	            _this.resetExchangeRate();
	        }, function (error) { return _this.setErrorResponse(error); });
	    };
	    CurrencyManagementController.prototype.updateExchangeRate = function (exchangeRate, startDate, endDate) {
	        var _this = this;
	        exchangeRate.exchange_rate_valid_from_date = startDate;
	        exchangeRate.exchange_rate_valid_to_date = endDate;
	        exchangeRate.exchange_rate = this.toUSDInverse(exchangeRate.exchange_rate);
	        this.currencyExchangeRatesService.update(exchangeRate, exchangeRate.id)
	            .then(function () {
	            _this.$scope.getExchangeRates(exchangeRate.currency.id);
	            _this.$scope.updateDisplay(exchangeRate.currency.id);
	            _this.resetExchangeRate();
	        }, function (error) { return _this.setErrorResponse(error); });
	    };
	    CurrencyManagementController.prototype.deleteExchangeRate = function (exchangeRate) {
	        var _this = this;
	        this.currencyExchangeRatesService.delete(exchangeRate.id)
	            .then(function () { return _this.$scope.getExchangeRates(exchangeRate.currency.id); }, function (error) { return _this.setErrorResponse(error); })
	            .then(function () { return _this.$scope.updateDisplay(exchangeRate.currency.id); }, function (error) { return _this.setErrorResponse(error); })
	            .then(function () { return _this.resetExchangeRate(); });
	    };
	    // makes api call to tell server to update currencies
	    CurrencyManagementController.prototype.updateFromWeb = function () {
	        var _this = this;
	        this.currencyExchangeRatesService.updateFromWeb()
	            .then(function () { return _this.currencyExchangeRatesService.listAll(); })
	            .then(function (rates) { return _this.$scope.allExchangeRates = rates; })
	            .then(function () { return _this.$scope.reset(); })
	            .catch(function (error) { return _this.setErrorResponse(error); });
	    };
	    /**
	     * Get required external system id flag from system configuration.
	     *
	     * @returns boolean true if required
	     */
	    CurrencyManagementController.prototype.requireExternalSystemId = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_CURRENCY_EXTERNAL_SYSTEM_ID);
	    };
	    /**
	     * Return inverse exchange rate
	     * if inverseExchange parameter set
	     * to true in system configuration
	     *
	     * @returns number
	     */
	    CurrencyManagementController.prototype.toUSDInverse = function (rate) {
	        if (this.$scope.inverseExchange) {
	            rate = 1 / rate;
	        }
	        return rate;
	    };
	    /**
	     * Return the list of active currencies
	     */
	    CurrencyManagementController.prototype.getActiveCurrencyList = function () {
	        return this.$scope.currencyList ?
	            this.$scope.currencyList.filter(function (currency) { return currency && currency.active; }) :
	            [];
	    };
	    /**
	     * Load all currencies -- we need that to manage the drop-down list of exchange target currencies
	     */
	    CurrencyManagementController.prototype.loadAllCurrencies = function () {
	        var _this = this;
	        this.currencyManagementService.listAll()
	            .then(function (resp) { return _this.$scope.currencyList = resp.content; }, function (error) { return _this.setErrorResponse(error); });
	    };
	    /**
	     * Load the extra info for the selected currency record
	     */
	    CurrencyManagementController.prototype.loadCurrencyInfo = function () {
	        var _this = this;
	        this.$scope.isAnspCurrency = false;
	        this.$scope.currencyInfo = null;
	        if (this.$scope.editable && this.$scope.editable.id) {
	            this.$scope.isAnspCurrency = this.$scope.editable.currency_code === this.$scope.anspCurrency;
	            this.currencyManagementService.getCurrencyInfo(this.$scope.editable.id)
	                .then(function (currencyInfo) {
	                if (_this.$scope.editable && currencyInfo && _this.$scope.editable.id === currencyInfo.currency_id) {
	                    _this.$scope.currencyInfo = currencyInfo;
	                }
	            });
	        }
	    };
	    /**
	     * Return true if current record can be deleted
	     */
	    CurrencyManagementController.prototype.canDeleteOrDeactivateCurrency = function () {
	        // if there's another currency that uses this currency as a target: return false
	        if (this.$scope.currencyInfo && this.$scope.currencyInfo.used_as_exchange_target_by_another_active_currency) {
	            return false;
	        }
	        // if there are accounts that reference this currency: return false
	        if (this.$scope.currencyInfo && this.$scope.currencyInfo.ref_accounts.length) {
	            return false;
	        }
	        // if this is an ANSP currency
	        if (this.$scope.isAnspCurrency) {
	            return false;
	        }
	        // allow deletion by default
	        return true;
	    };
	    return CurrencyManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CurrencyManagementController = CurrencyManagementController;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var AccountsController = (function (_super) {
	    __extends(AccountsController, _super);
	    /* @ngInject */
	    AccountsController.$inject = ["$scope", "$rootScope", "$state", "accountsService", "usersService", "systemConfigurationService", "$timeout", "$translate", "accountExternalChargeCategoryService", "typesService", "$uibModal", "currencyManagementService", "$filter"];
	    function AccountsController($scope, $rootScope, $state, accountsService, usersService, systemConfigurationService, $timeout, $translate, accountExternalChargeCategoryService, typesService, $uibModal, currencyManagementService, $filter) {
	        var _this = 
	        // setup
	        _super.call(this, $scope, accountsService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.$rootScope = $rootScope;
	        _this.$state = $state;
	        _this.accountsService = accountsService;
	        _this.usersService = usersService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$translate = $translate;
	        _this.accountExternalChargeCategoryService = accountExternalChargeCategoryService;
	        _this.typesService = typesService;
	        _this.$uibModal = $uibModal;
	        _this.currencyManagementService = currencyManagementService;
	        _this.$filter = $filter;
	        _this.EMAIL = 'Email';
	        _this.SMS = 'SMS text message';
	        _super.prototype.setup.call(_this, { refresh: false });
	        _super.prototype.list.call(_this, {}, "filter=true&cash=false");
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.setAccountType = function () { return _this.setAccountType(); };
	        $scope.$watch('filter', function () { return _this.getFilterParameters(); });
	        $scope.whitelistingEnabled = localStorage_service_1.LocalStorageService.getBooleanFromValueByName("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.WL_ENABLED);
	        _this.currencyManagementService.getByCurrencyCode('USD').then(function (currency) {
	            $scope.usdCurrency = _this.$scope.editable.invoice_currency = currency;
	        });
	        _this.typesService.listAll().then(function (types) {
	            _this.$scope.generalAviation = types.find(function (element) { return element.name === 'GeneralAviation'; });
	            _this.$scope.airline = types.find(function (element) { return element.name === 'Airline'; });
	            _this.setDefaultFields();
	        });
	        // if account was called from Invoices
	        if ($state.params.accountId) {
	            $timeout(function () { _this.$scope.toggle = true; });
	            accountsService.listAllWithCash().then(function (data) { return _this.findAccount(data.content, $state.params.accountId); });
	        }
	        // if account is created via accounts interface, cash_account is set to false,
	        // if account is created via point-of-sale interface, cash_account is set to true
	        $scope.$on('$locationChangeStart', function (event, current, previous) {
	            if (previous.includes('/invoice-generation/')) {
	                $scope.editable.cash_account = true;
	            }
	        });
	        $scope.notificationsTypeList = [{ id: 1, name: $translate.instant(_this.EMAIL), value: _this.EMAIL }, { id: 2, name: $translate.instant(_this.SMS), value: _this.SMS }];
	        $scope.listOfFormats = [{ "id": 1, "value": "pdf" }, { "id": 2, "value": "xlsx" }];
	        $scope.selectedFormatList = [];
	        $scope.notificationsList = [];
	        $scope.editable.list_of_events_account_notified = [];
	        _this.$scope.accountCreated = null;
	        _this.$scope.accountUpdated = null;
	        _this.$scope.accountDeleted = null;
	        $scope.updateFormatMultiselect = function () {
	            if ($scope.editable.invoice_delivery_format) {
	                $scope.selectedFormatList = $scope.listOfFormats.filter(function (format) { return ($scope.editable.invoice_delivery_format) ? $scope.editable.invoice_delivery_format.split(',').indexOf(format.value) > -1 : []; });
	            }
	            else {
	                $scope.selectedAirportsDeparture = [];
	            }
	            ;
	        };
	        accountsService.getCustomerNotifications().then(function (data) {
	            data.forEach(function (element) {
	                $scope.notificationsList.push({ id: element[0], name: element[1], model: [] });
	                _this.setListOfEventsAccountNotified(element[0], false, false);
	                $scope.emptyAccountEventList = $scope.editable.list_of_events_account_notified;
	            });
	        });
	        $scope.selfCareUserList = [];
	        usersService.listAll().then(function (users) {
	            users.content.forEach(function (user) {
	                if (user.is_selfcare_user && user.registration_status) {
	                    $scope.selfCareUserList.push(user);
	                }
	            });
	        });
	        $scope.addFormatToList = function () {
	            _this.$scope.editable.invoice_delivery_format = _this.addToList(_this.$scope.selectedFormatList, 'value');
	        };
	        // $scope.addNotificationsToList = () => this.addNotificationsToList();
	        $scope.getAviationInfo = function () { return _this.getAviationInfo(); };
	        $scope.getAllNotifications = function () { return _this.getAllNotifications(); };
	        $scope.setEmpty = function () { return _this.setEmpty(); };
	        $scope.setEmptyFormatList = function () { return _this.setEmptyFormatList(); };
	        $scope.setCreditLimitRange = function () { return _this.setCreditLimitRange(); };
	        $scope.setDefaultCreditLimit = function () { return _this.setDefaultCreditLimit(); };
	        // set scope value for require external system identifier
	        $scope.requireExternalSystemId = _this.requireExternalSystemId();
	        $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        $scope.editOverride = function (item) { return _this.editOverride(item); };
	        $scope.editExternal = function (item) { return _this.editExternal(item); };
	        $scope.createExternal = function (item) { return _this.createExternal(item); };
	        $scope.updateExternal = function (item, id) { return _this.updateExternal(item, id); };
	        $scope.deleteExternal = function (id) { return _this.deleteExternal(id); };
	        $scope.resetExternal = function () { return _this.resetExternal(); };
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        $scope.activeNotificationUpdated = function () { return _this.activeNotificationUpdated(); };
	        $scope.deleteOverride = function (id) { return _this.deleteOverride(id); };
	        $scope.changeDefaultParametersForAccountType = function () { return _this.changeDefaultParametersForAccountType(); };
	        return _this;
	    }
	    AccountsController.prototype.create = function (account) {
	        var _this = this;
	        return _super.prototype.create.call(this, account).then(function (createdAccount) {
	            if (_this.$state && _this.$state.params.after) {
	                _this.$state.go(_this.$state.params.after.create.goTo.state, {
	                    accountId: createdAccount.id
	                });
	            }
	            _this.$scope.accountCreated = true;
	        });
	    };
	    AccountsController.prototype.deleteOverride = function (id) {
	        var _this = this;
	        _super.prototype.delete.call(this, id).then(function () { return _this.$scope.accountDeleted = true; });
	    };
	    AccountsController.prototype.reset = function () {
	        this.$scope.resetPass = {}; // to reset pass2
	        _super.prototype.reset.call(this);
	        this.resetExternal();
	        this.setDefaultFields();
	    };
	    AccountsController.prototype.setDefaultFields = function () {
	        var _this = this;
	        this.setAccountType();
	        this.$scope.$watch('editable.account_type.name', function (accountTypeName) {
	            if (accountTypeName === 'GeneralAviation') {
	                _this.$scope.editable.payment_terms = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_PAYMENT_TERMS);
	                _this.$scope.editable.monthly_overdue_penalty_rate = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MONTHLY_PENALTY);
	                _this.$scope.editable.aircraft_parking_exemption = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_PARKING_EXEMPTION);
	                _this.$scope.editable.credit_limit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT);
	                _this.$scope.editable.maximum_amount_credit_note = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE);
	                _this.$scope.editable.minimum_amount_credit_note = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE);
	            }
	            if (accountTypeName === 'Airline') {
	                _this.$scope.editable.payment_terms = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_PAYMENT_TERMS);
	                _this.$scope.editable.monthly_overdue_penalty_rate = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MONTHLY_PENALTY);
	                _this.$scope.editable.aircraft_parking_exemption = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_PARKING_EXEMPTION);
	                _this.$scope.editable.credit_limit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_CREDIT_LIMIT);
	                _this.$scope.editable.maximum_amount_credit_note = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE);
	                _this.$scope.editable.minimum_amount_credit_note = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE);
	            }
	            if (accountTypeName === 'UnifiedTax') {
	                _this.$scope.editable.payment_terms = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_PAYMENT_TERMS);
	                _this.$scope.editable.monthly_overdue_penalty_rate = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MONTHLY_PENALTY);
	                _this.$scope.editable.aircraft_parking_exemption = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_PARKING_EXEMPTION);
	                _this.$scope.editable.credit_limit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_CREDIT_LIMIT);
	                _this.$scope.editable.maximum_amount_credit_note = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE);
	                _this.$scope.editable.minimum_amount_credit_note = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE);
	            }
	        });
	        this.$scope.anspCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        this.$scope.editable.invoice_delivery_format = 'pdf';
	        this.$scope.editable.invoice_delivery_method = 'email';
	        if (this.$scope.usdCurrency) {
	            this.$scope.editable.invoice_currency = this.$scope.usdCurrency;
	        }
	    };
	    AccountsController.prototype.setCreditLimitRange = function () {
	        if (this.$scope.editable.cash_account === true) {
	            this.$scope.minCreditLimit = 0;
	            this.$scope.maxCreditLimit = 0;
	        }
	        else {
	            this.$scope.minCreditLimit = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE);
	            this.$scope.maxCreditLimit = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE);
	        }
	    };
	    AccountsController.prototype.setDefaultCreditLimit = function () {
	        var _this = this;
	        if (this.$scope.editable.cash_account === true) {
	            this.$scope.minCreditLimit = 0;
	            this.$scope.maxCreditLimit = 0;
	            this.$scope.editable.credit_limit = 0;
	            this.$scope.editable.minimum_amount_credit_note = 0;
	            this.$scope.editable.maximum_amount_credit_note = 0;
	        }
	        else {
	            this.$scope.$watch('editable.account_type.name', function (accountTypeName) {
	                if (accountTypeName === 'GeneralAviation') {
	                    _this.$scope.minCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE);
	                    _this.$scope.maxCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE);
	                    _this.$scope.editable.maximum_amount_credit_note = _this.$scope.maxCreditLimit;
	                    _this.$scope.editable.minimum_amount_credit_note = _this.$scope.minCreditLimit;
	                    _this.$scope.editable.credit_limit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT);
	                }
	            });
	        }
	    };
	    AccountsController.prototype.changeDefaultParametersForAccountType = function () {
	        var _this = this;
	        var accountConfigMap = {
	            'Airline': {
	                maximum_amount_credit_note: system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE,
	                minimum_amount_credit_note: system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE,
	                credit_limit: system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_CREDIT_LIMIT,
	                payment_terms: system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_PAYMENT_TERMS,
	                monthly_overdue_penalty_rate: system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MONTHLY_PENALTY,
	                aircraft_parking_exemption: system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_PARKING_EXEMPTION,
	            },
	            'Unified Tax': {
	                maximum_amount_credit_note: system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE,
	                minimum_amount_credit_note: system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE,
	                credit_limit: system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_CREDIT_LIMIT,
	                payment_terms: system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_PAYMENT_TERMS,
	                monthly_overdue_penalty_rate: system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MONTHLY_PENALTY,
	                aircraft_parking_exemption: system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_PARKING_EXEMPTION,
	            },
	            'General Aviation': {
	                maximum_amount_credit_note: system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE,
	                minimum_amount_credit_note: system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE,
	                credit_limit: system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT,
	                payment_terms: system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_PAYMENT_TERMS,
	                monthly_overdue_penalty_rate: system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MONTHLY_PENALTY,
	                aircraft_parking_exemption: system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_PARKING_EXEMPTION,
	            }
	        };
	        var accountType = this.$scope.editable.account_type.name;
	        var config = accountConfigMap[accountType] || accountConfigMap['General Aviation'];
	        Object.keys(config).forEach(function (key) {
	            _this.$scope.editable[key] = _this.systemConfigurationService.getValueByName(config[key]);
	        });
	    };
	    AccountsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            filter: this.$scope.filter,
	            cash: this.$scope.accountTypeFilter,
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            selfCareAccounts: this.$scope.selfCareAccounts,
	            nationality: this.$scope.nationality
	        };
	    };
	    AccountsController.prototype.refreshOverride = function () {
	        var request;
	        this.getFilterParameters();
	        switch (this.$scope.accountFilter) {
	            case 'outstanding':
	            case 'overdue':
	                this.$scope.filterParameters.invoices = this.$scope.accountFilter;
	                this.$scope.accFilter = angular.copy(this.$scope.filterParameters); // used as a param for the export directive
	                break;
	            case 'credit-limit':
	                this.$scope.filterParameters.credit = true;
	                this.$scope.accFilter = angular.copy(this.$scope.filterParameters);
	                break;
	            case '':
	                this.$scope.accFilter = angular.copy(this.$scope.filterParameters);
	                this.$scope.accFilter.credit = '';
	                this.$scope.accFilter.invoices = '';
	        }
	        request = _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	        return request;
	    };
	    // returns the selected account from Invoices
	    AccountsController.prototype.findAccount = function (accountList, params) {
	        for (var i = 0; i < accountList.length; i++) {
	            if (accountList[i].id === parseInt(params, 10)) {
	                this.$scope.editable = accountList[i];
	                break;
	            }
	        }
	    };
	    AccountsController.prototype.getAviationInfo = function () {
	        this.$scope.editable.non_aviation_billing_contact_person_name = this.$scope.editable.aviation_billing_contact_person_name;
	        this.$scope.editable.non_aviation_billing_phone_number = this.$scope.editable.aviation_billing_phone_number;
	        this.$scope.editable.non_aviation_billing_mailing_address = this.$scope.editable.aviation_billing_mailing_address;
	        this.$scope.editable.non_aviation_billing_email_address = this.$scope.editable.aviation_billing_email_address;
	    };
	    AccountsController.prototype.getAllNotifications = function () {
	        var _this = this;
	        this.setEmpty();
	        if (this.$scope.editable.list_of_events_account_notified !== null && this.$scope.editable.list_of_events_account_notified.length > 0) {
	            this.$scope.notificationsList.forEach(function (element) {
	                element.model = [];
	                var event = _this.$scope.editable.list_of_events_account_notified.filter(function (item) { return (item.notification_event_type === element.id); });
	                if (event[0].notification_email) {
	                    element.model.push({ id: 1, name: _this.EMAIL, value: _this.EMAIL });
	                }
	                if (event[0].notification_sms) {
	                    element.model.push({ id: 2, name: _this.SMS, value: _this.SMS });
	                }
	            });
	        }
	        else {
	            this.$scope.editable.list_of_events_account_notified = this.$scope.emptyAccountEventList;
	        }
	    };
	    //to decide private addNotificationsToList(): void {
	    //   this.$scope.editable.list_of_events_account_notified = [];
	    //   this.$scope.notificationsList.forEach((element: INotificationList) => {
	    //     let email = false;
	    //     let sms = false;
	    //     if (element.model.length > 0) {
	    //       element.model.forEach((el: IStaticType) => {
	    //         if (el.name.includes(this.SMS)) {
	    //           sms = true;
	    //         }
	    //         if (el.name.includes(this.EMAIL)) {
	    //           email = true;
	    //         }
	    //       });
	    //     }
	    //     this.setListOfEventsAccountNotified(element.id, email, sms);
	    //   });
	    // }
	    AccountsController.prototype.setListOfEventsAccountNotified = function (notificationId, notificationEmail, notificationSms) {
	        this.$scope.editable.list_of_events_account_notified.push({
	            notification_event_type: notificationId,
	            notification_email: notificationEmail,
	            notification_sms: notificationSms
	        });
	    };
	    AccountsController.prototype.setEmpty = function () {
	        this.$scope.notificationsList.forEach(function (element) {
	            element.model = [];
	        });
	    };
	    AccountsController.prototype.setEmptyFormatList = function () {
	        this.$scope.selectedFormatList = [];
	    };
	    AccountsController.prototype.activeNotificationUpdated = function () {
	        this.$scope.accountUpdated = true;
	    };
	    /**
	     * Get required external system id flag from system configuration.
	     *
	     * @returns boolean true if required
	     */
	    AccountsController.prototype.requireExternalSystemId = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_ACCOUNT_EXTERNAL_SYSTEM_ID);
	    };
	    AccountsController.prototype.editOverride = function (item) {
	        var _this = this;
	        _super.prototype.edit.call(this, item);
	        this.resetExternal();
	        this.$scope.whitelistLastActivityDateTime = this.$filter('dateConverter')(item.whitelist_last_activity_date_time, 'HH:mm');
	        this.$scope.whitelistState = this.$translate.instant(item.whitelist_state.toLowerCase());
	        this.$scope.editableExternal.account = item;
	        console.log(this.$scope.editableExternal.account);
	        this.getDefaultCreditLimit();
	        this.accountExternalChargeCategoryService.getByAccountId(item.id)
	            .then(function (response) { return _this.$scope.listExternal = response; });
	    };
	    AccountsController.prototype.getDefaultCreditLimit = function () {
	        var _this = this;
	        this.$scope.$watch('editable.account_type.name', function (accountTypeName) {
	            if (accountTypeName === 'GeneralAviation') {
	                _this.$scope.minCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE);
	                _this.$scope.maxCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE);
	                _this.$scope.editable.maximum_amount_credit_note = _this.$scope.maxCreditLimit;
	                _this.$scope.editable.minimum_amount_credit_note = _this.$scope.minCreditLimit;
	            }
	            if (accountTypeName === 'Airline') {
	                _this.$scope.minCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE);
	                _this.$scope.maxCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE);
	                _this.$scope.editable.maximum_amount_credit_note = _this.$scope.maxCreditLimit;
	                _this.$scope.editable.minimum_amount_credit_note = _this.$scope.minCreditLimit;
	            }
	            if (accountTypeName === 'UnifiedTax') {
	                _this.$scope.minCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE);
	                _this.$scope.maxCreditLimit = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE);
	                _this.$scope.editable.maximum_amount_credit_note = _this.$scope.maxCreditLimit;
	                _this.$scope.editable.minimum_amount_credit_note = _this.$scope.minCreditLimit;
	            }
	        });
	    };
	    AccountsController.prototype.editExternal = function (item) {
	        this.$scope.error = null;
	        this.$scope.editableExternal = angular.copy(item);
	    };
	    AccountsController.prototype.createExternal = function (item) {
	        var _this = this;
	        return this.accountExternalChargeCategoryService.create(item)
	            .then(function (newObject) { return _this.resetExternal(); }, function (error) { return _this.setErrorResponse(error); });
	    };
	    AccountsController.prototype.updateExternal = function (item, id) {
	        var _this = this;
	        return this.accountExternalChargeCategoryService.update(item, id)
	            .then(function () { return _this.resetExternal(); }, function (error) { return _this.setErrorResponse(error); });
	    };
	    AccountsController.prototype.deleteExternal = function (id) {
	        var _this = this;
	        return this.accountExternalChargeCategoryService.delete(id)
	            .then(function () { return _this.resetExternal(); }, function (error) { return _this.setErrorResponse(error); });
	    };
	    AccountsController.prototype.refreshExternal = function () {
	        var _this = this;
	        if (this.$scope.editable !== null && this.$scope.editable.id !== null) {
	            this.accountExternalChargeCategoryService.getByAccountId(this.$scope.editable.id)
	                .then(function (response) { return _this.$scope.listExternal = response; });
	        }
	        else {
	            this.$scope.listExternal = null;
	        }
	    };
	    AccountsController.prototype.resetExternal = function () {
	        this.$scope.error = null;
	        this.$scope.editableExternal = angular.copy(this.accountExternalChargeCategoryService.modelOverride);
	        this.$scope.editableExternal.account = this.$scope.editable !== null && this.$scope.editable.id !== null ? this.$scope.editable : null;
	        this.$scope.whitelistLastActivityDateTime = null;
	        this.$scope.whitelistState = null;
	        this.$scope.whitelistInactivityNoticeSent = null;
	        this.$scope.whitelistExpiryNoticeSent = null;
	        this.refreshExternal();
	        if (this.$scope.formExternal) {
	            this.$scope.formExternal.$setUntouched();
	        }
	    };
	    AccountsController.prototype.setAccountType = function () {
	        if (this.$scope.editable.icao_code && this.$scope.airline) {
	            this.$scope.editable.account_type = this.$scope.airline;
	        }
	        else if (!this.$scope.editable.icao_code && this.$scope.generalAviation) {
	            this.$scope.editable.account_type = this.$scope.generalAviation;
	        }
	    };
	    AccountsController.prototype.addToList = function (model, prop) {
	        var items = null;
	        var neededProp = null;
	        if (model.length > 0) {
	            items = model.map(function (item) {
	                Object.getOwnPropertyNames(item).forEach(function (val, idx, array) {
	                    if (val === prop) {
	                        neededProp = item[val];
	                    }
	                });
	                return neededProp;
	            }).join(',');
	        }
	        return items;
	    };
	    return AccountsController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.AccountsController = AccountsController;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AerodromeCategoryManagementController = (function (_super) {
	    __extends(AerodromeCategoryManagementController, _super);
	    /* @ngInject */
	    AerodromeCategoryManagementController.$inject = ["$scope", "$rootScope", "aerodromeCategoryManagementService"];
	    function AerodromeCategoryManagementController($scope, $rootScope, aerodromeCategoryManagementService) {
	        var _this = _super.call(this, $scope, aerodromeCategoryManagementService) || this;
	        _this.$scope = $scope;
	        _this.aerodromeCategoryManagementService = aerodromeCategoryManagementService;
	        _super.prototype.setup.call(_this);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    AerodromeCategoryManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AerodromeCategoryManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return AerodromeCategoryManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AerodromeCategoryManagementController = AerodromeCategoryManagementController;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var aerodromes_constants_1 = __webpack_require__(60);
	// classes
	var convertCoordinates_class_1 = __webpack_require__(61);
	var AerodromesController = (function (_super) {
	    __extends(AerodromesController, _super);
	    /* @ngInject */
	    AerodromesController.$inject = ["$scope", "$rootScope", "aerodromesService", "systemConfigurationService", "$filter"];
	    function AerodromesController($scope, $rootScope, aerodromesService, systemConfigurationService, $filter) {
	        var _this = _super.call(this, $scope, aerodromesService) || this;
	        _this.$scope = $scope;
	        _this.aerodromesService = aerodromesService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$filter = $filter;
	        _super.prototype.setup.call(_this);
	        $scope.checkIfDefaultSet = function (aerodrome) { return $scope.hasDefault = _this.checkIfDefaultSet(aerodrome); };
	        $scope.edit = function (editable) { return _this.editOverride(editable); };
	        // formats: DD.dddd or DD°MM′SS″L or DD MM SS L
	        $scope.latitudeRegex = aerodromes_constants_1.CoordinateValidation.LATREGEX;
	        $scope.longitudeRegex = aerodromes_constants_1.CoordinateValidation.LONREGEX;
	        // get the current coordinate formant from system configurations
	        $scope.format = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.COORDINATE_FORMAT);
	        // setup functions to get the lat/lon label
	        $scope.getLatLabel = function () { return _this.getLatLabel(); };
	        $scope.getLonLabel = function () { return _this.getLonLabel(); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // set scope value for require external system identifier
	        $scope.requireExternalSystemId = _this.requireExternalSystemId();
	        aerodromesService.getAerodromeServiceTypes().then(function (serviceTypes) { return $scope.aerodromeServiceTypes = serviceTypes; });
	        return _this;
	    }
	    /**
	     * @param  {IAerodrome} aerodrome
	     * @returns boolean
	     * This prevents selecting more than one aerodrome
	     * as a default aerodrome for a billing centre
	     */
	    AerodromesController.prototype.checkIfDefaultSet = function (aerodrome) {
	        for (var _i = 0, _a = this.$scope.list; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (item.billing_center.id === aerodrome.billing_center.id && item.is_default_billing_center && aerodrome.id === null) {
	                this.$scope.editable.is_default_billing_center = false;
	                return true;
	            }
	        }
	        return false;
	    };
	    /**
	     * This will display the coordinates in the form as
	     * Degrees-Minutes-Seconds, provided the system
	     * is configured to DMS
	     *
	     * @param  {IAerodrome} editable
	     * @returns void
	     */
	    AerodromesController.prototype.editOverride = function (editable) {
	        var coordinates = new convertCoordinates_class_1.Coordinates();
	        var editableCopy = angular.copy(editable);
	        if (this.$scope.format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS) {
	            editableCopy.geometry.coordinates[0] = coordinates.toLon(editableCopy.geometry.coordinates[0], 'dms', 0);
	            editableCopy.geometry.coordinates[1] = coordinates.toLat(editableCopy.geometry.coordinates[1], 'dms', 0);
	        }
	        else {
	            // else display lon / lat
	            // with 5 decimal points
	            editableCopy.geometry.coordinates[0] = this.$filter('number')(editableCopy.geometry.coordinates[0], 5);
	            editableCopy.geometry.coordinates[1] = this.$filter('number')(editableCopy.geometry.coordinates[1], 5);
	        }
	        _super.prototype.edit.call(this, editableCopy);
	    };
	    /**
	     * Get required external system id flag from system configuration.
	     *
	     * @returns boolean true if required
	     */
	    AerodromesController.prototype.requireExternalSystemId = function () {
	        return this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_AERODROME_EXTERNAL_SYSTEM_ID);
	    };
	    // return the latitude label,
	    // based on the coordinate format
	    AerodromesController.prototype.getLatLabel = function () {
	        return this.$scope.format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS ?
	            aerodromes_constants_1.CoordinateLabels.DMSLAT : aerodromes_constants_1.CoordinateLabels.DECIMALLAT;
	    };
	    // return the longitude label,
	    // based on the coordinate formant
	    AerodromesController.prototype.getLonLabel = function () {
	        return this.$scope.format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS ?
	            aerodromes_constants_1.CoordinateLabels.DMSLON : aerodromes_constants_1.CoordinateLabels.DECIMALLON;
	    };
	    AerodromesController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AerodromesController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return AerodromesController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AerodromesController = AerodromesController;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	var sideBar_1 = __webpack_require__(111);
	// services
	var permissions_service_1 = __webpack_require__(112);
	var MainController = (function () {
	    /* @ngInject */
	    MainController.$inject = ["$scope", "$rootScope", "$state", "usersService", "permissionsService", "$location", "$window", "oAuthService"];
	    function MainController($scope, $rootScope, $state, usersService, permissionsService, $location, $window, oAuthService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$state = $state;
	        this.usersService = usersService;
	        this.permissionsService = permissionsService;
	        this.$location = $location;
	        this.$window = $window;
	        this.oAuthService = oAuthService;
	        this.$scope.page = this.$state.current.name;
	        this.permissionsService.generatePermissionsMap();
	        // log out a self care user from billing and vice-versa
	        // and redirect if accessing pages on incorrect url
	        oAuthService.validate();
	        var _proxy = this;
	        this.$scope.$on('headerBarCreatedEvent', function (event, b) {
	            if (_proxy.userAuthorized) {
	                $scope.$broadcast('userChanged', _proxy.user);
	            }
	        });
	        this.usersService.current.then(function (user) {
	            _this.user = user;
	            _this.userAuthorized = user !== undefined;
	            if (_this.userAuthorized) {
	                _this.isExternal = user.is_provider_user;
	                _this.isSelfCare = user.is_selfcare_user;
	                _this.loginFromBilling = JSON.parse(_this.$window.localStorage.getItem('loginFromBilling'));
	                if (user.force_password_change) {
	                    _this.checkForcePasswordChange();
	                    _this.$scope.forcePasswordChange = true;
	                    _this.$state.go('main.password-change');
	                }
	                _this.permissions = user ? user.permissions : [];
	            }
	            _this.$scope.hasPermission = function (permission) { return _this.hasPermission(permission); };
	            _this.$scope.hasPermissionInArray = function (listOfPermissions) { return _this.hasPermissionInArray(listOfPermissions); };
	            _this.$scope.$broadcast('userChanged', user);
	        });
	        // if content mode has been changed by the user, we set the content mode to what it was set on load
	        var contentMode = localStorage_service_1.LocalStorageService.get('contentMode');
	        if (contentMode !== null) {
	            this.$scope.contentMode = contentMode;
	        }
	        this.$rootScope.$on('contentModeChange', function (event, modeToChangeTo) {
	            _this.$scope.contentMode = modeToChangeTo;
	            localStorage_service_1.LocalStorageService.set('contentMode', modeToChangeTo);
	        });
	        // on page change, we append the state name as a class
	        this.$scope.$on('$stateChangeStart', function (event, toState) {
	            _this.$scope.page = toState.name;
	            // check if user is forced to change his password and always
	            // redirect him to password-change page
	            if (_this.userAuthorized) {
	                if (_this.$location.path() !== '/main.password-change' && _this.$scope.forcePasswordChange) {
	                    _this.$location.path('/main.password-change');
	                }
	                else if (!toState.url || toState.url !== '/login') {
	                    _this.checkPermissions();
	                }
	            }
	            // log out a self care user from billing and vice-versa
	            // and redirect if accessing pages on incorrect url
	            _this.oAuthService.validate(toState, event);
	            _this.$scope.$broadcast('toggleSideBar', false);
	        });
	        // redirect to appropriate authorized landing page if url not defined
	        if (this.$state.current.url === '') {
	            this.oAuthService.redirect();
	        }
	        this.$scope.sideBar = this.buildSidebarLabels(sideBar_1.sideBar);
	        this.$scope.sidebarProps = Array.apply(null, new Array($scope.sideBar.length)).map(function () { return { 'open': false }; });
	        this.$scope.clear = function () { return _this.setSidebarProps(_this.$scope.sidebarProps, false); };
	        this.$scope.keyUp = function (s) {
	            if (s.length > 0) {
	                _this.setSidebarProps(_this.$scope.sidebarProps, true);
	            }
	            else {
	                _this.setSidebarProps(_this.$scope.sidebarProps, false);
	            }
	        };
	    }
	    /**
	     * Returns whether the current user has this permission.
	     */
	    MainController.prototype.hasPermission = function (permission) {
	        return this.permissions && this.permissions.indexOf(permission) > -1;
	    };
	    /**
	     * Returns whether the current user has one of the permissions in an array of permissions.
	     */
	    MainController.prototype.hasPermissionInArray = function (listOfPermissions) {
	        if (listOfPermissions && listOfPermissions.length > 0) {
	            for (var _i = 0, listOfPermissions_1 = listOfPermissions; _i < listOfPermissions_1.length; _i++) {
	                var permission = listOfPermissions_1[_i];
	                if (this.userAuthorized) {
	                    /**
	                     * CASE A :
	                     *
	                     * INTERNAL USER | EXTERNAL USER CONVERTED TO INTERNAL USER [STANDARD LOGIN MODE]
	                     * EXTERNAL USER [SSO LOGIN MODE]
	                     */
	                    if (this.loginFromBilling || this.isExternal) {
	                        if (this.hasPermission(permission) || permission === permissions_service_1.NO_PERMISSIONS_REQUIRED) {
	                            return true;
	                        }
	                        if (permission === permissions_service_1.NO_PERMISSIONS_FOR_EXTERNAL_USER) {
	                            return !this.isExternal;
	                        }
	                    }
	                    else 
	                    /** ORIGINAL SELF CARE CONDITION */
	                    if (this.hasPermission(permission) && (permission === 'self_care_admin' || permission === 'self_care_access') ||
	                        permission === permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS) {
	                        return true;
	                    }
	                    else if (permission !== permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS) {
	                        if (this.hasPermission(permission) || permission === permissions_service_1.NO_PERMISSIONS_REQUIRED) {
	                            return true;
	                        }
	                        if (permission === permissions_service_1.NO_PERMISSIONS_FOR_EXTERNAL_USER) {
	                            return true;
	                        }
	                    }
	                }
	                else {
	                    if (permission === permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS || permission === permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS_NOT_AUTHORIZED) {
	                        return true;
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    MainController.prototype.setSidebarProps = function (array, boolean) {
	        for (var i in array) {
	            if (array.hasOwnProperty(i)) {
	                array[i].open = boolean;
	            }
	        }
	    };
	    MainController.prototype.checkPermissions = function () {
	        var permissionsMap = this.permissionsService.getPermissionsMap;
	        var attemptedUrl = this.$scope.page.split('.')[1];
	        var permitted;
	        var isAuthRoute = ['/login'].indexOf(this.$location.path()) >= 0;
	        // if attempted url is found in the permissions map
	        // check to see if user has permissions
	        if (permissionsMap[attemptedUrl]) {
	            for (var _i = 0, _a = permissionsMap[attemptedUrl]; _i < _a.length; _i++) {
	                var neededPermission = _a[_i];
	                if (this.isPermitted(neededPermission)) {
	                    permitted = true;
	                    break;
	                }
	            }
	        }
	        if (!permitted && !isAuthRoute) {
	            this.oAuthService.logout();
	        }
	    };
	    MainController.prototype.isPermitted = function (permission) {
	        return (this.permissions && this.permissions.indexOf(permission) !== -1)
	            || permission === permissions_service_1.NO_PERMISSIONS_REQUIRED
	            || permission === permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS
	            || permission === permissions_service_1.NO_PERMISSIONS_FOR_EXTERNAL_USER;
	    };
	    MainController.prototype.checkForcePasswordChange = function () {
	        if (!JSON.parse(window.localStorage.getItem('forcePasswordChange'))) {
	            window.localStorage.setItem('forcePasswordChange', JSON.stringify(true));
	        }
	    };
	    MainController.prototype.buildSidebarLabels = function (sidebar) {
	        sidebar.map(function (category) { return category.links.map(function (link) { return link.filterableText = link.category; }); });
	        return sidebar;
	    };
	    ;
	    return MainController;
	}());
	exports.MainController = MainController;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var permissions_service_1 = __webpack_require__(112);
	exports.sideBar = [
	    {
	        title: 'Billing', icon: 'file-text', permissions: ['invoices_view', 'transaction_view', 'aviation_invoice_preview',
	            'point_of_sale_access', 'invoices_approve', 'invoices_publish', 'transaction_modify', 'aviation_invoice_generate', 'aviation_invoice_recalculate',
	            'aviation_invoice_validate', 'nonaviation_invoice_preview', 'nonaviation_invoice_generate', 'passenger_revenue_reconcile',
	            'transaction_pending_modify', 'transaction_pending_view'],
	        links: [{ category: 'Invoices', icon: 'book', permissions: ['invoices_view', 'invoices_approve', 'invoices_publish'], url: 'invoices' },
	            { category: 'Transactions', icon: 'exchange', permissions: ['transaction_view', 'transaction_modify'], url: 'transactions' },
	            { category: 'Pending Transactions', icon: 'exchange', permissions: ['transaction_pending_view', 'transaction_pending_modify'], url: 'transactions-pending' },
	            { category: 'Aviation Billing', icon: 'plane', permissions: ['aviation_invoice_preview', 'aviation_invoice_generate',
	                    'aviation_invoice_recalculate', 'aviation_invoice_validate'], url: 'aviation-billing-engine' },
	            { category: 'Non-Aviation Billing', icon: 'plane', permissions: ['nonaviation_invoice_preview', 'nonaviation_invoice_generate'], url: 'non-aviation-billing-engine' },
	            { category: 'Point Of Sale Invoice Generation', icon: 'file-text-o', permissions: ['point_of_sale_access'], url: 'invoice-generation' },
	            { category: 'Passenger Revenue Reconciliation', icon: 'plane', permissions: ['passenger_revenue_reconcile'], url: 'passenger-revenue-reconciliation' }]
	    }, {
	        title: 'CRCO', icon: 'file-text', permissions: ['crco_connection_view', 'crco_connection_modify', 'crco_reporting_responsabilities_view', 'crco_reporting_responsabilities_modify',
	            'crco_messages_preview', 'crco_messages_generate', 'crco_messages_validate', 'crco_archive_view', 'crco_archive_modify', 'crco_claims_view', 'crco_claims_modify'],
	        links: [
	            { category: 'CRCO Connection', icon: 'link', permissions: ['crco_connection_view', 'crco_connection_modify'], url: 'crco-connection' },
	            { category: 'CRCO Certificates', icon: 'link', permissions: ['crco_connection_view', 'crco_connection_modify'], url: 'crco-certificates' },
	            { category: 'CRCO Reporting Responsabilities', icon: 'exchange', permissions: ['crco_reporting_responsabilities_view', 'crco_reporting_responsabilities_modify'], url: 'crco-reporting-responsabilities' },
	            { category: 'CRCO Messages ', icon: 'plane', permissions: ['crco_messages_preview', 'crco_messages_generate', 'crco_messages_validate'], url: 'crco-messages' },
	            { category: 'CRCO Archive ', icon: 'plane', permissions: ['crco_archive_view', 'crco_archive_modify'], url: 'crco-archive' },
	            { category: 'CRCO Claims', icon: 'file-text-o', permissions: ['crco_claims_view', 'crco_claims_modify'], url: 'crco-claims' },
	            { category: 'CRCO Cor Requests', icon: 'file-text-o', permissions: ['crco_claims_view', 'crco_claims_modify'], url: 'crco-cor-request' }
	        ]
	    },
	    {
	        title: 'Flight Data', icon: 'arrow-up', permissions: ['flight_movement_view', 'flight_movement_modify', 'flight_log_view', 'flight_log_modify', 'radar_summary_view',
	            'rejected_data_view', 'radar_summary_modify', 'rejected_data_modify', 'flight_schedule_view', 'flight_schedule_modify', 'flight_movement_key_modify'],
	        links: [{ category: 'Flight Movements', icon: 'plane', permissions: ['flight_movement_view', 'flight_movement_modify', 'flight_movement_key_modify'], url: 'flight-movement-management' },
	            { category: 'Flight Schedules', icon: 'plane', permissions: ['flight_schedule_view', 'flight_schedule_modify'], url: 'flight-schedule-management' },
	            { category: 'Aodb Flights', icon: 'plane', permissions: ['flight_movement_view', 'flight_movement_modify', 'flight_movement_key_modify'], url: 'aodb' },
	            { category: 'ATC Movement Log', icon: 'book', permissions: ['flight_log_view', 'flight_log_modify'], url: 'atc-movement-log' },
	            { category: 'Radar Summary', icon: 'rss', permissions: ['radar_summary_view', 'radar_summary_modify'], url: 'radar-summary' },
	            { category: 'Tower Movement Log', icon: 'tasks', permissions: ['flight_log_view', 'flight_log_modify'], url: 'tower-movement-logs' },
	            { category: 'Passenger Service Charge Return', icon: 'retweet', permissions: ['flight_log_view', 'flight_log_modify'], url: 'passenger-service-charge-return' },
	            { category: 'Rejected Items', icon: 'times-circle', permissions: ['rejected_data_view', 'rejected_data_modify'], url: 'rejected-items' }]
	    },
	    {
	        title: 'Operations', icon: 'cube', permissions: ['account_view', 'account_modify', 'aircraft_registration_view', 'aircraft_registration_modify',
	            'nominal_route_view', 'local_acreg_modify', 'local_acreg_view', 'nominal_route_modify', 'zzzz_aircraft_type_view', 'zzzz_aircraft_type_modify',
	            'zzzz_locations_view', 'zzzz_locations_modify', 'currency_view', 'currency_modify', 'aircraft_type_view', 'aircraft_type_modify',
	            'flight_reassignment_view', 'flight_reassignment_modify', 'charges_view', 'charges_modify'],
	        links: [{ category: 'Accounts', icon: 'users', permissions: ['account_view', 'account_modify'], url: 'accounts' },
	            { category: 'Aircraft Registrations', icon: 'fighter-jet', permissions: ['aircraft_registration_view', 'aircraft_registration_modify'], url: 'aircraft-registration' },
	            { category: 'Local Aircraft Registry', icon: 'fighter-jet', permissions: ['local_acreg_modify', 'local_acreg_view'], url: 'local-aircraft-registry' },
	            { category: 'Aircraft Types', icon: 'fighter-jet', permissions: ['aircraft_type_view', 'aircraft_type_modify'], url: 'aircraft-type-management' },
	            { category: 'Currencies', icon: 'dollar', permissions: ['currency_view', 'currency_modify'], url: 'currency-management' },
	            { category: 'Nominal Routes', icon: 'road', permissions: ['nominal_route_view', 'nominal_route_modify'], url: 'nominal-routes' },
	            { category: 'Unspecified Aircraft Types', icon: 'paper-plane-o', permissions: ['zzzz_aircraft_type_view', 'zzzz_aircraft_type_modify'], url: 'aircraft-unspecified-management' },
	            { category: 'Unspecified Locations', icon: 'map-pin', permissions: ['zzzz_locations_view', 'zzzz_locations_modify'], url: 'unspecified-locations' },
	            { category: 'Flight Reassignment', icon: 'plane', permissions: ['flight_reassignment_view', 'flight_reassignment_modify'], url: 'flight-reassignment' },
	            { category: 'Recurring Charges', icon: 'google-wallet', permissions: ['charges_view', 'charges_modify'], url: 'recurring-charges' }]
	    },
	    {
	        title: 'Charges and Formulas', icon: 'check-square-o', permissions: ['charges_schedule_view', 'charges_schedule_modify', 'avg_mtow_factor_view', 'avg_mtow_factor_modify',
	            'enroute_charges_view', 'enroute_charges_modify', 'service_charge_view', 'service_charge_modify', 'unified_tax_view', 'unified_tax_modify', 'utilities_schedule_view',
	            'utilities_schedule_modify', 'utilities_towns_view', 'utilities_towns_modify'],
	        links: [{ category: 'Air Navigation Charges Schedules', icon: 'cloud', permissions: ['charges_schedule_view', 'charges_schedule_modify'], url: 'air-navigation-charges' },
	            { category: 'Average MTOW Factor', icon: 'balance-scale', permissions: ['avg_mtow_factor_view', 'avg_mtow_factor_modify'], url: 'mtow' },
	            { category: 'Enroute Air Navigation Charges', icon: 'flask', permissions: ['enroute_charges_view', 'enroute_charges_modify'], url: 'enroute-air-navigation-charges-management' },
	            { category: 'Service Charge Catalogue', icon: 'retweet', permissions: ['service_charge_view', 'service_charge_modify'], url: 'catalogue-service-charge' },
	            { category: 'Unified Tax Management', icon: 'check-square-o', permissions: ['unified_tax_view', 'unified_tax_modify'], url: 'unified-tax-management' },
	            { category: 'Utilities Schedules', icon: 'flash', permissions: ['utilities_schedule_view', 'utilities_schedule_modify'], url: 'utilities-schedules' },
	            { category: 'Utilities Towns and Villages', icon: 'tint', permissions: ['utilities_towns_view', 'utilities_towns_modify'], url: 'utilities-towns' }]
	    },
	    {
	        title: 'Exemptions', icon: 'minus-circle', permissions: ['exempt_account_view', 'exempt_account_modify', 'exempt_aircraft_type_view', 'exempt_aircraft_type_modify',
	            'exempt_flight_route_view', 'exempt_flight_route_modify', 'exempt_flight_status_view', 'exempt_flight_status_modify', 'exempt_aircraft_flights_view',
	            'exempt_aircraft_flights_modify', 'aerodrome_category_view', 'aerodrome_category_modify', 'aerodrome_service_outage_view', 'aerodrome_service_outage_modify'],
	        links: [{ category: 'Exempt Accounts', icon: 'users', permissions: ['exempt_account_view', 'exempt_account_modify'], url: 'account-exempt-management' },
	            { category: 'Exempt Aircraft Types', icon: 'fighter-jet', permissions: ['exempt_aircraft_type_view', 'exempt_aircraft_type_modify'], url: 'aircraft-exempt-management' },
	            { category: 'Exempt Flight Routes', icon: 'external-link', permissions: ['exempt_flight_route_view', 'exempt_flight_route_modify'], url: 'flight-route-exemptions' },
	            { category: 'Exempt Flight Status', icon: 'pencil-square-o', permissions: ['exempt_flight_status_view', 'exempt_flight_status_modify'], url: 'flight-status-exemptions' },
	            { category: 'Exempt Aircraft and Flights', icon: 'paper-plane', permissions: ['exempt_aircraft_flights_view', 'exempt_aircraft_flights_modify'], url: 'aircraft-flights-exemptions' },
	            { category: 'Repositioning Aerodrome Clusters', icon: 'cubes', permissions: ['aerodrome_category_view', 'aerodrome_category_modify'], url: 'repositioning-aerodrome-clusters' },
	            { category: 'Service Outages', icon: 'adjust', permissions: ['aerodrome_service_outage_view', 'aerodrome_service_outage_modify'], url: 'service-outages' }]
	    },
	    {
	        title: 'Management', icon: 'user-plus', permissions: ['aerodrome_category_view', 'aerodrome_category_modify', 'aerodrome_view', 'aerodrome_modify',
	            'airspace_view', 'airspace_modify', 'billing_center_view', 'billing_center_modify', 'regional_countries_view', 'regional_countries_modify',
	            'countries_view', 'countries_modify', 'route_cache_modify', 'route_cache_view', 'sys_config_view', 'sys_config_modify', 'approval_workflow_view', 'approval_workflow_modify',
	            'manage_cached_event_view', 'manage_cached_event_modify', 'manage_plugin_view', 'manage_plugin_modify', 'banking_information_view', 'banking_information_modify',
	            'interest_rate_view', 'interest_rate_modify', 'aerodrome_operational_hours_view', 'aerodrome_operational_hours_modify', 'amhs_config_view', 'amhs_config_modify '],
	        links: [
	            { category: 'Aerodromes', icon: 'paper-plane', permissions: ['aerodrome_view', 'aerodrome_modify'], url: 'aerodromes' },
	            { category: 'Aerodrome Operational Hours', icon: 'hourglass', permissions: ['aerodrome_operational_hours_view', 'aerodrome_operational_hours_modify'],
	                url: 'aerodrome-operational-hours' },
	            { category: 'Aerodrome Categories', icon: 'object-group', permissions: ['aerodrome_category_view', 'aerodrome_category_modify'], url: 'aerodrome-category' },
	            { category: 'Airspaces', icon: 'object-group', permissions: ['airspace_view', 'airspace_modify'], url: 'airspace-management' },
	            { category: 'AMHS Connection', icon: 'link', permissions: ['amhs_config_view', 'amhs_config_modify'], url: 'amhs-connection' },
	            { category: 'AMHS Accounts', icon: 'link', permissions: ['amhs_config_view', 'amhs_config_modify'], url: 'amhs-accounts' },
	            { category: 'Application Management', icon: 'cog', permissions: ['route_cache_modify', 'route_cache_view'], url: 'application-management' },
	            { category: 'Bank Accounts', icon: 'university', permissions: ['banking_information_view', 'banking_information_modify'], url: 'bank-account-management' },
	            { category: 'Interest Rates', icon: 'percent', permissions: ['interest_rate_view', 'interest_rate_modify'], url: 'interest-rates' },
	            { category: 'Billing Centres', icon: 'book', permissions: ['billing_center_view', 'billing_center_modify'], url: 'billing-centre-management' },
	            { category: 'Countries', icon: 'flag', permissions: ['countries_view', 'countries_modify'], url: 'country-management' },
	            { category: 'Regional Countries', icon: 'flag', permissions: ['regional_countries_view', 'regional_countries_modify'], url: 'regional-country-management' },
	            { category: 'System Configuration', icon: 'cog', permissions: ['sys_config_view', 'sys_config_modify'], url: 'system-configuration' },
	            { category: 'Transaction Workflow', icon: 'exchange', permissions: ['approval_workflow_view', 'approval_workflow_modify'], url: 'transactions-workflow' },
	            { category: 'Cached Events', icon: 'cog', permissions: ['manage_cached_event_view', 'manage_cached_event_modify'], url: 'cached-events' },
	            { category: 'Plugins', icon: 'plug', permissions: ['manage_plugin_view', 'manage_plugin_modify'], url: 'plugins' }
	        ]
	    },
	    {
	        title: 'Data Analysis & Statistics', icon: 'pie-chart', permissions: ['system_summary_view', 'statistics_generate', 'reports_generate'],
	        links: [{ category: 'System Summary', icon: 'bar-chart', permissions: ['system_summary_view'], url: 'system-summary' },
	            { category: 'Analysis and Stats - Air Traffic', icon: 'line-chart', permissions: ['statistics_generate'], url: 'air-traffic-data' },
	            { category: 'Analysis and Stats - Revenue', icon: 'line-chart', permissions: ['statistics_generate'], url: 'revenue-data' },
	            { category: 'Report Generation', icon: 'file-text-o', permissions: ['reports_generate'], url: 'report-generation' }]
	        // hide Revenue Projection until it works correctly as PO and Kieran asked 2018-11-28
	        // { category: 'Revenue Projection', icon: 'dollar', permissions: ['reports_generate'], url: 'revenue-projection' }]
	    },
	    {
	        title: 'Templates', icon: 'align-justify', permissions: ['invoice_template_view', 'invoice_template_modify', 'report_template_view', 'report_template_modify'],
	        links: [{ category: 'Invoice Templates', icon: 'flash', permissions: ['invoice_template_view', 'invoice_template_modify'], url: 'invoice-template-management' },
	            { category: 'Report Templates', icon: 'book', permissions: ['report_template_view', 'report_template_modify'], url: 'report-templates' }]
	    },
	    {
	        title: 'Security', icon: 'lock', permissions: ['group_view', 'group_modify', 'user_event_view', 'user_event_modify', 'user_view', 'user_modify', 'auth_providers_view', 'auth_providers_modify'],
	        links: [{ category: 'Groups', icon: 'users', permissions: ['group_view', 'group_modify'], url: 'group-management' },
	            { category: 'User Event Log', icon: 'server', permissions: ['user_event_view', 'user_event_modify'], url: 'user-event-log' },
	            { category: 'Users', icon: 'user', permissions: ['user_view', 'user_modify'], url: 'users' },
	            { category: 'Password Change', icon: 'user', permissions: [permissions_service_1.NO_PERMISSIONS_FOR_EXTERNAL_USER], url: 'current-user' },
	            { category: 'SSO Providers', icon: 'server', permissions: ['auth_providers_view', 'auth_providers_modify'], url: 'sso-providers' }]
	    },
	    {
	        title: 'Help', icon: 'info', permissions: [permissions_service_1.NO_PERMISSIONS_REQUIRED],
	        links: [{ category: 'About', icon: 'code', permissions: [permissions_service_1.NO_PERMISSIONS_REQUIRED], url: 'about' },
	            { category: 'User Manual', icon: 'book', permissions: [permissions_service_1.NO_PERMISSIONS_REQUIRED], url: 'help' }]
	    },
	    {
	        title: 'Self-Care Portal', icon: 'user-plus', permissions: [permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS],
	        links: [{ category: 'Home Page', icon: 'home', permissions: [permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS], url: 'sc-home-page' },
	            { category: 'Login', icon: 'sign-in', permissions: [permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS_NOT_AUTHORIZED], url: 'sc-login' },
	            { category: 'Query Submission', icon: 'envelope', permissions: [permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS], url: 'sc-query-submission' },
	            { category: 'User Registration', icon: 'user', permissions: [permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS_NOT_AUTHORIZED], url: 'sc-user-registration' },
	            { category: 'Flight Cost Calculation', icon: 'calculator', permissions: [permissions_service_1.SELF_CARE_PORTAL_PERMISSIONS], url: 'sc-flight-cost-calculation' },
	            { category: 'Users', icon: 'user', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-user-management' },
	            { category: 'Accounts', icon: 'key', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-account-management' },
	            { category: 'Flight Search', icon: 'plane', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-flight-search' },
	            { category: 'Aircraft Registrations', icon: 'paper-plane', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-aircraft-registration' },
	            { category: 'Flight Schedules', icon: 'calendar', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-flight-schedules' },
	            { category: 'Transactions', icon: 'exchange', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-transactions' },
	            { category: 'Invoices', icon: 'book', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-invoices' },
	            { category: 'Passenger Service Charge Return', icon: 'retweet', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-passenger-service-charge-return' },
	            { category: 'Credit Payment', icon: 'credit-card', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-credit-payment' },
	            { category: 'Approval Request', icon: 'unlock', permissions: ['self_care_admin'], url: 'sc-approval-request' },
	            { category: 'Inactivity and Expiry Notices', icon: 'exclamation-circle', permissions: ['self_care_admin'], url: 'sc-inactivity-expiry-notice' },
	            { category: 'Report Generation', icon: 'file-text-o', permissions: ['self_care_access', 'self_care_admin'], url: 'sc-report-generation' }
	        ]
	    }
	];


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	var sideBar_1 = __webpack_require__(111);
	exports.endpoint = '/permissions';
	exports.NO_PERMISSIONS_REQUIRED = 'No permissions required';
	exports.SELF_CARE_PORTAL_PERMISSIONS = 'No permissions required for self-care portal';
	exports.SELF_CARE_PORTAL_PERMISSIONS_NOT_AUTHORIZED = 'No permissions required for self-care portal not authorized user';
	exports.NO_PERMISSIONS_FOR_EXTERNAL_USER = 'No permissions for external users';
	var PermissionsService = (function (_super) {
	    __extends(PermissionsService, _super);
	    /** @ngInject */
	    PermissionsService.$inject = ["Restangular"];
	    function PermissionsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = [{
	                id: null,
	                name: null,
	                permissions: []
	            }];
	        _this._pMap = {};
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    PermissionsService.prototype.generatePermissionsMap = function () {
	        // use sidebar to return a two dimensional
	        // array with permission objects
	        var links = sideBar_1.sideBar.map(function (category) {
	            return category.links.map(function (link) {
	                return _a = {}, _a[link.url] = link.permissions, _a;
	                var _a;
	            });
	        });
	        // put permission objects into
	        // a 'permission map'
	        for (var _i = 0, links_1 = links; _i < links_1.length; _i++) {
	            var link = links_1[_i];
	            for (var _a = 0, link_1 = link; _a < link_1.length; _a++) {
	                var obj = link_1[_a];
	                this._pMap = Object.assign(this._pMap, obj);
	            }
	        }
	    };
	    Object.defineProperty(PermissionsService.prototype, "getPermissionsMap", {
	        get: function () {
	            return this._pMap;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return PermissionsService;
	}(crud_service_1.CRUDService));
	exports.PermissionsService = PermissionsService;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var UsersController = (function (_super) {
	    __extends(UsersController, _super);
	    /* @ngInject */
	    UsersController.$inject = ["$scope", "$state", "usersService", "rolesService", "systemConfigurationService", "billingCentreManagementService", "ssoProvidersService"];
	    function UsersController($scope, $state, usersService, rolesService, systemConfigurationService, billingCentreManagementService, ssoProvidersService) {
	        var _this = _super.call(this, $scope, usersService) || this;
	        _this.$scope = $scope;
	        _this.$state = $state;
	        _this.usersService = usersService;
	        _this.rolesService = rolesService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.billingCentreManagementService = billingCentreManagementService;
	        _this.ssoProvidersService = ssoProvidersService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _super.prototype.list.call(_this, {}, "selfCareUser=&providerUser=&internalUser=");
	        // set default scope values
	        $scope.setZeroLength = false;
	        $scope.hasProviders = false;
	        _this.hasProviders();
	        $scope.is_provider_user_source = false;
	        // expose necessary methods to scope
	        $scope.resetPassword = function (setZeroLength) { return _this.resetPassword(setZeroLength); };
	        // watch for editable password change and if empty, assume setZeroLength true
	        $scope.$watch('editable.password', function (newValue) {
	            $scope.setZeroLength = newValue === '';
	        });
	        $scope.$watch('userType', function () { return _this.getFilterParameters(); });
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.create = function (editable) { return _this.createOverride(editable); };
	        $scope.update = function (editable, id) { return _this.updateOverride(editable, id); };
	        $scope.delete = function (id) { return _this.deleteOverride(id); };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        // get roles and bind to scope
	        rolesService.listAllWithoutChangePassword().then(function (roles) {
	            $scope.rolesList = roles;
	            $scope.rolesListForNotSelfCare = $scope.rolesList.filter(function (item) { return typeof item !== 'undefined' && item.name && item.name.toLowerCase() !== 'self-care operators'; });
	        });
	        // set default billing centre
	        billingCentreManagementService.listAll().then(function (billingCentres) {
	            $scope.editable.billing_center = $scope.defaultBillingCentre = billingCentres.content.find(function (bc) { return bc.hq; });
	        });
	        // get minlength system configuration value and update scope
	        $scope.minLength = parseInt(systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_MINIMUM_LENGTH), 10);
	        // get single user if state has a user id
	        if (typeof $state.params.id !== 'undefined') {
	            _this.service.get($state.params.id).then(function (user) { return _this.edit(user); });
	        }
	        $scope.checkSelfCareUser = function () {
	            if ($scope.editable.is_selfcare_user) {
	                $scope.editable.billing_center = null;
	                $scope.editable.roles = [];
	                $scope.rolesList.forEach(function (element) {
	                    if (typeof element !== 'undefined' && element.name && element.name.toLowerCase() === 'self-care operators') {
	                        $scope.editable.roles.push(element);
	                    }
	                });
	                if ($scope.editable.password === '') {
	                    $scope.editable.password = null;
	                }
	            }
	            else {
	                $scope.editable.roles = [];
	            }
	        };
	        $scope.checkProviderUser = function () {
	            if ($scope.editable.is_provider_user) {
	                $scope.editable.force_password_change = false;
	            }
	        };
	        return _this;
	    }
	    UsersController.prototype.edit = function (data) {
	        _super.prototype.edit.call(this, data);
	        this.$scope.is_provider_user_source = this.$scope.editable.is_provider_user;
	    };
	    UsersController.prototype.hasProviders = function () {
	        var proxyProv = this;
	        this.ssoProvidersService.hasProviderConfig().then(function (res) {
	            proxyProv.$scope.hasProviders = res ? true : false;
	        });
	    };
	    /**
	     * Reset password values, validation and flags.
	     *
	     * @param setZeroLength true to set password to zero length
	     */
	    UsersController.prototype.resetPassword = function (setZeroLength) {
	        setZeroLength = setZeroLength || false;
	        // set password to an empty string if isZeroLength
	        // else set to undefined to symbolize an untouched/unset value
	        if (setZeroLength) {
	            this.$scope.editable.password = '';
	        }
	        else {
	            delete (this.$scope.editable.password);
	        }
	        // used to call password directive resetPass method
	        // this will clean password fields and validatin flags/messages
	        this.$scope.resetPass = new Date().getTime();
	    };
	    UsersController.prototype.resetOverride = function () {
	        this.resetPassword();
	        _super.prototype.reset.call(this);
	        this.$scope.editable.billing_center = this.$scope.defaultBillingCentre;
	    };
	    UsersController.prototype.updateOverride = function (editable, id) {
	        var _this = this;
	        _super.prototype.update.call(this, editable, id).then(function () { return _this.resetOverride(); });
	    };
	    UsersController.prototype.deleteOverride = function (id) {
	        var _this = this;
	        _super.prototype.delete.call(this, id).then(function () { return _this.resetOverride(); });
	    };
	    UsersController.prototype.createOverride = function (editable) {
	        var _this = this;
	        _super.prototype.create.call(this, editable).then(function () { return _this.resetOverride(); });
	    };
	    UsersController.prototype.getFilterParameters = function () {
	        var selfCareUser = null;
	        var internalUser = null;
	        var providerUser = null;
	        var selected = this.$scope.userType;
	        if (selected) {
	            switch (selected) {
	                case 'selfcare':
	                    selfCareUser = true;
	                    break;
	                case 'internal': {
	                    internalUser = true;
	                    break;
	                }
	                case 'provider': {
	                    providerUser = true;
	                    break;
	                }
	                default:
	                    break;
	            }
	        }
	        this.$scope.filterParameters = {
	            // selfCareUser: this.$scope.userType,
	            selfCareUser: selfCareUser,
	            internalUser: internalUser,
	            providerUser: providerUser,
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    UsersController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString(), 'users');
	    };
	    return UsersController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.UsersController = UsersController;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var login_constants_1 = __webpack_require__(36);
	var LoginController = (function () {
	    /* @ngInject */
	    LoginController.$inject = ["$rootScope", "$scope", "$state", "$interval", "loginService", "localeSwitcherService", "usersService", "oAuthService", "systemConfigurationService"];
	    function LoginController($rootScope, $scope, $state, $interval, loginService, localeSwitcherService, usersService, oAuthService, systemConfigurationService) {
	        var _this = this;
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$interval = $interval;
	        this.loginService = loginService;
	        this.localeSwitcherService = localeSwitcherService;
	        this.usersService = usersService;
	        this.oAuthService = oAuthService;
	        this.systemConfigurationService = systemConfigurationService;
	        this.failedAttempts = 0;
	        // redirect to welcome page if the user is already logged in
	        this.loginService.redirectIfLoggedIn();
	        // log out a self care user from billing and vice-versa
	        // and redirect if accessing pages on incorrect url
	        this.oAuthService.validate();
	        $scope.language = this.$rootScope.language;
	        this.interval = null;
	        $scope.timeoutDelay = 0;
	        $scope.warning = false;
	        $scope.submit = function (username, password) { return _this.submit(username, password); };
	        $scope.changeLanguage = function (lang) { return _this.localeSwitcherService.changeLanguage(lang); };
	        $scope.offlineServerError = $scope.language && $scope.language.selected && $scope.language.selected.code
	            ? login_constants_1.LOGIN_ERROR.SERVER[$scope.language.selected.code]
	            : login_constants_1.LOGIN_ERROR.SERVER.en;
	        $scope.passwordRecoveryForm = function () {
	            $scope.recoveryForm = true;
	            $scope.error = null;
	        };
	        $scope.closeRecoveryForm = function () {
	            $scope.recoveryForm = false;
	            $scope.error = null;
	        };
	        $scope.showLogin = function () {
	            $scope.recoveryForm = false;
	            $scope.tempPaswordSent = false;
	            $scope.error = null;
	        };
	        $scope.setFrontendLanguage = function (lang) { return localeSwitcherService.setFrontendLanguage(lang); };
	        $scope.updateBackendLanguage = function (lang) { return localeSwitcherService.updateBackendLanguage(lang); };
	        $scope.recoverPassword = function (email) { return _this.usersService.recoverPassword(email).then(function () {
	            $scope.tempPaswordSent = true;
	        }, function (error) {
	            $scope.error = { error: error.data };
	            $scope.errorDescription = $scope.error
	                && $scope.error.error
	                && $scope.error.error.error_description !== 'null'
	                && $scope.error.error.error_description.length
	                ? $scope.error.error.error_description
	                : 'Service not available. Please contact the system administrator';
	        }); };
	        $scope.getAuthProviders = function () {
	            _this.oAuthService.getAuthProviders().then(function (result) {
	                $scope.providers = result && result.data ? result.data : [];
	            });
	        };
	        $scope.getAuthProviders();
	        $scope.logoName = '';
	        $scope.logoUrl = "assets/images/logo.png"; // Logo di default
	        $scope.logoOrganisation = function () {
	            _this.systemConfigurationService.getLogoOrganisation()
	                .then(function (item) {
	                if (item) {
	                    $scope.logoUrl = _this.initImage(item);
	                }
	            })
	                .catch(function (err) {
	                console.error("Errore nel recupero del logo:", err);
	            });
	        };
	    }
	    LoginController.prototype.submit = function (username, password) {
	        var _this = this;
	        if (this.$scope.timeoutDelay > 0) {
	            return; // prevents spamming
	        }
	        this.$scope.warning = false;
	        this.$scope.error = null;
	        this.loginService.login(username, password).then(function () {
	            var lang = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_SELECTION);
	            _this.$state.go('main.welcome-page');
	            _this.localeSwitcherService.updateBackendLanguage(lang);
	        }, function (data) {
	            _this.$scope.error = data.status;
	            if (data.status === 400 || data.status === 401) {
	                if (_this.failedAttempts > 2) {
	                    _this.countdown(5 * _this.failedAttempts);
	                    _this.$scope.error = null;
	                }
	                else {
	                    _this.$scope.warning = true;
	                }
	                _this.failedAttempts++;
	            }
	        });
	    };
	    LoginController.prototype.countdown = function (time) {
	        var _this = this;
	        this.$scope.timeoutDelay = time;
	        this.interval = this.$interval(function () {
	            _this.$scope.timeoutDelay--;
	            if (_this.$scope.timeoutDelay <= 0) {
	                _this.$interval.cancel(_this.interval);
	            }
	        }, 1000);
	    };
	    LoginController.prototype.getMimeTypeFromBase64 = function (base64String) {
	        var raw = atob(base64String.substring(0, 16)); // Decodifica primi byte
	        var uint8Array = new Uint8Array(raw.length);
	        for (var i = 0; i < raw.length; i++) {
	            uint8Array[i] = raw.charCodeAt(i);
	        }
	        if (uint8Array[0] === 0x89 && uint8Array[1] === 0x50) {
	            return "image/png";
	        }
	        else if (uint8Array[0] === 0xFF && uint8Array[1] === 0xD8) {
	            return "image/jpeg";
	        }
	        else if (uint8Array[0] === 0x47 && uint8Array[1] === 0x49) {
	            return "image/gif";
	        }
	        return "application/octet-stream";
	    };
	    LoginController.prototype.initImage = function (item) {
	        var logoUrl = '';
	        if (item.blob_value && Array.isArray(item.blob_value)) {
	            var binary = '';
	            var bytes = new Uint8Array(item.blob_value);
	            for (var i = 0; i < bytes.length; i++) {
	                binary += String.fromCharCode(bytes[i]);
	            }
	            var base64String = btoa(binary);
	            item.blob_value = base64String;
	            var mimeType = this.getMimeTypeFromBase64(base64String);
	            this.$scope.logoName = item.current_value;
	            logoUrl = 'data:' + mimeType + ';base64,' + base64String;
	        }
	        return logoUrl;
	    };
	    ;
	    return LoginController;
	}());
	exports.LoginController = LoginController;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AMHSConnectionController = (function (_super) {
	    __extends(AMHSConnectionController, _super);
	    /* @ngInject */
	    AMHSConnectionController.$inject = ["$scope", "$rootScope", "amhsConnectionService", "$interval"];
	    function AMHSConnectionController($scope, $rootScope, amhsConnectionService, $interval) {
	        var _this = _super.call(this, $scope, amhsConnectionService) || this;
	        _this.$scope = $scope;
	        _this.amhsConnectionService = amhsConnectionService;
	        _this.$interval = $interval;
	        _super.prototype.setup.call(_this);
	        // overrides
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.create = function (editable) { return _this.createOverride(editable); };
	        $scope.update = function (editable, id) { return _this.updateOverride(editable, id); };
	        $scope.delete = function (id) { return _this.deleteOverride(id); };
	        $scope.startAgent = function () { return _this.startAgent(); };
	        $scope.stopAgent = function () { return _this.stopAgent(); };
	        $scope.restartAgent = function () { return _this.restartAgent(); };
	        $scope.agentOperationInProgress = false;
	        // finish setup
	        _this.getFilterParameters();
	        _this.setDefaults();
	        // refresh agent status every 30 seconds
	        $scope.agentStatusPromise = $interval(function () { return _this.agentStatus(); }, 30000);
	        $scope.$on('$destroy', function () { return $interval.cancel($scope.agentStatusPromise); });
	        _this.agentStatus();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    AMHSConnectionController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AMHSConnectionController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	        this.agentStatus();
	    };
	    AMHSConnectionController.prototype.resetOverride = function () {
	        _super.prototype.reset.call(this);
	        this.setDefaults();
	    };
	    AMHSConnectionController.prototype.setDefaults = function () {
	        // set defaults for the form
	        this.$scope.editable.active = true;
	        this.$scope.editable.descr = '';
	        this.$scope.editable.protocol = 'P3';
	        this.$scope.editable.rtse_checkpoint_size = 4;
	        this.$scope.editable.rtse_window_size = 3;
	        this.$scope.editable.max_conn = 3;
	        this.$scope.editable.ping_enabled = true;
	        this.$scope.editable.ping_delay = null;
	        this.$scope.editable.network_device = null;
	        this.$scope.editable.local_bind_authenticated = false;
	        this.$scope.editable.local_passwd = 'default';
	        this.$scope.editable.local_hostname = '';
	        this.$scope.editable.local_ipaddr = '';
	        this.$scope.editable.local_port = 103;
	        this.$scope.editable.local_tsap_addr = '';
	        this.$scope.editable.local_tsap_addr_is_hex = false;
	        this.$scope.editable.remote_hostname = '';
	        this.$scope.editable.remote_ipaddr = '';
	        this.$scope.editable.remote_port = 103;
	        this.$scope.editable.remote_passwd = 'default';
	        this.$scope.editable.remote_bind_authenticated = false;
	        this.$scope.editable.remote_class_extended = true;
	        this.$scope.editable.remote_content_corr = true;
	        this.$scope.editable.remote_dl_exp_prohibit = true;
	        this.$scope.editable.remote_rcpt_reass_prohibit = true;
	        this.$scope.editable.remote_idle_time = 120;
	        this.$scope.editable.remote_internal_trace = true;
	        this.$scope.editable.remote_latest_delivery_time = true;
	        this.$scope.editable.remote_tsap_addr = '';
	        this.$scope.editable.remote_tsap_addr_is_hex = false;
	        this.$scope.agent_status = {};
	        this.$scope.agent_status.installed = false;
	        this.$scope.agent_status.started = false;
	        this.$scope.editable.psap_addr = '';
	        // validation defaults
	        this.$scope.valid = true;
	        this.$scope.pattern = '';
	        this.agentStatus();
	    };
	    AMHSConnectionController.prototype.createOverride = function (editable) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.create.call(this, editable)];
	                    case 1:
	                        _a.sent();
	                        this.setDefaults();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AMHSConnectionController.prototype.updateOverride = function (editable, id) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.update.call(this, editable, id)];
	                    case 1:
	                        _a.sent();
	                        this.setDefaults();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AMHSConnectionController.prototype.deleteOverride = function (id) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.delete.call(this, id)];
	                    case 1:
	                        _a.sent();
	                        this.setDefaults();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AMHSConnectionController.prototype.startAgent = function () {
	        var _this = this;
	        this.$scope.agentOperationInProgress = true;
	        return this.amhsConnectionService.startAgent()
	            .then(function (response) { return _this.$scope.agent_status = response; })
	            .catch(function (response) { return _this.displayErrorResponse(response); })
	            .finally(function () { return _this.$scope.agentOperationInProgress = false; });
	    };
	    AMHSConnectionController.prototype.stopAgent = function () {
	        var _this = this;
	        this.$scope.agentOperationInProgress = true;
	        return this.amhsConnectionService.stopAgent()
	            .then(function (response) { return _this.$scope.agent_status = response; })
	            .catch(function (response) { return _this.displayErrorResponse(response); })
	            .finally(function () { return _this.$scope.agentOperationInProgress = false; });
	    };
	    AMHSConnectionController.prototype.restartAgent = function () {
	        var _this = this;
	        this.$scope.agentOperationInProgress = true;
	        return this.amhsConnectionService.restartAgent()
	            .then(function (response) { return _this.$scope.agent_status = response; })
	            .catch(function (response) { return _this.displayErrorResponse(response); })
	            .finally(function () { return _this.$scope.agentOperationInProgress = false; });
	    };
	    AMHSConnectionController.prototype.agentStatus = function () {
	        var _this = this;
	        if (!this.$scope.agentOperationInProgress) {
	            return this.amhsConnectionService.agentStatus()
	                .then(function (response) { return _this.$scope.agent_status = response; });
	        }
	        return Promise.resolve({});
	    };
	    /**
	     * Display error message of restangular response.
	     *
	     * @param response restangular response with error
	     */
	    AMHSConnectionController.prototype.displayErrorResponse = function (response) {
	        this.$scope.error = {
	            error: response
	        };
	    };
	    return AMHSConnectionController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AMHSConnectionController = AMHSConnectionController;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var AMHSAccountsController = (function (_super) {
	    __extends(AMHSAccountsController, _super);
	    /* @ngInject */
	    AMHSAccountsController.$inject = ["$scope", "$rootScope", "amhsAccountsService"];
	    function AMHSAccountsController($scope, $rootScope, amhsAccountsService) {
	        var _this = _super.call(this, $scope, amhsAccountsService) || this;
	        _this.$scope = $scope;
	        _this.amhsAccountsService = amhsAccountsService;
	        _super.prototype.setup.call(_this);
	        // overrides
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.create = function (editable) { return _this.createOverride(editable); };
	        $scope.update = function (editable, id) { return _this.updateOverride(editable, id); };
	        $scope.delete = function (id) { return _this.deleteOverride(id); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // finish setup
	        _this.getFilterParameters();
	        _this.setDefaults();
	        return _this;
	    }
	    AMHSAccountsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AMHSAccountsController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    AMHSAccountsController.prototype.resetOverride = function () {
	        _super.prototype.reset.call(this);
	        this.setDefaults();
	    };
	    AMHSAccountsController.prototype.setDefaults = function () {
	        // set defaults for the form
	        this.$scope.editable.active = true;
	        this.$scope.editable.addr = '';
	        this.$scope.editable.descr = '';
	        this.$scope.editable.passwd = '';
	        this.$scope.editable.allow_mta_conn = true;
	        this.$scope.editable.svc_hold_for_delivery = true;
	        // validation defaults
	        this.$scope.valid = true;
	        this.$scope.pattern = '';
	    };
	    AMHSAccountsController.prototype.createOverride = function (editable) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.create.call(this, editable)];
	                    case 1:
	                        _a.sent();
	                        this.setDefaults();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AMHSAccountsController.prototype.updateOverride = function (editable, id) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.update.call(this, editable, id)];
	                    case 1:
	                        _a.sent();
	                        this.setDefaults();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    AMHSAccountsController.prototype.deleteOverride = function (id) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.delete.call(this, id)];
	                    case 1:
	                        _a.sent();
	                        this.setDefaults();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return AMHSAccountsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AMHSAccountsController = AMHSAccountsController;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var AircraftTypeManagementController = (function (_super) {
	    __extends(AircraftTypeManagementController, _super);
	    /* @ngInject */
	    AircraftTypeManagementController.$inject = ["$scope", "$rootScope", "aircraftTypeManagementService", "systemConfigurationService"];
	    function AircraftTypeManagementController($scope, $rootScope, aircraftTypeManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, aircraftTypeManagementService) || this;
	        _this.$scope = $scope;
	        _this.aircraftTypeManagementService = aircraftTypeManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.edit = function (item) { return _super.prototype.edit.call(_this, systemConfigurationService.convertMtowProperty(item, 'maximum_takeoff_weight')); };
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    AircraftTypeManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            searchFilter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    AircraftTypeManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return AircraftTypeManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.AircraftTypeManagementController = AircraftTypeManagementController;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var GroupManagementController = (function (_super) {
	    __extends(GroupManagementController, _super);
	    /* @ngInject */
	    GroupManagementController.$inject = ["$scope", "$rootScope", "permissionsService", "rolesService", "ssoProvidersService"];
	    function GroupManagementController($scope, $rootScope, permissionsService, rolesService, ssoProvidersService) {
	        var _this = _super.call(this, $scope, rolesService) || this;
	        _this.$scope = $scope;
	        _this.permissionsService = permissionsService;
	        _this.rolesService = rolesService;
	        _this.ssoProvidersService = ssoProvidersService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        // load groups without change password group
	        _super.prototype.list.call(_this, { 'ignoreChangePassword': true });
	        // load multipe select options
	        _this.updateRolesMayModifyList();
	        permissionsService.listAll().then(function (listOfPermissions) {
	            $scope.selfCareOperatorPermissionsList = listOfPermissions.filter(function (permission) { return permission.name === 'self_care_access'; });
	            listOfPermissions = listOfPermissions.filter(function (permission) { return permission.name !== 'self_care_access' && permission.name !== 'change_password'; });
	            $scope.permissionsList = _this.sortListOfPermissions(listOfPermissions);
	        });
	        // expose necessary methods to scope
	        $scope.update = function (role, id) { return _this.updateOverride(role, id); }; // override update method
	        $scope.create = function (role) { return _this.createOverride(role); }; // override create method
	        $scope.delete = function (id) { return _this.deleteOverride(id); }; // override create method
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        $scope.authProviderGroup = undefined;
	        $scope.authProviderEnabled = false;
	        _this.rolesService.getAuthProviderGroup().then(function (res) {
	            if (res && res.name) {
	                $scope.authProviderGroup = res.name;
	            }
	        });
	        _this.ssoProvidersService.hasProviderConfig().then(function (res) {
	            $scope.authProviderEnabled = res ? true : false;
	        });
	        return _this;
	    }
	    GroupManagementController.prototype.edit = function (data) {
	        _super.prototype.edit.call(this, data);
	        this.$scope.source_group_name = this.$scope.editable.name;
	    };
	    GroupManagementController.prototype.updateRolesMayModifyList = function () {
	        var _this = this;
	        this.rolesService.listAllWithoutChangePassword().then(function (roles) {
	            _this.$scope.rolesMayModify = roles
	                ? roles.filter(function (item) { return item.name !== 'Administrator'; })
	                : [];
	        });
	    };
	    GroupManagementController.prototype.sortListOfPermissions = function (listOfPermissions) {
	        listOfPermissions.sort(function (a, b) {
	            if (a.name < b.name) {
	                return -1;
	            }
	            if (a.name > b.name) {
	                return 1;
	            }
	            return 0;
	        });
	        return listOfPermissions;
	    };
	    GroupManagementController.prototype.createOverride = function (role) {
	        var _this = this;
	        _super.prototype.create.call(this, role)
	            .then(function (newRole) { return _this.updateRolesAndPermissions(newRole.id, role.permissions, role.owned_roles).then(function () {
	            _this.refreshOverride();
	            _this.updateRolesMayModifyList();
	        }); });
	    };
	    GroupManagementController.prototype.updateOverride = function (role, id) {
	        var _this = this;
	        _super.prototype.update.call(this, role, id) // update role
	            .then(function () { return _this.updateRolesAndPermissions(id, role.permissions, role.owned_roles).then(function () {
	            _this.refreshOverride();
	            _this.updateRolesMayModifyList();
	        }); });
	    };
	    GroupManagementController.prototype.deleteOverride = function (id) {
	        var _this = this;
	        _super.prototype.delete.call(this, id).then(function () {
	            _this.refreshOverride();
	            _this.updateRolesMayModifyList();
	        });
	    };
	    // updates the permissions and owned roles for a single group (or role id)
	    GroupManagementController.prototype.updateRolesAndPermissions = function (roleID, permissions, ownedRoles) {
	        var _this = this;
	        return this.rolesService.updatedPermissionsOfRole(roleID, permissions).then(function () { return _this.rolesService.updatedOwnedRolesOfRole(roleID, ownedRoles); });
	    };
	    GroupManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            ignoreChangePassword: true
	        };
	    };
	    GroupManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return GroupManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.GroupManagementController = GroupManagementController;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AboutController = (function () {
	    /* @ngInject */
	    AboutController.$inject = ["$scope", "aboutService", "releaseNoteService"];
	    function AboutController($scope, aboutService, releaseNoteService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.aboutService = aboutService;
	        this.releaseNoteService = releaseNoteService;
	        /**
	         * Maximum digits for individual semantic versioning parts.
	         */
	        this.SEMVER_PART_MAX_DIGITS = 3;
	        // allow multiple open at once
	        $scope.oneAtATime = false;
	        $scope.list = aboutService.list();
	        $scope.orderByReleaseVersion = function (releaseNote) { return _this.orderByReleaseVersion(releaseNote); };
	        // load release notes into scope
	        releaseNoteService.getReleaseNotes().then(function (data) { return $scope.releasenotes = data; });
	    }
	    /**
	     * Parse release note version and return negative number value.
	     *
	     * @param releaseNote release note to parse
	     */
	    AboutController.prototype.orderByReleaseVersion = function (releaseNote) {
	        var _this = this;
	        // split release note version into individual parts to format
	        // for example, '1.2.34' would be formatted as '[001,002,034]'
	        var version = releaseNote.release_version
	            .split('.').map(function (value) {
	            // remove any none digit characters
	            var number = value.replace(/\D/g, '');
	            // force three digit value by prepending '0' until in the format '###'
	            var format = [];
	            for (var i = number.length; i < _this.SEMVER_PART_MAX_DIGITS; i++) {
	                format.push('0');
	            }
	            format.push(number);
	            // return joined formatted value
	            return format.join('');
	        });
	        // return negavite (DESC) number representation of version
	        return -Number(version.join(''));
	    };
	    return AboutController;
	}());
	exports.AboutController = AboutController;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var organization_constants_1 = __webpack_require__(57);
	/** @ngInject */
	var FlightMovementTableController = (function () {
	    /**
	     * Constructor used to inject dependencies and setup intial field and scope state.
	     *
	     * @param systemConfigurationService system configuration service dependency
	     * @param $attrs flight movement table attributes dependency
	     * @param $scope flight movement table scope dependency
	     */
	    FlightMovementTableController.$inject = ["$timeout", "systemConfigurationService", "$rootScope", "$attrs", "$scope"];
	    function FlightMovementTableController($timeout, systemConfigurationService, $rootScope, $attrs, $scope) {
	        var _this = this;
	        this.$timeout = $timeout;
	        this.systemConfigurationService = systemConfigurationService;
	        this.$attrs = $attrs;
	        this.$scope = $scope;
	        // setup initial state
	        this.setup();
	        $scope.isEANS = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANS;
	        $scope.saveOldValue = function () {
	            //  salva il valore precedente
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // Sincronizzazione scrollbar dopo il rendering iniziale
	        this.$timeout(function () {
	            _this.updateTopScrollbarWidth();
	            _this.syncScrollbars();
	        }, 1000);
	        // Aggiorna la larghezza della scrollbar superiore ogni volta che cambiano i dati della tabella
	        $scope.$watch(function () { return $scope.listFlightMovements ? $scope.listFlightMovements.content : $scope.list; }, function () {
	            _this.$timeout(function () {
	                _this.updateTopScrollbarWidth();
	            }, 0);
	        });
	    }
	    /**
	     * Aggiorna la larghezza della scrollbar superiore in base alla tabella.
	     */
	    FlightMovementTableController.prototype.updateTopScrollbarWidth = function () {
	        var table = document.querySelector('.fm-table table');
	        var topScrollInner = document.querySelector('.table-scroll-inner');
	        if (table && topScrollInner) {
	            topScrollInner.style.width = table.scrollWidth + 'px';
	        }
	    };
	    /**
	     * Sincronizza lo scroll orizzontale tra la scrollbar superiore e quella inferiore.
	     */
	    FlightMovementTableController.prototype.syncScrollbars = function () {
	        var topScroll = document.querySelector('.table-scroll-top');
	        var bottomScroll = document.querySelector('.fm-table');
	        if (topScroll && bottomScroll) {
	            topScroll.addEventListener('scroll', function () {
	                bottomScroll.scrollLeft = topScroll.scrollLeft;
	            });
	            bottomScroll.addEventListener('scroll', function () {
	                topScroll.scrollLeft = bottomScroll.scrollLeft;
	            });
	        }
	    };
	    /**
	     * Setup field and scope values.
	     */
	    FlightMovementTableController.prototype.setup = function () {
	        this.setCurrencyInTableHeader();
	        this.setExportTableOptions();
	        this.setLabelsInTableHeader();
	        this.setColumnVisibility();
	    };
	    /**
	     * Looks at system configurations to determine what currency
	     * the Dom/Intl Pax charges use, and sets the proper
	     * currency code in the table header
	     *
	     * sets the ANSP currency in approach, aerodrome
	     * late dep/arr, parking charges header
	     *
	     * sets the unit of measure in the MTOW header
	     */
	    FlightMovementTableController.prototype.setCurrencyInTableHeader = function () {
	        var ANSP = 'ANSP';
	        var USD = 'USD';
	        var anspCurrency, airNavCurrency, domPaxCurrency, intlPaxCurrency;
	        anspCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        airNavCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.AIR_NAVIGATION_CHARGES_CURRENCY);
	        domPaxCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DOM_PAX_CURRENCY);
	        intlPaxCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INTL_PAX_CURRENCY);
	        // used for Dom/Intl passenger charges
	        this.airNavCurrencyInHeader = airNavCurrency === ANSP ? anspCurrency : USD;
	        this.domCurrencyInHeader = domPaxCurrency === ANSP ? anspCurrency : USD;
	        this.intlCurrencyInHeader = intlPaxCurrency === ANSP ? anspCurrency : USD;
	        // used for Approach, Aerodrome
	        // late Dep/Arr, Parking charges
	        this.anspCurrency = anspCurrency;
	        // mtow - ton / kg
	        this.mtowUnitOfMeasure = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        // distance - km / nm
	        this.distanceUnitOfMeasure = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE);
	    };
	    /**
	     * Set exprot table options to attribute binding or defaults if none supplied.
	     * Box header value default is '2' and endpoint is '/filters' for legecy support.
	     */
	    FlightMovementTableController.prototype.setExportTableOptions = function () {
	        var _this = this;
	        // evaluate options from directive attributes if any, one time binding
	        this.exportTableOptions = {
	            boxHeader: this.evaluate(this.$attrs.exportTableBoxHeader, 1),
	            endpoint: '/filters'
	        };
	        // observe endpoint attribute and evalulate, continues binding
	        this.$attrs.$observe('exportTableEndpoint', function (value) {
	            return _this.exportTableOptions.endpoint = _this.evaluate(value, '/filters');
	        });
	    };
	    /**
	     * Set approach label based on system configuration setting.
	     */
	    FlightMovementTableController.prototype.setLabelsInTableHeader = function () {
	        this.approachLabel = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.APPROACH_FEES_LABEL);
	    };
	    /**
	     * Evaluate value against scsope and return result or default if undefined.
	     *
	     * @param value value to evalulate
	     * @param dflt default if undefined
	     */
	    FlightMovementTableController.prototype.evaluate = function (value, dflt) {
	        return this.$scope.$eval(value) || dflt;
	    };
	    /**
	     * Set necessary fields for determining column visibility.
	     */
	    FlightMovementTableController.prototype.setColumnVisibility = function () {
	        // is approach fees label defined as 'ADAP' from system configuration settings.
	        this.isADAP = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.APPROACH_FEES_LABEL) === 'ADAP';
	    };
	    return FlightMovementTableController;
	}());
	exports.FlightMovementTableController = FlightMovementTableController;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var organization_constants_1 = __webpack_require__(57);
	var CountryManagementController = (function (_super) {
	    __extends(CountryManagementController, _super);
	    /* @ngInject */
	    CountryManagementController.$inject = ["$scope", "$rootScope", "countryManagementService", "systemConfigurationService"];
	    function CountryManagementController($scope, $rootScope, countryManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, countryManagementService) || this;
	        _this.$scope = $scope;
	        _this.countryManagementService = countryManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _super.prototype.setup.call(_this);
	        $scope.create = function (editable) { return _this.createOverride(editable); };
	        $scope.update = function (editable, id) { return _this.updateOverride(editable, id); };
	        $scope.edit = function (editable) { return _this.editOverride(editable); };
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.isLocaleEnglish = function () { return systemConfigurationService.isLocaleEnglish(); };
	        $scope.prefixArrayToString = function (list, key) { return _this.prefixArrayToString(list, key); };
	        _this.getFilterParameters();
	        $scope.isEANS = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANS;
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    /**
	     * Override create to format prefixes
	     * @param  {} editable
	     * @returns void
	     */
	    CountryManagementController.prototype.createOverride = function (editable) {
	        _super.prototype.create.call(this, this.formatPrefixes(editable));
	    };
	    /**
	     * Override update to format prefixes
	     * @param  {} editable
	     * @param  {} id
	     * @returns void
	     */
	    CountryManagementController.prototype.updateOverride = function (editable, id) {
	        _super.prototype.update.call(this, this.formatPrefixes(editable), id);
	    };
	    /**
	     * Override edit to display
	     * prefixes as a comma separated
	     * string
	     * @param  {ICountry} editable
	     * @returns void
	     */
	    CountryManagementController.prototype.editOverride = function (editable) {
	        var country = angular.copy(editable);
	        var aircraft_registration_prefixes = country.aircraft_registration_prefixes, aerodrome_prefixes = country.aerodrome_prefixes;
	        country.aircraft_registration_prefixes_input = aircraft_registration_prefixes
	            ? this.prefixArrayToString(aircraft_registration_prefixes, 'aircraft_registration_prefix')
	            : '';
	        country.aerodrome_prefixes_input = aerodrome_prefixes
	            ? this.prefixArrayToString(aerodrome_prefixes, 'aerodrome_prefix')
	            : '';
	        _super.prototype.edit.call(this, country);
	    };
	    /**
	     * Changes comma-separated strings of
	     * prefixes to arrays of prefixes
	     * @param  {ICountry} editable
	     * @returns ICountry
	     */
	    CountryManagementController.prototype.formatPrefixes = function (editable) {
	        var country = angular.copy(editable);
	        var aircraft_registration_prefixes_input = country.aircraft_registration_prefixes_input, aerodrome_prefixes_input = country.aerodrome_prefixes_input;
	        if (this.isString(aircraft_registration_prefixes_input)) {
	            country.aircraft_registration_prefixes = this.prefixStringToArray(aircraft_registration_prefixes_input, 'aircraft_registration_prefix', country);
	        }
	        if (this.isString(aerodrome_prefixes_input)) {
	            country.aerodrome_prefixes = this.prefixStringToArray(aerodrome_prefixes_input, 'aerodrome_prefix', country);
	        }
	        return country;
	    };
	    CountryManagementController.prototype.prefixArrayToString = function (list, key) {
	        return list.map(function (item) { return item[key]; }).join(', ');
	    };
	    CountryManagementController.prototype.prefixStringToArray = function (list, key, country) {
	        var id = country.id, country_name = country.country_name, country_code = country.country_code;
	        return list.split(',').map(function (prefix) {
	            if (prefix.trim().length) {
	                return _a = {}, _a[key] = prefix.trim(), _a.country_code = { id: id, country_name: country_name, country_code: country_code }, _a;
	            }
	            var _a;
	        });
	    };
	    /**
	     * type guard checks if
	     * value is a string
	     * @param  {string|string[]} prefix
	     * @returns prefix is string
	     */
	    CountryManagementController.prototype.isString = function (prefix) {
	        return typeof prefix === 'string';
	    };
	    CountryManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * This will add appropriate filters from scope
	     * for parent refresh parameters.
	     */
	    CountryManagementController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return CountryManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CountryManagementController = CountryManagementController;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var input_constants_1 = __webpack_require__(5);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var PluginsController = (function (_super) {
	    __extends(PluginsController, _super);
	    /* @ngInject */
	    PluginsController.$inject = ["$scope", "$rootScope", "pluginsService", "systemConfigurationService", "$stateParams"];
	    function PluginsController($scope, $rootScope, pluginsService, systemConfigurationService, $stateParams) {
	        var _this = 
	        // define and setup super class
	        _super.call(this, $scope, pluginsService) || this;
	        _this.$scope = $scope;
	        _this.pluginsService = pluginsService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.$stateParams = $stateParams;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.getFilterParameters();
	        $scope.isKcaaErpTimestampEnabled = function () { return _this.isKcaaErpTimestampEnabled(); };
	        // set hidden property from param
	        _this.$scope.showHidden = $stateParams.hidden === 'hidden' ? true : false;
	        // expose necessary methods to scope
	        _this.$scope.edit = function (plugin) { return _this.edit(plugin); };
	        _this.$scope.refresh = function () { return _this.refresh(); };
	        _this.$scope.add = function (plugin, id) { return _this.add(plugin, id); };
	        _this.$scope.update = function (plugin, id) { return _this.update(plugin, id); };
	        _this.$scope.remove = function (plugin, id) { return _this.remove(plugin, id); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        // call super list method with visible parameter
	        _super.prototype.list.call(_this, { visible: !_this.$scope.showHidden });
	        return _this;
	    }
	    PluginsController.prototype.isKcaaErpTimestampEnabled = function () {
	        if (!this.$scope.editable || !Array.isArray(this.$scope.editable.configurations)) {
	            return false;
	        }
	        var checkbox = this.$scope.editable.configurations.find(function (c) { return c.item_name === "Receipt processor starting timestamp enabled"; });
	        return checkbox && checkbox.current_value === 't';
	    };
	    PluginsController.prototype.edit = function (plugin) {
	        var _this = this;
	        this.systemConfigurationService.listByPluginId(plugin.id)
	            .then(function (systemConfiguration) {
	            plugin.configurations = systemConfiguration.content;
	            _super.prototype.edit.call(_this, plugin);
	        });
	    };
	    /**
	     * Adding a plugin simply shows it on the main view.
	     *
	     * @param plugin plugin to show
	     * @param id plugin id to show
	     */
	    PluginsController.prototype.add = function (plugin, id) {
	        plugin.visible = true;
	        return this.update(plugin, id);
	    };
	    /**
	     * Updating plugin values and system configuration items.
	     *
	     * @param plugin plugin to update
	     * @param id plugin to update id
	     */
	    PluginsController.prototype.update = function (plugin, id) {
	        var _this = this;
	        return this.systemConfigurationService.update(plugin.configurations, null)
	            .then(function () { return _super.prototype.update.call(_this, plugin, id); })
	            .catch(function (error) { return _this.displayError(error); });
	    };
	    /**
	     * Removing a plugin simply disables and hides it from the main view.
	     *
	     * @param plugin plugin to remove
	     * @param id plugin to remove id
	     */
	    PluginsController.prototype.remove = function (plugin, id) {
	        plugin.enabled = false;
	        plugin.visible = false;
	        return this.update(plugin, id);
	    };
	    PluginsController.prototype.refresh = function () {
	        var _this = this;
	        this.getFilterParameters();
	        // hold search value to update highlight text after promise returned
	        // this forces highlighting to use the same search value even if the 
	        // search value changes after the promise was sent
	        // and finally update next retry cycle
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString())
	            .then(function () { return _this.updateHighlight(_this.$scope.search); });
	    };
	    PluginsController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            visible: !this.$scope.showHidden
	        };
	    };
	    /**
	     * Display error message and highlight form feilds.
	     *
	     * @param error restangular response
	     */
	    PluginsController.prototype.displayError = function (error) {
	        this.$scope.error = { error: error };
	        if (typeof error.data.field_errors !== 'undefined' && error.data.field_errors !== null) {
	            for (var i = 0; i < error.data.field_errors.length; i++) {
	                if (this.$scope.form[error.data.field_errors[i].field] !== undefined) {
	                    this.$scope.form[error.data.field_errors[i].field].$setValidity(input_constants_1.DISPLAY.API_RESPONSE_CLASS, false);
	                }
	                else {
	                    console.warn('issue with backend sending input binding that does not exist on $scope');
	                }
	            }
	        }
	    };
	    /**
	     * Update scope highlight search with new search value.
	     *
	     * @param search search text
	     */
	    PluginsController.prototype.updateHighlight = function (search) {
	        this.$scope.highlightSearch = search;
	    };
	    return PluginsController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.PluginsController = PluginsController;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var organization_constants_1 = __webpack_require__(57);
	/** @ngInject */
	var SystemConfigurationItemController = (function () {
	    SystemConfigurationItemController.$inject = ["$scope", "systemConfigurationService", "sysConfigBoolean"];
	    function SystemConfigurationItemController($scope, systemConfigurationService, sysConfigBoolean) {
	        var _this = this;
	        this.$scope = $scope;
	        this.systemConfigurationService = systemConfigurationService;
	        this.sysConfigBoolean = sysConfigBoolean;
	        $scope.crossing = this.systemConfigurationService.setCrossingDistance();
	        $scope.languageOptions = this.systemConfigurationService.getLanguageOptions();
	        $scope.supportedLanguages = this.systemConfigurationService.getSupportedLanguages();
	        $scope.verifyInProgress = false;
	        this.parseRangeAndModel($scope.crossing);
	        // expose necessary methods to scope
	        $scope.addCDPToList = function () { return _this.addCDPToList(); };
	        $scope.updateSupportedLanguages = function () { return _this.updateSupportedLanguages(); };
	        $scope.mapRange = function (item) { return _this.mapRange(item); };
	        $scope.languageMap = function (item) { return _this.languageMap(item); };
	        $scope.itemValidation = function (item) { return _this.itemValidation(item); };
	        $scope.itemValidationInvoiceByFm = function (item) { return _this.itemValidationInvoiceByFm(item); };
	        $scope.isEANA = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION) === organization_constants_1.OrganizationName.EANA;
	        // watch for changes and reset verify result
	        $scope.$watch('item.current_value', function () { return _this.$scope.verifyResult = null; });
	        $scope.blob_url_string = '';
	        $scope.handleFileInput = function (file, item) { return _this.handleFileInput(file, item); };
	        $scope.initImage = this.initImage($scope.item);
	        $scope.systemConfigurationUpload = false;
	        $scope.activeNotificationUploadFile = function () { return _this.activeNotificationUploadFile(); };
	        $scope.getMimeTypeFromBase64 = function (base64String) { return _this.getMimeTypeFromBase64(base64String); };
	    }
	    /**
	     * This is the onChange event for the
	     * crossing distance precedence multiselect
	     *
	     * For CDP, the current value must be a string
	     * of comma separated values
	     *
	     * @returns void
	     */
	    SystemConfigurationItemController.prototype.addCDPToList = function () {
	        this.$scope.CDP = this.getItemName(this.$scope.CDPModel, this.$scope.baseCDPRange);
	        this.$scope.item.current_value = this.$scope.CDP.join();
	    };
	    /**
	     * This parses the Crossing Distance Precedence
	     * values, changing them from strings to objects,
	     * in order to populate the multiselect
	     *
	     * If upgrading, to v2.0.0 (`angularjs-dropdown-multiselect` currently in beta)
	     * we can use an array of strings and this code may
	     * be removed
	     *
	     * @param  {ISystemConfigurationSpring} data
	     * @returns void
	     */
	    SystemConfigurationItemController.prototype.parseRangeAndModel = function (crossing) {
	        if (!crossing) {
	            return;
	        }
	        var ranges = crossing.range.split(',');
	        var currentValues;
	        if (typeof crossing.current_value === 'string') {
	            currentValues = crossing.current_value.split(',');
	        }
	        this.$scope.CDPRange = ranges.map(function (x, idx) { return { id: idx + 1, label: x }; });
	        this.$scope.baseCDPRange = angular.copy(this.$scope.CDPRange);
	        this.$scope.CDPModel = [];
	        for (var _i = 0, currentValues_1 = currentValues; _i < currentValues_1.length; _i++) {
	            var value = currentValues_1[_i];
	            for (var _a = 0, _b = this.$scope.CDPRange; _a < _b.length; _a++) {
	                var range = _b[_a];
	                if (range.label === value) {
	                    this.$scope.CDPModel.push({ id: range.id });
	                }
	            }
	        }
	        this.$scope.CDP = this.getItemName(this.$scope.CDPModel, this.$scope.CDPRange);
	    };
	    /**
	     * Populates the precedence list of user
	     * selected crossing distances
	     *
	     * @param  {Array<Object>} models
	     * @param  {Array<Object>} ranges
	     * @returns Array<string>
	     */
	    SystemConfigurationItemController.prototype.getItemName = function (models, ranges) {
	        var array = [];
	        for (var _i = 0, models_1 = models; _i < models_1.length; _i++) {
	            var model = models_1[_i];
	            for (var _a = 0, ranges_1 = ranges; _a < ranges_1.length; _a++) {
	                var range = ranges_1[_a];
	                if (model.id === range.id) {
	                    array.push(range.label);
	                }
	            }
	        }
	        return array;
	    };
	    SystemConfigurationItemController.prototype.mapRange = function (item) {
	        var range = item.range.split(',');
	        var list = [];
	        // test to make sure that INVOICE_CURRENCY_ENROUTE and INVOICE_FM_CATEGORY codependant settings are correct
	        if (item.item_name === system_configuration_constants_1.SysConfigConstants.INVOICE_CURRENCY_ENROUTE.toString()) {
	            for (var i = 0, len = this.$scope.list.length; i < len; i++) {
	                if (this.$scope.list[i].item_name === system_configuration_constants_1.SysConfigConstants.INVOICE_FM_CATEGORY.toString()) {
	                    if (!this.sysConfigBoolean.parse(this.$scope.list[i].current_value)) {
	                        range.pop();
	                        item.current_value = range[0];
	                    }
	                    ;
	                }
	                ;
	            }
	            ;
	        }
	        ;
	        range.forEach(function (entry, index) { return list[entry] = range[index]; });
	        return list;
	    };
	    SystemConfigurationItemController.prototype.languageMap = function (item) {
	        var range = JSON.parse(item.range);
	        return range.reduce(function (formattedLanguages, language) {
	            formattedLanguages[JSON.stringify(language)] = language.label;
	            return formattedLanguages;
	        }, []);
	    };
	    SystemConfigurationItemController.prototype.updateSupportedLanguages = function () {
	        var _this = this;
	        var selected = this.$scope.languageOptions.reduce(function (selectedLanguages, language) {
	            if (_this.$scope.supportedLanguages.map(function (o) { return o.id; }).includes(language.id)) {
	                selectedLanguages.push({ code: language.id, label: language.label });
	            }
	            return selectedLanguages;
	        }, []);
	        this.$scope.item.current_value = JSON.stringify(selected);
	    };
	    SystemConfigurationItemController.prototype.itemValidation = function (item) {
	        var _this = this;
	        this.$scope.verifyInProgress = true;
	        this.systemConfigurationService.validateItem(item)
	            .then(function (response) { return _this.handleItemValidationResponse(response, null); })
	            .catch(function (error) { return _this.handleItemValidationResponse(false, error); });
	    };
	    SystemConfigurationItemController.prototype.itemValidationInvoiceByFm = function (item) {
	        var _this = this;
	        var data = [];
	        this.$scope.verifyInProgress = true;
	        this.$scope.list.map(function (item, index) {
	            if (item.item_name === system_configuration_constants_1.SysConfigConstants.INVOICE_FM_CATEGORY.toString() || item.item_name === system_configuration_constants_1.SysConfigConstants.INVOICE_CURRENCY_ENROUTE.toString()) {
	                data.push(item);
	            }
	            ;
	        });
	        this.systemConfigurationService.validateInvoiceByFm(data)
	            .then(function (response) { return _this.handleItemValidationResponse(response, null); })
	            .catch(function (error) { return _this.handleItemValidationResponse(false, error); });
	    };
	    SystemConfigurationItemController.prototype.handleItemValidationResponse = function (result, error) {
	        this.$scope.verifyInProgress = false;
	        this.$scope.verifyResult = result;
	        this.$scope.validationError = error && error.data ? error.data : null;
	    };
	    SystemConfigurationItemController.prototype.getMimeTypeFromBase64 = function (base64String) {
	        var raw = atob(base64String.substring(0, 16)); // Decodifica primi byte
	        var uint8Array = new Uint8Array(raw.length);
	        for (var i = 0; i < raw.length; i++) {
	            uint8Array[i] = raw.charCodeAt(i);
	        }
	        if (uint8Array[0] === 0x89 && uint8Array[1] === 0x50) {
	            return "image/png";
	        }
	        else if (uint8Array[0] === 0xFF && uint8Array[1] === 0xD8) {
	            return "image/jpeg";
	        }
	        else if (uint8Array[0] === 0x47 && uint8Array[1] === 0x49) {
	            return "image/gif";
	        }
	        return "application/octet-stream";
	    };
	    SystemConfigurationItemController.prototype.initImage = function (item) {
	        if (item.blob_value && Array.isArray(item.blob_value)) {
	            var binary = '';
	            var bytes = new Uint8Array(item.blob_value);
	            for (var i = 0; i < bytes.length; i++) {
	                binary += String.fromCharCode(bytes[i]);
	            }
	            var base64String = btoa(binary);
	            item.blob_value = base64String;
	            var mimeType = this.getMimeTypeFromBase64(base64String);
	            this.$scope.blob_url_string = 'data:' + mimeType + ';base64,' + base64String;
	            this.$scope.$parent.blob_url_string = this.$scope.blob_url_string;
	            this.$scope.$parent.cachedBlobValues[item.item_name] = base64String;
	            return this.$scope.blob_url_string;
	        }
	    };
	    ;
	    SystemConfigurationItemController.prototype.handleFileInput = function (file, item) {
	        var _this = this;
	        if (!file)
	            return;
	        var fileType = file.type;
	        if (fileType !== "image/png" && fileType !== "image/jpeg" && fileType !== "image/gif") {
	            this.activeNotificationUploadFile();
	            return;
	        }
	        var reader = new FileReader();
	        reader.onload = function (event) {
	            var fileReader = event.target;
	            if (fileReader.result) {
	                var base64String = fileReader.result.split(",")[1];
	                item.blob_value = base64String;
	                item.current_value = file.name;
	                _this.$scope.blob_url_string = 'data:' + fileType + ';base64,' + base64String;
	                _this.$scope.$parent.blob_url_string = _this.$scope.blob_url_string;
	                _this.$scope.$parent.cachedBlobValues[item.item_name] = base64String;
	                _this.$scope.$apply();
	            }
	        };
	        reader.readAsDataURL(file);
	    };
	    ;
	    SystemConfigurationItemController.prototype.activeNotificationUploadFile = function () {
	        this.$scope.systemConfigurationUpload = true;
	    };
	    return SystemConfigurationItemController;
	}());
	exports.SystemConfigurationItemController = SystemConfigurationItemController;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var PassengerRevenueReconciliationController = (function (_super) {
	    __extends(PassengerRevenueReconciliationController, _super);
	    /* @ngInject */
	    PassengerRevenueReconciliationController.$inject = ["$scope", "passengerServiceChargeReturnService", "systemConfigurationService", "customDate"];
	    function PassengerRevenueReconciliationController($scope, passengerServiceChargeReturnService, systemConfigurationService, customDate) {
	        var _this = _super.call(this, $scope, passengerServiceChargeReturnService) || this;
	        _this.$scope = $scope;
	        _this.passengerServiceChargeReturnService = passengerServiceChargeReturnService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(true);
	        $scope.executePSCR = function (start_date, end_date) { return _this.executePSCR(start_date, end_date); };
	        _this.setCurrencyLabels();
	        return _this;
	    }
	    /**
	     * Send date range of flights to check against PSCR
	     */
	    PassengerRevenueReconciliationController.prototype.executePSCR = function (start_date, end_date) {
	        var _this = this;
	        this.$scope.reconcilePSCRJob = false;
	        var params = {
	            start_date: start_date.toISOString().substr(0, 10),
	            end_date: end_date.toISOString().substr(0, 10),
	            dom_pay: this.$scope.dom_pay,
	            itl_pay: this.$scope.itl_pay
	        };
	        this.passengerServiceChargeReturnService.executePSCR(params)
	            .then(function (resp) {
	            _this.$scope.reconcilePSCRJob = true;
	            _this.$scope.reconcileResponse = resp;
	        })
	            .catch(function (error) { return _this.setErrorResponse(error); });
	    };
	    /**
	     * Sets the currency (ANNSP / USD)
	     * for Domestic and International
	     * Payment labels
	     */
	    PassengerRevenueReconciliationController.prototype.setCurrencyLabels = function () {
	        var ANSP = 'ANSP';
	        var USD = 'USD';
	        // get ANSP currency / dom & intl currency options
	        var anspCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        var domPaxCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DOM_PAX_CURRENCY);
	        var intlPaxCurrency = this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.INTL_PAX_CURRENCY);
	        // set dom & intl currency
	        this.$scope.domPaxCurrency = domPaxCurrency === ANSP ? anspCurrency : USD;
	        this.$scope.intlPaxCurrency = intlPaxCurrency === ANSP ? anspCurrency : USD;
	    };
	    return PassengerRevenueReconciliationController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.PassengerRevenueReconciliationController = PassengerRevenueReconciliationController;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TableSortController = (function () {
	    /* @ngInject */
	    TableSortController.$inject = ["$scope", "debounceService"];
	    function TableSortController($scope, debounceService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.debounceService = debounceService;
	        this.sortTableDebounce = debounceService.debounce(function () { return _this.$scope.sortTable(); }, 600);
	    }
	    TableSortController.prototype.updateElementSort = function (element) {
	        this.$scope.updateElementSort(element);
	    };
	    TableSortController.prototype.updateSortValue = function (newValue, oldValue) {
	        // update old sort value to new value
	        var isSorted = this.$scope.updateSortValue(newValue, oldValue);
	        // debounce table sort incase multiple sort values are to be updated
	        if (isSorted) {
	            this.sortTableDebounce();
	        }
	        // let all upstream scope know a table sort item value has changed
	        // this is used on the flight movement page for dep|dest ad flags to
	        // prevent flickering of column value changes on refresh
	        this.$scope.$emit('table-sort-item-value-changed', newValue, oldValue, isSorted);
	    };
	    return TableSortController;
	}());
	exports.TableSortController = TableSortController;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// enums
	var crud_file_handler_type_1 = __webpack_require__(24);
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var TransactionsPendingController = (function (_super) {
	    __extends(TransactionsPendingController, _super);
	    /** @ngInject */
	    TransactionsPendingController.$inject = ["$scope", "transactionsPendingService", "transactionsWorkflowService", "usersService", "systemConfigurationService", "currencyManagementService", "transactionsService", "organizationService"];
	    function TransactionsPendingController($scope, transactionsPendingService, transactionsWorkflowService, usersService, systemConfigurationService, currencyManagementService, transactionsService, organizationService) {
	        var _this = _super.call(this, $scope, transactionsPendingService, null, 'Supporting Document', crud_file_handler_type_1.CrudFileHandlerPropertyType.Part) || this;
	        _this.$scope = $scope;
	        _this.transactionsPendingService = transactionsPendingService;
	        _this.transactionsWorkflowService = transactionsWorkflowService;
	        _this.usersService = usersService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.currencyManagementService = currencyManagementService;
	        _this.transactionsService = transactionsService;
	        _this.organizationService = organizationService;
	        _super.prototype.setup.call(_this);
	        $scope.pattern = '.jpg, .gif, .png, .pdf';
	        // get required system configs
	        $scope.inverseExchange = _this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE);
	        $scope.activeOrg = _this.organizationService.active();
	        $scope.roundingAv = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.AVIATION_ROUNDING);
	        $scope.roundingNonAv = _this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.NONAVIATION_ROUNDING);
	        // methods exposed to the template
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.selectedItem = function (item) { return _this.selectedItem(item); };
	        $scope.approve = function (notes) { return _this.approve(notes); };
	        $scope.reject = function (notes) { return _this.reject(notes); };
	        $scope.showWarning = function () { return _this.$scope.error = transactionsPendingService.showWarning(); };
	        // get transaction work flow settings and functions
	        _this.getTransactionSettings();
	        $scope.parseApprovalDocument = function (file) { return _this.parseApprovalDocument(file); };
	        // set initial values
	        $scope.can_approve = false;
	        $scope.can_reject = false;
	        // set pending transaction form properties and functions
	        currencyManagementService.listAll().then(function (data) { return $scope.currencyList = data.content; });
	        transactionsService.getPaymentMechanismList().then(function (data) { return $scope.paymentMechanisms = data; });
	        $scope.fileUploadDisabled = true;
	        $scope.fileUploadRequired = false;
	        $scope.absoluteValue = function (value) { return value ? Math.abs(value) : null; };
	        $scope.resetForm = function () { return _this.resetForm(); };
	        _this.getFilterParameters();
	        return _this;
	    }
	    TransactionsPendingController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            text_search: this.$scope.textFilter,
	            approval_name: this.$scope.filter,
	            by_current_role: false,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Refresh override to include custom filters and sort query.
	     */
	    TransactionsPendingController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    /**
	     * Handles application of the transaction workflow approval steps to pending transactions
	     * @param {ITransactionPending} item - The data associated with the selected row
	     */
	    TransactionsPendingController.prototype.getTransactionSettings = function () {
	        var _this = this;
	        this.transactionsWorkflowService.getAllWorkflowLevels().then(function (resp) {
	            _this.$scope.levels = resp.content;
	            _this.$scope.levels.forEach(function (item) {
	                if (item.approval_document_required) {
	                    _this.$scope.approval_document_level = item.level;
	                }
	            });
	        });
	    };
	    /**
	     * Code to run when an item is selected in the data grid
	     * @param {ITransactionPending} item - The data associated with the selected row
	     */
	    TransactionsPendingController.prototype.selectedItem = function (item) {
	        var _this = this;
	        this.$scope.selected = true;
	        this.transactionsPendingService.getOne(item.id).then(function (resp) {
	            // update settings with data from response
	            _this.$scope.invoices = resp.detailed_invoices;
	            _this.$scope.charges = resp.pending_charge_adjustments;
	            _this.$scope.can_reject = resp.can_reject;
	            _this.$scope.decimalPlaces = resp.payment_currency.decimal_places;
	            _this.$scope.can_approve = resp.can_approve;
	            _this.$scope.approvals = resp.pending_transaction_approvals;
	            // check to see if approval document is needed
	            if (resp.current_approval_level.level === _this.$scope.approval_document_level) {
	                _this.$scope.approval_document_required = true;
	            }
	            else {
	                _this.$scope.approval_document_required = false;
	            }
	        });
	        this.$scope.invoice_to_approve_id = this.$scope.editable.id;
	        this.$scope.editable.document_filename = item.supporting_document_name;
	        this.$scope.fileUploadDisabled = false;
	        this.resetApprovalDocument();
	    };
	    /**
	     * Approve pending transaction, backend determines next steps
	     */
	    TransactionsPendingController.prototype.approve = function (notes) {
	        var _this = this;
	        var fd = new FormData();
	        if (this.$scope.approval_document_required) {
	            fd.append('file', this.$scope.approval_document, this.$scope.approval_document_filename);
	        }
	        this.transactionsPendingService.approve(this.$scope.invoice_to_approve_id, fd, notes)
	            .then(function (resp) {
	            _this.refreshOverride();
	            _this.resetForm();
	        }).catch(function (error) { return _this.handleResponseError(error); });
	    };
	    /**
	     * Reject pending transaction, backend determines next steps
	     */
	    TransactionsPendingController.prototype.reject = function (notes) {
	        var _this = this;
	        this.transactionsPendingService.reject(this.$scope.editable.id, notes)
	            .then(function (resp) {
	            _this.refreshOverride();
	            _this.resetForm();
	        }).catch(function (error) { return _this.handleResponseError(error); });
	    };
	    /**
	     * Rejsets the form afetr approve/reject
	     */
	    TransactionsPendingController.prototype.resetForm = function () {
	        this.reset();
	        this.$scope.selected = false;
	        this.$scope.can_approve = false;
	        this.$scope.can_reject = false;
	        this.$scope.fileUploadDisabled = true;
	        this.$scope.approval_document_required = false;
	        this.$scope.notes = null;
	        this.resetApprovalDocument();
	    };
	    /**
	     * Clears out any previous approval document file selection properties.
	     */
	    TransactionsPendingController.prototype.resetApprovalDocument = function () {
	        this.$scope.approval_document_filename = null;
	        this.$scope.approval_document_mime_type = null;
	        this.$scope.approval_document = null;
	        this.$scope.approvalDocumentAcceptedFileType = null;
	    };
	    /**
	     * Handle response error within scope.
	     *
	     * @param error response error to hanlde
	     */
	    TransactionsPendingController.prototype.handleResponseError = function (error) {
	        this.$scope.error = {
	            error: error
	        };
	    };
	    /**
	     * Sets the required file information to the scope to be used when the user
	     * uploads the file and any related fields of data for approval document.
	     */
	    TransactionsPendingController.prototype.parseApprovalDocument = function (file) {
	        var _this = this;
	        var r = new FileReader();
	        if (file) {
	            r.onload = function (readerEvt) {
	                var binaryString = readerEvt.target.result;
	                var type = (file.name.substr(file.name.lastIndexOf('.') + 1) === 'csv' ? 'text/plain' : file.type);
	                var array = new Uint8Array(binaryString.length);
	                for (var i = 0, len = binaryString.length; i < len; i++) {
	                    array[i] = binaryString.charCodeAt(i);
	                }
	                _this.$scope.approval_document_filename = file.name;
	                _this.$scope.approval_document_mime_type = type;
	                _this.$scope.approval_document = new Blob([array], { type: type });
	                // grab file extension and compare with pattern of acceptable types
	                // compare lower case version of file ext to list of valid extensions
	                var fileNameSplit = _this.$scope.approval_document_filename.split('.');
	                _this.$scope.approvalDocumentAcceptedFileType = _this.$scope.pattern.includes(fileNameSplit[fileNameSplit.length - 1].toLowerCase());
	            };
	            r.readAsBinaryString(file);
	        }
	    };
	    return TransactionsPendingController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.TransactionsPendingController = TransactionsPendingController;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Required Controllers
	 */
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	/**
	 * Controls all CRUD operations for creating a Transaction Approval Workflow
	 */
	var TransactionsWorkflowController = (function (_super) {
	    __extends(TransactionsWorkflowController, _super);
	    /** @ngInject */
	    TransactionsWorkflowController.$inject = ["$scope", "transactionsWorkflowService", "currencyManagementService", "rolesService", "$translate"];
	    function TransactionsWorkflowController($scope, transactionsWorkflowService, currencyManagementService, rolesService, $translate) {
	        var _this = _super.call(this, $scope, transactionsWorkflowService) || this;
	        _this.$scope = $scope;
	        _this.transactionsWorkflowService = transactionsWorkflowService;
	        _this.currencyManagementService = currencyManagementService;
	        _this.rolesService = rolesService;
	        _this.$translate = $translate;
	        _super.prototype.setup.call(_this);
	        $scope.addNewLevel = function () { return _this.addNewLevel(); };
	        $scope.refreshAll = function () { return _this.refreshAll(); };
	        $scope.createWorkflowItems = function () { return _this.createWorkflowItems(); };
	        $scope.updateWorkflowItems = function () { return _this.updateWorkflowItems(); };
	        $scope.removeExistingLevel = function () { return _this.removeExistingLevel(); };
	        $scope.createNewWorkflow = function (steps) { return _this.createNewWorkflow(steps); };
	        $scope.updateItemApproval = function (fld, level, idx) { return _this.updateItemApproval(fld, level, idx); };
	        $scope.updateItemData = function (data, fld, id, idx) { return _this.updateItemData(data, fld, id, idx); };
	        $scope.updateApprovalDocumentLevel = function (twf) { return _this.updateApprovalDocumentLevel(twf); };
	        $scope.list = [];
	        $scope.levelLabel = _this.$translate.instant('Level');
	        _this.getCurrencies();
	        _this.getStatusTypes();
	        _this.getRoles();
	        _this.getFilterParameters();
	        return _this;
	    }
	    /**
	     * Update flag for 'approval_document_required'
	     */
	    TransactionsWorkflowController.prototype.refreshAll = function () {
	        var _this = this;
	        this.transactionsWorkflowService.getAllWorkflowLevels().then(function (resp) {
	            _this.$scope.list = resp.content;
	            _this.checkExistingWorkflow();
	        });
	    };
	    /**
	     * Update flag for 'approval_document_required'
	     */
	    TransactionsWorkflowController.prototype.updateApprovalDocumentLevel = function (twf) {
	        var _this = this;
	        var level = twf ? twf.level : -1;
	        this.$scope.list.forEach(function (item) {
	            if (item.approval_document_required) {
	                _this.$scope.approval_document_level = item;
	            }
	            item.approval_document_required = (item.level === level ? true : false);
	        });
	    };
	    /**
	     * Get all available currencies from the API
	     */
	    TransactionsWorkflowController.prototype.getCurrencies = function () {
	        var _this = this;
	        this.$scope.fullCurrencyList = [];
	        this.currencyManagementService.listAll().then(function (data) {
	            _this.$scope.fullCurrencyList = data.content;
	        });
	    };
	    /**
	     * Get all status types from the service
	     */
	    TransactionsWorkflowController.prototype.getStatusTypes = function () {
	        this.$scope.statusTypes = this.transactionsWorkflowService.getStatusTypes();
	    };
	    /**
	     * Get all roles/groups from the API
	     * @following: checkExistingWorkflow
	     */
	    TransactionsWorkflowController.prototype.getRoles = function () {
	        var _this = this;
	        this.rolesService.listAll().then(function (data) {
	            _this.$scope.roles = data.content;
	            _this.checkExistingWorkflow();
	        });
	    };
	    /**
	     * Determine if workflow steps exist and set the flag accordingly.
	     * @param {initalNumberOfSteps} number: preserves initial number of steps, controls how to save if steps are added or removed
	     */
	    TransactionsWorkflowController.prototype.checkExistingWorkflow = function () {
	        var _this = this;
	        this.$scope.steps = this.$scope.list.length;
	        if (this.$scope.list.length) {
	            this.$scope.createNew = false;
	            this.$scope.initalNumberOfSteps = this.$scope.steps;
	            this.$scope.newSteps = this.$scope.steps;
	            this.$scope.list.forEach(function (item) {
	                if (item.approval_document_required) {
	                    _this.$scope.approval_document_level = item;
	                }
	            });
	        }
	        else {
	            this.$scope.createNew = true;
	        }
	        ;
	    };
	    /**
	     * Creates a new workflow, deletes all existing steps
	     * @param {number} steps - The number of steps to create
	     */
	    TransactionsWorkflowController.prototype.createNewWorkflow = function (steps) {
	        this.$scope.list = [];
	        this.$scope.initalNumberOfSteps = steps;
	        this.$scope.createNew = true;
	        for (var i = 0; i < steps; i++) {
	            var item = this.transactionsWorkflowService.getModel();
	            item.level = i;
	            item.approval_name = this.$scope.levelLabel + " " + i;
	            if (i === 0) {
	                item.status_type = this.$scope.statusTypes[0];
	                item.delete = true;
	            }
	            else if (i === (steps - 1)) {
	                item.status_type = this.$scope.statusTypes[2];
	            }
	            else {
	                item.status_type = this.$scope.statusTypes[1];
	            }
	            ;
	            this.$scope.list.push(item);
	        }
	        ;
	    };
	    /**
	     * Adds a new step to the end of the workflow
	     */
	    TransactionsWorkflowController.prototype.addNewLevel = function () {
	        var item = this.transactionsWorkflowService.getModel();
	        item.level = this.$scope.list.length;
	        item.status_type = this.$scope.statusTypes[2];
	        item.approval_name = this.$scope.levelLabel + " " + item.level;
	        this.$scope.list[this.$scope.list.length - 1].status_type = this.$scope.statusTypes[1];
	        this.$scope.list.push(item);
	        this.$scope.steps = this.$scope.list.length;
	    };
	    /**
	     * Deletes an existing step from the end of the workflow
	     */
	    TransactionsWorkflowController.prototype.removeExistingLevel = function () {
	        this.$scope.list.pop();
	        this.$scope.list[this.$scope.list.length - 1].status_type = this.$scope.statusTypes[2];
	        this.$scope.steps = this.$scope.list.length;
	    };
	    /**
	     * Persists changes made on form to objects in the $scope.list[] object
	     * @param {any} data - The data object selected by the user on the UI
	     * @param {string} fld - The field in $scope.list[] to update
	     * @param {number} id - The link between the id of the data and the $scope.list[]
	     * @param {number} idx - The item in $scope.list[] to update
	     */
	    TransactionsWorkflowController.prototype.updateItemData = function (data, fld, id, idx) {
	        this.$scope.list[idx][fld] = data.find(function (obj) {
	            if (obj.id === id) {
	                return obj;
	            }
	            ;
	        });
	    };
	    /**
	     * Persists changes made on form using approval column dropdowns to objects in the $scope.list[] object
	     * @param {string} fld - The field in $scope.list[] to update
	     * @param {number} level - The level/step in $scope.list[]
	     * @param {number} idx - The item in $scope.list[] to update
	     */
	    TransactionsWorkflowController.prototype.updateItemApproval = function (fld, level, idx) {
	        this.$scope.list[idx][fld] = level;
	    };
	    /**
	     * POST $scope.list[] to the API, delete all existing records
	     */
	    TransactionsWorkflowController.prototype.createWorkflowItems = function () {
	        var _this = this;
	        if (!this.checkWorkflowItems()) {
	            return;
	        }
	        this.$scope.error = null;
	        this.transactionsWorkflowService.create(this.$scope.list).then(function (a) {
	            _this.$scope.createNew = false;
	            _this.list();
	        }, function (error) {
	            _this.$scope.error = {
	                error: {
	                    data: error.data
	                }
	            };
	        });
	    };
	    /**
	     * Updates the existing workflow steps
	     * PUT: Changes to existing steps;
	     * POST: New levels that have been added
	     * DELETE: Levels that have been removed
	     */
	    TransactionsWorkflowController.prototype.updateWorkflowItems = function () {
	        if (!this.checkWorkflowItems()) {
	            return;
	        }
	        var list = this.$scope.list;
	        for (var i = 0; i < list.length; i++) {
	            if (i < this.$scope.initalNumberOfSteps) {
	                this.transactionsWorkflowService.update(list[i], i);
	            }
	            else {
	                this.transactionsWorkflowService.createNew(list[i], i);
	            }
	        }
	        if (list.length < this.$scope.initalNumberOfSteps) {
	            for (var j = list.length; j < this.$scope.initalNumberOfSteps; j++) {
	                this.transactionsWorkflowService.delete(j);
	            }
	        }
	        this.$scope.initalNumberOfSteps = list.length;
	    };
	    TransactionsWorkflowController.prototype.checkWorkflowItems = function () {
	        var _this = this;
	        this.$scope.errorWorkflowItems = [];
	        this.$scope.erroredLevel = [];
	        this.$scope.list.forEach(function (element) {
	            var status_type = element.status_type, level = element.level, approval_under_level = element.approval_under_level, approval_over_level = element.approval_over_level, rejected_level = element.rejected_level, threshold_amount = element.threshold_amount, threshold_currency = element.threshold_currency;
	            // 'Approval Under' & 'Approval Equal Or Over' should be always higher then the current level
	            if (status_type !== 'FINAL' && (approval_under_level < level || approval_over_level < level)) {
	                _this.addErrorWorkflowItems(element, 'Approval Level should be higher then the current level');
	            }
	            // 'Threshold Amount' and 'Threshold Currency' should be specified if 'Approval Under' & 'Approval Equal Or Over' are not equal
	            if (approval_under_level !== approval_over_level && (!threshold_amount || !threshold_currency)) {
	                _this.addErrorWorkflowItems(element, 'Please enter Threshold Amount and Threshold Currency');
	            }
	            // 'Rejected Level' should be always lower then the current level
	            if (rejected_level > level) {
	                _this.addErrorWorkflowItems(element, 'Rejected Level should be lower then the current level');
	            }
	        });
	        if (this.$scope.errorWorkflowItems.length) {
	            this.$scope.error = this.showWorkflowItemsWarning(this.$scope.errorWorkflowItems);
	            return false;
	        }
	        return true;
	    };
	    TransactionsWorkflowController.prototype.showWorkflowItemsWarning = function (error) {
	        var workflowItemsWarning = {
	            data: {
	                error: 'Please check following requirements:',
	                field_errors: error
	            }
	        };
	        return { error: workflowItemsWarning };
	    };
	    TransactionsWorkflowController.prototype.erroredLevel = function (level) {
	        if (this.$scope.errorWorkflowItems && !this.$scope.erroredLevel.includes(level)) {
	            this.$scope.erroredLevel.push(level);
	        }
	    };
	    TransactionsWorkflowController.prototype.addErrorWorkflowItems = function (element, message) {
	        this.$scope.errorWorkflowItems.push({ level: element.level, field: element.approval_name, message: message });
	        this.erroredLevel(element.level);
	    };
	    TransactionsWorkflowController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    return TransactionsWorkflowController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.TransactionsWorkflowController = TransactionsWorkflowController;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var RevenueProjectionController = (function (_super) {
	    __extends(RevenueProjectionController, _super);
	    /* @ngInject */
	    RevenueProjectionController.$inject = ["$scope", "revenueProjectionService", "usersService", "$sce", "$translate"];
	    function RevenueProjectionController($scope, revenueProjectionService, usersService, $sce, $translate) {
	        var _this = _super.call(this, $scope, revenueProjectionService) || this;
	        _this.$scope = $scope;
	        _this.revenueProjectionService = revenueProjectionService;
	        _this.usersService = usersService;
	        _this.$sce = $sce;
	        _this.$translate = $translate;
	        _super.prototype.setup.call(_this);
	        $scope.changeStatus = function (status, enabled) { return _this.changeStatus(status, enabled); };
	        $scope.addToFormula = function (text, type) { return _this.addToFormula(text, type); };
	        $scope.getTrustedHtml = function (text) { return _this.getTrustedHtml(text); };
	        $scope.setFocusInput = function (text) { return _this.setFocusInput(text); };
	        $scope.doGenerate = function (format) { return _this.doGenerate(format); };
	        $scope.getFormulas = function () { return _this.getFormulas(); };
	        $scope.validate = function () { return _this.validate(); };
	        $scope.clearForm = function () { return _this.clearForm(); };
	        _this.clearForm();
	        _this.getFormulas();
	        return _this;
	    }
	    RevenueProjectionController.prototype.changeStatus = function (status, enabled) {
	        if (!enabled) {
	            if (typeof this.$scope.editable[status] === 'number') {
	                this.$scope.editable[status] = 0;
	            }
	            else {
	                this.$scope.editable[status] = '';
	            }
	            ;
	        }
	        ;
	        this.checkParameters();
	    };
	    RevenueProjectionController.prototype.clearForm = function () {
	        this.clearChecks();
	        this.$scope.editable.upper_limit = 900;
	        this.$scope.canGenerate = false;
	        this.$scope.formula = null;
	        this.$scope.validated = false;
	        this.$scope.processing = false;
	        this.$scope.noFormulas = false;
	    };
	    RevenueProjectionController.prototype.getFormulas = function () {
	        var _this = this;
	        this.revenueProjectionService.getFormulas(this.$scope.editable.upper_limit).then(function (resp) {
	            var keys = Object.keys(_this.$scope.editable);
	            keys.map(function (key) {
	                if (_this.$scope.editable.hasOwnProperty(key) && resp.hasOwnProperty(key)) {
	                    _this.$scope.enabled[key + "_enabled"] = true;
	                    _this.$scope.editable[key] = resp[key];
	                }
	            });
	            _this.checkParameters();
	        });
	    };
	    RevenueProjectionController.prototype.checkParameters = function () {
	        var _this = this;
	        var set = 0;
	        Object.keys(this.$scope.enabled).reduce(function (p, c) {
	            if (_this.$scope.enabled[c]) {
	                return set++;
	            }
	            ;
	        }, {});
	        if (set > 0) {
	            this.$scope.canGenerate = true;
	        }
	        else {
	            this.$scope.canGenerate = false;
	        }
	        ;
	    };
	    RevenueProjectionController.prototype.doGenerate = function (format) {
	        var _this = this;
	        this.$scope.editable.format = format;
	        this.$scope.processing = true;
	        this.$scope.validated = false;
	        this.revenueProjectionService.doGenerate(this.$scope.editable).then(function (resp) {
	            _this.$scope.processing = false;
	            var blob;
	            var filename;
	            if (format === 'PDF') {
	                blob = new Blob([resp], { type: 'application/pdf' });
	                filename = 'revenue_projection.pdf';
	            }
	            else {
	                blob = new Blob([resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	                filename = 'revenue_projection.xlsx';
	            }
	            ;
	            var downloadLink = angular.element('<a></a>');
	            downloadLink.attr('href', window.URL.createObjectURL(blob));
	            downloadLink.attr('download', filename);
	            downloadLink[0].click();
	        }, function (err) {
	            _this.$scope.processing = false;
	        });
	    };
	    RevenueProjectionController.prototype.setFocusInput = function (text) {
	        if (text) {
	            this.$scope.formula = angular.element(document.getElementById(text))[0];
	            angular.element(document.getElementById(text))[0].focus();
	        }
	        else {
	            this.$scope.formula = null;
	        }
	        ;
	    };
	    RevenueProjectionController.prototype.addToFormula = function (text, type) {
	        var name = this.$scope.formula.name;
	        var eolReg = new RegExp(/[\+\-\*\/\(\)\√]$/);
	        var eolTest = eolReg.test(this.$scope.editable[name]);
	        this.$scope.formulaError = null;
	        if (!this.$scope.editable[name]) {
	            if (type === 'op') {
	                this.$scope.formulaError = 'Formula cannot start with operator.';
	            }
	            ;
	        }
	        else {
	            if (eolTest && type === 'op') {
	                this.$scope.formulaError = 'Operator already selected.';
	            }
	            else if (!eolTest && type !== 'op') {
	                this.$scope.formulaError = 'Operator required.';
	            }
	            ;
	        }
	        ;
	        if (!this.$scope.formulaError) {
	            this.$scope.editable[this.$scope.formula.name] += text;
	        }
	        ;
	    };
	    RevenueProjectionController.prototype.validate = function () {
	        var _this = this;
	        this.$scope.validated = false;
	        this.revenueProjectionService.validateSingle(this.$scope.editable).then(function (resp) {
	            _this.$scope.validated = true;
	            _this.$scope.data_results = resp;
	        });
	    };
	    RevenueProjectionController.prototype.getTrustedHtml = function (text) {
	        var output;
	        if (text) {
	            output = this.$sce.trustAsHtml(text);
	        }
	        else {
	            output = 'None';
	        }
	        return this.$translate.instant(output);
	    };
	    RevenueProjectionController.prototype.clearChecks = function () {
	        this.$scope.enabled = {
	            upper_limit_enabled: true,
	            domestic_formula_enabled: false,
	            regional_departure_formula_enabled: false,
	            regional_arrival_formula_enabled: false,
	            regional_overflight_formula_enabled: false,
	            international_departure_formula_enabled: false,
	            international_arrival_formula_enabled: false,
	            international_overflight_formula_enabled: false,
	            w_factor_formula_enabled: false,
	            domestic_d_factor_formula_enabled: false,
	            reg_dep_d_factor_formula_enabled: false,
	            reg_arr_d_factor_formula_enabled: false,
	            reg_ovr_d_factor_formula_enabled: false,
	            int_dep_d_factor_formula_enabled: false,
	            int_arr_d_factor_formula_enabled: false,
	            int_ovr_d_factor_formula_enabled: false,
	            charges_passenger_enabled: false,
	            charges_approach_enabled: false,
	            charges_aerodrome_enabled: false,
	            charges_late_arrival_enabled: false,
	            charges_late_departure_enabled: false,
	            charges_vol_flights_enabled: false,
	            charges_vol_passengers_enabled: false
	        };
	    };
	    return RevenueProjectionController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.RevenueProjectionController = RevenueProjectionController;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var CurrentUserController = (function (_super) {
	    __extends(CurrentUserController, _super);
	    /* @ngInject */
	    CurrentUserController.$inject = ["$scope", "usersService", "systemConfigurationService", "passwordChangeService"];
	    function CurrentUserController($scope, usersService, systemConfigurationService, passwordChangeService) {
	        var _this = _super.call(this, $scope, passwordChangeService) || this;
	        _this.$scope = $scope;
	        _this.usersService = usersService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.passwordChangeService = passwordChangeService;
	        _super.prototype.setup.call(_this, { refresh: false });
	        _this.usersService.current.then(function (user) {
	            var email = user.email, login = user.login, sms_number = user.sms_number;
	            $scope.login = login;
	            $scope.editable.email = email;
	            $scope.editable.sms_number = sms_number;
	            $scope.editable.new_password = null;
	        });
	        // expose necessary methods to scope
	        $scope.resetPassword = function (setZeroLength) { return _this.resetPassword(setZeroLength); };
	        // get minlength system configuration value and update scope
	        $scope.passwordMinLength = parseInt(systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_MINIMUM_LENGTH), 10);
	        $scope.updatePassword = function (changePassword) { return usersService.updatePassword(changePassword)
	            .then(function (response) {
	            if (response) {
	                _this.passwordChangeService.passwordChangedMessage(false);
	            }
	            $scope.editable.old_password = '';
	            $scope.resetPassword();
	        }).catch(function (error) { return _this.$scope.error = { error: error }; }); };
	        return _this;
	    }
	    /**
	     * Reset password values, validation and flags.
	     *
	     * @param setZeroLength true to set password to zero length
	     */
	    CurrentUserController.prototype.resetPassword = function (setZeroLength) {
	        setZeroLength = setZeroLength || false;
	        // set password to an empty string if isZeroLength
	        // else set to undefined to symbolize an untouched/unset value
	        if (setZeroLength) {
	            this.$scope.editable.new_password = '';
	        }
	        else {
	            delete (this.$scope.editable.new_password);
	        }
	        // used to call password directive resetPass method
	        // this will clean password fields and validatin flags/messages
	        this.$scope.resetPass = new Date().getTime();
	    };
	    return CurrentUserController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.CurrentUserController = CurrentUserController;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var FlightReassignmentScopeController = (function (_super) {
	    __extends(FlightReassignmentScopeController, _super);
	    /* @ngInject */
	    FlightReassignmentScopeController.$inject = ["$scope", "$rootScope", "flightReassignmentService", "aerodromesService"];
	    function FlightReassignmentScopeController($scope, $rootScope, flightReassignmentService, aerodromesService) {
	        var _this = _super.call(this, $scope, flightReassignmentService) || this;
	        _this.$scope = $scope;
	        _this.flightReassignmentService = flightReassignmentService;
	        _this.aerodromesService = aerodromesService;
	        _this.nameMap = {
	            applies_to_type_arrival: 'ARR',
	            applies_to_type_departure: 'DEP',
	            applies_to_type_domestic: 'DOM',
	            applies_to_type_overflight: 'OVF',
	            applies_to_scope_domestic: 'DOM',
	            applies_to_scope_regional: 'REG',
	            applies_to_scope_international: 'INT',
	            applies_to_nationality_national: 'NAT',
	            applies_to_nationality_foreign: 'INT'
	        };
	        _super.prototype.setup.call(_this);
	        aerodromesService.listAll().then(function (aerodromes) { return $scope.aerodromesList = aerodromes.content; });
	        _this.getFilterParameters();
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.getApplication = function (item, type) { return _this.getApplication(item, type); };
	        $scope.setMaxLength = function (idType) { return _this.setMaxLength(idType); };
	        $scope.getAerodromeIdentifiers = function (aerodromeIdentifiers) { return _this.getAerodromeIdentifiers(aerodromeIdentifiers); };
	        _this.$scope.aerodromesModel = [];
	        $scope.addAerodromeToList = function () { return $scope.editable.aerodrome_identifiers = $scope.aerodromesModel.map(function (aerodrome) { return aerodrome.aerodrome_name; }); };
	        $scope.updateAerodromeMultiselect = function () {
	            $scope.aerodromesModel = $scope.aerodromesList.filter(function (aerodrome) { return $scope.editable.aerodrome_identifiers.indexOf(aerodrome.aerodrome_name) > -1; });
	        };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    FlightReassignmentScopeController.prototype.setMaxLength = function (idType) {
	        if (idType === 'ICAO code') {
	            this.$scope.maxLength = 3;
	        }
	        else if (idType === 'Flight Id') {
	            this.$scope.maxLength = 7;
	        }
	        else {
	            this.$scope.maxLength = 20;
	        }
	        ;
	    };
	    FlightReassignmentScopeController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            filter: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0,
	            account: this.$scope.accountFilter
	        };
	    };
	    FlightReassignmentScopeController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    FlightReassignmentScopeController.prototype.getApplication = function (item, type) {
	        var output = '';
	        for (var p in item) {
	            if (item.hasOwnProperty(p)) {
	                if (p.indexOf(type) !== -1 && item[p]) {
	                    output += this.nameMap[p] + ', ';
	                }
	                ;
	            }
	        }
	        ;
	        return output.replace(/(^\s*,)|(,\s*$)/g, '');
	    };
	    FlightReassignmentScopeController.prototype.getAerodromeIdentifiers = function (aerodromeIdentifiers) {
	        var arr = aerodromeIdentifiers.slice(0, 14);
	        return arr.join(', ');
	    };
	    return FlightReassignmentScopeController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.FlightReassignmentScopeController = FlightReassignmentScopeController;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var BankAccountManagementController = (function (_super) {
	    __extends(BankAccountManagementController, _super);
	    /* @ngInject */
	    BankAccountManagementController.$inject = ["$scope", "$rootScope", "bankAccountManagementService", "systemConfigurationService"];
	    function BankAccountManagementController($scope, $rootScope, bankAccountManagementService, systemConfigurationService) {
	        var _this = _super.call(this, $scope, bankAccountManagementService) || this;
	        _this.$scope = $scope;
	        _this.bankAccountManagementService = bankAccountManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.setup();
	        _this.getFilterParameters();
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    /**
	     * Setup method override, add scope functions and properties.
	     */
	    BankAccountManagementController.prototype.setup = function () {
	        var _this = this;
	        // call parent setup method, required to override parent scope functions and properties
	        _super.prototype.setup.call(this);
	        // override refresh scope method with refresh override above
	        this.$scope.refresh = function () { return _this.refresh(); };
	        // add scope boolean flag for external identifier requirement
	        this.$scope.requireExternalSystemId = this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_BANK_ACCOUNT_EXTERNAL_SYSTEM_ID);
	    };
	    /**
	     * Refresh method override, adds scope filters, pagination, sort query.
	     */
	    BankAccountManagementController.prototype.refresh = function () {
	        this.getFilterParameters();
	        return _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    BankAccountManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    return BankAccountManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.BankAccountManagementController = BankAccountManagementController;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var system_configuration_constants_1 = __webpack_require__(10);
	var UnifiedTaxManagementController = (function (_super) {
	    __extends(UnifiedTaxManagementController, _super);
	    /* @ngInject */
	    UnifiedTaxManagementController.$inject = ["$scope", "unifiedTaxManagementService", "unifiedTaxValidityManagementService", "systemConfigurationService", "customDate"];
	    function UnifiedTaxManagementController($scope, unifiedTaxManagementService, unifiedTaxValidityManagementService, systemConfigurationService, customDate) {
	        var _this = _super.call(this, $scope, unifiedTaxManagementService) || this;
	        _this.$scope = $scope;
	        _this.unifiedTaxManagementService = unifiedTaxManagementService;
	        _this.unifiedTaxValidityManagementService = unifiedTaxValidityManagementService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _this.service = unifiedTaxValidityManagementService;
	        _this.serviceValidity = unifiedTaxValidityManagementService;
	        _this.serviceTax = unifiedTaxManagementService;
	        _this.setup();
	        $scope.reset = function () { return _this.reset(); };
	        $scope.addToFormula = function (text) { return _this.addToFormula(text); };
	        _this.getFilterParameters();
	        //$scope.customDate = this.customDate.returnDateFormatStr(false);
	        _this.unifiedTaxValidityManagementService.getList().then(function (validities) {
	            $scope.listUnifiedTaxValidity = validities;
	            _this.getFilterParameters();
	        });
	        return _this;
	    }
	    /**
	    * Setup method override, add scope functions and properties.
	    */
	    UnifiedTaxManagementController.prototype.setup = function () {
	        var _this = this;
	        this.$scope.customDate = this.customDate.returnDateFormatStr(false);
	        // call parent setup method, required to override parent scope functions and properties
	        _super.prototype.setup.call(this);
	        // override refresh scope method with refresh override above
	        this.$scope.createValidity = function (validity) { return _this.createValidity(validity); };
	        this.$scope.createTax = function (tax) { return _this.createTax(tax); };
	        this.$scope.updateValidity = function (validity, id) { return _this.updateValidity(validity, id); };
	        this.$scope.updateTax = function (tax, id) { return _this.updateTax(tax, id); };
	        this.$scope.deleteValidity = function (validity) { return _this.deleteValidity(validity); };
	        this.$scope.deleteTax = function (tax) { return _this.deleteTax(tax); };
	        this.$scope.refresh = function () { return _this.refreshOverride(); };
	        this.$scope.refreshOverride = function () { return _this.refreshOverride(); };
	        this.$scope.refreshOverrideUnifiedTaxValidity = function () { return _this.refreshOverrideUnifiedTaxValidity(); };
	        this.$scope.refreshOverrideUnifiedTax = function () { return _this.refreshOverrideUnifiedTax(); };
	        this.$scope.editValidity = function (validity) { return _this.editValidity(validity); };
	        this.$scope.editTax = function (tax) { return _this.editTax(tax); };
	        this.$scope.onChangeFormula = function () { return _this.onChangeFormula(); };
	        this.$scope.resetValidity = function () { return _this.resetValidity(); };
	        this.$scope.resetTax = function () { return _this.resetTax(); };
	        this.$scope.validateValidityDates = function (fromValidityYear, toValidityYear) { return _this.validateValidityDates(fromValidityYear, toValidityYear); };
	        this.$scope.validateTaxDates = function (fromManufactureYear, toManufactureYear) { return _this.validateTaxDates(fromManufactureYear, toManufactureYear); };
	        this.$scope.showTaxes = function (validity) { return _this.showTaxes(validity); };
	        // add scope boolean flag for external identifier requirement
	        this.$scope.requireExternalSystemId = this.systemConfigurationService
	            .getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.REQUIRE_UNIFIED_TAX_EXTERNAL_SYSTEM_ID);
	        this.resetValidity();
	        this.resetTax();
	    };
	    /**
	      * Sets the form to edit the single entry of tax validity
	      * @param {Object} data   entity to edit
	      */
	    UnifiedTaxManagementController.prototype.editValidity = function (data) {
	        this.$scope.error = null;
	        this.$scope.editableValidity = angular.copy(data);
	        var fromString = this.$scope.editableValidity.from_validity_year;
	        var toString = this.$scope.editableValidity.to_validity_year;
	        if (fromString) {
	            this.$scope.editableValidity.from_validity_year = new Date(fromString);
	        }
	        if (toString) {
	            this.$scope.editableValidity.to_validity_year = new Date(toString);
	        }
	    };
	    UnifiedTaxManagementController.prototype.refreshOverride = function () {
	        return this.refreshOverrideUnifiedTaxValidity();
	    };
	    /**
	     * Sets the form to edit the single entry of tax item
	     * @param {Object} data   entity to edit
	     */
	    UnifiedTaxManagementController.prototype.editTax = function (data) {
	        this.$scope.error = null;
	        this.$scope.editableTax = angular.copy(data);
	        this.$scope.formula = this.$scope.editableTax.charge_formula;
	        var fromString = this.$scope.editableTax.from_manufacture_year;
	        var toString = this.$scope.editableTax.to_manufacture_year;
	        if (fromString) {
	            this.$scope.editableTax.from_manufacture_year = new Date(fromString);
	        }
	        if (toString) {
	            this.$scope.editableTax.to_manufacture_year = new Date(toString);
	        }
	    };
	    /**
	     * Resets the form
	     */
	    UnifiedTaxManagementController.prototype.resetValidity = function () {
	        this.$scope.error = null;
	        this.$scope.editableValidity = angular.copy(this.service.model);
	        if (this.$scope.formValidity) {
	            this.$scope.formValidity.$setUntouched();
	        }
	    };
	    /**
	     * Resets the form
	     */
	    UnifiedTaxManagementController.prototype.resetTax = function () {
	        this.$scope.error = null;
	        this.$scope.editableTax = angular.copy(this.service.model);
	        if (this.$scope.formTax) {
	            this.$scope.formTax.$setUntouched();
	        }
	        this.$scope.editableTax.rate = "";
	        this.$scope.formula = "";
	    };
	    UnifiedTaxManagementController.prototype.onChangeFormula = function () {
	        this.$scope.formula = this.$scope.editableTax.charge_formula;
	    };
	    /**
	     * Refresh method override, adds scope filters, pagination, sort query.
	     */
	    //angular.IPromise<void>
	    UnifiedTaxManagementController.prototype.refreshOverrideUnifiedTaxValidity = function () {
	        var _this = this;
	        this.service = this.serviceValidity;
	        this.$scope.selectedValidity = null;
	        this.$scope.listUnifiedTax = null;
	        this.$scope.listUnifiedTaxValidity = null;
	        this.getFilterParameters();
	        return this.unifiedTaxValidityManagementService.getList().then(function (validities) {
	            _this.$scope.listUnifiedTaxValidity = validities;
	            _this.getFilterParameters();
	        });
	    };
	    UnifiedTaxManagementController.prototype.refreshOverrideUnifiedTax = function () {
	        var _this = this;
	        this.service = this.serviceValidity;
	        //this.$scope.selectedValidity = null;
	        this.$scope.listUnifiedTax = null;
	        //this.$scope.listUnifiedTaxValidity = null;
	        this.getFilterParameters();
	        if (this.$scope.selectedValidity != null) {
	            return this.unifiedTaxManagementService.getListByValidityId(this.$scope.selectedValidity.id)
	                .then(function (taxes) {
	                _this.$scope.listUnifiedTax = taxes;
	                _this.getFilterParameters();
	            });
	        }
	    };
	    UnifiedTaxManagementController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.search,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    UnifiedTaxManagementController.prototype.showTaxes = function (validity) {
	        var _this = this;
	        this.unifiedTaxManagementService.getListByValidityId(validity.id)
	            .then(function (taxes) {
	            _this.$scope.listUnifiedTax = taxes;
	            _this.getFilterParameters();
	        });
	        this.$scope.selectedValidity = validity;
	        this.editValidity(validity);
	    };
	    UnifiedTaxManagementController.prototype.createValidity = function (data) {
	        this.service = this.serviceValidity;
	        var toRet = _super.prototype.create.call(this, data);
	        this.refreshOverrideUnifiedTaxValidity();
	        this.resetValidity();
	        return toRet;
	    };
	    UnifiedTaxManagementController.prototype.createTax = function (data) {
	        var _this = this;
	        this.service = this.serviceTax;
	        data.validity = this.$scope.selectedValidity;
	        var toRet = _super.prototype.create.call(this, data).then(function () {
	            _this.showTaxes(_this.$scope.selectedValidity);
	        });
	        this.resetTax();
	        return toRet;
	    };
	    UnifiedTaxManagementController.prototype.updateValidity = function (data, id) {
	        this.service = this.serviceValidity;
	        var toRet = _super.prototype.update.call(this, data, id);
	        this.refreshOverrideUnifiedTaxValidity();
	        this.resetValidity();
	        return toRet;
	    };
	    UnifiedTaxManagementController.prototype.updateTax = function (data, id) {
	        var _this = this;
	        this.service = this.serviceTax;
	        var toRet = _super.prototype.update.call(this, data, id).then(function () {
	            _this.showTaxes(_this.$scope.selectedValidity);
	        });
	        this.resetTax();
	        return toRet;
	    };
	    UnifiedTaxManagementController.prototype.list = function (data, queryString, endpoint) {
	        this.service = this.serviceValidity;
	        return _super.prototype.list.call(this, data, queryString, endpoint);
	    };
	    /**
	     * Calls the service delete method then resets the form
	     * @param {number} id  the id to delete
	     */
	    UnifiedTaxManagementController.prototype.deleteValidity = function (id) {
	        this.service = this.serviceValidity;
	        var toRet = _super.prototype.delete.call(this, id);
	        this.refreshOverrideUnifiedTaxValidity();
	        this.resetValidity();
	        return toRet;
	    };
	    /**
	     * Calls the service delete method then resets the form
	     * @param {number} id  the id to delete
	     */
	    UnifiedTaxManagementController.prototype.deleteTax = function (id) {
	        var _this = this;
	        this.service = this.serviceTax;
	        var toRet = _super.prototype.delete.call(this, id).then(function () {
	            _this.showTaxes(_this.$scope.selectedValidity);
	        });
	        this.resetTax();
	        return toRet;
	    };
	    UnifiedTaxManagementController.prototype.validateValidityDates = function (fromValidityYear, toValidityYear) {
	        if (fromValidityYear != null || toValidityYear != null) {
	            return true;
	        }
	        return false;
	    };
	    UnifiedTaxManagementController.prototype.validateTaxDates = function (fromManufactureYear, toManufactureYear) {
	        if (fromManufactureYear != null || toManufactureYear != null) {
	            return true;
	        }
	        return false;
	    };
	    UnifiedTaxManagementController.prototype.addToFormula = function (text) {
	        this.$scope.ifValidate = true;
	        if (!this.$scope.formula) {
	            this.$scope.formula = text;
	        }
	        else {
	            this.$scope.formula += text;
	        }
	        if (this.$scope.index >= 0 && this.$scope.field) {
	            this.$scope.editable.unified_tax_formulas[this.$scope.index][this.$scope.field] = this.$scope.formula;
	        }
	        else {
	            this.$scope.editableTax.charge_formula = this.$scope.formula;
	        }
	    };
	    return UnifiedTaxManagementController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.UnifiedTaxManagementController = UnifiedTaxManagementController;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_form_user_service_controller_1 = __webpack_require__(3);
	var SSOProvidersController = (function (_super) {
	    __extends(SSOProvidersController, _super);
	    /* @ngInject */
	    SSOProvidersController.$inject = ["$scope", "$state", "ssoProvidersService", "systemConfigurationService", "billingCentreManagementService"];
	    function SSOProvidersController($scope, $state, ssoProvidersService, systemConfigurationService, billingCentreManagementService) {
	        var _this = _super.call(this, $scope, ssoProvidersService) || this;
	        _this.$scope = $scope;
	        _this.$state = $state;
	        _this.ssoProvidersService = ssoProvidersService;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.billingCentreManagementService = billingCentreManagementService;
	        _this.KEYCLOAK_KEY = "KEYCLOAK";
	        _this.AVAILABLE_PROVIDES = [_this.KEYCLOAK_KEY];
	        _super.prototype.setup.call(_this, { refresh: false });
	        _super.prototype.list.call(_this, {}, "search=");
	        $scope.availableProviderTypes = _this.AVAILABLE_PROVIDES;
	        $scope.hasBaseUrl = false;
	        $scope.hasRealm = false;
	        $scope.refresh = function () { return _this.refreshOverride(); };
	        $scope.reset = function () { return _this.resetOverride(); };
	        $scope.create = function (editable) { return _this.createOverride(editable); };
	        $scope.update = function (editable, id) { return _this.updateOverride(editable, id); };
	        $scope.delete = function (id) { return _this.deleteOverride(id); };
	        $scope.$watch('editable.type', function (selectedProvider) {
	            $scope.showCustomProperties(selectedProvider);
	        });
	        $scope.showCustomProperties = function (selectedProvider) {
	            /** RESET ALL CUSTOM PROPERTIES. */
	            $scope.hasBaseUrl = false;
	            $scope.hasRealm = false;
	            if (!selectedProvider) {
	                return;
	            }
	            if (selectedProvider === _this.KEYCLOAK_KEY) {
	                $scope.hasBaseUrl = true;
	                $scope.hasRealm = true;
	            }
	            /**
	             * ADD HERE CUSTOM PROVIDER CONFIGURATION.
	             *
	             * hasTenant = ['MICROSOFT_AZURE_AD', 'MICROSOFT_AD_B2C', 'ORACLE'];
	             * hasPolicy = ['MICROSOFT_AD_B2C'];
	             *
	             * */
	        };
	        return _this;
	    }
	    SSOProvidersController.prototype.getFilterParameters = function () {
	        this.$scope.filterParameters = {
	            search: this.$scope.textFilter,
	            page: this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    SSOProvidersController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString(), 'providers');
	    };
	    SSOProvidersController.prototype.resetOverride = function () {
	        _super.prototype.reset.call(this);
	    };
	    SSOProvidersController.prototype.updateOverride = function (editable, id) {
	        var _this = this;
	        _super.prototype.update.call(this, editable, id).then(function () { return _this.resetOverride(); });
	    };
	    SSOProvidersController.prototype.deleteOverride = function (id) {
	        var _this = this;
	        _super.prototype.delete.call(this, id).then(function () { return _this.resetOverride(); });
	    };
	    SSOProvidersController.prototype.createOverride = function (editable) {
	        var _this = this;
	        _super.prototype.create.call(this, editable).then(function () { return _this.resetOverride(); });
	    };
	    return SSOProvidersController;
	}(crud_form_user_service_controller_1.CRUDFormControllerUserService));
	exports.SSOProvidersController = SSOProvidersController;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var crud_file_handler_controller_1 = __webpack_require__(23);
	var AodbController = (function (_super) {
	    __extends(AodbController, _super);
	    /* @ngInject */
	    AodbController.$inject = ["$scope", "$rootScope", "aodbService", "$uibModal", "systemConfigurationService", "customDate"];
	    function AodbController($scope, $rootScope, aodbService, $uibModal, systemConfigurationService, customDate) {
	        var _this = _super.call(this, $scope, aodbService, $uibModal, 'File Name') || this;
	        _this.$scope = $scope;
	        _this.aodbService = aodbService;
	        _this.$uibModal = $uibModal;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this.customDate = customDate;
	        _super.prototype.setup.call(_this);
	        $scope.$watchGroup(['search', 'control'], function () { return _this.getFilterParameters(); });
	        _this.$scope.customDate = _this.customDate.returnDateFormatStr(false);
	        $scope.refreshOverride = function () { return _this.refreshOverride(); };
	        $scope.saveOldValue = function () {
	            $rootScope.oldFormData = angular.copy($scope.editable);
	        };
	        return _this;
	    }
	    AodbController.prototype.getFilterParameters = function () {
	        var startDate;
	        var endDate;
	        if (this.$scope.control && this.$scope.control.getUTCStartDate()) {
	            startDate = this.$scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.$scope.control && this.$scope.control.getUTCEndDate()) {
	            endDate = this.$scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        this.$scope.filterParameters = {
	            'search': this.$scope.search,
	            'start': startDate,
	            'end': endDate,
	            'page': this.$scope.pagination ? this.$scope.pagination.number : 0
	        };
	    };
	    /**
	     * Calls list with applied filters
	     *
	     * @returns void
	     */
	    AodbController.prototype.refreshOverride = function () {
	        this.getFilterParameters();
	        _super.prototype.list.call(this, this.$scope.filterParameters, this.$scope.getSortQueryString());
	    };
	    return AodbController;
	}(crud_file_handler_controller_1.CRUDFileUploadController));
	exports.AodbController = AodbController;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** serviceInject */
	var sc_report_generation_service_1 = __webpack_require__(136);
	var sc_flight_search_service_1 = __webpack_require__(137);
	var sc_inactivity_expiry_notice_service_1 = __webpack_require__(138);
	var aerodrome_operational_hours_service_1 = __webpack_require__(139);
	var interest_rates_service_1 = __webpack_require__(140);
	var service_outages_service_1 = __webpack_require__(141);
	var sc_approval_request_service_1 = __webpack_require__(142);
	var password_change_service_1 = __webpack_require__(143);
	var aircraft_flights_exemptions_service_1 = __webpack_require__(144);
	var sc_passenger_service_charge_return_service_1 = __webpack_require__(145);
	var sc_credit_payment_service_1 = __webpack_require__(147);
	var sc_invoices_service_1 = __webpack_require__(148);
	var sc_transactions_service_1 = __webpack_require__(149);
	var sc_flight_schedules_service_1 = __webpack_require__(150);
	var sc_aircraft_registration_service_1 = __webpack_require__(151);
	var sc_user_management_service_1 = __webpack_require__(152);
	var sc_user_registration_service_1 = __webpack_require__(153);
	var sc_account_management_service_1 = __webpack_require__(154);
	var sc_flight_cost_calculation_service_1 = __webpack_require__(155);
	var sc_query_submission_service_1 = __webpack_require__(156);
	var sc_login_service_1 = __webpack_require__(157);
	var cached_events_service_1 = __webpack_require__(159);
	var flight_schedule_management_service_1 = __webpack_require__(160);
	var local_aircraft_registry_service_1 = __webpack_require__(161);
	var user_event_log_service_1 = __webpack_require__(162);
	var application_management_service_1 = __webpack_require__(163);
	var non_aviation_billing_engine_service_1 = __webpack_require__(164);
	var revenue_data_service_1 = __webpack_require__(165);
	var rejected_items_service_1 = __webpack_require__(47);
	var recurring_charges_service_1 = __webpack_require__(166);
	var report_generation_service_1 = __webpack_require__(167);
	var air_traffic_data_service_1 = __webpack_require__(168);
	var report_templates_service_1 = __webpack_require__(169);
	var tower_movement_logs_service_1 = __webpack_require__(170);
	var repositioning_aerodrome_clusters_service_1 = __webpack_require__(171);
	var system_summary_service_1 = __webpack_require__(172);
	var atc_movement_log_service_1 = __webpack_require__(173);
	var billing_centre_management_service_1 = __webpack_require__(174);
	var unspecified_dep_dest_locations_service_1 = __webpack_require__(175);
	var nominal_routes_service_1 = __webpack_require__(176);
	var flight_status_exemptions_service_1 = __webpack_require__(177);
	var flight_route_exemptions_service_1 = __webpack_require__(178);
	var aircraft_unspecified_management_service_1 = __webpack_require__(179);
	var radar_summary_service_1 = __webpack_require__(180);
	var invoice_template_management_service_1 = __webpack_require__(181);
	var enroute_air_navigation_charges_management_service_1 = __webpack_require__(182);
	var catalogue_service_charge_service_1 = __webpack_require__(183);
	var flight_movement_management_service_1 = __webpack_require__(184);
	var flight_types_service_1 = __webpack_require__(75);
	var airspace_management_service_1 = __webpack_require__(185);
	var account_exempt_management_service_1 = __webpack_require__(186);
	var utilities_towns_service_1 = __webpack_require__(187);
	var utilities_schedules_service_1 = __webpack_require__(188);
	var regional_country_management_service_1 = __webpack_require__(189);
	var aircraft_exempt_management_service_1 = __webpack_require__(190);
	var crco_management_service_1 = __webpack_require__(191);
	var crco_connection_service_1 = __webpack_require__(192);
	var crco_certificates_service_1 = __webpack_require__(193);
	var crco_cor_request_service_1 = __webpack_require__(194);
	var crco_archive_service_1 = __webpack_require__(195);
	var crco_messages_service_1 = __webpack_require__(196);
	var crco_claims_service_1 = __webpack_require__(197);
	var crco_reporting_responsabilities_service_1 = __webpack_require__(198);
	var mtow_service_1 = __webpack_require__(199);
	var invoice_state_type_service_1 = __webpack_require__(200);
	var invoices_service_1 = __webpack_require__(201);
	var air_navigation_charges_service_1 = __webpack_require__(202);
	var system_configuration_service_1 = __webpack_require__(203);
	var passenger_service_charge_return_service_1 = __webpack_require__(204);
	var transactions_service_1 = __webpack_require__(205);
	var aircraft_registration_service_1 = __webpack_require__(206);
	var wake_turbulence_category_service_1 = __webpack_require__(207);
	var roles_service_1 = __webpack_require__(208);
	var permissions_service_1 = __webpack_require__(112);
	var types_service_1 = __webpack_require__(209);
	var country_management_service_1 = __webpack_require__(210);
	var currency_management_service_1 = __webpack_require__(211);
	var accounts_service_1 = __webpack_require__(212);
	var aerodrome_category_management_service_1 = __webpack_require__(213);
	var aerodromes_service_1 = __webpack_require__(214);
	var users_service_1 = __webpack_require__(7);
	var login_service_1 = __webpack_require__(215);
	var config_service_1 = __webpack_require__(216);
	var aircraft_type_management_service_1 = __webpack_require__(217);
	var saveLocalTemplate_service_1 = __webpack_require__(218);
	var oauth_service_1 = __webpack_require__(219);
	var transaction_types_service_1 = __webpack_require__(220);
	var about_service_1 = __webpack_require__(221);
	var route_segments_service_1 = __webpack_require__(222);
	var currency_exchange_rates_service_1 = __webpack_require__(223);
	var reports_service_1 = __webpack_require__(224);
	var dbquery_service_1 = __webpack_require__(225);
	var aviation_billing_engine_service_1 = __webpack_require__(226);
	var convert_item_type_service_1 = __webpack_require__(48);
	var debounce_service_1 = __webpack_require__(227);
	var plugins_service_1 = __webpack_require__(228);
	var languages_service_1 = __webpack_require__(229);
	var localeSwitcher_service_1 = __webpack_require__(230);
	var amhs_connection_service_1 = __webpack_require__(231);
	var amhs_accounts_service_1 = __webpack_require__(232);
	var transactions_pending_service_1 = __webpack_require__(233);
	var transactions_workflow_service_1 = __webpack_require__(234);
	var translate_run_1 = __webpack_require__(235);
	var release_notes_service_1 = __webpack_require__(236);
	var external_database_input_service_1 = __webpack_require__(237);
	var window_location_service_1 = __webpack_require__(238);
	var sysConfigBoolean_service_1 = __webpack_require__(239);
	var revenue_projection_service_1 = __webpack_require__(240);
	var customDate_service_1 = __webpack_require__(241);
	var external_charge_category_service_1 = __webpack_require__(242);
	var account_external_charge_category_service_1 = __webpack_require__(243);
	var server_datetime_service_1 = __webpack_require__(244);
	var selfCareHelper_service_1 = __webpack_require__(246);
	var download_service_1 = __webpack_require__(247);
	var flight_movement_category_service_1 = __webpack_require__(248);
	var flight_reassignment_service_1 = __webpack_require__(249);
	var charge_adjustments_service_1 = __webpack_require__(104);
	var organization_service_1 = __webpack_require__(250);
	var bank_account_management_service_1 = __webpack_require__(251);
	var recaptcha_service_1 = __webpack_require__(252);
	var unified_tax_management_service_1 = __webpack_require__(253);
	var unified_tax_validity_management_service_1 = __webpack_require__(254);
	var sso_providers_service_1 = __webpack_require__(255);
	var aodb_service_1 = __webpack_require__(256);
	exports.default = angular.module('armsWeb.services', [])
	    .service('scReportGenerationService', sc_report_generation_service_1.ScReportGenerationService)
	    .service('scFlightSearchService', sc_flight_search_service_1.ScFlightSearchService)
	    .service('scInactivityExpiryNoticeService', sc_inactivity_expiry_notice_service_1.ScInactivityExpiryNoticeService)
	    .service('aerodromeOperationalHoursService', aerodrome_operational_hours_service_1.AerodromeOperationalHoursService)
	    .service('interestRatesService', interest_rates_service_1.InterestRatesService)
	    .service('serviceOutagesService', service_outages_service_1.ServiceOutagesService)
	    .service('scApprovalRequestService', sc_approval_request_service_1.ScApprovalRequestService)
	    .service('passwordChangeService', password_change_service_1.PasswordChangeService)
	    .service('aircraftFlightsExemptionsService', aircraft_flights_exemptions_service_1.AircraftFlightsExemptionsService)
	    .service('scCreditPaymentService', sc_credit_payment_service_1.ScCreditPaymentService)
	    .service('scPassengerServiceChargeReturnService', sc_passenger_service_charge_return_service_1.ScPassengerServiceChargeReturnService)
	    .service('scInvoicesService', sc_invoices_service_1.ScInvoicesService)
	    .service('scTransactionsService', sc_transactions_service_1.ScTransactionsService)
	    .service('scFlightSchedulesService', sc_flight_schedules_service_1.ScFlightSchedulesService)
	    .service('scAircraftRegistrationService', sc_aircraft_registration_service_1.ScAircraftRegistrationService)
	    .service('scUserManagementService', sc_user_management_service_1.ScUserManagementService)
	    .service('scUserRegistrationService', sc_user_registration_service_1.ScUserRegistrationService)
	    .service('scAccountManagementService', sc_account_management_service_1.ScAccountManagementService)
	    .service('scFlightCostCalculationService', sc_flight_cost_calculation_service_1.ScFlightCostCalculationService)
	    .service('scQuerySubmissionService', sc_query_submission_service_1.ScQuerySubmissionService)
	    .service('scLoginService', sc_login_service_1.ScLoginService)
	    .service('cachedEventsService', cached_events_service_1.CachedEventsService)
	    .service('flightScheduleManagementService', flight_schedule_management_service_1.FlightScheduleManagementService)
	    .service('localAircraftRegistryService', local_aircraft_registry_service_1.LocalAircraftRegistryService)
	    .service('userEventLogService', user_event_log_service_1.UserEventLogService)
	    .service('applicationManagementService', application_management_service_1.ApplicationManagementService)
	    .service('nonAviationBillingEngineService', non_aviation_billing_engine_service_1.NonAviationBillingEngineService)
	    .service('revenueDataService', revenue_data_service_1.RevenueDataService)
	    .service('rejectedItemsService', rejected_items_service_1.RejectedItemsService)
	    .service('recurringChargesService', recurring_charges_service_1.RecurringChargesService)
	    .service('reportGenerationService', report_generation_service_1.ReportGenerationService)
	    .service('airTrafficDataService', air_traffic_data_service_1.AirTrafficDataService)
	    .service('reportTemplatesService', report_templates_service_1.ReportTemplatesService)
	    .service('towerMovementLogsService', tower_movement_logs_service_1.TowerMovementLogsService)
	    .service('repositioningAerodromeClustersService', repositioning_aerodrome_clusters_service_1.RepositioningAerodromeClustersService)
	    .service('systemSummaryService', system_summary_service_1.SystemSummaryService)
	    .service('atcMovementLogService', atc_movement_log_service_1.AtcMovementLogService)
	    .service('billingCentreManagementService', billing_centre_management_service_1.BillingCentreManagementService)
	    .service('unspecifiedDepDestLocationsService', unspecified_dep_dest_locations_service_1.UnspecifiedDepDestLocationsService)
	    .service('nominalRoutesService', nominal_routes_service_1.NominalRoutesService)
	    .service('flightStatusExemptionsService', flight_status_exemptions_service_1.FlightStatusExemptionsService)
	    .service('flightRouteExemptionsService', flight_route_exemptions_service_1.FlightRouteExemptionsService)
	    .service('aircraftUnspecifiedManagementService', aircraft_unspecified_management_service_1.AircraftUnspecifiedManagementService)
	    .service('radarSummaryService', radar_summary_service_1.RadarSummaryService)
	    .service('invoiceTemplateManagementService', invoice_template_management_service_1.InvoiceTemplateManagementService)
	    .service('enrouteAirNavigationChargesManagementService', enroute_air_navigation_charges_management_service_1.EnrouteAirNavigationChargesManagementService)
	    .service('catalogueServiceChargeService', catalogue_service_charge_service_1.CatalogueServiceChargeService)
	    .service('flightMovementManagementService', flight_movement_management_service_1.FlightMovementManagementService)
	    .service('flightTypeService', flight_types_service_1.FlightTypeService)
	    .service('airspaceManagementService', airspace_management_service_1.AirspaceManagementService)
	    .service('accountExemptManagementService', account_exempt_management_service_1.AccountExemptManagementService)
	    .service('utilitiesTownsService', utilities_towns_service_1.UtilitiesTownsService)
	    .service('utilitiesSchedulesService', utilities_schedules_service_1.UtilitiesSchedulesService)
	    .service('regionalCountryManagementService', regional_country_management_service_1.RegionalCountryManagementService)
	    .service('aircraftExemptManagementService', aircraft_exempt_management_service_1.AircraftExemptManagementService)
	    .service('mtowService', mtow_service_1.MtowService)
	    .service('invoiceStateTypeService', invoice_state_type_service_1.InvoiceStateTypeService)
	    .service('invoicesService', invoices_service_1.InvoicesService)
	    .service('airNavigationChargesService', air_navigation_charges_service_1.AirNavigationChargesService)
	    .service('systemConfigurationService', system_configuration_service_1.SystemConfigurationService)
	    .service('passengerServiceChargeReturnService', passenger_service_charge_return_service_1.PassengerServiceChargeReturnService)
	    .service('transactionsService', transactions_service_1.TransactionsService)
	    .service('aircraftRegistrationService', aircraft_registration_service_1.AircraftRegistrationService)
	    .service('wakeTurbulenceCategoryService', wake_turbulence_category_service_1.WakeTurbulenceCategoryService)
	    .service('typesService', types_service_1.TypesService)
	    .service('countryManagementService', country_management_service_1.CountryManagementService)
	    .service('currencyManagementService', currency_management_service_1.CurrencyManagementService)
	    .service('rolesService', roles_service_1.RolesService)
	    .service('permissionsService', permissions_service_1.PermissionsService)
	    .service('accountsService', accounts_service_1.AccountsService)
	    .service('aerodromeCategoryManagementService', aerodrome_category_management_service_1.AerodromeCategoryManagementService)
	    .service('aerodromesService', aerodromes_service_1.AerodromesService)
	    .service('usersService', users_service_1.UsersService)
	    .service('loginService', login_service_1.LoginService)
	    .service('configService', config_service_1.ConfigService)
	    .service('aircraftTypeManagementService', aircraft_type_management_service_1.AircraftTypeManagementService)
	    .service('oAuthService', oauth_service_1.OAuthService)
	    .service('transactionTypesService', transaction_types_service_1.TransactionTypesService)
	    .service('aboutService', about_service_1.AboutService)
	    .service('crcoManagementService', crco_management_service_1.CrcoManagementService)
	    .service('crcoConnectionService', crco_connection_service_1.CrcoConnectionService)
	    .service('crcoReportingResponsabilitiesService', crco_reporting_responsabilities_service_1.CrcoReportingResponsabilitiesService)
	    .service('crcoCertificatesService', crco_certificates_service_1.CrcoCertificatesService)
	    .service('crcoMessagesService', crco_messages_service_1.CrcoMessagesService)
	    .service('crcoClaimsService', crco_claims_service_1.CrcoClaimsService)
	    .service('crcoArchiveService', crco_archive_service_1.CrcoArchiveService)
	    .service('crcoCorRequestService', crco_cor_request_service_1.CrcoCorRequestService)
	    .service('routeSegmentsService', route_segments_service_1.RouteSegmentsService)
	    .service('currencyExchangeRatesService', currency_exchange_rates_service_1.CurrencyExchangeRatesService)
	    .service('reportsService', reports_service_1.ReportsService)
	    .service('dbqueryService', dbquery_service_1.DbqueryService)
	    .service('aviationBillingEngineService', aviation_billing_engine_service_1.AviationBillingEngineService)
	    .service('saveLocalTemplateService', saveLocalTemplate_service_1.SaveLocalTemplateService)
	    .service('convertItemTypeService', convert_item_type_service_1.ConvertItemTypeService)
	    .service('debounceService', debounce_service_1.DebounceService)
	    .service('pluginsService', plugins_service_1.PluginsService)
	    .service('languagesService', languages_service_1.LanguagesService)
	    .service('localeSwitcherService', localeSwitcher_service_1.LocaleSwitcherService)
	    .service('amhsConnectionService', amhs_connection_service_1.AMHSConnectionService)
	    .service('amhsAccountsService', amhs_accounts_service_1.AMHSAccountsService)
	    .service('transactionsPendingService', transactions_pending_service_1.TransactionsPendingService)
	    .service('transactionsWorkflowService', transactions_workflow_service_1.TransactionsWorkflowService)
	    .service('translateService', translate_run_1.TranslateService)
	    .service('releaseNoteService', release_notes_service_1.ReleaseNoteService)
	    .service('externalDatabaseInputService', external_database_input_service_1.ExternalDatabaseInputService)
	    .service('windowLocationService', window_location_service_1.WindowLocationService)
	    .service('revenueProjectionService', revenue_projection_service_1.RevenueProjectionService)
	    .service('customDate', customDate_service_1.CustomDate)
	    .service('externalChargeCategoryService', external_charge_category_service_1.ExternalChargeCategoryService)
	    .service('accountExternalChargeCategoryService', account_external_charge_category_service_1.AccountExternalChargeCategoryService)
	    .service('serverDatetimeService', server_datetime_service_1.ServerDatetimeService)
	    .service('selfCareHelper', selfCareHelper_service_1.SelfCareHelper)
	    .service('sysConfigBoolean', sysConfigBoolean_service_1.SysConfigBoolean)
	    .service('flightMovementCategoryService', flight_movement_category_service_1.FlightMovementCategoryService)
	    .service('flightReassignmentService', flight_reassignment_service_1.FlightReassignmentService)
	    .service('downloadService', download_service_1.DownloadService)
	    .service('chargeAdjustmentsService', charge_adjustments_service_1.ChargeAdjustmentsService)
	    .service('organizationService', organization_service_1.OrganizationService)
	    .service('bankAccountManagementService', bank_account_management_service_1.BankAccountManagementService)
	    .service('recaptchaService', recaptcha_service_1.RecaptchaService)
	    .service('unifiedTaxManagementService', unified_tax_management_service_1.UnifiedTaxManagementService)
	    .service('unifiedTaxValidityManagementService', unified_tax_validity_management_service_1.UnifiedTaxValidityManagementService)
	    .service('ssoProvidersService', sso_providers_service_1.SSOProvidersService)
	    .service('aodbService', aodb_service_1.AodbService);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'sc-report-generation';
	var ScReportGenerationService = (function (_super) {
	    __extends(ScReportGenerationService, _super);
	    /** @ngInject */
	    ScReportGenerationService.$inject = ["Restangular"];
	    function ScReportGenerationService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            report: null,
	            startDate: null,
	            endDate: null,
	            account_ids: null,
	            group_by_account: false,
	            account_status: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScReportGenerationService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    ScReportGenerationService.prototype.getPreview = function (params, body) {
	        return this.restangular.one("" + exports.endpoint).customPOST(body, null, params);
	    };
	    return ScReportGenerationService;
	}(crud_service_1.CRUDService));
	exports.ScReportGenerationService = ScReportGenerationService;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'sc-flight-search';
	var ScFlightSearchService = (function (_super) {
	    __extends(ScFlightSearchService, _super);
	    /** @ngInject */
	    ScFlightSearchService.$inject = ["Restangular"];
	    function ScFlightSearchService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            item18_reg_num: null,
	            flight_id: null,
	            date_of_flight: null,
	            status: null,
	            dep_time: null,
	            dep_ad: null,
	            dest_ad: null,
	            total_charges_usd: null,
	            amount_prepaid: null,
	            flight_notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return ScFlightSearchService;
	}(crud_service_1.CRUDService));
	exports.ScFlightSearchService = ScFlightSearchService;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'self-care-portal-inactivity-expiry-notices';
	var ScInactivityExpiryNoticeService = (function (_super) {
	    __extends(ScInactivityExpiryNoticeService, _super);
	    /** @ngInject */
	    ScInactivityExpiryNoticeService.$inject = ["Restangular"];
	    function ScInactivityExpiryNoticeService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            notice_type: null,
	            date_time: null,
	            message_text: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return ScInactivityExpiryNoticeService;
	}(crud_service_1.CRUDService));
	exports.ScInactivityExpiryNoticeService = ScInactivityExpiryNoticeService;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'aerodrome-operational-hours';
	var AerodromeOperationalHoursService = (function (_super) {
	    __extends(AerodromeOperationalHoursService, _super);
	    /** @ngInject */
	    AerodromeOperationalHoursService.$inject = ["Restangular"];
	    function AerodromeOperationalHoursService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aerodrome: null,
	            operational_hours_monday: null,
	            operational_hours_tuesday: null,
	            operational_hours_wednesday: null,
	            operational_hours_thursday: null,
	            operational_hours_friday: null,
	            operational_hours_saturday: null,
	            operational_hours_sunday: null,
	            operational_hours_holidays1: null,
	            operational_hours_holidays2: null,
	            holiday_dates_holidays1: null,
	            holiday_dates_holidays2: null,
	            start_date_time: null,
	            end_date_time: null,
	            notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    AerodromeOperationalHoursService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    AerodromeOperationalHoursService.prototype.getAllDistinctAerodrome = function () {
	        return this.restangular.one(exports.endpoint + "/allDistinct").get();
	    };
	    AerodromeOperationalHoursService.prototype.getAllAerodromeOperationalHours = function () {
	        return this.restangular.one(exports.endpoint + "/all").get();
	    };
	    return AerodromeOperationalHoursService;
	}(crud_service_1.CRUDService));
	exports.AerodromeOperationalHoursService = AerodromeOperationalHoursService;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'interest-rate';
	var InterestRatesService = (function (_super) {
	    __extends(InterestRatesService, _super);
	    /** @ngInject */
	    InterestRatesService.$inject = ["Restangular"];
	    function InterestRatesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            default_interest_specification: null,
	            default_interest_application: null,
	            default_interest_grace_period: null,
	            default_foreign_interest_specified_percentage: null,
	            default_national_interest_specified_percentage: null,
	            default_foreign_interest_applied_percentage: null,
	            default_national_interest_applied_percentage: null,
	            punitive_interest_specification: null,
	            punitive_interest_application: null,
	            punitive_interest_grace_period: null,
	            punitive_interest_specified_percentage: null,
	            punitive_interest_applied_percentage: null,
	            start_date: null,
	            end_date: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return InterestRatesService;
	}(crud_service_1.CRUDService));
	exports.InterestRatesService = InterestRatesService;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'aerodrome-service-outages';
	var ServiceOutagesService = (function (_super) {
	    __extends(ServiceOutagesService, _super);
	    /** @ngInject */
	    ServiceOutagesService.$inject = ["Restangular"];
	    function ServiceOutagesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aerodrome: null,
	            aerodrome_service_type: null,
	            start_date_time: null,
	            end_date_time: null,
	            approach_discount_type: null,
	            approach_discount_amount: null,
	            aerodrome_discount_type: null,
	            aerodrome_discount_amount: null,
	            flight_notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ServiceOutagesService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    return ServiceOutagesService;
	}(crud_service_1.CRUDService));
	exports.ServiceOutagesService = ServiceOutagesService;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'self-care-approval-request';
	var ScApprovalRequestService = (function (_super) {
	    __extends(ScApprovalRequestService, _super);
	    /** @ngInject */
	    ScApprovalRequestService.$inject = ["Restangular"];
	    function ScApprovalRequestService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            user: null,
	            request_type: null,
	            request_dataset: null,
	            object_id: null,
	            request_text: null,
	            status: null,
	            responders_name: null,
	            response_date: null,
	            response_text: null,
	            created_at: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScApprovalRequestService.prototype.approve = function (item, id) {
	        return this.restangular.one(exports.endpoint + "/approve/" + id).customPUT(item);
	    };
	    ScApprovalRequestService.prototype.approveSelected = function (itemsId, text) {
	        return this.restangular.one(exports.endpoint + "/bulk-approve/" + text).customPUT(itemsId);
	    };
	    ScApprovalRequestService.prototype.reject = function (item, id) {
	        return this.restangular.one(exports.endpoint + "/reject/" + id).customPUT(item);
	    };
	    ScApprovalRequestService.prototype.rejectSelected = function (itemsId, text) {
	        return this.restangular.one(exports.endpoint + "/bulk-reject/" + text).customPUT(itemsId);
	    };
	    return ScApprovalRequestService;
	}(crud_service_1.CRUDService));
	exports.ScApprovalRequestService = ScApprovalRequestService;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'users/change-pwd';
	var PasswordChangeService = (function (_super) {
	    __extends(PasswordChangeService, _super);
	    /** @ngInject */
	    PasswordChangeService.$inject = ["Restangular", "$uibModal", "oAuthService"];
	    function PasswordChangeService(Restangular, $uibModal, oAuthService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$uibModal = $uibModal;
	        _this.oAuthService = oAuthService;
	        _this.passwordChange = {
	            old_password: '',
	            new_password: null
	        };
	        _this.model = _this.passwordChange;
	        return _this;
	    }
	    PasswordChangeService.prototype.updatePassword = function (passwordChange) {
	        return this.restangular.one("" + exports.endpoint).customPUT(passwordChange);
	    };
	    /**
	     * Modal to tell user that the password is changed successfully
	     */
	    PasswordChangeService.prototype.passwordChangedMessage = function (logout) {
	        var _this = this;
	        var modal = this.$uibModal.open({
	            templateUrl: 'app/partials/password-change/password-change.template.html',
	            controller: ['$scope', function ($scope) {
	                    $scope.logout = logout;
	                    $scope.confirm = function () {
	                        modal.close();
	                        if (logout) {
	                            _this.oAuthService.logout();
	                        }
	                    };
	                }]
	        });
	    };
	    return PasswordChangeService;
	}(crud_service_1.CRUDService));
	exports.PasswordChangeService = PasswordChangeService;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'exempt-aircraft-flights';
	var AircraftFlightsExemptionsService = (function (_super) {
	    __extends(AircraftFlightsExemptionsService, _super);
	    /** @ngInject */
	    AircraftFlightsExemptionsService.$inject = ["Restangular"];
	    function AircraftFlightsExemptionsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aircraft_registration: null,
	            flight_id: null,
	            enroute_fees_exempt: 0,
	            approach_fees_exempt: 0,
	            aerodrome_fees_exempt: 0,
	            late_arrival_fees_exempt: 0,
	            late_departure_fees_exempt: 0,
	            parking_fees_exempt: 0,
	            international_pax: 0,
	            domestic_pax: 0,
	            unified_tax: 0,
	            extended_hours: 0,
	            flight_notes: null,
	            exemption_start_date: null,
	            exemption_end_date: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return AircraftFlightsExemptionsService;
	}(crud_service_1.CRUDService));
	exports.AircraftFlightsExemptionsService = AircraftFlightsExemptionsService;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'sc-passenger-service-charge-return';
	var ScPassengerServiceChargeReturnService = (function (_super) {
	    __extends(ScPassengerServiceChargeReturnService, _super);
	    /** @ngInject */
	    ScPassengerServiceChargeReturnService.$inject = ["Restangular"];
	    function ScPassengerServiceChargeReturnService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            flight_id: null,
	            day_of_flight: null,
	            departure_time: null,
	            transit_passengers: 0,
	            joining_passengers: 0,
	            children: 0,
	            chargeable_itl_passengers: 0,
	            chargeable_domestic_passengers: 0,
	            document_filename: null,
	            mime_type: null,
	            document: null,
	            document_filename2: null,
	            arriving_pax_domestic_airport: null,
	            landing_pax_domestic_airport: null,
	            transfer_pax_domestic_airport: null,
	            departing_pax_domestic_airport: null,
	            arriving_child_domestic_airport: null,
	            landing_child_domestic_airport: null,
	            transfer_child_domestic_airport: null,
	            departing_child_domestic_airport: null,
	            exempt_arriving_pax_domestic_airport: null,
	            exempt_landing_pax_domestic_airport: null,
	            exempt_transfer_pax_domestic_airport: null,
	            exempt_departing_pax_domestic_airport: null,
	            loaded_goods: null,
	            discharged_goods: null,
	            loaded_mail: null,
	            discharged_mail: null,
	            account: null,
	            account_id: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Send date range of flights to check against PSCR
	     */
	    ScPassengerServiceChargeReturnService.prototype.executePSCR = function (params) {
	        return this.restangular.all(exports.endpoint + "/reconciliation").customPOST(null, '', params);
	    };
	    return ScPassengerServiceChargeReturnService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.ScPassengerServiceChargeReturnService = ScPassengerServiceChargeReturnService;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	var CRUDFileUploadService = (function (_super) {
	    __extends(CRUDFileUploadService, _super);
	    function CRUDFileUploadService(Restangular, endpoint) {
	        var _this = _super.call(this, Restangular, endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.endpoint = endpoint;
	        _this.endpoint = endpoint;
	        return _this;
	    }
	    CRUDFileUploadService.prototype.upload = function (method, fd, dest, params) {
	        if (method === 'PUT') {
	            return this.restangular.one(this.buildUrl(dest) + "/upload").withHttpConfig({ 'transformRequest': angular.identity })
	                .customPUT(fd, undefined, params, { 'Content-Type': undefined });
	        }
	        else {
	            return this.restangular.one(this.buildUrl(dest) + "/upload").withHttpConfig({ 'transformRequest': angular.identity })
	                .customPOST(fd, undefined, params, { 'Content-Type': undefined });
	        }
	    };
	    CRUDFileUploadService.prototype.uploadFile = function (method, fd, dest, params) {
	        if (method === 'PUT') {
	            return this.restangular.one(this.buildUrl(dest) + "/" + params + "/upload").withHttpConfig({ 'transformRequest': angular.identity })
	                .customPUT(fd, undefined, params, { 'Content-Type': undefined });
	        }
	        else {
	            return this.restangular.one("" + this.buildUrl(dest)).withHttpConfig({ 'transformRequest': angular.identity })
	                .customPOST(fd, undefined, params, { 'Content-Type': undefined });
	        }
	    };
	    CRUDFileUploadService.prototype.preview = function (dest) {
	        return this.restangular.one(this.buildUrl(dest) + '/preview').get({}, { 'Content-Type': 'text/json; charset=utf-8' });
	    };
	    CRUDFileUploadService.prototype.deleteFile = function (dest) {
	        return this.restangular.one(this.buildUrl(dest)).remove();
	    };
	    CRUDFileUploadService.prototype.buildUrl = function (dest) {
	        return this.endpoint + (angular.isArray(dest) ? '/' + dest.join('/') : '');
	    };
	    return CRUDFileUploadService;
	}(crud_service_1.CRUDService));
	exports.CRUDFileUploadService = CRUDFileUploadService;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'sc-credit-payment';
	var ScCreditPaymentService = (function (_super) {
	    __extends(ScCreditPaymentService, _super);
	    /** @ngInject */
	    ScCreditPaymentService.$inject = ["Restangular"];
	    function ScCreditPaymentService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            transactionTime: null,
	            account: null,
	            requestorIp: null,
	            request: null,
	            response: null,
	            responseStatus: null,
	            responseDescription: null,
	            version: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScCreditPaymentService.prototype.sendNonSensitiveDataToCreditGateway = function (amount, accountId) {
	        return this.restangular.one(this.endpoint).customPOST(null, null, { amount: amount, accountId: accountId });
	    };
	    ScCreditPaymentService.prototype.sendTokenIdToCreditGateway = function (token) {
	        return this.restangular.one(this.endpoint + "/token").customPOST(null, null, { token: token });
	    };
	    return ScCreditPaymentService;
	}(crud_service_1.CRUDService));
	exports.ScCreditPaymentService = ScCreditPaymentService;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	// endpoint
	exports.endpoint = 'sc-billing-ledgers';
	var ScInvoicesService = (function (_super) {
	    __extends(ScInvoicesService, _super);
	    /** @ngInject */
	    ScInvoicesService.$inject = ["Restangular", "$http"];
	    function ScInvoicesService(Restangular, $http) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            invoice_period_or_date: null,
	            invoice_type: null,
	            invoice_state_type: null,
	            payment_due_date: null,
	            user: null,
	            invoice_document: null,
	            invoice_number: null,
	            invoice_amount: null,
	            invoice_currency: null,
	            invoice_exchange_to_usd: null,
	            invoice_date_of_issue: null,
	            payment_amount: null,
	            payment_currency: null,
	            payment_exchange_to_usd: null,
	            payment_date: null,
	            exported: null,
	            amount_owing: null,
	            proforma: null,
	            point_of_sale: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScInvoicesService.prototype.getModel = function () {
	        return this._mod;
	    };
	    return ScInvoicesService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.ScInvoicesService = ScInvoicesService;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'sc-transactions';
	var ScTransactionsService = (function (_super) {
	    __extends(ScTransactionsService, _super);
	    /** @ngInject */
	    ScTransactionsService.$inject = ["Restangular"];
	    function ScTransactionsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            transaction_date_time: null,
	            description: null,
	            transaction_type: null,
	            amount: null,
	            currency: null,
	            payment_mechanism: null,
	            payment_reference_number: null,
	            exported: false,
	            billing_ledger_ids: null,
	            exchange_rate_to_usd: null,
	            exchange_rate_to_ansp: null,
	            balance: null,
	            payment_amount: null,
	            payment_currency: null,
	            payment_exchange_rate: null,
	            charges_adjustment: [],
	            kra_receipt_number: null,
	            kra_clerk_name: null,
	            payments_exported: null,
	            has_approval_document: null,
	            approval_document_name: null,
	            approval_document_type: null,
	            has_supporting_document: null,
	            supporting_document_name: null,
	            supporting_document_type: null,
	            interest_invoice_error: null,
	            transaction_approvals: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScTransactionsService.prototype.getModel = function () {
	        return this._mod;
	    };
	    ScTransactionsService.prototype.getInvoicesByTransactionId = function (transactionId) {
	        return this.restangular.one(exports.endpoint + "/getBillingLedgersByTransactionId/" + transactionId).get();
	    };
	    return ScTransactionsService;
	}(crud_service_1.CRUDService));
	exports.ScTransactionsService = ScTransactionsService;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'sc-flight-schedules';
	var ScFlightSchedulesService = (function (_super) {
	    __extends(ScFlightSchedulesService, _super);
	    /** @ngInject */
	    ScFlightSchedulesService.$inject = ["Restangular"];
	    function ScFlightSchedulesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            flight_service_number: null,
	            dep_ad: null,
	            dep_time: null,
	            dest_ad: null,
	            dest_time: null,
	            daily_schedule: null,
	            self_care: true,
	            active_indicator: 'active',
	            start_date: null,
	            end_date: null,
	            missing_flight_movements: null,
	            unexpected_flights: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // check to see which schedules will be replaced by upload
	    ScFlightSchedulesService.prototype.preUploadSchedules = function (startDate, document) {
	        var formDate = new FormData();
	        formDate.append('file', document, 'flight_schedules');
	        return this.restangular.one(exports.endpoint + "/pre-upload?startDate=" + startDate).withHttpConfig({ 'transformRequest': angular.identity })
	            .customPUT(formDate, undefined, undefined, { 'Content-Type': undefined });
	    };
	    return ScFlightSchedulesService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.ScFlightSchedulesService = ScFlightSchedulesService;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'sc-aircraft-registration';
	var ScAircraftRegistrationService = (function (_super) {
	    __extends(ScAircraftRegistrationService, _super);
	    /** @ngInject */
	    ScAircraftRegistrationService.$inject = ["Restangular"];
	    function ScAircraftRegistrationService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            registration_number: null,
	            registration_start_date: null,
	            registration_expiry_date: null,
	            mtow_override: null,
	            account: {
	                id: null,
	                name: null,
	                alias: null,
	                aviation_billing_contact_person_name: null,
	                aviation_billing_phone_number: null,
	                aviation_billing_mailing_address: null,
	                aviation_billing_email_address: null,
	                non_aviation_billing_contact_person_name: null,
	                non_aviation_billing_phone_number: null,
	                non_aviation_billing_mailing_address: null,
	                non_aviation_billing_email_address: null,
	                is_vat_free: null,
	                exempt_flight_free: null,
	                is_self_care: null,
	                account_users: [],
	                iata_code: null,
	                icao_code: null,
	                opr_identifier: null,
	                payment_terms: null,
	                discount_structure: null,
	                tax_profile: null,
	                cash_account: null,
	                percentage_of_passenger_fee_payable: null,
	                invoice_delivery_format: null,
	                invoice_delivery_method: null,
	                invoice_currency: {
	                    id: null,
	                    currency_code: null,
	                    currency_name: null,
	                    country_code: null,
	                    decimal_places: null,
	                    allow_updated_from_web: null,
	                    symbol: null,
	                    active: null,
	                    external_accounting_system_identifier: null,
	                    exchange_rate_target_currency_id: null
	                },
	                monthly_overdue_penalty_rate: null,
	                notes: null,
	                black_listed_indicator: null,
	                black_listed_override: null,
	                credit_limit: null,
	                maximum_amount_credit_note: null,
	                minimum_amount_credit_note: null,
	                aircraft_parking_exemption: null,
	                account_type: null,
	                account_type_discount: null,
	                list_of_events_account_notified: null,
	                iata_member: null,
	                separate_pax_invoice: null,
	                external_accounting_system_identifier: null,
	                active: null,
	                approved_flight_school_indicator: null,
	                nationality: null,
	                whitelist_last_activity_date_time: null,
	                whitelist_state: null,
	                whitelist_inactivity_notice_sent_flag: null,
	                whitelist_expiry_notice_sent_flag: null,
	                invoice_pubblication: null,
	                invoice_overdue: null,
	                expired_certificate_warning: null,
	                expired_certificate: null,
	                has_uploaded_document: false,
	                uploaded_document_name: null,
	                uploaded_document_type: null,
	                document: null,
	                document_filename: null
	            },
	            aircraft_type: {
	                id: null,
	                aircraft_type: null,
	                aircraft_image: null,
	                aircraft_name: null,
	                manufacturer: null,
	                maximum_takeoff_weight: null,
	                wake_turbulence_category: null
	            },
	            country_of_registration: {
	                id: null,
	                country_code: null,
	                country_name: null,
	                aircraft_registration_prefixes: null,
	                aerodrome_prefixes: null,
	                crco_member: false
	            },
	            country_override: false,
	            created_by_self_care: true,
	            coa_expiry_date: null,
	            coa_issue_date: null,
	            aircraft_service_date: null,
	            is_local: null,
	            aircraft_scope: null,
	            uploaded_document_name: '',
	            uploaded_document_type: '',
	            has_uploaded_document: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // returns a country based on the registration number prefix
	    ScAircraftRegistrationService.prototype.getCountryByRegistrationNumberPrefix = function (prefix) {
	        return this.restangular.one(exports.endpoint + "/prefix/" + prefix).get();
	    };
	    return ScAircraftRegistrationService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.ScAircraftRegistrationService = ScAircraftRegistrationService;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'sc-user-management';
	var ScUserManagementService = (function (_super) {
	    __extends(ScUserManagementService, _super);
	    /** @ngInject */
	    ScUserManagementService.$inject = ["Restangular"];
	    function ScUserManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            email: null,
	            login: null,
	            job_title: null,
	            name: null,
	            permissions: [],
	            roles: [],
	            contact_information: null,
	            sms_number: null,
	            billing_center: null,
	            language: null,
	            is_selfcare_user: true,
	            is_provider_user: false,
	            force_password_change: false,
	            registration_status: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return ScUserManagementService;
	}(crud_service_1.CRUDService));
	exports.ScUserManagementService = ScUserManagementService;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'sc-user-registration';
	var ScUserRegistrationService = (function (_super) {
	    __extends(ScUserRegistrationService, _super);
	    /** @ngInject */
	    ScUserRegistrationService.$inject = ["Restangular", "usersService"];
	    function ScUserRegistrationService(Restangular, usersService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.usersService = usersService;
	        _this._mod = {
	            id: null,
	            email: null,
	            login: null,
	            job_title: null,
	            name: null,
	            permissions: [],
	            roles: [],
	            contact_information: null,
	            sms_number: null,
	            billing_center: null,
	            language: null,
	            is_selfcare_user: true,
	            is_provider_user: false,
	            force_password_change: false,
	            registration_status: false,
	            url: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScUserRegistrationService.prototype.create = function (editable) {
	        return this.restangular.all(exports.endpoint).customPOST(editable);
	    };
	    ScUserRegistrationService.prototype.activate = function (key) {
	        return this.restangular.all(exports.endpoint + "/activate").customPOST(key);
	    };
	    ScUserRegistrationService.prototype.getSettings = function () {
	        var _this = this;
	        return this.restangular.one("system-configurations/noauth/getPasswordSettings").get().then(function (resp) {
	            return _this.restangular.stripRestangular(resp);
	        }, function (err) {
	            return null;
	        });
	    };
	    return ScUserRegistrationService;
	}(crud_service_1.CRUDService));
	exports.ScUserRegistrationService = ScUserRegistrationService;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'sc-account-management';
	var ScAccountManagementService = (function (_super) {
	    __extends(ScAccountManagementService, _super);
	    /** @ngInject */
	    ScAccountManagementService.$inject = ["Restangular"];
	    function ScAccountManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            name: null,
	            alias: null,
	            aviation_billing_contact_person_name: null,
	            aviation_billing_phone_number: null,
	            aviation_billing_mailing_address: null,
	            aviation_billing_email_address: null,
	            non_aviation_billing_contact_person_name: null,
	            non_aviation_billing_phone_number: null,
	            non_aviation_billing_mailing_address: null,
	            non_aviation_billing_email_address: null,
	            is_self_care: false,
	            iata_code: null,
	            icao_code: null,
	            opr_identifier: null,
	            payment_terms: null,
	            discount_structure: null,
	            tax_profile: null,
	            percentage_of_passenger_fee_payable: null,
	            invoice_delivery_format: null,
	            invoice_delivery_method: null,
	            invoice_currency: null,
	            monthly_overdue_penalty_rate: null,
	            notes: null,
	            black_listed_indicator: false,
	            black_listed_override: false,
	            credit_limit: null,
	            maximum_amount_credit_note: null,
	            minimum_amount_credit_note: null,
	            aircraft_parking_exemption: null,
	            account_type: null,
	            account_type_discount: null,
	            list_of_events_account_notified: null,
	            iata_member: false,
	            separate_pax_invoice: false,
	            external_accounting_system_identifier: null,
	            active: true,
	            cash_account: false,
	            approved_flight_school_indicator: false,
	            account_users: [],
	            nationality: null,
	            whitelist_last_activity_date_time: null,
	            whitelist_state: null,
	            whitelist_inactivity_notice_sent_flag: null,
	            whitelist_expiry_notice_sent_flag: null,
	            is_vat_free: false,
	            exempt_flight_free: false,
	            invoice_pubblication: false,
	            invoice_overdue: false,
	            expired_certificate_warning: false,
	            expired_certificate: false,
	            document: null,
	            uploaded_document_type: null,
	            has_uploaded_document: null,
	            uploaded_document_name: null,
	            document_filename: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScAccountManagementService.prototype.getSCAccounts = function (onlyActive) {
	        var active = onlyActive ? '?active=true' : '';
	        return this.restangular.one(exports.endpoint + "/approved-only" + active).get();
	    };
	    ScAccountManagementService.prototype.getSCActiveAccounts = function () {
	        return this.getSCAccounts(true);
	    };
	    ScAccountManagementService.prototype.getSCWhiteListAccounts = function () {
	        return this.restangular.one(exports.endpoint + "/cash-whitelist").get();
	    };
	    ScAccountManagementService.prototype.getAccountsWithFlightSchedules = function () {
	        return this.restangular.one(exports.endpoint + "/accounts-with-flight-schedules").get();
	    };
	    return ScAccountManagementService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.ScAccountManagementService = ScAccountManagementService;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'flight-cost-calculation';
	var ScFlightCostCalculationService = (function (_super) {
	    __extends(ScFlightCostCalculationService, _super);
	    /** @ngInject */
	    ScFlightCostCalculationService.$inject = ["Restangular"];
	    function ScFlightCostCalculationService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            aircraft_type: null,
	            registration_number: null,
	            speed: null,
	            estimated_elapsed_time: null,
	            dep_aerodrome: null,
	            dest_aerodrome: null,
	            route: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScFlightCostCalculationService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    ScFlightCostCalculationService.prototype.calculate = function (editable) {
	        return this.restangular.all(this.endpoint).customPOST(editable);
	    };
	    return ScFlightCostCalculationService;
	}(crud_service_1.CRUDService));
	exports.ScFlightCostCalculationService = ScFlightCostCalculationService;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'query-submission';
	var ScQuerySubmissionService = (function (_super) {
	    __extends(ScQuerySubmissionService, _super);
	    /** @ngInject */
	    ScQuerySubmissionService.$inject = ["Restangular"];
	    function ScQuerySubmissionService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            sender_email: null,
	            subject: null,
	            message: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ScQuerySubmissionService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    ScQuerySubmissionService.prototype.send = function (editable) {
	        return this.restangular.all(this.endpoint).customPOST(editable);
	    };
	    return ScQuerySubmissionService;
	}(crud_service_1.CRUDService));
	exports.ScQuerySubmissionService = ScQuerySubmissionService;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// classes
	var user_event_log_class_1 = __webpack_require__(158);
	var ScLoginService = (function () {
	    /** @ngInject */
	    ScLoginService.$inject = ["oAuthService", "systemConfigurationService", "userEventLogService"];
	    function ScLoginService(oAuthService, systemConfigurationService, userEventLogService) {
	        this.oAuthService = oAuthService;
	        this.systemConfigurationService = systemConfigurationService;
	        this.userEventLogService = userEventLogService;
	    }
	    ScLoginService.prototype.login = function (username, password) {
	        var _this = this;
	        var valid = false;
	        // makes a call to system configuration as well when logging in to get system variables
	        return this.oAuthService.authenticate(username, password, true).then(function () {
	            _this.systemConfigurationService.listForClientStorage();
	            window.localStorage.setItem('loginFromBilling', JSON.stringify(false));
	            // allows logging of successfull sign in event
	            valid = true;
	        }).finally(function () {
	            if (valid) {
	                var event_1 = new user_event_log_class_1.Event('login', '', 'login', '', '');
	                _this.userEventLogService.create(event_1);
	            }
	        });
	    };
	    return ScLoginService;
	}());
	exports.ScLoginService = ScLoginService;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Event = (function () {
	    function Event(event_type, record_primary_key, new_value, old_value, unique_record_id) {
	        this.event_type = event_type;
	        this.record_primary_key = record_primary_key;
	        this.new_value = new_value;
	        this.old_value = old_value;
	        this.unique_record_id = unique_record_id;
	    }
	    return Event;
	}());
	exports.Event = Event;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'cachedevents';
	var CachedEventsService = (function (_super) {
	    __extends(CachedEventsService, _super);
	    /** @ngInject */
	    CachedEventsService.$inject = ["Restangular"];
	    function CachedEventsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            target: null,
	            method_name: null,
	            param_types: [],
	            exceptions: [],
	            caches: [],
	            results: [],
	            metadata: [],
	            retry_count: 0,
	            last_attempt: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CachedEventsService.prototype.getNextRetryCycle = function () {
	        return this.restangular.one(exports.endpoint + "/nextretrycycle").get();
	    };
	    CachedEventsService.prototype.retry = function (id) {
	        return this.restangular.one("" + exports.endpoint, id).one("retry").put();
	    };
	    return CachedEventsService;
	}(crud_service_1.CRUDService));
	exports.CachedEventsService = CachedEventsService;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'flight-schedules';
	var FlightScheduleManagementService = (function (_super) {
	    __extends(FlightScheduleManagementService, _super);
	    /** @ngInject */
	    FlightScheduleManagementService.$inject = ["Restangular"];
	    function FlightScheduleManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            flight_service_number: null,
	            dep_ad: null,
	            dep_time: null,
	            dest_ad: null,
	            dest_time: null,
	            daily_schedule: null,
	            self_care: false,
	            active_indicator: 'active',
	            start_date: null,
	            end_date: null,
	            missing_flight_movements: null,
	            unexpected_flights: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    FlightScheduleManagementService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    // check to see which schedules will be replaced by upload
	    FlightScheduleManagementService.prototype.preUploadSchedules = function (startDate, document) {
	        var formDate = new FormData();
	        formDate.append('file', document, 'flight_schedules');
	        return this.restangular.one(exports.endpoint + "/pre-upload?startDate=" + startDate).withHttpConfig({ 'transformRequest': angular.identity })
	            .customPUT(formDate, undefined, undefined, { 'Content-Type': undefined });
	    };
	    /**
	     * Populate multiselect
	     * with days of the week
	     *
	     * @returns Array
	     */
	    FlightScheduleManagementService.prototype.getDaysOfWeek = function () {
	        return [
	            {
	                id: 1,
	                name: 'Sunday',
	                value: '1'
	            },
	            {
	                id: 2,
	                name: 'Monday',
	                value: '2'
	            },
	            {
	                id: 3,
	                name: 'Tuesday',
	                value: '3'
	            },
	            {
	                id: 4,
	                name: 'Wednesday',
	                value: '4'
	            },
	            {
	                id: 5,
	                name: 'Thursday',
	                value: '5'
	            },
	            {
	                id: 6,
	                name: 'Friday',
	                value: '6'
	            },
	            {
	                id: 7,
	                name: 'Saturday',
	                value: '7'
	            }
	        ];
	    };
	    return FlightScheduleManagementService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.FlightScheduleManagementService = FlightScheduleManagementService;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'local-aircraft-registries';
	var LocalAircraftRegistryService = (function (_super) {
	    __extends(LocalAircraftRegistryService, _super);
	    /** @ngInject */
	    LocalAircraftRegistryService.$inject = ["Restangular"];
	    function LocalAircraftRegistryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            registration_number: null,
	            owner_name: null,
	            analysis_type: null,
	            mtow_weight: null,
	            coa_date_of_renewal: null,
	            coa_date_of_expiry: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return LocalAircraftRegistryService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.LocalAircraftRegistryService = LocalAircraftRegistryService;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	// class
	var user_event_log_class_1 = __webpack_require__(158);
	exports.endpoint = 'user-event-logs';
	var UserEventLogService = (function (_super) {
	    __extends(UserEventLogService, _super);
	    /** @ngInject */
	    UserEventLogService.$inject = ["Restangular"];
	    function UserEventLogService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            user_name: null,
	            date_time: null,
	            ip_address: null,
	            event_type: null,
	            record_primary_key: null,
	            unique_record_id: null,
	            modified_column_names_values: null,
	            new_value: null,
	            old_value: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Creates 'delete' logs from requests
	     * Creates 'add' or 'update' logs from responses
	     *
	     * @param  {any} element - the data from a request/response
	     * @param  {string} operation - the type of request (get, post, put, remove)
	     * @param  {any} id - the identifier (/radar-summaries/4782)
	     * @param  {any} vecchio valore del form
	     * @returns void
	     */
	    UserEventLogService.prototype.createEvent = function (element, operation, id, oldValue) {
	        // prevent duplicate records
	        var identifier = this.formatIdentifier(id);
	        var isNotEventLog = identifier.includes(exports.endpoint) && operation === 'post';
	        var data = this.getData(element, id);
	        var eventType = this.getEventTypeFromResponse(data, operation);
	        var newValue = JSON.stringify(data);
	        oldValue = JSON.stringify(oldValue);
	        if (operation !== 'get' && !isNotEventLog) {
	            if (data && data.id) {
	                var event_1 = new user_event_log_class_1.Event(eventType, data.id.toString(), newValue, oldValue, identifier.split('-').join(' '));
	                _super.prototype.create.call(this, event_1);
	            }
	        }
	    };
	    /**
	     * Returns the event type. Usually a CRUD operation,
	     * except for custom events like credit/debit note
	     * generation
	     *
	     * @param  {any} data - response object
	     * @param  {string} operation - request type
	     * @returns string
	     */
	    UserEventLogService.prototype.getEventTypeFromResponse = function (data, operation) {
	        var CREDIT_NOTE_EVENT = 'credit note creation';
	        var DEBIT_NOTE_EVENT = 'debit note creation';
	        // custom events for credit / debit note creation
	        var isCreditDebitNote = data && data.payment_mechanism && data.payment_mechanism === 'adjustment';
	        if (isCreditDebitNote) {
	            return data.transaction_type.name === 'credit' ? CREDIT_NOTE_EVENT : DEBIT_NOTE_EVENT;
	        }
	        switch (operation) {
	            // returns the event type
	            // associated with the operation
	            case 'post': return 'add';
	            case 'put': return 'update';
	            case 'remove': return 'delete';
	        }
	    };
	    /**
	     * Will return a user readable identifier
	     * that corresponts with the modified table,
	     * for logging purposes
	     *
	     * @param  {string} identifier
	     * @returns string
	     */
	    UserEventLogService.prototype.formatIdentifier = function (identifier) {
	        var splitIdentifier = identifier.split('/');
	        var lastPosition = splitIdentifier[splitIdentifier.length - 1];
	        // if it is not a number, use the last
	        // part of the identifier in the
	        // user event log
	        if (isNaN(lastPosition)) {
	            return lastPosition;
	        }
	        // if it is a number, return the
	        // first part for the identifier
	        if (identifier.includes('/')) {
	            return splitIdentifier[0];
	        }
	        // return as is if no parsing
	        // is necessary
	        return identifier;
	    };
	    /**
	     * If there is no data.id, this will
	     * search for and return an id from
	     * the last part of the identifier
	     * eg: radar-summaries/2873
	     *
	     * @param  {} element
	     * @param  {string} identifier
	     * @returns any
	     */
	    UserEventLogService.prototype.getData = function (element, identifier) {
	        var splitIdentifier = identifier.split('/');
	        var lastPosition = splitIdentifier[splitIdentifier.length - 1];
	        if (element && element.id) {
	            return element;
	        }
	        else {
	            // if data.id is undefined,
	            // use the last part of the
	            // identifier, if it is a number
	            if (!isNaN(lastPosition)) {
	                return { id: lastPosition };
	            }
	        }
	    };
	    return UserEventLogService;
	}(crud_service_1.CRUDService));
	exports.UserEventLogService = UserEventLogService;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'route-caching';
	var ApplicationManagementService = (function (_super) {
	    __extends(ApplicationManagementService, _super);
	    /** @ngInject */
	    ApplicationManagementService.$inject = ["Restangular"];
	    function ApplicationManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            count: null,
	            number_of_retention: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ApplicationManagementService.prototype.clearCurrentCache = function () {
	        return this.restangular.one(exports.endpoint + "/reset").remove();
	    };
	    ApplicationManagementService.prototype.getNumberToRetain = function () {
	        return this.restangular.one(exports.endpoint + "/retention").get();
	    };
	    ApplicationManagementService.prototype.updateNumberToRetain = function (numberToRetain) {
	        return this.restangular.one(exports.endpoint + "/retention/" + numberToRetain).customPUT();
	    };
	    return ApplicationManagementService;
	}(crud_service_1.CRUDService));
	exports.ApplicationManagementService = ApplicationManagementService;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'non-aviation-billing';
	var NonAviationBillingEngineService = (function (_super) {
	    __extends(NonAviationBillingEngineService, _super);
	    /** @ngInject */
	    NonAviationBillingEngineService.$inject = ["Restangular"];
	    function NonAviationBillingEngineService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            month: null,
	            year: null,
	            accountId: null,
	            externalChargeCategory: null,
	            currencyCode: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return NonAviationBillingEngineService;
	}(crud_service_1.CRUDService));
	exports.NonAviationBillingEngineService = NonAviationBillingEngineService;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'dbqueries/stats/revenue-statistics';
	exports.endpointRevenue = 'revenue-statistics';
	var RevenueDataService = (function (_super) {
	    __extends(RevenueDataService, _super);
	    /** @ngInject */
	    RevenueDataService.$inject = ["Restangular"];
	    function RevenueDataService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            start_date: null,
	            end_date: null,
	            analysis_type: null,
	            billing_centres: null,
	            accounts: null,
	            aerodromes: null,
	            payment_mode: null,
	            charge_class: null,
	            charge_category: null,
	            charge_type: null,
	            temporal_group: null,
	            group_by: null,
	            sort: null,
	            fiscal_year: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    RevenueDataService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    RevenueDataService.prototype.query = function (obj) {
	        return this.restangular.all("" + exports.endpoint).customPOST(obj);
	    };
	    RevenueDataService.prototype.createTemplate = function (obj) {
	        return this.restangular.all("" + exports.endpointRevenue).customPOST(obj);
	    };
	    RevenueDataService.prototype.deleteTemplate = function (id) {
	        return this.restangular.one(exports.endpointRevenue + "/" + id).remove();
	    };
	    RevenueDataService.prototype.updateTemplate = function (obj, id) {
	        return this.restangular.one(exports.endpointRevenue + "/" + id).customPUT(obj);
	    };
	    // returns all template names
	    RevenueDataService.prototype.getAllNames = function () {
	        return this.restangular.one(exports.endpointRevenue + "/getNames/").get();
	    };
	    // returns template by name
	    RevenueDataService.prototype.getTemplateByName = function (name) {
	        return this.restangular.one(exports.endpointRevenue + "/template-name/" + name).get();
	    };
	    RevenueDataService.prototype.displayValues = function () {
	        return [
	            {
	                name: 'Revenue (USD)',
	                value: 'usd_sum'
	            },
	            {
	                name: 'Revenue (ANSP)',
	                value: 'ansp_sum'
	            },
	            {
	                name: 'Occurrences of Item',
	                value: 'count'
	            }
	        ];
	    };
	    /**
	     * Used for `Group By` as well as fields to ignore
	     */
	    RevenueDataService.prototype.groupByValues = function () {
	        return [
	            {
	                id: 1,
	                name: 'Analysis Type',
	                value: 'analysis_type'
	            },
	            {
	                id: 2,
	                name: 'Billing Centre',
	                value: 'billing_centre'
	            },
	            {
	                id: 3,
	                name: 'Account',
	                value: 'account_name'
	            },
	            {
	                id: 4,
	                name: 'Aerodrome',
	                value: 'aerodrome_name'
	            },
	            {
	                id: 5,
	                name: 'Payment Mode',
	                value: 'payment_mode'
	            },
	            {
	                id: 6,
	                name: 'Charge Class',
	                value: 'charge_class'
	            },
	            {
	                id: 7,
	                name: 'Charge Category',
	                value: 'category'
	            },
	            {
	                id: 8,
	                name: 'Charge Type',
	                value: 'type'
	            }
	        ];
	    };
	    return RevenueDataService;
	}(crud_service_1.CRUDService));
	exports.RevenueDataService = RevenueDataService;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'recurring-charges';
	var RecurringChargesService = (function (_super) {
	    __extends(RecurringChargesService, _super);
	    /** @ngInject */
	    RecurringChargesService.$inject = ["Restangular"];
	    function RecurringChargesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            service_charge_catalogue: {
	                id: null,
	                charge_class: null,
	                category: null,
	                type: null,
	                subtype: null,
	                description: null,
	                charge_basis: null,
	                minimum_amount: null,
	                maximum_amount: null,
	                amount: null,
	                invoice_category: null,
	                external_accounting_system_identifier: null,
	                external_charge_category: null,
	                currency: null
	            },
	            account: {
	                id: null,
	                name: null,
	                alias: null,
	                aviation_billing_contact_person_name: null,
	                aviation_billing_phone_number: null,
	                aviation_billing_mailing_address: null,
	                aviation_billing_email_address: null,
	                non_aviation_billing_contact_person_name: null,
	                non_aviation_billing_phone_number: null,
	                non_aviation_billing_mailing_address: null,
	                non_aviation_billing_email_address: null,
	                account_users: [],
	                is_self_care: null,
	                is_vat_free: null,
	                exempt_flight_free: null,
	                iata_code: null,
	                icao_code: null,
	                opr_identifier: null,
	                payment_terms: null,
	                discount_structure: null,
	                tax_profile: null,
	                percentage_of_passenger_fee_payable: null,
	                invoice_delivery_format: null,
	                invoice_delivery_method: null,
	                invoice_currency: {
	                    id: null,
	                    currency_code: null,
	                    currency_name: null,
	                    country_code: null,
	                    decimal_places: null,
	                    allow_updated_from_web: null,
	                    symbol: null,
	                    active: null,
	                    external_accounting_system_identifier: null,
	                    exchange_rate_target_currency_id: null
	                },
	                monthly_overdue_penalty_rate: null,
	                notes: null,
	                black_listed_indicator: null,
	                black_listed_override: null,
	                credit_limit: null,
	                maximum_amount_credit_note: null,
	                minimum_amount_credit_note: null,
	                aircraft_parking_exemption: null,
	                account_type: null,
	                account_type_discount: null,
	                list_of_events_account_notified: null,
	                iata_member: null,
	                separate_pax_invoice: null,
	                external_accounting_system_identifier: null,
	                active: null,
	                cash_account: null,
	                approved_flight_school_indicator: null,
	                nationality: null,
	                whitelist_last_activity_date_time: null,
	                whitelist_state: null,
	                whitelist_inactivity_notice_sent_flag: null,
	                whitelist_expiry_notice_sent_flag: null,
	                invoice_pubblication: false,
	                invoice_overdue: false,
	                expired_certificate_warning: false,
	                expired_certificate: false,
	                has_uploaded_document: false,
	                uploaded_document_name: null,
	                uploaded_document_type: null,
	                document: null,
	                document_filename: null
	            },
	            start_date: null,
	            end_date: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    RecurringChargesService.prototype.getByAccountId = function (accountId, filter) {
	        return this.restangular.one(exports.endpoint + "/" + accountId).get({ filter: filter });
	    };
	    return RecurringChargesService;
	}(crud_service_1.CRUDService));
	exports.RecurringChargesService = RecurringChargesService;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'reports/generic';
	var ReportGenerationService = (function (_super) {
	    __extends(ReportGenerationService, _super);
	    /** @ngInject */
	    ReportGenerationService.$inject = ["Restangular"];
	    function ReportGenerationService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            report: null,
	            used_defined: null,
	            used_undefined: null,
	            todate: null,
	            overdue_interval: null,
	            invoices: null,
	            credit_type: null,
	            summary_interval: null,
	            filter_type: null,
	            account_ids: null,
	            account_new_page: null,
	            group_by_aerodrome: null,
	            group_by_account: true,
	            group_by_owner: null,
	            credit_notes: null,
	            debit_notes: null,
	            status: null,
	            include_null_accounts: null,
	            fiscal_year: null,
	            report_month: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    ReportGenerationService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    ReportGenerationService.prototype.getMissingInfoErrors = function () {
	        return [
	            { id: 1, name: 'Unresolved aircraft type', value: 'UNKNOWN_AIRCRAFT_TYPE' },
	            { id: 2, name: 'No Associated Account', value: 'NO_ASSOCIATED_ACCOUNT' },
	            { id: 3, name: 'Zero length billable flight track', value: 'ZERO_LENGTH_BILLABLE_TRACK' },
	            { id: 4, name: 'No international passenger count', value: 'MISSING_PASSENGER_INTERNATIONAL_DATA' },
	            { id: 5, name: 'No domestic passenger count', value: 'MISSING_PASSENGER_DOMESTIC_DATA' },
	            { id: 6, name: 'No parking time', value: 'MISSING_PARKING_TIME' },
	            { id: 7, name: 'No flight plan', value: 'FLIGHT_PLAN_MISSING' },
	            { id: 8, name: 'No radar track', value: 'RADAR_SUMMARY_CROSSCHECK' },
	            { id: 9, name: 'No ATC log', value: 'ATC_LOG_MISSING' },
	            { id: 10, name: 'No Tower log', value: 'TOWER_LOG_MISSING' },
	            { id: 11, name: 'No passenger service charge return', value: 'MISSING_PASSENGER_SERVICE_CHARGE_RETURN' },
	            { id: 12, name: 'Small aircraft withough valid CoA', value: 'EXPIRED_OR_MISSING_COA' }
	        ];
	    };
	    return ReportGenerationService;
	}(crud_service_1.CRUDService));
	exports.ReportGenerationService = ReportGenerationService;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'dbqueries/stats/air-traffic-statistics';
	exports.endpointAirTraffic = 'air-traffic-statistics';
	var AirTrafficDataService = (function (_super) {
	    __extends(AirTrafficDataService, _super);
	    /** @ngInject */
	    AirTrafficDataService.$inject = ["Restangular"];
	    function AirTrafficDataService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            start_date: null,
	            end_date: null,
	            aerodromes: null,
	            aircraft_types: null,
	            mtow_categories: null,
	            billing_centres: null,
	            accounts: null,
	            temporal_group: null,
	            flight_types: [],
	            flight_scopes: [],
	            flight_categories: [],
	            flight_rules: [],
	            flight_levels: null,
	            routes: null,
	            sort: null,
	            group_by: null,
	            fiscal_year: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    AirTrafficDataService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    AirTrafficDataService.prototype.displayValues = function () {
	        return [
	            {
	                name: 'Number of Flights',
	                value: 'count'
	            },
	            {
	                name: 'Total Revenue Generated',
	                value: 'sum_total_charges'
	            },
	            {
	                name: 'Domestic Passengers',
	                value: 'sum_passengers_chargeable_domestic'
	            },
	            {
	                name: 'International Passengers',
	                value: 'sum_passengers_chargeable_intern'
	            },
	            {
	                name: 'Revenue by Category',
	                value: 'revenue_category'
	            }
	        ];
	    };
	    /**
	     * Used for `Group By` as well as fields to ignore
	     */
	    AirTrafficDataService.prototype.groupByValues = function () {
	        return [
	            {
	                id: 1,
	                name: 'Billing Centre',
	                value: 'billing_centre'
	            },
	            {
	                id: 2,
	                name: 'Account',
	                value: 'account'
	            },
	            {
	                id: 3,
	                name: 'Flight Type',
	                value: 'flight_type'
	            },
	            {
	                id: 4,
	                name: 'Flight Scope',
	                value: 'flight_scope'
	            },
	            {
	                id: 5,
	                name: 'Flight Schedule Type',
	                value: 'flight_category'
	            },
	            {
	                id: 6,
	                name: 'Flight Rules',
	                value: 'flight_rules'
	            },
	            {
	                id: 7,
	                name: 'Aerodromes',
	                value: 'bill_aerodrome'
	            },
	            {
	                id: 8,
	                name: 'Route',
	                value: 'route'
	            },
	            {
	                id: 9,
	                name: 'Aircraft Type',
	                value: 'aircraft_type'
	            },
	            {
	                id: 10,
	                name: 'MTOW Category',
	                value: 'mtow_category'
	            },
	            {
	                id: 11,
	                name: 'Flight Level',
	                value: 'flight_level'
	            }
	        ];
	    };
	    AirTrafficDataService.prototype.query = function (obj) {
	        return this.restangular.all("" + exports.endpoint).customPOST(obj);
	    };
	    AirTrafficDataService.prototype.createTemplate = function (obj) {
	        return this.restangular.all("" + exports.endpointAirTraffic).customPOST(obj);
	    };
	    AirTrafficDataService.prototype.deleteTemplate = function (id) {
	        return this.restangular.one(exports.endpointAirTraffic + "/" + id).remove();
	    };
	    AirTrafficDataService.prototype.updateTemplate = function (obj, id) {
	        return this.restangular.one(exports.endpointAirTraffic + "/" + id).customPUT(obj);
	    };
	    // returns all template names
	    AirTrafficDataService.prototype.getAllNames = function () {
	        return this.restangular.one(exports.endpointAirTraffic + "/getNames/").get();
	    };
	    // returns template by name
	    AirTrafficDataService.prototype.getTemplateByName = function (name) {
	        return this.restangular.one(exports.endpointAirTraffic + "/template-name/" + name).get();
	    };
	    return AirTrafficDataService;
	}(crud_service_1.CRUDService));
	exports.AirTrafficDataService = AirTrafficDataService;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'report-templates';
	var ReportTemplatesService = (function (_super) {
	    __extends(ReportTemplatesService, _super);
	    /** @ngInject */
	    ReportTemplatesService.$inject = ["Restangular"];
	    function ReportTemplatesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            report_name: null,
	            sql_query: null,
	            parameters: null,
	            template_document: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return ReportTemplatesService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.ReportTemplatesService = ReportTemplatesService;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'tower-movement-log';
	var TowerMovementLogsService = (function (_super) {
	    __extends(TowerMovementLogsService, _super);
	    /** @ngInject */
	    TowerMovementLogsService.$inject = ["Restangular"];
	    function TowerMovementLogsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            date_of_contact: null,
	            flight_id: null,
	            registration: null,
	            aircraft_type: null,
	            operator_name: null,
	            departure_aerodrome: null,
	            departure_contact_time: null,
	            destination_aerodrome: null,
	            destination_contact_time: null,
	            route: null,
	            flight_level: null,
	            flight_crew: null,
	            passengers: null,
	            flight_category: null,
	            day_of_flight: null,
	            departure_time: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    TowerMovementLogsService.prototype.listFlightCategories = function () {
	        var listFlightCategories = [
	            {
	                name: 'Scheduled',
	                value: 'sch'
	            },
	            {
	                name: 'Non-scheduled',
	                value: 'nonsch'
	            }
	        ];
	        return listFlightCategories;
	    };
	    return TowerMovementLogsService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.TowerMovementLogsService = TowerMovementLogsService;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'repositioning-aerodrome-clusters';
	var RepositioningAerodromeClustersService = (function (_super) {
	    __extends(RepositioningAerodromeClustersService, _super);
	    /** @ngInject */
	    RepositioningAerodromeClustersService.$inject = ["Restangular"];
	    function RepositioningAerodromeClustersService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            repositioning_aerodrome_cluster_name: null,
	            enroute_fees_are_exempt: 0,
	            approach_fees_are_exempt: 0,
	            aerodrome_fees_are_exempt: 0,
	            late_arrival_fees_are_exempt: 0,
	            late_departure_fees_are_exempt: 0,
	            parking_fees_are_exempt: 0,
	            international_pax: 0,
	            domestic_pax: 0,
	            extended_hours: 0,
	            aerodrome_identifiers: [],
	            flight_notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return RepositioningAerodromeClustersService;
	}(crud_service_1.CRUDService));
	exports.RepositioningAerodromeClustersService = RepositioningAerodromeClustersService;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'system-summary';
	var SystemSummaryService = (function (_super) {
	    __extends(SystemSummaryService, _super);
	    /** @ngInject */
	    SystemSummaryService.$inject = ["Restangular"];
	    function SystemSummaryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            flight_movement_aircraft_type: null,
	            flight_movement_all: null,
	            flight_movement_blacklisted_account: null,
	            flight_movement_blacklisted_movement: null,
	            flight_movement_categories: null,
	            flight_movement_domestic_active_account: null,
	            flight_movement_international_active_account: null,
	            flight_movement_latest: null,
	            flight_movement_inside: null,
	            flight_movement_outside: null,
	            flight_movement_parking_time_domestic: null,
	            flight_movement_parking_time_internationa_arrivals: null,
	            flight_movement_parking_time_total: null,
	            flight_movement_rejected: null,
	            flight_movement_unknown_aircraft_type: null,
	            outstanding_bill: null,
	            overdue_bill: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return SystemSummaryService;
	}(crud_service_1.CRUDService));
	exports.SystemSummaryService = SystemSummaryService;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'atc-movement-log';
	var AtcMovementLogService = (function (_super) {
	    __extends(AtcMovementLogService, _super);
	    /** @ngInject */
	    AtcMovementLogService.$inject = ["Restangular"];
	    function AtcMovementLogService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            date_of_contact: null,
	            registration: null,
	            operator_identifier: null,
	            route: null,
	            flight_id: null,
	            aircraft_type: null,
	            departure_aerodrome: null,
	            destination_aerodrome: null,
	            fir_entry_point: null,
	            fir_entry_time: null,
	            fir_second_point: null,
	            fir_second_time: null,
	            fir_mid_point: null,
	            fir_mid_time: null,
	            fir_fourth_point: null,
	            fir_fourth_time: null,
	            fir_fifth_point: null,
	            fir_fifth_time: null,
	            fir_exit_point: null,
	            fir_exit_time: null,
	            flight_level: null,
	            wake_turbulence: null,
	            flight_category: null,
	            flight_type: null,
	            day_of_flight: null,
	            departure_time: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    AtcMovementLogService.prototype.listFlightTypes = function () {
	        return [
	            {
	                name: 'S',
	                value: 's'
	            },
	            {
	                name: 'N',
	                value: 'n'
	            },
	            {
	                name: 'G',
	                value: 'g'
	            },
	            {
	                name: 'M',
	                value: 'm'
	            },
	            {
	                name: 'X',
	                value: 'x'
	            }
	        ];
	    };
	    AtcMovementLogService.prototype.listFlightCategories = function () {
	        return [
	            {
	                name: 'I',
	                value: 'i'
	            },
	            {
	                name: 'V',
	                value: 'v'
	            },
	            {
	                name: 'Y',
	                value: 'y'
	            },
	            {
	                name: 'Z',
	                value: 'z'
	            }
	        ];
	    };
	    return AtcMovementLogService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.AtcMovementLogService = AtcMovementLogService;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'billing-centers';
	var BillingCentreManagementService = (function (_super) {
	    __extends(BillingCentreManagementService, _super);
	    /** @ngInject */
	    BillingCentreManagementService.$inject = ["Restangular"];
	    function BillingCentreManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            aerodromes: [],
	            hq: null,
	            id: null,
	            invoice_sequence_number: null,
	            name: null,
	            prefix_invoice_number: null,
	            prefix_receipt_number: null,
	            receipt_sequence_number: null,
	            users: [],
	            external_accounting_system_identifier: null,
	            iata_invoice_sequence_number: null,
	            receipt_cheque_sequence_number: null,
	            receipt_wire_sequence_number: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return list of billing centres IDs and names ONLY
	     */
	    BillingCentreManagementService.prototype.findAllMinimalReturn = function () {
	        return this.restangular.one(exports.endpoint + "/allMinimal").get();
	    };
	    BillingCentreManagementService.prototype.getBillingCentreByAerodromes = function (depAd, destAd) {
	        return this.restangular.one(exports.endpoint + "/" + depAd + "/" + destAd).get();
	    };
	    return BillingCentreManagementService;
	}(crud_service_1.CRUDService));
	exports.BillingCentreManagementService = BillingCentreManagementService;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'unspecified-departure-destination-locations';
	/* @ngInject */
	var UnspecifiedDepDestLocationsService = (function (_super) {
	    __extends(UnspecifiedDepDestLocationsService, _super);
	    UnspecifiedDepDestLocationsService.$inject = ["Restangular", "$q"];
	    function UnspecifiedDepDestLocationsService(Restangular, $q) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$q = $q;
	        _this._mod = {
	            id: null,
	            text_identifier: null,
	            name: null,
	            maintained: null,
	            aerodrome_identifier: null,
	            latitude: null,
	            longitude: null,
	            status: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return UnspecifiedDepDestLocationsService;
	}(crud_service_1.CRUDService));
	exports.UnspecifiedDepDestLocationsService = UnspecifiedDepDestLocationsService;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'nominal-routes';
	var NominalRoutesService = (function (_super) {
	    __extends(NominalRoutesService, _super);
	    /** @ngInject */
	    NominalRoutesService.$inject = ["Restangular"];
	    function NominalRoutesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            type: null,
	            pointa: null,
	            pointb: null,
	            nominal_distance: null,
	            bi_directional: true,
	            nominal_route_floor: 0,
	            nominal_route_ceiling: 999
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    NominalRoutesService.prototype.listRouteTypes = function () {
	        var routeTypes = [
	            {
	                id: 0,
	                name: 'Aerodrome/Aerodrome',
	                value: 'AA'
	            },
	            {
	                id: 1,
	                name: 'FIR Entry/Exit to Aerodrome',
	                value: 'FIRA'
	            },
	            {
	                id: 2,
	                name: 'FIR / FIR',
	                value: 'FIRFIR'
	            }
	        ];
	        return routeTypes;
	    };
	    return NominalRoutesService;
	}(crud_service_1.CRUDService));
	exports.NominalRoutesService = NominalRoutesService;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'exempt-flight-status';
	var FlightStatusExemptionsService = (function (_super) {
	    __extends(FlightStatusExemptionsService, _super);
	    /** @ngInject */
	    FlightStatusExemptionsService.$inject = ["Restangular"];
	    function FlightStatusExemptionsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aerodrome_fees_exempt: 0,
	            flight_item_type: null,
	            flight_item_value: null,
	            late_departure_fees_exempt: 0,
	            parking_fees_are_exempt: 0,
	            enroute_fees_are_exempt: 0,
	            approach_fees_exempt: 0,
	            late_arrival_fees_exempt: 0,
	            international_pax: 0,
	            domestic_pax: 0,
	            extended_hours: 0,
	            flight_notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    FlightStatusExemptionsService.prototype.listFlightTypes = function () {
	        return [
	            {
	                name: 'Item 18 - Statuses',
	                value: 'ITEM18-STS'
	            },
	            {
	                name: 'Item 8 - Type',
	                value: 'ITEM8-TYPE'
	            },
	            {
	                name: 'Item 18 - RMK',
	                value: 'ITEM18-RMK'
	            },
	            {
	                name: 'Item 8 - Rule',
	                value: 'ITEM8-RULE'
	            }
	        ];
	    };
	    FlightStatusExemptionsService.prototype.listItem8Codes = function () {
	        return [
	            {
	                name: 'General Aviation',
	                value: 'G'
	            },
	            {
	                name: 'Military',
	                value: 'M'
	            },
	            {
	                name: 'Non-scheduled Air Service',
	                value: 'N'
	            },
	            {
	                name: 'Other',
	                value: 'X'
	            },
	            {
	                name: 'Scheduled Air Service',
	                value: 'S'
	            }
	        ];
	    };
	    FlightStatusExemptionsService.prototype.listRulesCodes = function () {
	        return [
	            {
	                name: 'I - Instrument flight rules',
	                value: 'I'
	            },
	            {
	                name: 'V - Visual flight rules',
	                value: 'V'
	            },
	            {
	                name: 'Z – Initially VFR',
	                value: 'Z'
	            },
	            {
	                name: 'Y – Initially IFR',
	                value: 'Y'
	            }
	        ];
	    };
	    FlightStatusExemptionsService.prototype.listSTSCodes = function () {
	        return [
	            {
	                name: 'Altitude Reservation',
	                value: 'ALTRV'
	            },
	            {
	                name: 'Approved by ATS Authorities',
	                value: 'ATFMX'
	            },
	            {
	                name: 'Firefighting',
	                value: 'FFR'
	            },
	            {
	                name: 'Hazardous Material',
	                value: 'HAZMAT'
	            },
	            {
	                name: 'Head of State',
	                value: 'HEAD'
	            },
	            {
	                name: 'Humanitarian Mission',
	                value: 'HUM'
	            },
	            {
	                name: 'Medical Evacuation',
	                value: 'MEDEVAC'
	            },
	            {
	                name: 'Medical Flight',
	                value: 'HOSP'
	            },
	            {
	                name: 'Military Authority',
	                value: 'MARSA'
	            },
	            {
	                name: 'Military, Customs or Police',
	                value: 'STATE'
	            },
	            {
	                name: 'Navaid Calibration',
	                value: 'FLTCK'
	            },
	            {
	                name: 'Non-RVSM Capable Flight',
	                value: 'NONRVSM'
	            },
	            {
	                name: 'Search and Rescue',
	                value: 'SAR'
	            }
	        ];
	    };
	    return FlightStatusExemptionsService;
	}(crud_service_1.CRUDService));
	exports.FlightStatusExemptionsService = FlightStatusExemptionsService;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'exempt-flight-routes';
	var FlightRouteExemptionsService = (function (_super) {
	    __extends(FlightRouteExemptionsService, _super);
	    /** @ngInject */
	    FlightRouteExemptionsService.$inject = ["Restangular"];
	    function FlightRouteExemptionsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            departure_aerodrome: null,
	            destination_aerodrome: null,
	            exempt_type: null,
	            waypoint_from: null,
	            waypoint_to: null,
	            airway: null,
	            coordinate_from: null,
	            coordinate_to: null,
	            start_date: null,
	            end_date: null,
	            exemption_in_either_direction: false,
	            enroute_fees_are_exempt: 0,
	            approach_fees_are_exempt: 0,
	            aerodrome_fees_are_exempt: 0,
	            late_arrival_fees_are_exempt: 0,
	            late_departure_fees_are_exempt: 0,
	            parking_fees_are_exempt: 0,
	            international_pax: 0,
	            domestic_pax: 0,
	            extended_hours: 0,
	            flight_notes: null,
	            exempt_route_floor: 0,
	            exempt_route_ceiling: 999,
	            exempt_item_type: null,
	            exempt_item_value: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    FlightRouteExemptionsService.prototype.getEanaAirwaysFromNavDB = function () {
	        return this.restangular.one(exports.endpoint + "/eanaAirwaysFromnavdb").get();
	    };
	    FlightRouteExemptionsService.prototype.getEanaWaypointsFromNavDB = function () {
	        return this.restangular.one(exports.endpoint + "/eanaWaypointsFromnavdb").get();
	    };
	    FlightRouteExemptionsService.prototype.listExemptTypes = function () {
	        return [
	            {
	                name: 'Aerodrome',
	                value: 'Aerodrome To Aerodrome'
	            },
	            {
	                name: 'Waypoint',
	                value: 'Waypoint To Waypoint'
	            },
	            {
	                name: 'Airway',
	                value: 'Airway'
	            },
	            {
	                name: 'Coordinate',
	                value: 'Coordinate'
	            }
	        ];
	    };
	    return FlightRouteExemptionsService;
	}(crud_service_1.CRUDService));
	exports.FlightRouteExemptionsService = FlightRouteExemptionsService;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'unspecified-aircraft-types';
	var AircraftUnspecifiedManagementService = (function (_super) {
	    __extends(AircraftUnspecifiedManagementService, _super);
	    /** @ngInject */
	    AircraftUnspecifiedManagementService.$inject = ["Restangular"];
	    function AircraftUnspecifiedManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            text_identifier: null,
	            aircraft_type: null,
	            name: null,
	            status: null,
	            mtow: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return AircraftUnspecifiedManagementService;
	}(crud_service_1.CRUDService));
	exports.AircraftUnspecifiedManagementService = AircraftUnspecifiedManagementService;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'radar-summaries';
	var RadarSummaryService = (function (_super) {
	    __extends(RadarSummaryService, _super);
	    /** @ngInject */
	    RadarSummaryService.$inject = ["Restangular"];
	    function RadarSummaryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            date: null,
	            flight_identifier: null,
	            day_of_flight: null,
	            departure_time: null,
	            registration: null,
	            aircraft_type: null,
	            departure_aero_drome: null,
	            destination_aero_drome: null,
	            route: null,
	            fir_entry_point: null,
	            fir_entry_time: null,
	            fir_entry_flight_level: null,
	            fir_exit_point: null,
	            fir_exit_time: null,
	            fir_exit_flight_level: null,
	            flight_rule: null,
	            flight_travel_category: null,
	            cruising_speed: null,
	            flight_level: null,
	            wake_turb: null,
	            entry_coordinate: null,
	            exit_coordinate: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    RadarSummaryService.prototype.listCategories = function () {
	        return [
	            'overflight',
	            'arrival',
	            'departure',
	            'domestic'
	        ];
	    };
	    RadarSummaryService.prototype.listFlightRules = function () {
	        return ['IFR', 'VFR'];
	    };
	    // this has to be done because if filters are used, it is a different endpoint
	    RadarSummaryService.prototype.list = function (params, queryString) {
	        var _this = this;
	        if (params &&
	            (typeof params.search !== 'undefined' || (typeof params.start !== 'undefined' && typeof params.end !== 'undefined'))) {
	            if (params.search === '') {
	                delete params.search;
	            }
	            this.endpoint = exports.endpoint + "/filters"; // to use filters, it is a different URL endpoint
	        }
	        return _super.prototype.list.call(this, params, queryString)
	            .then(function (data) { _this.endpoint = exports.endpoint; return data; })
	            .catch(function () { return _this.endpoint = exports.endpoint; }); // always revert endpoint
	    };
	    return RadarSummaryService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.RadarSummaryService = RadarSummaryService;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'invoice-templates';
	var InvoiceTemplateManagementService = (function (_super) {
	    __extends(InvoiceTemplateManagementService, _super);
	    /** @ngInject */
	    InvoiceTemplateManagementService.$inject = ["Restangular"];
	    function InvoiceTemplateManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            invoice_template_name: null,
	            invoice_category: null,
	            template_document: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    InvoiceTemplateManagementService.prototype.resetTemplate = function (invoiceCategory) {
	        return this.restangular.one(exports.endpoint + "/" + invoiceCategory + "/reset").get();
	    };
	    return InvoiceTemplateManagementService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.InvoiceTemplateManagementService = InvoiceTemplateManagementService;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'enroute-airnavigation-charges';
	var EnrouteAirNavigationChargesManagementService = (function (_super) {
	    __extends(EnrouteAirNavigationChargesManagementService, _super);
	    /** @ngInject */
	    EnrouteAirNavigationChargesManagementService.$inject = ["Restangular"];
	    function EnrouteAirNavigationChargesManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            mtow_category_upper_limit: null,
	            w_factor_formula: null,
	            enroute_air_navigation_charge_formulas: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // validates formulas, returning which formulas are invalid and why
	    EnrouteAirNavigationChargesManagementService.prototype.validate = function (enrouteAirNavigationCharge) {
	        var copy = angular.copy(enrouteAirNavigationCharge); // copy of object sends to back end with id = null because back end doesn't accept id when updating
	        copy.id = null;
	        return this.restangular.all(exports.endpoint + "/validate").customPOST(copy);
	    };
	    return EnrouteAirNavigationChargesManagementService;
	}(crud_service_1.CRUDService));
	exports.EnrouteAirNavigationChargesManagementService = EnrouteAirNavigationChargesManagementService;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'service-charge-catalogues';
	var CatalogueServiceChargeService = (function (_super) {
	    __extends(CatalogueServiceChargeService, _super);
	    /** @ngInject */
	    CatalogueServiceChargeService.$inject = ["Restangular"];
	    function CatalogueServiceChargeService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            charge_class: null,
	            category: null,
	            type: null,
	            subtype: null,
	            description: null,
	            charge_basis: null,
	            minimum_amount: null,
	            maximum_amount: null,
	            amount: null,
	            invoice_category: null,
	            external_accounting_system_identifier: null,
	            external_charge_category: null,
	            currency: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CatalogueServiceChargeService.prototype.getBasisList = function () {
	        return [
	            {
	                name: 'Fixed',
	                value: 'fixed'
	            },
	            {
	                name: 'Price per Unit',
	                value: 'unit'
	            },
	            {
	                name: 'Percentage',
	                value: 'percentage'
	            },
	            {
	                name: 'User Entered Price',
	                value: 'user'
	            },
	            {
	                name: 'Water',
	                value: 'water'
	            },
	            {
	                name: 'Residential Electric',
	                value: 'residential-electric'
	            },
	            {
	                name: 'Commercial Electric',
	                value: 'commercial-electric'
	            },
	            {
	                name: 'Discount',
	                value: 'discount'
	            },
	            {
	                name: 'External Database',
	                value: 'external-database'
	            }
	        ];
	    };
	    CatalogueServiceChargeService.prototype.listCategories = function () {
	        return [
	            {
	                name: 'IATA-AVI',
	                value: 'iata-avi'
	            },
	            {
	                name: 'Non-IATA-AVI',
	                value: 'non-iata-avi'
	            },
	            {
	                name: 'Cash AVI',
	                value: 'cash-avi'
	            },
	            {
	                name: 'Non-AVI',
	                value: 'non-avi'
	            },
	            {
	                name: 'Utility',
	                value: 'utility'
	            },
	            {
	                name: 'Lease',
	                value: 'lease'
	            },
	            {
	                name: 'Concession',
	                value: 'concession'
	            },
	            {
	                name: 'Point of Sale',
	                value: 'pos'
	            },
	            {
	                name: 'Receipt',
	                value: 'receipt'
	            }
	        ];
	    };
	    return CatalogueServiceChargeService;
	}(crud_service_1.CRUDService));
	exports.CatalogueServiceChargeService = CatalogueServiceChargeService;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// contants
	var system_configuration_constants_1 = __webpack_require__(10);
	// services
	var crud_service_1 = __webpack_require__(8);
	var localStorage_service_1 = __webpack_require__(9);
	// endpoint
	exports.endpoint = 'flightmovements';
	exports.endpoint_fm_categories = 'flightmovement-categories';
	exports.aerodromesEndpoint = 'aerodromes';
	var FlightMovementManagementService = (function (_super) {
	    __extends(FlightMovementManagementService, _super);
	    /** @ngInject */
	    FlightMovementManagementService.$inject = ["Restangular", "$q", "systemConfigurationService"];
	    function FlightMovementManagementService(Restangular, $q, systemConfigurationService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$q = $q;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this._mod = {
	            id: null,
	            actual_departure_time: null,
	            actual_mtow: null,
	            aerodrome_charges: null,
	            approach_charges: null,
	            aircraft_type: null,
	            arrival_ad: null,
	            arrival_time: null,
	            associated_aircraft: null,
	            associated_account: null,
	            associated_account_black_listed_indicator: null,
	            associated_account_black_listed_override: null,
	            associated_account_id: null,
	            average_mass_factor: null,
	            atc_crossing_distance: null,
	            atc_crossing_distance_cost: null,
	            crew_members: null,
	            date_of_flight: null,
	            delta_flight: null,
	            dep_ad: null,
	            dep_time: null,
	            dest_ad: null,
	            domestic_passenger_charges: null,
	            enroute_charges: null,
	            enroute_charges_basis: null,
	            enroute_charges_status: null,
	            enroute_invoice_id: null,
	            entry_time: null,
	            exempt_approach_charges: null,
	            exempt_dep_charges: null,
	            exempt_domestic_passenger_charges: null,
	            exempt_enroute_charges: null,
	            exempt_international_passenger_charges: null,
	            exempt_parking_charges: null,
	            exempt_late_departure_charges: null,
	            exempt_late_arrival_charges: null,
	            exempt_aerodrome_charges: null,
	            exit_time: null,
	            flight_id: null,
	            flight_level: null,
	            flight_notes: null,
	            flight_rules: null,
	            flight_type: null,
	            flight_category_nationality: null,
	            flight_category_scope: null,
	            flight_category_type: null,
	            flightmovement_category_name: null,
	            fpl_crossing_cost: null,
	            fpl_crossing_distance: null,
	            fpl_route: null,
	            initial_fpl_data: null,
	            ac_number: null,
	            international_passenger_charges: null,
	            item18_dep: null,
	            item18_dest: null,
	            item18_reg_num: null,
	            item18_rmk: null,
	            item18_status: null,
	            item18_aircraft_type: null,
	            item18_operator: null,
	            late_arrival_charges: null,
	            late_departure_charges: null,
	            manually_changed_fields: null,
	            movement_type: null,
	            nominal_crossing_cost: null,
	            nominal_crossing_distance: null,
	            other_charges_status: null,
	            other_info: null,
	            other_invoice_id: null,
	            parking_charges: null,
	            parking_time: null,
	            passenger_charges_status: null,
	            passenger_invoice_id: null,
	            passengers_chargeable_domestic: null,
	            passengers_chargeable_intern: null,
	            passengers_joining_adult: null,
	            passengers_transit_adult: null,
	            passengers_child: null,
	            prepaid_amount: null,
	            radar_crossing_cost: null,
	            radar_crossing_distance: null,
	            resolution_errors: null,
	            source: 'manual',
	            spatia_fpl_object_id: null,
	            status: null,
	            total_charges: null,
	            tower_crossing_distance: null,
	            tower_crossing_distance_cost: null,
	            user_crossing_distance: null,
	            user_crossing_distance_cost: null,
	            wake_turb: null,
	            estimated_elapsed_time: null,
	            radar_route_text: null,
	            atc_log_route_text: null,
	            tower_log_route_text: null,
	            tasp_charge: null,
	            cruising_speed_or_mach_number: null,
	            adhoc_charge_required: false,
	            flightCategory: null,
	            enroute_invoice_currency: null,
	            enroute_result_currency: null,
	            arriving_pax_domestic_airport: null,
	            landing_pax_domestic_airport: null,
	            transfer_pax_domestic_airport: null,
	            departing_pax_domestic_airport: null,
	            arriving_child_domestic_airport: null,
	            landing_child_domestic_airport: null,
	            transfer_child_domestic_airport: null,
	            departing_child_domestic_airport: null,
	            exempt_arriving_pax_domestic_airport: null,
	            exempt_landing_pax_domestic_airport: null,
	            exempt_transfer_pax_domestic_airport: null,
	            exempt_departing_pax_domestic_airport: null,
	            loaded_goods: null,
	            discharged_goods: null,
	            loaded_mail: null,
	            discharged_mail: null,
	            status_notes: null,
	            extended_hours_surcharge_currency: null,
	            extended_hours_surcharge: null,
	            tasp_charge_currency: null,
	            reporting_responsabilities: null,
	            ifpl_id: null,
	            warnings: [],
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    FlightMovementManagementService.prototype.getAccountFlightMovements = function (accountId) {
	        return this.restangular.all(exports.endpoint + "/account/" + accountId).getList();
	    };
	    // recalculates one or many flight movements
	    FlightMovementManagementService.prototype.recalculate = function (flightMovements) {
	        return this.restangular.all(exports.endpoint + "/recalculate").customPUT(flightMovements);
	    };
	    // reconciles one or many flight movements
	    FlightMovementManagementService.prototype.reconcile = function (flightMovements) {
	        return this.restangular.all(exports.endpoint + "/reconcile").customPUT(flightMovements);
	    };
	    // generates invoices for flight movements
	    FlightMovementManagementService.prototype.generateInvoice = function (flightMovements) {
	        return this.restangular.all(exports.endpoint + "/generate-invoices").customPOST(flightMovements);
	    };
	    FlightMovementManagementService.prototype.getFlightMovementCategoryForAviationInvoice = function () {
	        return this.restangular.one(exports.endpoint_fm_categories + "/aviation-invoice").get();
	    };
	    // tests to see if a flight movement is complete
	    FlightMovementManagementService.prototype.validate = function (flightMovement) {
	        return this.restangular.all(exports.endpoint + "/validate").customPOST(flightMovement);
	    };
	    FlightMovementManagementService.prototype.verifyRoute = function (dep_ad, route, dest_ad) {
	        return this.restangular
	            .all(exports.endpoint + "/verify-route")
	            .customPOST({ dep_ad: dep_ad, route: route, dest_ad: dest_ad });
	    };
	    // this has to be done because if filters are used, it is a different endpoint
	    FlightMovementManagementService.prototype.list = function (params, queryString) {
	        var _this = this;
	        if (params &&
	            (typeof params.fmStatusFilter !== 'undefined' || typeof params.search !== 'undefined' || typeof params.type !== 'undefined' || typeof params.status !== 'undefined' || typeof params.invoice !== 'undefined'
	                || typeof params.issue !== 'undefined' || typeof params.iata !== 'undefined' || (typeof params.start !== 'undefined' && typeof params.end !== 'undefined'
	                || typeof params.flight_rules !== 'undefined' || typeof params.flight_type !== 'undefined' || typeof params.crco_flight !== 'undefined'))) {
	            if (params.search === '') {
	                delete params.search;
	            }
	            this.endpoint = exports.endpoint + "/filters"; // to use filters, it is a different URL endpoint
	        }
	        return _super.prototype.list.call(this, params, queryString)
	            .then(function (data) { _this.endpoint = exports.endpoint; return data; })
	            .catch(function () { return _this.endpoint = exports.endpoint; }); // always revert endpoint
	    };
	    // returns an aircraft type by the last registration number in the database (if it exists)
	    FlightMovementManagementService.prototype.getAircraftTypeByLatestRegistrationNumber = function (registrationNumber) {
	        return this.restangular.one(exports.endpoint + "/aircraftTypeByLatestRegistrationNumber/" + registrationNumber).get();
	    };
	    // returns flight movements that are related to the invoice (or `billing_ledger` which it's currently called in the database)
	    FlightMovementManagementService.prototype.findAllFlightMovementsByAssociatedInvoiceId = function (invoiceId, page, size) {
	        // request parameters, always pass 'size' parameter
	        var params = {
	            size: size || localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE) || 20
	        };
	        // add page parameter if supplied
	        // the uib-pagination starts at `1` but Spring Framework starts at `0`, therefore we fake it
	        if (page && page > 0) {
	            params.page = page - 1;
	        }
	        return this.restangular.one(exports.endpoint + "/invoices/" + invoiceId).get(params);
	    };
	    // returns flight movements that are related to the invoice (or `billing_ledger` which it's currently called in the database)
	    FlightMovementManagementService.prototype.findAllFlightMovementsListByAssociatedInvoiceId = function (invoiceId) {
	        return this.restangular.one(exports.endpoint + "/list/invoices/" + invoiceId).get();
	    };
	    FlightMovementManagementService.prototype.findInitialFpl = function (id) {
	        return this.restangular.one(exports.endpoint + "/initialFpl/" + id).get();
	    };
	    FlightMovementManagementService.prototype.getTrackableFields = function () {
	        return ['flight_id', 'item18_reg_num', 'date_of_flight', 'dep_time', 'dep_ad',
	            'aircraft_type', 'dest_ad', 'associated_account_id', 'flight_type', 'item18_status',
	            'item18_rmk', 'item18_dep', 'item18_dest', 'item18_aircraft_type', 'route', 'arrival_ad', 'arrival_time',
	            'parking_time', 'passengers_chargeable_intern', 'passengers_chargeable_domestic', 'passengers_child',
	            'estimated_elapsed_time', 'cruising_speed_or_mach_number', 'flight_level', 'user_crossing_distance'];
	    };
	    // returns distinct dep_ad and dest_ad
	    FlightMovementManagementService.prototype.getDistinctRoutes = function () {
	        return this.restangular.one(exports.endpoint + "/distinctRoutes/").get();
	    };
	    // returns distinct flight levels
	    FlightMovementManagementService.prototype.getDistinctFlightLevels = function () {
	        return this.restangular.one(exports.endpoint + "/distinctFlightLevels/").get();
	    };
	    // returns distinct registration numbers
	    FlightMovementManagementService.prototype.getDistinctRegNum = function () {
	        return this.restangular.one(exports.endpoint + "/distinctRegNumbers/").get();
	    };
	    // when a user deletes a flight movement, the record is not physically deleting but modifying the flight movement status
	    FlightMovementManagementService.prototype.deleteOverride = function (id, reason) {
	        return this.restangular.one(exports.endpoint + "/delete/" + id).customPUT(reason);
	    };
	    FlightMovementManagementService.prototype.showWarning = function (actionOne, actionTwo) {
	        var warning = {
	            data: {
	                error: actionOne + " Reason is required",
	                error_description: actionOne + " Reason is required for " + actionTwo + " a flight movement"
	            }
	        };
	        return { error: warning };
	    };
	    // gets an account based on FLIGHT_ID
	    FlightMovementManagementService.prototype.getAccountFromIdentifier = function (identifier) {
	        if (identifier) {
	            return this.restangular.one(exports.endpoint + "/accountByIdentifier/" + identifier).get();
	        }
	        else {
	            return this.$q.reject('identifier prefix cannot be null or empty');
	        }
	    };
	    // get an account based on item18 operator
	    FlightMovementManagementService.prototype.getAccountFromOperator = function (operator) {
	        return operator
	            ? this.restangular.one(exports.endpoint + "/accountByOperator/" + operator).get()
	            : this.$q.reject('operator cannot be null or empty');
	    };
	    // gets valid aircraft registration based on REGISTRATION_NUMBER
	    FlightMovementManagementService.prototype.getAircraftRegistrationFromRegNumber = function (regNumber, flightDate) {
	        if (regNumber && flightDate) {
	            return this.restangular.one(exports.endpoint + "/aircraftRegistrationByRegNumber/" + regNumber + "/" + flightDate).get();
	        }
	        else {
	            return this.$q.reject('regNumber and flightDate cannot be null or empty');
	        }
	    };
	    /**
	     * Mark flight movements as paid, only PENDING zero cost flights will be processed.
	     *
	     * @param flightIdList list of flight movements to mark as paid
	     */
	    FlightMovementManagementService.prototype.markAsPaid = function (flightIdList) {
	        return this.Restangular.one(exports.endpoint + "/mark-as-paid").customPOST(flightIdList);
	    };
	    /**
	     * Returns all incomplete flight movement reasons. MISSING_PARKING_TIME is only
	     * included if system configuration item 'CALCULATE_PARKING_CHARGES' is enabled.
	     */
	    FlightMovementManagementService.prototype.getAllIncompleteReasons = function () {
	        // add all default incomplete reasons
	        // ids values must be unique but are only used for ngRepeat trackBy and can be 'number' value
	        var result = [
	            { id: 1, name: 'Missing MTOW', value: 'MISSING_MTOW' },
	            { id: 2, name: 'No Associated Account', value: 'NO_ASSOCIATED_ACCOUNT' },
	            { id: 3, name: 'Unknown Aircraft Type', value: 'UNKNOWN_AIRCRAFT_TYPE' },
	            { id: 4, name: 'Zero Length Billable Track', value: 'ZERO_LENGTH_BILLABLE_TRACK' },
	            { id: 5, name: 'Passenger Service Charge Incomplete', value: 'MISSING_PASSENGER_SERVICE_CHARGE_RETURN' },
	            { id: 6, name: 'Radar Summary Incomplete', value: 'RADAR_SUMMARY_MISSING' },
	            { id: 7, name: 'Tower Log Incomplete', value: 'TOWER_LOG_MISSING' },
	            { id: 8, name: 'ATC Log Incomplete', value: 'ATC_LOG_MISSING' },
	            { id: 9, name: 'Flight Plan Incomplete', value: 'FLIGHT_PLAN_MISSING' },
	            { id: 10, name: 'Passenger Domestic Data Incomplete', value: 'MISSING_PASSENGER_DOMESTIC_DATA' },
	            { id: 11, name: 'Passenger International Data Incomplete', value: 'MISSING_PASSENGER_INTERNATIONAL_DATA' },
	            { id: 12, name: 'Unknown Departure Aerodrome', value: 'UNKNOWN_DEP_AD' },
	            { id: 13, name: 'Unknown Destination Aerodrome', value: 'UNKNOWN_DEST_AD' },
	            { id: 14, name: 'Expired Or Missing CoA For Small Aircraft', value: 'EXPIRED_OR_MISSING_COA_FOR_SMALL_AIRCRAFT' },
	            { id: 15, name: 'Invalid Time Format', value: 'INVALID_TIME_FORMAT' },
	            { id: 16, name: 'Invalid Flight Level', value: 'INVALID_FLIGHT_LEVEL' },
	            { id: 17, name: 'Invalid Route', value: 'INVALID_ROUTE' },
	        ];
	        // only add parking charge if 'CALCULATE_PARKING_CHARGES' is enabled in system configuration
	        if (this.systemConfigurationService.shouldShowCharge('parking')) {
	            result.push({
	                id: 16, name: 'Missing Parking Time', value: 'MISSING_PARKING_TIME'
	            });
	        }
	        return result;
	    };
	    FlightMovementManagementService.prototype.checkBalance = function (flightMovement) {
	        return this.Restangular.one(exports.endpoint + "/check-balance").customPOST(flightMovement);
	    };
	    FlightMovementManagementService.prototype.getAerodromesByBillingCentre = function () {
	        return this.restangular.one(exports.aerodromesEndpoint + "?current-billing-center").get();
	    };
	    FlightMovementManagementService.prototype.getAirportFromNavDBByQuery = function (query) {
	        return this.restangular.one('airport/getAllAirportsFromNavDBByQuery').get({ query: query });
	    };
	    return FlightMovementManagementService;
	}(crud_service_1.CRUDService));
	exports.FlightMovementManagementService = FlightMovementManagementService;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'airspaces';
	var AirspaceManagementService = (function (_super) {
	    __extends(AirspaceManagementService, _super);
	    /** @ngInject */
	    AirspaceManagementService.$inject = ["Restangular"];
	    function AirspaceManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            airspace_name: null,
	            airspace_type: null,
	            airspace_full_name: null,
	            airspace_included: null,
	            airspace_ceiling: null,
	            id: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    AirspaceManagementService.prototype.getAirspacesFromNavDB = function () {
	        return this.restangular.one(exports.endpoint + "/fromnavdb").get();
	    };
	    AirspaceManagementService.prototype.create = function (id) {
	        return this.restangular.one(exports.endpoint + "/fromnavdb/" + id).customPOST();
	    };
	    return AirspaceManagementService;
	}(crud_service_1.CRUDService));
	exports.AirspaceManagementService = AirspaceManagementService;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'account-exemptions';
	var AccountExemptManagementService = (function (_super) {
	    __extends(AccountExemptManagementService, _super);
	    /** @ngInject */
	    AccountExemptManagementService.$inject = ["Restangular"];
	    function AccountExemptManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account_id: null,
	            account_name: null,
	            enroute: 0,
	            parking: 0,
	            approach_fees_exempt: 0,
	            aerodrome_fees_exempt: 0,
	            late_arrival: 0,
	            late_departure: 0,
	            international_pax: 0,
	            domestic_pax: 0,
	            extended_hours: 0,
	            unified_tax: 0,
	            flight_notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return AccountExemptManagementService;
	}(crud_service_1.CRUDService));
	exports.AccountExemptManagementService = AccountExemptManagementService;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'utilities-towns-and-villages';
	var UtilitiesTownsService = (function (_super) {
	    __extends(UtilitiesTownsService, _super);
	    /** @ngInject */
	    UtilitiesTownsService.$inject = ["Restangular"];
	    function UtilitiesTownsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            town_or_village_name: null,
	            water_utility_schedule: null,
	            residential_electricity_utility_schedule: null,
	            commercial_electricity_utility_schedule: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return UtilitiesTownsService;
	}(crud_service_1.CRUDService));
	exports.UtilitiesTownsService = UtilitiesTownsService;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'utilities-schedules';
	var UtilitiesSchedulesService = (function (_super) {
	    __extends(UtilitiesSchedulesService, _super);
	    /** @ngInject */
	    UtilitiesSchedulesService.$inject = ["Restangular", "$translate"];
	    function UtilitiesSchedulesService(Restangular, $translate) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            schedule_id: null,
	            schedule_type: null,
	            minimum_charge: null,
	            utilities_range_bracket: [{
	                    id: null,
	                    schedule_id: null,
	                    range_top_end: null,
	                    unit_price: null
	                }],
	            utilities_water_towns_and_village: [{
	                    id: null,
	                    town_or_village_name: null,
	                    water_utility_schedule: null,
	                    commercial_electricity_utility_schedule: null,
	                    residential_electricity_utility_schedule: null
	                }],
	            residential_electricity_utility_schedule: [{
	                    id: null,
	                    town_or_village_name: null,
	                    water_utility_schedule: null,
	                    commercial_electricity_utility_schedule: null,
	                    residential_electricity_utility_schedule: null
	                }],
	            commercial_electricity_utility_schedule: [{
	                    id: null,
	                    town_or_village_name: null,
	                    water_utility_schedule: null,
	                    commercial_electricity_utility_schedule: null,
	                    residential_electricity_utility_schedule: null
	                }]
	        };
	        _this.model = angular.copy(_this._mod);
	        _this.translate = function (word) {
	            return $translate.instant(word);
	        };
	        return _this;
	    }
	    UtilitiesSchedulesService.prototype.listScheduleTypes = function () {
	        return [
	            {
	                name: this.translate('Water'),
	                value: 'WATER'
	            },
	            {
	                name: this.translate('Commercial Electrical'),
	                value: 'ELECTRIC_COMM'
	            },
	            {
	                name: this.translate('Residential Electrical'),
	                value: 'ELECTRIC_RES'
	            }
	        ];
	    };
	    UtilitiesSchedulesService.prototype.createRange = function (scheduleId, range) {
	        return this.restangular.one(exports.endpoint + "/" + scheduleId + "/range-brackets").customPOST(range);
	    };
	    UtilitiesSchedulesService.prototype.updateRange = function (range) {
	        return this.restangular.one(exports.endpoint + "/range-brackets/" + range.id).customPUT(range);
	    };
	    UtilitiesSchedulesService.prototype.deleteRange = function (id) {
	        return this.restangular.one(exports.endpoint + "/range-brackets/" + id).remove(id);
	    };
	    return UtilitiesSchedulesService;
	}(crud_service_1.CRUDService));
	exports.UtilitiesSchedulesService = UtilitiesSchedulesService;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'regional-countries';
	var RegionalCountryManagementService = (function (_super) {
	    __extends(RegionalCountryManagementService, _super);
	    /** @ngInject */
	    RegionalCountryManagementService.$inject = ["Restangular"];
	    function RegionalCountryManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            country: {
	                id: null,
	                country_code: null,
	                country_name: null,
	                aircraft_registration_prefixes: null,
	                aerodrome_prefixes: null,
	                crco_member: false
	            }
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    RegionalCountryManagementService.prototype.update = function (list) {
	        var obj = [];
	        for (var i = 0; i < list.length; i++) {
	            obj.push({
	                country: list[i]
	            });
	        }
	        return _super.prototype.update.call(this, obj, null);
	    };
	    return RegionalCountryManagementService;
	}(crud_service_1.CRUDService));
	exports.RegionalCountryManagementService = RegionalCountryManagementService;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'aircraft-type-exemptions';
	var AircraftExemptManagementService = (function (_super) {
	    __extends(AircraftExemptManagementService, _super);
	    /** @ngInject */
	    AircraftExemptManagementService.$inject = ["Restangular"];
	    function AircraftExemptManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aircraft_type: null,
	            enroute_fees_exempt: 0,
	            late_arrival_fees_exempt: 0,
	            late_departure_fees_exempt: 0,
	            parking_fees_exempt: 0,
	            approach_fees_exempt: 0,
	            aerodrome_fees_exempt: 0,
	            international_pax: 0,
	            domestic_pax: 0,
	            extended_hours_fees_exempt: 0,
	            flight_notes: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return AircraftExemptManagementService;
	}(crud_service_1.CRUDService));
	exports.AircraftExemptManagementService = AircraftExemptManagementService;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'crco';
	var CrcoManagementService = (function (_super) {
	    __extends(CrcoManagementService, _super);
	    /** @ngInject */
	    CrcoManagementService.$inject = ["Restangular", "$q", "systemConfigurationService"];
	    function CrcoManagementService(Restangular, $q, systemConfigurationService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$q = $q;
	        _this.systemConfigurationService = systemConfigurationService;
	        return _this;
	    }
	    CrcoManagementService.prototype.getCrco = function (rcoId) {
	        return this.restangular.one("/crco/" + rcoId).get();
	    };
	    CrcoManagementService.prototype.getFlightMessage = function (packetId) {
	        return this.restangular.one("/crco/" + packetId + "/flightMessages").get(null, { 'Content-Type': 'text/plain', 'Accept': 'text/plain' }).then(function (response) {
	            return response;
	        });
	    };
	    CrcoManagementService.prototype.addCrco = function (flightMessages) {
	        return this.restangular.all("/crco/EE/flightMessages").post(flightMessages);
	    };
	    CrcoManagementService.prototype.getMessagesById = function (rcoId) {
	        return this.restangular.one("/crco/" + rcoId + "/listFlightMessages").get();
	    };
	    return CrcoManagementService;
	}(crud_service_1.CRUDService));
	exports.CrcoManagementService = CrcoManagementService;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'crco-connection';
	var CrcoConnectionService = (function (_super) {
	    __extends(CrcoConnectionService, _super);
	    /** @ngInject */
	    CrcoConnectionService.$inject = ["Restangular"];
	    function CrcoConnectionService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            connection_name: null,
	            endpoint: null,
	            port: null,
	            password: null,
	            enabled: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoConnectionService.prototype.getCrcoConnections = function () {
	        console.log("connect");
	        return this.restangular.all(exports.endpoint + "/list").getList();
	    };
	    return CrcoConnectionService;
	}(crud_service_1.CRUDService));
	exports.CrcoConnectionService = CrcoConnectionService;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_file_handler_service_1 = __webpack_require__(146);
	var localStorage_service_1 = __webpack_require__(9);
	var system_configuration_constants_1 = __webpack_require__(10);
	exports.endpoint = 'crco-certificates';
	var CrcoCertificatesService = (function (_super) {
	    __extends(CrcoCertificatesService, _super);
	    /** @ngInject */
	    CrcoCertificatesService.$inject = ["Restangular", "$q"];
	    function CrcoCertificatesService(Restangular, $q) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$q = $q;
	        _this._mod = {
	            id: null,
	            type: null,
	            valid_from: null,
	            valid_to: null,
	            status: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoCertificatesService.prototype.getCrcoCertificates = function () {
	        return this.restangular.all(exports.endpoint + "/listCertificates").getList();
	    };
	    /**
	  * Makes a GET request to the endpoint
	  *
	  * Note: This is kind of set up with Spring in mind
	  *
	  * @param params        is an Object that will be converted to GET parameters
	  * @param queryString   is GET parameters that will be appended to the URL
	  * @returns {IPromise<ISpringPageableParams>}
	  */
	    CrcoCertificatesService.prototype.list = function (params, queryString, endpoint) {
	        var _this = this;
	        if (params === void 0) { params = {}; }
	        if (queryString === void 0) { queryString = ''; }
	        if (endpoint === void 0) { endpoint = ''; }
	        if (queryString !== '') {
	            queryString = "?" + queryString;
	        }
	        // if not set to 'get all / -1' add the system config page size
	        if (!params.size) {
	            params.size = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.ROW_FOR_PAGE) || 20;
	        }
	        ;
	        // the uib-pagination starts at `1` but Spring Framework starts at `0`, therefore we fake it
	        if (params.page) {
	            params.page--;
	        }
	        return this.restangular.one("" + (endpoint ? endpoint : this.endpoint) + queryString).get(params)
	            .then(function (response) { return _this.rectifyPageableParams(response); });
	    };
	    // sends size=-1 with parameters, returning all rows
	    CrcoCertificatesService.prototype.listAll = function (params) {
	        if (!params) {
	            params = {};
	        }
	        params.size = -1; // override and ensure get all results
	        return this.list(params); // calls list method since it's the same
	    };
	    CrcoCertificatesService.prototype.update = function (obj, id) {
	        return this.restangular.one(this.endpoint, id).customPUT(obj);
	    };
	    CrcoCertificatesService.prototype.delete = function (id) {
	        return this.restangular.one(this.endpoint, id).remove();
	    };
	    CrcoCertificatesService.prototype.get = function (id) {
	        return this.restangular.one(this.endpoint, id).get();
	    };
	    /**
	     * To not screw up the uib-pagination directive, we fake the number one higher.
	     *
	     * @param response from spring
	     */
	    CrcoCertificatesService.prototype.rectifyPageableParams = function (response) {
	        if (response.number) {
	            response.number++;
	        }
	        return response;
	    };
	    return CrcoCertificatesService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.CrcoCertificatesService = CrcoCertificatesService;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'crco-cor-request';
	var CrcoCorRequestService = (function (_super) {
	    __extends(CrcoCorRequestService, _super);
	    /** @ngInject */
	    CrcoCorRequestService.$inject = ["Restangular"];
	    function CrcoCorRequestService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            packet_id: null,
	            packet_date_time: null,
	            archive: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoCorRequestService.prototype.getCrcoCorRequest = function (packetId) {
	        return this.restangular.one("/" + exports.endpoint + "/" + packetId + "/corRequests").get(null, { 'Content-Type': 'application/debi+json', 'Accept': 'application/debi+json' }).then(function (response) {
	            // console.log(response);
	            return response;
	        });
	    };
	    CrcoCorRequestService.prototype.getCrcoCorRequestById = function (rcoId) {
	        return this.restangular.one("/" + exports.endpoint + "/" + rcoId + "/listCorRequests").get();
	    };
	    CrcoCorRequestService.prototype.sendCrcoCorReply = function (message) {
	        var _this = this;
	        return this.Restangular.one(exports.endpoint + "/sendCorReply").customPOST(message).then(function (data) {
	            // console.log(data)
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    return CrcoCorRequestService;
	}(crud_service_1.CRUDService));
	exports.CrcoCorRequestService = CrcoCorRequestService;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'crco-archive';
	var CrcoArchiveService = (function (_super) {
	    __extends(CrcoArchiveService, _super);
	    /** @ngInject */
	    CrcoArchiveService.$inject = ["Restangular"];
	    function CrcoArchiveService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            packet_id: null,
	            packet_date_time: null,
	            archive: null,
	            status: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoArchiveService.prototype.getFlightMessage = function (packetId) {
	        return this.restangular.one("/" + exports.endpoint + "/" + packetId + "/flightMessages").get(null, { 'Content-Type': 'text/plain', 'Accept': 'text/plain' }).then(function (response) {
	            return response;
	        });
	    };
	    CrcoArchiveService.prototype.getMessagesById = function (rcoId) {
	        return this.restangular.one("/" + exports.endpoint + "/" + rcoId + "/listFlightMessages").get();
	    };
	    return CrcoArchiveService;
	}(crud_service_1.CRUDService));
	exports.CrcoArchiveService = CrcoArchiveService;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'crco-connection';
	var CrcoMessagesService = (function (_super) {
	    __extends(CrcoMessagesService, _super);
	    /** @ngInject */
	    CrcoMessagesService.$inject = ["Restangular", "downloadService"];
	    function CrcoMessagesService(Restangular, downloadService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.downloadService = downloadService;
	        _this._mod = {
	            id: null,
	            packet_id: null,
	            packet_date_time: null,
	            archive: null,
	            crcoData: null,
	            account_id_list: null,
	            editable: null,
	            status: '',
	            reporting_responsabilities_id_list: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoMessagesService.prototype.getCrcoMessages = function () {
	        return this.restangular.all(exports.endpoint + "/list").getList();
	    };
	    CrcoMessagesService.prototype.getCrcoMessagePreview = function (editable, startDate, endDateInclusive, messageType, messageCode, commentToCrco, additionalCommentToCrco) {
	        var params = {
	            endDateInclusive: endDateInclusive,
	            startDate: startDate,
	            messageType: messageType,
	            messageCode: messageCode,
	            commentToCrco: commentToCrco,
	            additionalCommentToCrco: additionalCommentToCrco,
	            flightCategory: editable.flightCategory,
	            reporting_responsabilities_id_list: editable.reporting_responsabilities_id_list,
	            account_id_list: editable.account_id_list
	        };
	        var data = {
	            account_id_list: editable.account_id_list || [],
	            reporting_responsabilities_id_list: editable.reporting_responsabilities_id_list || []
	        };
	        return this.restangular.one("/crco-message-preview/EE/flightMessages").customPOST(data || [], '', params);
	    };
	    CrcoMessagesService.prototype.validate = function (editable, startDate, endDateInclusive) {
	        var params = {
	            endDateInclusive: endDateInclusive,
	            startDate: startDate,
	            flightCategory: editable.flightCategory,
	            reporting_responsabilities_id_list: editable.reporting_responsabilities_id_list,
	            flight_movement_id_list: editable.flight_movement_id_list,
	            crco_id: editable.crco_id,
	            crco_seq_num: editable.crco_seq_num
	        };
	        var data = {
	            account_id_list: editable.account_id_list || [],
	            reporting_responsabilities_id_list: editable.reporting_responsabilities_id_list || []
	        };
	        return this.restangular.one('flightmovements/validations-crco/byParams').customPOST(data || [], '', params);
	        //return this.restangular.one('flightmovements/validations-crco/byParams').customPOST(editable.account_id_list  && editable.reporting_responsabilities_id_list, '', params);
	    };
	    CrcoMessagesService.prototype.executeGeneration = function (editable) {
	        var _this = this;
	        var params = {
	            reporting_responsabilities_id_list: editable.reporting_responsabilities_id_list,
	        };
	        var data = {
	            reporting_responsabilities_id_list: editable.reporting_responsabilities_id_list || [],
	            account_id_list: editable.account_id_list || [],
	            flight_movement_id_list: editable.flight_movement_id_list || [],
	            comment_to_crco: editable.comment_to_crco || []
	        };
	        var url = "async-reports/crco-invoice?billingInterval=" + editable.billing_interval + "&endDateInclusive=" + editable.endDateInclusive + "&" +
	            ("format=pdf&startDate=" + editable.processStartDate + "&messageType=" + editable.messageType + "&messageCode=" + editable.messageCode + "&preview=" + editable.preview);
	        if (editable.flightCategory) {
	            url += "&flightCategory=" + editable.flightCategory;
	        }
	        if (editable.flight_movement_id_list !== undefined) {
	            url += "&flightMovementIds=" + editable.flight_movement_id_list;
	        }
	        if (editable.commentToCrco !== undefined) {
	            url += "&commentToCrco=" + editable.commentToCrco;
	        }
	        if (editable.additionalCommentToCrco !== undefined) {
	            url += "&additionalCommentToCrco=" + editable.additionalCommentToCrco;
	        }
	        return this.Restangular.one(url).customPOST(data || [], '', params).then(function (data) {
	            editable.message_preview = data.string_builder;
	            editable.id_crco_response = data.id_crco_response;
	            editable.fmcrco = data.fmcrco;
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    CrcoMessagesService.prototype.getStatusForGeneration = function () {
	        var _this = this;
	        return this.restangular.one("async-reports/crco-invoice").get().then(function (data) {
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    // cancel a generate invoice or preview invoice report polling request
	    CrcoMessagesService.prototype.cancelGeneration = function () {
	        return this.restangular.one("async-reports/crco-invoice").remove();
	    };
	    CrcoMessagesService.prototype.downloadInvoice = function (preview, iataInvoice) {
	        var _this = this;
	        if (iataInvoice === void 0) { iataInvoice = false; }
	        var req = this.restangular.withConfig(function (RestangularConfigurer) { return RestangularConfigurer.setFullResponse(true); });
	        var url = "async-reports/crco-invoice/download?format=pdf&preview=" + (preview === 1) + "&iata=" + (iataInvoice === true);
	        return req.one(url).withHttpConfig({ responseType: 'arraybuffer' }).get().then(function (resp) {
	            var result = null;
	            // if not preview, download result and return null to clear preview
	            // else display result as preview
	            if (resp.status === 200) {
	                if (preview === 0) {
	                    _this.downloadService.getDownload(resp);
	                }
	                else {
	                    result = _this.downloadService.getPreview(resp);
	                }
	            }
	            return result;
	        });
	    };
	    return CrcoMessagesService;
	}(crud_service_1.CRUDService));
	exports.CrcoMessagesService = CrcoMessagesService;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'crco-claims';
	var CrcoClaimsService = (function (_super) {
	    __extends(CrcoClaimsService, _super);
	    /** @ngInject */
	    CrcoClaimsService.$inject = ["Restangular"];
	    function CrcoClaimsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {};
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoClaimsService.prototype.getCrcoClaimRequest = function (packetId) {
	        return this.restangular.one("/" + exports.endpoint + "/" + packetId + "/claRequests").get(null, { 'Content-Type': 'application/debi+json', 'Accept': 'application/debi+json' }).then(function (response) {
	            return response;
	        });
	    };
	    CrcoClaimsService.prototype.getCrcoClaims = function () {
	        return this.restangular.all(exports.endpoint + "/list").getList();
	    };
	    CrcoClaimsService.prototype.sendCrcoClaimsReply = function (message) {
	        var _this = this;
	        return this.Restangular.one(exports.endpoint + "/send").customPOST(message).then(function (data) {
	            console.log(data);
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    CrcoClaimsService.prototype.getCrcoClaimsRequestById = function (rcoId) {
	        return this.restangular.one("/" + exports.endpoint + "/" + rcoId + "/listCrcoClaimsRequest").get();
	    };
	    return CrcoClaimsService;
	}(crud_service_1.CRUDService));
	exports.CrcoClaimsService = CrcoClaimsService;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'crco-reporting-responsabilities';
	exports.endpointAirspace = 'airspaces';
	exports.endpointAirport = 'airport';
	var CrcoReportingResponsabilitiesService = (function (_super) {
	    __extends(CrcoReportingResponsabilitiesService, _super);
	    /** @ngInject */
	    CrcoReportingResponsabilitiesService.$inject = ["Restangular"];
	    function CrcoReportingResponsabilitiesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            reporting_crco: null,
	            typ_entering: '',
	            typ_departure: '',
	            departure_include: '',
	            airspace_name: '',
	            departure_exclude: '',
	            entering_include: '',
	            entering_exclude: '',
	            prefix_departure_include: '',
	            prefix_departure_exclude: '',
	            applies_to_scope_domestic: false,
	            applies_to_scope_international: false,
	            applies_to_scope_regional: false,
	            applies_to_type_arrival: false,
	            applies_to_type_departure: false,
	            applies_to_type_domestic: false,
	            applies_to_type_overflight: false,
	            applies_to_rule_ifr: false,
	            applies_to_rule_vfr: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CrcoReportingResponsabilitiesService.prototype.create = function (rep_resp) {
	        //const events = rep_resp.reporting_rco;
	        return _super.prototype.create.call(this, rep_resp);
	    };
	    CrcoReportingResponsabilitiesService.prototype.getAirspacesFromNavDB = function () {
	        return this.restangular.one(exports.endpointAirspace + "/fromnavdb").get();
	    };
	    CrcoReportingResponsabilitiesService.prototype.getAirportFromNavDB = function () {
	        return this.restangular.one(exports.endpointAirport + "/fromnavdb").get();
	    };
	    CrcoReportingResponsabilitiesService.prototype.getReportingResponsabilities = function () {
	        return this.restangular.all(exports.endpoint + "/list-reporting-responsabilities").getList();
	    };
	    return CrcoReportingResponsabilitiesService;
	}(crud_service_1.CRUDService));
	exports.CrcoReportingResponsabilitiesService = CrcoReportingResponsabilitiesService;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'average-mtow-factors';
	var MtowService = (function (_super) {
	    __extends(MtowService, _super);
	    /** @ngInject */
	    MtowService.$inject = ["Restangular"];
	    function MtowService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            upper_limit: null,
	            average_mtow_factor: null,
	            factor_class: 'DOMESTIC' // default factor class
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    MtowService.prototype.listMtowFactorClass = function () {
	        return [
	            {
	                name: 'Domestic',
	                value: 'DOMESTIC'
	            },
	            {
	                name: 'Regional',
	                value: 'REGIONAL'
	            },
	            {
	                name: 'International',
	                value: 'INTERNATIONAL'
	            }
	        ];
	    };
	    return MtowService;
	}(crud_service_1.CRUDService));
	exports.MtowService = MtowService;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'invoice-state-types';
	var InvoiceStateTypeService = (function (_super) {
	    __extends(InvoiceStateTypeService, _super);
	    /** @ngInject */
	    InvoiceStateTypeService.$inject = ["Restangular"];
	    function InvoiceStateTypeService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = [];
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return InvoiceStateTypeService;
	}(crud_service_1.CRUDService));
	exports.InvoiceStateTypeService = InvoiceStateTypeService;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	// endpoint
	// note: formerly known as billing-ledgers
	exports.endpoint = 'billing-ledgers';
	var InvoicesService = (function (_super) {
	    __extends(InvoicesService, _super);
	    /** @ngInject */
	    InvoicesService.$inject = ["Restangular", "$http"];
	    function InvoicesService(Restangular, $http) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: {
	                id: null,
	                name: null,
	                alias: null,
	                aviation_billing_contact_person_name: null,
	                aviation_billing_phone_number: null,
	                aviation_billing_mailing_address: null,
	                aviation_billing_email_address: null,
	                non_aviation_billing_contact_person_name: null,
	                non_aviation_billing_phone_number: null,
	                non_aviation_billing_mailing_address: null,
	                non_aviation_billing_email_address: null,
	                account_users: [],
	                is_vat_free: null,
	                exempt_flight_free: null,
	                is_self_care: null,
	                iata_code: null,
	                icao_code: null,
	                opr_identifier: null,
	                payment_terms: null,
	                discount_structure: null,
	                tax_profile: null,
	                percentage_of_passenger_fee_payable: null,
	                invoice_delivery_format: null,
	                invoice_delivery_method: null,
	                invoice_currency: {
	                    id: null,
	                    currency_code: null,
	                    currency_name: null,
	                    country_code: null,
	                    decimal_places: null,
	                    allow_updated_from_web: null,
	                    symbol: null,
	                    active: null,
	                    external_accounting_system_identifier: null,
	                    exchange_rate_target_currency_id: null
	                },
	                monthly_overdue_penalty_rate: null,
	                notes: null,
	                black_listed_indicator: null,
	                black_listed_override: null,
	                credit_limit: null,
	                maximum_amount_credit_note: null,
	                minimum_amount_credit_note: null,
	                aircraft_parking_exemption: null,
	                account_type: null,
	                account_type_discount: null,
	                list_of_events_account_notified: null,
	                iata_member: null,
	                separate_pax_invoice: null,
	                external_accounting_system_identifier: null,
	                active: null,
	                cash_account: null,
	                approved_flight_school_indicator: null,
	                nationality: null,
	                whitelist_last_activity_date_time: null,
	                whitelist_state: null,
	                whitelist_inactivity_notice_sent_flag: null,
	                whitelist_expiry_notice_sent_flag: null,
	                invoice_pubblication: null,
	                invoice_overdue: null,
	                expired_certificate_warning: null,
	                expired_certificate: null,
	                has_uploaded_document: false,
	                uploaded_document_name: null,
	                uploaded_document_type: null,
	                document: null,
	                document_filename: null
	            },
	            invoice_period_or_date: null,
	            invoice_type: null,
	            invoice_state_type: null,
	            payment_due_date: null,
	            user: {
	                email: null,
	                id: null,
	                login: null,
	                job_title: null,
	                name: null,
	                permissions: [],
	                roles: [],
	                contact_information: null,
	                sms_number: null,
	                billing_center: {
	                    aerodromes: [],
	                    hq: null,
	                    id: null,
	                    invoice_sequence_number: null,
	                    name: null,
	                    prefix_invoice_number: null,
	                    prefix_receipt_number: null,
	                    receipt_sequence_number: null,
	                    users: [],
	                    external_accounting_system_identifier: null,
	                    iata_invoice_sequence_number: null,
	                    receipt_cheque_sequence_number: null,
	                    receipt_wire_sequence_number: null
	                },
	                language: null,
	                is_selfcare_user: null,
	                is_provider_user: null,
	                force_password_change: null,
	                registration_status: null
	            },
	            invoice_document: null,
	            invoice_number: null,
	            invoice_amount: null,
	            invoice_currency: {
	                id: null,
	                currency_code: null,
	                currency_name: null,
	                country_code: {
	                    id: null,
	                    country_code: null,
	                    country_name: null,
	                    aircraft_registration_prefixes: null,
	                    aerodrome_prefixes: null,
	                    crco_member: false
	                },
	                decimal_places: null,
	                symbol: null,
	                active: null,
	                allow_updated_from_web: null,
	                external_accounting_system_identifier: null,
	                exchange_rate_target_currency_id: null
	            },
	            invoice_exchange_to_usd: null,
	            invoice_date_of_issue: null,
	            payment_amount: null,
	            payment_currency: {
	                id: null,
	                currency_code: null,
	                currency_name: null,
	                country_code: {
	                    id: 1,
	                    country_code: null,
	                    country_name: null,
	                    aircraft_registration_prefixes: null,
	                    aerodrome_prefixes: null,
	                    crco_member: false
	                },
	                decimal_places: null,
	                symbol: null,
	                active: null,
	                allow_updated_from_web: null,
	                external_accounting_system_identifier: null,
	                exchange_rate_target_currency_id: null
	            },
	            payment_exchange_to_usd: null,
	            payment_date: null,
	            exported: null,
	            amount_owing: null,
	            proforma: null,
	            point_of_sale: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    InvoicesService.prototype.getModel = function () {
	        return this._mod;
	    };
	    InvoicesService.prototype.insertInvoicesTransaction = function (invoice) {
	        return this.restangular.all("" + exports.endpoint).post(invoice);
	    };
	    InvoicesService.prototype.updateInvoiceStatus = function (id, invoiceStatus) {
	        return this.restangular.one(exports.endpoint + "/" + id + "/" + invoiceStatus).put();
	    };
	    InvoicesService.prototype.voidPublishedInvoice = function (id, motivation) {
	        return this.restangular
	            .one(exports.endpoint + "/" + id + "/void-published")
	            .customPUT({ motivation: motivation }, undefined, undefined, {
	            'Content-Type': 'application/json'
	        });
	    };
	    InvoicesService.prototype.getUnpaidInvoices = function (accountId, currencyId, page, sort) {
	        var pageSort = sort ? "&" + sort : '';
	        var pageNum = page ? page - 1 : 0;
	        return this.restangular.one(exports.endpoint + "/getUnpaidBillingLedgersByAccountAndCurrency?accountId=" + accountId + "&currencyId=" + currencyId + "&page=" + pageNum + pageSort).get()
	            .then(function (response) {
	            response.number++;
	            return response;
	        });
	    };
	    InvoicesService.prototype.getAllInvoicesByAccountIdAndCurrency = function (accountId, currencyId, page, sort) {
	        var pageSort = sort ? "&" + sort : '';
	        var pageNum = page ? page - 1 : 0;
	        return this.restangular.one(exports.endpoint + "/getAllBillingLedgersByAccountAndCurrency?accountId=" + accountId + "&currencyId=" + currencyId + "&page=" + pageNum + pageSort).get().
	            then(function (response) {
	            response.number++;
	            return response;
	        });
	    };
	    InvoicesService.prototype.getTotalAmountForInvoices = function (accountId, currencyId) {
	        return this.restangular.one(exports.endpoint + "/getTotalAmountForInvoicesByAccountIdAndCurrency?accountId=" + accountId + "&currencyId=" + currencyId).get();
	    };
	    InvoicesService.prototype.getLineItemsByInvoiceId = function (invoiceId) {
	        return this.restangular.one(exports.endpoint + "/getLineItemsByInvoiceId/" + invoiceId).get();
	    };
	    InvoicesService.prototype.exportSupport = function () {
	        return this.restangular.one(exports.endpoint + "/export-support").get();
	    };
	    InvoicesService.prototype.exportSupportType = function (type) {
	        return this.restangular.one(exports.endpoint + "/export-support/" + type).get();
	    };
	    InvoicesService.prototype.exportAllInvoices = function () {
	        return this.restangular.all(exports.endpoint + "/export-all").post({});
	    };
	    InvoicesService.prototype.exportSelectedInvoices = function (ids) {
	        return this.restangular.all(exports.endpoint + "/export").post(ids);
	    };
	    return InvoicesService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.InvoicesService = InvoicesService;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'air-navigation-charges-schedules';
	var AirNavigationChargesService = (function (_super) {
	    __extends(AirNavigationChargesService, _super);
	    /** @ngInject */
	    AirNavigationChargesService.$inject = ["Restangular", "systemConfigurationService"];
	    function AirNavigationChargesService(Restangular, systemConfigurationService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this._mod = {
	            id: null,
	            charges_type: null,
	            aerodrome_category_name: null,
	            aerodrome_category_id: null,
	            document_filename: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    AirNavigationChargesService.prototype.listChargeTypes = function () {
	        var _this = this;
	        var chargeTypes = [
	            { name: 'Approach', value: 'approach_charges' },
	            { name: 'Aerodrome', value: 'aerodrome_charges' },
	            { name: 'Late Arrival', value: 'late_arrival_charges' },
	            { name: 'Late Departure', value: 'late_departure_charges' },
	            { name: 'Parking', value: 'parking_charges' },
	            { name: 'Extended Hours Service', value: 'extended_hours_service_charge' }
	        ];
	        return chargeTypes.filter(function (chargeType) {
	            var chargeTypeSplit = chargeType.name.split(' ');
	            if (chargeTypeSplit.length > 1) {
	                return _this.systemConfigurationService.shouldShowCharge(chargeTypeSplit[1].toLowerCase());
	            }
	            else {
	                return _this.systemConfigurationService.shouldShowCharge(chargeType.name.toLowerCase());
	            }
	        });
	    };
	    return AirNavigationChargesService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.AirNavigationChargesService = AirNavigationChargesService;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	exports.endpoint = 'system-configurations';
	var SystemConfigurationService = (function (_super) {
	    __extends(SystemConfigurationService, _super);
	    /** @ngInject */
	    SystemConfigurationService.$inject = ["Restangular", "$filter", "$translate"];
	    function SystemConfigurationService(Restangular, $filter, $translate) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$filter = $filter;
	        _this.$translate = $translate;
	        _this._mod = [{
	                id: null,
	                item_name: null,
	                item_class: {
	                    id: null,
	                    name: null
	                },
	                data_type: {
	                    id: null,
	                    name: null
	                },
	                units: null,
	                range: null,
	                default_value: null,
	                current_value: null,
	                client_storage_forbidden: null,
	                system_validation_type: null,
	                display_units: null,
	                blob_value: null
	            }];
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    SystemConfigurationService.prototype.getLanguageConfiguration = function () {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/noauth/getLanguages").get().then(function (resp) {
	            return _this.restangular.stripRestangular(resp);
	        }, function (err) {
	            console.error(err);
	            return null;
	        });
	    };
	    SystemConfigurationService.prototype.getUnitsOfMeasureConfiguration = function () {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/noauth/getUnitsOfMeasure").get().then(function (resp) {
	            return _this.restangular.stripRestangular(resp);
	        }, function (err) {
	            console.error(err);
	            return null;
	        });
	    };
	    SystemConfigurationService.prototype.getAirNavigationChargesCurrency = function () {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/noauth/getAirNavigationChargesCurrency").get().then(function (resp) {
	            return _this.restangular.stripRestangular(resp);
	        }, function (err) {
	            console.error(err);
	            return null;
	        });
	    };
	    SystemConfigurationService.prototype.getANSPCurrency = function () {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/noauth/getANSPCurrency").get().then(function (resp) {
	            return _this.restangular.stripRestangular(resp);
	        }, function (err) {
	            console.error(err);
	            return null;
	        });
	    };
	    SystemConfigurationService.prototype.getSupportedLanguages = function () {
	        var options = [];
	        var languageOptions = this.systemConfigurationContent.find(function (option) { return option.item_name === 'Language supported'; });
	        if (languageOptions) {
	            JSON.parse(languageOptions.current_value).map(function (language) { return options.push({ id: language.code, label: language.label }); });
	        }
	        return options;
	    };
	    SystemConfigurationService.prototype.getLanguageOptions = function () {
	        var options = [];
	        var languageOptions = this.systemConfigurationContent.find(function (option) { return option.item_name === 'Language supported'; });
	        if (languageOptions) {
	            JSON.parse(languageOptions.range).map(function (language) { return options.push({ id: language.code, label: language.label }); });
	        }
	        return options;
	    };
	    // on save it updates localStorage variables which should be reflected in the UI instantly
	    SystemConfigurationService.prototype.list = function () {
	        var _this = this;
	        // override default size to ensure all entries are retrieved
	        var params = { size: -1 };
	        return _super.prototype.list.call(this, params).then(function (systemConfiguration) { return _this.parseResults(systemConfiguration); });
	    };
	    SystemConfigurationService.prototype.listByPluginId = function (pluginId) {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/plugins/" + pluginId).get()
	            .then(function (response) { return _super.prototype.rectifyPageableParams.call(_this, response); })
	            .then(function (systemConfiguration) { return _this.parseResults(systemConfiguration); });
	    };
	    SystemConfigurationService.prototype.listForClientStorage = function () {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/storage").get()
	            .then(function (response) { return _super.prototype.rectifyPageableParams.call(_this, response); })
	            .then(function (systemConfiguration) { return _this.parseResults(systemConfiguration); });
	    };
	    SystemConfigurationService.prototype.validateItem = function (item) {
	        return this.restangular.all(this.endpoint + "/validate").post(item);
	    };
	    SystemConfigurationService.prototype.validateInvoiceByFm = function (item) {
	        return this.restangular.all(this.endpoint + "/validate/fm").post(item);
	    };
	    // returns configuration value by name
	    SystemConfigurationService.prototype.getValueByName = function (name) {
	        var val = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + name);
	        if (typeof (val) === 'undefined' || val === null) {
	            console.warn("could not find configuration for " + name + ".");
	        }
	        return val;
	    };
	    SystemConfigurationService.prototype.getBooleanFromValueByName = function (name) {
	        return this.getValueByName(name) === system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_TRUE;
	    };
	    SystemConfigurationService.prototype.convertMtowProperty = function (editable, prop) {
	        var mtow = angular.copy(editable);
	        var mtowUnit = this.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        if (mtowUnit === 'kg') {
	            var mtowInKg = this.$filter('number')(mtow[prop] * 907.185, 0);
	            var mtowAsFloat = void 0;
	            if (mtowInKg !== null) {
	                mtowAsFloat = parseFloat(mtowInKg.replace(/,/g, ''));
	            }
	            mtow[prop] = mtowAsFloat;
	        }
	        else {
	            var mtowInTons = this.$filter('number')(mtow[prop], 2);
	            if (mtowInTons !== null) {
	                mtow[prop] = parseFloat(mtowInTons.replace(/,/g, ''));
	            }
	        }
	        return mtow;
	    };
	    SystemConfigurationService.prototype.convertCargoProperty = function (editable, prop) {
	        var _this = this;
	        var cargo = angular.copy(editable);
	        var cargoUnit = this.getValueByName(system_configuration_constants_1.SysConfigConstants.CARGO_DISPLAY_UNITS);
	        var properties = prop.split(',');
	        properties.forEach(function (element) {
	            if (cargoUnit === 'kg') {
	                var cargoInKg = cargo[element] ? parseFloat(_this.$filter('number')(cargo[element] * 907.185, 0).replace(/,/g, '')) : null;
	                cargo[element] = cargoInKg;
	            }
	            else {
	                var cargoInTons = cargo[element] ? parseFloat(_this.$filter('number')(cargo[element], 2).replace(/,/g, '')) : null;
	                cargo[element] = cargoInTons;
	            }
	        });
	        return cargo;
	    };
	    SystemConfigurationService.prototype.convertDistanceProperty = function (editable, prop, distanceValue) {
	        var toConvert = editable[prop] || editable[prop] === 0 ? true : false;
	        var converted;
	        if (toConvert) {
	            if (distanceValue === 'nm') {
	                converted = Number(this.$filter('number')(editable[prop] * 0.539957, 2).replace(/,/g, ''));
	            }
	            else {
	                converted = Number(this.$filter('number')(editable[prop], 2).replace(/,/g, ''));
	            }
	        }
	        return __assign({}, editable, (_a = {}, _a[prop] = converted, _a));
	        var _a;
	    };
	    SystemConfigurationService.prototype.shouldShowCharge = function (chargeType) {
	        switch (chargeType) {
	            case 'parking':
	                return this.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_PARKING_CHARGES);
	            case 'arrival':
	                return this.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_ARRIVAL_CHARGES);
	            case 'departure':
	                return this.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_DEPARTURE_CHARGES);
	            case 'TASP':
	                return this.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.CALCULATE_TASP_CHARGES);
	            case 'passenger':
	                return this.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.PASSENGER_CHARGES_SUPPORT);
	            case 'extendedHours':
	                return this.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.EXTENDED_HOURS_SURCHARGE_SUPPORT);
	            default:
	                return true;
	        }
	    };
	    /**
	     * @param  {ISystemConfigurationSpring} data
	     * @returns ISystemConfiguration - crossing distance precedence
	     */
	    SystemConfigurationService.prototype.setCrossingDistance = function () {
	        for (var _i = 0, _a = this.systemConfigurationContent; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (item.item_name === 'Crossing distance precedence') {
	                return item;
	            }
	            ;
	        }
	        ;
	    };
	    SystemConfigurationService.prototype.isLocaleEnglish = function () {
	        return this.$translate.use().startsWith('en');
	    };
	    SystemConfigurationService.prototype.parseResults = function (systemConfiguration) {
	        this.systemConfigurationContent = systemConfiguration.content;
	        if (!systemConfiguration.content) {
	            return systemConfiguration;
	        }
	        for (var i = 0; i < systemConfiguration.content.length; i++) {
	            // this contains the user
	            // selected distance unit
	            // of measure, before it
	            // is stored locally
	            var distanceBeforeStorage = systemConfiguration.content.find(function (item) {
	                return item.item_name === system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE.toString();
	            });
	            var distanceValueBeforeStorage = distanceBeforeStorage ? distanceBeforeStorage.current_value : '';
	            // because we use the input[type=number] and max/min attrs, we need to convert to number here
	            if (systemConfiguration.content[i].data_type.name === 'int' || systemConfiguration.content[i].data_type.name === 'float') {
	                systemConfiguration.content[i].current_value = Number(systemConfiguration.content[i].current_value);
	                // handle distances props that need to be converted
	                if (systemConfiguration.content[i].item_name.includes('distance')) {
	                    systemConfiguration.content[i] = this.convertDistanceProperty(systemConfiguration.content[i], 'current_value', distanceValueBeforeStorage);
	                }
	                ;
	            }
	            // because the label (item_name) is also the primary key,
	            // if we want to change the label, we add a 'display_name'
	            // to the object and display that instead
	            var displayNames = this.getNames(distanceValueBeforeStorage);
	            for (var _i = 0, displayNames_1 = displayNames; _i < displayNames_1.length; _i++) {
	                var name_1 = displayNames_1[_i];
	                if (name_1[0] === systemConfiguration.content[i].item_name) {
	                    systemConfiguration.content[i].display_units = name_1[1];
	                }
	            }
	            // bind all the system configurations
	            var configValue = void 0;
	            if (systemConfiguration.content[i].current_value !== undefined && systemConfiguration.content[i].current_value !== null) {
	                configValue = systemConfiguration.content[i].current_value;
	            }
	            else {
	                configValue = systemConfiguration.content[i].default_value;
	            }
	            if (systemConfiguration.content[i].item_name.indexOf('Language') === -1 && !systemConfiguration.content[i].client_storage_forbidden) {
	                localStorage_service_1.LocalStorageService.set("SystemConfiguration:" + systemConfiguration.content[i].item_name, configValue);
	            }
	            ;
	        }
	        return systemConfiguration;
	    };
	    SystemConfigurationService.prototype.getNames = function (distanceValueBeforeStorage) {
	        var ANSP = this.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_CURRENCY);
	        var dUM = distanceValueBeforeStorage;
	        return [
	            [system_configuration_constants_1.SysConfigConstants.ENTRY_EXIT_POINT_ROUNDING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.ENTRY_EXIT_POINT_ROUNDING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.EXEMPT_FLIGHTS_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.EXEMPT_FLIGHTS_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MAX_DOMESTIC_CROSSING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MAX_DOMESTIC_CROSSING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MAX_REGIONAL_CROSSING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MAX_REGIONAL_CROSSING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MAX_INTERNATIONAL_CROSSING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MAX_INTERNATIONAL_CROSSING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MIN_DOMESTIC_CROSSING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MIN_DOMESTIC_CROSSING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MIN_REGIONAL_CROSSING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MIN_REGIONAL_CROSSING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MIN_INTERNATIONAL_CROSSING_DISTANCE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MIN_INTERNATIONAL_CROSSING_DISTANCE, dUM)],
	            [system_configuration_constants_1.SysConfigConstants.MIN_RANGE_FOR_FLIGHT_MATCH, this.getLabel(system_configuration_constants_1.SysConfigConstants.MIN_RANGE_FOR_FLIGHT_MATCH, true)],
	            [system_configuration_constants_1.SysConfigConstants.PERCENT_EET_USED_FOR_FLIGHT_MATCH, this.getLabel(system_configuration_constants_1.SysConfigConstants.PERCENT_EET_USED_FOR_FLIGHT_MATCH, '%')],
	            [system_configuration_constants_1.SysConfigConstants.ATC_MOVEMENT_RETENTION, this.getLabel(system_configuration_constants_1.SysConfigConstants.ATC_MOVEMENT_RETENTION, true)],
	            [system_configuration_constants_1.SysConfigConstants.FLIGHT_MOVEMENT_RETENTION, this.getLabel(system_configuration_constants_1.SysConfigConstants.FLIGHT_MOVEMENT_RETENTION, true)],
	            [system_configuration_constants_1.SysConfigConstants.RADAR_TRACK_FILES_RETENTION, this.getLabel(system_configuration_constants_1.SysConfigConstants.RADAR_TRACK_FILES_RETENTION, true)],
	            [system_configuration_constants_1.SysConfigConstants.LINE_ITEM_RETENTION, this.getLabel(system_configuration_constants_1.SysConfigConstants.LINE_ITEM_RETENTION, true)],
	            [system_configuration_constants_1.SysConfigConstants.USER_EVENT_LOG_RETENTION, this.getLabel(system_configuration_constants_1.SysConfigConstants.USER_EVENT_LOG_RETENTION, true)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_CREDIT_LIMIT, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_CREDIT_LIMIT, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MIN_CREDIT_NOTE, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_AIRLINE_ACCOUNT_MAX_CREDIT_NOTE, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_CREDIT_LIMIT, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MIN_CREDIT_NOTE, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_GENERAL_AVIATION_ACCOUNT_MAX_CREDIT_NOTE, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_CREDIT_LIMIT, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_CREDIT_LIMIT, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MIN_CREDIT_NOTE, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DEFAULT_UNIFIED_TAX_ACCOUNT_MAX_CREDIT_NOTE, ANSP)],
	            [system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE, this.getLabel(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE, 'tons / kg')],
	            [system_configuration_constants_1.SysConfigConstants.AUTOMATED_UPLOAD_SCHEDULING, this.getLabel(system_configuration_constants_1.SysConfigConstants.AUTOMATED_UPLOAD_SCHEDULING, true)],
	            [system_configuration_constants_1.SysConfigConstants.CACHED_EVENT_RETRY_INTERVAL, this.getLabel(system_configuration_constants_1.SysConfigConstants.CACHED_EVENT_RETRY_INTERVAL, true)],
	            [system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE, this.getLabel(system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE, 'km / nm')],
	            [system_configuration_constants_1.SysConfigConstants.MOCK_FATAL_ERROR_OCCURRENCE_FREQUENCY, this.getLabel(system_configuration_constants_1.SysConfigConstants.MOCK_FATAL_ERROR_OCCURRENCE_FREQUENCY, '%')],
	            [system_configuration_constants_1.SysConfigConstants.DUPL_OR_MISS_FLIGHTS_MIN_WIND, this.getLabel(system_configuration_constants_1.SysConfigConstants.DUPL_OR_MISS_FLIGHTS_MIN_WIND, true)],
	            [system_configuration_constants_1.SysConfigConstants.DUPL_OR_MISS_FLIGHTS_EET_PERC, this.getLabel(system_configuration_constants_1.SysConfigConstants.DUPL_OR_MISS_FLIGHTS_EET_PERC, '%')],
	            [system_configuration_constants_1.SysConfigConstants.FIRST_DAY_OF_FISCAL_YEAR, this.getLabel(system_configuration_constants_1.SysConfigConstants.FIRST_DAY_OF_FISCAL_YEAR, true)],
	            [system_configuration_constants_1.SysConfigConstants.SMALL_AIRCRAFT_MAXIMUM_WEIGHT, this.getLabel(system_configuration_constants_1.SysConfigConstants.SMALL_AIRCRAFT_MAXIMUM_WEIGHT, true)],
	            [system_configuration_constants_1.SysConfigConstants.SMALL_AIRCRAFT_MINIMUN_WEIGHT, this.getLabel(system_configuration_constants_1.SysConfigConstants.SMALL_AIRCRAFT_MINIMUN_WEIGHT, true)],
	            [system_configuration_constants_1.SysConfigConstants.WL_INACTIVITY_PERIOD, this.getLabel(system_configuration_constants_1.SysConfigConstants.WL_INACTIVITY_PERIOD, true)],
	            [system_configuration_constants_1.SysConfigConstants.WL_EXPIRY_PERIOD, this.getLabel(system_configuration_constants_1.SysConfigConstants.WL_EXPIRY_PERIOD, true)]
	        ];
	    };
	    SystemConfigurationService.prototype.getLabel = function (name, addText) {
	        var label;
	        this.systemConfigurationContent.forEach(function (element) {
	            if (element.item_name === name) {
	                if (typeof (addText) === 'boolean') {
	                    label = "(" + element.units + ")";
	                }
	                else {
	                    label = "(" + addText + ")";
	                }
	                return;
	            }
	        });
	        return label;
	    };
	    // api returns logo saved on db
	    SystemConfigurationService.prototype.getLogoOrganisation = function () {
	        var _this = this;
	        return this.restangular.one(this.endpoint + "/logo").get().then(function (resp) {
	            return _this.restangular.stripRestangular(resp);
	        }, function (err) {
	            console.error(err);
	            return null;
	        });
	    };
	    SystemConfigurationService.prototype.getMimeTypeFromBase64 = function (base64String) {
	        var raw = atob(base64String.substring(0, 16)); // Decodifica primi byte
	        var uint8Array = new Uint8Array(raw.length);
	        for (var i = 0; i < raw.length; i++) {
	            uint8Array[i] = raw.charCodeAt(i);
	        }
	        if (uint8Array[0] === 0x89 && uint8Array[1] === 0x50) {
	            return "image/png";
	        }
	        else if (uint8Array[0] === 0xFF && uint8Array[1] === 0xD8) {
	            return "image/jpeg";
	        }
	        else if (uint8Array[0] === 0x47 && uint8Array[1] === 0x49) {
	            return "image/gif";
	        }
	        return "application/octet-stream";
	    };
	    SystemConfigurationService.prototype.initImage = function (item) {
	        if (item.blob_value && Array.isArray(item.blob_value)) {
	            var binary = '';
	            var bytes = new Uint8Array(item.blob_value);
	            for (var i = 0; i < bytes.length; i++) {
	                binary += String.fromCharCode(bytes[i]);
	            }
	            var base64String = btoa(binary);
	            item.blob_value = base64String;
	            var mimeType = this.getMimeTypeFromBase64(base64String);
	            var blob_url_string = 'data:' + mimeType + ';base64,' + base64String;
	            localStorage_service_1.LocalStorageService.set('logoUrl', blob_url_string);
	            localStorage_service_1.LocalStorageService.set('logoName', item.current_value);
	            window.dispatchEvent(new Event('storage'));
	            return blob_url_string;
	        }
	    };
	    ;
	    SystemConfigurationService.prototype.reloadLogoOrganisation = function () {
	        var _this = this;
	        this.getLogoOrganisation()
	            .then(function (item) {
	            if (item) {
	                _this.initImage(item); // Assegna il logo all'ambito dello scope
	            }
	        })
	            .catch(function (err) {
	            console.error("Errore nel recupero del logo:", err);
	        });
	    };
	    return SystemConfigurationService;
	}(crud_service_1.CRUDService));
	exports.SystemConfigurationService = SystemConfigurationService;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'passenger-service-charge-return';
	var PassengerServiceChargeReturnService = (function (_super) {
	    __extends(PassengerServiceChargeReturnService, _super);
	    /** @ngInject */
	    PassengerServiceChargeReturnService.$inject = ["Restangular"];
	    function PassengerServiceChargeReturnService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            flight_id: null,
	            day_of_flight: null,
	            departure_time: null,
	            transit_passengers: 0,
	            joining_passengers: 0,
	            children: 0,
	            chargeable_itl_passengers: 0,
	            chargeable_domestic_passengers: 0,
	            document_filename: null,
	            mime_type: null,
	            document: null,
	            document_filename2: null,
	            arriving_pax_domestic_airport: null,
	            landing_pax_domestic_airport: null,
	            transfer_pax_domestic_airport: null,
	            departing_pax_domestic_airport: null,
	            arriving_child_domestic_airport: null,
	            landing_child_domestic_airport: null,
	            transfer_child_domestic_airport: null,
	            departing_child_domestic_airport: null,
	            exempt_arriving_pax_domestic_airport: null,
	            exempt_landing_pax_domestic_airport: null,
	            exempt_transfer_pax_domestic_airport: null,
	            exempt_departing_pax_domestic_airport: null,
	            loaded_goods: null,
	            discharged_goods: null,
	            loaded_mail: null,
	            discharged_mail: null,
	            account: null,
	            account_id: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Send date range of flights to check against PSCR
	     */
	    PassengerServiceChargeReturnService.prototype.executePSCR = function (params) {
	        return this.restangular.all(exports.endpoint + "/reconciliation").customPOST(null, '', params);
	    };
	    return PassengerServiceChargeReturnService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.PassengerServiceChargeReturnService = PassengerServiceChargeReturnService;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'transactions';
	var TransactionsService = (function (_super) {
	    __extends(TransactionsService, _super);
	    /** @ngInject */
	    TransactionsService.$inject = ["Restangular"];
	    function TransactionsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            transaction_date_time: null,
	            description: null,
	            transaction_type: null,
	            amount: null,
	            currency: null,
	            payment_mechanism: null,
	            payment_reference_number: null,
	            exported: false,
	            billing_ledger_ids: null,
	            exchange_rate_to_usd: null,
	            exchange_rate_to_ansp: null,
	            balance: null,
	            payment_amount: null,
	            payment_currency: null,
	            payment_exchange_rate: null,
	            charges_adjustment: null,
	            kra_receipt_number: null,
	            kra_clerk_name: null,
	            payments_exported: null,
	            has_approval_document: null,
	            approval_document_name: null,
	            approval_document_type: null,
	            has_supporting_document: null,
	            supporting_document_name: null,
	            supporting_document_type: null,
	            payment_date: null,
	            bank_account_name: null,
	            bank_account_number: null,
	            bank_account_external_accounting_system_id: null,
	            interest_invoice_error: null,
	            transaction_approvals: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    TransactionsService.prototype.getPaymentMechanismList = function () {
	        return this.restangular.one(exports.endpoint + "/getPaymentMechanismList").get();
	    };
	    TransactionsService.prototype.getCurrencyListByAccountId = function (id) {
	        return this.restangular.one(exports.endpoint + "/getCurrencyListByAccountId/" + id).get();
	    };
	    TransactionsService.prototype.validateSelectedInvoice = function (transaction) {
	        return this.restangular.all(exports.endpoint + "/calculateAmountForTransactionPayments").post(transaction);
	    };
	    TransactionsService.prototype.getTransactionByInvoiceId = function (invoiceId) {
	        return this.restangular.one(exports.endpoint + "/getTransactionByBillingLedgerId/" + invoiceId).get();
	    };
	    TransactionsService.prototype.getTransactionPaymentsByInvoiceId = function (invoiceId) {
	        return this.restangular.one(exports.endpoint + "/getTransactionPaymentsByBillingLedgerId/" + invoiceId).get();
	    };
	    TransactionsService.prototype.getInvoicesByTransactionId = function (transactionId) {
	        return this.restangular.one(exports.endpoint + "/getBillingLedgersByTransactionId/" + transactionId).get();
	    };
	    TransactionsService.prototype.getTransactionPaymentsByTransactionId = function (transactionId) {
	        return this.restangular.one(exports.endpoint + "/getTransactionPaymentsByTransactionId/" + transactionId).get();
	    };
	    TransactionsService.prototype.getAircraftRegistrationByBillingLedgerId = function (invoiceId) {
	        return this.restangular.one(exports.endpoint + "getAircraftRegistrationBillingLedgerId/" + invoiceId).get();
	    };
	    TransactionsService.prototype.getModel = function () {
	        return this._mod;
	    };
	    TransactionsService.prototype.exportSupport = function () {
	        return this.restangular.one(exports.endpoint + "/export-support").get();
	    };
	    TransactionsService.prototype.exportSupportMechanism = function (mechanism) {
	        return this.restangular.one(exports.endpoint + "/export-support/" + mechanism).get();
	    };
	    TransactionsService.prototype.exportAllTransactions = function () {
	        return this.restangular.all(exports.endpoint + "/export-all").post({});
	    };
	    TransactionsService.prototype.exportSelectedTransactions = function (ids) {
	        return this.restangular.all(exports.endpoint + "/export").post(ids);
	    };
	    return TransactionsService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.TransactionsService = TransactionsService;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'aircraft-registrations';
	exports.endpointCharges = 'unified-tax-charges';
	var AircraftRegistrationService = (function (_super) {
	    __extends(AircraftRegistrationService, _super);
	    /** @ngInject */
	    AircraftRegistrationService.$inject = ["Restangular", "$q"];
	    function AircraftRegistrationService(Restangular, $q) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$q = $q;
	        _this._mod = {
	            id: null,
	            registration_number: null,
	            registration_start_date: null,
	            registration_expiry_date: null,
	            mtow_override: null,
	            account: {
	                id: null,
	                name: null,
	                alias: null,
	                aviation_billing_contact_person_name: null,
	                aviation_billing_phone_number: null,
	                aviation_billing_mailing_address: null,
	                aviation_billing_email_address: null,
	                non_aviation_billing_contact_person_name: null,
	                non_aviation_billing_phone_number: null,
	                non_aviation_billing_mailing_address: null,
	                non_aviation_billing_email_address: null,
	                is_self_care: null,
	                account_users: [],
	                iata_code: null,
	                icao_code: null,
	                opr_identifier: null,
	                payment_terms: null,
	                discount_structure: null,
	                tax_profile: null,
	                cash_account: null,
	                percentage_of_passenger_fee_payable: null,
	                invoice_delivery_format: null,
	                invoice_delivery_method: null,
	                invoice_currency: {
	                    id: null,
	                    currency_code: null,
	                    currency_name: null,
	                    country_code: null,
	                    decimal_places: null,
	                    allow_updated_from_web: null,
	                    symbol: null,
	                    active: null,
	                    external_accounting_system_identifier: null,
	                    exchange_rate_target_currency_id: null
	                },
	                monthly_overdue_penalty_rate: null,
	                notes: null,
	                black_listed_indicator: null,
	                black_listed_override: null,
	                credit_limit: null,
	                maximum_amount_credit_note: null,
	                minimum_amount_credit_note: null,
	                aircraft_parking_exemption: null,
	                account_type: null,
	                account_type_discount: null,
	                list_of_events_account_notified: null,
	                iata_member: null,
	                separate_pax_invoice: null,
	                external_accounting_system_identifier: null,
	                active: null,
	                approved_flight_school_indicator: null,
	                nationality: null,
	                whitelist_last_activity_date_time: null,
	                whitelist_state: null,
	                whitelist_inactivity_notice_sent_flag: null,
	                whitelist_expiry_notice_sent_flag: null,
	                is_vat_free: false,
	                exempt_flight_free: false,
	                invoice_pubblication: false,
	                invoice_overdue: false,
	                expired_certificate_warning: false,
	                expired_certificate: false,
	                has_uploaded_document: false,
	                uploaded_document_name: null,
	                uploaded_document_type: null,
	                document: null,
	                document_filename: null
	            },
	            aircraft_type: {
	                id: null,
	                aircraft_type: null,
	                aircraft_image: null,
	                aircraft_name: null,
	                manufacturer: null,
	                maximum_takeoff_weight: null,
	                wake_turbulence_category: null
	            },
	            country_of_registration: {
	                id: null,
	                country_code: null,
	                country_name: null,
	                aircraft_registration_prefixes: null,
	                aerodrome_prefixes: null,
	                crco_member: false
	            },
	            country_override: false,
	            created_by_self_care: false,
	            coa_expiry_date: null,
	            coa_issue_date: null,
	            aircraft_service_date: null,
	            is_local: null,
	            aircraft_scope: null,
	            has_uploaded_document: false,
	            uploaded_document_name: null,
	            uploaded_document_type: null,
	            document: null,
	            document_filename: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // returns a country based on the registration number prefix
	    AircraftRegistrationService.prototype.getCountryByRegistrationNumberPrefix = function (prefix) {
	        return this.restangular.one(exports.endpoint + "/prefix/" + prefix).get();
	    };
	    /**
	     * Get valid aircraft type from aircraft registration number and registration date.
	     *
	     * @param regNumber registration number
	     * @param flightDate date of registration
	     */
	    AircraftRegistrationService.prototype.getAircraftType = function (regNumber, regDate) {
	        if (regNumber && regDate) {
	            return this.restangular.one(exports.endpoint + "/aircraft-type/" + regNumber + "/" + regDate.toISOString()).get();
	        }
	        else {
	            return this.$q.reject('regNumber and flightDate cannot be null or empty');
	        }
	    };
	    AircraftRegistrationService.prototype.getAircraftRegistrationByBillingLedgerId = function (invoiceId) {
	        return this.restangular.one(exports.endpointCharges + "/getAircraftRegistrationsByBillingLedgerId/" + invoiceId).get();
	    };
	    return AircraftRegistrationService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.AircraftRegistrationService = AircraftRegistrationService;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = '/wake-turbulence-categories';
	var WakeTurbulenceCategoryService = (function (_super) {
	    __extends(WakeTurbulenceCategoryService, _super);
	    /** @ngInject */
	    WakeTurbulenceCategoryService.$inject = ["Restangular"];
	    function WakeTurbulenceCategoryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        return _this;
	    }
	    return WakeTurbulenceCategoryService;
	}(crud_service_1.CRUDService));
	exports.WakeTurbulenceCategoryService = WakeTurbulenceCategoryService;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = '/roles';
	var RolesService = (function (_super) {
	    __extends(RolesService, _super);
	    /** @ngInject */
	    RolesService.$inject = ["Restangular"];
	    function RolesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            name: null,
	            permissions: [],
	            owned_roles: [],
	            max_credit_note_amount_approval_limit: null,
	            max_debit_note_amount_approval_limit: null,
	            notification_mechanism: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return all roles without 'Change the password'
	     */
	    RolesService.prototype.listAllWithoutChangePassword = function () {
	        return _super.prototype.listAll.call(this, { 'ignoreChangePassword': true })
	            .then(function (data) { return data.content; });
	    };
	    RolesService.prototype.updatedPermissionsOfRole = function (roleID, listOfPermissions) {
	        return this.restangular.one(exports.endpoint + "/" + roleID + "/permissions").customPUT(listOfPermissions);
	    };
	    RolesService.prototype.updatedOwnedRolesOfRole = function (roleID, listOfOwnedRoles) {
	        return this.restangular.one(exports.endpoint + "/" + roleID + "/owned-roles").customPUT(listOfOwnedRoles);
	    };
	    RolesService.prototype.getAuthProviderGroup = function () {
	        return this.restangular.one(exports.endpoint + "/authProviderGroup").get();
	    };
	    return RolesService;
	}(crud_service_1.CRUDService));
	exports.RolesService = RolesService;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = '/account-types';
	var TypesService = (function (_super) {
	    __extends(TypesService, _super);
	    /** @ngInject */
	    TypesService.$inject = ["Restangular"];
	    function TypesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            name: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return TypesService;
	}(crud_service_1.CRUDService));
	exports.TypesService = TypesService;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// crud service and interface
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = '/countries';
	var CountryManagementService = (function (_super) {
	    __extends(CountryManagementService, _super);
	    /** @ngInject */
	    CountryManagementService.$inject = ["Restangular"];
	    function CountryManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            country_code: null,
	            country_name: null,
	            aircraft_registration_prefixes: null,
	            aerodrome_prefixes: null,
	            crco_member: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // override to handle prefix arrays
	    CountryManagementService.prototype.listAll = function (params) {
	        if (!params) {
	            params = {};
	        }
	        params.size = -1; // override and ensure get all results
	        return this.list(params).then(function (result) {
	            var formattedResults = result.content.map(function (entry) {
	                entry.aerodrome_prefixes = entry.aerodrome_prefixes.map(function (aP) { return aP.aerodrome_prefix; }).join(', ');
	                entry.aircraft_registration_prefixes = entry.aircraft_registration_prefixes.map(function (aRP) { return aRP.aircraft_registration_prefix; }).join(', ');
	                return entry;
	            });
	            result.content = formattedResults;
	            return result;
	        });
	    };
	    CountryManagementService.prototype.findCountryByCountryCode = function (countryCode) {
	        return this.restangular.one(exports.endpoint + "/country-by-country-code/" + countryCode).get();
	    };
	    return CountryManagementService;
	}(crud_service_1.CRUDService));
	exports.CountryManagementService = CountryManagementService;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'currencies';
	var CurrencyManagementService = (function (_super) {
	    __extends(CurrencyManagementService, _super);
	    /** @ngInject */
	    CurrencyManagementService.$inject = ["Restangular"];
	    function CurrencyManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            currency_code: null,
	            currency_name: null,
	            country_code: null,
	            decimal_places: null,
	            allow_updated_from_web: false,
	            symbol: null,
	            active: null,
	            external_accounting_system_identifier: null,
	            exchange_rate_target_currency_id: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Returns page with USD and ANSP currency
	     */
	    CurrencyManagementService.prototype.getANSPCurrencyAndUSD = function () {
	        return this.restangular.one(exports.endpoint + "/ansp").get();
	    };
	    /**
	     * Returns list with USD and ANSP currency
	     */
	    CurrencyManagementService.prototype.getListCurrencyANSPAndUSD = function () {
	        return this.restangular.one(exports.endpoint + "/ansp-usd-list").get();
	    };
	    CurrencyManagementService.prototype.getCurrencyInfo = function (id) {
	        return this.restangular.one(exports.endpoint + "/" + id + "/info").get();
	    };
	    CurrencyManagementService.prototype.getByCurrencyCode = function (code) {
	        return this.restangular.one(exports.endpoint + "/currency-code/" + code).get();
	    };
	    CurrencyManagementService.prototype.getActiveCurrency = function () {
	        return this.restangular.one(exports.endpoint + "/active").get();
	    };
	    return CurrencyManagementService;
	}(crud_service_1.CRUDService));
	exports.CurrencyManagementService = CurrencyManagementService;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// contants
	var system_configuration_constants_1 = __webpack_require__(10);
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'accounts';
	var AccountsService = (function (_super) {
	    __extends(AccountsService, _super);
	    /** @ngInject */
	    AccountsService.$inject = ["Restangular", "systemConfigurationService"];
	    function AccountsService(Restangular, systemConfigurationService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this._mod = {
	            id: null,
	            name: null,
	            alias: null,
	            aviation_billing_contact_person_name: null,
	            aviation_billing_phone_number: null,
	            aviation_billing_mailing_address: null,
	            aviation_billing_email_address: null,
	            non_aviation_billing_contact_person_name: null,
	            non_aviation_billing_phone_number: null,
	            non_aviation_billing_mailing_address: null,
	            non_aviation_billing_email_address: null,
	            is_self_care: false,
	            iata_code: null,
	            icao_code: null,
	            opr_identifier: null,
	            payment_terms: null,
	            discount_structure: null,
	            tax_profile: null,
	            percentage_of_passenger_fee_payable: null,
	            invoice_delivery_format: null,
	            invoice_delivery_method: null,
	            invoice_currency: null,
	            monthly_overdue_penalty_rate: null,
	            notes: null,
	            black_listed_indicator: false,
	            black_listed_override: false,
	            credit_limit: null,
	            maximum_amount_credit_note: null,
	            minimum_amount_credit_note: null,
	            aircraft_parking_exemption: null,
	            account_type: null,
	            account_type_discount: null,
	            list_of_events_account_notified: null,
	            iata_member: false,
	            separate_pax_invoice: false,
	            external_accounting_system_identifier: null,
	            active: true,
	            cash_account: false,
	            approved_flight_school_indicator: false,
	            account_users: [],
	            nationality: null,
	            whitelist_last_activity_date_time: null,
	            whitelist_state: null,
	            whitelist_inactivity_notice_sent_flag: null,
	            whitelist_expiry_notice_sent_flag: null,
	            is_vat_free: false,
	            exempt_flight_free: false,
	            invoice_pubblication: false,
	            invoice_overdue: false,
	            expired_certificate_warning: false,
	            expired_certificate: false,
	            document: null,
	            uploaded_document_type: null,
	            has_uploaded_document: null,
	            uploaded_document_name: null,
	            document_filename: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return only credit accounts
	     */
	    AccountsService.prototype.listAll = function () {
	        return _super.prototype.list.call(this, {}, "cash=false&size=-1");
	    };
	    /**
	     * Return all accounts (cash and credit)
	     */
	    AccountsService.prototype.listAllWithCash = function () {
	        return _super.prototype.listAll.call(this);
	    };
	    /**
	     * Return all accounts (cash and credit) if credit PoS workflow configured,
	     * otherwise only return credit accounts.
	     *
	     * US 93566 - allow cash account transaction creation
	     */
	    AccountsService.prototype.listAllCreditWorkflow = function () {
	        var posWorkflow = this.systemConfigurationService
	            .getValueByName(system_configuration_constants_1.SysConfigConstants.POINT_OF_SALE_WORKFLOW);
	        if (posWorkflow === 'credit') {
	            return this.findAllMinimalReturn(true);
	        }
	        else {
	            return this.findAllCreditMinimalActiveReturn();
	        }
	    };
	    /**
	     * Return list of account IDs and names ONLY -- to be used for forms (includes cash accounts)
	     */
	    AccountsService.prototype.findAllMinimalReturn = function (onlyActive) {
	        var active = onlyActive ? '?active=true' : '';
	        return this.restangular.one(exports.endpoint + "/allMinimal" + active).get();
	    };
	    /**
	     * Return list of active account IDs and names ONLY -- to be used for forms (includes cash accounts)
	     */
	    AccountsService.prototype.findAllActiveMinimalReturn = function () {
	        return this.findAllMinimalReturn(true);
	    };
	    /**
	     * Return list of account IDs and names ONLY for cash accounts
	     */
	    AccountsService.prototype.findAllCashMinimalReturn = function (onlyActive) {
	        var active = onlyActive ? '?active=true' : '';
	        return this.restangular.one(exports.endpoint + "/cashMinimal" + active).get();
	    };
	    /**
	     * Return list of account IDs and names ONLY for credit accounts
	     */
	    AccountsService.prototype.findAllCreditMinimalReturn = function (onlyActive) {
	        var active = onlyActive ? '?active=true' : '';
	        return this.restangular.one(exports.endpoint + "/creditMinimal" + active).get();
	    };
	    /**
	     * Return list of active account IDs and names ONLY for credit accounts
	     */
	    AccountsService.prototype.findAllCreditMinimalActiveReturn = function () {
	        return this.findAllCreditMinimalReturn(true);
	    };
	    /**
	   * Return list of active account IDs and names ONLY for credit accounts
	   */
	    AccountsService.prototype.findAllCrediAndCashtMinimalActiveReturn = function () {
	        return this.findAllMinimalReturn(true);
	    };
	    /**
	     * Return list of account IDs and names ONLY for active credit aviation accounts (Airline, General Aviation or Charter)
	     */
	    AccountsService.prototype.findAllActiveCreditMinimalAviationReturn = function (accountType) {
	        return this.restangular.one(exports.endpoint + "/activeCreditMinimalAviation").customGET('', { accountType: accountType });
	    };
	    /**
	     * Return list of account IDS and names ONLY for accounts with flight
	     * schedules.
	     */
	    AccountsService.prototype.findSchedMinimalReturn = function () {
	        return this.restangular.one(exports.endpoint + "/schedMinimal").get();
	    };
	    /**
	     * Return list of customer notifications
	     */
	    AccountsService.prototype.getCustomerNotifications = function () {
	        return this.restangular.one(exports.endpoint + "/getCustomerNotifications").get();
	    };
	    AccountsService.prototype.update = function (account, id) {
	        var _this = this;
	        return _super.prototype.update.call(this, account, id)
	            .then(function () { return _this.updateAccountCustomerEvent(id, account.list_of_events_account_notified); });
	    };
	    AccountsService.prototype.create = function (account) {
	        var _this = this;
	        var events = account.list_of_events_account_notified;
	        return _super.prototype.create.call(this, account)
	            .then(function (newAccount) { return _this.updateAccountCustomerEvent(newAccount.id, events); });
	    };
	    AccountsService.prototype.updateAccountCustomerEvent = function (accountId, events) {
	        return this.restangular.one(exports.endpoint + "/" + accountId + "/account_events").customPUT(events || []);
	    };
	    return AccountsService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.AccountsService = AccountsService;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoints
	exports.endpoint = 'aerodromecategories';
	var AerodromeCategoryManagementService = (function (_super) {
	    __extends(AerodromeCategoryManagementService, _super);
	    /** @ngInject */
	    AerodromeCategoryManagementService.$inject = ["Restangular"];
	    function AerodromeCategoryManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            category_name: null,
	            international_passenger_fee_adult: null,
	            international_passenger_fee_child: null,
	            domestic_passenger_fee_adult: null,
	            domestic_passenger_fee_child: null,
	            domestic_fees_currency: null,
	            international_fees_currency: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return AerodromeCategoryManagementService;
	}(crud_service_1.CRUDService));
	exports.AerodromeCategoryManagementService = AerodromeCategoryManagementService;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = '/aerodromes';
	var AerodromesService = (function (_super) {
	    __extends(AerodromesService, _super);
	    /** @ngInject */
	    AerodromesService.$inject = ["Restangular"];
	    function AerodromesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aerodrome_name: null,
	            extended_aerodrome_name: null,
	            aixm_flag: null,
	            geometry: {
	                type: 'Point',
	                coordinates: [null, null]
	            },
	            is_default_billing_center: null,
	            billing_center: null,
	            aerodrome_category: null,
	            external_accounting_system_identifier: null,
	            aerodrome_services: []
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // returns only aerodromes managed by the billing center that is assigned to the current user
	    AerodromesService.prototype.getAerodromesByBillingCentre = function () {
	        return this.restangular.one(exports.endpoint + "?current-billing-center").get();
	    };
	    AerodromesService.prototype.getAerodromeServiceTypes = function () {
	        return this.restangular.one(exports.endpoint + "/aerodrome-service-types").get();
	    };
	    // returns all aerodrome services
	    AerodromesService.prototype.getAllAerodromeServices = function () {
	        return this.restangular.one(exports.endpoint + "/aerodrome-services").get();
	    };
	    return AerodromesService;
	}(crud_service_1.CRUDService));
	exports.AerodromesService = AerodromesService;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// classes
	var user_event_log_class_1 = __webpack_require__(158);
	var LoginService = (function () {
	    /** @ngInject */
	    LoginService.$inject = ["oAuthService", "systemConfigurationService", "userEventLogService", "$location", "$rootScope"];
	    function LoginService(oAuthService, systemConfigurationService, userEventLogService, $location, $rootScope) {
	        this.oAuthService = oAuthService;
	        this.systemConfigurationService = systemConfigurationService;
	        this.userEventLogService = userEventLogService;
	        this.$location = $location;
	        this.$rootScope = $rootScope;
	    }
	    LoginService.prototype.login = function (username, password) {
	        var _this = this;
	        var valid = false;
	        // makes a call to system configuration as well when logging in to get system variables
	        return this.oAuthService.authenticate(username, password, false).then(function () {
	            _this.systemConfigurationService.listForClientStorage().then(function () {
	                _this.$rootScope.$broadcast('system_configurations', 'complete');
	            });
	            window.localStorage.setItem('loginFromBilling', JSON.stringify(true));
	            // allows logging of successfull sign in event
	            valid = true;
	        }).finally(function () {
	            if (valid) {
	                var event_1 = new user_event_log_class_1.Event('login', '', 'login', '', '');
	                _this.userEventLogService.create(event_1);
	            }
	        });
	    };
	    LoginService.prototype.redirectIfLoggedIn = function () {
	        var oauth = this.oAuthService.oauth;
	        if (oauth && Object.keys(oauth)) {
	            this.$location.path('/welcome-page');
	        }
	    };
	    return LoginService;
	}());
	exports.LoginService = LoginService;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ConfigService = (function () {
	    function ConfigService() {
	        /** @ngInject */
	        // start config injection
	        this.config = { 'API_HOST': '/abms', 'AUTH_TOKEN': 'YWJtc193ZWI6YWJtc193ZWI=', 'YANDEX_API': 'trnsl.1.1.20180119T153832Z.d6797901d248188c.e6d0d0a27ae0b3b7bebfa0ca92f6d30cca64c81b', 'BASE_PROVIDER': 'OSM', 'BASE_LOCAL_URL': '/abms/basemap/', 'SCENE_MODE': 'SCENE2D', 'CESIUM_KEY': 'ApskkoQn7i-Q1dvMbpxNhiG3opQex5G1xjLwQHczAwrF8cnNsbj8L5zBqip1cwtJ', 'GEOSERVER_NAVDB': '/abms/geoserver/NAVDB/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application%2Fjson&srs=EPSG:4326&srsName=EPSG:4326&typeName=NAVDB:', 'GEOSERVER_ABMSDB': '/abms/geoserver/ABMSDB/ows?service=WFS&version=1.0.0&request=GetFeature&outputFormat=application%2Fjson&srs=EPSG:4326&srsName=EPSG:4326&typeName=ABMSDB:', 'GEOSERVER_BASE_PT1': '/abms/geoserver/', 'BUILD_DATE': '2026-03-27T19:23:52.136Z', 'BUILD_VERSION': '01.05.005.0058' };
	    }
	    // ** DO NOT CHANGE ANYTHING ABOUT THE PREVIOUS LINE ** //
	    ConfigService.prototype.get = function (key) {
	        return this.config[key];
	    };
	    ConfigService.prototype.list = function () {
	        return this.config;
	    };
	    return ConfigService;
	}());
	exports.ConfigService = ConfigService;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'aircraft-types';
	var AircraftTypeManagementService = (function (_super) {
	    __extends(AircraftTypeManagementService, _super);
	    /** @ngInject */
	    AircraftTypeManagementService.$inject = ["Restangular"];
	    function AircraftTypeManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            aircraft_type: null,
	            aircraft_image: null,
	            aircraft_name: null,
	            manufacturer: null,
	            wake_turbulence_category: null,
	            maximum_takeoff_weight: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return list of account IDs and names ONLY -- to be used for forms (includes cash accounts)
	     */
	    AircraftTypeManagementService.prototype.findAllMinimalReturn = function () {
	        return this.restangular.one(exports.endpoint + "/allMinimal").get();
	    };
	    return AircraftTypeManagementService;
	}(crud_service_1.CRUDService));
	exports.AircraftTypeManagementService = AircraftTypeManagementService;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	/**
	 * This service can be used to save data, filter,
	 * and sorting templates on different UIs
	 *
	 * It requires the UI to have the cannedSort
	 * attribute on the data-grid table
	 * eg: canned-sort=cannedSort
	 */
	var SaveLocalTemplateService = (function () {
	    /** @ngInject */
	    SaveLocalTemplateService.$inject = ["$rootScope", "$window"];
	    function SaveLocalTemplateService($rootScope, $window) {
	        this.$rootScope = $rootScope;
	        this.$window = $window;
	        this.setupEventListeners();
	    }
	    /**
	     * Use to save data, filter, and sorting between page changes.
	     * Note, all parameters are required.
	     *
	     * The module's scope
	     * Usually just this.scope
	     * @param  {angular.IScope} scope
	     *
	     * The module name
	     * Must correspond with the state name
	     * eg: if state name is main.radar-summary
	     * pass in 'radar-summary'
	     * @param  {string} moduleName
	     *
	     * Two dimensional array
	     * Each array has a pair of strings
	     * eg: ['filterModelName', 'filterParam']
	     * Do not include pagination or date range pairs
	     * See flightmovements for an example of this array
	     * @param  {string[][]} filterPairs
	     */
	    SaveLocalTemplateService.prototype.saveLocalTemplate = function (scope, moduleName, filterPairs) {
	        var _this = this;
	        this.scope = scope;
	        this.moduleName = moduleName;
	        this.filterPairs = filterPairs;
	        // watch for list change and apply previous state
	        // from local storage, remove watch once complete
	        var clearWatch = this.scope.$watch('list', function () {
	            if (_this.scope.list !== undefined) {
	                _this.getAndApplyTemplate();
	                clearWatch();
	            }
	        });
	    };
	    /**
	     * Apply preivous state from local storage and refresh. This causes list to
	     * refresh a second time with previous state.. should fine another approach.
	     */
	    SaveLocalTemplateService.prototype.getAndApplyTemplate = function () {
	        // returns the data, filters, and queryString from local storage
	        var editable = localStorage_service_1.LocalStorageService.get(this.moduleName + "Data");
	        var filters = localStorage_service_1.LocalStorageService.get(this.moduleName + "Filters");
	        var queryString = localStorage_service_1.LocalStorageService.get(this.moduleName + "QueryString");
	        if (editable) {
	            this.scope.editable = editable;
	        }
	        // if there is a dateRange, apply UTC time
	        if (filters && filters.start && this.scope.control) {
	            var startDate = new Date(filters.start);
	            this.scope.control.setUTCStartDate(startDate);
	        }
	        if (filters && filters.end && this.scope.control) {
	            var endDate = new Date(filters.end);
	            this.scope.control.setUTCEndDate(endDate);
	        }
	        if (filters || queryString) {
	            // fills in the filter inputs
	            for (var _i = 0, _a = this.filterPairs; _i < _a.length; _i++) {
	                var filterPair = _a[_i];
	                this.scope[filterPair[0]] = filters[filterPair[1]];
	            }
	            // sets the table sorting icon
	            this.scope.cannedSort = queryString;
	            // call the endpoint with filters and queryString
	            this.scope.refresh(filters, this.scope.cannedSort);
	        }
	    };
	    /**
	     * Save current template state to local storage for use latter.
	     */
	    SaveLocalTemplateService.prototype.saveTemplate = function () {
	        // require local fields to be set from preivous state
	        if (!this.scope || !this.moduleName || !this.filterPairs) {
	            return;
	        }
	        var filters = {};
	        // gets scope values
	        // adds to to filters object
	        // keys are query params, values are query values eg: {search : 'FAOR'}
	        for (var _i = 0, _a = this.filterPairs; _i < _a.length; _i++) {
	            var filterPair = _a[_i];
	            filters[filterPair[1]] = this.scope[filterPair[0]];
	        }
	        // if there is a page number, add it to the filters object
	        if (this.scope.pagination && this.scope.pagination.number) {
	            filters.page = this.scope.pagination.number;
	        }
	        // if there is a date range, add dates to filters object
	        if (this.scope.control && this.scope.control.getUTCStartDate()) {
	            filters.start = this.scope.control.getUTCStartDate().toISOString().substr(0, 10);
	        }
	        if (this.scope.control && this.scope.control.getUTCEndDate()) {
	            filters.end = this.scope.control.getUTCEndDate().toISOString().substr(0, 10);
	        }
	        // save data, filters, and queryString to local storage
	        localStorage_service_1.LocalStorageService.set(this.moduleName + "Data", this.scope.editable);
	        localStorage_service_1.LocalStorageService.set(this.moduleName + "Filters", filters);
	        localStorage_service_1.LocalStorageService.set(this.moduleName + "QueryString", (typeof this.scope.getSortQueryString === 'function')
	            ? this.scope.getSortQueryString() : this.scope.getSortQueryString);
	    };
	    /**
	     * Use this function on construction to add necessary state event listeners - should only be done once.
	     */
	    SaveLocalTemplateService.prototype.setupEventListeners = function () {
	        var _this = this;
	        // save template if name matches from state and always clear fields to keep fresh between state changes
	        this.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	            if (_this.moduleName && fromState.name === "main." + _this.moduleName) {
	                _this.saveTemplate();
	            }
	            // clear fields on every state change
	            delete _this.scope;
	            delete _this.moduleName;
	            delete _this.filterPairs;
	        });
	        // save template when window closed only if fields set
	        this.$window.addEventListener('beforeunload', function () { return _this.saveTemplate(); });
	    };
	    return SaveLocalTemplateService;
	}());
	exports.SaveLocalTemplateService = SaveLocalTemplateService;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// classes
	var user_event_log_class_1 = __webpack_require__(158);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var localStorage_service_1 = __webpack_require__(9);
	// todo this could use refactoring to simplify how it works
	var OAuthService = (function () {
	    /** @ngInject */
	    OAuthService.$inject = ["$location", "$http", "Restangular", "configService", "$window", "$state", "userEventLogService", "$auth", "$q"];
	    function OAuthService($location, $http, Restangular, configService, $window, $state, userEventLogService, $auth, $q) {
	        this.$location = $location;
	        this.$http = $http;
	        this.Restangular = Restangular;
	        this.configService = configService;
	        this.$window = $window;
	        this.$state = $state;
	        this.userEventLogService = userEventLogService;
	        this.$auth = $auth;
	        this.$q = $q;
	        this._secondsPassUntilRefresh = 604800; // expires if time passed is 1 week
	        this.makingRefreshRequest = false;
	        // list of config items to keep on logout (i.e. stuff needed by login UI or preconfiguration items)
	        this.list = [system_configuration_constants_1.SysConfigConstants.LANGUAGE_SELECTION, system_configuration_constants_1.SysConfigConstants.LANGUAGE_ENABLED, system_configuration_constants_1.SysConfigConstants.LANGUAGE_SUPPORTED];
	    }
	    Object.defineProperty(OAuthService.prototype, "oauth", {
	        get: function () {
	            return this._oauth;
	        },
	        set: function (oauth) {
	            this._oauth = oauth;
	            // updated restangular default authorization header state to match oauth value
	            // on clear, revet back to 'Content-Type': 'application/json' to match oauth.run
	            var defaultHeaders;
	            if (oauth && oauth.access_token) {
	                defaultHeaders = { 'Authorization': "Bearer " + oauth.access_token };
	            }
	            else {
	                defaultHeaders = { 'Content-Type': 'application/json' };
	            }
	            this.Restangular.setDefaultHeaders(defaultHeaders);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OAuthService.prototype, "secondsPassUntilRefresh", {
	        get: function () {
	            return this._secondsPassUntilRefresh;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OAuthService.prototype.setExpiryTimestamp = function () {
	        localStorage_service_1.LocalStorageService.set('oauth.expiry', (Math.floor(Date.now() / 1000)));
	    };
	    OAuthService.prototype.getExpiryTimestamp = function () {
	        return localStorage_service_1.LocalStorageService.get('oauth.expiry');
	    };
	    OAuthService.prototype.shouldRefreshToken = function () {
	        return (Math.floor(Date.now() / 1000)) - this.getExpiryTimestamp() > this.secondsPassUntilRefresh;
	    };
	    OAuthService.prototype.authenticate = function (username, password, selfCare) {
	        var _this = this;
	        var api = this.configService.get('API_HOST') || '';
	        var token = this.configService.get('AUTH_TOKEN');
	        return this.$http.post(api + "/oauth/token", null, {
	            params: {
	                username: username,
	                password: password,
	                grant_type: 'password',
	                selfCare: selfCare
	            },
	            headers: {
	                'Content-Type': 'application/x-www-form-urlencoded',
	                'Authorization': "Basic " + token
	            },
	            withCredentials: true
	        }).success(function (oauth) {
	            _this.oauth = oauth;
	            localStorage_service_1.LocalStorageService.set('oauth', oauth);
	            _this.setExpiryTimestamp();
	            return oauth;
	        }).error(function (error) {
	            return error;
	        });
	    };
	    /**
	     * Logout user session and navigate to appropriate landing page state.
	     */
	    OAuthService.prototype.logout = function (logEvent, connError) {
	        var _this = this;
	        if (logEvent === void 0) { logEvent = false; }
	        if (connError === void 0) { connError = false; }
	        // create a 'logout' user event before session is destroyed
	        var promise;
	        if (logEvent && this.oauth) {
	            promise = this.userEventLogService.create(new user_event_log_class_1.Event('logout', '', 'logout', '', ''));
	        }
	        else {
	            promise = this.$q.reject('No user session found');
	        }
	        return promise.finally(function () { return _this.destroySession(connError); });
	    };
	    /**
	     * Redirect user to appropriate landing page based on route.
	     */
	    OAuthService.prototype.redirect = function (isLogout, event) {
	        if (isLogout === void 0) { isLogout = false; }
	        if (event === void 0) { event = null; }
	        // prevent default event from occuring before redirecting
	        // required when called from event $stateChargeStart
	        if (event) {
	            event.preventDefault();
	        }
	        // determine if selfcare based on location
	        var isBillingPath = this.$window.location.pathname.endsWith('/web/');
	        var isSelfcarePath = this.$window.location.pathname.endsWith('/selfcare/');
	        var isSelfcarePage = this.$location.path().startsWith('/sc-') || this.$location.path().includes('password-change');
	        // redirect user to self-care home page if selfcare route, else go to billing login page
	        if (isSelfcarePath || (!isBillingPath && isSelfcarePage)) {
	            this.$state.go('main.sc-home-page', {}, { reload: true });
	        }
	        else {
	            this.$state.go(isLogout ? 'login' : 'main.welcome-page', {}, { reload: true });
	        }
	    };
	    OAuthService.prototype.refresh = function (refreshToken) {
	        var _this = this;
	        if (this.makingRefreshRequest !== true) {
	            var api = this.configService.get('API_HOST') || '';
	            var token = this.configService.get('AUTH_TOKEN');
	            // prevents multiple refresh requests being made
	            // throws a constraint SQL error if too many come in at once
	            this.makingRefreshRequest = true;
	            return this.$http.post(api + "/oauth/token", null, {
	                params: {
	                    grant_type: 'refresh_token',
	                    refresh_token: refreshToken
	                },
	                headers: {
	                    'Content-Type': 'application/x-www-form-urlencoded',
	                    'Authorization': "Basic " + token
	                },
	                withCredentials: true
	            }).success(function (oauth) {
	                _this.oauth = oauth;
	                _this.makingRefreshRequest = false;
	                localStorage_service_1.LocalStorageService.set('oauth', oauth);
	                _this.setExpiryTimestamp();
	                return oauth;
	            }).error(function (error) {
	                _this.logout();
	                return error;
	            });
	        }
	    };
	    /**
	     * Ensure billing users are not authenticated in self-care portal and self-care portal users are not authenticated in billing.
	     */
	    OAuthService.prototype.validate = function (toState, event) {
	        if (toState === void 0) { toState = null; }
	        if (event === void 0) { event = null; }
	        // default to current location path
	        var path = toState ? toState.url : this.$location.path();
	        // determine if user exists and where they logged in from
	        var loginFromBilling = this.$window.localStorage.getItem('loginFromBilling');
	        var isUserBilling = !!loginFromBilling && loginFromBilling.toLowerCase() === 'true';
	        var isUserSelfcare = !!loginFromBilling && loginFromBilling.toLowerCase() === 'false';
	        // determine if billing or selfcare path name exists
	        var isPathBilling = this.$window.location.pathname.endsWith('/web/');
	        var isPathSelfcare = this.$window.location.pathname.endsWith('/selfcare/');
	        // determine if path is for selfcare or shared page
	        var isPageSelfcare = path.startsWith('/sc-');
	        var isPageShared = path.includes('password-change');
	        // determine if route is billing or selfcare by path and pages
	        var isRouteBilling = isPathBilling || !isPageSelfcare;
	        var isRouteSelfcare = isPathSelfcare || isPageSelfcare || isPageShared;
	        // if is a selfcare route and a billing user or a selfcare user and a billing route, logout to appropriate page
	        if ((isUserBilling && !isRouteBilling) || (isUserSelfcare && !isRouteSelfcare)) {
	            this.logout();
	        }
	        // limit '/selfcare/' and '/web/' path to respective pages if present by redirecting to landing page
	        if ((isPathSelfcare && !(isPageSelfcare || isPageShared)) || (isPathBilling && isPageSelfcare)) {
	            this.redirect(false, event);
	        }
	    };
	    OAuthService.prototype.getAuthProviders = function () {
	        var api = this.configService.get('API_HOST') || '';
	        return this.$http.get(api + "/auth/providers").success(function (res) {
	            return res ? res : [];
	        }).error(function (error) {
	            return [];
	        });
	    };
	    OAuthService.prototype.providerLogout = function () {
	        var _this = this;
	        var api = this.configService.get('API_HOST') || '';
	        return this.$http.get(api + "/auth/providers/logout").success(function (res) {
	            return res;
	        }).error(function (error) {
	            _this.redirect(true);
	        });
	    };
	    OAuthService.prototype.clear = function () {
	        this.oauth = null;
	    };
	    OAuthService.prototype.destroySession = function (skipProviderLogOut) {
	        if (skipProviderLogOut === void 0) { skipProviderLogOut = false; }
	        // remove saved items from local storage
	        localStorage_service_1.LocalStorageService.destroy(this.savedItems());
	        // nullify oauth object
	        this.clear();
	        this.$auth.logout();
	        var oauthProxy = this;
	        if (!skipProviderLogOut) {
	            this.providerLogout().then(function (result) {
	                if (result && result.data && result.data.provider_redirect && result.data.redirect) {
	                    // redirect user to sso provider logout page
	                    oauthProxy.$window.location.href = result.data.redirect;
	                }
	                else {
	                    // redirect user to login page, selfcare
	                    oauthProxy.redirect(true);
	                }
	            });
	        }
	        else {
	            // redirect user to login page, selfcare
	            oauthProxy.redirect(true);
	        }
	    };
	    OAuthService.prototype.savedItems = function () {
	        var output = [];
	        for (var i = 0, len = this.list.length; i < len; i++) {
	            output.push("SystemConfiguration:" + this.list[i]);
	        }
	        return output;
	    };
	    return OAuthService;
	}());
	exports.OAuthService = OAuthService;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = '/transaction-types';
	var TransactionTypesService = (function (_super) {
	    __extends(TransactionTypesService, _super);
	    /** @ngInject */
	    TransactionTypesService.$inject = ["Restangular"];
	    function TransactionTypesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = [{
	                id: null,
	                name: null
	            }];
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return TransactionTypesService;
	}(crud_service_1.CRUDService));
	exports.TransactionTypesService = TransactionTypesService;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var AboutService = (function () {
	    /** @ngInject */
	    AboutService.$inject = ["configService"];
	    function AboutService(configService) {
	        this.configService = configService;
	        this.service = configService;
	    }
	    AboutService.prototype.list = function () {
	        return this.service.list();
	    };
	    return AboutService;
	}());
	exports.AboutService = AboutService;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = '/route-segments';
	var RouteSegmentsService = (function (_super) {
	    __extends(RouteSegmentsService, _super);
	    /** @ngInject */
	    RouteSegmentsService.$inject = ["Restangular"];
	    function RouteSegmentsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            flight_record_id: null,
	            segment_type: null,
	            segment_number: null,
	            location: null,
	            segment_start_label: null,
	            segment_length: null,
	            segment_cost: null,
	            destination: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    RouteSegmentsService.prototype.getRouteSegmentsByTypeAndFlightMovementId = function (id, segmentType) {
	        return this.restangular.one(exports.endpoint + "/find-by-segmenttype-and-flightid/" + segmentType + "/" + id).get();
	    };
	    return RouteSegmentsService;
	}(crud_service_1.CRUDService));
	exports.RouteSegmentsService = RouteSegmentsService;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'currency-exchange-rates';
	var CurrencyExchangeRatesService = (function (_super) {
	    __extends(CurrencyExchangeRatesService, _super);
	    /** @ngInject */
	    CurrencyExchangeRatesService.$inject = ["Restangular"];
	    function CurrencyExchangeRatesService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            currency: {
	                id: null
	            },
	            currency_code: null,
	            exchange_rate: null,
	            exchange_rate_valid_from_date: null,
	            exchange_rate_valid_to_date: null,
	            target_currency: {
	                id: null,
	                currency_code: null
	            }
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    CurrencyExchangeRatesService.prototype.getExchangeRatesByCurrencyId = function (currencyId, page) {
	        var pagination = { page: page };
	        if (page) {
	            pagination.page = --page; // the uib-pagination starts at `1` but Spring Framework starts at `0`, therefore we fake it
	        }
	        return this.restangular.one(exports.endpoint + "/for-currency/" + currencyId).get(pagination);
	    };
	    CurrencyExchangeRatesService.prototype.getAllExchangeRatesByCurrencyId = function (currencyId, queryString) {
	        var qs = queryString ? queryString : '';
	        return this.restangular.one(exports.endpoint + "/all-currency/" + currencyId + "?" + qs).get();
	    };
	    CurrencyExchangeRatesService.prototype.getExchangeRateByCurrencyId = function (fromCurrenyId, toCurrencyId, datetime) {
	        return this.restangular.one(exports.endpoint + "/for-currency/" + fromCurrenyId + "/to/" + toCurrencyId).get({ datetime: datetime || null });
	    };
	    CurrencyExchangeRatesService.prototype.getExchangeAmount = function (fromAmount, exchangeRate, toDecimalPoints, inverse) {
	        if (inverse === void 0) { inverse = false; }
	        return this.restangular.one(exports.endpoint + "/for-exchange-rate/" + exchangeRate + "/from-amount/" + fromAmount + "/rounded-to/" + toDecimalPoints + "?inverse=" + inverse).get();
	    };
	    CurrencyExchangeRatesService.prototype.updateFromWeb = function () {
	        return this.restangular.one(exports.endpoint + "/update-all").customPUT();
	    };
	    CurrencyExchangeRatesService.prototype.getCurrentExchangeRatesByCurrencyCode = function (currencyCode) {
	        return this.restangular.one(exports.endpoint + "/for-currency-code/" + currencyCode).get();
	    };
	    return CurrencyExchangeRatesService;
	}(crud_service_1.CRUDService));
	exports.CurrencyExchangeRatesService = CurrencyExchangeRatesService;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.endpoint = 'reports';
	// named poorly this way because there already is a reports endpoint
	var ReportsService = (function () {
	    /** @ngInject */
	    ReportsService.$inject = ["Restangular"];
	    function ReportsService(Restangular) {
	        this.Restangular = Restangular;
	    }
	    //
	    //  - Aviation
	    //
	    /**
	     * Generate an aviation invoice with the status "new" from Point Of Sale Invoice Generation
	     *
	     * @param accountId
	     * @param flightIdList
	     * @param format
	     * @param preview
	     * @param tempFlightMovementList
	     * @param flightCategory
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.generateAviationInvoice = function (accountId, flightIdList, invoice_permits, format, preview, tempFlightMovementList, flightCategory, invoiceCurrency) {
	        var url = exports.endpoint + "/aviation-invoice?accountId=" + accountId + "&flightIdList=" + flightIdList + "&format=" + format + "&preview=" + preview + "&invoiceCurrency=" + invoiceCurrency;
	        if (flightCategory) {
	            url = url + "&flightCategory=" + flightCategory;
	        }
	        return this.Restangular.one(url).customPOST({
	            'flight_items': tempFlightMovementList,
	            'invoice_permits': invoice_permits
	        });
	    };
	    /**
	     * Generate an aviation invoice with the status "new" from Flight Movement
	     *
	     * @param accountId
	     * @param flightIdList
	     * @param pointOfSale - indicated from what page it's called (Point Of Sale or Flight Movement)
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.generateAviationInvoiceFM = function (accountId, flightIdList, flightCategory) {
	        var param = "/aviation-invoice?accountId=" + accountId + "&flightIdList=" + flightIdList + "&pointOfSale=false";
	        if (flightCategory) {
	            return this.Restangular.one("" + exports.endpoint + param + "&flightCategory=" + flightCategory).get();
	        }
	        else {
	            return this.Restangular.one("" + exports.endpoint + param).get();
	        }
	    };
	    /**
	     * Preview/Generate an invoice.
	     * Used for calculating an invoice
	     *
	     * @param accountId
	     * @param flightIdListArr
	     * @param preview
	     * @param format
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.aviationInvoice = function (accountId, flightIdListArr, flight_items, invoice_permits, flightCategory, preview, format, invoiceCurrency) {
	        if (accountId === void 0) { accountId = null; }
	        if (flightIdListArr === void 0) { flightIdListArr = []; }
	        if (preview === void 0) { preview = 0; }
	        if (format === void 0) { format = 'json'; }
	        var flightIdList = flightIdListArr.toString();
	        return this.Restangular.one(exports.endpoint + "/aviation-invoice").customPOST({ flight_items: flight_items, invoice_permits: invoice_permits }, null, {
	            accountId: accountId,
	            invoiceCurrency: invoiceCurrency,
	            flightIdList: flightIdList,
	            flightCategory: flightCategory,
	            preview: preview,
	            format: format,
	            pay: 0
	        });
	    };
	    // returns billable flights for a single account
	    ReportsService.prototype.getNonInvoicedFlightMovementsByAccount = function (accountId, userBillingCenterOnly, page, queryString, flightCategory) {
	        if (queryString === void 0) { queryString = ''; }
	        return this.Restangular.one(exports.endpoint + "/aviation-invoice/non-invoiced-flights-for-account?" + queryString).get({
	            accountId: accountId,
	            page: page,
	            userBillingCenterOnly: userBillingCenterOnly,
	            flightCategory: flightCategory
	        });
	    };
	    // generates and pays invoice
	    ReportsService.prototype.aviationInvoicePay = function (accountId, flightIdListArr, flight_items, payment, invoice_permits, invoiceCurrency) {
	        if (accountId === void 0) { accountId = null; }
	        if (flightIdListArr === void 0) { flightIdListArr = []; }
	        var flightIdList = flightIdListArr.toString();
	        return this.Restangular.one(exports.endpoint + "/aviation-invoice").customPOST({ flight_items: flight_items, payment: payment, invoice_permits: invoice_permits }, null, {
	            accountId: accountId,
	            invoiceCurrency: invoiceCurrency,
	            flightIdList: flightIdList,
	            preview: 0,
	            format: 'pdf',
	            pay: 1
	        });
	    };
	    /**
	     * Validates a flight movement (for the reports service)
	     *
	     * @param accountId
	     * @param flightMovement
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.validateFlight = function (accountId, flightMovement, temporaryFlights) {
	        return this.Restangular.one(exports.endpoint + "/aviation-invoice/validate-flight")
	            .customPOST({
	            flight: flightMovement,
	            temporary_flights: temporaryFlights
	        }, null, { accountId: accountId });
	    };
	    //
	    //  - Non-Aviation
	    //
	    /**
	     * Generate a non-aviation invoice with the status "new" from Point Of Sale Invoice Generation
	     *
	     * @param accountId
	     * @param preview
	     * @param format
	     * @param lineItems
	     * @param invoiceCurrency
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.generateNonAviationInvoicePOS = function (accountId, preview, format, lineItems, invoiceCurrency, proforma) {
	        var body = this.nonAviationInvoicePayload(lineItems);
	        return this.Restangular.one(exports.endpoint + "/non-aviation-invoice/pos").customPOST(body, null, { accountId: accountId, invoiceCurrency: invoiceCurrency, preview: preview, format: format, proforma: proforma });
	    };
	    /**
	     * Generate a non-aviation invoice with the status "new" from Non-Aviation Billing
	     *
	     * @param format
	     * @param preview
	     * @param accountId
	     * @param year
	     * @param month
	     * @param lineItems
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.generateNonAviationInvoice = function (format, preview, accountId, year, month, lineItems, kraClerkName, kraReceiptNumber) {
	        var url = exports.endpoint + "/non-aviation-invoice/monthly?accountId=" + accountId + "&format=" + format + "&preview=" + preview + "&month=" + month +
	            ("&year=" + year + "&kraClerkName=" + kraClerkName + "&kraReceiptNumber=" + kraReceiptNumber);
	        return this.Restangular.one(url).customPOST(lineItems);
	    };
	    /**
	     * Preview/Generate a non-aviation invoice.  NOTE: no option to pay, is structured differently
	     * Used for calculating an invoice
	     *
	     * @param accountId
	     * @param lineItem
	     * @param preview
	     * @param format
	     * @param invoiceCurrency
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.nonAviationInvoice = function (accountId, lineItems, preview, format, invoiceCurrency, proforma) {
	        if (accountId === void 0) { accountId = null; }
	        if (lineItems === void 0) { lineItems = []; }
	        if (preview === void 0) { preview = 0; }
	        if (format === void 0) { format = 'pdf'; }
	        if (invoiceCurrency === void 0) { invoiceCurrency = null; }
	        var body = this.nonAviationInvoicePayload(lineItems);
	        return this.Restangular.one(exports.endpoint + "/non-aviation-invoice/pos").customPOST(body, null, { accountId: accountId, invoiceCurrency: invoiceCurrency, preview: preview, format: format, proforma: proforma });
	    };
	    // same as above `nonAviationInvoice` method except it is structured differently to pay it
	    ReportsService.prototype.nonAviationInvoicePay = function (accountId, lineItems, payment, invoiceCurrency) {
	        if (accountId === void 0) { accountId = null; }
	        if (lineItems === void 0) { lineItems = []; }
	        if (invoiceCurrency === void 0) { invoiceCurrency = null; }
	        var body = this.nonAviationInvoicePayload(lineItems, payment);
	        return this.Restangular.one(exports.endpoint + "/non-aviation-invoice/pos").customPOST(body, null, { accountId: accountId, invoiceCurrency: invoiceCurrency, preview: 0, format: 'pdf', pay: 1 });
	    };
	    /**
	     * Gets line items for non-aviation billing engine
	     *
	     * @param  {number} month
	     * @param  {number} year
	     * @param  {number} accountId
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.getLineItemsByMonth = function (month, year, accountId, externalChargeCategoryId) {
	        var route = exports.endpoint + "/non-aviation-invoice/monthly/prepare-line-items?month=" + month + "&year=" + year + "&accountId=" + accountId;
	        if (externalChargeCategoryId) {
	            route += "&externalChargeCategoryId=" + externalChargeCategoryId;
	        }
	        return this.Restangular.one(route).customPOST();
	    };
	    // returns a list of service charges that can be used
	    ReportsService.prototype.getApplicablePosServiceCharges = function () {
	        return this.Restangular.one(exports.endpoint + "/non-aviation-invoice/pos/service-charges").get();
	    };
	    /**
	     * Validates a line item, returns line item with more fields filled out if successful
	     *
	     * @param lineItem
	     * @returns {IPromise<IInvoiceLineItem>}
	     */
	    ReportsService.prototype.validateInvoiceLineItem = function (accountId, lineItem, month, year, invoiceCurrency) {
	        if (month === void 0) { month = null; }
	        if (year === void 0) { year = null; }
	        if (invoiceCurrency === void 0) { invoiceCurrency = null; }
	        switch (lineItem.service_charge_catalogue.charge_basis) {
	            case 'percentage':
	                lineItem.user_markup_amount = lineItem.user_unit_amount;
	                break;
	            case 'user':
	                lineItem.user_price = lineItem.user_unit_amount;
	                break;
	            case 'commercial-electric':
	            case 'residential-electric':
	                lineItem.user_electricity_meter_reading = lineItem.user_unit_amount;
	                break;
	            case 'water':
	                lineItem.user_water_meter_reading = lineItem.user_unit_amount;
	                break;
	            case 'discount':
	                lineItem.user_discount_percentage = lineItem.user_unit_amount;
	                break;
	            default:
	                console.error('Could not match the `charge_basis`');
	        }
	        if (month && year) {
	            // used for Non-Aviation Invoices
	            return this.Restangular.one(exports.endpoint + "/non-aviation-invoice/monthly/validate-line-item").customPOST(lineItem, null, {
	                accountId: accountId,
	                year: year,
	                month: month
	            });
	        }
	        // used for Point of Sale Non-Aviation Invoices
	        return this.Restangular.one(exports.endpoint + "/non-aviation-invoice/pos/validate-line-item").customPOST(lineItem, null, { accountId: accountId, invoiceCurrency: invoiceCurrency });
	    };
	    //
	    //  - IATA
	    //
	    /**
	     * Generate an IATA invoice with the status "new"
	     *
	     * @param billingInterval
	     * @param startDate
	     * @param endDateInclusive
	     * @param preview
	     * @param accountIdList
	     * @param sort
	     * @param userBillingCenterOnly
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.generateIATAInvoice = function (billingInterval, startDate, endDateInclusive, preview, accountIdList, sort, userBillingCenterOnly) {
	        var url = exports.endpoint + "/iata-invoice?billingInterval=" + billingInterval + "&startDate=" + startDate + "&endDateInclusive=" + endDateInclusive + "&preview=" + preview +
	            ("&sort=" + sort + "&userBillingCenterOnly=" + userBillingCenterOnly);
	        var body = { account_id_list: accountIdList };
	        return this.Restangular.one(url).customPOST(body);
	    };
	    //
	    //  - NON-IATA
	    //
	    /**
	     * Generate an NON-IATA invoice with the status "new"
	     *
	     * @param billingInterval
	     * @param startDate
	     * @param endDateInclusive
	     * @param preview
	     * @param accountIdList
	     * @param sort
	     * @param userBillingCenterOnly
	     * @returns {IPromise<any>}
	     */
	    ReportsService.prototype.generateNonIATAInvoice = function (billingInterval, startDate, endDateInclusive, preview, accountIdList, sort, userBillingCenterOnly, flightCategory) {
	        var baseUrl = exports.endpoint + "/aviation-invoice?billingInterval=" + billingInterval + "&startDate=" + startDate + "&endDateInclusive=" + endDateInclusive +
	            ("&preview=" + preview + "&sort=" + sort + "&userBillingCenterOnly=" + userBillingCenterOnly);
	        var url = flightCategory ? baseUrl + "&flightCategory=" + flightCategory : baseUrl;
	        var body = { account_id_list: accountIdList };
	        return this.Restangular.one(url).customPOST(body);
	    };
	    ReportsService.prototype.nonAviationInvoicePayload = function (lineItems, payment) {
	        if (lineItems === void 0) { lineItems = []; }
	        if (payment === void 0) { payment = null; }
	        var requisitions = lineItems.filter(function (item) {
	            return item.requisiton !== null && item.requisition.req_number !== null;
	        }).map(function (item) { return item.requisition; });
	        var invoicePermits = lineItems.filter(function (item) {
	            return item.invoice_permit !== null && item.invoice_permit.invoice_permit_number !== null;
	        }).map(function (item) { return item.invoice_permit; });
	        return {
	            line_items: lineItems.length ? lineItems : null,
	            payment: payment,
	            permit_numbers: invoicePermits.length ? invoicePermits : null,
	            requisition_numbers: requisitions.length ? requisitions : null
	        };
	    };
	    return ReportsService;
	}());
	exports.ReportsService = ReportsService;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DbqueryService = (function () {
	    function DbqueryService() {
	    }
	    DbqueryService.prototype.formatDataPointsForPie = function (data, yaxis, sortList) {
	        var datapoints = [];
	        var xAxisAttribute = sortList[0].value;
	        var yAxisAttribute = sortList[1] ? sortList[1].value : yaxis;
	        var defaultGroupName = 'Other';
	        // Calcolo somma totale per calcolare percentuali
	        var total = data.reduce(function (acc, item) { return acc + (parseFloat(item[yaxis]) || 0); }, 0);
	        var _loop_1 = function (item) {
	            var xValue = item[xAxisAttribute] || defaultGroupName;
	            // Se xValue è una data nel formato "YYYY-MM", la formatto in "MM-YYYY"
	            if (typeof xValue === 'string' && xValue.includes('-')) {
	                var _a = xValue.split('-'), year = _a[0], month = _a[1];
	                // Formatta il mese con un controllo manuale
	                var formattedMonth = (parseInt(month, 10) < 10) ? "0" + month : month;
	                xValue = formattedMonth + "-" + year;
	            }
	            var amount = parseFloat(item[yaxis]) || 0;
	            // Se inferiore all'1%, raggruppa sotto "OTHER"
	            var percentage = (amount / total) * 100;
	            var finalX = percentage < 1 ? 'OTHER' : xValue;
	            var existing = datapoints.find(function (dp) { return dp.x === finalX; });
	            if (existing) {
	                existing.Amount += amount;
	            }
	            else {
	                datapoints.push({ x: finalX, Amount: amount });
	            }
	        };
	        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
	            var item = data_1[_i];
	            _loop_1(item);
	        }
	        // Ordina alfabeticamente (o cronologicamente, se "MM-YYYY")
	        datapoints.sort(function (a, b) { return a.x.localeCompare(b.x, undefined, { numeric: true, sensitivity: 'base' }); });
	        return datapoints;
	    };
	    /**
	     * This function creates an array of all
	     * temporal groups, sorts them ascending
	     *
	     * These temporal groups are used along
	     * the Y-Axis of the chart
	     *
	     * Temporal groups are one of
	     * year/quarter/month/week
	     *
	     * Loops through the data and returns
	     * an array of objects in the following format
	     * {"x": "temp_group", "column1": 1, "column2": 1}
	     *
	     * @param data JSON data
	     * @param yaxis comparison value
	     * @param groupBY group by value
	     * @returns {Array}
	     */
	    DbqueryService.prototype.getDataPoints = function (data, yaxis, sortList) {
	        var datapoints = [];
	        var xAxisAttribute = sortList[0].value;
	        var yAxisAttribute = sortList[1] ? sortList[1].value : null;
	        var defaultKey = 'Amount';
	        var defaultGroupName = 'Other';
	        var _loop_2 = function (item) {
	            // return the item if already exist in datapoints
	            // the bar is not displayed when a key have decimal point as a dot
	            if (typeof (item[yAxisAttribute]) === 'number') {
	                item[yAxisAttribute] = (item[yAxisAttribute]).toString().replace(/\./g, ',');
	            }
	            var itemXAxisAttribute = item[xAxisAttribute] ? item[xAxisAttribute] : defaultGroupName;
	            var existingTarget = datapoints.find((function (dp) { return dp.x === itemXAxisAttribute; }));
	            var target = existingTarget ? existingTarget : { x: itemXAxisAttribute };
	            var groupName = item[yAxisAttribute] ? item[yAxisAttribute] : defaultGroupName;
	            //calcolo il totale dei valori passati 
	            var sum = 0;
	            for (var i = 0; i < data.length; i++) {
	                sum = sum + data[i][yaxis];
	            }
	            //controllo che la percentuale sia inferiore all'1%
	            var percentuale = (item[yaxis] / sum) * 100;
	            if (percentuale < 0.01) {
	                //se la percentuale è inferiore all'1% effettuo una somma dei valori raggruppandoli in "Other"
	                groupName = "OTHER";
	            }
	            if (!yAxisAttribute) {
	                target[defaultKey] = item[yaxis];
	            }
	            else {
	                if (groupName === "OTHER") {
	                    target[groupName] = target[groupName] !== undefined ? target[groupName] + item[yaxis] : item[yaxis];
	                }
	                else {
	                    target[groupName] = item[yaxis];
	                }
	            }
	            if (!existingTarget) {
	                datapoints.push(target);
	            }
	        };
	        for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
	            var item = data_2[_i];
	            _loop_2(item);
	        }
	        // sort the buckets by date
	        datapoints.sort(function (a, b) {
	            return a.x.localeCompare(b.x, undefined, { numeric: true, sensitivity: 'base' });
	        });
	        return datapoints;
	    };
	    /**
	     * Builds an array of objects that contain
	     * the names and types of columns in the
	     * following format
	     * {"id": "ColumnId", "type": "bar", "name": "Column Name"}
	     * @param data        entire dataset from server
	     * @param datapoints  datapoints from getDataPoints method
	     * @param labelKey    takes the datapoint data and uses the labelKey to get data to use on the x-axis
	     * @param type        chart type bar|line|pie etc.
	     * @returns {Array}
	     */
	    DbqueryService.prototype.getColumnsLabels = function (data, datapoints, labelKey, type) {
	        var dataColumns = [];
	        var ids = [];
	        for (var _i = 0, datapoints_1 = datapoints; _i < datapoints_1.length; _i++) {
	            var point = datapoints_1[_i];
	            for (var key in point) {
	                if (key !== 'x') {
	                    ids.push(key);
	                }
	            }
	        }
	        for (var _a = 0, ids_1 = ids; _a < ids_1.length; _a++) {
	            var id = ids_1[_a];
	            /**
	             * id matches the id of the datapoints
	             * type is the chart type   bar|line|pie etc.
	             * name is the x label legend for this point
	             */
	            if (labelKey) {
	                dataColumns.push({ 'id': id, 'type': type, 'name': id });
	            }
	            else {
	                dataColumns.push({ 'id': id, 'type': type, 'name': null });
	            }
	        }
	        return dataColumns;
	    };
	    return DbqueryService;
	}());
	exports.DbqueryService = DbqueryService;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'flm-job';
	var AviationBillingEngineService = (function (_super) {
	    __extends(AviationBillingEngineService, _super);
	    /** @ngInject */
	    AviationBillingEngineService.$inject = ["Restangular", "$sce", "downloadService"];
	    function AviationBillingEngineService(Restangular, $sce, downloadService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$sce = $sce;
	        _this.downloadService = downloadService;
	        _this._mod = {
	            month: null,
	            account_id_list: null,
	            year: null,
	            flights: null,
	            incompleteFlights: null,
	            iata_status: 'iata',
	            sort: null,
	            userBillingCenterOnly: null,
	            billing_interval: null,
	            end_date: null,
	            start_date: null,
	            start_date_open: null,
	            end_date_open: null,
	            due_date: null,
	            processStartDate: null,
	            processEndDate: null,
	            flightCategory: null,
	            preview: null,
	            endDateInclusive: null,
	            account_type: null,
	            selected_options: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // reconciliation methods by month and year
	    AviationBillingEngineService.prototype.executeRecalulation = function (_a) {
	        var _this = this;
	        var processStartDate = _a.processStartDate, processEndDate = _a.processEndDate, account_id_list = _a.account_id_list, flightCategory = _a.flightCategory, selected_options = _a.selected_options;
	        var url = '';
	        if (flightCategory) {
	            url = exports.endpoint + "/reconciliation/" + processStartDate + "/" + processEndDate + "/?flightMovementCategoryId=" + flightCategory;
	        }
	        else {
	            url = exports.endpoint + "/reconciliation/" + processStartDate + "/" + processEndDate + "/";
	        }
	        ;
	        var requestBody = {
	            account_id_list: account_id_list,
	            selected_options: selected_options
	        };
	        console.log(requestBody);
	        // execute a recalculation job
	        return this.restangular.all(url).customPOST(requestBody).then(function (data) {
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    // get status of bulk recalculation
	    AviationBillingEngineService.prototype.getStatusForRecalulations = function () {
	        var _this = this;
	        return this.restangular.one(exports.endpoint + "/reconciliation").get().then(function (data) {
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    // cancels a recalculation job
	    AviationBillingEngineService.prototype.cancelRecalculation = function () {
	        return this.restangular.one(exports.endpoint + "/reconciliation").remove();
	    };
	    // start a generate invoice or preview invoice report polling request
	    AviationBillingEngineService.prototype.executeGeneration = function (editable) {
	        var _this = this;
	        var url = "async-reports/aviation-invoice?billingInterval=" + editable.billing_interval + "&endDateInclusive=" + editable.endDateInclusive + "&" +
	            ("format=pdf&sort=" + editable.sort + "&startDate=" + editable.processStartDate + "&") +
	            ("userBillingCenterOnly=" + editable.userBillingCenterOnly + "&preview=" + editable.preview + "&iataInvoice=" + editable.iataInvoice);
	        // if flight movement category provided, add to params
	        if (editable.flightCategory) {
	            url += "&flightCategory=" + editable.flightCategory;
	        }
	        if (editable.billing_interval === 'UNIFIED_TAX_ANNUALLY' || editable.billing_interval === 'UNIFIED_TAX_PARTIALLY') {
	            if (editable.due_date) {
	                url += "&dueDateOverrideUnifiedTax=" + editable.due_date.toISOString();
	            }
	        }
	        return this.Restangular.one(url).customPOST(editable.account_id_list).then(function (data) {
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    // get status of bulk reconciliation
	    AviationBillingEngineService.prototype.getStatusForGeneration = function () {
	        var _this = this;
	        return this.restangular.one("async-reports/aviation-invoice").get().then(function (data) {
	            return _this.restangular.stripRestangular(data);
	        });
	    };
	    // cancel a generate invoice or preview invoice report polling request
	    AviationBillingEngineService.prototype.cancelGeneration = function () {
	        return this.restangular.one("async-reports/aviation-invoice").remove();
	    };
	    // download and show a pdf preview of the aviation billing invoice
	    AviationBillingEngineService.prototype.downloadInvoice = function (preview, iataInvoice) {
	        var _this = this;
	        if (iataInvoice === void 0) { iataInvoice = false; }
	        var req = this.restangular.withConfig(function (RestangularConfigurer) { return RestangularConfigurer.setFullResponse(true); });
	        var url = "async-reports/aviation-invoice/download?format=pdf&preview=" + (preview === 1) + "&iata=" + (iataInvoice === true);
	        return req.one(url).withHttpConfig({ responseType: 'arraybuffer' }).get().then(function (resp) {
	            var result = null;
	            // if not preview, download result and return null to clear preview
	            // else display result as preview
	            if (resp.status === 200) {
	                if (preview === 0) {
	                    _this.downloadService.getDownload(resp);
	                }
	                else {
	                    result = _this.downloadService.getPreview(resp);
	                }
	            }
	            return result;
	        });
	    };
	    // validates flights by period
	    // this endpoint is only used for aviation billing engine, not fm
	    // back end expects true/false for iata value
	    AviationBillingEngineService.prototype.validate = function (editable, startDate, endDateInclusive) {
	        var params = {
	            endDateInclusive: endDateInclusive,
	            startDate: startDate,
	            userBillingCenterOnly: editable.userBillingCenterOnly,
	            iata: editable.iata_status === 'iata',
	            flightCategory: editable.flightCategory
	        };
	        return this.restangular.one('flightmovements/validations/byParams').customPOST(editable.account_id_list || [], '', params);
	    };
	    // required because of typescript:
	    // the left-hand side of an arithmetic operation must be of type 'any', 'number' or an enum type.
	    // does not allow for a vanilla (http://vanilla-js.com/) expression in the form: return new Date() * 1
	    AviationBillingEngineService.prototype.returnEpochTime = function () {
	        var date = new Date();
	        return date * 1;
	    };
	    /**
	     * Below are the recalculation and
	     * reconciliation methods a list of
	     * maccount ids. They are used
	     * in flight movement management
	     */
	    // reconciliation methods by flight movement ids
	    // execute a reconciliation job
	    AviationBillingEngineService.prototype.executeSpecificReconciliation = function (ids) {
	        return this.restangular.all(exports.endpoint + "/reconciliation/item/" + ids).customPOST();
	    };
	    // get status of bulk reconciliation
	    AviationBillingEngineService.prototype.getStatusForSpecificReconciliation = function () {
	        return this.restangular.one(exports.endpoint + "/reconciliation/item").get();
	    };
	    AviationBillingEngineService.prototype.getStatusForSpecificReconciliationForHeaderBar = function () {
	        return this.restangular.one(exports.endpoint + "/reconciliation/list").get();
	    };
	    // cancels a reconciliation job
	    AviationBillingEngineService.prototype.cancelSpecificReconciliation = function () {
	        return this.restangular.one(exports.endpoint + "/reconciliation/item").remove();
	    };
	    // recalculation methods by flight movement ids
	    // execute a recalculation job
	    AviationBillingEngineService.prototype.executeSpecificRecalculation = function (ids) {
	        return this.restangular.all(exports.endpoint + "/recalculation/item/" + ids).customPOST();
	    };
	    // get status of bulk recalculation
	    AviationBillingEngineService.prototype.getStatusForSpecificRecalculate = function () {
	        return this.restangular.one(exports.endpoint + "/recalculation/item").get();
	    };
	    // cancels a recalculation job
	    AviationBillingEngineService.prototype.cancelSpecificRecalculation = function () {
	        return this.restangular.one(exports.endpoint + "/recalculation/item").remove();
	    };
	    return AviationBillingEngineService;
	}(crud_service_1.CRUDService));
	exports.AviationBillingEngineService = AviationBillingEngineService;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DebounceService = (function () {
	    /** @ngInject */
	    DebounceService.$inject = ["$q", "$timeout"];
	    function DebounceService($q, $timeout) {
	        this.$q = $q;
	        this.$timeout = $timeout;
	    }
	    /**
	     * @param  {Function} func - The function to debounce
	     * @param  {number} wait - The number of miliseconds to wait
	     * @param  {boolean} immediate - Optional conditional which, if true, will immediately resolve the function
	     */
	    DebounceService.prototype.debounce = function (func, wait, immediate) {
	        if (immediate === void 0) { immediate = false; }
	        var deferred = this.$q.defer();
	        var timeout = null;
	        var self = this;
	        // use a deferred object that will be resolved
	        // when we need to actually call the function
	        return function () {
	            var args = arguments;
	            var later = function () {
	                if (!immediate) {
	                    deferred.resolve(func.apply(self, args));
	                    deferred = self.$q.defer();
	                }
	            };
	            if (timeout) {
	                self.$timeout.cancel(timeout);
	            }
	            timeout = self.$timeout(later, wait);
	            if (immediate) {
	                self.$timeout.cancel(timeout);
	                deferred.resolve(func.apply(self, args));
	                deferred = self.$q.defer();
	            }
	            return deferred.promise;
	        };
	    };
	    return DebounceService;
	}());
	exports.DebounceService = DebounceService;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'plugins';
	var PluginsService = (function (_super) {
	    __extends(PluginsService, _super);
	    /** @ngInject */
	    PluginsService.$inject = ["Restangular", "systemConfigurationService"];
	    function PluginsService(Restangular, systemConfigurationService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.systemConfigurationService = systemConfigurationService;
	        _this._mod = {
	            id: null,
	            name: null,
	            description: null,
	            enabled: null,
	            key: null,
	            configurations: [],
	            visible: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    PluginsService.prototype.getPluginEnabled = function (organizationName, pluginName) {
	        return this.restangular.one(this.endpoint + "/isEnabled/" + organizationName + "/" + pluginName).get();
	    };
	    return PluginsService;
	}(crud_service_1.CRUDService));
	exports.PluginsService = PluginsService;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.endpoint = 'languages';
	var LanguagesService = (function () {
	    /** @ngInject */
	    LanguagesService.$inject = ["Restangular"];
	    function LanguagesService(Restangular) {
	        this.Restangular = Restangular;
	        // to do -> anythinng?
	    }
	    LanguagesService.prototype.createLangFileByPart = function (part) {
	        return this.Restangular.one(exports.endpoint + "/file/" + part).get();
	    };
	    return LanguagesService;
	}());
	exports.LanguagesService = LanguagesService;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var LocaleSwitcherService = (function () {
	    /** @ngInject */
	    LocaleSwitcherService.$inject = ["systemConfigurationService", "$rootScope", "$translate", "usersService", "$window"];
	    function LocaleSwitcherService(systemConfigurationService, $rootScope, $translate, usersService, $window) {
	        this.systemConfigurationService = systemConfigurationService;
	        this.$rootScope = $rootScope;
	        this.$translate = $translate;
	        this.usersService = usersService;
	        this.$window = $window;
	        this.systemConfigurationService = systemConfigurationService;
	    }
	    /**
	     * Update Angular Translate, Local Storage, and user (if authenticated) upon locale change
	     */
	    LocaleSwitcherService.prototype.changeLanguage = function (lang) {
	        this.setFrontendLanguage(lang);
	        this.updateBackendLanguage(lang);
	    };
	    LocaleSwitcherService.prototype.setFrontendLanguage = function (lang) {
	        this.$translate.preferredLanguage(lang.code);
	        this.$translate.use(lang.code);
	        this.$rootScope.language.selected = lang;
	        localStorage_service_1.LocalStorageService.set("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_SELECTION, lang);
	    };
	    LocaleSwitcherService.prototype.updateBackendLanguage = function (lang) {
	        this.usersService.setCurrentUserLanguage(lang.code);
	    };
	    return LocaleSwitcherService;
	}());
	exports.LocaleSwitcherService = LocaleSwitcherService;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'amhs-configurations';
	var AMHSConnectionService = (function (_super) {
	    __extends(AMHSConnectionService, _super);
	    /** @ngInject */
	    AMHSConnectionService.$inject = ["Restangular"];
	    function AMHSConnectionService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            active: null,
	            descr: null,
	            protocol: null,
	            rtse_checkpoint_size: null,
	            rtse_window_size: null,
	            max_conn: null,
	            ping_enabled: null,
	            ping_delay: null,
	            network_device: null,
	            local_bind_authenticated: null,
	            local_passwd: null,
	            local_hostname: null,
	            local_ipaddr: null,
	            local_port: null,
	            local_tsap_addr: null,
	            local_tsap_addr_is_hex: null,
	            remote_hostname: null,
	            remote_ipaddr: null,
	            remote_port: null,
	            remote_passwd: null,
	            remote_bind_authenticated: null,
	            remote_class_extended: null,
	            remote_content_corr: null,
	            remote_dl_exp_prohibit: null,
	            remote_rcpt_reass_prohibit: null,
	            remote_idle_time: null,
	            remote_internal_trace: null,
	            remote_latest_delivery_time: null,
	            remote_tsap_addr: null,
	            remote_tsap_addr_is_hex: null,
	            psap_addr: null,
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    AMHSConnectionService.prototype.startAgent = function () {
	        return this.restangular.all(exports.endpoint + "/agent/start").customPOST();
	    };
	    AMHSConnectionService.prototype.stopAgent = function () {
	        return this.restangular.all(exports.endpoint + "/agent/stop").customPOST();
	    };
	    AMHSConnectionService.prototype.restartAgent = function () {
	        return this.restangular.all(exports.endpoint + "/agent/restart").customPOST();
	    };
	    AMHSConnectionService.prototype.agentStatus = function () {
	        return this.restangular.one(exports.endpoint + "/agent/status").get();
	    };
	    return AMHSConnectionService;
	}(crud_service_1.CRUDService));
	exports.AMHSConnectionService = AMHSConnectionService;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'amhs-accounts';
	var AMHSAccountsService = (function (_super) {
	    __extends(AMHSAccountsService, _super);
	    /** @ngInject */
	    AMHSAccountsService.$inject = ["Restangular"];
	    function AMHSAccountsService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            active: null,
	            addr: null,
	            descr: null,
	            passwd: null,
	            allow_mta_conn: null,
	            svc_hold_for_delivery: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return AMHSAccountsService;
	}(crud_service_1.CRUDService));
	exports.AMHSAccountsService = AMHSAccountsService;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Required Services
	 */
	var crud_file_handler_service_1 = __webpack_require__(146);
	/**
	 * Base API endpoint for this service
	 */
	exports.endpoint = 'pending-transactions';
	/**
	 * Supports the Pending Transactions controller
	 */
	var TransactionsPendingService = (function (_super) {
	    __extends(TransactionsPendingService, _super);
	    /** @ngInject */
	    TransactionsPendingService.$inject = ["Restangular"];
	    function TransactionsPendingService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            account: null,
	            can_approve: null,
	            can_reject: null,
	            current_approval_level: null,
	            description: null,
	            detailed_invoices: null,
	            exchange_rate_to_ansp: null,
	            exchange_rate_to_usd: null,
	            exported: null,
	            local_amount: null,
	            local_currency: null,
	            payment_amount: null,
	            payment_currency: null,
	            payment_exchange_rate: null,
	            payment_mechanism: null,
	            payment_reference_number: null,
	            pending_charge_adjustments: null,
	            previous_approval_level: null,
	            related_invoices: null,
	            transaction_date_time: null,
	            transaction_type: null,
	            version: null,
	            document: null,
	            document_filename: null,
	            has_approval_document: null,
	            approval_document_name: null,
	            approval_document_type: null,
	            has_supporting_document: null,
	            supporting_document_name: null,
	            supporting_document_type: null,
	            pending_transaction_approvals: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Get details of selected pending transaction
	     * @param {number} id - id of the pending transaction
	     */
	    TransactionsPendingService.prototype.getOne = function (id) {
	        return this.get(id);
	    };
	    /**
	     * Approve pending transaction, backend determines next steps
	     * @param {number} id - id of the pending transaction
	     */
	    TransactionsPendingService.prototype.approve = function (id, fd, notes) {
	        var path = notes ? this.endpoint + "/approve/" + id + "/" + notes : this.endpoint + "/approve/" + id;
	        var req = this.restangular.one(path);
	        if (fd) {
	            return req.withHttpConfig({ 'transformRequest': angular.identity }).customPUT(fd, undefined, undefined, { 'Content-Type': undefined });
	        }
	        else {
	            return req.customPUT();
	        }
	    };
	    /**
	     * Reject pending transaction, backend determines next steps
	     * @param {number} id - id of the pending transaction
	     */
	    TransactionsPendingService.prototype.reject = function (id, notes) {
	        return this.restangular.one(this.endpoint + "/" + id + "/reject").customPUT(notes).then(function (resp) {
	            return resp;
	        });
	    };
	    TransactionsPendingService.prototype.showWarning = function () {
	        var warning = {
	            data: {
	                error: "Notes is required",
	                error_description: "Notes is required for rejecting a pending transaction"
	            }
	        };
	        return { error: warning };
	    };
	    return TransactionsPendingService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.TransactionsPendingService = TransactionsPendingService;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Required Services
	 */
	var crud_service_1 = __webpack_require__(8);
	/**
	 * Base API endpoint for this service
	 */
	exports.endpoint = 'approval-workflow';
	/**
	 * Supports the Transaction Approval Workflow controller
	 */
	var TransactionsWorkflowService = (function (_super) {
	    __extends(TransactionsWorkflowService, _super);
	    /** @ngInject */
	    TransactionsWorkflowService.$inject = ["Restangular", "$translate"];
	    function TransactionsWorkflowService(Restangular, $translate) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$translate = $translate;
	        _this._mod = {
	            id: null,
	            level: null,
	            delete: false,
	            approval_name: null,
	            approval_group: null,
	            status_type: null,
	            threshold_amount: null,
	            threshold_currency: null,
	            approval_under_level: null,
	            approval_over_level: null,
	            rejected_level: null,
	            version: 0,
	            approval_document_required: false
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return translation supported list of status_types (required by API)
	     */
	    TransactionsWorkflowService.prototype.getStatusTypes = function () {
	        return [
	            'INITIAL',
	            'INTERMEDIATE',
	            'FINAL',
	        ];
	    };
	    /**
	     * Return a copy of the model with all fields set to their initial value (as defined in _mod above)
	     */
	    TransactionsWorkflowService.prototype.getModel = function () {
	        return angular.copy(this._mod);
	    };
	    /**
	     * Return a list of all existing workflow steps
	     */
	    TransactionsWorkflowService.prototype.getAllWorkflowLevels = function () {
	        return this.list();
	    };
	    /**
	     * Creates a new step when some workflow steps already exist (overrides create in CRUD service which uses PUT)
	     */
	    TransactionsWorkflowService.prototype.createNew = function (obj, id) {
	        return this.restangular.all(this.endpoint + "/" + id).customPOST(obj);
	    };
	    return TransactionsWorkflowService;
	}(crud_service_1.CRUDService));
	exports.TransactionsWorkflowService = TransactionsWorkflowService;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	TranslateRun.$inject = ["translateService"];
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var LANGUAGE_ENABLED = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_ENABLED;
	var LANGUAGE_SELECTION = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_SELECTION;
	var LANGUAGE_SUPPORTED = "SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_SUPPORTED;
	var DEFAULT_LANGUAGE = '{"code": "en", "label": "English"}';
	var DEFAULT_LANGUAGE_CODE = 'en';
	var TranslateService = (function () {
	    /** @ngInject */
	    TranslateService.$inject = ["$rootScope", "systemConfigurationService", "usersService", "$translate"];
	    function TranslateService($rootScope, systemConfigurationService, usersService, $translate) {
	        this.$rootScope = $rootScope;
	        this.systemConfigurationService = systemConfigurationService;
	        this.usersService = usersService;
	        this.$translate = $translate;
	        this.$rootScope = $rootScope;
	        this.systemConfigurationService = systemConfigurationService;
	        this.usersService = usersService;
	        this.$translate = $translate;
	    }
	    TranslateService.prototype.run = function () {
	        var _this = this;
	        this.$rootScope.language = {};
	        this.systemConfigurationService.getLanguageConfiguration().then(function (resp) {
	            _this.setLanguageConfiguration(resp);
	        });
	    };
	    TranslateService.prototype.setLanguageConfiguration = function (data) {
	        if (data && data.length) {
	            localStorage_service_1.LocalStorageService.set(LANGUAGE_ENABLED, data[0].current_value);
	            localStorage_service_1.LocalStorageService.set(LANGUAGE_SELECTION, data[1].current_value);
	            localStorage_service_1.LocalStorageService.set(LANGUAGE_SUPPORTED, data[2].current_value);
	        }
	        else {
	            localStorage_service_1.LocalStorageService.set(LANGUAGE_ENABLED, system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_FALSE);
	            localStorage_service_1.LocalStorageService.set(LANGUAGE_SELECTION, DEFAULT_LANGUAGE);
	            localStorage_service_1.LocalStorageService.set(LANGUAGE_SUPPORTED, "[" + DEFAULT_LANGUAGE + "]");
	        }
	        ;
	        this.initializeTranslator();
	        this.createLanguageOptions();
	    };
	    TranslateService.prototype.initializeTranslator = function () {
	        var lang = localStorage_service_1.LocalStorageService.get(LANGUAGE_SELECTION);
	        var langEnabled = localStorage_service_1.LocalStorageService.get(LANGUAGE_ENABLED);
	        this.$rootScope.language.enabled = langEnabled === system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_TRUE;
	        if (lang) {
	            this.$translate.preferredLanguage(lang.code);
	            this.$translate.use(lang.code);
	        }
	        else {
	            this.$translate.preferredLanguage(DEFAULT_LANGUAGE_CODE);
	            this.$translate.use(DEFAULT_LANGUAGE_CODE);
	        }
	        ;
	    };
	    TranslateService.prototype.createLanguageOptions = function () {
	        var langs = localStorage_service_1.LocalStorageService.get(LANGUAGE_SUPPORTED);
	        this.$rootScope.language.supported = langs;
	        for (var i = 0, len = langs.length; i < len; i++) {
	            if (langs[i].code === this.$translate.preferredLanguage()) {
	                this.$rootScope.language.selected = langs[i];
	            }
	            ;
	        }
	        ;
	    };
	    return TranslateService;
	}());
	exports.TranslateService = TranslateService;
	/** @ngInject */
	function TranslateRun(translateService) {
	    translateService.run();
	}
	exports.TranslateRun = TranslateRun;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.endpoint = 'releasenotes';
	var ReleaseNoteService = (function () {
	    /** @ngInject */
	    ReleaseNoteService.$inject = ["Restangular"];
	    function ReleaseNoteService(Restangular) {
	        this.Restangular = Restangular;
	    }
	    ReleaseNoteService.prototype.getReleaseNotes = function () {
	        return this.Restangular.all("" + exports.endpoint).getList();
	    };
	    return ReleaseNoteService;
	}());
	exports.ReleaseNoteService = ReleaseNoteService;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	var AATIS_ENDPOINT = 'aatis_invoice_permits';
	var EAIP_ENDPOINT = 'eaip_requisitions';
	var ExternalDatabaseInputService = (function (_super) {
	    __extends(ExternalDatabaseInputService, _super);
	    /** @ngInject */
	    ExternalDatabaseInputService.$inject = ["Restangular"];
	    function ExternalDatabaseInputService(Restangular) {
	        var _this = _super.call(this, Restangular, null) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            permitNumber: null,
	            reqNumber: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // eaip
	    ExternalDatabaseInputService.prototype.getRequisitionFromEAIP = function (reqNumber) {
	        return this.restangular.one(EAIP_ENDPOINT).get({ 'reqNumber': reqNumber });
	    };
	    // aatis
	    ExternalDatabaseInputService.prototype.getInvoicePermitFromAATIS = function (permitNumber, currencyCode) {
	        return this.restangular.one(AATIS_ENDPOINT).get({ 'permitNumber': permitNumber, 'currencyCode': currencyCode });
	    };
	    return ExternalDatabaseInputService;
	}(crud_service_1.CRUDService));
	exports.ExternalDatabaseInputService = ExternalDatabaseInputService;


/***/ }),
/* 238 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * This is simply a wrapper for window location properties
	 * so it can be injected as a dependency and mocked for
	 * testibility.
	 *
	 * Added because the angularjs wrapper for $window
	 * cannot be used in UsersService since users.html contains
	 * data-export.directive which depp copies the UsersService using
	 * `angular.copy(...)` BUT $window and $scope cannot be
	 * deep copied because of cyclical and self references.
	 *
	 * See https://code.angularjs.org/1.5.3/docs/error/ng/cpws
	 */
	var WindowLocationService = (function () {
	    function WindowLocationService() {
	    }
	    Object.defineProperty(WindowLocationService.prototype, "hash", {
	        get: function () {
	            return window.location.hash;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "host", {
	        get: function () {
	            return window.location.host;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "hostname", {
	        get: function () {
	            return window.location.hostname;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "href", {
	        get: function () {
	            return window.location.href;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "origin", {
	        get: function () {
	            return window.location.origin;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "pathname", {
	        get: function () {
	            return window.location.pathname;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "port", {
	        get: function () {
	            return window.location.port;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "protocol", {
	        get: function () {
	            return window.location.protocol;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(WindowLocationService.prototype, "search", {
	        get: function () {
	            return window.location.search;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WindowLocationService.prototype.assign = function (url) {
	        window.location.assign(url);
	    };
	    WindowLocationService.prototype.reload = function (forcedReload) {
	        window.location.reload(forcedReload);
	    };
	    WindowLocationService.prototype.replace = function (url) {
	        window.location.replace(url);
	    };
	    WindowLocationService.prototype.toString = function () {
	        return window.location.toString();
	    };
	    return WindowLocationService;
	}());
	exports.WindowLocationService = WindowLocationService;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var SysConfigBoolean = (function () {
	    function SysConfigBoolean() {
	    }
	    /** @ngInject */
	    // returns Boolean true or false for system configs in the form 'f' or 't' so that
	    // the boolean evaluation can be used instead of testing against a string
	    SysConfigBoolean.prototype.parse = function (val) {
	        return !/^(?:f(?:alse)?|no?|0+)$/i.test(val) && !!val;
	    };
	    SysConfigBoolean.prototype.parse.$inject = ["val"];
	    ;
	    return SysConfigBoolean;
	}());
	exports.SysConfigBoolean = SysConfigBoolean;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'stats/revenue-projection';
	var RevenueProjectionService = (function (_super) {
	    __extends(RevenueProjectionService, _super);
	    /** @ngInject */
	    RevenueProjectionService.$inject = ["Restangular", "enrouteAirNavigationChargesManagementService"];
	    function RevenueProjectionService(Restangular, enrouteAirNavigationChargesManagementService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            upper_limit: 900,
	            domestic_formula: '',
	            regional_departure_formula: '',
	            regional_arrival_formula: '',
	            regional_overflight_formula: '',
	            international_departure_formula: '',
	            international_arrival_formula: '',
	            international_overflight_formula: '',
	            w_factor_formula: '',
	            domestic_d_factor_formula: '',
	            reg_dep_d_factor_formula: '',
	            reg_arr_d_factor_formula: '',
	            reg_ovr_d_factor_formula: '',
	            int_dep_d_factor_formula: '',
	            int_arr_d_factor_formula: '',
	            int_ovr_d_factor_formula: '',
	            charges_passenger: 0,
	            charges_approach: 0,
	            charges_aerodrome: 0,
	            charges_late_arrival: 0,
	            charges_late_departure: 0,
	            charges_vol_flights: 0,
	            charges_vol_passengers: 0,
	            time_period: 'MONTH',
	            modified_only: 'yes',
	            format: 'PDF'
	        };
	        _this.model = angular.copy(_this._mod);
	        _this.enrouteAirNavigationChargesManagementService = enrouteAirNavigationChargesManagementService;
	        return _this;
	    }
	    RevenueProjectionService.prototype.doGenerate = function (data) {
	        return this.restangular.one("/stats/revenue-projection").withHttpConfig({ responseType: 'arraybuffer' }).customPOST(data);
	    };
	    RevenueProjectionService.prototype.validateSingle = function (data) {
	        return this.restangular.one("/enroute-air-navigation-charges/validate/new").customPOST(data);
	    };
	    RevenueProjectionService.prototype.getFormulas = function (upperLimit) {
	        return this.restangular.one("/enroute-air-navigation-charges/upperlimit").customGET('', { 'upperLimit': upperLimit });
	    };
	    return RevenueProjectionService;
	}(crud_service_1.CRUDService));
	exports.RevenueProjectionService = RevenueProjectionService;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var CustomDate = (function () {
	    /** @ngInject */
	    CustomDate.$inject = ["systemConfigurationService"];
	    function CustomDate(systemConfigurationService) {
	        this.dateStr = system_configuration_constants_1.SysConfigConstants.DATE_FORMAT;
	        this.systemConfigurationService = systemConfigurationService;
	    }
	    CustomDate.prototype.returnDateFormatStr = function (remove) {
	        var dateStr = this.dateStr || 'DATE_RANGE';
	        var dateFormatSys = this.systemConfigurationService.getValueByName(dateStr.toString());
	        var dateFormatSysStr = dateFormatSys || 'yyyy-MMM-dd';
	        if (remove) {
	            return dateFormatSysStr.toString().replace(/(-dd|dd-)/gi, '');
	        }
	        else {
	            return dateFormatSysStr.toString();
	        }
	        ;
	    };
	    return CustomDate;
	}());
	exports.CustomDate = CustomDate;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = '/external-charge-categories';
	var ExternalChargeCategoryService = (function (_super) {
	    __extends(ExternalChargeCategoryService, _super);
	    /** @ngInject */
	    ExternalChargeCategoryService.$inject = ["Restangular"];
	    function ExternalChargeCategoryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = [{
	                id: null,
	                name: null,
	                unique: null
	            }];
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return list of non-aviation charge categories
	     */
	    ExternalChargeCategoryService.prototype.getNonAviationCategories = function () {
	        return this.restangular.one(exports.endpoint + "/non-aviation").get();
	    };
	    return ExternalChargeCategoryService;
	}(crud_service_1.CRUDService));
	exports.ExternalChargeCategoryService = ExternalChargeCategoryService;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'accounts-external-charge-categories';
	var AccountExternalChargeCategoryService = (function (_super) {
	    __extends(AccountExternalChargeCategoryService, _super);
	    /** @ngInject */
	    AccountExternalChargeCategoryService.$inject = ["Restangular"];
	    function AccountExternalChargeCategoryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            account: null,
	            external_charge_category: null,
	            external_system_identifier: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    Object.defineProperty(AccountExternalChargeCategoryService.prototype, "modelOverride", {
	        get: function () { return angular.copy(this._mod); },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    AccountExternalChargeCategoryService.prototype.getByAccountId = function (accountId, externalChargeCategoryId) {
	        var params = {
	            externalChargeCategoryId: externalChargeCategoryId
	        };
	        return this.restangular.one(exports.endpoint + "/for-account/" + accountId).get(params);
	    };
	    return AccountExternalChargeCategoryService;
	}(crud_service_1.CRUDService));
	exports.AccountExternalChargeCategoryService = AccountExternalChargeCategoryService;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// contants
	var server_datetime_contant_1 = __webpack_require__(245);
	var ServerDatetimeService = (function () {
	    /** @ngInject */
	    ServerDatetimeService.$inject = ["$interval", "Restangular"];
	    function ServerDatetimeService($interval, Restangular) {
	        this.$interval = $interval;
	        this.Restangular = Restangular;
	        this.interval = $interval;
	        this.restangular = Restangular;
	    }
	    /**
	     * Initialize server datetime offset service.
	     *
	     * @param endpoint api endpoint to call for current datetime
	     * @param updateDuration duration in milliseconds to refresh offset
	     */
	    ServerDatetimeService.prototype.initialize = function (endpoint, updateDuration, defaultOffset) {
	        var _this = this;
	        if (defaultOffset === void 0) { defaultOffset = 0; }
	        this.endpoint = endpoint;
	        this.offset = defaultOffset;
	        this.updateOffset();
	        this.interval(function () { return _this.updateOffset(); }, updateDuration);
	    };
	    /**
	     * Get the local date of the supplied server date.
	     *
	     * @param serverDatetime server date to conver to local date
	     */
	    ServerDatetimeService.prototype.getLocalDate = function (serverDate) {
	        return moment(serverDate)
	            .subtract(this.offset, server_datetime_contant_1.ServerDatetimeConstant.offsetPercision)
	            .toDate();
	    };
	    /**
	     * Get the server date of supplied date.
	     *
	     * @param localDatetime local date to convert to server date
	     */
	    ServerDatetimeService.prototype.getServerDate = function (localDate) {
	        return moment(localDate)
	            .add(this.offset, server_datetime_contant_1.ServerDatetimeConstant.offsetPercision)
	            .toDate();
	    };
	    /**
	     * Return server date/time
	     * @param endpoint
	     */
	    ServerDatetimeService.prototype.getCurrentDateTime = function (endpoint) {
	        return this.restangular.one(endpoint).get();
	    };
	    /**
	     * Determine date time difference between server time and local time using.
	     *
	     * @param serverDatetime server datetime ISO-8601 value
	     * @param requestDatetime request sent date
	     */
	    ServerDatetimeService.prototype.resolveOffset = function (serverDatetime, requestDatetime) {
	        var local = moment(new Date());
	        var request = moment(requestDatetime);
	        var server = moment(serverDatetime);
	        // adjust for delay in request
	        var delay = local.diff(request, server_datetime_contant_1.ServerDatetimeConstant.offsetPercision) / 2;
	        server.add(delay, server_datetime_contant_1.ServerDatetimeConstant.offsetPercision);
	        // return difference in local time verse server time
	        return server.diff(local, server_datetime_contant_1.ServerDatetimeConstant.offsetPercision);
	    };
	    /**
	     * Update offset from remote server.
	     */
	    ServerDatetimeService.prototype.updateOffset = function () {
	        var _this = this;
	        var requestDatetime = new Date();
	        this.restangular.one(this.endpoint).get()
	            .then(function (response) { return _this.offset = _this.resolveOffset(response, requestDatetime); });
	    };
	    return ServerDatetimeService;
	}());
	exports.ServerDatetimeService = ServerDatetimeService;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ServerDatetimeConstant = (function () {
	    function ServerDatetimeConstant() {
	    }
	    return ServerDatetimeConstant;
	}());
	/**
	 * Precension used to determine difference between
	 * local and server datetime.
	 */
	ServerDatetimeConstant.offsetPercision = 'milliseconds';
	exports.ServerDatetimeConstant = ServerDatetimeConstant;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	* Helper class for common methods and requests used by the self-care portal
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	var SelfCareHelper = (function () {
	    function SelfCareHelper(Restangular, sysConfigBoolean) {
	        this.Restangular = Restangular;
	        this.sysConfigBoolean = sysConfigBoolean;
	        this.restangular = Restangular;
	    }
	    /**
	     * Fetch the system config item from the API
	     *
	     * @param  {string}               name      name of the system config item to look for
	     * @return {string|number|Object}           Returns a string, number, or JSON
	     */
	    SelfCareHelper.prototype.fetchConfig = function (name) {
	        var _this = this;
	        return this.restangular.one("system-configurations/noauth/getSelfCareSettings").customGET('', { param: name }).then(function (resp) {
	            _this.parseReturn(name, _this.restangular.stripRestangular(resp));
	        });
	    };
	    /**
	     * Format the current value of the system config
	     *
	     * @param  {ISystemConfiguration} resp    the system configuration item to parse
	     */
	    SelfCareHelper.prototype.parseReturn = function (name, resp) {
	        var type = resp[0].data_type.name;
	        var val;
	        if (type === 'boolean') {
	            val = this.sysConfigBoolean.parse(resp[0].current_value);
	        }
	        else {
	            val = resp[0].current_value;
	        }
	        ;
	        localStorage_service_1.LocalStorageService.set(name, val);
	    };
	    return SelfCareHelper;
	}());
	exports.SelfCareHelper = SelfCareHelper;
	SelfCareHelper.$inject = ['Restangular', 'sysConfigBoolean'];


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DownloadService = (function () {
	    function DownloadService($sce) {
	        this.$sce = $sce;
	    }
	    DownloadService.prototype.getPreview = function (resp) {
	        var headers = resp.headers();
	        var contentType = headers['content-type'];
	        var blob = new Blob([resp.data], { type: contentType });
	        var objectUrl = URL.createObjectURL(blob);
	        var iframe = "<iframe src=\"" + objectUrl + "\" style=\"width: 100%; height: 800px;\"></iframe>";
	        return this.$sce.trustAsHtml(iframe);
	    };
	    DownloadService.prototype.getDownload = function (resp) {
	        var headers = resp.headers();
	        var contentType = headers['content-type'];
	        var disposition = headers['content-disposition'];
	        var blob = new Blob([resp.data], { type: contentType });
	        var filename;
	        // removes superfluous part of filename
	        if (disposition && disposition.indexOf('attachment') !== -1) {
	            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
	            var matches = filenameRegex.exec(disposition);
	            if (matches !== null && matches[1]) {
	                filename = matches[1].replace(/['"]/g, '');
	            }
	        }
	        // check for Microsoft specific download, or regular download
	        if (navigator.msSaveBlob) {
	            window.navigator.msSaveBlob(blob, filename);
	        }
	        else {
	            var downloadLink = angular.element('<a></a>');
	            downloadLink.attr('href', window.URL.createObjectURL(blob));
	            downloadLink.attr('download', filename);
	            downloadLink[0].click();
	        }
	    };
	    ;
	    return DownloadService;
	}());
	exports.DownloadService = DownloadService;
	DownloadService.$inject = ['$sce'];


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	// endpoint
	exports.endpoint = 'flightmovement-categories';
	var FlightMovementCategoryService = (function (_super) {
	    __extends(FlightMovementCategoryService, _super);
	    /** @ngInject */
	    FlightMovementCategoryService.$inject = ["Restangular"];
	    function FlightMovementCategoryService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            name: null,
	            sort_order: null,
	            short_name: null,
	            enroute_currency_calculated: null,
	            enroute_currency_invoice: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Return all flight movement categories except OTHER
	     */
	    FlightMovementCategoryService.prototype.getFlightMovementCategoryForAviationInvoice = function () {
	        return this.restangular.one(exports.endpoint + "/aviation-invoice").get();
	    };
	    return FlightMovementCategoryService;
	}(crud_service_1.CRUDService));
	exports.FlightMovementCategoryService = FlightMovementCategoryService;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'flight-reassignments';
	var FlightReassignmentService = (function (_super) {
	    __extends(FlightReassignmentService, _super);
	    /** @ngInject */
	    FlightReassignmentService.$inject = ["Restangular"];
	    function FlightReassignmentService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            applies_to_type_arrival: false,
	            applies_to_type_departure: false,
	            applies_to_type_domestic: false,
	            applies_to_type_overflight: false,
	            applies_to_scope_domestic: false,
	            applies_to_scope_regional: false,
	            applies_to_scope_international: false,
	            applies_to_nationality_national: false,
	            applies_to_nationality_foreign: false,
	            identification_type: null,
	            identifier_text: null,
	            aerodrome_identifiers: [],
	            start_date: null,
	            end_date: null,
	            account: null,
	            previous_accounts: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    return FlightReassignmentService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.FlightReassignmentService = FlightReassignmentService;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var organization_constants_1 = __webpack_require__(57);
	var system_configuration_constants_1 = __webpack_require__(10);
	var OrganizationService = (function () {
	    /** @ngInject */
	    OrganizationService.$inject = ["systemConfigurationService"];
	    function OrganizationService(systemConfigurationService) {
	        this.systemConfigurationService = systemConfigurationService;
	    }
	    /**
	     * Retrieve active organization flags from systom configuration settings.
	     */
	    OrganizationService.prototype.active = function () {
	        // define active organization result and set all to false
	        var result = {
	            isCaab: false,
	            isDcAnsp: false,
	            isEana: false,
	            isInac: false,
	            isKcaa: false,
	            isZacl: false,
	            isTTCAA: false
	        };
	        // set active organization flag from system configuration settings, only ever one
	        switch (this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ORGANIZATION)) {
	            case organization_constants_1.OrganizationName.CAAB:
	                result.isCaab = true;
	                break;
	            case organization_constants_1.OrganizationName.DC_ANSP:
	                result.isDcAnsp = true;
	                break;
	            case organization_constants_1.OrganizationName.EANA:
	                result.isEana = true;
	                break;
	            case organization_constants_1.OrganizationName.INAC:
	                result.isInac = true;
	                break;
	            case organization_constants_1.OrganizationName.KCAA:
	                result.isKcaa = true;
	                break;
	            case organization_constants_1.OrganizationName.ZACL:
	                result.isZacl = true;
	                break;
	            case organization_constants_1.OrganizationName.TTCAA:
	                result.isTTCAA = true;
	                break;
	            default:
	        }
	        return result;
	    };
	    return OrganizationService;
	}());
	exports.OrganizationService = OrganizationService;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'bank-accounts';
	var BankAccountManagementService = (function (_super) {
	    __extends(BankAccountManagementService, _super);
	    /** @ngInject */
	    BankAccountManagementService.$inject = ["Restangular"];
	    function BankAccountManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            name: null,
	            number: null,
	            version: 0,
	            currency: null,
	            external_accounting_system_id: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Get list of all bank accounts.
	     */
	    BankAccountManagementService.prototype.getList = function () {
	        return this.restangular.all(exports.endpoint + "/list").getList();
	    };
	    /**
	     * Get bank account support.
	     */
	    BankAccountManagementService.prototype.getIsSupported = function () {
	        return this.restangular.one(exports.endpoint + "/is-supported").get();
	    };
	    /**
	     * Format bank account as label, `name (number)`.
	     *
	     * @param bankAccount bank acount into to use
	     */
	    BankAccountManagementService.prototype.getLabel = function (name, number) {
	        return name && number
	            ? name + " (" + number + ")"
	            : name || number || '';
	    };
	    return BankAccountManagementService;
	}(crud_service_1.CRUDService));
	exports.BankAccountManagementService = BankAccountManagementService;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var RecaptchaService = (function () {
	    /** @ngInject */
	    RecaptchaService.$inject = ["vcRecaptchaService", "Restangular"];
	    function RecaptchaService(vcRecaptchaService, Restangular) {
	        this.vcRecaptchaService = vcRecaptchaService;
	        this.Restangular = Restangular;
	        /**
	         * Google reCAPTCHA public key used for all captcha validation.
	         */
	        this._publicKey = null;
	    }
	    /**
	     * Wrapper for recaptcha service implemntation to reload widget when expired.
	     *
	     * @param widgetId widget id to reload
	     */
	    RecaptchaService.prototype.reload = function (widgetId) {
	        this.vcRecaptchaService.reload(widgetId);
	    };
	    /**
	     * Retreives the reCAPTCHA public key from the provided enpoint
	     * and updates publicKey value.
	     *
	     * @param endpoint url of reCATPCHA public key
	     */
	    RecaptchaService.prototype.updatePublishKey = function (endpoint) {
	        var _this = this;
	        this.Restangular.one(endpoint).get()
	            .then(function (response) { return _this.publicKey = typeof response !== 'undefined' && response.value
	            ? response.value : null; })
	            .catch(function (response) { return console.warn("Could not retreive reCAPTCHA public key at " + endpoint + ": " + response); });
	    };
	    Object.defineProperty(RecaptchaService.prototype, "publicKey", {
	        get: function () {
	            return this._publicKey;
	        },
	        set: function (value) {
	            this._publicKey = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return RecaptchaService;
	}());
	exports.RecaptchaService = RecaptchaService;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'unified-taxes';
	exports.endpointCharges = 'unified-tax-charges';
	var UnifiedTaxManagementService = (function (_super) {
	    __extends(UnifiedTaxManagementService, _super);
	    /** @ngInject */
	    UnifiedTaxManagementService.$inject = ["Restangular"];
	    function UnifiedTaxManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            from_manufacture_year: null,
	            to_manufacture_year: null,
	            charge_formula: null,
	            validity: null,
	            requireExternalSystemId: null,
	            w_factor_formula: null,
	            unified_tax_formulas: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Get list of all unified TAx.
	     */
	    UnifiedTaxManagementService.prototype.getList = function () {
	        return this.restangular.all(exports.endpoint + "/list").getList();
	    };
	    UnifiedTaxManagementService.prototype.getListByValidityId = function (validityId) {
	        var taxList = this.restangular.all(exports.endpoint + "/validity/" + validityId + "/list").getList();
	        return taxList;
	    };
	    UnifiedTaxManagementService.prototype.getUnifiedTaxChargesByAircraftRegistationNumberAndBillingLedgerdId = function (aircraftRegistrationId, billingLedgerdId) {
	        return this.restangular.one(exports.endpointCharges + "/getUnifiedTaxChargesByAircraftRegistrationIdAndBillingLedgerId/" + aircraftRegistrationId + "/" + billingLedgerdId).get();
	    };
	    // validates formulas, returning which formulas are invalid and why
	    UnifiedTaxManagementService.prototype.validate = function (unifiedTaxCharge) {
	        var copy = angular.copy(unifiedTaxCharge); // copy of object sends to back end with id = null because back end doesn't accept id when updating
	        copy.id = null;
	        return this.restangular.all(exports.endpoint + "/validate").customPOST(copy);
	    };
	    return UnifiedTaxManagementService;
	}(crud_service_1.CRUDService));
	exports.UnifiedTaxManagementService = UnifiedTaxManagementService;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'unified-tax-validities';
	var UnifiedTaxValidityManagementService = (function (_super) {
	    __extends(UnifiedTaxValidityManagementService, _super);
	    /** @ngInject */
	    UnifiedTaxValidityManagementService.$inject = ["Restangular"];
	    function UnifiedTaxValidityManagementService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            id: null,
	            from_validity_year: null,
	            to_validity_year: null,
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    /**
	     * Get list of all unified TAx.
	     */
	    UnifiedTaxValidityManagementService.prototype.getList = function () {
	        return this.restangular.all(exports.endpoint + "/list").getList();
	    };
	    return UnifiedTaxValidityManagementService;
	}(crud_service_1.CRUDService));
	exports.UnifiedTaxValidityManagementService = UnifiedTaxValidityManagementService;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var crud_service_1 = __webpack_require__(8);
	exports.endpoint = 'providers';
	var SSOProvidersService = (function (_super) {
	    __extends(SSOProvidersService, _super);
	    /** @ngInject */
	    SSOProvidersService.$inject = ["Restangular", "$location", "windowLocationService", "oAuthService"];
	    function SSOProvidersService(Restangular, $location, windowLocationService, oAuthService) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this.$location = $location;
	        _this.windowLocationService = windowLocationService;
	        _this.oAuthService = oAuthService;
	        _this.providerModel = {
	            /** COMMON PROPERTIES */
	            id: null,
	            uuid: null,
	            type: null,
	            name: null,
	            client_id: null,
	            client_secret: null,
	            success_url: null,
	            failure_url: null,
	            perform_provider_logout: false,
	            tenant: null,
	            post_logout_url: null,
	            active: false,
	            link_url: false,
	            /** KEYCLOACK PROPERTIES. */
	            base_url: null,
	            ignore_SSL: false,
	            realm: null
	        };
	        _this.model = angular.copy(_this.providerModel);
	        return _this;
	    }
	    SSOProvidersService.prototype.getSSOProviders = function () {
	        return this.restangular.one("" + exports.endpoint).get();
	    };
	    SSOProvidersService.prototype.hasProviderConfig = function () {
	        return this.restangular.one(exports.endpoint + "/hasAuthProviderConfig").get();
	    };
	    return SSOProvidersService;
	}(crud_service_1.CRUDService));
	exports.SSOProvidersService = SSOProvidersService;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	// service
	var crud_file_handler_service_1 = __webpack_require__(146);
	exports.endpoint = 'aodb-flights';
	var AodbService = (function (_super) {
	    __extends(AodbService, _super);
	    /** @ngInject */
	    AodbService.$inject = ["Restangular"];
	    function AodbService(Restangular) {
	        var _this = _super.call(this, Restangular, exports.endpoint) || this;
	        _this.Restangular = Restangular;
	        _this._mod = {
	            callsign: null,
	            toa: null,
	            reg: null,
	            mtow: null,
	            airline: null,
	            ad: null,
	            atd: null,
	            da: null,
	            ata: null,
	            remark: null,
	            runway_date_time: null
	        };
	        _this.model = angular.copy(_this._mod);
	        return _this;
	    }
	    // this has to be done because if filters are used, it is a different endpoint
	    AodbService.prototype.list = function (params, queryString) {
	        var _this = this;
	        if (params &&
	            (typeof params.search !== 'undefined' || (typeof params.start !== 'undefined' && typeof params.end !== 'undefined'))) {
	            if (params.search === '') {
	                delete params.search;
	            }
	            //this.endpoint = `${endpoint}/filters`; // to use filters, it is a different URL endpoint
	        }
	        return _super.prototype.list.call(this, params, queryString)
	            .then(function (data) { _this.endpoint = exports.endpoint; return data; })
	            .catch(function () { return _this.endpoint = exports.endpoint; }); // always revert endpoint
	    };
	    return AodbService;
	}(crud_file_handler_service_1.CRUDFileUploadService));
	exports.AodbService = AodbService;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// directives
	var headerBar_directive_1 = __webpack_require__(258);
	var sideBar_directive_1 = __webpack_require__(259);
	var boxHeader_directive_1 = __webpack_require__(260);
	var download_directive_1 = __webpack_require__(262);
	var dynamicChart_directive_1 = __webpack_require__(263);
	var footer_directive_1 = __webpack_require__(264);
	var dateRange_directive_1 = __webpack_require__(265);
	var notImplemented_directive_1 = __webpack_require__(266); // upon completion of this project, this can be removed
	var password_directive_1 = __webpack_require__(267);
	var title_directive_1 = __webpack_require__(268);
	var tableSort_directive_1 = __webpack_require__(269);
	var datePicker_directive_1 = __webpack_require__(270);
	var errorHandling_directive_1 = __webpack_require__(271);
	var input_directive_1 = __webpack_require__(272);
	var select_directive_1 = __webpack_require__(273);
	var popup_directive_1 = __webpack_require__(274);
	var dynamicServiceDropdown_directive_1 = __webpack_require__(275);
	var download_oauth2_directive_1 = __webpack_require__(276);
	var preview_oauth2_directive_1 = __webpack_require__(278);
	var export_table_directive_1 = __webpack_require__(279);
	var export_pdf_directive_1 = __webpack_require__(281);
	var modalMovable_directive_1 = __webpack_require__(282);
	var flight_movement_form_directive_1 = __webpack_require__(283);
	var flight_movement_table_directive_1 = __webpack_require__(284);
	var upload_feedback_directive_1 = __webpack_require__(285);
	var line_items_table_directive_1 = __webpack_require__(286);
	var payment_directive_1 = __webpack_require__(287);
	var multiselect_directive_1 = __webpack_require__(289);
	var onlyNumbers_directive_1 = __webpack_require__(290);
	var onlyLetters_directive_1 = __webpack_require__(291);
	var emptyToNull_directive_1 = __webpack_require__(292);
	var convertToTons_directive_1 = __webpack_require__(293);
	var convertCoordinates_directive_1 = __webpack_require__(294);
	var rejected_records_directive_1 = __webpack_require__(295);
	var aerodromeIdentifiers_directive_1 = __webpack_require__(296);
	var unitConversionInput_directive_1 = __webpack_require__(297);
	var unitConverter_directive_1 = __webpack_require__(298);
	var copyToClipboard_directive_1 = __webpack_require__(299);
	var system_configuration_item_directive_1 = __webpack_require__(300);
	var boolean_text_directive_1 = __webpack_require__(301);
	var recaptcha_directive_1 = __webpack_require__(302);
	var external_database_input_directive_1 = __webpack_require__(303);
	var pagination_display_directive_1 = __webpack_require__(304);
	var uploadFileFormat_directive_1 = __webpack_require__(305);
	var uppercase_input_directive_1 = __webpack_require__(306);
	var summary_upload_directive_1 = __webpack_require__(307);
	// directive module
	exports.default = angular.module('armsWeb.directives', [])
	    .directive('headerBar', headerBar_directive_1.headerBar)
	    .directive('sideBar', sideBar_directive_1.sideBar)
	    .directive('sideBarCategory', sideBar_directive_1.sideBarCategory)
	    .directive('sideBarLink', sideBar_directive_1.sideBarLink)
	    .directive('boxHeader', boxHeader_directive_1.boxHeader)
	    .directive('download', download_directive_1.download)
	    .directive('dynamicChart', dynamicChart_directive_1.dynamicChart)
	    .directive('footer', footer_directive_1.footer)
	    .directive('dateRange', dateRange_directive_1.dateRange)
	    .directive('notImplemented', notImplemented_directive_1.notImplemented)
	    .directive('password', password_directive_1.password)
	    .directive('title', title_directive_1.title)
	    .directive('tableSort', tableSort_directive_1.tableSort)
	    .directive('sort', tableSort_directive_1.tableSortItem)
	    .directive('datePicker', datePicker_directive_1.datePicker)
	    .directive('errorHandling', errorHandling_directive_1.errorHandling)
	    .directive('input', input_directive_1.input)
	    .directive('select', select_directive_1.select)
	    .directive('popup', popup_directive_1.popup)
	    .directive('dynamicServiceDropdown', dynamicServiceDropdown_directive_1.dynamicServiceDropdown)
	    .directive('downloadOauth2', download_oauth2_directive_1.downloadOauth2)
	    .directive('previewOauth2', preview_oauth2_directive_1.previewOauth2)
	    .directive('exportTable', export_table_directive_1.exportTable)
	    .directive('exportPdf', export_pdf_directive_1.exportPdf)
	    .directive('modalMovable', modalMovable_directive_1.modalMovable)
	    .directive('flightMovementForm', flight_movement_form_directive_1.flightMovementForm)
	    .directive('flightMovementTable', flight_movement_table_directive_1.flightMovementTable)
	    .directive('uploadFeedback', upload_feedback_directive_1.uploadFeedback)
	    .directive('lineItemsTable', line_items_table_directive_1.lineItemsTable)
	    .directive('payment', payment_directive_1.payment)
	    .directive('multiselect', multiselect_directive_1.multiselect)
	    .directive('onlyNumbers', onlyNumbers_directive_1.onlyNumbers)
	    .directive('onlyLetters', onlyLetters_directive_1.onlyLetters)
	    .directive('emptyToNull', emptyToNull_directive_1.emptyToNull)
	    .directive('convertToTons', convertToTons_directive_1.convertToTons)
	    .directive('convertCoordinates', convertCoordinates_directive_1.convertCoordinates)
	    .directive('rejectedRecords', rejected_records_directive_1.rejectedRecords)
	    .directive('aerodromeIdentifiers', aerodromeIdentifiers_directive_1.aerodromeIdentifiers)
	    .directive('unitConversionInput', unitConversionInput_directive_1.unitConversionInput)
	    .directive('unitConverter', unitConverter_directive_1.unitConverter)
	    .directive('copyToClipboard', copyToClipboard_directive_1.copyToClipboard)
	    .directive('systemConfigurationItem', system_configuration_item_directive_1.systemConfigurationItem)
	    .directive('booleanText', boolean_text_directive_1.booleanText)
	    .directive('recaptcha', recaptcha_directive_1.recaptcha)
	    .directive('externalDatabaseInput', external_database_input_directive_1.externalDatabaseInput)
	    .directive('paginationDisplay', pagination_display_directive_1.paginationDisplay)
	    .directive('uploadFileFormat', uploadFileFormat_directive_1.uploadFileFormat)
	    .directive('uppercaseInput', uppercase_input_directive_1.uppercaseInput)
	    .directive('summaryUpload', summary_upload_directive_1.summaryUpload);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	/** @ngInject */
	function headerBar() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/headerBar/headerBar.html',
	        controller: HeaderBarController,
	        controllerAs: 'HeaderBar',
	        bindToController: true,
	        replace: true,
	        transclude: true
	    };
	}
	exports.headerBar = headerBar;
	/** @ngInject */
	var HeaderBarController = (function () {
	    HeaderBarController.$inject = ["$rootScope", "$scope", "$location", "windowLocationService", "localeSwitcherService", "oAuthService", "amhsConnectionService", "$interval", "aviationBillingEngineService", "serverDatetimeService", "$timeout", "saveLocalTemplateService", "$uibModal", "systemConfigurationService"];
	    function HeaderBarController($rootScope, $scope, $location, windowLocationService, localeSwitcherService, oAuthService, amhsConnectionService, $interval, aviationBillingEngineService, serverDatetimeService, $timeout, saveLocalTemplateService, $uibModal, systemConfigurationService) {
	        var _this = this;
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$location = $location;
	        this.windowLocationService = windowLocationService;
	        this.localeSwitcherService = localeSwitcherService;
	        this.oAuthService = oAuthService;
	        this.amhsConnectionService = amhsConnectionService;
	        this.$interval = $interval;
	        this.aviationBillingEngineService = aviationBillingEngineService;
	        this.serverDatetimeService = serverDatetimeService;
	        this.saveLocalTemplateService = saveLocalTemplateService;
	        this.systemConfigurationService = systemConfigurationService;
	        $scope.toggleSideBar = function () { return $scope.$broadcast('toggleSideBar'); };
	        $scope.changeMode = function (mode) { return _this.changeMode(mode); };
	        $scope.$on('userChanged', function (e, user) { return $scope.user = user; });
	        $scope.onButtonGroupClick = function ($event) { return _this.onButtonGroupClick($event); };
	        $scope.logout = function () { return _this.oAuthService.logout(true); };
	        $scope.changeLanguage = function (lang) { return _this.localeSwitcherService.changeLanguage(lang); };
	        $scope.getLastOperation = function () { return _this.getLastOperation(); };
	        $scope.modal = $uibModal;
	        $scope.openModal = function () { return _this.openModal(); };
	        $scope.isSelfCare = this.$location.path().startsWith('/sc-') || this.windowLocationService.pathname.endsWith('/selfcare/');
	        console.log('isSelfCare: ', $scope.isSelfCare);
	        $scope.mode = localStorage_service_1.LocalStorageService.get('contentMode') ? localStorage_service_1.LocalStorageService.get('contentMode') : 'content-mode';
	        $scope.language = $rootScope.language;
	        $scope.previousData = this.aviationBillingEngineService.getStatusForSpecificReconciliationForHeaderBar()
	            .then(function (response) {
	            _this.$scope.listOperations = response;
	        });
	        $scope.toggleDropdown = function () {
	            if (!$rootScope.isIconDisabled) {
	                $scope.openDropdown2 = !$scope.openDropdown2;
	            }
	        };
	        $scope.stopBlinking = function () {
	            $rootScope.isBlinking = false;
	        };
	        $rootScope.isIconDisabled = false;
	        $scope.disableIcon = function () {
	            if ($rootScope.isIconDisabled === true)
	                $rootScope.isIconDisabled = false;
	            else
	                $rootScope.isIconDisabled = true;
	            $scope.openDropdown2 = false; // Chiude il dropdown
	        };
	        $scope.stateHistory = {}; // Memorizza la storia degli stati per ciascun job
	        $scope.getFlightIdsAsString = function (job_parameters) {
	            var match = job_parameters.match(/flightId=\[([^\]]+)\]/);
	            if (match) {
	                return match[1].split(',').map(function (id) { return id.trim(); }).join(', ');
	            }
	            return '';
	        };
	        if (!$scope.isSelfCare) {
	            $interval(getAgentStatus, 15000);
	        }
	        function getAgentStatus() {
	            amhsConnectionService.agentStatus()
	                .then(function (response) {
	                $scope.agent_status = response;
	            })
	                .catch(function (error) {
	                console.log('Error in AMHS AGENT');
	            });
	        }
	        /* const updateAgentStatus = (newData) => {
	           newData.forEach((newItem, index) => {
	             const previousItem = $scope.previousData[index];
	             if (previousItem && previousItem.job_execution_status === 'STARTED' && newItem.job_execution_status === 'COMPLETED') {
	               console.log('Status changed from STARTED to COMPLETED');
	     
	               $rootScope.isBlinking = true;
	               $scope.previousData[index] = {}; // Reset previousItem
	               newData[index] = {}; // Reset newItem
	             }
	           });
	     
	           // Aggiorna previousData con i nuovi dati
	           $scope.previousData = newData.map(item => ({ ...item }));
	         }; */
	        var getNotified = function () {
	            aviationBillingEngineService.getStatusForSpecificReconciliationForHeaderBar()
	                .then(function (response) {
	                var newData = response;
	                if (newData.length > 0) {
	                    var jobId = newData[0].id;
	                    if (!$scope.stateHistory[jobId]) {
	                        $scope.stateHistory[jobId] = [];
	                    }
	                    var previousState = $scope.stateHistory[jobId].slice(-1)[0];
	                    var currentState = newData[0].job_execution_status;
	                    $scope.stateHistory[jobId].push(currentState);
	                    // Check for state change from STARTED to COMPLETED
	                    if (previousState === 'STARTED' && currentState === 'COMPLETED') {
	                        $rootScope.isBlinking = true;
	                        $rootScope.isIconDisabled = false; // Abilita l'icona
	                    }
	                    else {
	                        $rootScope.isIconDisabled = true; // Disabilita l'icona
	                    }
	                }
	            })
	                .catch(function (error) {
	                console.log(error);
	            });
	        };
	        var startPolling = function () {
	            $interval(getNotified, 5000); // Poll ogni 5 secondi
	        };
	        $scope.$on('$viewContentLoaded', function () {
	            startPolling(); // Inizia il polling quando la vista è caricata
	        });
	        $rootScope.$watch('language', function () {
	            $scope.language = $rootScope.language;
	        });
	        $scope.$emit('headerBarCreatedEvent', true);
	        $scope.logoName = '';
	        $scope.logoUrl = "assets/images/logo.png"; // Logo di default
	        this.logoOrganisation();
	        window.addEventListener('storage', function (event) {
	            $scope.logoUrl = localStorage_service_1.LocalStorageService.get('logoUrl');
	        });
	    }
	    HeaderBarController.prototype.changeMode = function (mode) {
	        this.$scope.mode = mode;
	        this.$rootScope.$broadcast('contentModeChange', mode);
	    };
	    HeaderBarController.prototype.onButtonGroupClick = function ($event) {
	        $event.stopPropagation();
	        var clickedElement = $event.target || $event.srcElement;
	        var alreadyActive = clickedElement.parentElement.querySelector('.active');
	        if (alreadyActive) {
	            alreadyActive.classList.remove('active');
	        }
	        clickedElement.classList.add('active');
	    };
	    HeaderBarController.prototype.getLastOperation = function () {
	        var _this = this;
	        this.aviationBillingEngineService.getStatusForSpecificReconciliationForHeaderBar()
	            .then(function (response) {
	            _this.$scope.listOperations = response;
	        })
	            .catch(function (error) {
	            console.log(error);
	        });
	    };
	    HeaderBarController.prototype.openModal = function () {
	        var _this = this;
	        var modalContent = angular.element(document.querySelector('.modal-content'));
	        var modal = angular.element(document.querySelector('.modal-movable'));
	        if (modalContent.length > 0 && modal.length > 0) {
	            modal.css('height', modalContent[0].offsetHeight + 'px');
	        }
	        setTimeout(function () {
	            _this.$scope.modal.open({
	                templateUrl: 'app/angular-ids-project/src/components/headerBar/jobs.template.html',
	                controller: HeaderBarController,
	                windowClass: 'app-modal-window',
	                scope: _this.$scope,
	                appendTo: angular.element(document.querySelector('#last-operations-modal-holder'))
	            });
	        }, 140);
	    };
	    HeaderBarController.prototype.logoOrganisation = function () {
	        var _this = this;
	        var storedLogoUrl = localStorage_service_1.LocalStorageService.get('logoUrl');
	        var storedLogoName = localStorage_service_1.LocalStorageService.get('logoName');
	        if (storedLogoUrl) {
	            this.$scope.logoUrl = storedLogoUrl;
	            this.$scope.logoName = storedLogoName;
	        }
	        else {
	            this.systemConfigurationService.getLogoOrganisation()
	                .then(function (item) {
	                if (item) {
	                    _this.$scope.logoUrl = _this.systemConfigurationService.initImage(item);
	                    _this.$scope.$applyAsync();
	                }
	            })
	                .catch(function (err) {
	                console.error("Errore nel recupero del logo:", err);
	            });
	        }
	    };
	    ;
	    return HeaderBarController;
	}());
	exports.HeaderBarController = HeaderBarController;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/**
	 * Side bar (parent)
	 */
	/** @ngInject */
	function sideBar() {
	    return {
	        restrict: 'E',
	        template: '<div ng-class="{\'show\': toggle }"><ul ng-transclude> </ul></div>',
	        controller: SideBarController,
	        controllerAs: 'SideBar',
	        bindToController: true,
	        replace: true,
	        transclude: true,
	        scope: {}
	    };
	}
	exports.sideBar = sideBar;
	/** @ngInject */
	var SideBarController = (function () {
	    SideBarController.$inject = ["$scope"];
	    function SideBarController($scope) {
	        this.$scope = $scope;
	        $scope.$on('toggleSideBar', function (e, open) {
	            $scope.toggle = typeof open === 'boolean' ? open : !$scope.toggle; // if open is sent
	        });
	        /**
	         * On State change, the sidebar will broadcast what the state is changing to and try and highlight the correct link
	         * @param linkToHighlight
	         */
	        $scope.$on('$stateChangeStart', function (event, toState) {
	            $scope.highlight(toState);
	        });
	        $scope.highlight = function (stateToHighlight) {
	            $scope.$broadcast('sideBarLink.highlight', stateToHighlight);
	        };
	    }
	    return SideBarController;
	}());
	exports.SideBarController = SideBarController;
	/**
	 * Side bar category
	 */
	/** @ngInject */
	function sideBarCategory() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/sideBar/sideBarCategory.html',
	        controller: SideBarCategory,
	        controllerAs: 'SideBarCategory',
	        bindToController: true,
	        replace: true,
	        transclude: true,
	        scope: {
	            icon: '=',
	            text: '=',
	            links: '=',
	            categoryOpen: '='
	        }
	    };
	}
	exports.sideBarCategory = sideBarCategory;
	/**
	 * Side bar category
	 */
	/** @ngInject */
	var SideBarCategory = (function () {
	    SideBarCategory.$inject = ["$scope", "$state", "$translate"];
	    function SideBarCategory($scope, $state, $translate) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$translate = $translate;
	        // translate link category for search
	        if (localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_ENABLED) === system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_TRUE) {
	            $scope.SideBarCategory.links.map(function (link) { return link.filterableText = $translate.instant(link.category); });
	        }
	        // this is used for initial launch of the app, will highlight on load
	        this.highlight($state.current, this.links);
	        // listen for state changes and highlight if active
	        $scope.$on('sideBarLink.highlight', function (e, state) {
	            _this.highlight(state, _this.links);
	        });
	    }
	    /**
	     * Set active value based on provided state.
	     *
	     * @param state angular ui router state
	     * @param links category links
	     */
	    SideBarCategory.prototype.highlight = function (state, links) {
	        // loop through each link and set active true if one matches the state provided
	        this.active = links.some(function (link) {
	            return highlight(state, link);
	        });
	    };
	    return SideBarCategory;
	}());
	exports.SideBarCategory = SideBarCategory;
	/**
	 * Side bar link (child)
	 */
	/** @ngInject */
	function sideBarLink() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/sideBar/sideBarLink.html',
	        controller: SideBarLink,
	        controllerAs: 'SideBarLink',
	        bindToController: true,
	        replace: true,
	        transclude: true,
	        scope: {
	            icon: '=',
	            uiSref: '=',
	            url: '=',
	            category: '@'
	        }
	    };
	}
	exports.sideBarLink = sideBarLink;
	/** @ngInject */
	var SideBarLink = (function () {
	    SideBarLink.$inject = ["$scope", "$state", "oAuthService"];
	    function SideBarLink($scope, $state, oAuthService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.oAuthService = oAuthService;
	        // this is used for initial launch of the app, will highlight on load
	        this.highlight($state.current);
	        // listen for state changes and highlight if active
	        this.$scope.$on('sideBarLink.highlight', function (e, state) {
	            _this.highlight(state);
	        });
	    }
	    /**
	     * Change state using `uiSref` or `url` values if set.
	     */
	    SideBarLink.prototype.goTo = function () {
	        if (this.url === 'logout') {
	            this.oAuthService.logout(true);
	        }
	        else if (this.uiSref) {
	            this.$state.go(this.uiSref);
	        }
	        else if (this.url) {
	            this.$state.go('main.' + this.url);
	        }
	    };
	    /**
	     * Set active value based on provided state.
	     *
	     * @param state angular ui router state
	     */
	    SideBarLink.prototype.highlight = function (state) {
	        this.active = highlight(state, { uiSref: this.uiSref, url: this.url });
	    };
	    return SideBarLink;
	}());
	exports.SideBarLink = SideBarLink;
	/**
	 * Return true if provided state matched the provided link.
	 *
	 * @param state angular ui router currrent state
	 * @param link link object containing at least uiSref and url properties
	 */
	function highlight(state, link) {
	    if (link.uiSref) {
	        // standard angular-ui-router approach
	        return state.name === link.uiSref;
	    }
	    else if (link.url) {
	        // custom to match sideBar.ts list of main items -> `$state.go('main.' + itemUrl)`
	        return state.name === 'main.' + link.url;
	    }
	    else {
	        return false;
	    }
	}
	exports.highlight = highlight;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var boxHeader_constant_1 = __webpack_require__(261);
	/** @ngInject */
	function boxHeader() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/boxHeader/boxHeader.html',
	        bindToController: false,
	        scope: {
	            icon: '=',
	            page: '=?',
	            pageName: '@?',
	            toggle: '=?',
	            title: '@',
	            suppressDownload: '@',
	            showClose: '@',
	            closeFunc: '&'
	        },
	        link: function (scope, element, attrs) {
	            scope.toggle = attrs.toggle ? false : null;
	        },
	        controller: BoxHeaderController,
	        replace: true,
	        transclude: true
	    };
	}
	exports.boxHeader = boxHeader;
	/** @ngInject */
	var BoxHeaderController = (function () {
	    BoxHeaderController.$inject = ["$scope", "$rootScope", "$location", "$translate"];
	    function BoxHeaderController($scope, $rootScope, $location, $translate) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$location = $location;
	        this.$translate = $translate;
	        // espose user guide url from page number if page number exists
	        // if no page in scope, parse from user guide using page name
	        $scope.pageUrl = this.getUserGuideUrl($scope.page || this.findUserGuidePageNumber($scope.pageName));
	        $rootScope.$on('$translateChangeSuccess', function () {
	            return $scope.pageUrl = _this.getUserGuideUrl($scope.page || _this.findUserGuidePageNumber($scope.pageName));
	        });
	    }
	    /**
	     * Return user guide location with page number only if page number is not null.
	     *
	     * @param pageNum page number in user guide
	     */
	    BoxHeaderController.prototype.getUserGuideUrl = function (pageNum) {
	        // page number must be provided and defined
	        if (pageNum === undefined || pageNum === null || pageNum <= 0) {
	            return null;
	        }
	        // get base url from location path
	        var baseUrl = this.$location.absUrl().split('#')[0];
	        // set language code from translation service
	        var langCode = this.$translate.use() || 'en';
	        // build user guide url with provided page number reference
	        return "" + baseUrl + boxHeader_constant_1.BoxHeaderConstant.userGuide.location + boxHeader_constant_1.BoxHeaderConstant.userGuide.name + "." + langCode + ".pdf#page=" + pageNum;
	    };
	    /**
	     * Find user guide's page number from provided page name.
	     *
	     * @param pageName page name to find in user guide
	     */
	    BoxHeaderController.prototype.findUserGuidePageNumber = function (pageName) {
	        // return null if page name is undefined as it is required
	        if (pageName === undefined || pageName === null) {
	            return null;
	        }
	        // parse section names from page name, return null if empty
	        var sectionNames = this.parseSectionNames(pageName);
	        if (sectionNames === undefined || sectionNames === null || sectionNames.length === 0) {
	            return null;
	        }
	        // loop through each section name and find appropriate user content section in user guide
	        // will loop until all section names have been parsed OR stop if section could not be found
	        var level = 0;
	        var section = boxHeader_constant_1.BoxHeaderConstant.userGuide;
	        var _loop_1 = function () {
	            // find section name for current level
	            var sectionName = sectionNames[level];
	            // find section in content by section name
	            section = section.content.find(function (section) { return section.name === sectionName; });
	            // increase level for next loop
	            level++;
	        };
	        while (sectionNames[level] && section !== null) {
	            _loop_1();
	        }
	        // return page number from user guide section if found
	        return section !== undefined && section !== null && 'page' in section
	            ? section.page : null;
	    };
	    /**
	     * Parse user guide page name to get list of sections, must be separated by dot ('.').
	     *
	     * @param pageName page name to parse sections from
	     */
	    BoxHeaderController.prototype.parseSectionNames = function (pageName) {
	        // ensure page name is defiend
	        if (pageName === undefined || pageName === null) {
	            return [];
	        }
	        // remove all whitespace and any leading or trailing dots
	        // if string is empty after normalizing, return as it is invalid
	        var sections = pageName.replace(/\s/g, '').replace(/^\.|\.$/g, '');
	        if (sections === undefined || sections === null || sections.length === 0) {
	            return [];
	        }
	        // split sections into array of strings, split on dot value ('.')
	        return sections.split('.');
	    };
	    return BoxHeaderController;
	}());
	exports.BoxHeaderController = BoxHeaderController;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var BoxHeaderConstant = (function () {
	    function BoxHeaderConstant() {
	    }
	    return BoxHeaderConstant;
	}());
	BoxHeaderConstant.userGuide = {
	    date: new Date(2025, 5),
	    location: 'assets/',
	    name: 'guide',
	    notes: 'Update after CAAB, KCAA, INAC, EANA and ZACL releases.',
	    version: '1.5',
	    content: [
	        { identifier: '1', name: 'introduction', page: 24 },
	        { identifier: '2', name: 'overview', page: 28 },
	        { identifier: '5', name: 'arms-introduction', page: 36 },
	        { identifier: '6', name: 'login', page: 47 },
	        { identifier: '7', name: 'billing', page: 49, content: [
	                { identifier: '7.1', name: 'invoice-management', page: 49 },
	                { identifier: '7.2', name: 'transaction-management', page: 55, content: [
	                        { identifier: '5.2.1', name: 'background', page: 55 },
	                        { identifier: '5.2.2', name: 'interface', page: 55 },
	                        { identifier: '5.2.3', name: 'form', page: 58 }
	                    ] },
	                { identifier: '7.3', name: 'pending-transaction-management', page: 59, content: [
	                        { identifier: '7.3.1', name: 'background', page: 59 },
	                        { identifier: '7.3.2', name: 'interface', page: 60 },
	                        { identifier: '7.3.3', name: 'form', page: 61 }
	                    ] },
	                //  { identifier: '7.4', name: 'certificate-management', page: 48 },
	                { identifier: '7.4', name: 'aviation-billing-engine', page: 61 },
	                { identifier: '7.5', name: 'non-aviation-billing-engine', page: 66 },
	                { identifier: '7.6', name: 'point-of-sale-invoice-generation', page: 68 },
	                { identifier: '7.7', name: 'passenger-revenue-reconciliation-kcaa', page: 72 }
	            ] },
	        { identifier: '8', name: 'crco', page: 74, content: [
	                { identifier: '8.1', name: 'crco-connection', page: 74 },
	                { identifier: '8.2', name: 'crco-certificates', page: 76 },
	                { identifier: '8.3', name: 'crco-reporting-responsabilities', page: 77 },
	                { identifier: '8.4', name: 'crco-messages', page: 79 },
	                { identifier: '8.5', name: 'crco-archive', page: 80 },
	                { identifier: '8.6', name: 'crco-claims', page: 81 },
	                { identifier: '8.7', name: 'crco-cor-request', page: 82 },
	            ] },
	        { identifier: '9', name: 'flight-data', page: 84, content: [
	                { identifier: '9.1', name: 'flight-movement-management', page: 84, content: [
	                        { identifier: '9.1.1', name: 'general', page: 84 },
	                        { identifier: '9.1.2', name: 'data-grid-display-interface', page: 85 },
	                        { identifier: '9.1.3', name: 'data-grid-display-form', page: 87 },
	                        { identifier: '9.1.4', name: 'data-grid-functions', page: 91 },
	                        { identifier: '9.1.5', name: 'data-entry-form', page: 92 },
	                        { identifier: '9.1.6', name: 'gis-mapping-form', page: 94 },
	                        { identifier: '9.1.7', name: 'flight-plan-display-form', page: 96 }
	                    ] },
	                { identifier: '9.2', name: 'flight-schedule-management', page: 96 },
	                { identifier: '9.3', name: 'atc-movement-log-management', page: 99 },
	                { identifier: '9.4', name: 'radar-flight-strip-management', page: 102 },
	                { identifier: '9.5', name: 'tower-movement-log-management', page: 105 },
	                { identifier: '9.6', name: 'passenger-service-charge-return-management', page: 108 },
	                { identifier: '9.7', name: 'rejected-item-management', page: 112 },
	            ] },
	        { identifier: '10', name: 'operations', page: 115, content: [
	                { identifier: '10.1', name: 'account-management', page: 115 },
	                { identifier: '10.2', name: 'aircraft-registration-management', page: 121 },
	                { identifier: '10.3', name: 'local-aircraft-registry', page: 124 },
	                { identifier: '10.4', name: 'aircraft-type-management', page: 126 },
	                { identifier: '10.5', name: 'currency-and-exchange-rate-management', page: 128 },
	                { identifier: '10.6', name: 'nominal-route-management', page: 130 },
	                { identifier: '10.7', name: 'unspecified-aircraft-type-management', page: 132 },
	                { identifier: '10.8', name: 'unspecified-departure-and-destination-location-management', page: 133 },
	                { identifier: '10.9', name: 'flight-reassignement', page: 135 },
	                { identifier: '10.10', name: 'recurring-charges', page: 138 },
	            ] },
	        { identifier: '11', name: 'charges-and-formulas', page: 140, content: [
	                { identifier: '11.1', name: 'air-navigation-charges-schedule-managment', page: 140 },
	                { identifier: '11.2', name: 'average-mtow-factor-managment', page: 144 },
	                { identifier: '11.3', name: 'enroute-air-navigation-charge-managment', page: 145 },
	                { identifier: '11.4', name: 'service-charge-catalogue-managment', page: 148 },
	                { identifier: '11.5', name: 'unified-tax-managment', page: 150 },
	                { identifier: '11.6', name: 'utilities-schedule-managment', page: 152 },
	                { identifier: '11.7', name: 'utilities-town-and-village-managment', page: 154 },
	            ] },
	        { identifier: '12', name: 'exemptions', page: 156, content: [
	                { identifier: '12.1', name: 'exempt-account-management', page: 156 },
	                { identifier: '12.2', name: 'exempt-aircraft-type-management', page: 158 },
	                { identifier: '12.3', name: 'exempt-flight-route-management', page: 159 },
	                { identifier: '12.4', name: 'exempt-flight-status-management', page: 162 },
	                { identifier: '12.5', name: 'exempt-aircraft-and-flights-management', page: 165 },
	                { identifier: '12.6', name: 'repositioning-aerodrome-cluster-management', page: 167 },
	                { identifier: '12.7', name: 'aerodrome-service-outage-management', page: 169 }
	            ] },
	        { identifier: '13', name: 'management', page: 172, content: [
	                { identifier: '13.1', name: 'aerodrome-management', page: 173 },
	                { identifier: '13.2', name: 'aerodrome-operational-hours', page: 175 },
	                { identifier: '13.3', name: 'aerodrome-category-management', page: 177 },
	                { identifier: '13.4', name: 'airpsace-management', page: 178, content: [
	                        { identifier: '13.4.1', name: 'background', page: 178 },
	                        { identifier: '13.4.2', name: 'interface', page: 178 },
	                        { identifier: '13.4.3', name: 'form', page: 179 }
	                    ] },
	                { identifier: '13.5', name: 'amhs-connection', page: 180 },
	                { identifier: '13.6', name: 'amhs-accounts', page: 182 },
	                { identifier: '13.7', name: 'application-management', page: 184 },
	                { identifier: '13.8', name: 'banking-account-management', page: 185 },
	                { identifier: '13.9', name: 'interest-rates-management', page: 186 },
	                { identifier: '13.10', name: 'billing-centre-management', page: 189 },
	                { identifier: '13.11', name: 'country-management', page: 191 },
	                { identifier: '13.12', name: 'regional-country-management', page: 192 },
	                { identifier: '13.13', name: 'system-configuration-management', page: 194 },
	                { identifier: '13.14', name: 'transaction-workflow-management', page: 203 },
	                { identifier: '13.15', name: 'cached-event-management', page: 205 },
	                { identifier: '13.16', name: 'plugin-management', page: 206 }
	            ] },
	        { identifier: '14', name: 'data-analysis-and-statistics', page: 208, content: [
	                { identifier: '14.1', name: 'system-summary', page: 208 },
	                { identifier: '14.2', name: 'analysis-and-statistics-air-traffic', page: 209 },
	                { identifier: '14.3', name: 'analysis-and-statistics-revenue', page: 211 },
	                { identifier: '14.4', name: 'report-generation', page: 213 }
	            ] },
	        { identifier: '15', name: 'templates', page: 220, content: [
	                { identifier: '15.1', name: 'invoice-templates', page: 220 },
	                { identifier: '15.2', name: 'report-templates', page: 222 }
	            ] },
	        { identifier: '16', name: 'security', page: 224, content: [
	                { identifier: '16.1', name: 'groups', page: 224 },
	                { identifier: '16.2', name: 'user-event-log', page: 226 },
	                { identifier: '16.3', name: 'users', page: 228 },
	                { identifier: '16.4', name: 'password-change', page: 230 },
	                { identifier: '16.5', name: 'sso-providers', page: 231 },
	            ] },
	        { identifier: '17', name: 'help', page: 233 },
	    ]
	};
	exports.BoxHeaderConstant = BoxHeaderConstant;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function download() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/download/download.html',
	        link: linkFunc,
	        scope: {
	            url: '='
	        },
	        replace: true,
	        transclude: true
	    };
	}
	exports.download = download;
	function linkFunc(scope, elem, attrs, ctrl) {
	    scope.types = ['pdf', 'csv'];
	    scope.notImplementedTypes = typeof attrs.notImplementedTypes !== 'undefined' ? attrs.notImplementedTypes.split(',') : [];
	}


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	"use strict";
	dynamicChart.$inject = ["$timeout"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function dynamicChart($timeout) {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/dynamicChart/dynamicChart.html',
	        controller: (function () {
	            function DynamicChartController() {
	            }
	            return DynamicChartController;
	        }()),
	        controllerAs: 'DynamicChart',
	        bindToController: true,
	        replace: true,
	        scope: {
	            chart: '=',
	            yaxis: '=',
	            yLabel: '='
	        },
	        transclude: true,
	        link: function (scope, elem, attrs) {
	            scope.labelFormat = function (v /*, id: number, i: number, j: number*/) { return v; };
	            scope.tooltipNameFormat = function (n /*, r: number, id: number, index: number*/) { return n; };
	            scope.tooltipTitleFormat = function (x) { return x; };
	            scope.valueFormat = function (v /*, r: number, i: number, index: number*/) { return (v * getScaling()).toFixed(2); };
	            function getScaling() {
	                var scaling = 0;
	                switch (scope.DynamicChart.yaxis.scaling) {
	                    case 'thousands':
	                        scaling = 1000;
	                        break;
	                    case 'millions':
	                        scaling = 1000000;
	                        break;
	                    default: scaling = 1; // does not alter data
	                }
	                return scaling;
	            }
	            // returns the datapoints scaled properly for the chart
	            function returnScaledPoints(datapoints) {
	                for (var point in datapoints) {
	                    if (datapoints.hasOwnProperty(point)) {
	                        for (var data in datapoints[point]) {
	                            if (data !== 'x' && datapoints[point].hasOwnProperty(data)) {
	                                datapoints[point][data] = datapoints[point][data] / getScaling();
	                            }
	                        }
	                    }
	                }
	                return datapoints;
	            }
	            scope.$watch('DynamicChart.chart', function () {
	                if (scope.DynamicChart.chart.datapoints.length === 0) {
	                    return; // this prevents a rendering with no data, saves it from not getting the width correctly
	                }
	                // we create aa datapoints array of objects, reason is because of the two-way binding. careful with changing values
	                var datapoints = [];
	                for (var i = 0; i < scope.DynamicChart.chart.datapoints.length; i++) {
	                    if (typeof datapoints[i] === 'undefined') {
	                        datapoints[i] = {};
	                    }
	                    for (var j in scope.DynamicChart.chart.datapoints[i]) {
	                        if (scope.DynamicChart.chart.datapoints[i].hasOwnProperty(j)) {
	                            datapoints[i][j] = angular.copy(scope.DynamicChart.chart.datapoints[i][j]);
	                        }
	                    }
	                }
	                // because the yaxis is two-way binding, we assign custom variables and build that chart with that
	                var upper = angular.copy(scope.DynamicChart.yaxis.upper);
	                var lower = angular.copy(scope.DynamicChart.yaxis.lower);
	                upper = upper !== null ? (upper / getScaling()) : null;
	                lower = lower !== null ? (lower / getScaling()) : null;
	                datapoints = returnScaledPoints(datapoints); // bind the scope variable
	                scope.chart = '';
	                // this is for analysis only, so if this directive is to be used for other things, this may have to be moved
	                for (var key = 0; key < datapoints.length; key++) {
	                    if (datapoints[key].x.match(/^20\d{2}\-\d{2}\-\d{2}/)) {
	                        datapoints[key].x = datapoints[key].x.substr(0, 10); // removes T00:00:000Z from timestamps
	                    }
	                }
	                scope.datapoints = datapoints;
	                $timeout(function () {
	                    scope.chart = "<c3chart bindto-id=\"chart-timeseries\" label-format-function=\"labelFormat\"  chart-data=\"datapoints\" chart-columns=\"DynamicChart.chart.datacolumns\"\n      chart-x=\"DynamicChart.chart.datax\">\n        <!--<chart-tooltip title-format-function=\"tooltipTitleFormat\" />-->\n        <chart-tooltip label-format-function=\"labelFormat\" />\n        <chart-tooltip value-format-function=\"valueFormat\" />\n        <!--<chart-tooltip name-format-function=\"tooltipNameFormat\" />-->\n        <chart-size chart-height=\"600\" />\n        <chart-axis>\n        <chart-axis-x axis-id=\"x\" axis-type=\"category\" axis-x-format=\"%Y-%m-%d\" />\n        <chart-axis-y axis-id=\"y\"\n      axis-position=\"middle-right\"\n      axis-label=\"" + scope.DynamicChart.yLabel + "\"\n      tick-rotate=\"2\"\n      axis-min=\"" + lower + "\"\n      axis-max=\"" + upper + "\"/>\n        </chart-axis>\n        </c3chart>";
	                }, 0);
	            }, true);
	        }
	    };
	}
	exports.dynamicChart = dynamicChart;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// service, cannot be injected
	var config_service_1 = __webpack_require__(216);
	/** @ngInject */
	function footer() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/footer/footer.html',
	        controller: FooterBarController,
	        controllerAs: 'FooterBarController',
	        bindToController: true,
	        scope: {}
	    };
	}
	exports.footer = footer;
	/** @ngInject */
	var FooterBarController = (function () {
	    FooterBarController.$inject = ["$scope", "$interval", "serverDatetimeService"];
	    function FooterBarController($scope, $interval, serverDatetimeService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$interval = $interval;
	        this.serverDatetimeService = serverDatetimeService;
	        // set initial server time and update every second
	        this.setServerTime();
	        $interval(function () { return _this.setServerTime(); }, 1000);
	        var cfg = new config_service_1.ConfigService();
	        $scope.buildVersion = cfg.get('BUILD_VERSION');
	    }
	    /**
	     * Set server time using server datetime service for current date.
	     */
	    FooterBarController.prototype.setServerTime = function () {
	        this.$scope.serverTime = this.serverDatetimeService.getServerDate(new Date());
	    };
	    return FooterBarController;
	}());
	exports.FooterBarController = FooterBarController;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * startEndAdjust will convert the start and end dates to the start/end of the month
	 * NOTE: even without this it'll convert start/end date hours/mins/secs to the start/end of the day
	 */
	/** @ngInject */
	function dateRange() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/dateRange/dateRange.html',
	        replace: true,
	        controller: DateRangeController,
	        controllerAs: 'DateRangeController',
	        scope: {
	            control: '=',
	            isRequired: '=',
	            format: '@?',
	            dateOptions: '=?',
	            startEndAdjust: '=?',
	            endName: '@?',
	            startName: '@?'
	        }
	    };
	}
	exports.dateRange = dateRange;
	/** @ngInject */
	var DateRangeController = (function () {
	    DateRangeController.$inject = ["$scope"];
	    function DateRangeController($scope) {
	        var _this = this;
	        this.$scope = $scope;
	        this.dateModel = {
	            open: false,
	            date: null,
	            time: null,
	            minDate: null,
	            maxDate: null
	        };
	        $scope.getUTCStartDate = function () { return _this.getUTCStartDate(); };
	        $scope.getUTCEndDate = function () { return _this.getUTCEndDate(); };
	        $scope.setUTCStartDate = function (dateObject) { return _this.setUTCStartDate(dateObject); };
	        $scope.setUTCEndDate = function (dateObject) { return _this.setUTCEndDate(dateObject); };
	        $scope.dateChanged = function (type, date) { return _this.dateChanged(type, date); };
	        $scope.reset = function () { return _this.reset(); };
	        $scope.dateValidate = function () { return _this.dateValidate(); };
	        $scope.control = $scope;
	        this.reset(); // initial set up
	        $scope.startName = $scope.startName === undefined ? 'Start Date' : $scope.startName;
	        $scope.endName = $scope.endName === undefined ? 'End Date' : $scope.endName;
	    }
	    DateRangeController.prototype.reset = function () {
	        this.$scope.start = angular.copy(this.dateModel);
	        this.$scope.end = angular.copy(this.dateModel);
	        if (this.$scope.dateRangeForm && this.getUTCStartDate() !== undefined && this.getUTCEndDate() !== undefined) {
	            this.$scope.dateRangeForm.$setPristine();
	        }
	    };
	    DateRangeController.prototype.setUTCStartDate = function (date) {
	        if (date.getTime !== undefined) {
	            date = this.convertStartDate(date);
	            this.$scope.start.date = date;
	            this.setEndMinDate(date);
	            this.dateValidate();
	        }
	    };
	    DateRangeController.prototype.setUTCEndDate = function (date) {
	        if (date.getTime !== undefined) {
	            date = this.convertEndDate(date);
	            this.$scope.end.date = date;
	            this.setStartMaxDate(date);
	            this.dateValidate();
	        }
	    };
	    DateRangeController.prototype.getUTCEndDate = function () {
	        return this.$scope.end.date;
	    };
	    DateRangeController.prototype.getUTCStartDate = function () {
	        return this.$scope.start.date;
	    };
	    DateRangeController.prototype.dateValidate = function () {
	        if (this.getUTCStartDate() !== undefined && this.getUTCEndDate() !== undefined) {
	            if (this.getUTCStartDate() > this.getUTCEndDate()) {
	                this.$scope.dateRangeForm.end.$setTouched(); // in case the end date has not been modified since loading, this will allow it to be highlighted
	                this.$scope.dateRangeForm.end.$setDirty(); // in case the end date has not been modified since loading, this will allow it to be highlighted
	                this.$scope.dateRangeForm.end.$setValidity('valid', false);
	            }
	            else {
	                this.$scope.dateRangeForm.end.$setValidity('valid', true);
	            }
	        }
	    };
	    // fires when the datePickers inside are changed manually
	    DateRangeController.prototype.dateChanged = function (type, date) {
	        if (date === undefined || date === null) {
	            return;
	        }
	        switch (type) {
	            case 'start':
	                date = this.convertStartDate(date);
	                this.setUTCStartDate(date);
	                break;
	            case 'end':
	                date = this.convertEndDate(date);
	                this.setUTCEndDate(date);
	                break;
	        }
	    };
	    DateRangeController.prototype.setStartMaxDate = function (date) {
	        this.$scope.start.maxDate = date;
	    };
	    DateRangeController.prototype.setEndMinDate = function (date) {
	        this.$scope.end.minDate = date;
	    };
	    DateRangeController.prototype.convertStartDate = function (date) {
	        if (this.$scope.startEndAdjust) {
	            date.setUTCDate(1);
	        }
	        date.setUTCHours(0);
	        date.setMinutes(0);
	        date.setSeconds(0);
	        return date;
	    };
	    DateRangeController.prototype.convertEndDate = function (date) {
	        if (this.$scope.startEndAdjust) {
	            var lastDate = new Date(date.getUTCFullYear(), date.getUTCMonth() + 1, 0, 23, 59, 59);
	            date.setUTCDate(lastDate.getDate());
	        }
	        date.setUTCHours(23);
	        date.setMinutes(59);
	        date.setSeconds(59);
	        return date;
	    };
	    return DateRangeController;
	}());
	exports.DateRangeController = DateRangeController;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function notImplemented() {
	    return {
	        controller: NotImplementedController,
	        controllerAs: 'NotImplementedController',
	        bindToController: true,
	        restrict: 'A',
	        compile: function () {
	            return {
	                pre: function precompile(scope, element) {
	                    if (angular.isUndefined(element.attr('uib-tooltip'))) {
	                        element.attr('uib-tooltip', 'this has not been implemented yet');
	                        scope.NotImplementedController.$compile(element)(scope);
	                    }
	                }
	            };
	        }
	    };
	}
	exports.notImplemented = notImplemented;
	/** @ngInject */
	var NotImplementedController = (function () {
	    NotImplementedController.$inject = ["$compile"];
	    function NotImplementedController($compile) {
	        this.$compile = $compile;
	        this.$compile = $compile;
	    }
	    return NotImplementedController;
	}());
	exports.NotImplementedController = NotImplementedController;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function password() {
	    return {
	        restrict: 'E',
	        controller: PasswordController,
	        controllerAs: 'PasswordController',
	        templateUrl: 'app/angular-ids-project/src/components/password/password.html',
	        replace: true,
	        scope: {
	            password: '=',
	            required: '=',
	            resetPass: '=',
	            error: '=',
	            name1: '@?',
	            name2: '@?'
	        },
	        require: '^form',
	        link: function (scope, elem, attrs, ngModelCtrl) { return scope.modelCtrl = ngModelCtrl; }
	    };
	}
	exports.password = password;
	/** @ngInject */
	var PasswordController = (function () {
	    PasswordController.$inject = ["$scope", "systemConfigurationService"];
	    function PasswordController($scope, systemConfigurationService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.systemConfigurationService = systemConfigurationService;
	        // set labels for password inputs. Default id 'Password *' and 'Repeat Password *'
	        $scope.name1 = !$scope.name1 ? 'Password *' : $scope.name1;
	        $scope.name2 = !$scope.name2 ? 'Repeat Password *' : $scope.name2;
	        // set password min length value in scope
	        $scope.minLength = parseInt(this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_MINIMUM_LENGTH), 10);
	        // methods used to check passwords on change and blur
	        $scope.checkPasswords = function (password1, password2) { return _this.checkPasswords(password1, password2); };
	        // clears the form fields when a new entry is wanted to be changed or updating an entry
	        $scope.$watchGroup(['required', 'resetPass'], function () { return _this.resetPass(); });
	    }
	    /**
	     * Reset password fields if main password empty, else validate.
	     *
	     * Zero length passwords are handled using a toggle button in
	     * the user view and thus password field validation should be
	     * reset when an empty string.
	     *
	     * @param password1 main password value
	     * @param password2 validation password value
	     */
	    PasswordController.prototype.checkPasswords = function (password1, password2) {
	        // if main password value is empty, assume "clear"
	        // else validate passwords
	        if (!password1 && !this.$scope.required) {
	            // sets password to undefined
	            delete (this.$scope.password);
	            // cleanup password fields and validation flags/messages
	            this.resetPass();
	        }
	        else {
	            this.validatePasswords(password1, password2);
	        }
	    };
	    /**
	     * Check if password values are valid using system configuration settings.
	     *
	     * @param password1 main password value
	     * @param password2 validation password value
	     */
	    PasswordController.prototype.getPasswordValidation = function (password1, password2) {
	        var lowercase = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_LOWERCASE);
	        var minLength = parseInt(this.systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_MINIMUM_LENGTH), 10);
	        var numeric = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_NUMERIC);
	        var special = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_SPECIAL);
	        var uppercase = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.PASSWORD_UPPERCASE);
	        if ((!password1 || !password2) && !this.$scope.required) {
	            return null;
	        }
	        var validation = {
	            required: true,
	            minlength: true,
	            confirm: true,
	            lowercase: true,
	            uppercase: true,
	            numeric: true,
	            special: true
	        };
	        if (!password1) {
	            validation.required = false;
	        }
	        if (password1 && password1.length < minLength) {
	            validation.minlength = false;
	        }
	        if (password1 !== password2) {
	            validation.confirm = false;
	        }
	        if (lowercase && password1 && !password1.match(/[a-z]/)) {
	            validation.lowercase = false;
	        }
	        if (uppercase && password1 && !password1.match(/[A-Z]/)) {
	            validation.uppercase = false;
	        }
	        if (numeric && password1 && !password1.match(/[0-9]/)) {
	            validation.numeric = false;
	        }
	        if (special && password1 && !password1.match(/[\s!"#$%&'\(\)\*\+,\-\.\/:;\<\=\>\?@\[\\\]\^\_\`\{\|\}\~]/)) {
	            validation.special = false;
	        }
	        return validation;
	    };
	    /**
	     * Return true if password validation is valid.
	     *
	     * @param passwordValidation password validation to check
	     */
	    PasswordController.prototype.isPasswordValid = function (passwordValidation) {
	        // loop through each validation key and return false if invalid
	        for (var _i = 0, _a = Object.keys(passwordValidation); _i < _a.length; _i++) {
	            var key = _a[_i];
	            if (!passwordValidation[key]) {
	                return false;
	            }
	        }
	        // else return true inidcating password validation is valid
	        return true;
	    };
	    /**
	     * Resets password values and form validation flags.
	     */
	    PasswordController.prototype.resetPass = function () {
	        // reset password
	        this.$scope.password1 = null;
	        this.$scope.password2 = null;
	        // clean validation flags and messages
	        this.$scope.modelCtrl.$setUntouched();
	        this.setValidation();
	    };
	    /**
	     * Use to validate password values with the following logic.
	     *
	     * If the password is valid, clears validation flags/messages and updates
	     * directive two-way password value.
	     *
	     * Else if the password is invalid, display first validation flag/message and
	     * set two-way password value to null.
	     *
	     * @param password1 main password value
	     * @param password2 validation password value
	     */
	    PasswordController.prototype.validatePasswords = function (password1, password2) {
	        var passwordValidation = this.getPasswordValidation(password1, password2);
	        this.setValidation(passwordValidation);
	        // if valid, set linked password or set to null*/
	        var p = passwordValidation && this.isPasswordValid(passwordValidation) ? password1 : null;
	        if (p !== null) {
	            this.$scope.password = p;
	        }
	        else if (this.$scope.password !== null || this.$scope.password === '') {
	            this.$scope.password = null;
	        }
	    };
	    /**
	     * Clear existing validation and set invalid key if passed.
	     *
	     * @param invalidKey invalid pwcheck key
	     */
	    PasswordController.prototype.setValidation = function (passwordValidation) {
	        if (!passwordValidation) {
	            passwordValidation = {
	                required: true,
	                minlength: true,
	                confirm: true,
	                lowercase: true,
	                uppercase: true,
	                numeric: true,
	                special: true
	            };
	        }
	        for (var _i = 0, _a = Object.keys(passwordValidation); _i < _a.length; _i++) {
	            var key = _a[_i];
	            if (key === 'confirm') {
	                this.$scope.modelCtrl.passwordConfirm.$setValidity('pwcheck-' + key, passwordValidation[key]);
	            }
	            else {
	                this.$scope.modelCtrl.password.$setValidity('pwcheck-' + key, passwordValidation[key]);
	            }
	            ;
	        }
	    };
	    return PasswordController;
	}());
	exports.PasswordController = PasswordController;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function title() {
	    return {
	        restrict: 'E',
	        template: '{{ prefix }} {{ divider }} {{ title | translate }} {{ suffix }}',
	        controller: TitleController,
	        controllerAs: 'TitleController',
	        scope: {},
	        link: linkFunc,
	        transclude: true
	    };
	}
	exports.title = title;
	function linkFunc(scope, elem, attrs) {
	    scope.suffix = typeof attrs.suffix !== 'undefined' ? attrs.suffix : '';
	    scope.prefix = typeof attrs.prefix !== 'undefined' ? attrs.prefix : '';
	}
	/** @ngInject */
	var TitleController = (function () {
	    TitleController.$inject = ["$scope", "$translate"];
	    function TitleController($scope, $translate) {
	        this.$scope = $scope;
	        $scope.$on('$stateChangeStart', function (event, toState) {
	            // title must be translated alone for matching
	            $scope.title = toState.title;
	            $scope.divider = toState.title ? ' - ' : '';
	        });
	    }
	    return TitleController;
	}());
	exports.TitleController = TitleController;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Table Sort directive
	 *
	 * Note: This is set up with the Spring framework in mind, specifically the Pageable notation
	 *
	 * How to use:
	 *
	 * on a table add the attribute
	 *
	 * table-sort="refresh(null, sort)"
	 *
	 * The second parameter is a string in this format sort=name,desc&sort=address,asc
	 * It's not part of the first parameter which is an object because javascript objects cannot have duplicate keys
	 *
	 * There is an optional parameter as well:
	 *
	 * table-sort-set="whatToSetTo"
	 *
	 * `whatToSetTo` is an object that follows the ISort interface
	 *
	 * After you set that, the directive will callback the controller as well to make an API call.
	 * Only update `whatToSetTo` if you want to make an API call
	 *
	 * HTML bindings by column:
	 *
	 * on the `th` elements, add the attribute like this:
	 *
	 * sort="name"
	 *
	 * Note: these do not match the model, but bind one-to-one with the API's object
	 *
	 * If you need to bind to an object inside an object, dot notation works (Spring allows this)
	 *
	 * sort="group.id"
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// import controllers
	var tableSort_controller_1 = __webpack_require__(125);
	/** @ngInject */
	function tableSort() {
	    return {
	        restrict: 'A',
	        scope: {
	            tableSort: '&',
	            sortQueryString: '=',
	            disableSort: '=?',
	            cannedSort: '=?',
	            sortQueryStringSuffix: '@?'
	        },
	        link: tableSortLinkFunc,
	        controller: tableSort_controller_1.TableSortController,
	        controllerAs: 'tableSortCtrl'
	    };
	}
	exports.tableSort = tableSort;
	/** @ngInject */
	function tableSortItem() {
	    return {
	        require: '?^^tableSort',
	        restrict: 'A',
	        link: tableSortItemLinkFunc
	    };
	}
	exports.tableSortItem = tableSortItem;
	function tableSortLinkFunc(scope, elem) {
	    var th = elem.find('th');
	    var sortArr = [];
	    var sortString = '';
	    scope.sortTable = function () { return sortTable(); };
	    // add update element value function
	    scope.updateElementSort = function (e) { return updateElementSort(e); };
	    scope.updateSortValue = function (newValue, oldValue) { return updateSortValue(newValue, oldValue); };
	    // disable sort when true
	    scope.$watch('disableSort', function () { return disableSort(scope.disableSort); });
	    // update canned sort when changed
	    scope.$watch('cannedSort', function () { return updateCannedSort(scope.cannedSort); }, true);
	    // sort string getter method
	    scope.sortQueryString = function () {
	        sortString = buildQueryString(sortArr);
	        return sortString;
	    };
	    /**
	     * Build sort query string from sort array.
	     *
	     * @param sortArr sort array
	     */
	    function buildQueryString(sortArr) {
	        var tmpArr = [];
	        for (var i = 0; i < sortArr.length; i++) {
	            tmpArr.push("sort=" + sortArr[i].value + "," + sortArr[i].dir);
	        }
	        if (tmpArr.length > 0 && scope.sortQueryStringSuffix) {
	            tmpArr.push(scope.sortQueryStringSuffix);
	        }
	        return tmpArr.join('&'); // join the string
	    }
	    /**
	     * Disable sorting by applying table-sort-disabled class.
	     *
	     * @param disabled disable sorting
	     */
	    function disableSort(disabled) {
	        if (disabled) {
	            elem.addClass('table-sort-disabled');
	        }
	        else {
	            elem.removeClass('table-sort-disabled');
	        }
	    }
	    /**
	     * Update sort from a canned sort order.
	     *
	     * @param sortString canned sort string
	     */
	    function updateCannedSort(sortString) {
	        sortString = sortString || '';
	        var sortOptions = sortString.split('&');
	        sortArr = []; // clear previously selected options
	        for (var i = 0; i < th.length; i++) {
	            var e = angular.element(th[i]);
	            e.removeClass('sort-desc'); // remove all icons
	            e.removeClass('sort-asc');
	            for (var _i = 0, sortOptions_1 = sortOptions; _i < sortOptions_1.length; _i++) {
	                var item = sortOptions_1[_i];
	                var itemSort = item
	                    .replace('sort=', '')
	                    .split(',');
	                // first index contains value
	                // second index contains the sort direction (asc / desc)
	                if (e.attr('sort') === itemSort[0]) {
	                    sortArr.push({
	                        value: itemSort[0],
	                        dir: itemSort[1]
	                    });
	                    e.addClass("sort-" + itemSort[1]);
	                }
	            }
	        }
	    }
	    /**
	     * Add/remove element from sort or update direction.
	     *
	     * @param e element to update
	     */
	    function updateElementSort(e) {
	        if (scope.disableSort) {
	            return;
	        }
	        ;
	        var dir = null;
	        var found = false;
	        var value = e.attr('sort');
	        if (e.hasClass('sort-asc')) {
	            e.removeClass('sort-asc');
	            e.addClass('sort-desc');
	            dir = 'desc';
	        }
	        else if (e.hasClass('sort-desc')) {
	            e.removeClass('sort-desc');
	        }
	        else {
	            e.addClass('sort-asc');
	            dir = 'asc';
	        }
	        for (var i = 0; i < sortArr.length; i++) {
	            if (sortArr[i].value === value) {
	                if (dir !== null) {
	                    sortArr[i].dir = dir; // update the direction
	                }
	                else {
	                    sortArr.splice(i, 1); // remove it from array
	                }
	                found = true;
	                break;
	            }
	        }
	        if (!found) {
	            sortArr.push({
	                value: value,
	                dir: dir
	            });
	        }
	        sortTable();
	    }
	    /**
	     * Update sort value by old value if exists.
	     *
	     * @param newValue new value of sort item
	     * @param oldValue old value of sort item
	     */
	    function updateSortValue(newValue, oldValue) {
	        // used to indicate if value sorted
	        var isSorted = false;
	        // only update if values exist and aren't equal
	        if (newValue && oldValue && newValue !== oldValue) {
	            // loop through each array value and update sort string if found
	            for (var i = 0; i < sortArr.length; i++) {
	                if (sortArr[i].value === oldValue) {
	                    sortArr[i].value = newValue;
	                    isSorted = true;
	                    break;
	                }
	            }
	        }
	        // true if sorting by updated sort item value
	        return isSorted;
	    }
	    function sortTable() {
	        sortString = buildQueryString(sortArr); // update string for retrieving
	        scope.tableSort({ sort: sortString });
	    }
	}
	function tableSortItemLinkFunc(scope, elem, attrs, tableSortCtrl) {
	    // parent table sort controller is required
	    if (!tableSortCtrl) {
	        return;
	    }
	    // if sort value, bind click event, add class and icon
	    if (attrs.sort) {
	        elem.bind('click', function () { return tableSortCtrl.updateElementSort(elem); });
	    }
	    // update sort value if attribute changed
	    var currentValue = attrs.sort || '';
	    attrs.$observe('sort', function (value) {
	        tableSortCtrl.updateSortValue(value, currentValue);
	        currentValue = value;
	    });
	}


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * DatePicker
	 *
	 * What it does:
	 *
	 *  This gets the users SystemConfiguration:Date format from LocalStorage and puts it on the Angular Bootstrap UI datepicker (from parent)
	 *
	 * What it saves:
	 *
	 *  Requiring that every controller needs to have the LocalStorageService to get the SystemConfiguration:Date format
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	/** @ngInject */
	function datePicker() {
	    return {
	        restrict: 'E',
	        template: "<input ng-model-options=\"{ timezone: 'UTC' }\"/>",
	        controller: DatePickerController,
	        controllerAs: 'DatePickerController',
	        replace: true,
	        link: linkFunc,
	        require: '?ngModel'
	    };
	}
	exports.datePicker = datePicker;
	/** @ngInject */
	var DatePickerController = (function () {
	    DatePickerController.$inject = ["$scope"];
	    function DatePickerController($scope) {
	        this.$scope = $scope;
	        $scope.dateFormat = localStorage_service_1.LocalStorageService.get('SystemConfiguration:Date format');
	    }
	    return DatePickerController;
	}());
	exports.DatePickerController = DatePickerController;
	function linkFunc(scope, elem, attrs, ctrl) {
	    // this fires when the datepicker calendar is used or input value is manually changed
	    // it is not called when the model changes outside the directive
	    ctrl.$parsers.push(function (viewValue) {
	        if (viewValue !== null && typeof viewValue === 'object') {
	            viewValue.setUTCHours(0);
	        }
	        return viewValue;
	    });
	    // fires on model change, if it's a string, we change it to a date object
	    scope.$watch(attrs.ngModel, function (val) {
	        if (typeof val === 'string') {
	            var dt = new Date(val);
	            ctrl.$setViewValue(dt);
	        }
	        else {
	            ctrl.$modelValue = new Date();
	        }
	    });
	    // this only fires when the model is updated from outside the directive
	    // this changes what is displayed in the UI, but changes here will not update the model or calendar popup
	    ctrl.$formatters.push(function (modelValue) {
	        if (!modelValue) {
	            return undefined;
	        }
	        return new Date(modelValue);
	    });
	}


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	// displays box with error and error description
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function errorHandling() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/errorHandling/errorHandling.html',
	        replace: true,
	        scope: {
	            error: '='
	        }
	    };
	}
	exports.errorHandling = errorHandling;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var input_constants_1 = __webpack_require__(5);
	/**
	 * /**
	 * Input Clientside Error Tooltip
	 *
	 * When an input field is considered invalid, a tooltip will appear on hover
	 *
	 * NOTE: This is not an isolate scope!
	 *
	 * @returns {{restrict: string, controller: InputController, controllerAs: string, link: (function(IInput, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController): void), require: string}}
	 */
	function input() {
	    return {
	        restrict: 'E',
	        controller: InputController,
	        controllerAs: 'InputController',
	        link: linkFunc,
	        require: ['?ngModel', '?^^form']
	    };
	}
	exports.input = input;
	function linkFunc(scope, elem, attr, ctrls) {
	    var ctrl = ctrls[0];
	    var formCtrl = ctrls[1];
	    if (ctrl === null) {
	        return;
	    }
	    var el;
	    var errorHasBeenCreated = false; // this prevents multiple tooltips from being created
	    var id = String(new Date().getTime()) + String(Math.floor(Math.random() * (100 - 0 + 1))); // because the scope is not isolate, we just generate an "id" from milleseconds but also a random number.  This could be avoided with an isolate scope
	    if (typeof scope.showTooltip === 'undefined') {
	        scope.showTooltip = {};
	    }
	    scope.showTooltip[id] = false;
	    scope.errorMessages = input_constants_1.MESSAGES;
	    scope.minLength = attr.minLength;
	    scope.$watch(attr.minLength, function (val) { return scope.minLength = val; });
	    function setInputStateToDirty() {
	        scope.errorTooltip = ctrl.$error;
	        ctrl.$setDirty(); // sets the input as dirty, for scss reasons
	        ctrl.$setTouched(); // sets the input as touched, for scss reasons
	    }
	    function tooltip() {
	        if (attr && attr.inputFormat && ctrl.$error.pattern) {
	            ctrl.$error.patternFormat = attr.inputFormat;
	        }
	        else if (ctrl.$error.patternFormat) {
	            delete ctrl.$error.patternFormat;
	            ctrl.$validate();
	        }
	        if (ctrl.$valid && typeof el !== 'undefined' && errorHasBeenCreated) {
	            scope.showTooltip[id] = false; // force hide the tooltip
	            errorHasBeenCreated = false; // reset value
	        }
	        else if (ctrl.$invalid && ctrl.$touched && !errorHasBeenCreated) {
	            setInputStateToDirty();
	            el = scope.InputController.$compile("<span class=\"error error-tooltip\" uib-tooltip-template=\"'app/angular-ids-project/src/components/input/input.tooltip.html'\" trigger=\"''\" tooltip-is-open=\"showTooltip[" + id + "]\"><!-- Empty --></span>")(scope);
	            elem.parent().append(el);
	            errorHasBeenCreated = true;
	        }
	        else if (ctrl.$invalid && ctrl.$touched) {
	            setInputStateToDirty();
	        }
	    }
	    scope.$watch(attr.ngModel, function (val) {
	        // set api-response validation to true to remove the error highlighting sent back from the server
	        ctrl.$setValidity(input_constants_1.DISPLAY.API_RESPONSE_CLASS, true);
	        // if existing api response duplicate is invalid, set to true and reset all form field duplicate validation errors as well if exist
	        if (ctrl.$error[input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS]) {
	            // set response duplicate error to valid and do the same for all remaining form duplicate errors if they exist
	            ctrl.$setValidity(input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS, true);
	            if (formCtrl && formCtrl.$error && formCtrl.$error[input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS]) {
	                // loop in reverse as $setValidity ends up removing item from array index
	                var errors = formCtrl.$error[input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS];
	                for (var i = errors.length - 1; i >= 0; i--) {
	                    errors[i].$setValidity(input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS, true);
	                }
	            }
	        }
	        if (val !== null) {
	            tooltip();
	        }
	    });
	    elem.bind('mouseenter', function () {
	        if (errorHasBeenCreated && !angular.equals(ctrl.$error, {}) && !ctrl.$pristine) {
	            scope.errorTooltip = ctrl.$error;
	            scope.showTooltip[id] = true;
	        }
	    });
	    elem.bind('mouseleave', function () { return scope.showTooltip[id] = false; }); // hides tooltip
	    elem.bind('keyup', tooltip); // on keyup it checks validity and updates tooltip
	    elem.bind('blur', tooltip); // on blur it checks validity and updates tooltip
	}
	/** @ngInject */
	var InputController = (function () {
	    InputController.$inject = ["$compile", "$sce"];
	    function InputController($compile, $sce) {
	        this.$compile = $compile;
	        this.$sce = $sce;
	        this.$compile = $compile;
	        this.$sce = $sce;
	    }
	    return InputController;
	}());
	exports.InputController = InputController;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// interfaces
	var input_constants_1 = __webpack_require__(5);
	/**
	 * Select Clientside Error Hanlding
	 *
	 * NOTE: This is not an isolate scope!
	 */
	function select() {
	    return {
	        restrict: 'E',
	        link: linkFunc,
	        require: ['?ngModel', '?^^form']
	    };
	}
	exports.select = select;
	function linkFunc(scope, elem, attr, ctrls) {
	    var ctrl = ctrls[0];
	    var formCtrl = ctrls[1];
	    if (ctrl === null) {
	        return;
	    }
	    // if the model changes, we check the validity, this may occur outside the directive
	    scope.$watch(attr.ngModel, function (val) {
	        // set api-response validation to true to remove the error highlighting sent back from the server
	        ctrl.$setValidity(input_constants_1.DISPLAY.API_RESPONSE_CLASS, true);
	        // if existing api response duplicate is invalid, set to true and reset all form field duplicate validation errors as well if exist
	        if (ctrl.$error[input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS]) {
	            // set response duplicate error to valid and do the same for all remaining form duplicate errors if they exist
	            ctrl.$setValidity(input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS, true);
	            if (formCtrl && formCtrl.$error && formCtrl.$error[input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS]) {
	                // loop in reverse as $setValidity ends up removing item from array index
	                var errors = formCtrl.$error[input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS];
	                for (var i = errors.length - 1; i >= 0; i--) {
	                    errors[i].$setValidity(input_constants_1.DISPLAY.API_RESPONSE_EXISTS_CLASS, true);
	                }
	            }
	        }
	    });
	}


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	/**
	 *  Popup!
	 *
	 *  NOTE: use the popup-confirm event as the `ng-click`.  This will not override the `ng-click`
	 *        I tried fixing this with `terminal` ($compile) attribute for directive, that fixes one issue but creates many more
	 *
	 *  what this does currently is check if localStorage item is set to true, if so, we continue
	 *
	 *  this will intercept the ng-click with a confirm/cancel dialog, if `confirm` is clicked, it will run the `ng-click` for that element
	 *  if `cancel`, will not fire `ng-click`
	 *
	 *  popup {required} This binds the directive
	 *  popup-text {required} {string} The text to display in the popup
	 *  popup-local-storage-enable {required} {string} The local storage variable to determine whether to include this
	 *  popup-confirm {required} {any} when confirm is clicked, these events fire.  Works like an `ng-click`
	 */
	/** @ngInject */
	function popup() {
	    return {
	        restrict: 'A',
	        bindToController: false,
	        controller: PopupController,
	        priority: 1,
	        link: linkFunc
	    };
	}
	exports.popup = popup;
	/** @ngInject */
	var PopupController = (function () {
	    PopupController.$inject = ["$scope", "$uibModal"];
	    function PopupController($scope, $uibModal) {
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        this.$uibModal = $uibModal;
	    }
	    return PopupController;
	}());
	exports.PopupController = PopupController;
	function linkFunc(scope, elem, attrs, ctrl) {
	    var popupText = attrs.popupText !== '' ? attrs.popupText : 'Are you sure?'; // if no attribute is supplied, we use the default
	    var createWarning, updateWarning, deleteWarning, saveAs;
	    attrs.$observe('createWarning', function (val) {
	        createWarning = val;
	    });
	    attrs.$observe('updateWarning', function (val) {
	        updateWarning = val;
	    });
	    attrs.$observe('deleteWarning', function (val) {
	        deleteWarning = val;
	    });
	    attrs.$observe('saveAs', function (val) {
	        saveAs = val;
	    });
	    var popUpConfirmAction = attrs.popupConfirm; // this is required at this time
	    function runClickEvent(popUpConfirmAction) {
	        scope.$eval(popUpConfirmAction);
	    }
	    scope.$on('triggerPopup', function () {
	        popupText = scope.$parent.popupText; // Retrieve the latest popupText from the scope
	        var modal = ctrl.$uibModal.open({
	            templateUrl: 'app/angular-ids-project/src/components/popup/popup.template.html',
	            controller: ['$scope', function ($scope) {
	                    $scope.text = popupText; // Use the updated popupText
	                    $scope.confirm = function () {
	                        popUpConfirmAction = "create(convertedEditable || editable); form.$setUntouched();";
	                        runClickEvent(popUpConfirmAction);
	                        modal.close();
	                    };
	                    $scope.close = function () { return modal.close(); };
	                }]
	        });
	    });
	    elem.bind('click', function () {
	        if (attrs.popupLocalStorageEnable) {
	            var continueWithDialog = localStorage_service_1.LocalStorageService.get(attrs.popupLocalStorageEnable);
	            if (continueWithDialog !== true && continueWithDialog !== 't') {
	                runClickEvent(popUpConfirmAction); // runs click event, does not continue with modal
	                return;
	            }
	        }
	        if (attrs.popupEnabled === 'false') {
	            runClickEvent(popUpConfirmAction); // runs click event, does not continue with modal
	            return;
	        }
	        var modal = ctrl.$uibModal.open({
	            templateUrl: 'app/angular-ids-project/src/components/popup/popup.template.html',
	            controller: ['$scope', function ($scope) {
	                    $scope.text = popupText; // Use the updated popupText
	                    $scope.saveAs = saveAs;
	                    $scope.createWarning = createWarning;
	                    $scope.updateWarning = updateWarning;
	                    $scope.deleteWarning = deleteWarning;
	                    $scope.setName = function (inputText) { return scope.inputText = inputText; };
	                    $scope.close = function () { return modal.close(); }; // bind the `close` scope method
	                    $scope.confirm = function () {
	                        runClickEvent(popUpConfirmAction); // runs ng-click action, note: scope of the element, not the dialog
	                        modal.close();
	                    };
	                }]
	        });
	    });
	}


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Dynamic Service Dropdown
	 *
	 * Using a string, the directive will bind a service which will keep it encapsulated.  This removes having the controller having to hold onto it
	 *
	 * todo: add ability to use the multi select dropdown
	 */
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function dynamicServiceDropdown() {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl: 'app/angular-ids-project/src/components/dynamicServiceDropdown/dynamicServiceDropdown.html',
	        controller: DynamicServiceDropdown,
	        link: linkFunc,
	        scope: {
	            method: '@',
	            isRequired: '<',
	            service: '@',
	            allowEmpty: '@',
	            queryString: '@?',
	            disabled: '<?',
	            sortedBy: '@?',
	            selected: '@',
	            field: '@',
	            object: '@',
	            listFilter: '=?',
	            selectedValue: '=?',
	            model: '@'
	        },
	        require: 'ngModel'
	    };
	}
	exports.dynamicServiceDropdown = dynamicServiceDropdown;
	function linkFunc(scope, elem, attrs, ctrl) {
	    scope.dropdownType = attrs.dropdownType;
	    scope.ngOptions = attrs.options;
	    scope.ngModel = ctrl;
	    scope.class = attrs.class;
	    scope.allowEmpty = attrs.allowEmpty;
	    scope.$watch(function () {
	        return ctrl.$viewValue;
	    }, function (newValue) {
	        ctrl.$setViewValue(newValue);
	        ctrl.$render();
	    });
	}
	/** @ngInject */
	var DynamicServiceDropdown = (function () {
	    DynamicServiceDropdown.$inject = ["$scope", "$injector"];
	    function DynamicServiceDropdown($scope, $injector) {
	        if ($scope.service.substring(0, 2) !== '::') {
	            console.error("Please add '::' to the front of the 'service' binding, otherwise this won't work");
	            return;
	        }
	        var serviceString = $scope.service.substring(2);
	        var service = $injector.get(serviceString);
	        var method = $scope.method ? $scope.method : 'listAll'; // unless specified we call the `listAll` method
	        var sortBy = function (list) {
	            // sort array of objects by key/value from param
	            var content = list.content.sort(function (a, b) { return a[$scope.sortedBy].localeCompare(b[$scope.sortedBy]); });
	            return __assign({}, list, { content: content });
	        };
	        if ($scope.queryString) {
	            var serviceWithParams = angular.copy(service);
	            serviceWithParams.endpoint += "?" + $scope.queryString;
	            service = serviceWithParams;
	        }
	        var serviceCall = service[method]();
	        if (typeof serviceCall.then !== 'undefined') {
	            serviceCall.then(function (data) {
	                $scope.list = $scope.sortedBy ? sortBy(data) : data;
	                if ($scope.selected && $scope.list.content && $scope.field) {
	                    if ($scope.object) {
	                        $scope.$parent[$scope.object][$scope.model] = $scope.selectedValue = $scope.list.content.find(function (item) { return item[$scope.field] === $scope.selected; });
	                    }
	                    else {
	                        $scope.$parent[$scope.model] = $scope.selectedValue = $scope.list.content.find(function (item) { return item[$scope.field] === $scope.selected; });
	                    }
	                }
	                ;
	            });
	        }
	        else {
	            $scope.list = $scope.sortedBy ? sortBy(serviceCall) : serviceCall; // is just a regular array/object
	        }
	    }
	    return DynamicServiceDropdown;
	}());
	exports.DynamicServiceDropdown = DynamicServiceDropdown;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var download_oauth2_class_1 = __webpack_require__(277);
	/**
	 * Download directive
	 *
	 * Note: will display `fa-floppy-o` icon, unless there is text inside the element, which remove the icon
	 */
	/** @ngInject */
	function downloadOauth2() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/download-oauth2/download-oauth2.html',
	        scope: {
	            bodyParams: '<?',
	            bodyParamsFn: '=?',
	            url: '@',
	            params: '=?',
	            disable: '<?',
	            error: '=',
	            classUsed: '@?',
	            requestMethod: '@?',
	            callbackSuccessFn: '&?',
	            callbackErrorFn: '&?',
	            hideIcon: '<?' // force hiding of default save icon
	        },
	        replace: true,
	        controller: DownloadOAuth2Controller,
	        transclude: true,
	        compile: function (elem, attrs, transcludeFn) { return function () {
	            transcludeFn(elem, function (clone) {
	                if (clone.text().trim().length) {
	                    elem.find('i').remove(); // remove the icon to just have text
	                }
	            });
	        }; }
	    };
	}
	exports.downloadOauth2 = downloadOauth2;
	/** @ngInject */
	var DownloadOAuth2Controller = (function () {
	    DownloadOAuth2Controller.$inject = ["$scope", "Restangular"];
	    function DownloadOAuth2Controller($scope, Restangular) {
	        var downloadOAuth2 = new download_oauth2_class_1.DownloadOauth2($scope, Restangular);
	        $scope.requestMethod = $scope.requestMethod || 'GET';
	        $scope.classUsed = $scope.classUsed === undefined ? 'btn btn-primary btn-sm btn-download' : $scope.classUsed;
	        $scope.generate = function () { return downloadOAuth2.generate(); };
	    }
	    return DownloadOAuth2Controller;
	}());
	exports.DownloadOAuth2Controller = DownloadOAuth2Controller;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var DownloadOauth2 = (function () {
	    function DownloadOauth2(scope, Restangular) {
	        this.$scope = scope;
	        this.Restangular = Restangular;
	    }
	    DownloadOauth2.prototype.generate = function () {
	        var _this = this;
	        var request = this.getRequestMethod();
	        request.then(function (resp) {
	            var filename = _this.parseFileName(resp);
	            var blob = _this.generateBlob(resp);
	            var browser = _this.determineBrowser();
	            if (browser === 'IE') {
	                window.navigator.msSaveBlob(blob, filename);
	            }
	            else if (browser === 'CHROME') {
	                _this.generateChromeDownload(blob, filename);
	            }
	            else {
	                _this.generateOtherDownload(blob, filename);
	            }
	            ;
	            if (_this.$scope.callbackSuccessFn) {
	                _this.$scope.callbackSuccessFn();
	            }
	            ;
	        }).catch(function (error) {
	            _this.$scope.error = {};
	            var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.data)); // must be decoded as error returns in an arraybuffer
	            var errorObj = JSON.parse(decodedString);
	            _this.$scope.error.error = { data: errorObj }; // tie into current error handling
	            if (_this.$scope.callbackErrorFn) {
	                _this.$scope.callbackErrorFn();
	            }
	        });
	    };
	    /**
	     * Construct a restangular promise based on parameters that returns full headers
	     *
	     * @return  {ng.IPromise<any>}  A restangular request
	     */
	    DownloadOauth2.prototype.getRequestMethod = function () {
	        var rest = this.Restangular.withConfig(function (RestangularConfigurer) { return RestangularConfigurer.setFullResponse(true); });
	        var req = rest.one(this.$scope.url).withHttpConfig({ responseType: 'arraybuffer' });
	        var method = this.$scope.requestMethod;
	        if (method === 'GET') {
	            return req.get(this.$scope.params);
	        }
	        else {
	            var body = this.$scope.bodyParamsFn ? this.$scope.bodyParamsFn(this.$scope.bodyParams) : this.$scope.bodyParams;
	            return req.customPOST(body, null, this.$scope.params);
	        }
	        ;
	    };
	    /**
	     * Construct the filename from the response, removing superfluous characters
	     *
	     * @param   {ng.IPromise<any>}  resp  response from the server
	     * @return  {string}                  filename
	     */
	    DownloadOauth2.prototype.parseFileName = function (resp) {
	        var headers = resp.headers();
	        var disposition = headers['content-disposition'];
	        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
	        var matches = filenameRegex.exec(disposition);
	        var filename = null;
	        if (disposition && disposition.indexOf('attachment') !== -1) {
	            if (matches !== null && matches[1]) {
	                filename = matches[1].replace(/['"]/g, '');
	            }
	            ;
	        }
	        ;
	        return filename;
	    };
	    /**
	     * Generate a blob for the file object
	     *
	     * @param   {ng.IPromise<any>}  resp  response from the server
	     * @return  {Blob}                    file object
	     */
	    DownloadOauth2.prototype.generateBlob = function (resp) {
	        var headers = resp.headers();
	        var contentType = headers['content-type'];
	        return new Blob([resp.data], { type: contentType });
	    };
	    /**
	     * Determine which browser is being used
	     *
	     * @return  {string}  file object
	     */
	    DownloadOauth2.prototype.determineBrowser = function () {
	        if (navigator.msSaveBlob) {
	            return 'IE';
	        }
	        else if (document.createEvent) {
	            return 'CHROME';
	        }
	        else {
	            return 'OTHER';
	        }
	        ;
	    };
	    /**
	     * Construct the download for chrome
	     *
	     * @param   {Blob}    blob      file object
	     * @param   {string}  filename  name of file to save
	     */
	    DownloadOauth2.prototype.generateChromeDownload = function (blob, filename) {
	        var target = this.buildTarget(blob, filename);
	        var ev = document.createEvent('MouseEvent');
	        ev.initMouseEvent('click', true, true, window, null, 0, 0, 0, 0, false, false, false, false, 0, null);
	        target[0].dispatchEvent(ev);
	    };
	    /**
	     * Construct the download for other browsers
	     *
	     * @param   {Blob}    blob      file object
	     * @param   {string}  filename  name of file to save
	     */
	    DownloadOauth2.prototype.generateOtherDownload = function (blob, filename) {
	        var target = this.buildTarget(blob, filename);
	        target[0].fireEvent('onclick');
	    };
	    /**
	     * Creaet the target <a/> element
	     *
	     * @param   {Blob}    blob      file object
	     * @param   {string}  filename  name of file to save
	     */
	    DownloadOauth2.prototype.buildTarget = function (blob, filename) {
	        var target = angular.element('<a/>');
	        target.attr({
	            href: window.URL.createObjectURL(blob),
	            target: '_blank',
	            download: filename
	        });
	        return target;
	    };
	    return DownloadOauth2;
	}());
	exports.DownloadOauth2 = DownloadOauth2;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Preview directive
	 *
	 */
	/** @ngInject */
	function previewOauth2() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/preview-oauth2/preview-oauth2.html',
	        scope: {
	            bodyParams: '<?',
	            bodyParamsFn: '=?',
	            disable: '=?',
	            error: '=',
	            height: '=?',
	            params: '=?',
	            requestMethod: '@?',
	            callbackSuccessFn: '&?',
	            url: '@',
	            classUsed: '@?',
	            paramId: '@?'
	        },
	        transclude: true,
	        controller: PreviewOAuth2Controller
	    };
	}
	exports.previewOauth2 = previewOauth2;
	/** @ngInject */
	var PreviewOAuth2Controller = (function () {
	    PreviewOAuth2Controller.$inject = ["$scope", "$sce", "Restangular", "downloadService"];
	    function PreviewOAuth2Controller($scope, $sce, Restangular, downloadService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.Restangular = Restangular;
	        this.downloadService = downloadService;
	        $scope.getPreview = function () { return _this.getPreview(); };
	        $scope.height = $scope.height || '1100px';
	        $scope.error = {};
	        $scope.requestMethod = $scope.requestMethod || 'GET';
	        this.$sce = $sce;
	        $scope.classUsed = $scope.classUsed === undefined ? 'btn btn-primary btn-preview' : $scope.classUsed;
	        $scope.paramId = $scope.paramId === undefined ? 'preview' : $scope.paramId;
	        $scope.$on('hidePreview', function () { return _this.$scope.hide = true; });
	    }
	    PreviewOAuth2Controller.prototype.getPreview = function () {
	        var _this = this;
	        var rest = this.Restangular.withConfig(function (RestangularConfigurer) { return RestangularConfigurer.setFullResponse(true); }); // this is done to get the full headers
	        var method = this.$scope.requestMethod;
	        var req = rest.one(this.$scope.url).withHttpConfig({ responseType: 'arraybuffer' });
	        var request = null;
	        // which http method to use
	        if (method === 'GET') {
	            request = req.get(this.$scope.params);
	        }
	        else if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
	            var body = this.$scope.bodyParamsFn ? this.$scope.bodyParamsFn(this.$scope.bodyParams) : this.$scope.bodyParams;
	            request = req.customPOST(body, null, this.$scope.params);
	        }
	        else {
	            console.error('`requestMethod` not valid:', method);
	        }
	        request.then(function (resp) {
	            _this.$scope.preview = _this.downloadService.getPreview(resp);
	            _this.$scope.hide = false;
	            _this.$scope.showButton = true;
	            if (_this.$scope.callbackSuccessFn) {
	                _this.$scope.callbackSuccessFn();
	            }
	            ;
	        })
	            .catch(function (error) {
	            var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.data)); // must be decoded as error returns in an arraybuffer
	            var errorObj = JSON.parse(decodedString);
	            _this.$scope.error = {};
	            _this.$scope.error.error = { data: errorObj };
	        });
	    };
	    return PreviewOAuth2Controller;
	}());
	exports.PreviewOAuth2Controller = PreviewOAuth2Controller;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PDF = __webpack_require__(280);
	var download_oauth2_class_1 = __webpack_require__(277);
	/**
	 * Export TABLE to CSV/XLS/PDF
	 *
	 * This directive is used in two ways.
	 *
	 * The first is used on a row containing a table or
	 * data-grid, and creates a dropdown allowing creation
	 * of files (currently .pdf/.csv/.xls ) in the specified formats
	 *
	 * The second is for a single button file generation that
	 * generates .csv OR .xls files depending on the specified format
	 *
	 */
	/** @ngInject */
	function exportTable() {
	    return {
	        restrict: 'A',
	        scope: {
	            chartJson: '<?',
	            filename: '@',
	            sorted: '<?',
	            formats: '<?',
	            format: '@?',
	            button: '<?',
	            columnsPerPage: '<?',
	            columnWidth: '<?',
	            rowHeight: '<?',
	            fontSize: '<?',
	            boxHeader: '<?',
	            exportTableId: '@?',
	            service: '@?',
	            list: '=?',
	            queryString: '<?',
	            sortQueryString: '<?',
	            endpointParam: '@?',
	            maximumRows: '<?',
	            csvHeader: '<?',
	            backEndExport: '<?' // indicate that CSV should be created on back-end (default false)
	        },
	        controller: ExportTable,
	        compile: compileTableData
	    };
	}
	exports.exportTable = exportTable;
	/**
	 * $scope.theaders are the table headers used for both
	 * PDF and CSV generation
	 *
	 * $scope.tfields is an object that contains the properties
	 * required to access row object properties. For instance,
	 * if the account row propery is [Object object], it will check the tfields
	 * and find {account: name}, then use it value to access the account name.
	 * This is done in both exportCSV and exportPDF
	 *
	 * @param  {ng.IAugmentedJQuery} element
	 * @returns Function
	 */
	function compileTableData(element, attrs) {
	    var htmlString = element[0].innerText;
	    var splitString = htmlString.toLocaleLowerCase().split('item.');
	    var theaders = splitString.map(function (x) { return x.substr(0, x.indexOf(' ')); });
	    var tfields = {};
	    // these lines set and init a fixed 
	    // header on every table with this directive 
	    element[0].addEventListener('scroll', tableFixHead);
	    var scroll = new Event('scroll');
	    element[0].dispatchEvent(scroll);
	    theaders.shift(); // we do not want all json data in the csv file, only the json displayed in the table
	    theaders = theaders.map(function (x) {
	        // remove commas to prevent incorrect field name
	        var split = x.replace(/,/, '').split('.');
	        if (split[1]) {
	            tfields[split[0]] = split[1];
	        }
	        return split[0];
	    });
	    return function (scope) {
	        scope.tfields = tfields;
	        scope.theaders = theaders;
	        // sort alphabetically by default
	        scope.sorted = attrs.sorted ? attrs.sorted : true;
	    };
	}
	/** @ngInject */
	var ExportTable = (function () {
	    ExportTable.$inject = ["$scope", "$element", "$timeout", "$compile", "$templateRequest", "$injector", "$filter", "$translate", "$uibModal", "Restangular"];
	    function ExportTable($scope, $element, $timeout, $compile, $templateRequest, $injector, $filter, $translate, $uibModal, Restangular) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$injector = $injector;
	        this.$filter = $filter;
	        this.$uibModal = $uibModal;
	        this.Restangular = Restangular;
	        $scope.translate = $translate;
	        // listens for trigger to scroll
	        // this table to the top
	        $scope.$on('scrollToTop', function () {
	            $element[0].scrollTop = 0;
	        });
	        if ($scope.service) {
	            $scope.getAllDataFromService = $injector.get($scope.service);
	        }
	        $scope.uibModal = this.$uibModal;
	        $scope.formats = $scope.formats || ['csv'];
	        $scope.backEndExport = $scope.backEndExport || false;
	        $scope.getCsvFromBackend = function () { return _this.getCsvFromBackend(); };
	        $scope.exportCsv = function (format) {
	            $scope.format = format || $scope.format || 'csv'; // dropdown / single / default
	            if (_this.$scope.chartJson) {
	                _this.exportCsv(_this.$scope.chartJson, $scope.filename, $scope.tfields, $scope.theaders);
	            }
	            else {
	                _this.export('csv');
	            }
	        };
	        $scope.exportPdf = function () { return _this.export('pdf'); };
	        $timeout(function () {
	            if (!$scope.button) {
	                $templateRequest('app/components/directives/export-table/export-table.html').then(function (temp) {
	                    var boxHeader = $scope.boxHeader || 0; // defaults to first box header
	                    var template = angular.element(temp);
	                    angular.element(document).ready(function () {
	                        var exportButton = document.getElementsByClassName('export-button')[boxHeader];
	                        if (exportButton) {
	                            exportButton.innerHTML = ''; // safety so that only one is appended at a time
	                            exportButton.appendChild($compile(template)($scope)[0]);
	                        }
	                    });
	                });
	            }
	            else {
	                $element.on('click', function () { return $scope.exportCsv(); });
	            }
	        });
	    }
	    /**
	     * If there is a different endpoint than the
	     * one typically used, this function will modify it with
	     * the endpointParam value that is
	     * passed into the directive
	     *
	     * This method also combines the queryString
	     * object into a queryString and adds it to
	     * the endpoint
	     *
	     * @returns any // returns any service
	     */
	    ExportTable.prototype.getFullService = function () {
	        var fullService;
	        try {
	            fullService = angular.copy(this.$scope.getAllDataFromService);
	        }
	        catch (err) {
	            // can't copy user service, the error - Can't copy! Making copies of Window or Scope instances is not supported
	            fullService = this.$injector.get(this.$scope.service);
	            var index = fullService.endpoint.indexOf('?');
	            if (index !== -1) {
	                fullService.endpoint = fullService.endpoint.slice(0, index);
	            }
	        }
	        if (!this.$scope.queryString && !this.$scope.sortQueryString && !this.$scope.endpointParam) {
	            return fullService;
	        }
	        else {
	            fullService.endpoint += (this.$scope.endpointParam ? this.$scope.endpointParam : '') + "?";
	        }
	        if (this.$scope.queryString || this.$scope.backEndExport) {
	            var queryString = angular.copy(this.$scope.queryString);
	            var params = [];
	            this.$scope.endpointParam = this.$scope.endpointParam || '';
	            if (this.$scope.queryString) {
	                for (var key in queryString) {
	                    if (queryString.hasOwnProperty(key) && queryString[key] !== undefined && queryString[key] !== null) {
	                        var page = queryString.page;
	                        queryString.page = page > 0 ? page - 1 : page; // if page is greater than 0, minus 1 for proper paging
	                        params.push(key + "=" + queryString[key]);
	                    }
	                }
	            }
	            if (this.$scope.backEndExport) {
	                params.push('csvExport=true');
	                // setting size=-1 to return all data
	                var indexSize = params.findIndex(function (param) { return param.startsWith('size'); });
	                if (indexSize > -1) {
	                    params[indexSize] = 'size=-1';
	                }
	                else {
	                    params.push('size=-1');
	                }
	                // setting page=0 to return data from a table from the first page
	                var indexPage = params.findIndex(function (param) { return param.startsWith('page'); });
	                if (indexPage > -1) {
	                    params[indexPage] = 'page=0';
	                }
	                else {
	                    params.push('page=0');
	                }
	            }
	            queryString = params.join('&');
	            fullService.endpoint += "" + queryString;
	        }
	        if (this.$scope.sortQueryString) {
	            fullService.endpoint += "&" + this.$scope.sortQueryString;
	        }
	        return fullService;
	    };
	    /**
	     * This either loops through the specified
	     * number of pages, adds the data, then
	     * exports to pdf or csv. OR if no pages
	     * are specified, it exports all the data
	     *
	     * @returns void
	     */
	    ExportTable.prototype.export = function (type) {
	        var _this = this;
	        var fullService = this.getFullService();
	        if (this.$scope.queryString) {
	            var firstCall = fullService.list();
	            firstCall.then(function (data) {
	                fullService.endpoint = data.route; // makes sure the endpoint doesn't reset to the default
	                var totalPromises = [];
	                var totalPages = data.total_pages;
	                var allData = data.content;
	                var currentPage = data.number;
	                var finalPage = totalPages - currentPage;
	                var pagesToGo = finalPage - currentPage;
	                if (totalPages > 10) {
	                    var modal_1 = _this.$scope.uibModal.open({
	                        animation: true,
	                        templateUrl: 'app/components/directives/export-table/export-table-warning.template.html',
	                        controller: ['$scope', function ($scope) {
	                                $scope.close = function () { return modal_1.close(); };
	                            }]
	                    });
	                    totalPages = 10;
	                    finalPage = totalPages - currentPage;
	                    pagesToGo = finalPage - currentPage;
	                }
	                ;
	                if (totalPages > 1) {
	                    while (pagesToGo) {
	                        if (currentPage > 0) {
	                            pagesToGo--;
	                            if (fullService.endpoint.indexOf('page') !== -1) {
	                                var newEndpoint = fullService.endpoint.replace("page=" + (currentPage - 1), "page=" + currentPage);
	                                fullService.endpoint = newEndpoint;
	                            }
	                            totalPromises.push(fullService.list());
	                        }
	                        currentPage = currentPage + 1;
	                    }
	                }
	                Promise.all(totalPromises).then(function (pages) {
	                    for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
	                        var page = pages_1[_i];
	                        allData = allData.concat(page.content);
	                    }
	                    // export set of pages to pdf or csv
	                    type === 'pdf' ? _this.exportPDF(allData) : _this.exportCsv(allData, _this.$scope.filename, _this.$scope.tfields, _this.$scope.theaders);
	                });
	            });
	        }
	        else {
	            if (this.$scope.list) {
	                this.checkListData(this.$scope.list);
	                type === 'pdf' ? this.exportPDF(this.$scope.list) : this.exportCsv(this.$scope.list, this.$scope.filename, this.$scope.tfields, this.$scope.theaders);
	            }
	            else {
	                fullService.listAll().then(function (allData) {
	                    var data = allData.content || allData;
	                    // export all data to pdf or csv
	                    type === 'pdf' ? _this.exportPDF(data) : _this.exportCsv(data, _this.$scope.filename, _this.$scope.tfields, _this.$scope.theaders);
	                });
	            }
	        }
	    };
	    ;
	    ExportTable.prototype.checkListData = function (list) {
	        var _this = this;
	        list.forEach(function (element) {
	            for (var item in element) {
	                if (element.hasOwnProperty(item)) {
	                    if (item.includes('date_time')) {
	                        element[item] = _this.$filter('dateConverter')(element[item], 'HH:mm');
	                    }
	                    element[item] = element[item] === null ? '' : element[item];
	                }
	            }
	        });
	    };
	    ExportTable.prototype.snakeToCamel = function (snake) {
	        snake = snake.replace(/[\-_\s]+(.)?/g, (function (match, ch) {
	            return ch ? ch.toUpperCase() : '';
	        }));
	        // ensure 1st char is always lowercase
	        return snake.substr(0, 1).toLowerCase() + snake.substr(1);
	    };
	    /**
	     * Find table header text value if sort attribute exists as
	     * camel case version of header snake case.
	     *
	     * @param header header property snake case
	     * @param columns header columns (thead > th)
	     */
	    ExportTable.prototype.getHeaderText = function (header, columns) {
	        // convert snake case header proeprty into camel case
	        var camel = this.snakeToCamel(header);
	        // loop through each table header column and parse for matching header
	        for (var i = 0, n = columns.length; i < n; i++) {
	            // sort attribute is used to match header value
	            var sort = columns[i].attributes.sort;
	            // skip if no sort attribute as it is required for matching
	            if (!sort) {
	                continue;
	            }
	            // get all table suffixes and split by comma
	            // used to add additional text suffix
	            var suffix = columns[i].attributes['export-table-suffix'];
	            var suffixes = suffix ? suffix.value.split(',') : [];
	            // loop through each sort value and return header text with suffix if camel case matches
	            var sorts = sort.value.split(',');
	            for (var ii = 0; ii < sorts.length; ii++) {
	                // continue if sort does not match camel case
	                if (sorts[ii].split('.')[0] !== camel) {
	                    continue;
	                }
	                // return translated text as sort innerText and any suffixes
	                var text = this.$scope.translate.instant(columns[i].innerText);
	                if (suffixes[ii]) {
	                    text = text + " " + this.$scope.translate.instant(suffixes[ii]);
	                }
	                return text;
	            }
	        }
	    };
	    ExportTable.prototype.exportPDF = function (data) {
	        var allData = data;
	        // the first object of the row will be the header object
	        this.$scope.headerObj = {};
	        var columns = angular.element(document).find('thead').find('th');
	        for (var _i = 0, _a = this.$scope.theaders; _i < _a.length; _i++) {
	            var header = _a[_i];
	            var result = this.getHeaderText(header, columns);
	            if (result) {
	                this.$scope.headerObj[header] = result;
	            }
	        }
	        for (var _b = 0, allData_1 = allData; _b < allData_1.length; _b++) {
	            var item = allData_1[_b];
	            for (var key in item) {
	                if (item.hasOwnProperty(key)) {
	                    if (item[key] === null) {
	                        item[key] = '';
	                    }
	                    else if (typeof item[key] !== 'object') {
	                        item[key] = this.$scope.translate.instant(String(item[key]));
	                    }
	                    if (!this.$scope.theaders.includes(key)) {
	                        delete item[key];
	                    }
	                    else if (this.$scope.tfields.hasOwnProperty(key)) {
	                        item[key] = this.$scope.translate.instant(item[key][this.$scope.tfields[key]]); // if it is an object, get the property
	                    }
	                }
	            }
	        }
	        allData.unshift(this.$scope.headerObj); // add headers to beginning of rows
	        var columnsPerPage = this.$scope.columnsPerPage || 13;
	        var cellWidth = this.$scope.columnWidth || 63;
	        var fontSize = this.$scope.fontSize || 6;
	        var pdf = new PDF('landscape', 'pt', 'a4');
	        var rowHeight = this.$scope.rowHeight || 26.6;
	        var paddingLeft = 10;
	        var paddingTop = 20;
	        pdf.cellInitialize();
	        this.addColumnsToPdf(pdf, allData, paddingLeft, paddingTop, cellWidth, rowHeight, columnsPerPage, fontSize);
	        pdf.save(this.$scope.filename + ".pdf");
	    };
	    /**
	     *
	     * PDF Files
	     *
	     * This is for the style of the pdf rows/header
	     * It will add the number of specified table columns
	     * and then add a new page and continue if there are
	     * further columns
	     *
	     * @param  {any} pdf - this is the jspdf object
	     * @param  {Array<Object>} rows
	     * @param  {number} paddingLeft
	     * @param  {number} paddingTop
	     * @param  {number} cellWidth
	     * @param  {number} rowHeight
	     * @param  {number} columnsPerPage
	     * @returns void
	     */
	    ExportTable.prototype.addColumnsToPdf = function (pdf, rows, paddingLeft, paddingTop, cellWidth, rowHeight, columnsPerPage, fontSize, captured) {
	        var _this = this;
	        var nextPage = [];
	        var is = [];
	        var excess = captured || [];
	        var maxCellCharLength = 75;
	        var headers = this.$scope.sorted ? Object.keys(rows[0]).sort() : Object.keys(rows[0]);
	        var addNewPage = function () {
	            pdf.addPage();
	            pdf.setTableHeaderRow({});
	            pdf.setHeaderFunction(function () { return [10, 20, 0, 0]; }); // this resets the cell margins so that it starts at the top of new page
	            pdf.printHeaderRow();
	        };
	        /*
	         * Filter out empty rows
	         * A row will be empty if it is filtered out using query params.
	         * This prevents multiple blank pages.
	         */
	        rows = rows.filter(function (row) { return Object.keys(row).length; });
	        rows.forEach(function (row, i) {
	            var column = 0;
	            var maximumRows = _this.$scope.maximumRows || 20;
	            row = _this.createTableRow(headers, row);
	            if (i > maximumRows) {
	                is.push(row);
	            }
	            for (var key in row) {
	                if (row.hasOwnProperty(key)) {
	                    column++;
	                    pdf.setFontStyle('helvetica');
	                    pdf.setFontSize(fontSize);
	                    pdf.setTextColor(0, 0, 0);
	                    pdf.printingHeaderRow = false;
	                    if (i === 0) {
	                        pdf.printingHeaderRow = true;
	                        pdf.setFontStyle('bold');
	                        pdf.setTextColor(255, 255, 255); // text color
	                        pdf.setFillColor(51, 122, 183); // background color
	                        pdf.setDrawColor(211, 211, 211); // table outline color
	                    }
	                    ;
	                    if (column > columnsPerPage && column <= Object.keys(row).length && i <= maximumRows) {
	                        if (nextPage[i] === null || nextPage[i] === undefined) {
	                            nextPage[i] = {};
	                        }
	                        Object.assign(nextPage[i], (_a = {}, _a[key] = row[key], _a));
	                    }
	                    else if (i <= maximumRows) {
	                        var cellText = row[key];
	                        if (cellText === '') {
	                            cellText = '\ ';
	                        } // if empty string, escape a space so that it still creates a table cell
	                        if (angular.isString(cellText)) {
	                            cellText = cellText.replace(/(\r\n|\n|\r)/gm, ' ');
	                        }
	                        ; // remove any line breaks before placing in the cell
	                        if (angular.isArray(cellText)) {
	                            var joinedCellText = cellText.join('\n');
	                            if (joinedCellText.length > maxCellCharLength) {
	                                cellText = joinedCellText.substring(0, maxCellCharLength) + '...'; // max 75 characters per table cell, at smallest font
	                            }
	                        }
	                        ;
	                        pdf.cell(paddingLeft, paddingTop, cellWidth, rowHeight, cellText, i);
	                    }
	                }
	            }
	            var _a;
	        });
	        if (nextPage.length > 0) {
	            addNewPage();
	            this.addColumnsToPdf(pdf, nextPage, paddingLeft, paddingTop, cellWidth, rowHeight, columnsPerPage, fontSize, excess); // calls recursively until no new pages needed
	        }
	        if (excess.concat(is).length > 0) {
	            excess = excess.concat(is);
	            addNewPage();
	            excess.unshift(this.$scope.headerObj);
	            this.addColumnsToPdf(pdf, excess, paddingLeft, paddingTop, cellWidth, rowHeight, columnsPerPage, fontSize, []);
	        }
	    };
	    /**
	     *
	     * CSV / XSL Files
	     *
	     * If this directive is not used with a table it
	     * will use the JSON provided for the CSV file
	     *
	     * If this directive is used with a table, it will loop
	     * through the provided JSON and delete anything
	     * not in the table before it creates the CSV File
	     *
	     * @param  {Array<Object>} json
	     * @param  {string} filename
	     * @param  {object} obj
	     * @param  {any} th
	     * @returns void
	     */
	    ExportTable.prototype.exportCsv = function (jsonData, filename, obj, th) {
	        var includeHeader = this.$scope.csvHeader === undefined ? true : this.$scope.csvHeader;
	        var row = '';
	        var CSV = '';
	        if (!this.$scope.button) {
	            for (var key in obj) {
	                if (obj.hasOwnProperty(key)) {
	                    for (var _i = 0, jsonData_1 = jsonData; _i < jsonData_1.length; _i++) {
	                        var item = jsonData_1[_i];
	                        if (item[key] === null) {
	                            item[key] = '';
	                        }
	                        item[key] = item[key][obj[key]]; // changes [object Object] to the correct value
	                    }
	                }
	            }
	            for (var _a = 0, jsonData_2 = jsonData; _a < jsonData_2.length; _a++) {
	                var item = jsonData_2[_a];
	                for (var key in item) {
	                    if (item.hasOwnProperty(key)) {
	                        if (item[key] && item[key].length > 0 && item[key].constructor === Array) {
	                            item[key] = item[key].join('; '); // if any props are an array, turn it into a string, otherwise it may misalign the exported csv
	                        }
	                        if (!th.includes(key)) {
	                            delete item[key]; // remove json key/value pairs that are not inside the table
	                        }
	                    }
	                }
	            }
	        }
	        for (var index in jsonData[0]) {
	            if (jsonData[0].hasOwnProperty(index)) {
	                row += index + ","; // now convert each value to string and comma-seprated
	            }
	        }
	        row = row.slice(0, -1);
	        if (includeHeader) {
	            var columns = void 0;
	            if (this.$scope.exportTableId) {
	                columns = angular.element(document.getElementById(this.$scope.exportTableId)).find('thead').find('th');
	            }
	            else {
	                columns = angular.element(document).find('thead').find('th');
	            }
	            var headerRow = row.split(',');
	            var output = [];
	            for (var i = 0, n = headerRow.length; i < n; i++) {
	                output.push(this.getHeaderText(headerRow[i], columns));
	            }
	            CSV += output.join(',') + "\r\n"; // append header row with line break
	        }
	        for (var i = 0; i < jsonData.length; i++) {
	            var row_1 = '';
	            for (var index in jsonData[i]) {
	                if (jsonData[i].hasOwnProperty(index)) {
	                    row_1 += this.$scope.translate.instant("" + jsonData[i][index]) + ',';
	                }
	            }
	            row_1.slice(0, row_1.length - 1);
	            CSV += row_1 + "\r\n"; // add a line break after each row
	        }
	        if (CSV === '') {
	            console.error('Invalid data');
	            return;
	        }
	        filename = filename.replace(/ /g, '_'); // if blank spaces in filename, they are replaced with underscores
	        // handle EDGE and IE (do not support download attribute on <a> tag)
	        if (window.navigator.msSaveBlob) {
	            window.navigator.msSaveBlob(new Blob([CSV]), filename);
	            return;
	        }
	        var uri = "data:text/" + this.$scope.format + ";charset=utf-8," + encodeURI(CSV);
	        var link = angular.element('<a></a>');
	        link.attr('href', uri);
	        link.attr('download', filename + "." + this.$scope.format);
	        // handle CHROME and FIREFOX
	        this.click(link[0]);
	    };
	    ExportTable.prototype.click = function (target) {
	        var event = typeof (Event) === 'function'
	            ? new MouseEvent('click')
	            : document.createEvent('click');
	        target.dispatchEvent(event);
	    };
	    ExportTable.prototype.createTableRow = function (headers, object) {
	        return headers.reduce(function (tableRow, header) {
	            if (object[header] === undefined) {
	                object[header] = '';
	            }
	            tableRow[header] = object[header];
	            return tableRow;
	        }, {});
	    };
	    ExportTable.prototype.getCsvFromBackend = function () {
	        var downloadScope = this.setDownloadOauth2();
	        var downloadOAuth2 = new download_oauth2_class_1.DownloadOauth2(downloadScope, this.Restangular);
	        downloadOAuth2.generate();
	    };
	    ExportTable.prototype.setDownloadOauth2 = function () {
	        return {
	            url: this.getFullService().endpoint,
	            requestMethod: 'GET'
	        };
	    };
	    return ExportTable;
	}());
	exports.ExportTable = ExportTable;
	/**
	 * Because this directive is already on
	 * every table. Here we add fixed table headers
	 */
	function tableFixHead(e) {
	    var el = e.target;
	    var sT = el.scrollTop;
	    el.querySelectorAll('thead').forEach(function (thead) {
	        thead.style.transform = "translateY(" + sT + "px)";
	        thead.style.background = "white";
	        thead.style.backgroundClip = "padding-box";
	    });
	    el.querySelectorAll('th').forEach(function (th) {
	        th.style.background = 'white';
	        th.style.backgroundClip = "padding-box";
	    });
	}


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.jspdf=e()}(this,function(){"use strict";var t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},e=(function(){function t(t){this.value=t}function e(e){function n(i,o){try{var a=e[i](o),s=a.value;s instanceof t?Promise.resolve(s.value).then(function(t){n("next",t)},function(t){n("throw",t)}):r(a.done?"return":"normal",a.value)}catch(t){r("throw",t)}}function r(t,e){switch(t){case"return":i.resolve({value:e,done:!0});break;case"throw":i.reject(e);break;default:i.resolve({value:e,done:!1})}(i=i.next)?n(i.key,i.arg):o=null}var i,o;this._invoke=function(t,e){return new Promise(function(r,a){var s={key:t,arg:e,resolve:r,reject:a,next:null};o?o=o.next=s:(i=o=s,n(t,e))})},"function"!=typeof e.return&&(this.return=void 0)}"function"==typeof Symbol&&Symbol.asyncIterator&&(e.prototype[Symbol.asyncIterator]=function(){return this}),e.prototype.next=function(t){return this._invoke("next",t)},e.prototype.throw=function(t){return this._invoke("throw",t)},e.prototype.return=function(t){return this._invoke("return",t)}}(),function(e){function n(t){var n={};this.subscribe=function(t,e,r){if("function"!=typeof e)return!1;n.hasOwnProperty(t)||(n[t]={});var i=Math.random().toString(35);return n[t][i]=[e,!!r],i},this.unsubscribe=function(t){for(var e in n)if(n[e][t])return delete n[e][t],!0;return!1},this.publish=function(r){if(n.hasOwnProperty(r)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var a in n[r]){var s=n[r][a];try{s[0].apply(t,i)}catch(t){e.console&&console.error("jsPDF PubSub Error",t.message,t)}s[1]&&o.push(a)}o.length&&o.forEach(this.unsubscribe)}}}function i(c,l,u,h){var f={};"object"===(void 0===c?"undefined":t(c))&&(c=(f=c).orientation,l=f.unit||l,u=f.format||u,h=f.compress||f.compressPdf||h),l=l||"mm",u=u||"a4",c=(""+(c||"P")).toLowerCase();(""+u).toLowerCase();var d,p,m,g,w,y,v,b,x,k=!!h&&"function"==typeof Uint8Array,_=f.textColor||"0 g",C=f.drawColor||"0 G",A=f.fontSize||16,S=f.lineHeight||1.15,q=f.lineWidth||.200025,T=2,P=!1,I=[],E={},O={},F=0,B=[],R=[],D=[],j=[],z=[],N=0,L=0,M=0,U={title:"",subject:"",author:"",keywords:"",creator:""},H={},W=new n(H),X=f.hotfixes||[],V=function(t){return t.toFixed(2)},G=function(t){return t.toFixed(3)},Y=function(t){return("0"+parseInt(t)).slice(-2)},J=function(t){P?B[g].push(t):(M+=t.length+1,j.push(t))},Q=function(){return T++,I[T]=M,J(T+" 0 obj"),T},K=function(t){J("stream"),J(t),J("endstream")},$=function(){var t,n,r,a,s,c,l,u,h,f=[];for(l=e.adler32cs||i.adler32cs,k&&void 0===l&&(k=!1),t=1;t<=F;t++){if(f.push(Q()),u=(w=D[t].width)*p,h=(y=D[t].height)*p,J("<</Type /Page"),J("/Parent 1 0 R"),J("/Resources 2 0 R"),J("/MediaBox [0 0 "+V(u)+" "+V(h)+"]"),W.publish("putPage",{pageNumber:t,page:B[t]}),J("/Contents "+(T+1)+" 0 R"),J(">>"),J("endobj"),n=B[t].join("\n"),Q(),k){for(r=[],a=n.length;a--;)r[a]=n.charCodeAt(a);c=l.from(n),(s=new o(6)).append(new Uint8Array(r)),n=s.flush(),(r=new Uint8Array(n.length+6)).set(new Uint8Array([120,156])),r.set(n,2),r.set(new Uint8Array([255&c,c>>8&255,c>>16&255,c>>24&255]),n.length+2),n=String.fromCharCode.apply(null,r),J("<</Length "+n.length+" /Filter [/FlateDecode]>>")}else J("<</Length "+n.length+">>");K(n),J("endobj")}I[1]=M,J("1 0 obj"),J("<</Type /Pages");var d="/Kids [";for(a=0;a<F;a++)d+=f[a]+" 0 R ";J(d+"]"),J("/Count "+F),J(">>"),J("endobj"),W.publish("postPutPages")},Z=function(t){t.objectNumber=Q(),J("<</BaseFont/"+t.PostScriptName+"/Type/Font"),"string"==typeof t.encoding&&J("/Encoding/"+t.encoding),J("/Subtype/Type1>>"),J("endobj")},tt=function(){for(var t in E)E.hasOwnProperty(t)&&Z(E[t])},et=function(){W.publish("putXobjectDict")},nt=function(){J("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),J("/Font <<");for(var t in E)E.hasOwnProperty(t)&&J("/"+t+" "+E[t].objectNumber+" 0 R");J(">>"),J("/XObject <<"),et(),J(">>")},rt=function(){tt(),W.publish("putResources"),I[2]=M,J("2 0 obj"),J("<<"),nt(),J(">>"),J("endobj"),W.publish("postPutResources")},it=function(){W.publish("putAdditionalObjects");for(var t=0;t<z.length;t++){var e=z[t];I[e.objId]=M,J(e.objId+" 0 obj"),J(e.content),J("endobj")}T+=z.length,W.publish("postPutAdditionalObjects")},ot=function(t,e,n){O.hasOwnProperty(e)||(O[e]={}),O[e][n]=t},at=function(t,e,n,r){var i="F"+(Object.keys(E).length+1).toString(10),o=E[i]={id:i,PostScriptName:t,fontName:e,fontStyle:n,encoding:r,metadata:{}};return ot(i,e,n),W.publish("addFont",o),i},st=function(t,e){var n,r,i,o,a,s,c,l,u;if(e=e||{},i=e.sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&E[d].metadata&&E[d].metadata[i]&&E[d].metadata[i].encoding&&(o=E[d].metadata[i].encoding,!a&&E[d].encoding&&(a=E[d].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(c=!1,s=[],n=0,r=t.length;n<r;n++)(l=a[t.charCodeAt(n)])?s.push(String.fromCharCode(l)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(n=t.length;void 0===c&&0!==n;)t.charCodeAt(n-1)>>8&&(c=!0),n--;if(!c)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if(l=t.charCodeAt(n),(u=l>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(l-(u<<8))}return String.fromCharCode.apply(void 0,s)},ct=function(t,e){return st(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},lt=function(){J("/Producer (jsPDF "+i.version+")");for(var t in U)U.hasOwnProperty(t)&&U[t]&&J("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+ct(U[t])+")");var e=new Date,n=e.getTimezoneOffset(),r=n<0?"+":"-",o=Math.floor(Math.abs(n/60)),a=Math.abs(n%60),s=[r,Y(o),"'",Y(a),"'"].join("");J(["/CreationDate (D:",e.getFullYear(),Y(e.getMonth()+1),Y(e.getDate()),Y(e.getHours()),Y(e.getMinutes()),Y(e.getSeconds()),s,")"].join(""))},ut=function(){switch(J("/Type /Catalog"),J("/Pages 1 0 R"),b||(b="fullwidth"),b){case"fullwidth":J("/OpenAction [3 0 R /FitH null]");break;case"fullheight":J("/OpenAction [3 0 R /FitV null]");break;case"fullpage":J("/OpenAction [3 0 R /Fit]");break;case"original":J("/OpenAction [3 0 R /XYZ null null 1]");break;default:var t=""+b;"%"===t.substr(t.length-1)&&(b=parseInt(b)/100),"number"==typeof b&&J("/OpenAction [3 0 R /XYZ null null "+V(b)+"]")}switch(x||(x="continuous"),x){case"continuous":J("/PageLayout /OneColumn");break;case"single":J("/PageLayout /SinglePage");break;case"two":case"twoleft":J("/PageLayout /TwoColumnLeft");break;case"tworight":J("/PageLayout /TwoColumnRight")}v&&J("/PageMode /"+v),W.publish("putCatalog")},ht=function(){J("/Size "+(T+1)),J("/Root "+T+" 0 R"),J("/Info "+(T-1)+" 0 R")},ft=function(t,e){var n="string"==typeof e&&e.toLowerCase();if("string"==typeof t){var r=t.toLowerCase();s.hasOwnProperty(r)&&(t=s[r][0]/p,e=s[r][1]/p)}if(Array.isArray(t)&&(e=t[1],t=t[0]),n){switch(n.substr(0,1)){case"l":e>t&&(n="s");break;case"p":t>e&&(n="s")}"s"===n&&(m=t,t=e,e=m)}P=!0,B[++F]=[],D[F]={width:Number(t)||w,height:Number(e)||y},R[F]={},mt(F)},dt=function(){ft.apply(this,arguments),J(V(q*p)+" w"),J(C),0!==N&&J(N+" J"),0!==L&&J(L+" j"),W.publish("addPage",{pageNumber:F})},pt=function(t){t>0&&t<=F&&(B.splice(t,1),D.splice(t,1),g>--F&&(g=F),this.setPage(g))},mt=function(t){t>0&&t<=F&&(g=t,w=D[t].width,y=D[t].height)},gt=function(t,e){var n;switch(t=void 0!==t?t:E[d].fontName,e=void 0!==e?e:E[d].fontStyle,void 0!==t&&(t=t.toLowerCase()),t){case"sans-serif":case"verdana":case"arial":case"helvetica":t="helvetica";break;case"fixed":case"monospace":case"terminal":case"courier":t="courier";break;case"serif":case"cursive":case"fantasy":default:t="times"}try{n=O[t][e]}catch(t){}return n||null==(n=O.times[e])&&(n=O.times.normal),n},wt=function(){P=!1,T=2,M=0,j=[],I=[],z=[],W.publish("buildDocument"),J("%PDF-"+a),$(),it(),rt(),Q(),J("<<"),lt(),J(">>"),J("endobj"),Q(),J("<<"),ut(),J(">>"),J("endobj");var t,e=M,n="0000000000";for(J("xref"),J("0 "+(T+1)),J(n+" 65535 f "),t=1;t<=T;t++){var r=I[t];J("function"==typeof r?(n+I[t]()).slice(-10)+" 00000 n ":(n+I[t]).slice(-10)+" 00000 n ")}return J("trailer"),J("<<"),ht(),J(">>"),J("startxref"),J(""+e),J("%%EOF"),P=!0,j.join("\n")},yt=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e},vt=function(){for(var t=wt(),e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},bt=function(){return new Blob([vt()],{type:"application/pdf"})},xt=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var n=t.stack||"";~n.indexOf(" at ")&&(n=n.split(" at ")[1]);var r="Error in function "+n.split("\n")[0].split("<")[0]+": "+t.message;if(!e.console)throw new Error(r);e.console.error(r,t),e.alert&&alert(r)}},t.foo.bar=t,t.foo}(function(t,n){var i="dataur"===(""+t).substr(0,6)?"data:application/pdf;base64,"+btoa(wt()):0;switch(t){case void 0:return wt();case"save":if(navigator.getUserMedia&&(void 0===e.URL||void 0===e.URL.createObjectURL))return H.output("dataurlnewwindow");r(bt(),n),"function"==typeof r.unload&&e.setTimeout&&setTimeout(r.unload,911);break;case"arraybuffer":return vt();case"blob":return bt();case"bloburi":case"bloburl":return e.URL&&e.URL.createObjectURL(bt())||void 0;case"datauristring":case"dataurlstring":return i;case"dataurlnewwindow":var o=e.open(i);if(o||"undefined"==typeof safari)return o;case"datauri":case"dataurl":return e.document.location.href=i;default:throw new Error('Output type "'+t+'" is not supported.')}}),kt=function(t){return!0===Array.isArray(X)&&X.indexOf(t)>-1};switch(l){case"pt":p=1;break;case"mm":p=72/25.4000508;break;case"cm":p=72/2.54000508;break;case"in":p=72;break;case"px":p=1==kt("px_scaling")?.75:96/72;break;case"pc":case"em":p=12;break;case"ex":p=6;break;default:throw"Invalid unit: "+l}H.internal={pdfEscape:ct,getStyle:yt,getFont:function(){return E[gt.apply(H,arguments)]},getFontSize:function(){return A},getLineHeight:function(){return A*S},write:function(t){J(1===arguments.length?t:Array.prototype.join.call(arguments," "))},getCoordinateString:function(t){return V(t*p)},getVerticalCoordinateString:function(t){return V((y-t)*p)},collections:{},newObject:Q,newAdditionalObject:function(){var t=2*B.length+1,e={objId:t+=z.length,content:""};return z.push(e),e},newObjectDeferred:function(){return T++,I[T]=function(){return M},T},newObjectDeferredBegin:function(t){I[t]=M},putStream:K,events:W,scaleFactor:p,pageSize:{get width(){return w},get height(){return y}},output:function(t,e){return xt(t,e)},getNumberOfPages:function(){return B.length-1},pages:B,out:J,f2:V,getPageInfo:function(t){return{objId:2*(t-1)+3,pageNumber:t,pageContext:R[t]}},getCurrentPageInfo:function(){return{objId:2*(g-1)+3,pageNumber:g,pageContext:R[g]}},getPDFVersion:function(){return a},hasHotfix:kt},H.addPage=function(){return dt.apply(this,arguments),this},H.setPage=function(){return mt.apply(this,arguments),this},H.insertPage=function(t){return this.addPage(),this.movePage(g,t),this},H.movePage=function(t,e){if(t>e){for(var n=B[t],r=D[t],i=R[t],o=t;o>e;o--)B[o]=B[o-1],D[o]=D[o-1],R[o]=R[o-1];B[e]=n,D[e]=r,R[e]=i,this.setPage(e)}else if(t<e){for(var n=B[t],r=D[t],i=R[t],o=t;o<e;o++)B[o]=B[o+1],D[o]=D[o+1],R[o]=R[o+1];B[e]=n,D[e]=r,R[e]=i,this.setPage(e)}return this},H.deletePage=function(){return pt.apply(this,arguments),this},H.setDisplayMode=function(t,e,n){if(b=t,x=e,v=n,-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(n))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+n+'" is not recognized.');return this},H.text=function(t,e,n,r,i,o){function a(t){return t=t.split("\t").join(Array(f.TabLen||9).join(" ")),ct(t,r)}"number"==typeof t&&(m=n,n=e,e=t,t=m),"string"==typeof t&&(t=t.match(/[\n\r]/)?t.split(/\r\n|\r|\n/g):[t]),"string"==typeof i&&(o=i,i=null),"string"==typeof r&&(o=r,r=null),"number"==typeof r&&(i=r,r=null);var s="",c="Td";if(i){i*=Math.PI/180;var l=Math.cos(i),u=Math.sin(i);s=[V(l),V(u),V(-1*u),V(l),""].join(" "),c="Tm"}"noBOM"in(r=r||{})||(r.noBOM=!0),"autoencode"in r||(r.autoencode=!0);var h="",g=this.internal.getCurrentPageInfo().pageContext;if(!0===r.stroke?!0!==g.lastTextWasStroke&&(h="1 Tr\n",g.lastTextWasStroke=!0):(g.lastTextWasStroke&&(h="0 Tr\n"),g.lastTextWasStroke=!1),void 0===this._runningPageHeight&&(this._runningPageHeight=0),"string"==typeof t)t=a(t);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');for(var w=t.concat(),v=[],b=w.length;b--;)v.push(a(w.shift()));if(o){var x,k,C,q=A*S,T=t.map(function(t){return this.getStringUnitWidth(t)*A/p},this);if(C=Math.max.apply(Math,T),"center"===o)x=e-C/2,e-=T[0]/2;else{if("right"!==o)throw new Error('Unrecognized alignment option, use "center" or "right".');x=e-C,e-=T[0]}k=e,t=v[0];for(var P=1,b=v.length;P<b;P++){var I=C-T[P];"center"===o&&(I/=2),t+=") Tj\n"+(x-k+I)+" -"+q+" Td ("+v[P],k=x+I}}else t=v.join(") Tj\nT* (")}var E;return E=V((y-n)*p),J("BT\n/"+d+" "+A+" Tf\n"+A*S+" TL\n"+h+_+"\n"+s+V(e*p)+" "+E+" "+c+"\n("+t+") Tj\nET"),this},H.lstext=function(t,e,n,r){console.warn("jsPDF.lstext is deprecated");for(var i=0,o=t.length;i<o;i++,e+=r)this.text(t[i],e,n);return this},H.line=function(t,e,n,r){return this.lines([[n-t,r-e]],t,e)},H.clip=function(){J("W"),J("S")},H.clip_fixed=function(t){J("evenodd"===t?"W*":"W"),J("n")},H.lines=function(t,e,n,r,i,o){var a,s,c,l,u,h,f,d,g,w,v;for("number"==typeof t&&(m=n,n=e,e=t,t=m),r=r||[1,1],J(G(e*p)+" "+G((y-n)*p)+" m "),a=r[0],s=r[1],l=t.length,w=e,v=n,c=0;c<l;c++)2===(u=t[c]).length?(w=u[0]*a+w,v=u[1]*s+v,J(G(w*p)+" "+G((y-v)*p)+" l")):(h=u[0]*a+w,f=u[1]*s+v,d=u[2]*a+w,g=u[3]*s+v,w=u[4]*a+w,v=u[5]*s+v,J(G(h*p)+" "+G((y-f)*p)+" "+G(d*p)+" "+G((y-g)*p)+" "+G(w*p)+" "+G((y-v)*p)+" c"));return o&&J(" h"),null!==i&&J(yt(i)),this},H.rect=function(t,e,n,r,i){yt(i);return J([V(t*p),V((y-e)*p),V(n*p),V(-r*p),"re"].join(" ")),null!==i&&J(yt(i)),this},H.triangle=function(t,e,n,r,i,o,a){return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},H.roundedRect=function(t,e,n,r,i,o,a){var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},H.ellipse=function(t,e,n,r,i){var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return J([V((t+n)*p),V((y-e)*p),"m",V((t+n)*p),V((y-(e-a))*p),V((t+o)*p),V((y-(e-r))*p),V(t*p),V((y-(e-r))*p),"c"].join(" ")),J([V((t-o)*p),V((y-(e-r))*p),V((t-n)*p),V((y-(e-a))*p),V((t-n)*p),V((y-e)*p),"c"].join(" ")),J([V((t-n)*p),V((y-(e+a))*p),V((t-o)*p),V((y-(e+r))*p),V(t*p),V((y-(e+r))*p),"c"].join(" ")),J([V((t+o)*p),V((y-(e+r))*p),V((t+n)*p),V((y-(e+a))*p),V((t+n)*p),V((y-e)*p),"c"].join(" ")),null!==i&&J(yt(i)),this},H.circle=function(t,e,n,r){return this.ellipse(t,e,n,n,r)},H.setProperties=function(t){for(var e in U)U.hasOwnProperty(e)&&t[e]&&(U[e]=t[e]);return this},H.setFontSize=function(t){return A=t,this},H.setFont=function(t,e){return d=gt(t,e),this},H.setFontStyle=H.setFontType=function(t){return d=gt(void 0,t),this},H.getFontList=function(){var t,e,n,r={};for(t in O)if(O.hasOwnProperty(t)){r[t]=n=[];for(e in O[t])O[t].hasOwnProperty(e)&&n.push(e)}return r},H.addFont=function(t,e,n){at(t,e,n,"StandardEncoding")},H.setLineWidth=function(t){return J((t*p).toFixed(2)+" w"),this},H.setDrawColor=function(t,e,n,r){var i;return i=void 0===e||void 0===r&&t===e===n?"string"==typeof t?t+" G":V(t/255)+" G":void 0===r?"string"==typeof t?[t,e,n,"RG"].join(" "):[V(t/255),V(e/255),V(n/255),"RG"].join(" "):"string"==typeof t?[t,e,n,r,"K"].join(" "):[V(t),V(e),V(n),V(r),"K"].join(" "),J(i),this},H.setFillColor=function(e,n,r,i){var o;return void 0===n||void 0===i&&e===n===r?o="string"==typeof e?e+" g":V(e/255)+" g":void 0===i||"object"===(void 0===i?"undefined":t(i))?(o="string"==typeof e?[e,n,r,"rg"].join(" "):[V(e/255),V(n/255),V(r/255),"rg"].join(" "),i&&0===i.a&&(o=["255","255","255","rg"].join(" "))):o="string"==typeof e?[e,n,r,i,"k"].join(" "):[V(e),V(n),V(r),V(i),"k"].join(" "),J(o),this},H.setTextColor=function(t,e,n){if("string"==typeof t&&/^#[0-9A-Fa-f]{6}$/.test(t)){var r=parseInt(t.substr(1),16);t=r>>16&255,e=r>>8&255,n=255&r}return _=0===t&&0===e&&0===n||void 0===e?G(t/255)+" g":[G(t/255),G(e/255),G(n/255),"rg"].join(" "),this},H.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},H.setLineCap=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return N=e,J(e+" J"),this},H.setLineJoin=function(t){var e=this.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return L=e,J(e+" j"),this},H.output=xt,H.save=function(t){H.output("save",t)};for(var _t in i.API)i.API.hasOwnProperty(_t)&&("events"===_t&&i.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(W,i.API.events):H[_t]=i.API[_t]);return function(){for(var t=[["Helvetica","helvetica","normal"],["Helvetica-Bold","helvetica","bold"],["Helvetica-Oblique","helvetica","italic"],["Helvetica-BoldOblique","helvetica","bolditalic"],["Courier","courier","normal"],["Courier-Bold","courier","bold"],["Courier-Oblique","courier","italic"],["Courier-BoldOblique","courier","bolditalic"],["Times-Roman","times","normal"],["Times-Bold","times","bold"],["Times-Italic","times","italic"],["Times-BoldItalic","times","bolditalic"],["ZapfDingbats","zapfdingbats"]],e=0,n=t.length;e<n;e++){var r=at(t[e][0],t[e][1],t[e][2],"StandardEncoding"),i=t[e][0].split("-");ot(r,i[0],i[1]||"")}W.publish("addFonts",{fonts:E,dictionary:O})}(),d="F1",dt(u,c),W.publish("initialized"),H}var a="1.3",s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};return i.API={events:[]},i.version="1.x-master","function"==typeof define&&define.amd?define("jsPDF",function(){return i}):"undefined"!=typeof module&&module.exports?module.exports=i:e.jsPDF=i,i}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0));/**
	 * jsPDF AcroForm Plugin
	 * Copyright (c) 2016 Alexander Weidt, https://github.com/BiggA94
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	(window.AcroForm=function(t){var n=window.AcroForm;n.scale=function(t){return t*(r.internal.scaleFactor/1)},n.antiScale=function(t){return 1/r.internal.scaleFactor*t};var r={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null};e.API.acroformPlugin=r;var i=function(){for(var t in this.acroformPlugin.acroFormDictionaryRoot.Fields){var e=this.acroformPlugin.acroFormDictionaryRoot.Fields[t];e.hasAnnotation&&a.call(this,e)}},o=function(){if(this.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");this.acroformPlugin.acroFormDictionaryRoot=new n.AcroFormDictionary,this.acroformPlugin.internal=this.internal,this.acroformPlugin.acroFormDictionaryRoot._eventID=this.internal.events.subscribe("postPutResources",l),this.internal.events.subscribe("buildDocument",i),this.internal.events.subscribe("putCatalog",c),this.internal.events.subscribe("postPutPages",u)},a=function(t){var n={type:"reference",object:t};e.API.annotationPlugin.annotations[this.internal.getPageInfo(t.page).pageNumber].push(n)},s=function(t){this.acroformPlugin.printedOut&&(this.acroformPlugin.printedOut=!1,this.acroformPlugin.acroFormDictionaryRoot=null),this.acroformPlugin.acroFormDictionaryRoot||o.call(this),this.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)},c=function(){void 0!==this.acroformPlugin.acroFormDictionaryRoot?this.internal.write("/AcroForm "+this.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R"):console.log("Root missing...")},l=function(){this.internal.events.unsubscribe(this.acroformPlugin.acroFormDictionaryRoot._eventID),delete this.acroformPlugin.acroFormDictionaryRoot._eventID,this.acroformPlugin.printedOut=!0},u=function(t){var e=!t;t||(this.internal.newObjectDeferredBegin(this.acroformPlugin.acroFormDictionaryRoot.objId),this.internal.out(this.acroformPlugin.acroFormDictionaryRoot.getString()));var t=t||this.acroformPlugin.acroFormDictionaryRoot.Kids;for(var r in t){var i=t[r],o=i.Rect;i.Rect&&(i.Rect=n.internal.calculateCoordinates.call(this,i.Rect)),this.internal.newObjectDeferredBegin(i.objId);var a="";if(a+=i.objId+" 0 obj\n",a+="<<\n"+i.getContent(),i.Rect=o,i.hasAppearanceStream&&!i.appearanceStreamContent){var s=n.internal.calculateAppearanceStream.call(this,i);a+="/AP << /N "+s+" >>\n",this.acroformPlugin.xForms.push(s)}if(i.appearanceStreamContent){a+="/AP << ";for(var c in i.appearanceStreamContent){var l=i.appearanceStreamContent[c];if(a+="/"+c+" ",a+="<< ",Object.keys(l).length>=1||Array.isArray(l))for(var r in l)"function"==typeof(u=l[r])&&(u=u.call(this,i)),a+="/"+r+" "+u+" ",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u);else{var u=l;"function"==typeof u&&(u=u.call(this,i)),a+="/"+r+" "+u+" \n",this.acroformPlugin.xForms.indexOf(u)>=0||this.acroformPlugin.xForms.push(u)}a+=" >>\n"}a+=">>\n"}a+=">>\nendobj\n",this.internal.out(a)}e&&h.call(this,this.acroformPlugin.xForms)},h=function(t){for(var e in t){var n=e,r=t[e];this.internal.newObjectDeferredBegin(r&&r.objId);var i="";i+=r?r.getString():"",this.internal.out(i),delete t[n]}};t.addField=function(t){return t instanceof n.TextField?d.call(this,t):t instanceof n.ChoiceField?p.call(this,t):t instanceof n.Button?f.call(this,t):t instanceof n.ChildClass?s.call(this,t):t&&s.call(this,t),t.page=this.acroformPlugin.internal.getCurrentPageInfo().pageNumber,this};var f=function(t){(t=t||new n.Field).FT="/Btn";var e=t.Ff||0;t.pushbutton&&(e=n.internal.setBitPosition(e,17),delete t.pushbutton),t.radio&&(e=n.internal.setBitPosition(e,16),delete t.radio),t.noToggleToOff&&(e=n.internal.setBitPosition(e,15)),t.Ff=e,s.call(this,t)},d=function(t){(t=t||new n.Field).FT="/Tx";var e=t.Ff||0;t.multiline&&(e|=4096),t.password&&(e|=8192),t.fileSelect&&(e|=1<<20),t.doNotSpellCheck&&(e|=1<<22),t.doNotScroll&&(e|=1<<23),t.Ff=t.Ff||e,s.call(this,t)},p=function(t){var e=t||new n.Field;e.FT="/Ch";var r=e.Ff||0;e.combo&&(r=n.internal.setBitPosition(r,18),delete e.combo),e.edit&&(r=n.internal.setBitPosition(r,19),delete e.edit),e.sort&&(r=n.internal.setBitPosition(r,20),delete e.sort),e.multiSelect&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,22),delete e.multiSelect),e.doNotSpellCheck&&this.internal.getPDFVersion()>=1.4&&(r=n.internal.setBitPosition(r,23),delete e.doNotSpellCheck),e.Ff=r,s.call(this,e)}})(e.API);var n=window.AcroForm;n.internal={},n.createFormXObject=function(t){var e=new n.FormXObject,r=n.Appearance.internal.getHeight(t)||0,i=n.Appearance.internal.getWidth(t)||0;return e.BBox=[0,0,i,r],e},n.Appearance={CheckBox:{createAppearanceStream:function(){return{N:{On:n.Appearance.CheckBox.YesNormal},D:{On:n.Appearance.CheckBox.YesPushDown,Off:n.Appearance.CheckBox.OffPushDown}}},createMK:function(){return"<< /CA (3)>>"},YesPushDown:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",50);return r+="0.749023 g\n             0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n             f\n             BMC\n             q\n             0 0 1 rg\n             /F13 "+i.fontSize+" Tf 0 g\n             BT\n",r+=i.text,r+="ET\n             Q\n             EMC\n",e.stream=r,e},YesNormal:function(t){var e=n.createFormXObject(t),r="";t.Q=1;var i=n.internal.calculateX(t,"3","ZapfDingbats",.9*n.Appearance.internal.getHeight(t));return r+="1 g\n0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\nf\nq\n0 0 1 rg\n0 0 "+(n.Appearance.internal.getWidth(t)-1)+" "+(n.Appearance.internal.getHeight(t)-1)+" re\nW\nn\n0 g\nBT\n/F13 "+i.fontSize+" Tf 0 g\n",r+=i.text,r+="ET\n             Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Circle.YesNormal,e.D[t]=n.Appearance.RadioButton.Circle.YesPushDown,e},createMK:function(){return"<< /CA (l)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4;i*=.9;var o=n.Appearance.internal.Bezier_C;return r+="q\n1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+i*o+" "+i*o+" "+i+" 0 "+i+" c\n-"+i*o+" "+i+" -"+i+" "+i*o+" -"+i+" 0 c\n-"+i+" -"+i*o+" -"+i*o+" -"+i+" 0 -"+i+" c\n"+i*o+" -"+i+" "+i+" -"+i*o+" "+i+" 0 c\nf\nQ\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4,o=2*(i*=.9),a=o*n.Appearance.internal.Bezier_C,s=i*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n           1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n            0 g\n            q\n            1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+i+" 0 m\n"+i+" "+s+" "+s+" "+i+" 0 "+i+" c\n-"+s+" "+i+" -"+i+" "+s+" -"+i+" 0 c\n-"+i+" -"+s+" -"+s+" -"+i+" 0 -"+i+" c\n"+s+" -"+i+" "+i+" -"+s+" "+i+" 0 c\n            f\n            Q\n",e.stream=r,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.getWidth(t)<=n.Appearance.internal.getHeight(t)?n.Appearance.internal.getWidth(t)/4:n.Appearance.internal.getHeight(t)/4,o=2*(i*=.9),a=o*n.Appearance.internal.Bezier_C;return r+="0.749023 g\n            q\n 1 0 0 1 "+n.Appearance.internal.getWidth(t)/2+" "+n.Appearance.internal.getHeight(t)/2+" cm\n"+o+" 0 m\n"+o+" "+a+" "+a+" "+o+" 0 "+o+" c\n-"+a+" "+o+" -"+o+" "+a+" -"+o+" 0 c\n-"+o+" -"+a+" -"+a+" -"+o+" 0 -"+o+" c\n"+a+" -"+o+" "+o+" -"+a+" "+o+" 0 c\n            f\n            Q\n",e.stream=r,e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:n.Appearance.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=n.Appearance.RadioButton.Cross.YesNormal,e.D[t]=n.Appearance.RadioButton.Cross.YesPushDown,e},createMK:function(){return"<< /CA (8)>>"},YesNormal:function(t){var e=n.createFormXObject(t),r="",i=n.Appearance.internal.calculateCross(t);return r+="q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+i.x1.x+" "+i.x1.y+" m\n            "+i.x2.x+" "+i.x2.y+" l\n            "+i.x4.x+" "+i.x4.y+" m\n            "+i.x3.x+" "+i.x3.y+" l\n            s\n            Q\n",e.stream=r,e},YesPushDown:function(t){var e=n.createFormXObject(t),r=n.Appearance.internal.calculateCross(t),i="";return i+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n            q\n            1 1 "+(n.Appearance.internal.getWidth(t)-2)+" "+(n.Appearance.internal.getHeight(t)-2)+" re\n            W\n            n\n            "+r.x1.x+" "+r.x1.y+" m\n            "+r.x2.x+" "+r.x2.y+" l\n            "+r.x4.x+" "+r.x4.y+" m\n            "+r.x3.x+" "+r.x3.y+" l\n            s\n            Q\n",e.stream=i,e},OffPushDown:function(t){var e=n.createFormXObject(t),r="";return r+="0.749023 g\n            0 0 "+n.Appearance.internal.getWidth(t)+" "+n.Appearance.internal.getHeight(t)+" re\n            f\n",e.stream=r,e}}},createDefaultAppearanceStream:function(t){var e="";return e+="/Helv 0 Tf 0 g"}},n.Appearance.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=n.Appearance.internal.getWidth(t),r=n.Appearance.internal.getHeight(t),i=function(t,e){return t>e?e:t}(e,r);return{x1:{x:(e-i)/2,y:(r-i)/2+i},x2:{x:(e-i)/2+i,y:(r-i)/2},x3:{x:(e-i)/2,y:(r-i)/2},x4:{x:(e-i)/2+i,y:(r-i)/2+i}}}},n.Appearance.internal.getWidth=function(t){return t.Rect[2]},n.Appearance.internal.getHeight=function(t){return t.Rect[3]},n.internal.inherit=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},n.internal.arrayToPdfArray=function(t){if(Array.isArray(t)){var e=" [";for(var n in t)e+=t[n].toString(),e+=n<t.length-1?" ":"";return e+="]"}},n.internal.toPdfString=function(t){return 0!==(t=t||"").indexOf("(")&&(t="("+t),")"!=t.substring(t.length-1)&&(t+="("),t},n.PDFObject=function(){var t;Object.defineProperty(this,"objId",{get:function(){return t||(this.internal?t=this.internal.newObjectDeferred():e.API.acroformPlugin.internal&&(t=e.API.acroformPlugin.internal.newObjectDeferred())),t||console.log("Couldn't create Object ID"),t},configurable:!1})},n.PDFObject.prototype.toString=function(){return this.objId+" 0 R"},n.PDFObject.prototype.getString=function(){var t=this.objId+" 0 obj\n<<";return t+=this.getContent()+">>\n",this.stream&&(t+="stream\n",t+=this.stream,t+="endstream\n"),t+="endobj\n"},n.PDFObject.prototype.getContent=function(){var t="";return t+=function(t){var e="",r=Object.keys(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var i in r){var o=r[i],a=t[o];a&&(Array.isArray(a)?e+="/"+o+" "+n.internal.arrayToPdfArray(a)+"\n":a instanceof n.PDFObject?e+="/"+o+" "+a.objId+" 0 R\n":e+="/"+o+" "+a+"\n")}return e}(this)},n.FormXObject=function(){n.PDFObject.call(this),this.Type="/XObject",this.Subtype="/Form",this.FormType=1,this.BBox,this.Matrix,this.Resources="2 0 R",this.PieceInfo;var t;Object.defineProperty(this,"Length",{enumerable:!0,get:function(){return void 0!==t?t.length:0}}),Object.defineProperty(this,"stream",{enumerable:!1,set:function(e){t=e},get:function(){return t||null}})},n.internal.inherit(n.FormXObject,n.PDFObject),n.AcroFormDictionary=function(){n.PDFObject.call(this);var t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return t.length>0?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!0,configurable:!0,get:function(){return t}}),this.DA},n.internal.inherit(n.AcroFormDictionary,n.PDFObject),n.Field=function(){n.PDFObject.call(this);var t;Object.defineProperty(this,"Rect",{enumerable:!0,configurable:!1,get:function(){if(t)return t},set:function(e){t=e}});var e="";Object.defineProperty(this,"FT",{enumerable:!0,set:function(t){e=t},get:function(){return e}});var r;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,set:function(t){r=t},get:function(){if(!r||r.length<1){if(this instanceof n.ChildClass)return;return"(FieldObject"+n.Field.FieldNum+++")"}return"("==r.substring(0,1)&&r.substring(r.length-1)?r:"("+r+")"}});var i;Object.defineProperty(this,"DA",{enumerable:!0,get:function(){if(i)return"("+i+")"},set:function(t){i=t}});var o;Object.defineProperty(this,"DV",{enumerable:!0,configurable:!0,get:function(){if(o)return o},set:function(t){o=t}}),Object.defineProperty(this,"Type",{enumerable:!0,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,get:function(){return this.hasAnnotation?"/Widget":null}}),this.BG,Object.defineProperty(this,"hasAnnotation",{enumerable:!1,get:function(){return!!(this.Rect||this.BC||this.BG)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,configurable:!0,writable:!0}),Object.defineProperty(this,"page",{enumerable:!1,configurable:!0,writable:!0})},n.Field.FieldNum=0,n.internal.inherit(n.Field,n.PDFObject),n.ChoiceField=function(){n.Field.call(this),this.FT="/Ch",this.Opt=[],this.V="()",this.TI=0,this.combo=!1,Object.defineProperty(this,"edit",{enumerable:!0,set:function(t){1==t?(this._edit=!0,this.combo=!0):this._edit=!1},get:function(){return!!this._edit&&this._edit},configurable:!1}),this.hasAppearanceStream=!0,Object.defineProperty(this,"V",{get:function(){n.internal.toPdfString()}})},n.internal.inherit(n.ChoiceField,n.Field),window.ChoiceField=n.ChoiceField,n.ListBox=function(){n.ChoiceField.call(this)},n.internal.inherit(n.ListBox,n.ChoiceField),window.ListBox=n.ListBox,n.ComboBox=function(){n.ListBox.call(this),this.combo=!0},n.internal.inherit(n.ComboBox,n.ListBox),window.ComboBox=n.ComboBox,n.EditBox=function(){n.ComboBox.call(this),this.edit=!0},n.internal.inherit(n.EditBox,n.ComboBox),window.EditBox=n.EditBox,n.Button=function(){n.Field.call(this),this.FT="/Btn"},n.internal.inherit(n.Button,n.Field),window.Button=n.Button,n.PushButton=function(){n.Button.call(this),this.pushbutton=!0},n.internal.inherit(n.PushButton,n.Button),window.PushButton=n.PushButton,n.RadioButton=function(){n.Button.call(this),this.radio=!0;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,get:function(){if(t.length>0)return t}}),Object.defineProperty(this,"__Kids",{get:function(){return t}});var e;Object.defineProperty(this,"noToggleToOff",{enumerable:!1,get:function(){return e},set:function(t){e=t}})},n.internal.inherit(n.RadioButton,n.Button),window.RadioButton=n.RadioButton,n.ChildClass=function(t,e){n.Field.call(this),this.Parent=t,this._AppearanceType=n.Appearance.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(e),this.F=n.internal.setBitPosition(this.F,3,1),this.MK=this._AppearanceType.createMK(),this.AS="/Off",this._Name=e},n.internal.inherit(n.ChildClass,n.Field),n.RadioButton.prototype.setAppearance=function(t){if("createAppearanceStream"in t&&"createMK"in t)for(var e in this.__Kids){var n=this.__Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n._Name),n.MK=t.createMK()}else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!")},n.RadioButton.prototype.createOption=function(t){var r=this,i=new n.ChildClass(r,t);return this.__Kids.push(i),e.API.addField(i),i},n.CheckBox=function(){Button.call(this),this.appearanceStreamContent=n.Appearance.CheckBox.createAppearanceStream(),this.MK=n.Appearance.CheckBox.createMK(),this.AS="/On",this.V="/On"},n.internal.inherit(n.CheckBox,n.Button),window.CheckBox=n.CheckBox,n.TextField=function(){n.Field.call(this),this.DA=n.Appearance.createDefaultAppearanceStream(),this.F=4;var t;Object.defineProperty(this,"V",{get:function(){return t?"("+t+")":t},enumerable:!0,set:function(e){t=e}});var e;Object.defineProperty(this,"DV",{get:function(){return e?"("+e+")":e},enumerable:!0,set:function(t){e=t}});var r=!1;Object.defineProperty(this,"multiline",{enumerable:!1,get:function(){return r},set:function(t){r=t}});var i=!1;Object.defineProperty(this,"MaxLen",{enumerable:!0,get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!1,get:function(){return this.V||this.DV}})},n.internal.inherit(n.TextField,n.Field),window.TextField=n.TextField,n.PasswordField=function(){TextField.call(this),Object.defineProperty(this,"password",{value:!0,enumerable:!1,configurable:!1,writable:!1})},n.internal.inherit(n.PasswordField,n.TextField),window.PasswordField=n.PasswordField,n.internal.calculateFontSpace=function(t,e,r){var r=r||"helvetica",i=n.internal.calculateFontSpace.canvas||(n.internal.calculateFontSpace.canvas=document.createElement("canvas"));(s=i.getContext("2d")).save();var o=e+" "+r;s.font=o;var a=s.measureText(t);s.fontcolor="black";var s=i.getContext("2d");return a.height=1.5*s.measureText("3").width,s.restore(),a},n.internal.calculateX=function(t,e,r,i){var i=i||12,r=r||"helvetica",o={text:"",fontSize:""},a=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" "),s=i,c=n.Appearance.internal.getHeight(t)||0;c=c<0?-c:c;var l=n.Appearance.internal.getWidth(t)||0;l=l<0?-l:l;s++;t:for(;;){var e="";s--;var u=n.internal.calculateFontSpace("3",s+"px",r).height,h=t.multiline?c-s:(c-u)/2,f=-2,d=h+=2,p=0,m=0,g=0;if(0==s){s=12,e="(...) Tj\n",e+="% Width of Text: "+n.internal.calculateFontSpace(e,"1px").width+", FieldWidth:"+l+"\n";break}g=n.internal.calculateFontSpace(a[0]+" ",s+"px",r).width;var w="",y=0;for(var v in a){w=" "==(w+=a[v]+" ").substr(w.length-1)?w.substr(0,w.length-1):w;var b=parseInt(v);g=n.internal.calculateFontSpace(w+" ",s+"px",r).width;var x=function(t,e,i){if(t+1<a.length){var o=e+" "+a[t+1];return n.internal.calculateFontSpace(o,i+"px",r).width<=l-4}return!1}(b,w,s),k=v>=a.length-1;if(!x||k){if(x||k){if(k)m=b;else if(t.multiline&&(u+2)*(y+2)+2>c)continue t}else{if(!t.multiline)continue t;if((u+2)*(y+2)+2>c)continue t;m=b}for(var _="",C=p;C<=m;C++)_+=a[C]+" ";switch(_=" "==_.substr(_.length-1)?_.substr(0,_.length-1):_,g=n.internal.calculateFontSpace(_,s+"px",r).width,t.Q){case 2:f=l-g-2;break;case 1:f=(l-g)/2;break;case 0:default:f=2}e+=f+" "+d+" Td\n",e+="("+_+") Tj\n",e+=-f+" 0 Td\n",d=-(s+2),g=0,p=m+1,y++,w=""}else w+=" "}break}return o.text=e,o.fontSize=s,o},n.internal.calculateAppearanceStream=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e="",r=t.V||t.DV,i=n.internal.calculateX(t,r);e+="/Tx BMC\nq\n/F1 "+i.fontSize+" Tf\n1 0 0 1 0 0 Tm\n",e+="BT\n",e+=i.text,e+="ET\n",e+="Q\nEMC\n";var o=new n.createFormXObject(t);return o.stream=e,o}},n.internal.calculateCoordinates=function(t,e,r,i){var o={};if(this.internal){var a=function(t){return t*this.internal.scaleFactor};Array.isArray(t)?(t[0]=n.scale(t[0]),t[1]=n.scale(t[1]),t[2]=n.scale(t[2]),t[3]=n.scale(t[3]),o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=a.call(this,this.internal.pageSize.height)-t[3]-t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=a.call(this,this.internal.pageSize.height)-t[1]||0):(t=n.scale(t),e=n.scale(e),r=n.scale(r),i=n.scale(i),o.lowerLeft_X=t||0,o.lowerLeft_Y=this.internal.pageSize.height-e||0,o.upperRight_X=t+r||0,o.upperRight_Y=this.internal.pageSize.height-e+i||0)}else Array.isArray(t)?(o.lowerLeft_X=t[0]||0,o.lowerLeft_Y=t[1]||0,o.upperRight_X=t[0]+t[2]||0,o.upperRight_Y=t[1]+t[3]||0):(o.lowerLeft_X=t||0,o.lowerLeft_Y=e||0,o.upperRight_X=t+r||0,o.upperRight_Y=e+i||0);return[o.lowerLeft_X,o.lowerLeft_Y,o.upperRight_X,o.upperRight_Y]},n.internal.calculateColor=function(t,e,n){var r=new Array(3);return r.r=0|t,r.g=0|e,r.b=0|n,r},n.internal.getBitPosition=function(t,e){var n=1;return n<<=e-1,(t=t||0)|n},n.internal.setBitPosition=function(t,e,n){t=t||0;var r=1;if(r<<=e-1,1==(n=n||1))t=t|r;else var t=t&~r;return t},e.API.addHTML=function(t,e,n,r,i){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof e&&(r=e,i=n),"function"==typeof r&&(i=r,r=null);var o=this.internal,a=o.scaleFactor,s=o.pageSize.width,c=o.pageSize.height;if(r=r||{},r.onrendered=function(t){e=parseInt(e)||0,n=parseInt(n)||0;var o=r.dim||{},l=o.h||0,u=o.w||Math.min(s,t.width/a)-e,h="JPEG";if(r.format&&(h=r.format),t.height>c&&r.pagesplit){var f=function(){for(var r=0;;){var o=document.createElement("canvas");o.width=Math.min(s*a,t.width),o.height=Math.min(c*a,t.height-r),o.getContext("2d").drawImage(t,0,r,t.width,o.height,0,0,o.width,o.height);var l=[o,e,r?0:n,o.width/a,o.height/a,h,null,"SLOW"];if(this.addImage.apply(this,l),(r+=o.height)>=t.height)break;this.addPage()}i(u,r,null,l)}.bind(this);if("CANVAS"===t.nodeName){var d=new Image;d.onload=f,d.src=t.toDataURL("image/png"),t=d}else f()}else{var p=Math.random().toString(35),m=[t,e,n,u,l,h,p,"SLOW"];this.addImage.apply(this,m),i(u,l,p,m)}}.bind(this),"undefined"!=typeof html2canvas&&!r.rstz)return html2canvas(t,r);if("undefined"!=typeof rasterizeHTML){var l="drawDocument";return"string"==typeof t&&(l=/^http/.test(t)?"drawURL":"drawHTML"),r.width=r.width||s*a,rasterizeHTML[l](t,void 0,r).then(function(t){r.onrendered(t.image)},function(t){i(null,t)})}return null},/** @preserve
	 * jsPDF addImage plugin
	 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	 *               2013 Chris Dowling, https://github.com/gingerchris
	 *               2013 Trinh Ho, https://github.com/ineedfat
	 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	 *               2013 Norah Smith, https://github.com/burnburnrocket
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 */
	function(e){var n=["jpeg","jpg","png"],r=function t(e){var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream;if(e.n=n,r("<</Type /XObject"),r("/Subtype /Image"),r("/Width "+e.w),r("/Height "+e.h),e.cs===this.color_spaces.INDEXED?r("/ColorSpace [/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"):(r("/ColorSpace /"+e.cs),e.cs===this.color_spaces.DEVICE_CMYK&&r("/Decode [1 0 1 0 1 0 1 0]")),r("/BitsPerComponent "+e.bpc),"f"in e&&r("/Filter /"+e.f),"dp"in e&&r("/DecodeParms <<"+e.dp+">>"),"trns"in e&&e.trns.constructor==Array){for(var o="",a=0,s=e.trns.length;a<s;a++)o+=e.trns[a]+" "+e.trns[a]+" ";r("/Mask ["+o+"]")}if("smask"in e&&r("/SMask "+(n+1)+" 0 R"),r("/Length "+e.data.length+">>"),i(e.data),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,l={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(l.f=e.f),t.call(this,l)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),r("<< /Length "+e.pal.length+">>"),i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))),r("endobj"))},i=function(){var t=this.internal.collections.addImage_images;for(var e in t)r.call(this,t[e])},o=function(){var t,e=this.internal.collections.addImage_images,n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},a=function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:e.image_compression.NONE},s=function(){var t=this.internal.collections.addImage_images;return t||(this.internal.collections.addImage_images=t={},this.internal.events.subscribe("putResources",i),this.internal.events.subscribe("putXobjectDict",o)),t},c=function(t){var e=0;return t&&(e=Object.keys?Object.keys(t).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(t)),e},l=function(t){return void 0===t||null===t},u=function(t){return"string"==typeof t&&e.sHashCode(t)},h=function(t){return-1===n.indexOf(t)},f=function(t){return"function"!=typeof e["process"+t.toUpperCase()]},d=function(e){return"object"===(void 0===e?"undefined":t(e))&&1===e.nodeType},p=function(e,n,r){if("IMG"===e.nodeName&&e.hasAttribute("src")){var i=""+e.getAttribute("src");if(!r&&0===i.indexOf("data:image/"))return i;!n&&/\.png(?:[?#].*)?$/i.test(i)&&(n="png")}if("CANVAS"===e.nodeName)var o=e;else{(o=document.createElement("canvas")).width=e.clientWidth||e.width,o.height=e.clientHeight||e.height;var a=o.getContext("2d");if(!a)throw"addImage requires canvas to be supported by browser.";if(r){var s,c,l,u,h,f,d,p,m=Math.PI/180;"object"===(void 0===r?"undefined":t(r))&&(s=r.x,c=r.y,l=r.bg,r=r.angle),p=r*m,u=Math.abs(Math.cos(p)),h=Math.abs(Math.sin(p)),f=o.width,d=o.height,o.width=d*h+f*u,o.height=d*u+f*h,isNaN(s)&&(s=o.width/2),isNaN(c)&&(c=o.height/2),a.clearRect(0,0,o.width,o.height),a.fillStyle=l||"white",a.fillRect(0,0,o.width,o.height),a.save(),a.translate(s,c),a.rotate(p),a.drawImage(e,-f/2,-d/2),a.rotate(-p),a.translate(-s,-c),a.restore()}else a.drawImage(e,0,0,o.width,o.height)}return o.toDataURL("png"==(""+n).toLowerCase()?"image/png":"image/jpeg")},m=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n},g=function(t,e,n){return t||e||(t=-96,e=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]},w=function(t,e,n,r,i,o,a){var s=g.call(this,n,r,i),c=this.internal.getCoordinateString,l=this.internal.getVerticalCoordinateString;n=s[0],r=s[1],a[o]=i,this.internal.write("q",c(n),"0 0",c(r),c(t),l(e+r),"cm /I"+i.i,"Do Q")};e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},e.sHashCode=function(t){return Array.prototype.reduce&&t.split("").reduce(function(t,e){return(t=(t<<5)-t+e.charCodeAt(0))&t},0)},e.isString=function(t){return"string"==typeof t},e.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(t)},e.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},e.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},e.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},e.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},e.arrayBufferToBinaryString=function(t){if("function"==typeof window.atob)return atob(this.arrayBufferToBase64(t));for(var e=this.isArrayBuffer(t)?t:new Uint8Array(t),n="",r=Math.round(e.byteLength/20480),i=0;i<r;i++)n+=String.fromCharCode.apply(null,e.slice(20480*i,20480*i+20480));return n},e.arrayBufferToBase64=function(t){for(var e,n,r,i,o="",a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=new Uint8Array(t),c=s.byteLength,l=c%3,u=c-l,h=0;h<u;h+=3)e=(258048&(i=s[h]<<16|s[h+1]<<8|s[h+2]))>>12,n=(4032&i)>>6,r=63&i,o+=a[(16515072&i)>>18]+a[e]+a[n]+a[r];return 1==l?(e=(3&(i=s[u]))<<4,o+=a[(252&i)>>2]+a[e]+"=="):2==l&&(e=(1008&(i=s[u]<<8|s[u+1]))>>4,n=(15&i)<<2,o+=a[(64512&i)>>10]+a[e]+a[n]+"="),o},e.createImageInfo=function(t,e,n,r,i,o,a,s,c,l,u,h,f){var d={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(d.f=o),c&&(d.dp=c),l&&(d.trns=l),u&&(d.pal=u),h&&(d.smask=h),f&&(d.p=f),d},e.addImage=function(e,r,i,o,g,y,v,b,x){if("string"!=typeof r){var k=y;y=g,g=o,o=i,i=r,r=k}if("object"===(void 0===e?"undefined":t(e))&&!d(e)&&"imageData"in e){var _=e;e=_.imageData,r=_.format||r,i=_.x||i||0,o=_.y||o||0,g=_.w||g,y=_.h||y,v=_.alias||v,b=_.compression||b,x=_.rotation||_.angle||x}if(isNaN(i)||isNaN(o))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var C,A=s.call(this);if(!(C=m(e,A))){var S;if(d(e)&&(e=p(e,r,x)),l(v)&&(v=u(e)),!(C=m(v,A))){if(this.isString(e)){var q=this.extractInfoFromBase64DataURI(e);q?(r=q[2],e=atob(q[3])):137===e.charCodeAt(0)&&80===e.charCodeAt(1)&&78===e.charCodeAt(2)&&71===e.charCodeAt(3)&&(r="png")}if(r=(r||"JPEG").toLowerCase(),h(r))throw new Error("addImage currently only supports formats "+n+", not '"+r+"'");if(f(r))throw new Error("please ensure that the plugin for '"+r+"' support is added");if(this.supportsArrayBuffer()&&(e instanceof Uint8Array||(S=e,e=this.binaryStringToUint8Array(e))),!(C=this["process"+r.toUpperCase()](e,c(A),v,a(b),S)))throw new Error("An unkwown error occurred whilst processing the image")}}return w.call(this,i,o,g,y,C,C.i,A),this};var y=function(t){var e,n,r;if(255===!t.charCodeAt(0)||216===!t.charCodeAt(1)||255===!t.charCodeAt(2)||224===!t.charCodeAt(3)||!t.charCodeAt(6)==="J".charCodeAt(0)||!t.charCodeAt(7)==="F".charCodeAt(0)||!t.charCodeAt(8)==="I".charCodeAt(0)||!t.charCodeAt(9)==="F".charCodeAt(0)||0===!t.charCodeAt(10))throw new Error("getJpegSize requires a binary string jpeg file");for(var i=256*t.charCodeAt(4)+t.charCodeAt(5),o=4,a=t.length;o<a;){if(o+=i,255!==t.charCodeAt(o))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(o+1)||193===t.charCodeAt(o+1)||194===t.charCodeAt(o+1)||195===t.charCodeAt(o+1)||196===t.charCodeAt(o+1)||197===t.charCodeAt(o+1)||198===t.charCodeAt(o+1)||199===t.charCodeAt(o+1))return n=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),e=256*t.charCodeAt(o+7)+t.charCodeAt(o+8),r=t.charCodeAt(o+9),[e,n,r];o+=2,i=256*t.charCodeAt(o)+t.charCodeAt(o+1)}},v=function(t){if(65496!==(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n,r,i,o=t.length,a=(t[4]<<8)+t[5],s=4;s<o;){if(s+=a,e=b(t,s),a=(e[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&a>7)return e=b(t,s+5),n=(e[2]<<8)+e[3],r=(e[0]<<8)+e[1],i=e[4],{width:n,height:r,numcomponents:i};s+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")},b=function(t,e){return t.subarray(e,e+5)};e.processJPEG=function(t,e,n,r,i){var o,a=this.color_spaces.DEVICE_RGB,s=this.decode.DCT_DECODE;return this.isString(t)?(o=y(t),this.createImageInfo(t,o[0],o[1],1==o[3]?this.color_spaces.DEVICE_GRAY:a,8,s,e,n)):(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)?(o=v(t),t=i||this.arrayBufferToBinaryString(t),this.createImageInfo(t,o.width,o.height,1==o.numcomponents?this.color_spaces.DEVICE_GRAY:a,8,s,e,n)):null)},e.processJPG=function(){return this.processJPEG.apply(this,arguments)}}(e.API),/**
	 * jsPDF Annotations PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){var n={annotations:[],f2:function(t){return t.toFixed(2)},notEmpty:function(t){if(void 0!==t&&""!=t)return!0}};e.API.annotationPlugin=n,e.API.events.push(["addPage",function(t){this.annotationPlugin.annotations[t.pageNumber]=[]}]),t.events.push(["putPage",function(t){for(var e=this.annotationPlugin.annotations[t.pageNumber],r=!1,i=0;i<e.length&&!r;i++)switch((l=e[i]).type){case"link":if(n.notEmpty(l.options.url)||n.notEmpty(l.options.pageNumber)){r=!0;break}case"reference":case"text":case"freetext":r=!0}if(0!=r){this.internal.write("/Annots [");for(var o=this.annotationPlugin.f2,a=this.internal.scaleFactor,s=this.internal.pageSize.height,c=this.internal.getPageInfo(t.pageNumber),i=0;i<e.length;i++){var l=e[i];switch(l.type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var u=this.internal.newAdditionalObject(),h=this.internal.newAdditionalObject(),f=l.title||"Note";w="<</Type /Annot /Subtype /Text "+(p="/Rect ["+o(l.bounds.x*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+" "+o((l.bounds.x+l.bounds.w)*a)+" "+o((s-l.bounds.y)*a)+"] ")+"/Contents ("+l.contents+")",w+=" /Popup "+h.objId+" 0 R",w+=" /P "+c.objId+" 0 R",w+=" /T ("+f+") >>",u.content=w;var d=u.objId+" 0 R";w="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+o((l.bounds.x+30)*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+" "+o((l.bounds.x+l.bounds.w+30)*a)+" "+o((s-l.bounds.y)*a)+"] ")+" /Parent "+d,l.open&&(w+=" /Open true"),w+=" >>",h.content=w,this.internal.write(u.objId,"0 R",h.objId,"0 R");break;case"freetext":var p="/Rect ["+o(l.bounds.x*a)+" "+o((s-l.bounds.y)*a)+" "+o(l.bounds.x+l.bounds.w*a)+" "+o(s-(l.bounds.y+l.bounds.h)*a)+"] ",m=l.color||"#000000";w="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",w+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+m+")",w+=" /Border [0 0 0]",w+=" >>",this.internal.write(w);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);var p="/Rect ["+o(l.x*a)+" "+o((s-l.y)*a)+" "+o((l.x+l.w)*a)+" "+o((s-(l.y+l.h))*a)+"] ",w="";if(l.options.url)w="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(w="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+(t=this.internal.getPageInfo(l.options.pageNumber)).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":w+=" /Fit]";break;case"FitH":w+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,w+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=o((s-l.options.top)*a);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),w+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=w&&(w+=" >>",this.internal.write(w))}}this.internal.write("]")}}]),t.createAnnotation=function(t){switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t)}},t.link=function(t,e,n,r,i){this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},t.getLineHeight=function(){return this.internal.getLineHeight()}}(e.API),e.API.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this},/**
	 * jsPDF Canvas PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){t.events.push(["initialized",function(){this.canvas.pdf=this}]),t.canvas={getContext:function(t){return this.pdf.context2d._canvas=this,this.pdf.context2d},style:{}},Object.defineProperty(t.canvas,"width",{get:function(){return this._width},set:function(t){this._width=t,this.getContext("2d").pageWrapX=t+1}}),Object.defineProperty(t.canvas,"height",{get:function(){return this._height},set:function(t){this._height=t,this.getContext("2d").pageWrapY=t+1}})}(e.API),/** ====================================================================
	 * jsPDF Cell plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Hall, james@parall.ax
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * 
	 * ====================================================================
	 */
	function(t){var e,n,r,i,o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1,s=function(t,e,n,r,i){o={x:t,y:e,w:n,h:r,ln:i}},c=function(){return o},l={left:0,top:0,bottom:0};t.setHeaderFunction=function(t){i=t},t.getTextDimensions=function(t){e=this.internal.getFont().fontName,n=this.table_font_size||this.internal.getFontSize(),r=this.internal.getFont().fontStyle;var i,o;(o=document.createElement("font")).id="jsPDFCell";try{o.style.fontStyle=r}catch(t){o.style.fontWeight=r}o.style.fontName=e,o.style.fontSize=n+"pt";try{o.textContent=t}catch(e){o.innerText=t}return document.body.appendChild(o),i={w:(o.offsetWidth+1)*(19.049976/25.4),h:(o.offsetHeight+1)*(19.049976/25.4)},document.body.removeChild(o),i},t.cellAddPage=function(){var t=this.margins||l;this.addPage(),s(t.left,t.top,void 0,void 0),a+=1},t.cellInitialize=function(){o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1},t.cell=function(t,e,n,r,i,o,a){var u=c(),h=!1;if(void 0!==u.ln)if(u.ln===o)t=u.x+u.w,e=u.y;else{var f=this.margins||l;u.y+u.h+r+13>=this.internal.pageSize.height-f.bottom&&(this.cellAddPage(),h=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=c().y+c().h,h&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var d=0;d<i.length;d++){var p=i[d],m=this.getStringUnitWidth(p)*this.internal.getFontSize();this.text(p,t+n-m-3,e+this.internal.getLineHeight()*(d+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return s(t,e,n,r,o),this},t.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):i>o&&(o=i);return o},t.table=function(e,n,r,i,s){if(!r)throw"No data for PDF table";var c,u,h,f,d,p,m,g,w,y,v=[],b=[],x={},k={},_=[],C=[],A=!1,S=!0,q=12,T=l;if(T.width=this.internal.pageSize.width,s&&(!0===s.autoSize&&(A=!0),!1===s.printHeaders&&(S=!1),s.fontSize&&(q=s.fontSize),s.css&&void 0!==s.css["font-size"]&&(q=16*s.css["font-size"]),s.margins&&(T=s.margins)),this.lnMod=0,o={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},a=1,this.printHeaders=S,this.margins=T,this.setFontSize(q),this.table_font_size=q,void 0===i||null===i)v=Object.keys(r[0]);else if(i[0]&&"string"!=typeof i[0]){for(u=0,h=i.length;u<h;u+=1)c=i[u],v.push(c.name),b.push(c.prompt),k[c.name]=c.width*(19.049976/25.4)}else v=i;if(A)for(y=function(t){return t[c]},u=0,h=v.length;u<h;u+=1){for(x[c=v[u]]=r.map(y),_.push(this.getTextDimensions(b[u]||c).w),m=0,f=(p=x[c]).length;m<f;m+=1)d=p[m],_.push(this.getTextDimensions(d).w);k[c]=t.arrayMax(_),_=[]}if(S){P=this.calculateLineHeight(v,k,b.length?b:v);for(u=0,h=v.length;u<h;u+=1)c=v[u],C.push([e,n,k[c],P,String(b.length?b[u]:c)]);this.setTableHeaderRow(C),this.printHeaderRow(1,!1)}for(u=0,h=r.length;u<h;u+=1){var P;for(g=r[u],P=this.calculateLineHeight(v,k,g),m=0,w=v.length;m<w;m+=1)c=v[m],this.cell(e,n,k[c],P,g[c],u+2,c.align)}return this.lastCellPos=o,this.table_x=e,this.table_y=n,this},t.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;a>i&&(i=a)}return i},t.setTableHeaderRow=function(t){this.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,o,c;if(this.printingHeaderRow=!0,void 0!==i){var l=i(this,a);s(l[0],l[1],l[2],l[3],-1)}this.setFontStyle("bold");var u=[];for(o=0,c=this.tableHeaderRow.length;o<c;o+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[o],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,u.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));u.length>0&&this.setTableHeaderRow(u),this.setFontStyle("normal"),this.printingHeaderRow=!1}}(e.API),/**
	 * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
	 *
	 * Licensed under the MIT License. http://opensource.org/licenses/mit-license
	 */
	function(t){function e(){this._isStrokeTransparent=!1,this._strokeOpacity=1,this.strokeStyle="#000000",this.fillStyle="#000000",this._isFillTransparent=!1,this._fillOpacity=1,this.font="12pt times",this.textBaseline="alphabetic",this.textAlign="start",this.lineWidth=1,this.lineJoin="miter",this.lineCap="butt",this._transform=[1,0,0,1,0,0],this.globalCompositeOperation="normal",this.globalAlpha=1,this._clip_path=[],this.ignoreClearRect=!1,this.copy=function(t){this._isStrokeTransparent=t._isStrokeTransparent,this._strokeOpacity=t._strokeOpacity,this.strokeStyle=t.strokeStyle,this._isFillTransparent=t._isFillTransparent,this._fillOpacity=t._fillOpacity,this.fillStyle=t.fillStyle,this.font=t.font,this.lineWidth=t.lineWidth,this.lineJoin=t.lineJoin,this.lineCap=t.lineCap,this.textBaseline=t.textBaseline,this.textAlign=t.textAlign,this._fontSize=t._fontSize,this._transform=t._transform.slice(0),this.globalCompositeOperation=t.globalCompositeOperation,this.globalAlpha=t.globalAlpha,this._clip_path=t._clip_path.slice(0),this.ignoreClearRect=t.ignoreClearRect}}t.events.push(["initialized",function(){this.context2d.pdf=this,this.context2d.internal.pdf=this,this.context2d.ctx=new e,this.context2d.ctxStack=[],this.context2d.path=[]}]),t.context2d={pageWrapXEnabled:!1,pageWrapYEnabled:!1,pageWrapX:9999999,pageWrapY:9999999,ctx:new e,f2:function(t){return t.toFixed(2)},fillRect:function(t,e,n,r){if(!this._isFillTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"f")}},strokeRect:function(t,e,n,r){if(!this._isStrokeTransparent()){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.pdf.rect(i.x,i.y,i.w,i.h,"s")}},clearRect:function(t,e,n,r){if(!this.ctx.ignoreClearRect){t=this._wrapX(t),e=this._wrapY(e);var i=this._matrix_map_rect(this.ctx._transform,{x:t,y:e,w:n,h:r});this.save(),this.setFillStyle("#ffffff"),this.pdf.rect(i.x,i.y,i.w,i.h,"f"),this.restore()}},save:function(){this.ctx._fontSize=this.pdf.internal.getFontSize();var t=new e;t.copy(this.ctx),this.ctxStack.push(this.ctx),this.ctx=t},restore:function(){this.ctx=this.ctxStack.pop(),this.setFillStyle(this.ctx.fillStyle),this.setStrokeStyle(this.ctx.strokeStyle),this.setFont(this.ctx.font),this.pdf.setFontSize(this.ctx._fontSize),this.setLineCap(this.ctx.lineCap),this.setLineWidth(this.ctx.lineWidth),this.setLineJoin(this.ctx.lineJoin)},rect:function(t,e,n,r){this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.closePath()},beginPath:function(){this.path=[]},closePath:function(){this.path.push({type:"close"})},_getRGBA:function(t){var e,n,r,o;if(!t)return{r:0,g:0,b:0,a:0,style:t};if(this.internal.rxTransparent.test(t))e=0,n=0,r=0,o=0;else{var a=this.internal.rxRgb.exec(t);null!=a?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),o=1):null!=(a=this.internal.rxRgba.exec(t))?(e=parseInt(a[1]),n=parseInt(a[2]),r=parseInt(a[3]),o=parseFloat(a[4])):(o=1,"#"!=t.charAt(0)&&((t=i.colorNameToHex(t))||(t="#000000")),4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16))}return{r:e,g:n,b:r,a:o,style:t}},setFillStyle:function(t){var e=this._getRGBA(t);this.ctx.fillStyle=t,this.ctx._isFillTransparent=0===e.a,this.ctx._fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})},setStrokeStyle:function(t){var e=this._getRGBA(t);this.ctx.strokeStyle=e.style,this.ctx._isStrokeTransparent=0===e.a,this.ctx._strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))},fillText:function(t,e,n,r){if(!this._isFillTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(this.ctx._clip_path.length>0){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(c<.01)this.pdf.text(t,e,this._getBaseline(n),null,o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),null,o),this.pdf.setFontSize(l)}this.ctx._clip_path.length>0&&a.push("Q")}},strokeText:function(t,e,n,r){if(!this._isStrokeTransparent()){e=this._wrapX(e),n=this._wrapY(n);var i=this._matrix_map_point(this.ctx._transform,[e,n]);e=i[0],n=i[1];var o=57.2958*this._matrix_rotation(this.ctx._transform);if(this.ctx._clip_path.length>0){var a;(a=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var s=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(null,!0),this.ctx._clip_path=this.path,this.path=s}var c=1;try{c=this._matrix_decompose(this._getTransform()).scale[0]}catch(t){console.warn(t)}if(1===c)this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o);else{var l=this.pdf.internal.getFontSize();this.pdf.setFontSize(l*c),this.pdf.text(t,e,this._getBaseline(n),{stroke:!0},o),this.pdf.setFontSize(l)}this.ctx._clip_path.length>0&&a.push("Q")}},setFont:function(t){this.ctx.font=t;var e=/\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/;if(null!=(u=e.exec(t))){var n=u[1],r=u[3],i=u[4],o=u[5],a=u[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i),"bold"===r||"700"===r?this.pdf.setFontStyle("bold"):"italic"===n?this.pdf.setFontStyle("italic"):this.pdf.setFontStyle("normal");var s,c=(f=a).toLowerCase().split(/\s*,\s*/);s=-1!=c.indexOf("arial")?"Arial":-1!=c.indexOf("verdana")?"Verdana":-1!=c.indexOf("helvetica")?"Helvetica":-1!=c.indexOf("sans-serif")?"sans-serif":-1!=c.indexOf("fixed")?"Fixed":-1!=c.indexOf("monospace")?"Monospace":-1!=c.indexOf("terminal")?"Terminal":-1!=c.indexOf("courier")?"Courier":-1!=c.indexOf("times")?"Times":-1!=c.indexOf("cursive")?"Cursive":-1!=c.indexOf("fantasy")?"Fantasy":(c.indexOf("serif"),"Serif");var l;l="bold"===r?"bold":"normal",this.pdf.setFont(s,l)}else{var u=(e=/\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/).exec(t);if(null!=u){var h=u[1],f=u[3];(l=u[4])||(l="normal"),h="em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(h)),this.pdf.setFontSize(h),this.pdf.setFont(f,l)}}},setTextBaseline:function(t){this.ctx.textBaseline=t},getTextBaseline:function(){return this.ctx.textBaseline},setTextAlign:function(t){this.ctx.textAlign=t},getTextAlign:function(){return this.ctx.textAlign},setLineWidth:function(t){this.ctx.lineWidth=t,this.pdf.setLineWidth(t)},setLineCap:function(t){this.ctx.lineCap=t,this.pdf.setLineCap(t)},setLineJoin:function(t){this.ctx.lineJoin=t,this.pdf.setLineJoin(t)},moveTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"mt",x:t=n[0],y:e=n[1]};this.path.push(r)},_wrapX:function(t){return this.pageWrapXEnabled?t%this.pageWrapX:t},_wrapY:function(t){return this.pageWrapYEnabled?(this._gotoPage(this._page(t)),(t-this.lastBreak)%this.pageWrapY):t},transform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},setTransform:function(t,e,n,r,i,o){this.ctx._transform=[t,e,n,r,i,o]},_getTransform:function(){return this.ctx._transform},lastBreak:0,pageBreaks:[],_page:function(t){if(this.pageWrapYEnabled){this.lastBreak=0;for(var e=0,n=0,r=0;r<this.pageBreaks.length;r++)if(t>=this.pageBreaks[r]){e++,0===this.lastBreak&&n++;var i=this.pageBreaks[r]-this.lastBreak;this.lastBreak=this.pageBreaks[r],n+=o=Math.floor(i/this.pageWrapY)}if(0===this.lastBreak){var o=Math.floor(t/this.pageWrapY)+1;n+=o}return n+e}return this.pdf.internal.getCurrentPageInfo().pageNumber},_gotoPage:function(t){},lineTo:function(t,e){t=this._wrapX(t),e=this._wrapY(e);var n=this._matrix_map_point(this.ctx._transform,[t,e]),r={type:"lt",x:t=n[0],y:e=n[1]};this.path.push(r)},bezierCurveTo:function(t,e,n,r,i,o){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r),i=this._wrapX(i),o=this._wrapY(o);var a;i=(a=this._matrix_map_point(this.ctx._transform,[i,o]))[0],o=a[1];var s={type:"bct",x1:t=(a=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=a[1],x2:n=(a=this._matrix_map_point(this.ctx._transform,[n,r]))[0],y2:r=a[1],x:i,y:o};this.path.push(s)},quadraticCurveTo:function(t,e,n,r){t=this._wrapX(t),e=this._wrapY(e),n=this._wrapX(n),r=this._wrapY(r);var i;n=(i=this._matrix_map_point(this.ctx._transform,[n,r]))[0],r=i[1];var o={type:"qct",x1:t=(i=this._matrix_map_point(this.ctx._transform,[t,e]))[0],y1:e=i[1],x:n,y:r};this.path.push(o)},arc:function(t,e,n,r,i,o){if(t=this._wrapX(t),e=this._wrapY(e),!this._matrix_is_identity(this.ctx._transform)){var a=this._matrix_map_point(this.ctx._transform,[t,e]);t=a[0],e=a[1];var s=this._matrix_map_point(this.ctx._transform,[0,0]),c=this._matrix_map_point(this.ctx._transform,[0,n]);n=Math.sqrt(Math.pow(c[0]-s[0],2)+Math.pow(c[1]-s[1],2))}var l={type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,anticlockwise:o};this.path.push(l)},drawImage:function(t,e,n,r,i,o,a,s,c){void 0!==o&&(e=o,n=a,r=s,i=c),e=this._wrapX(e),n=this._wrapY(n);var l,u=this._matrix_map_rect(this.ctx._transform,{x:e,y:n,w:r,h:i}),h=(this._matrix_map_rect(this.ctx._transform,{x:o,y:a,w:s,h:c}),/data:image\/(\w+).*/i.exec(t));l=null!=h?h[1]:"png",this.pdf.addImage(t,l,u.x,u.y,u.w,u.h)},_matrix_multiply:function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],a=e[4],s=e[5],c=n*t[0]+r*t[2],l=i*t[0]+o*t[2],u=a*t[0]+s*t[2]+t[4];return r=n*t[1]+r*t[3],o=i*t[1]+o*t[3],s=a*t[1]+s*t[3]+t[5],n=c,i=l,a=u,[n,r,i,o,a,s]},_matrix_rotation:function(t){return Math.atan2(t[2],t[0])},_matrix_decompose:function(t){var e=t[0],n=t[1],r=t[2],i=t[3],o=Math.sqrt(e*e+n*n),a=(e/=o)*r+(n/=o)*i;r-=e*a,i-=n*a;var s=Math.sqrt(r*r+i*i);return r/=s,i/=s,a/=s,e*i<n*r&&(e=-e,n=-n,a=-a,o=-o),{scale:[o,0,0,s,0,0],translate:[1,0,0,1,t[4],t[5]],rotate:[e,n,-n,e,0,0],skew:[1,0,a,1,0,0]}},_matrix_map_point:function(t,e){var n=t[0],r=t[1],i=t[2],o=t[3],a=t[4],s=t[5],c=e[0],l=e[1];return[c*n+l*i+a,c*r+l*o+s]},_matrix_map_point_obj:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]);return{x:n[0],y:n[1]}},_matrix_map_rect:function(t,e){var n=this._matrix_map_point(t,[e.x,e.y]),r=this._matrix_map_point(t,[e.x+e.w,e.y+e.h]);return{x:n[0],y:n[1],w:r[0]-n[0],h:r[1]-n[1]}},_matrix_is_identity:function(t){return 1==t[0]&&(0==t[1]&&(0==t[2]&&(1==t[3]&&(0==t[4]&&0==t[5]))))},rotate:function(t){var e=[Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,e)},scale:function(t,e){var n=[t,0,0,e,0,0];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},translate:function(t,e){var n=[1,0,0,1,t,e];this.ctx._transform=this._matrix_multiply(this.ctx._transform,n)},stroke:function(){if(this.ctx._clip_path.length>0){var t;(t=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var e=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._stroke(!0),this.ctx._clip_path=this.path,this.path=e,this._stroke(!1),t.push("Q")}else this._stroke(!1)},_stroke:function(t){if(t||!this._isStrokeTransparent()){for(var e=[],n=this.path,r=0;r<n.length;r++){var i=n[r];switch(i.type){case"mt":e.push({start:i,deltas:[],abs:[]});break;case"lt":h=[i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(h),e[e.length-1].abs.push(i);break;case"bct":h=[i.x1-n[r-1].x,i.y1-n[r-1].y,i.x2-n[r-1].x,i.y2-n[r-1].y,i.x-n[r-1].x,i.y-n[r-1].y];e[e.length-1].deltas.push(h);break;case"qct":var o=n[r-1].x+2/3*(i.x1-n[r-1].x),a=n[r-1].y+2/3*(i.y1-n[r-1].y),s=i.x+2/3*(i.x1-i.x),c=i.y+2/3*(i.y1-i.y),l=i.x,u=i.y,h=[o-n[r-1].x,a-n[r-1].y,s-n[r-1].x,c-n[r-1].y,l-n[r-1].x,u-n[r-1].y];e[e.length-1].deltas.push(h);break;case"arc":0==e.length&&e.push({start:{x:0,y:0},deltas:[],abs:[]}),e[e.length-1].arc=!0,e[e.length-1].abs.push(i)}}for(r=0;r<e.length;r++){var f;if(f=r==e.length-1?"s":null,e[r].arc)for(var d=e[r].abs,p=0;p<d.length;p++){var m=d[p],g=360*m.startAngle/(2*Math.PI),w=360*m.endAngle/(2*Math.PI),y=m.x,v=m.y;this.internal.arc2(this,y,v,m.radius,g,w,m.anticlockwise,f,t)}else{var y=e[r].start.x,v=e[r].start.y;t?(this.pdf.lines(e[r].deltas,y,v,null,null),this.pdf.clip_fixed()):this.pdf.lines(e[r].deltas,y,v,null,f)}}}},_isFillTransparent:function(){return this.ctx._isFillTransparent||0==this.globalAlpha},_isStrokeTransparent:function(){return this.ctx._isStrokeTransparent||0==this.globalAlpha},fill:function(t){if(this.ctx._clip_path.length>0){var e;(e=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage()).push("q");var n=this.path;this.path=this.ctx._clip_path,this.ctx._clip_path=[],this._fill(t,!0),this.ctx._clip_path=this.path,this.path=n,this._fill(t,!1),e.push("Q")}else this._fill(t,!1)},_fill:function(t,e){if(!this._isFillTransparent()){var r,i="function"==typeof this.pdf.internal.newObject2;r=window.outIntercept?"group"===window.outIntercept.type?window.outIntercept.stream:window.outIntercept:this.internal.getCurrentPage();var o=[],a=window.outIntercept;if(i)switch(this.ctx.globalCompositeOperation){case"normal":case"source-over":break;case"destination-in":case"destination-out":var s=this.pdf.internal.newStreamObject(),c=this.pdf.internal.newObject2();c.push("<</Type /ExtGState"),c.push("/SMask <</S /Alpha /G "+s.objId+" 0 R>>"),c.push(">>");d="MASK"+c.objId;this.pdf.internal.addGraphicsState(d,c.objId);var l="/"+d+" gs";r.splice(0,0,"q"),r.splice(1,0,l),r.push("Q"),window.outIntercept=s;break;default:var u="/"+this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];u&&this.pdf.internal.out(u+" gs")}var h=this.ctx.globalAlpha;if(this.ctx._fillOpacity<1&&(h=this.ctx._fillOpacity),i){var f=this.pdf.internal.newObject2();f.push("<</Type /ExtGState"),f.push("/CA "+h),f.push("/ca "+h),f.push(">>");var d="GS_O_"+f.objId;this.pdf.internal.addGraphicsState(d,f.objId),this.pdf.internal.out("/"+d+" gs")}for(var p=this.path,m=0;m<p.length;m++){var g=p[m];switch(g.type){case"mt":o.push({start:g,deltas:[],abs:[]});break;case"lt":_=[g.x-p[m-1].x,g.y-p[m-1].y];o[o.length-1].deltas.push(_),o[o.length-1].abs.push(g);break;case"bct":_=[g.x1-p[m-1].x,g.y1-p[m-1].y,g.x2-p[m-1].x,g.y2-p[m-1].y,g.x-p[m-1].x,g.y-p[m-1].y];o[o.length-1].deltas.push(_);break;case"qct":var w=p[m-1].x+2/3*(g.x1-p[m-1].x),y=p[m-1].y+2/3*(g.y1-p[m-1].y),v=g.x+2/3*(g.x1-g.x),b=g.y+2/3*(g.y1-g.y),x=g.x,k=g.y,_=[w-p[m-1].x,y-p[m-1].y,v-p[m-1].x,b-p[m-1].y,x-p[m-1].x,k-p[m-1].y];o[o.length-1].deltas.push(_);break;case"arc":0===o.length&&o.push({deltas:[],abs:[]}),o[o.length-1].arc=!0,o[o.length-1].abs.push(g);break;case"close":o.push({close:!0})}}for(m=0;m<o.length;m++){var C;if(m==o.length-1?(C="f","evenodd"===t&&(C+="*")):C=null,o[m].close)this.pdf.internal.out("h"),this.pdf.internal.out("f");else if(o[m].arc){o[m].start&&this.internal.move2(this,o[m].start.x,o[m].start.y);for(var A=o[m].abs,S=0;S<A.length;S++){var q=A[S];if(void 0!==q.startAngle){var T=360*q.startAngle/(2*Math.PI),P=360*q.endAngle/(2*Math.PI),I=q.x,E=q.y;if(0===S&&this.internal.move2(this,I,E),this.internal.arc2(this,I,E,q.radius,T,P,q.anticlockwise,null,e),S===A.length-1&&o[m].start){var I=o[m].start.x,E=o[m].start.y;this.internal.line2(n,I,E)}}else this.internal.line2(n,q.x,q.y)}}else{var I=o[m].start.x,E=o[m].start.y;e?(this.pdf.lines(o[m].deltas,I,E,null,null),this.pdf.clip_fixed()):this.pdf.lines(o[m].deltas,I,E,null,C)}}window.outIntercept=a}},pushMask:function(){if("function"==typeof this.pdf.internal.newObject2){var t=this.pdf.internal.newStreamObject(),e=this.pdf.internal.newObject2();e.push("<</Type /ExtGState"),e.push("/SMask <</S /Alpha /G "+t.objId+" 0 R>>"),e.push(">>");var n="MASK"+e.objId;this.pdf.internal.addGraphicsState(n,e.objId);var r="/"+n+" gs";this.pdf.internal.out(r)}else console.log("jsPDF v2 not enabled")},clip:function(){if(this.ctx._clip_path.length>0)for(var t=0;t<this.path.length;t++)this.ctx._clip_path.push(this.path[t]);else this.ctx._clip_path=this.path;this.path=[]},measureText:function(t){var e=this.pdf;return{getWidth:function(){var n=e.internal.getFontSize(),r=e.getStringUnitWidth(t)*n/e.internal.scaleFactor;return r*=1.3333},get width(){return this.getWidth(t)}}},_getBaseline:function(t){var e=parseInt(this.pdf.internal.getFontSize()),n=.25*e;switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e;case"hanging":return t+e-n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}}};var n=t.context2d;Object.defineProperty(n,"fillStyle",{set:function(t){this.setFillStyle(t)},get:function(){return this.ctx.fillStyle}}),Object.defineProperty(n,"strokeStyle",{set:function(t){this.setStrokeStyle(t)},get:function(){return this.ctx.strokeStyle}}),Object.defineProperty(n,"lineWidth",{set:function(t){this.setLineWidth(t)},get:function(){return this.ctx.lineWidth}}),Object.defineProperty(n,"lineCap",{set:function(t){this.setLineCap(t)},get:function(){return this.ctx.lineCap}}),Object.defineProperty(n,"lineJoin",{set:function(t){this.setLineJoin(t)},get:function(){return this.ctx.lineJoin}}),Object.defineProperty(n,"miterLimit",{set:function(t){this.ctx.miterLimit=t},get:function(){return this.ctx.miterLimit}}),Object.defineProperty(n,"textBaseline",{set:function(t){this.setTextBaseline(t)},get:function(){return this.getTextBaseline()}}),Object.defineProperty(n,"textAlign",{set:function(t){this.setTextAlign(t)},get:function(){return this.getTextAlign()}}),Object.defineProperty(n,"font",{set:function(t){this.setFont(t)},get:function(){return this.ctx.font}}),Object.defineProperty(n,"globalCompositeOperation",{set:function(t){this.ctx.globalCompositeOperation=t},get:function(){return this.ctx.globalCompositeOperation}}),Object.defineProperty(n,"globalAlpha",{set:function(t){this.ctx.globalAlpha=t},get:function(){return this.ctx.globalAlpha}}),Object.defineProperty(n,"ignoreClearRect",{set:function(t){this.ctx.ignoreClearRect=t},get:function(){return this.ctx.ignoreClearRect}}),n.internal={},n.internal.rxRgb=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/,n.internal.rxRgba=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/,n.internal.rxTransparent=/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/,n.internal.arc=function(t,e,n,r,i,o,a,s){for(var c=this.pdf.internal.scaleFactor,l=this.pdf.internal.pageSize.height,u=this.pdf.internal.f2,h=i*(Math.PI/180),f=o*(Math.PI/180),d=this.createArc(r,h,f,a),p=0;p<d.length;p++){var m=d[p];0===p?this.pdf.internal.out([u((m.x1+e)*c),u((l-(m.y1+n))*c),"m",u((m.x2+e)*c),u((l-(m.y2+n))*c),u((m.x3+e)*c),u((l-(m.y3+n))*c),u((m.x4+e)*c),u((l-(m.y4+n))*c),"c"].join(" ")):this.pdf.internal.out([u((m.x2+e)*c),u((l-(m.y2+n))*c),u((m.x3+e)*c),u((l-(m.y3+n))*c),u((m.x4+e)*c),u((l-(m.y4+n))*c),"c"].join(" ")),t._lastPoint={x:e,y:n}}null!==s&&this.pdf.internal.out(this.pdf.internal.getStyle(s))},n.internal.arc2=function(t,e,n,r,i,o,a,s,c){var l=e,u=n;c?(this.arc(t,l,u,r,i,o,a,null),this.pdf.clip_fixed()):this.arc(t,l,u,r,i,o,a,s)},n.internal.move2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2;this.pdf.internal.out([o(e*r),o((i-n)*r),"m"].join(" ")),t._lastPoint={x:e,y:n}},n.internal.line2=function(t,e,n){var r=this.pdf.internal.scaleFactor,i=this.pdf.internal.pageSize.height,o=this.pdf.internal.f2,a={x:e,y:n};this.pdf.internal.out([o(a.x*r),o((i-a.y)*r),"l"].join(" ")),t._lastPoint=a},n.internal.createArc=function(t,e,n,r){var i=2*Math.PI,o=Math.PI/2,a=e;for((a<i||a>i)&&(a%=i),a<0&&(a=i+a);e>n;)e-=i;var s=Math.abs(n-e);s<i&&r&&(s=i-s);for(var c=[],l=r?-1:1,u=a;s>1e-5;){var h=u+l*Math.min(s,o);c.push(this.createSmallArc(t,u,h)),s-=Math.abs(h-u),u=h}return c},n.internal.getCurrentPage=function(){return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber]},n.internal.createSmallArc=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,c=a*a+s*s,l=c+a*i+s*o,u=4/3*(Math.sqrt(2*c*l)-l)/(a*o-s*i),h=a-u*s,f=s+u*a,d=h,p=-f,m=r+e,g=Math.cos(m),w=Math.sin(m);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*g-f*w,y2:h*w+f*g,x3:d*g-p*w,y3:d*w+p*g,x4:t*Math.cos(n),y4:t*Math.sin(n)}}}(e.API),/** @preserve
	 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Daniel Husar, https://github.com/danielhusar
	 *               2014 Wolfgang Gassler, https://github.com/woolfg
	 *               2014 Steven Spungin, https://github.com/flamenco
	 *
	 * 
	 * ====================================================================
	 */
	function(e){var n,r,o,a,s,c,l,u,h,f,d,p,m,g,w,y,v,b,x,k;n=function(){function t(){}return function(e){return t.prototype=e,new t}}(),f=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,i=!1,a=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},p=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=o[n.trim().toLowerCase()],n=r.shift();return e},m=function(t){(t="auto"===t?"0px":t).indexOf("em")>-1&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),t.indexOf("pt")>-1&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px");var e;return void 0,16,(e=g[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[{css_line_height_string:t}])?g[t]=e/16:(e=parseFloat(t))?g[t]=e/16:3===(e=t.match(/([\d\.]+)(px)/)).length?g[t]=parseFloat(e[1])/16:g[t]=1},h=function(t){var e,n,r;return r=function(e){var n;return n=function(t){return document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(t,null):t.currentStyle?t.currentStyle:t.style}(t),function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),n[t]}}(),e={},n=void 0,e["font-family"]=p(r("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=c[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=m(r("font-size"))||1,e["line-height"]=m(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&m(r("margin-top"))||0,e["margin-bottom"]=n&&m(r("margin-bottom"))||0,e["padding-top"]=n&&m(r("padding-top"))||0,e["padding-bottom"]=n&&m(r("padding-bottom"))||0,e["margin-left"]=n&&m(r("margin-left"))||0,e["margin-right"]=n&&m(r("margin-right"))||0,e["padding-left"]=n&&m(r("padding-left"))||0,e["padding-right"]=n&&m(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=l[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},w=function(t,e,n){var r,i,o,a,s;if(o=!1,i=void 0,a=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s=t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},k=function(t,e){var n,r,i,o,a,s,c,l,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,c=t.clientWidth;i<u;)l=t.rows[0].cells[i],r[i]={name:l.textContent.toLowerCase().replace(/\s+/g,""),prompt:l.textContent.replace(/\r?\n/g,""),width:l.clientWidth/c*e.pdf.internal.pageSize.width},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var _={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},C=1;r=function(e,i,o){var a,s,c,l,u,f,d,p;for(s=e.childNodes,a=void 0,(u="block"===(c=h(e)).display)&&(i.setBlockBoundary(),i.setBlockStyle(c)),l=0,f=s.length;l<f;){if("object"===(void 0===(a=s[l])?"undefined":t(a))){if(i.executeWatchFunctions(a),1===a.nodeType&&"HEADER"===a.nodeName){var m=a,g=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=g,r(m,i,o),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===a.nodeType&&"#comment"===a.nodeName)~a.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==a.nodeType||_[a.nodeName])if(3===a.nodeType){var v=a.nodeValue;if(a.nodeValue&&"LI"===a.parentNode.nodeName)if("OL"===a.parentNode.parentNode.nodeName)v=C+++". "+v;else{var b=c["font-size"],x=(3-.75*b)*i.pdf.internal.scaleFactor,A=.75*b*i.pdf.internal.scaleFactor,S=1.74*b/i.pdf.internal.scaleFactor;p=function(t,e){this.pdf.circle(t+x,e+A,S,"FD")}}16&a.ownerDocument.body.compareDocumentPosition(a)&&i.addText(v,c)}else"string"==typeof a&&i.addText(a,c);else{var q;if("IMG"===a.nodeName){var T=a.getAttribute("src");q=y[i.pdf.sHashCode(T)||T]}if(q){i.pdf.internal.pageSize.height-i.pdf.margins_doc.bottom<i.y+a.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(a));var P=h(a),I=i.x,E=12/i.pdf.internal.scaleFactor,O=(P["margin-left"]+P["padding-left"])*E,F=(P["margin-right"]+P["padding-right"])*E,B=(P["margin-top"]+P["padding-top"])*E,R=(P["margin-bottom"]+P["padding-bottom"])*E;void 0!==P.float&&"right"===P.float?I+=i.settings.width-a.width-F:I+=O,i.pdf.addImage(q,I,i.y+B,a.width,a.height),q=void 0,"right"===P.float||"left"===P.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!_[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===P.float?-a.width-O-F:0,i.y+a.height+B+R,a.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===h(n).clear&&(i.y=t,!0)}.bind(this,i.y+a.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=a.width+O+F,"left"===P.float&&(i.x+=a.width+O+F)):i.y+=a.height+B+R}else if("TABLE"===a.nodeName)d=k(a,i),i.y+=10,i.pdf.table(i.x,i.y,d.rows,d.headers,{autoSize:!1,printHeaders:o.printHeaders,margins:i.pdf.margins_doc,css:h(a)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===a.nodeName||"UL"===a.nodeName)C=1,w(a,i,o)||r(a,i,o),i.y+=10;else if("LI"===a.nodeName){var D=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,w(a,i,o)||r(a,i,o),i.x=D}else"BR"===a.nodeName?(i.y+=c["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",n(c))):w(a,i,o)||r(a,i,o)}}l++}if(o.outY=i.y,u)return i.setBlockBoundary(p)},y={},v=function(t,e,n,r){function i(){e.pdf.internal.events.publish("imagesLoaded"),r(o)}for(var o,a=t.getElementsByTagName("img"),s=a.length,c=0;s--;)!function(t,n,r){if(t){var a=new Image;o=++c,a.crossOrigin="",a.onerror=a.onload=function(){if(a.complete&&(0===a.src.indexOf("data:image/")&&(a.width=n||a.width||0,a.height=r||a.height||0),a.width+a.height)){var o=e.pdf.sHashCode(t)||t;y[o]=y[o]||a}--c||i()},a.src=t}}(a[s].getAttribute("src"),a[s].width,a[s].height);return c||i()},b=function(t,e,n){var i=t.getElementsByTagName("footer");if(i.length>0){i=i[0];var o=e.pdf.internal.write,a=e.y;e.pdf.internal.write=function(){},r(i,e,n);var s=Math.ceil(e.y-a)+5;e.y=a,e.pdf.internal.write=o,e.pdf.margins_doc.bottom+=s;for(var c=function(t){var o=void 0!==t?t.pageNumber:1,a=e.y;e.y=e.pdf.internal.pageSize.height-e.pdf.margins_doc.bottom,e.pdf.margins_doc.bottom-=s;for(var c=i.getElementsByTagName("span"),l=0;l<c.length;++l)(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")>-1&&(c[l].innerHTML=o),(" "+c[l].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&(c[l].innerHTML="###jsPDFVarTotalPages###");r(i,e,n),e.pdf.margins_doc.bottom+=s,e.y=a},l=i.getElementsByTagName("span"),u=0;u<l.length;++u)(" "+l[u].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")>-1&&e.pdf.internal.events.subscribe("htmlRenderingFinished",e.pdf.putTotalPages.bind(e.pdf,"###jsPDFVarTotalPages###"),!0);e.pdf.internal.events.subscribe("addPage",c,!1),c(),_.FOOTER=1}},x=function(t,e,n,i,o,a){if(!e)return!1;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(e=function(t){var e,n,r,i;return r="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),i="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",n=document.createElement("div"),n.style.cssText=i,n.innerHTML='<iframe style="height:1px;width:1px" name="'+r+'" />',document.body.appendChild(n),(e=window.frames[r]).document.open(),e.document.writeln(t),e.document.close(),e.document.body}(e.replace(/<\/?script[^>]*?>/gi,"")));var s,c=new d(t,n,i,o);return v.call(this,e,c,o.elementHandlers,function(t){b(e,c,o.elementHandlers),r(e,c,o.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),s=c.dispose(),"function"==typeof a?a(s):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),s||{x:c.x,y:c.y}},(d=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},d.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},d.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(this.watchFunctions.length>0){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},d.prototype.splitFragmentsIntoLines=function(t,e){var r,i,o,a,s,c,l,u,h,f,d,p,m,g;for(12,f=this.pdf.internal.scaleFactor,a={},i=void 0,h=void 0,o=void 0,s=void 0,g=void 0,u=void 0,l=void 0,c=void 0,p=[d=[]],r=0,m=this.settings.width;t.length;)if(s=t.shift(),g=e.shift(),s)if(i=g["font-family"],h=g["font-style"],(o=a[i+h])||(o=this.pdf.internal.getFont(i,h).metadata.Unicode,a[i+h]=o),u={widths:o.widths,kerning:o.kerning,fontSize:12*g["font-size"],textIndent:r},l=this.pdf.getStringUnitWidth(s,u)*u.fontSize/f,"\u2028"==s)d=[],p.push(d);else if(r+l>m){for(c=this.pdf.splitTextToSize(s,m,u),d.push([c.shift(),g]);c.length;)d=[[c.shift(),g]],p.push(d);r=this.pdf.getStringUnitWidth(d[0][0],u)*u.fontSize/f}else d.push([s,g]),r+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var w=0;w<p.length;++w){var y=this.pdf.getStringUnitWidth(p[w][0][0],u)*u.fontSize/f;w>0&&(p[w][0][1]=n(p[w][0][1]));var v=m-y;if("right"===g["text-align"])p[w][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[w][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var b=p[w][0][0].split(" ").length-1;p[w][0][1]["word-spacing"]=v/b,w===p.length-1&&(p[w][0][1]["word-spacing"]=0)}}return p},d.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.height-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),e.color,"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&e["word-spacing"]>0&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},d.prototype.getPdfColor=function(t){var e,n,r,o=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=o?(e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3])):("#"!=t.charAt(0)&&((t=i.colorNameToHex(t))||(t="#000000")),e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)),"string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},d.prototype.f3=function(t){return t.toFixed(3)},d.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,c,l,u,h,d,p;if(r=f(this.paragraph.text),d=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,d),a=void 0,c=void 0,12,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,h=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,h=((e["margin-top"]||0)+(e["padding-top"]||0))*n),l=this.pdf.internal.write,i=void 0,o=void 0,this.y+=h,l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var m=0;s.length;){for(c=0,i=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(c=Math.max(c,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,w=0;for(void 0!==a[0][1]["margin-left"]&&a[0][1]["margin-left"]>0&&(g=(w=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-m,m=w),l(g+Math.max(e["margin-left"]||0,0)*n,(-12*c).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=c*n,this.executeWatchFunctions(a[0][1])&&s.length>0){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(f(y),v),l("ET","Q"),l("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),l("ET","Q"),this.y+=u}},d.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},d.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},d.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},o={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},c={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},l={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},g={normal:1},e.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),x(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(e.API),/** ==================================================================== 
	 * jsPDF JavaScript plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){var n,r,i;e.API.addJS=function(t){return i=t,this.internal.events.subscribe("postPutResources",function(t){n=this.internal.newObject(),this.internal.write("<< /Names [(EmbeddedJS) "+(n+1)+" 0 R] >>","endobj"),r=this.internal.newObject(),this.internal.write("<< /S /JavaScript /JS (",i,") >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==n&&void 0!==r&&this.internal.write("/Names <</JavaScript "+n+" 0 R>>")}),this}}(),/**
	 * jsPDF Outline PlugIn
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	function(t){t.events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a)}t.internal.write(i)}if(this.outline.createNamedDestinations){for(var s=this.internal.pages.length,c=[],r=0;r<s;r++){var l=t.internal.newObject();c.push(l);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var h=t.internal.newObject();t.internal.write("<< /Names [ ");for(r=0;r<c.length;r++)t.internal.write("(page_"+(r+1)+")"+c[r]+" 0 R");t.internal.write(" ] >>","endobj");t.internal.newObject();t.internal.write("<< /Dests "+h+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){var t=this;t.outline.root.children.length>0&&(t.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&t.internal.write("/Names "+namesOid+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var n=0;n<e.children.length;n++)this.genIds_r(e.children[n])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(i=0;i<e.children.length;i++){o=e.children[i];this.objStart(o),this.line("/Title "+this.makeString(o.title)),this.line("/Parent "+this.makeRef(e)),i>0&&this.line("/Prev "+this.makeRef(e.children[i-1])),i<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[i+1])),o.children.length>0&&(this.line("/First "+this.makeRef(o.children[0])),this.line("/Last "+this.makeRef(o.children[o.children.length-1])));var n=this.count=this.count_r({count:0},o);if(n>0&&this.line("/Count "+n),o.options&&o.options.pageNumber){var r=t.internal.getPageInfo(o.options.pageNumber);this.line("/Dest ["+r.objId+" 0 R /XYZ 0 "+this.ctx.pdf.internal.pageSize.height+" 0]")}this.objEnd()}for(var i=0;i<e.children.length;i++){var o=e.children[i];this.renderItems(o)}},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}])}(e.API),/**@preserve
	 *  ====================================================================
	 * jsPDF PNG PlugIn
	 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	 *
	 * 
	 * ====================================================================
	 */
	function(t){var e=function(){return"function"!=typeof PNG||"function"!=typeof s},n=function(e){return e!==t.image_compression.NONE&&r()},r=function(){var t="function"==typeof o;if(!t)throw new Error("requires deflate.js for compression");return t},i=function(e,n,r,i){var s=5,u=f;switch(i){case t.image_compression.FAST:s=3,u=h;break;case t.image_compression.MEDIUM:s=6,u=d;break;case t.image_compression.SLOW:s=9,u=p}e=l(e,n,r,u);var m=new Uint8Array(a(s)),g=c(e),w=new o(s),y=w.append(e),v=w.flush(),b=m.length+y.length+v.length,x=new Uint8Array(b+4);return x.set(m),x.set(y,m.length),x.set(v,m.length+y.length),x[b++]=g>>>24&255,x[b++]=g>>>16&255,x[b++]=g>>>8&255,x[b++]=255&g,t.arrayBufferToBinaryString(x)},a=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,r+=31-r%31,[n,255&r]},c=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;o>0;){o-=n=o>e?e:o;do{i+=r+=t[a++]}while(--n);r%=65521,i%=65521}return(i<<16|r)>>>0},l=function(t,e,n,r){for(var i,o,a,s=t.length/e,c=new Uint8Array(t.length+s),l=g(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)c.set(r(i,n,o),a+u);else{for(var h=0,f=l.length,d=[];h<f;h++)d[h]=l[h](i,n,o);var p=w(d.concat());c.set(d[p],a+u)}o=i}return c},u=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},h=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},f=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},d=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},p=function(t,e,n){var r,i,o,a,s=[],c=0,l=t.length;for(s[0]=4;c<l;c++)r=t[c-e]||0,i=n&&n[c]||0,o=n&&n[c-e]||0,a=m(r,i,o),s[c+1]=t[c]-a+256&255;return s},m=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},g=function(){return[u,h,f,d,p]},w=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=y(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},y=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},v=function(e){var n;switch(e){case t.image_compression.FAST:n=11;break;case t.image_compression.MEDIUM:n=13;break;case t.image_compression.SLOW:n=14;break;default:n=12}return n};t.processPNG=function(t,r,o,a,s){var c,l,u,h,f,d,p=this.color_spaces.DEVICE_RGB,m=this.decode.FLATE_DECODE,g=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if(e())throw new Error("PNG support requires png.js and zlib.js");if(c=new PNG(t),t=c.imgData,g=c.bits,p=c.colorSpace,h=c.colors,-1!==[4,6].indexOf(c.colorType)){if(8===c.bits)for(var w,y=(I=32==c.pixelBitlength?new Uint32Array(c.decodePixels().buffer):16==c.pixelBitlength?new Uint16Array(c.decodePixels().buffer):new Uint8Array(c.decodePixels().buffer)).length,b=new Uint8Array(y*c.colors),x=new Uint8Array(y),k=c.pixelBitlength-c.bits,_=0,C=0;_<y;_++){for(A=I[_],w=0;w<k;)b[C++]=A>>>w&255,w+=c.bits;x[_]=A>>>w&255}if(16===c.bits){for(var A,y=(I=new Uint32Array(c.decodePixels().buffer)).length,b=new Uint8Array(y*(32/c.pixelBitlength)*c.colors),x=new Uint8Array(y*(32/c.pixelBitlength)),S=c.colors>1,_=0,C=0,q=0;_<y;)A=I[_++],b[C++]=A>>>0&255,S&&(b[C++]=A>>>16&255,A=I[_++],b[C++]=A>>>0&255),x[q++]=A>>>16&255;g=8}n(a)?(t=i(b,c.width*c.colors,c.colors,a),d=i(x,c.width,1,a)):(t=b,d=x,m=null)}if(3===c.colorType&&(p=this.color_spaces.INDEXED,f=c.palette,c.transparency.indexed)){for(var T=c.transparency.indexed,P=0,_=0,y=T.length;_<y;++_)P+=T[_];if((P/=255)===y-1&&-1!==T.indexOf(0))u=[T.indexOf(0)];else if(P!==y){for(var I=c.decodePixels(),x=new Uint8Array(I.length),_=0,y=I.length;_<y;_++)x[_]=T[I[_]];d=i(x,c.width,1)}}var E=v(a);return l=m===this.decode.FLATE_DECODE?"/Predictor "+E+" /Colors "+h+" /BitsPerComponent "+g+" /Columns "+c.width:"/Colors "+h+" /BitsPerComponent "+g+" /Columns "+c.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(d&&this.isArrayBuffer(d)||this.isArrayBufferView(d))&&(d=this.arrayBufferToBinaryString(d)),this.createImageInfo(t,c.width,c.height,p,g,m,r,o,l,u,f,d,E)}throw new Error("Unsupported PNG image data, try using JPEG instead.")}}(e.API),e.API.autoPrint=function(){var t;return this.internal.events.subscribe("postPutResources",function(){t=this.internal.newObject(),this.internal.write("<< /S/Named /Type/Action /N/Print >>","endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.write("/OpenAction "+t+" 0 R")}),this},/** @preserve
	 * jsPDF split_text_to_size plugin - MIT license.
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Diego Casorran, https://github.com/diegocr
	 */
	function(t){var e=t.getCharWidthsArray=function(t,e){e||(e={});var n,r,i,o=e.widths?e.widths:this.internal.getFont().metadata.Unicode.widths,a=o.fof?o.fof:1,s=e.kerning?e.kerning:this.internal.getFont().metadata.Unicode.kerning,c=s.fof?s.fof:1,l=0,u=o[0]||a,h=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),h.push((o[i]||u)/a+(s[i]&&s[i][l]||0)/c),l=i;return h},n=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},r=t.getStringUnitWidth=function(t,r){return n(e.call(this,t,r))},i=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var c=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(c,o)),s=0,c=o),s+=e[o],o++;return c!==o&&i.push(t.slice(c,o)),i},o=function(t,o,a){a||(a={});var s,c,l,u,h,f,d=[],p=[d],m=a.textIndent||0,g=0,w=0,y=t.split(" "),v=e(" ",a)[0];if(f=-1===a.lineIndent?y[0].length+2:a.lineIndent||0){var b=Array(f).join(" "),x=[];y.map(function(t){(t=t.split(/\s*\n/)).length>1?x=x.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):x.push(t[0])}),y=x,f=r(b,a)}for(l=0,u=y.length;l<u;l++){var k=0;if(s=y[l],f&&"\n"==s[0]&&(s=s.substr(1),k=1),c=e(s,a),w=n(c),m+g+w>o||k){if(w>o){for(h=i(s,c,o-(m+g),o),d.push(h.shift()),d=[h.pop()];h.length;)p.push([h.shift()]);w=n(c.slice(s.length-d[0].length))}else d=[s];p.push(d),m=w+f,g=v}else d.push(s),m+=g+w,g=v}if(f)_=function(t,e){return(e?b:"")+t.join(" ")};else var _=function(t){return t.join(" ")};return p.map(_)};t.splitTextToSize=function(t,e,n){n||(n={});var r,i=n.fontSize||this.internal.getFontSize(),a=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle);return r.metadata.Unicode?{widths:r.metadata.Unicode.widths||e,kerning:r.metadata.Unicode.kerning||n}:{widths:e,kerning:n}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var s=1*this.internal.scaleFactor*e/i;a.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=n.lineIndent;var c,l,u=[];for(c=0,l=r.length;c<l;c++)u=u.concat(o(r[c],s,a));return u}}(e.API),/** @preserve 
	jsPDF standard_fonts_metrics plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	MIT license.
	*/
	function(t){var e=function(t){for(var e={},n=0;n<"klmnopqrstuvwxyz".length;n++)e["klmnopqrstuvwxyz"[n]]="0123456789abcdef"[n];var r,i,o,a,s={},c=1,l=s,u=[],h="",f="",d=t.length-1;for(n=1;n!=d;)a=t[n],n+=1,"'"==a?r?(o=r.join(""),r=void 0):r=[]:r?r.push(a):"{"==a?(u.push([l,o]),l={},o=void 0):"}"==a?((i=u.pop())[0][i[1]]=l,o=void 0,l=i[0]):"-"==a?c=-1:void 0===o?e.hasOwnProperty(a)?(h+=e[a],o=parseInt(h,16)*c,c=1,h=""):h+=a:e.hasOwnProperty(a)?(f+=e[a],l[o]=parseInt(f,16)*c,c=1,o=void 0,f=""):f+=a;return s},n={codePages:["WinAnsiEncoding"],WinAnsiEncoding:e("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},r={Unicode:{Courier:n,"Courier-Bold":n,"Courier-BoldOblique":n,"Courier-Oblique":n,Helvetica:n,"Helvetica-Bold":n,"Helvetica-BoldOblique":n,"Helvetica-Oblique":n,"Times-Roman":n,"Times-Bold":n,"Times-BoldItalic":n,"Times-Italic":n}},i={Unicode:{"Courier-Oblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":e("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":e("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Helvetica:e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":e("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),"Courier-Bold":e("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":e("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":e("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":e("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e,n,o;(e=i.Unicode[t.PostScriptName])&&((n=t.metadata.Unicode?t.metadata.Unicode:t.metadata.Unicode={}).widths=e.widths,n.kerning=e.kerning),(o=r.Unicode[t.PostScriptName])&&((n=t.metadata.Unicode?t.metadata.Unicode:t.metadata.Unicode={}).encoding=o,o.codePages&&o.codePages.length&&(t.encoding=o.codePages[0]))}])}(e.API),e.API.addSVG=function(t,e,n,r,i){function o(t,e){var n=e.createElement("style");n.type="text/css",n.styleSheet?n.styleSheet.cssText=t:n.appendChild(e.createTextNode(t)),e.getElementsByTagName("head")[0].appendChild(n)}if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");var a=function(t,e){var n=(e.contentWindow||e.contentDocument).document;return n.write(t),n.close(),n.getElementsByTagName("svg")[0]}(t,function(t){var e=t.createElement("iframe");return o(".jsPDF_sillysvg_iframe {display:none;position:absolute;}",t),e.name="childframe",e.setAttribute("width",0),e.setAttribute("height",0),e.setAttribute("frameborder","0"),e.setAttribute("scrolling","no"),e.setAttribute("seamless","seamless"),e.setAttribute("class","jsPDF_sillysvg_iframe"),t.body.appendChild(e),e}(document)),s=[1,1],c=parseFloat(a.getAttribute("width")),l=parseFloat(a.getAttribute("height"));c&&l&&(r&&i?s=[r/c,i/l]:r?s=[r/c,r/c]:i&&(s=[i/l,i/l]));var u,h,f,d,p=a.childNodes;for(u=0,h=p.length;u<h;u++)(f=p[u]).tagName&&"PATH"===f.tagName.toUpperCase()&&((d=function(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}(f.getAttribute("d").split(" ")))[0]=d[0]*s[0]+e,d[1]=d[1]*s[1]+n,this.lines.call(this,d[2],d[0],d[1],s));return this},e.API.putTotalPages=function(t){for(var e=new RegExp(t,"g"),n=1;n<=this.internal.getNumberOfPages();n++)for(var r=0;r<this.internal.pages[n].length;r++)this.internal.pages[n][r]=this.internal.pages[n][r].replace(e,this.internal.getNumberOfPages());return this},/** ==================================================================== 
	 * jsPDF XMP metadata plugin
	 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
	 * 
	 * 
	 * ====================================================================
	 */
	function(t){var n="",r="",i="";e.API.addMetadata=function(t,e){return r=e||"http://jspdf.default.namespaceuri/",n=t,this.internal.events.subscribe("postPutResources",function(){if(n){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+r+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),o=unescape(encodeURIComponent(t)),a=unescape(encodeURIComponent(n)),s=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),c=unescape(encodeURIComponent("</x:xmpmeta>")),l=o.length+a.length+s.length+e.length+c.length;i=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+l+" >>"),this.internal.write("stream"),this.internal.write(e+o+a+s+c),this.internal.write("endstream"),this.internal.write("endobj")}else i=""}),this.internal.events.subscribe("putCatalog",function(){i&&this.internal.write("/Metadata "+i+" 0 R")}),this}}(),function(t){if(t.URL=t.URL||t.webkitURL,t.Blob&&t.URL)try{return void new Blob}catch(t){}var e=t.BlobBuilder||t.WebKitBlobBuilder||t.MozBlobBuilder||function(t){var e=function(t){return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1]},n=function(){this.data=[]},r=function(t,e,n){this.data=t,this.size=t.length,this.type=e,this.encoding=n},i=n.prototype,o=r.prototype,a=t.FileReaderSync,s=function(t){this.code=this[this.name=t]},c="NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "),l=c.length,u=t.URL||t.webkitURL||t,h=u.createObjectURL,f=u.revokeObjectURL,d=u,p=t.btoa,m=t.atob,g=t.ArrayBuffer,w=t.Uint8Array,y=/^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;for(r.fake=o.fake=!0;l--;)s.prototype[c[l]]=l+1;return u.createObjectURL||(d=t.URL=function(t){var e,n=document.createElementNS("http://www.w3.org/1999/xhtml","a");return n.href=t,"origin"in n||("data:"===n.protocol.toLowerCase()?n.origin=null:(e=t.match(y),n.origin=e&&e[1])),n}),d.createObjectURL=function(t){var e,n=t.type;return null===n&&(n="application/octet-stream"),t instanceof r?(e="data:"+n,"base64"===t.encoding?e+";base64,"+t.data:"URI"===t.encoding?e+","+decodeURIComponent(t.data):p?e+";base64,"+p(t.data):e+","+encodeURIComponent(t.data)):h?h.call(u,t):void 0},d.revokeObjectURL=function(t){"data:"!==t.substring(0,5)&&f&&f.call(u,t)},i.append=function(t){var n=this.data;if(w&&(t instanceof g||t instanceof w)){for(var i="",o=new w(t),c=0,l=o.length;c<l;c++)i+=String.fromCharCode(o[c]);n.push(i)}else if("Blob"===e(t)||"File"===e(t)){if(!a)throw new s("NOT_READABLE_ERR");var u=new a;n.push(u.readAsBinaryString(t))}else t instanceof r?"base64"===t.encoding&&m?n.push(m(t.data)):"URI"===t.encoding?n.push(decodeURIComponent(t.data)):"raw"===t.encoding&&n.push(t.data):("string"!=typeof t&&(t+=""),n.push(unescape(encodeURIComponent(t))))},i.getBlob=function(t){return arguments.length||(t=null),new r(this.data.join(""),t,"raw")},i.toString=function(){return"[object BlobBuilder]"},o.slice=function(t,e,n){var i=arguments.length;return i<3&&(n=null),new r(this.data.slice(t,i>1?e:this.data.length),n,this.encoding)},o.toString=function(){return"[object Blob]"},o.close=function(){this.size=0,delete this.data},n}(t);t.Blob=function(t,n){var r=n?n.type||"":"",i=new e;if(t)for(var o=0,a=t.length;o<a;o++)Uint8Array&&t[o]instanceof Uint8Array?i.append(t[o].buffer):i.append(t[o]);var s=i.getBlob(r);return!s.slice&&s.webkitSlice&&(s.slice=s.webkitSlice),s};var n=Object.getPrototypeOf||function(t){return t.__proto__};t.Blob.prototype=n(new t.Blob)}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content||void 0);var r=r||function(t){if(!(void 0===t||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var e=function(){return t.URL||t.webkitURL||t},n=t.document.createElementNS("http://www.w3.org/1999/xhtml","a"),r="download"in n,i=function(t){var e=new MouseEvent("click");t.dispatchEvent(e)},o=/constructor/i.test(t.HTMLElement)||t.safari,a=/CriOS\/[\d]+/.test(navigator.userAgent),s=function(e){(t.setImmediate||t.setTimeout)(function(){throw e},0)},c=function(t){setTimeout(function(){"string"==typeof t?e().revokeObjectURL(t):t.remove()},4e4)},l=function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){s(t)}}},u=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},h=function(s,h,f){f||(s=u(s));var d,p=this,m="application/octet-stream"===s.type,g=function(){l(p,"writestart progress write writeend".split(" "))};if(p.readyState=p.INIT,r)return d=e().createObjectURL(s),void setTimeout(function(){n.href=d,n.download=h,i(n),g(),c(d),p.readyState=p.DONE});!function(){if((a||m&&o)&&t.FileReader){var n=new FileReader;return n.onloadend=function(){var e=a?n.result:n.result.replace(/^data:[^;]*;/,"data:attachment/file;");t.open(e,"_blank")||(t.location.href=e),e=void 0,p.readyState=p.DONE,g()},n.readAsDataURL(s),void(p.readyState=p.INIT)}d||(d=e().createObjectURL(s)),m?t.location.href=d:t.open(d,"_blank")||(t.location.href=d),p.readyState=p.DONE,g(),c(d)}()},f=h.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=u(t)),navigator.msSaveOrOpenBlob(t,e)}:(f.abort=function(){},f.readyState=f.INIT=0,f.WRITING=1,f.DONE=2,f.error=f.onwritestart=f.onprogress=f.onwrite=f.onabort=f.onerror=f.onwriteend=null,function(t,e,n){return new h(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||(void 0).content);"undefined"!=typeof module&&module.exports?module.exports.saveAs=r:"undefined"!=typeof define&&null!==define&&null!==define.amd&&define("FileSaver.js",function(){return r}),function(t,e){"object"==typeof module?module.exports=e():"function"==typeof define?define(e):t.adler32cs=e()}(e,function(){var t="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,e=null,n=function(){if(!t)return function(){return!1};try{var n={};"function"==typeof n.Buffer&&(e=n.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==e&&t instanceof e}}(),r=null!==e?function(t){return new e(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},i=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)r=(r+(n=(n+(255&e.charCodeAt(i)))%65521))%65521;return(r<<16|n)>>>0},o=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)r=(r+(n=(n+e[i])%65521))%65521;return(r<<16|n)>>>0},a={},s=a.Adler32=function(){var e=function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0},a=e.prototype={};return a.constructor=e,e.from=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=i(1,t.toString())}),e.fromUtf8=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var n=r(t.toString());this.checksum=i(1,n)}),t&&(e.fromBuffer=function(t){return t.prototype=a,t}(function(t){if(!(this instanceof e))throw new TypeError("Constructor cannot called be as a function.");if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var r=new Uint8Array(t);return this.checksum=o(1,r)})),a.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=i(this.checksum,t)},a.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return this.checksum=i(this.checksum,e)},t&&(a.updateBuffer=function(t){if(!n(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=o(this.checksum,e)}),a.clone=function(){return new s(this.checksum)},e}();return a.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return i(1,t.toString())},a.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=r(t.toString());return i(1,e)},t&&(a.fromBuffer=function(t){if(!n(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return o(1,e)}),a});/**
	 * CssColors
	 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */
	var i={};i._colorsTable={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",ghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",honeydew:"#f0fff0",hotpink:"#ff69b4","indianred ":"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgrey:"#d3d3d3",lightgreen:"#90ee90",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370d8",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#d87093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",seagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"},i.colorNameToHex=function(t){return t=t.toLowerCase(),void 0!==this._colorsTable[t]&&this._colorsTable[t]};/*
	 Deflate.js - https://github.com/gildas-lormeau/zip.js
	 Copyright (c) 2013 Gildas Lormeau. All rights reserved.

	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are met:

	 1. Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.

	 2. Redistributions in binary form must reproduce the above copyright 
	 notice, this list of conditions and the following disclaimer in 
	 the documentation and/or other materials provided with the distribution.

	 3. The names of the authors may not be used to endorse or promote products
	 derived from this software without specific prior written permission.

	 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	var o=function(t){function e(){function t(t){var e,n,i,o,a,c,l=r.dyn_tree,u=r.stat_desc.static_tree,h=r.stat_desc.extra_bits,d=r.stat_desc.extra_base,p=r.stat_desc.max_length,m=0;for(o=0;o<=s;o++)t.bl_count[o]=0;for(l[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<f;e++)(o=l[2*l[2*(n=t.heap[e])+1]+1]+1)>p&&(o=p,m++),l[2*n+1]=o,n>r.max_code||(t.bl_count[o]++,a=0,n>=d&&(a=h[n-d]),c=l[2*n],t.opt_len+=c*(o+a),u&&(t.static_len+=c*(u[2*n+1]+a)));if(0!==m){do{for(o=p-1;0===t.bl_count[o];)o--;t.bl_count[o]--,t.bl_count[o+1]+=2,t.bl_count[p]--,m-=2}while(m>0);for(o=p;0!==o;o--)for(n=t.bl_count[o];0!==n;)(i=t.heap[--e])>r.max_code||(l[2*i+1]!=o&&(t.opt_len+=(o-l[2*i+1])*l[2*i],l[2*i+1]=o),n--)}}function e(t,e){var n=0;do{n|=1&t,t>>>=1,n<<=1}while(--e>0);return n>>>1}function n(t,n,r){var i,o,a,c=[],l=0;for(i=1;i<=s;i++)c[i]=l=l+r[i-1]<<1;for(o=0;o<=n;o++)0!==(a=t[2*o+1])&&(t[2*o]=e(c[a]++,a))}var r=this;r.build_tree=function(e){var i,o,a,s=r.dyn_tree,c=r.stat_desc.static_tree,l=r.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=f,i=0;i<l;i++)0!==s[2*i]?(e.heap[++e.heap_len]=u=i,e.depth[i]=0):s[2*i+1]=0;for(;e.heap_len<2;)s[2*(a=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[a]=0,e.opt_len--,c&&(e.static_len-=c[2*a+1]);for(r.max_code=u,i=Math.floor(e.heap_len/2);i>=1;i--)e.pqdownheap(s,i);a=l;do{i=e.heap[1],e.heap[1]=e.heap[e.heap_len--],e.pqdownheap(s,1),o=e.heap[1],e.heap[--e.heap_max]=i,e.heap[--e.heap_max]=o,s[2*a]=s[2*i]+s[2*o],e.depth[a]=Math.max(e.depth[i],e.depth[o])+1,s[2*i+1]=s[2*o+1]=a,e.heap[1]=a++,e.pqdownheap(s,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1],t(e),n(s,r.max_code,e.bl_count)}}function n(t,e,n,r,i){var o=this;o.static_tree=t,o.extra_bits=e,o.extra_base=n,o.elems=r,o.max_length=i}function r(t,e,n,r,i){var o=this;o.good_length=t,o.max_lazy=e,o.nice_length=n,o.max_chain=r,o.func=i}function i(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function o(){function t(){var t;for(Pt=2*At,Et[Ft-1]=0,t=0;t<Ft-1;t++)Et[t]=0;Vt=z[Gt].max_lazy,Jt=z[Gt].good_length,Qt=z[Gt].nice_length,Xt=z[Gt].max_chain,Mt=0,jt=0,Ht=0,zt=Wt=$-1,Lt=0,Ot=0}function r(){var t;for(t=0;t<h;t++)Kt[2*t]=0;for(t=0;t<c;t++)$t[2*t]=0;for(t=0;t<l;t++)Zt[2*t]=0;Kt[2*d]=1,te.opt_len=te.static_len=0,ae=ce=0}function o(){ee.dyn_tree=Kt,ee.stat_desc=n.static_l_desc,ne.dyn_tree=$t,ne.stat_desc=n.static_d_desc,re.dyn_tree=Zt,re.stat_desc=n.static_bl_desc,ue=0,he=0,le=8,r()}function a(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<c?Zt[2*r]+=a:0!==r?(r!=i&&Zt[2*r]++,Zt[2*p]++):a<=10?Zt[2*m]++:Zt[2*g]++,a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4))}function s(){var t;for(a(Kt,ee.max_code),a($t,ne.max_code),re.build_tree(te),t=l-1;t>=3&&0===Zt[2*e.bl_order[t]+1];t--);return te.opt_len+=3*(t+1)+5+5+4,t}function f(t){te.pending_buf[te.pending++]=t}function O(t){f(255&t),f(t>>>8&255)}function et(t){f(t>>8&255),f(255&t)}function nt(t,e){var n,r=e;he>w-r?(O(ue|=(n=t)<<he&65535),ue=n>>>w-he,he+=r-w):(ue|=t<<he&65535,he+=r)}function rt(t,e){var n=2*t;nt(65535&e[n],65535&e[n+1])}function it(t,e){var n,r,i=-1,o=t[1],a=0,s=7,c=4;for(0===o&&(s=138,c=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<c)do{rt(r,Zt)}while(0!=--a);else 0!==r?(r!=i&&(rt(r,Zt),a--),rt(p,Zt),nt(a-3,2)):a<=10?(rt(m,Zt),nt(a-3,3)):(rt(g,Zt),nt(a-11,7));a=0,i=r,0===o?(s=138,c=3):r==o?(s=6,c=3):(s=7,c=4)}}function ot(t,n,r){var i;for(nt(t-257,5),nt(n-1,5),nt(r-4,4),i=0;i<r;i++)nt(Zt[2*e.bl_order[i]+1],3);it(Kt,t-1),it($t,n-1)}function at(){16==he?(O(ue),ue=0,he=0):he>=8&&(f(255&ue),ue>>>=8,he-=8)}function st(){nt(Q<<1,3),rt(d,n.static_ltree),at(),1+le+10-he<9&&(nt(Q<<1,3),rt(d,n.static_ltree),at()),le=7}function ct(t,n){var r,i,o;if(te.pending_buf[se+2*ae]=t>>>8&255,te.pending_buf[se+2*ae+1]=255&t,te.pending_buf[ie+ae]=255&n,ae++,0===t?Kt[2*n]++:(ce++,t--,Kt[2*(e._length_code[n]+u+1)]++,$t[2*e.d_code(t)]++),0==(8191&ae)&&Gt>2){for(r=8*ae,i=Mt-jt,o=0;o<c;o++)r+=$t[2*o]*(5+e.extra_dbits[o]);if(r>>>=3,ce<Math.floor(ae/2)&&r<Math.floor(i/2))return!0}return ae==oe-1}function lt(t,n){var r,i,o,a,s=0;if(0!==ae)do{r=te.pending_buf[se+2*s]<<8&65280|255&te.pending_buf[se+2*s+1],i=255&te.pending_buf[ie+s],s++,0===r?rt(i,t):(rt((o=e._length_code[i])+u+1,t),0!==(a=e.extra_lbits[o])&&nt(i-=e.base_length[o],a),r--,rt(o=e.d_code(r),n),0!==(a=e.extra_dbits[o])&&nt(r-=e.base_dist[o],a))}while(s<ae);rt(d,t),le=t[2*d+1]}function ut(){he>8?O(ue):he>0&&f(255&ue),ue=0,he=0}function ht(t,e,n){ut(),le=8,n&&(O(e),O(~e)),te.pending_buf.set(Tt.subarray(t,t+e),te.pending),te.pending+=e}function ft(t,e,n){nt((J<<1)+(n?1:0),3),ht(t,e,!0)}function dt(t,e,i){var o,a,c=0;Gt>0?(ee.build_tree(te),ne.build_tree(te),c=s(),o=te.opt_len+3+7>>>3,(a=te.static_len+3+7>>>3)<=o&&(o=a)):o=a=e+5,e+4<=o&&-1!=t?ft(t,e,i):a==o?(nt((Q<<1)+(i?1:0),3),lt(n.static_ltree,n.static_dtree)):(nt((K<<1)+(i?1:0),3),ot(ee.max_code+1,ne.max_code+1,c+1),lt(Kt,$t)),r(),i&&ut()}function pt(t){dt(jt>=0?jt:-1,Mt-jt,t),jt=Mt,xt.flush_pending()}function mt(){var t,e,n,r;do{if(0===(r=Pt-Ht-Mt)&&0===Mt&&0===Ht)r=At;else if(-1==r)r--;else if(Mt>=At+At-tt){Tt.set(Tt.subarray(At,At+At),0),Ut-=At,Mt-=At,jt-=At,n=t=Ft;do{e=65535&Et[--n],Et[n]=e>=At?e-At:0}while(0!=--t);n=t=At;do{e=65535&It[--n],It[n]=e>=At?e-At:0}while(0!=--t);r+=At}if(0===xt.avail_in)return;t=xt.read_buf(Tt,Mt+Ht,r),(Ht+=t)>=$&&(Ot=255&Tt[Mt],Ot=(Ot<<Dt^255&Tt[Mt+1])&Rt)}while(Ht<tt&&0!==xt.avail_in)}function gt(t){var e,n=65535;for(n>_t-5&&(n=_t-5);;){if(Ht<=1){if(mt(),0===Ht&&t==k)return L;if(0===Ht)break}if(Mt+=Ht,Ht=0,e=jt+n,(0===Mt||Mt>=e)&&(Ht=Mt-e,Mt=e,pt(!1),0===xt.avail_out))return L;if(Mt-jt>=At-tt&&(pt(!1),0===xt.avail_out))return L}return pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function wt(t){var e,n,r=Xt,i=Mt,o=Wt,a=Mt>At-tt?Mt-(At-tt):0,s=Qt,c=qt,l=Mt+Z,u=Tt[i+o-1],h=Tt[i+o];Wt>=Jt&&(r>>=2),s>Ht&&(s=Ht);do{if(e=t,Tt[e+o]==h&&Tt[e+o-1]==u&&Tt[e]==Tt[i]&&Tt[++e]==Tt[i+1]){i+=2,e++;do{}while(Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&Tt[++i]==Tt[++e]&&i<l);if(n=Z-(l-i),i=l-Z,n>o){if(Ut=t,o=n,n>=s)break;u=Tt[i+o-1],h=Tt[i+o]}}}while((t=65535&It[t&c])>a&&0!=--r);return o<=Ht?o:Ht}function yt(t){for(var e,n=0;;){if(Ht<tt){if(mt(),Ht<tt&&t==k)return L;if(0===Ht)break}if(Ht>=$&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,n=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt),0!==n&&(Mt-n&65535)<=At-tt&&Yt!=b&&(zt=wt(n)),zt>=$)if(e=ct(Mt-Ut,zt-$),Ht-=zt,zt<=Vt&&Ht>=$){zt--;do{Ot=(Ot<<Dt^255&Tt[++Mt+($-1)])&Rt,n=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt}while(0!=--zt);Mt++}else Mt+=zt,zt=0,Ot=255&Tt[Mt],Ot=(Ot<<Dt^255&Tt[Mt+1])&Rt;else e=ct(0,255&Tt[Mt]),Ht--,Mt++;if(e&&(pt(!1),0===xt.avail_out))return L}return pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function vt(t){for(var e,n,r=0;;){if(Ht<tt){if(mt(),Ht<tt&&t==k)return L;if(0===Ht)break}if(Ht>=$&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,r=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt),Wt=zt,Nt=Ut,zt=$-1,0!==r&&Wt<Vt&&(Mt-r&65535)<=At-tt&&(Yt!=b&&(zt=wt(r)),zt<=5&&(Yt==v||zt==$&&Mt-Ut>4096)&&(zt=$-1)),Wt>=$&&zt<=Wt){n=Mt+Ht-$,e=ct(Mt-1-Nt,Wt-$),Ht-=Wt-1,Wt-=2;do{++Mt<=n&&(Ot=(Ot<<Dt^255&Tt[Mt+($-1)])&Rt,r=65535&Et[Ot],It[Mt&qt]=Et[Ot],Et[Ot]=Mt)}while(0!=--Wt);if(Lt=0,zt=$-1,Mt++,e&&(pt(!1),0===xt.avail_out))return L}else if(0!==Lt){if((e=ct(0,255&Tt[Mt-1]))&&pt(!1),Mt++,Ht--,0===xt.avail_out)return L}else Lt=1,Mt++,Ht--}return 0!==Lt&&(e=ct(0,255&Tt[Mt-1]),Lt=0),pt(t==A),0===xt.avail_out?t==A?U:L:t==A?H:M}function bt(e){return e.total_in=e.total_out=0,e.msg=null,te.pending=0,te.pending_out=0,kt=V,Ct=k,o(),t(),S}var xt,kt,_t,Ct,At,St,qt,Tt,Pt,It,Et,Ot,Ft,Bt,Rt,Dt,jt,zt,Nt,Lt,Mt,Ut,Ht,Wt,Xt,Vt,Gt,Yt,Jt,Qt,Kt,$t,Zt,te=this,ee=new e,ne=new e,re=new e;te.depth=[];var ie,oe,ae,se,ce,le,ue,he;te.bl_count=[],te.heap=[],Kt=[],$t=[],Zt=[],te.pqdownheap=function(t,e){for(var n=te.heap,r=n[e],o=e<<1;o<=te.heap_len&&(o<te.heap_len&&i(t,n[o+1],n[o],te.depth)&&o++,!i(t,r,n[o],te.depth));)n[e]=n[o],e=o,o<<=1;n[e]=r},te.deflateInit=function(t,e,n,r,i,o){return r||(r=Y),i||(i=B),o||(o=x),t.msg=null,e==y&&(e=6),i<1||i>F||r!=Y||n<9||n>15||e<0||e>9||o<0||o>b?P:(t.dstate=te,St=n,At=1<<St,qt=At-1,Bt=i+7,Ft=1<<Bt,Rt=Ft-1,Dt=Math.floor((Bt+$-1)/$),Tt=new Uint8Array(2*At),It=[],Et=[],oe=1<<i+6,te.pending_buf=new Uint8Array(4*oe),_t=4*oe,se=Math.floor(oe/2),ie=3*oe,Gt=e,Yt=o,bt(t))},te.deflateEnd=function(){return kt!=X&&kt!=V&&kt!=G?P:(te.pending_buf=null,Et=null,It=null,Tt=null,te.dstate=null,kt==V?I:S)},te.deflateParams=function(t,e,n){var r=S;return e==y&&(e=6),e<0||e>9||n<0||n>b?P:(z[Gt].func!=z[e].func&&0!==t.total_in&&(r=t.deflate(_)),Gt!=e&&(Vt=z[Gt=e].max_lazy,Jt=z[Gt].good_length,Qt=z[Gt].nice_length,Xt=z[Gt].max_chain),Yt=n,r)},te.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||kt!=X)return P;if(i<$)return S;for(i>At-tt&&(o=n-(i=At-tt)),Tt.set(e.subarray(o,o+i),0),Mt=i,jt=i,Ot=255&Tt[0],Ot=(Ot<<Dt^255&Tt[1])&Rt,r=0;r<=i-$;r++)Ot=(Ot<<Dt^255&Tt[r+($-1)])&Rt,It[r&qt]=Et[Ot],Et[Ot]=r;return S},te.deflate=function(t,e){var n,r,i,o,a;if(e>A||e<0)return P;if(!t.next_out||!t.next_in&&0!==t.avail_in||kt==G&&e!=A)return t.msg=N[T-P],P;if(0===t.avail_out)return t.msg=N[T-E],E;if(xt=t,o=Ct,Ct=e,kt==X&&(r=Y+(St-8<<4)<<8,(i=(Gt-1&255)>>1)>3&&(i=3),r|=i<<6,0!==Mt&&(r|=W),kt=V,et(r+=31-r%31)),0!==te.pending){if(xt.flush_pending(),0===xt.avail_out)return Ct=-1,S}else if(0===xt.avail_in&&e<=o&&e!=A)return xt.msg=N[T-E],E;if(kt==G&&0!==xt.avail_in)return t.msg=N[T-E],E;if(0!==xt.avail_in||0!==Ht||e!=k&&kt!=G){switch(a=-1,z[Gt].func){case R:a=gt(e);break;case D:a=yt(e);break;case j:a=vt(e)}if(a!=U&&a!=H||(kt=G),a==L||a==U)return 0===xt.avail_out&&(Ct=-1),S;if(a==M){if(e==_)st();else if(ft(0,0,!1),e==C)for(n=0;n<Ft;n++)Et[n]=0;if(xt.flush_pending(),0===xt.avail_out)return Ct=-1,S}}return e!=A?S:q}}function a(){var t=this;t.next_in_index=0,t.next_out_index=0,t.avail_in=0,t.total_in=0,t.avail_out=0,t.total_out=0}var s=15,c=30,l=19,u=256,h=u+1+29,f=2*h+1,d=256,p=16,m=17,g=18,w=16,y=-1,v=1,b=2,x=0,k=0,_=1,C=3,A=4,S=0,q=1,T=2,P=-2,I=-3,E=-5,O=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];e._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],e.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],e.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],e.d_code=function(t){return t<256?O[t]:O[256+(t>>>7)]},e.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],e.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],e.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],e.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],n.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],n.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],n.static_l_desc=new n(n.static_ltree,e.extra_lbits,u+1,h,s),n.static_d_desc=new n(n.static_dtree,e.extra_dbits,0,c,s),n.static_bl_desc=new n(null,e.extra_blbits,0,l,7);var F=9,B=8,R=0,D=1,j=2,z=[new r(0,0,0,0,R),new r(4,4,8,4,D),new r(4,5,16,8,D),new r(4,6,32,32,D),new r(4,4,16,16,j),new r(8,16,32,32,j),new r(8,16,128,128,j),new r(8,32,128,256,j),new r(32,128,258,1024,j),new r(32,258,258,4096,j)],N=["need dictionary","stream end","","","stream error","data error","","buffer error","",""],L=0,M=1,U=2,H=3,W=32,X=42,V=113,G=666,Y=8,J=0,Q=1,K=2,$=3,Z=258,tt=Z+$+1;return a.prototype={deflateInit:function(t,e){var n=this;return n.dstate=new o,e||(e=s),n.dstate.deflateInit(n,t,e)},deflate:function(t){var e=this;return e.dstate?e.dstate.deflate(e,t):P},deflateEnd:function(){var t=this;if(!t.dstate)return P;var e=t.dstate.deflateEnd();return t.dstate=null,e},deflateParams:function(t,e){var n=this;return n.dstate?n.dstate.deflateParams(n,t,e):P},deflateSetDictionary:function(t,e){var n=this;return n.dstate?n.dstate.deflateSetDictionary(n,t,e):P},read_buf:function(t,e,n){var r=this,i=r.avail_in;return i>n&&(i=n),0===i?0:(r.avail_in-=i,t.set(r.next_in.subarray(r.next_in_index,r.next_in_index+i),e),r.next_in_index+=i,r.total_in+=i,i)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}},function(t){var e=this,n=new a,r=k,i=new Uint8Array(512);void 0===t&&(t=y),n.deflateInit(t),n.next_out=i,e.append=function(t,e){var o,a=[],s=0,c=0,l=0;if(t.length){n.next_in_index=0,n.next_in=t,n.avail_in=t.length;do{if(n.next_out_index=0,n.avail_out=512,n.deflate(r)!=S)throw"deflating: "+n.msg;n.next_out_index&&(512==n.next_out_index?a.push(new Uint8Array(i)):a.push(new Uint8Array(i.subarray(0,n.next_out_index)))),l+=n.next_out_index,e&&n.next_in_index>0&&n.next_in_index!=s&&(e(n.next_in_index),s=n.next_in_index)}while(n.avail_in>0||0===n.avail_out);return o=new Uint8Array(l),a.forEach(function(t){o.set(t,c),c+=t.length}),o}},e.flush=function(){var t,e,r=[],o=0,a=0;do{if(n.next_out_index=0,n.avail_out=512,(t=n.deflate(A))!=q&&t!=S)throw"deflating: "+n.msg;512-n.avail_out>0&&r.push(new Uint8Array(i.subarray(0,n.next_out_index))),a+=n.next_out_index}while(n.avail_in>0||0===n.avail_out);return n.deflateEnd(),e=new Uint8Array(a),r.forEach(function(t){e.set(t,o),o+=t.length}),e}}}();/*
	  html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
	  Copyright (c) 2016 Niklas von Hertzen

	  Released under  License
	*/
	!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.html2canvas=t()}}(function(){return function t(e,n,r){function i(a,s){if(!n[a]){if(!e[a]){var c="function"==typeof require&&require;if(!s&&c)return c(a,!0);if(o)return o(a,!0);var l=new Error("Cannot find module '"+a+"'");throw l.code="MODULE_NOT_FOUND",l}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n||t)},u,u.exports,t,e,n,r)}return n[a].exports}for(var o="function"==typeof require&&require,a=0;a<r.length;a++)i(r[a]);return i}({1:[function(t,e,n){(function(t){!function(r){function i(t){throw RangeError(E[t])}function o(t,e){for(var n=t.length;n--;)t[n]=e(t[n]);return t}function a(t,e){return o(t.split(I),e).join(".")}function s(t){for(var e,n,r=[],i=0,o=t.length;i<o;)(e=t.charCodeAt(i++))>=55296&&e<=56319&&i<o?56320==(64512&(n=t.charCodeAt(i++)))?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),i--):r.push(e);return r}function c(t){return o(t,function(t){var e="";return t>65535&&(e+=B((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=B(t)}).join("")}function l(t){return t-48<10?t-22:t-65<26?t-65:t-97<26?t-97:b}function u(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function h(t,e,n){var r=0;for(t=n?F(t/C):t>>1,t+=F(t/e);t>O*k>>1;r+=b)t=F(t/O);return F(r+(O+1)*t/(t+_))}function f(t){var e,n,r,o,a,s,u,f,d,p,m=[],g=t.length,w=0,y=S,_=A;for((n=t.lastIndexOf(q))<0&&(n=0),r=0;r<n;++r)t.charCodeAt(r)>=128&&i("not-basic"),m.push(t.charCodeAt(r));for(o=n>0?n+1:0;o<g;){for(a=w,s=1,u=b;o>=g&&i("invalid-input"),((f=l(t.charCodeAt(o++)))>=b||f>F((v-w)/s))&&i("overflow"),w+=f*s,d=u<=_?x:u>=_+k?k:u-_,!(f<d);u+=b)s>F(v/(p=b-d))&&i("overflow"),s*=p;_=h(w-a,e=m.length+1,0==a),F(w/e)>v-y&&i("overflow"),y+=F(w/e),w%=e,m.splice(w++,0,y)}return c(m)}function d(t){var e,n,r,o,a,c,l,f,d,p,m,g,w,y,_,C=[];for(g=(t=s(t)).length,e=S,n=0,a=A,c=0;c<g;++c)(m=t[c])<128&&C.push(B(m));for(r=o=C.length,o&&C.push(q);r<g;){for(l=v,c=0;c<g;++c)(m=t[c])>=e&&m<l&&(l=m);for(l-e>F((v-n)/(w=r+1))&&i("overflow"),n+=(l-e)*w,e=l,c=0;c<g;++c)if((m=t[c])<e&&++n>v&&i("overflow"),m==e){for(f=n,d=b;p=d<=a?x:d>=a+k?k:d-a,!(f<p);d+=b)_=f-p,y=b-p,C.push(B(u(p+_%y,0))),f=F(_/y);C.push(B(u(f,0))),a=h(n,w,r==o),n=0,++r}++n,++e}return C.join("")}var p="object"==typeof n&&n,m="object"==typeof e&&e&&e.exports==p&&e,g="object"==typeof t&&t;g.global!==g&&g.window!==g||(r=g);var w,y,v=2147483647,b=36,x=1,k=26,_=38,C=700,A=72,S=128,q="-",T=/^xn--/,P=/[^ -~]/,I=/\x2E|\u3002|\uFF0E|\uFF61/g,E={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},O=b-x,F=Math.floor,B=String.fromCharCode;if(w={version:"1.2.4",ucs2:{decode:s,encode:c},decode:f,encode:d,toASCII:function(t){return a(t,function(t){return P.test(t)?"xn--"+d(t):t})},toUnicode:function(t){return a(t,function(t){return T.test(t)?f(t.slice(4).toLowerCase()):t})}},p&&!p.nodeType)if(m)m.exports=w;else for(y in w)w.hasOwnProperty(y)&&(p[y]=w[y]);else r.punycode=w}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],2:[function(t,e,n){function r(t,e,n){!t.defaultView||e===t.defaultView.pageXOffset&&n===t.defaultView.pageYOffset||t.defaultView.scrollTo(e,n)}function i(t,e){try{e&&(e.width=t.width,e.height=t.height,e.getContext("2d").putImageData(t.getContext("2d").getImageData(0,0,t.width,t.height),0,0))}catch(e){s("Unable to copy canvas content from",t,e)}}function o(t,e){for(var n=3===t.nodeType?document.createTextNode(t.nodeValue):t.cloneNode(!1),r=t.firstChild;r;)!0!==e&&1===r.nodeType&&"SCRIPT"===r.nodeName||n.appendChild(o(r,e)),r=r.nextSibling;return 1===t.nodeType&&(n._scrollTop=t.scrollTop,n._scrollLeft=t.scrollLeft,"CANVAS"===t.nodeName?i(t,n):"TEXTAREA"!==t.nodeName&&"SELECT"!==t.nodeName||(n.value=t.value)),n}function a(t){if(1===t.nodeType){t.scrollTop=t._scrollTop,t.scrollLeft=t._scrollLeft;for(var e=t.firstChild;e;)a(e),e=e.nextSibling}}var s=t("./log");e.exports=function(t,e,n,i,s,c,l){var u=o(t.documentElement,s.javascriptEnabled),h=e.createElement("iframe");return h.className="html2canvas-container",h.style.visibility="hidden",h.style.position="fixed",h.style.left="-10000px",h.style.top="0px",h.style.border="0",h.width=n,h.height=i,h.scrolling="no",e.body.appendChild(h),new Promise(function(e){var n=h.contentWindow.document;h.contentWindow.onload=h.onload=function(){var t=setInterval(function(){n.body.childNodes.length>0&&(a(n.documentElement),clearInterval(t),"view"===s.type&&(h.contentWindow.scrollTo(c,l),!/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||h.contentWindow.scrollY===l&&h.contentWindow.scrollX===c||(n.documentElement.style.top=-l+"px",n.documentElement.style.left=-c+"px",n.documentElement.style.position="absolute")),e(h))},50)},n.open(),n.write("<!DOCTYPE html><html></html>"),r(t,c,l),n.replaceChild(n.adoptNode(u),n.documentElement),n.close()})}},{"./log":13}],3:[function(t,e,n){function r(t){this.r=0,this.g=0,this.b=0,this.a=null;this.fromArray(t)||this.namedColor(t)||this.rgb(t)||this.rgba(t)||this.hex6(t)||this.hex3(t)}r.prototype.darken=function(t){var e=1-t;return new r([Math.round(this.r*e),Math.round(this.g*e),Math.round(this.b*e),this.a])},r.prototype.isTransparent=function(){return 0===this.a},r.prototype.isBlack=function(){return 0===this.r&&0===this.g&&0===this.b},r.prototype.fromArray=function(t){return Array.isArray(t)&&(this.r=Math.min(t[0],255),this.g=Math.min(t[1],255),this.b=Math.min(t[2],255),t.length>3&&(this.a=t[3])),Array.isArray(t)};var i=/^#([a-f0-9]{3})$/i;r.prototype.hex3=function(t){var e=null;return null!==(e=t.match(i))&&(this.r=parseInt(e[1][0]+e[1][0],16),this.g=parseInt(e[1][1]+e[1][1],16),this.b=parseInt(e[1][2]+e[1][2],16)),null!==e};var o=/^#([a-f0-9]{6})$/i;r.prototype.hex6=function(t){var e=null;return null!==(e=t.match(o))&&(this.r=parseInt(e[1].substring(0,2),16),this.g=parseInt(e[1].substring(2,4),16),this.b=parseInt(e[1].substring(4,6),16)),null!==e};var a=/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;r.prototype.rgb=function(t){var e=null;return null!==(e=t.match(a))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3])),null!==e};var s=/^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;r.prototype.rgba=function(t){var e=null;return null!==(e=t.match(s))&&(this.r=Number(e[1]),this.g=Number(e[2]),this.b=Number(e[3]),this.a=Number(e[4])),null!==e},r.prototype.toString=function(){return null!==this.a&&1!==this.a?"rgba("+[this.r,this.g,this.b,this.a].join(",")+")":"rgb("+[this.r,this.g,this.b].join(",")+")"},r.prototype.namedColor=function(t){t=t.toLowerCase();var e=c[t];if(e)this.r=e[0],this.g=e[1],this.b=e[2];else if("transparent"===t)return this.r=this.g=this.b=this.a=0,!0;return!!e},r.prototype.isColor=!0;var c={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]};e.exports=r},{}],4:[function(t,e,n){function r(t,e){var n=k++;if((e=e||{}).logging&&(g.options.logging=!0,g.options.start=Date.now()),e.async=void 0===e.async||e.async,e.allowTaint=void 0!==e.allowTaint&&e.allowTaint,e.removeContainer=void 0===e.removeContainer||e.removeContainer,e.javascriptEnabled=void 0!==e.javascriptEnabled&&e.javascriptEnabled,e.imageTimeout=void 0===e.imageTimeout?1e4:e.imageTimeout,e.renderer="function"==typeof e.renderer?e.renderer:f,e.strict=!!e.strict,"string"==typeof t){if("string"!=typeof e.proxy)return Promise.reject("Proxy must be used when rendering url");var r=null!=e.width?e.width:window.innerWidth,a=null!=e.height?e.height:window.innerHeight;return v(u(t),e.proxy,document,r,a,e).then(function(t){return o(t.contentWindow.document.documentElement,t,e,r,a)})}var s=(void 0===t?[document.documentElement]:t.length?t:[t])[0];return s.setAttribute(x+n,n),i(s.ownerDocument,e,s.ownerDocument.defaultView.innerWidth,s.ownerDocument.defaultView.innerHeight,n).then(function(t){return"function"==typeof e.onrendered&&(g("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"),e.onrendered(t)),t})}function i(t,e,n,r,i){return y(t,t,n,r,e,t.defaultView.pageXOffset,t.defaultView.pageYOffset).then(function(a){g("Document cloned");var s=x+i,c="["+s+"='"+i+"']";t.querySelector(c).removeAttribute(s);var l=a.contentWindow,u=l.document.querySelector(c);return("function"==typeof e.onclone?Promise.resolve(e.onclone(l.document)):Promise.resolve(!0)).then(function(){return o(u,a,e,n,r)})})}function o(t,e,n,r,i){var o=e.contentWindow,u=new h(o.document),f=new d(n,u),m=b(t),w="view"===n.type?r:c(o.document),y="view"===n.type?i:l(o.document),v=new n.renderer(w,y,f,n,document);return new p(t,v,u,f,n).ready.then(function(){g("Finished rendering");var r;return r="view"===n.type?s(v.canvas,{width:v.canvas.width,height:v.canvas.height,top:0,left:0,x:0,y:0}):t===o.document.body||t===o.document.documentElement||null!=n.canvas?v.canvas:s(v.canvas,{width:null!=n.width?n.width:m.width,height:null!=n.height?n.height:m.height,top:m.top,left:m.left,x:0,y:0}),a(e,n),r})}function a(t,e){e.removeContainer&&(t.parentNode.removeChild(t),g("Cleaned up container"))}function s(t,e){var n=document.createElement("canvas"),r=Math.min(t.width-1,Math.max(0,e.left)),i=Math.min(t.width,Math.max(1,e.left+e.width)),o=Math.min(t.height-1,Math.max(0,e.top)),a=Math.min(t.height,Math.max(1,e.top+e.height));n.width=e.width,n.height=e.height;var s=i-r,c=a-o;return g("Cropping canvas at:","left:",e.left,"top:",e.top,"width:",s,"height:",c),g("Resulting crop with width",e.width,"and height",e.height,"with x",r,"and y",o),n.getContext("2d").drawImage(t,r,o,s,c,e.x,e.y,s,c),n}function c(t){return Math.max(Math.max(t.body.scrollWidth,t.documentElement.scrollWidth),Math.max(t.body.offsetWidth,t.documentElement.offsetWidth),Math.max(t.body.clientWidth,t.documentElement.clientWidth))}function l(t){return Math.max(Math.max(t.body.scrollHeight,t.documentElement.scrollHeight),Math.max(t.body.offsetHeight,t.documentElement.offsetHeight),Math.max(t.body.clientHeight,t.documentElement.clientHeight))}function u(t){var e=document.createElement("a");return e.href=t,e.href=e.href,e}var h=t("./support"),f=t("./renderers/canvas"),d=t("./imageloader"),p=t("./nodeparser"),m=t("./nodecontainer"),g=t("./log"),w=t("./utils"),y=t("./clone"),v=t("./proxy").loadUrlDocument,b=w.getBounds,x="data-html2canvas-node",k=0;r.CanvasRenderer=f,r.NodeContainer=m,r.log=g,r.utils=w;var _="undefined"==typeof document||"function"!=typeof Object.create||"function"!=typeof document.createElement("canvas").getContext?function(){return Promise.reject("No canvas support")}:r;e.exports=_},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(t,e,n){function r(t){if(this.src=t,i("DummyImageContainer for",t),!this.promise||!this.image){i("Initiating DummyImageContainer"),r.prototype.image=new Image;var e=this.image;r.prototype.promise=new Promise(function(t,n){e.onload=t,e.onerror=n,e.src=o(),!0===e.complete&&t(e)})}}var i=t("./log"),o=t("./utils").smallImage;e.exports=r},{"./log":13,"./utils":26}],6:[function(t,e,n){var r=t("./utils").smallImage;e.exports=function(t,e){var n,i,o=document.createElement("div"),a=document.createElement("img"),s=document.createElement("span");o.style.visibility="hidden",o.style.fontFamily=t,o.style.fontSize=e,o.style.margin=0,o.style.padding=0,document.body.appendChild(o),a.src=r(),a.width=1,a.height=1,a.style.margin=0,a.style.padding=0,a.style.verticalAlign="baseline",s.style.fontFamily=t,s.style.fontSize=e,s.style.margin=0,s.style.padding=0,s.appendChild(document.createTextNode("Hidden Text")),o.appendChild(s),o.appendChild(a),n=a.offsetTop-s.offsetTop+1,o.removeChild(s),o.appendChild(document.createTextNode("Hidden Text")),o.style.lineHeight="normal",a.style.verticalAlign="super",i=a.offsetTop-o.offsetTop+1,document.body.removeChild(o),this.baseline=n,this.lineWidth=1,this.middle=i}},{"./utils":26}],7:[function(t,e,n){function r(){this.data={}}var i=t("./font");r.prototype.getMetrics=function(t,e){return void 0===this.data[t+"-"+e]&&(this.data[t+"-"+e]=new i(t,e)),this.data[t+"-"+e]},e.exports=r},{"./font":6}],8:[function(t,e,n){function r(e,n,r){this.image=null,this.src=e;var o=this,a=i(e);this.promise=(n?new Promise(function(t){"about:blank"===e.contentWindow.document.URL||null==e.contentWindow.document.documentElement?e.contentWindow.onload=e.onload=function(){t(e)}:t(e)}):this.proxyLoad(r.proxy,a,r)).then(function(e){return t("./core")(e.contentWindow.document.documentElement,{type:"view",width:e.width,height:e.height,proxy:r.proxy,javascriptEnabled:r.javascriptEnabled,removeContainer:r.removeContainer,allowTaint:r.allowTaint,imageTimeout:r.imageTimeout/2})}).then(function(t){return o.image=t})}var i=t("./utils").getBounds,o=t("./proxy").loadUrlDocument;r.prototype.proxyLoad=function(t,e,n){var r=this.src;return o(r.src,t,r.ownerDocument,e.width,e.height,n)},e.exports=r},{"./core":4,"./proxy":16,"./utils":26}],9:[function(t,e,n){function r(t){this.src=t.value,this.colorStops=[],this.type=null,this.x0=.5,this.y0=.5,this.x1=.5,this.y1=.5,this.promise=Promise.resolve(!0)}r.TYPES={LINEAR:1,RADIAL:2},r.REGEXP_COLORSTOP=/^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i,e.exports=r},{}],10:[function(t,e,n){e.exports=function(t,e){this.src=t,this.image=new Image;var n=this;this.tainted=null,this.promise=new Promise(function(r,i){n.image.onload=r,n.image.onerror=i,e&&(n.image.crossOrigin="anonymous"),n.image.src=t,!0===n.image.complete&&r(n.image)})}},{}],11:[function(t,e,n){function r(t,e){this.link=null,this.options=t,this.support=e,this.origin=this.getOrigin(window.location.href)}var i=t("./log"),o=t("./imagecontainer"),a=t("./dummyimagecontainer"),s=t("./proxyimagecontainer"),c=t("./framecontainer"),l=t("./svgcontainer"),u=t("./svgnodecontainer"),h=t("./lineargradientcontainer"),f=t("./webkitgradientcontainer"),d=t("./utils").bind;r.prototype.findImages=function(t){var e=[];return t.reduce(function(t,e){switch(e.node.nodeName){case"IMG":return t.concat([{args:[e.node.src],method:"url"}]);case"svg":case"IFRAME":return t.concat([{args:[e.node],method:e.node.nodeName}])}return t},[]).forEach(this.addImage(e,this.loadImage),this),e},r.prototype.findBackgroundImage=function(t,e){return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t,this.loadImage),this),t},r.prototype.addImage=function(t,e){return function(n){n.args.forEach(function(r){this.imageExists(t,r)||(t.splice(0,0,e.call(this,n)),i("Added image #"+t.length,"string"==typeof r?r.substring(0,100):r))},this)}},r.prototype.hasImageBackground=function(t){return"none"!==t.method},r.prototype.loadImage=function(t){if("url"===t.method){var e=t.args[0];return!this.isSVG(e)||this.support.svg||this.options.allowTaint?e.match(/data:image\/.*;base64,/i)?new o(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi,""),!1):this.isSameOrigin(e)||!0===this.options.allowTaint||this.isSVG(e)?new o(e,!1):this.support.cors&&!this.options.allowTaint&&this.options.useCORS?new o(e,!0):this.options.proxy?new s(e,this.options.proxy):new a(e):new l(e)}return"linear-gradient"===t.method?new h(t):"gradient"===t.method?new f(t):"svg"===t.method?new u(t.args[0],this.support.svg):"IFRAME"===t.method?new c(t.args[0],this.isSameOrigin(t.args[0].src),this.options):new a(t)},r.prototype.isSVG=function(t){return"svg"===t.substring(t.length-3).toLowerCase()||l.prototype.isInline(t)},r.prototype.imageExists=function(t,e){return t.some(function(t){return t.src===e})},r.prototype.isSameOrigin=function(t){return this.getOrigin(t)===this.origin},r.prototype.getOrigin=function(t){var e=this.link||(this.link=document.createElement("a"));return e.href=t,e.href=e.href,e.protocol+e.hostname+e.port},r.prototype.getPromise=function(t){return this.timeout(t,this.options.imageTimeout).catch(function(){return new a(t.src).promise.then(function(e){t.image=e})})},r.prototype.get=function(t){var e=null;return this.images.some(function(n){return(e=n).src===t})?e:null},r.prototype.fetch=function(t){return this.images=t.reduce(d(this.findBackgroundImage,this),this.findImages(t)),this.images.forEach(function(t,e){t.promise.then(function(){i("Succesfully loaded image #"+(e+1),t)},function(n){i("Failed loading image #"+(e+1),t,n)})}),this.ready=Promise.all(this.images.map(this.getPromise,this)),i("Finished searching images"),this},r.prototype.timeout=function(t,e){var n,r=Promise.race([t.promise,new Promise(function(r,o){n=setTimeout(function(){i("Timed out loading image",t),o(t)},e)})]).then(function(t){return clearTimeout(n),t});return r.catch(function(){clearTimeout(n)}),r},e.exports=r},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(t,e,n){function r(t){i.apply(this,arguments),this.type=i.TYPES.LINEAR;var e=r.REGEXP_DIRECTION.test(t.args[0])||!i.REGEXP_COLORSTOP.test(t.args[0]);e?t.args[0].split(/\s+/).reverse().forEach(function(t,e){switch(t){case"left":this.x0=0,this.x1=1;break;case"top":this.y0=0,this.y1=1;break;case"right":this.x0=1,this.x1=0;break;case"bottom":this.y0=1,this.y1=0;break;case"to":var n=this.y0,r=this.x0;this.y0=this.y1,this.x0=this.x1,this.x1=r,this.y1=n;break;case"center":break;default:var i=.01*parseFloat(t,10);if(isNaN(i))break;0===e?(this.y0=i,this.y1=1-this.y0):(this.x0=i,this.x1=1-this.x0)}},this):(this.y0=0,this.y1=1),this.colorStops=t.args.slice(e?1:0).map(function(t){var e=t.match(i.REGEXP_COLORSTOP),n=+e[2],r=0===n?"%":e[3];return{color:new o(e[1]),stop:"%"===r?n/100:null}}),null===this.colorStops[0].stop&&(this.colorStops[0].stop=0),null===this.colorStops[this.colorStops.length-1].stop&&(this.colorStops[this.colorStops.length-1].stop=1),this.colorStops.forEach(function(t,e){null===t.stop&&this.colorStops.slice(e).some(function(n,r){return null!==n.stop&&(t.stop=(n.stop-this.colorStops[e-1].stop)/(r+1)+this.colorStops[e-1].stop,!0)},this)},this)}var i=t("./gradientcontainer"),o=t("./color");r.prototype=Object.create(i.prototype),r.REGEXP_DIRECTION=/^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i,e.exports=r},{"./color":3,"./gradientcontainer":9}],13:[function(t,e,n){var r=function(){r.options.logging&&window.console&&window.console.log&&Function.prototype.bind.call(window.console.log,window.console).apply(window.console,[Date.now()-r.options.start+"ms","html2canvas:"].concat([].slice.call(arguments,0)))};r.options={logging:!1},e.exports=r},{}],14:[function(t,e,n){function r(t,e){this.node=t,this.parent=e,this.stack=null,this.bounds=null,this.borders=null,this.clip=[],this.backgroundClip=[],this.offsetBounds=null,this.visible=null,this.computedStyles=null,this.colors={},this.styles={},this.backgroundImages=null,this.transformData=null,this.transformMatrix=null,this.isPseudoElement=!1,this.opacity=null}function i(t){var e=t.options[t.selectedIndex||0];return e?e.text||"":""}function o(t){if(t&&"matrix"===t[1])return t[2].split(",").map(function(t){return parseFloat(t.trim())});if(t&&"matrix3d"===t[1]){var e=t[2].split(",").map(function(t){return parseFloat(t.trim())});return[e[0],e[1],e[4],e[5],e[12],e[13]]}}function a(t){return-1!==t.toString().indexOf("%")}function s(t){return t.replace("px","")}function c(t){return parseFloat(t)}var l=t("./color"),u=t("./utils"),h=u.getBounds,f=u.parseBackgrounds,d=u.offsetBounds;r.prototype.cloneTo=function(t){t.visible=this.visible,t.borders=this.borders,t.bounds=this.bounds,t.clip=this.clip,t.backgroundClip=this.backgroundClip,t.computedStyles=this.computedStyles,t.styles=this.styles,t.backgroundImages=this.backgroundImages,t.opacity=this.opacity},r.prototype.getOpacity=function(){return null===this.opacity?this.opacity=this.cssFloat("opacity"):this.opacity},r.prototype.assignStack=function(t){this.stack=t,t.children.push(this)},r.prototype.isElementVisible=function(){return this.node.nodeType===Node.TEXT_NODE?this.parent.visible:"none"!==this.css("display")&&"hidden"!==this.css("visibility")&&!this.node.hasAttribute("data-html2canvas-ignore")&&("INPUT"!==this.node.nodeName||"hidden"!==this.node.getAttribute("type"))},r.prototype.css=function(t){return this.computedStyles||(this.computedStyles=this.isPseudoElement?this.parent.computedStyle(this.before?":before":":after"):this.computedStyle(null)),this.styles[t]||(this.styles[t]=this.computedStyles[t])},r.prototype.prefixedCss=function(t){var e=["webkit","moz","ms","o"],n=this.css(t);return void 0===n&&e.some(function(e){return void 0!==(n=this.css(e+t.substr(0,1).toUpperCase()+t.substr(1)))},this),void 0===n?null:n},r.prototype.computedStyle=function(t){return this.node.ownerDocument.defaultView.getComputedStyle(this.node,t)},r.prototype.cssInt=function(t){var e=parseInt(this.css(t),10);return isNaN(e)?0:e},r.prototype.color=function(t){return this.colors[t]||(this.colors[t]=new l(this.css(t)))},r.prototype.cssFloat=function(t){var e=parseFloat(this.css(t));return isNaN(e)?0:e},r.prototype.fontWeight=function(){var t=this.css("fontWeight");switch(parseInt(t,10)){case 401:t="bold";break;case 400:t="normal"}return t},r.prototype.parseClip=function(){var t=this.css("clip").match(this.CLIP);return t?{top:parseInt(t[1],10),right:parseInt(t[2],10),bottom:parseInt(t[3],10),left:parseInt(t[4],10)}:null},r.prototype.parseBackgroundImages=function(){return this.backgroundImages||(this.backgroundImages=f(this.css("backgroundImage")))},r.prototype.cssList=function(t,e){var n=(this.css(t)||"").split(",");return n=n[e||0]||n[0]||"auto",1===(n=n.trim().split(" ")).length&&(n=[n[0],a(n[0])?"auto":n[0]]),n},r.prototype.parseBackgroundSize=function(t,e,n){var r,i,o=this.cssList("backgroundSize",n);if(a(o[0]))r=t.width*parseFloat(o[0])/100;else{if(/contain|cover/.test(o[0])){var s=t.width/t.height,c=e.width/e.height;return s<c^"contain"===o[0]?{width:t.height*c,height:t.height}:{width:t.width,height:t.width/c}}r=parseInt(o[0],10)}return i="auto"===o[0]&&"auto"===o[1]?e.height:"auto"===o[1]?r/e.width*e.height:a(o[1])?t.height*parseFloat(o[1])/100:parseInt(o[1],10),"auto"===o[0]&&(r=i/e.height*e.width),{width:r,height:i}},r.prototype.parseBackgroundPosition=function(t,e,n,r){var i,o,s=this.cssList("backgroundPosition",n);return i=a(s[0])?(t.width-(r||e).width)*(parseFloat(s[0])/100):parseInt(s[0],10),o="auto"===s[1]?i/e.width*e.height:a(s[1])?(t.height-(r||e).height)*parseFloat(s[1])/100:parseInt(s[1],10),"auto"===s[0]&&(i=o/e.height*e.width),{left:i,top:o}},r.prototype.parseBackgroundRepeat=function(t){return this.cssList("backgroundRepeat",t)[0]},r.prototype.parseTextShadows=function(){var t=this.css("textShadow"),e=[];if(t&&"none"!==t)for(var n=t.match(this.TEXT_SHADOW_PROPERTY),r=0;n&&r<n.length;r++){var i=n[r].match(this.TEXT_SHADOW_VALUES);e.push({color:new l(i[0]),offsetX:i[1]?parseFloat(i[1].replace("px","")):0,offsetY:i[2]?parseFloat(i[2].replace("px","")):0,blur:i[3]?i[3].replace("px",""):0})}return e},r.prototype.parseTransform=function(){if(!this.transformData)if(this.hasTransform()){var t=this.parseBounds(),e=this.prefixedCss("transformOrigin").split(" ").map(s).map(c);e[0]+=t.left,e[1]+=t.top,this.transformData={origin:e,matrix:this.parseTransformMatrix()}}else this.transformData={origin:[0,0],matrix:[1,0,0,1,0,0]};return this.transformData},r.prototype.parseTransformMatrix=function(){if(!this.transformMatrix){var t=this.prefixedCss("transform"),e=t?o(t.match(this.MATRIX_PROPERTY)):null;this.transformMatrix=e||[1,0,0,1,0,0]}return this.transformMatrix},r.prototype.parseBounds=function(){return this.bounds||(this.bounds=this.hasTransform()?d(this.node):h(this.node))},r.prototype.hasTransform=function(){return"1,0,0,1,0,0"!==this.parseTransformMatrix().join(",")||this.parent&&this.parent.hasTransform()},r.prototype.getValue=function(){var t=this.node.value||"";return"SELECT"===this.node.tagName?t=i(this.node):"password"===this.node.type&&(t=Array(t.length+1).join("•")),0===t.length?this.node.placeholder||"":t},r.prototype.MATRIX_PROPERTY=/(matrix|matrix3d)\((.+)\)/,r.prototype.TEXT_SHADOW_PROPERTY=/((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g,r.prototype.TEXT_SHADOW_VALUES=/(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g,r.prototype.CLIP=/^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/,e.exports=r},{"./color":3,"./utils":26}],15:[function(t,e,n){function r(t,e,n,r,i){L("Starting NodeParser"),this.renderer=e,this.options=i,this.range=null,this.support=n,this.renderQueue=[],this.stack=new G(!0,1,t.ownerDocument,null);var o=new U(t,null);if(i.background&&e.rectangle(0,0,e.width,e.height,new V(i.background)),t===t.ownerDocument.documentElement){var a=new U(o.color("backgroundColor").isTransparent()?t.ownerDocument.body:t.ownerDocument.documentElement,null);e.rectangle(0,0,e.width,e.height,a.color("backgroundColor"))}o.visibile=o.isElementVisible(),this.createPseudoHideStyles(t.ownerDocument),this.disableAnimations(t.ownerDocument),this.nodes=R([o].concat(this.getChildren(o)).filter(function(t){return t.visible=t.isElementVisible()}).map(this.getPseudoElements,this)),this.fontMetrics=new X,L("Fetched nodes, total:",this.nodes.length),L("Calculate overflow clips"),this.calculateOverflowClips(),L("Start fetching images"),this.images=r.fetch(this.nodes.filter(q)),this.ready=this.images.ready.then(J(function(){return L("Images loaded, starting parsing"),L("Creating stacking contexts"),this.createStackingContexts(),L("Sorting stacking contexts"),this.sortStackingContexts(this.stack),this.parse(this.stack),L("Render queue created with "+this.renderQueue.length+" items"),new Promise(J(function(t){i.async?"function"==typeof i.async?i.async.call(this,this.renderQueue,t):this.renderQueue.length>0?(this.renderIndex=0,this.asyncRenderer(this.renderQueue,t)):t():(this.renderQueue.forEach(this.paint,this),t())},this))},this))}function i(t){return t.parent&&t.parent.clip.length}function o(t){return t.replace(/(\-[a-z])/g,function(t){return t.toUpperCase().replace("-","")})}function a(){}function s(t,e,n,r){return t.map(function(i,o){if(i.width>0){var a=e.left,s=e.top,c=e.width,l=e.height-t[2].width;switch(o){case 0:l=t[0].width,i.args=h({c1:[a,s],c2:[a+c,s],c3:[a+c-t[1].width,s+l],c4:[a+t[3].width,s+l]},r[0],r[1],n.topLeftOuter,n.topLeftInner,n.topRightOuter,n.topRightInner);break;case 1:a=e.left+e.width-t[1].width,c=t[1].width,i.args=h({c1:[a+c,s],c2:[a+c,s+l+t[2].width],c3:[a,s+l],c4:[a,s+t[0].width]},r[1],r[2],n.topRightOuter,n.topRightInner,n.bottomRightOuter,n.bottomRightInner);break;case 2:s=s+e.height-t[2].width,l=t[2].width,i.args=h({c1:[a+c,s+l],c2:[a,s+l],c3:[a+t[3].width,s],c4:[a+c-t[3].width,s]},r[2],r[3],n.bottomRightOuter,n.bottomRightInner,n.bottomLeftOuter,n.bottomLeftInner);break;case 3:c=t[3].width,i.args=h({c1:[a,s+l+t[2].width],c2:[a,s],c3:[a+c,s+t[0].width],c4:[a+c,s+l]},r[3],r[0],n.bottomLeftOuter,n.bottomLeftInner,n.topLeftOuter,n.topLeftInner)}}return i})}function c(t,e,n,r){var i=(Math.sqrt(2)-1)/3*4,o=n*i,a=r*i,s=t+n,c=e+r;return{topLeft:u({x:t,y:c},{x:t,y:c-a},{x:s-o,y:e},{x:s,y:e}),topRight:u({x:t,y:e},{x:t+o,y:e},{x:s,y:c-a},{x:s,y:c}),bottomRight:u({x:s,y:e},{x:s,y:e+a},{x:t+o,y:c},{x:t,y:c}),bottomLeft:u({x:s,y:c},{x:s-o,y:c},{x:t,y:e+a},{x:t,y:e})}}function l(t,e,n){var r=t.left,i=t.top,o=t.width,a=t.height,s=e[0][0]<o/2?e[0][0]:o/2,l=e[0][1]<a/2?e[0][1]:a/2,u=e[1][0]<o/2?e[1][0]:o/2,h=e[1][1]<a/2?e[1][1]:a/2,f=e[2][0]<o/2?e[2][0]:o/2,d=e[2][1]<a/2?e[2][1]:a/2,p=e[3][0]<o/2?e[3][0]:o/2,m=e[3][1]<a/2?e[3][1]:a/2,g=o-u,w=a-d,y=o-f,v=a-m;return{topLeftOuter:c(r,i,s,l).topLeft.subdivide(.5),topLeftInner:c(r+n[3].width,i+n[0].width,Math.max(0,s-n[3].width),Math.max(0,l-n[0].width)).topLeft.subdivide(.5),topRightOuter:c(r+g,i,u,h).topRight.subdivide(.5),topRightInner:c(r+Math.min(g,o+n[3].width),i+n[0].width,g>o+n[3].width?0:u-n[3].width,h-n[0].width).topRight.subdivide(.5),bottomRightOuter:c(r+y,i+w,f,d).bottomRight.subdivide(.5),bottomRightInner:c(r+Math.min(y,o-n[3].width),i+Math.min(w,a+n[0].width),Math.max(0,f-n[1].width),d-n[2].width).bottomRight.subdivide(.5),bottomLeftOuter:c(r,i+v,p,m).bottomLeft.subdivide(.5),bottomLeftInner:c(r+n[3].width,i+v,Math.max(0,p-n[3].width),m-n[2].width).bottomLeft.subdivide(.5)}}function u(t,e,n,r){var i=function(t,e,n){return{x:t.x+(e.x-t.x)*n,y:t.y+(e.y-t.y)*n}};return{start:t,startControl:e,endControl:n,end:r,subdivide:function(o){var a=i(t,e,o),s=i(e,n,o),c=i(n,r,o),l=i(a,s,o),h=i(s,c,o),f=i(l,h,o);return[u(t,a,l,f),u(f,h,c,r)]},curveTo:function(t){t.push(["bezierCurve",e.x,e.y,n.x,n.y,r.x,r.y])},curveToReversed:function(r){r.push(["bezierCurve",n.x,n.y,e.x,e.y,t.x,t.y])}}}function h(t,e,n,r,i,o,a){var s=[];return e[0]>0||e[1]>0?(s.push(["line",r[1].start.x,r[1].start.y]),r[1].curveTo(s)):s.push(["line",t.c1[0],t.c1[1]]),n[0]>0||n[1]>0?(s.push(["line",o[0].start.x,o[0].start.y]),o[0].curveTo(s),s.push(["line",a[0].end.x,a[0].end.y]),a[0].curveToReversed(s)):(s.push(["line",t.c2[0],t.c2[1]]),s.push(["line",t.c3[0],t.c3[1]])),e[0]>0||e[1]>0?(s.push(["line",i[1].end.x,i[1].end.y]),i[1].curveToReversed(s)):s.push(["line",t.c4[0],t.c4[1]]),s}function f(t,e,n,r,i,o,a){e[0]>0||e[1]>0?(t.push(["line",r[0].start.x,r[0].start.y]),r[0].curveTo(t),r[1].curveTo(t)):t.push(["line",o,a]),(n[0]>0||n[1]>0)&&t.push(["line",i[0].start.x,i[0].start.y])}function d(t){return t.cssInt("zIndex")<0}function p(t){return t.cssInt("zIndex")>0}function m(t){return 0===t.cssInt("zIndex")}function g(t){return-1!==["inline","inline-block","inline-table"].indexOf(t.css("display"))}function w(t){return t instanceof G}function y(t){return t.node.data.trim().length>0}function v(t){return/^(normal|none|0px)$/.test(t.parent.css("letterSpacing"))}function b(t){return["TopLeft","TopRight","BottomRight","BottomLeft"].map(function(e){var n=t.css("border"+e+"Radius").split(" ");return n.length<=1&&(n[1]=n[0]),n.map(O)})}function x(t){return t.nodeType===Node.TEXT_NODE||t.nodeType===Node.ELEMENT_NODE}function k(t){var e=t.css("position");return"auto"!==(-1!==["absolute","relative","fixed"].indexOf(e)?t.css("zIndex"):"auto")}function _(t){return"static"!==t.css("position")}function C(t){return"none"!==t.css("float")}function A(t){return-1!==["inline-block","inline-table"].indexOf(t.css("display"))}function S(t){var e=this;return function(){return!t.apply(e,arguments)}}function q(t){return t.node.nodeType===Node.ELEMENT_NODE}function T(t){return!0===t.isPseudoElement}function P(t){return t.node.nodeType===Node.TEXT_NODE}function I(t){return function(e,n){return e.cssInt("zIndex")+t.indexOf(e)/t.length-(n.cssInt("zIndex")+t.indexOf(n)/t.length)}}function E(t){return t.getOpacity()<1}function O(t){return parseInt(t,10)}function F(t){return t.width}function B(t){return t.node.nodeType!==Node.ELEMENT_NODE||-1===["SCRIPT","HEAD","TITLE","OBJECT","BR","OPTION"].indexOf(t.node.nodeName)}function R(t){return[].concat.apply([],t)}function D(t){var e=t.substr(0,1);return e===t.substr(t.length-1)&&e.match(/'|"/)?t.substr(1,t.length-2):t}function j(t){for(var e,n=[],r=0,i=!1;t.length;)z(t[r])===i?((e=t.splice(0,r)).length&&n.push(M.ucs2.encode(e)),i=!i,r=0):r++,r>=t.length&&(e=t.splice(0,r)).length&&n.push(M.ucs2.encode(e));return n}function z(t){return-1!==[32,13,10,9,45].indexOf(t)}function N(t){return/[^\u0000-\u00ff]/.test(t)}var L=t("./log"),M=t("punycode"),U=t("./nodecontainer"),H=t("./textcontainer"),W=t("./pseudoelementcontainer"),X=t("./fontmetrics"),V=t("./color"),G=t("./stackingcontext"),Y=t("./utils"),J=Y.bind,Q=Y.getBounds,K=Y.parseBackgrounds,$=Y.offsetBounds;r.prototype.calculateOverflowClips=function(){this.nodes.forEach(function(t){if(q(t)){T(t)&&t.appendToDOM(),t.borders=this.parseBorders(t);var e="hidden"===t.css("overflow")?[t.borders.clip]:[],n=t.parseClip();n&&-1!==["absolute","fixed"].indexOf(t.css("position"))&&e.push([["rect",t.bounds.left+n.left,t.bounds.top+n.top,n.right-n.left,n.bottom-n.top]]),t.clip=i(t)?t.parent.clip.concat(e):e,t.backgroundClip="hidden"!==t.css("overflow")?t.clip.concat([t.borders.clip]):t.clip,T(t)&&t.cleanDOM()}else P(t)&&(t.clip=i(t)?t.parent.clip:[]);T(t)||(t.bounds=null)},this)},r.prototype.asyncRenderer=function(t,e,n){n=n||Date.now(),this.paint(t[this.renderIndex++]),t.length===this.renderIndex?e():n+20>Date.now()?this.asyncRenderer(t,e,n):setTimeout(J(function(){this.asyncRenderer(t,e)},this),0)},r.prototype.createPseudoHideStyles=function(t){this.createStyles(t,"."+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+':before { content: "" !important; display: none !important; }.'+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER+':after { content: "" !important; display: none !important; }')},r.prototype.disableAnimations=function(t){this.createStyles(t,"* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}")},r.prototype.createStyles=function(t,e){var n=t.createElement("style");n.innerHTML=e,t.body.appendChild(n)},r.prototype.getPseudoElements=function(t){var e=[[t]];if(t.node.nodeType===Node.ELEMENT_NODE){var n=this.getPseudoElement(t,":before"),r=this.getPseudoElement(t,":after");n&&e.push(n),r&&e.push(r)}return R(e)},r.prototype.getPseudoElement=function(t,e){var n=t.computedStyle(e);if(!n||!n.content||"none"===n.content||"-moz-alt-content"===n.content||"none"===n.display)return null;for(var r=D(n.content),i="url"===r.substr(0,3),a=document.createElement(i?"img":"html2canvaspseudoelement"),s=new W(a,t,e),c=n.length-1;c>=0;c--){var l=o(n.item(c));a.style[l]=n[l]}if(a.className=W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE+" "+W.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER,i)return a.src=K(r)[0].args[0],[s];var u=document.createTextNode(r);return a.appendChild(u),[s,new H(u,s)]},r.prototype.getChildren=function(t){return R([].filter.call(t.node.childNodes,x).map(function(e){var n=[e.nodeType===Node.TEXT_NODE?new H(e,t):new U(e,t)].filter(B);return e.nodeType===Node.ELEMENT_NODE&&n.length&&"TEXTAREA"!==e.tagName?n[0].isElementVisible()?n.concat(this.getChildren(n[0])):[]:n},this))},r.prototype.newStackingContext=function(t,e){var n=new G(e,t.getOpacity(),t.node,t.parent);t.cloneTo(n),(e?n.getParentStack(this):n.parent.stack).contexts.push(n),t.stack=n},r.prototype.createStackingContexts=function(){this.nodes.forEach(function(t){q(t)&&(this.isRootElement(t)||E(t)||k(t)||this.isBodyWithTransparentRoot(t)||t.hasTransform())?this.newStackingContext(t,!0):q(t)&&(_(t)&&m(t)||A(t)||C(t))?this.newStackingContext(t,!1):t.assignStack(t.parent.stack)},this)},r.prototype.isBodyWithTransparentRoot=function(t){return"BODY"===t.node.nodeName&&t.parent.color("backgroundColor").isTransparent()},r.prototype.isRootElement=function(t){return null===t.parent},r.prototype.sortStackingContexts=function(t){t.contexts.sort(I(t.contexts.slice(0))),t.contexts.forEach(this.sortStackingContexts,this)},r.prototype.parseTextBounds=function(t){return function(e,n,r){if("none"!==t.parent.css("textDecoration").substr(0,4)||0!==e.trim().length){if(this.support.rangeBounds&&!t.parent.hasTransform()){var i=r.slice(0,n).join("").length;return this.getRangeBounds(t.node,i,e.length)}if(t.node&&"string"==typeof t.node.data){var o=t.node.splitText(e.length),a=this.getWrapperBounds(t.node,t.parent.hasTransform());return t.node=o,a}}else this.support.rangeBounds&&!t.parent.hasTransform()||(t.node=t.node.splitText(e.length));return{}}},r.prototype.getWrapperBounds=function(t,e){var n=t.ownerDocument.createElement("html2canvaswrapper"),r=t.parentNode,i=t.cloneNode(!0);n.appendChild(t.cloneNode(!0)),r.replaceChild(n,t);var o=e?$(n):Q(n);return r.replaceChild(i,n),o},r.prototype.getRangeBounds=function(t,e,n){var r=this.range||(this.range=t.ownerDocument.createRange());return r.setStart(t,e),r.setEnd(t,e+n),r.getBoundingClientRect()},r.prototype.parse=function(t){var e=t.contexts.filter(d),n=t.children.filter(q),r=n.filter(S(C)),i=r.filter(S(_)).filter(S(g)),o=n.filter(S(_)).filter(C),s=r.filter(S(_)).filter(g),c=t.contexts.concat(r.filter(_)).filter(m),l=t.children.filter(P).filter(y),u=t.contexts.filter(p);e.concat(i).concat(o).concat(s).concat(c).concat(l).concat(u).forEach(function(t){this.renderQueue.push(t),w(t)&&(this.parse(t),this.renderQueue.push(new a))},this)},r.prototype.paint=function(t){try{t instanceof a?this.renderer.ctx.restore():P(t)?(T(t.parent)&&t.parent.appendToDOM(),this.paintText(t),T(t.parent)&&t.parent.cleanDOM()):this.paintNode(t)}catch(t){if(L(t),this.options.strict)throw t}},r.prototype.paintNode=function(t){w(t)&&(this.renderer.setOpacity(t.opacity),this.renderer.ctx.save(),t.hasTransform()&&this.renderer.setTransform(t.parseTransform())),"INPUT"===t.node.nodeName&&"checkbox"===t.node.type?this.paintCheckbox(t):"INPUT"===t.node.nodeName&&"radio"===t.node.type?this.paintRadio(t):this.paintElement(t)},r.prototype.paintElement=function(t){var e=t.parseBounds();this.renderer.clip(t.backgroundClip,function(){this.renderer.renderBackground(t,e,t.borders.borders.map(F))},this),this.renderer.clip(t.clip,function(){this.renderer.renderBorders(t.borders.borders)},this),this.renderer.clip(t.backgroundClip,function(){switch(t.node.nodeName){case"svg":case"IFRAME":var n=this.images.get(t.node);n?this.renderer.renderImage(t,e,t.borders,n):L("Error loading <"+t.node.nodeName+">",t.node);break;case"IMG":var r=this.images.get(t.node.src);r?this.renderer.renderImage(t,e,t.borders,r):L("Error loading <img>",t.node.src);break;case"CANVAS":this.renderer.renderImage(t,e,t.borders,{image:t.node});break;case"SELECT":case"INPUT":case"TEXTAREA":this.paintFormValue(t)}},this)},r.prototype.paintCheckbox=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height),r={width:n-1,height:n-1,top:e.top,left:e.left},i=[3,3],o=[i,i,i,i],a=[1,1,1,1].map(function(t){return{color:new V("#A5A5A5"),width:t}}),c=l(r,o,a);this.renderer.clip(t.backgroundClip,function(){this.renderer.rectangle(r.left+1,r.top+1,r.width-2,r.height-2,new V("#DEDEDE")),this.renderer.renderBorders(s(a,r,c,o)),t.node.checked&&(this.renderer.font(new V("#424242"),"normal","normal","bold",n-3+"px","arial"),this.renderer.text("✔",r.left+n/6,r.top+n-1))},this)},r.prototype.paintRadio=function(t){var e=t.parseBounds(),n=Math.min(e.width,e.height)-2;this.renderer.clip(t.backgroundClip,function(){this.renderer.circleStroke(e.left+1,e.top+1,n,new V("#DEDEDE"),1,new V("#A5A5A5")),t.node.checked&&this.renderer.circle(Math.ceil(e.left+n/4)+1,Math.ceil(e.top+n/4)+1,Math.floor(n/2),new V("#424242"))},this)},r.prototype.paintFormValue=function(t){var e=t.getValue();if(e.length>0){var n=t.node.ownerDocument,r=n.createElement("html2canvaswrapper");["lineHeight","textAlign","fontFamily","fontWeight","fontSize","color","paddingLeft","paddingTop","paddingRight","paddingBottom","width","height","borderLeftStyle","borderTopStyle","borderLeftWidth","borderTopWidth","boxSizing","whiteSpace","wordWrap"].forEach(function(e){try{r.style[e]=t.css(e)}catch(t){L("html2canvas: Parse: Exception caught in renderFormValue: "+t.message)}});var i=t.parseBounds();r.style.position="fixed",r.style.left=i.left+"px",r.style.top=i.top+"px",r.textContent=e,n.body.appendChild(r),this.paintText(new H(r.firstChild,t)),n.body.removeChild(r)}},r.prototype.paintText=function(t){t.applyTextTransform();var e=M.ucs2.decode(t.node.data),n=this.options.letterRendering&&!v(t)||N(t.node.data)?e.map(function(t){return M.ucs2.encode([t])}):j(e),r=t.parent.fontWeight(),i=t.parent.css("fontSize"),o=t.parent.css("fontFamily"),a=t.parent.parseTextShadows();this.renderer.font(t.parent.color("color"),t.parent.css("fontStyle"),t.parent.css("fontVariant"),r,i,o),a.length?this.renderer.fontShadow(a[0].color,a[0].offsetX,a[0].offsetY,a[0].blur):this.renderer.clearShadow(),this.renderer.clip(t.parent.clip,function(){n.map(this.parseTextBounds(t),this).forEach(function(e,r){e&&(this.renderer.text(n[r],e.left,e.bottom),this.renderTextDecoration(t.parent,e,this.fontMetrics.getMetrics(o,i)))},this)},this)},r.prototype.renderTextDecoration=function(t,e,n){switch(t.css("textDecoration").split(" ")[0]){case"underline":this.renderer.rectangle(e.left,Math.round(e.top+n.baseline+n.lineWidth),e.width,1,t.color("color"));break;case"overline":this.renderer.rectangle(e.left,Math.round(e.top),e.width,1,t.color("color"));break;case"line-through":this.renderer.rectangle(e.left,Math.ceil(e.top+n.middle+n.lineWidth),e.width,1,t.color("color"))}};var Z={inset:[["darken",.6],["darken",.1],["darken",.1],["darken",.6]]};r.prototype.parseBorders=function(t){var e=t.parseBounds(),n=b(t),r=["Top","Right","Bottom","Left"].map(function(e,n){var r=t.css("border"+e+"Style"),i=t.color("border"+e+"Color");"inset"===r&&i.isBlack()&&(i=new V([255,255,255,i.a]));var o=Z[r]?Z[r][n]:null;return{width:t.cssInt("border"+e+"Width"),color:o?i[o[0]](o[1]):i,args:null}}),i=l(e,n,r);return{clip:this.parseBackgroundClip(t,i,r,n,e),borders:s(r,e,i,n)}},r.prototype.parseBackgroundClip=function(t,e,n,r,i){var o=[];switch(t.css("backgroundClip")){case"content-box":case"padding-box":f(o,r[0],r[1],e.topLeftInner,e.topRightInner,i.left+n[3].width,i.top+n[0].width),f(o,r[1],r[2],e.topRightInner,e.bottomRightInner,i.left+i.width-n[1].width,i.top+n[0].width),f(o,r[2],r[3],e.bottomRightInner,e.bottomLeftInner,i.left+i.width-n[1].width,i.top+i.height-n[2].width),f(o,r[3],r[0],e.bottomLeftInner,e.topLeftInner,i.left+n[3].width,i.top+i.height-n[2].width);break;default:f(o,r[0],r[1],e.topLeftOuter,e.topRightOuter,i.left,i.top),f(o,r[1],r[2],e.topRightOuter,e.bottomRightOuter,i.left+i.width,i.top),f(o,r[2],r[3],e.bottomRightOuter,e.bottomLeftOuter,i.left+i.width,i.top+i.height),f(o,r[3],r[0],e.bottomLeftOuter,e.topLeftOuter,i.left,i.top+i.height)}return o},e.exports=r},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,punycode:1}],16:[function(t,e,n){function r(t,e,n){var r="withCredentials"in new XMLHttpRequest;if(!e)return Promise.reject("No proxy configured");var s=o(r),l=a(e,t,s);return r?c(l):i(n,l,s).then(function(t){return f(t.content)})}function i(t,e,n){return new Promise(function(r,i){var o=t.createElement("script"),a=function(){delete window.html2canvas.proxy[n],t.body.removeChild(o)};window.html2canvas.proxy[n]=function(t){a(),r(t)},o.src=e,o.onerror=function(t){a(),i(t)},t.body.appendChild(o)})}function o(t){return t?"":"html2canvas_"+Date.now()+"_"+ ++d+"_"+Math.round(1e5*Math.random())}function a(t,e,n){return t+"?url="+encodeURIComponent(e)+(n.length?"&callback=html2canvas.proxy."+n:"")}function s(t){return function(e){var n,r=new DOMParser;try{n=r.parseFromString(e,"text/html")}catch(t){u("DOMParser not supported, falling back to createHTMLDocument"),n=document.implementation.createHTMLDocument("");try{n.open(),n.write(e),n.close()}catch(t){u("createHTMLDocument write not supported, falling back to document.body.innerHTML"),n.body.innerHTML=e}}var i=n.querySelector("base");if(!i||!i.href.host){var o=n.createElement("base");o.href=t,n.head.insertBefore(o,n.head.firstChild)}return n}}var c=t("./xhr"),l=t("./utils"),u=t("./log"),h=t("./clone"),f=l.decode64,d=0;n.Proxy=r,n.ProxyURL=function(t,e,n){var r="crossOrigin"in new Image,s=o(r),c=a(e,t,s);return r?Promise.resolve(c):i(n,c,s).then(function(t){return"data:"+t.type+";base64,"+t.content})},n.loadUrlDocument=function(t,e,n,i,o,a){return new r(t,e,window.document).then(s(t)).then(function(t){return h(t,n,i,o,a,0,0)})}},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(t,e,n){var r=t("./proxy").ProxyURL;e.exports=function(t,e){var n=document.createElement("a");n.href=t,t=n.href,this.src=t,this.image=new Image;var i=this;this.promise=new Promise(function(n,o){i.image.crossOrigin="Anonymous",i.image.onload=n,i.image.onerror=o,new r(t,e,document).then(function(t){i.image.src=t}).catch(o)})}},{"./proxy":16}],18:[function(t,e,n){function r(t,e,n){i.call(this,t,e),this.isPseudoElement=!0,this.before=":before"===n}var i=t("./nodecontainer");r.prototype.cloneTo=function(t){r.prototype.cloneTo.call(this,t),t.isPseudoElement=!0,t.before=this.before},(r.prototype=Object.create(i.prototype)).appendToDOM=function(){this.before?this.parent.node.insertBefore(this.node,this.parent.node.firstChild):this.parent.node.appendChild(this.node),this.parent.node.className+=" "+this.getHideClass()},r.prototype.cleanDOM=function(){this.node.parentNode.removeChild(this.node),this.parent.node.className=this.parent.node.className.replace(this.getHideClass(),"")},r.prototype.getHideClass=function(){return this["PSEUDO_HIDE_ELEMENT_CLASS_"+(this.before?"BEFORE":"AFTER")]},r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE="___html2canvas___pseudoelement_before",r.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER="___html2canvas___pseudoelement_after",e.exports=r},{"./nodecontainer":14}],19:[function(t,e,n){function r(t,e,n,r,i){this.width=t,this.height=e,this.images=n,this.options=r,this.document=i}var i=t("./log");r.prototype.renderImage=function(t,e,n,r){var i=t.cssInt("paddingLeft"),o=t.cssInt("paddingTop"),a=t.cssInt("paddingRight"),s=t.cssInt("paddingBottom"),c=n.borders,l=e.width-(c[1].width+c[3].width+i+a),u=e.height-(c[0].width+c[2].width+o+s);this.drawImage(r,0,0,r.image.width||l,r.image.height||u,e.left+i+c[3].width,e.top+o+c[0].width,l,u)},r.prototype.renderBackground=function(t,e,n){e.height>0&&e.width>0&&(this.renderBackgroundColor(t,e),this.renderBackgroundImage(t,e,n))},r.prototype.renderBackgroundColor=function(t,e){var n=t.color("backgroundColor");n.isTransparent()||this.rectangle(e.left,e.top,e.width,e.height,n)},r.prototype.renderBorders=function(t){t.forEach(this.renderBorder,this)},r.prototype.renderBorder=function(t){t.color.isTransparent()||null===t.args||this.drawShape(t.args,t.color)},r.prototype.renderBackgroundImage=function(t,e,n){t.parseBackgroundImages().reverse().forEach(function(r,o,a){switch(r.method){case"url":var s=this.images.get(r.args[0]);s?this.renderBackgroundRepeating(t,e,s,a.length-(o+1),n):i("Error loading background-image",r.args[0]);break;case"linear-gradient":case"gradient":var c=this.images.get(r.value);c?this.renderBackgroundGradient(c,e,n):i("Error loading background-image",r.args[0]);break;case"none":break;default:i("Unknown background-image type",r.args[0])}},this)},r.prototype.renderBackgroundRepeating=function(t,e,n,r,i){var o=t.parseBackgroundSize(e,n.image,r),a=t.parseBackgroundPosition(e,n.image,r,o);switch(t.parseBackgroundRepeat(r)){case"repeat-x":case"repeat no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+i[3],e.top+a.top+i[0],99999,o.height,i);break;case"repeat-y":case"no-repeat repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+i[0],o.width,99999,i);break;case"no-repeat":this.backgroundRepeatShape(n,a,o,e,e.left+a.left+i[3],e.top+a.top+i[0],o.width,o.height,i);break;default:this.renderBackgroundRepeat(n,a,o,{top:e.top,left:e.left},i[3],i[0])}},e.exports=r},{"./log":13}],20:[function(t,e,n){function r(t,e){o.apply(this,arguments),this.canvas=this.options.canvas||this.document.createElement("canvas"),this.options.canvas||(this.canvas.width=t,this.canvas.height=e),this.ctx=this.canvas.getContext("2d"),this.taintCtx=this.document.createElement("canvas").getContext("2d"),this.ctx.textBaseline="bottom",this.variables={},s("Initialized CanvasRenderer with size",t,"x",e)}function i(t){return t.length>0}var o=t("../renderer"),a=t("../lineargradientcontainer"),s=t("../log");(r.prototype=Object.create(o.prototype)).setFillStyle=function(t){return this.ctx.fillStyle="object"==typeof t&&t.isColor?t.toString():t,this.ctx},r.prototype.rectangle=function(t,e,n,r,i){this.setFillStyle(i).fillRect(t,e,n,r)},r.prototype.circle=function(t,e,n,r){this.setFillStyle(r),this.ctx.beginPath(),this.ctx.arc(t+n/2,e+n/2,n/2,0,2*Math.PI,!0),this.ctx.closePath(),this.ctx.fill()},r.prototype.circleStroke=function(t,e,n,r,i,o){this.circle(t,e,n,r),this.ctx.strokeStyle=o.toString(),this.ctx.stroke()},r.prototype.drawShape=function(t,e){this.shape(t),this.setFillStyle(e).fill()},r.prototype.taints=function(t){if(null===t.tainted){this.taintCtx.drawImage(t.image,0,0);try{this.taintCtx.getImageData(0,0,1,1),t.tainted=!1}catch(e){this.taintCtx=document.createElement("canvas").getContext("2d"),t.tainted=!0}}return t.tainted},r.prototype.drawImage=function(t,e,n,r,i,o,a,s,c){this.taints(t)&&!this.options.allowTaint||this.ctx.drawImage(t.image,e,n,r,i,o,a,s,c)},r.prototype.clip=function(t,e,n){this.ctx.save(),t.filter(i).forEach(function(t){this.shape(t).clip()},this),e.call(n),this.ctx.restore()},r.prototype.shape=function(t){return this.ctx.beginPath(),t.forEach(function(t,e){"rect"===t[0]?this.ctx.rect.apply(this.ctx,t.slice(1)):this.ctx[0===e?"moveTo":t[0]+"To"].apply(this.ctx,t.slice(1))},this),this.ctx.closePath(),this.ctx},r.prototype.font=function(t,e,n,r,i,o){this.setFillStyle(t).font=[e,n,r,i,o].join(" ").split(",")[0]},r.prototype.fontShadow=function(t,e,n,r){this.setVariable("shadowColor",t.toString()).setVariable("shadowOffsetY",e).setVariable("shadowOffsetX",n).setVariable("shadowBlur",r)},r.prototype.clearShadow=function(){this.setVariable("shadowColor","rgba(0,0,0,0)")},r.prototype.setOpacity=function(t){this.ctx.globalAlpha=t},r.prototype.setTransform=function(t){this.ctx.translate(t.origin[0],t.origin[1]),this.ctx.transform.apply(this.ctx,t.matrix),this.ctx.translate(-t.origin[0],-t.origin[1])},r.prototype.setVariable=function(t,e){return this.variables[t]!==e&&(this.variables[t]=this.ctx[t]=e),this},r.prototype.text=function(t,e,n){this.ctx.fillText(t,e,n)},r.prototype.backgroundRepeatShape=function(t,e,n,r,i,o,a,s,c){var l=[["line",Math.round(i),Math.round(o)],["line",Math.round(i+a),Math.round(o)],["line",Math.round(i+a),Math.round(s+o)],["line",Math.round(i),Math.round(s+o)]];this.clip([l],function(){this.renderBackgroundRepeat(t,e,n,r,c[3],c[0])},this)},r.prototype.renderBackgroundRepeat=function(t,e,n,r,i,o){var a=Math.round(r.left+e.left+i),s=Math.round(r.top+e.top+o);this.setFillStyle(this.ctx.createPattern(this.resizeImage(t,n),"repeat")),this.ctx.translate(a,s),this.ctx.fill(),this.ctx.translate(-a,-s)},r.prototype.renderBackgroundGradient=function(t,e){if(t instanceof a){var n=this.ctx.createLinearGradient(e.left+e.width*t.x0,e.top+e.height*t.y0,e.left+e.width*t.x1,e.top+e.height*t.y1);t.colorStops.forEach(function(t){n.addColorStop(t.stop,t.color.toString())}),this.rectangle(e.left,e.top,e.width,e.height,n)}},r.prototype.resizeImage=function(t,e){var n=t.image;if(n.width===e.width&&n.height===e.height)return n;var r=document.createElement("canvas");return r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(n,0,0,n.width,n.height,0,0,e.width,e.height),r},e.exports=r},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(t,e,n){function r(t,e,n,r){i.call(this,n,r),this.ownStacking=t,this.contexts=[],this.children=[],this.opacity=(this.parent?this.parent.stack.opacity:1)*e}var i=t("./nodecontainer");(r.prototype=Object.create(i.prototype)).getParentStack=function(t){var e=this.parent?this.parent.stack:null;return e?e.ownStacking?e:e.getParentStack(t):t.stack},e.exports=r},{"./nodecontainer":14}],22:[function(t,e,n){function r(t){this.rangeBounds=this.testRangeBounds(t),this.cors=this.testCORS(),this.svg=this.testSVG()}r.prototype.testRangeBounds=function(t){var e,n,r=!1;return t.createRange&&(e=t.createRange()).getBoundingClientRect&&((n=t.createElement("boundtest")).style.height="123px",n.style.display="block",t.body.appendChild(n),e.selectNode(n),123===e.getBoundingClientRect().height&&(r=!0),t.body.removeChild(n)),r},r.prototype.testCORS=function(){return void 0!==(new Image).crossOrigin},r.prototype.testSVG=function(){var t=new Image,e=document.createElement("canvas"),n=e.getContext("2d");t.src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";try{n.drawImage(t,0,0),e.toDataURL()}catch(t){return!1}return!0},e.exports=r},{}],23:[function(t,e,n){function r(t){this.src=t,this.image=null;var e=this;this.promise=this.hasFabric().then(function(){return e.isInline(t)?Promise.resolve(e.inlineFormatting(t)):i(t)}).then(function(t){return new Promise(function(n){window.html2canvas.svg.fabric.loadSVGFromString(t,e.createCanvas.call(e,n))})})}var i=t("./xhr"),o=t("./utils").decode64;r.prototype.hasFabric=function(){return window.html2canvas.svg&&window.html2canvas.svg.fabric?Promise.resolve():Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"))},r.prototype.inlineFormatting=function(t){return/^data:image\/svg\+xml;base64,/.test(t)?this.decode64(this.removeContentType(t)):this.removeContentType(t)},r.prototype.removeContentType=function(t){return t.replace(/^data:image\/svg\+xml(;base64)?,/,"")},r.prototype.isInline=function(t){return/^data:image\/svg\+xml/i.test(t)},r.prototype.createCanvas=function(t){var e=this;return function(n,r){var i=new window.html2canvas.svg.fabric.StaticCanvas("c");e.image=i.lowerCanvasEl,i.setWidth(r.width).setHeight(r.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(n,r)).renderAll(),t(i.lowerCanvasEl)}},r.prototype.decode64=function(t){return"function"==typeof window.atob?window.atob(t):o(t)},e.exports=r},{"./utils":26,"./xhr":28}],24:[function(t,e,n){function r(t,e){this.src=t,this.image=null;var n=this;this.promise=e?new Promise(function(e,r){n.image=new Image,n.image.onload=e,n.image.onerror=r,n.image.src="data:image/svg+xml,"+(new XMLSerializer).serializeToString(t),!0===n.image.complete&&e(n.image)}):this.hasFabric().then(function(){return new Promise(function(e){window.html2canvas.svg.fabric.parseSVGDocument(t,n.createCanvas.call(n,e))})})}var i=t("./svgcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./svgcontainer":23}],25:[function(t,e,n){function r(t,e){o.call(this,t,e)}function i(t,e,n){if(t.length>0)return e+n.toUpperCase()}var o=t("./nodecontainer");(r.prototype=Object.create(o.prototype)).applyTextTransform=function(){this.node.data=this.transform(this.parent.css("textTransform"))},r.prototype.transform=function(t){var e=this.node.data;switch(t){case"lowercase":return e.toLowerCase();case"capitalize":return e.replace(/(^|\s|:|-|\(|\))([a-z])/g,i);case"uppercase":return e.toUpperCase();default:return e}},e.exports=r},{"./nodecontainer":14}],26:[function(t,e,n){n.smallImage=function(){return"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},n.bind=function(t,e){return function(){return t.apply(e,arguments)}},/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	n.decode64=function(t){var e,n,r,i,o,a,s,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=t.length,u="";for(e=0;e<l;e+=4)o=c.indexOf(t[e])<<2|(n=c.indexOf(t[e+1]))>>4,a=(15&n)<<4|(r=c.indexOf(t[e+2]))>>2,s=(3&r)<<6|(i=c.indexOf(t[e+3])),u+=64===r?String.fromCharCode(o):64===i||-1===i?String.fromCharCode(o,a):String.fromCharCode(o,a,s);return u},n.getBounds=function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=null==t.offsetWidth?e.width:t.offsetWidth;return{top:e.top,bottom:e.bottom||e.top+e.height,right:e.left+n,left:e.left,width:n,height:null==t.offsetHeight?e.height:t.offsetHeight}}return{}},n.offsetBounds=function(t){var e=t.offsetParent?n.offsetBounds(t.offsetParent):{top:0,left:0};return{top:t.offsetTop+e.top,bottom:t.offsetTop+t.offsetHeight+e.top,right:t.offsetLeft+e.left+t.offsetWidth,left:t.offsetLeft+e.left,width:t.offsetWidth,height:t.offsetHeight}},n.parseBackgrounds=function(t){var e,n,r,i,o,a,s,c=[],l=0,u=0,h=function(){e&&('"'===n.substr(0,1)&&(n=n.substr(1,n.length-2)),n&&s.push(n),"-"===e.substr(0,1)&&(i=e.indexOf("-",1)+1)>0&&(r=e.substr(0,i),e=e.substr(i)),c.push({prefix:r,method:e.toLowerCase(),value:o,args:s,image:null})),s=[],e=r=n=o=""};return s=[],e=r=n=o="",t.split("").forEach(function(t){if(!(0===l&&" \r\n\t".indexOf(t)>-1)){switch(t){case'"':a?a===t&&(a=null):a=t;break;case"(":if(a)break;if(0===l)return l=1,void(o+=t);u++;break;case")":if(a)break;if(1===l){if(0===u)return l=0,o+=t,void h();u--}break;case",":if(a)break;if(0===l)return void h();if(1===l&&0===u&&!e.match(/^url$/i))return s.push(n),n="",void(o+=t)}o+=t,0===l?e+=t:n+=t}}),h(),c}},{}],27:[function(t,e,n){function r(t){i.apply(this,arguments),this.type="linear"===t.args[0]?i.TYPES.LINEAR:i.TYPES.RADIAL}var i=t("./gradientcontainer");r.prototype=Object.create(i.prototype),e.exports=r},{"./gradientcontainer":9}],28:[function(t,e,n){e.exports=function(t){return new Promise(function(e,n){var r=new XMLHttpRequest;r.open("GET",t),r.onload=function(){200===r.status?e(r.responseText):n(new Error(r.statusText))},r.onerror=function(){n(new Error("Network Error"))},r.send()})}},{}]},{},[4])(4)}),/*
	# PNG.js
	# Copyright (c) 2011 Devon Govett
	# MIT LICENSE
	# 
	# 
	*/
	function(t){var e;e=function(){function e(t){var e,n,r,i,o,a,s,c,l,u,h,f,d,p,m;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],s=t=0;t<4;s=++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,s=d=0;0<=e?d<e:d>e;s=0<=e?++d:--d)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if((h=r-this.transparency.indexed.length)>0)for(s=p=0;0<=h?p<h:p>h;s=0<=h?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":c=(f=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,f.slice(0,c)),this.text[l]=String.fromCharCode.apply(String,f.slice(c+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(m=this.colorType)||6===m,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}var n,r,i;e.load=function(t,n,r){var i;return"function"==typeof n&&(r=n),(i=new XMLHttpRequest).open("GET",t,!0),i.responseType="arraybuffer",i.onload=function(){var t,o;return t=new Uint8Array(i.response||i.mozResponseArrayBuffer),o=new e(t),"function"==typeof(null!=n?n.getContext:void 0)&&o.render(n),"function"==typeof r?r(o):void 0},i.send(null)},e.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},e.prototype.readUInt32=function(){var t,e,n,r;return t=this.data[this.pos++]<<24,e=this.data[this.pos++]<<16,n=this.data[this.pos++]<<8,r=this.data[this.pos++],t|e|n|r},e.prototype.readUInt16=function(){var t,e;return t=this.data[this.pos++]<<8,e=this.data[this.pos++],t|e},e.prototype.decodePixels=function(t){var e,n,r,i,o,a,c,l,u,h,f,d,p,m,g,w,y,v,b,x,k,_,C;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);for(t=(t=new s(t)).getBytes(),w=(d=this.pixelBitlength/8)*this.width,p=new Uint8Array(w*this.height),a=t.length,g=0,m=0,n=0;m<a;){switch(t[m++]){case 0:for(i=b=0;b<w;i=b+=1)p[n++]=t[m++];break;case 1:for(i=x=0;x<w;i=x+=1)e=t[m++],o=i<d?0:p[n-d],p[n++]=(e+o)%256;break;case 2:for(i=k=0;k<w;i=k+=1)e=t[m++],r=(i-i%d)/d,y=g&&p[(g-1)*w+r*d+i%d],p[n++]=(y+e)%256;break;case 3:for(i=_=0;_<w;i=_+=1)e=t[m++],r=(i-i%d)/d,o=i<d?0:p[n-d],y=g&&p[(g-1)*w+r*d+i%d],p[n++]=(e+Math.floor((o+y)/2))%256;break;case 4:for(i=C=0;C<w;i=C+=1)e=t[m++],r=(i-i%d)/d,o=i<d?0:p[n-d],0===g?y=v=0:(y=p[(g-1)*w+r*d+i%d],v=r&&p[(g-1)*w+(r-1)*d+i%d]),c=o+y-v,l=Math.abs(c-o),h=Math.abs(c-y),f=Math.abs(c-v),u=l<=h&&l<=f?o:h<=f?y:v,p[n++]=(e+u)%256;break;default:throw new Error("Invalid filter algorithm: "+t[m-1])}g++}return p},e.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,c;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,t=0,e=a=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(c=o[t++])?c:255;return i},e.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,c,l,u,h,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),i=t.data||t,l=i.length,a=u||e,o=s=0,1===r)for(;o<l;)c=u?4*e[o/4]:s,h=a[c++],i[o++]=h,i[o++]=h,i[o++]=h,i[o++]=n?a[c++]:255,s=c;else for(;o<l;)c=u?4*e[o/4]:s,i[o++]=a[c++],i[o++]=a[c++],i[o++]=a[c++],i[o++]=n?a[c++]:255,s=c},e.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{r=t.document.createElement("canvas"),i=r.getContext("2d")}catch(t){return-1}return n=function(t){var e;return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),e=new Image,e.src=r.toDataURL(),e},e.prototype.decodeFrames=function(t){var e,r,i,o,a,s,c,l;if(this.animation){for(l=[],r=a=0,s=(c=this.animation.frames).length;a<s;r=++a)e=c[r],i=t.createImageData(e.width,e.height),o=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(i,o),e.imageData=i,l.push(e.image=n(i));return l}},e.prototype.renderFrame=function(t,e){var n,r,i;return r=this.animation.frames,n=r[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},e.prototype.animate=function(t){var e,n,r,i,o,a,s=this;return n=0,a=this.animation,i=a.numFrames,r=a.frames,o=a.numPlays,(e=function(){var a,c;if(a=n++%i,c=r[a],s.renderFrame(t,a),i>1&&n/i<o)return s.animation._timeout=setTimeout(e,c.delay)})()},e.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},e.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},e}(),t.PNG=e}("undefined"!=typeof window&&window||void 0);/*
	 * Extracted from pdf.js
	 * https://github.com/andreasgal/pdf.js
	 *
	 * Copyright (c) 2011 Mozilla Foundation
	 *
	 * Contributors: Andreas Gal <gal@mozilla.com>
	 *               Chris G Jones <cjones@mozilla.com>
	 *               Shaon Barman <shaon.barman@gmail.com>
	 *               Vivien Nicolas <21@vingtetun.org>
	 *               Justin D'Arcangelo <justindarc@gmail.com>
	 *               Yury Delendik
	 *
	 * 
	 */
	var a=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(r=e+t;!this.eof&&this.bufferLength<r;)this.readBlock();var n=this.bufferLength;r>n&&(r=n)}else{for(;!this.eof;)this.readBlock();var r=this.bufferLength}return this.pos=r,this.buffer.subarray(e,r)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),s=function(){function t(t){throw new Error(t)}function e(e){var n=0,r=e[n++],i=e[n++];-1!=r&&-1!=i||t("Invalid header in flate stream"),8!=(15&r)&&t("Unknown compression method in flate stream"),((r<<8)+i)%31!=0&&t("Bad FCHECK in flate stream"),32&i&&t("FDICT bit set in flate stream"),this.bytes=e,this.bytesPos=n,this.codeSize=0,this.codeBuf=0,a.call(this)}if("undefined"!=typeof Uint32Array){var n=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),r=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),i=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),o=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],s=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return e.prototype=Object.create(a.prototype),e.prototype.getBits=function(e){for(var n,r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<e;)void 0===(n=o[a++])&&t("Bad encoding in flate stream"),i|=n<<r,r+=8;return n=i&(1<<e)-1,this.codeBuf=i>>e,this.codeSize=r-=e,this.bytesPos=a,n},e.prototype.getCode=function(e){for(var n=e[0],r=e[1],i=this.codeSize,o=this.codeBuf,a=this.bytes,s=this.bytesPos;i<r;){var c;void 0===(c=a[s++])&&t("Bad encoding in flate stream"),o|=c<<i,i+=8}var l=n[o&(1<<r)-1],u=l>>16,h=65535&l;return(0==i||i<u||0==u)&&t("Bad encoding in flate stream"),this.codeBuf=o>>u,this.codeSize=i-u,this.bytesPos=s,h},e.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,c=2;a<=n;++a,s<<=1,c<<=1)for(var l=0;l<e;++l)if(t[l]==a){for(var u=0,h=s,r=0;r<a;++r)u=u<<1|1&h,h>>=1;for(r=u;r<i;r+=c)o[r]=a<<16|l;++s}return[o,n]},e.prototype.readBlock=function(){function e(t,e,n,r,i){for(var o=t.getBits(n)+r;o-- >0;)e[p++]=i}var a=this.getBits(3);if(1&a&&(this.eof=!0),0!=(a>>=1)){var c,l;if(1==a)c=o,l=s;else if(2==a){for(var u=this.getBits(5)+257,h=this.getBits(5)+1,f=this.getBits(4)+4,d=Array(n.length),p=0;p<f;)d[n[p++]]=this.getBits(3);for(var m=this.generateHuffmanTable(d),g=0,p=0,w=u+h,y=new Array(w);p<w;){var v=this.getCode(m);16==v?e(this,y,2,3,g):17==v?e(this,y,3,3,g=0):18==v?e(this,y,7,11,g=0):y[p++]=g=v}c=this.generateHuffmanTable(y.slice(0,u)),l=this.generateHuffmanTable(y.slice(u,w))}else t("Unknown block type in flate stream");for(var b=(O=this.buffer)?O.length:0,x=this.bufferLength;;){var k=this.getCode(c);if(k<256)x+1>=b&&(b=(O=this.ensureBuffer(x+1)).length),O[x++]=k;else{if(256==k)return void(this.bufferLength=x);var _=(k=r[k-=257])>>16;_>0&&(_=this.getBits(_));g=(65535&k)+_;k=this.getCode(l),(_=(k=i[k])>>16)>0&&(_=this.getBits(_));var C=(65535&k)+_;x+g>=b&&(b=(O=this.ensureBuffer(x+g)).length);for(var A=0;A<g;++A,++x)O[x]=O[x-C]}}}else{var S,q=this.bytes,T=this.bytesPos;void 0===(S=q[T++])&&t("Bad block header in flate stream");var P=S;void 0===(S=q[T++])&&t("Bad block header in flate stream"),P|=S<<8,void 0===(S=q[T++])&&t("Bad block header in flate stream");var I=S;void 0===(S=q[T++])&&t("Bad block header in flate stream"),(I|=S<<8)!=(65535&~P)&&t("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var E=this.bufferLength,O=this.ensureBuffer(E+P),F=E+P;this.bufferLength=F;for(var B=E;B<F;++B){if(void 0===(S=q[T++])){this.eof=!0;break}O[B]=S}this.bytesPos=T}},e}}();return function(t){var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var n,r,i,o,a,s=0,c=0,l="",u=[];if(!t)return t;do{n=(a=t.charCodeAt(s++)<<16|t.charCodeAt(s++)<<8|t.charCodeAt(s++))>>18&63,r=a>>12&63,i=a>>6&63,o=63&a,u[c++]=e.charAt(n)+e.charAt(r)+e.charAt(i)+e.charAt(o)}while(s<t.length);l=u.join("");var h=t.length%3;return(h?l.slice(0,h-3):l)+"===".slice(h||3)}),void 0===t.atob&&(t.atob=function(t){var n,r,i,o,a,s,c=0,l=0,u=[];if(!t)return t;t+="";do{n=(s=e.indexOf(t.charAt(c++))<<18|e.indexOf(t.charAt(c++))<<12|(o=e.indexOf(t.charAt(c++)))<<6|(a=e.indexOf(t.charAt(c++))))>>16&255,r=s>>8&255,i=255&s,u[l++]=64==o?String.fromCharCode(n):64==a?String.fromCharCode(n,r):String.fromCharCode(n,r,i)}while(c<t.length);return u.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=arguments.length>1?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(void 0===this||null===this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Object.keys||(Object.keys=function(){var t=Object.prototype.hasOwnProperty,e=!{toString:null}.propertyIsEnumerable("toString"),n=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],r=n.length;return function(i){if("object"!=typeof i&&("function"!=typeof i||null===i))throw new TypeError;var o,a,s=[];for(o in i)t.call(i,o)&&s.push(o);if(e)for(a=0;a<r;a++)t.call(i,n[a])&&s.push(n[a]);return s}}()),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")})}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0),e});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var PDF = __webpack_require__(280);
	/**
	 * Exports HTML Elements to PDF Format
	 *
	 * This directive was built specifically for c3 charts
	 * However, it should work with other SVGs
	 *
	 */
	/** @ngInject */
	function exportPdf() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/export-pdf/export-pdf.html',
	        scope: {
	            element: '@',
	            filename: '@',
	            orientation: '@?',
	            disable: '=?',
	            error: '=',
	            text: '@'
	        },
	        transclude: true,
	        controller: ExportPdf
	    };
	}
	exports.exportPdf = exportPdf;
	/** @ngInject */
	var ExportPdf = (function () {
	    ExportPdf.$inject = ["$scope"];
	    function ExportPdf($scope) {
	        var _this = this;
	        this.$scope = $scope;
	        $scope.exportPdf = function () { return _this.exportPdf(); };
	        $scope.error = {};
	        $scope.filename = $scope.filename.replace(/ /g, '_'); // if blank spaces in filename, they are replaced with underscores
	        $scope.orientation = 'portrait' || $scope.orientation;
	    }
	    ExportPdf.prototype.exportPdf = function () {
	        var _this = this;
	        var ticks = document.querySelectorAll('.c3-axis-y .tick text');
	        for (var i = 0; i < ticks.length; i++) {
	            ticks[i].setAttribute('font-size', '9px');
	        }
	        var svg = document.getElementsByTagName(this.$scope.element)[0] || document.getElementById(this.$scope.element);
	        if (svg) {
	            var lines = svg.querySelectorAll('.c3 line');
	            for (var i = 0; i < lines.length; i++) {
	                lines[i].setAttribute('fill', 'none');
	            }
	            var paths = svg.querySelectorAll('.c3 path');
	            for (var i = 0; i < paths.length; i++) {
	                paths[i].setAttribute('fill', 'none');
	            }
	            var axisX = svg.querySelectorAll('.c3-axis-x');
	            for (var i = 0; i < axisX.length; i++) {
	                axisX[i].setAttribute('stroke', 'black');
	                axisX[i].setAttribute('stroke-width', '1');
	            }
	            var axisY = svg.querySelectorAll('.c3-axis-y');
	            for (var i = 0; i < axisY.length; i++) {
	                axisY[i].setAttribute('stroke', 'black');
	                axisY[i].setAttribute('stroke-width', '1');
	            }
	            var tick = svg.querySelectorAll('.tick');
	            for (var i = 0; i < tick.length; i++) {
	                tick[i].setAttribute('stroke', 'black');
	                tick[i].setAttribute('stroke-width', '0.2');
	            }
	            var paths2 = svg.querySelectorAll('.tick line');
	            for (var i = 0; i < paths2.length; i++) {
	                paths2[i].setAttribute('stroke', 'black');
	                paths2[i].setAttribute('stroke-width', '1');
	            }
	            var tickText = svg.querySelectorAll('.tick text');
	            for (var i = 0; i < tick.length; i++) {
	                tickText[i].setAttribute('stroke', 'black');
	                tickText[i].setAttribute('stroke-width', '0.1');
	            }
	            var xLabel = document.querySelectorAll('.c3-axis-x-label');
	            if (xLabel) {
	                for (var i = 0; i < xLabel.length; i++) {
	                    xLabel[i].setAttribute('stroke', 'none');
	                }
	            }
	            var yLabel = document.querySelectorAll('.c3-axis-y-label');
	            if (yLabel) {
	                for (var i = 0; i < yLabel.length; i++) {
	                    yLabel[i].setAttribute('stroke', 'none');
	                }
	            }
	        }
	        var svg_xml = (new XMLSerializer()).serializeToString(svg);
	        var blob = new Blob([svg_xml], { type: 'image/svg+xml;charset=utf-8' });
	        var url = window.URL.createObjectURL(blob);
	        var img = new Image();
	        img.onload = function () {
	            var canvas = document.createElement('canvas');
	            canvas.width = img.width;
	            canvas.height = img.height;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(img, 0, 0, img.width, img.height);
	            window.URL.revokeObjectURL(url);
	            var canvasdata = canvas.toDataURL('image/png');
	            var pdf = new PDF(_this.$scope.orientation);
	            pdf.addImage(canvasdata, 'PNG', 5, 50, 285, 60);
	            pdf.save(_this.$scope.filename + ".pdf");
	        };
	        img.src = url;
	    };
	    return ExportPdf;
	}());
	exports.ExportPdf = ExportPdf;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	"use strict";
	// wrap around contents of a modal, just inside the script tags, and it will become draggable
	modalMovable.$inject = ["$document"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function modalMovable($document) {
	    return {
	        restrict: 'E',
	        link: function (scope, elem, attrs) {
	            var startX = 0;
	            var startY = 0;
	            var x = 0;
	            var y = 0;
	            var dialogWrapper = elem.parent();
	            dialogWrapper.css({
	                position: 'relative'
	            });
	            dialogWrapper.on('mousedown', function (event) {
	                // prevent default dragging of selected content
	                event.preventDefault();
	                startX = event.pageX - x;
	                startY = event.pageY - y;
	                $document.on('mousemove', mousemove);
	                $document.on('mouseup', mouseup);
	            });
	            function mousemove(event) {
	                y = event.pageY - startY;
	                x = event.pageX - startX;
	                dialogWrapper.css({
	                    top: y + 'px',
	                    left: x + 'px'
	                });
	            }
	            function mouseup() {
	                $document.unbind('mousemove', mousemove);
	                $document.unbind('mouseup', mouseup);
	            }
	        }
	    };
	}
	exports.modalMovable = modalMovable;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function flightMovementForm() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/flight-movement-form/flight-movement-form.directive.html',
	        controller: FlightMovementFormController,
	        scope: {
	            flightMovement: '=',
	            manual: '=',
	            disabled: '=?',
	            shouldShowCharge: '=?',
	            distanceUnitOfMeasure: '=?',
	            showPassengerCounts: '=?',
	            showDeletionReason: '=?',
	            showRadarRoute: '=?',
	            showFlightNotes: '=?' // boolean; defaults to true
	        },
	        replace: true
	    };
	}
	exports.flightMovementForm = flightMovementForm;
	/** @ngInject */
	var FlightMovementFormController = (function () {
	    FlightMovementFormController.$inject = ["$scope", "systemConfigurationService", "flightMovementManagementService", "countryManagementService", "usersService", "currencyManagementService", "billingCentreManagementService", "$rootScope", "sysConfigBoolean"];
	    function FlightMovementFormController($scope, systemConfigurationService, flightMovementManagementService, countryManagementService, usersService, currencyManagementService, billingCentreManagementService, $rootScope, sysConfigBoolean) {
	        var _this = this;
	        this.$scope = $scope;
	        this.flightMovementManagementService = flightMovementManagementService;
	        this.usersService = usersService;
	        this.currencyManagementService = currencyManagementService;
	        this.billingCentreManagementService = billingCentreManagementService;
	        this.$rootScope = $rootScope;
	        this.sysConfigBoolean = sysConfigBoolean;
	        this.$scope.isFmCopied = false;
	        $scope.verifyInProgress = false;
	        $scope.verifyResult = null;
	        $scope.showErrors = false;
	        $scope.errorsList = null;
	        $scope.verifyRoute = function (dep_ad, route, dest_ad) { return _this.verifyRoute(dep_ad, route, dest_ad); };
	        $scope.verifyRouteEnabled = this.sysConfigBoolean.parse(systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ENABLED_VALIDATION_ROUTE));
	        this.$scope.$on('resetVerifyResult', function () {
	            _this.$scope.verifyResult = null;
	            _this.$scope.verifyInProgress = false;
	        });
	        this.$scope.$watch(function () { return _this.$rootScope.isFmCopied; }, function (newValue, oldValue) {
	            if (newValue !== oldValue) {
	                _this.$scope.isFmCopied = newValue;
	            }
	        });
	        $scope.$watch('flightMovement.flight_id', function (val) {
	            if ($scope.flightMovement) {
	                $scope.flightMovement.flight_id = _this.cleanDataField($scope.flightMovement.flight_id, val);
	                _this.resetValues();
	            }
	        });
	        $scope.$watch('flightMovement.id', function () {
	            _this.resetValues();
	        });
	        $scope.$watch('flightMovement.item18_operator', function (val) {
	            if ($scope.flightMovement) {
	                _this.resetValues();
	            }
	        });
	        $scope.$watch('flightMovement.dest_ad', function () {
	            _this.checkIfDomesticAerodrome();
	        });
	        this.usersService.current.then(function (user) {
	            _this.$scope.user = user ? user : {};
	            _this.permissions = user ? user.permissions : [];
	            _this.$scope.hasPermission = function (permission) { return _this.hasPermission(permission); };
	        });
	        // get tasp/adhoc label text
	        $scope.taspLabel = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.TASP_FEES_LABEL);
	        this.currencyManagementService.getANSPCurrencyAndUSD().then(function (currencies) {
	            $scope.taspCurrenciesList = currencies;
	            if ($scope.flightMovement && $scope.flightMovement.tasp_charge_currency) {
	                $scope.flightMovement.tasp_charge_currency = $scope.taspCurrenciesList.content.find(function (currency) { return currency.currency_code === 'USD'; });
	            }
	        });
	        var countryCode = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.ANSP_COUNTRY_CODE);
	        if (countryCode) {
	            countryManagementService.findCountryByCountryCode(countryCode).then(function (domesticCountry) {
	                if (domesticCountry) {
	                    $scope.aerodromePrefixes = domesticCountry.aerodrome_prefixes;
	                    _this.checkIfDomesticAerodrome();
	                }
	            });
	        }
	        $scope.flightLevelRequired = systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.VALIDATE_FLIGHT_LEVEL_AIRSPACE);
	        // default value for distance units
	        if (!$scope.distanceUnitOfMeasure) {
	            $scope.distanceUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE);
	        }
	        // default lookup function
	        if (!$scope.shouldShowCharge) {
	            $scope.shouldShowCharge = function (chargeType) { return systemConfigurationService.shouldShowCharge(chargeType); };
	        }
	        // default showPassengerCharges
	        if (typeof $scope.showPassengerCounts !== 'boolean') {
	            $scope.showPassengerCounts = true;
	        }
	        // default showDeletionReason
	        if (typeof $scope.showDeletionReason !== 'boolean') {
	            $scope.showDeletionReason = true;
	        }
	        // default showRadarRoute
	        if (typeof $scope.showRadarRoute !== 'boolean') {
	            $scope.showRadarRoute = true;
	        }
	        // default showFlightNotes
	        if (typeof $scope.showFlightNotes !== 'boolean') {
	            $scope.showFlightNotes = true;
	        }
	        $scope.checkAccountMatchIdentifier = function (selectedAccountId) { return _this.checkAccountMatchIdentifier(selectedAccountId); };
	        $scope.checkAircraftTypeMatchIdentifier = function (selectedAircraftType) { return _this.checkAircraftTypeMatchIdentifier(selectedAircraftType); };
	        $scope.checkBillingCentreMismatch = function (flightMovement) { return _this.checkBillingCentreMismatch(flightMovement); };
	        $scope.getDataByIdentifier = function () { return _this.setDataByIdentifier(); };
	    }
	    FlightMovementFormController.prototype.resetValues = function () {
	        this.$scope.showAccountMismatchError = false;
	        this.$scope.showAircraftTypeMismatchError = false;
	        this.$scope.showBillingCentreMismatchError = false;
	        this.$scope.accountIdByIdentifier = null;
	        this.$scope.aircraftTypeByIdentifier = null;
	        this.$scope.accountIdByOperator = null;
	    };
	    // only numbers and letters allowed, no special characters
	    // field must also be uppercase and without spaces
	    FlightMovementFormController.prototype.cleanDataField = function (field, val) {
	        if (val) {
	            return val.replace(/[^A-Za-z0-9]+/g, '').trim();
	        }
	        return null;
	    };
	    // set account and aircraft type based on Flight Id or Registration Number
	    FlightMovementFormController.prototype.setDataByIdentifier = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getDataByIdentifier()];
	                    case 1:
	                        _a.sent();
	                        // set associated account by operator or flightId/regNum identifier if found, skip if account selection is disabled
	                        if (!this.$scope.disabled || this.$scope.disabled && !this.$scope.disabled.account) {
	                            this.$scope.flightMovement.associated_account_id = this.$scope.accountIdByOperator || this.$scope.accountIdByIdentifier || this.$scope.flightMovement.associated_account_id;
	                        }
	                        // set aircraft type from regNum identifier if found
	                        this.$scope.flightMovement.aircraft_type = this.$scope.aircraftTypeByIdentifier
	                            ? this.$scope.aircraftTypeByIdentifier
	                            : this.$scope.flightMovement.aircraft_type;
	                        // display warning message if selected account does not match flightId or regNum
	                        if (this.$scope.flightMovement.associated_account_id && this.$scope.accountIdByIdentifier) {
	                            this.$scope.showAccountMismatchError = this.$scope.flightMovement.associated_account_id !== this.$scope.accountIdByIdentifier;
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // get account and aircraft type based on Flight Id or Registration Number
	    // the account returned based on the Registration Number overrides the account returned based on the Flight Id
	    FlightMovementFormController.prototype.getDataByIdentifier = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!(this.$scope.flightMovement.item18_reg_num && this.$scope.flightMovement.date_of_flight)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.getAircraftRegistrationFromRegNumber()];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2:
	                        if (!(!this.$scope.accountIdByIdentifier && this.$scope.flightMovement.flight_id)) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.getAccountFromIdentifier()];
	                    case 3:
	                        _a.sent();
	                        _a.label = 4;
	                    case 4:
	                        if (!this.$scope.flightMovement.item18_operator) return [3 /*break*/, 6];
	                        return [4 /*yield*/, this.getAccountFromOperator()];
	                    case 5:
	                        _a.sent();
	                        _a.label = 6;
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    FlightMovementFormController.prototype.getAircraftRegistrationFromRegNumber = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.flightMovementManagementService.getAircraftRegistrationFromRegNumber(this.$scope.flightMovement.item18_reg_num, this.$scope.flightMovement.date_of_flight.toISOString())
	                            .then(function (aircraftRegistration) {
	                            _this.$scope.accountIdByIdentifier = aircraftRegistration.account.id;
	                            _this.$scope.aircraftTypeByIdentifier = aircraftRegistration.aircraft_type.aircraft_type;
	                        }).catch(function () {
	                            _this.$scope.accountIdByIdentifier = null;
	                            _this.$scope.aircraftTypeByIdentifier = null;
	                        })];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    FlightMovementFormController.prototype.getAccountFromIdentifier = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.flightMovementManagementService.getAccountFromIdentifier(this.$scope.flightMovement.flight_id).then(function (account) {
	                            _this.$scope.accountIdByIdentifier = account.id;
	                        }).catch(function () {
	                            _this.$scope.accountIdByIdentifier = null;
	                        })];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    FlightMovementFormController.prototype.getAccountFromOperator = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.flightMovementManagementService.getAccountFromOperator(this.$scope.flightMovement.item18_operator)
	                            .then(function (account) { return _this.$scope.accountIdByOperator = account.id; })
	                            .catch(function () { return _this.$scope.accountIdByOperator = null; })];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    FlightMovementFormController.prototype.checkAccountMatchIdentifier = function (selectedAccountId) {
	        if (!this.$scope.accountIdByIdentifier) {
	            // check for match based on flight id or reg num
	            this.getDataByIdentifier();
	            this.$scope.showAccountMismatchError = this.$scope.accountIdByIdentifier && this.$scope.accountIdByIdentifier !== selectedAccountId;
	        }
	        else {
	            this.$scope.showAccountMismatchError = this.$scope.accountIdByIdentifier && this.$scope.accountIdByIdentifier !== selectedAccountId;
	        }
	    };
	    FlightMovementFormController.prototype.checkAircraftTypeMatchIdentifier = function (selectedAircraftType) {
	        if (!this.$scope.aircraftTypeByIdentifier && this.$scope.flightMovement.item18_reg_num && this.$scope.flightMovement.date_of_flight) {
	            // check for match based on reg num
	            this.getAircraftRegistrationFromRegNumber();
	            this.$scope.showAircraftTypeMismatchError = this.$scope.aircraftTypeByIdentifier && this.$scope.aircraftTypeByIdentifier !== selectedAircraftType;
	        }
	        else {
	            this.$scope.showAircraftTypeMismatchError = this.$scope.aircraftTypeByIdentifier && this.$scope.aircraftTypeByIdentifier !== selectedAircraftType;
	        }
	    };
	    FlightMovementFormController.prototype.checkIfDomesticAerodrome = function () {
	        var _this = this;
	        this.$scope.domesticDestAd = this.$scope.aerodromePrefixes && this.$scope.aerodromePrefixes.length
	            && this.$scope.flightMovement && this.$scope.flightMovement.dest_ad ?
	            this.$scope.aerodromePrefixes.some((function (aerodromePrefix) {
	                return _this.$scope.flightMovement.dest_ad.startsWith(aerodromePrefix.aerodrome_prefix);
	            })) || this.$scope.flightMovement.dest_ad === 'ZZZZ' : false;
	    };
	    FlightMovementFormController.prototype.checkBillingCentreMismatch = function (fm) {
	        return __awaiter(this, void 0, void 0, function () {
	            var hasAerodromes, hasItem18Aerodromes, hasItem18Dep, hasItem18Dest, flightBillingCentre;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        hasAerodromes = Boolean((fm.dep_ad && fm.dep_ad.length) && (fm.dest_ad && fm.dest_ad.length));
	                        hasItem18Aerodromes = Boolean((fm.item18_dep && fm.item18_dep.length) && (fm.item18_dest && fm.item18_dest.length));
	                        hasItem18Dep = Boolean((fm.item18_dep && fm.item18_dep.length) && (fm.dest_ad && fm.dest_ad.length));
	                        hasItem18Dest = Boolean((fm.dep_ad && fm.dep_ad.length) && (fm.item18_dest && fm.item18_dest.length));
	                        flightBillingCentre = null;
	                        if (!hasAerodromes) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.billingCentreManagementService.getBillingCentreByAerodromes(fm.dep_ad, fm.dest_ad)];
	                    case 1:
	                        flightBillingCentre = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 2:
	                        if (!hasItem18Aerodromes) return [3 /*break*/, 4];
	                        return [4 /*yield*/, this.billingCentreManagementService.getBillingCentreByAerodromes(fm.item18_dep, fm.item18_dest)];
	                    case 3:
	                        flightBillingCentre = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 4:
	                        if (!hasItem18Dep) return [3 /*break*/, 6];
	                        return [4 /*yield*/, this.billingCentreManagementService.getBillingCentreByAerodromes(fm.item18_dep, fm.dest_ad)];
	                    case 5:
	                        flightBillingCentre = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 6:
	                        if (!hasItem18Dest) return [3 /*break*/, 8];
	                        return [4 /*yield*/, this.billingCentreManagementService.getBillingCentreByAerodromes(fm.dep_ad, fm.item18_dest)];
	                    case 7:
	                        flightBillingCentre = _a.sent();
	                        _a.label = 8;
	                    case 8:
	                        if (flightBillingCentre && flightBillingCentre.id !== this.$scope.user.billing_center.id) {
	                            this.$scope.showBillingCentreMismatchError = true;
	                        }
	                        else {
	                            this.$scope.showBillingCentreMismatchError = false;
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Returns whether the current user has this permission.
	     */
	    FlightMovementFormController.prototype.hasPermission = function (permission) {
	        return this.permissions && this.permissions.indexOf(permission) > -1;
	    };
	    FlightMovementFormController.prototype.verifyRoute = function (dep_ad, route, dest_ad) {
	        var _this = this;
	        this.$scope.verifyInProgress = true;
	        this.flightMovementManagementService.verifyRoute(dep_ad, route, dest_ad)
	            .then(function (response) {
	            return _this.handleVerifyRouteResponse(response.valid, response.errors);
	        })
	            .catch(function (error) {
	            return _this.handleVerifyRouteResponse(false, [error.data.error]);
	        });
	    };
	    FlightMovementFormController.prototype.handleVerifyRouteResponse = function (valid, errors) {
	        this.$scope.verifyInProgress = false;
	        this.$scope.verifyResult = valid;
	        if (!valid) {
	            this.$scope.showErrors = true;
	            this.$scope.errorsList = errors;
	        }
	    };
	    return FlightMovementFormController;
	}());


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var flight_movement_table_controller_1 = __webpack_require__(120);
	/** @ngInject */
	function flightMovementTable() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/flight-movement-table/flight-movement-table.directive.html',
	        controller: flight_movement_table_controller_1.FlightMovementTableController,
	        controllerAs: 'flightMovementTableCtrl'
	    };
	}
	exports.flightMovementTable = flightMovementTable;


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function uploadFeedback() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/upload-feedback/upload-feedback.directive.html'
	    };
	}
	exports.uploadFeedback = uploadFeedback;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function lineItemsTable() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/line-items-table/line-items-table.directive.html',
	        scope: {
	            lineItems: '=',
	            isValid: '=',
	            params: '=',
	            isNonAvi: '=?' // non-aviation billing specific
	        },
	        controller: LineItemsTableController
	    };
	}
	exports.lineItemsTable = lineItemsTable;
	/** @ngInject */
	var LineItemsTableController = (function () {
	    LineItemsTableController.$inject = ["$scope", "utilitiesTownsService", "aerodromesService", "reportsService", "utilitiesSchedulesService", "usersService", "accountExternalChargeCategoryService"];
	    function LineItemsTableController($scope, utilitiesTownsService, aerodromesService, reportsService, utilitiesSchedulesService, usersService, accountExternalChargeCategoryService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.utilitiesTownsService = utilitiesTownsService;
	        this.aerodromesService = aerodromesService;
	        this.reportsService = reportsService;
	        this.utilitiesSchedulesService = utilitiesSchedulesService;
	        this.usersService = usersService;
	        this.accountExternalChargeCategoryService = accountExternalChargeCategoryService;
	        $scope.lineItemAccountExternalChargeCategories = [];
	        $scope.$watch('lineItems', function (newlineItems) {
	            $scope.lineItemError = []; // reset errors
	            _this.dynamicTable(newlineItems);
	            _this.$scope.isValid = _this.areAllLineItemsValid();
	        }, true);
	        $scope.$watch('params.currencyCode', function (currencyCode) {
	            if (_this.$scope.lineItems) {
	                _this.$scope.lineItems.forEach(function (item, index) { return _this.validate(index, item, currencyCode); });
	            }
	        });
	        $scope.validateInvoiceLineItem = function (index, lineItem, selectedInvoiceCurrency) { return _this.validate(index, lineItem, selectedInvoiceCurrency); };
	        $scope.removeChargeItem = function (index) { return _this.$scope.lineItems.splice(index, 1); };
	        $scope.getUtility = function (index, lineItem, amount) { return _this.getUtility(index, lineItem, amount); };
	        $scope.lineItemError = [];
	        utilitiesTownsService.listAll().then(function (towns) { return $scope.townsList = towns; });
	        aerodromesService.getAerodromesByBillingCentre().then(function (aerodromes) { return $scope.aerodromeList = aerodromes; });
	        aerodromesService.listAll().then(function (aerodromes) { return $scope.aerodromeListAll = aerodromes.content; });
	        utilitiesSchedulesService.listAll().then(function (data) { return $scope.schedules = data.content; });
	        $scope.checkAll = function () { return _this.checkAll(); };
	        $scope.itemCheck = function () { return _this.$scope.selectAll = false; };
	        // external database related
	        $scope.isLocalInput = function (lineItem) { return !_this.isExternalDatabaseInput(lineItem); };
	        $scope.hasLocalInputs = function () {
	            if ($scope.lineItems) {
	                // check if any line items are local inputs
	                return $scope.lineItems.find(function (item) { return $scope.isLocalInput(item); });
	            }
	            else {
	                // no line items so no local input
	                return false;
	            }
	        };
	        $scope.isExternalDatabaseInput = function (lineItem) { return _this.isExternalDatabaseInput(lineItem); };
	        $scope.hasExternalInputs = function () {
	            if ($scope.lineItems) {
	                // check if any line items are external database inputs
	                return $scope.lineItems.find(function (item) { return $scope.isExternalDatabaseInput(item); });
	            }
	            else {
	                // no line items so no external databse inputs
	                return false;
	            }
	        };
	        $scope.getAccountExternalChargeCategories = function (item) { return _this.getAccountExternalChargeCategories(item); };
	        this.setAccountExternalChargeCategories($scope.params.accountId);
	        $scope.$watch('params.accountId', function (newAccountId) { return _this.setAccountExternalChargeCategories(newAccountId); });
	    }
	    /**
	     * Validates line item by month
	     * If valid, it updates the line item amount
	     *
	     * @param  {number} index
	     * @param  {IInvoiceLineItem} lineItem
	     * @returns void
	     */
	    LineItemsTableController.prototype.validate = function (index, lineItem, selectedInvoiceCurrency) {
	        var _this = this;
	        lineItem.amount = null; // need to clear amount so that it recalculates if the user changes a value. This also disables things from being `valid` when fields are missing
	        var acountExternalList = this.$scope.lineItemAccountExternalChargeCategories[index];
	        if (!this.$scope.params.accountId || !lineItem.aerodrome || !lineItem.aerodrome.id
	            || (!lineItem.user_unit_amount && lineItem.service_charge_catalogue.charge_basis !== 'fixed')
	            || (!lineItem.account_external_system_identifier && acountExternalList && acountExternalList.length > 1)) {
	            return;
	        }
	        var month = null, year = null;
	        if (this.$scope.params.month !== null) {
	            month = this.$scope.params.month;
	        }
	        if (this.$scope.params.year !== null) {
	            year = this.$scope.params.year;
	        }
	        this.reportsService.validateInvoiceLineItem(this.$scope.params.accountId, lineItem, month, year, selectedInvoiceCurrency)
	            .then(function (itemReturned) {
	            _this.$scope.lineItemError[index] = null;
	            lineItem.amount = itemReturned.amount;
	            _this.$scope.$emit('lineItem amount changed');
	            _this.$scope.isValid = _this.areAllLineItemsValid();
	        })
	            .catch(function (error) {
	            if (error.data.error_description && error.data.error_description !== 'null') {
	                _this.$scope.lineItemError[index] = error.data.error_description;
	            }
	            else {
	                _this.$scope.lineItemError[index] = error.data.error;
	            }
	            _this.$scope.isValid = _this.areAllLineItemsValid();
	        });
	    };
	    LineItemsTableController.prototype.areAllLineItemsValid = function () {
	        if (!this.$scope.lineItems) {
	            return;
	        }
	        for (var _i = 0, _a = this.$scope.lineItems; _i < _a.length; _i++) {
	            var item = _a[_i];
	            if (item.amount === null) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     * Shows or hides the town / electricity charge type columns
	     *
	     * @param  {Array<IInvoiceLineItem>} lineItems
	     * @returns void
	     */
	    LineItemsTableController.prototype.dynamicTable = function (lineItems) {
	        if (!lineItems) {
	            return;
	        }
	        this.$scope.isWater = false;
	        this.$scope.isElectric = false;
	        this.$scope.isFixed = false;
	        this.$scope.isExternalDatabase = false;
	        this.$scope.isAccountExternalSystemIdentifier = false;
	        var _loop_1 = function (item) {
	            if (item.service_charge_catalogue.charge_basis === 'unit' || item.service_charge_catalogue.charge_basis === 'fixed' || item.service_charge_catalogue.charge_basis === 'percentage') {
	                item.price_per_unit = item.service_charge_catalogue.amount;
	            }
	            if (item.service_charge_catalogue.charge_basis === 'water') {
	                this_1.$scope.isWater = true;
	            }
	            if (item.service_charge_catalogue.charge_basis === 'commercial-electric' || item.service_charge_catalogue.charge_basis === 'residential-electric') {
	                this_1.$scope.isElectric = true;
	            }
	            if (item.service_charge_catalogue.charge_basis === 'fixed' && lineItems.length === 1) {
	                this_1.$scope.isFixed = true;
	            }
	            if (item.service_charge_catalogue.external_charge_category && this_1.accountExternalChargeCategories.filter(function (category) {
	                return category.external_charge_category.id === item.service_charge_catalogue.external_charge_category.id;
	            }).length > 1) {
	                this_1.$scope.isAccountExternalSystemIdentifier = true;
	            }
	        };
	        var this_1 = this;
	        for (var _i = 0, lineItems_1 = lineItems; _i < lineItems_1.length; _i++) {
	            var item = lineItems_1[_i];
	            _loop_1(item);
	        }
	    };
	    LineItemsTableController.prototype.getUtility = function (index, lineItem, amount) {
	        if (lineItem === null || lineItem === undefined || amount === null || amount === undefined) {
	            return;
	        }
	        if (amount === 0) {
	            this.$scope.lineItems[index].price_per_unit = 1; // hard-coded to 1 because that's what the back-end is returning
	            return;
	        }
	        var scheduleId;
	        var rangeBracket = [];
	        if (lineItem.service_charge_catalogue.charge_basis === 'water') {
	            scheduleId = lineItem.user_town.water_utility_schedule.schedule_id;
	        }
	        else if (lineItem.service_charge_catalogue.charge_basis === 'commercial-electric') {
	            scheduleId = lineItem.user_town.commercial_electricity_utility_schedule.schedule_id;
	        }
	        else if (lineItem.service_charge_catalogue.charge_basis === 'residential-electric') {
	            scheduleId = lineItem.user_town.residential_electricity_utility_schedule.schedule_id;
	        }
	        for (var _i = 0, _a = this.$scope.schedules; _i < _a.length; _i++) {
	            var schedule = _a[_i];
	            if (schedule.schedule_id === scheduleId) {
	                rangeBracket = schedule.utilities_range_bracket;
	            }
	        }
	        var ranges = rangeBracket.map(function (item) { return item.range_top_end; });
	        var closest = Math.max.apply(null, ranges); // get the highest number in arr in case it match nothing.
	        for (var i = 0; i < ranges.length; i++) {
	            if (ranges[i] >= amount && ranges[i] < closest) {
	                closest = ranges[i];
	            }
	        }
	        if (amount > closest) {
	            this.$scope.lineItems[index].price_per_unit = null;
	            return;
	        }
	        for (var _b = 0, rangeBracket_1 = rangeBracket; _b < rangeBracket_1.length; _b++) {
	            var bracket = rangeBracket_1[_b];
	            if (bracket.range_top_end === closest) {
	                this.$scope.lineItems[index].price_per_unit = bracket.unit_price;
	            }
	        }
	    };
	    LineItemsTableController.prototype.checkAll = function () {
	        for (var _i = 0, _a = this.$scope.lineItems; _i < _a.length; _i++) {
	            var item = _a[_i];
	            item.any_aerodrome = this.$scope.selectAll ? true : false;
	        }
	    };
	    LineItemsTableController.prototype.isExternalDatabaseInput = function (lineItem) {
	        return lineItem.service_charge_catalogue.charge_basis === 'external-database';
	    };
	    LineItemsTableController.prototype.setAccountExternalChargeCategories = function (accountId) {
	        var _this = this;
	        if (!accountId) {
	            this.accountExternalChargeCategories = [];
	        }
	        else {
	            this.accountExternalChargeCategoryService.getByAccountId(accountId)
	                .then(function (response) { return _this.accountExternalChargeCategories = response; })
	                .catch(function (error) { return _this.accountExternalChargeCategories = []; });
	        }
	    };
	    LineItemsTableController.prototype.getAccountExternalChargeCategories = function (lineItem) {
	        if (lineItem.service_charge_catalogue && lineItem.service_charge_catalogue.external_charge_category) {
	            return this.accountExternalChargeCategories.filter(function (item) {
	                return item.external_charge_category.id === lineItem.service_charge_catalogue.external_charge_category.id;
	            });
	        }
	        else {
	            return [];
	        }
	    };
	    return LineItemsTableController;
	}());
	exports.LineItemsTableController = LineItemsTableController;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var payment_controller_1 = __webpack_require__(288);
	/**
	 * Payment directive to be used for Point of Sale Invoice Generation
	 *
	 * Set up how an invoice will be paid
	 *
	 * <payment is-valid="paymentValid" reset="paymentReset" payment="payment" invoice-currency="invoiceCurrency"><!-- Payment Directive --></payment>
	 *
	 */
	/** @ngInject */
	function payment() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/payment/payment.html',
	        scope: {
	            invoiceCurrency: '=',
	            payment: '=',
	            isValid: '=?',
	            reset: '=?',
	            items: '=',
	            invoiceAmount: '=?',
	            accountId: '=' // number
	        },
	        replace: true,
	        controller: payment_controller_1.PaymentController,
	        controllerAs: 'PaymentController',
	        require: ['^form'],
	        link: PaymentLink
	    };
	}
	exports.payment = payment;
	function PaymentLink(scope, elem, attr, ctrl) {
	    // intialize payment as empty object
	    scope.payment = scope.payment || GetEmptyPayment();
	    // ensures on load form isn't `touched` and `invalid`
	    scope.PaymentController.$timeout(function () { return ctrl[0].$setUntouched(); }, 0);
	    // sets `isValid` to parent
	    scope.$watch('payment', function () {
	        attachExternalDatabaseItems(scope);
	        scope.isValid = ctrl[0].$valid;
	    }, true);
	    // clear payment and set untouched on reset
	    scope.$watch('reset', function () {
	        scope.payment = GetEmptyPayment();
	        ctrl[0].$setUntouched();
	    });
	}
	function attachExternalDatabaseItems(scope) {
	    if (!scope.items || !scope.items.length) {
	        return;
	    }
	    var requisitions = scope.items.filter(function (item) {
	        return item.requisiton !== null && item.requisition.req_number !== null;
	    }).map(function (item) { return item.requisition; });
	    var invoicePermits = scope.items.filter(function (item) {
	        return item.invoice_permit !== null && item.invoice_permit.invoice_permit_number !== null;
	    }).map(function (item) { return item.invoice_permit; });
	    scope.payment.requisitions = requisitions.length ? requisitions : null;
	    scope.payment.invoice_permits = invoicePermits.length ? invoicePermits : null;
	}
	/**
	 * Retrieve an empty payment object used on initialization or reset.
	 */
	function GetEmptyPayment() {
	    return {
	        amount: null,
	        currency: null,
	        payment_mechanism: null,
	        description: null,
	        payment_reference_number: null,
	        payment_amount: null,
	        payment_currency: null,
	        payment_exchange_rate: null,
	        invoice_permits: null,
	        requisitions: null,
	        kra_receipt_number: null,
	        kra_clerk_name: null,
	        bank_account_name: null,
	        bank_account_number: null,
	        bank_account_external_accounting_system_id: null
	    };
	}


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var helpers_service_1 = __webpack_require__(19);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	var PaymentController = (function () {
	    PaymentController.$inject = ["$scope", "$timeout", "currencyExchangeRatesService", "currencyManagementService", "transactionsService", "systemConfigurationService", "accountsService", "organizationService", "bankAccountManagementService"];
	    function PaymentController($scope, $timeout, currencyExchangeRatesService, currencyManagementService, transactionsService, systemConfigurationService, accountsService, organizationService, bankAccountManagementService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.currencyExchangeRatesService = currencyExchangeRatesService;
	        this.currencyManagementService = currencyManagementService;
	        this.transactionsService = transactionsService;
	        this.systemConfigurationService = systemConfigurationService;
	        this.accountsService = accountsService;
	        this.organizationService = organizationService;
	        this.bankAccountManagementService = bankAccountManagementService;
	        $scope.ctrl = $scope;
	        $scope.activeOrg = this.organizationService.active();
	        $scope.workflow = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.POINT_OF_SALE_WORKFLOW);
	        // expose necessary methods to scope
	        $scope.filterPaymentMechanism = function (mechanism) { return _this.filterPaymentMechanism(mechanism); };
	        $scope.updateExchangeRate = function (fromCurrency, toCurrency) { return _this.updateExchangeRate(fromCurrency, toCurrency); };
	        $scope.updatePaymentAmount = function () { return _this.updatePaymentAmount(); };
	        // default exchange rate to null and add watch to update from payment value
	        // this is here to limit exchange rate in view to 5 decimal places
	        $scope.paymentExchangeRate = null;
	        $scope.$watch('payment.payment_exchange_rate', function (value) { return _this.updatePaymentExchangeRate(value); });
	        // get full list of currencies, only do this once
	        this.currencyManagementService.listAll().then(function (data) { return _this.$scope.fullCurrencyList = data.content; });
	        // get invoice currencies
	        $scope.$watch('invoiceCurrency', function (value) { return _this.updateCurrencyList(value); });
	        $scope.$watch('accountId', function (accountId) {
	            if (accountId) {
	                _this.accountsService.get(accountId).then(function (data) {
	                    _this.$scope.cashAccount = data.cash_account;
	                });
	            }
	        });
	        $scope.$watch('invoiceAmount', function (value) {
	            $scope.payment.amount = value;
	            _this.updateExchangeRate($scope.payment.payment_currency, $scope.payment.currency);
	        });
	        $scope.inverseExchange = this.systemConfigurationService.getBooleanFromValueByName(system_configuration_constants_1.SysConfigConstants.INVERSE_CURRENCY_RATE);
	        // define scope payment mechanism functions
	        this.$scope.isPaymentMechanism = function () {
	            var mechanisms = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                mechanisms[_i] = arguments[_i];
	            }
	            return _this.isPaymentMechanism(mechanisms);
	        };
	        // define scope bank account properties and functions
	        this.$scope.getBankAccountLabel = function (name, number) { return _this.bankAccountManagementService.getLabel(name, number); };
	        this.$scope.setPaymentBankAccount = function (bankAccount) { return _this.setPaymentBankAccount(bankAccount); };
	        // get bank account support and define in scope
	        this.bankAccountManagementService.getIsSupported().then(function (isSupported) { return _this.$scope.isBankAccountSupported = isSupported; });
	        // define on change event functions
	        this.$scope.onPaymentMechanismChange = function (payment) { return _this.onPaymentMechanismChange(payment); };
	    }
	    /**
	     * Update invoice currency with the currency that user selected
	     *
	     * @param invoiceCurrency invoiceCurrency
	     */
	    PaymentController.prototype.updateCurrencyList = function (invoiceCurrency) {
	        // update invoice currency for the chosen account
	        if (invoiceCurrency) {
	            this.$scope.payment.currency = invoiceCurrency;
	            var paymentCurrency = invoiceCurrency;
	            var currency_name = paymentCurrency.currency_name, currency_code = paymentCurrency.currency_code;
	            this.$scope.paymentCurrency = currency_name + " (" + currency_code + ")";
	        }
	    };
	    /**
	     * Update payment exchange rate by even rounding supplied value.
	     *
	     * @param value exchange rate value
	     */
	    PaymentController.prototype.updatePaymentExchangeRate = function (value) {
	        // even round exchange rate to 5 decimal places of value
	        if (value) {
	            this.$scope.paymentExchangeRate = helpers_service_1.HelperService.evenRound(value, 5).toFixed(5);
	        }
	        else {
	            this.$scope.paymentExchangeRate = null;
	        }
	        ;
	        // determine if inverse needs to be shown
	        if (this.$scope.paymentExchangeRate && this.$scope.inverseExchange) {
	            this.$scope.paymentExchangeRate = (1 / parseFloat(this.$scope.paymentExchangeRate)).toString();
	        }
	    };
	    /**
	     * Calcualte exchange amount. Rounding decimal points is defined by supplied `currency`.
	     *
	     * @param amount amount to exchange
	     * @param exchangeRate exchange rate
	     * @param currency currency to use for formatting
	     * @param inverse inverse exchange rate (divide instead of multiple)
	     */
	    PaymentController.prototype.calculateAmount = function (amount, exchangeRate, currency, inverse) {
	        if (inverse === void 0) { inverse = false; }
	        // if amount, exchange and currency are null, return null
	        if (amount === null || exchangeRate === null || currency === null) {
	            return null;
	        }
	        // calculate exchange from amount and exchange rate (inverse if true)
	        var exchange;
	        if (inverse) {
	            exchange = amount / exchangeRate;
	        }
	        else {
	            exchange = amount * exchangeRate;
	        }
	        // value should be even rounded to currency decimal points
	        return helpers_service_1.HelperService.evenRound(exchange, currency.decimal_places || 2);
	    };
	    /**
	     * Calculate exchange rate from payment currency into local currency. This method will
	     * set currency fields to invalid if no exchange rate is found.
	     *
	     * @param fromCurrency payment currency
	     * @param toCurrency local currency
	     */
	    PaymentController.prototype.updateExchangeRate = function (fromCurrency, toCurrency) {
	        var _this = this;
	        // assert that scope payment exists
	        if (!this.$scope.payment) {
	            return;
	        }
	        // if fromCurrency exists, toCurrency null and fromCurrency in currencyList
	        // set toCurrency to fromCurrency for better user experience
	        if (fromCurrency && !toCurrency && this.$scope.currencyList.filter(function (currency) { return currency.id === fromCurrency.id; }).length > 0) {
	            toCurrency = fromCurrency;
	            this.$scope.payment.currency = fromCurrency;
	        }
	        // if currency values are empty, return
	        // else find exchange rate between currencies
	        if (!fromCurrency || !toCurrency) {
	            this.$scope.payment.payment_exchange_rate = null;
	            this.updatePaymentAmount();
	        }
	        else {
	            this.currencyExchangeRatesService.getExchangeRateByCurrencyId(fromCurrency.id, toCurrency.id)
	                .then(function (data) {
	                _this.$scope.payment.payment_exchange_rate = data;
	                _this.$scope.form.currency.$setValidity('valid_exchange_rate', true);
	                _this.$scope.form.paymentCurrency.$setValidity('valid_exchange_rate', true);
	            }).catch(function (error) {
	                _this.$scope.payment.payment_exchange_rate = null;
	                _this.$scope.form.currency.$setValidity('valid_exchange_rate', false);
	                _this.$scope.form.paymentCurrency.$setValidity('valid_exchange_rate', false);
	                _this.$scope.error = { error: error };
	            }).finally(function () {
	                _this.updatePaymentAmount();
	            });
	        }
	    };
	    /**
	     * Update payment amount from local amount and exchange rate.
	     */
	    PaymentController.prototype.updatePaymentAmount = function () {
	        var _this = this;
	        // if exchange call to service already pending, cancel and send another
	        // use one timeout for both local and payment amounts so that if user
	        // switches input controls and updates before result is returned, their new value
	        // isn't overwritten
	        if (this._exchangeTimeout) {
	            this.$timeout.cancel(this._exchangeTimeout);
	        }
	        // get all values from editable form
	        var amount = this.$scope.payment.amount;
	        var rate = this.$scope.payment.payment_exchange_rate;
	        var currency = this.$scope.payment.payment_currency;
	        var inverse = true;
	        // if amount, exchange and currency are null, return
	        // else calculate exchange in browser (emulated banker's rounding)
	        // and after custom debounce of 800 milliseconds, get calcualtion from service (so that banker's rounding is consistent)
	        if (!amount && amount !== 0 || !rate || !currency) {
	            this.$scope.payment.payment_amount = null;
	        }
	        else {
	            // initially get amount from emulated banker's rounding in browser
	            // this will provide immediate feedback to the user
	            this.$scope.payment.payment_amount = this.calculateAmount(amount, rate, currency, inverse);
	            // send call to service to get calcualted exchange amount
	            // wait 800 milliseconds before sending
	            this._exchangeTimeout = this.$timeout(function () {
	                _this.currencyExchangeRatesService.getExchangeAmount(amount, rate, currency.decimal_places || 2, inverse)
	                    .then(function (data) {
	                    _this.$scope.payment.payment_amount = data;
	                }).catch(function (Error) {
	                    // fallback to manual calculations
	                    _this.$scope.payment.payment_amount = _this.calculateAmount(amount, rate, currency, inverse);
	                });
	            }, 800);
	        }
	    };
	    /**
	     * Filter out adjustment payment mechanisms for point-of-sale interface.
	     *
	     * @param mechanism payment mechanism
	     */
	    PaymentController.prototype.filterPaymentMechanism = function (mechanism) {
	        return mechanism !== 'adjustment';
	    };
	    /**
	     * Verify if any provided payment mechanisms are selected.
	     *
	     * @param mechanisms payment mechanisms to verify
	     */
	    PaymentController.prototype.isPaymentMechanism = function (mechanisms) {
	        // mechanisms parameter is required, return false if not valid
	        if (!mechanisms) {
	            return false;
	        }
	        var mechanism = this.$scope.payment
	            ? this.$scope.payment.payment_mechanism : null;
	        return mechanisms.indexOf(mechanism) > -1;
	    };
	    /**
	     * Set payment transaction's bank account name, number, externalId from
	     * provided bank account object.
	     *
	     * @param bankAccount bank account info to use
	     */
	    PaymentController.prototype.setPaymentBankAccount = function (bankAccount) {
	        if (bankAccount) {
	            this.$scope.payment.bank_account_name = bankAccount.name;
	            this.$scope.payment.bank_account_number = bankAccount.number;
	            this.$scope.payment.bank_account_external_accounting_system_id = bankAccount.external_accounting_system_id;
	        }
	        else {
	            this.$scope.payment.bank_account_name = null;
	            this.$scope.payment.bank_account_number = null;
	            this.$scope.payment.bank_account_external_accounting_system_id = null;
	        }
	    };
	    /**
	     * On payment mechanism change event, updated payment properties.
	     *
	     * @param payment editable payment
	     */
	    PaymentController.prototype.onPaymentMechanismChange = function (payment) {
	        // set payment reference number to 'N/A' if payment mechanism is cash
	        payment.payment_reference_number = this.isPaymentMechanism(['cash'])
	            ? 'N/A' : null;
	        // on payment mechanism other than cheque or wire, clear bank account
	        if (!this.isPaymentMechanism(['cheque', 'wire'])) {
	            payment.bank_account = null; // type <any> as bank_account is not an expected IPayment property
	            payment.bank_account_name = null;
	            payment.bank_account_number = null;
	            payment.bank_account_external_accounting_system_id = null;
	        }
	    };
	    return PaymentController;
	}());
	exports.PaymentController = PaymentController;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Multiselect directive to be reusable across all multiselect inputs
	 *
	 * Accepts params as follows:
	 *
	 * <multiselect id="id" name="name" extra-settings="{ ...settings }" options="itemsForSelect" model="targetModel" events="{ ...events } isRequired="true"></multiselect>
	 *
	 */
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function multiselect() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/multiselect/multiselect.template.html',
	        controllerAs: 'MultiSelectController',
	        controller: MultiselectController,
	        scope: {
	            id: '@',
	            name: '@',
	            extraSettings: '=',
	            options: '=',
	            model: '=',
	            events: '=',
	            isRequired: '<',
	            search: '@?',
	            translatedValue: '@?',
	            disabled: '='
	        }
	    };
	}
	exports.multiselect = multiselect;
	/** @ngInject */
	var MultiselectController = (function () {
	    MultiselectController.$inject = ["$rootScope", "$scope", "$translate", "$compile"];
	    function MultiselectController($rootScope, $scope, $translate, $compile) {
	        var _this = this;
	        var baseOptions;
	        $scope.$watch('options', function () {
	            baseOptions = angular.copy($scope.options);
	            _this.translateOptions(baseOptions, $scope.options, $scope.translatedValue, $translate);
	        });
	        $translate.onReady(function () { return $scope.texts = _this.translateOptions(baseOptions, $scope.options, $scope.translatedValue, $translate); });
	        $rootScope.$on('$translateChangeEnd', function () { return _this.translateOptions(baseOptions, $scope.options, $scope.translatedValue, $translate); });
	        $scope.compile = $compile;
	        $scope.translate = $translate;
	        $scope.testval = true;
	        $scope.settings = __assign({ enableSearch: true ? !$scope.search : false, searchField: $scope.extraSettings.displayProp, smartButtonMaxItems: 5, scrollable: true, buttonClasses: 'multiselect-dropdown btn btn-default' }, $scope.extraSettings);
	    }
	    MultiselectController.prototype.translateOptions = function (baseOptions, options, translatedValue, $translate) {
	        if (baseOptions && translatedValue) {
	            for (var i = 0, len = options.length; i < len; i++) {
	                if (baseOptions[i][translatedValue] != undefined)
	                    options[i][translatedValue] = $translate.instant(baseOptions[i][translatedValue]);
	            }
	            ;
	        }
	    };
	    return MultiselectController;
	}());


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Directive to be placed on text inputs
	 * Allows only numbers to be entered
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function onlyNumbers() {
	    return {
	        require: 'ngModel',
	        link: function (scope, elem, attrs, modelCtrl) {
	            modelCtrl.$parsers.push(function (inputValue) {
	                var transformedInput = inputValue.toLowerCase().replace(/[^0-9]/g, '');
	                if (transformedInput !== inputValue) {
	                    modelCtrl.$setViewValue(transformedInput);
	                    modelCtrl.$render();
	                }
	                return transformedInput;
	            });
	        }
	    };
	}
	exports.onlyNumbers = onlyNumbers;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Directive to be placed on text inputs
	 * Allows only numbers to be entered
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function onlyLetters() {
	    return {
	        require: 'ngModel',
	        link: function (scope, elem, attrs, modelCtrl) {
	            modelCtrl.$parsers.push(function (inputValue) {
	                var transformedInput = inputValue.replace(/[^a-zA-Z]/g, '');
	                if (transformedInput !== inputValue) {
	                    modelCtrl.$setViewValue(transformedInput);
	                    modelCtrl.$render();
	                }
	                return transformedInput;
	            });
	        }
	    };
	}
	exports.onlyLetters = onlyLetters;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Directive to be placed on text inputs
	 * Changes model values from empty strings to null
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function emptyToNull() {
	    return {
	        require: 'ngModel',
	        link: function (scope, elem, attrs, modelCtrl) {
	            modelCtrl.$parsers.push(function (viewValue) {
	                if (viewValue === '') {
	                    return null;
	                }
	                return viewValue;
	            });
	        }
	    };
	}
	exports.emptyToNull = emptyToNull;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * If the system is set to enter MTOW or Cargo values in kg,
	 * they will need to be converted to tons before sending to
	 * the back-end
	 *
	 * This directive is placed on create / update buttons
	 * and is given the property name for the value to convert
	 *
	 * After conversion, it proceeds with the crud function
	 *
	 * example use:
	 * convert-to-tons property="nameOfProperty"
	 * conversion-complete="create(convertedEditable || editable)"
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function convertToTons() {
	    return {
	        restrict: 'A',
	        link: linkFunc,
	        priority: 2
	    };
	}
	exports.convertToTons = convertToTons;
	function linkFunc(scope, elem, attrs) {
	    var KG = 907.185;
	    var mtowUnitOfMeasure = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	    var cargoDisplayUnits = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.CARGO_DISPLAY_UNITS);
	    var mtowInKg = attrs.property; // property name for MTOW
	    var cargoInKg = attrs.properties; // property name for cargo
	    var conversionComplete = attrs.conversionComplete; // function to run after conversion
	    function runClickEvent(func) {
	        scope.$eval(func);
	    }
	    elem.bind('click', function () {
	        if (mtowUnitOfMeasure === 'kg') {
	            scope.convertedEditable = angular.copy(scope.editable);
	            scope.convertedEditable[mtowInKg] = scope.editable[mtowInKg] / KG;
	        }
	        if (cargoDisplayUnits === 'kg' && cargoInKg) {
	            scope.convertedEditable = angular.copy(scope.editable);
	            var array = cargoInKg.split(',');
	            array.forEach(function (element) {
	                scope.convertedEditable[element] = scope.editable[element] ? scope.editable[element] / KG : null;
	            });
	        }
	        if (conversionComplete) {
	            runClickEvent(conversionComplete); // continue with create
	        }
	    });
	}


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * This directive is placed on create / update buttons
	 * and is given latitude and longitude property names,
	 * the values of which will be converted from
	 * Degrees/Minutes/Seconds to Decimal Degrees
	 *
	 * After conversion, it proceeds with the crud function
	 *
	 * @example
	 * convert-to-tons latitude="prop" longitude="prop"
	 * conversion-complete="create(convertedEditable || editable)"
	 *
	 * For Lat/Lon properties that are nested, dot
	 * notation must be used (including array indexes)
	 * @example
	 * convert-to-tons latitude="nested.property.1"
	 * longitude="nested.property.2"
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// classes
	var convertCoordinates_class_1 = __webpack_require__(61);
	// lodash
	var lodash_1 = __webpack_require__(72);
	/** @ngInject */
	function convertCoordinates() {
	    return {
	        restrict: 'A',
	        link: linkFunc,
	        priority: 2
	    };
	}
	exports.convertCoordinates = convertCoordinates;
	function linkFunc(scope, elem, attrs) {
	    var lon = attrs.longitude;
	    var lat = attrs.latitude;
	    var conversionComplete = attrs.conversionComplete; // function to run after conversion
	    var coordinates = new convertCoordinates_class_1.Coordinates();
	    function runClickEvent(func) {
	        scope.$eval(func);
	    }
	    elem.bind('click', function () {
	        scope.convertedEditable = angular.copy(scope.editable);
	        // if lat and long are nested 
	        // properties with dot notation
	        if (lat.includes('.') || lon.includes('.')) {
	            // finds values of nested lat/lon properties
	            // on the convertedEditable object
	            var lonValue = lon.split('.').reduce(function (o, i) { return o[i]; }, scope.convertedEditable);
	            var latValue = lat.split('.').reduce(function (o, i) { return o[i]; }, scope.convertedEditable);
	            // use lodash to assign the converted value
	            // to the nested property on the
	            // convertedEditable object
	            lodash_1.set(scope.convertedEditable, lon, coordinates.parseDMS(lonValue));
	            lodash_1.set(scope.convertedEditable, lat, coordinates.parseDMS(latValue));
	        }
	        else {
	            scope.convertedEditable[lat] = coordinates.parseDMS(scope.convertedEditable[lat]);
	            scope.convertedEditable[lon] = coordinates.parseDMS(scope.convertedEditable[lon]);
	        }
	        if (conversionComplete) {
	            runClickEvent(conversionComplete); // continue with create
	        }
	    });
	}


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function rejectedRecords() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/rejected-records/rejected-records.directive.html'
	    };
	}
	exports.rejectedRecords = rejectedRecords;


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Directive to be placed on text inputs
	 * Check validation for Aerodrome  names
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function aerodromeIdentifiers() {
	    return {
	        require: 'ngModel',
	        link: function (scope, elem, attrs, modelCtrl) {
	            modelCtrl.$parsers.push(function (inputValue) {
	                var transformedInput;
	                var maxlength = 4;
	                if (inputValue) {
	                    transformedInput = inputValue[0].replace(/[^a-zA-Z]/g, '').toUpperCase();
	                }
	                for (var i = 1, len = inputValue.length; i < len; i++) {
	                    transformedInput += inputValue[i].replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
	                    if (transformedInput.length > maxlength) {
	                        transformedInput = inputValue.substring(0, maxlength);
	                    }
	                }
	                if (transformedInput !== inputValue) {
	                    modelCtrl.$setViewValue(transformedInput);
	                    modelCtrl.$render();
	                }
	                return transformedInput;
	            });
	        }
	    };
	}
	exports.aerodromeIdentifiers = aerodromeIdentifiers;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Unit conversion input
	 *
	 * Currently only used for MTOW, CARGO and USER_CROSSING_DISTANCE
	 *
	 * ex:
	 * <unit-conversion-input id="upper-limit" name="upperLimit" ng-model="editable.upper_limit" measurement-type="weight" required />
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// mtow settings
	var MTOW = {
	    min: 0,
	    max_kg: 907186,
	    max_tons: 1000,
	    pattern_kg: /^\d*?$/,
	    pattern_tons: /^(?!0\d|$)\d*(\.\d{1,})?$/,
	    step_kg: 1,
	    step_tons: 0.01
	};
	// cargo settings
	var CARGO = {
	    min: 0,
	    max_kg: 999000,
	    max_tons: 1101.21,
	    pattern_kg: /^\d*?$/,
	    pattern_tons: /^(?!0\d|$)\d*(\.\d{1,})?$/,
	    step_kg: 1,
	    step_tons: 0.01
	};
	/** @ngInject */
	function unitConversionInput() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/unit-conversion-input/unitConversionInput.template.html',
	        controller: UnitConversionInputController,
	        controllerAs: 'UnitConversionInputController',
	        replace: true,
	        require: 'ngModel',
	        scope: {
	            id: '@',
	            name: '@',
	            ngModel: '=',
	            isRequired: '@',
	            measurementType: '@'
	        }
	    };
	}
	exports.unitConversionInput = unitConversionInput;
	/** @ngInject */
	var UnitConversionInputController = (function () {
	    UnitConversionInputController.$inject = ["$scope", "systemConfigurationService"];
	    function UnitConversionInputController($scope, systemConfigurationService) {
	        $scope.mtowUnitOfMeasure = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	        $scope.cargoDisplayUnits = systemConfigurationService.getValueByName(system_configuration_constants_1.SysConfigConstants.CARGO_DISPLAY_UNITS);
	        $scope.isWeight = $scope.measurementType === 'weight';
	        $scope.isCargo = $scope.measurementType === 'cargo';
	        if ($scope.isWeight) {
	            $scope.min = MTOW.min;
	            $scope.max = $scope.mtowUnitOfMeasure === 'kg' ? MTOW.max_kg : MTOW.max_tons;
	            $scope.step = $scope.mtowUnitOfMeasure === 'kg' ? MTOW.step_kg : MTOW.step_tons;
	            $scope.pattern = $scope.mtowUnitOfMeasure === 'kg' ? MTOW.pattern_kg : MTOW.pattern_tons;
	        }
	        if ($scope.isCargo) {
	            $scope.min = CARGO.min;
	            $scope.max = $scope.cargoDisplayUnits === 'kg' ? CARGO.max_kg : CARGO.max_tons;
	            $scope.step = $scope.cargoDisplayUnits === 'kg' ? CARGO.step_kg : CARGO.step_tons;
	            $scope.pattern = $scope.cargoDisplayUnits === 'kg' ? CARGO.pattern_kg : CARGO.pattern_tons;
	        }
	    }
	    return UnitConversionInputController;
	}());


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Certain units must be converted before being sent to the API.
	 * For example, if the frontend is set to enter distance
	 * values in nautical miles, they must be converted to kilometers.
	 *
	 * This directive is placed on create / update buttons
	 * and is given the property name for the value to convert
	 *
	 * After conversion, it proceeds with the crud function
	 *
	 * example use:
	 * unit-converter unit-to-convert="nameOfProperty"
	 * conversion-complete="create(convertedEditable || editable)"
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function unitConverter() {
	    return {
	        restrict: 'A',
	        link: linkFunc,
	        priority: 2
	    };
	}
	exports.unitConverter = unitConverter;
	function linkFunc(scope, elem, attrs) {
	    var TO_KM = 1.852;
	    var unitToConvert = attrs.unitToConvert;
	    var conversionComplete = attrs.conversionComplete; // function to run after conversion
	    function runClickEvent(func) {
	        scope.$eval(func);
	    }
	    elem.bind('click', function () {
	        var localStorageValue = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE);
	        var distanceConfig = scope.list.find(function (item) {
	            return item.item_name === system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE.toString();
	        });
	        var distanceUnitOfMeasure = distanceConfig ? distanceConfig.current_value : '';
	        scope.convertedList = angular.copy(scope.list);
	        scope.convertedEditable = angular.copy(scope.editable);
	        if ((isChangingToKM() && !isChangingToNM()) || localStorageValue === 'nm') {
	            if (unitToConvert === 'distance') {
	                var itemToConvertIndexes = scope.list.filter(function (item) { return item.item_name.includes('distance') && ['int', 'float'].indexOf(item.data_type.name) > -1; })
	                    .map(function (item) { return scope.list.indexOf(item); });
	                itemToConvertIndexes.forEach(function (itemIndex) {
	                    scope.convertedList[itemIndex].current_value = scope.convertedList[itemIndex].current_value * TO_KM;
	                });
	            }
	            else if (unitToConvert === 'user_crossing_distance') {
	                scope.convertedEditable[unitToConvert] = scope.convertedEditable[unitToConvert] * TO_KM;
	            }
	        }
	        // if NM is in local storage
	        // and KM selected on interface
	        function isChangingToKM() {
	            return ((unitToConvert === 'user_crossing_distance' && localStorageValue === 'nm') ||
	                (unitToConvert === 'distance' && localStorageValue === 'nm' && distanceUnitOfMeasure === 'km'));
	        }
	        // if KM is in local storage
	        // and NM selected on interface
	        function isChangingToNM() {
	            return unitToConvert === 'distance' && localStorageValue === 'km' && distanceUnitOfMeasure === 'nm';
	        }
	        if (conversionComplete) {
	            runClickEvent(conversionComplete); // continue with create
	        }
	    });
	}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var helpers_service_1 = __webpack_require__(19);
	/** @ngInject */
	function copyToClipboard() {
	    return {
	        restrict: 'A',
	        link: linkFunc,
	        priority: 2,
	        scope: {
	            copyToClipboard: '='
	        }
	    };
	}
	exports.copyToClipboard = copyToClipboard;
	function linkFunc(scope, element, attrs) {
	    element.bind('click', function () {
	        helpers_service_1.HelperService.copyToClipboard(document.getElementById(scope.copyToClipboard));
	    });
	}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// controllers
	var system_configuration_item_controller_1 = __webpack_require__(123);
	/** @ngInject */
	function systemConfigurationItem() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/system-configuration-item/system-configuration-item.template.html',
	        controller: system_configuration_item_controller_1.SystemConfigurationItemController,
	        controllerAs: 'sytemConfigurationItemCtrl',
	        scope: {
	            item: '=',
	            pluginKey: '=?',
	            list: '='
	        }
	    };
	}
	exports.systemConfigurationItem = systemConfigurationItem;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function booleanText() {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl: 'app/components/directives/boolean-text/boolean-text.html',
	        controller: BooleanTextController
	    };
	}
	exports.booleanText = booleanText;
	/** @ngInject */
	var BooleanTextController = (function () {
	    BooleanTextController.$inject = ["$rootScope", "$scope", "$translate"];
	    function BooleanTextController($rootScope, $scope, $translate) {
	        var _this = this;
	        this.setBooleanList($translate, $scope);
	        $rootScope.$on('$translateChangeEnd', function (resp) {
	            _this.setBooleanList($translate, $scope);
	        });
	    }
	    BooleanTextController.prototype.setBooleanList = function ($translate, $scope) {
	        $scope.booleanList = [
	            { n: $translate.instant('True'), v: true },
	            { n: $translate.instant('False'), v: false }
	        ];
	    };
	    return BooleanTextController;
	}());


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [0, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var localStorage_service_1 = __webpack_require__(9);
	/** @ngInject */
	function recaptcha() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/angular-ids-project/src/components/recaptcha/recaptcha.html',
	        replace: true,
	        controller: RecaptchaController,
	        controllerAs: 'RecaptchaController'
	    };
	}
	exports.recaptcha = recaptcha;
	/** @ngInject */
	var RecaptchaController = (function () {
	    RecaptchaController.$inject = ["$scope", "recaptchaService", "selfCareHelper"];
	    function RecaptchaController($scope, recaptchaService, selfCareHelper) {
	        var _this = this;
	        this.$scope = $scope;
	        this.recaptchaService = recaptchaService;
	        this.selfCareHelper = selfCareHelper;
	        // intialize recaptcha scope properties that are dependent on system configuration setting
	        this.initialize();
	        // always set public key from recaptcha service if available
	        this.$scope.publicKey = this.recaptchaService.publicKey;
	        // get the widgetId when the recaptcha instance is created via onCreate callback
	        this.$scope.onWidgetCreate = function (widgetId) { return _this.$scope.widgetId = widgetId; };
	        this.$scope.setResponse = function (response) { return _this.$scope.showButton = true; };
	        this.$scope.recaptchaExpire = function () { return _this.recaptchaService.reload(_this.$scope.widgetId); };
	    }
	    RecaptchaController.prototype.initialize = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _a;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        // test to see if captcha configurations are available
	                        // if not download them and add to localstorage
	                        this.$scope.requireCaptcha = localStorage_service_1.LocalStorageService.get(system_configuration_constants_1.SysConfigConstants.REQUIRE_CAPTCHA);
	                        if (!!this.$scope.requireCaptcha) return [3 /*break*/, 2];
	                        _a = this.$scope;
	                        return [4 /*yield*/, this.selfCareHelper.fetchConfig(system_configuration_constants_1.SysConfigConstants.REQUIRE_CAPTCHA)
	                                .then(function () { return localStorage_service_1.LocalStorageService.get(system_configuration_constants_1.SysConfigConstants.REQUIRE_CAPTCHA); })];
	                    case 1:
	                        _a.requireCaptcha = _b.sent();
	                        _b.label = 2;
	                    case 2:
	                        if (this.$scope.requireCaptcha) {
	                            this.$scope.loginFromBilling = JSON.parse(window.localStorage.getItem('loginFromBilling'));
	                            this.$scope.showButton = this.$scope.loginFromBilling === false;
	                        }
	                        else {
	                            this.$scope.showButton = true;
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return RecaptchaController;
	}());
	exports.RecaptchaController = RecaptchaController;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Input for querying external database.
	 *
	 * Accepts an input value and a target value
	 *
	 * Accepts params as follows:
	 *
	 *
	 * <external-database-input
	 *   input-value="inputValue"
	 *   return-value="returnValue"
	 * />
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var EXTERNAL_DATABASE_TARGETS = {
	    AATIS: {
	        name: 'AATIS',
	        error: {
	            notFound: 'Adhoc permit not found',
	            error: 'There was an error connecting to the AATIS database'
	        }
	    },
	    EAIP: {
	        name: 'EAIP',
	        error: {
	            notFound: 'Requisition not found',
	            error: 'There was an error connecting to the eAIP database'
	        }
	    }
	};
	/** @ngInject */
	function externalDatabaseInput() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/external-database-input/external-database-input.template.html',
	        scope: {
	            item: '=',
	            required: '=?',
	            callback: '=?',
	            supported: '=?',
	            externalDatabase: '@?',
	            currencyCode: '=?',
	            posAviation: '=?'
	        },
	        controller: ExternalDatabaseInputController
	    };
	}
	exports.externalDatabaseInput = externalDatabaseInput;
	/** @ngInject */
	var ExternalDatabaseInputController = (function () {
	    ExternalDatabaseInputController.$inject = ["$scope", "externalDatabaseInputService"];
	    function ExternalDatabaseInputController($scope, externalDatabaseInputService) {
	        var _this = this;
	        this.$scope = $scope;
	        this.externalDatabaseInputService = externalDatabaseInputService;
	        $scope.databaseTarget = this.$scope.item.service_charge_catalogue ? this.$scope.item.service_charge_catalogue.external_database_for_charge : this.$scope.externalDatabase;
	        $scope.queryExternalDatabase = function () { return _this.queryExternalDatabase(); };
	        $scope.supported = angular.isDefined(this.$scope.supported) ? this.$scope.supported : true;
	        $scope.posAviation = $scope.posAviation ? $scope.posAviation : false;
	        $scope.$watch('required', function (isRequired) {
	            if (!isRequired) {
	                _this.$scope.permitNumber = null;
	            }
	        });
	        $scope.$watch('currencyCode', function () { return _this.queryExternalDatabase(); });
	    }
	    ExternalDatabaseInputController.prototype.queryExternalDatabase = function () {
	        this.$scope.error = null;
	        switch (this.$scope.databaseTarget) {
	            case EXTERNAL_DATABASE_TARGETS.AATIS.name:
	                this.getInvoicPermitFromAATIS();
	                break;
	            case EXTERNAL_DATABASE_TARGETS.EAIP.name:
	                this.getRequisitionFromEAIP();
	                break;
	            default:
	                break;
	        }
	    };
	    ExternalDatabaseInputController.prototype.getInvoicPermitFromAATIS = function () {
	        var _this = this;
	        var adhocFee = {
	            invoice_permit_number: this.$scope.permitNumber,
	            external_database_for_charge: EXTERNAL_DATABASE_TARGETS.AATIS.name,
	            adhoc_total_fee_payment_amount: null,
	            flight_movement: this.$scope.item
	        };
	        if (!this.$scope.permitNumber) {
	            if (this.$scope.callback) {
	                return this.$scope.callback(adhocFee);
	            }
	            return;
	        }
	        var _a = this.$scope, item = _a.item, permitNumber = _a.permitNumber, databaseTarget = _a.databaseTarget;
	        item.invoice_permit.invoice_permit_number = permitNumber;
	        item.invoice_permit.external_database_for_charge = databaseTarget;
	        this.externalDatabaseInputService.getInvoicePermitFromAATIS(this.$scope.permitNumber, this.$scope.currencyCode).then(function (invoicePermit) {
	            if (invoicePermit) {
	                item.invoice_permit.adhoc_total_fee_payment_amount = invoicePermit.adhoc_fee;
	                adhocFee.adhoc_total_fee_payment_amount = _this.$scope.currencyCode ? invoicePermit.adhoc_fee_converted : invoicePermit.adhoc_fee;
	                if (_this.$scope.callback) {
	                    _this.$scope.callback(adhocFee);
	                }
	                else {
	                    _this.$scope.item.amount = adhocFee.adhoc_total_fee_payment_amount;
	                }
	            }
	            else {
	                _this.showError(EXTERNAL_DATABASE_TARGETS.AATIS.error.notFound);
	                _this.updateNotFoundAdhoc(item, adhocFee);
	            }
	        }).catch(function () {
	            _this.showError(EXTERNAL_DATABASE_TARGETS.AATIS.error.error);
	            _this.updateNotFoundAdhoc(item, adhocFee);
	        });
	    };
	    ExternalDatabaseInputController.prototype.getRequisitionFromEAIP = function () {
	        var _this = this;
	        if (!this.$scope.permitNumber) {
	            return;
	        }
	        this.externalDatabaseInputService.getRequisitionFromEAIP(this.$scope.permitNumber).then(function (requisition) {
	            if (requisition) {
	                var _a = _this.$scope, item = _a.item, permitNumber = _a.permitNumber, databaseTarget = _a.databaseTarget;
	                var req_currency = requisition.req_currency, req_total_amount = requisition.req_total_amount, req_ar_id = requisition.req_ar_id, req_country_id = requisition.req_country_id, req_id = requisition.req_id, req_maninfo_id = requisition.req_maninfo_id;
	                var newRequisition = {
	                    req_number: permitNumber,
	                    external_database_for_charge: databaseTarget,
	                    req_currency: req_currency,
	                    req_total_amount: req_total_amount,
	                    req_ar_id: req_ar_id,
	                    req_country_id: req_country_id,
	                    req_id: req_id,
	                    req_maninfo_id: req_maninfo_id
	                };
	                item.requisition = newRequisition;
	                item.amount = req_total_amount;
	            }
	            else {
	                _this.showError(EXTERNAL_DATABASE_TARGETS.EAIP.error.notFound);
	            }
	        }).catch(function () { return _this.showError(EXTERNAL_DATABASE_TARGETS.EAIP.error.error); });
	    };
	    ExternalDatabaseInputController.prototype.showError = function (errorDescription) {
	        this.$scope.item.amount = null;
	        this.$scope.error = {
	            error: {
	                data: {
	                    error: 'NOT FOUND',
	                    error_description: errorDescription,
	                    field_errors: null
	                }
	            }
	        };
	    };
	    // we need to include the user entered permit number on the invoice (only for POS Aviation), 
	    // with fees of 0.00, even if it's not found/not connected to external db
	    ExternalDatabaseInputController.prototype.updateNotFoundAdhoc = function (item, adhocFee) {
	        if (this.$scope.permitNumber && this.$scope.posAviation && this.$scope.callback) {
	            item.invoice_permit.adhoc_total_fee_payment_amount = 0;
	            adhocFee.adhoc_total_fee_payment_amount = 0;
	            this.$scope.callback(adhocFee);
	        }
	    };
	    return ExternalDatabaseInputController;
	}());
	exports.ExternalDatabaseInputController = ExternalDatabaseInputController;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function paginationDisplay() {
	    return {
	        restrict: 'E',
	        replace: true,
	        templateUrl: 'app/components/directives/pagination-display/pagination-display.html'
	    };
	}
	exports.paginationDisplay = paginationDisplay;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function uploadFileFormat() {
	    return {
	        restrict: 'E',
	        controller: UploadFileFormatController,
	        controllerAs: 'UploadFileFormatController',
	        templateUrl: 'app/angular-ids-project/src/components/uploadFileFormat/uploadFileFormat.html',
	        replace: true,
	        scope: {
	            template: '@',
	            mtow: '@',
	            format: '@'
	        }
	    };
	}
	exports.uploadFileFormat = uploadFileFormat;
	/** @ngInject */
	var UploadFileFormatController = (function () {
	    UploadFileFormatController.$inject = ["$scope", "$uibModal"];
	    function UploadFileFormatController($scope, $uibModal) {
	        this.$scope = $scope;
	        this.$uibModal = $uibModal;
	        var mtow = $scope.mtow;
	        var format = $scope.format;
	        $scope.showFileFormat = function () {
	            var modal = $uibModal.open({
	                templateUrl: $scope.template,
	                controller: ['$scope', function ($scope) {
	                        $scope.mtow = mtow;
	                        $scope.format = format;
	                        $scope.confirm = function () {
	                            modal.close();
	                        };
	                    }]
	            });
	        };
	    }
	    return UploadFileFormatController;
	}());
	exports.UploadFileFormatController = UploadFileFormatController;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Directive to be placed on text inputs
	 * Converts all input to uppercase
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function uppercaseInput() {
	    var inputToUppercase = function (val, modelCtrl, elem) {
	        if (!val || !val.length) {
	            return;
	        }
	        var targetElement = elem[0];
	        // store position to prevent line jump
	        var start = targetElement.selectionStart;
	        var end = targetElement.selectionEnd;
	        // set value and rerender
	        modelCtrl.$setViewValue(val.toUpperCase());
	        modelCtrl.$render();
	        // restore position
	        targetElement.setSelectionRange(start, end);
	    };
	    return {
	        require: 'ngModel',
	        restrict: 'A',
	        link: function (scope, elem, attrs, modelCtrl) {
	            scope.$watch(function () { return modelCtrl.$modelValue; }, function (val) { return inputToUppercase(val, modelCtrl, elem); });
	        }
	    };
	}
	exports.uppercaseInput = uppercaseInput;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function summaryUpload() {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/components/directives/summary-upload/summary-upload.directive.html',
	        scope: {
	            uploadJob: '='
	        }
	    };
	}
	exports.summaryUpload = summaryUpload;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// filters
	var dateConverter_filter_1 = __webpack_require__(309);
	var weightConverter_filter_1 = __webpack_require__(310);
	var distanceConverter_filter_1 = __webpack_require__(311);
	var longitudeConverter_filter_1 = __webpack_require__(312);
	var latitudeConverter_filter_1 = __webpack_require__(313);
	var abs_filter_1 = __webpack_require__(314);
	var evenRound_filter_1 = __webpack_require__(315);
	var customRound_filter_1 = __webpack_require__(316);
	var highlight_filter_1 = __webpack_require__(317);
	var hideCurrent_filter_1 = __webpack_require__(318);
	var hideHigher_filter_1 = __webpack_require__(319);
	var hideLower_filter_1 = __webpack_require__(320);
	var system_configuration_item_label_filter_1 = __webpack_require__(321);
	// filter module
	exports.default = angular.module('armsWeb.filters', [])
	    .filter('dateConverter', dateConverter_filter_1.dateConverter)
	    .filter('weightConverter', weightConverter_filter_1.weightConverter)
	    .filter('distanceConverter', distanceConverter_filter_1.distanceConverter)
	    .filter('longitudeConverter', longitudeConverter_filter_1.longitudeConverter)
	    .filter('latitudeConverter', latitudeConverter_filter_1.latitudeConverter)
	    .filter('abs', abs_filter_1.abs)
	    .filter('evenRound', evenRound_filter_1.evenRound)
	    .filter('customRound', customRound_filter_1.customRound)
	    .filter('highlight', highlight_filter_1.highlight)
	    .filter('hideCurrent', hideCurrent_filter_1.hideCurrent)
	    .filter('hideHigher', hideHigher_filter_1.hideHigher)
	    .filter('hideLower', hideLower_filter_1.hideLower)
	    .filter('systemConfigurationItemLabel', system_configuration_item_label_filter_1.systemConfigurationItemLabel);


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Date Converter
	 *
	 * This is used to convert a date string into one of the following
	 *
	 * https://docs.angularjs.org/api/ng/filter/date
	 *
	 * Note: there is the optional parameter `additionalDateFilter` that can append the systems format.
	 *       it is ignored if you use an Angular date filter that is a "word" to keep things from breaking
	 *       ex. you can't do `longDate hh:mm:ss`, it does not work
	 *
	 */
	dateConverter.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	/** @ngInject */
	function dateConverter($filter) {
	    // the reason we do the regex inside is to save memory if we don't need to test against it
	    var ignoreWords = [
	        'medium',
	        'short',
	        'fullDate',
	        'longDate',
	        'mediumDate',
	        'shortDate',
	        'mediumTime',
	        'shortTime'
	    ];
	    return function (oldValue, additionalDateFilter) {
	        // do not convert placeholders
	        if (oldValue === '...') {
	            return oldValue;
	        }
	        if (oldValue !== null) {
	            var format = localStorage_service_1.LocalStorageService.get('SystemConfiguration:Date format')
	                ? localStorage_service_1.LocalStorageService.get('SystemConfiguration:Date format')
	                : 'yyyy-MMM-dd';
	            // we join the words together and see if our format contains it
	            // append the additional optional parameter to our filter
	            if (additionalDateFilter && ignoreWords.indexOf(format) === -1) {
	                format += " " + additionalDateFilter;
	            }
	            // always display times in UTC, GMT +0000
	            return $filter('date')(new Date(oldValue), format, 'UTC');
	        }
	    };
	}
	exports.dateConverter = dateConverter;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Weight Converter
	 *
	 * This filter is used to display a weight in kilograms (kg)
	 * Conversion is currently done with the US ton: 1 ton = 907.185 kg
	 *
	 */
	weightConverter.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function weightConverter($filter) {
	    return function (val) {
	        if (val !== null && !isNaN(val)) {
	            var format = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.MTOW_UNIT_OF_MEASURE);
	            if (format === 'kg') {
	                return $filter('number')(val * 907.185, 0); // us ton
	            }
	            else {
	                return $filter('number')(val, 2);
	            }
	        }
	    };
	}
	exports.weightConverter = weightConverter;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Distance converter
	 *
	 * This filter is used to display distance in nautical miles.
	 * Conversion: km to nm 1km =  0.539957nm
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function distanceConverter() {
	    return function (val) {
	        if (val !== null && !isNaN(val)) {
	            var format = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.DISTANCE_UNIT_OF_MEASURE);
	            if (format === 'nm') {
	                return val * 0.539957; // nautical mile
	            }
	            return val;
	        }
	    };
	}
	exports.distanceConverter = distanceConverter;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Longitude Converter
	 *
	 * This filter is used to display a longitude in Degrees-Minutes-Seconds
	 *
	 */
	longitudeConverter.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// classes
	var convertCoordinates_class_1 = __webpack_require__(61);
	/** @ngInject */
	function longitudeConverter($filter) {
	    return function (longitude) {
	        var coordinates = new convertCoordinates_class_1.Coordinates();
	        if (longitude !== null) {
	            var format = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.COORDINATE_FORMAT);
	            // if system set to dms, return
	            // dms with 0 decimals points
	            if (format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS) {
	                var longitudeNumber = parseFloat(longitude);
	                return coordinates.toLon(longitudeNumber, 'dms', 0);
	            }
	            else {
	                // else return decimal degrees
	                // with 5 decimal points
	                var lon = $filter('number')(longitude, 5);
	                if (lon !== null) {
	                    return lon.replace(/,/g, '');
	                }
	            }
	        }
	    };
	}
	exports.longitudeConverter = longitudeConverter;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Latitude Converter
	 *
	 * This filter is used to display a latitude in Degrees-Minutes-Seconds
	 *
	 */
	latitudeConverter.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	// classes
	var convertCoordinates_class_1 = __webpack_require__(61);
	/** @ngInject */
	function latitudeConverter($filter) {
	    return function (latitude) {
	        var coordinates = new convertCoordinates_class_1.Coordinates();
	        if (latitude !== null) {
	            var format = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.COORDINATE_FORMAT);
	            // if system set to dms, return
	            // dms with 0 decimals points
	            if (format === system_configuration_constants_1.SysConfigConstants.DEGREES_MINUTES_SECONDS) {
	                var latitudeNumber = parseFloat(latitude);
	                return coordinates.toLat(latitudeNumber, 'dms', 0);
	            }
	            else {
	                // else return decimal degrees
	                // with 5 decimal points
	                var lat = $filter('number')(latitude, 5);
	                if (lat !== null) {
	                    return lat.replace(/,/g, '');
	                }
	            }
	        }
	    };
	}
	exports.latitudeConverter = latitudeConverter;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	"use strict";
	// converts a number to its absolute positive
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function abs() {
	    return function (val) {
	        if (val !== null && !isNaN(val)) {
	            return Math.abs(val);
	        }
	        return val;
	    };
	}
	exports.abs = abs;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var helpers_service_1 = __webpack_require__(19);
	// roungs a number using even rounding (banker's rounding)
	/** @ngInject */
	function evenRound() {
	    return function (num, decimals) {
	        if (decimals === void 0) { decimals = 0; }
	        if (num !== null && !isNaN(num)) {
	            return helpers_service_1.HelperService.evenRound(num, decimals);
	        }
	        return num;
	    };
	}
	exports.evenRound = evenRound;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

	"use strict";
	// roungs a number using system configs
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function customRound() {
	    return function (num, direction) {
	        if (direction === 'Up') {
	            return Math.ceil(num);
	        }
	        else if (direction === 'Down') {
	            return Math.floor(num);
	        }
	        else {
	            return num;
	        }
	    };
	}
	exports.customRound = customRound;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Wraps all highlight text found within the expresion value with an element.
	 *
	 * Default element is a `span` with the classes `text-warning ng-
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function highlight() {
	    return function (val, highlight, cssClass, element) {
	        // if no higlight value, return original value supplied as is
	        if (!highlight) {
	            return val;
	        }
	        // if no cssClass value, set to default
	        if (!cssClass) {
	            cssClass = 'text-warning bg-warning';
	        }
	        // if no element value, set to default
	        if (!element) {
	            element = 'span';
	        }
	        // replace all instances of highlight value found in text with 
	        // wrapped value using `element` and `cssClass` values
	        return val.replace(new RegExp(highlight, 'gi'), '<' + element + ' class="' + cssClass + '">$&</' + element + '>');
	    };
	}
	exports.highlight = highlight;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

	"use strict";
	// removes the option that is the same level as the level being considered
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function hideCurrent() {
	    return function (vals, idx) {
	        var output = [];
	        for (var _i = 0, vals_1 = vals; _i < vals_1.length; _i++) {
	            var val = vals_1[_i];
	            if (idx !== val.level) {
	                output.push(val);
	            }
	        }
	        return output;
	    };
	}
	exports.hideCurrent = hideCurrent;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	"use strict";
	// removes the option that are higher then the current level as the level being considered
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function hideHigher() {
	    return function (vals, idx) {
	        var output = [];
	        for (var _i = 0, vals_1 = vals; _i < vals_1.length; _i++) {
	            var val = vals_1[_i];
	            if (idx > val.level) {
	                output.push(val);
	            }
	        }
	        return output;
	    };
	}
	exports.hideHigher = hideHigher;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	"use strict";
	// removes the option that are lower then the current level as the level being considered
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function hideLower() {
	    return function (vals, idx) {
	        var output = [];
	        for (var _i = 0, vals_1 = vals; _i < vals_1.length; _i++) {
	            var val = vals_1[_i];
	            if (idx < val.level) {
	                output.push(val);
	            }
	        }
	        return output;
	    };
	}
	exports.hideLower = hideLower;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * System configuration item label format filter.
	 *
	 * This filter is used to trim plugin specific prefixes
	 * on display.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function systemConfigurationItemLabel() {
	    return function (name, pluginKey) {
	        // if no plugin key set, return existing name
	        if (!pluginKey || pluginKey.length === 0) {
	            return name;
	        }
	        // regular expression that finds plugin key prefix
	        var pluginPrefix = new RegExp('^' + pluginKey.replace('_', ' '), 'i');
	        // return name without plugin key prefix and capitalizes first character
	        return name
	            .replace(pluginPrefix, '').trim()
	            .replace(/^\w/, function (c) { return c.toUpperCase(); });
	    };
	}
	exports.systemConfigurationItemLabel = systemConfigurationItemLabel;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// configs
	var loading_bar_config_1 = __webpack_require__(323);
	var log_config_1 = __webpack_require__(324);
	var router_config_1 = __webpack_require__(325);
	var translate_config_1 = __webpack_require__(326);
	var locale_interceptor_config_1 = __webpack_require__(327);
	var pagination_config_1 = __webpack_require__(328);
	var recaptcha_config_1 = __webpack_require__(329);
	// decorators
	var multiselect_1 = __webpack_require__(330);
	var progressBar_1 = __webpack_require__(331);
	var datePicker_1 = __webpack_require__(332);
	var locale_1 = __webpack_require__(333);
	var input_1 = __webpack_require__(334);
	// config module
	exports.default = angular.module('armsWeb.configs', [])
	    .config(loading_bar_config_1.LoadingBarConfig)
	    .config(log_config_1.LogConfig)
	    .config(router_config_1.RouterConfig)
	    .config(translate_config_1.TranslateConfig)
	    .config(locale_interceptor_config_1.LocaleInterceptor)
	    .config(multiselect_1.MultiselectDecorator)
	    .config(progressBar_1.ProgressBarDecorator)
	    .config(datePicker_1.DatePickerDecorator)
	    .config(locale_1.LocaleDecorator)
	    .config(pagination_config_1.PaginationConfig)
	    .config(recaptcha_config_1.RecaptchaConfig)
	    .config(input_1.InputDecorator);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Override functionality from angular-progress-bar
	 */
	LoadingBarConfig.$inject = ["cfpLoadingBarProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function LoadingBarConfig(cfpLoadingBarProvider) {
	    cfpLoadingBarProvider.startSize = 0.005;
	    // we set auto increment to false so we can define our own increment
	    cfpLoadingBarProvider.autoIncrement = false;
	    cfpLoadingBarProvider.includeSpinner = true;
	    cfpLoadingBarProvider.includeBar = false;
	    cfpLoadingBarProvider.latencyThreshold = 1000;
	    cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
	    cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-container"><div id="loading-bar-spinner"><i class="fa fa-spinner fa-pulse fa-5x fa-fw"></i><span class="sr-only">Loading...</span></div>';
	    // cfpLoadingBarProvider.spinnerTemplate = '<div style="height: 100%; width:100%; position:absolute;z-index: 300; top: 0;bottom: 0; right: 0; left: 0"><div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    // cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-container"><div id="loading-bar-spinner"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"><span class="sr-only">Loading...</span></i></div></div>';
	}
	exports.LoadingBarConfig = LoadingBarConfig;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Override functionality for log provider.
	 */
	LogConfig.$inject = ["$logProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function LogConfig($logProvider) {
	    // enable log, uncomment for development purposes only
	    // $logProvider.debugEnabled(true);
	}
	exports.LogConfig = LogConfig;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	"use strict";
	RouterConfig.$inject = ["$httpProvider", "$stateProvider", "$locationProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function RouterConfig($httpProvider, $stateProvider, $locationProvider, $urlRouterProvider) {
	    $httpProvider.defaults.withCredentials = true;
	    $httpProvider.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
	    $stateProvider
	        .state('main', {
	        url: '',
	        views: {
	            '': {
	                templateUrl: 'app/main/main.html',
	                controller: 'MainController',
	                controllerAs: 'main'
	            },
	            'map@main': {
	                templateUrl: 'app/partials/map/map.html',
	                controller: 'MapController',
	                title: 'Map'
	            }
	        }
	    })
	        .state('main.map', {
	        name: 'map',
	        templateUrl: 'app/partials/users/users.html',
	        controller: 'MapController',
	        title: 'Users'
	    })
	        .state('login', {
	        url: '/login',
	        templateUrl: 'app/login/login.html',
	        controller: 'LoginController',
	        controllerAs: 'login',
	        title: 'Log In'
	    })
	        .state('main.users', {
	        url: '/users',
	        templateUrl: 'app/partials/users/users.html',
	        controller: 'UsersController',
	        title: 'Users'
	    })
	        .state('main.sso-providers', {
	        url: '/sso-providers',
	        templateUrl: 'app/partials/sso-providers/sso-providers.html',
	        controller: 'SSOProvidersController',
	        title: 'SSO Providers'
	    })
	        .state('main.aircraft-type-management', {
	        url: '/aircraft-type-management',
	        templateUrl: 'app/partials/aircraft-type-management/aircraft-type-management.html',
	        controller: 'AircraftTypeManagementController',
	        title: 'Aircraft Type Management'
	    })
	        .state('main.aircraft-exempt-management', {
	        url: '/aircraft-exempt-management',
	        templateUrl: 'app/partials/aircraft-exempt-management/aircraft-exempt-management.html',
	        controller: 'AircraftExemptManagementController',
	        title: 'Exempt Aircraft Management'
	    })
	        .state('main.crco-connection', {
	        url: '/crco-connection',
	        templateUrl: 'app/partials/crco-connections/crco-connection.html',
	        controller: 'CrcoConnectionController',
	        title: 'CRCO connection'
	    })
	        .state('main.crco-certificates', {
	        url: '/crco-certificates',
	        templateUrl: 'app/partials/crco-management/crco-certificates.html',
	        controller: 'CrcoCertificatesController',
	        title: 'CRCO certificates'
	    })
	        .state('main.crco-reporting-responsabilities', {
	        url: '/crco-reporting-responsabilities',
	        templateUrl: 'app/partials/crco-reporting-responsabilities/crco-reporting-responsabilities.html',
	        controller: 'CrcoReportingResponsabilitiesController',
	        title: 'CRCO Reporting Responsabilities'
	    })
	        .state('main.crco-messages', {
	        url: '/crco-messages',
	        templateUrl: 'app/partials/crco-messages/crco-messages.html',
	        controller: 'CrcoMessagesController',
	        title: 'CRCO Messages'
	    })
	        .state('main.crco-claims', {
	        url: '/crco-claims',
	        templateUrl: 'app/partials/crco-claims/crco-claims.html',
	        controller: 'CrcoClaimsController',
	        title: 'CRCO Claims'
	    })
	        .state('main.crco-archive', {
	        url: '/crco-archive',
	        templateUrl: 'app/partials/crco-archive/crco-archive.html',
	        controller: 'CrcoArchiveController',
	        title: 'CRCO Archive'
	    })
	        .state('main.crco-cor-request', {
	        url: '/crco-cor-request',
	        templateUrl: 'app/partials/crco-cor-request/crco-cor-request.html',
	        controller: 'CrcoCorRequestController',
	        title: 'CRCO Cor Requests'
	    })
	        .state('main.aircraft-registration', {
	        url: '/aircraft-registration',
	        templateUrl: 'app/partials/aircraft-registration/aircraft-registration.html',
	        controller: 'AircraftRegistrationController',
	        title: 'Aircraft Registration',
	        params: {
	            after: null
	        }
	    })
	        .state('main.aerodromes', {
	        url: '/aerodromes',
	        templateUrl: 'app/partials/aerodromes/aerodromes.html',
	        controller: 'AerodromesController',
	        title: 'Aerodromes'
	    })
	        .state('main.accounts', {
	        url: '/accounts/:accountId',
	        templateUrl: 'app/partials/accounts/accounts.html',
	        controller: 'AccountsController',
	        title: 'Accounts',
	        params: {
	            after: null
	        }
	    })
	        .state('main.account-exempt-management', {
	        url: '/account-exempt-management',
	        templateUrl: 'app/partials/account-exempt-management/account-exempt-management.html',
	        controller: 'AccountExemptManagementController',
	        title: 'Accounts Exempt Management'
	    })
	        .state('main.aerodrome-category', {
	        url: '/aerodrome-category',
	        templateUrl: 'app/partials/aerodrome-category-management/aerodrome-category-management.html',
	        controller: 'AerodromeCategoryManagementController',
	        title: 'Aerodrome Category Management'
	    })
	        .state('main.transactions-workflow', {
	        url: '/transactions-workflow',
	        templateUrl: 'app/partials/transactions-workflow/transactions-workflow.html',
	        controller: 'TransactionsWorkflowController',
	        title: 'Transactions Workflow'
	    })
	        .state('main.airspace-management', {
	        url: '/airspace-management',
	        templateUrl: 'app/partials/airspace-management/airspace-management.html',
	        controller: 'AirspaceManagementController',
	        title: 'Airspace Management'
	    })
	        .state('main.currency-management', {
	        url: '/currency-management',
	        templateUrl: 'app/partials/currency-management/currency-management.html',
	        controller: 'CurrencyManagementController',
	        title: 'Currency Management'
	    })
	        .state('main.group-management', {
	        url: '/group-management',
	        templateUrl: 'app/partials/group-management/group-management.html',
	        controller: 'GroupManagementController',
	        title: 'Group Management'
	    })
	        .state('main.transactions', {
	        url: '/transactions',
	        templateUrl: 'app/partials/transactions/transactions.html',
	        controller: 'TransactionsController',
	        title: 'Transactions',
	        params: {
	            transaction: null
	        }
	    })
	        .state('main.transactions-pending', {
	        url: '/transactions-pending',
	        templateUrl: 'app/partials/transactions-pending/transactions-pending.html',
	        controller: 'TransactionsPendingController',
	        title: 'Pending Transactions'
	    })
	        .state('main.invoice-generation', {
	        url: '/invoice-generation/:accountId',
	        templateUrl: 'app/partials/invoice-generation/invoice-generation.html',
	        controller: 'InvoiceGenerationController',
	        title: 'Point Of Sale Invoice Generation',
	        params: {
	            accountId: null
	        }
	    })
	        .state('main.air-navigation-charges', {
	        url: '/air-navigation-charges',
	        templateUrl: 'app/partials/air-navigation-charges/air-navigation-charges.html',
	        controller: 'AirNavigationChargesController',
	        title: 'Air Navigation Charges'
	    })
	        .state('main.enroute-air-navigation-charges-management', {
	        url: '/enroute-air-navigation-charges-management',
	        templateUrl: 'app/partials/enroute-air-navigation-charges-management/enroute-air-navigation-charges-management.html',
	        controller: 'EnrouteAirNavigationChargesManagementController',
	        title: 'Enroute Air Navigation Charges Management'
	    })
	        .state('main.system-configuration', {
	        url: '/system-configuration',
	        templateUrl: 'app/partials/system-configuration/system-configuration.html',
	        controller: 'SystemConfigurationController',
	        title: 'System Configuration'
	    })
	        .state('main.languages', {
	        url: '/languages',
	        templateUrl: 'app/partials/languages/languages.html',
	        controller: 'LanguagesController',
	        title: 'Language Management'
	    })
	        .state('main.application-management', {
	        url: '/application-management',
	        templateUrl: 'app/partials/application-management/application-management.html',
	        controller: 'ApplicationManagementController',
	        title: 'Application Management'
	    })
	        .state('main.system-summary', {
	        url: '/system-summary',
	        templateUrl: 'app/partials/system-summary/system-summary.html',
	        controller: 'SystemSummaryController',
	        title: 'System Summary'
	    })
	        .state('main.regional-country-management', {
	        url: '/regional-country-management',
	        templateUrl: 'app/partials/regional-country-management/regional-country-management.html',
	        controller: 'RegionalCountryManagementController',
	        title: 'Regional Country'
	    })
	        .state('main.country-management', {
	        url: '/country-management',
	        templateUrl: 'app/partials/country-management/country-management.html',
	        controller: 'CountryManagementController',
	        title: 'Countries'
	    })
	        .state('main.invoices', {
	        url: '/invoices',
	        templateUrl: 'app/partials/invoices/invoices.html',
	        controller: 'InvoicesController',
	        title: 'Invoices'
	    })
	        .state('main.aviation-billing-engine', {
	        url: '/aviation-billing-engine',
	        templateUrl: 'app/partials/aviation-billing-engine/aviation-billing-engine.html',
	        controller: 'AviationBillingEngineController',
	        title: 'Aviation Billing Engine'
	    })
	        .state('main.non-aviation-billing-engine', {
	        url: '/non-aviation-billing-engine',
	        templateUrl: 'app/partials/non-aviation-billing-engine/non-aviation-billing-engine.html',
	        controller: 'NonAviationBillingEngineController',
	        title: 'Non-Aviation Billing Engine'
	    })
	        .state('main.passenger-service-charge-return', {
	        url: '/passenger-service-charge-return',
	        templateUrl: 'app/partials/passenger-service-charge-return/passenger-service-charge-return.html',
	        controller: 'PassengerServiceChargeReturnController',
	        title: 'Passenger Service Charge Return Management'
	    })
	        .state('main.catalogue-service-charge', {
	        url: '/catalogue-service-charge',
	        templateUrl: 'app/partials/catalogue-service-charge/catalogue-service-charge.html',
	        controller: 'CatalogueServiceChargeController',
	        title: 'Service Charge Catalogue'
	    })
	        .state('main.unified-tax-management', {
	        url: '/unified-tax-management',
	        templateUrl: 'app/partials/unified-tax-management/unified-tax-management.html',
	        controller: 'UnifiedTaxManagementController',
	        title: 'Unified Tax Management'
	    })
	        .state('main.utilities-schedules', {
	        url: '/utilities-schedules',
	        templateUrl: 'app/partials/utilities-schedules/utilities-schedules.html',
	        controller: 'UtilitiesSchedulesController',
	        title: 'Utilities Schedules Management'
	    })
	        .state('main.utilities-towns', {
	        url: '/utilities-towns',
	        templateUrl: 'app/partials/utilities-towns/utilities-towns.html',
	        controller: 'UtilitiesTownsController',
	        title: 'Utilities Towns and Villages Management'
	    })
	        .state('main.flight-movement-management', {
	        url: '/flight-movement-management/:flightId',
	        templateUrl: 'app/partials/flight-movement-management/flight-movement-management.html',
	        controller: 'FlightMovementManagementController',
	        title: 'Flight Movement Management',
	        params: {
	            after: null
	        }
	    })
	        .state('main.mtow', {
	        url: '/mtow',
	        templateUrl: 'app/partials/mtow/mtow.html',
	        controller: 'MtowController',
	        title: 'MTOW Factor Management'
	    })
	        .state('main.invoice-template-management', {
	        url: '/invoice-template-management',
	        templateUrl: 'app/partials/invoice-template-management/invoice-template-management.html',
	        controller: 'InvoiceTemplateManagementController',
	        title: 'Invoice Template Management'
	    })
	        .state('main.report-templates', {
	        url: '/report-templates',
	        templateUrl: 'app/partials/report-templates/report-templates.html',
	        controller: 'ReportTemplatesController',
	        title: 'Report Templates'
	    })
	        .state('main.unspecified-locations', {
	        url: '/unspecified-locations',
	        templateUrl: 'app/partials/unspecified-dep-dest-locations/unspecified-dep-dest-locations.html',
	        controller: 'UnspecifiedDepDestLocationsController',
	        title: 'Unspecified Departure and Destination Locations'
	    })
	        .state('main.aircraft-unspecified-management', {
	        url: '/aircraft-unspecified-management',
	        templateUrl: 'app/partials/aircraft-unspecified-management/aircraft-unspecified-management.html',
	        controller: 'AircraftUnspecifiedManagementController',
	        title: 'Unspecified Aircraft'
	    })
	        .state('main.about', {
	        url: '/about',
	        templateUrl: 'app/partials/about/about.html',
	        controller: 'AboutController',
	        title: 'About'
	    })
	        .state('main.help', {
	        url: '/help',
	        templateUrl: 'app/partials/help/help.html',
	        controller: 'HelpController',
	        title: 'Help'
	    })
	        .state('main.radar-summary', {
	        url: '/radar-summary',
	        templateUrl: 'app/partials/radar-summary/radar-summary.html',
	        controller: 'RadarSummaryController',
	        title: 'Radar Summary'
	    })
	        .state('main.flight-route-exemptions', {
	        url: '/flight-route-exemptions',
	        templateUrl: 'app/partials/flight-route-exemptions/flight-route-exemptions.html',
	        controller: 'FlightRouteExemptionsController',
	        title: 'Exempt Flight Route Management'
	    })
	        .state('main.flight-status-exemptions', {
	        url: '/flight-status-exemptions',
	        templateUrl: 'app/partials/flight-status-exemptions/flight-status-exemptions.html',
	        controller: 'FlightStatusExemptionsController',
	        title: 'Exempt Flight Status Management'
	    })
	        .state('main.billing-centre-management', {
	        url: '/billing-centre-management',
	        templateUrl: 'app/partials/billing-centre-management/billing-centre-management.html',
	        controller: 'BillingCentreManagementController',
	        title: 'Billing Centre Management'
	    })
	        .state('main.nominal-routes', {
	        url: '/nominal-routes',
	        templateUrl: 'app/partials/nominal-routes/nominal-routes.html',
	        controller: 'NominalRoutesController',
	        title: 'Nominal Routes'
	    })
	        .state('main.atc-movement-log', {
	        url: '/atc-movement-log',
	        templateUrl: 'app/partials/atc-movement-log/atc-movement-log.html',
	        controller: 'AtcMovementLogController',
	        title: 'ATC Movement Logs'
	    })
	        .state('main.tower-movement-logs', {
	        url: '/tower-movement-logs',
	        templateUrl: 'app/partials/tower-movement-logs/tower-movement-logs.html',
	        controller: 'TowerMovementLogsController',
	        title: 'Tower Movement Logs'
	    })
	        .state('main.user-event-log', {
	        url: '/user-event-log',
	        templateUrl: 'app/partials/user-event-log/user-event-log.html',
	        controller: 'UserEventLogController',
	        title: 'User Event Log'
	    })
	        .state('main.rejected-items', {
	        url: '/rejected-items',
	        templateUrl: 'app/partials/rejected-items/rejected-items.html',
	        controller: 'RejectedItemsController',
	        title: 'Rejected Items'
	    })
	        .state('main.recurring-charges', {
	        url: '/recurring-charges',
	        templateUrl: 'app/partials/recurring-charges/recurring-charges.html',
	        controller: 'RecurringChargesController',
	        title: 'Recurring Charges'
	    })
	        .state('main.report-generation', {
	        url: '/report-generation',
	        templateUrl: 'app/partials/report-generation/report-generation.html',
	        controller: 'ReportGenerationController',
	        title: 'Report Generation'
	    })
	        .state('main.revenue-projection', {
	        url: '/revenue-projection',
	        templateUrl: 'app/partials/revenue-projection/revenue-projection.html',
	        controller: 'RevenueProjectionController',
	        title: 'Revenue Projection'
	    })
	        .state('main.air-traffic-data', {
	        url: '/air-traffic-data',
	        templateUrl: 'app/partials/air-traffic-data/air-traffic-data.html',
	        controller: 'AirTrafficDataController',
	        title: 'Data Analysis and Statistics - Air Traffic'
	    })
	        .state('main.revenue-data', {
	        url: '/revenue-data',
	        templateUrl: 'app/partials/revenue-data/revenue-data.html',
	        controller: 'RevenueDataController',
	        title: 'Data Analysis and Statistics - Revenue'
	    })
	        .state('main.repositioning-aerodrome-clusters', {
	        url: '/repositioning-aerodrome-clusters',
	        templateUrl: 'app/partials/repositioning-aerodrome-clusters/repositioning-aerodrome-clusters.html',
	        controller: 'RepositioningAerodromeClustersController',
	        title: 'Repositioning Aerodrome Clusters'
	    })
	        .state('main.flight-schedule-management', {
	        url: '/flight-schedule-management',
	        templateUrl: 'app/partials/flight-schedule-management/flight-schedule-management.html',
	        controller: 'FlightScheduleManagementController',
	        title: 'Flight Schedule Management'
	    })
	        .state('main.flight-reassignment', {
	        url: '/flight-reassignment',
	        templateUrl: 'app/partials/flight-reassignment/flight-reassignment.html',
	        controller: 'FlightReassignmentScopeController',
	        title: 'Flight Reassignment'
	    })
	        .state('main.welcome-page', {
	        url: '/welcome-page',
	        templateUrl: 'app/partials/welcome-page/welcome-page.html',
	        title: 'Welcome to ARMS'
	    })
	        .state('main.local-aircraft-registry', {
	        url: '/local-aircraft-registry',
	        templateUrl: 'app/partials/local-aircraft-registry/local-aircraft-registry.html',
	        controller: 'LocalAircraftRegistryController',
	        title: 'Local Aircraft Registry'
	    })
	        .state('main.cached-events', {
	        url: '/cached-events',
	        templateUrl: 'app/partials/cached-events/cached-events.html',
	        controller: 'CachedEventsController',
	        title: 'Cached Events'
	    })
	        .state('main.plugins', {
	        url: '/plugins/:hidden',
	        templateUrl: 'app/partials/plugins/plugins.html',
	        controller: 'PluginsController',
	        title: 'Plugins',
	        params: {
	            hidden: { squash: true, value: null }
	        }
	    })
	        .state('main.passenger-revenue-reconciliation', {
	        url: '/passenger-revenue-reconciliation',
	        templateUrl: 'app/partials/passenger-revenue-reconciliation/passenger-revenue-reconciliation.html',
	        controller: 'PassengerRevenueReconciliationController',
	        title: 'Passenger Revenue Reconciliation'
	    })
	        .state('main.sc-home-page', {
	        url: '/sc-home-page',
	        templateUrl: 'app/partials/sc-home-page/sc-home-page.html',
	        controller: 'ScHomePageController',
	        title: 'Home Page'
	    })
	        .state('main.sc-login', {
	        url: '/sc-login',
	        templateUrl: 'app/partials/sc-login/sc-login.html',
	        controller: 'ScLoginController',
	        title: 'Login'
	    })
	        .state('main.sc-query-submission', {
	        url: '/sc-query-submission',
	        templateUrl: 'app/partials/sc-query-submission/sc-query-submission.html',
	        controller: 'ScQuerySubmissionController',
	        title: 'Query Submission'
	    })
	        .state('main.sc-user-registration', {
	        url: '/sc-user-registration',
	        templateUrl: 'app/partials/sc-user-registration/sc-user-registration.html',
	        controller: 'ScUserRegistrationController',
	        title: 'User Registration'
	    })
	        .state('main.sc-user-registration-activate', {
	        url: '/sc-user-registration-activate',
	        templateUrl: 'app/partials/sc-user-registration/sc-user-registration-activate.html',
	        controller: 'ScUserRegistrationController',
	        title: 'Activating User Registration'
	    })
	        .state('main.sc-flight-cost-calculation', {
	        url: '/sc-flight-cost-calculation',
	        templateUrl: 'app/partials/sc-flight-cost-calculation/sc-flight-cost-calculation.html',
	        controller: 'ScFlightCostCalculationController',
	        title: 'Flight Cost Calculation'
	    })
	        .state('main.sc-user-management', {
	        url: '/sc-user-management',
	        templateUrl: 'app/partials/sc-user-management/sc-user-management.html',
	        controller: 'ScUserManagementController',
	        title: 'User Management'
	    })
	        .state('main.sc-account-management', {
	        url: '/sc-account-management',
	        templateUrl: 'app/partials/sc-account-management/sc-account-management.html',
	        controller: 'ScAccountManagementController',
	        title: 'Account Management'
	    })
	        .state('main.sc-flight-schedules', {
	        url: '/sc-flight-schedules',
	        templateUrl: 'app/partials/sc-flight-schedules/sc-flight-schedules.html',
	        controller: 'ScFlightSchedulesController',
	        title: 'Flight Schedules'
	    })
	        .state('main.sc-transactions', {
	        url: '/sc-transactions',
	        templateUrl: 'app/partials/sc-transactions/sc-transactions.html',
	        controller: 'ScTransactionsController',
	        title: 'Transactions'
	    })
	        .state('main.sc-invoices', {
	        url: '/sc-invoices',
	        templateUrl: 'app/partials/sc-invoices/sc-invoices.html',
	        controller: 'ScInvoicesController',
	        title: 'Invoices'
	    })
	        .state('main.sc-aircraft-registration', {
	        url: '/sc-aircraft-registration',
	        templateUrl: 'app/partials/sc-aircraft-registration/sc-aircraft-registration.html',
	        controller: 'ScAircraftRegistrationController',
	        title: 'Aircraft Registration'
	    })
	        .state('main.sc-flight-search', {
	        url: '/sc-flight-search',
	        templateUrl: 'app/partials/sc-flight-search/sc-flight-search.html',
	        controller: 'ScFlightSearchController',
	        title: 'Flight Search'
	    })
	        .state('main.sc-passenger-service-charge-return', {
	        url: '/sc-passenger-service-charge-return',
	        templateUrl: 'app/partials/sc-passenger-service-charge-return/sc-passenger-service-charge-return.html',
	        controller: 'ScPassengerServiceChargeReturnController',
	        title: 'Passenger Service Charge Return Management'
	    })
	        .state('main.sc-credit-payment', {
	        url: '/sc-credit-payment',
	        templateUrl: 'app/partials/sc-credit-payment/sc-credit-payment.html',
	        controller: 'ScCreditPaymentController',
	        title: 'Credit Payment'
	    })
	        .state('main.sc-report-generation', {
	        url: '/sc-report-generation',
	        templateUrl: 'app/partials/sc-report-generation/sc-report-generation.html',
	        controller: 'ScReportGenerationController',
	        title: 'Report Generation'
	    })
	        .state('main.current-user', {
	        url: '/current-user',
	        templateUrl: 'app/partials/current-user/current-user.html',
	        controller: 'CurrentUserController',
	        title: 'Current User'
	    })
	        .state('main.password-change', {
	        url: '/password-change',
	        templateUrl: 'app/partials/password-change/password-change.html',
	        controller: 'PasswordChangeController',
	        title: 'Password Change'
	    })
	        .state('main.aircraft-flights-exemptions', {
	        url: '/aircraft-flights-exemptions',
	        templateUrl: 'app/partials/aircraft-flights-exemptions/aircraft-flights-exemptions.html',
	        controller: 'AircraftFlightsExemptionsController',
	        title: 'Exempt Aircraft and Flights'
	    })
	        .state('main.sc-approval-request', {
	        url: '/sc-approval-request',
	        templateUrl: 'app/partials/sc-approval-request/sc-approval-request.html',
	        controller: 'ScApprovalRequestController',
	        title: 'Approval Request'
	    })
	        .state('main.service-outages', {
	        url: '/service-outages',
	        templateUrl: 'app/partials/service-outages/service-outages.html',
	        controller: 'ServiceOutagesController',
	        title: 'Service Outages'
	    })
	        .state('main.bank-account-management', {
	        url: '/bank-account-management',
	        templateUrl: 'app/partials/bank-account-management/bank-account-management.html',
	        controller: 'BankAccountManagementController',
	        title: 'Bank Account Management'
	    })
	        .state('main.interest-rates', {
	        url: '/interest-rates',
	        templateUrl: 'app/partials/interest-rates/interest-rates.html',
	        controller: 'InterestRatesController',
	        title: 'Interest Rates'
	    })
	        .state('main.amhs-connection', {
	        url: '/amhs-connection',
	        templateUrl: 'app/partials/amhs-connection/amhs-connection.html',
	        controller: 'AMHSConnectionController',
	        title: 'AMHS Connection'
	    })
	        .state('main.amhs-accounts', {
	        url: '/amhs-accounts',
	        templateUrl: 'app/partials/amhs-accounts/amhs-accounts.html',
	        controller: 'AMHSAccountsController',
	        title: 'AMHS Accounts'
	    })
	        .state('main.aerodrome-operational-hours', {
	        url: '/aerodrome-operational-hours',
	        templateUrl: 'app/partials/aerodrome-operational-hours/aerodrome-operational-hours.html',
	        controller: 'AerodromeOperationalHoursController',
	        title: 'Aerodrome Operational Hours'
	    })
	        .state('main.sc-inactivity-expiry-notice', {
	        url: '/sc-inactivity-expiry-notice',
	        templateUrl: 'app/partials/sc-inactivity-expiry-notice/sc-inactivity-expiry-notice.html',
	        controller: 'ScInactivityExpiryNoticeController',
	        title: 'Inactivity and Expiry Notices'
	    })
	        .state('main.aodb', {
	        url: '/aodb',
	        templateUrl: 'app/partials/aodb/aodb.html',
	        controller: 'AodbController',
	        title: 'Aodb Flights'
	    });
	    $urlRouterProvider.otherwise('/login');
	    // use the HTML5 History API
	    $locationProvider.html5Mode({
	        enabled: false,
	        requireBase: false
	    });
	}
	exports.RouterConfig = RouterConfig;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Override functionality from angular-translate.
	 */
	TranslateConfig.$inject = ["$translateProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	// service, cannot be injected
	var config_service_1 = __webpack_require__(216);
	/** @ngInject */
	function TranslateConfig($translateProvider) {
	    var cfg = new config_service_1.ConfigService();
	    var host = cfg.get('API_HOST');
	    $translateProvider.useSanitizeValueStrategy(null);
	    $translateProvider.fallbackLanguage('en');
	    $translateProvider.useUrlLoader(host + "/api/languages/json");
	}
	exports.TranslateConfig = TranslateConfig;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	LocaleInterceptor.$inject = ["$httpProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	var config_service_1 = __webpack_require__(216);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	/** @ngInject */
	function LocaleInterceptor($httpProvider) {
	    $httpProvider.interceptors.push(LocaleInHeader);
	}
	exports.LocaleInterceptor = LocaleInterceptor;
	function LocaleInHeader() {
	    return {
	        request: function (config) {
	            var configService = new config_service_1.ConfigService();
	            var apiHost = configService.get('API_HOST');
	            var localStorageLocale = localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_SELECTION);
	            // interceptor should only be applied on requests to ABMS API
	            // fall back to browser if locale is not set in local storage
	            if (!config.url.startsWith(apiHost) || !localStorageLocale) {
	                return config;
	            }
	            // set accept-language code to use on the backend
	            config.headers['Accept-Language'] = localStorageLocale.code;
	            return config;
	        }
	    };
	}


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Override functionality from uib-pagination.
	 */
	PaginationConfig.$inject = ["uibPaginationConfig"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function PaginationConfig(uibPaginationConfig) {
	    uibPaginationConfig.previousText = '<';
	    uibPaginationConfig.nextText = '>';
	    uibPaginationConfig.firstText = '<<';
	    uibPaginationConfig.lastText = '>>';
	}
	exports.PaginationConfig = PaginationConfig;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Override functionality from angular-recaptcha.
	 * https://github.com/VividCortex/angular-recaptcha#service-provider
	 */
	RecaptchaConfig.$inject = ["vcRecaptchaServiceProvider"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function RecaptchaConfig(vcRecaptchaServiceProvider) {
	    // default to an invalid key placeholder so that a warning is displayed to the user.
	    // if key is undefined, null, or blank, it only logs a console error.
	    vcRecaptchaServiceProvider.setSiteKey('INVALID_PUBLIC_KEY');
	}
	exports.RecaptchaConfig = RecaptchaConfig;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 *
	 * MultiselectDecorator is used to override functionality found within the angularjs-dropdown-multiselect package.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var ITEMS_TO_DISPLAY = 5;
	var createButtonText = function ($scope) {
	    // return placeholder if none selected or options is empty
	    if (!$scope.options || !$scope.selectedModel.length) {
	        return $scope.texts.buttonDefaultText;
	    }
	    var selectedItems = $scope.options.filter(function (option) {
	        // selectedModel contains selected options
	        return $scope.selectedModel.map(function (selectedItem) { return selectedItem.id; }).includes(option.id);
	    });
	    var selectedItemsText = selectedItems.slice(0, ITEMS_TO_DISPLAY).map(function (selectedItem) {
	        return $scope.extraSettings ? selectedItem[$scope.extraSettings.displayProp] : selectedItem.label;
	    });
	    // add ellipsis if more than ITEMS_TO_DISPLAY selected
	    var buttonText = $scope.selectedModel.length > ITEMS_TO_DISPLAY
	        ? selectedItemsText.concat(['...']) : selectedItemsText;
	    return buttonText.join(', ');
	};
	var updateLabelText = function (translate) {
	    return {
	        buttonDefaultText: translate.instant('Select'),
	        checkAll: translate.instant('Check All'),
	        uncheckAll: translate.instant('Uncheck All'),
	        searchPlaceholder: translate.instant('Search') + "..."
	    };
	};
	/** @ngInject */
	exports.MultiselectDecorator = function ($provide) {
	    $provide.decorator('ngDropdownMultiselectDirective', ["$delegate", "$translate", "$rootScope", function ($delegate, $translate, $rootScope) {
	        var directive = $delegate[0];
	        var link = directive.link;
	        directive.compile = function () {
	            return function ($scope, element, attrs) {
	                link.apply(this, arguments);
	                $translate.onReady(function () { return $scope.texts = updateLabelText($translate); });
	                $rootScope.$on('$translateChangeEnd', function () { return $scope.texts = updateLabelText($translate); });
	                // override function provided by package for displaying selected items
	                $scope.getButtonText = function () { return createButtonText($scope); };
	            };
	        };
	        return $delegate;
	    }]);
	};
	exports.MultiselectDecorator.$inject = ["$provide"];


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	exports.ProgressBarDecorator = function ($provide) {
	    $provide.decorator('cfpLoadingBar', ["$delegate", "$timeout", "$rootScope", function ($delegate, $timeout, $rootScope) {
	        /**
	         *
	         * We use 30 minutes as a base case to handle long requests.
	         * 30 mins = 1800 seconds = 0.00054/s to reach 0.98
	         *
	         */
	        var ONE_SECOND_PROGRESS = 0.00054;
	        var incTimeout;
	        var set;
	        var inc = function () {
	            var currentStatus = $delegate.status();
	            // skip if finished or not started
	            if (currentStatus >= 1 || currentStatus <= 0) {
	                return;
	            }
	            // prevent increment after 98% percent
	            var amountToInc = currentStatus <= 0.98 ? currentStatus + ONE_SECOND_PROGRESS : 0;
	            set(amountToInc);
	        };
	        // use the set function found in cfpLoadingBar but call our own inc function
	        var packageSet = $delegate.set;
	        set = function (n) {
	            packageSet.apply(this, arguments);
	            $timeout.cancel(incTimeout);
	            incTimeout = $timeout(function () {
	                inc();
	            }, 1000);
	        };
	        // set loading bar to complete before state change
	        $rootScope.$on('$stateChangeStart', function () { return $delegate.complete(); });
	        $delegate.set = set;
	        // return augmented cfpLoadingBar
	        return $delegate;
	    }]);
	};
	exports.ProgressBarDecorator.$inject = ["$provide"];


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var updateLabelText = function (scope, translate) {
	    scope.closeText = translate.instant('Close');
	    scope.currentText = translate.instant('Today');
	    scope.clearText = translate.instant('Clear');
	};
	/** @ngInject */
	exports.DatePickerDecorator = function ($provide) {
	    $provide.decorator('uibDatepickerPopupDirective', ["$delegate", "$translate", "$rootScope", function ($delegate, $translate, $rootScope) {
	        var directive = $delegate[0];
	        var link = directive.link;
	        directive.compile = function () {
	            return function ($scope, element, attrs) {
	                link.apply(this, arguments);
	                $translate.onReady(function () { return updateLabelText($scope, $translate); });
	                $rootScope.$on('$translateChangeEnd', function () { return updateLabelText($scope, $translate); });
	            };
	        };
	        return $delegate;
	    }]);
	};
	exports.DatePickerDecorator.$inject = ["$provide"];


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var localStorage_service_1 = __webpack_require__(9);
	var helpers_service_1 = __webpack_require__(19);
	// constants
	var system_configuration_constants_1 = __webpack_require__(10);
	var updateCalendar = function (translate, delegate, valueToJSON) {
	    // override $locale.DATETIME_FORMATS
	    var value = delegate.DATETIME_FORMATS;
	    var day = valueToJSON(translate.instant('DP_DAY'));
	    var shortDay = valueToJSON(translate.instant('DP_SHORTDAY'));
	    var month = valueToJSON(translate.instant('DP_MONTH'));
	    var shortMonth = valueToJSON(translate.instant('DP_SHORTMONTH'));
	    if (day) {
	        value.DAY = day;
	    }
	    ;
	    if (shortDay) {
	        value.SHORTDAY = shortDay;
	    }
	    ;
	    if (month) {
	        value.MONTH = month;
	    }
	    ;
	    if (shortMonth) {
	        value.SHORTMONTH = shortMonth;
	    }
	    ;
	};
	/** @ngInject */
	exports.LocaleDecorator = function ($provide) {
	    // only decorate if language support is enabled
	    if (localStorage_service_1.LocalStorageService.get("SystemConfiguration:" + system_configuration_constants_1.SysConfigConstants.LANGUAGE_ENABLED) === system_configuration_constants_1.SysConfigConstants.SYSTEM_CONFIG_TRUE) {
	        $provide.decorator('$locale', ["$delegate", "$translate", "$rootScope", function ($delegate, $translate, $rootScope) {
	            $translate.onReady(function () { return updateCalendar($translate, $delegate, helpers_service_1.HelperService.valueToJSON); });
	            $rootScope.$on('$translateChangeEnd', function () { return updateCalendar($translate, $delegate, helpers_service_1.HelperService.valueToJSON); });
	            return $delegate;
	        }]);
	    }
	};
	exports.LocaleDecorator.$inject = ["$provide"];


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var input_constants_1 = __webpack_require__(5);
	/**
	 * InputDecorator is used to extend functions found on the input directive.
	 * Functions are extended to give more control and functionality for displaying errors
	 */
	// apply class to corresponding label
	var setLabelError = function (element) {
	    var labels = element.labels || [];
	    for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
	        var label = labels_1[_i];
	        var classList = label.classList;
	        // check if label has already been updated
	        if (!classList.contains(input_constants_1.DISPLAY.LABEL_CLASS)) {
	            classList.add(input_constants_1.DISPLAY.LABEL_CLASS);
	        }
	    }
	};
	// remove all corresponding labels
	var clearLabelError = function (element) {
	    var labels = element.labels || [];
	    for (var _i = 0, labels_2 = labels; _i < labels_2.length; _i++) {
	        var label = labels_2[_i];
	        label.classList.remove(input_constants_1.DISPLAY.LABEL_CLASS);
	    }
	};
	// add error icon to input with error
	var setErrorIcon = function (element) {
	    var nextSibling = element.nextElementSibling;
	    // check if icon has already been created
	    if (nextSibling && nextSibling.className.includes(input_constants_1.DISPLAY.INPUT_CLASS)) {
	        return;
	    }
	    // create icon, set class, and append to input
	    var error = document.createElement('span');
	    error.setAttribute('class', input_constants_1.DISPLAY.INPUT_CLASS + ' ' + input_constants_1.DISPLAY.ICON_CLASS);
	    element.parentNode.insertBefore(error, nextSibling);
	};
	// remove error icon from input
	var clearErrorIcon = function (element) {
	    var nextSibling = element.nextElementSibling;
	    if (nextSibling && nextSibling.className.includes(input_constants_1.DISPLAY.INPUT_CLASS)) {
	        nextSibling.remove();
	    }
	};
	// display form errors in red box used for API errors
	var setFormErrors = function ($scope, ctrlTarget, element) {
	    // find appropriate scope with form value
	    var errorTarget = $scope.form
	        ? $scope
	        : $scope.$parent;
	    // return if no target scope with a form was found
	    if (!errorTarget) {
	        return;
	    }
	    // get error message for field, combine all that apply
	    var message = null;
	    for (var _i = 0, _a = Object.keys(ctrlTarget.$error); _i < _a.length; _i++) {
	        var key = _a[_i];
	        // skip messages that are not found
	        if (!input_constants_1.MESSAGES[key]) {
	            continue;
	        }
	        // add message onto existing message with space and periods
	        message = message === null ? '' : message + ' ';
	        message += input_constants_1.MESSAGES[key] + '.';
	    }
	    // return if no message to set
	    if (message === null) {
	        return;
	    }
	    // get all labels and name for the element
	    var labels = element.labels || [];
	    var name = ctrlTarget.$name;
	    // get field text for readability and translation
	    var field = labels && labels[0] && labels[0].textContent
	        ? labels[0].textContent.replace('*', '').trim()
	        : name;
	    // make sure necessary error objects exist
	    errorTarget.error = errorTarget.error || {};
	    errorTarget.error.error = errorTarget.error.error || {};
	    errorTarget.error.error.data = errorTarget.error.error.data || {};
	    errorTarget.error.error.data.form_errors = errorTarget.error.error.data.form_errors || [];
	    // prevent duplicate errors, only update message and field if exists
	    var formErrors = errorTarget.error.error.data.form_errors;
	    var fieldError = formErrors.find(function (error) { return error.name === name; });
	    if (fieldError) {
	        fieldError.field = field;
	        fieldError.message = message;
	    }
	    else {
	        formErrors.push({ field: field, message: message, name: name });
	    }
	};
	var clearFormErrors = function ($scope, ctrlTarget) {
	    var errorTarget = $scope.form
	        ? $scope
	        : $scope.$parent;
	    // ensure the an error exists
	    if (!(errorTarget
	        && errorTarget.error
	        && errorTarget.error.error
	        && errorTarget.error.error.data
	        && errorTarget.error.error.data.form_errors)) {
	        return;
	    }
	    var formErrors = errorTarget.error.error.data.form_errors;
	    // return form errors sans valid input
	    errorTarget.error.error.data.form_errors = formErrors.filter(function (error) { return error.name !== ctrlTarget.$name; });
	};
	var clearAllErrors = function ($scope, elementTarget) {
	    $scope.error = null;
	    $scope.$parent.error = null;
	    clearLabelError(elementTarget);
	    clearErrorIcon(elementTarget);
	};
	var handleErrorDisplay = function ($scope, ctrlTarget, elementTarget) {
	    var $invalid = ctrlTarget.$invalid, $valid = ctrlTarget.$valid, $dirty = ctrlTarget.$dirty, $touched = ctrlTarget.$touched, $$parentForm = ctrlTarget.$$parentForm;
	    // required fields are not valid -- check for touched
	    var invalidAndDirtyAndTouched = $invalid && $dirty && $touched;
	    // date range inputs react to other in pair -- check for dirty and NOT valid
	    var dirtyAndDateRange = ($$parentForm.$name === input_constants_1.DISPLAY.DATE_RANGE_FORM && ($dirty && !$valid));
	    if (invalidAndDirtyAndTouched || dirtyAndDateRange) {
	        setLabelError(elementTarget);
	        setErrorIcon(elementTarget);
	        // don't show box for date range
	        if (!dirtyAndDateRange) {
	            setFormErrors($scope, ctrlTarget, elementTarget);
	        }
	    }
	    else {
	        clearLabelError(elementTarget);
	        clearErrorIcon(elementTarget);
	        clearFormErrors($scope, ctrlTarget);
	    }
	};
	/** @ngInject */
	exports.InputDecorator = function ($provide) {
	    $provide.decorator('inputDirective', ["$delegate", function ($delegate) {
	        var directive = $delegate[1];
	        var link = directive.link;
	        directive.compile = function () {
	            return function ($scope, element, attrs, ctrl) {
	                link.apply(this, arguments);
	                var ctrlTarget = ctrl;
	                var elementTarget = element[0];
	                // exit if control is not accessible
	                if (!ctrlTarget) {
	                    return;
	                }
	                var setValidity = ctrlTarget.$setValidity;
	                var setUntouched = ctrlTarget.$setUntouched;
	                var setTouched = ctrlTarget.$setTouched;
	                ctrlTarget.$setValidity = function () {
	                    setValidity.apply(this, arguments);
	                    handleErrorDisplay($scope, ctrlTarget, elementTarget);
	                };
	                ctrlTarget.$setTouched = function () {
	                    setTouched.apply(this, arguments);
	                    handleErrorDisplay($scope, ctrlTarget, elementTarget);
	                };
	                ctrlTarget.$setUntouched = function () {
	                    setUntouched.apply(this, arguments);
	                    clearAllErrors($scope, elementTarget);
	                };
	                ctrlTarget.$setManualError = function () {
	                    ctrlTarget.$setDirty();
	                    ctrlTarget.$setTouched();
	                };
	            };
	        };
	        return $delegate;
	    }]);
	};
	exports.InputDecorator.$inject = ["$provide"];


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// runners
	var oauth_run_1 = __webpack_require__(336);
	var translate_run_1 = __webpack_require__(235);
	var server_datetime_run_1 = __webpack_require__(337);
	var recaptcha_run_1 = __webpack_require__(338);
	// run module
	exports.default = angular.module('armsWeb.run', [])
	    .run(oauth_run_1.OAuthRun)
	    .run(translate_run_1.TranslateRun)
	    .run(server_datetime_run_1.ServerDateTimeRun)
	    .run(recaptcha_run_1.RecaptchaRun);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	OAuthRun.$inject = ["$location", "$rootScope", "Restangular", "configService", "oAuthService", "userEventLogService", "$timeout", "$window"];
	Object.defineProperty(exports, "__esModule", { value: true });
	var localStorage_service_1 = __webpack_require__(9);
	/** @ngInject */
	function OAuthRun($location, $rootScope, Restangular, configService, oAuthService, userEventLogService, $timeout, $window) {
	    // todo the oauth stuff below should be cleaned up and done better
	    // https://github.com/witoldsz/angular-http-auth
	    // currently it checks the oauth token timestamp when it was initialized and determines if should refresh
	    // issue is that multiple calls can be made at once which some may be authorized and unauthorized (forcing a logout)
	    var baseURL = configService.get('API_HOST') || '';
	    var oauth = localStorage_service_1.LocalStorageService.get('oauth');
	    Restangular.setBaseUrl(baseURL + "/api");
	    Restangular.setDefaultHeaders({ 'Content-Type': 'application/json' });
	    Restangular.setRequestInterceptor(function (data, operation, identifier) {
	        $timeout(function () { if (operation === 'remove') {
	            userEventLogService.createEvent(data, operation, identifier, $rootScope.oldFormData);
	        } });
	        return data;
	    });
	    Restangular.addResponseInterceptor(function (data, operation, identifier, what) {
	        $timeout(function () { if (operation !== 'remove') {
	            userEventLogService.createEvent(data, operation, identifier, $rootScope.oldFormData);
	        } });
	        return data;
	    });
	    if (oauth !== null) {
	        oAuthService.oauth = oauth; // user has oauth token
	        if (oAuthService.shouldRefreshToken()) {
	            oAuthService.refresh(oauth.refresh_token); // error has occurred when attempting to refresh token, we force a logout
	        }
	    }
	    if ($location.path().startsWith('/sc-') || $window.location.pathname.endsWith('/selfcare/')) {
	        if ($location.path() === '/sc-user-registration-activate') {
	            $location.path('sc-user-registration-activate');
	        }
	        Restangular.setErrorInterceptor(function (response) {
	            console.error('Set Error Interceptor: ', response);
	            if (response.status === 401 || response.status === 403) {
	                if (JSON.parse(window.localStorage.getItem('forcePasswordChange'))) {
	                    $location.path('/main.password-change');
	                }
	                else if (($location.path().startsWith('/sc-') || $window.location.pathname.endsWith('/selfcare/'))
	                    && ($location.path() === '/sc-user-registration-activate')) {
	                    $location.path('sc-user-registration-activate');
	                }
	                else if (oAuthService.oauth) {
	                    oAuthService.logout();
	                }
	            }
	        });
	    }
	}
	exports.OAuthRun = OAuthRun;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	"use strict";
	ServerDateTimeRun.$inject = ["serverDatetimeService"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function ServerDateTimeRun(serverDatetimeService) {
	    serverDatetimeService.initialize('util/current-datetime', 600000);
	}
	exports.ServerDateTimeRun = ServerDateTimeRun;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	"use strict";
	RecaptchaRun.$inject = ["recaptchaService"];
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @ngInject */
	function RecaptchaRun(recaptchaService) {
	    // on initial run, retreive recaptcha public key from api if avaialble
	    recaptchaService.updatePublishKey('util/recaptcha-public-key');
	}
	exports.RecaptchaRun = RecaptchaRun;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var caab_module_1 = __webpack_require__(340);
	// plugin module
	exports.default = angular.module('armsWeb.plugins', [
	    caab_module_1.default.name
	]);


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var sage_module_1 = __webpack_require__(341);
	// caab plugin module
	exports.default = angular.module('armsWeb.plugins.caab', [
	    sage_module_1.default.name
	]);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var sage_services_1 = __webpack_require__(342);
	// caab sage plugins module
	exports.default = angular.module('armsWeb.plugins.caab.sage', [
	    sage_services_1.default.name
	]);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var charge_adjustments_caab_sage_service_1 = __webpack_require__(343);
	// service module
	exports.default = angular.module('armsWeb.plugins.caab.sage.services', [])
	    .service('caabSageChargeAdjustmentsService', charge_adjustments_caab_sage_service_1.CaabSageChargeAdjustmentsService);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// services
	var charge_adjustments_service_1 = __webpack_require__(104);
	var system_configuration_caab_sage_contants_1 = __webpack_require__(344);
	var flight_types_service_1 = __webpack_require__(75);
	var CaabSageChargeAdjustmentsService = (function () {
	    /** @ngInject */
	    CaabSageChargeAdjustmentsService.$inject = ["systemConfigurationService"];
	    function CaabSageChargeAdjustmentsService(systemConfigurationService) {
	        this.systemConfigurationService = systemConfigurationService;
	    }
	    /**
	     * CAAB organization specific logic for resolving flight adjustment external properties.
	     *
	     * @param charge charge adjustment details
	     * @param flight flight movement being adjusted
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolveFlightAdjustementExternal = function (charge, flight, invoiceType) {
	        // set external accounting system identifier by charge and flight
	        charge.external_accounting_system_identifier = this.getExternalAccountingSystemIdentifier(charge, flight);
	        // set exgternal charge category name by ivnoice type
	        charge.external_charge_category_name = this.getExternalChargeCategoryName(invoiceType);
	    };
	    /**
	     * Get external account system identifier (charge code) by charge adjustment descriptiong
	     * and flight movement type from system configuration settings.
	     *
	     * @param charge charge adjustment details
	     * @param flight flight movement being adjusted
	     */
	    CaabSageChargeAdjustmentsService.prototype.getExternalAccountingSystemIdentifier = function (charge, flight) {
	        var isScheduled = flight.flight_type && flight.flight_type.toUpperCase() === 'S';
	        var isDomestic = flight.movement_type === flight_types_service_1.FlightType.DOMESTIC;
	        var chargeCode;
	        switch (charge.charge_description) {
	            case charge_adjustments_service_1.ChargesAdjustmentType.ENROUTE_CHARGES:
	                chargeCode = this.resolveEnrouteCharges(isScheduled);
	                break;
	            case charge_adjustments_service_1.ChargesAdjustmentType.LANDING_CHARGES:
	                chargeCode = this.resolveLandingCharges(isScheduled, isDomestic);
	                break;
	            case charge_adjustments_service_1.ChargesAdjustmentType.PARKING_CHARGES:
	                chargeCode = this.resolveParkingCharges();
	                break;
	            case charge_adjustments_service_1.ChargesAdjustmentType.PASSENGER_CHARGES:
	                // assumed domestic passenger charges being adjusted
	                chargeCode = this.resolvePassengerCharges(true);
	                break;
	            default:
	                chargeCode = this.resolveEnrouteCharges(isScheduled);
	        }
	        return chargeCode;
	    };
	    /**
	     * Return external charge category name based on the invoice type.
	     *
	     * @param invoiceType invoice adjusted type
	     */
	    CaabSageChargeAdjustmentsService.prototype.getExternalChargeCategoryName = function (invoiceType) {
	        return invoiceType === 'aviation-iata'
	            ? CaabSageChargeAdjustmentsService.IATA_EXTERNAL_CHARGE_CATEGORY
	            : CaabSageChargeAdjustmentsService.ENROUTE_EXTERNAL_CHARGE_CATEGORY;
	    };
	    /**
	     * Resolve domestic landing charge code by system configuration setting.
	     *
	     * @param isScheduled true if flight type scheduled ('S')
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolveDomesticLandingCharges = function (isScheduled) {
	        var config = isScheduled
	            ? system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.DOMESTIC_LANDING_CHARGES_SCHEDULED_CODE
	            : system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.DOMESTIC_LANDING_CHARGES_NON_SCHEDULED_CODE;
	        return this.systemConfigurationService.getValueByName(config);
	    };
	    /**
	     * Resolve enroute charge code by system configuration setting.
	     *
	     * @param isScheduled true if flight type scheduled ('S')
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolveEnrouteCharges = function (isScheduled) {
	        var config = isScheduled
	            ? system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.ENROUTE_NAVIGATION_CHARGES_SCHEDULED_CODE
	            : system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.ENROUTE_NAVIGATION_CHARGES_NON_SCHEDULED_CODE;
	        return this.systemConfigurationService.getValueByName(config);
	    };
	    /**
	     * Resolve international landing charge code by system configuration setting.
	     *
	     * @param isScheduled true if flight type scheduled ('S')
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolveInternationalLandingCharges = function (isScheduled) {
	        var config = isScheduled
	            ? system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.INTERNATIONAL_LANDING_CHARGES_SCHEDULED_CODE
	            : system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.INTERNATIONAL_LANDING_CHARGES_NON_SCHEDULED_CODE;
	        return this.systemConfigurationService.getValueByName(config);
	    };
	    /**
	     * Resolve landing charge code by system configuration setting.
	     *
	     * @param isScheduled true if flight type scheduled ('S')
	     * @param isDomestic true if domestic landing charge
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolveLandingCharges = function (isScheduled, isDomestic) {
	        return isDomestic
	            ? this.resolveDomesticLandingCharges(isScheduled)
	            : this.resolveInternationalLandingCharges(isScheduled);
	    };
	    /**
	     * Resolve parking charge code by system configuration setting.
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolveParkingCharges = function () {
	        return this.systemConfigurationService.getValueByName(system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.PARKING_CHARGES_CODE);
	    };
	    /**
	     * Resolve passenger charge code by system configuration setting.
	     *
	     * @param isDomestic true if domestic passenger charge
	     */
	    CaabSageChargeAdjustmentsService.prototype.resolvePassengerCharges = function (isDomestic) {
	        var config = isDomestic
	            ? system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.DOMESTIC_PASSENGER_SERVICE_CHARGES_CODE
	            : system_configuration_caab_sage_contants_1.CaabSageSysConfigConstants.INTERNATIONAL_PASSENGER_SERVICE_CHARGES_CODE;
	        return this.systemConfigurationService.getValueByName(config);
	    };
	    return CaabSageChargeAdjustmentsService;
	}());
	CaabSageChargeAdjustmentsService.ENROUTE_EXTERNAL_CHARGE_CATEGORY = 'ENROUTE';
	CaabSageChargeAdjustmentsService.IATA_EXTERNAL_CHARGE_CATEGORY = 'IATA';
	exports.CaabSageChargeAdjustmentsService = CaabSageChargeAdjustmentsService;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CaabSageSysConfigConstants;
	(function (CaabSageSysConfigConstants) {
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["CASH_CUSTOMER_ACCOUNT"] = 'CAAB Sage Cash Customer Account'] = "CASH_CUSTOMER_ACCOUNT";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["DOMESTIC_LANDING_CHARGES_NON_SCHEDULED_CODE"] = 'CAAB Sage Domestic Landing Charges - Non-Scheduled Code'] = "DOMESTIC_LANDING_CHARGES_NON_SCHEDULED_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["DOMESTIC_LANDING_CHARGES_SCHEDULED_CODE"] = 'CAAB Sage Domestic Landing Charges – Scheduled Code'] = "DOMESTIC_LANDING_CHARGES_SCHEDULED_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["DOMESTIC_PASSENGER_SERVICE_CHARGES_CODE"] = 'CAAB Sage Domestic Passenger Service Charges Code'] = "DOMESTIC_PASSENGER_SERVICE_CHARGES_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["ENROUTE_NAVIGATION_CHARGES_NON_SCHEDULED_CODE"] = 'CAAB Sage Enroute Navigation Charges - Non-Scheduled Code'] = "ENROUTE_NAVIGATION_CHARGES_NON_SCHEDULED_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["ENROUTE_NAVIGATION_CHARGES_SCHEDULED_CODE"] = 'CAAB Sage Enroute Navigation Charges - Scheduled Code'] = "ENROUTE_NAVIGATION_CHARGES_SCHEDULED_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["INTERNATIONAL_LANDING_CHARGES_NON_SCHEDULED_CODE"] = 'CAAB Sage International Landing Charges - Non–Scheduled Code'] = "INTERNATIONAL_LANDING_CHARGES_NON_SCHEDULED_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["INTERNATIONAL_LANDING_CHARGES_SCHEDULED_CODE"] = 'CAAB Sage International Landing Charges - Scheduled Code'] = "INTERNATIONAL_LANDING_CHARGES_SCHEDULED_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["INTERNATIONAL_PASSENGER_SERVICE_CHARGES_CODE"] = 'CAAB Sage International Passenger Service Charges Code'] = "INTERNATIONAL_PASSENGER_SERVICE_CHARGES_CODE";
	    CaabSageSysConfigConstants[CaabSageSysConfigConstants["PARKING_CHARGES_CODE"] = 'CAAB Sage Parking Charges Code'] = "PARKING_CHARGES_CODE";
	})(CaabSageSysConfigConstants = exports.CaabSageSysConfigConstants || (exports.CaabSageSysConfigConstants = {}));


/***/ })
/******/ ]);
angular.module("armsWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/login/login.html","<div id=page-login class=translate-cloak translate-cloak><div class=container-fluid><div class=row><div class=\"col-xs-push-0 col-xs-12 col-sm-8 col-sm-push-2 col-md-6 col-md-push-3 col-lg-4 col-lg-push-4\"><form ng-show=!recoveryForm novalidate name=loginForm onsubmit=\"return false\" class=box-container><div class=row><div class=\"form-group logo-holder col-xs-9 text-center\"><img class=logo alt={{logoName}} ng-src={{logoUrl}} ng-init=logoOrganisation()><h3>ARMS</h3></div><div class=col-xs-3><span ng-show=language.enabled><label translate for=language>Languages</label><select id=language class=form-control ng-model=language.selected ng-change=setFrontendLanguage(language.selected) ng-options=\"language as language.label for language in language.supported\"></select></span></div></div><div class=form-group><label translate for=username>Username</label><input ng-model=user.username type=text class=form-control id=username autocomplete=off></div><div class=form-group><label translate for=password>Password</label><input ng-model=user.password type=password ng-paste=$event.preventDefault(); class=form-control id=password></div><div class=\"form-group text-center\"><button ng-disabled=\"loginForm.$invalid || user.username == \'\' ||  timeoutDelay > 0\" ng-click=\"submit(user.username, user.password || \'\')\" type=submit class=\"btn btn-primary\" translate>SIGN IN</button></div><div ng-show=\"warning || timeoutDelay > 0\" class=form-group><uib-alert ng-show=timeoutDelay type=warning ng-click=\"warning = false\"><span translate>A number of failed attempts have occurred. Please wait</span> <span>{{ timeoutDelay }}</span> <span translate>seconds to retry</span></uib-alert></div><div ng-show=error class=form-group><uib-alert ng-show=\"error === 400 || error === 401\" translate>Invalid username and/or password. Please try again</uib-alert><uib-alert ng-show=\"error !== 400 && error !== 401\">{{ offlineServerError }}</uib-alert></div><div class=sso-providers ng-if=\"providers && providers.length > 0\"><hr><a href=\"\" class=\"btn btn-block btn-default\" ng-repeat=\"provider in providers\" ng-href={{provider.link_url}}><span translate=sign-in-with></span>&nbsp;<span>{{provider.name}}</span></a><hr></div><div><button type=button class=\"btn-link link btn-forgot-password\" translate ng-click=passwordRecoveryForm()>Forgot password?</button></div></form><!-- Recovery password form --><form ng-show=recoveryForm novalidate name=loginForm onsubmit=\"return false\" class=box-container><div class=row><div class=\"form-group logo-holder col-xs-12\"><h1>ARMS</h1><img class=logo alt={{logoName}} ng-src={{logoUrl}} ng-init=logoOrganisation()></div></div><div class=form-group ng-show=!tempPaswordSent><label for=email translate>Please enter your email</label><input ng-model=email type=text class=form-control id=email autocomplete=off></div><div class=\"form-group text-center\" ng-show=!tempPaswordSent><button ng-click=recoverPassword(email) type=submit class=\"btn btn-primary\" ng-disabled=!email translate>Next</button> <button ng-click=closeRecoveryForm() type=submit class=\"btn btn-primary\" translate>Cancel</button></div><div class=\"form-group text-center\" ng-show=tempPaswordSent translate>The temporary password has been sent to your email. Please update your password when you login.</div><div class=\"form-group text-center\" ng-show=tempPaswordSent><button ng-click=showLogin() type=submit class=\"btn btn-primary\" translate>Login</button></div><div ng-show=error><uib-alert translate>{{ errorDescription }}</uib-alert></div></form></div></div></div></div>");
$templateCache.put("app/main/main.html","<div id=page-main><header-bar><!-- Header --></header-bar><div id=main><side-bar id=side-bar ng-if=!forcePasswordChange><div class=row><div style=position:relative><div id=searchicon></div></div><input name=search id=search type=text ng-model=sidebarSearchTextFilter placeholder=\"{{\'search\' | translate}}\" ng-keyup=keyUp(sidebarSearchTextFilter) ng-mouseover=\"class=\'search\'\"> <button class=btn-xs ng-click=\"sidebarSearchTextFilter = \'\'; clear()\"><i class=\"fa fa-times-circle fa-lg\" aria-hidden=true></i></button></div><side-bar-category icon=val.icon text=val.title links=val.links category-open=sidebarProps[key].open ng-if=::hasPermissionInArray(val.permissions) ng-repeat=\"(key, val) in sideBar | filter: { links: { filterableText: sidebarSearchTextFilter } }\"><side-bar-link icon=valV.icon url=valV.url ng-repeat=\"(keyV, valV) in val.links | filter: { filterableText: sidebarSearchTextFilter }\" ng-show=sidebarProps[key].open ng-if=::hasPermissionInArray(valV.permissions) category={{valV.category}}>{{valV.category}}</side-bar-link></side-bar-category><!-- The following are only displayed on smaller screens --><side-bar-link url=\"\'logout\'\" class=visible-xs icon=\"\'sign-out\'\">Log Out</side-bar-link></side-bar><div id=page-split ng-class=contentMode><div ng-class={{page}} id=content ui-view><!-- Page content render in here --></div><div class=page-map id=content-map ui-view=map><!-- Map will be loaded into here --></div></div></div><footer><!-- Footer --></footer></div>");
$templateCache.put("app/partials/about/about.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=help icon=\"\'code\'\" title=\"{{ \'About\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th translate>Key</th><th translate>Value</th></tr></thead><tbody><tr ng-repeat=\"(key, val) in ::list track by key\"><td>{{ key }}</td><td>{{ val }}</td></tr></tbody></table></div></div></div></form><div><uib-accordion close-others=oneAtATime><div uib-accordion-group class=panel-default heading=\"{{ \'Version\' | translate }} {{ ::version }}\" is-open=isReleaseAccordionOpen[$index] ng-init=\"isReleaseAccordionOpen[$index] = $first\" ng-repeat=\"(version, items) in ::releasenotes | orderBy: orderByReleaseVersion | groupBy: \'release_version\'\" id=\"release-{{ ::version }}\"><div ng-repeat=\"(category, notes) in ::items | orderBy: \'release_category.sort_order\' | groupBy: \'release_category.title\'\"><p id=\"release-{{ ::version }}-category-{{ ::category }}\"><b translate>{{ ::category }}</b></p><ul><li ng-repeat=\"note in ::notes | orderBy: \'number\' track by note.id\" ng-class=\"{ \'work-item-reopened\': note.reopened }\" id=\"release-{{ ::version }}-item-{{ ::note.id }}\">{{ ::note.number }} - <span translate>{{ ::note.title }}</span><label for=\"release-{{ ::version }}-item-{{ ::note.id }}\" ng-if=note.reopened class=\"label label-warning\" translate>Reopened</label></li></ul></div></div></uib-accordion></div></div></div></div></div>");
$templateCache.put("app/partials/account-exempt-management/account-exempt-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=exemptions.exempt-account-management icon=\"\'users\'\" title=\"{{ \'Exempt Accounts\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-6 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=accountExemptManagementService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th class=text-nowrap sort=accountName>{{\'Account\' | translate}}</th><th class=text-nowrap sort=enroute>{{\'Enroute Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=approachFeesExempt>{{\'Approach Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=aerodromeFeesExempt>{{\'Aerodrome Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=lateArrival ng-if=\"shouldShowCharge(\'arrival\')\">{{\'Late Arrival Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=lateDeparture ng-if=\"shouldShowCharge(\'departure\')\">{{\'Late Departure Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=parking ng-if=\"shouldShowCharge(\'parking\')\">{{\'Parking Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=internationalPax>{{\'International PAX Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=domesticPax>{{\'Domestic PAX Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=extendedHours ng-if=\"shouldShowCharge(\'extendedHours\')\">{{\'Extended Hours Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=unifiedTax>{{\'Unified Tax Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=flightNotes>{{\'Flight Notes\' | translate}}</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); form.$setUntouched(); preview(item);\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.account_name }}</td><td class=text-nowrap>{{ item.enroute | number: 2 }}</td><td class=text-nowrap>{{ item.approach_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.aerodrome_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking | number: 2 }}</td><td class=text-nowrap>{{ item.international_pax | number: 2 }}</td><td class=text-nowrap>{{ item.domestic_pax | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours | number: 2 }}</td><td class=text-nowrap>{{ item.unified_tax | number: 2 }}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Exempt Accounts data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'users\'\" title=\"{{ \'Create an Exempt Account\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'users\'\" title=\"{{ \'Edit an Exempt Account\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'exempt_account_modify\')\"><div class=row><div class=\"col-xs-6 col-md-6\"><label for=account>{{\'Account\' | translate}} *</label><dynamic-service-dropdown ng-model=editable.account_id id=account name=accountId dropdown-type=single service=::accountsService method=findAllCrediAndCashtMinimalActiveReturn is-required=::true options=\"item.id as (item.name | translate) for item in list\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=enroute>{{\'Enroute Fees Exempt\' | translate}} * (%)</label><input id=enroute name=enroute class=form-control ng-model=editable.enroute type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=approach_fees_exempt>{{\'Approach Fees Exempt\' | translate}} * (%)</label><input id=approach_fees_exempt name=approachFeesExempt class=form-control ng-model=editable.approach_fees_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome_fees_exempt>{{\'Aerodrome Fees Exempt\' | translate}} * (%)</label><input id=aerodrome_fees_exempt name=aerodromeFeesExempt class=form-control ng-model=editable.aerodrome_fees_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'arrival\')\"><label for=late-arrival>{{\'Late Arrival Fees Exempt\' | translate}} * (%)</label><input id=late-arrival name=lateArrival class=form-control ng-model=editable.late_arrival type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'departure\')\"><label for=late-departure>{{\'Late Departure Fees Exempt\' | translate}} * (%)</label><input id=late-departure name=lateDeparture class=form-control ng-model=editable.late_departure type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking>{{\'Parking Fees Exempt\' | translate}} * (%)</label><input id=parking name=parking class=form-control ng-model=editable.parking type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=international-pax>{{\'International PAX Fees Exempt\' | translate}} * (%)</label><input id=international-pax name=internationalPax class=form-control ng-model=editable.international_pax type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=domestic-pax>{{\'Domestic PAX Fees Exempt\' | translate}} * (%)</label><input id=domestic-pax name=domesticPax class=form-control ng-model=editable.domestic_pax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'extendedHours\')\"><label for=extended-hours>{{\'Extended Hours Fees Exempt\' | translate}} * (%)</label><input id=extended-hours name=extendedHours class=form-control ng-model=editable.extended_hours type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=unified-tax>{{\'Unified Tax Fees Exempt\' | translate}} * (%)</label><input id=unified-tax name=unifiedTax class=form-control ng-model=editable.unified_tax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=col-xs-12><label for=message>{{\'Flight Notes\' | translate}} *</label><textarea id=message name=flightNotes class=form-control type=text ng-model=editable.flight_notes ng-attr-title=\"{{editable.flight_notes ? \'\' : \'Please indicate which fees are exempt and why\' | translate}}\" required>\n                                </textarea></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/accounts/accounts.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.account-management icon=\"\'users\'\" title=\"{{ \'Accounts\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><button ng-click=refreshOverride() class=\"btn btn-primary pull-right\" translate>Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=accounts-filter>Accounts</label><select id=accounts-filter ng-init=\"filter = \'true\'\" empty-to-null class=form-control ng-change=refreshOverride() ng-model=filter><option translate value=\"\">All</option><option translate value=true>Active</option><option translate value=false>Not Active</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=accounts-type>Accounts Type</label><select id=accounts-type class=form-control empty-to-null ng-init=\"accountTypeFilter = \'false\'\" ng-change=refreshOverride() ng-model=accountTypeFilter><option translate value=\"\">All</option><option translate value=true>Cash Accounts</option><option translate value=false>Credit Accounts</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=filter>Invoice</label><select id=filter class=form-control empty-to-null ng-model=accountFilter ng-change=refreshOverride()><option translate value=\"\">All</option><option translate value=outstanding>Outstanding Invoices</option><option translate value=overdue>Overdue Invoices</option><option translate value=credit-limit>Credit Facilities</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=nationality-filter>Nationality</label><select id=nationality-filter empty-to-null class=form-control ng-change=refreshOverride() ng-model=nationality><option translate value=\"\">All</option><option translate value=NA>National</option><option translate value=FO>Foreign</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><input id=self-care-accounts type=checkbox ng-init=\"selfCareAccounts = \'false\'\" ng-model=selfCareAccounts ng-change=refreshOverride()><label translate for=self-care-accounts>Self-care portal accounts</label></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=accountsService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th class=text-nowrap translate sort=name>Account Name</th><th class=text-nowrap translate sort=icaoCode>ICAO Code</th><th class=text-nowrap translate sort=iataCode>IATA Code</th><th class=text-nowrap translate sort=aviationBillingContactPersonName>Contact Name</th><th class=text-nowrap translate sort=nationality>Nationality</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); editOverride(item);saveOldValue(); getAllNotifications(); updateFormatMultiselect();\" ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td>{{ item.name | translate }}</td><td>{{ item.icao_code }}</td><td>{{ item.iata_code }}</td><td>{{ item.aviation_billing_contact_person_name }}</td><td>{{ item.nationality }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=5>There are no Accounts data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div class=\"box-container margin-top-20\" ng-show=editable.id><box-header icon=\"\'users\'\" title=\"{{ \'External Accounting System Identifiers\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>External System Identifier</th><th translate>External Charge Category</th></tr></thead><tbody><tr ng-click=\"formExternal.$setUntouched(); editExternal(item);\" ng-class=\"{\'highlight\': editableExternal.id === item.id}\" ng-repeat=\"item in listExternal\"><td>{{ item.external_system_identifier }}</td><td>{{ item.external_charge_category.name }}</td></tr><tr ng-show=!listExternal.length><td translate class=text-center colspan=4>There are no external sytem identifiers</td></tr></tbody></table></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'users\'\" title=\"{{ \'Create an Account\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'users\'\" title=\"{{ \'Edit an Account\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'account_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=name>Account Name *</label><input id=name name=name class=form-control type=text ng-model=editable.name required></div><div class=\"col-xs-12 col-md-6\"><label translate for=alias>Account Alias</label><input id=alias name=alias class=form-control type=text ng-model=editable.alias></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-contact-person-name>Aviation Billing Contact Person Name</label><input id=aviation-billing-contact-person-name name=aviationBillingContactPersonName class=form-control type=text ng-model=editable.aviation_billing_contact_person_name></div><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-phone-number>Aviation Billing Phone Number</label><input id=aviation-billing-phone-number name=aviationBillingPhoneNumber class=form-control type=text ng-model=editable.aviation_billing_phone_number></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-mailing-address>Aviation Billing Mailing Address</label><input id=aviation-billing-mailing-address name=aviationBillingMailingAddress class=form-control type=text ng-model=editable.aviation_billing_mailing_address></div><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-email-address>Aviation Billing Email Address</label><input id=aviation-billing-email-address name=aviationBillingEmailAddress class=form-control type=text ng-model=editable.aviation_billing_email_address placeholder=\"enter up to four emails separated by \';\'\" pattern=\" [a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+(?:;[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+){0,3}$\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=nationality><span translate>Nationality</span> *</label><select id=nationality-filter class=form-control ng-model=editable.nationality required><option translate value=NA>National</option><option translate value=FO>Foreign</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><button translate class=btn ng-click=getAviationInfo()>Use aviation billing contact for non-aviation</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=non-aviation-billing-contact-person-name>Non-Aviation Billing Contact Person Name</label><input id=non-aviation-billing-contact-person-name name=nonAviationBillingContactPersonName class=form-control type=text ng-model=editable.non_aviation_billing_contact_person_name></div><div class=\"col-xs-12 col-md-6\"><label translate for=non-aviation-billing-phone-number>Non-Aviation Billing Phone Number</label><input id=non-aviation-billing-phone-number name=nonAviationBillingPhoneNumber class=form-control type=text ng-model=editable.non_aviation_billing_phone_number></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=non-aviation-billing-mailing-address>Non-Aviation Billing Mailing Address</label><input id=non-aviation-billing-mailing-address name=nonAviationBillingMailingAddress class=form-control type=text ng-model=editable.non_aviation_billing_mailing_address></div><div class=\"col-xs-12 col-md-6\"><label translate for=non-aviation-billing-email-address>Non-Aviation Billing Email Address</label><input id=non-aviation-billing-email-address name=nonAviationBillingEmailAddress class=form-control type=text ng-model=editable.non_aviation_billing_email_address placeholder=\"enter up to four emails separated by \';\'\" pattern=\" [a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+(?:;[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+){0,3}$\"></div></div><div class=row><!-- <div class=\"col-xs-12 col-md-6\">\n                                <label translate for=\"non-aviation-billing-sms-number\">Non-Aviation Billing SMS Number</label>\n                                <input id=\"non-aviation-billing-sms-number\" name=\"nonAviationBillingSmsNumber\"\n                                    class=\"form-control\" type=\"text\" ng-model=\"editable.non_aviation_billing_sms_number\" />\n                            </div> --><div class=\"col-xs-12 col-md-6\"><label for=is-vat-free><span translate>Vat Free Account</span> *</label><boolean-text id=is-vat-free class=form-control name=vatFreeAccounts ng-model=editable.is_vat_free required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label for=exempt-flight-free><span translate>Exempt Flight Free Account</span> *</label><boolean-text id=exempt-flight-free class=form-control name=exemptFlightFreeAccount ng-model=editable.exempt_flight_free required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=self-care-account><span translate>Self-Care Account</span> *</label><boolean-text id=self-care-account class=form-control name=selfCareAccount ng-model=editable.is_self_care required ng-disabled=true></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=approved-flight-school-indicator>Approved Flight School *</label><boolean-text class=form-control name=approvedFlightSchoolIndicator id=approved-flight-school-indicator ng-model=editable.approved_flight_school_indicator required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=iata-code>IATA Code</label><input id=iata-code name=iataCode class=form-control type=text maxlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false ng-model=editable.iata_code uppercase-input empty-to-null ng-blur=\"editable.iata_code ? editable.iata_member = true : editable.iata_member = false\"></div><div class=\"col-xs-12 col-md-6\"><label translate for=icao-code>ICAO Code</label><input id=icao-code name=icaoCode class=form-control type=text maxlength=3 ng-pattern=/^[a-zA-Z]*$/ ng-trim=false ng-model=editable.icao_code uppercase-input empty-to-null ng-blur=setAccountType()></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=opr-identifier>OPR Identifier</label><input id=opr-identifier name=oprIdentifier class=form-control type=text ng-model=editable.opr_identifier uppercase-input empty-to-null></div><div class=\"col-xs-12 col-md-6\"><label translate for=payment-terms>Payment Terms (days) *</label><input id=payment-terms name=paymentTerms class=form-control type=number step=1 min=0 pattern=\\d+ ng-model=editable.payment_terms required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=account-type>Account Type *</label><dynamic-service-dropdown ng-model=editable.account_type id=account-type name=accountType class=text-capitalize dropdown-type=single ng-change=changeDefaultParametersForAccountType() service=::typesService is-required=::true options=\"item as (item.name | translate) for item in list track by item.id\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=percentage-of-passenger-fee-payable>Percentage of Passenger Fee Payable</label><input id=percentage-of-passenger-fee-payable name=percentageOfPassengerFeePayable class=form-control type=number min=0 ng-model=editable.percentage_of_passenger_fee_payable></div></div><!--   <div class=\"row\" ng-show=\"editable.account_type.name === \'Unified Tax\'\" >\n                            <div class=\"col-xs-12 col-md-6\">\n                                <label translate for=\"account-type-discount\">Account Type Discount (%) </label>\n                                <input id=\"account-type-discount\" name=\"accountTypeDiscount\" class=\"form-control\"\n                                    type=\"number\" step=\"1\" min=\"0\" max=\"100\" ng-model=\"editable.account_type_discount\" >\n                            </div>\n                        </div>\n                        --><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=invoice-delivery-format>Invoice Delivery Format *</label><multiselect id=invoice-delivery-format name=invoiceDeliveryFormat class=form-control model=selectedFormatList options=listOfFormats extra-settings=\"{ displayProp: \'value\', idProp: \'value\',externalIdProp: \'\'}\" events=\"{ onSelectionChanged: addFormatToList }\" required></multiselect></div><div class=\"col-xs-12 col-md-6\"><label translate for=invoice-delivery-method>Invoice Delivery Method *</label><select id=invoice-delivery-method name=invoiceDeliveryMethod ng-model=editable.invoice_delivery_method class=form-control required><option translate value=email>Email</option><option translate value=paper>Paper</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=invoice-currency>Invoice Currency *</label><dynamic-service-dropdown ng-model=editable.invoice_currency id=invoice-currency query-string=\"filter=active\" name=invoiceCurrency dropdown-type=single service=::currencyManagementService is-required=::true options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in list.content track by item.currency_code\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=monthly-overdue-penalty-rate>Monthly Overdue Penalty Rate (%) *</label><input id=monthly-overdue-penalty-rate name=monthlyOverduePenaltyRate class=form-control min=0 type=number ng-model=editable.monthly_overdue_penalty_rate required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=blacklisted-indicator>Blacklisted Indicator</label><boolean-text id=blacklisted-indicator class=form-control name=blackListedIndicator ng-model=editable.black_listed_indicator ng-disabled=true></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=blacklisted-override>Blacklisted Override *</label><boolean-text id=blacklisted-override class=form-control name=blackListedOverride ng-model=editable.black_listed_override required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=cash-account>Cash Account</label><boolean-text id=cash-account class=form-control name=cash_account ng-model=editable.cash_account ng-change=setDefaultCreditLimit() required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label for=credit-limit><span translate>Credit Limit</span>&nbsp;({{ ::anspCurrency }})&nbsp;*</label><input id=credit-limit name=creditLimit class=form-control type=number min={{minCreditLimit}} max={{maxCreditLimit}} ng-readonly=editable.cash_account ng-model=editable.credit_limit required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=maximun-amount-credit-note>Maximum Amount Credit Note&nbsp;({{ ::anspCurrency }})&nbsp;*</label><input id=maximun-amount-credit-note class=form-control name=maximun_amount_credit_note type=number ng-readonly=editable ng-model=editable.maximum_amount_credit_note required></div><div class=\"col-xs-12 col-md-6\"><label translate for=minimum-amount-credit-note>Minimum Amount Credit Note&nbsp;({{ ::anspCurrency }})&nbsp;*</label><input id=minimum-amount-credit-note class=form-control name=minimum_amount_credit_note type=number ng-readonly=editable.cash_account ng-model=editable.minimum_amount_credit_note required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label translate for=aircraft-parking-exemption>Aircraft Parking Exemption *</label><input id=aircraft-parking-exemption name=aircraftParkingExemption type=number min=0 step=1 pattern=\\d+ class=form-control ng-model=editable.aircraft_parking_exemption required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=iata-member>IATA Member *</label><boolean-text class=form-control name=iataMember id=iata-member ng-model=editable.iata_member required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=separate-pax-invoice>Separate PAX Invoice *</label><boolean-text class=form-control name=separatePaxInvoice id=separate-pax-invoice ng-model=editable.separate_pax_invoice required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=active>Active *</label><boolean-text class=form-control name=active id=active ng-model=editable.active required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=account_users>Self-Care Account Users</label><multiselect id=account_users name=account_users translated-value=name extra-settings=\"{ displayProp: \'name\', idProp: \'id\', externalIdProp: \'\', scrollableHeight: auto }\" options=selfCareUserList model=editable.account_users></multiselect></div></div><div class=row ng-show=whitelistingEnabled><div class=\"col-xs-12 col-md-6\"><label translate for=whitelist_last_activity>Whitelist Last Activity</label><input id=whitelist-last-activity name=whitelistLastActivity type=text class=form-control ng-value=whitelistLastActivityDateTime readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label translate for=whitelist_state>Whitelist State</label><input id=whitelist-state name=whitelistState type=text class=form-control ng-value=whitelistState readonly=readonly></div></div><div class=row ng-show=whitelistingEnabled><div class=\"col-xs-12 col-md-6\"><label translate for=whitelist_inactivity_notice_sent>Whitelist Inactivity Notice Sent</label><boolean-text id=whitelistInactivityNoticeSent class=form-control name=whitelist-inactivity-notice-sent ng-model=editable.whitelist_inactivity_notice_sent_flag ng-disabled=true></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=whitelist_expiry_notice_sent>Whitelist Expiry Notice Sent</label><boolean-text id=whitelistExpiryNoticeSent class=form-control name=whitelist-expiry-notice-sent ng-model=editable.whitelist_expiry_notice_sent_flag ng-disabled=true></boolean-text></div></div><div class=row><div class=col-xs-12><label translate ng-click=\"notifications.open = !notifications.open\" for=list-of-events-account-notified>List of events account is to be notified</label><div><ul ng-init=\"notifications.open = true\" ng-show=notifications.open style=list-style-type:none><div class=\"col-xs-12 col-md-12\"><label for=invoice-pubblication><span translate>Invoice Pubblication</span></label><boolean-text id=invoice-pubblication class=form-control name=incoicePubblication ng-model=editable.invoice_pubblication></boolean-text></div><div class=\"col-xs-12 col-md-12\"><label for=invoice-overdue><span translate>Invoice Overdue</span></label><boolean-text id=invoice-overdue class=form-control name=invoiceOverdue ng-model=editable.invoice_overdue></boolean-text></div><div class=\"col-xs-12 col-md-12\"><label for=expired-certificate-warning><span translate>Expired Certificate Warning</span></label><boolean-text id=expired-certificate-warning class=form-control name=expireCertificateWarning ng-model=editable.expired_certificate_warning></boolean-text></div><div class=\"col-xs-12 col-md-12\"><label for=expired-certificate><span translate>Expired Certificate</span></label><boolean-text id=expired-certificate class=form-control name=expiredCertificate ng-model=editable.expired_certificate></boolean-text></div><!-- <li ng-repeat=\"item in notificationsList\">\n                                            <div class=\"col-md-6 col-xs-12\"> {{ item.name | translate }} </div>\n                                            <div class=\"col-md-6 col-xs-12\">\n                                                <multiselect id=\"notifications\" name=\"notifications\"\n                                                    translated-value=\'name\' search=\"false\"\n                                                    extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\', scrollableHeight: auto }\"\n                                                    options=\"notificationsTypeList\" model=\"item.model\"\n                                                    events=\"{ onSelectionChanged: addNotificationsToList }\">\n                                                </multiselect>\n                                            </div>\n                                        </li> --></ul></div></div></div><div class=row><div class=col-xs-12><label translate for=notes>Notes</label><textarea id=notes class=form-control name=notes ng-model=editable.notes></textarea></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button ng-disabled=false class=\"btn btn-primary btn-reset\" ng-click=\"reset(); getAllNotifications(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=form.$invalid ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id);activeNotificationUpdated();setEmptyFormatList(); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=deleteOverride(editable.id);setEmptyFormatList();>Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();setEmptyFormatList();\">Create</button></div></div></fieldset></form></div></div><div class=\"box-container margin-top-20\" ng-show=\"editable.id !== null && listExternal !== null\"><box-header ng-show=\"editableExternal.id === null\" icon=\"\'users\'\" title=\"{{ \'Create an External Accounting System Identifier\' | translate }}\"></box-header><box-header ng-show=\"editableExternal.id !== null\" icon=\"\'users\'\" title=\"{{ \'Edit an External Accounting System Identifier\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=formExternal onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'account_modify\')\"><legend class=sr-only ng-if=\"editableExternal.id === null\" translate>Create an External Accounting System Identifier</legend><legend class=sr-only ng-if=\"editableExternal.id !== null\" translate>Edit an External Accounting System Identifier</legend><div class=row><div class=\"col-xs-12 col-md-6\"><label for=external-system-identifier><span translate>External System Identifier</span> <span>*</span></label><input id=external-system-identifier name=externalSystemIdentifier class=form-control type=text maxlength=25 ng-model=editableExternal.external_system_identifier required></div><div class=\"col-xs-12 col-md-6\"><label translate for=external-charge-category><span translate>External Charge Category</span> <span>*</span></label><dynamic-service-dropdown id=external-charge-category name=externalChargeCategory dropdown-type=single service=::externalChargeCategoryService is-required=::true options=\"item as (item.name | translate) for item in list track by item.id\" ng-model=editableExternal.external_charge_category></dynamic-service-dropdown></div></div><div class=row><div class=col-xs-12><button translate type=button ng-disabled=false class=\"btn btn-primary btn-reset\" ng-click=\"resetExternal(); formExternal.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=formExternal.$invalid ng-show=\"editableExternal.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateExternal(editableExternal, editableExternal.id); formExternal.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editableExternal.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=deleteExternal(editableExternal.id)>Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=formExternal.$invalid ng-show=\"editableExternal.id === null\" ng-click=\"createExternal(editableExternal); formExternal.$setUntouched();\">Create</button></div></div></fieldset></form></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'users\'\" title=\"{{ \'Upload Accounts\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'account_modify\')\"><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\')\" ng-disabled=!editable.document_filename>Upload</button><upload-file-format format={{pattern}} mtow={{mtowUnitOfMeasure}} template=app/partials/accounts/accounts.template.html></upload-file-format></div></div></fieldset></form></div></div></div></div><div class=\"notification notification-responsive\" ng-show=\"accountCreated === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #4caf50; color: white;\n                         padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Successfully created account</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"accountCreated = false\">X</span></div><div class=\"notification notification-responsive\" ng-show=\"accountUpdated === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #4caf50; color: white;\n                         padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Successfully updated account</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"accountUpdated = false\">X</span></div><div class=\"notification notification-responsive\" ng-show=\"accountDeleted === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #4caf50; color: white;\n                         padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Successfully deleted account</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"accountDeleted = false\">X</span></div></div></div>");
$templateCache.put("app/partials/accounts/accounts.template.html","<div class=\"confirm-popup padding-20\" style=\"max-width: 100%; overflow-x: auto\" xmlns=http://www.w3.org/1999/html><div class=row><div class=col-xs-12><div class=text-center><h5>{{ \'Accounts File\' | translate }}</h5></div><ul><li>{{ \'Format\' | translate }}: {{ format }}</li><li>{{ \'Top\' | translate }} 1 {{ \'row is ignored\' | translate }}</li><li>{{ \'No column header\' | translate }}</li></ul><span>{{ \'Columns\' | translate }}:</span><ul><li>#1 - {{ \'Account Name\' | translate }} *</li><li>#2 - {{ \'Account Alias\' | translate }}</li><li>#3 - {{ \'Aviation Billing Contact Person Name\' | translate }}</li><li>#4 - {{ \'Aviation Billing Phone Number\' | translate }}</li><li>#5 - {{ \'Aviation Billing Mailing Address\' | translate }}</li><li>#6 - {{ \'Aviation Billing Email Address\' | translate }}<br><small>{{ \'Enter up to four emails separated by \";\"\' | translate }}</small></li><li>#7 - {{ \'Nationality\' | translate }} *<br><small>{{ \'Accepted values\' | translate }}: \"NA\", \"FO\", \"national\", \"foreign\",\"NATIONAL\", \"FOREIGN\"</small></li><li>#8 - {{ \'Non-Aviation Billing Contact Person Name\' | translate }}</li><li>#9 - {{ \'Non-Aviation Billing Phone Number\' | translate }}</li><li>#10 - {{ \'Non-Aviation Billing Mailing Address\' | translate }}</li><li>#11 - {{ \'Non-Aviation Billing Email Address\' | translate }}<br><small>{{ \'Enter up to four emails separated by \";\"\' | translate }}</small></li><li>#12 - {{ \'Vat Free Account\' | translate }} *</li><li>#13 - {{ \'Exempt Flight Free\' | translate }} *</li><li>#14 - {{ \'Approved Flight School Indicator\' | translate }} *</li><li>#15 - {{ \'Is Self Care\' | translate }} *</li><li>#16 - {{ \'IATA Code\' | translate }}</li><li>#17 - {{ \'ICAO Code\' | translate }}</li><li>#18 - {{ \'OPR Identifier\' | translate }}</li><li>#19 - {{ \'Account Type\' | translate }} *</li><small>{{ \'Accepted values\' | translate }}: \"Airline\", \"GeneralAviation\", \"Nonaviation\", \"Unified Tax\", \"Charter\", \"Other\", \"Commercial\", \"Tenant\"</small><li>#20 - {{ \'Aircraft Parking Exemption\' | translate }}</li><li>#21 - {{ \'Invoice Delivery Format\' | translate }} *</li><small>{{ \'Accepted values\' | translate }}: \"pdf\", \"xlsx\"</small><li>#22 - {{ \'Invoice Delivery Method\' | translate }} *</li><small>{{ \'Accepted values\' | translate }}: \"email\", \"paper\"</small><li>#23 - {{ \'Invoice Currency\' | translate }} *</li><small>{{ \'Accepted values\' | translate }}: \"USD\", \"ANSP\"</small><li>#24 - {{ \'Black Listed Indicator\' | translate }}</li><li>#25 - {{ \'Black Listed Override\' | translate }} *</li><li>#26 - {{ \'Cash Account\' | translate }}</li><li>#27 - {{ \'IATA Member\' | translate }} *</li><li>#28 - {{ \'Separate Pax Invoice\' | translate }} *</li><li>#29 - {{ \'Active\' | translate }}</li><li>#30 - {{ \'Invoice Publication\' | translate }}</li><li>#31 - {{ \'Invoice Overdue\' | translate }}</li><li>#32 - {{ \'Expired Certificate Warning\' | translate }}</li><li>#33 - {{ \'Expired Certificate\' | translate }}</li></ul><p><strong>{{ \'NOTE\' | translate }}:</strong> {{ \'If you are creating a file in Excel, the first row must contain non-blank data otherwise Excel will remove any completely empty rows or columns\' | translate }}</p></div></div><div class=\"row margin-top-20\"><div class=text-right style=margin-right:15px><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/aerodrome-category-management/aerodrome-category-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.aerodrome-category-management icon=\"\'object-group\'\" title=\"{{ \'Aerodrome Categories\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=aerodromeCategoryManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=categoryName>Cat Name</th><th translate class=\"text-nowrap text-right\" sort=internationalPassengerFeeAdult>Int Pass Fee - Adult</th><th translate class=\"text-nowrap text-right\" sort=internationalPassengerFeeChild>Int Pass Fee - Child</th><th translate class=\"text-nowrap text-right\" sort=domesticPassengerFeeAdult>Dom Pass Fee - Adult</th><th translate class=\"text-nowrap text-right\" sort=domesticPassengerFeeChild>Dom Pass Fee - Child</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td translate>{{ item.category_name }}</td><td class=text-right>{{ item.international_passenger_fee_adult }}</td><td class=text-right>{{ item.international_passenger_fee_child }}</td><td class=text-right>{{ item.domestic_passenger_fee_adult }}</td><td class=text-right>{{ item.domestic_passenger_fee_child }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=5>There are no Aerodrome Categories data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'object-group\'\" title=\"{{ \'Create an Aerodrome Category\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'object-group\'\" title=\"{{ \'Edit an Aerodrome Category\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aerodrome_category_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=category_name>Aerodrome Category Name *</label><input id=category_name name=categoryName class=form-control type=text ng-model=editable.category_name required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=domestic_passenger_fee_adult>Domestic Passenger Fee - Adult *</label><input id=domestic_passenger_fee_adult name=domesticPassengerFeeAdult class=form-control type=number step=0.01 min=0 ng-model=editable.domestic_passenger_fee_adult required></div><div class=\"col-xs-12 col-md-6\"><label translate for=international_passenger_fee_adult>International Passenger Fee - Adult *</label><input id=international_passenger_fee_adult name=internationalPassengerFeeAdult class=form-control type=number step=0.01 min=0 ng-model=editable.international_passenger_fee_adult required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=domestic_passenger_fee_child>Domestic Passenger Fee - Child *</label><input id=domestic_passenger_fee_child class=form-control type=number step=0.01 min=0 name=domesticPassengerFeeChild ng-model=editable.domestic_passenger_fee_child required></div><div class=\"col-xs-12 col-md-6\"><label translate for=international_passenger_fee_child>International Passenger Fee - Child *</label><input id=international_passenger_fee_child name=internationalPassengerFeeChild class=form-control type=number step=0.01 min=0 ng-model=editable.international_passenger_fee_child required></div></div><div class=row><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include></div><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-reset\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=form.$invalid ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id)>Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/aerodrome-operational-hours/aerodrome-operational-hours.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'hourglass\'\" page-name=management.aerodrome-operational-hours title=\"{{ \'Aerodrome Operational Hours\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode === 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-4><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=aerodromeOperationalHoursService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=aerodrome>Aerodrome</th></tr></thead><tbody><tr ng-click=showAerodromeOperationalHours(item,$index);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editableIndexAerodrome === $index}\"><td class=text-nowrap>{{item.aerodrome_operational_hours[0].aerodrome}}</td></tr><tr ng-show=!list.length><td class=text-center translate>There are no Aerodrome Operational Hours data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements max-size=::20 items-per-page=pagination.size ng-change=refresh() ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div><div><div class=col-xs-8><div class=table-responsive style=\"max-height: 25vh; margin-bottom: 10px\"><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=startDateTime>Start Date/Time</th><th translate class=text-nowrap sort=endDateTime>End Date/Time</th><th translate class=text-nowrap sort=operationalHoursMonday>Operational Hours Monday</th><th translate class=text-nowrap sort=operationalHoursTuesday>Operational Hours Tuesday</th><th translate class=text-nowrap sort=operationalHoursWednesday>Operational Hours Wednesday</th><th translate class=text-nowrap sort=operationalHoursThursday>Operational Hours Thursday</th><th translate class=text-nowrap sort=operationalHoursFriday>Operational Hours Friday</th><th translate class=text-nowrap sort=operationalHoursSaturday>Operational Hours Saturday</th><th translate class=text-nowrap sort=operationalHoursSunday>Operational Hours Sunday</th><th translate class=text-nowrap sort=holidayDatesHolidays1>Holiday Dates Holidays A</th><th translate class=text-nowrap sort=operationalHoursHolidays1>Operational Hours Holidays A</th><th translate class=text-nowrap sort=holidayDatesHolidays2>Holiday Dates Holidays B</th><th translate class=text-nowrap sort=operationalHoursHolidays2>Operational Hours Holidays B</th></tr></thead><tbody><tr ng-click=\"editAerodromeOperationalHours(item, $index); enableAerodromeInput = false\" ng-repeat=\"item in aerodromeOperationalHours\" ng-class=\"{\'highlight\':editableIndex === $index}\"><!-- Start and End Date --><td class=text-nowrap>{{ item.start_date_time | dateConverter: \'HH:mm\' }}</td><td class=text-nowrap>{{ item.end_date_time | dateConverter: \'HH:mm\' }}</td><!-- Operational Hours for Each Day --><td>{{ item.operational_hours_monday }}</td><td>{{ item.operational_hours_tuesday }}</td><td>{{ item.operational_hours_wednesday }}</td><td>{{ item.operational_hours_thursday }}</td><td>{{ item.operational_hours_friday }}</td><td>{{ item.operational_hours_saturday }}</td><td>{{ item.operational_hours_sunday }}</td><td>{{ item.holiday_dates_holidays1 }}</td><td>{{ item.operational_hours_holidays1 }}</td><td>{{ item.holiday_dates_holidays2 }}</td><td>{{ item.operational_hours_holidays2 }}</td></tr><!-- No data message --><tr ng-show=!aerodromeOperationalHours.length><td colspan=13 translate>There are no Aerodrome Start/End Date</td></tr></tbody></table></div></div></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'hourglass\'\" title=\"{{ \'Create an Aerodrome Operational Hours\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'hourglass\'\" title=\"{{ \'Edit an Aerodrome Operational Hours\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aerodrome_operational_hours_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome>{{ \'Aerodrome\' | translate }} *</label><select id=aerodrome name=aerodrome class=form-control ng-options=\"item for item in aerodromeWithServices\" ng-disabled=\"editable.id && !enableAerodromeInput\" ng-model=editable.aerodrome required></select></div><div class=\"col-xs-12 col-md-6\"><label for=copy-from-aerodrome>{{ \'Copy From Aerodrome\' | translate }}</label><select id=copy-from-aerodrome name=copyFromAerodrome class=form-control ng-model=copyFromAerodrome ng-change=\"copyDataFromAerodrome(copyFromAerodrome); editable.aerodrome = \'\'; enableAerodromeInput = true; editable.id = null\" ng-options=\"item as item.aerodrome_name for item in copiedAerodromes | orderBy:\'aerodrome_name\'\"><option value=\"\"></option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=start-date><span translate>Start Date</span> *&nbsp;<span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=start-date name=startDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=start_date is-open=startDate.open ng-attr-title=\"{{start_date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDate.open = !startDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=start_time><span translate>Start Time</span>&nbsp;(<span tranlate>HHmm</span>) *</label><input id=start_time name=startTime class=form-control type=text ng-model=start_time minlength=4 maxlength=4 ng-attr-title=\"{{start_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=end-date><span translate>End Date</span> *&nbsp;<span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=end-date name=endDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=end_date is-open=endDate.open ng-attr-title=\"{{end_date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDate.open = !endDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=end_time><span translate>End Time</span>&nbsp;(<span tranlate>HHmm</span>) *</label><input id=end_time name=endTime class=form-control type=text ng-model=end_time minlength=4 maxlength=4 ng-attr-title=\"{{end_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-monday>{{ \'Operational Hours Monday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-monday name=operationalHoursMonday class=form-control type=text ng-model=editable.operational_hours_monday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_monday, \'operationalHoursMonday\', \'operational_hours_monday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursMonday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursMonday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursMonday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-tuesday>{{ \'Operational Hours Tuesday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-tuesday name=operationalHoursTuesday class=form-control type=text ng-model=editable.operational_hours_tuesday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_tuesday, \'operationalHoursTuesday\', \'operational_hours_tuesday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursTuesday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursTuesday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursTuesday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-wednesday>{{ \'Operational Hours Wednesday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-wednesday name=operationalHoursWednesday class=form-control type=text ng-model=editable.operational_hours_wednesday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_wednesday, \'operationalHoursWednesday\', \'operational_hours_wednesday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursWednesday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursWednesday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursWednesday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-thursday>{{ \'Operational Hours Thursday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-thursday name=operationalHoursThursday class=form-control type=text ng-model=editable.operational_hours_thursday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_thursday, \'operationalHoursThursday\', \'operational_hours_thursday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursThursday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursThursday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursThursday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-friday>{{ \'Operational Hours Friday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-friday name=operationalHoursFriday class=form-control type=text ng-model=editable.operational_hours_friday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_friday, \'operationalHoursFriday\', \'operational_hours_friday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursFriday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursFriday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursFriday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-saturday>{{ \'Operational Hours Saturday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-saturday name=operationalHoursSaturday class=form-control type=text ng-model=editable.operational_hours_saturday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_saturday, \'operationalHoursSaturday\', \'operational_hours_saturday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursSaturday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursSaturday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursSaturday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-sunday>{{ \'Operational Hours Sunday\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-sunday name=operationalHoursSunday class=form-control type=text ng-model=editable.operational_hours_sunday autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_sunday, \'operationalHoursSunday\', \'operational_hours_sunday\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursSunday\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursSunday\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursSunday\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=holiday-dates-holidays1>{{ \'Holiday Dates - Holidays A\' | translate }} ({{ \'mm/dd\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=holiday-dates-holidays1 name=holidayDatesHolidays1 class=form-control type=text ng-model=editable.holiday_dates_holidays1 autocomplete=off ng-blur=\"dateValidate(editable.holiday_dates_holidays1, \'holidayDatesHolidays1\', \'holiday_dates_holidays1\')\" ng-attr-title=\"{{ showDateErrorMessage[\'holidayDatesHolidays1\'] ? (dateFormatErrorMessage | translate) : \'\' ||\n                                        dateIsAlreadyExist[\'holidayDatesHolidays1\'] ? (dateIsAlreadyExistErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-holidays1>{{ \'Operational Hours Holidays A\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-holidays1 name=operationalHoursHolidays1 class=form-control type=text ng-model=editable.operational_hours_holidays1 autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_holidays1, \'operationalHoursHolidays1\', \'operational_hours_holidays1\')\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursHolidays1\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursHolidays1\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursHolidays1\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=holiday-dates-holidays2>{{ \'Holiday Dates - Holidays B\' | translate }} ({{ \'mm/dd\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=holiday-dates-holidays2 name=holidayDatesHolidays2 class=form-control type=text ng-model=editable.holiday_dates_holidays2 autocomplete=off ng-blur=\"dateValidate(editable.holiday_dates_holidays2, \'holidayDatesHolidays2\', \'holiday_dates_holidays2\')\" ng-attr-title=\"{{ showDateErrorMessage[\'holidayDatesHolidays2\'] ? (dateFormatErrorMessage | translate) : \'\' ||\n                                        dateIsAlreadyExist[\'holidayDatesHolidays2\'] ? (dateIsAlreadyExistErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operational-hours-holidays2>{{ \'Operational Hours Holidays B\' | translate }} ({{ \'HHmm\' | translate }}-{{ \'HHmm\' | translate }}, {{ \'UTC\' | translate }})</label></div><div class=\"col-xs-12 col-md-6\"><input id=operational-hours-holidays2 name=operationalHoursHolidays2 class=form-control type=text ng-model=editable.operational_hours_holidays2 autocomplete=off ng-blur=\"timeValidate(editable.operational_hours_holidays2, \'operationalHoursHolidays2\', operational_hours_holidays2)\" ng-attr-title=\"{{ showTimeErrorMessage[\'operationalHoursHolidays2\'] ? (timeFormatErrorMessage | translate) : \'\' ||\n                                        timeIsAlreadyExist[\'operationalHoursHolidays2\'] ? (timeIsAlreadyExistErrorMessage | translate) : \'\' ||\n                                        fromTimeIsAfterEndHours[\'operationalHoursHolidays2\'] ? (timeStartEndErrorMessage | translate) : \'\' }}\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=notes>{{ \'Notes\' | translate}}</label></div><div class=\"col-xs-12 col-md-6\"><input id=notes name=notes class=form-control type=text ng-model=editable.notes autocomplete=off></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id, start_date, start_time, end_date, end_time); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable, start_date, start_time, end_date, end_time); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/aerodromes/aerodromes.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.aerodrome-management icon=\"\'paper-plane\'\" title=\"{{ \'Domestic Aerodromes\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div><div class=row><div class=col-xs-12><div class=table-responsive sort-query-string=getSortQueryString() export-table query-string=filterParameters back-end-export=true service=aerodromesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=extendedAerodromeName>Aerodrome Name</th><th translate class=text-nowrap sort=aerodromeName>ICAO Identifier</th><th translate class=text-nowrap sort=aixmFlag>Defined in AIX/M</th><th translate class=text-nowrap sort=billingCenter>Billing Centre</th><th translate class=text-nowrap sort=isDefaultBillingCenter>Default for Billing Centre</th><th translate class=text-nowrap sort=aerodromeCategory>Aerodrome Category</th><th translate class=text-nowrap>Latitude</th><th translate class=text-nowrap>Longitude</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); checkIfDefaultSet(editable);\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.extended_aerodrome_name }}</td><td class=text-nowrap>{{ item.aerodrome_name }}</td><td class=\"text-capitalize text-nowrap\">{{ item.aixm_flag | translate }}</td><td class=text-nowrap>{{ item.billing_center.name }}</td><td class=\"text-capitalize text-nowrap\">{{ item.is_default_billing_center | translate }}</td><td class=text-nowrap translate>{{ item.aerodrome_category.category_name }}</td><td class=text-nowrap>{{ item.geometry.coordinates[1] | latitudeConverter }}</td><td class=text-nowrap>{{ item.geometry.coordinates[0] | longitudeConverter }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=8>There are no Domestic Aerodromes data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'paper-plane\'\" title=\"{{ \'Create an Aerodrome\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'paper-plane\'\" title=\"{{ \'Edit an Aerodrome\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aerodrome_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=extended-aerodrome-name>Aerodrome Name *</label><input id=extended-aerodrome-name class=form-control type=text name=extendedAerodromeName ng-model=editable.extended_aerodrome_name required></div><div class=\"col-xs-12 col-md-6\"><label translate for=aerodrome-name>ICAO Identifier *</label><input id=aerodrome-name class=form-control type=text name=aerodromeName ng-model=editable.aerodrome_name uppercase-input minlength=4 maxlength=4 ng-pattern=/^[a-zA-Z0-9]{4}$/ required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aixm>Defined in AIX/M</label><input id=aixm class=\"form-control text-capitalize\" name=aixmFlag ng-value=\"editable.aixm_flag | translate\" readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label translate for=aerodrome-category>Aerodrome Category *</label><dynamic-service-dropdown ng-model=editable.aerodrome_category id=aerodrome-category name=aerodromeCategory dropdown-type=single service=::aerodromeCategoryManagementService is-required=::true options=\"category as (category.category_name | translate) for category in list.content track by category.id\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=latitude>Latitude ({{ ::getLatLabel() }}) *</label><input id=latitude class=form-control type=text name=coordinates ng-model=editable.geometry.coordinates[1] ng-pattern=latitudeRegex input-format=\"DD.ddddd or DD°MM′SS″L or DD MM SSL\" required></div><div class=\"col-xs-12 col-md-6\"><label translate for=longitude>Longitude ({{ ::getLonLabel() }}) *</label><input id=longitude class=form-control type=text name=coordinates ng-model=editable.geometry.coordinates[0] ng-pattern=longitudeRegex input-format=\"DD.ddddd or DDD°MM′SS″L or DDD MM SSL\" required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=billing-center>Billing Centre *</label><dynamic-service-dropdown ng-model=editable.billing_center id=billing-center name=billingCenter dropdown-type=single service=::billingCentreManagementService is-required=::true ng-change=checkIfDefaultSet(editable) options=\"centre as centre.name for centre in list.content track by centre.name\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=default-aerodrome>Default for Billing Centre *</label><boolean-text id=default-aerodrome class=form-control name=isDefaultBillingCenter ng-model=editable.is_default_billing_center ng-disabled=hasDefault required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=external-accounting-system-identifier><span translate>External Accounting System Identifier</span> <span ng-if=requireExternalSystemId>*</span></label><input id=external-accounting-system-identifier name=externalAccountingSystemIdentifier class=form-control type=text ng-model=editable.external_accounting_system_identifier maxlength=20 ng-required=requireExternalSystemId></div><div class=\"col-xs-12 col-md-6\"><label translate for=aerodrome-service-types>Aerodrome Service Types</label><multiselect id=aerodrome-service-types name=aerodrome-service-types translated-value=service_name search=false extra-settings=\"{ displayProp: \'service_name\', idProp: \'id\', externalIdProp: \'\', scrollableHeight: auto }\" options=aerodromeServiceTypes model=editable.aerodrome_services></multiselect></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-reset\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=form.$invalid ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" convert-coordinates latitude=geometry.coordinates.1 longitude=geometry.coordinates.0 popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-coordinates latitude=geometry.coordinates.1 longitude=geometry.coordinates.0 conversion-complete=\"create(convertedEditable || editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/air-navigation-charges/air-navigation-charges.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=charges-and-formulas.air-navigation-charges-schedule-managment icon=\"\'cloud\'\" title=\"{{ \'Air Navigation Charges Schedules\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters service=airNavigationChargesService back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=\"text-nowrap text-center\">Actions</th><th translate class=text-nowrap sort=chargesType>Schedule</th><th translate class=text-nowrap sort=aerodromeCategoryName>Aerodrome Category</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue(); editable.index = $index\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.index === $index}\" ng-hide=\"!shouldShowCharge(\'parking\') && item.charges_type.includes(\'parking\')\"><td class=text-center><download-oauth2 title=\"{{ \'Download air charges spreadsheet\' | translate }}\" url=/air-navigation-charges-schedules/{{item.id}}/{{item.charges_type}}/download? error=$parent.error></download-oauth2><button title=\"{{ \'Preview air charges spreadsheet\' | translate }}\" ng-click=\"preview([item.id, item.charges_type])\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-text-o\"></i></button></td><td translate class=word-wrap-break-word>{{ item.charges_type }}</td><td translate class=word-wrap-break-word>{{ item.aerodrome_category_name }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=3>There are no Air Navigation Charges Schedules data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div ng-show=!toggle class=\"row col-xs-12\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'cloud\'\" title=\"{{ \'Upload an Air Navigation Charge File\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'charges_schedule_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=charges_type>Schedule *</label><select id=charges_type class=form-control ng-model=editable.charges_type ng-options=\"item.value as (item.name | translate) for item in chargeTypes\" required></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=aerodrome_category_id>Aerodrome Category *</label><select id=aerodrome_category_id class=form-control ng-model=editable.aerodrome_category_id ng-options=\"item.id as (item.category_name | translate) for item in aerodromeCategoryList\" required></select></div></div><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"!editable.charges_type || !editable.aerodrome_category_id || !editable.document_filename || !editable.document\" ng-show=\"editable.id === null\" ng-click=\"upload(\'PUT\', [editable.aerodrome_category_id, editable.charges_type]); form.$setUntouched(); reset();\">Create</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=\"!editable.charges_type || !editable.aerodrome_category_id || !editable.document_filename || !editable.document\" ng-show=\"editable.id !== null\" ng-click=\"upload(\'PUT\', [editable.aerodrome_category_id, editable.charges_type]); form.$setUntouched(); reset();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteFile([ editable.id + \'/\' + editable.charges_type ]); form.$setUntouched();\">Delete</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/air-traffic-data/air-traffic-data.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=data-analysis-and-statistics.analysis-and-statistics-air-traffic icon=\"\'line-chart\'\" title=\"{{ \'Data Analysis and Statistics - Air Traffic\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-6 col-md-2\"><select id=report class=form-control ng-model=template ng-change=selectTemplate(template) ng-options=\"item for item in templatesList\"><option value=\"\"></option></select></div><div class=\"col-xs-6 col-md-1\" ng-if=!template><button translate class=\"btn btn-sm btn-primary btn-save-template\" popup popup-text=\"Save Template as\" save-as=true popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"saveTemplate(inputText); form.$setUntouched()\">Save Template</button></div><div class=\"col-xs-6 col-md-4\" ng-if=template><button translate class=\"btn btn-sm btn-primary btn-delete-template\" popup popup-text=\"Are you sure you want to delete this template?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"deleteTemplate(template); form.$setUntouched()\">Delete Template</button> <button translate class=\"btn btn-sm btn-primary btn-update-template\" popup popup-text=\"Are you sure you want to update this template?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateTemplate(template); form.$setUntouched()\">Update Template</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=row><date-range is-required=::true control=control format={{customDate}} start-end-adjust=true date-options=\"{ minMode: \'month\' }\" start-name=\"Start Date *\" end-name=\"End Date *\"><!--Datepickers --></date-range></div></div><div class=\"col-xs-12 col-md-6\"><div class=row><div class=col-xs-6><label translate for=billing-centre>Billing Centre</label><multiselect id=billing-centre name=billingCentresList extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=billingCentresList model=billingCentresModel events=\"{ onSelectionChanged: addBillingCentreToList }\"></multiselect></div><div class=col-xs-6><label translate for=account>Account</label><multiselect id=account name=accountsList extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=accountsList model=accountsModel events=\"{ onSelectionChanged: addAccountToList }\"></multiselect></div></div></div></div><!--End Row--><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=col-xs-3><label translate for=aerodrome>Aerodrome</label><multiselect id=aerodrome name=aerodromesList extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'aerodrome_name\', externalIdProp: \'\' }\" options=aerodromesList model=aerodromesModel events=\"{ onSelectionChanged: addAerodromeToList }\"></multiselect></div><div class=col-xs-3><label translate for=aircraft-type>Aircraft Type</label><multiselect id=aircraft-type name=aircraftTypeList extra-settings=\"{ displayProp: \'aircraft_type\', idProp: \'aircraft_type\', externalIdProp: \'\' }\" options=aircraftTypeList model=aircraftTypeModel events=\"{ onSelectionChanged: addAircraftToList }\"></multiselect></div><div class=col-xs-3><label translate for=route>Route</label><multiselect id=route name=routeList extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=routeList model=routeModel events=\"{ onSelectionChanged: addRouteToList }\"></multiselect></div><div class=col-xs-3 ng-if=!KCAA><label for=mtow><span>{{ \'MTOW Category\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></label><multiselect id=mtow name=mtowList extra-settings=\"{ displayProp: \'upper_limit\', idProp: \'upper_limit\', externalIdProp: \'\' }\" options=mtowList model=mtowModel events=\"{ onSelectionChanged: addMTOWToList }\"></multiselect></div><div class=col-xs-3 ng-if=KCAA><label translate for=flight-level>Flight Level</label><multiselect id=flight-level name=flightLevelList extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=flightLevelList model=flightLevelModel events=\"{ onSelectionChanged: addFlightLevelToList }\"></multiselect></div></div></div></div><!--End Row--><div class=row ng-show=KCAA><div class=\"col-xs-12 col-md-12\"><div class=row><div class=col-xs-3><label translate for=mtow-factor-class>MTOW factor class</label><select id=mtow-factor-class class=form-control name=mtowFactorClass ng-model=mtow_factor_class ng-change=showMTOWList(mtow_factor_class)><option value=\"\"></option><option translate value=DOMESTIC>Domestic</option><option translate value=REGIONAL>Regional</option><option translate value=INTERNATIONAL>International</option></select></div><div class=col-xs-3 ng-show=mtow_factor_class><label for=mtow><span>{{ \'MTOW Category\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></label><multiselect id=mtow name=mtowList extra-settings=\"{ displayProp: \'upper_limit\', idProp: \'upper_limit\', externalIdProp: \'\' }\" options=mtowList model=mtowModel events=\"{ onSelectionChanged: addMTOWToList }\"></multiselect></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-2\"><input id=flight-type type=checkbox name=flightType ng-click=\"flight_type ? editable.flight_types = [\'DEPARTURE\', \'ARRIVAL\', \'OVERFLIGHT\'] : editable.flight_types = []\" ng-model=flight_type><label translate for=flight-type>Flight Type</label></div><div ng-show=flight_type><div class=\"col-xs-12 col-md-1\"><input id=departure type=checkbox name=departure ng-true-value=\"\'DEPARTURE\'\" ng-false-value=null ng-model=editable.flight_types[0] ng-checked=\"editable.flight_types[0] ? true : \'\' \"><label translate for=departure>Departure</label></div><div class=\"col-xs-12 col-md-1\"><input id=arrival type=checkbox name=arrival ng-true-value=\"\'ARRIVAL\'\" ng-false-value=null ng-model=editable.flight_types[1] ng-checked=\"editable.flight_types[1] ? true : \'\' \"><label translate for=arrival>Arrivals</label></div><div class=\"col-xs-12 col-md-1\"><input id=overflight type=checkbox name=overflight ng-true-value=\"\'OVERFLIGHT\'\" ng-false-value=null ng-model=editable.flight_types[2] ng-checked=\"editable.flight_types[2] ? true : \'\' \"><label translate for=overflight>Overflights</label></div></div></div><div class=row><div class=\"col-xs-12 col-md-2\"><input id=flight-scope type=checkbox name=flightScope ng-click=\"flight_scope ? editable.flight_scopes = [\'DOMESTIC\', \'REGIONAL\', \'INTERNATIONAL\'] : editable.flight_scopes = []\" ng-model=flight_scope><label translate for=flight-scope>Flight Scope</label></div><div ng-show=flight_scope><div class=\"col-xs-12 col-md-1\"><input id=domestic type=checkbox name=domestic ng-true-value=\"\'DOMESTIC\'\" ng-false-value=null ng-model=editable.flight_scopes[0] ng-checked=\"editable.flight_scopes[0] ? true : \'\' \"><label translate for=domestic>Domestic</label></div><div class=\"col-xs-12 col-md-1\"><input id=regional type=checkbox name=regional ng-true-value=\"\'REGIONAL\'\" ng-false-value=null ng-model=editable.flight_scopes[1] ng-checked=\"editable.flight_scopes[1] ? true : \'\' \"><label translate for=regional>Regional</label></div><div class=\"col-xs-12 col-md-2\"><input id=international type=checkbox name=international ng-true-value=\"\'INTERNATIONAL\'\" ng-false-value=null ng-model=editable.flight_scopes[2] ng-checked=\"editable.flight_scopes[2] ? true : \'\' \"><label translate for=international>International</label></div></div></div><div class=row><div class=\"col-xs-12 col-md-2\"><input id=flight-schedule-type type=checkbox name=flightScheduleType ng-click=\"flight_category ? editable.flight_categories = [\'SCH\', \'NONSCH\'] : editable.flight_categories = []\" ng-model=flight_category><label translate for=flight-schedule-type>Flight Schedule Type</label></div><div ng-show=flight_category><div class=\"col-xs-12 col-md-1\"><input id=scheduled type=checkbox name=scheduled ng-true-value=\"\'SCH\'\" ng-false-value=null ng-model=editable.flight_categories[0] ng-checked=\"editable.flight_categories[0] ? true : \'\' \"><label translate for=scheduled>Scheduled</label></div><div class=\"col-xs-12 col-md-2\"><input id=nonscheduled type=checkbox name=nonscheduled ng-true-value=\"\'NONSCH\'\" ng-false-value=null ng-model=editable.flight_categories[1] ng-checked=\"editable.flight_categories[1] ? true : \'\' \"><label translate for=nonscheduled>Non-Scheduled</label></div></div></div><div class=row><div class=\"col-xs-12 col-md-2\"><input id=flight-rules type=checkbox name=flightRules ng-click=\"flight_rules ? editable.flight_rules = [\'I\', \'V\'] : editable.flight_rules = []\" ng-model=flight_rules><label translate for=flight-rules>Flight Rule</label></div><div ng-show=flight_rules><div class=\"col-xs-12 col-md-1\"><input id=ifr type=checkbox name=ifr ng-true-value=\"\'I\'\" ng-false-value=null ng-model=editable.flight_rules[0] ng-checked=\"editable.flight_rules[0] ? true : \'\' \"><label translate for=ifr>IFR</label></div><div class=\"col-xs-12 col-md-1\"><input id=vfr type=checkbox name=vfr ng-true-value=\"\'V\'\" ng-false-value=null ng-model=editable.flight_rules[1] ng-checked=\"editable.flight_rules[1] ? true : \'\' \"><label translate for=vfr>VFR</label></div></div></div></div><!--Box Content--></div><!--Box Container--></div><!--Full Width Column--><div class=\"col-xs-12 margin-top-20\"><div class=box-container><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=temporal-group>Temporal Group *</label><select id=temporal-group class=form-control name=temporalGroup ng-model=editable.temporal_group ng-change=\"editable.fiscal_year = false\" required><option translate value=\"\"></option><option translate value=year>Year</option><option translate value=quarter>Quarter</option><option translate value=month>Month</option><option translate value=week>Week</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=group-by>Group By</label><multiselect id=group-by name=groupByValues translated-value=name extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\', selectionLimit: 1 }\" options=groupByValues model=groupByModel events=\"{ onSelectionChanged: addGroupToList }\"></multiselect></div><div class=\"col-xs-12 col-md-2\"><label translate for=sort>Sort By *</label><ol id=my-sort class=sortable ng-model=editable.sort><li ng-repeat=\"item in sortList track by item.id\" data-index={{$index}}>{{item.name | translate}}</li></ol></div><div ng-show=\"editable.temporal_group === \'year\' || editable.temporal_group === \'quarter\'\" class=\"col-xs-12 col-md-3\"><input id=is-fiscal-year type=checkbox name=isFiscalYear ng-model=editable.fiscal_year><label translate for=is-fiscal-year>Group by Fiscal Year</label></div></div><!--End Row--></div></div></div></div></div><div class=\"col-xs-12 margin-top-20\"><div class=box-container><form novalidate action=# name=form onsubmit=\"return false\"><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=display-value>Values *</label><select ng-change=\"revenue_category = null;\" id=display-value class=form-control ng-model=display_value ng-options=\"display.value as display.name | translate for display in displayValues\" required></select></div><div ng-show=\"display_value === \'revenue_category\'\" class=\"col-xs-12 col-md-3\"><label translate for=revenue-category>Category</label><select id=revenue-category class=form-control ng-model=revenue_category ng-required=\"display_value === \'revenue_category\'\"><option translate value=sum_aerodrome_charges>Aerodrome Charges</option><option translate value=sum_approach_charges>Approach Charges</option><option translate value=sum_late_arrival_charges>Late Arrival Charges</option><option translate value=sum_late_departure_charges>Late Departure Charges</option><option translate value=sum_domestic_passenger_charges>Domestic Passenger Fees</option><option translate value=sum_international_passenger_charges>International Passenger Fees</option><option translate value=sum_parking_charges>Parking Charges</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=chart-type>Chart Type *</label><select id=chart-type name=chart-type class=form-control ng-model=chartType ng-change=\"showChart = false\" required><option translate value=bar>Bar</option><option translate value=line>Line</option><option translate value=pie>Pie</option></select></div><div class=\"col-xs-12 col-md-3\"><input id=display-values type=checkbox ng-init=\"display_values = true\" ng-model=display_values><label translate for=display-values>Display values</label></div></div><div class=row><div class=\"col-xs-12 col-md-4\"><button class=\"btn btn-primary btn-generate\" ng-disabled=\"form.$invalid || !control.getUTCStartDate() || !control.getUTCEndDate()\" ng-click=\"datapoints = []; generate(editable, control.getUTCStartDate(), control.getUTCEndDate(), groupBy, chartType); form.$setUntouched(); showChart=true\"><span translate>Generate</span></button> <button class=\"btn btn-primary\" ng-disabled=\"!datapoints.length || !showChart\"><div export-table chart-json=csvData filename=Air_Traffic_Data error=error format=csv button=true><span translate>Export CSV</span></div></button><export-pdf element=svg filename=Air_Traffic_Data error=error disable=\"!datapoints.length || !showChart\" orientation=landscape text=\"Export PDF\"></export-pdf></div></div><!--End Row--><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row ng-show=noData><div class=\"col-xs-6 col-xs-offset-3\"><div class=\"alert text-center infoAlert\"><span translate>NO DATA FOR THESE SELECTIONS</span></div></div></div></div></div></div></form></div></div><div class=\"chart-div-height col-xs-12 margin-top-10\" ng-if=\"datapoints.length > 0 && !noData && showChart\"><div class=box-container><div class=box-content><div class=row ng-if=\"chartType !==\'pie\'\"><c3chart bindto-id=chart id=chart labels-format-function=labelFormat chart-data=datapoints chart-columns=datacolumns chart-x=datax><chart-bar ratio=0.75><chart-axes values-x=x><chart-legend show-legend=true legend-position=bottom><chart-size chart-height={{chartHeight}}><chart-tooltip show-tooltip=true group-tooltip=true value-format-function=valueFormat><chart-axis><chart-axis-x axis-position=outer-right axis-label=\"{{ xlabel | translate }}\" axis-type=category><chart-axis-y axis-position=inner-right axis-label=\"{{ ylabel | translate }}\"><chart-axis-y-tick tick-format-function=labelFormat></chart-axis></c3chart></div><div class=row ng-if=\"chartType ===\'pie\'\"><c3chart bindto-id=pie-plot1-chart sort-data=desc><chart-column ng-repeat=\"item in datapoints\" column-id={{item.x}} column-values={{item.Amount}} column-type=pie><chart-pie expand=true show-label=true threshold-label=0.1></c3chart></div></div></div></div></div><!--End of Main Row-->");
$templateCache.put("app/partials/aircraft-exempt-management/aircraft-exempt-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=exemptions.exempt-aircraft-type-management icon=\"\'fighter-jet\'\" title=\"{{ \'Exempt Aircraft Types\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-6 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=aircraftExemptManagementService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th class=text-nowrap sort=aircraftType>{{\'A/C Type\' | translate}}</th><th class=text-nowrap sort=enrouteFeesExempt>{{\'Enroute Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=approachFeesExempt>{{\'Approach Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=aerodromeFeesExempt>{{\'Aerodrome Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=lateArrivalFeesExempt ng-if=\"shouldShowCharge(\'arrival\')\">{{\'Late Arrival Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=lateDepartureFeesExempt ng-if=\"shouldShowCharge(\'departure\')\">{{\'Late Departure Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=parkingFeesExempt ng-if=\"shouldShowCharge(\'parking\')\">{{\'Parking Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=internationalPax>{{\'International PAX Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=domesticPax>{{\'Domestic PAX Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=extendedHoursFeesExempt ng-if=\"shouldShowCharge(\'extendedHours\')\">{{\'Extended Hours Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=flightNotes>{{\'Flight Notes\' | translate}}</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); form.$setUntouched(); preview(item);\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.aircraft_type }}</td><td class=text-nowrap>{{ item.enroute_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.approach_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.aerodrome_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.international_pax | number: 2 }}</td><td class=text-nowrap>{{ item.domestic_pax | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Exempt Aircraft Types data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Create an Exempt Aircraft Type\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Edit an Exempt Aircraft Type\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'exempt_aircraft_type_modify\')\"><div class=row><div class=col-xs-6><label for=aircraft-type>{{\'Aircraft Type\' | translate}} *</label><dynamic-service-dropdown ng-model=editable.aircraft_type id=aircraft-type name=aircraftType dropdown-type=single service=::aircraftTypeManagementService is-required=::true options=\"item.aircraft_type as item.aircraft_type for item in list.content\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=enroute-fees-exempt>{{\'Enroute Fees Exempt\' | translate}} * (%)</label><input id=enroute-fees-exempt name=enrouteFeesExempt class=form-control ng-model=editable.enroute_fees_exempt type=number max=100 min=0 step=1></div><div class=\"col-xs-12 col-md-6\"><label for=approach-fees-exempt>{{\'Approach Fees Exempt\' | translate}} * (%)</label><input id=approach-fees-exempt name=approachFeesExempt class=form-control ng-model=editable.approach_fees_exempt type=number max=100 min=0 step=1></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome-fees-exempt>{{\'Aerodrome Fees Exempt\' | translate}} * (%)</label><input id=aerodrome-fees-exempt name=aerodromeFeesExempt class=form-control ng-model=editable.aerodrome_fees_exempt type=number max=100 min=0 step=1></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'arrival\')\"><label for=late-arrival-fees-exempt>{{\'Late Arrival Fees Exempt\' | translate}} * (%)</label><input id=late-arrival-fees-exempt name=lateArrivalFeesExempt class=form-control ng-model=editable.late_arrival_fees_exempt type=number max=100 min=0 step=1></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'departure\')\"><label for=late-departure-fees-exempt>{{\'Late Departure Fees Exempt\' | translate}} * (%)</label><input id=late-departure-fees-exempt name=lateDepartureFeesExempt class=form-control ng-model=editable.late_departure_fees_exempt type=number max=100 min=0 step=1></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking-fees-exempt>{{\'Parking Fees Exempt\' | translate}} * (%)</label><input id=parking-fees-exempt name=parkingFeesExempt class=form-control ng-model=editable.parking_fees_exempt type=number max=100 min=0 step=1></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=international-pax>{{\'International PAX Fees Exempt\' | translate}} * (%)</label><input id=international-pax name=internationalPax class=form-control ng-model=editable.international_pax type=number max=100 min=0 step=1></div><div class=\"col-xs-12 col-md-6\"><label for=domestic-pax>{{\'Domestic PAX Fees Exempt\' | translate}} * (%)</label><input id=domestic-pax name=domesticPax class=form-control ng-model=editable.domestic_pax type=number max=100 min=0 step=1></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'extendedHours\')\"><label for=extended-hours>{{\'Extended Hours Fees Exempt\' | translate}} * (%)</label><input id=extended-hours name=extendedHours class=form-control ng-model=editable.extended_hours_fees_exempt type=number max=100 min=0 step=1 required></div></div><!-- Flight Notes --><div class=row><div class=col-xs-12><label for=flight-notes>{{\'Flight Notes\' | translate}} *</label><textarea id=flight-notes name=flightNotes class=form-control type=text ng-model=editable.flight_notes ng-attr-title=\"{{editable.flight_notes ? \'\' : \'Please indicate which fees are exempt and why\' | translate}}\" required>\n                                </textarea></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/aircraft-flights-exemptions/aircraft-flights-exemptions.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=exemptions.exempt-aircraft-and-flights-management icon=\"\'paper-plane\'\" title=\"{{ \'Exempt Aircraft and Flights\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-6 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=aircraftFlightsExemptionsService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th class=text-nowrap sort=aircraftRegistration>{{\'Aircraft Registration\' | translate}}</th><th class=text-nowrap sort=flightId>{{\'Flight Id\' | translate}}</th><th class=text-nowrap sort=enrouteFeesExempt>{{\'Enroute Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=approachFeesExempt>{{\'Approach Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=aerodromeFeesExempt>{{\'Aerodrome Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=lateArrivalFeesExempt ng-if=\"shouldShowCharge(\'arrival\')\">{{\'Late Arrival Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=lateDepartureFeesExempt ng-if=\"shouldShowCharge(\'departure\')\">{{\'Late Departure Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=parkingFeesExempt ng-if=\"shouldShowCharge(\'parking\')\">{{\'Parking Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=internationalPax>{{\'International PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=domesticPax>{{\'Domestic PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=extendedHours ng-if=\"shouldShowCharge(\'extendedHours\')\">{{\'Extended Hours Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=unifiedTax>{{\'Unified Tax Fees Exempt\' | translate}}&nbsp;(%)</th><th class=text-nowrap sort=flightNotes>{{\'Flight Notes\' | translate}} (%)</th><th class=text-nowrap sort=exemptionStartDate>{{\'Exemption Start Date\' | translate}} (%)</th><th class=text-nowrap sort=exemptionEndDate>{{\'Exemption End Date\' | translate}} (%)</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); form.$setUntouched()\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.aircraft_registration }}</td><td class=text-nowrap>{{ item.flight_id }}</td><td class=text-nowrap>{{ item.enroute_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.approach_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.aerodrome_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.international_pax | number: 2 }}</td><td class=text-nowrap>{{ item.domestic_pax | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours | number: 2 }}</td><td class=text-nowrap>{{ item.unified_tax | number: 2 }}</td><td class=text-nowrap>{{ item.flight_notes }}</td><td class=text-nowrap>{{ item.exemption_start_date | dateConverter }}</td><td class=text-nowrap>{{ item.exemption_end_date | dateConverter }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=14 translate>There are no Exempt Aircraft and Flights data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'paper-plane\'\" title=\"{{ \'Create an Exempt Aircraft and Flights\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'paper-plane\'\" title=\"{{ \'Edit an Exempt Aircraft and Flights\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'exempt_aircraft_flights_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aircraft-registration>{{ \'Aircraft Registration\' | translate }} <span ng-show=!editable.flight_id>*</span></label><input id=aircraft-registration name=aircraftRegistration class=form-control type=text ng-model=editable.aircraft_registration maxlength=10 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false ng-required=!editable.flight_id uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=flight-id>{{ \'Flight Id\' | translate }} <span ng-show=!editable.aircraft_registration>*</span></label><input id=flight-id name=flightId class=form-control type=text ng-model=editable.flight_id minlength=2 maxlength=10 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false ng-required=!editable.aircraft_registration uppercase-input></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=enroute-fees-exempt>{{ \'Enroute Fees Exempt\' | translate }} * (%)</label><input id=enroute-fees-exempt name=enrouteFeesExempt class=form-control ng-model=editable.enroute_fees_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=approach-fees-exempt>{{ \'Approach Fees Exempt\' | translate }} * (%)</label><input id=approach-fees-exempt name=approachFeesExempt class=form-control ng-model=editable.approach_fees_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome-fees-exempt>{{ \'Aerodrome Fees Exempt\' | translate }} * (%)</label><input id=aerodrome-fees-exempt name=aerodromeFeesExempt class=form-control ng-model=editable.aerodrome_fees_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking-fees-exempt>{{ \'Parking Fees Exempt\' | translate }} * (%)</label><input id=parking-fees-exempt name=parkingFeesExempt class=form-control ng-model=editable.parking_fees_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'arrival\')\"><label for=late-arrival-fees-exempt>{{ \'Late Arrival Fees Exempt\' | translate }} * (%)</label><input id=late-arrival-fees-exempt name=lateArrivalFeesExempt class=form-control ng-model=editable.late_arrival_fees_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'departure\')\"><label for=late-departure-fees-exempt>{{ \'Late Departure Fees Exempt\' | translate }} * (%)</label><input id=late-departure-fees-exempt name=lateDepartureFeesExempt class=form-control ng-model=editable.late_departure_fees_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=international-pax>{{ \'International PAX Fees Exempt\' | translate }} * (%)</label><input id=international-pax name=internationalPax class=form-control ng-model=editable.international_pax type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=domestic-pax>{{ \'Domestic PAX Fees Exempt\' | translate }} * (%)</label><input id=domestic-pax name=domesticPax class=form-control ng-model=editable.domestic_pax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'extendedHours\')\"><label for=extended-hours>{{\'Extended Hours Fees Exempt\' | translate}} * (%)</label><input id=extended-hours name=extendedHours class=form-control ng-model=editable.extended_hours type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=unified-tax>{{\'Unified Tax Fees Exempt\' | translate}} * (%)</label><input id=unified-tax name=unifiedTax class=form-control ng-model=editable.unified_tax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=col-xs-12><label for=flight-notes>{{ \'Flight Notes\' | translate }} *</label><textarea id=flight-notes name=flightNotes class=form-control type=text ng-model=editable.flight_notes required ng-attr-title=\"{{editable.flight_notes ? \'\' : \'Please indicate which fees are exempt and why\' | translate}}\">\n                                </textarea></div></div><div class=row><date-range control=control is-required=::true start-name=\"Start Date *\" end-name=\"End Date *\" format=\"{{ customDate }}\"><!--Datepickers --></date-range></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); control.reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateOverride(editable, editable.id, control.getUTCStartDate(), control.getUTCEndDate()); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); control.reset(); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"createOverride(editable, control.getUTCStartDate(), control.getUTCEndDate()); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/aircraft-registration/aircraft-registration.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.aircraft-registration-management icon=\"\'fighter-jet\'\" title=\"{{ \'Aircraft Registrations\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button ng-click=refreshOverride() class=\"btn btn-primary pull-right\" translate>Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=aircraftRegistrationService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=registrationNumber>Registration Number</th><th translate class=text-nowrap sort=registrationStartDate>Start Date</th><th translate class=text-nowrap sort=registrationExpiryDate>Expiry Date</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=aircraftType.aircraftType>Aircraft Type</th><th class=\"text-nowrap text-right\" sort=mtowOverride><span>{{ \'MTOW Override\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th translate class=text-nowrap sort=createdBySelfCare>Created By Self-Care</th></tr></thead><tbody><tr ng-click=setEditable(item) ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.registration_number }}</td><td class=text-nowrap>{{ item.registration_start_date | dateConverter }}</td><td class=text-nowrap>{{ item.registration_expiry_date | dateConverter }}</td><td class=text-nowrap>{{ item.account.name | translate }}</td><td class=text-nowrap>{{ item.aircraft_type.aircraft_type }}</td><td class=text-right>{{ item.mtow_override | weightConverter }}</td><td>{{ item.created_by_self_care }}</td></tr><tr ng-show=!list.length><td class=text-center translate colspan=7>There are no Aircraft Registration data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Register an Aircraft\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Edit an Aircraft\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aircraft_registration_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=registration-number>Registration Number *</label><input id=registration-number name=registrationNumber class=\"form-control text-uppercase\" type=text ng-model=editable.registration_number ng-blur=\"editable.registration_number = editable.registration_number.toUpperCase();\n                                        getAircraftTypeByLatestRegistrationNumber(editable.registration_number);\n                                        getCountryByRegistrationNumberPrefix(editable.registration_number)\" minlength=2 maxlength=7 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false required></div><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account id=account name=account dropdown-type=single service=::accountsService method=findAllActiveMinimalReturn is-required=::true options=\"account as account.name for account in list track by account.id\"></dynamic-service-dropdown></div></div><div class=row><date-range control=control is-required=::true format={{customDate}} start-name=\"Start Date *\" end-name=\"Expiry Date *\"><!-- Datepickers --></date-range></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-type>{{\'Aircraft Type\' | translate}} *</label><dynamic-service-dropdown ng-model=editable.aircraft_type id=aircraft-type name=aircraftType dropdown-type=single service=::aircraftTypeManagementService is-required=::true options=\"item as item.aircraft_type for item in list.content | orderBy: \'aircraft_type\' track by item.id\" ng-change=convertMtowProperty(editable.aircraft_type)></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=mtow-override><span>{{ \'MTOW Override\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }}) *</span></label><unit-conversion-input id=mtow-override name=mtowOverride ng-model=editable.mtow_override measurement-type=weight required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=country-of-registration>Country of Registration *</label><dynamic-service-dropdown ng-model=editable.country_of_registration id=country-of-registration name=countryOfRegistration dropdown-type=single service=::countryManagementService is-required=::true ng-change=setLocal(editable.country_of_registration) options=\"item as (item.country_name | translate) for item in list.content track by item.id\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=country-override>Override country of registration</label><boolean-text ng-disabled=countryMatch name=countryOverride ng-model=editable.country_override class=form-control id=country-override ng-init=\"editable.country_override = false\"></boolean-text></div></div><div class=row><date-range control=control_coa is-required=::false format={{customDate}} start-name=\"Coa Issue Date\" end-name=\"Coa Expiry Date\"><!-- Datepickers --></date-range></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aircraft-service-date><span translate>Aircraft Service Date</span> <span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=aircraft-service-date name=aircraftServiceDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=editable.aircraft_service_date is-open=aircraftServiceDate.open ng-attr-title=\"{{editable.aircraft_service_date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"aircraftServiceDate.open = !aircraftServiceDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=is-local><span translate>Local</span></label><boolean-text name=isLocal ng-model=editable.is_local class=form-control id=is-local required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-scope>Aircraft Scope</label><select id=aircraft-scope name=aircraft-scope type=text class=form-control ng-model=editable.aircraft_scope><option selected=selected></option><option translate value=agriculture>Agriculture</option><option translate value=flight-school>Flight School</option></select></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"form.$setUntouched(); reset()\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=\"form.$invalid || editable.account.id === null || editable.aircraft_type.id === null || editable.country_of_registration.id === null || !(editable.country_override || countryMatch)\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, control, control_coa);saveOldValue(); form.$setUntouched();\" convert-to-tons property=mtow_override>Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id)>Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-show=\"editable.id === null\" ng-disabled=\"form.$invalid || editable.account.id === null || editable.aircraft_type.id === null || editable.country_of_registration.id === null || !(editable.country_override || countryMatch)\" convert-to-tons property=mtow_override conversion-complete=\"create(convertedEditable || editable, control, control_coa); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'fighter-jet\'\" title=\"{{ \'Upload Aircraft Registrations\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aircraft_registration_modify\')\"><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\')\" ng-disabled=!editable.document_filename>Upload</button><upload-file-format format={{pattern}} mtow={{mtowUnitOfMeasure}} template=app/partials/aircraft-registration/aircraft-registration.template.html></upload-file-format></div></div></fieldset></form></div></div></div></div></div></div>");
$templateCache.put("app/partials/aircraft-registration/aircraft-registration.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12><span class=text-center><h5>{{ \'Aircraft Registration File\' | translate }}</h5></span><ul><li>{{ \'Format\' | translate }}: {{ format }}</li><li>{{ \'Top\' | translate }} 1 {{ \'row is ignored\' | translate }}</li><li>{{ \'No column header\' | translate }}</li></ul><span>{{ \'Columns\' | translate }}:</span><ul><li>#1 - {{ \'Registration Number\' | translate }}</li><li>#2 - {{ \'Account Name\' | translate }}</li><li>#3 - {{ \'Start Date\' | translate }} ({{ \'dd-MM-yyyy\' | translate }})</li><li>#4 - {{ \'Expiry Date\' | translate }} ({{ \'dd-MM-yyyy\' | translate }})</li><li>#5 - {{ \'Aircraft Type\' | translate }}</li><li>#6 - {{ \'MTOW\' | translate }} ({{ mtow | translate }})</li></ul><span><strong>{{ \'NOTE\' | translate }}:</strong> {{ \'If you are creating a file in Excel, the first row must contain non-blank data otherwise Excel will remove any completely empty rows or columns\' | translate }}</span></div></div><div class=\"row margin-top-20\"><div class=text-center><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/aircraft-unspecified-management/aircraft-unspecified-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.unspecified-aircraft-type-management icon=\"\'paper-plane-o\'\" title=\"{{ \'Unspecified Aircraft Types\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive query-string=filterParameters sort-query-string=getSortQueryString() export-table sorted=false back-end-export=true service=aircraftUnspecifiedManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=textIdentifier>Text Identifier</th><th translate sort=name>Name</th><th translate sort=aircraftType>Aircraft Type</th><th class=text-right sort=mtow><span>{{ \'MTOW\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th translate sort=status>Status</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.text_identifier }}</td><td>{{ item.name }}</td><td>{{ item.aircraft_type }}</td><td class=text-right>{{ item.mtow | weightConverter }}</td><td>{{ item.status ? item.status.toUpperCase() : item.status | translate }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=5>There are no Unspecified Aircraft Types data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'paper-plane-o\'\" title=\"{{ \'Create Unspecified Aircraft Type\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'paper-plane-o\'\" title=\"{{ \'Edit Unspecified Aircraft Type\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'zzzz_aircraft_type_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text_identifier>Text Identifier *</label><input id=text_identifier name=textIdentifier class=form-control type=text ng-model=editable.text_identifier required uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label translate for=name>Name *</label><input id=name name=name class=form-control type=text ng-model=editable.name required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft_type>Aircraft Type</label><input id=aircraft_type name=aircraftType class=form-control type=text minlength=2 maxlength=4 ng-model=editable.aircraft_type ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=mtow><span>{{ \'MTOW\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }}) *</span></label><unit-conversion-input id=mtow name=mtow ng-model=editable.mtow measurement-type=weight required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, editable.id); form.$setUntouched();\" convert convert-to-tons property=mtow>Update</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button translate class=\"btn btn-primary\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-to-tons property=mtow conversion-complete=\"create(convertedEditable || editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/airspace-management/airspace-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'object-group\'\" page-name=management.airpsace-management title=\"{{ \'Select an Airspace\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-6><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=col-xs-6><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=airspaceManagementService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-center>Action</th><th translate sort=airspaceName>Identifier</th><th translate sort=airspaceFullName>Name</th><th translate sort=airspaceType>Type</th><th translate sort=airspaceIncluded>Included</th><th translate sort=airspaceCeiling>Ceiling</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{ \'highlight\': selectedItemId && item.id === editable.id }\"><td class=text-center><button ng-click=showAirspaceOnMap(item) class=\"btn btn-sm btn-primary\"><i class=\"fa fa-map-pin\"></i></button></td><td>{{ item.airspace_name }}</td><td>{{ item.airspace_full_name }}</td><td>{{ item.airspace_type }}</td><td>{{ item.airspace_included }}</td><td>{{ item.airspace_ceiling | number: 2}}</td></tr><tr ng-show=!list.length><td class=text-center colspan=6 translate>There are no Airspaces</td></tr></tbody></table></div><pagination-display></pagination-display></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'object-group\'\" page-name=management.airpsace-management.form title=\"{{ \'All Available Airspaces\' | translate }}\"></box-header><div class=box-content><div class=row ng-show=\"listFromNavDB === undefined\"><div class=col-xs-12><span translate ng-show=\"navDBError === undefined\">Please wait, loading airspaces from NavDB</span> <span translate ng-show=navDBError>Failed to retrieve airspaces from NavDB</span></div></div><div class=row ng-show=\"listFromNavDB !== undefined && !openForm\"><div class=col-xs-6><label for=type-of-airspace>{{\'Airspace Type\' | translate}} *</label><select id=type-of-airspace name=airspaceType class=form-control ng-model=airspaceType ng-change=filterAirspaceType(airspaceType) ng-options=\"o as o for o in [\'FIR\', \'FIR_P\', \'TMA\']\"><option translate value=\"\"></option></select></div><div class=col-xs-6><label for=select-airspace>{{\'Select an Airspace\' | translate}} *</label><div class=input-group><select id=select-airspace name=airspaceName class=form-control ng-model=navDBeditable ng-change=checkIfAirspaceAdded(navDBeditable.airspace_name) ng-options=\"item as item.airspace_name + \' (\' + item.airspace_type + \')\' for item in listFromNavDB | orderBy: \'airspace_name\' track by item.id\"></select><span class=input-group-btn><button ng-click=showAirspaceOnMapNavDb(navDBeditable) class=\"btn btn-primary\" ng-disabled=!navDBeditable><i class=\"fa fa-map-pin\"></i></button></span></div></div></div><!-- Editable form --><form novalidate action=# name=form onsubmit=\"return false\"><div class=row ng-show=\"openForm && listFromNavDB\"><div class=col-xs-6><label for=airspace-type>{{\'Airspace Type\' | translate}} *</label><input id=airspace-type name=airspaceType type=text class=form-control ng-model=editable.airspace_type required disabled=disabled></div><div class=col-xs-6><label for=airspace-name>{{\'Airspace Name\' | translate}} *</label><input id=airspace-name name=airspaceName type=text class=form-control ng-model=editable.airspace_full_name required disabled=disabled></div></div><div class=row ng-show=\"openForm && listFromNavDB\"><div class=col-xs-6><label for=airspace-included>{{\'Airspace Included\' | translate}} *</label><boolean-text class=form-control name=airspaceIncluded id=airspace-included ng-model=editable.airspace_included required></boolean-text></div><div class=col-xs-6><label for=airspace-ceiling>{{\'Airspace Ceiling\' | translate}} *</label><input id=airspace-ceiling name=airspaceCeiling type=number min=0 max=999 class=form-control ng-model=editable.airspace_ceiling required></div></div></form><!-- End of editable form --><div class=row ng-show=\"listFromNavDB !== undefined\"><div class=col-xs-12><button translate ng-show=!openForm class=\"btn btn-primary\" ng-click=create(navDBeditable.id) ng-disabled=\"airspaceAlreadyExists || !navDBeditable || !hasPermission(\'airspace_modify\')\">Add Airspace</button> <button translate class=\"btn btn-primary btn-reset\" ng-click=reset()>Clear</button> <span ng-if=airspaceAlreadyExists><span translate>This airspace has already been added</span></span> <button ng-show=openForm class=\"btn btn-primary btn-update\" translate ng-disabled=\"form.$invalid || !hasPermission(\'airspace_modify\')\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); setEmpty(); form.$setUntouched();\">Update</button> <button ng-show=openForm translate class=\"btn btn-primary\" ng-show=\"selectedItemId && selectedItemId === editable.id\" ng-disabled=\"!hasPermission(\'airspace_modify\')\" popup popup-text=\"Are you sure you want to remove this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Remove</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div>");
$templateCache.put("app/partials/aircraft-type-management/aircraft-type-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.aircraft-type-management icon=\"\'fighter-jet\'\" title=\"{{ \'Aircraft Types\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=aircraftTypeManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=aircraftType>Aircraft Type</th><th translate class=text-nowrap sort=aircraftName>Aircraft Name</th><th translate class=text-nowrap sort=manufacturer>Aircraft Manufacturer</th><th class=\"text-nowrap text-right\" sort=maximumTakeoffWeight><span>{{ \'MTOW Override\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.aircraft_type }}</td><td>{{ item.aircraft_name }}</td><td>{{ item.manufacturer }}</td><td class=text-right>{{ item.maximum_takeoff_weight | weightConverter }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=4 translate>There are no Aircraft Types data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Create an Aircraft Type\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Edit an Aircraft Type\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aircraft_type_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-type>Aircraft Type *</label><input id=aircraft-type class=form-control type=text ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false maxlength=4 minlength=2 name=aircraftType ng-model=editable.aircraft_type uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-name>Aircraft Name *</label><input id=aircraft-name name=aircraftName class=form-control type=text ng-model=editable.aircraft_name required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-manufacturer>Aircraft Manufacturer *</label><input id=aircraft-manufacturer name=aircraftManufacturer class=form-control type=text ng-model=editable.manufacturer required></div><div class=\"col-xs-12 col-md-6\"><label translate for=wake-turbulence>Wake Turbulence *</label><dynamic-service-dropdown ng-model=editable.wake_turbulence_category id=wake-turbulence name=wakeTurbulence dropdown-type=single service=::wakeTurbulenceCategoryService is-required=::true options=\"item as (item.name | translate) for item in list.content track by item.id\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=mtow><span>{{ \'MTOW\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }}) *</span></label><unit-conversion-input id=mtow name=maximumTakeoffWeight ng-model=editable.maximum_takeoff_weight measurement-type=weight required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid convert-to-tons property=maximum_takeoff_weight popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-to-tons property=maximum_takeoff_weight conversion-complete=\"create(convertedEditable || editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/amhs-accounts/amhs-accounts.html","<!-- vim: set ts=4 sts=4 sw=4 et: --><div class=row><div class=col-xs-12 ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.amhs-accounts icon=\"\'link\'\" title=\"{{ \'AMHS Accounts\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=amhsAccountsService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap>Active</th><th translate sort=addr,id class=text-nowrap>Address</th><th translate sort=descr,id class=text>Description</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.active }}</td><td class=text-nowrap>{{ item.addr }}</td><td class=text>{{ item.descr }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=23 translate>There are no AMHS accounts</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><!-- Form --><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'link\'\" title=\"{{ \'Create an account\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'link\'\" title=\"{{ \'Edit an account\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=col-xs-12><!-- active --><div class=row><div class=col-xs-2><input id=active ng-model=editable.active type=checkbox><label translate for=active>Active</label></div></div><!-- descr --><div class=row><div class=col-xs-12><label for=descr><span translate>Description</span></label><textarea ng-model=editable.descr id=descr name=descr class=form-control>\n                                    </textarea></div></div><!-- addr --><div class=row><div class=col-xs-12><label for=addr><span translate>Address</span></label><input id=addr class=form-control type=text ng-model=editable.addr name=addr required></div></div><!-- passwd --><div class=row><div class=col-xs-6><label for=passwd><span translate>Password</span></label><input id=addr class=form-control type=password ng-model=editable.passwd name=passwd required></div></div><!-- allow_mta_conn--><div class=row><div class=col-xs-6><input id=allow-mta-conn name=allowMtaConn ng-model=editable.allow_mta_conn type=checkbox><label translate for=allow-mta-conn>Allow MTA connections</label></div></div><!-- svc_hold_for_delivery --><div class=row><div class=col-xs-6><input id=svc-hold-for-delivery name=allowMtaConn ng-model=editable.svc_hold_for_delivery type=checkbox><label translate for=svc_hold_for_delivery>Svc Hold for Delivery</label></div></div></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><!-- Buttons --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=\"form.$invalid || !valid\" convert-to-tons property=upper_limit popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || !valid\" ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div><!-- End Form --></form></div></div></div></div>");
$templateCache.put("app/partials/amhs-connection/amhs-connection.html","<!-- vim: set ts=4 sts=4 sw=4 et: --><div class=row><div class=col-xs-12 ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.amhs-connection icon=\"\'link\'\" title=\"{{ \'AMHS Connection\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><button translate ng-click=startAgent() class=\"btn btn-primary\" ng-disabled=\"agentOperationInProgress || !agent_status.installed || agent_status.started\">Start agent</button>&nbsp; <button translate ng-click=stopAgent() class=\"btn btn-primary\" ng-disabled=\"agentOperationInProgress || !agent_status.installed || !agent_status.started\">Stop agent</button>&nbsp; <button translate ng-click=restartAgent() class=\"btn btn-primary\" ng-disabled=\"agentOperationInProgress || !agent_status.installed || !agent_status.started\">Restart agent</button>&nbsp;</div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=amhsConnectionService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap>Active</th><th translate sort=remoteHostname,id class=text-nowrap>Remote Host</th><th translate sort=descr,id class=text-nowrap>Description</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.active }}</td><td class=text-nowrap>{{ item.remote_hostname }}</td><td class=text>{{ item.descr }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=23 translate>There are no AMHS Connections</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div><div class=row><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div><!-- Form --><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'link\'\" title=\"{{ \'Create a Connection\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'link\'\" title=\"{{ \'Edit a Connection\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=col-xs-12><!-- active --><div class=row><div class=col-xs-2><input id=active ng-model=editable.active type=checkbox><label translate for=active>Active</label></div></div><!-- descr --><div class=row><div class=col-xs-12><label for=descr><span translate>Description</span></label><textarea ng-model=editable.descr id=descr name=descr class=form-control>\n                                    </textarea></div></div><!-- protocol, max_connections --><div class=row><div class=col-xs-6><label for=protocol><span translate>Protocol</span><span> *</span></label><select ng-model=editable.protocol id=protocol name=protocol class=form-control required><option value=P1>P1</option><option value=P3>P3</option></select></div><div class=col-xs-6><label for=max-conn><span translate>Max connections</span><span> [1..100] *</span></label><input id=max-conn class=form-control type=number ng-model=editable.max_conn name=maxConn onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" min=1 max=100 maxlength=3 required></div></div><!-- ping_enabled, ping_delay --><div class=row><div class=col-xs-6><input id=ping-enabled name=pingEnabled ng-model=editable.ping_enabled type=checkbox><label translate for=ping-enabled>Enable ping messages</label></div><div class=col-xs-6><label for=ping-delay><span translate>Ping delay (seconds)</span></label><input id=ping-delay class=form-control type=number ng-model=editable.ping_delay name=pingDelay onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" ng-disabled=!editable.ping_enabled ng-required=!editable.ping_enabled min=10 max=3600 maxlength=3></div></div><!-- network_device --><!-- dpanech: we don\'t want to see this (requested by Wener) --><!--\n                            <div class=\"row\">\n                                <div class=\"col-xs-6\">\n                                    <label for=\"network-device\">\n                                        <span translate>Network Device</span>\n                                    </label>\n                                    <input id=\"network-device\" class=\"form-control\" type=\"text\"\n                                           ng-model=\"editable.network_device\" name=\"networkDevice\"\n                                           pattern=\"^\\s*[a-zA-Z0-9:._-]*\\s*$\"\n                                           input-format=\"letters, digits, \':\', \'.\', \'_\' and \'-\'\"\n                                           maxlength=100 />\n                                </div>\n                            </div>\n                            --><!-- rtse_checkpoint_size, rtse_window_size --><div class=row><div class=col-xs-6><label for=rtse-checkpoint-size><span translate>RTSE Checkpoint Size (KB)</span><span> *</span></label><input id=rtse-checkpoint-size name=rtseCheckpointSize class=form-control type=number onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" ng-model=editable.rtse_checkpoint_size min=1 max=1024 required></div><div class=col-xs-6><label for=rtse-window-size><span translate>RTSE Window Size (KB)</span><span> *</span></label><input id=rtse-window-size name=rtseWindowSize class=form-control type=number onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" ng-model=editable.rtse_window_size min=1 max=1024 required></div></div><!-- local_hostname, local_ipaddr--><div class=row><div class=col-xs-6><label for=local-hostname><span translate>Local MTA name</span></label><input id=local-hostname class=form-control type=text ng-model=editable.local_hostname name=localHostname input-format=\"letetrs, digits, \'-\', \'.\' and \'_\'\" pattern=^[a-zA-Z0-9._-]+$></div><!-- dpanech: we don\'t want to see this: requested by Werner --><!--\n                                <div class=\"col-xs-6\">\n                                    <label for=\"local-ipaddr\">\n                                        <span translate>Local IP Address</span>\n                                    </label>\n                                    <input id=\"local-ipaddr\" class=\"form-control\" type=\"text\" ng-model=\"editable.local_ipaddr\" name=\"localIpaddr\"\n                                           input-format=\"[0-255].[0-255].[0-255].[0-255]\"\n                                           pattern=\"^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$\"\n                                           ng-disabled=\"editable.local_hostname.trim().length == 0\"/>\n                                </div>\n                                --></div><!-- local_port, local_bind_authenticated, local_passwd --><div class=row><div class=col-xs-6><label for=local-port><span translate>Local Port</span><span> *</span></label><input id=local-port class=form-control type=number ng-model=editable.local_port name=localPort onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" min=1 max=65535 required></div><div class=col-xs-6><label for=local-passwd><input id=local-bind-authenticated name=localBindAuthenticated ng-model=editable.local_bind_authenticated type=checkbox> <span translate>Local MTA Password</span></label><input id=local-passwd name=localPasswd class=form-control type=password ng-model=editable.local_passwd ng-disabled=!editable.local_bind_authenticated ng-required=!editable.local_bind_authenticated></div></div><!-- local_tsap_addr, local_tsap_addr_is_hex --><div class=row><div class=col-xs-6><label for=local-tsap-addr><span translate>Local TSAP</span><span> *</span></label><input id=local-tsap-addr name=localTsapAddr class=form-control type=text ng-model=editable.local_tsap_addr maxlength=40/ ></div><div class=col-xs-6><input id=local-tsap-addr-is-hex name=localTsapAddrIsHex ng-model=editable.local_tsap_addr_is_hex type=checkbox><label translate for=local-tsap-addr-is-hex>Local TSAP is in hex</label></div></div><!-- remote_hostname, remote_ipaddr --><div class=row><div class=col-xs-6><label for=remote-hostname><span translate>Remote MTA Name</span><span> *</span></label><input id=remote-hostname class=form-control type=text ng-model=editable.remote_hostname name=remoteHostname required input-format=\"letetrs, digits, \'-\', \'.\' and \'_\'\" pattern=^[a-zA-Z0-9_.-]+$></div><!-- dpanech: we don\'t want to see this: requested by Werner --><!--\n                                <div class=\"col-xs-6\">\n                                    <label for=\"remote-ipaddr\">\n                                        <span translate>Remote IP Address</span>\n                                    </label>\n                                    <input id=\"remote-ipaddr\" class=\"form-control\" type=\"text\" ng-model=\"editable.remote_ipaddr\" name=\"remoteIpaddr\"\n                                           input-format=\"[0-255].[0-255].[0-255].[0-255]\"\n                                           pattern=\"^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$\"/>\n                                </div>\n                                --></div><!-- remote_port, remote_bind_authenticated, remote_passwd --><div class=row><div class=col-xs-6><label for=remote-port><span translate>Remote Port</span><span> *</span></label><input id=remote-port class=form-control type=number ng-model=editable.remote_port name=remotePort onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" min=1 max=65535 required></div><div class=col-xs-6><label for=remote-passwd><input id=remote-bind-authenticated name=remoteBindAuthenticated ng-model=editable.remote_bind_authenticated type=checkbox> <span translate>Remote MTA Password</span></label><input id=remote-passwd name=remotePasswd class=form-control type=password ng-model=editable.remote_passwd ng-disabled=!editable.remote_bind_authenticated ng-required=editable.remote_bind_authenticated></div></div><!-- remote_tsap_addr, remote_tsap_addr_is_hex --><div class=row><div class=col-xs-6><label for=remote-tsap-addr><span translate>Remote TSAP</span><span> *</span></label><input id=remote-tsap-addr name=remoteTsapAddr class=form-control type=text ng-model=editable.remote_tsap_addr required></div><div class=col-xs-6><input id=remote-tsap-addr-is-hex name=remoteTsapAddrIsHex ng-model=editable.remote_tsap_addr_is_hex type=checkbox><label translate for=remote-tsap-addr-is-hex>Remote TSAP is in hex</label></div></div><!-- remote_idle_time, remote_class_extended --><div class=row><div class=col-xs-6><label for=remote-idle-time><span translate>Keep remote connection open (seconds)</span><span> [1..86400] *</span></label><input id=remote-idle-time name=remoteIdleTime class=form-control type=number onkeypress=\"return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57\" ng-model=editable.remote_idle_time min=1 max=86400 required></div><div class=col-xs-6 ng-show=\"editable.protocol === \'P3\'\"><label for=psap-addr><span translate>PSAP</span></label><input id=psap-addr name=psapAddr class=form-control type=text ng-model=editable.psap_addr></div></div><!-- remote_class_extended --><div class=row><div class=col-xs-6><div><input id=remote-class-extended name=remoteClassExtended ng-model=editable.remote_class_extended type=checkbox><label translate for=remote-class-extended>Use extended options</label></div><div><div><input id=remote-latest-delivery-time type=checkbox ng-model=editable.remote_latest_delivery_time ng-disabled=!editable.remote_class_extended><label translate for=remote-latest-delivery-time>Latest Delivery Time</label></div><div><input id=remote-dl-exp-prohibit type=checkbox ng-model=editable.remote_dl_exp_prohibit ng-disabled=!editable.remote_class_extended><label translate for=remote-dl-exp-prohibit>DL Expansion Prohibited</label></div><div><input id=remote-content-corr type=checkbox ng-model=editable.remote_content_corr ng-disabled=!editable.remote_class_extended><label translate for=remote-content-corr>Content Correlator</label></div><div><input id=remote-internal-trace type=checkbox ng-model=editable.remote_internal_trace ng-disabled=!editable.remote_class_extended><label translate for=remote-internal-trace>Internal Trace</label></div><div><input id=remote-rcpt-reass-prohibit type=checkbox ng-model=editable.remote_rcpt_reass_prohibit ng-disabled=!editable.remote_class_extended><label translate for=remote-rcpt-reass-prohibit>Recipient Reassignment Prohibited</label></div></div></div></div></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><!-- Buttons --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=\"form.$invalid || !valid\" convert-to-tons property=upper_limit popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || !valid\" ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div><!-- End Form --></form></div></div></div></div>");
$templateCache.put("app/partials/aodb/aodb.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=flight-data.radar-flight-strip-management icon=\"\'rss\'\" title=\"{{ \'AODB Flights\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\'\"><!--Datepickers --></date-range></div><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=aodbService endpoint-param=/filters><table style=\"table-layout: auto\" class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=runwayDateTime>Day of Flight</th><th translate class=text-nowrap sort=runwayDateTime>Dep Time</th><th translate class=text-nowrap sort=runwayDateTime>Arr Time</th><th translate class=text-nowrap sort=ad>Departure Aerodrome</th><th translate class=text-nowrap sort=da>Destination Aerodrome</th><th translate class=text-nowrap sort=reg>Reg Number</th><th translate class=text-nowrap sort=toa>A/C Type</th><th translate class=text-nowrap sort=mtow>Mtow (Kg)</th><th translate class=text-nowrap sort=callsign>Callsign</th><th translate class=text-nowrap sort=airline>Account</th><!-- <th translate class=\"text-nowrap text-right\">Remark</th> --></tr></thead><tbody><tr ng-repeat=\"item in list\"><td>{{ item.runway_date_time | date:\'yyyy-MM-dd\' }}</td><td>{{ item.atd | date:\'HHmm\' }}</td><td>{{ item.ata | date:\'HHmm\' }}</td><td>{{ item.ad }}</td><td>{{ item.da }}</td><td>{{ item.reg }}</td><td>{{ item.toa }}</td><td>{{ item.mtow | number:0 }}</td><td>{{ item.callsign }}</td><td>{{ item.airline }}</td><!-- <td class=\"text-right\">{{ item.remark }}</td> --></tr><tr ng-show=!list.length><td class=text-center colspan=10 translate>There are no Aodb Flights</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/application-management/application-management.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=management.application-management icon=\"\'cog\'\" title=\"{{ \'Application Management\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-3><label translate for=caching-retention>Route Caching Retention</label><input id=caching-retention type=number pattern=[0-9]+ class=form-control ng-model=numberToRetain max=\"{{ (item.range.split(\'-\')[1] === \'maxint\' ? 2147483647 : item.range.split(\'-\')[1]) }}\" min=\"{{ item.range.split(\'-\')[0] }}\"></div><div class=col-xs-3><label translate for=current-entries>Current Cache Entries</label><input id=current-entries type=text ng-model=currentEntries size=7 class=form-control readonly=readonly></div></div><div class=row><div class=col-xs-5><button translate ng-disabled=\"!hasPermission(\'route_cache_modify\')\" class=\"btn btn-primary\" popup popup-text=\"Are you sure you want to update the retention number?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=updateNumberToRetain(numberToRetain)>Update</button> <button translate ng-disabled=\"!hasPermission(\'route_cache_modify\')\" class=\"btn btn-primary\" popup popup-text=\"Are you sure you want to clear the current cache?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=clearCache()>Clear Cache</button></div></div></div></div></div></div>");
$templateCache.put("app/partials/atc-movement-log/atc-movement-log.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><!-- atc movemnt logs container --><div class=box-container><box-header toggle=toggle page-name=flight-data.atc-movement-log-management icon=\"\'book\'\" title=\"{{ \'ATC Movement Logs\' | translate }}\"></box-header><div class=box-content><!-- atc movement logs data grid filters --><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\'\"><!--Datepickers --></date-range></div><!-- atc movement logs data grid actions --><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><!-- atc movement logs data grid --><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=atcMovementLogService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=dayOfFlight>Day Of Flight</th><th translate class=text-nowrap sort=departureTime>Dep Time</th><th translate class=text-nowrap sort=dateOfContact>Date Of Contact</th><th translate class=text-nowrap sort=flightId>Flight Id</th><th translate class=text-nowrap sort=registration>Reg Number</th><th translate class=text-nowrap sort=operatorIdentifier>Operator Identifier</th><th translate class=text-nowrap sort=aircraftType>A/C Type</th><th translate class=text-nowrap sort=flightType>Flight Type</th><th translate class=text-nowrap sort=departureAerodrome>Dep Ad</th><th translate class=text-nowrap sort=destinationAerodrome>Dest Ad</th><th translate class=text-nowrap sort=firEntryPoint>Entry Point</th><th translate class=text-nowrap sort=firEntryTime>Entry Time</th><th translate class=text-nowrap sort=firMidPoint>Mid Point</th><th translate class=text-nowrap sort=firMidTime>Mid Time</th><th translate class=text-nowrap sort=firExitPoint>Exit Point</th><th translate class=text-nowrap sort=firExitTime>Exit Time</th><th translate class=text-nowrap sort=flightLevel>Flight Level</th><th translate class=text-nowrap sort=wakeTurbulence>WTC</th><th translate class=text-nowrap sort=route>Route</th><th translate class=text-nowrap sort=flightCategory>Flight Category</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.day_of_flight | dateConverter }}</td><td>{{ item.departure_time }}</td><td>{{ item.date_of_contact | dateConverter }}</td><td>{{ item.flight_id }}</td><td>{{ item.registration }}</td><td>{{ item.operator_identifier }}</td><td>{{ item.aircraft_type }}</td><td>{{ item.flight_type | translate | uppercase }}</td><td>{{ item.departure_aerodrome }}</td><td>{{ item.destination_aerodrome }}</td><td>{{ item.fir_entry_point }}</td><td>{{ item.fir_entry_time }}</td><td>{{ item.fir_mid_point }}</td><td>{{ item.fir_mid_time }}</td><td>{{ item.fir_exit_point }}</td><td>{{ item.fir_exit_time }}</td><td>{{ item.flight_level }}</td><td>{{ item.wake_turbulence | translate }}</td><td class=text-nowrap>{{ item.route }}</td><td>{{ item.flight_category | translate | uppercase }}</td></tr><tr ng-show=!list.length><td class=text-center translate colspan=20>There are no ATC Movement Logs data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><!-- create/edit atc movement log container --><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'book\'\" title=\"{{ \'Create an ATC Movement Log\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'book\'\" title=\"{{ \'Edit an ATC Movement Log\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_log_modify\')\"><!-- atc movement log form fields --><div class=row><div class=\"col-xs-12 col-md-6\"><label for=day_of_flight><span translate>Day of Flight</span>&nbsp;(<span translate>{{ ::dateFormat }}</span>)</label><p class=input-group><date-picker id=day_of_flight name=dayOfFlight type=text ng-change=\"dateChanged(\'day_of_flight\', editable.day_of_flight)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.day_of_flight is-open=atcDayOfFlight.open ng-blur=\"resolveAircraftType(editable.registration, editable.day_of_flight || editable.date_of_contact)\" ng-attr-title=\"{{editable.day_of_flight ? \'\' : \'Please fill out this field\' | translate}}\" ng-disabled=\"editable.id !== null\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"atcDayOfFlight.open = !atcDayOfFlight.open\" ng-disabled=\"editable.id !== null\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=departure_time><span translate>Departure Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=departure_time name=departureTime class=form-control type=text ng-model=editable.departure_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.departure_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ ng-model-options=\"{allowInvalid: true}\" ng-disabled=\"editable.id !== null\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=date_of_contact><span translate>Date of Contact</span>&nbsp;<span translate>({{ ::dateFormat }}) *</span></label><p class=input-group><date-picker id=date_of_contact name=dateOfContact type=text ng-change=\"dateChanged(\'date_of_contact\', editable.date_of_contact)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.date_of_contact is-open=atcContactDate.open ng-blur=\"resolveAircraftType(editable.registration, editable.day_of_flight || editable.date_of_contact)\" ng-attr-title=\"{{editable.date_of_contact ? \'\' : \'Please fill out this field\' | translate}}\" ng-disabled=\"editable.id !== null\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"atcContactDate.open = !atcContactDate.open\" ng-disabled=\"editable.id !== null\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_id>Flight Identifier *</label><input id=flight_id name=flightId class=form-control type=text ng-model=editable.flight_id maxlength=10 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false ng-model-options=\"{allowInvalid: true}\" uppercase-input ng-disabled=\"editable.id !== null\" required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=registration>Registration</label><input id=registration name=registration class=form-control type=text ng-model=editable.registration ng-blur=\"resolveAircraftType(editable.registration, editable.day_of_flight || editable.date_of_contact)\" maxlength=7 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input ng-model-options=\"{allowInvalid: true}\"></div><div class=\"col-xs-12 col-md-6\"><label translate for=operator_identifier>Operator Identifier</label><input id=operator_identifier name=operatorIdentifier class=form-control type=text ng-model=editable.operator_identifier maxlength=100 ng-trim=false uppercase-input></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft_type>{{\'Aircraft Type\' | translate}} *</label><dynamic-service-dropdown ng-model=editable.aircraft_type id=aircraft_type name=aircraftType dropdown-type=single service=::aircraftTypeManagementService method=findAllMinimalReturn is-required=::true options=\"item.aircraft_type as item.aircraft_type for item in list\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_type>Flight Type *</label><select id=flight_type name=flightType class=form-control ng-model=editable.flight_type ng-options=\"item.value as (item.name | translate) for item in flightTypes\" required></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=departure_aerodrome>Departure Aerodrome *</label><input id=departure_aerodrome name=departureAerodrome type=text class=form-control ng-model=editable.departure_aerodrome maxlength=100 ng-trim=false ng-model-options=\"{allowInvalid: true}\" ng-disabled=\"editable.id !== null\" only-letters uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=destination_aerodrome>Destination Aerodrome *</label><input id=destination_aerodrome name=destinationAerodrome type=text class=form-control ng-model=editable.destination_aerodrome maxlength=100 ng-trim=false ng-model-options=\"{allowInvalid: true}\" only-letters uppercase-input required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=fir_entry_point>FIR Entry Point</label><input id=fir_entry_point name=firEntryPoint class=form-control ng-model=editable.fir_entry_point type=text ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=fir_entry_time><span translate>FIR Entry Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=fir_entry_time name=firEntryTime class=form-control ng-model=editable.fir_entry_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_entry_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=fir_entry_point>FIR Second Point</label><input id=fir_second_point name=firSecondPoint class=form-control ng-model=editable.fir_second_point type=text ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=fir_second_time><span translate>FIR Second Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=fir_second_time name=firSecondTime class=form-control ng-model=editable.fir_second_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_entry_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=fir_mid_point>FIR Mid Point</label><input id=fir_mid_point name=firMidPoint class=form-control ng-model=editable.fir_mid_point type=text ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=fir_mid_time><span translate>FIR Mid Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=fir_mid_time name=firMidTime class=form-control ng-model=editable.fir_mid_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_mid_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=fir_fourth_point>FIR Fourth Point</label><input id=fir_fourth_point name=firMidPoint class=form-control ng-model=editable.fir_fourth_point type=text ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=fir_fourth_time><span translate>FIR Fourth Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=fir_fourth_time name=firMidTime class=form-control ng-model=editable.fir_fourth_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_mid_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=fir_fifth_point>FIR Fifth Point</label><input id=fir_fifth_point name=firMidPoint class=form-control ng-model=editable.fir_fifth_point type=text ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=fir_fifth_time><span translate>FIR Fifth Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=fir_fifth_time name=firMidTime class=form-control ng-model=editable.fir_fifth_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_mid_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=fir_exit_point>FIR Exit Point</label><input id=fir_exit_point name=firExitPoint class=form-control ng-model=editable.fir_exit_point type=text ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label for=fir_exit_time><span translate>FIR Exit Time</span>&nbsp;<span translate>(<span tranlate>HHmm</span>)</span></label><input id=fir_exit_time name=firExitTime class=form-control ng-model=editable.fir_exit_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_exit_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=flight_level><span translate>Flight Level</span>&nbsp;<span translate>(<span tranlate>Fnnn</span>)</span></label><input id=flight_level name=flightLevel class=form-control ng-model=editable.flight_level uppercase-input type=text></div><div class=\"col-xs-12 col-md-6\"><label translate for=wake_turbulence>Wake Turbulence</label><dynamic-service-dropdown ng-model=editable.wake_turbulence id=wake_turbulence name=wakeTurbulence dropdown-type=single service=::wakeTurbulenceCategoryService options=\"item.name as (item.name | translate) for item in list.content\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=route>Route *</label><input id=route name=route class=form-control ng-model=editable.route type=text uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_category>Flight Category *</label><select id=flight_category name=flightCategory class=form-control ng-model=editable.flight_category ng-options=\"item.value as (item.name | translate) for item in flightCategories\" required></select></div></div><!-- atc movement log form errors --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><!-- atc movement log form actions --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div><!-- upload atc moevment logs container --><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'book\'\" title=\"{{ \'Upload an ATC Movement Log\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_log_modify\')\"><!-- atc movement logs upload fields --><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><!-- atc movement logs upload feeback --><div class=row><div class=col-xs-12><upload-feedback><!-- Upload Feedback --></upload-feedback></div></div><!-- atc movement logs upload actions --><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=\"!editable.document_filename || !acceptedFileType\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\'); form.$setUntouched(); reset();\">Upload</button></div></div></fieldset></form></div></div></div></div></div></div>");
$templateCache.put("app/partials/aviation-billing-engine/aviation-billing-engine.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=billing.aviation-billing-engine icon=\"\'plane\'\" title=\"{{ \'Aviation Billing\' | translate }}\"></box-header><div class=box-content><fieldset><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=invoice_type>Invoice Type *</label><select id=invoice_type name=status ng-change=\"setBillingInterval(); editable.flights = null; editable.incompleteFlights = null;\n                                setDefaultFlights(editable.iata_status);\" ng-model=editable.iata_status class=form-control required><option translate value=iata ng-if=iataSupported>IATA</option><option translate value=non-iata>NON-IATA</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=account_type>{{\'Account Type\' | translate }} *</label><select id=account_type name=status ng-init=\"editable.account_type = \'all\'\" ng-change=\"updateAccounts(editable.account_type); editable.flights = null; editable.incompleteFlights = null; selectedAccounts = [];\n                                setIntervalPeriodForUnifiedTax(editable.account_type); setFlightMovementCategory(editable.account_type)\" ng-model=editable.account_type class=form-control required ng-options=\"item.id as (item.name | translate) for item in accountTypes\"></select></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=billing_interval>Billing Interval *</label><select id=billing_interval name=billing_interval class=form-control ng-model=editable.billing_interval ng-change=setMonthlyDates() required><option ng-if=\"editable.account_type != 8\" translate value=WEEKLY>Weekly</option><option ng-if=\"editable.account_type != 8\" translate value=MONTHLY>Monthly</option><option ng-if=\"editable.account_type === 8\" translate value=UNIFIED_TAX_ANNUALLY>Annual</option><option ng-if=\"editable.account_type === 8\" translate value=UNIFIED_TAX_PARTIALLY>Partial</option><option ng-if=\"editable.account_type != 8\" translate value=OPEN>Open</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><div ng-show=\"editable.billing_interval === \'WEEKLY\'\"><label for=end_date>{{ \'End Date Of Invoice *\' | translate }} (<span translate>yyyy-MM-dd</span>)</label><p class=input-group><date-picker id=end_date name=end_date type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.end_date is-open=open datepicker-options=dateOptions close-text=Close ng-change=setWeekStartDate() required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-show=\"editable.billing_interval === \'MONTHLY\'\"><label for=billing-period><span translate>Billing Period</span>&nbsp;*&nbsp;(<span translate>yyyy-MM</span>)</label><p class=input-group><input id=billing_period name=billing_period type=text class=form-control ng-change=setMonthlyDates() uib-datepicker-popup=yyyy-MM ng-required=true close-text=Close ng-model=dateObject is-open=open datepicker-options=\"{ formatYear: \'yyyy-MM\', startingDay: 1, minMode: \'month\' }\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-show=\"editable.billing_interval === \'UNIFIED_TAX_ANNUALLY\'\"><label for=billing_period_annually>{{ \'Billing period *\' | translate }} (<span translate>yyyy</span>)</label><p class=input-group><input id=billing_period_annually name=billing_period_annually type=text ng-pattern=datePickerRegex class=form-control uib-datepicker-popup=yyyy ng-model=dateObject is-open=open ng-change=setAnnuallyDates() datepicker-options=dateOptionsAnnually required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-show=\"editable.billing_interval === \'UNIFIED_TAX_PARTIALLY\'\"><label for=billing_period_partially>{{ \'Billing period *\' | translate }} (<span translate>yyyy-MM</span>)</label><p class=input-group><input id=billing_period_partially name=billing_period_partially type=text class=form-control uib-datepicker-popup=yyyy-MM ng-model=dateObject is-open=open ng-change=setPartiallyDates() datepicker-options=dateOptionsPartially required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-xs-12 col-sm-12 col-md-6\" ng-show=\"editable.billing_interval === \'OPEN\'\"><date-range is-required=false control=control format=yyyy-MM-dd ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\"><!--Datepickers --></date-range></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-3\"><label for=accounts><span translate>Accounts</span> <span ng-show=\"editable.iata_status === \'iata\'\" translate>(Preview Invoice)</span> <span ng-show=\"editable.iata_status !== \'iata\'\">*</span></label><multiselect id=accounts name=accountIdList extra-settings=\"{ displayProp: \'name\' }\" options=listOfAccounts model=selectedAccounts></multiselect></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=sort>Sort By *</label><select id=sort name=sort ng-init=\"editable.sort = \'account,dateTime\'\" ng-model=editable.sort class=form-control required><option translate value=dateTime,account>Date, Account</option><option translate value=account,dateTime>Account, Date</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=userBillingCenterOnly>Select Flights *</label><select class=form-control ng-model=editable.userBillingCenterOnly id=userBillingCenterOnly name=userBillingCenterOnly ng-init=\"editable.iata_status === \'iata\' ? editable.userBillingCenterOnly = \'false\' : editable.userBillingCenterOnly = \'true\'\" required><option translate value=true>Show flights for billing centre</option><option translate value=false>Show all flights</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\" ng-if=::invoiceByFmCategory ng-show=\" editable.account_type != 8 \"><label for=flightCategory><span translate>Flight Movement Category</span> <span>*</span></label><dynamic-service-dropdown class=text-capitalize id=flightCategory allow-empty=true name=flightCategory ng-model=editable.flightCategory options=\"item.id as (item.name | translate).toLowerCase() for item in list\" dropdown-type=single service=::flightMovementCategoryService method=getFlightMovementCategoryForAviationInvoice is-required=::invoiceByFmCategory></dynamic-service-dropdown></div></div><div class=row><div class=col-xs-12><button translate ng-disabled=\"(processing === true || !hasPermission(\'aviation_invoice_validate\')\n                            || ((editable.billing_interval === \'MONTHLY\' || editable.billing_interval === \'UNIFIED_TAX_PARTIALLY\' || editable.billing_interval === \'UNIFIED_TAX_ANNUALLY\') && !dateObject)\n                            || (editable.billing_interval === \'WEEKLY\' && !editable.end_date))\n                            || (editable.billing_interval === \'OPEN\' && (control.start.date === null || control.end.date === null))\" class=\"btn btn-primary\" ng-click=\"editable.flights = null; editable.incompleteFlights = null; closeHeader(); validate();\">Validate</button> <button translate ng-disabled=\"(processing === true || !hasPermission(\'aviation_invoice_validate\')\n                            || ((editable.billing_interval === \'MONTHLY\' || editable.billing_interval === \'UNIFIED_TAX_PARTIALLY\' || editable.billing_interval === \'UNIFIED_TAX_ANNUALLY\') && !dateObject)\n                            || (editable.billing_interval === \'WEEKLY\' && !editable.end_date))\n                            || (editable.billing_interval === \'OPEN\' && (control.start.date === null || control.end.date === null))\" ng-show=\"recalculateJob.job_execution_status !== \'STARTED\' && recalculateJob.job_execution_status !== \'QUEUED\'\" ng-click=openRecalculationPopup() class=\"btn btn-primary\">Recalculate</button> <button translate ng-show=\"recalculateJob.job_execution_status === \'STARTED\' || recalculateJob.job_execution_status === \'QUEUED\'\" ng-click=cancelRecalculation(); class=\"btn btn-default\">Cancel Recalculate</button> <button translate ng-disabled=\"processing === true || (!selectedAccounts.length && editable.iata_status !== \'iata\')\n                                || ((editable.billing_interval === \'MONTHLY\' || editable.billing_interval === \'UNIFIED_TAX_PARTIALLY\' || editable.billing_interval === \'UNIFIED_TAX_ANNUALLY\') && !dateObject)\n                                || (editable.billing_interval === \'WEEKLY\' && !editable.end_date)\n                                || (editable.billing_interval === \'OPEN\' && (control.start.date === null || control.end.date === null))\n                                || (editable.account_type!=8 && !( invoiceByFmCategory === false || editable.flightCategory)) || !hasPermission(\'aviation_invoice_generate\')\" ng-show=\"generateJob.job_execution_status !== \'STARTED\' && generateJob.job_execution_status !== \'QUEUED\'\" ng-click=\"editable.flights = null; editable.incompleteFlights = null;  closeHeader(); executeGeneration(0);\" class=\"btn btn-primary\">Generate Invoice</button> <button translate ng-disabled=\"processing === true || (!selectedAccounts.length && editable.iata_status !== \'iata\')\n                                || ((editable.billing_interval === \'MONTHLY\' || editable.billing_interval === \'UNIFIED_TAX_PARTIALLY\' || editable.billing_interval === \'UNIFIED_TAX_ANNUALLY\') && !dateObject)\n                                || (editable.billing_interval === \'WEEKLY\' && !editable.end_date)\n                                || (editable.billing_interval === \'OPEN\' && (control.start.date === null || control.end.date === null))\n                                || (editable.account_type!=8 && !( invoiceByFmCategory === false || editable.flightCategory)) || !hasPermission(\'aviation_invoice_preview\')\" ng-show=\"generateJob.job_execution_status !== \'STARTED\' && generateJob.job_execution_status !== \'QUEUED\'\" ng-click=\"editable.flights = null; editable.incompleteFlights = null;  closeHeader(); executeGeneration(1);\" class=\"btn btn-primary\">Preview Invoice</button> <button translate ng-show=\"processing === true && generateJob.job_execution_status === \'STARTED\' || generateJob.job_execution_status === \'QUEUED\'\" ng-click=cancelGeneration(); class=\"btn btn-default\">Cancel Invoice</button><!-- Overlay per inibire il resto della pagina --><div ng-show=showRecalculationPopup class=overlay></div><div ng-if=showRecalculationPopup class=popup><div class=popup-content><form name=recalculationForm><label><input type=checkbox ng-model=$parent.selectAll ng-change=toggleSelectAll()> <span translate>Select All</span></label><div ng-repeat=\"option in recalculationOptions\"><label><input type=checkbox ng-model=option.selected ng-change=updateSelectAll()> {{ option.name | translate }}</label></div><div class=popup-buttons><button translate type=button ng-click=executeRecalculation();closeRecalculationPopup(); class=\"btn btn-primary\" ng-disabled=!isAnyOptionSelected()>Confirm</button> <button translate type=button ng-click=closeRecalculationPopup() class=\"btn btn-secondary\">Cancel</button></div></form></div></div></div></div><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></fieldset></div></div></div></div><div class=\"row margin-top-20\" ng-show=editable.incompleteFlights><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Incomplete Flight Movements\' | translate }} ({{ editable.incompleteFlights.length }})\" show-close=true close-func=closeHeader()></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive sort-query-string=getSortQueryString()><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride();><thead><tr><th translate class=text-nowrap sort=operator>Operator</th><th translate class=text-nowrap>Flight Id</th><th translate class=text-nowrap>Registration Number</th><th translate class=text-nowrap>Day of Flight</th><th translate class=text-nowrap>Departure Time</th><th translate class=text-nowrap>Status</th><th translate class=text-nowrap>Issues</th></tr></thead><tbody><tr ng-repeat=\"item in editable.incompleteFlights | orderBy: incompleteFlightSort(editable.sort)\"><td class=text-nowrap>{{ item.account_name}}</td><td class=text-nowrap>{{ item.flight_id }}</td><td class=text-nowrap>{{ item.registration }}</td><td class=text-nowrap>{{ item.day_of_flight | dateConverter}}</td><td class=text-nowrap>{{ item.departure_time }}</td><td class=text-nowrap>{{ item.status }}</td><td class=text-nowrap>{{ item.issues.join(\', \') }}</td></tr><tr ng-show=!editable.incompleteFlights.length><td class=text-center colspan=7 translate>There are no incomplete flight movements</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row margin-top-20\" ng-show=recalculateJob><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Recalculating Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=feedback><u translate>Recalculation</u> <span ng-show=\"processing === false && recalculateJob.job_execution_status !== \'STARTED\' && recalculateJob.job_execution_status !== \'QUEUED\'\" class=\"btn btn-sm pull-right\" ng-click=\"recalculateJob = null;\">X</span><br><span translate>Period:</span> <span>&nbsp;{{ recalculateJob.job_parameters }}</span><br><span translate>Started:</span> <span>&nbsp;{{ recalculateJob.start_time | dateConverter: \'HH:mm\' }}</span><br><span translate>Status:</span>&nbsp; <span translate>{{ recalculateJob.job_execution_status }}</span><br><span translate>Total Records:</span> <span>&nbsp;{{ recalculateJob.total_steps }}</span><br><span translate>Processed:</span> <span>&nbsp;{{ recalculateJob.steps_completed + recalculateJob.steps_aborted }}</span><br><span translate>ETC:</span> <span>&nbsp;{{ recalculateJob.etc_time | dateConverter: \'HH:mm\' }}</span> <span ng-show=recalculateJob.seconds_left>&nbsp;({{ recalculateJob.seconds_left }})</span><br><span translate>Rate:</span> <span>&nbsp;{{ recalculateJob.rate }}</span><br><br><uib-progressbar max=recalculateJob.total_steps value=\"recalculateJob.steps_completed + recalculateJob.steps_aborted\" ng-show=\"recalculateJob.job_execution_status !== \'STARTING\'\" style=\"height: 10px\"></uib-progressbar></div></div></div></div></div></div></div><div class=\"row margin-top-20\" ng-show=\"generateJob && generateJob.job_execution_status !== \'CANCELED\'\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Generate/Preview Invoice\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=feedback style=\"width: 600px\"><u translate>Generate/Preview Invoice</u> <span class=\"btn btn-sm pull-right\" ng-show=\"processing === false\" ng-click=\"generateJob = null;\">X</span><br><span translate>Period:</span> <span>&nbsp;{{ generateJob.job_parameters }}</span><br><span translate>Started:</span> <span>&nbsp;{{ generateJob.start_time | dateConverter: \'HH:mm\' }}</span><br><span class=highlightBold translate>Status:</span>&nbsp; <span class=highlightBold translate>{{ generateJob.job_execution_status }}</span><br><span translate>Total Records:</span> <span>&nbsp;{{ generateJob.total_steps }}</span><br><span translate>Processed:</span> <span>&nbsp;{{ generateJob.steps_completed + generateJob.steps_aborted }}</span><br><span translate>ETC:</span> <span>&nbsp;{{ generateJob.etc_time | dateConverter: \'HH:mm\' }}</span> <span ng-show=generateJob.seconds_left>&nbsp;({{ generateJob.seconds_left }})</span><br><span translate>Rate:</span> <span>&nbsp;{{ generateJob.rate }}</span><br><span class=highlightBold translate>Message:</span> <span class=highlightBold ng-show=generateJob.message>&nbsp;<span translate>{{ generateJob.message }}</span></span> <span class=highlightBold ng-show=!generateJob.message>&nbsp;<span translate>Initializing ...</span></span><br><div class=table-responsive ng-show=generateJob.unifiedTaxErrors.length><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap>Registration Number</th><th translate class=text-nowrap>Reason of Missed Invoice</th></tr></thead><tbody><tr ng-repeat=\"item in generateJob.unifiedTaxErrors\"><td class=text-nowrap>{{ item.account_name}}</td><td class=text-nowrap>{{ item.registration }}</td><td translate class=text-nowrap>{{ item.reason }}</td></tr><tr ng-show=!generateJob.unifiedTaxErrors.length><td class=text-center colspan=7 translate>There are no unified tax invoice errors movements</td></tr></tbody></table></div><br><span ng-show=generateJob.accountName><span translate>Account:</span> <span><span>&nbsp;{{ generateJob.accountName }} ({{ generateJob.accountNumber }} of {{ generateJob.accountsTotal }})</span> </span><span ng-show=generateJob.flightsTotal><br><span translate>Flights:</span> <span ng-show=generateJob.flightsTotal><span>&nbsp;Processing {{ generateJob.flightNumber }} of {{ generateJob.flightsTotal }}</span></span></span></span><br><br><uib-progressbar ng-show=generateJob.accountsTotal max=generateJob.accountsTotal value=\"getProgressBarValue(generateJob.accountsTotal, generateJob.accountNumber, generateJob.flightsTotal, generateJob.flightNumber)\" style=\"height: 10px\"></uib-progressbar></div></div></div></div></div></div></div><div class=row ng-show=preview><div class=\"col-sm-12 preview-oauth2-container\"><button class=\"btn btn-xs preview-oauth2-close\" ng-click=\"hide = true; preview = null;\"><i class=\"fa fa-close\"></i></button><div ng-bind-html=preview><!-- iframe renders in here --></div></div></div>");
$templateCache.put("app/partials/bank-account-management/bank-account-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=management.banking-account-management toggle=toggle icon=\"\'book\'\" title=\"{{ \'Bank Accounts\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-keyup=\"$event.keyCode == 13 && refresh()\" ng-model=search></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=bankAccountManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=name>Bank Name</th><th translate class=text-nowrap sort=number>Account Number</th><th translate class=text-nowrap sort=currency>Currency</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ ::item.name }}</td><td class=text-nowrap>{{ ::item.number }}</td><td class=text-nowrap>{{ ::item.currency.currency_code }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=6>There are no Bank Accounts data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'book\'\" title=\"{{ \'Add a Bank Account\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'book\'\" title=\"{{ \'Edit a Bank Account\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'banking_information_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-6\"><label for=name><span translate>Bank Name</span> <span>*</span></label><input id=name name=name class=form-control type=text ng-model=editable.name required></div><div class=\"col-xs-12 col-md-6\"><label for=number><span translate>Account Number</span> <span>*</span></label><input id=number name=number class=form-control type=text ng-model=editable.number required></div><div class=\"col-xs-12 col-md-6\"><label for=currency><span translate>Currency</span> <span>*</span></label><dynamic-service-dropdown id=currency name=currency dropdown-type=single query-string=\"filter=active\" is-required=::true options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in list.content track by item.currency_code\" ng-model=editable.currency service=::currencyManagementService></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=external-accounting-system-id><span translate>External Accounting System Identifier</span> <span ng-if=requireExternalSystemId>*</span></label><input id=external-accounting-system-id name=externalAccountingSystemId class=form-control type=text empty-to-null ng-model=editable.external_accounting_system_id ng-required=requireExternalSystemId></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/billing-centre-management/billing-centre-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=management.billing-centre-management toggle=toggle icon=\"\'book\'\" title=\"{{ \'Billing Centres\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=billingCentreManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=name>Name</th><th translate class=text-nowrap sort=hq>Headquarters</th><th translate class=text-nowrap sort=prefixInvoiceNumber>Invoice Prefix</th><th translate class=\"text-right text-nowrap\" sort=invoiceSequenceNumber>Invoice Sequence Number</th><th ng-show=iataInvoiceSeparatedSeqNumber translate class=\"text-right text-nowrap\" sort=iataInvoiceSequenceNumber>IATA Invoice Sequence Number</th><th translate class=text-nowrap sort=prefixReceiptNumber>Receipt Prefix</th><th translate class=\"text-right text-nowrap\" sort=receiptSequenceNumber>Receipt Sequence Number</th><th ng-show=receiptSeqNumberByPayMechanism translate class=\"text-right text-nowrap\" sort=receiptChequeSequenceNumber>Receipt Cheque Sequence Number</th><th ng-show=receiptSeqNumberByPayMechanism translate class=\"text-right text-nowrap\" sort=receiptWireSequenceNumber>Receipt Wire Sequence Number</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.name }}</td><td class=text-nowrap>{{ item.hq | translate }}</td><td class=text-nowrap>{{ item.prefix_invoice_number }}</td><td class=\"text-right text-nowrap\">{{ item.invoice_sequence_number }}</td><td ng-show=iataInvoiceSeparatedSeqNumber class=\"text-right text-nowrap\">{{ item.iata_invoice_sequence_number }}</td><td class=text-nowrap>{{ item.prefix_receipt_number }}</td><td class=\"text-right text-nowrap\">{{ item.receipt_sequence_number }}</td><td ng-show=receiptSeqNumberByPayMechanism class=\"text-right text-nowrap\">{{ item.receipt_cheque_sequence_number }}</td><td ng-show=receiptSeqNumberByPayMechanism class=\"text-right text-nowrap\">{{ item.receipt_wire_sequence_number }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=9>There are no Billing Centres data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'book\'\" title=\"{{ \'Add a Billing Centre\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'book\'\" title=\"{{ \'Edit a Billing Centre\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'billing_center_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=name>Name *</label><input id=name name=name class=form-control type=text ng-model=editable.name required></div><div class=\"col-xs-12 col-md-6\"><label translate for=hq>Headquarters *</label><boolean-text ng-model=editable.hq id=hq name=hq class=\"form-control text-capitalize\" ng-change=checkHq(editable) required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=prefix-invoice-number>Invoice Prefix</label><input id=prefix-invoice-number name=prefixInvoiceNumber class=form-control type=text ng-model=editable.prefix_invoice_number ng-pattern=/^[a-zA-Z0-9]+$/ ></div><div class=\"col-xs-12 col-md-6\"><label for=invoice-sequence-number><span translate>Invoice Sequence Number</span> *</label><input ng-disabled=\"editable.id !== null\" id=invoice-sequence-number name=invoiceSequenceNumber class=form-control type=number min=0 max=2147483647 ng-model=editable.invoice_sequence_number ng-pattern=/^\\d+$/ required></div></div><div class=row ng-show=iataInvoiceSeparatedSeqNumber><div class=\"col-xs-12 col-md-6\"><label for=iata_invoice_sequence_number><span translate>IATA Invoice Sequence Number</span> *</label><input ng-disabled=\"editable.id !== null\" id=iata_invoice_sequence_number name=iataInvoiceSequenceNumber class=form-control type=number min=0 max=2147483647 ng-model=editable.iata_invoice_sequence_number ng-pattern=/^\\d+$/ ng-required=iataInvoiceSeparatedSeqNumber></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=prefix-receipt-number>Receipt Prefix</label><input id=prefix-receipt-number name=prefixReceiptNumber class=form-control type=text ng-model=editable.prefix_receipt_number ng-pattern=/^[a-zA-Z0-9]+$/ ></div><div class=\"col-xs-12 col-md-6\"><label for=receipt-sequence-number><span translate>Receipt Sequence Number</span> *</label><input ng-disabled=\"editable.id !== null\" id=receipt-sequence-number name=receiptSequenceNumber class=form-control type=number min=0 max=2147483647 ng-model=editable.receipt_sequence_number ng-pattern=/^\\d+$/ required></div></div><div class=row ng-show=receiptSeqNumberByPayMechanism><div class=\"col-xs-12 col-md-6\"><label for=receipt_cheque_sequence_number><span translate>Receipt Cheque Sequence Number</span> *</label><input ng-disabled=\"editable.id !== null\" id=receipt_cheque_sequence_number name=receiptChequeSequenceNumber class=form-control type=number min=0 max=2147483647 ng-model=editable.receipt_cheque_sequence_number ng-pattern=/^\\d+$/ ng-required=receiptSeqNumberByPayMechanism></div><div class=\"col-xs-12 col-md-6\"><label for=receipt_wire_sequence_number><span translate>Receipt Wire Sequence Number</span> *</label><input ng-disabled=\"editable.id !== null\" id=receipt_wire_sequence_number name=receiptWireSequenceNumber class=form-control type=number min=0 max=2147483647 ng-model=editable.receipt_wire_sequence_number ng-pattern=/^\\d+$/ ng-required=receiptSeqNumberByPayMechanism></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=external-accounting-system-id><span translate>External Accounting System Identifier</span> <span ng-if=requireExternalSystemId>*</span></label><input id=external-accounting-system-id name=externalAccountingSystemIdentifier class=form-control ng-model=editable.external_accounting_system_identifier maxlength=20 ng-required=requireExternalSystemId></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); headquarter = false; form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\" update-warning=\"{{ updateWarning }}\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\" delete-warning=\"{{ deleteWarning }}\">Delete</button> <button translate ng-if=\"!createWarning && !updateWarning\" class=\"btn btn-primary btn-create\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button> <button translate ng-if=createWarning class=\"btn btn-primary btn-create\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" popup popup-text=\"Are you sure you want to create billing centre without designated headquarter?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"create(editable); form.$setUntouched();\" create-warning=\"{{ createWarning }}\">Create</button> <button translate ng-if=updateWarning class=\"btn btn-primary btn-create\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" popup popup-text=\"Are you sure you want to create billing centre without designated headquarter?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"create(editable); form.$setUntouched();\" create-warning=\"{{ updateWarning }}\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/cached-events/cached-events.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=management.cached-event-management icon=\"\'cog\'\" title=\"{{ \'Cached Events\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-keyup=\"$event.keyCode == 13 && refresh()\" ng-model=search></div><div class=\"col-xs-12 col-md-6 text-right margin-top-20\"><button translate class=\"btn btn-primary\" ng-click=refresh()>Refresh</button> <button translate class=\"btn btn-primary\" ng-click=retry(editable.id) ng-disabled=\"editable === null || editable.id === null || retryInProgress\" ng-if=\"hasPermission(\'manage_cached_event_modify\')\">Retry</button> <button translate class=\"btn btn-primary\" ng-disabled=\"editable === null || editable.id === null || retryInProgress\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id); ng-if=\"hasPermission(\'manage_cached_event_modify\')\">Delete</button></div></div><div class=row><div class=col-xs-12><div ng-show=message class=error-handling-container><div class=\"alert alert-dismissible alert-icon\" ng-class=\"{ \'alert-success\': !message.thrown, \'alert-warning\': message.thrown }\" role=alert><button type=button ng-click=\"message = null\" class=close data-dismiss=alert>×</button> <span ng-if=!message.thrown class=\"glyphicon glyphicon-ok-sign icon\" aria-hidden=true></span> <span ng-if=message.thrown class=\"glyphicon glyphicon-warning-sign icon\" aria-hidden=true></span> <strong translate>Response:</strong> <span ng-if=message.title><span>{{message.title | translate}}</span></span> <span ng-if=\"!message.title && message.thrown\"><span translate>Retry failed for unknown reason...</span></span> <span ng-if=\"!message.title && !message.thrown\"><span translate>Successfully completed retry attempt!</span></span><p ng-if=message.description><strong translate>Description:</strong> {{ message.description | translate }}</p></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div><div class=row><div class=col-xs-12><span id=cached-events-status class=text-muted ng-if=nextRetryCycle><i class=\"fa fa-cog\"></i> <span translate>System will retry all cached events on</span>&nbsp;<span>{{ nextRetryCycle | dateConverter: \'\\\' HH:mm\' }}</span></span><div class=table-responsive><div class=table-responsive export-table sort-query-string=getSortQueryString() service=cachedEventsService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=metadata.type>Type</th><th translate sort=metadata.resource>Resource</th><th translate sort=metadata.action>Action</th><th translate sort=retryCount>Attempts</th><th translate>Last Attempt</th></tr></thead><tbody><tr ng-click=edit(item) ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id, \'text-danger\': !item.retry}\"><td ng-bind-html=\"::(commaSeperate(item.metadata, \'type\') || \'OTHER\') | highlight:highlightSearch\"></td><td ng-bind-html=\"::(commaSeperate(item.metadata, \'resource\') || item.target) | highlight:highlightSearch\"></td><td ng-bind-html=\"::(commaSeperate(item.metadata, \'action\') || item.method_name) | highlight:highlightSearch\"></td><td>{{ ::item.retry_count }}</td><td>{{ ::item.last_attempt | dateConverter: \'\\\'at\\\' HH:mm\' }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=5>There are no cached events pending.</td></tr></tbody></table></div></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div class=row ng-show=\"editable !== null && editable.id !== null\"><div class=col-xs-12><div class=\"box-container margin-top-20\"><box-header icon=\"\'cogs\'\" title=\"{{ \'Cached Event Result(s)\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!editable.results.length || editable.results === undefined\"><span translate>There are no results related to the selected cached event.</span></div><div ng-if=editable.results.length><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>Response</th><th translate>Message</th><th translate>Date / Time</th><th translate>User</th></tr></thead><tbody><tr ng-repeat=\"item in editable.results | orderBy:\'-created_at\' | limitTo : 5 : (editable.results.number * 5) - 5\"><td ng-bind-html=\"::item.clazz | highlight:highlightSearch\"></td><td ng-bind-html=\"::item.result | highlight:highlightSearch\"></td><td>{{ ::item.created_at | dateConverter: \'/ HH:mm:ss\' }}</td><td>{{ ::item.created_by }}</td></tr></tbody></table></div></div><ul uib-pagination total-items=editable.results.length max-size=::20 ng-model=editable.results.number items-per-page=::5 class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div class=row ng-show=\"editable.metadata !== null && editable.metadata.length > 0\"><div class=col-xs-12><div class=\"box-container margin-top-20 cached-event-metadata-container\"><box-header icon=\"\'clipboard\'\" title=\"{{ \'Cached Event Statement(s)\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 cached-event-metadata\" ng-repeat=\"item in editable.metadata\" ng-init=\"item.view = false\"><figure><figcaption><span ng-show=\"editable.metadata.length > 1\">{{ ::$index + 1 }}:</span> {{ ::item.type }} {{ ::item.action }} <span ng-show=item.resource>on <code>{{ ::item.resource }}</code> </span><span class=\"text-muted pull-right md-pull-left\"><a href=\"\" ng-click=\"item.view = !item.view\">{{ item.view ? \'Hide\' : \'Show\' }}</a> | <a copy-to-clipboard=\"\'statement-\' + ($index + 1)\">Copy to Clipboard</a></span></figcaption><pre id=\"statement-{{ ::$index + 1 }}\" class=\"pre-scrollable pre-wordwrap\" ng-show=item.view-statement><code ng-bind-html=\"::item.statement | highlight:highlightSearch\"></code></pre></figure></div></div></div></div></div></div>");
$templateCache.put("app/partials/catalogue-service-charge/catalogue-service-charge.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=charges-and-formulas.service-charge-catalogue-managment icon=\"\'retweet\'\" title=\"{{ \'Service Charge Catalogue\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text empty-to-null ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=catalogueServiceChargeService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=chargeClass>Charge Class</th><th translate class=text-nowrap sort=category>Category</th><th translate class=text-nowrap sort=type>Type</th><th translate class=text-nowrap sort=subType>Subtype</th><th translate class=text-nowrap sort=description>Description</th><th translate class=text-nowrap sort=currency>Currency</th><th translate class=\"text-nowrap text-right\" sort=minimumAmount>Min Amount</th><th translate class=\"text-nowrap text-right\" sort=maximumAmount>Max Amount</th><th translate class=\"text-nowrap text-right\" sort=amount>Actual Amount</th><th translate class=text-nowrap sort=basisCharge>Basis for Charge</th><th translate class=text-nowrap sort=basisCharge>Invoice Category</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td translate class=text-nowrap>{{ item.charge_class }}</td><td class=text-nowrap>{{ item.category }}</td><td class=text-nowrap>{{ item.type }}</td><td class=text-nowrap>{{ item.subtype }}</td><td class=text-nowrap>{{ item.description }}</td><td class=text-nowrap>{{ item.currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ item.minimum_amount | number: 2 }}</td><td class=\"text-nowrap text-right\">{{ item.maximum_amount | number: 2 }}</td><td class=\"text-nowrap text-right\">{{ item.amount | number: 2 }}</td><td class=text-nowrap>{{ item.charge_basis | translate }}</td><td class=text-nowrap>{{ item.invoice_category | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Service Charge Catalogue data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'retweet\'\" title=\"{{ \'Create Service Charge Catalogue\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'retweet\'\" title=\"{{ \'Edit Service Charge Catalogue\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'service_charge_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=charge_class>Charge Class *</label><input id=charge_class name=chargeClass class=form-control type=text ng-model=editable.charge_class required></div><div class=\"col-xs-12 col-md-6\"><label translate for=category>Category *</label><input id=category name=category class=form-control type=text ng-model=editable.category required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=type>Type *</label><input id=type name=type class=form-control type=text ng-model=editable.type required></div><div class=\"col-xs-12 col-md-6\"><label translate for=subtype>Subtype *</label><input id=subtype name=subtype class=form-control type=text ng-model=editable.subtype required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=description>Description *</label><input id=description name=description class=form-control type=text ng-model=editable.description required></div><div class=\"col-xs-12 col-md-6\"><label for=currency><span translate>Currency *</span></label><select class=form-control id=currency name=externalDatabaseForCharge ng-model=editable.currency ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in currencies.content track by item.currency_code\" required></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=minimum_amount>Minimum Amount *</label><input id=minimum_amount name=minimumAmount class=form-control type=number min=0 ng-model=editable.minimum_amount required></div><div class=\"col-xs-12 col-md-6\"><label translate for=maximum_amount>Maximum Amount *</label><input id=maximum_amount name=maximumAmount class=form-control type=number min=0 ng-model=editable.maximum_amount required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=amount>Actual Amount</label><span ng-show=\"editable.charge_basis === \'fixed\' || editable.charge_basis === \'unit\' || editable.charge_basis === \'percentage\'\">*</span><input ng-disabled=\"editable.charge_basis === \'water\' || editable.charge_basis === \'residential-electric\' || editable.charge_basis === \'commercial-electric\' || editable.charge_basis === \'user\' || editable.charge_basis === \'discount\' || editable.charge_basis === \'external-database\'\" ng-required=\"editable.charge_basis === \'fixed\' || editable.charge_basis === \'unit\' || editable.charge_basis === \'percentage\'\" id=amount name=amount class=form-control type=number min=0 ng-model=editable.amount></div><div class=\"col-xs-12 col-md-6\"><label translate for=charge_basis>Basis For Charge *</label><select class=form-control id=charge_basis name=chargeBasis ng-model=editable.charge_basis ng-options=\"t.value as (t.name.toLowerCase() | translate) for t in basisList\" ng-change=\"editable.charge_basis === \'water\'|| editable.charge_basis === \'residential-electric\' || editable.charge_basis === \'commercial-electric\' || editable.charge_basis === \'user\' || editable.charge_basis === \'discount\' ? editable.amount = null : \'\'\" required></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=invoice_category>Invoice Category *</label><select class=form-control id=invoice_category name=invoiceCategory ng-model=editable.invoice_category ng-options=\"t.value as (t.name.toLowerCase() | translate) for t in categoryList\" required></select></div><div class=\"col-xs-12 col-md-6\"><label for=external-accounting-system-id><span translate>External Accounting System Identifier</span> <span ng-if=requireExternalSystemId>*</span></label><input class=form-control name=externalAccountingSystemIdentifier id=external-accounting-system-id ng-model=editable.external_accounting_system_identifier maxlength=20 ng-required=requireExternalSystemId></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=external-charge-category><span translate>External Charge Category</span> <span>*</span></label><dynamic-service-dropdown id=external-charge-category name=externalChargeCategory dropdown-type=single service=::externalChargeCategoryService is-required=::true options=\"item as (item.name | translate) for item in list track by item.id\" ng-model=editable.external_charge_category></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\" ng-if=\"editable.charge_basis === \'external-database\'\"><label translate for=external_database_for_charge>External database for charge *</label><select class=form-control id=external_database_for_charge name=externalDatabaseForCharge ng-model=editable.external_database_for_charge ng-options=\"t.value as (t.name | translate) for t in externalDatabaseList\" required></select></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><div><button translate class=\"btn btn-primary btn-reset\" ng-click=\"reset(); form.$setUntouched();\" type=button>Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/country-management/country-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.country-management icon=\"\'flag\'\" title=\"{{ \'Countries\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-2 pull-right\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=countryManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=countryCode class=text-nowrap>Country Code</th><th translate sort=countryName class=text-nowrap>Country Name</th><th translate class=text-nowrap>Aircraft Registration Prefixes</th><th translate class=text-nowrap>Aerodrome Prefixes</th><th translate class=text-nowrap ng-if=isEANS>CRCO Member</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.country_code }}</td><td class=text-nowrap>{{ item.country_name | translate }}</td><td class=text-nowrap>{{ prefixArrayToString(item.aircraft_registration_prefixes, \"aircraft_registration_prefix\") }}</td><td class=text-nowrap>{{ prefixArrayToString(item.aerodrome_prefixes, \"aerodrome_prefix\") }}</td><td class=text-nowrap ng-if=isEANS>{{ item.crco_member }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=4>There is no Countries data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'flag\'\" title=\"{{ \'Add a Country\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'flag\'\" title=\"{{ \'Edit a Country\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset><!-- add permission here --><div class=row><div class=\"col-xs-12 col-md-{{ isLocaleEnglish() ? \'6\' : \'4\' }}\"><label translate for=country-code>Country Code *</label><input id=country-code name=countryCode class=form-control type=text ng-model=editable.country_code maxlength=3 only-letters uppercase-input required></div><div class=\"col-xs-12 col-md-{{ isLocaleEnglish() ? \'6\' : \'4\' }}\"><label for=country-name><span translate>Country Name</span> (EN) *</label><input id=country-name name=countryName class=form-control type=text ng-model=editable.country_name required></div><div class=\"col-xs-12 col-md-4\" ng-if=!isLocaleEnglish()><label translate for=country-name>Country Name</label><input name=\"\" disabled=disabled ng-disabled class=\"form-control disabled\" type=text ng-model=\"editable.country_name | translate\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-registration-prefixes>Aircraft Registration Prefixes *</label><input id=aircraft-registration-prefixes name=aircraftRegistrationPrefixes class=form-control type=text ng-model=editable.aircraft_registration_prefixes_input ng-pattern=/^(([A-Za-z0-9]{1,2})((,(\\W)?[A-Za-z0-9]{1,2})+)?)$/ uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=aerodrome-prefixes>Aerodrome Prefixes *</label><input id=aaerodrome-prefixes name=aerodromePrefixes class=form-control type=text ng-model=editable.aerodrome_prefixes_input ng-pattern=/^(([A-Za-z]{1,2})((,(\\W)?[A-Za-z]{1,2})+)?)$/ uppercase-input required></div></div><div class=row ng-if=isEANS><div class=\"col-xs-12 col-md-6\"><input id=crco_member name=crco_member type=checkbox ng-model=editable.crco_member><label>CRCO Member</label></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><input id=applies_to_type_departure name=applies_to_type_departure type=checkbox ng-model=editable.applies_to_type_departure ng-disabled=\"!editable.exclude && !editable.include\"><label>Departure</label><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/crco-archive/crco-archive.html","<div class=row><div class=col-xs-12><div class=box-container><div class=box-content><box-header page-name=crco.crco-archive icon=\"\'plane\'\" title=\"{{ \'CRCO Archive\' | translate }}\"></box-header><fieldset><div class=row><div class=col-xs-6><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><!-- <div class=\"col-xs-12 col-sm-12 col-md-2\">\n                            <label for=\"accounts\" ng-click=\"getAccount()\">\n                                <span translate>Accounts</span>\n                                <span ng-show=\"editable.iata_status === \'iata\'\" translate>(Preview Invoice)</span>\n                                <span ng-show=\"editable.iata_status !== \'iata\'\">*</span>\n                            </label>\n                            <multiselect id=\"accounts\" name=\"accountIdList\" extra-settings=\"{ displayProp: \'name\' }\"\n                                ng-click=\"updateAccounts(editable.account_type)\" options=\"listOfAccounts\"\n                                model=\"selectedAccounts\">\n                            </multiselect>\n                        </div>\n                        <div class=\"col-xs-12 col-sm-12 col-md-2\">\n                            <label translate for=\"billing_interval\">Billing Interval *</label>\n                            <select id=\"billing_interval\" name=\"billing_interval\" class=\"form-control\"\n                                ng-model=\"editable.billing_interval\" ng-change=\"setMonthlyDates()\" required>\n                                <option ng-if=\"editable.account_type != 8\" translate value=\"WEEKLY\">Weekly</option>\n                                <option ng-if=\"editable.account_type != 8\" translate value=\"MONTHLY\">Monthly</option>\n                                </option>\n                                <option ng-if=\"editable.account_type != 8\" translate value=\"OPEN\">Open</option>\n                            </select>\n                        </div>\n                        <div class=\"col-xs-12 col-sm-12 col-md-4\">\n                            <div ng-show=\"editable.billing_interval === \'WEEKLY\'\">\n                                <label for=\"end_date\">\n                                    {{ \'End Date Of Invoice *\' | translate }} (<span translate>yyyy-MM-dd</span>)\n                                </label>\n                                <p class=\"input-group\">\n                                    <date-picker id=\"end_date\" name=\"end_date\" type=\"text\" ng-pattern=\"datePickerRegex\"\n                                        show-button-bar=\"false\" class=\"form-control\"\n                                        uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=\"editable.end_date\"\n                                        is-open=\"open\" datepicker-options=\"dateOptions\" close-text=\"Close\"\n                                        ng-change=\"setWeekStartDate()\" required>\n                                    </date-picker>\n                                    <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open = !open\">\n                                            <i class=\"glyphicon glyphicon-calendar\"></i>\n                                        </button>\n                                    </span>\n                                </p>\n                            </div>\n                            <div ng-show=\"editable.billing_interval === \'MONTHLY\'\">\n                                <label for=\"billing-period\"><span translate>Billing Period</span>&nbsp;*&nbsp;(<span\n                                        translate>{{ customDate }}</span>)</label>\n                                <p class=\"input-group\">\n                                    <input id=\"billing_period\" name=\"billing_period\" type=\"text\" class=\"form-control\"\n                                        ng-change=\"setMonthlyDates()\" uib-datepicker-popup=\"yyyy-MM\" ng-required=\"true\"\n                                        close-text=\"Close\" ng-model=\"dateObject\" is-open=\"open\"\n                                        datepicker-options=\"{ formatYear: \'yyyy-MM\', startingDay: 1, minMode: \'month\' }\" />\n                                    <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open = !open\">\n                                            <i class=\"glyphicon glyphicon-calendar\"></i>\n                                        </button>\n                                    </span>\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"col-xs-12 col-sm-12 col-md-4\" ng-show=\"editable.billing_interval === \'OPEN\'\">\n                            <date-range is-required=\"false\" control=\"control\" format=\"yyyy-MM-dd\"\n                                ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\"\n                                ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\">\n                            </date-range>\n                        </div> --><div class=\"col-xs-6 text-right margin-top-15\"><button translate ng-click=createArchive(flightMessageById) class=\"btn btn-primary pull-right\">Refresh</button></div></div></fieldset><div class=row><div class=\"col-xs-12 col-md-12\"><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=crcoArchiveService><table class=\"table table-fixed table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=\"text-center text-nowrap middle\">Action</th><th translate class=\"text-center text-nowrap middle\" sort=packetId>ID</th><th translate class=\"text-center text-nowrap middle\">Date/Time</th><!-- <th translate class=\"text-center text-nowrap middle\">Message\n                                            Type\n                                        </th> --><th translate class=\"text-center text-nowrap middle\">Status</th></tr></thead><tbody><tr ng-click=showCompletenessCheckMessages(item) ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.packet_id === item.packet_id}\"><td class=text-center><!-- <download-oauth2 title=\"{{ \'Download flight messages\' | translate }}\"\n                                                url=\"/crco-archive/{{item.id}}/download?\"\n                                                error=\"$parent.error\">\n                                            </download-oauth2> --> <button title=\"{{ \'Preview flight messages\' | translate }}\" ng-click=\"showCompletenessCheckMessages(item) ;getFlightMessages(editable.packet_id)\" class=\"btn btn-sm btn-primary\"><i class=\"fa fa-file-text-o\"></i></button></td><td class=\"middle text-center\">{{item.packet_id}}</td><td class=\"middle text-center\">{{item.packet_date_time | date:\'dd-MM-yyyy HH:mm\'}}</td><!-- <td class=\"middle text-center\">NOR</td> --><td class=\"middle text-center\">{{item.status}}</td></tr><tr><td ng-show=!flightMessageById.length translate class=text-center colspan=6>There are no CRCO Messages</td></tr></tbody></table><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div></div><div class=\"col-xs-6 margin-top-15\" style=\"z-index: 1500\"></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container ng-show=flightMessage><box-header icon=\"\'plane\'\" title=\"{{ \'Preview Flight Message\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><span><pre class=message_preview>{{flightMessage}}</pre></span></div></div></div></div></div></div><div class=row ng-show=preview><div class=\"col-sm-12 preview-oauth2-container\"><div ng-bind-html=preview><!-- iframe renders in here --></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"></div></div>");
$templateCache.put("app/partials/crco-claims/crco-claims.html","<div class=row><div class=col-xs-12><div class=box-container><box-header toggle=toggle page-name=crco.crco-claims icon=\"\'check-square-o\'\" title=\"{{ \'CRCO Claims\'  | translate }}\"></box-header><div class=box-content><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\" ng-hide=toggle><!-- Error Handling --></ng-include><div class=row><!-- <div class=\"col-xs-12 col-md-6\">\n                        <label translate for=\"text-filter\">Filter</label>\n                        <input id=\"text-filter\" class=\"form-control\" type=\"text\" empty-to-null ng-model=\"textFilter\"\n                            ng-keyup=\"$event.keyCode == 13 && refreshOverride()\" />\n                    </div> --><!-- <div class=\"col-xs-6 col-md-2\">\n                        <label translate for=\"account-filter\">Account</label>\n                        <dynamic-service-dropdown ng-model=\"accountFilter\" id=\"account-filter\" dropdown-type=\"single\"\n                            allow-empty=\"true\" service=\"::accountsService\" is-required=\"false\"\n                            method=\"findAllMinimalReturn\" options=\"item.id as (item.name | translate) for item in list\"\n                            ng-change=\"refreshList()\">\n                        </dynamic-service-dropdown>\n                    </div>\n\n                    <div class=\"col-xs-12 col-md-6\">\n                        <date-range is-required=\"false\" control=\"control\" format=\"{{customDate}}\"\n                            ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\"\n                            ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\">\n                        </date-range>\n                    </div> --><!-- <div class=\"col-xs-12 col-md-6\">\n                        <button translate ng-click=\"refreshOverride()\" class=\"btn btn-primary pull-right\">Refresh\n                        </button>\n                    </div> --></div><div class=row><div class=col-xs-12><div id=crco-claims class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=crcoClaimsService box-header=1><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap>Claim Number</th><th translate class=text-nowrap>Airspace User (Account)</th><th translate class=text-nowrap>Date of request</th><th translate class=text-nowrap>Source</th><th translate class=text-nowrap>Flight Date</th><th translate class=text-nowrap>Dep/Entry Time</th><th translate class=text-nowrap>Flight Id</th><th translate class=text-nowrap>Seq</th><th translate class=text-nowrap>ADEP</th><th translate class=text-nowrap>ADES</th><th translate class=text-nowrap>A/C Type</th><th translate class=text-nowrap>Reg</th><th translate class=text-nowrap>Ex</th><th translate class=text-nowrap>Amount</th><th translate class=text-nowrap>CRCO Reason</th><th translate class=text-nowrap>Decision</th><th translate class=text-nowrap>Pro Forma Line N.</th></tr></thead><tbody><tr ng-click=\"showClaim(item); updateFormattedDate(item.OriginalRcoMessageData.FlightDateTime)\" ng-class=\"{\'highlight\': editable.OriginalRcoMessageData.FlightDateTime === item.OriginalRcoMessageData.FlightDateTime}\" ng-repeat=\"item in listclaRequestMessages.CLARequestMessage\"><td class=text-nowrap>{{ item.UserClaim.ClaimNumber}}</td><td class=text-nowrap>{{ item.UserClaim.UserNumber }}</td><td class=text-nowrap>{{ item.UserClaim.CLARequestDate }}</td><td class=text-nowrap>{{ item.DestinationRco}}</td><td class=text-nowrap>{{ item.OriginalRcoMessageData.FlightDateTime | date:\'yyyy-MM-dd\'}}</td><td class=text-nowrap>{{ item.OriginalRcoMessageData.FlightDateTime | date:\'HH:mm\' }}</td><td class=text-capitalize>{{ item.OriginalRcoMessageData.FlightId }}</td><td class=text-right>{{ item.OriginalRcoMessageData.SequenceNumber}}</td><td class=text-nowrap>{{ item.OriginalRcoMessageData.ADEP.Code}}</td><td class=text-nowrap>{{ item.OriginalRcoMessageData.ADES.Code}}</td><td class=text-nowrap>{{ item.OriginalRcoMessageData.AircraftType}}</td><td class=text-nowrap>{{ item.reg}}</td><td class=text-nowrap>{{ item.OriginalRcoMessageData.ExemptionCode | translate }}</td><td class=text-nowrap>{{ item.UserClaim.NetChargeBilled}}</td><td class=text-nowrap>{{ item.UserClaim.ClaimReasonCode}}</td><td class=text-nowrap>{{ item.decision}}</td><td class=text-nowrap>{{ item.UserClaim.ProFormaLineNumber}}</td></tr><tr ng-show=!listclaRequestMessages.CLARequestMessage.length><td class=text-center colspan=16 translate>There are no Crco Claims</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div class=row ng-class=\"{\'margin-top-20\': toggle}\" ng-show=toggle><div class=col-xs-12><div class=box-container><box-header icon=\"\'rsexchanges\'\" title=\"{{ \'CRCO Claims Reply\'  | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'crco_claims_modify\')\"><box-header icon=\"\'check-square-o\'\" title=\"{{ \'Reference\' | translate }}\"></box-header><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=flight-date>Fight Date *</label><p class=input-group><input id=flight-date name=flight-date type=text class=form-control ng-model=formattedFlightDate required disabled=disabled> <span class=input-group-btn></span></p></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=account>Account *</label><input id=account name=account class=form-control type=text ng-model=editableReply.CRCOCLARequestReference.UserNumber maxlength=5 only-numbers uppercase-input required disabled=disabled></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=pro-forma-line-number>Pro Forma line number *</label><input id=pro-forma-line-number name=proFormaLineNumber class=form-control type=text ng-model=editableReply.CRCOCLARequestReference.ProFormaLineNumber maxlength=6 only-numbers uppercase-input required disabled=disabled></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=claim-serial-number>Claim Serial Num *</label><input id=claim-serial-number name=claimSerialNumber class=form-control type=text ng-model=editableReply.CRCOCLARequestReference.CLASerialNumber maxlength=2 only-numbers uppercase-input required disabled=disabled></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=claim-number>Claim Num *</label><input id=claim-number name=claimNumber class=form-control type=text ng-model=editableReply.CRCOCLARequestReference.ClaimNumber maxlength=6 only-numbers uppercase-input required disabled=disabled></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=date-of-request>Date of Reply *</label><p class=input-group><input id=date-of-request name=date-of-request type=text class=form-control ng-model=dateClaReply required disabled=disabled></p></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=claim-reason-code>Claim Reason Code *</label><input id=claim-reason-code name=claimReasonCode class=form-control type=text ng-model=editableReply.CRCOCLARequestReference.ClaimReasonCode maxlength=2 only-numbers uppercase-input required></div><div class=\"col-xs-12 col-md-4 col-lg-3\"><label translate for=decision-code>Decision Code *</label><select id=claim-decision-code name=claimDecisionCode class=\"form-control text-capitalize\" ng-model=editableReply.CRCOCLARequestReference.ClaimDecisionCode maxlength=1 only-letters required><option value=A ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || \n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 12 || \n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 13 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 14 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 16 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 18 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 40\">A(ACP)</option><option value=C ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || \n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || \n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\">C(QTA)</option><option value=M ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || \n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 12 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 13 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 14 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 16 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 18 ||\n                                                               editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\">M(CHG)</option><option value=R>R(CFM)</option></select></div></div><div class=row><!--  <div class=\"col-xs-12 col-md-8\">\n                                 <button type=\"button\" class=\"btn btn-primary btn-reset\" translate\n                                ng-show=\"editable.id !== null\"\n                                    ng-click =\"reset(); form.$setUntouched();\">Clear</button> \n                            </div>\n                            <div class=\"col-xs-12 col-md-4\" >\n                                <button type=\"button\" class=\"btn btn-primary btn-acp \"                                \n                                     ng-disabled = \"editableReply.CRCOCLARequestReference.ClaimDecisionCode !== \'A\' ||\n                                     editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\">A(ACP)</button>\n                                <button type=\"button\" class=\"btn btn-primary btn-qta \"          \n                                   ng-disabled = \"editableReply.CRCOCLARequestReference.ClaimDecisionCode !== \'C\'|| editableReply.CRCOCLARequestReference.ClaimReasonCode == 12 ||\n                                    editableReply.CRCOCLARequestReference.ClaimReasonCode == 13 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 14 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 16 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 18\" >C(QTA)</button>\n                                <button type=\"button\" class=\"btn btn-primary btn-chg \"                                 \n                                     ng-disabled = \"editableReply.CRCOCLARequestReference.ClaimDecisionCode !== \'M\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 ||\n                                     editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40\">M(CHG)</button>\n                                <button type=\"button\" class=\"btn btn-primary btn-cfm \"                                \n                             ng-disabled = \"editableReply.CRCOCLARequestReference.ClaimDecisionCode !== \'R\'\">R(CFM)</button>\n                            </div> --></div><box-header icon=\"\'check-square-o\'\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'M\' && formattedFlightDate != null\" title=\"{{ \'Correction\' | translate }}\"></box-header><div class=\"row row-responsive\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'M\' && formattedFlightDate != null\"><div class=\"col-xs-12 col-md-4 col-lg-4\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\"><label translate for=corretting-flight-date>Fight Date</label><p class=input-group><input id=corretting-flight-date name=correttingFlightDate type=text class=form-control uib-datepicker-popup=yyyy-MM-dd ng-model=editableReply.CorrectingMessageElements.FlightDateTime is-open=openc datepicker-options=dateOptionsPartially required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"openc = !openc\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-4 col-lg-4\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 13 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\"><label translate for=adep>ADEP</label><input id=dest-aerodrome name=destAd class=form-control type=text ng-model=editableReply.CorrectingMessageElements.ADEP.Code maxlength=4 only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-4\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 14 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\"><label translate for=ades>ADES</label><input id=ades name=ades class=\"form-control text-capitalize\" type=text ng-model=editableReply.CorrectingMessageElements.ADES.Code maxlength=4 only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-4\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\"><label translate for=flight-id>Flight ID</label><input id=dest-aerodrome name=destAd class=form-control type=text ng-model=editableReply.CorrectingMessageElements.FlightId maxlength=4 uppercase-input required></div><div class=\"col-xs-12 col-md-4 col-lg-4\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 16 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 18 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\"><label translate for=exemption-code>Exemption Code</label><input id=exemption-code name=exemptionCode class=\"form-control text-capitalize\" type=text ng-model=editableReply.CorrectingMessageElements.ExemptionCode maxlength=1 only-numbers uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-4\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 12 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99\"><label translate for=aircraft-type>Aircraft Type</label><input id=aircraft-type name=aircraftType class=\"form-control text-capitalize\" type=text ng-model=editableReply.CorrectingMessageElements.AircraftType maxlength=7 uppercase-input only-numbers-letters></div></div><box-header icon=\"\'check-square-o\'\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' && formattedFlightDate != null\" title=\"{{ \'Confirmation\' | translate }}\"></box-header><div class=\"row row-responsive\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' && formattedFlightDate != null\"><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 12 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=confirmed-flight-id>Flight ID</label><input id=confirmed-flight-id name=confirmedFlightId class=\"form-control text-capitalize\" type=text ng-model=editableReply.ConfirmationElements.ConfirmedFlightIdentification maxlength=9 uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 12 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=confirmed-aircraft-registration>Aircraft Registration</label><input id=aircraft-type name=aircraftType class=\"form-control text-capitalize\" type=text ng-model=editableReply.ConfirmationElements.ConfirmedAircraftRegistration maxlength=7 uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 13 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=atd>ATD (HHmm)</label><input id=atd name=atd class=form-control type=text ng-model=editableReply.ConfirmationElements.ConfirmedATD minlength=4 maxlength=4 ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ ></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11  || editableReply.CRCOCLARequestReference.ClaimReasonCode == 14 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=adep>ADEP</label><input id=adep name=adep class=form-control type=text ng-model=editableReply.ConfirmationElements.ConfirmedADEP.Code maxlength=4 only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 14 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=ata>ATA (HHmm)</label><input id=ata name=ata class=form-control type=text ng-model=editableReply.ConfirmationElements.ConfirmedATA minlength=4 maxlength=4 ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ ></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11  || editableReply.CRCOCLARequestReference.ClaimReasonCode == 13 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=ades>ADES</label><input id=ades name=ades class=form-control type=text ng-model=editableReply.ConfirmationElements.ConfirmedADES.Code maxlength=4 only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=first-ato>1st ATO (DDHHmm)</label><input id=first-ato name=firstAto class=form-control type=text maxlength=7 ng-model=editableReply.ConfirmationElements.FirstATO ng-pattern=/^(0[1-9]|[12]\\d|3[01])([01]\\d|2[0-3])([0-5]\\d)$/ ></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=first-reporting-point>1st reporting point</label><input id=first-reporting-point name=firstReportingPoint class=form-control type=text ng-model=editableReply.ConfirmationElements.FirstRoutePoint minlength=3 maxlength=5></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 11 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=second-ato>2nd ATO (DDHHmm)</label><input id=second-ato name=second-ato class=form-control type=text maxlength=6 ng-model=editableReply.ConfirmationElements.SecondATO ng-pattern=/^(0[1-9]|[12]\\d|3[01])([01]\\d|2[0-3])([0-5]\\d)$/ only-numbers></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 10 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 40 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=second-reporting-point>2nd reporting point</label><input id=second-reporting-point name=secondReportingPoint class=form-control type=text ng-model=editableReply.ConfirmationElements.SecondRoutePoint minlength=3 maxlength=5></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=ifr-daylight-criterion>IFR daylight criterion</label><select id=ifr-daylight-criterion name=ifrDaylightCriterion class=\"form-control text-capitalize\" ng-model=editableReply.ConfirmationElements.IFRDaylightCriterion><option value=1>sunrise at ADEP</option><option value=2>sunset at ADEP</option><option value=3>sunset at ADES</option><option value=4>sunrise at ADES</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=ifr-sunset-time>IFR sunset time (HHmm)</label><input id=ifr-sunset-time name=ifrSunsetTime class=form-control type=text ng-model=editableReply.ConfirmationElements.IFRSunriseOrSunsetTime maxlength=4 only-numbers></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=ifr-daylight-criterion>nature of IFR proof</label><select id=ifr-daylight-criterion name=ifrDaylightCriterion class=\"form-control text-capitalize\" ng-model=editableReply.ConfirmationElements.IFRNatureOfProof><option value=1>IFR FPL</option><option value=2>IFR strip</option><option value=3>ADEP log</option><option value=4>ADES log</option><option value=5>IFR FPL+strip</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 15 || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=source-ifr-proof>source of IFR proof</label><input id=source-ifr-proof name=sourceIfrProof class=form-control type=text ng-model=editableReply.ConfirmationElements.IFRSourceOfProof maxlength=7></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-show=\"editableReply.CRCOCLARequestReference.ClaimReasonCode == 16 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 18 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' || editableReply.CRCOCLARequestReference.ClaimReasonCode == 99 && editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><label translate for=exemption-rejecton-code>exemption rejection code:</label><select id=exemption-rejecton-code name=exemptionRejectonCode class=\"form-control text-capitalize\" ng-model=editableReply.ConfirmationElements.ExemptionCode><option value=0>0</option><option value=1>1</option><option value=2>2</option><option value=3>3</option><option value=4>4</option></select></div></div><box-header class=margin-top-20 icon=\"\'check-square-o\'\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'A\' && formattedFlightDate != null || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'C\' && formattedFlightDate != null|| editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'M\' && formattedFlightDate != null || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' && formattedFlightDate != null \" title=\"{{ \'Remarks\' | translate }}\"></box-header><div class=\"row row-responsive\" ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'A\' && formattedFlightDate != null || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'C\' && formattedFlightDate != null || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'M\' && formattedFlightDate != null|| editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\' && formattedFlightDate != null\"><div class=\"col-xs-12 col-lg-12\"><label translate for=rco-remark>RCO remark</label><input id=rco-remarks name=rcoRemark class=form-control type=text ng-model=editableReply.Remark></div></div><div class=row-responsive ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'A\' || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'C\' || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'M\' || editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\"><div class=\"col-xs-12 col-md-6\"><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"resetReply(); form.$setUntouched();\">Clear</button></div><div class=\"col-xs-12 col-md-6\"><button type=button class=\"btn btn-primary btn-send pull-right\" translate ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'A\'\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to send this?\" popup-confirm=\"sendClaimReply(editableReply); form.$setUntouched();resetReply()\">Send ACP</button> <button type=button class=\"btn btn-primary btn-send pull-right\" translate ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'C\'\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to send this?\" popup-confirm=\"sendClaimReply(editableReply); form.$setUntouched();resetReply()\">Send QTA</button> <button type=button class=\"btn btn-primary btn-send pull-right\" translate ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'M\'\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to send this?\" popup-confirm=\"sendClaimReply(editableReply); form.$setUntouched();resetReply()\">Send CHG</button> <button type=button class=\"btn btn-primary btn-send pull-right\" translate ng-if=\"editableReply.CRCOCLARequestReference.ClaimDecisionCode == \'R\'\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to send this?\" popup-confirm=\"sendClaimReply(editableReply); form.$setUntouched();resetReply()\">Send CFM</button></div></div></fieldset><fieldset ng-disabled=\"!hasPermission(\'transaction_modify\')\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/crco-connections/crco-connection.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><div class=box-content><fieldset ng-disabled=!crco_invoice_support><box-header toggle=toggle page-name=crco.crco-connection icon=\"\'check-square-o\'\" title=\"{{ \'CRCO Connection\'  | translate }}\"></box-header><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-keyup=\"$event.keyCode == 13 && refreshOverride()\" ng-model=textFilter></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=crcoConnectionService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=connectionName>Connection Name</th><th translate class=text-nowrap>Endpoint</th><th translate class=text-nowrap>Port</th><th translate class=text-nowrap>Password</th><th translate class=text-nowrap>Enabled</th></tr></thead><tbody><tr ng-click=showConnection(item); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{item.connection_name}}</td><td class=text-nowrap>{{item.endpoint}}</td><td class=text-nowrap>{{item.port}}</td><td class=text-nowrap ng-bind=getMaskedPassword(item.password)></td><td class=text-nowrap>{{item.enabled}}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=6>There are no CRCO connections</td></tr></tbody></table><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></fieldset></div></div></div><div id=crud-second-container ng-show=toggle><div class=row><div class=col-xs-12><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'rss\'\" title=\"{{ \'Create a CRCO Connection\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'rss\'\" title=\"{{ \'Edit a CRCO Connection\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'crco_connection_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-6\"><label for=connection_name>{{\'Connection Name\' | translate}} *</label><input id=connection_name maxlength=20 minlength=3 name=connection_name class=form-control type=text ng-model=editable.connection_name ng-trim=false ng-model-options=\"{allowInvalid: true}\" ng-pattern=/^[a-zA-Z0-9]*$/ required></div><div class=\"col-xs-12 col-md-6\"><label for=endpoint>{{\'Endpoint\' | translate}} *</label><input id=endpoint name=type class=form-control type=text ng-pattern=/.*[^\\/]$/ ng-model=editable.endpoint ng-trim=false ng-model-options=\"{allowInvalid: true}\" required></div><div class=\"col-xs-12 col-md-6\"><label for=port>{{\'Port\' | translate}} *</label><input id=port name=port class=form-control type=text ng-model=editable.port ng-trim=false ng-model-options=\"{allowInvalid: true}\" ng-pattern=/^[a-zA-Z0-9]*$/ required></div><div class=\"col-xs-12 col-md-6\"><label for=password>{{\'Password\' | translate}} *</label><input id=password name=type class=form-control type=password ng-model=editable.password ng-trim=false required></div><div class=\"col-xs-12 col-md-6\"><label for=enabled>{{\'Enabled\' | translate}} *</label><boolean-text id=enabled name=enabled class=form-control type=text ng-model=editable.enabled ng-trim=false ng-model-options=\"{allowInvalid: true}\" ng-pattern=/^[a-zA-Z0-9]*$/ required></boolean-text></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateConnection(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteConnection(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"createConnection(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div></div></div>");
$templateCache.put("app/partials/crco-cor-request/crco-cor-request.html","<div class=row><div class=col-xs-12><div class=box-container><box-header toggle=toggle page-name=crco.crco-cor-request icon=\"\'check-square-o\'\" title=\"{{ \'CRCO Cor request\'  | translate }}\"></box-header><div class=box-content><!-- <fieldset> --><!-- <div class=\"row\"> --><!-- <div class=\"col-xs-6\">\n                            <label translate for=\"text-filter\">Filter</label>\n                            <input id=\"text-filter\" class=\"form-control\" type=\"text\" ng-model=\"textFilter\" empty-to-null\n                                ng-keyup=\"$event.keyCode == 13 && refreshOverride()\" />\n                        </div> --><!-- <div class=\"col-xs-12 col-sm-12 col-md-2\">\n                            <label for=\"accounts\" ng-click=\"getAccount()\">\n                                <span translate>Accounts</span>\n                                <span ng-show=\"editable.iata_status === \'iata\'\" translate>(Preview Invoice)</span>\n                                <span ng-show=\"editable.iata_status !== \'iata\'\">*</span>\n                            </label>\n                            <multiselect id=\"accounts\" name=\"accountIdList\" extra-settings=\"{ displayProp: \'name\' }\"\n                                ng-click=\"updateAccounts(editable.account_type)\" options=\"listOfAccounts\"\n                                model=\"selectedAccounts\">\n                            </multiselect>\n                        </div>\n                        <div class=\"col-xs-12 col-sm-12 col-md-2\">\n                            <label translate for=\"billing_interval\">Billing Interval *</label>\n                            <select id=\"billing_interval\" name=\"billing_interval\" class=\"form-control\"\n                                ng-model=\"editable.billing_interval\" ng-change=\"setMonthlyDates()\" required>\n                                <option ng-if=\"editable.account_type != 8\" translate value=\"WEEKLY\">Weekly</option>\n                                <option ng-if=\"editable.account_type != 8\" translate value=\"MONTHLY\">Monthly</option>\n                                </option>\n                                <option ng-if=\"editable.account_type != 8\" translate value=\"OPEN\">Open</option>\n                            </select>\n                        </div>\n                        <div class=\"col-xs-12 col-sm-12 col-md-4\">\n                            <div ng-show=\"editable.billing_interval === \'WEEKLY\'\">\n                                <label for=\"end_date\">\n                                    {{ \'End Date Of Invoice *\' | translate }} (<span translate>yyyy-MM-dd</span>)\n                                </label>\n                                <p class=\"input-group\">\n                                    <date-picker id=\"end_date\" name=\"end_date\" type=\"text\" ng-pattern=\"datePickerRegex\"\n                                        show-button-bar=\"false\" class=\"form-control\"\n                                        uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=\"editable.end_date\"\n                                        is-open=\"open\" datepicker-options=\"dateOptions\" close-text=\"Close\"\n                                        ng-change=\"setWeekStartDate()\" required>\n                                    </date-picker>\n                                    <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open = !open\">\n                                            <i class=\"glyphicon glyphicon-calendar\"></i>\n                                        </button>\n                                    </span>\n                                </p>\n                            </div>\n                            <div ng-show=\"editable.billing_interval === \'MONTHLY\'\">\n                                <label for=\"billing-period\"><span translate>Billing Period</span>&nbsp;*&nbsp;(<span\n                                        translate>{{ customDate }}</span>)</label>\n                                <p class=\"input-group\">\n                                    <input id=\"billing_period\" name=\"billing_period\" type=\"text\" class=\"form-control\"\n                                        ng-change=\"setMonthlyDates()\" uib-datepicker-popup=\"yyyy-MM\" ng-required=\"true\"\n                                        close-text=\"Close\" ng-model=\"dateObject\" is-open=\"open\"\n                                        datepicker-options=\"{ formatYear: \'yyyy-MM\', startingDay: 1, minMode: \'month\' }\" />\n                                    <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"open = !open\">\n                                            <i class=\"glyphicon glyphicon-calendar\"></i>\n                                        </button>\n                                    </span>\n                                </p>\n                            </div>\n                        </div>\n                        <div class=\"col-xs-12 col-sm-12 col-md-4\" ng-show=\"editable.billing_interval === \'OPEN\'\">\n                            <date-range is-required=\"false\" control=\"control\" format=\"yyyy-MM-dd\"\n                                ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\"\n                                ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\">\n                            </date-range>\n                        </div> --><!-- <div class=\"col-xs-6 text-right margin-top-15\">\n                            <button translate ng-click=\"createArchive(flightMessageById)\"\n                                class=\"btn btn-primary pull-right\">Refresh\n                            </button>\n                        </div> --><!-- </div> --><!-- </fieldset> --><div class=row><div class=\"col-xs-12 col-md-12\"><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=crcoCorRequestService><table class=\"table table-fixed table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=\"text-center text-nowrap middle\" sort=packetId>RCO</th><th translate class=\"text-center text-nowrap middle\" sort=packetId>Flight Date</th><th translate class=\"text-center text-nowrap middle\" sort=packetId>Seq. Number</th><th translate class=\"text-center text-nowrap middle\" sort=packetId>ADEP</th><th translate class=\"text-center text-nowrap middle\" sort=packetId>ADES</th><th translate class=\"text-center text-nowrap middle\">Flight Id</th><th translate class=\"text-center text-nowrap middle\">Exemption</th><th translate class=\"text-center text-nowrap middle\">Aircraft Type</th><th translate class=\"text-center text-nowrap middle\">Correction Request</th><th translate class=\"text-center text-nowrap middle\">Comment</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); updateFormattedDate(item.FlightDateTime)\" ng-repeat=\"item in listclaRequestMessages.CORRequestMessage\" ng-class=\"{\'highlight\': editable.FlightDateTime === item.FlightDateTime}\"><td class=\"middle text-center\">{{item.RCOCollector}}</td><td class=\"middle text-center\">{{item.FlightDateTime | date:\'dd-MM-yyyy HH:mm\'}}</td><td class=\"middle text-center\">{{item.SequenceNumber}}</td><td class=\"middle text-center\">{{item.ADEP.Code}}</td><td class=\"middle text-center\">{{item.ADES.Code}}</td><td class=\"middle text-center\">{{item.FlightId}}</td><td class=\"middle text-center\">{{item.Exemption}}</td><td class=\"middle text-center\">{{item.AircraftType}}</td><td class=\"middle text-center\">{{item.CorrectionRequest}}</td><td class=\"middle text-center\">{{item.Comment}}</td></tr><tr><td ng-show=!listclaRequestMessages.CORRequestMessage.length translate class=text-center colspan=11>There are no CRCO Messages</td></tr></tbody></table><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div></div><div class=\"col-xs-6 margin-top-15\" style=\"z-index: 1500\"></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container ng-show=flightMessage><box-header icon=\"\'plane\'\" title=\"{{ \'Preview Flight Message\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><span><pre class=message_preview>{{flightMessage}}</pre></span></div></div></div></div></div></div><div class=row ng-show=preview><div class=\"col-sm-12 preview-oauth2-container\"><div ng-bind-html=preview><!-- iframe renders in here --></div></div></div><div class=row ng-class=\"{\'margin-top-20\': toggle}\" ng-show=toggle><div class=col-xs-12><div class=box-container><box-header icon=\"\'rsexchanges\'\" title=\"{{ \'CRCO Cor Reply\'  | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'crco_claims_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-4 col-lg-4\"><label translate for=flight-date>Fight Date *</label><p class=input-group><input id=flight-date name=flight-date type=text class=form-control ng-model=\"editable.FlightDateTime \" required> <span class=input-group-btn></span></p></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label translate for=adep>ADEP</label><input id=dest-aerodrome name=destAd class=form-control type=text ng-model=editable.ADEP.Code maxlength=4 only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label translate for=ades>ADES</label><input id=ades name=ades class=\"form-control text-capitalize\" type=text ng-model=editable.ADES.Code maxlength=4 only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label translate for=flight-id>Flight ID</label><input id=dest-aerodrome name=destAd class=form-control type=text ng-model=editable.FlightId maxlength=9 uppercase-input required></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label translate for=exception-code>Exemption</label><input id=exemption-code name=exemption class=\"form-control text-capitalize\" type=text ng-model=editable.Exemption maxlength=1 uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-4\"><label translate for=aircraft-type>Aircraft Type</label><input id=aircraft-type name=aircraftType class=\"form-control text-capitalize\" type=text ng-model=editable.AircraftType maxlength=7 uppercase-input only-numbers-letters></div></div><div class=row-responsive><!-- <div class=\"col-xs-12 col-md-6\">\n                                <button type=\"button\" class=\"btn btn-primary btn-reset \" translate\n                                    ng-click=\"resetReply(); form.$setUntouched();\">Clear</button>\n                            </div> --><div class=\"col-xs-12 col-md-6\"><button type=button class=\"btn btn-primary btn-send pull-right\" translate popup popup-text=\"Are you sure you want to send this?\" popup-confirm=\"sendCorReply(editable); form.$setUntouched();resetReply()\">Send COR REPLY</button></div></div></fieldset><fieldset ng-disabled=\"!hasPermission(\'transaction_modify\')\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"></div></div>");
$templateCache.put("app/partials/crco-management/crco-certificates.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><div class=box-content><fieldset ng-disabled=!crco_invoice_support><box-header toggle=toggle page-name=crco.crco-certificates icon=\"\'check-square-o\'\" title=\"{{ \'CRCO Certificates\'  | translate }}\"></box-header><div class=row><div class=\"col-xs-12 col-md-12\"><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=crcoCertificatesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=\"text-center text-nowrap middle\">Action</th><th translate class=text-nowrap sort=type>Type</th><th translate class=text-nowrap sort=to_validity_year>Valid From</th><th translate class=text-nowrap sort=from_validity_year>Valid To</th><th translate class=text-nowrap sort=to_validity_year>Status</th></tr></thead><tbody><tr ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-center><button title=\"{{ \'Delete Crco Certificate\' | translate }}\" ng-click=showCertificate(item);deleteCertificate(editable.id); class=\"btn btn-sm btn-primary\" ng-disabled=!crco_invoice_support><i class=\"fa fa-trash\"></i></button></td><td class=text-nowrap>{{item.type}}</td><td class=text-nowrap>{{item.valid_from | date:\'dd-MM-yyyy\' }}</td><td class=text-nowrap>{{item.valid_to | date:\'dd-MM-yyyy\'}}</td><td class=text-nowrap>{{item.status}}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=6>There are no CRCO certificates</td></tr></tbody></table><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></fieldset></div></div></div><div id=crud-second-container ng-show=toggle><div class=row><div class=col-xs-12><div class=box-container><box-header icon=\"\'rss\'\" title=\"{{ \'Upload a Crco Certificate\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'crco_connection_modify\')\"><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=\"!editable.document_filename || !acceptedFileType\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\'); form.$setUntouched(); reset();\">Upload</button></div></div></fieldset></form></div></div></div></div></div></div>");
$templateCache.put("app/partials/crco-messages/crco-messages.html","<div class=row><div class=col-xs-12><div class=box-container><div class=box-content><box-header page-name=crco.crco-messages icon=\"\'plane\'\" title=\"{{ \'CRCO Messages\' | translate }}\"></box-header><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=!crco_invoice_support><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=message_type>{{\'Message Type\' | translate }} *</label><select id=message_type name=message_type ng-init=\"editable.message_type = \'NOR\'\" ng-change=\"updateAccounts(editable.account_type); resetSelectedFlightMovements();  editable.message_code = \'F\'; editable.flights = null; editable.incompleteFlights = null; \n                                setIntervalPeriodForUnifiedTax(editable.account_type); setFlightMovementCategory(editable.account_type)\" ng-model=editable.message_type class=form-control required><option translate value=NOR>NOR</option><option translate value=ADD>ADD</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=message_code>{{\'Message Code\' | translate }} *</label><select id=message_code name=message_code ng-init=\"editable.message_code = \'F\'\" ng-change=resetSelectedFlightMovements() ng-model=editable.message_code class=form-control required><option translate value=F>F (Create a flight message)</option><option translate value=C>C (Cancellation of a flight message)</option><option translate value=I ng-show=\"editable.message_type === \'ADD\'\">I (Supplementary information message)</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=message_interval>Message Interval *</label><select id=billing_interval name=billing_interval class=form-control ng-model=editable.billing_interval ng-change=setMonthlyDates();resetSelectedFlightMovements() required><option translate value=DAILY>Daily</option><option translate value=WEEKLY>Weekly</option><option translate value=MONTHLY>Monthly</option><option translate value=OPEN>Open</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-4\"><div ng-show=\"editable.billing_interval === \'WEEKLY\'\"><label for=end_date>{{ \'End Date *\' | translate }} (<span translate>yyyy-MM-dd</span>)</label><p class=input-group><date-picker id=end_date name=end_date type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.end_date is-open=open datepicker-options=dateOptions close-text=Close ng-change=\"setWeekStartDate(); resetSelectedFlightMovements()\" required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-show=\"editable.billing_interval === \'DAILY\'\"><!-- <date-range is-required=\"false\" control=\"control\" format=\"yyyy-MM-dd\"\n                                    ng-selected=\"selectedOptionBillingInterval\"\n                                    ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\"\n                                    ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\">\n                                </date-range> --><label for=end_date>{{ \'Daily Message *\' | translate }} (<span translate>yyyy-MM-dd</span>)</label><p class=input-group><date-picker id=end_date name=end_date type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=todayDate is-open=open datepicker-options=\"{ minMode: \'day\' }\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-show=\"editable.billing_interval === \'MONTHLY\'\"><label for=billing-period><span translate>Messages Period</span>&nbsp;*&nbsp;(<span translate>{{ customDate }}</span>)</label><p class=input-group><input id=billing_period name=billing_period type=text class=form-control ng-change=setMonthlyDates() uib-datepicker-popup=yyyy-MM ng-required=true close-text=Close ng-model=dateObject is-open=open datepicker-options=\"{ formatYear: \'yyyy-MM\', startingDay: 1, minMode: \'month\' }\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"col-xs-12 col-sm-12 col-md-5\" ng-show=\"editable.billing_interval === \'OPEN\'\"><date-range is-required=false control=control format=yyyy-MM-dd ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\">2023-02-01<!--Datepickers --></date-range></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-3\"><label for=accounts ng-click=getAccount()><span translate>Accounts</span> <span ng-show=\"editable.iata_status === \'iata\'\" translate>(Preview Invoice)</span> <span ng-show=\"editable.iata_status !== \'iata\'\">*</span></label><multiselect id=accounts name=accountIdList extra-settings=\"{ displayProp: \'name\' }\" ng-click=updateAccounts(editable.account_type);resetSelectedFlightMovements() options=listOfAccounts model=selectedAccounts required></multiselect></div></div><div class=row><div class=col-xs-12><button translate ng-disabled=\"form.$invalid || processing === true || !hasPermission(\'crco_messages_validate\') || (!selectedAccounts.length)\" class=\"btn btn-primary\" ng-click=\"resetComments();editable.flights = null; editable.incompleteFlights = null; closeHeader(); validate(); resetSelectedFlightMovements()\">Validate</button><!-- <button translate ng-disabled=\"true\"\n                                    ng-show=\"recalculateJob.job_execution_status !== \'STARTED\' && recalculateJob.job_execution_status !== \'QUEUED\'\"\n                                    ng-click=\"editable.flights = null; editable.incompleteFlights = null; closeHeader(); executeRecalculation(); resetSelectedFlightMovements()\"\n                                    class=\"btn btn-primary\">\n                                    Recalculate\n                                </button> --> <button translate ng-show=\"recalculateJob.job_execution_status === \'STARTED\' || recalculateJob.job_execution_status === \'QUEUED\'\" ng-click=cancelRecalculation(); class=\"btn btn-default\">Cancel Recalculate</button> <button translate ng-show=\"(editable.message_preview || editable.message_code === \'C\') && generateJob.job_execution_status === \'COMPLETED\'  && !editable.id_crco_response\" ng-click=\"editable.flights = null; editable.incompleteFlights = null;  closeHeader(); executeGeneration(0); resetSelectedFlightMovements()\" class=\"btn btn-primary\">Generate Message</button> <button translate ng-disabled=\"processing === true || (!selectedAccounts.length) || editable.flight_movement_id_list.length < 1 \n                               || !hasPermission(\'crco_messages_preview\')\" ng-show=\"generateJob.job_execution_status !== \'STARTED\' && generateJob.job_execution_status !== \'QUEUED\'\" ng-click=\"editable.flights = null; editable.incompleteFlights = null;  closeHeader(); executeGeneration(1); \" class=\"btn btn-primary\">Preview Message</button> <button translate ng-show=\"processing === true && generateJob.job_execution_status === \'STARTED\' || generateJob.job_execution_status === \'QUEUED\'\" ng-click=cancelGeneration(); class=\"btn btn-default\">Cancel Invoice</button><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 form-group-inline\"><div class=checkbox><label><input id=select-all-messages ng-click=\"toggleAll(); \" type=checkbox id=chb_crco_select_all ng-model=isChbChecked> <span translate>Select all flights</span></label></div></div></div></div></div><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></fieldset></form></div></div></div></div><div class=\"row margin-top-20\" ng-show=editable.crcoFlights><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Crco Flight Movements\' | translate }} ({{ editable.crcoFlights.length }})\" show-close=true close-func=closeHeader()></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=\"table-responsive fm-table\" sort-query-string=getSortQueryString()><table class=\"table table-fixed table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride();><thead><tr><th translate class=\"text-center text-nowrap middle\"><span translate>Select</span></th><th translate class=\"text-center text-nowrap middle\" sort=item.account_name>Operator</th><th translate class=\"text-center text-nowrap middle\">Flight Id</th><th translate class=\"text-center text-nowrap middle\">Registration Number</th><th translate class=\"text-center text-nowrap middle\">Day of Flight</th><th translate class=\"text-center text-nowrap middle\">Departure Time</th><th translate class=\"text-center text-nowrap middle\" sort=operator>Sent to CRCO</th><th translate class=\"text-center text-nowrap middle\" sort=operator>CRCO Id</th><th translate class=\"text-center text-nowrap middle\" sort=operator>CRCO Sequence Number</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); \" ng-class=\"{\'highlight\': editable.crcoFlights.flight_movement_id === item.flight_movement_id}\" ng-repeat=\"item in editable.crcoFlights | orderBy: incompleteFlightSort(editable.sort)\"><td class=\"text-center checkbox-center\"><input ng-click=countSelected() type=checkbox id=chb_crco ng-disabled=\"(item.crco_id && editable.message_code ===\'F\') || (!item.crco_id && (editable.message_code ===\'C\' || editable.message_code ===\'I\' ))\" ng-model=selectedFlightMovements[item.flight_movement_id] ng-checked=selectedFlightMovements[item.flight_movement_id]></td><!-- <td>{{item.flight_movement_id}}</td> --><td class=\"middle text-center\">{{ item.account_name}}</td><td ng-click=\"openFlight(item.flight_movement_id,hasPermission(\'crco_messages_validate\'))\" ng-class=\"{\'underline\': hasPermission(\'crco_messages_validate\')}\">{{ item.flight_id }}</td><td class=\"middle text-center\">{{ item.registration }}</td><td class=\"middle text-center\">{{ item.day_of_flight | dateConverter}}</td><td class=\"middle text-center\">{{ item.departure_time }}</td><td class=\"middle text-center\" ng-show=item.crco_id style=\"color: green\"><i class=\"fa fa-check\"></i></td><td class=\"middle text-center\" ng-show=!item.crco_id style=\"color: red\"><i class=\"fa fa-close\"></i></td><td class=\"middle text-center\">{{ item.crco_id }}</td><td class=\"middle text-center\" ng-show=\"item.crco_seq_num !== 0\">{{ item.crco_seq_num }}</td><td class=\"middle text-center\" ng-show=\"item.crco_seq_num === 0\"></td></tr><tr ng-show=!editable.crcoFlights.length><td class=text-center colspan=8 translate>There are no CRCO flight movements</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row margin-top-20\" ng-show=recalculateJob><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Recalculating Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=message_feedback><u translate>Recalculation</u> <span ng-show=\"processing === false && recalculateJob.job_execution_status !== \'STARTED\' && recalculateJob.job_execution_status !== \'QUEUED\'\" class=\"btn btn-sm pull-right\" ng-click=\"recalculateJob = null;\">X</span><br><span translate>Period:</span> <span>&nbsp;{{ recalculateJob.job_parameters }}</span><br><span translate>Started:</span> <span>&nbsp;{{ recalculateJob.start_time | dateConverter: \'HH:mm\' }}</span><br><span translate>Status:</span>&nbsp; <span translate>{{ recalculateJob.job_execution_status }}</span><br><span translate>Total Records:</span> <span>&nbsp;{{ recalculateJob.total_steps }}</span><br><span translate>Processed:</span> <span>&nbsp;{{ recalculateJob.steps_completed + recalculateJob.steps_aborted }}</span><br><span translate>ETC:</span> <span>&nbsp;{{ recalculateJob.etc_time | dateConverter: \'HH:mm\' }}</span> <span ng-show=recalculateJob.seconds_left>&nbsp;({{ recalculateJob.seconds_left }})</span><br><span translate>Rate:</span> <span>&nbsp;{{ recalculateJob.rate }}</span><br><br><uib-progressbar max=recalculateJob.total_steps value=\"recalculateJob.steps_completed + recalculateJob.steps_aborted\" ng-show=\"recalculateJob.job_execution_status !== \'STARTING\'\" style=\"height: 10px\"></uib-progressbar></div></div></div></div></div></div></div><div class=\"row margin-top-20\" ng-show=\"generateJob && generateJob.job_execution_status !== \'CANCELED\'\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Generate/Preview Message\' | translate }}\"></box-header><div class=box-content><div class=row ng-show=editable.message_preview><div class=col-xs-12><button translate ng-show=\"!previewJson && generateJob.job_execution_status ===\'COMPLETED\'\" ng-disabled=\"!hasPermission(\'crco_messages_validate\')\" class=\"btn btn-primary\" ng-click=toggleJson()>JSON</button> <button translate ng-show=\"previewJson && generateJob.job_execution_status ===\'COMPLETED\'\" ng-disabled=\"!hasPermission(\'crco_messages_validate\')\" class=\"btn btn-primary\" ng-click=toggleText()>Text</button> <button translate ng-show=\"generateJob.job_execution_status ===\'COMPLETED\'\" ng-disabled=\"!hasPermission(\'crco_messages_validate\')\" class=\"btn btn-primary\" ng-click=showJsonText()>Text + JSON</button></div></div><div class=row><div class=col-xs-12><div class=message_feedback style=\"width: 100%\"><u translate>Generate/Preview Message</u> <span class=\"btn btn-sm pull-right\" ng-show=\"processing === false\" ng-click=\"generateJob = null;\">X</span><br><span translate>Period:</span> <span>&nbsp;{{ generateJob.job_parameters }}</span><br><span translate>Started:</span> <span>&nbsp;{{ generateJob.start_time | dateConverter: \'HH:mm\' }}</span><br><span class=highlightBold translate>Status:</span>&nbsp; <span class=highlightBold translate>{{ generateJob.job_execution_status }}</span><br><span class=highlightBold ng-show=\"!editable.message_preview && generateJob.job_execution_status ===\'COMPLETED\'\" translate>Message:</span>&nbsp; <span class=highlightBold ng-show=\"!editable.message_preview && generateJob.job_execution_status ===\'COMPLETED\'\" translate>No Flights to send to CRCO</span><br><!-- <span class=\"highlightBold\" translate>Message:</span>\n                            <span class=\"highlightBold\" ng-show=\"generateJob.message\">&nbsp;<span translate>{{\n                                    generateJob.message }}</span></span> --><!-- <span class=\"highlightBold\" ng-show=\"!generateJob.message\">&nbsp;<span\n                                    translate>Initializing ...</span></span> --> <span ng-show=\"editable.id_crco_response \" translate>Message sent with ID: </span><span>&nbsp;<b>{{ editable.id_crco_response }}</b></span><br><span ng-show=\"editable.id_crco_response \" translate>Check CRCO Archive for more info</span><div class=table-responsive ng-show=generateJob.unifiedTaxErrors.length><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap>Registration Number</th><th translate class=text-nowrap>Reason of Missed Invoice</th></tr></thead><tbody><tr ng-repeat=\"item in generateJob.unifiedTaxErrors\"><td class=text-nowrap>{{ item.account_name}}</td><td class=text-nowrap>{{ item.registration }}</td><td translate class=text-nowrap>{{ item.reason }}</td></tr><tr ng-show=!generateJob.unifiedTaxErrors.length><td class=text-center colspan=7 translate>There are no unified tax invoice errors movements</td></tr></tbody></table></div><br><span ng-show=generateJob.accountName><span translate>Account:</span> <span><span>&nbsp;{{ generateJob.accountName }} ({{ generateJob.accountNumber }} of {{ generateJob.accountsTotal }})</span> </span><span ng-show=generateJob.flightsTotal><br><span translate>Flights:</span> <span ng-show=generateJob.flightsTotal><span>&nbsp;Processing {{ generateJob.flightNumber }} of {{ generateJob.flightsTotal }}</span></span></span></span><br><br><uib-progressbar ng-show=generateJob.accountsTotal max=generateJob.accountsTotal value=\"getProgressBarValue(generateJob.accountsTotal, generateJob.accountNumber, generateJob.flightsTotal, generateJob.flightNumber)\" style=\"height: 10px\"></uib-progressbar><pre class=message_preview ng-show=\"editable.message_preview && previewText && generateJob.job_execution_status ===\'COMPLETED\'\">{{editable.message_preview}}</pre><div ng-show=\"previewJson && generateJob.job_execution_status ===\'COMPLETED\'\" class=\"table-responsive fm-table\"><table class=\"table table-fixed table-striped table-bordered table-hover table-condensed\"><thead><tr><!-- <th class=\"text-center text-nowrap middle \"><span translate>Select</span>\n                                            </th> --><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Seq. Num.</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Operator</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Comment</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>EOBD</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>IFPLId</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>ADES</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>ADEP</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Departure/EntryTime</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Initial ADES</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Registration</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Flight Id</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Data Type</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Main Exemption</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Supplementary Exemptions</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Zone</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Entry Point</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Exit Point</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Aircraft Type</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Aircraft Address</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Additional Comment</th></tr></thead><tbody><tr ng-repeat=\"x in editable.fmcrco.FlightMessages\"><!-- <td class=\"text-center\">\n                                                <input ng-click=\"countSelected()\" type=\"checkbox\"\n                                                    id=\"checkbox_{{x.SequenceNumber}}\"\n                                                    ng-model=\"selectedFlightMovements[x.SequenceNumber]\"\n                                                    ng-checked=\"selectedFlightMovements[x.SequenceNumber]\" />\n                                            </td> --><td class=\"middle text-center\">{{x.SequenceNumber}}</td><td class=\"middle text-center\">{{x.Operator}}</td><td class=\"middle text-center\"><input id=comment name=comment maxlength=21 class=form-control ng-model=x.Comment></td><td class=\"middle text-center\" style=\"width: 100px\">{{x.FlightPlan.EOBD}}</td><td class=\"middle text-center\">{{x.FlightPlan.IFPLId}}</td><td class=\"middle text-center\">{{x.ADES.Code}}</td><td class=\"middle text-center\">{{x.ADEP.Code}}</td><td class=\"middle text-center\">{{x.DepartureOrEntryTime | date:\'yyyy-MM-dd HH:mm\':\'UTC\'}}</td><td class=\"middle text-center\">{{x.InitialADES.Code}}</td><td class=\"middle text-center\">{{x.Registration}}</td><td class=\"middle text-center\">{{x.FlightId}}</td><td class=\"middle text-center\">{{x.DataType}}</td><td class=\"middle text-center\" ng-show=\"x.Exemptions.length !== 0\"><input maxlength=1 ng-model=x.Exemptions[0] class=\"form-control text-uppercase\"></td><td class=\"middle text-center\" ng-show=\"x.Exemptions.length == 0\"></td><td class=\"middle text-center\" ng-show=\"x.Exemptions.length !== 0\">{{x.Exemptions.slice(1).join(\'\')}}</td><td class=\"middle text-center\" ng-show=\"x.Exemptions.length == 0\"></td><td class=\"middle text-center\">{{x.ChargingZone.Zone}}</td><td class=\"middle text-center\">{{x.ChargingZone.EntryPoint.Coordinates}}</td><td class=\"middle text-center\">{{x.ChargingZone.ExitPoint.Coordinates}}</td><td class=\"middle text-center\">{{x.AircraftType}}</td><td class=\"middle text-center\">{{x.AircraftAddress}}</td><td class=\"middle text-center\"><input id=additionalComment name=additionalComment class=form-control ng-model=x.AdditionalComment maxlength=76></td></tr></tbody></table></div></div></div></div></div></div></div></div><!-- <div class=\"row margin-top-20\">\n    <div class=\"col-xs-12\">\n        <div class=\"box-container\">\n            <box-header icon=\"\'plane\'\" title=\"{{ \'Preview Flight Message\' | translate }}\"></box-header>\n            <div class=\"box-content\">\n                <div class=\"row\">\n                    <div class=\"col-xs-12\">\n                        <span>\n                            <pre>{{flightMessage}}</pre>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div> --> <!-- <div class=\"row\" ng-show=\"editable.message_preview\">\n    <div class=\"col-sm-12 preview-oauth2-container\">\n        <button class=\"btn btn-xs preview-oauth2-close\" ng-click=\"hide = true; preview = null;\">      \n        </button>\n        <div>\n            <pre>{{editable.message_preview}}</pre>\n        </div>\n    </div>\n</div> -->");
$templateCache.put("app/partials/crco-reporting-responsabilities/crco-reporting-responsabilities.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><div class=box-content><fieldset ng-disabled=!crco_invoice_support><box-header page-name=crco.crco-reporting-responsabilities toggle=toggle icon=\"\'check-square-o\'\" title=\"{{ \'CRCO Reporting Responsabilities\'  | translate }}\"></box-header><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-keyup=\"$event.keyCode == 13 && refreshOverride()\" ng-model=textFilter></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=crcoReportingResponsabilitiesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap>Reporting CRCO</th><th translate class=text-nowrap>Departure</th><th translate class=text-nowrap>Departure except conditions</th><th translate class=text-nowrap>Entering from</th><th translate class=text-nowrap>Entering from except conditions</th><th translate class=text-nowrap>Type</th><th translate class=text-nowrap>Scope</th><th translate class=text-nowrap>Rule</th></tr></thead><tbody><tr ng-click=\"showReportingResponsability(item); updateAerodromeMultiselect();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{item.reporting_crco}}</td><td class=text-nowrap>{{item.prefix_departure_include}}</td><td class=text-nowrap>{{item.prefix_departure_exclude}}</td><td class=text-nowrap>{{item.entering_include}}</td><td class=text-nowrap>{{item.entering_exclude}}</td><td class=text-nowrap>{{ ::getApplication(item, \'applies_to_type\') }}</td><td class=text-nowrap>{{ ::getApplication(item, \'applies_to_scope\') }}</td><td class=text-nowrap>{{ ::getApplication(item, \'applies_to_rule\') }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=8>There are no CRCO reporting responsabilities</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></fieldset></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id !== null\" icon=\"\'plane\'\" title=\"{{ \'Edit a Reporting Responsability\' | translate }}\"></box-header><box-header ng-show=\"editable.id === null\" icon=\"\'plane\'\" title=\"{{ \'Create a Reporting Responsability\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div><div class=row><div class=\"col-xs-12 col-md-12\"><label translate for=reporting-crco>Reporting CRCO *</label><input id=reporting-crco name=reportingCrco class=form-control type=text ng-model=editable.reporting_crco required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" style=\"display: flex; justify-content: space-between; align-items: center;  gap: 10px\"><div style=flex:1><label translate for=departure-from>Departure From *</label><select id=departure-from name=departureFrom class=form-control ng-model=editable.typ_departure ng-change=setDropdownDepartureToNull() ng-options=\"o as o for o in [\'ALL FLIGHTS\',\'FIR\',\'AIRPORT\']\"><option translate value=\"\"></option></select></div><div ng-if=\"editable.typ_departure === \'AIRPORT\'\" style=\"width: 120px\"><label for=airport-category>Selection Type</label><select id=selection-type name=selectionType class=form-control ng-model=editable.selectionType ng-change=setDropdownDepartureToNull() ng-options=\"opt as opt for opt in [\'Default\', \'Group\']\"></select></div></div><div class=\"col-xs-12 col-md-6\"><div style=\"display: flex; justify-content: space-between; align-items: center\"><label translate for=identifier>Identifier</label><span ng-if=\"editable.typ_departure === \'ALL FLIGHTS\'\">Mode: <span style=\"font-weight: bold\">EXCLUDE</span></span> <span ng-if=\"editable.typ_departure === \'FIR\' || editable.typ_departure === \'AIRPORT\'\">Mode: <span style=\"font-weight: bold\">INCLUDE</span></span></div><select ng-if=\"editable.typ_departure === \'\' || editable.typ_departure === null || editable.selectionType === \'\' \" ng-disabled=\"editable.typ_departure === \'\' || editable.typ_departure === null\" id=select-airspace name=airspaceName class=form-control ng-model=editable.departure_include></select><multiselect ng-if=\"editable.typ_departure === \'FIR\' || editable.typ_departure === \'ALL FLIGHTS\'\" id=editable-departure name=fir extra-settings=\"{ displayProp: \'displayLabel\', idProp: \'airspace_name\', externalIdProp: \'\'}\" options=filteredListFromNavDB model=selectedFirDeparture events=\"{ onSelectionChanged: addFirToListDeparture }\"></multiselect><p style=\"color: red\" ng-if=\"validationErrors.departure_include && editable.typ_departure === \'FIR\'\">Include all related FIR for <span ng-if=\"validationErrors.departure_conflicts.length > 0\">{{ validationErrors.departure_conflicts}}</span></p><div ng-if=\"editable.typ_departure === \'AIRPORT\'\" style=\"display: flex; align-items: center; gap: 10px\"><!-- Dropdown per iniziale a sinistra --><select ng-if=\"editable.selectionType !== \'Group\'\" ng-model=editable.airportInitials class=form-control style=\"width: 120px\" ng-change=\"filterAirportsByInitial(\'departure\')\"><option value=\"\">Select initial</option><option ng-repeat=\"letter in airportInitials\" ng-value=letter>{{letter}}</option></select><!-- Multiselect per aeroporti a destra --><select ng-if=\"!editable.airportInitials && editable.selectionType !== \'Group\' \" ng-disabled=!editable.airportInitials class=form-control></select><multiselect ng-if=\"editable.airportInitials && editable.selectionType !== \'Group\'\" id=editable-departure ng-disabled=!editable.airportInitials name=airport extra-settings=\"{ displayProp: \'ident\', idProp: \'ident\', externalIdProp: \'\'}\" options=filteredAirportFromNavDb model=selectedAirportsDeparture events=\"{ onSelectionChanged: addAirportToListDeparture }\" style=\"flex: 1\"></multiselect></div><multiselect ng-if=\"editable.selectionType === \'Group\' && editable.typ_departure===\'AIRPORT\'\" id=editable-departure name=airport options=airportInitialsGroup extra-settings=\"{ displayProp: \'label\', idProp: \'id\', externalIdProp: \'\'}\" model=selectedAirportsDepartureGroup events=\"{ onSelectionChanged: addAirportToListDeparture }\"></multiselect></div></div><div style=\"margin-top: 20px\"><div class=row><div class=\"col-xs-12 col-md-6\"><label>Flight Type</label></div><div class=\"col-xs-12 col-md-6\"><label>Flight Scope</label></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><input id=applies_to_type_arrival name=applies_to_type_arrival type=checkbox ng-model=editable.applies_to_type_arrival ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>Arrival</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_scope_domestic name=applies_to_scope_domestic type=checkbox ng-model=editable.applies_to_scope_domestic ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>Domestic</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_type_departure name=applies_to_type_departure type=checkbox ng-model=editable.applies_to_type_departure ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>Departure</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_scope_regional name=applies_to_scope_regional type=checkbox ng-model=editable.applies_to_scope_regional ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>Regional</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_type_domestic name=applies_to_type_domestic type=checkbox ng-model=editable.applies_to_type_domestic ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>Domestic</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_scope_international name=applies_to_scope_international type=checkbox ng-model=editable.applies_to_scope_international ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>International</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_type_overflight name=applies_to_type_overflight type=checkbox ng-model=editable.applies_to_type_overflight ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>Overflights</label></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label>Flight Rule</label></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><input id=applies_to_rule_ifr name=applies_to_rule_ifr type=checkbox ng-model=editable.applies_to_rule_ifr ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>IFR</label></div><div class=\"col-xs-12 col-md-6\"><input id=applies_to_rule_vfr name=applies_to_rule_vfr type=checkbox ng-model=editable.applies_to_rule_vfr ng-disabled=\"!(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\"><label>VFR</label></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\" style=\"margin-top: 20px\"><label translate for=entering-from>Entering From</label><select id=entering-from name=enteringFrom class=form-control ng-disabled=\"listEnteringIncludedExcluded.length || !(editable.typ_departure === \'ALL FLIGHTS\' || editable.departure_include)\" ng-model=editable.typ_entering ng-change=setDropdownEnteringToNull() ng-options=\"o as o for o in [\'FIR\',\'AIRPORT\']\"><option translate value=\"\"></option></select></div><div class=\"col-xs-12 col-md-6\" style=\"margin-top: 20px\"><label translate for=currency-name>Identifier</label><select id=select-entering name=airspaceName class=form-control ng-disabled=!editable.typ_entering ng-show=\"editable.typ_entering !== \'FIR\' && editable.typ_entering != \'AIRPORT\'\" ng-model=editable.entering_include></select><multiselect ng-show=\"editable.typ_entering === \'FIR\'\" id=editable-entering name=fir-entering extra-settings=\"{ displayProp: \'displayLabel\', idProp: \'airspace_name\', externalIdProp: \'\'}\" options=listFirEntering model=selectedFirEntering></multiselect><p style=\"color: red\" ng-if=validationErrors.listFirEntering>Include/Exclude all related FIR options</p><div ng-if=\"editable.typ_entering === \'AIRPORT\'\" style=\"display: flex; align-items: center; gap: 10px; margin-top: 5px\"><!-- Dropdown per iniziale a sinistra --><select ng-model=editable.airportInitialsEntering class=form-control style=\"width: 120px\" ng-change=\"filterAirportsByInitial(\'entering\')\"><option value=\"\">Select initial</option><option ng-repeat=\"letter in airportInitialsEntering\" ng-value=letter>{{letter}}</option></select><!-- Multiselect per aeroporti a destra --><select ng-if=!editable.airportInitialsEntering ng-disabled=!editable.airportInitialsEntering class=form-control></select><multiselect ng-if=editable.airportInitialsEntering id=editable-entering name=airport extra-settings=\"{ displayProp: \'ident\', idProp: \'ident\', externalIdProp: \'\'}\" options=listAirportEntering model=selectedAirportsEntering style=\"flex: 1\"></multiselect></div><div style=\"float: right; margin-top: 10px\"><button class=\"btn btn-outline-secondary\" style=\"margin-right: 5px\" ng-disabled=\"!selectedFirEntering.length && !selectedAirportsEntering.length\" ng-click=include()>Include</button> <button class=\"btn btn-outline-secondary\" ng-disabled=\"!selectedFirEntering.length && !selectedAirportsEntering.length\" ng-click=exclude()>Exclude</button></div></div></div><div class=container-fluid id=crud-third-container style=\"margin-top: 40px; margin-bottom: 40px; width: 100%\" ng-show=\"listEnteringIncludedExcluded.length > 0\"><div class=table-responsive style=\"width: 100%; max-height: 200px; overflow-y: auto\"><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Fir/Aeroport</th><th translate class=text-nowrap>Status</th><th translate class=\"text-center text-nowrap middle\">Action</th></tr></thead><tbody><tr ng-repeat=\"entry in listEnteringIncludedExcluded\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ entry.item.displayLabel ? entry.item.displayLabel : entry.item.ident }}</td><td class=text-nowrap ng-style=\"entry.action && entry.action.toLowerCase() === \'exclude\' ? {\'font-weight\': \'bold\'} : {}\">{{entry.action}}</td><td class=\"text-center text-nowrap\"><button title=\"{{ \'Remove\' | translate }}\" ng-click=deleteEntering(entry.item.id); class=\"btn btn-sm btn-primary\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div><p style=\"color: red\" ng-if=validationErrors.listEnteringIncludedExcluded>Conflicting selection: related FIRs can’t be in both include and exclude</p></div><div class=row><div class=col-xs-12><button translate type=button ng-disabled=false class=\"btn btn-primary btn-reset\" ng-click=\"reset(); getAllNotifications(); setEmpty(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=\"form.$invalid || !isValidMultiselect()\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"prepareFields();updateReportingResponsability(editable, editable.id)\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); setEmpty();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || !isValidMultiselect()\" ng-show=\"editable.id === null\" ng-click=\"prepareFields(); createReportingResponsability(editable);\">Create</button></div></div></div></form></div></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div>");
$templateCache.put("app/partials/currency-management/currency-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.currency-and-exchange-rate-management icon=\"\'dollar\'\" title=\"{{ \'Currencies\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><button translate class=\"btn btn-small btn-primary pull-left\" ng-disabled=\"!hasPermission(\'currency_modify\')\" popup popup-text=\"Are you sure you want to update the exchange rate of currencies?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=updateFromWeb()>Update from Web</button></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=currency-filter>Currency</label><select id=currency-filter ng-init=\"currencyFilter = \'active\'\" class=form-control ng-change=refresh() ng-model=currencyFilter><option translate value=all>All</option><option translate value=active>Active</option></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=text-search>Filter</label><input id=text-search class=form-control type=text ng-model=textSearch empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div></div><div ng-show=!toggle class=\"row col-xs-12\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div><div class=row><div ng-class=\"{ \'col-xs-12\': !exchangeRates, \'col-xs-6\': exchangeRates }\"><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=currencyManagementService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=currencyCode>Currency Code</th><th translate class=text-nowrap sort=currencyName>Currency Name</th><th translate class=text-nowrap sort=countryCode.countryName>Country Name</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); getExchangeRates(item.id);saveOldValue()\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.currency_code }}</td><td class=text-nowrap>{{ item.currency_name | translate }}</td><td class=text-nowrap>{{ item.country_code.country_name | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=4 translate>There are no Currencies data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div ng-show=\"editable.id !== null && exchangeRates\"><div class=col-xs-6><div class=table-responsive style=\"max-height: 25vh; margin-bottom: 10px\"><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString sort-query-string-suffix=\"sort=id,desc\" table-sort=\"getExchangeRates (editable.id, sort)\"><thead><tr><th class=\"text-nowrap text-right\" sort=exchangeRate translate>Exchange Rate</th><th translate class=text-nowrap ng-show=\"editable.currency_code !== \'USD\'\" sort=exchangeRateValidFromDate>From</th><th translate class=text-nowrap ng-show=\"editable.currency_code !== \'USD\'\" sort=exchangeRateValidToDate>To</th></tr></thead><tbody><tr ng-click=editExchangeRate(rate) ng-repeat=\"rate in exchangeRates\" ng-class=\"{\'highlight\': exchangeRate.id === rate.id}\"><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / rate.exchange_rate : rate.exchange_rate) | evenRound: 5 | number: 5 }}</td><td ng-show=\"editable.currency_code !== \'USD\'\" class=text-nowrap>{{ rate.exchange_rate_valid_from_date | dateConverter }}</td><td ng-show=\"editable.currency_code !== \'USD\'\" class=text-nowrap>{{ rate.exchange_rate_valid_to_date | dateConverter }}</td></tr></tbody></table></div></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'dollar\'\" title=\"{{ \'Create a Currency\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'dollar\'\" title=\"{{ \'Edit a Currency\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'currency_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=currency-code>Currency Code *</label><input id=currency-code name=currencyCode class=form-control type=text ng-pattern=/^\\w{1,3}$/ maxlength=3 ng-model=editable.currency_code required></div><div class=\"col-xs-12 col-md-6\"><label translate for=currency-name>Currency Name *</label><input id=currency-name name=currencyName class=form-control type=text ng-model=editable.currency_name maxlength=50 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=country-code>Country Code *</label><dynamic-service-dropdown ng-model=editable.country_code id=country-code name=countryCode dropdown-type=single service=::countryManagementService is-required=::true options=\"country as country.country_code for country in list.content track by country.id\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label><input name=allowUpdatedFromWeb type=checkbox ng-model=editable.allow_updated_from_web><span translate>Allow Update From Web</span></label></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=decimal-places>Decimal Places *</label><input id=decimal-places name=decimalPlaces class=form-control type=number ng-model=editable.decimal_places min=0 max=4 ng-pattern=/^\\d+$/ required></div><div class=\"col-xs-12 col-md-6\"><label translate for=symbol>Symbol *</label><input id=symbol name=symbol class=form-control type=text ng-model=editable.symbol required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=target_currency><span translate>Target Currency</span><span> *</span></label><select id=target_currency name=target_currency class=form-control ng-model=editable.exchange_rate_target_currency_id ng-options=\"currency.id as currency.currency_code for currency in getActiveCurrencyList()\" required></select></div><div class=\"col-xs-12 col-md-6\"><label for=external-accounting-system-identifier><span translate>External Accounting System Identifier</span> <span ng-if=requireExternalSystemId>*</span></label><input id=external-accounting-system-identifier name=externalAccountingSystemIdentifier class=form-control type=text ng-model=editable.external_accounting_system_identifier maxlength=10 ng-required=requireExternalSystemId></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=active>Active *</label><boolean-text class=form-control name=active id=active ng-model=editable.active ng-disabled=!canDeleteOrDeactivateCurrency() required></boolean-text></div><div ng-show=\"currencyInfo || isAnspCurrency\" class=\"col-xs-12 col-md-6\"><p ng-show=isAnspCurrency><strong translate class=text-danger>*ANSP Currency</strong></p><label translate ng-show=currencyInfo.ref_accounts.length>Used by the following accounts:</label><ul><li ng-repeat=\"accountName in currencyInfo.ref_accounts\">{{ accountName }}</li><li ng-show=\"(currencyInfo.ref_account_total - currencyInfo.ref_accounts.length) > 0\"><span translate>... and</span>&nbsp;{{currencyInfo.ref_account_total - currencyInfo.ref_accounts.length}}&nbsp;<span translate>more</span></li></ul></div></div><div class=row><div class=col-xs-8><button translate class=\"btn btn-primary btn-reset\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" ng-disabled=!canDeleteOrDeactivateCurrency() popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form></div></div></div><div ng-show=\"editable.id !== null && toggle && editable.currency_code !== \'USD\'\" class=\"col-xs-12 col-md-6 pull-right margin-top-20\"><div class=box-container><form novalidate action=# name=form2 onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'currency_modify\')\"><box-header ng-show=\"exchangeRate.id === null\" icon=\"\'dollar\'\" title=\"{{ \'Add an Exchange Rate\' | translate }}\"></box-header><box-header ng-show=\"exchangeRate.id !== null\" icon=\"\'dollar\'\" title=\"{{ \'Update an Exchange Rate\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exchange-rate>{{ \'Exchange Rate\' | translate }} *</label><input id=exchange-rate name=exchangeRateToUsd class=form-control min=0 step=0.01 type=number ng-model=exchangeRate.exchange_rate required></div><div class=\"col-xs-12 col-md-6\"><label for=exchange-rate-target-currency><span translate>Target Currency</span><span> *</span></label><input id=exchange-rate-target-currency class=form-control ng-model=exchangeRate.target_currency.currency_code disabled=disabled></div></div><div class=row><date-range is-required=::true control=control start-name=\"Start Date *\" end-name=\"End Date *\" format={{customDate}}><!--Datepickers --></date-range></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary btn-rate-reset\" ng-click=\"resetExchangeRate(); form2.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary btn-rate-create\" ng-show=\"exchangeRate.id === null\" ng-click=\"addExchangeRate(editable.id, exchangeRate, control.getUTCStartDate(), control.getUTCEndDate()); form2.$setUntouched()\" ng-disabled=form2.$invalid>Create</button> <button translate class=\"btn btn-primary btn-rate-update\" ng-show=\"exchangeRate.id !== null\" ng-disabled=form2.$invalid popup popup-text=\"Are you sure you want to update this exchange rate?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateExchangeRate(exchangeRate, control.getUTCStartDate(), control.getUTCEndDate()); form2.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary btn-rate-delete\" ng-show=\"exchangeRate.id !== null\" popup popup-text=\"Are you sure you want to delete this exchange rate?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"deleteExchangeRate(exchangeRate); form2.$setUntouched();\">Delete</button></div></div></div></fieldset></form></div></div></div>");
$templateCache.put("app/partials/current-user/current-user.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=security.password-change icon=\"\'user\'\" title=\"{{ \'Password Change\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=email-address>Email Address *</label><input id=email-address name=email class=form-control type=email ng-model=editable.email pattern=[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+$ required></div><div class=\"col-xs-12 col-md-6\"><label translate for=userlogin>User Login *</label><input id=userlogin name=login class=form-control type=text ng-model=login readonly=readonly required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=current-password><span translate>Current Password</span>&nbsp;<span ng-show=\"passwordMinLength > 0\">*</span></label><input id=current-password name=currentPassword class=form-control type=password ng-model=editable.old_password autocomplete=new-password ng-required=\"passwordMinLength > 0\"></div></div><password name-1=\"New Password *\" name-2=\"Confirm New Password *\" error=error reset-pass=resetPass required password=editable.new_password></password><div ng-if=\"passwordMinLength === 0\" class=row><div class=col-xs-12><button translate id=empty-password class=\"btn btn-primary\" ng-class=\"{ \'active\': setZeroLength }\" ng-click=resetPassword(!setZeroLength) ng-model=setZeroLength>Set password to zero length password</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || editable.new_password === null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updatePassword(editable); form.$setUntouched();\">Update</button></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/enroute-air-navigation-charges-management/enroute-air-navigation-charges-management.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header toggle=toggle page-name=charges-and-formulas.enroute-air-navigation-charge-managment icon=\"\'flask\'\" title=\"{{ \'Enroute Air Navigation Charges\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive export-table back-end-export=true service=enrouteAirNavigationChargesManagementService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=\"refresh({ page: pagination.number }, sort)\"><thead><tr><th class=\"text-right text-nowrap\"><span>{{ \'MTOW Upper Limit\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th class=\"text-nowrap text-capitalize\" ng-show=\"!item.name.includes(\'OTHER\')\" ng-repeat=\"item in categories\"><span>{{ item.name.toLowerCase() + \' Formula\' | translate }}</span></th><th translate class=text-nowrap>W Factor Formula</th><th class=\"text-nowrap text-capitalize\" ng-show=\"!item.name.includes(\'OTHER\')\" ng-repeat=\"item in categories\"><span>{{ item.name.toLowerCase() + \' D-Factor Formula\' | translate }}</span></th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-right>{{ item.mtow_category_upper_limit | weightConverter }}</td><td ng-show=\"!value.flightmovement_category.name.includes(\'OTHER\')\" ng-repeat=\"value in item.enroute_air_navigation_charge_formulas\">{{ value.formula }}</td><td>{{ item.w_factor_formula }}</td><td ng-show=\"!value.flightmovement_category.name.includes(\'OTHER\')\" ng-repeat=\"value in item.enroute_air_navigation_charge_formulas\">{{ value.d_factor_formula }}</td></tr><tr ng-show=!list.length><td translate class=text-left colspan=16>There are no Enroute Air Navigation Charges data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=\"refresh({ page: pagination.number }, getSortQueryString())\" max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div class=\"col-xs-12 col-md-12 margin-top-20\" ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'flask\'\" title=\"{{ \'Create Formulas\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'flask\'\" title=\"{{ \'Edit Formulas\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'enroute_charges_modify\')\"><div class=row><div class=\"col-xs-6 col-xs-offset-3\"><div class=\"alert text-center infoAlert\"><span translate>PLEASE DO NOT USE COMMAS FOR THOUSAND SEPARATORS. e.g. 1000000.00</span></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><uib-accordion close-others=oneAtATime><div uib-accordion-group class=panel-default heading=\"{{\'Parameters\' | translate}}\" is-open=status.isFirstOpen is-disabled=status.isFirstDisabled><table><tr><td class=col-md-1><button translate type=button class=\"btn btn-primary btn-block\" id=btn-mtow ng-click=\"addToFormula(\'[MTOW]\')\">[MTOW]</button></td><td translate>Maximum Take Off Weight</td></tr><tr><td class=col-md-1><button translate type=button class=\"btn btn-primary btn-block\" id=btn-avgMassFactor ng-click=\"addToFormula(\'[AvgMassFactor]\')\">[AvgMassFactor]</button></td><td translate>Average Mass Factor</td></tr><tr><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-crossDist ng-click=\"addToFormula(\'[CrossDist]\')\">[CrossDist]</button></td><td translate>FIR crossing distance</td></tr><tr><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-accountDiscount ng-click=\"addToFormula(\'[AccountDiscount]\')\">[AccountDiscount]</button></td><td translate>Discount percentage for the account</td></tr><tr><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-entriesNumber ng-click=\"addToFormula(\'[EntriesNumber]\')\">[EntriesNumber]</button></td><td translate>Number of entry points into FIR</td></tr><tr><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-firEntryFee ng-click=\"addToFormula(\'[FirEntryFee]\')\">[FirEntryFee]</button></td><td translate>Cost per FIR entry based on account</td></tr><tr><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-approachFee ng-click=\"addToFormula(\'[ApproachFee]\')\">[ApproachFee]</button></td><td translate>Approach fee</td></tr><tr><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-aerodromeFee ng-click=\"addToFormula(\'[AerodromeFee]\')\">[AerodromeFee]</button></td><td translate>Aerodrome fee</td></tr><tr ng-show=showDWFactor><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-wFactor ng-click=\"addToFormula(\'[WFACTOR]\')\">[WFACTOR]</button></td><td translate>W Factor Formula</td></tr><tr ng-show=showDWFactor><td class=col-md-1><button type=button class=\"btn btn-primary btn-block\" id=btn-dFactor ng-click=\"addToFormula(\'[DFACTOR]\')\">[DFACTOR]</button></td><td translate>D Factor Formula</td></tr></table></div><div uib-accordion-group class=panel-default heading=\"{{\'Operators\' | translate}}\" is-open=status.open><button type=button class=\"btn btn-primary\" id=btn-addition ng-click=\"addToFormula(\' + \')\">+</button> <button type=button class=\"btn btn-primary\" id=btn-subtraction ng-click=\"addToFormula(\' - \')\">-</button> <button type=button class=\"btn btn-primary\" id=btn-multiplication ng-click=\"addToFormula(\' * \')\">*</button> <button type=button class=\"btn btn-primary\" id=btn-division ng-click=\"addToFormula(\' / \')\">/</button> <button type=button class=\"btn btn-primary\" id=btn-leftBracket ng-click=\"addToFormula(\'(\')\">(</button> <button type=button class=\"btn btn-primary\" id=btn-rightBracket ng-click=\"addToFormula(\')\')\">)</button> <button type=button class=\"btn btn-primary\" id=btn-comma ng-click=\"addToFormula(\',\')\">,</button> <button type=button class=\"btn btn-primary\" id=btn-dot ng-click=\"addToFormula(\'.\')\">.</button></div></uib-accordion></div><div class=\"col-xs-12 col-md-6\"><uib-accordion close-others=oneAtATime><div uib-accordion-group class=panel-default heading=\"{{\'Math Functions\' | translate}}\" is-open=status.open><table class=col-md-12><tr><th translate class=col-md-1>Name</th><th translate class=col-md-1>Usage</th><th translate class=col-md-1>Result</th><th>Description</th></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-sqr ng-click=\"addToFormula(\'sqr\')\">sqr</button></td><td translate class=col-md-1>sqr(2)</td><td class=col-md-1>4</td><td translate>Returns a specified number raised to the power of 2</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-sqrt ng-click=\"addToFormula(\'sqrt\')\">sqrt</button></td><td translate class=col-md-1>sqrt(4)</td><td class=col-md-1>2</td><td translate>Returns the square root of a number</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-abs ng-click=\"addToFormula(\'abs\')\">abs</button></td><td translate class=col-md-1>abs(-7.25)</td><td class=col-md-1>7.25</td><td translate>Returns the absolute value of a number</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-round ng-click=\"addToFormula(\'round\')\">round</button></td><td translate class=col-md-1>round(3.222,2)</td><td class=col-md-1>3.22</td><td translate>Rounds a value to the nearest integer or specified number of decimal places</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-truncate ng-click=\"addToFormula(\'truncate\')\">truncate</button></td><td translate class=col-md-1>truncate(1.7)</td><td class=col-md-1>1</td><td translate>Calculates the integral part of a number</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-pow ng-click=\"addToFormula(\'pow\')\">pow</button></td><td translate class=col-md-1>pow(3, 2)</td><td class=col-md-1>9</td><td translate>Returns a specified number raised to the specified power</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-min ng-click=\"addToFormula(\'min\')\">min</button></td><td translate class=col-md-1>min(1, 2)</td><td class=col-md-1>1</td><td translate>Returns the smaller of two numbers</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-max ng-click=\"addToFormula(\'max\')\">max</button></td><td translate class=col-md-1>max(1, 2)</td><td class=col-md-1>2</td><td translate>Returns the larger of two numbers</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-ceiling ng-click=\"addToFormula(\'ceiling\')\">ceiling</button></td><td translate class=col-md-1>ceiling(1.5)</td><td class=col-md-1>2</td><td translate>Returns the smaller integer greater than or equal to the specified number</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-floor ng-click=\"addToFormula(\'floor\')\">floor</button></td><td translate class=col-md-1>floor(1.5)</td><td class=col-md-1>1</td><td translate>Returns the largest integer less than or equal to the specified number</td></tr></table></div></uib-accordion></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=mtow-category-upper-limit><span>{{ \'MTOW Upper Limit\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }}) *</span></label><unit-conversion-input id=mtow-category-upper-limit name=mtowCategoryUpperLimit ng-model=editable.mtow_category_upper_limit measurement-type=weight required></div><div class=\"col-xs-12 col-md-6\"><label translate for=w-factor-formula>W Factor Formula *</label><input id=w-factor-formula name=wFactorFormula class=form-control type=text ng-model=editable.w_factor_formula ng-click=setField() ng-change=\"isValidate(); setField()\" required></div></div><div ng-if=\"!value.flightmovement_category.name.includes(\'OTHER\')\" ng-repeat=\"value in editable.enroute_air_navigation_charge_formulas\"><div class=row><div class=\"col-xs-12 col-md-6\"><label><span class=text-capitalize>{{ value.flightmovement_category.name.toLowerCase() + \' Formula\' | translate }} *</span></label><input id=formula class=form-control type=text ng-model=editable.enroute_air_navigation_charge_formulas[$index].formula ng-click=\"setField($index, \'formula\')\" ng-change=\"isValidate(); setField($index, \'formula\')\" required></div><div class=\"col-xs-12 col-md-6\"><label><span class=text-capitalize>{{ value.flightmovement_category.name.toLowerCase() + \' D-Factor Formula\' | translate }} *</span></label><input class=form-control type=text ng-model=editable.enroute_air_navigation_charge_formulas[$index].d_factor_formula ng-click=\"setField($index, \'d_factor_formula\')\" ng-change=\"isValidate(); setField($index, \'d_factor_formula\')\" required></div></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12 ng-init=\"ifValidate = true\"><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setPristine(); form.$setUntouched()\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=\"form.$invalid || ifValidate\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" convert-to-tons property=mtow_category_upper_limit popup-confirm=\"update(convertedEditable || editable, editable.id); form.$setUntouched()\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || ifValidate\" ng-show=\"editable.id === null\" convert-to-tons property=mtow_category_upper_limit conversion-complete=\"create(convertedEditable || editable); form.$setUntouched();\">Create</button> <button translate class=\"btn btn-primary btn-validate\" ng-disabled=form.$invalid ng-click=validate()>Validate</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/flight-movement-management/flight-movement-management.html","<!-- Form for entering a new flight movement --><div ng-show=toggle class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=flight-data.flight-movement-management.data-entry-form icon=\"\'plane\'\" title=\"{{ (editable.id !== null && isFmCopied === false)? \'Edit a Flight Movement\' : \'Create a Flight Movement\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"(!hasPermission(\'flight_movement_modify\') && !hasPermission(\'flight_movement_key_modify\')) || editable.status === \'INVOICED\' || editable.status === \'PAID\'\"><flight-movement-form flight-movement=editable manual=manual should-show-charge=shouldShowCharge distance-unit-of-measure=distanceUnitOfMeasure><!-- Flight Movement Component --></flight-movement-form></fieldset><div class=row><div class=col-xs-8><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();clearVerify();\">Clear</button><!-- Update --> <button class=\"btn btn-primary btn-update\" translate ng-show=\"isFmCopied === false && editable.id !== null && (hasPermission(\'flight_movement_modify\') || hasPermission(\'flight_movement_key_modify\'))\" ng-disabled=\"isFmCopied === true || form.$invalid || editable.status === \'INVOICED\' || editable.status === \'PAID\' || editable.status === \'DELETED\' || editable.status === \'DECLINED\'\" unit-converter unit-to-convert=user_crossing_distance popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateOverride(convertedEditable || editable, editable.id); form.$setUntouched();clearVerify();\">Update</button><!-- Delete --> <button ng-if=!editable.deletion_reason class=\"btn btn-primary btn-delete\" translate ng-show=\"isFmCopied === false && editable.id !== null && (hasPermission(\'flight_movement_modify\') || hasPermission(\'flight_movement_key_modify\')) && editable.status !== \'DELETED\'\" ng-disabled=\"isFmCopied === true || editable.status === \'INVOICED\' || editable.status === \'PAID\' || editable.status === \'CANCELED\' || editable.status === \'DECLINED\'\" ng-click=\"showWarning(\'Deletion\', \'deleting\')\">Delete</button> <button ng-if=editable.deletion_reason class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null && (hasPermission(\'flight_movement_modify\') || hasPermission(\'flight_movement_key_modify\')) && editable.status !== \'DELETED\'\" popup popup-text=\"Are you sure you want to delete this flight?\" ng-disabled=\"editable.status === \'INVOICED\' || editable.status === \'PAID\' || editable.status === \'DELETED\' || editable.status === \'CANCELED\' || editable.status === \'DECLINED\'\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteOverride(editable.id, editable.deletion_reason); form.$setUntouched();clearVerify();\">Delete</button><!-- Undelete --> <button ng-if=\"editable.status === \'DELETED\' && !editable.undeletion_reason\" class=\"btn btn-primary btn-undelete\" translate ng-disabled=\"editable.id === null || (!hasPermission(\'flight_movement_modify\') && !hasPermission(\'flight_movement_key_modify\'))\" ng-click=\"showWarning(\'Undeletion\', \'undeleting\')\">Undelete</button> <button ng-if=\"editable.status === \'DELETED\' && editable.undeletion_reason\" class=\"btn btn-primary btn-undelete\" translate ng-disabled=\"editable.id === null || (!hasPermission(\'flight_movement_modify\') && !hasPermission(\'flight_movement_key_modify\'))\" popup popup-text=\"Are you sure you want to undelete this flight?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateOverride(convertedEditable || editable, editable.id, editable.undeletion_reason); form.$setUntouched();\">Undelete</button><!-- Create --> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || editable.status === \'INVOICED\' || editable.status === \'PAID\'\" ng-show=\"(editable.id === null || isFmCopied === true) && (hasPermission(\'flight_movement_modify\') || hasPermission(\'flight_movement_key_modify\'))\" unit-converter unit-to-convert=user_crossing_distance ng-click=checkBalance(editable);clearVerify();>Create</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=warning-modal-overlay ng-if=\"showWarnings && warningsList.length > 0\"><div class=col-xs-12><div class=error-handling-container><div class=\"alert alert-dismissible alert-warning alert-icon\" role=alert><button id=error_button type=button ng-click=\"$parent.showWarnings = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Warning</strong><div ng-repeat=\"w in warningsList track by $index\">{{ w }}</div></div></div></div></div><div class=row><div class=col-xs-12 ng-show=showErrors><div class=error-handling-container><div class=\"alert alert-dismissible alert-danger alert-icon\" role=alert><button id=error_button type=button ng-click=\"showErrors = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Error</strong><div ng-repeat=\"e in errorsList track by $index\">{{ e }}</div></div></div></div></div></form></div></div></div></div><!-- Form for filtering/sorting options --><div class=row ng-class=\"{\'margin-top-20\': toggle}\"><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=flight-data.flight-movement-management class=margin-bottom-0 toggle=toggle icon=\"\'plane\'\" title=\"{{ \'Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6\"><button class=\"btn btn-secondary\" ng-click=\"filterSectionVisible = !filterSectionVisible\">{{ (filterSectionVisible ? \'Hide Filters\' : \'Show Filters\') | translate }}</button></div><div class=\"col-xs-12 col-sm-12 col-md-6 text-right\"><button translate ng-click=\"refreshOverride(); resetSelectedFlightMovements();\" class=\"btn btn-primary spaced-buttons\">Refresh</button> <button translate ng-click=resetFilters() class=\"btn btn-primary btn-fpl spaced-buttons\">Reset</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\" ng-show=\"!toggle && !showErrorOnlyOnForm\"><!-- Error Handling --></ng-include><div class=row ng-show=filterSectionVisible><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=account-type-filter>Account Type</label><select id=account-type-filter class=form-control ng-model=accountTypeFilter empty-to-null ng-change=refreshOverride()><option translate value=\"\"></option><option translate value=true>IATA</option><option translate value=false>Non-IATA</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=invoice-status-filter>Invoice Status</label><select id=invoice-status-filter class=form-control ng-model=invoiceStatusFilter empty-to-null ng-change=refreshOverride() ng-disabled=showDuplicateMissing><option translate value=\"\"></option><option translate value=ENROUTE_PENDING>Enroute Pending</option><option translate value=ENROUTE_INVOICED>Enroute Invoiced</option><option translate value=ENROUTE_PAID>Enroute Paid</option><option translate value=PASSENGER_PENDING>Passenger Pending</option><option translate value=PASSENGER_INVOICED>Passenger Invoiced</option><option translate value=PASSENGER_PAID>Passenger Paid</option><option translate value=OTHER_PENDING>Other Pending</option><option translate value=OTHER_INVOICED>Other Invoiced</option><option translate value=OTHER_PAID>Other Paid</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-6\" style=\"z-index: 1000\"><date-range class=datepicker is-required=false control=control ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\' \" format={{customDate}}><!--Datepickers --></date-range></div></div><div class=\"row margin-top-10 mb-4\" ng-show=filterSectionVisible><div class=\"col-xs-12 col-sm-12 col-md-2\" style=\"z-index: 1001\"><label translate for=flight-filter>Flight ID</label><input id=flight-filter class=form-control type=text ng-model=flightIdFilter maxlength=10 uppercase-input empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=flight-movement-type-filter>Flight Movement Type</label><select id=flight-movement-type-filter empty-to-null class=form-control ng-model=flightTypeFilter ng-change=refreshOverride() ng-disabled=showDuplicateMissing><option translate value=\"\"></option><option translate value=S>S</option><option translate value=N>N</option><option translate value=G>G</option><option translate value=M>M</option><option translate value=X>X</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=flight-movement-rules-filter>Flight Movement Rules</label><select id=flight-movement-rules-filter empty-to-null class=form-control ng-model=flightRulesFilter ng-change=refreshOverride() ng-disabled=showDuplicateMissing><option translate value=\"\"></option><option translate value=I>I - Instrumental Flight Rules</option><option translate value=V>V - Visual Flight Rules</option><option translate value=Y>Y - Initially operating under IFR,followed by one or more changes of flight rules</option><option translate value=Z>Z - Initially operating under VFR,followed by one or more changes of flight rules</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=flight-movement-status-filter>Flight Movement Status</label><select id=flight-movement-status-filter empty-to-null class=form-control ng-model=flightMovementStatusFilter ng-change=refreshOverride() ng-disabled=showDuplicateMissing><option translate value=\"\"></option><option translate value=ACTIVE>Active (Pending/Incomplete)</option><option translate value=INVPAID>Invoiced (Invoiced/Paid)</option><option translate value=REJECTED>Rejected (Cancelled/Deleted)</option><option translate value=INCOMPLETE>Incomplete</option><option translate value=PENDING>Pending (Complete)</option><option translate value=INVOICED>Invoiced</option><option translate value=PAID>Paid</option><option translate value=CANCELED>Cancelled</option><option translate value=DELETED>Deleted</option><option translate value=DECLINED>Declined</option><option translate value=OTHER>Other</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=flight-category-filter>Flight Movement Category</label><multiselect events=multiselectEvents extra-settings=\"{ displayProp: \'name\', idProp: \'id\',externalIdProp: \'\'}\" options=flightCategoryOptions model=selectedFlightCategories></multiselect></div></div><div class=\"row margin-top-15px margin-bottom: 20px;\" ng-show=filterSectionVisible><div class=\"col-xs-12 col-sm-12 col-md-2\" ng-show=!isAllAerodromesActive><label translate for=departure-aerodrome-filter>Departure Aerodrome</label><multiselect events=multiselectEventsDepAerodromes extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'id\',externalIdProp: \'\'}\" options=aerodromesOptions model=selectedDepAerodromes></multiselect></div><div class=\"col-xs-12 col-sm-12 col-md-2\" ng-show=isAllAerodromesActive><label translate for=departure-aerodrome-filter>Departure Aerodrome</label><div><!-- Campo ricerca --> <input ng-click=\"toggleDropdown(\'dropdownDepAerodromesOpen\', $event)\" type=text maxlength=4 ng-model=searchQueryDep ng-change=\"onSearchChange(\'Dep\')\" class=form-control><!-- Seleziona/Deseleziona tutti --><ul class=dropdown-list ng-show=\"dropdownDepAerodromesOpen && filteredDepAerodromes.length > 0\"><li class=select-all ng-click=\"selectAll(\'dep\')\" translate>Check All</li><li class=deselect-all ng-click=\"deselectAll(\'dep\')\" translate>Uncheck All</li><li class=li-divider></li><li ng-repeat=\"aero in filteredDepAerodromes\" ng-click=\"toggleSelection(aero, \'listSelectedDepAerodromes\', $event)\" ng-class=\"{ selected: isSelected(aero, \'Dep\') }\">{{ aero.ident }}</li></ul><div ng-if=\"listSelectedDepAerodromes.length > 0\" class=selected-inline><!-- Mostra solo i primi 3 selezionati --> <span ng-repeat=\"sel in listSelectedDepAerodromes.slice(0, 3)\" class=selected-chip>{{ sel.ident || sel }} <span class=\"glyphicon glyphicon-remove\" ng-click=\"removeSelection(sel, \'dep\', $event)\"></span> </span><!-- Mostra un badge con tooltip se ci sono più di 3 --> <span class=more-chip ng-click=\"deselectAll(\'dep\')\" ng-if=\"listSelectedDepAerodromes.length > 3\">{{ listSelectedDepAerodromes.length - 3 }} <span class=\"glyphicon glyphicon-remove remove-all-icon\"></span></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-2\" ng-show=!isAllAerodromesActive><label translate for=destination-aerodrome-filter>Destination Aerodrome</label><multiselect events=multiselectEventsDestAerodromes extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'id\',externalIdProp: \'\'}\" options=aerodromesOptions model=selectedDestAerodromes></multiselect></div><div class=\"col-xs-12 col-sm-12 col-md-2\" ng-show=isAllAerodromesActive><label translate for=destination-aerodrome-filter>Destination Aerodrome</label><div><!-- Campo ricerca --> <input ng-click=\"toggleDropdown(\'dropdownDestAerodromesOpen\', $event)\" type=text maxlength=10 ng-model=searchQueryDest ng-change=\"onSearchChange(\'Dest\')\" class=form-control><!-- Seleziona/Deseleziona tutti --><ul class=dropdown-list ng-show=\"dropdownDestAerodromesOpen && filteredDestAerodromes.length > 0\"><li class=select-all ng-click=\"selectAll(\'dest\')\" translate>Check All</li><li class=deselect-all ng-click=\"deselectAll(\'dest\')\" translate>Uncheck All</li><li class=li-divider></li><li ng-repeat=\"aero in filteredDestAerodromes\" ng-click=\"toggleSelection(aero, \'listSelectedDestAerodromes\', $event)\" ng-class=\"{ selected: isSelected(aero, \'Dest\') }\">{{ aero.ident }}</li></ul><div ng-if=\"listSelectedDestAerodromes.length > 0\" class=selected-inline><!-- Mostra solo i primi 3 selezionati --> <span ng-repeat=\"sel in listSelectedDestAerodromes.slice(0, 3)\" class=selected-chip>{{ sel.ident || sel }} <span class=\"glyphicon glyphicon-remove\" ng-click=\"removeSelection(sel, \'dest\', $event)\"></span> </span><!-- Mostra un badge con tooltip se ci sono più di 3 --> <span class=more-chip ng-click=\"deselectAll(\'dest\')\" ng-if=\"listSelectedDestAerodromes.length > 3\">{{ listSelectedDestAerodromes.length - 3 }} <span class=\"glyphicon glyphicon-remove remove-all-icon\"></span></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-2\"><label translate for=aircraft-type-filter>Aircraft Type</label><multiselect events=multiselectEventsAircraftTypes extra-settings=\"{ displayProp: \'aircraft_type\', idProp: \'aircraft_type\', externalIdProp: \'\' }\" options=aircraftTypesOptions model=selectedAircraftsTypes></multiselect></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=incomplete-flight-movement-reason>Incomplete Flight Reason</label><select id=incomplete-flight-movement-reason class=form-control ng-change=refreshOverride() empty-to-null ng-model=incompleteFlightReason ng-disabled=showDuplicateMissing><option value=\"\"></option><option translate value=ALL>All (Flight Rejection List)</option><option ng-repeat=\"item in incompleteReasons | orderBy:\'name | translate\' track by item.id\" value=\"{{ item.value }}\">{{ item.name | translate }}</option></select></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><label translate for=canned-sort>Sort Options</label><select id=canned-sort class=form-control ng-model=cannedSort ng-change=\"refreshOverride(false, cannedSort)\" ng-disabled=showDuplicateMissing><option translate value=\"\"></option><option translate value=\"sort=dateOfFlight,asc&sort=depTime,asc&sort=account.name,asc&sort=item18RegNum,asc\">Date</option><option translate value=\"sort=item18RegNum,asc&sort=dateOfFlight,asc&sort=depTime,asc\">Aircraft</option></select></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 form-group-inline\" style=\"margin-left: 15px\"><div class=checkbox><label><input id=select-all-flights type=checkbox ng-model=allFlightsSelected ng-change=toggleAllFlights() checked=allFlightsSelected> <span translate>Select all flights</span></label></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 form-group-inline\"><div class=checkbox><label><input id=locate-duplicate-missing-flights type=checkbox ng-model=showDuplicateMissing ng-change=locateDuplicateMissingFlights(showDuplicateMissing)> <span translate>Locate duplicate/missing flights</span></label></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 form-group-inline\"><div class=checkbox><label><input id=show-actual-dep-dest-ad type=checkbox ng-model=showActualDepDestAd ng-disabled=showDuplicateMissing> <span translate>Show actual departure/destination</span></label></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 form-group-inline\"><div class=checkbox ng-show=isEANS><label><input id=crco-flight-filter type=checkbox ng-model=crcoFlightFilter ng-change=refreshOverride() ng-init=\"crcoFlightFilter = \'false\'\"> <span translate>CRCO Flight</span></label></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><div class=notification><span class=text-warning>{{ notification_text | translate }}</span></div></div></div><div class=row ng-show=\"flagDisableButton === true\"><div class=\"col-xs-12 text-center\"><div class=notification><span class=text-warning>{{ notification_text_mark_as_paid | translate}}</span></div></div></div><div class=row ng-show=\"showAircraftRegistrationWarning === true\"><div class=\"col-xs-12 text-center\"><div class=notification><span class=text-warning>{{ notification_no_aircraft_registration | translate}}</span></div></div></div><div class=\"row margin-top-15 margin-bottom-15\"><div class=col-xs-12><button translate ng-show=\"reconcileJob.job_execution_status !== \'STARTED\' && reconcileJob.job_execution_status !== \'QUEUED\'\" ng-disabled=\"numberOfSelectedMovements === 0 || notAllowedRecalculate || (!hasPermission(\'flight_movement_modify\') && !hasPermission(\'flight_movement_key_modify\'))\" ng-click=executeReconciliation() class=\"btn btn-primary btn-reconcile spaced-buttons\">Recalculate</button> <button translate ng-show=\"reconcileJob.job_execution_status === \'STARTED\' || reconcileJob.job_execution_status === \'QUEUED\'\" ng-click=cancelReconciliation() class=\"btn btn-default spaced-buttons\">Cancel Recalculate</button> <button translate class=\"btn btn-primary btn-generate spaced-buttons\" ng-disabled=\"numberOfSelectedMovements === 0 || !isAllowedInvoice || (!hasPermission(\'flight_movement_modify\') && !hasPermission(\'flight_movement_key_modify\'))\" ng-click=\"generateInvoice(accountId, checkboxesSelected());\">Generate Invoice</button> <button translate class=\"btn btn-primary spaced-buttons\" ng-if=\"markZeroFlightCostsAsPaid === \'Manually\'\" ng-disabled=\"(numberOfSelectedMovements === 0 || flagDisableButton) || (!hasPermission(\'flight_movement_modify\') && !hasPermission(\'flight_movement_key_modify\'))\" ng-click=markAsPaid(checkboxesSelected());>Mark as PAID</button></div></div><!-- Notication Panels --><div ng-show=\"invoiceCreated || markedAsPaid || (reconcileJob && (reconcileJob.start_time || reconcileJob.job_execution_status === \'QUEUED\'))\" class=\"row notifications-container\"><div class=col-xs-12><!-- Reconciliation Notification --><div class=\"notification notification-responsive notification-reconcile-job\" ng-show=\"reconcileJob && (reconcileJob.start_time || reconcileJob.job_execution_status === \'QUEUED\')\"><u translate>Recalculation</u> <span class=\"btn btn-sm btn-close pull-right\" ng-click=\"reconcileJob = null\">X</span><br><span translate>Flight ID:</span><span>&nbsp;{{ reconcileJob.job_parameters }}</span><br><span translate>Started:</span><span>&nbsp;{{ reconcileJob.start_time | dateConverter: \'HH:mm\' }}</span><br><span translate>Status:</span><span>&nbsp;{{ reconcileJob.job_execution_status | translate }}</span><br><span translate>Processed:</span><span>&nbsp;{{ reconcileJob.total_steps }}</span><br><span translate>Updated:</span><span>&nbsp;{{ reconcileJob.steps_completed + reconcileJob.steps_aborted }}</span><br><span translate>ETC:</span><span>&nbsp;{{ reconcileJob.etc_time | dateConverter: \'HH:mm\' }}</span> <span ng-show=reconcileJob.seconds_left>&nbsp;({{ reconcileJob.seconds_left }})</span><br><span translate>Rate:</span><span>&nbsp;{{ reconcileJob.rate }}</span><br><br><uib-progressbar max=reconcileJob.total_steps value=\"reconcileJob.steps_completed + reconcileJob.steps_aborted\" ng-show=\"reconcileJob.job_execution_status !== \'STARTING\'\" style=\"height: 10px\"></uib-progressbar></div><!-- Invoice Generation Notification --><div class=\"notification notification-responsive\" ng-show=\"invoiceCreated === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #4caf50; color: white;\n                         padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Successfully created invoice</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"invoiceCreated = false\">X</span></div><!-- Mark As Paid Notification --><div class=\"notification notification-responsive\" ng-show=\"markedAsPaid === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #4caf50; color: white;\n                         padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Successfully marked PENDING zero cost flights as PAID</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"markedAsPaid = false\">X</span></div></div></div><div class=row><flight-movement-table><!-- Flight Movement Table --></flight-movement-table></div><div class=row><div class=col-xs-12><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div id=flight-plan-modal-holder><!-- Flight Plan Modal --></div>");
$templateCache.put("app/partials/flight-movement-management/flight-plan.template.html","<modal-movable class=modal-movable><div><div class=modal-header><h5 class=\"modal-title text-center\" id=modal-title translate>Flight Plan</h5></div><div id=modal-body><div><pre class=modal-content>{{fpl.initial_fpl_data}}</pre></div></div></div></modal-movable>");
$templateCache.put("app/partials/flight-movement-management/flight-plan.template_old.html","<modal-movable><div class=modal-header><h5 class=\"modal-title text-center\" id=modal-title translate>Flight Plan</h5></div><div class=modal-body id=modal-body><div class=row><div class=col-xs-7><div class=row><div class=col-xs-3><label translate>3 MESSAGE TYPE</label><h4 class=fpl>&lt;=(FPL</h4></div><div class=col-xs-3><label translate for=registration-number>7 REGISTRATION NUMBER</label><br><span>&#x2015;</span> <input class=num-of-chars-7 maxlength=7 id=registration-number type=text ng-model=$parent.editable.item18_reg_num readonly=readonly></div><div class=col-xs-2><label translate for=flight-rules>8 FLIGHT RULES</label><br><span>&#x2015;</span> <input class=num-of-chars-1 maxlength=1 id=flight-rules type=text ng-model=$parent.editable.flight_rules readonly=readonly></div><div class=col-xs-3><label translate for=type-of-flight>TYPE OF FLIGHT</label><br><span>&#x2015;</span> <input class=num-of-chars-1 maxlength=1 id=type-of-flight type=text ng-model=$parent.editable.flight_type></div><div class=col-xs-1><h4 class=fpl>&lt;=</h4></div></div><!--Row 2--><div class=row><div class=col-xs-2><!-- As of 14/12/17, number is not used in ABMS. Col is kept to maintain spacing --><label translate for=number>9 NUMBER</label><br><span ng-if=$parent.editable.number><span>&#x2015;</span> <input class=num-of-chars-2 maxlength=2 id=number type=text readonly=readonly></span></div><div class=col-xs-3><label translate for=type-of-aircraft>TYPE OF AIRCRAFT</label><br><input class=num-of-chars-4 maxlength=4 id=type-of-aircraft type=text ng-model=$parent.editable.aircraft_type readonly=readonly></div><div class=col-xs-3><label translate for=wake-turbulence-cat>WAKE TURBULENCE CAT.</label><br><span class=slash>&#47;&nbsp;</span> <input class=num-of-chars-1 maxlength=1 id=wake-turbulence-cat type=text ng-model=$parent.editable.wake_turb readonly=readonly></div><div class=col-xs-3><!-- As of 14/12/17, equipment is not used in ABMS. Col is kept to maintain spacing --> <span ng-if=$parent.editable.equipment><label translate for=equipment>10 EQUIPMENT</label><br><nobr><span>&#x2015;</span> <input id=equipment type=text readonly=readonly ng-model=$parent.editable.equipment></nobr></span></div><div class=col-xs-1><h4 class=fpl>&lt;=</h4></div></div><!--Row 3--><div class=row><div class=\"col-xs-3 col-xs-offset-1\"><label translate for=departure-aerodrome>13 DEPARTURE AERODROME</label><br><input class=num-of-chars-4 maxlength=4 id=departure-aerodrome type=text ng-model=$parent.editable.dep_ad readonly=readonly></div><div class=col-xs-3><label translate for=time>TIME</label><br><input class=num-of-chars-6 maxlength=6 id=time type=text ng-model=$parent.editable.dep_time readonly=readonly></div><div class=col-xs-4></div><div class=col-xs-1><br><h4 class=fpl>&lt;=</h4></div></div><!--Row 4--><div class=row><div class=col-xs-3><label translate for=cruising-speed>15 CRUISING SPEED</label><br><span>&#x2015;</span> <input class=num-of-chars-5 maxlength=5 id=cruising-speed-or-mach-number type=text readonly=readonly ng-model=$parent.editable.cruising_speed_or_mach_number></div><div class=col-xs-2><label translate for=level>LEVEL</label><br><input class=num-of-chars-5 maxlength=5 id=level type=text readonly=readonly ng-model=$parent.editable.flight_level></div><div class=col-xs-6><label translate for=fpRoute>ROUTE</label><br><p id=fpRoute><span class=span1><span class=span2>{{ $parent.dynamicRoute || \'\\r\\n\' }}</span></span></p></div></div><!--Row 5--><div class=row><div class=\"col-xs-3 col-xs-offset-1\"><label translate for=destination-aerodrome>16 DESTINATION AERODROME</label><br><input class=num-of-chars-4 maxlength=4 id=destination-aerodrome type=text ng-model=$parent.editable.dest_ad readonly=readonly></div><div class=col-xs-2><!-- As of 14/12/17, alternative aerodrome is not used in ABMS. Col is kept to maintain spacing --> <span ng-if=$parent.editable.hr_min><label translate for=hr-min>HR MIN</label><br><input class=num-of-chars-4 maxlength=4 id=hr-min type=text readonly=readonly></span></div><div class=col-xs-2><!-- As of 14/12/17, alternative aerodrome is not used in ABMS. Col is kept to maintain spacing --> <span ng-if=$parent.editable.altn_ad><label translate for=altn-aerodrome>ALTN AERODROME</label><br><input class=num-of-chars-4 maxlength=4 id=altn-aerodrome type=text readonly=readonly ng-model=$parent.editable.altn_ad></span></div><div class=col-xs-3><!-- As of 14/12/17, alternative aerodrome 2 is not used in ABMS. Col is kept to maintain spacing --> <span ng-if=$parent.editable.altn_ad_2><label translate for=second-altn-aerodrome>2ND ALTN AERODROME</label><br><input class=num-of-chars-4 maxlength=4 id=second-altn-aerodrome type=text readonly=readonly ng-model=$parent.editable.altn_ad_2></span></div><div class=col-xs-1><br><h4 class=fpl>&lt;=</h4></div></div><!--Row 6--><div class=row><div class=col-xs-11><label translate for=other-information>18 OTHER INFORMATION</label><p id=other-information><span class=span1><span class=span2>{{ $parent.editable.item18_rmk || \'\\r\\n\' }}</span></span></p></div><div class=col-xs-1><br><h4 class=fpl>&lt;=</h4></div></div></div><div class=col-xs-5><div class=\"row table-row\"><div class=\"col-xs-12 table-responsive fp-table\"><table class=table><thead><tr><th translate>From</th><th translate>To</th><th class=text-right><span>{{ \'Distance\' | translate }}&nbsp;({{ $parent.distanceUnitOfMeasure | translate }}) *</span></th></tr></thead><tbody><tr ng-click=\"editable.distanceToPay = segment.segment_length; editable.segment_clicked = segment.id\" ng-init=\"editable.distanceToPay = totalDistance\" ng-repeat=\"segment in specificRouteSegments\" ng-class=\"{\'highlight\': segment.id === editable.segment_clicked}\"><td>{{ segment.segment_start_label }}</td><td>{{ segment.destination }}</td><td class=text-right>{{ segment.segment_length | distanceConverter | number : \'2\'}}</td></tr></tbody></table></div></div><div class=row><div class=col-xs-12><div class=totals><span>{{ \'Total distance\' | translate }}&nbsp;({{ $parent.distanceUnitOfMeasure | translate }})</span> <span class=pull-right>{{ totalDistance | distanceConverter | number : \'2\' }}</span><br><span>{{ \'Total distance to pay\' | translate }}&nbsp;({{ $parent.distanceUnitOfMeasure | translate }})</span> <span class=pull-right>{{ editable.distanceToPay | distanceConverter | number : \'2\' }}</span><br><span>{{ \'Total to pay for Flight (USD)\' | translate }}&nbsp;{{ totalCost | number : \'2\' }}</span></div></div></div></div></div></div></modal-movable>");
$templateCache.put("app/partials/flight-reassignment/flight-reassignment.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.flight-reassignement icon=\"\'plane\'\" title=\"{{ \'Flight Reassignment\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-3\"><label translate for=account>Account</label><dynamic-service-dropdown empty-to-null ng-model=accountFilter id=accountFilter name=accountFilter dropdown-type=single service=::accountsService method=findAllMinimalReturn options=\"item.id as item.name for item in list track by item.id\" ng-change=refreshOverride() allow-empty=true></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table back-end-export=true service=flightReassignmentService sort-query-string=getSortQueryString() query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate sort=account>Reassigned Company</th><th translate sort=previousAccounts>Previous Companies</th><th translate sort=startDate>Start Date</th><th translate sort=endDate>End Date</th><th translate sort=identificationType>Identifier Type</th><th translate sort=identifierText>Identifier Text</th><th translate sort=aerodromes>Aerodromes</th><th translate sort=appliesToTypeArrival>Flight Type</th><th translate sort=appliesToScopeDomestic>Flight Scope</th><th translate sort=appliesToNationalityNat>Aircraft Nationality</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item); saveOldValue(); populateDropdowns(); updateAerodromeMultiselect();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.previous_accounts }}</td><td class=text-nowrap>{{ item.start_date | dateConverter }}</td><td class=text-nowrap>{{ item.end_date | dateConverter }}</td><td class=text-nowrap>{{ item.identification_type }}</td><td class=text-nowrap>{{ item.identifier_text }}</td><td class=text-nowrap>{{ ::getAerodromeIdentifiers(item.aerodrome_identifiers) }}</td><td class=text-nowrap>{{ ::getApplication(item, \'applies_to_type\') }}</td><td class=text-nowrap>{{ ::getApplication(item, \'applies_to_scope\') }}</td><td class=text-nowrap>{{ ::getApplication(item, \'applies_to_nationality\') }}</td></tr><tr ng-show=\"!list.length || !list\"><td colspan=9 class=text-center translate>There are no Reassigned Flights</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div ng-show=!toggle class=\"row col-xs-15\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'plane\'\" ng-show=\"editable.id === null\" title=\"{{ \'Create a Flight Reassignment\' | translate }}\"></box-header><box-header icon=\"\'plane\'\" ng-show=\"editable.id !== null\" title=\"{{ \'Edit a Flight Reassignment\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_reassignment_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=account>{{ \'Reassigned Company\' | translate }} *</label><dynamic-service-dropdown ng-model=editable.account id=account name=account dropdown-type=single service=::accountsService method=findAllCreditMinimalActiveReturn is-required=::true options=\"item as item.name for item in list track by item.name\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=identification_type>{{ \'Identifier Type\' | translate }} *</label><select id=identification_type class=form-control ng-model=editable.identification_type ng-change=setMaxLength(editable.identification_type);><option translate value=\"ICAO code\">ICAO Code</option><option translate value=\"Flight Id\">Flight Identifier</option><option translate value=Registration>Registration</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodromes>{{ \'Aerodromes\' | translate }} *</label><multiselect id=aerodromes name=aerodromesList extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'aerodrome_name\', externalIdProp: \'\' }\" options=aerodromesList model=aerodromesModel events=\"{ onSelectionChanged: addAerodromeToList }\"></multiselect></div><div class=\"col-xs-12 col-md-6\"><label for=identifier_text>{{ \'Identifier Text\' | translate }} *</label><input ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false maxlength=\"{{ maxLength }}\" maxlength=3 id=identifier_text name=identifier_text type=identifier_text class=\"form-control text-uppercase\" ng-model=editable.identifier_text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=start_date>{{ \'Start Date\' | translate }} *</label><p class=input-group><date-picker id=start_date name=startDate type=text ng-change=\"dateChanged(\'start\', editable.start)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" uib-datepicker-popup=yyyy-MM-dd ng-model=editable.start_date is-open=startDate.open ng-attr-title=\"{{ editable.start ? \'\' : \'Please fill out this field\' | translate }}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDate.open = !startDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=end-date>{{ \'End Date\' | translate }} *</label><p class=input-group><date-picker id=end_date name=endDate type=text ng-change=\"dateChanged(\'end\', editable.end)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" uib-datepicker-popup=yyyy-MM-dd ng-model=editable.end_date is-open=endDate.open ng-attr-title=\"{{editable.end ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDate.open = !endDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate>Flight Type</label><div class=checkbox><label><input id=applies_to_type_arrival name=applies_to_type_arrival type=checkbox ng-model=editable.applies_to_type_arrival> <span translate>Arrival</span></label></div><div class=checkbox><label><input id=applies_to_type_departure name=applies_to_type_departure type=checkbox ng-model=editable.applies_to_type_departure> <span translate>Departure</span></label></div><div class=checkbox><label><input id=applies_to_type_domestic name=applies_to_type_domestic type=checkbox ng-model=editable.applies_to_type_domestic> <span translate>Domestic</span></label></div><div class=checkbox><label><input id=applies_to_type_overflight name=applies_to_type_overflight type=checkbox ng-model=editable.applies_to_type_overflight> <span translate>Overflight</span></label></div></div><div class=\"col-xs-12 col-md-6\"><label translate>Flight Scope</label><div class=checkbox><label><input id=applies_to_scope_domestic name=applies_to_scope_domestic type=checkbox ng-model=editable.applies_to_scope_domestic> <span translate>Domestic</span></label></div><div class=checkbox><label><input id=applies_to_scope_regional name=applies_to_scope_regional type=checkbox ng-model=editable.applies_to_scope_regional> <span translate>Regional</span></label></div><div class=checkbox><label><input id=applies_to_scope_international name=applies_to_scope_international type=checkbox ng-model=editable.applies_to_scope_international> <span translate>International</span></label></div></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate>Aircraft Nationality</label><div class=checkbox><label><input id=applies_to_nationality_national name=applies_to_nationality_national type=checkbox ng-model=editable.applies_to_nationality_national> <span translate>National</span></label></div><div class=checkbox><label><input id=applies_to_nationality_foreign name=applies_to_nationality_foreign type=checkbox ng-model=editable.applies_to_nationality_foreign> <span translate>Foreign</span></label></div></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || editable.daily_schedule === null || editable.daily_schedule === \'\'\" ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched(); reset();\">Create</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=form.$invalid ng-show=\"editable.id !== null\" ng-click=\"update(editable, editable.id); form.$setUntouched(); reset();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/flight-route-exemptions/flight-route-exemptions.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=exemptions.exempt-flight-route-management toggle=toggle icon=\"\'external-link\'\" title=\"{{ \'Exempt Flight Routes\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=flightRouteExemptionsService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th class=text-nowrap sort=exemptType ng-if=\"isEANA && isExemptRouteForEana\">{{\'Exempt Type\' | translate}}</th><th class=text-nowrap sort=departureAerodrome>{{\'Departure Aerodrome\' | translate}}</th><th class=text-nowrap sort=destinationAerodrome>{{\'Destination Aerodrome\' | translate}}</th><th class=text-nowrap sort=waypointFrom ng-if=\"isEANA && isExemptRouteForEana\">{{\'Waypoint From\' | translate}}</th><th class=text-nowrap sort=waypointTo ng-if=\"isEANA && isExemptRouteForEana\">{{\'Waypoint To\' | translate}}</th><th class=text-nowrap sort=airway ng-if=\"isEANA && isExemptRouteForEana\">{{\'Airway\' | translate}}</th><th class=text-nowrap sort=coordinateFrom ng-if=\"isEANA && isExemptRouteForEana\">{{\'Coordinate From\' | translate}}</th><th class=text-nowrap sort=coordinateTo ng-if=\"isEANA && isExemptRouteForEana\">{{\'Coordinate To\' | translate}}</th><th class=text-nowrap sort=startDate ng-if=isEANA>{{\'Start Date\' | translate}}</th><th class=text-nowrap sort=endDate ng-if=isEANA>{{\'End Date\' | translate}}</th><th class=text-nowrap sort=exemptionInEitherDirection>{{\'Bidirectional Route\' | translate}}</th><th class=text-nowrap sort=enrouteFeesAreExempt>{{\'Enroute Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=approachFeesAreExempt>{{\'Approach Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=aerodromeFeesAreExempt>{{\'Aerodrome Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=lateArrivalFeesAreExempt ng-if=\"shouldShowCharge(\'arrival\')\">{{\'Late Arrival Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=lateDepartureFeesAreExempt ng-if=\"shouldShowCharge(\'departure\')\">{{\'Late Departure Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=parkingFeesAreExempt ng-if=\"shouldShowCharge(\'parking\')\">{{\'Parking Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=internationalPax>{{\'International PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=domesticPax>{{\'Domestic PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=extendedHours ng-if=\"shouldShowCharge(\'extendedHours\')\">{{\'Extended Hours Fees Exempt\' | translate}} (%)</th><th class=\"text-nowrap text-right\" sort=exemptRouteFloor>{{\'Exempt Route Floor\' | translate}}</th><th class=\"text-nowrap text-right\" sort=exemptRouteCeiling>{{\'Exempt Route Ceiling\' | translate}}</th><th class=text-nowrap sort=flightNotes>{{\'Flight Notes\' | translate}}</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap ng-if=\"isEANA && isExemptRouteForEana\">{{ item.exempt_type }}</td><td class=text-nowrap>{{ item.departure_aerodrome }}</td><td class=text-nowrap>{{ item.destination_aerodrome }}</td><td class=text-nowrap ng-if=\"isEANA && isExemptRouteForEana\">{{ item.waypoint_from }}</td><td class=text-nowrap ng-if=\"isEANA && isExemptRouteForEana\">{{ item.waypoint_to }}</td><td class=text-nowrap ng-if=\"isEANA && isExemptRouteForEana\">{{ item.airway }}</td><td class=text-nowrap ng-if=\"isEANA && isExemptRouteForEana\">{{ item.coordinate_from }}</td><td class=text-nowrap ng-if=\"isEANA && isExemptRouteForEana\">{{ item.coordinate_to }}</td><td class=text-nowrap ng-if=isEANA>{{ item.start_date | dateConverter }}</td><td class=text-nowrap ng-if=isEANA>{{ item.end_date | dateConverter }}</td><td class=text-nowrap>{{ item.exemption_in_either_direction | translate }}</td><td class=text-nowrap>{{ item.enroute_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.approach_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.aerodrome_fees_are_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_fees_are_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_fees_are_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.international_pax | number: 2 }}</td><td class=text-nowrap>{{ item.domestic_pax | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours | number: 2 }}</td><td class=text-right>{{ item.exempt_route_floor | number: 2 }}</td><td class=text-right>{{ item.exempt_route_ceiling | number: 2 }}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!list.length><td class=text-center translate colspan=15>There are no Exempt Flight Routes data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'external-link\'\" title=\"{{ \'Create an Exempt Flight Route\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'external-link\'\" title=\"{{ \'Edit an Exempt Flight Route\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'exempt_flight_route_modify\')\"><div class=row ng-if=\"isEANA && isExemptRouteForEana\"><div class=\"col-xs-12 col-md-6\"><label translate for=exempt_type>Exempt Type *</label><dynamic-service-dropdown ng-model=editable.exempt_type id=exempt_type name=exemptType dropdown-type=single disabled=\"editable.id && editable.id !== null\" service=::flightRouteExemptionsService is-required=::true method=listExemptTypes ng-change=\"editable.exempt_item_value = null\" options=\"item.value as (item.value | translate) for item in list\"></dynamic-service-dropdown></div></div><div class=row ng-if=\"!isEANA || !isExemptRouteForEana || (editable.exempt_type && editable.exempt_type === \'Aerodrome To Aerodrome\')\"><div class=\"col-xs-12 col-md-6\"><label for=departure_aerodrome>{{\'Departure Aerodrome\' | translate}} *</label><input id=departure_aerodrome name=departureAerodrome type=text class=form-control ng-model=editable.departure_aerodrome uppercase-input minlength=4 maxlength=4 ng-pattern=/^[a-zA-Z0-9]{4}$/ required></div><div class=\"col-xs-12 col-md-6\"><label for=destination_aerodrome>{{\'Destination Aerodrome\' | translate}} *</label><input id=destination_aerodrome name=destinationAerodrome type=text class=form-control ng-model=editable.destination_aerodrome uppercase-input minlength=4 maxlength=4 ng-pattern=/^[a-zA-Z0-9]{4}$/ required></div></div><div class=row ng-if=\"editable.exempt_type && editable.exempt_type === \'Waypoint To Waypoint\' && isExemptRouteForEana\"><div class=\"col-xs-12 col-md-6\"><label for=waypoint_from>{{\'Waypoint From\' | translate}} *</label><select id=waypoint_from name=waypoint_from class=form-control ng-model=editable.waypoint_from required><option ng-repeat=\"item in listEanaWaypoints | orderBy: \'ident\'\" value={{item.ident}}>{{item.ident}}</option></select></div><div class=\"col-xs-12 col-md-6\"><label for=waypoint_to>{{\'Waypoint To\' | translate}} *</label><select id=waypoint_to name=waypoint_to class=form-control ng-model=editable.waypoint_to required><option ng-repeat=\"item in listEanaWaypoints | orderBy: \'ident\'\" value={{item.ident}}>{{item.ident}}</option></select></div></div><div class=row ng-if=\"editable.exempt_type && editable.exempt_type === \'Airway\' && isExemptRouteForEana\"><div class=\"col-xs-12 col-md-6\"><label for=airway>{{\'Airway\' | translate}} *</label><select id=airway name=airway class=form-control ng-model=editable.airway required><option ng-repeat=\"item in listEanaAirways | orderBy: \'txtdesig\'\" value={{item.txtdesig}}>{{item.txtdesig}}</option></select></div></div><div class=row ng-if=\"editable.exempt_type && editable.exempt_type === \'Coordinate\' && isExemptRouteForEana\"><div class=\"col-xs-12 col-md-6\"><label for=coordinate_from>{{\'Coordinate From\' | translate}} (DDMMSS[N|S]DDDMMSS[E|W])*</label><input id=coordinate_from name=coordinate_from type=text class=form-control ng-model=editable.coordinate_from uppercase-input minlength=4 maxlength=15 ng-pattern=/^(\\d{6}[N|S]\\d{7}[W|E])/ required></div><div class=\"col-xs-12 col-md-6\"><label for=coordinate_to>{{\'Coordinate To\' | translate}} (DDMMSS[N|S]DDDMMSS[E|W])*</label><input id=coordinate_to name=coordinate_to type=text class=form-control ng-model=editable.coordinate_to uppercase-input minlength=4 maxlength=15 ng-pattern=/^(\\d{6}[N|S]\\d{7}[W|E])/ required></div></div><div class=row ng-if=isEANA><div class=\"col-xs-12 col-md-6\"><label for=start_date>{{ \'Start Date\' | translate }} *</label><p class=input-group><date-picker id=start_date name=startDate type=text ng-change=\"dateChanged(\'start\', editable.start)\" show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" uib-datepicker-popup=yyyy-MM-dd ng-required=true ng-model=editable.start_date is-open=startDate.open ng-attr-title=\"{{ editable.start ? \'\' : \'Please fill out this field\' | translate }}\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDate.open = !startDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=end-date>{{ \'End Date\' | translate }} *</label><p class=input-group><date-picker id=end_date name=endDate type=text ng-change=\"dateChanged(\'end\', editable.end)\" show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" uib-datepicker-popup=yyyy-MM-dd ng-required=true ng-model=editable.end_date is-open=endDate.open ng-attr-title=\"{{editable.end ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDate.open = !endDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exemption_in_either_direction>{{\'Bidirectional Route\' | translate}} *</label><boolean-text id=exemption_in_either_direction name=exemptionInEitherDirection class=form-control ng-model=editable.exemption_in_either_direction required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=enroute_fees_are_exempt>{{\'Enroute Fees Exempt\' | translate}} * (%)</label><input id=enroute_fees_are_exempt name=enrouteFeesAreExempt class=form-control ng-model=editable.enroute_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome_fees_are_exempt>{{\'Aerodrome Fees Exempt\' | translate}} * (%)</label><input id=aerodrome_fees_are_exempt name=aerodromeFeesAreExempt class=form-control ng-model=editable.aerodrome_fees_are_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=approach_fees_are_exempt>{{\'Approach Fees Exempt\' | translate}} * (%)</label><input id=approach_fees_are_exempt name=approachFeesAreExempt class=form-control ng-model=editable.approach_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'arrival\')\"><label for=late_arrival_fees_are_exempt>{{\'Late Arrival Fees Exempt\' | translate}} * (%)</label><input id=late_arrival_fees_are_exempt name=lateArrivalFeesAreExempt class=form-control ng-model=editable.late_arrival_fees_are_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'departure\')\"><label for=late_departure_fees_are_exempt>{{\'Late Departure Fees Exempt\' | translate}} * (%)</label><input id=late_departure_fees_are_exempt name=lateDepartureFeesAreExempt class=form-control ng-model=editable.late_departure_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking_fees_are_exempt>{{\'Parking Fees Exempt\' | translate}} * (%)</label><input id=parking_fees_are_exempt name=parkingFeesAreExempt class=form-control ng-model=editable.parking_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=international-pax>{{\'International PAX Fees Exempt\' | translate}} * (%)</label><input id=international-pax name=inernationalPax class=form-control ng-model=editable.international_pax type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=domestic-pax>{{\'Domestic PAX Fees Exempt\' | translate}} * (%)</label><input id=domestic-pax name=domesticPax class=form-control ng-model=editable.domestic_pax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'extendedHours\')\"><label for=extended-hours>{{\'Extended Hours Fees Exempt\' | translate}} * (%)</label><input id=extended-hours name=extendedHours class=form-control ng-model=editable.extended_hours type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exempt-route-floor>{{\'Exempt Route Floor\' | translate}} *</label><input id=exempt-route-floor name=exemptRouteFloor class=form-control type=number step=0.01 min=0 max=999 ng-model=editable.exempt_route_floor required></div><div class=\"col-xs-12 col-md-6\"><label translate for=exempt-route-ceiling>{{\'Exempt Route Ceiling\' | translate}} *</label><input id=exempt-route-ceiling name=exemptRouteCeiling class=form-control type=number step=0.01 min=0 max=999 ng-model=editable.exempt_route_ceiling required></div></div><div class=row><div class=col-xs-12><label for=flight_notes>{{\'Flight Notes\' | translate}} *</label><input id=flight_notes name=flightNotes type=text class=form-control ng-model=editable.flight_notes required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button translate class=\"btn btn-primary\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/flight-schedule-management/flight-schedule-management.html","<div class=row><div class=col-xs-12 ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><!-- flight schedules --><div class=box-container><box-header toggle=toggle page-name=flight-data.flight-schedule-management icon=\"\'calendar\'\" title=\"{{ \'Flight Schedules\' | translate }}\"></box-header><div class=box-content><!-- flight schedule data grid filters and actions --><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-4\"><label translate for=account>Account</label><select ng-model=accountId id=account name=account class=form-control ng-change=refreshOverride() ng-options=\"item.id as item.name for item in accountsWithFlightSchedules\"></select></div><div class=\"col-xs-12 col-md-4\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><!-- flight schedule data grid --><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=flightScheduleManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=activeIndicator>Active</th><th translate class=text-nowrap sort=flightServiceNumber>Flight Service Number</th><th translate class=text-nowrap sort=depAd>Dep Ad</th><th translate class=text-nowrap sort=depTime>Dep Time</th><th translate class=text-nowrap sort=destAd>Dest Ad</th><th translate class=text-nowrap sort=destTime>Dest Time</th><th translate class=text-nowrap sort=dailySchedule>Daily Schedule</th><th translate class=text-nowrap sort=selfCare>Self-Care</th><th translate class=text-nowrap sort=startDate>Start Date</th><th translate class=text-nowrap sort=endDate>End Date</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.active_indicator | translate }}</td><td class=text-nowrap>{{ item.flight_service_number }}</td><td class=text-nowrap>{{ item.dep_ad }}</td><td class=text-nowrap>{{ item.dep_time }}</td><td class=text-nowrap>{{ item.dest_ad }}</td><td class=text-nowrap>{{ item.dest_time }}</td><td class=text-nowrap>{{ formatDailySchedules(item.daily_schedule, \',\') }}</td><td class=text-nowrap>{{ item.self_care | translate }}</td><td class=text-nowrap>{{ item.start_date | dateConverter }}</td><td class=text-nowrap>{{ item.end_date | dateConverter }}</td></tr><tr ng-show=!accountsWithFlightSchedules.length><td class=text-center colspan=10 translate>There are no Accounts with Flight Schedules data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div><!-- non-form errors --><ng-include ng-show=!toggle src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div><!-- missing flight movements for selected flight schedule --><div class=\"box-container margin-top-20\" ng-show=editable.id><box-header icon=\"\'plane\'\" title=\"{{ \'Missing Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th class=text-nowrap translate>Flight ID</th><th class=text-nowrap translate>Day of Flight</th><th class=text-nowrap translate>Dep Ad</th><th class=text-nowrap translate>Dep Time</th></tr></thead><tbody><tr ng-show=editable.missing_flight_movements.length ng-repeat=\"flightmovement in editable.missing_flight_movements | orderBy:[\'-date_of_flight\',\'-dep_time\'] \n                                            | limitTo : pagination.size : (editable.missing_flight_movements.number * pagination.size) - pagination.size\"><td class=text-nowrap>{{ flightmovement.flight_id }}</td><td class=text-nowrap>{{ flightmovement.date_of_flight | dateConverter }}</td><td class=text-nowrap>{{ flightmovement.dep_ad }}</td><td class=text-nowrap>{{ flightmovement.dep_time }}</td></tr><tr ng-show=!editable.missing_flight_movements.length><td class=text-center colspan=4 translate>There are no missing flight movements</td></tr></tbody></table></div><ul uib-pagination total-items=editable.missing_flight_movements.length max-size=::20 items-per-page=pagination.size ng-model=editable.missing_flight_movements.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><!-- unexpected flight movements for selected flight schedule --><div class=\"box-container margin-top-20\" ng-show=editable.id><box-header icon=\"\'plane\'\" title=\"{{ \'Unexpected Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th class=text-nowrap><span translate>Flight ID</span></th><th class=text-nowrap><span translate>Day of Flight</span></th><th class=text-nowrap translate>Dep Ad</th><th class=text-nowrap translate>Dep Time</th></tr></thead><tbody><tr ng-show=editable.unexpected_flights.length ng-repeat=\"flightmovement in editable.unexpected_flights | orderBy:[\'-date_of_flight\',\'-dep_time\'] \n                                            | limitTo : pagination.size : (editable.unexpected_flights.number * pagination.size) - pagination.size\"><td class=text-nowrap>{{ flightmovement.flight_id }}</td><td class=text-nowrap>{{ flightmovement.date_of_flight | dateConverter }}</td><td class=text-nowrap>{{ flightmovement.dep_ad }}</td><td class=text-nowrap>{{ flightmovement.dep_time }}</td></tr><tr ng-show=!editable.unexpected_flights.length><td class=text-center colspan=4 translate>There are no unexpected flight movements</td></tr></tbody></table></div><ul uib-pagination total-items=editable.unexpected_flights.length max-size=::20 items-per-page=pagination.size ng-model=editable.unexpected_flights.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container class=\"col-xs-12 col-lg-6\" ng-show=toggle><!-- create/edit flight schedule --><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Create a Flight Schedule\' | translate }}\" ng-show=\"editable.id === null\"></box-header><box-header icon=\"\'plane\'\" title=\"{{ \'Edit a Flight Schedule\' | translate }}\" ng-show=\"editable.id !== null\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_schedule_modify\')\"><legend class=sr-only ng-if=\"editable.id === null\" translate>Create a Flight Schedule</legend><legend class=sr-only ng-if=\"editable.id !== null\" translate>Edit a Flight Schedule</legend><!-- create/edit flight schedule fields --><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account name=accountId dropdown-type=single service=::accountsService method=findAllActiveMinimalReturn is-required=::true options=\"item as item.name for item in list track by item.name\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight-service-number>Flight Service Number *</label><input id=flight-service-number name=flightServiceNumber class=form-control type=text ng-model=editable.flight_service_number uppercase-input required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=dep-ad>Departure Aerodrome *</label><input id=dep-ad name=depAd class=form-control type=text ng-model=editable.dep_ad aerodrome-identifiers minlength=4 ng-trim=false required></div><div class=\"col-xs-12 col-md-6\"><label translate for=destination-aerodrome>Destination Aerodrome *</label><input id=destination-aerodrome name=destAd class=form-control type=text ng-model=editable.dest_ad aerodrome-identifiers minlength=4 ng-trim=false required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=dep-time>Departure Time *</label><input id=dep-time name=depTime class=form-control type=text ng-model=editable.dep_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.dep_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div><div class=\"col-xs-12 col-md-6\"><label translate for=dest-time>Destination Time *</label><input id=dest-time name=destTime class=form-control type=text ng-model=editable.dest_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.dest_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=daily-schedule>Daily Schedule *</label><multiselect events=\"{ onSelectionChanged: addDaysToSchedule }\" translated-value=name extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=listOfDays id=daily_schedule is-required=true name=days model=days></multiselect></div><div class=\"col-xs-12 col-md-6\"><label translate for=active>Active *</label><select id=active name=active class=form-control ng-model=editable.active_indicator required><option translate value=active>active</option><option translate value=inactive>inactive</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=start_date><span translate>Start Date</span>&nbsp;({{ ::dateFormat | translate }})&nbsp;*</label><p class=input-group><date-picker id=start_date name=start_date type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.start_date is-open=start_date.open close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"start_date.open = !start_date.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=end-date><span translate>End Date</span>&nbsp;({{ ::dateFormat | translate }})</label><p class=input-group><date-picker id=end_date name=end_date type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.end_date is-open=end_date.open close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"end_date.open = !end_date.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=self-care>Created by Self-Care</label><input id=self-care name=selfCare class=\"form-control text-capitalize\" ng-value=\"editable.self_care | translate\" readonly=readonly></div></div><!-- form errors --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><!-- create/edit flight schedule actions --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"clearFilters(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id);\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || editable.daily_schedule === null || editable.daily_schedule === \'\'\" ng-show=\"editable.id === null\" ng-click=create(editable);>Create</button></div></div></fieldset></form></div></div><!-- upload flight schedules per account --><div class=\"box-container margin-top-20\"><box-header icon=\"\'plane\'\" title=\"{{ \'Upload a Flight Schedule\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_schedule_modify\')\"><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=\"col-xs-12 col-md-6 schedule-start-date\"><label translate for=start>Start Date *</label><p class=input-group><date-picker ng-init=\"start = null\" id=start name=start type=text ng-change=\"dateChanged(\'start\', start)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=start is-open=start.open ng-attr-title=\"{{start ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"start.open = !start.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=\"preUploadSchedules(start.toISOString(), editable.document)\" ng-disabled=\"!editable.document_filename || !start\">Upload</button><upload-file-format format={{pattern}} template=app/partials/flight-schedule-management/flight-schedule-management.template.html></upload-file-format></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/flight-schedule-management/flight-schedule-management.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12><span class=text-center><h5>{{ \'Flight Schedule File\' | translate }}</h5></span><ul><li>{{ \'Format\' | translate }}: {{ format }}</li><li>{{ \'No column header\' | translate }}</li></ul><span>{{ \'Columns\' | translate }}:</span><ul><li>#1 - {{ \'Flight Service Number\' | translate }}</li><li>#2 - {{ \'Departure Aerodrome\' | translate }} ({{ \'ICAO code\' | translate }})</li><li>#3 - {{ \'Departure Time\' | translate }} (HHmm)</li><li>#4 - {{ \'Destination Aerodrome\' | translate }} ({{ \'ICAO code\' | translate }})</li><li>#5 - {{ \'Destination Time\' | translate }} (HHmm)</li><li>#6 - {{ \'Daily Schedule\' | translate }} ({{ \'day of the week, i.e. MONDAY or TUESDAY/WEDNESDAY\' | translate }})</li></ul><span><strong>{{ \'NOTE\' | translate }}:</strong> {{ \'You can create a flight schedule only for one account per file\' | translate }}</span></div></div><div class=\"row margin-top-20\"><div class=text-center><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/flight-schedule-management/schedule-warning.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12>This file contains schedules that will overwite the following:</div></div><div class=row><div class=\"col-xs-12 warning\"><pre>{{warning}}</pre></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><button type=button class=\"btn btn-primary\" ng-click=confirm()>Confirm</button> <button type=button class=\"btn btn-primary\" ng-click=close()>Cancel</button></div></div></div>");
$templateCache.put("app/partials/flight-status-exemptions/flight-status-exemptions.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=exemptions.exempt-flight-status-management toggle=toggle icon=\"\'pencil-square-o\'\" title=\"{{ \'Exempt Flight Status\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=flightStatusExemptionsService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th class=text-nowrap sort=flightItemType>{{\'Flight Item Type\' | translate}}</th><th class=text-nowrap sort=flightItemValue>{{\'Flight Item Value\' | translate}}</th><th class=text-nowrap sort=enrouteFeesAreExempt>{{\'Enroute Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=approachFeesExempt>{{\'Approach Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=aerodromeFeesExempt>{{\'Aerodrome Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=lateArrivalFeesExempt ng-if=\"shouldShowCharge(\'arrival\')\">{{\'Late Arrival Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=lateDepartureFeesExempt ng-if=\"shouldShowCharge(\'departure\')\">{{\'Late Departure Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=parkingFeesAreExempt ng-if=\"shouldShowCharge(\'parking\')\">{{\'Parking Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=internationalPax>{{\'International PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=domesticPax>{{\'Domestic PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=extendedHours ng-if=\"shouldShowCharge(\'extendedHours\')\">{{\'Extended Hours Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=flightNotes>{{\'Flight Notes\' | translate}}</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.flight_item_type | translate }}</td><td class=text-nowrap>{{ item.flight_item_value }}</td><td class=text-nowrap>{{ item.enroute_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.approach_fees_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.aerodrome_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_fees_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.international_pax | number: 2 }}</td><td class=text-nowrap>{{ item.domestic_pax | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours | number: 2 }}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!list.length><td class=text-center translate colspan=12>There are no Exempt Flight Status data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'pencil-square-o\'\" title=\"{{ \'Create an Exempt Flight Status\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'pencil-square-o\'\" title=\"{{ \'Edit an Exempt Flight Status\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'exempt_flight_status_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=flight_item_type>Flight Item Type *</label><dynamic-service-dropdown ng-model=editable.flight_item_type id=flight_item_type name=flightItemType dropdown-type=single service=::flightStatusExemptionsService is-required=::true method=listFlightTypes ng-change=\"editable.flight_item_value = null\" options=\"item.value as (item.value | translate) for item in list\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_item_value>Flight Item Value *</label><dynamic-service-dropdown ng-model=editable.flight_item_value name=flightItemValue dropdown-type=single service=::flightStatusExemptionsService is-required=::true method=listItem8Codes ng-show=\"editable.flight_item_type === \'ITEM8-TYPE\'\" options=\"item.value as (item.name | translate) for item in list\"></dynamic-service-dropdown><dynamic-service-dropdown ng-model=editable.flight_item_value name=flightItemValue dropdown-type=single service=::flightStatusExemptionsService is-required=::true method=listSTSCodes ng-show=\"editable.flight_item_type === \'ITEM18-STS\'\" options=\"item.value as (item.name | translate) for item in list\"></dynamic-service-dropdown><dynamic-service-dropdown ng-model=editable.flight_item_value name=flightItemValue dropdown-type=single service=::flightStatusExemptionsService is-required=::true method=listRulesCodes ng-show=\"editable.flight_item_type === \'ITEM8-RULE\'\" options=\"item.value as (item.name | translate) for item in list\"></dynamic-service-dropdown><input id=flight_item_value class=form-control ng-model=editable.flight_item_value ng-show=\"editable.flight_item_type == \'ITEM18-RMK\'\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=enroute_fees_are_exempt>{{\'Enroute Fees Exempt\' | translate}} * (%)</label><input id=enroute_fees_are_exempt name=enrouteFeesAreExempt class=form-control ng-model=editable.enroute_fees_are_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=approach_fees_exempt>{{\'Approach Fees Exempt\' | translate}} * (%)</label><input id=approach_fees_exempt name=approachFeesExempt class=form-control ng-model=editable.approach_fees_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome_fees_exempt>{{\'Aerodrome Fees Exempt\' | translate}} * (%)</label><input id=aerodrome_fees_exempt name=aerodromeFeesExempt class=form-control ng-model=editable.aerodrome_fees_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'arrival\')\"><label for=late_arrival_fees_exempt>{{\'Late Arrival Fees Exempt\' | translate}} * (%)</label><input id=late_arrival_fees_exempt name=lateArrivalFeesExempt class=form-control ng-model=editable.late_arrival_fees_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'departure\')\"><label for=late_departure_fees_exempt>{{\'Late Departure Fees Exempt\' | translate}} * (%)</label><input id=late_departure_fees_exempt name=lateDepartureFeesExempt class=form-control ng-model=editable.late_departure_fees_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking_fees_are_exempt>{{\'Parking Fees Exempt\' | translate}} * (%)</label><input id=parking_fees_are_exempt name=parkingFeesAreExempt class=form-control ng-model=editable.parking_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=international-pax>{{\'International PAX Fees Exempt\' | translate}} * (%)</label><input id=international-pax name=internationalPax class=form-control ng-model=editable.international_pax type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=domestic-pax>{{\'Domestic PAX Fees Exempt\' | translate}} * (%)</label><input id=domestic-pax name=domesticPax class=form-control ng-model=editable.domestic_pax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'extendedHours\')\"><label for=extended-hours>{{\'Extended Hours Fees Exempt\' | translate}} * (%)</label><input id=extended-hours name=extendedHours class=form-control ng-model=editable.extended_hours type=number max=100 min=0 step=1 required></div></div><div class=row><div class=col-xs-12><label for=flight_notes>{{\'Flight Notes\' | translate}} *</label><input id=flight_notes name=flightNotes type=text class=form-control ng-model=editable.flight_notes required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/group-management/group-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=security.groups icon=\"\'users\'\" title=\"{{ \'Groups\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=rolesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=name>Group Name</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.name }}</td></tr><tr ng-show=!list.length><td translate class=text-center>There are no Groups data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'users\'\" title=\"{{ \'Create a Group\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'users\'\" title=\"{{ \'Edit a Group\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'group_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=profile-name>Group Name *</label><input id=profile-name class=form-control type=text name=name ng-model=editable.name ng-disabled=\"authProviderEnabled && editable.id && source_group_name === authProviderGroup\" required></div><div class=\"col-xs-12 col-md-6\"><label id=privileges><span translate>Permissions</span> *</label><multiselect name=permissions extra-settings=\"{ displayProp: \'name\' }\" options=\"editable.name && editable.name.toLowerCase() === \'self-care operators\' \n                                        ? selfCareOperatorPermissionsList : permissionsList\" model=editable.permissions is-required=true disabled=\"editable.name && editable.name.toLowerCase() === \'self-care operators\'\"></multiselect></div></div><div ng-if=\"authProviderEnabled && source_group_name !== authProviderGroup\" class=row><div class=\"col-xs-12 col-md-12\"><label translate for=external-group-name>EXTERNAL_AUTH_GROUP_NAME</label><input id=external-group-name class=form-control type=text name=external-group ng-model=editable.external_auth_method_group_name></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=maximum-credit-note>Maximum Credit Note Amount Approval Limit *</label><input id=maximum-credit-note name=maxCreditNoteAmountApprovalLimit class=form-control type=number min=0 step=0.01 ng-model=editable.max_credit_note_amount_approval_limit required></div><div class=\"col-xs-12 col-md-6\"><label translate for=maximum-debit-note>Maximum Debit Note Amount Approval Limit *</label><input id=maximum-debit-note name=maxDebitNoteAmountApprovalLimit class=form-control type=number min=0 step=0.01 ng-model=editable.max_debit_note_amount_approval_limit required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=modifiable-roles>Roles May Modify</label><multiselect id=modifiable-roles name=ownedRoles extra-settings=\"{ displayProp: \'name\' }\" options=rolesMayModify model=editable.owned_roles></multiselect></div><div class=\"col-xs-12 col-md-6\"><label translate for=notification-mechanism>Notification Mechanism</label><input id=notification-mechanism name=notificationMechanism class=form-control ng-model=editable.notification_mechanism></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || !editable.permissions.length\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id); ng-disabled=\"authProviderEnabled && editable.id && source_group_name === authProviderGroup\">Delete</button> <button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || !editable.permissions.length\" ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/help/help.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header icon=\"\'book\'\" title=\"{{ \'User Manual\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><object id=user-manual data=\"{{ ::url }}\" type=application/pdf alt=\"User Manual\"><p><span translate>Your web browser doesn\'t have a PDF plugin. Instead you can click</span> <a translate ng-href=\"{{ ::url }}\">here</a><span translate> to download the PDF file.</span></p></object></div></div></div></div></div></div>");
$templateCache.put("app/partials/interest-rates/interest-rates.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.interest-rates-management icon=\"\'percent\'\" title=\"{{ \'Interest Rates\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode === 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=interestRatesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=startDate>Start Date</th><th translate class=text-nowrap sort=endDate>End Date</th><th translate class=text-nowrap sort=defaultInterestSpecification>Default Interest Specification</th><th translate class=text-nowrap sort=defaultInterestApplication>Default Interest Application</th><th translate class=\"text-nowrap text-right\" sort=defaultForeignInterestSpecifiedPercentage>Default Foreign Interest Percentage</th><th translate class=\"text-nowrap text-right\" sort=defaultNationalInterestSpecifiedPercentage>Default National Interest Percentage</th><th translate class=\"text-nowrap text-right\" sort=defaultInterestGracePeriod>Default Interest Grace Period</th><th translate class=\"text-nowrap text-right\" sort=punitiveInterestGracePeriod>Punitive Interest Grace Period</th><th translate class=text-nowrap sort=punitiveInterestSpecification>Punitive Interest Specification</th><th translate class=text-nowrap sort=punitiveInterestApplication>Punitive Interest Application</th><th translate class=\"text-nowrap text-right\" sort=punitiveInterestSpecifiedPercentage>Punitive Interest Percentage</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td translate class=text-nowrap>{{ item.start_date | dateConverter }}</td><td translate class=text-nowrap>{{ item.end_date | dateConverter }}</td><td translate class=text-nowrap>{{ item.default_interest_specification }}</td><td translate class=text-nowrap>{{ item.default_interest_application }}</td><td translate class=\"text-nowrap text-right\">{{ item.default_foreign_interest_specified_percentage }}</td><td translate class=\"text-nowrap text-right\">{{ item.default_national_interest_specified_percentage }}</td><td translate class=\"text-nowrap text-right\">{{ item.default_interest_grace_period }}</td><td translate class=\"text-nowrap text-right\">{{ item.punitive_interest_grace_period }}</td><td translate class=text-nowrap>{{ item.punitive_interest_specification }}</td><td translate class=text-nowrap>{{ item.punitive_interest_application }}</td><td translate class=\"text-nowrap text-right\">{{ item.punitive_interest_specified_percentage }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Interest Rates data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements max-size=::20 items-per-page=pagination.size ng-change=refresh() ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'percent\'\" title=\"{{ \'Create an Interest Rate\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'percent\'\" title=\"{{ \'Edit an Interest Rate\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'interest_rate_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=default-interest-specification>{{ \'Default Interest Specification\' | translate }} *</label><select id=default-interest-specification name=defaultInterestSpecification class=form-control ng-model=editable.default_interest_specification required><option translate value=YEARLY>Yearly</option><option translate value=MONTHLY>Monthly</option><option translate value=DAILY>Daily</option></select></div><div class=\"col-xs-12 col-md-6\"><label for=default-interest-application>{{ \'Default Interest Application\' | translate }} *</label><select id=default-interest-application name=defaultInterestApplication class=form-control ng-model=editable.default_interest_application required><option translate value=MONTHLY>Monthly</option><option translate value=DAILY>Daily</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=default-foreign-interest-specified-percentage>{{ \'Default Foreign Interest Percentage\' | translate }} *</label><input id=default-foreign-interest-specified-percentage name=defaultForeignInterestSpecifiedPercentage class=form-control type=number ng-model=editable.default_foreign_interest_specified_percentage min=0 step=0.01 required></div><div class=\"col-xs-12 col-md-6\"><label for=default-national-interest-specified-percentage>{{ \'Default National Interest Percentage\' | translate }} *</label><input id=default-national-interest-specified-percentage name=defaultNationalInterestSpecifiedPercentage class=form-control type=number ng-model=editable.default_national_interest_specified_percentage min=0 step=0.01 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=default-interest-grace-period>{{ \'Default Interest Grace Period\' | translate }} *</label><input id=default-interest-grace-period name=defaultInterestGracePeriod class=form-control pattern=\\d+ type=number ng-model=editable.default_interest_grace_period min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=punitive-interest-grace-period>{{ \'Punitive Interest Grace Period\' | translate }} *</label><input id=punitive-interest-grace-period name=punitiveInterestGracePeriod class=form-control pattern=\\d+ type=number ng-model=editable.punitive_interest_grace_period min=\"{{editable.default_interest_grace_period + 1}}\" step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=punitive-interest-specification>{{ \'Punitive Interest Specification\' | translate }} *</label><select id=punitive-interest-specification name=punitiveInterestSpecification class=form-control ng-model=editable.punitive_interest_specification required><option translate value=YEARLY>Yearly</option><option translate value=MONTHLY>Monthly</option><option translate value=DAILY>Daily</option></select></div><div class=\"col-xs-12 col-md-6\"><label for=punitive-interest-application>{{ \'Punitive Interest Application\' | translate }} *</label><select id=punitive-interest-application name=punitiveInterestApplication class=form-control ng-model=editable.punitive_interest_application required><option translate value=MONTHLY>Monthly</option><option translate value=DAILY>Daily</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=punitive-interest-specified-percentage>{{ \'Punitive Interest Percentage\' | translate }} *</label><input id=punitive-interest-specified-percentage name=punitiveInterestSpecifiedPercentage class=form-control type=number ng-model=editable.punitive_interest_specified_percentage min=0 step=0.01 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=start-date>{{ \'Start Date\' | translate }} * ({{ customDate | translate }})</label><p class=input-group><date-picker id=start-date name=startDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=editable.start_date is-open=startDate.open ng-blur=\"editable.end_date = null\" ng-attr-title=\"{{ editable.start_date ? \'\' : \'Please fill out this field\' | translate }}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDate.open = !startDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=end-date>{{ \'End Date\' | translate }} * ({{ customDate | translate }})</label><p class=input-group><date-picker id=end-date name=endDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=editable.end_date is-open=endDate.open ng-attr-title=\"{{ editable.end_date ? \'\' : \'Please fill out this field\' | translate }}\" close-text=Close ng-disabled=true></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDate.open = !endDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/invoice-generation/invoice-generation.aviation.html","<div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=createFlightMovement(account)>Create Flight</button><div class=row ng-if=tempFlightMovementList.length><div class=col-xs-12><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>Action</th><th translate>Flight ID</th><th translate>Registration Number</th><th translate>Date Of Flight</th><th translate>Departure Time</th><th translate>Departure Airport</th><th translate>Arrival Airport</th><th translate>Aircraft Type</th><th translate>Flight Type</th><th translate>Status</th><th ng-if=isAATISEnabled class=text-nowrap><span translate>AATIS Permit Number</span></th></tr></thead><tbody><tr ng-repeat=\"item in tempFlightMovementList track by $index\"><td><button translate class=\"btn btn-primary\" ng-click=\"editFlightMovement(account, item, $index)\">Edit</button> <button translate class=\"btn btn-primary\" popup popup-text=\"Are you sure you want to remove this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=removeFlightMovement($index)>Delete</button></td><td>{{ item.flight_id }}</td><td>{{ item.item18_reg_num }}</td><td>{{ item.date_of_flight | dateConverter }}</td><td>{{ item.dep_time }}</td><td>{{ item.dep_ad }}</td><td>{{ item.dest_ad }}</td><td>{{ item.aircraft_type }}</td><td>{{ item.flight_type }}</td><td>{{ item.status | translate }}</td><td ng-if=isAATISEnabled><external-database-input supported=item.adhoc_charge_required item=item pos-aviation=true external-database=AATIS callback=addAdhocFeeToList error=error required=item.adhoc_charge_required></td></tr></tbody></table></div></div><div class=row><div class=\"col-xs-12 text-center\"><div class=notification><span>{{ notification_text | translate }}</span></div></div></div><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=\"getNonInvoicedFlightMovementsByAccount(account.id, \'aviation\', userBillingCenterOnly, editable.flightCategory, flightMovementList.number, getSortQueryString())\"><thead><tr><th translate>Flight Selection</th><th translate sort=flightId>Flight ID</th><th translate sort=item18RegNum>Registration Number</th><th translate sort=dateOfFlight>Date Of Flight</th><th translate sort=depTime>Departure Time</th><th translate sort=depAd>Departure Airport</th><th translate sort=destAd>Arrival Airport</th><th translate sort=aircraftType>Aircraft Type</th><th translate sort=flightType>Flight Type</th><th translate sort=status>Status</th><th ng-if=isAATISEnabled class=text-nowrap><span translate>AATIS Permit Number</span></th></tr></thead><tbody><tr ng-repeat=\"flight in flightMovementList.content\"><td><input id=\"{{ flight.id }}\" type=checkbox value=\"{{ flight.id }}\" ng-checked=\"selectedFlights.indexOf(flight.id) > -1\" ng-click=flightToggleSelection(flight.id)></td><td>{{ flight.flight_id }}</td><td>{{ flight.item18_reg_num }}</td><td>{{ flight.date_of_flight | dateConverter }}</td><td>{{ flight.dep_time }}</td><td>{{ flight.dep_ad }}</td><td>{{ flight.dest_ad }}</td><td>{{ flight.aircraft_type }}</td><td>{{ flight.flight_type }}</td><td>{{ flight.status | translate }}</td><td ng-if=isAATISEnabled><external-database-input supported=flight.adhoc_charge_required item=flight pos-aviation=true external-database=AATIS callback=addAdhocFeeToList error=error required=\"selectedFlights.indexOf(flight.id) > -1\"></td></tr><tr ng-show=!flightMovementList.content.length><td class=text-center colspan=\"{{ isAATISEnabled ? 11 : 10 }}\" translate>There are no existing flight movements for this account that can be billed</td></tr></tbody></table></div><ul uib-pagination total-items=flightMovementList.total_elements ng-change=\"getNonInvoicedFlightMovementsByAccount(account.id, \'aviation\', userBillingCenterOnly, editable.flightCategory, flightMovementList.number, getSortQueryString())\" max-size=::20 items-per-page=flightMovementList.size ng-model=flightMovementList.number class=pagination-sm boundary-link-numbers=::true></ul></div></div><div class=row><div class=col-xs-12><!--CALCULATE INVOICE--> <button translate ng-disabled=\"!selectedFlights.length && !tempFlightMovementList.length\" popup popup-enabled=\"{{ flightsRequiringAdhocFee.length ? true : false }}\" popup-text=\"Some flights are missing an adhoc fee. Proceed with invoice generation anyway?\" popup-confirm=\"removeError(); previewAviationInvoiceJSON(account.id, selectedFlights, tempFlightMovementList, editable.flightCategory, accountCurrencyCode);\" class=\"btn btn-primary\" type=button>Calculate Invoice</button><!--PREVIEW INVOICE--> <button translate class=\"btn btn-primary btn-preview\" ng-disabled=\"(!selectedFlights.length && !tempFlightMovementList.length)\" popup popup-enabled=\"{{ flightsRequiringAdhocFee.length ? true : false }}\" popup-text=\"Some flights are missing an adhoc fee. Proceed with invoice generation anyway?\" popup-confirm=clickPreview()>Preview Invoice</button><preview-oauth2 url=reports/aviation-invoice ng-click=removeError() request-method=POST params=\"{ flightIdList: selectedFlights.toString(), format: \'pdf\', preview: 1, accountId: account.id, text: \'Preview Invoice\', flightCategory: editable.flightCategory, invoiceCurrency: accountCurrencyCode }\" disable=\"(!selectedFlights.length && !tempFlightMovementList.length)\" error=error class-used=\"btn btn-primary btn-preview hidden\" callback-success-fn=\"previewAviationInvoiceJSON(account.id, selectedFlights, tempFlightMovementList, editable.flightCategory, accountCurrencyCode)\" body-params=\"{ flight_items: tempFlightMovementList, invoice_permits: selectedAdhocFees }\" param-id=preview-button></preview-oauth2></div></div><div class=row ng-if=aviationInvoices.preview.flight_info_list><div class=col-xs-12><table class=\"table table-bordered table-condensed\"><thead><tr><th translate rowspan=2 class=text-center>Date</th><th translate rowspan=2>Flight Details</th><th translate rowspan=2>Route</th><th ng-if=\"shouldShowCharge(\'TASP\')\" translate rowspan=2>{{ taspLabel }} Details</th><th translate rowspan=2>Dep</th><th translate rowspan=2>Arr</th><th translate rowspan=2>PAX</th><th translate colspan=\"{{ approachLabel !== \'ADAP\' ? 6 : 5 }}\" class=text-center>Charges</th></tr><tr><th translate>Enroute</th><th ng-if=\"shouldShowCharge(\'TASP\')\" translate>{{ taspLabel }}</th><th translate>{{ approachLabel }}</th><th translate ng-if=\"approachLabel !== \'ADAP\'\">Aerodrome</th><th translate ng-if=\"shouldShowCharge(\'parking\')\">Parking</th><th translate ng-if=\"shouldShowCharge(\'passenger\')\">Passenger</th><th translate ng-if=\"shouldShowCharge(\'extendedHours\')\">Extended Hours</th></tr></thead><tbody><tr ng-repeat=\"item in aviationInvoices.preview.flight_info_list\"><td class=text-right><span translate>In:</span> {{ item.billing_entry_date_str }}<br><span translate>Out:</span> {{ item.billing_exit_date_str }}</td><td><span translate>Reg:</span> {{ item.reg_num }}<br><span translate>Type:</span> {{ item.aircraft_type }}<br><span translate>MTOW:</span> {{ item.mtow | number: 0 }}&nbsp;({{ item.mtow_unit_of_measure | translate }})</td><td><span translate>Entry:</span> {{ item.entry_point }}<br><span translate>Exit:</span> {{ item.exit_point }}<br><span translate>Dist:</span> {{ item.cross_dist | number: 2 }}</td><td ng-if=\"shouldShowCharge(\'TASP\')\"><!-- TASP Details --> {{ item.aatis_number }}</td><td>{{ item.departure_time_str }}</td><td>{{ item.arrival_time_str }}</td><td>Arr: {{ item.arrival_passenger_count }}<br><span translate>Dep:</span> {{ item.departure_passenger_count }}<br><span translate>Transit:</span> {{ item.transit_passenger_count }}<br><span translate>Infant:</span> {{ item.infant_passenger_count }}</td><td class=text-right>{{ item.enroute_charges_str }}</td><td class=text-right ng-if=\"shouldShowCharge(\'TASP\')\">{{ item.tasp_charges_str }}</td><td class=text-right>{{ approachLabel === \'ADAP\' ? item.landing_charges_str : item.approach_charges_str }}</td><td class=text-right ng-if=\"approachLabel !== \'ADAP\'\">{{ item.aerodrome_charges_str }}</td><td class=text-right ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_charges_str }}</td><td class=text-right ng-if=\"shouldShowCharge(\'passenger\')\">{{ item.passenger_charges_str }}</td><td class=text-right ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours_surcharge_str }}</td></tr><tr class=text-right><td colspan=\"{{ !shouldShowCharge(\'TASP\') ? 6 : 7 }}\"><span translate>Totals:</span></td><td>{{ aviationInvoices.preview.global.enroute_charges_str }}</td><td ng-if=\"shouldShowCharge(\'TASP\')\">{{ aviationInvoices.preview.global.tasp_charges_str }}</td><td>{{ approachLabel === \'ADAP\' ? aviationInvoices.preview.global.landing_charges_str : aviationInvoices.preview.global.approach_charges_str }}</td><td ng-if=\"approachLabel !== \'ADAP\'\">{{ aviationInvoices.preview.global.aerodrome_charges_str }}</td><td ng-if=\"shouldShowCharge(\'parking\')\">{{ aviationInvoices.preview.global.parking_charges_str }}</td><td ng-if=\"shouldShowCharge(\'passenger\')\">{{ aviationInvoices.preview.global.passenger_charges_str }}</td><td ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ aviationInvoices.preview.global.extended_hours_surcharge_str }}</td></tr></tbody></table><div class=text-right ng-if=\"aviationInvoices.preview.global.late_departure_arrival_charges_str !== null && (shouldShowCharge(\'arrival\') || shouldShowCharge(\'departure\'))\"><span translate>Late departure/arrival charges:</span> {{ aviationInvoices.preview.global.late_departure_arrival_charges_str }}</div><div class=text-right><strong><span translate>Invoice Total:</span></strong> {{ aviationInvoices.preview.global.total_amount_str }} {{ aviationInvoices.preview.global.invoice_currency_code}}</div></div></div><div ng-show=\"workflow !== \'credit\'\"><payment is-valid=aviationPaymentValid reset=paymentReset payment=payment invoice-currency=invoiceCurrency invoice-amount=aviationInvoices.preview.global.total_amount account-id=account.id><!-- Payment Directive --></payment></div><div class=row><div class=col-xs-12><!--GENERATE INVOICE--> <button translate class=\"btn btn-primary btn-generate\" ng-disabled=\"isGenerateDisabled(false, selectedFlights.length > 0 || tempFlightMovementList.length > 0);\" popup popup-enabled=\"{{ flightsRequiringAdhocFee.length ? true : false }}\" popup-text=\"Some flights are missing an adhoc fee. Proceed with invoice generation anyway?\" popup-confirm=\"removeError(); aviationInvoices.generating = true; aviationInvoices.preview = null; removePreview(); \n                        generateAviationInvoice(account.id, selectedFlights, \'pdf\', 0, tempFlightMovementList, editable.flightCategory, accountCurrencyCode)\">Generate Invoice</button><!--GENERATE INVOICE AND PAY--> <button translate class=\"btn btn-primary btn-generate\" ng-disabled=\"isGenerateDisabled(true, selectedFlights.length > 0 || tempFlightMovementList.length > 0, aviationPaymentValid)\" popup popup-enabled=\"{{ flightsRequiringAdhocFee.length ? true : false }}\" popup-text=\"Some flights are missing an adhoc fee. Proceed with invoice generation anyway?\" popup-confirm=clickGenerateAndPay();>Generate and Pay Invoice</button><download-oauth2 id=generate-pay-button url=/reports/aviation-invoice params=\"{text: \'Generate and Pay Invoice\', \n                            accountId: account.id, \n                            flightIdList: selectedFlights, \n                            format: \'pdf\', \n                            pay: 1, preview: 0, \n                            flightCategory: editable.flightCategory, \n                            invoiceCurrency: accountCurrencyCode}\" disable=\"isGenerateDisabled(true, selectedFlights.length > 0 || tempFlightMovementList.length > 0, aviationPaymentValid)\" ng-click=\"removeError(); aviationInvoices.generatePay = true; removePreview();\" class-used=\"btn btn-primary btn-generate hidden\" request-method=POST error=error callback-success-fn=\"generateAviationInvoicePaySuccess(); aviationInvoices.preview = null\" callback-error-fn=generateError() hide-icon=true body-params=\"{flight_items: tempFlightMovementList, payment: payment, invoice_permits: selectedAdhocFees}\"></download-oauth2></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div><div id=flight-modal-holder><!-- Flight Plan Modal --></div>");
$templateCache.put("app/partials/invoice-generation/invoice-generation.flight-modal.html","<h4 translate>Flight Movement</h4><form name=flightForm><flight-movement-form disabled=\"{ account: true }\" flight-movement=editable manual=manual show-passenger-counts=showPassengerCounts show-deletion-reason=false show-radar-route=false show-flight-notes=false><!-- Flight Movement Component --></flight-movement-form></form><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><button ng-if=\"index === null\" ng-disabled=\"flightForm.$invalid || flightMovementButtonDisabled\" class=\"btn btn-primary\" ng-click=addFlightMovement(editable);><span translate>Add Flight Movement</span></button> <button ng-if=\"index !== null\" ng-disabled=\"flightForm.$invalid || flightMovementButtonDisabled\" class=\"btn btn-primary\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateFlightMovement(editable, index);\"><span translate>Update Flight Movement</span></button> <button class=\"btn btn-primary\" ng-click=$close()><span translate>Close/Cancel</span></button>");
$templateCache.put("app/partials/invoice-generation/invoice-generation.general.html","<div class=row id=line-item-selections><span ng-if=!serviceChargeList.length translate>There are no service charges</span><ng-form ng-if=serviceChargeList.length name=chargeItemForm><div class=\"col-xs-12 col-md-3\"><label translate for=category-list>Category</label><select class=\"form-control line-item-selection\" name=categoryList id=category-list ng-model=chargeItemForm.category ng-options=\"item as item for item in chargeProps.categories\" ng-change=getTypes(chargeItemForm.category) required></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=type-list>Type</label><select class=\"form-control line-item-selection\" name=typeList id=type-list ng-model=chargeItemForm.type ng-options=\"item as item for item in chargeProps.types\" ng-change=getDescriptions(chargeItemForm.type) required></select></div><div class=\"col-xs-11 col-md-3\"><label translate for=type-list>Description</label><select class=\"form-control line-item-selection\" name=descriptionList id=description-list ng-model=chargeItemForm.description ng-options=\"item as item for item in chargeProps.descriptions\" ng-change=addChargeItem(chargeItemForm.description) required></select></div><div class=\"col-xs-12 col-md-1\"><button translate ng-click=clearChargeItemForm(chargeItemForm) class=\"btn btn-primary clear-button\">Clear</button></div></ng-form></div><div class=row><div class=col-xs-12><line-items-table line-items=lineItems params=\"{ accountId: account.id, month: null, year: null, currencyCode: accountCurrencyCode }\" is-valid=lineItemsValid is-non-avi=false></line-items-table><div class=row><div class=col-xs-12><button translate ng-click=\"removeError(); previewNonAviationInvoiceJSON(account.id, lineItems, accountCurrencyCode)\" ng-disabled=\"!lineItems.length || !lineItemsValid\" class=\"btn btn-primary\">Calculate Invoice</button><preview-oauth2 url=reports/non-aviation-invoice/pos ng-click=removeError() params=\"{ text: \'Preview Invoice\', \n                            format: \'pdf\', \n                            preview: 1, \n                            accountId: account.id, \n                            invoiceCurrency: accountCurrencyCode, \n                            proforma: typeOfSaleSelection === \'general-proforma\' }\" request-method=POST disable=\"!lineItems.length || !lineItemsValid\" class=btn-preview-iata error=error body-params=\"{ line_items: lineItems }\" body-params-fn=nonAviationInvoicePayload callback-success-fn=\"previewNonAviationInvoiceJSON(account.id, lineItems, accountCurrencyCode)\"></preview-oauth2><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div><div ng-show=\"nonAviationInvoices.preview && nonAviationInvoices.totalCurrency\" class=row><div class=\"col-xs-12 col-md-4\"><table class=\"table table-striped table-bordered table-hover table-condensed\"><tr><th translate>Total</th><th translate>Currency</th></tr><tr><td class=text-right>{{ nonAviationInvoices.preview | number: 2 }}</td><td>{{ nonAviationInvoices.totalCurrency }}</td></tr></table></div></div><div ng-show=\"workflow !== \'credit\'\"><payment is-valid=generalPaymentValid reset=paymentReset payment=payment account-id=account.id invoice-currency=invoiceCurrency items=lineItems invoice-amount=nonAviationInvoices.preview><!-- Payment Directive --></payment></div><div class=row><div class=col-xs-12><!--GENERATE INVOICE--> <button translate class=\"btn btn-primary btn-generate\" ng-disabled=\"isGenerateDisabled(false, lineItems.length > 0 && lineItemsValid)\" ng-click=\"removeError(); nonAviationInvoices.generating = true; nonAviationInvoices.preview = null; removePreview(); \n                        generateNonAviationInvoice(account.id, 0, \'pdf\', lineItems, accountCurrencyCode)\">Generate Invoice</button><!--GENERATE INVOICE AND PAY--><download-oauth2 url=/reports/non-aviation-invoice/pos params=\"{ text: \'Generate and Pay Invoice\', \n                            accountId: account.id, \n                            preview: 0, \n                            format: \'pdf\', \n                            pay: 1, \n                            invoiceCurrency: accountCurrencyCode, \n                            proforma: typeOfSaleSelection === \'general-proforma\' }\" disable=\"isGenerateDisabled(true, lineItems.length > 0 && lineItemsValid, generalPaymentValid)\" ng-click=\"removeError(); nonAviationInvoices.generatePay = true; removePreview();\" class-used=\"btn btn-primary btn-generate\" request-method=POST error=error callback-success-fn=\"generateNonAviationInvoicePaySuccess(); nonAviationInvoices.preview = null;\" callback-error-fn=generateNonAviError() hide-icon=true body-params=\"{ line_items: lineItems, payment: payment }\" body-params-fn=nonAviationInvoicePayload></download-oauth2></div></div></div></div>");
$templateCache.put("app/partials/invoice-generation/invoice-generation.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=billing.point-of-sale-invoice-generation icon=\"\'book\'\" title=\"{{ \'Point Of Sale Invoice Generation\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-3\"><label translate for=accounts-type>Accounts Type</label><select id=accounts-type class=form-control ng-change=getAccounts() ng-model=accounts_type><option translate value=cash>Cash Accounts</option><option translate value=credit>Credit Accounts</option><option translate value=all>All Accounts</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=account>Account *</label><select ng-model=account id=account name=account class=form-control ng-options=\"account as account.name for account in accountsList track by account.id\" ng-change=\"setEmptyObjects();\n                                               getNonInvoicedFlightMovementsByAccount(account.id, typeOfSaleSelection, userBillingCenterOnly, editable.flightCategory);\"></select></div><div class=\"col-xs-12 col-md-3\"><label translate>Type Of Sale *</label><select class=form-control ng-model=typeOfSaleSelection ng-change=\"results = []; aviationInvoices.generating = false; tempFlightMovementList = [];\n                                               aviationInvoices.generatePay = false; invoiceCreatedAndPaid = false; aviationInvoices.preview;\n                                               lineItems = []; selectedFlights = []; invoiceCreated = null; removePreview();\n                                               getNonInvoicedFlightMovementsByAccount(account.id, typeOfSaleSelection, userBillingCenterOnly, editable.flightCategory);\"><option translate value=aviation>Aviation</option><option translate value=general>General</option><option ng-show=showProforma translate value=general-proforma>General (Proforma)</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=invoice-currency>Invoice Currency *</label><select ng-model=invoiceCurrency id=invoice-currency name=invoiceCurrency class=form-control ng-change=recalculateInvoiceAmount() ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in currenciesList\"></select></div><div class=\"col-xs-12 col-md-3\" ng-show=\"typeOfSaleSelection === \'aviation\'\"><label translate>Select Flights *</label><select class=form-control ng-model=userBillingCenterOnly ng-init=\"userBillingCenterOnly = \'true\'\" ng-change=\"setEmptyObjects();\n                                            getNonInvoicedFlightMovementsByAccount(account.id, typeOfSaleSelection, userBillingCenterOnly, editable.flightCategory);\"><option translate value=true>Show flights for my billing centre</option><option translate value=false>Show all flights</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-if=\"invoiceByFmCategory && typeOfSaleSelection === \'aviation\'\"><label><span translate>Flight Movement Category</span> *</label><select class=\"form-control text-capitalize\" id=flightCategory name=flightCategory ng-model=editable.flightCategory ng-change=\"setEmptyObjects();\n                                        getNonInvoicedFlightMovementsByAccount(account.id, typeOfSaleSelection, userBillingCenterOnly, editable.flightCategory)\" ng-options=\"fc.id as (fc.name | translate).toLowerCase() for fc in flightCategories\"></select></div></div><div class=row><div class=col-xs-12><button ng-disabled=\"!hasPermission(\'account_modify\')\" translate class=\"btn btn-primary\" ng-click=createAccount()>Add a new Account</button> <button ng-disabled=\"!hasPermission(\'aircraft_registration_modify\')\" translate class=\"btn btn-primary\" ng-click=createAircraftRegistration()>Add a new Aircraft Registration</button></div></div><!-- general/non-aviation invoices --><ng-include ng-show=\"account !== undefined && account !== null && (typeOfSaleSelection === \'general\' || typeOfSaleSelection === \'general-proforma\')\" src=\"\'app/partials/invoice-generation/invoice-generation.general.html\'\"></ng-include><!-- aviation invoices --><ng-include ng-show=\"account !== undefined && account !== null && typeOfSaleSelection === \'aviation\'\" src=\"\'app/partials/invoice-generation/invoice-generation.aviation.html\'\"></ng-include><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row ng-show=results.length><div class=col-xs-12><div class=table-responsive><table id=aviation-invoice ng-if=\"typeOfSaleSelection === \'aviation\'\" class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-right>Enroute Charges</th><th translate class=text-right>Landing Charges</th><th translate class=text-right>Parking Charges</th><th translate class=text-right>Passenger Services Charges</th><th translate class=text-right>Total Invoice</th><th translate class=text-center>Options</th></tr></thead><tbody><tr ng-repeat=\"result in results\"><td class=text-right>{{ result.sum_enroute_charges | number: 2}}</td><td class=text-right>{{ result.sum_arrival_charges | number: 2 }}</td><td class=text-right>{{ result.sum_parking_charges | number: 2 }}</td><td class=text-right>--</td><td class=text-right>{{ result.sum_total_charges | number: 2 }} {{ account.invoice_currency.currency_code }}</td><td class=text-center><button class=\"btn btn-primary\">Preview Invoice</button><!-- For aviation invoices --><download-oauth2 url=\"reports/aviation-invoice?accountId={{ account.id }}&flight={{ selectedFlights.toString() }}&format=pdf\" class-used=\"btn btn-primary btn-generate\" params=\"{text: \'Download Invoice\'}\"></download-oauth2><!-- todo this does not work --> <button ng-click=downloadReceipt() class=\"btn btn-primary\">Download Receipt</button></td></tr></tbody></table><!-- todo fix up --><table id=general-invoice ng-if=\"typeOfSaleSelection === \'general\' || typeOfSaleSelection === \'general-proforma\'\" class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-right>Total Invoice</th><th translate class=text-center>Options</th></tr></thead><tbody><tr ng-repeat=\"result in results\"><td class=text-right>{{ result.sum_general_charges | number: 2}} {{ account.invoice_currency.currency_code }}</td><td class=text-center><button ng-click=downloadFile() class=\"btn btn-default\">Download Invoice</button><download-oauth2 url=\"reports/aviation-invoice?accountId={{ account.id }}&flight={{ selectedFlights.toString() }}&format=pdf\"></download-oauth2><button ng-click=downloadReceipt() class=\"btn btn-default\">Download Receipt</button><hr><button ng-click=\"downloadFile(\'print\')\" type=button class=\"btn btn-primary\">Print Invoice</button> <button ng-click=\"downloadReceipt(\'print\')\" class=\"btn btn-primary\">Print Receipt</button></td></tr></tbody></table></div></div></div><div ng-show=invoiceCreated class=row><div class=col-xs-5><div class=row><div class=\"col-xs-12 col-md-6\"><p class=feedback><span translate>Successfully created invoice</span><span ng-show=invoiceCreatedAndPaid> and paid</span> <span class=\"btn btn-xs pull-right\" ng-click=\"invoiceCreated = false\">X</span></p></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/invoice-template-management/invoice-template-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=templates.invoice-templates toggle=toggle icon=\"\'book\'\" title=\"{{ \'Invoice Templates\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=invoiceTemplateManagementService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th class=\"col-xs-1 text-nowrap\" translate sort=templateDocument>Template Document</th><th class=\"col-xs-1 text-nowrap\" translate sort=templateExample>Template Example XML</th><th translate sort=invoiceTemplateName>Invoice Name</th><th translate sort=invoiceCategory>Invoice Category</th></tr></thead><tbody><tr ng-click=\"edit(item); editable.document_filename = null\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.invoice_category === item.invoice_category}\"><td class=text-center><download-oauth2 url=invoice-templates/{{item.invoice_category}}/download error=error></download-oauth2></td><td class=text-center><download-oauth2 url=invoice-templates/{{item.invoice_category}}/downloadTemplateExampleXml error=error></download-oauth2></td><td>{{ item.invoice_template_name | translate }}</td><td>{{ item.invoice_category | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=3 translate>There are no Invoice Templates</td></tr></tbody></table></div><pagination-display></pagination-display></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'book\'\" title=\"{{ \'Upload an Invoice Template\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'invoice_template_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=invoice_template_name>Invoice Name *</label><input type=text class=form-control id=invoice_template_name ng-model=editable.invoice_template_name required></div><div class=\"col-xs-12 col-md-6\"><label translate for=invoice_category>Invoice Category</label><input type=text class=form-control id=invoice_category ng-model=editable.invoice_category readonly=readonly></div></div><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary btn-upload\" ng-disabled=\"!editable.invoice_template_name || !editable.invoice_category || !editable.document_filename\n                                    || editable.document_filename.substr(editable.document_filename.length - 10) !== \'.rptdesign\'\" ng-click=\"upload(\'POST\', [editable.invoice_category], editable); form.$setUntouched(); reset();\">Upload</button> <button translate type=button class=\"btn btn-primary pull-right\" ng-disabled=!editable.invoice_category ng-click=\"resetTemplate(editable.invoice_category); form.$setUntouched();\">Reset Template</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/invoices/invoices.html","<div class=row><div class=col-xs-12><!-- invoices container --><div class=box-container><box-header page-name=billing.invoice-management icon=\"\'book\'\" title=\"{{ \'Invoices\' | translate }}\"></box-header><div class=box-content><!-- invoices approval errors --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><!-- invoices export messages --><div class=row ng-show=exportSuccess><div class=col-xs-12><div class=\"alert alert-dismissible alert-icon alert-success\" role=alert><button type=button ng-click=\"exportSuccess = false\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-ok-sign icon\" aria-hidden=true></span> <strong translate>Response:</strong> <span translate>Successfully completed batch export!</span></div></div></div><!-- invoices data grid filters and actions --><div class=row><div class=\"col-xs-12 col-md-6 col-lg-2\"><label translate for=account-filter>Account</label><dynamic-service-dropdown ng-model=accountFilter id=account-filter dropdown-type=single allow-empty=true service=::accountsService is-required=false method=findAllMinimalReturn options=\"item.id as item.name for item in list\" ng-change=refreshList()></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6 col-lg-2\"><label translate for=status-filter>Invoice Status</label><select id=status-filter class=form-control ng-model=statusFilter ng-change=refreshList()><option translate value=\"\"></option><option ng-show=\"manualApproval && (hasPermission(\'invoices_approve\') || hasPermission(\'invoices_publish\'))\" translate value=unapproved>Unapproved Invoices</option><option ng-show=\"manualPublishing && (hasPermission(\'invoices_approve\') || hasPermission(\'invoices_publish\'))\" translate value=unpublished>Unpublished Invoices</option><option translate value=unpaid>Unpaid Invoices</option><option translate value=overdue>Overdue Invoices</option><option translate value=paid>Paid Invoices</option><option translate value=void>Void Invoices</option></select></div><div class=\"col-xs-12 col-md-6 col-lg-3\"><label translate for=flight-id>Flight Id/Registration Number</label><input id=flight-id class=form-control type=text empty-to-null ng-model=flightIdOrRegistration uppercase-input ng-keyup=\"$event.keyCode == 13 && refreshList()\"></div><!-- invoice data grid actions --><div class=\"col-xs-12 col-lg-5\"><form action=# name=formAction onsubmit=\"return false\" novalidate><div class=row><div class=col-xs-12><fieldset class=pull-right><legend class=sr-only translate>Invoice action</legend><!-- <div class=\"dropdown export-dropdown\" ng-class=\"{\'open\': toggleExportDropdown}\" ng-init=\"toggleExportDropdown = false\" ng-if=\"exportSupport\">\n                                            <button class=\"btn btn-primary dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\"\n                                                ng-click=\"toggleExportDropdown = !toggleExportDropdown\" ng-disabled=\"exportInProcess\">\n                                                <span translate>Export</span>\n                                                <span class=\"caret\"></span>\n                                            </button>\n                                            <ul class=\"dropdown-menu\" role=\"button\">\n                                                <li>\n                                                    <a ng-click=\"exportAllInvoices(); toggleExportDropdown = false;\">\n                                                        All non-exported\n                                                    </a>\n                                                </li>\n                                                <li ng-class=\"{ \'disabled\': !isSelectedItems(selectedItems) }\">\n                                                    <a ng-click=\"!isSelectedItems(selectedItems) || exportSelectedInvoices(selectedItems); toggleExportDropdown = false;\">\n                                                        Selected only\n                                                    </a>\n                                                </li>\n                                            </ul>\n                                        </div> --> <button translate class=\"btn btn-primary\" ng-if=manualApproval ng-disabled=\"editable.invoice_state_type !== \'NEW\' || !hasPermission(\'invoices_approve\')\" popup popup-text=\"Are you sure you want to approve this invoice?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateState(editable.id, \'approved\')\">Approve</button> <button translate class=\"btn btn-primary\" ng-if=manualPublishing ng-disabled=\"editable.invoice_state_type !== \'APPROVED\' || !hasPermission(\'invoices_publish\')\" popup popup-text=\"Are you sure you want to publish this invoice?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateState(editable.id, \'published\')\">Publish</button> <button translate class=\"btn btn-primary\" ng-disabled=\"!enableVoid(editable) || !hasPermission(\'invoices_void\')\" popup popup-text=\"Are you sure you want to void this invoice?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=openVoidReasonPopup(editable)>Void</button> <button translate class=\"btn btn-primary\" ng-disabled=\"editable.invoice_state_type !== \'PUBLISHED\' || !hasPermission(\'transaction_modify\')\" popup popup-text=\"Are you sure you want to pay this invoice?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=payInvoice(editable)>Pay</button> <button translate ng-click=refreshList(); class=\"btn btn-primary\">Refresh</button></fieldset></div></div></form></div></div><!-- invoices data grid filters --><div class=row><!-- invoice data grid filters --><div class=\"col-xs-12 col-md-6 col-lg-2\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text empty-to-null ng-model=invoiceTextFilter ng-keyup=\"$event.keyCode == 13 && refreshList()\"></div><div class=\"col-xs-12 col-md-6 col-lg-2\"><label translate for=user-filter>User</label><select id=user-filter class=form-control empty-to-null ng-model=userFilter ng-change=refreshList() ng-options=\"item.id as item.name for item in usersList\"><option translate value=\"\"></option></select></div><div class=\"col-xs-12 col-md-6 col-lg-3\"><label translate for=billing-centre>Billing Centre</label><dynamic-service-dropdown ng-model=billingCentreFilter id=billing-centre dropdown-type=single allow-empty=true service=::billingCentreManagementService is-required=false method=findAllMinimalReturn options=\"item.id as item.name for item in list\" ng-change=refreshList()></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6 col-lg-5\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\"><!--Datepickers --></date-range></div></div><!-- invoices data grid export filters --><!-- <div class=\"row\" ng-show=\"exportSupport\">\n                    <div class=\"col-xs-12 form-group-inline\">\n                        <div class=\"checkbox\">\n                            <label>\n                                <input id=\"exported-filter\" type=\"checkbox\"\n                                    ng-model=\"exportedFilter\"\n                                    ng-change=\"refreshList()\" /> <span translate>Show only non-exported invoices</span>\n                            </label>\n                        </div>\n                    </div>\n                </div> --><!-- invoices data grid --><div class=row><div class=col-xs-12><div id=invoices class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=invoicesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshList() grid-pages=10><thead><tr><th translate class=text-center ng-if=exportSupport>Select</th><th translate class=text-center>Actions</th><th translate sort=account.name>Account</th><th translate sort=invoiceNumber>Invoice Number</th><th translate sort=invoicePeriodOrDate>Invoice Date</th><th translate class=text-nowrap sort=invoiceType>Invoice Type</th><th translate sort=invoiceStateType>Status</th><th translate sort=paymentDueDate>Payment Due Date</th><th translate class=text-nowrap sort=user.name>Created By</th><th translate sort=invoiceAmount class=text-right>Invoice Amount</th><th translate sort=amountOwing>Amount Owing</th><th translate sort=invoiceCurrency.currencyCode>Invoice Currency</th><th translate class=text-right sort=invoiceExchangeToUsd>Exchange USD</th><th translate sort=invoiceDateOfIssue>Invoice Date of Issue</th><th translate sort=billingCentre.name>Billing Centre</th><th translate sort=proforma ng-if=showProforma>Proforma</th><th translate sort=pointOfSale>Point Of Sale</th><th translate sort=exported ng-if=exportSupport>Exported</th></tr></thead><tbody><tr ng-click=\"edit(item, \'INVOICE\')\" ng-class=\"{\'highlight\': editable.id === item.id}\" ng-init=setExportSupportType(item.invoice_type) ng-repeat=\"item in list\"><td class=text-center ng-if=exportSupport><input type=checkbox title=\"{{ \'select for export\' | translate }}\" ng-model=selectedItems[item.id] ng-disabled=!isExportSupport(item)></td><td class=text-center><download-oauth2 url=/billing-ledgers/{{item.id}}/download? error=error title=\"{{ \'download\' | translate }}\"></download-oauth2></td><td ng-click=\"openAccount(item.account.id, (hasPermission(\'account_view\') || hasPermission(\'account_modify\')))\" ng-class=\"{\'underline\': hasPermission(\'account_view\') || hasPermission(\'account_modify\')}\">{{ item.account.name }}</td><td class=text-nowrap>{{ item.invoice_number }}</td><td class=text-nowrap>{{ item.invoice_period_or_date | dateConverter}}</td><td class=text-nowrap>{{ item.invoice_type.replace(\'-\', \'_\').toUpperCase() | translate }}</td><td class=text-nowrap>{{ item.invoice_state_type | translate }}</td><td class=text-nowrap>{{ item.payment_due_date | dateConverter }}</td><td class=text-nowrap>{{ item.user }}</td><td class=text-right>{{ item.invoice_amount | number: 2 }}</td><td class=text-right>{{ item.amount_owing | number: 2}}</td><td>{{ item.invoice_currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item.invoice_exchange : item.invoice_exchange) | evenRound: 5 | number: 5}}</td><td class=text-nowrap>{{ item.invoice_date_of_issue | dateConverter }}</td><td class=text-nowrap>{{ item.billing_center.name }}</td><td ng-if=showProforma>{{ item.proforma | translate }}</td><td class=text-nowrap>{{ item.point_of_sale | translate }}</td><td ng-if=exportSupport>{{ item.exported | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=17 translate>There are no Invoices data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshList() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><!-- invoice line items container --><div ng-show=\"editable.id && lineItems && editable.invoice_type === \'non-aviation\'\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=\"{{ \'Invoice Line Items\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><!-- invoice line items data grid message --><div ng-if=!lineItems.length><span translate>There are no Line Items related to this invoice</span></div><!-- invoice line items data grid --><div ng-if=lineItems.length><div id=line-items class=table-responsive export-table box-header=1 back-end-export=true service=invoicesService endpoint-param=/getLineItemsByInvoiceId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=amount>Amount</th><th translate class=text-nowrap sort=serviceChargeCatalogue.category>Category</th><th translate class=text-nowrap sort=serviceChargeCatalogue.chargeClass>Charge Class</th><th translate class=text-nowrap sort=serviceChargeCatalogue.description>Description</th></tr></thead><tbody><tr ng-repeat=\"item in lineItems | limitTo : pagination.size : (lineItems.number * pagination.size) - pagination.size\"><td class=\"text-nowrap text-right\">{{ item.amount | number: 2 }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.category }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.charge_class }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.description }}</td></tr></tbody></table></div><ul uib-pagination total-items=lineItems.length max-size=::20 items-per-page=pagination.size ng-model=lineItems.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><!-- invoice transaction payments container --><div ng-show=\"editable.id && listTransactionPayments\" class=\"box-container margin-top-20\"><box-header icon=\"\'exchange\'\" title=\"{{ \'Transaction Payments\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><!-- invoice transaction payments data grid message --><div ng-if=!listTransactionPayments.length><span translate>There are no Transaction Payments related to this invoice</span></div><!-- invoice transaction payments data grid --><div ng-if=listTransactionPayments.length><div id=transaction-payments class=table-responsive export-table box-header=2 back-end-export=true service=transactionsService endpoint-param=/getTransactionPaymentsByBillingLedgerId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=billingLedger.invoiceNumber>Invoice Number</th><th translate class=text-nowrap sort=amount>Amount</th><th translate class=text-nowrap sort=currency.currencyCode>Currency</th><th translate class=text-nowrap sort=exchangeRate>Exchange USD</th><th translate class=text-nowrap sort=exchangeRateToAnsp>Exchange ANSP</th><th translate class=text-nowrap sort=isAccountCredit>Account Credit</th></tr></thead><tbody><tr ng-repeat=\"item in listTransactionPayments | limitTo : pagination.size : (listTransactionPayments.number * pagination.size) - pagination.size\"><td class=text-nowrap>{{ item.billing_ledger.invoice_number }}</td><td class=\"text-nowrap text-right\">{{ item.amount | abs| number: 2 }}</td><td class=\"text-nowrap text-right\">{{ item.currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5}}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-nowrap translate>{{ item.is_account_credit }}</td></tr></tbody></table></div><ul uib-pagination total-items=listTransactionPayments.length max-size=::20 items-per-page=pagination.size ng-model=listTransactionPayments.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><!-- invoice transactions container --><div ng-show=\"editable.id && listTransactions\" class=\"box-container margin-top-20\"><box-header icon=\"\'exchange\'\" title=\"{{ \'Transactions\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><!-- invoice transactions data grid message --><div ng-if=!listTransactions.length><span translate>There are no Transactions related to this invoice</span></div><!-- invoice transactions data grid --><div ng-if=listTransactions.length><div id=transaction class=table-responsive export-table box-header=3 service=transactionsService endpoint-param=/getTransactionByBillingLedgerId/{{editable.id}} back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Receipt</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=transactionDateTime>Date/Time</th><th translate class=text-nowrap sort=description>Description</th><th translate class=text-nowrap sort=transactionType.name>Type</th><th translate class=\"text-nowrap text-right\" sort=amount>Amount</th><th translate class=text-nowrap sort=currency.currencyCode>Currency</th><th translate class=\"text-nowrap text-right\" sort=exchangeRate>Exchange USD</th><th translate class=\"text-nowrap text-right\" sort=exchangeRateToAnsp>Exchange ANSP</th><th translate class=\"text-nowrap text-right\" sort=balance>Balance</th><th translate class=\"text-nowrap text-right\" sort=paymentReferenceNumber>Payment Reference Number</th><th translate class=\"text-nowrap text-right\" sort=paymentMechanism>Payment Mechanism</th><th translate class=text-nowrap sort=exported>Exported</th></tr></thead><tbody><tr ng-repeat=\"item in listTransactions | limitTo : pagination.size : (listTransactions.numberTransactions * pagination.size) - pagination.size\"><td class=text-center><download-oauth2 url=\"/reports/transaction-receipt?transactionId={{item.id}}\" error=error></download-oauth2></td><td class=text-nowrap>{{item.account.name}}</td><td class=text-nowrap>{{ item.transaction_date_time | dateConverter: \'HH:mm\' }}</td><td class=word-break-break-all>{{ item.description }}</td><td translate>{{ item.transaction_type.name }}</td><td class=text-right>{{ item.amount }}</td><td>{{ item.currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ item.balance | number : 2 }}</td><td>{{ item.payment_reference_number }}</td><td translate>{{ item.payment_mechanism }}</td><td translate>{{ item.exported }}</td></tr></tbody></table></div><ul uib-pagination total-items=listTransactions.length max-size=::20 items-per-page=pagination.size ng-model=listTransactions.numberTransactions class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><!-- invoice flight movements container --><div ng-show=\"editable.id && listFlightMovements && editable.invoice_type !== \'non-aviation\'\" class=\"box-container margin-top-20\"><box-header icon=\"\'plane\'\" title=\"{{ \'Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><!-- invoice flight movements data grid message --><div class=col-xs-12><div ng-if=!listFlightMovements.content.length><span translate>There are no Flight Movements related to this invoice</span></div></div><!-- invoice flight movements data grid --><div ng-if=listFlightMovements.content.length><flight-movement-table export-table-box-header=4 export-table-endpoint=\"\'/invoices/{{ editable.id }}\'\"><!-- Flight Movement Table --></flight-movement-table></div><!-- invoice flight movements data grid pagination --><div ng-show=listFlightMovements.content.length class=col-xs-12><ul uib-pagination total-items=listFlightMovements.total_elements ng-change=\"getFlightMovementsByInvoiceId(editable.id, listFlightMovements.number, listFlightMovements.size)\" max-size=::20 items-per-page=listFlightMovements.size ng-model=listFlightMovements.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/local-aircraft-registry/local-aircraft-registry.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.local-aircraft-registry icon=\"\'fighter-jet\'\" title=\"{{ \'Local Aircraft Registry\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-5\"><label translate for=registration-status-filter>Registration Status</label><select id=registration-status-filter ng-init=\"registrationFilter = \'all\'\" class=form-control ng-change=refreshOverride() ng-model=registrationFilter><option translate value=all>All registrations</option><option translate value=active>Active registrations</option><option translate value=expired>Expired registrations</option></select></div><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-3\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters service=localAircraftRegistryService back-end-export=true sort-query-string=getSortQueryString()><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=registrationNumber>Registration Number</th><th translate class=text-nowrap sort=ownerName>Owner Name</th><th translate class=text-nowrap sort=analysisType>Analysis Type</th><th class=text-nowrap sort=mtowWeight><span>{{ \'MTOW\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th translate class=text-nowrap sort=coaDateOfRenewal>CoA Date of Renewal</th><th translate class=text-nowrap sort=coaDateOfExpiry>CoA Date of Expiry</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); addDate(item); edit(item); saveOldValue(); editable.index = $index\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.index === $index}\"><td class=text-nowrap>{{ item.registration_number }}</td><td class=text-nowrap>{{ item.owner_name }}</td><td class=text-nowrap>{{ item.analysis_type }}</td><td class=text-nowrap>{{ item.mtow_weight | weightConverter }}</td><td class=text-nowrap>{{ item.coa_date_of_renewal | dateConverter }}</td><td class=text-nowrap>{{ item.coa_date_of_expiry | dateConverter }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=6>There are no Local Aircraft Registry data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div ng-show=!toggle class=\"row col-xs-12\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'fighter-jet\'\" title=\"{{ \'Create a Local Aircraft Registry\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'local_acreg_modify\')\"><div class=row><!-- Registration Number --><div class=\"col-xs-12 col-md-6\"><label translate for=registration-number>Registration Number *</label><input id=registration-number name=registrationNumber class=form-control type=string ng-model=editable.registration_number minlength=2 maxlength=7 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input required></div><!-- Owner Name --><div class=\"col-xs-12 col-md-6\"><label translate for=owner-name>Owner Name *</label><input id=owner-name name=ownerName class=form-control type=string ng-model=editable.owner_name required></div></div><div class=row><!-- Analysis Type --><div class=\"col-xs-12 col-md-6\"><label translate for=analysis-type>Analysis Type *</label><input id=analysis-type name=analysisType class=form-control type=string ng-model=editable.analysis_type required></div><!-- Weight --><div class=\"col-xs-12 col-md-6\"><label for=weight><span>{{ \'MTOW\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span> *</label><unit-conversion-input id=weight name=weight ng-model=editable.mtow_weight measurement-type=weight required></div></div><div class=row><date-range control=control is-required=::true start-name=\"Renewal Date *\" end-name=\"Expiry Date *\" format={{customDate}}><!-- Datepickers --></date-range></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"control.reset(); reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-to-tons property=mtow_weight conversion-complete=\"create(convertedEditable || editable, control.getUTCStartDate(), control.getUTCEndDate()); form.$setUntouched();\">Create</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=form.$invalid ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" convert-to-tons property=mtow_weight popup-confirm=\"update(convertedEditable || editable, control.getUTCStartDate(), control.getUTCEndDate()); control.reset(); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); control.reset(); form.$setUntouched();\">Delete</button></div></div></fieldset></form></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'local_acreg_modify\')\"><box-header icon=\"\'book\'\" title=\"{{ \'Upload Local Aircraft Registration(s)\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=!editable.document_filename ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\'); form.$setUntouched(); control.reset(); reset();\">Upload</button><upload-file-format format={{pattern}} template=app/partials/local-aircraft-registry/local-aircraft-registry.template.html></upload-file-format></div></div></div></fieldset></form></div></div></div></div></div>");
$templateCache.put("app/partials/local-aircraft-registry/local-aircraft-registry.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12><span class=text-center><h5>{{ \'Local Aircraft Registry File\' | translate }}</h5></span><ul><li>{{ \'Format\' | translate }}: {{ format }}</li><li>{{ \'Top\' | translate }} 17 {{ \'rows are ignored\' | translate }}</li><li>{{ \'No column header\' | translate }}</li></ul><span>{{ \'Columns\' | translate }}:</span><ul><li>#4 - {{ \'Registration Number\' | translate }}</li><li>#12 - {{ \'Owner Name\' | translate }}</li><li>#15 - {{ \'Analysis Type\' | translate }} ({{ \'full aircraft type name\' | translate }})</li><li>#19 - {{ \'MTOW\' | translate }} (kg)</li><li>#26 - {{ \'CoA Date of Renewal\' | translate }} ({{ \'dd-MM-yyyy\' | translate }})</li><li>#27 - {{ \'CoA Date of Expiry\' | translate }} ({{ \'dd-MM-yyyy\' | translate }})</li></ul><span><strong>{{ \'NOTE\' | translate }}:</strong> {{ \'If you are creating a file in Excel, the first row must contain non-blank data otherwise Excel will remove any completely empty rows or columns\' | translate }}</span></div></div><div class=\"row margin-top-20\"><div class=text-center><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/map/map.html","<div class=map><div id=cesiumContainer class=\"map cesiumContainer\"><!-- Cesium is initialized in here --></div></div><div class=\"cesium-navigation-help cesium-navigation-help-visible\" ng-show=showDetails><div id=cesium-layers-container class=\"cesium-navigation-help cesium-navigation-help-visible\"><button ng-click=\"showSettingsTab = false\" type=button ng-class=\"!showSettingsTab ? \'cesium-navigation-button-selected\' : \'cesium-navigation-button-unselected\'\" class=\"cesium-navigation-button cesium-navigation-button-left cesium-navigation-button-selected\"><i class=\"fa fa-list-ul\" aria-hidden=true></i> <span>Layers</span></button> <button ng-click=\"showSettingsTab = true\" type=button ng-class=\"showSettingsTab ? \'cesium-navigation-button-selected\' : \'cesium-navigation-button-unselected\'\" class=\"cesium-navigation-button cesium-navigation-button-right cesium-navigation-button-unselected pull-right\"><i class=\"fa fa-cog\" aria-hidden=true></i> <span>Settings</span></button><div ng-show=!showSettingsTab class=\"cesium-click-navigation-help cesium-navigation-help-instructions cesium-click-navigation-help-visible cesium-layers\"><table class=layer-control-table id=wfsLayerTable><tbody><tr ng-repeat=\"layer in layers\" ng-show=\"layer.layerName === aerodromesLayerName || flightMovementLoaded\"><td class=text-white>{{ layer.displayName }}</td><td class=legend><div ng-style=\"{\'background-color\': layer.cssValue }\"></div></td><td class=input-box><input type=checkbox ng-model=layer.show ng-checked=layer.show></td><td class=input-range><input ng-attr-title=\"{{ layer.alpha }}\" type=range ng-model=layer.alpha min=0 max=1 step=0.01 ng-change=changeLayerAlpha(layer)></td></tr></tbody></table><table class=layer-control-table id=wmsLayerTable><tbody><tr ng-repeat=\"layer in imgLayers\"><td class=text-white>{{ layer.displayName }}</td><td class=input-box><input type=checkbox ng-model=layer.show ng-checked=layer.show></td><td class=input-range><input ng-attr-title=\"{{ layer.alpha }}\" type=range ng-model=layer.alpha min=0 max=1 step=0.01 ng-change=changeImageryLayerAlpha(layer)></td></tr></tbody></table></div><div ng-show=showSettingsTab class=\"cesium-click-navigation-help cesium-navigation-help-instructions cesium-click-navigation-help-visible cesium-information\"><!-- <table>\n                <tbody>\n                <tr >\n                    \n                </tr>\n                </tbody>\n            </table> --></div></div></div>");
$templateCache.put("app/partials/mtow/mtow.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=charges-and-formulas.average-mtow-factor-managment icon=\"\'balance-scale\'\" title=\"{{ \'Average MTOW Factor\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-5\" ng-if=useMTOWFactorClass><label translate for=factor-class-filter>MTOW factor class</label><select id=factor-class-filter class=form-control ng-change=refreshOverride() ng-model=factorClassFilter.value ng-options=\"item.value as (item.name | translate) for item in factorClass\"></select></div><div class=\"col-xs-12 col-md-2 pull-right\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=mtowService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th sort=upperLimit class=text-right><span>{{ \'Upper Limit\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th translate sort=averageMtowFactor class=text-right>Average MTOW Factor</th><th ng-if=useMTOWFactorClass sort=factorClass><span translate>Factor Class</span></th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-right>{{ item.upper_limit | weightConverter }}</td><td class=text-right>{{ item.average_mtow_factor | number: 3 }}</td><td ng-if=useMTOWFactorClass>{{ item.factor_class | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=3 translate>There are no Average MTOW Factor data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'balance-scale\'\" title=\"{{ \'Create an MTOW Factor\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'balance-scale\'\" title=\"{{ \'Edit an MTOW Factor\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'avg_mtow_factor_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=upper-limit><span>{{ \'Upper Limit\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }}) *</span></label><unit-conversion-input id=upper-limit name=upperLimit ng-model=editable.upper_limit measurement-type=weight required></div><div class=\"col-xs-12 col-md-6\"><label translate for=average-mtow-factor>Average MTOW Factor *</label><input id=average-mtow-factor name=averageMtowFactor class=form-control min=0 step=0.001 ng-pattern=/^(?!0\\d|$)\\d*(\\.\\d{1,3})?$/ type=number ng-model=editable.average_mtow_factor required></div></div><div class=row ng-if=useMTOWFactorClass><div class=\"col-xs-12 col-md-6\"><label translate for=factor-class>Factor Class *</label><select id=factor-class name=factor-class class=form-control ng-model=editable.factor_class ng-options=\"item.value as (item.name | translate) for item in factorClass\" required></select></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid convert-to-tons property=upper_limit popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-to-tons property=upper_limit conversion-complete=\"create(convertedEditable || editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/nominal-routes/nominal-routes.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.nominal-route-management icon=\"\'road\'\" title=\"{{ \'Nominal Routes\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters sort-query-string=getSortQueryString() back-end-export=true service=nominalRoutesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=type>Type</th><th translate class=text-nowrap sort=pointa>Point A</th><th translate class=text-nowrap sort=pointb>Point B</th><th translate class=text-nowrap sort=biDirectional>Bidirectional Route</th><th translate class=text-nowrap sort=status>Status</th><th translate class=\"text-nowrap text-right\" sort=nominalDistance>Nominal Distance</th><th translate class=\"text-nowrap text-right\" sort=nominalRouteFloor>Nominal Route Floor</th><th translate class=\"text-nowrap text-right\" sort=nominalRouteCeiling>Nominal Route Ceiling</th></tr></thead><tbody><tr ng-click=\"edit(item); saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td translate>{{ item.type }}</td><td>{{ item.pointa }}</td><td>{{ item.pointb }}</td><td class=text-nowrap>{{ item.bi_directional | translate }}</td><td>{{ (item.status.toUpperCase() | translate).toLowerCase() }}</td><td class=text-right>{{ item.nominal_distance | number: 2 }}</td><td class=text-right>{{ item.nominal_route_floor | number: 2 }}</td><td class=text-right>{{ item.nominal_route_ceiling | number: 2 }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=8 translate>There are no Nominal Routes data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'road\'\" title=\"{{ \'Create a Nominal Route\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'road\'\" title=\"{{ \'Edit a Nominal Route\' | translate }}\"></box-header><div class=box-content><form action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'nominal_route_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=type>Type *</label><select id=type name=type class=form-control ng-model=editable.type ng-options=\"item.name as (item.name | translate) for item in routeTypes\" required></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=nominal_distance>Nominal Distance *</label><input id=nominal_distance name=nominalDistance class=form-control type=number step=0.01 min=0 ng-model=editable.nominal_distance required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=pointa>Point A *</label><input id=pointa name=pointa class=form-control type=text ng-model=editable.pointa required></div><div class=\"col-xs-12 col-md-6\"><label translate for=pointb>Point B *</label><input id=pointb name=pointb class=form-control type=text ng-model=editable.pointb required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=bi-directional>{{\'Bidirectional Route\' | translate}} *</label><boolean-text id=bi-directional name=biDirectional class=form-control ng-model=editable.bi_directional required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=nominal-route-floor>{{\'Nominal Route Floor\' | translate}} *</label><input id=nominal-route-floor name=nominalRouteFloor class=form-control type=number step=0.01 min=0 max=999 ng-model=editable.nominal_route_floor required></div><div class=\"col-xs-12 col-md-6\"><label translate for=nominal-route-ceiling>{{\'Nominal Route Ceiling\' | translate}} *</label><input id=nominal-route-ceiling name=nominalRouteCeiling class=form-control type=number step=0.01 min=0 max=999 ng-model=editable.nominal_route_ceiling required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/non-aviation-billing-engine/non-aviation-billing-engine.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=billing.non-aviation-billing-engine icon=\"\'plane\'\" title=\"{{ \'Non-Aviation Billing\' | translate }}\"></box-header><div class=box-content><fieldset><div class=row><div class=\"col-xs-12 col-sm-6 col-md-3\"><label for=billing-period><span translate>Billing Period</span>&nbsp;*&nbsp;(<span translate>{{ customDate }}</span>)</label><p class=input-group><input id=billing-period name=billing-period type=text class=form-control ng-change=\"getLineItems(editable); form.$setUntouched();\" uib-datepicker-popup=\"{{ customDate }}\" ng-model=dateObject is-open=open datepicker-options=\"{ startingDay: 1, minMode: \'month\' }\" ng-required=true close-text=Close> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"open = !open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-sm-6 col-md-3\"><label translate for=accountId>Account *</label><dynamic-service-dropdown ng-model=editable.accountId id=accountId name=accountId dropdown-type=single service=::accountsService method=findAllCreditMinimalActiveReturn is-required=::true options=\"item.id as item.name for item in list\" ng-change=\"getLineItems(editable); form.$setUntouched();\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-show=\"externalChargeCategories && externalChargeCategories.length > 1\"><label for=external-charge-category><span translate>External Charge Category</span> <span>*</span></label><dynamic-service-dropdown id=external-charge-category name=externalChargeCategory dropdown-type=single service=::externalChargeCategoryService method=getNonAviationCategories is-required=::true options=\"item as (item.name | translate) for item in list track by item.id\" ng-model=editable.externalChargeCategory ng-change=\"getLineItems(editable); form.$setUntouched();\"></dynamic-service-dropdown></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset><div ng-show=invoiceCreated class=row><div class=col-xs-5><div class=row><div class=\"col-xs-12 col-md-6\"><p class=feedback><span translate>Successfully created invoice</span> <span class=\"btn btn-xs pull-right\" ng-click=\"invoiceCreated = false\">X</span></p></div></div></div></div><div class=row><div class=col-xs-12><line-items-table line-items=lineItems ng-show=lineItems params=editable is-valid=lineItemsValid is-non-avi=true></line-items-table></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary btn-generate-non-aviation\" ng-disabled=\"!(hasPermission(\'nonaviation_invoice_generate\') && lineItemsValid)\" ng-click=\"generateNonAviationInvoice(\'pdf\',\n                                                                    0,\n                                                                    editable.accountId,\n                                                                    dateObject.getFullYear(),\n                                                                    dateObject.getMonth() + 1,\n                                                                    lineItems,\n                                                                    editable.kra_clerk_name,\n                                                                    editable.kra_receipt_number);\">Generate Invoice</button><preview-oauth2 url=reports/non-aviation-invoice/monthly params=\"{\n                                                    text: \'Preview Invoice\',\n                                                    format: \'pdf\',\n                                                    preview: 1,\n                                                    accountId: editable.accountId,\n                                                    year: dateObject.getFullYear(),\n                                                    month: dateObject.getMonth() + 1,\n                                                    kraClerkName: editable.kra_clerk_name,\n                                                    kraReceiptNumber: editable.kra_receipt_number\n                                                }\" disable=\"!hasPermission(\'nonaviation_invoice_preview\') || !lineItemsValid\" class=btn-preview-non-aviation request-method=POST body-params=lineItems remove-preview=removePreview error=error></preview-oauth2><div ng-if=\"!isBillingPeriodValid && !invoiceCreated\"><p class=text-danger>*<span translate>Invoice will be generated for a future billing period!</span></p></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/passenger-revenue-reconciliation/passenger-revenue-reconciliation.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=billing.passenger-revenue-reconciliation-kcaa icon=\"\'plane\'\" title=\"{{ \'Passenger Revenue Reconciliation\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=row><date-range is-required=::true control=control start-name=\"Start Date *\" end-name=\"End Date *\" format={{customDate}} start-end-adjust=true date-options=\"{ minMode: \'month\' }\"></date-range></div></div><div class=\"col-xs-12 col-sm-3\"><div class=row><div class=col-xs-12><label translate for=dom_pay>Domestic Payment</label><label>&nbsp;({{domPaxCurrency}}) *</label><input id=dom_pay name=dom_pay class=form-control min=0 type=number ng-model=dom_pay></div></div></div><div class=\"col-xs-12 col-sm-3\"><div class=row><div class=col-xs-12><label translate for=itl_pay>International Payment</label><label>&nbsp;({{intlPaxCurrency}}) *</label><input id=itl_pay name=itl_pay class=form-control min=0 type=number ng-model=itl_pay></div></div></div></div><div class=row><div class=col-xs-12><button ng-disabled=\"!dom_pay || dom_pay < 0 || !itl_pay || itl_pay < 0 || !control.getUTCStartDate() || !control.getUTCEndDate()\" ng-click=\"executePSCR(control.getUTCStartDate(), control.getUTCEndDate())\" class=\"btn btn-primary btn-reconcile\"><span translate>Reconcile</span></button></div></div></fieldset></form><div class=row><div ng-show=reconcilePSCRJob class=\"col-xs-12 top-10\" aria-hidden=false><p class=\"wideFeedback ng-binding\"><u><span translate>Reconciliation</span></u> <span class=\"btn btn-sm pull-right\" ng-click=\"reconcilePSCRJob = null\" role=button tabindex=0>X</span><br><span translate>Unmatched Flight Movements:</span> {{reconcileResponse.count_fm}}<br><span translate>Unmatched Passenger Service Charges:</span> {{reconcileResponse.count_pscr}}<br><span translate>Domestic Passenger Fees Collected:</span> {{reconcileResponse.total_dom_collected}}% <span ng-show=reconcileResponse.total_dom_fees><span translate>of total Domestic Passenger Fees</span> {{reconcileResponse.total_dom_fees}} <span translate>({{domPaxCurrency}})</span></span><br ng-show=reconcileResponse.dom_warning><span class=text-danger ng-show=reconcileResponse.dom_warning translate>Warning: Less than 98% of domestic fees collected</span><br><span translate>International Passenger Fees Collected:</span> {{reconcileResponse.total_itl_collected}}% <span ng-show=reconcileResponse.total_itl_fees><span translate>of total International Passenger Fees</span> {{reconcileResponse.total_itl_fees}} <span translate>({{intlPaxCurrency}})</span></span><br ng-show=reconcileResponse.itl_warning><span class=text-danger ng-show=reconcileResponse.itl_warning translate>Warning: Less than 98% of international fees collected</span></p></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div>");
$templateCache.put("app/partials/passenger-service-charge-return/passenger-service-charge-return.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=flight-data.passenger-service-charge-return-management icon=\"\'retweet\'\" title=\"{{ \'Passenger Service Charge Return\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-5\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-10 col-md-5\"><label translate for=charge-returns>Service Charge Returns</label><select id=charge-returns ng-init=\"chargeReturnFilter = \'false\'\" class=form-control ng-change=refresh() ng-model=chargeReturnFilter><option translate value=false>All</option><option translate value=true>Orphan</option></select></div><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=passengerServiceChargeReturnService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh() canned-sort=cannedSort><thead><tr><th translate class=\"text-nowrap text-center\">Action</th><th translate class=text-nowrap sort=flightId>Flight Id</th><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap sort=dayOfFlight>Day of Flight</th><th translate class=text-nowrap sort=departureTime>Dep Time</th><th translate class=\"text-nowrap text-right\" sort=joiningPassengers>Join Pass</th><th translate class=\"text-nowrap text-right\" sort=transitPassengers>Trans Pass</th><th translate class=\"text-nowrap text-right\" sort=chargeableItlPassengers>Charge Int Pass</th><th translate class=\"text-nowrap text-right\" sort=chargeableDomesticPassengers>Charge Dom Pass</th><th translate class=\"text-nowrap text-right\" sort=children>Children</th><th translate class=\"text-nowrap text-right\" sort=createdBySelfCare>Created By Self-Care</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-center><download-oauth2 ng-show=item.has_image url=\"passenger-service-charge-return/{{ item.id }}/image\"></download-oauth2></td><td class=text-nowrap>{{ item.flight_id }}</td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.day_of_flight | dateConverter }}</td><td class=text-nowrap>{{ item.departure_time }}</td><td class=text-right>{{ item.joining_passengers }}</td><td class=text-right>{{ item.transit_passengers }}</td><td class=text-right>{{ item.chargeable_itl_passengers }}</td><td class=text-right>{{ item.chargeable_domestic_passengers }}</td><td class=text-right>{{ item.children }}</td><td class=text-right>{{ item.created_by_self_care }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Passenger Service Charge Return data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=row><div class=col-xs-12><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'retweet\'\" title=\"{{ \'Create a Passenger Service Charge Return\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'retweet\'\" title=\"{{ \'Edit a Passenger Service Charge Return\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_log_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=flight-id>{{ \'Flight Identifier\' | translate }} *</label><input id=flight-id name=flightId class=form-control type=text ng-model=editable.flight_id maxlength=10 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account</label><dynamic-service-dropdown allow-empty=true empty-to-null ng-model=editable.account id=account name=account dropdown-type=single service=::scAccountManagementService method=getSCActiveAccounts options=\"account as account.name for account in list track by account.id\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=day-of-flight>{{ \'Day of Flight\' | translate }} ({{ dateFormat | translate }}) *</label><p class=input-group><date-picker id=day-of-flight type=text name=dayOfFlight pad-hours=true show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.day_of_flight is-open=expiry.open close-text=Close ng-attr-title=\"{{editable.day_of_flight ? \'\' : \'Please fill out this field\' | translate}}\" required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"expiry.open = !expiry.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=departure_time>{{ \'Departure Time\' | translate }} ({{ \'HHmm\' | translate}})</label><input id=departure_time class=form-control name=departureTime type=text minlength=4 maxlength=4 ng-model=editable.departure_time ng-attr-title=\"{{editable.departure_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ ></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=joining-passengers>{{ \'Joining Passengers\' | translate }}</label><input id=joining-passengers name=joiningPassengers class=form-control min=0 type=number ng-model=editable.joining_passengers pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=transit-passengers>{{ \'Transit Passengers\' | translate }}</label><input id=transit-passengers name=transitPassengers class=form-control min=0 type=number ng-model=editable.transit_passengers pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=chargeable-international>{{ \'Chargeable International Passengers\' | translate }}</label><input id=chargeable-international name=chargeableItlPassengers class=form-control min=0 type=number ng-model=editable.chargeable_itl_passengers pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=chargeable-domestic>{{ \'Chargeable Domestic Passengers\' | translate }}</label><input id=chargeable-domestic name=chargeableDomesticPassengers class=form-control min=0 type=number ng-model=editable.chargeable_domestic_passengers pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=children>{{ \'Children\' | translate }}</label><input id=children name=children class=form-control type=number min=0 ng-model=editable.children pattern=\\d+></div></div><div ng-show=extendedPassengerInformation><div class=row><div class=\"col-xs-12 col-md-6\"><label for=arriving-pax-domestic-airport>{{ \'Arriving Passengers At Domestic Airport\' | translate }}</label><input id=arriving-pax-domestic-airport name=arrivingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.arriving_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=landing-pax-domestic-airport>{{ \'Landing Passengers At Domestic Airport\' | translate }}</label><input id=landing-pax-domestic-airport name=landingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.landing_pax_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=transfer-pax-domestic-airport>{{ \'Transfer Passengers At Domestic Airport\' | translate }}</label><input id=transfer-pax-domestic-airport name=transferPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.transfer_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=departing-pax-domestic-airport>{{ \'Departing Passengers From Domestic Airport\' | translate }}</label><input id=departing-pax-domestic-airport name=departingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.departing_pax_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=arriving-child-domestic-airport>{{ \'Arriving Children At Domestic Airport\' | translate }}</label><input id=arriving-child-domestic-airport name=arrivingChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.arriving_child_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=landing-child-domestic-airport>{{ \'Landing Children At Domestic Airport\' | translate }}</label><input id=landing-child-domestic-airport name=landingChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.landing_child_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=transfer-child-domestic-airport>{{ \'Transfer Children At Domestic Airport\' | translate }}</label><input id=transfer-child-domestic-airport name=transferChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.transfer_child_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=departing-child-domestic-airport>{{ \'Departing Children From Domestic Airport\' | translate }}</label><input id=departing-child-domestic-airport name=departingChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.departing_child_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exempt-arriving-pax-domestic-airport>{{ \'Exempt Arriving Passengers At Domestic Airport\' | translate }}</label><input id=exempt-arriving-pax-domestic-airport name=exemptArrivingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_arriving_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=exempt-landing-pax-domestic-airport>{{ \'Exempt Landing Passengers At Domestic Airport\' | translate }}</label><input id=exempt-landing-pax-domestic-airport name=exemptLandingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_landing_pax_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exempt-transfer-pax-domestic-airport>{{ \'Exempt Transfer Passengers At Domestic Airport\' | translate }}</label><input id=exempt-transfer-pax-domestic-airport name=exemptTransferPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_transfer_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=exempt-departing-pax-domestic-airport>{{ \'Exempt Departing Passengers From Domestic Airport\' | translate }}</label><input id=exempt-departing-pax-domestic-airport name=exemptDepartingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_departing_pax_domestic_airport pattern=\\d+></div></div></div><div ng-show=extendedCargoInformation><div class=row><div class=\"col-xs-12 col-md-6\"><label for=loaded-goods>{{ \'Loaded Goods\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=loaded-goods name=loadedGoods ng-model=editable.loaded_goods measurement-type=cargo></div><div class=\"col-xs-12 col-md-6\"><label for=discharged-goods>{{ \'Discharged Goods\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=discharged-goods name=dischargedGoods ng-model=editable.discharged_goods measurement-type=cargo></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=loaded-mail>{{ \'Loaded Mail\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=loaded-mail name=loadedMail ng-model=editable.loaded_mail measurement-type=cargo></div><div class=\"col-xs-12 col-md-6\"><label for=discharged-mail>{{ \'Discharged Mail\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=discharged-mail name=dischargedMail ng-model=editable.discharged_mail measurement-type=cargo></div></div></div><div class=row><div class=col-xs-12><p class=input-group><label for=document_filename2>{{ \'Image File\' | translate}} (*.jpg, *.gif, *.png, *.pdf)</label><input id=document_filename2 name=document_filename2 class=form-control type=text readonly=readonly ng-model=editable.document_filename2> <span class=input-group-btn><button type=button class=\"btn btn-default\" ngf-select=\"parse($file, \'document_filename2\');\" ngf-accept=\"\'.jpg,.gif,.png,.pdf\'\" ngf-multiple=false ng-click=\"image_expiry.open = !image_expiry.open\"><i class=\"fa fa-upload\"></i></button></span></p></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid convert-to-tons properties=loaded_goods,discharged_goods,loaded_mail,discharged_mail popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"uploadNew(convertedEditable || editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-to-tons properties=loaded_goods,discharged_goods,loaded_mail,discharged_mail conversion-complete=\"uploadNew(convertedEditable || editable); form.$setUntouched(); reset();\">Create</button></div></div></fieldset></form></div></div><div class=\"row margin-top-20\" ng-show=\"editable.id === null\"><div class=col-xs-12><div class=box-container><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_log_modify\')\"><box-header icon=\"\'retweet\'\" title=\"{{ \'Upload a Passenger Service Charge Return\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=!editable.document_filename ng-click=\"upload(\'PUT\', null, null, \'list\', {search: search, size: pageSize}); form.$setUntouched(); reset();\">Upload</button><upload-file-format format={{pattern}} template=app/partials/passenger-service-charge-return/passenger-service-charge-return.template.html></upload-file-format></div></div></div></fieldset></form></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/passenger-service-charge-return/passenger-service-charge-return.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12><span class=text-center><h5>{{ \'Passenger Service Charge Return File\' | translate }}</h5></span><ul><li>{{ \'Format\' | translate }}: {{ format }}</li><li>{{ \'Top\' | translate }} 6 {{ \'rows are ignored\' | translate }}</li><li>{{ \'No column header\' | translate }}</li></ul><span>{{ \'Columns\' | translate }}:</span><ul><li>#1 - {{ \'Account Name\' | translate }} ({{ \'Can be null\' | translate }})</li><li>#2 - {{ \'Day of Flight\' | translate }} ({{ \'dd/MM/yyyy\' | translate }})</li><li>#3 - {{ \'Flight Identifier\' | translate }}</li><li>#4 - {{ \'empty\' | translate }}</li><li>#5 - {{ \'Transit Passengers\' | translate }}</li><li>#6 - {{ \'Joining Passengers\' | translate }}</li><li>#7 - {{ \'Children\' | translate }}</li><li>#8 - {{ \'Chargeable International Passengers\' | translate }}</li><li>#9 - {{ \'Chargeable Domestic Passengers\' | translate }}</li></ul><span><strong>{{ \'NOTE\' | translate }}:</strong> {{ \'If you are creating a file in Excel, the first row must contain non-blank data otherwise Excel will remove any completely empty rows or columns\' | translate }}</span></div></div><div class=\"row margin-top-20\"><div class=text-center><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/password-change/password-change.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header icon=\"\'user\'\" title=\"{{ \'Password Change\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-7 col-md-offset-2\"><p class=notification><span translate ng-bind-html=notificationText></span></p></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=email>Email Address *</label><input id=email name=email class=form-control type=text ng-model=email readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label translate for=login>User Login *</label><input id=login name=login class=form-control type=text ng-model=login readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=current-password><span translate>Current Password</span>&nbsp;*</label><input id=current-password name=currentPassword class=form-control type=password ng-model=editable.old_password required></div></div><password name-1=\"New Password *\" name-2=\"Confirm New Password *\" error=error reset-pass=resetPass required password=editable.new_password></password><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || editable.new_password === null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updatePassword(editable); form.$setUntouched();\">Update</button></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/password-change/password-change.template.html","<div class=\"confirm-popup padding-20 text-center\"><div class=row><div class=col-xs-12><span translate>You have successfully changed your password.</span><span ng-show=logout> Please login again to continue.</span></div></div><div class=\"row margin-top-20\"><div class=text-center><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/plugins/plugins.html","<div class=row><div class=col-xs-12 ng-class=\"{ \'col-md-6 col-split-xs-12\': toggle }\"><!-- plugins --><div class=box-container><box-header page-name=management.plugin-management icon=\"\'plug\'\" title=\"{{ \'Plugins\' | translate }}\" toggle=toggle></box-header><div class=box-content><!-- plugin development and testing warning --><div ng-if=showHidden><div class=row><div class=col-xs-12><div class=\"alert alert-icon alert-info\" role=alert><span class=\"glyphicon glyphicon-info-sign icon\" aria-hidden=true></span><h4><span translate>Warning:</span> <small translate>Showing development and testing plugins ONLY!</small></h4><p><span translate>The list shown is for development and testing purposes only. If you are looking for the regular list of plugins, please press the button below.</span></p><a class=\"btn btn-warning margin-top-20 btn-sm\" href=#/plugins role=button><span translate>Return to regular list</span></a></div></div></div></div><!-- plugin data grid filters and actions --><div class=row><div class=\"col-xs-12 col-md-8\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-keyup=\"$event.keyCode == 13 && refresh()\" ng-model=search></div><div class=\"col-xs-12 col-md-4 text-right margin-top-20\"><button translate class=\"btn btn-primary\" ng-click=refresh()>Refresh</button></div></div><!-- non-form errors --><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div><!-- plugin data grid --><div class=row><div class=col-xs-12><div class=table-responsive><div class=table-responsive export-table sort-query-string=getSortQueryString() service=pluginsService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=name>Name</th><th translate sort=description>Description</th><th translate sort=enabled>Enabled</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td ng-bind-html=::item.name></td><td ng-bind-html=::item.description></td><td>{{ ::item.enabled }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=3 translate>There are no plugins to configure.</td></tr></tbody></table></div></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container-lg class=\"col-xs-12 col-lg-6\" ng-show=toggle><!-- edit plugin --><div class=box-container><box-header icon=\"\'plug\'\" title=\"{{ \'Edit a Plugin\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'manage_plugin_modify\')\"><!-- plugin form fields --><div class=row><div class=col-xs-12><label translate for=plugin-name>Plugin Name</label><input id=plugin-name class=form-control type=text name=name disabled=disabled ng-model=editable.name></div><div class=\"col-xs-12 margin-top-20\"><label translate for=plugin-description>Plugin Description</label><textarea id=plugin-description class=form-control name=description disabled=disabled ng-model=editable.description>\n                                </textarea></div><system-configuration-item class=\"col-xs-12 margin-top-20\" item=configuration plugin-key=editable.key ng-repeat=\"configuration in editable.configurations | orderBy: [\'item_name\']\" ng-class=\"{\'disabled-section\': (configuration.item_name === \'KCAA ERP receipt processor starting timestamp\' && !isKcaaErpTimestampEnabled())}\"></system-configuration-item><div class=\"col-xs-12 margin-top-20\"><label><span translate>Enable Plugin</span> <input id=plugin-enabled type=checkbox ng-model=editable.enabled ng-disabled=\"editable === null || editable.id === null\"></label></div></div><!-- plugin form actions --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\" update-warning=\"{{ updateWarning }}\">Update</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/radar-summary/radar-summary.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=flight-data.radar-flight-strip-management icon=\"\'rss\'\" title=\"{{ \'Radar Summary\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\'\"><!--Datepickers --></date-range></div><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=radarSummaryService endpoint-param=/filters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=flightIdentifier>Flight Id</th><th translate class=text-nowrap sort=date>Date</th><th translate class=\"text-nowrap text-right\" sort=departureTime>Dep Time</th><th translate class=text-nowrap sort=dayOfFlight>Day of Flight</th><th translate class=text-nowrap sort=registration>Reg Number</th><th translate class=text-nowrap sort=aircraftType>A/C Type</th><th translate class=text-nowrap sort=departureAeroDrome>Dep Ad</th><th translate class=text-nowrap sort=destinationAeroDrome>Dest Ad</th><th translate class=text-nowrap sort=firEntryPoint>Entry Point</th><th translate class=\"text-nowrap text-right\" sort=firEntryTime>Entry Time</th><th translate class=text-nowrap sort=firExitPoint>Exit Point</th><th translate class=\"text-nowrap text-right\" sort=firExitTime>Exit Time</th><th translate class=text-nowrap sort=flightRule>Flight Rule</th><th translate class=text-nowrap sort=flightTravelCategory>Flight Category</th><th translate class=text-nowrap sort=route>Route</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.flight_identifier }}</td><td class=text-nowrap>{{ item.date | dateConverter }}</td><td class=text-right>{{ item.departure_time }}</td><td>{{ item.day_of_flight | dateConverter }}</td><td>{{ item.registration }}</td><td>{{ item.aircraft_type }}</td><td>{{ item.departure_aero_drome }}</td><td>{{ item.destination_aero_drome }}</td><td>{{ item.fir_entry_point }}</td><td class=text-right>{{ item.fir_entry_time }}</td><td>{{ item.fir_exit_point }}</td><td class=text-right>{{ item.fir_exit_time }}</td><td>{{ item.flight_rule }}</td><td>{{ item.flight_travel_category.toUpperCase() | translate }}</td><td class=text-nowrap>{{ item.route }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=15 translate>There are no Radar Summary data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'rss\'\" title=\"{{ \'Create a Radar Summary\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'rss\'\" title=\"{{ \'Edit a Radar Summary\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'radar_summary_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-6\"><label for=flight_identifier>{{\'Flight Identifier\' | translate}} *</label><input id=flight_identifier maxlength=10 minlength=2 name=flightIdentifier class=form-control type=text ng-model=editable.flight_identifier ng-trim=false ng-model-options=\"{allowInvalid: true}\" ng-pattern=/^[a-zA-Z0-9]*$/ uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label for=date>{{\'Date\' | translate}} (<span translate>{{ ::dateFormat }}</span>) *</label><p class=input-group><date-picker id=date name=date type=text ng-change=\"dateChanged(\'radarSummaryDate\', editable.date)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.date is-open=radarSummaryDate.open ng-attr-title=\"{{editable.date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"radarSummaryDate.open = !radarSummaryDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=departure_time>{{\'Departure Time\' | translate}} ({{\'HHmm\' | translate}}) *</label><input id=departure_time name=departureTime class=form-control ng-model=editable.departure_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_exit_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ required></div><div class=\"col-xs-12 col-md-6\"><label for=day_of_flight>{{\'Day of Flight\' | translate}} (<span translate>{{ ::dateFormat }}</span>) *</label><p class=input-group><date-picker id=day_of_flight name=dayOfFlight type=text ng-change=\"dateChanged(\'radarSummaryDayOfFlight\', editable.day_of_flight)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.day_of_flight is-open=radarSummaryDayOfFlight.open ng-attr-title=\"{{editable.day_of_flight ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"radarSummaryDayOfFlight.open = !radarSummaryDayOfFlight.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=registration>{{\'Registration\' | translate}}</label><input id=registration name=registration class=form-control type=text ng-model=editable.registration maxlength=7 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input ng-model-options=\"{allowInvalid: true}\"></div><div class=\"col-xs-12 col-md-6\"><label for=aircraft_type>{{\'Aircraft Type\' | translate}} *</label><dynamic-service-dropdown name=aircraftType ng-model=editable.aircraft_type id=aircraft_type dropdown-type=single service=::aircraftTypeManagementService method=findAllMinimalReturn is-required=::true options=\"item.aircraft_type as item.aircraft_type for item in list\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=departure_aero_drome>{{\'Departure Aerodrome *\' | translate}}</label><input id=departure_aero_drome name=departureAeroDrome type=text class=form-control ng-model=editable.departure_aero_drome uppercase-input maxlength=4 only-letters required></div><div class=\"col-xs-12 col-md-6\"><label for=destination_aero_drome>{{\'Destination Aerodrome *\' | translate}}</label><input id=destination_aero_drome name=destinationAeroDrome type=text class=form-control ng-model=editable.destination_aero_drome uppercase-input maxlength=4 only-letters required></div><div class=\"col-xs-12 col-md-6\"><label for=cruising-speed>{{\'Cruising Speed\' | translate}} (Knnnn/Nnnnn/Mnnn)</label><input id=cruising-speed name=cruisingSpeed type=text class=form-control maxlength=5 minlength=4 uppercase-input ng-pattern=/^([kK][0-9]{4})|([mM][0-9]{3})|([nN][0-9]{4})$/ ng-model=editable.cruising_speed></div><div class=\"col-xs-12 col-md-6\"><label for=flight-level>{{\'Flight Level\' | translate}} (Fnnn)</label><input id=flight-level name=flightLevel class=form-control type=text maxlength=5 uppercase-input ng-pattern=/^(?:[fF|aA]\\d{3}|[sS|mM]\\d{4})$/ ng-model=editable.flight_level></div><div class=\"col-xs-12 col-md-6\"><label for=wake-turbulence>{{\'Wake Turbulence\' | translate}}</label><dynamic-service-dropdown id=wake-turbulence name=wakeTurbulence dropdown-type=single ng-model=editable.wake_turb service=::wakeTurbulenceCategoryService options=\"item.name as item.name for item in list.content\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=flight_rule>{{\'Flight Rule\' | translate}} *</label><dynamic-service-dropdown ng-model=editable.flight_rule id=flight_rule name=flightRule class=text-uppercase dropdown-type=single service=::radarSummaryService is-required=::true method=listFlightRules options=\"item as item for item in list\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=fir-entry-flight-level>{{\'FIR Entry Flight Level\' | translate}} (Fnnn)</label><input id=fir-entry-flight-level name=firEntryFlightLevel class=form-control type=text maxlength=5 uppercase-input ng-pattern=/^(?:[fF|aA]\\d{3}|[sS|mM]\\d{4})$/ ng-model=editable.fir_entry_flight_level></div><div class=\"col-xs-12 col-md-6\"><label for=fir-exit-flight-level>{{\'FIR Exit Flight Level\' | translate}} (Fnnn)</label><input id=fir-exit-flight-level name=firExitFlightLevel class=form-control type=text maxlength=5 uppercase-input ng-pattern=/^(?:[fF|aA]\\d{3}|[sS|mM]\\d{4})$/ ng-model=editable.fir_exit_flight_level></div><div class=\"col-xs-12 col-md-6\"><label for=fir_entry_time>{{\'FIR Entry Time\' | translate}} ({{\'HHmm\' | translate}}) <span ng-if=flightLevelRequired>*</span></label><input id=fir_entry_time name=firEntryTime class=form-control ng-model=editable.fir_entry_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_exit_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers ng-required=flightLevelRequired></div><div class=\"col-xs-12 col-md-6\"><label for=fir_entry_point>{{\'FIR Entry Point\' | translate}}<span ng-if=flightLevelRequired> *</span></label><input id=fir_entry_point name=firEntryPoint class=form-control type=text ng-model=editable.fir_entry_point ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-trim=false uppercase-input ng-required=flightLevelRequired></div><div class=\"col-xs-12 col-md-6\"><label for=fir_exit_time>{{\'FIR Exit Time\' | translate}} ({{\'HHmm\' | translate}}) <span ng-if=flightLevelRequired>*</span></label><input id=fir_exit_time name=firExitTime class=form-control ng-model=editable.fir_exit_time type=text minlength=4 maxlength=4 ng-attr-title=\"{{editable.fir_exit_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers ng-required=flightLevelRequired></div><div class=\"col-xs-12 col-md-6\"><label for=fir_exit_point>{{\'FIR Exit Point\' | translate}}<span ng-if=flightLevelRequired> *</span></label><input id=fir_exit_point name=firExitPoint class=form-control type=text ng-model=editable.fir_exit_point uppercase-input ng-trim=false ng-pattern=/^[a-zA-Z0-9.-]*$/ ng-required=flightLevelRequired></div><div class=\"col-xs-12 col-md-6\"><label for=fir-entry-coordinate>{{\'FIR Entry Coordinate\' | translate}} (DDMMSS[N|S]DDDMMSS[E|W]) <span ng-if=flightLevelRequired>*</span></label><input id=fir-entry-coordinate name=firEntryCoordinate class=form-control type=text maxlength=15 uppercase-input ng-pattern=/^(\\d{6}[N|S]\\d{7}[W|E])/ ng-model=editable.entry_coordinate ng-required=flightLevelRequired></div><div class=\"col-xs-12 col-md-6\"><label for=fir-exit-coordinate>{{\'FIR Exit Coordinate\' | translate}} (DDMMSS[N|S]DDDMMSS[E|W]) <span ng-if=flightLevelRequired>*</span></label><input id=fir-exit-coordinate name=firExitCoordinate class=form-control type=text maxlength=15 uppercase-input ng-pattern=/^(\\d{6}[N|S]\\d{7}[W|E])/ ng-model=editable.exit_coordinate ng-required=flightLevelRequired></div><div class=\"col-xs-12 col-md-6\"><label for=flight_travel_category>{{\'Flight Category\' | translate}}</label><dynamic-service-dropdown ng-model=editable.flight_travel_category id=flight_travel_category name=flightTravelCategory dropdown-type=single service=::radarSummaryService method=listCategories options=\"item as (item.toUpperCase() | translate) for item in list\"></dynamic-service-dropdown></div><div class=col-xs-12><label for=route>{{\'Route\' | translate}} *</label><input id=route name=route class=form-control type=text ng-model=editable.route uppercase-input required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-click=\"create(editable); form.$setUntouched();\" ng-show=\"editable.id === null\">Create</button></div></div></fieldset></form></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'rss\'\" title=\"{{ \'Upload a Radar Summary File\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'radar_summary_modify\')\"><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><label><input id=merge-upload type=checkbox ng-model=merge_upload ng-init=\"merge_upload = format === \'INDRA-REC\'\" ng-disabled=\"format !== \'INDRA-REC\'\"> <span translate>Merge with existing flight strips</span></label></div></div><div class=row><div class=col-xs-12><upload-feedback><!-- Upload Feedback --></upload-feedback></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=\"!editable.document_filename || !acceptedFileType\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\', { \'format\': format, \'merge\': merge_upload }); form.$setUntouched(); reset();\">Upload</button></div></div></fieldset></form></div></div></div></div></div></div>");
$templateCache.put("app/partials/recurring-charges/recurring-charges.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.recurring-charges icon=\"\'google-wallet\'\" title=\"{{ \'Recurring Charges\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-4\"><label translate for=search-by-account>Account</label><dynamic-service-dropdown ng-model=accountFilter allow-empty=true ng-change=refresh() id=search-by-account name=account dropdown-type=single service=::accountsService method=findAllCreditMinimalReturn options=\"item.id as item.name for item in list\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-4\"><label translate for=filter>Operational Status</label><select id=filter ng-init=\"filter = \'all\'\" class=form-control ng-model=statusFilter ng-change=refresh()><option translate value=all>All</option><option translate value=near_end_date>Near end date</option><option translate value=out_of_date>Out of date</option></select></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=recurringChargesService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=serviceChargeCatalogue.id>Service Charge Catalogue</th><th translate sort=account.id>Account</th><th translate sort=startDate>Start Date</th><th translate sort=endDate>Expected End Date</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td translate>{{ item.service_charge_catalogue.description }}</td><td>{{ item.account.name }}</td><td>{{ item.start_date | dateConverter }}</td><td>{{ item.end_date | dateConverter }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=4 translate>There are no Recurring Charges data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'google-wallet\'\" title=\"{{ \'Create a Recurring Charge\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'google-wallet\'\" title=\"{{ \'Edit a Recurring Charge\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'charges_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=service-charge-catalogue>Service Charge Catalogue *</label><select id=service-charge-catalogue class=form-control ng-model=editable.service_charge_catalogue.id name=serviceChargeCatalogue ng-options=\"item.id as (item.description | translate) for item in catalogueServiceChargeListFiltered\" required></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account.id id=account method=findAllCreditMinimalActiveReturn name=account dropdown-type=single service=::accountsService is-required=::true options=\"item.id as item.name for item in list\"></dynamic-service-dropdown></div></div><div class=row><date-range control=control is-required=::true start-name=\"Start Date *\" end-name=\"End Date *\" format={{customDate}}><!-- Datepickers --></date-range></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, control.getUTCStartDate(), control.getUTCEndDate()); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable, control.getUTCStartDate(), control.getUTCEndDate()); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/regional-country-management/regional-country-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=management.regional-country-management icon=\"\'flag\'\" title=\"{{ \'Regional Countries\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=regionalCountryManagementService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate sort=country.countryName>Country Name</th><th translate sort=country.countryCode>Country Code</th></tr></thead><tbody><tr ng-repeat=\"item in regionalCountryList.content\"><td translate>{{ item.country.country_name }}</td><td>{{ item.country.country_code }}</td></tr><tr ng-show=!regionalCountryList.content.length><td class=text-center colspan=2 translate>There are no Regional Countries data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'flag\'\" title=\"{{ \'Add a Country\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'regional_countries_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=countries>Country Name</label><multiselect id=countries name=countryList options=countryList model=editableCountryList.content translated-value=country_name extra-settings=\"{ externalIdProp: \'\', displayProp: \'country_name\' }\"></multiselect></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button class=\"btn btn-primary btn-update\" translate popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editableCountryList.content); form.$setUntouched()\">Update</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/rejected-items/rejected-items.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header ng-click=selectFirstIfNoSelection() toggle=toggle page-name=flight-data.rejected-item-management icon=\"\'rss\'\" title=\"{{ \'Rejected Items\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12 text-right\"><button translate ng-click=refreshOverride() class=\"btn btn-primary\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text empty-to-null ng-model=search ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\' \"><!--Datepickers --></date-range></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=\"\'filter-by-record-type\'\">Record Type</label><select id=\"\'filter-by-record-type\'\" class=form-control empty-to-null ng-model=filter_by_record_type ng-change=refreshOverride()><option translate value=\"\"></option><option translate value=FLIGHT_MOV>Flight Movement</option><option translate value=ATS_MESS>ATS Message</option><option translate value=ATS_MOV>ATC Movement</option><option translate value=TOWER_AIRC>Tower Movement</option><option translate value=PASSENGER_SERV>Passenger Service Charge</option><option translate value=RADAR_SUMM>Radar Summary</option><option translate value=OTHER>Other</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=\"\'filter-by-status\'\">Status</label><select id=\"\'filter-by-status\'\" class=form-control empty-to-null ng-model=filter_by_status ng-change=refreshOverride()><option translate value=\"\"></option><option translate value=corrected>Corrected</option><option translate value=uncorrected>Uncorrected</option><option translate value=empty>Empty</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=\"\'filter-by-originator\'\">Originator</label><input id=\"\'filter-by-originator\'\" class=form-control type=text empty-to-null ng-model=filter_by_originator ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-3\"><label translate for=\"\'filter-by-file-name\'\">File Name</label><input id=\"\'filter-by-file-name\'\" class=form-control type=text empty-to-null ng-model=filter_by_file_name ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div></div><fieldset ng-disabled=\"!hasPermission(\'rejected_data_modify\')\"><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=rejectedItemsService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=recordType>Record Type</th><th translate class=text-nowrap sort=rejectedDateTime>Rejection Date / Time</th><th translate class=text-nowrap sort=rejectedReason>Rejection Reason</th><th translate class=text-nowrap sort=errorMessage>Error Message</th><th translate class=text-nowrap sort=status>Status</th><th translate class=text-nowrap sort=originator>Originator</th><th translate class=text-nowrap sort=fileName>File Name</th></tr></thead><tbody><tr ng-click=edit(item) ng-repeat=\"item in list\" ng-class=\"{\'text-danger\': (item.status === \'uncorrected\' || item.status === \'empty\') , \'highlight\': id === item.id}\"><td translate class=text-nowrap>{{ item.record_type }}</td><td class=text-nowrap>{{ item.rejected_date_time | dateConverter: \'/ HH:mm\' }}</td><td translate class=text-nowrap>{{ item.rejected_reason }}</td><td class=text-nowrap><span ng-if=\"item.error_message.split(\'\\\'\')[0].length\" translate>{{ item.error_message.split(\"\\\"\")[0] }}</span> <span ng-if=\"item.error_message.split(\'\\\'\')[1].length\" translate>{{ item.error_message.split(\"\\\"\")[1] }}</span> <span ng-if=\"item.error_message.split(\'\\\'\')[2].length\" translate>{{ item.error_message.split(\"\\\"\")[2] }}</span></td><td class=text-nowrap>{{ (item.status.toUpperCase() | translate).toLowerCase() }}</td><td class=text-nowrap>{{ item.originator }}</td><td class=text-nowrap>{{ item.file_name }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=7 translate>There are no Rejected Items data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true ng-change=refreshOverride()></ul></div></div></fieldset></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'dollar\'\" title=\"{{ \'Edit Rejected Item\' | translate }}\"></box-header><div class=box-content><div class=\"row row-responsive\"><div ng-show=\"!value.header.includes(\'Unknown\')\" ng-class=\"[\'col-xs-12\', value.isMultiLineField ? \'col-md-12\' : \'col-md-3\']\" ng-repeat=\"value in displayed_data\"><label for=value-{{$index}} class=text-capitalize>{{ value.header | translate }}</label><input id=value-{{$index}} type=text class=form-control ng-if=\"value.type !== \'[object Date]\' && !value.isMultiLineField\" ng-init=\"userInput[$index] = value.data\" ng-model=userInput[$index] ng-change=\"!value.header.includes(\'date\') && !value.header.includes(\'day\') ? userInput[$index] = userInput[$index].toUpperCase() : userInput[$index]\"><textarea id=value-{{$index}} class=form-control rows=3 ng-if=\"value.type !== \'[object Date]\' && value.isMultiLineField\" ng-init=\"userInput[$index] = value.data\" ng-model=userInput[$index] ng-change=\"!value.header.includes(\'date\') && !value.header.includes(\'day\') ? userInput[$index] = userInput[$index].toUpperCase() : userInput[$index]\">\n                        </textarea><p class=input-group ng-if=\"value.type === \'[object Date]\'\"><date-picker id=value-{{$index}} type=text class=form-control ng-init=\"userInput[$index] = value.data\" ng-model=userInput[$index] ng-pattern=datePickerRegex uib-datepicker-popup=\"{{ dateFormat }}\" show-button-bar=false is-open=value.datePickerOpen></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"value.datePickerOpen = !value.datePickerOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row ng-show=\"item.record_type === \'RADAR_SUMM\'\"><div class=col-xs-12><label><input id=merge-upload type=checkbox ng-model=merge_upload ng-disabled=\"result.format !== \'INDRA_REC\'\"> <span translate>Merge with existing flight strips</span></label></div></div><div class=row><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div><div class=row><div class=col-xs-12><button class=\"btn btn-primary btn-update\" translate ng-disabled=\"form.$invalid; !hasPermission(\'rejected_data_modify\')\" ng-show=displayed_data.length popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-disabled=\"!hasPermission(\'rejected_data_modify\')\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(); form.$setUntouched()\">Delete</button></div></div></div></div></div></div>");
$templateCache.put("app/partials/report-generation/report-generation.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=data-analysis-and-statistics.report-generation icon=\"\'file-text\'\" title=\"{{ \'Report Generation\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-3\"><label><span translate>Report</span> *</label><select id=report class=form-control ng-model=editable.report ng-change=setClear(editable) ng-init=\"editable.report=\'accountStatusReport\'\" required><!-- generic base reports --><option translate value=accountStatusReport>Account status report</option><option translate ng-if=!KCAA value=accountStatementReport>Account statement report</option><option translate ng-if=!KCAA value=debtorReport>Debtor report</option><option translate value=revenueLostToExemptionsReport>Revenue lost to exemptions report</option><option translate value=summarisedInvoiceTotalsReport>Summarised invoice totals report</option><option translate value=aircraftTypesReport>Aircraft types report</option><option translate ng-if=!KCAA value=passengerReport>Passenger Report</option><option translate value=creditAndDebitNotesReport>Credit and Debit Notes Report</option><option translate ng-if=KCAA value=creditAndCashReportReconciledReceipts>Reconciled Receipts Report</option><option translate ng-if=KCAA value=creditAndCashReportUnreconciledReceipts>Unreconciled Receipts Report</option><option translate value=aircraftRegistrationReport>Aircraft Registration Report</option><option translate value=missingBillingInformationReport>Missing Billing Information Report</option><option translate value=aircraftRegistrationTrackingReport>Aircraft Registration Tracking Report</option><option translate value=revenueReport>Revenue Report</option><option translate value=unifiedTaxReport>Unified Tax Report</option><!-- kcaa customized reports --><option translate ng-if=KCAA value=kcaaDebtorReport>Debtor report</option><option translate ng-if=KCAA value=kcaaAccountStatementReport>Account statement report</option><option translate ng-if=KCAA value=localAircraftRegistryReport>Local Aircraft Registry Report</option><option translate ng-if=KCAA value=kcaaPassengerReport>Passenger Report</option><!-- ttcaa customized reports --><option translate ng-if=TTCAA value=iataSummarySum>IATA Summary Sum</option><option translate ng-if=TTCAA value=iataSummaryData>IATA Summary Data</option></select></div><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'accountStatementReport\'         ||\n                                    editable.report===\'revenueLostToExemptionsReport\'     ||\n                                    editable.report===\'summarisedInvoiceTotalsReport\'     ||\n                                    editable.report===\'creditAndDebitNotesReport\'         ||\n                                    editable.report===\'missingBillingInformationReport\'   ||\n                                    editable.report===\'aircraftRegistrationTrackingReport\'||\n                                    editable.report===\'creditAndCashReportReconciledReceipts\'||\n                                    editable.report===\'creditAndCashReportUnreconciledReceipts\'||                                   \n\n                                    editable.report===\'kcaaAccountStatementReport\' ||\n                             editable.report===\'unifiedTaxReport\'\"><label translate for=accounts>Accounts *</label><multiselect id=accounts name=accounts extra-settings=\"{ displayProp: \'name\' }\" options=accountsList model=selectedAccounts events=\"{ onSelectionChanged: addAccountToList }\"></multiselect></div><!-- unified Tax Form --><!--   <div class=\"col-xs-12 col-md-2\" ng-if=\"editable.report==\'unifiedTaxReport\'\">\n                            <label translate>Account Type *</label>\n                            <select id=\"customer_type\" class=\"form-control\" ng-model=\"editable.customer_type\" ng-init=\"editable.customer_type = \'tu\'\" required>\n                                <option translate value=\"tu\">TU</option>\n                            </select>\n                        </div>\n\n                        <div class=\"col-xs-12 col-md-3\">\n                            <label translate for=\"aircraft_registration\">Aircraft Registration</label>\n                            <multiselect id=\"aircraft_registration\" name=\"aircraft_registration\"\n                                         extra-settings=\"{ displayProp: \'aircraft_registration_name\', idProp: \'aircraft_registration_name\', externalIdProp: \'\' }\"\n                                         options=\"aircraftRegistrationList\"\n                                         model=\"selectedAircraftRegistration\"\n                                         events=\"{ onSelectionChanged: addAircraftRegistrationToList }\">\n                            </multiselect>\n                        </div>--><!-- end unified Tax Form --><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report ===\'kcaaPassengerReport\' || editable.report ===\'passengerReport\'\"><label translate for=accounts>Accounts</label><multiselect id=accounts name=accounts extra-settings=\"{ displayProp: \'name\' }\" options=accountsListWithCash model=selectedAccounts events=\"{ onSelectionChanged: addAccountToList }\"></multiselect></div><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report ===\'iataSummarySum\' || editable.report ===\'iataSummaryData\'\"><label for=report_month><span translate>Month</span> *</label><p class=input-group><date-picker id=report_month name=reportMonth type=text ng-change=\"dateChanged(\'report_month\', editable.report_month)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ \'MMMM yyyy\' }}\" ng-model=editable.report_month is-open=reportMonth.open datepicker-options=\"{ minMode: \'month\' }\" required close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"reportMonth.open = !reportMonth.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-5\" ng-show=\"requiresDatePicker(editable.report) || editable.report===\'creditAndCashReportReconciledReceipts\' || editable.report===\'creditAndCashReportUnreconciledReceipts\'\"><date-range control=control is-required=requiresDatePicker(editable.report) start-end-adjust=true date-options=\"{ minMode: \'month\' }\" start-name=\"Start Date *\" end-name=\"End Date *\" format={{customDate}}><!--Datepickers --></date-range></div><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'aircraftTypesReport\' || editable.report===\'aircraftRegistrationReport\'\"><input id=all-used-defined type=checkbox ng-init=\"editable.used_defined = true\" ng-model=editable.used_defined><label translate for=all-used-defined>All used and defined</label><br><input id=all-used-undefined type=checkbox ng-init=\"editable.used_undefined = true\" ng-model=editable.used_undefined><label translate for=all-used-undefined>All used but undefined</label></div><div class=\"col-xs-12 col-md-2\" ng-if=\"editable.report===\'kcaaDebtorReport\'\"><label translate for=overdue-interval>Number of Days Overdue *</label><select id=overdue-interval class=form-control ng-model=editable.overdue_interval required><option translate value=\"\"></option><option translate value=1>0-30</option><option translate value=2>30-60</option><option translate value=3>60-90</option><option translate value=4>90-120</option><option translate value=5>120+</option></select></div><div class=\"col-xs-12 col-md-2\" ng-if=\"editable.report===\'debtorReport\' ||\n                                    editable.report===\'kcaaDebtorReport\'\"><label translate for=invoices>Invoices *</label><select id=invoices class=form-control ng-model=editable.invoices required><option translate value=\"\"></option><option translate value=false>Outstanding</option><option translate value=true>Overdue</option></select></div><div class=\"col-xs-12 col-md-2\" ng-if=\"editable.report==\'accountStatusReport\'\"><label translate>Account Type *</label><select id=credit_type class=form-control ng-model=editable.credit_type ng-init=\"editable.credit_type = \'false\'\" required><option translate value=false>All</option><option translate value=true>Credit</option></select></div><div ng-if=\"editable.report==\'revenueReport\'\"><div class=\"col-xs-12 col-md-2\"><label for=report-type>{{ \'Type Of Invoice\' | translate }} *</label><select id=report-type class=form-control ng-model=editable.report_type required ng-init=\"editable.report_type = \'cash\'\"><option translate value=cash>Cash</option><option translate value=credit>Credit</option></select></div></div></div><div class=row><!-- Summarised Invoice Totals Report --><div ng-if=\"editable.report==\'summarisedInvoiceTotalsReport\'\"><div class=\"col-xs-12 col-md-2\"><label translate for=summary-interval>Summary Interval *</label><select id=summary-interval class=form-control ng-model=editable.summary_interval required><option translate value=\"\"></option><option translate value=1>Daily</option><option translate value=2>Weekly</option><option translate value=3>Monthly</option><option translate value=4>Quarterly</option><option translate value=5>Yearly</option></select></div><div class=\"col-xs-12 col-md-2\"><label translate for=report-currency>Report Currency *</label><select id=report-currency name=reportCurrency class=form-control ng-model=editable.report_currency required ng-options=\"item.currency_code as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\')\n                                        for item in currenciesList\"></select></div><div class=\"col-xs-12 col-md-3\"><input id=fiscal-year type=checkbox ng-init=\"editable.fiscal_year = flase\" ng-model=editable.fiscal_year ng-change=getFiscalYear()><label translate for=fiscal-year>Use the fiscal start of the year</label><br><input id=account-new-page type=checkbox ng-init=\"editable.account_new_page = true\" ng-model=editable.account_new_page><label translate for=account-new-page>Begin each statement on new page</label></div></div><!-- KCAA credit and debit notes --><div class=\"col-xs-12 col-md-2\" ng-if=\"editable.report===\'creditAndDebitNotesReport\' \"><input id=credit-notes type=checkbox ng-init=\"editable.credit_notes = 1\" ng-true-value=1 ng-false-value=0 ng-model=editable.credit_notes><label translate for=credit-notes>Credit notes</label><br><input id=debit-notes type=checkbox ng-init=\"editable.debit_notes = 2\" ng-true-value=2 ng-false-value=0 ng-model=editable.debit_notes><label translate for=debit-notes>Debit notes</label></div><!-- group by account / new page --><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report ===\'creditAndDebitNotesReport\' || editable.report === \'aircraftRegistrationReport\'\"><input id=group-by-account type=checkbox ng-init=\"editable.group_by_account = true\" ng-model=editable.group_by_account><label translate for=group-by-account>Group by account</label><br><input id=account-new-page type=checkbox ng-init=\"editable.account_new_page = true\" ng-model=editable.account_new_page><label translate for=account-new-page>Begin each statement on new page</label></div><!-- KCAA group by owner / new page per account --><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'localAircraftRegistryReport\'\"><input id=group-by-owner type=checkbox ng-init=\"editable.group_by_owner = true\" ng-model=editable.group_by_owner><label translate for=group-by-owner>Group by owner</label><br><input id=account-new-page type=checkbox ng-init=\"editable.account_new_page = true\" ng-model=editable.account_new_page><label translate for=account-new-page>Begin each statement on new page</label></div><!-- KCAA small aircraft / valid coa --><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'localAircraftRegistryReport\'\"><input id=small-aircraft type=checkbox ng-init=\"editable.small_aircraft = true\" ng-model=editable.small_aircraft><label translate for=small-aircraft>Under 2,500 kg</label><br><input id=valid-coa type=checkbox ng-init=\"editable.valid_coa = true\" ng-model=editable.valid_coa><label translate for=valid-coa>Valid CoA</label></div></div><!-- Revenue Report --><div class=row ng-if=\"editable.report==\'revenueReport\'\"><div class=col-xs-12><label for=displayed-columns>{{ \'Displayed Columns\' | translate }} *</label><br><div class=\"col-xs-12 col-md-2\"><input id=exchange-rate-USD type=checkbox ng-model=editable.exchange_rate_usd><label translate for=exchange-rate-USD>Exchange rate to USD</label></div><div class=\"col-xs-12 col-md-2\"><input id=amount-USD type=checkbox ng-model=editable.amount_usd><label translate for=amount-USD>Amount in USD</label></div></div></div><div class=row ng-if=\"editable.report==\'revenueReport\'\"><div class=col-xs-12><div class=\"col-xs-12 col-md-2\"><input id=exchange-rate-ANSP type=checkbox ng-model=editable.exchange_rate_ansp><label translate for=exchange-rate-ANSP>Exchange rate to ANSP</label></div><div class=\"col-xs-12 col-md-2\"><input id=amount-ANSP type=checkbox ng-model=editable.amount_ansp><label translate for=amount-ANSP>Amount in ANSP</label></div></div></div><!-- KCAA select resolution errors --><div class=row ng-if=\"editable.report===\'missingBillingInformationReport\' || editable.report===\'aircraftRegistrationTrackingReport\'\"><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'missingBillingInformationReport\'\"><label for=types-of-errors><span translate>Types of Errors</span> *</label><multiselect events=\"{ onSelectionChanged: formatMissingInfo }\" extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=listOfMissingInfo id=types-of-errors translated-value=name is-required=true name=missingInfo model=missingInfo></multiselect></div><!-- KCAA select resolution errors --><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'aircraftRegistrationTrackingReport\'\"><label translate for=aircraft-registrations>Aircraft Registrations *</label><multiselect events=\"{ onSelectionChanged: formatAircraftRegistrations }\" extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=listOfAirRegs id=aircraft-registrations is-required=true name=aircraftRegistrations model=aircraftRegistrations></multiselect></div><!-- KCAA group by account --><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report===\'missingBillingInformationReport\' ||\n                                    editable.report===\'aircraftRegistrationTrackingReport\'\"><input id=group-by-account type=checkbox ng-init=\"editable.report !== \'aircraftRegistrationTrackingReport\' ? editable.group_by_account = true : \'\'\" ng-model=editable.group_by_account><label translate for=group-by-account>Group by account</label><br><span ng-if=\"editable.report===\'missingBillingInformationReport\'\"><input id=include-null-accounts type=checkbox ng-init=\"editable.include_null_accounts = true\" ng-model=editable.include_null_accounts><label translate for=include-null-accounts>Include missing accounts</label></span></div></div><!-- Passenger Report --><div class=row ng-if=\"editable.report ===\'kcaaPassengerReport\' || editable.report ===\'passengerReport\'\"><div class=\"col-xs-12 col-md-3\"><label translate for=aerodromes>Aerodromes</label><multiselect id=aerodromes name=aerodromes extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'aerodrome_name\', externalIdProp: \'\' }\" options=aerodromesList model=selectedAerodromes events=\"{ onSelectionChanged: addAerodromeToList }\"></multiselect></div><div class=\"col-xs-12 col-md-3\"><input id=group-by-account type=checkbox ng-init=\"editable.group_by_account = true\" ng-change=\"editable.group_by_account === true ? editable.group_by_aerodrome = false : \'\'\" ng-model=editable.group_by_account><label translate for=group-by-account>Group by account</label><br><input id=\"group-by-aerodrome \" type=checkbox ng-init=\"editable.group_by_aerodrome  = false\" ng-change=\"editable.group_by_aerodrome === true ? editable.group_by_account = false : \'\'\" ng-model=\"editable.group_by_aerodrome \"><label translate for=\"group-by-aerodrome \">Group by aerodrome</label></div></div><div class=row><div class=col-xs-4><label translate for=report_format>Report Download Format</label><select id=report_format class=form-control ng-model=report_format><option translate value=pdf>Adobe PDF</option><option translate value=docx>Microsoft Word</option><option translate value=xlsx>Microsoft Excel</option></select></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-clean\" ng-click=\"setClear(editable); form.$setUntouched();\">Clear</button><!--Account status report--><download-oauth2 ng-show=\"editable.report===\'accountStatusReport\'\" url=reports/generic/account_status error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        credit_type: editable.credit_type,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"editable.credit_type !== \'false\' && editable.credit_type !== \'true\' || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'accountStatusReport\'\" url=reports/generic/account_status error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        credit_type: editable.credit_type,\n                                        page_break: editable.account_new_page }\" disable=\"editable.credit_type !== \'false\' && editable.credit_type !== \'true\'\"></preview-oauth2><!--Account statement report--><download-oauth2 ng-show=\"editable.report===\'accountStatementReport\'\" url=reports/generic/account_statement_v2 error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" request-method=POST body-params=\"{\'account_id\': accountIdsWithBrackets }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'accountStatementReport\'\" url=reports/generic/account_statement_v2 error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{\'account_id\': accountIdsWithBrackets }\"></preview-oauth2><!--Debtor report--><download-oauth2 ng-show=\"editable.report===\'debtorReport\'\" url=reports/generic/debtor_report_v2 error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        overdue_interval: editable.overdue_interval,\n                                        credit_type: editable.invoices,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'debtorReport\'\" url=reports/generic/debtor_report_v2 error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        overdue_interval: editable.overdue_interval,\n                                        credit_type: editable.invoices }\" disable=form.$invalid></preview-oauth2><!--Revenue lost to exemptions report--><download-oauth2 ng-show=\"editable.report===\'revenueLostToExemptionsReport\'\" url=reports/generic/revenue_lost_to_exemptions error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{\'account-id\': accountIds}\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'revenueLostToExemptionsReport\'\" url=reports/generic/revenue_lost_to_exemptions error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{\'account-id\': accountIds}\"></preview-oauth2><!--Summarised invoice totals report--><download-oauth2 ng-show=\"editable.report===\'summarisedInvoiceTotalsReport\'\" url=reports/generic/summarised_invoice_totals_v2 error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        grouping: editable.summary_interval,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page,\n                                        currency: editable.report_currency,\n                                        fiscal_year: editable.fiscal_year,\n                                        fiscal_year_start: fiscalYear,\n                                        generated_by: userName }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{accountid: accountIdsWithBrackets}\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'summarisedInvoiceTotalsReport\'\" url=reports/generic/summarised_invoice_totals_v2 error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        grouping: editable.summary_interval,\n                                        currency: editable.report_currency,\n                                        fiscal_year: editable.fiscal_year,\n                                        fiscal_year_start: fiscalYear,\n                                        generated_by: userName }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{accountid: accountIdsWithBrackets}\"></preview-oauth2><!--Aircraft types report--><download-oauth2 ng-show=\"editable.report===\'aircraftTypesReport\'\" url=reports/generic/aircraft_types error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        filter_type: getFilterType(editable),\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"!editable.used_defined && !editable.used_undefined || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'aircraftTypesReport\'\" url=reports/generic/aircraft_types error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        filter_type: getFilterType(editable) }\" disable=\"!editable.used_defined && !editable.used_undefined\"></preview-oauth2><!--Credit and Debit Notes report--><download-oauth2 ng-show=\"editable.report===\'creditAndDebitNotesReport\' && !KCAA\" url=reports/generic/credit_debit_note error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromDate: returnFilteredDate(control.getUTCStartDate()),\n                                        toDate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        credit: editable.credit_notes,\n                                        debit: editable.debit_notes,\n                                        page_break: editable.account_new_page,\n                                        output_format: report_format }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'creditAndDebitNotesReport\' && !KCAA\" url=reports/generic/credit_debit_note error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromDate: returnFilteredDate(control.getUTCStartDate()),\n                                        toDate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        credit: editable.credit_notes,\n                                        debit: editable.debit_notes,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></preview-oauth2><!--Aircraft Registration report--><download-oauth2 ng-show=\"editable.report===\'aircraftRegistrationReport\' && !KCAA\" url=reports/generic/aircraft_registration error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\', fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        filter_type: getFilterType(editable),\n                                        group_by_account: editable.group_by_account,\n                                        page_break: editable.account_new_page,\n                                        output_format: report_format }\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'aircraftRegistrationReport\' && !KCAA\" url=reports/generic/aircraft_registration error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\', fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        filter_type: getFilterType(editable),\n                                        group_by_account: editable.group_by_account,\n                                        page_break: editable.account_new_page }\" disable=form.$invalid></preview-oauth2><!--Missing Billing Information Report--><download-oauth2 ng-show=\"editable.report===\'missingBillingInformationReport\' && !KCAA\" url=reports/generic/missing_billing_info error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        null_accounts: editable.include_null_accounts,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length  || !missingInfo.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{account_ids: accountIdsWithBrackets, billing_errors: billingErrors}\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'missingBillingInformationReport\' && !KCAA\" url=reports/generic/missing_billing_info error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        null_accounts: editable.include_null_accounts,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length  || !missingInfo.length || form.$invalid\" request-method=POST body-params=\"{account_ids: accountIdsWithBrackets, billing_errors: billingErrors}\"></preview-oauth2><!--Aircraft Registration Tracking Report--><download-oauth2 ng-show=\"editable.report===\'aircraftRegistrationTrackingReport\' && !KCAA\" url=reports/generic/registration_tracking error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" request-method=POST body-params=\"{aircraft_regs: aircraftRegs, account_ids: accountIdsWithBrackets}\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'aircraftRegistrationTrackingReport\' && !KCAA\" url=reports/generic/registration_tracking error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        page_break: editable.account_new_page }\" request-method=POST body-params=\"{aircraft_regs: aircraftRegs, account_ids: accountIdsWithBrackets}\" disable=form.$invalid></preview-oauth2><!--Revenue Report--><download-oauth2 ng-show=\"editable.report === \'revenueReport\'\" url=reports/generic/revenue_report_{{editable.report_type}} error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        output_format: report_format,\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        exchangeUSD: editable.exchange_rate_usd,\n                                        amountUSD: editable.amount_usd,\n                                        exchangeANSP: editable.exchange_rate_ansp,\n                                        amountANSP: editable.amount_ansp,\n                                        generated_by: userName }\" request-method=POST disable=\"form.$invalid || !report_format || !(editable.exchange_rate_usd || editable.amount_usd\n                                    || editable.exchange_rate_ansp || editable.amount_ansp)\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report === \'revenueReport\'\" url=reports/generic/revenue_report_{{editable.report_type}} error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        exchangeUSD: editable.exchange_rate_usd,\n                                        amountUSD: editable.amount_usd,\n                                        exchangeANSP: editable.exchange_rate_ansp,\n                                        amountANSP: editable.amount_ansp,\n                                        generated_by: userName }\" request-method=POST disable=\"form.$invalid || !(editable.exchange_rate_usd || editable.amount_usd\n                                    || editable.exchange_rate_ansp || editable.amount_ansp)\"></preview-oauth2><!--CAAB Passenger Report--><download-oauth2 ng-show=\"editable.report===\'passengerReport\'\" url=reports/generic/passenger_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        group_by_aerodrome: editable.group_by_aerodrome,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{account_ids: accountIdsWithBrackets, aerodrome_ids: aerodromeIdsWithBrackets}\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'passengerReport\'\" url=reports/generic/passenger_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        group_by_aerodrome: editable.group_by_aerodrome,\n                                        page_break: editable.account_new_page }\" disable=form.$invalid request-method=POST body-params=\"{account_ids: accountIdsWithBrackets, aerodrome_ids: aerodromeIdsWithBrackets}\"></preview-oauth2><!--KCAA Account statement report--><download-oauth2 ng-show=\"editable.report===\'kcaaAccountStatementReport\'\" url=reports/generic/account_statement_kcaa error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{ \'account_id\': accountIdsWithBrackets }\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'kcaaAccountStatementReport\'\" url=reports/generic/account_statement_kcaa error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{ \'account_id\': accountIdsWithBrackets }\"></preview-oauth2><!--KCAA Credit and Debit Notes report--><download-oauth2 ng-show=\"editable.report===\'creditAndDebitNotesReport\' && KCAA\" url=reports/generic/credit_debit_note_kcaa_v2 error=error class-used=\"btn btn-primary btn-generate\" params=\"{text: \'Generate\',\n                                        fromDate: returnFilteredDate(control.getUTCStartDate()),\n                                        toDate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        credit: editable.credit_notes,\n                                        debit: editable.debit_notes,\n                                        page_break: editable.account_new_page,\n                                        output_format: report_format }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'creditAndDebitNotesReport\' && KCAA\" url=reports/generic/credit_debit_note_kcaa_v2 error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromDate: returnFilteredDate(control.getUTCStartDate()),\n                                        toDate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        credit: editable.credit_notes,\n                                        debit: editable.debit_notes,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></preview-oauth2><!--KCAA Credit and Cash  report reconciled receipts--><download-oauth2 ng-show=\"editable.report===\'creditAndCashReportReconciledReceipts\' && KCAA\" url=reports/generic/revenue_report_reconciled_receipts error=error class-used=\"btn btn-primary btn-generate\" params=\"{text: \'Generate\',\n                                    fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                    todate: returnFilteredDate(control.getUTCEndDate()),\n                                    group_by_account: editable.group_by_account,\n                                    credit: editable.credit_notes,\n                                    debit: editable.debit_notes,\n                                    page_break: editable.account_new_page,\n                                    output_format: report_format }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'creditAndCashReportReconciledReceipts\' && KCAA\" url=reports/generic/revenue_report_reconciled_receipts error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                    fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                    todate: returnFilteredDate(control.getUTCEndDate()),\n                                    group_by_account: editable.group_by_account,\n                                    credit: editable.credit_notes,\n                                    debit: editable.debit_notes,\n                                    page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></preview-oauth2><!--KCAA Credit and Cash  report unreconciled receipts--><download-oauth2 ng-show=\"editable.report===\'creditAndCashReportUnreconciledReceipts\' && KCAA\" url=reports/generic/revenue_report_unreconciled_receipts error=error class-used=\"btn btn-primary btn-generate\" params=\"{text: \'Generate\',\n                                fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                todate: returnFilteredDate(control.getUTCEndDate()),\n                                group_by_account: editable.group_by_account,\n                                credit: editable.credit_notes,\n                                debit: editable.debit_notes,\n                                page_break: editable.account_new_page,\n                                output_format: report_format }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'creditAndCashReportUnreconciledReceipts\' && KCAA\" url=reports/generic/revenue_report_unreconciled_receipts error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                todate: returnFilteredDate(control.getUTCEndDate()),\n                                group_by_account: editable.group_by_account,\n                                credit: editable.credit_notes,\n                                debit: editable.debit_notes,\n                                page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></preview-oauth2><!--KCAA Aircraft Registration report--><download-oauth2 ng-show=\"editable.report===\'aircraftRegistrationReport\' && KCAA\" url=reports/generic/aircraft_registration_kcaa error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\', fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        filter_type: getFilterType(editable),\n                                        group_by_account: editable.group_by_account,\n                                        page_break: editable.account_new_page,\n                                        output_format: report_format }\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'aircraftRegistrationReport\' && KCAA\" url=reports/generic/aircraft_registration_kcaa error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\', fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        filter_type: getFilterType(editable),\n                                        group_by_account: editable.group_by_account,\n                                        page_break: editable.account_new_page }\" disable=form.$invalid></preview-oauth2><!--KCAA Local Aircraft Registry--><download-oauth2 ng-show=\"editable.report===\'localAircraftRegistryReport\'\" url=reports/generic/local_aircraft_registry_v4 error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\', group_by_owner: editable.group_by_owner,\n                                        page_break: editable.account_new_page,\n                                        small_aircraft: editable.small_aircraft,\n                                        valid_coa: editable.valid_coa,\n                                        output_format: report_format }\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'localAircraftRegistryReport\'\" url=reports/generic/local_aircraft_registry_v4 error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\', group_by_owner: editable.group_by_owner,\n                                        page_break: editable.account_new_page,\n                                        small_aircraft: editable.small_aircraft,\n                                        valid_coa: editable.valid_coa }\" disable=form.$invalid></preview-oauth2><!--KCAA Missing Billing Information Report--><download-oauth2 ng-show=\"editable.report===\'missingBillingInformationReport\' && KCAA\" url=reports/generic/missing_billing_info_kcaa_v2 error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        null_accounts: editable.include_null_accounts,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || !missingInfo.length || form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{ account_ids: accountIdsWithBrackets,\n                                            billing_errors: billingErrors }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'missingBillingInformationReport\' && KCAA\" url=reports/generic/missing_billing_info_kcaa_v2 error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        null_accounts: editable.include_null_accounts,\n                                        page_break: editable.account_new_page }\" disable=\"!selectedAccounts.length || !missingInfo.length || form.$invalid\" request-method=POST body-params=\"{account_ids: accountIdsWithBrackets, billing_errors: billingErrors}\"></preview-oauth2><!--KCAA Aircraft Registration Tracking Report--><download-oauth2 ng-show=\"editable.report===\'aircraftRegistrationTrackingReport\' && KCAA\" url=reports/generic/registration_tracking_kcaa error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" request-method=POST body-params=\"{aircraft_regs: aircraftRegs, account_ids: accountIdsWithBrackets}\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'aircraftRegistrationTrackingReport\' && KCAA\" url=reports/generic/registration_tracking_kcaa error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        page_break: editable.account_new_page }\" request-method=POST body-params=\"{aircraft_regs: aircraftRegs, account_ids: accountIdsWithBrackets}\" disable=form.$invalid></preview-oauth2><!--KCAA Debtor report--><download-oauth2 ng-show=\"editable.report===\'kcaaDebtorReport\'\" url=reports/generic/debtor_report_kcaa error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        overdue_interval: editable.overdue_interval,\n                                        credit_type: editable.invoices,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'kcaaDebtorReport\'\" url=reports/generic/debtor_report_kcaa error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        overdue_interval: editable.overdue_interval,\n                                        credit_type: editable.invoices }\" disable=form.$invalid></preview-oauth2><!--KCAA Passenger Report--><download-oauth2 ng-show=\"editable.report===\'kcaaPassengerReport\'\" url=reports/generic/passenger_report_kcaa error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        group_by_aerodrome: editable.group_by_aerodrome,\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" disable=\"form.$invalid || !report_format\" hide-icon=true request-method=POST body-params=\"{aerodrome_ids: aerodromeIdsWithBrackets, account_ids: accountIdsWithBrackets}\"></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'kcaaPassengerReport\'\" url=reports/generic/passenger_report_kcaa error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        group_by_account: editable.group_by_account,\n                                        group_by_aerodrome: editable.group_by_aerodrome,\n                                        page_break: editable.account_new_page }\" disable=form.$invalid request-method=POST body-params=\"{aerodrome_ids: aerodromeIdsWithBrackets, account_ids: accountIdsWithBrackets}\"></preview-oauth2><!--TTCAA IATA Summary Sum--><download-oauth2 ng-show=\"editable.report===\'iataSummarySum\'\" url=reports/generic/iata_summary_sum error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(editable.report_month),\n                                        todate: returnEndOfMonth(editable.report_month),\n                                        output_format: report_format }\" request-method=POST disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'iataSummarySum\'\" url=reports/generic/iata_summary_sum error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(editable.report_month),\n                                        todate: returnEndOfMonth(editable.report_month) }\" disable=form.$invalid request-method=POST></preview-oauth2><!--TTCAA IATA Summary Data--><download-oauth2 ng-show=\"editable.report===\'iataSummaryData\'\" url=reports/generic/iata_summary_data error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(editable.report_month),\n                                        todate: returnEndOfMonth(editable.report_month),\n                                        output_format: report_format }\" request-method=POST disable=\"form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'iataSummaryData\'\" url=reports/generic/iata_summary_data error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        fromdate: returnFilteredDate(editable.report_month),\n                                        todate: returnEndOfMonth(editable.report_month) }\" disable=form.$invalid request-method=POST></preview-oauth2><!--Unified Tax report--><download-oauth2 ng-show=\"editable.report===\'unifiedTaxReport\'\" url=reports/generic/unified_tax error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()),\n                                        output_format: report_format,\n                                        page_break: editable.account_new_page }\" request-method=POST body-params=\"{\'account_id\': accountIdsWithBrackets }\" disable=\"!selectedAccounts.length || form.$invalid || !report_format\" hide-icon=true></download-oauth2><preview-oauth2 ng-if=\"editable.report===\'unifiedTaxReport\'\" url=reports/generic/unified_tax error=$parent.error height=\"\'670px\'\" params=\"{ page_break: editable.account_new_page,\n                                        text: \'Preview\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"!selectedAccounts.length || form.$invalid\" request-method=POST body-params=\"{\'account_id\': accountIdsWithBrackets }\"></preview-oauth2></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/report-templates/report-templates.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=templates.report-templates toggle=toggle icon=\"\'book\'\" title=\"{{ \'Report Templates\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString service=reportTemplatesService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate sort=reportName>Report Name</th><th translate sort=sqlQuery>SQL Query</th><th translate sort=parameters>Parameters</th><th translate sort=templateDocument>Template Document</th><th translate>Action</th></tr></thead><tbody><tr ng-click=edit(item) ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.report_name }}</td><td>{{ item.sql_query }}</td><td>{{ item.parameters }}</td><td>{{ item.template_document }}</td><td class=text-center><download-oauth2 url=report-templates/{{item.id}}/download error=error></download-oauth2></td></tr><tr ng-show=!list.length><td class=text-center colspan=5 translate>There are no Report Templates</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'book\'\" title=\"{{ \'Upload a Report Template\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'report_template_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=report_name>Report Name *</label><input type=text name=reportName class=form-control id=report_name ng-model=editable.report_name required></div><div class=\"col-xs-12 col-md-6\"><label translate for=sql_query>SQL Query *</label><input type=text name=sqlQuery class=form-control id=sql_query ng-model=editable.sql_query required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=parameters>Parameters *</label><input type=text name=parameters class=form-control id=parameters ng-model=editable.parameters required></div><div class=\"col-xs-12 col-md-6\"><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteFile([editable.id]); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-click=\"upload(\'PUT\', null, editable); form.$setUntouched();\" ng-show=\"editable.id === null\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/repositioning-aerodrome-clusters/repositioning-aerodrome-clusters.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=exemptions.repositioning-aerodrome-cluster-management icon=\"\'cubes\'\" title=\"{{ \'Repositioning Aerodrome Clusters\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=repositioningAerodromeClustersService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th sort=repositioningAerodromeClusterName class=text-nowrap>{{\'Cluster Name\' | translate}} *</th><th sort=enrouteFeesAreExempt class=text-nowrap>{{\'Enroute Fees Exempt\' | translate}} (%)</th><th sort=approachFeesAreExempt class=text-nowrap>{{\'Approach Fees Exempt\' | translate}} (%)</th><th sort=aerodromeFeesAreExempt class=text-nowrap>{{\'Aerodrome Fees Exempt\' | translate}} (%)</th><th sort=lateArrivalFeesAreExempt class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{\'Late Arrival Fees Exempt\' | translate}} (%)</th><th sort=lateDepartureFeesAreExempt class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{\'Late Departure Fees Exempt\' | translate}} (%)</th><th sort=parkingFeesAreExempt class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{\'Parking Fees Exempt\' | translate}} (%)</th><th sort=internationalPax class=text-nowrap>{{\'International PAX Fees Exempt\' | translate}} (%)</th><th sort=domesticPax class=text-nowrap>{{\'Domestic PAX Fees Exempt\' | translate}} (%)</th><th class=text-nowrap sort=extendedHours ng-if=\"shouldShowCharge(\'extendedHours\')\">{{\'Extended Hours Fees Exempt\' | translate}} (%)</th><th sort=flightNotes class=text-nowrap>{{\'Flight Notes\' | translate}}</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); populateDropdowns();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.repositioning_aerodrome_cluster_name }}</td><td class=text-nowrap>{{ item.enroute_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.approach_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.aerodrome_fees_are_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_fees_are_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_fees_are_exempt | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_fees_are_exempt | number: 2 }}</td><td class=text-nowrap>{{ item.international_pax | number: 2 }}</td><td class=text-nowrap>{{ item.domestic_pax | number: 2 }}</td><td class=text-nowrap ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours | number: 2 }}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Repositioning Aerodrome Clusters data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'cubes\'\" title=\"{{ \'Create a Repositioning Aerodrome Cluster\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'cubes\'\" title=\"{{ \'Edit a Repositioning Aerodrome Cluster\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aerodrome_category_modify\')\"><div class=row><div class=\"col-xs-12 col-md-12\"><label for=cluster-name>{{\'Cluster Name\' | translate}} *</label><input id=cluster-name name=repositioningAerodromeClusterName class=form-control ng-model=editable.repositioning_aerodrome_cluster_name required></div></div><div class=row><div class=col-xs-6><label for=aerodromes>{{\'Select Aerodromes\' | translate}}</label><multiselect id=aerodromes name=aerodromesList extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'aerodrome_name\', externalIdProp: \'\' }\" options=aerodromesList model=aerodromesModel></multiselect></div><div class=col-xs-6><label for=unknown-aerodromes>{{\'Select Unknown Aerodromes\' | translate}}</label><multiselect id=unknown-aerodromes name=unknownAerodromesList options=unknownAerodromesList model=unknownAerodromesModel extra-settings=\"{ displayProp: \'text_identifier\', idProp: \'text_identifier\', externalIdProp: \'\' }\"></multiselect></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><label for=enter-aerodrome>{{\'Assign Aerodromes\' | translate}}</label><input id=enter-aerodrome name=enteredAerodromes class=form-control ng-model=enteredAerodromes></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=enroute-fees-exempt>{{\'Enroute Fees Exempt\' | translate}} * (%)</label><input id=enroute-fees-exempt name=enrouteFeesAreExempt class=form-control ng-model=editable.enroute_fees_are_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=approach-fees-exempt>{{\'Approach Fees Exempt\' | translate}} * (%)</label><input id=approach-fees-exempt name=approachFeesAreExempt class=form-control ng-model=editable.approach_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome-fees-exempt>{{\'Aerodrome Fees Exempt\' | translate}} * (%)</label><input id=aerodrome-fees-exempt name=aerodromeFeesAreExempt class=form-control ng-model=editable.aerodrome_fees_are_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'arrival\')\"><label for=late-arrival-fees-exempt>{{\'Late Arrival Fees Exempt\' | translate}} * (%)</label><input id=late-arrival-fees-exempt name=lateArrivalFeesAreExempt class=form-control ng-model=editable.late_arrival_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'departure\')\"><label for=late-departure-fees-exempt>{{\'Late Departure Fees Exempt\' | translate}} * (%)</label><input id=late-departure-fees-exempt name=lateDepartureFeesAreExempt class=form-control ng-model=editable.late_departure_fees_are_exempt type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking-fees-exempt>{{\'Parking Fees Exempt\' | translate}} * (%)</label><input id=parking-fees-exempt name=parkingFeesAreExempt class=form-control ng-model=editable.parking_fees_are_exempt type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=international-pax>{{\'International PAX Fees Exempt\' | translate}} * (%)</label><input id=international-pax name=internationalPax class=form-control ng-model=editable.international_pax type=number max=100 min=0 step=1 required></div><div class=\"col-xs-12 col-md-6\"><label for=domestic-pax>{{\'Domestic PAX Fees Exempt\' | translate}} * (%)</label><input id=domestic-pax name=domesticPAX class=form-control ng-model=editable.domestic_pax type=number max=100 min=0 step=1 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-if=\"shouldShowCharge(\'extendedHours\')\"><label for=extended-hours>{{\'Extended Hours Fees Exempt\' | translate}} * (%)</label><input id=extended-hours name=extendedHours class=form-control ng-model=editable.extended_hours type=number max=100 min=0 step=1 required></div></div><div class=row><div class=col-xs-12><label for=message>{{\'Flight Notes\' | translate}} *</label><input id=message class=form-control name=flightNotes type=text ng-model=editable.flight_notes ng-attr-title=\"{{editable.flight_notes ? \'\' : \'Please indicate which fees are exempt and why\' | translate}}\" required></div></div><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateOverride(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"createOverride(editable); form.$setUntouched();\">Create</button></div></div></fieldset><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></form></div></div></div></div>");
$templateCache.put("app/partials/revenue-data/revenue-data.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=data-analysis-and-statistics.analysis-and-statistics-revenue icon=\"\'line-chart\'\" title=\"{{ \'Data Analysis and Statistics - Revenue\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-6 col-md-2\"><select id=report class=form-control ng-model=template ng-change=selectTemplate(template) ng-options=\"item for item in templatesList\"><option value=\"\"></option></select></div><div class=\"col-xs-6 col-md-1\" ng-if=!template><button translate class=\"btn btn-sm btn-primary btn-save-template\" popup popup-text=\"Save Template as\" save-as=true popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"saveTemplate(inputText); form.$setUntouched()\">Save Template</button></div><div class=\"col-xs-6 col-md-4\" ng-if=template><button translate class=\"btn btn-sm btn-primary btn-delete-template\" popup popup-text=\"Are you sure you want to delete this template?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"deleteTemplate(template); form.$setUntouched()\">Delete Template</button> <button translate class=\"btn btn-sm btn-primary btn-update-template\" popup popup-text=\"Are you sure you want to update this template?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateTemplate(template); form.$setUntouched()\">Update Template</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><div class=row><date-range is-required=::true control=control start-end-adjust=true date-options=\"{ minMode: \'month\' }\" start-name=\"Start Date *\" end-name=\"End Date *\" format={{customDate}}><!--Datepickers --></date-range></div></div><div class=\"col-xs-12 col-md-6\"><div class=row><div class=col-xs-6><label translate for=analysis-type>Analysis Type</label><select id=analysis-type class=form-control name=analysisType ng-model=editable.analysis_type><option value=\"\"></option><option translate value=payment>Payment</option><option translate value=invoice>Invoice</option></select></div><div class=col-xs-6><label translate for=billing-centre>Billing Centre</label><multiselect id=billing-centre name=billingCentresList extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=billingCentresList model=billingCentresModel events=\"{ onSelectionChanged: addBillingCentreToList }\"></multiselect></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=col-xs-3><label translate for=account>Account</label><multiselect id=account name=accountsList extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=accountsList model=accountsModel events=\"{ onSelectionChanged: addAccountToList }\"></multiselect></div><div class=col-xs-3><label translate for=aerodrome>Aerodrome</label><multiselect id=aerodrome name=aerodromesList extra-settings=\"{ displayProp: \'aerodrome_name\', idProp: \'aerodrome_name\', externalIdProp: \'\' }\" options=aerodromesList model=aerodromesModel events=\"{ onSelectionChanged: addAerodromeToList }\"></multiselect></div><div class=col-xs-3 ng-if=KCAA><label translate for=payment-mode>Payment Mode</label><select id=payment-mode class=form-control name=paymentMode ng-model=editable.payment_mode><option value=\"\"></option><option translate value=cash>Cash</option><option translate value=credit>Credit</option></select></div></div></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=col-xs-3><label translate for=charge-class>Charge Class</label><select class=form-control name=chargeClass id=charge-class ng-model=editable.charge_class ng-options=\"item as item for item in chargeClasses\" ng-change=getCategories(editable.charge_class)><option value=\"\"></option></select></div><div class=col-xs-3 ng-show=editable.charge_class><label translate for=charge-category>Charge Category</label><select class=form-control name=chargeCategory id=charge-category ng-model=editable.charge_category ng-options=\"item as item for item in chargeCategories\" ng-change=\"getTypes(editable.charge_class, editable.charge_category)\"><option value=\"\"></option></select></div><div class=col-xs-3 ng-show=editable.charge_category><label translate for=charge-type>Charge Type</label><select class=form-control name=chargeType id=charge-type ng-model=editable.charge_type ng-options=\"item as item for item in chargeTypes\"><option value=\"\"></option></select></div></div></div></div></div></div></div><div class=\"col-xs-12 margin-top-20\"><div class=box-container><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=temporal-group>Temporal Group *</label><select id=temporal-group class=form-control name=temporalGroup ng-model=editable.temporal_group ng-change=\"editable.fiscal_year = false\" required><option translate value=\"\"></option><option translate value=year>Year</option><option translate value=quarter>Quarter</option><option translate value=month>Month</option><option translate value=week>Week</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=group-by>Group By</label><multiselect id=group-by name=groupByValues translated-value=name extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\', selectionLimit: 1 }\" options=groupByValues model=groupByModel events=\"{ onSelectionChanged: addGroupToList }\"></multiselect></div><div class=\"col-xs-12 col-md-2\"><label translate for=sort>Sort By *</label><ol id=my-sort class=sortable ng-model=editable.sort><li ng-repeat=\"item in sortList track by item.id\" data-index={{$index}}>{{item.name | translate}}</li></ol></div><div ng-show=\"editable.temporal_group === \'year\' || editable.temporal_group === \'quarter\'\" class=\"col-xs-12 col-md-3\"><input id=is-fiscal-year type=checkbox name=isFiscalYear ng-model=editable.fiscal_year><label translate for=is-fiscal-year>Group by Fiscal Year</label></div></div></div></div></div></div></div><div class=\"col-xs-12 margin-top-20\"><div class=box-container><form novalidate action=# name=form onsubmit=\"return false\"><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=display-value>Values *</label><select id=display-value class=form-control ng-model=display_value ng-options=\"display.value as display.name | translate for display in displayValues\" required></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=chart-type>Chart Type *</label><select id=chart-type name=chart-type class=form-control ng-model=chartType required><option translate value=bar>Bar</option><option translate value=line>Line</option><option translate value=pie>Pie</option></select></div><div class=\"col-xs-12 col-md-3\"><input id=display-values type=checkbox ng-init=\"display_values = true\" ng-model=display_values><label translate for=display-values>Display values</label></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><button class=\"btn btn-primary btn-generate\" ng-disabled=\"form.$invalid || !control.getUTCStartDate || !control.getUTCEndDate()\" ng-click=\"datapoints = []; generate(editable, control.getUTCStartDate(), control.getUTCEndDate(), groupBy, chartType); form.$setUntouched()\"><span translate>Generate</span></button> <button class=\"btn btn-primary\" ng-disabled=!datapoints.length><div export-table chart-json=csvData filename=Revenue_Data error=error format=csv button=true><span translate>Export CSV</span></div></button><export-pdf element=svg filename=Revenue_Data error=error disable=!datapoints.length orientation=landscape text=\"Export PDF\"></export-pdf></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row ng-show=noData><div class=\"col-xs-6 col-xs-offset-3\"><div class=\"alert text-center infoAlert\"><span translate>NO DATA FOR THESE SELECTIONS</span></div></div></div></div></div></div></form></div></div><div ng-if=\"datapoints.length > 0 && !noData\" class=\"col-xs-12 margin-top-20\"><div class=box-container><div class=box-content><div class=row><c3chart bindto-id=chart id=chart chart-data=datapoints chart-columns=datacolumns chart-x=datax labels-format-function=labelFormat><chart-bar ratio=0.75><chart-axes values-x=x><chart-legend show-legend=true legend-position=right><chart-axis><chart-axis-x axis-position=outer-right axis-label=\"Revenue Data\" axis-type=category><chart-axis-y axis-position=outer-right axis-label=\"{{ ylabel }}\"></chart-axis></c3chart></div></div></div></div></div>");
$templateCache.put("app/partials/revenue-projection/revenue-projection.html","<div class=\"row revenue-projection\"><div class=col-xs-9><div class=box-container><box-header icon=\"\'dollar\'\" title=\"{{ \'Revenue Projection\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-3><h6 class=underline translate>Enroute Formulas</h6></div><div class=col-xs-9 style=\"background-color: red\" ng-show=\"noFormulas === true\"><div><h6 translate>No existing formulas can be found for the provided MTOW upper limit</h6></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=upper_limit_enabled name=upper_limit_enabled type=checkbox ng-model=enabled.upper_limit_enabled ng-click=\"changeStatus(\'upper_limit\');\" ng-focus=setFocusInput(null) disabled=disabled><label translate>Enroute MTOW</label></div><div class=col-sm-7><input id=upper_limit name=upper_limit ng-model=editable.upper_limit ng-hide=!enabled.upper_limit_enabled type=number class=center-number min=0 max=640000 ng-focus=setFocusInput(null) style=\"width: 75%\" ng-blur=getFormulas();></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=w_factor_formula_enabled name=w_factor_formula_enabled type=checkbox ng-model=enabled.w_factor_formula_enabled ng-click=\"changeStatus(\'w_factor_formula\');\" ng-focus=\"setFocusInput(\'w_factor_formula\')\"><label translate>W Factor</label></div><div class=col-sm-7><input id=w_factor_formula name=w_factor_formula ng-model=editable.w_factor_formula ng-hide=!enabled.w_factor_formula_enabled type=text ng-focus=\"setFocusInput(\'w_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=domestic_formula_enabled name=domestic_formula_enabled type=checkbox ng-model=enabled.domestic_formula_enabled ng-click=\"changeStatus(\'domestic_formula\');\" ng-focus=\"setFocusInput(\'domestic_formula\')\"><label translate>Domestic</label></div><div class=col-sm-7><input id=domestic_formula name=domestic_formula ng-hide=!enabled.domestic_formula_enabled ng-model=editable.domestic_formula type=text ng-focus=\"setFocusInput(\'domestic_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=domestic_d_factor_formula_enabled name=domestic_d_factor_formula_enabled type=checkbox ng-model=enabled.domestic_d_factor_formula_enabled ng-click=\"changeStatus(\'domestic_d_factor_formula\');\" ng-focus=\"setFocusInput(\'domestic_d_factor_formula\')\"><label translate>Domestic (D)</label></div><div class=col-sm-7><input id=domestic_d_factor_formula name=domestic_d_factor_formula ng-hide=!enabled.domestic_d_factor_formula_enabled ng-model=editable.domestic_d_factor_formula type=text ng-focus=\"setFocusInput(\'domestic_d_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=regional_arrival_formula_enabled name=regional_arrival_formula_enabled type=checkbox ng-model=enabled.regional_arrival_formula_enabled ng-click=\"changeStatus(\'regional_arrival_formula\');\" ng-focus=\"setFocusInput(\'regional_arrival_formula\')\"><label translate>Regional Arrival</label></div><div class=col-sm-7><input id=regional_arrival_formula name=regional_arrival_formula ng-hide=!enabled.regional_arrival_formula_enabled ng-model=editable.regional_arrival_formula type=text ng-focus=\"setFocusInput(\'regional_arrival_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=reg_arr_d_factor_formula_enabled name=reg_arr_d_factor_formula_enabled type=checkbox ng-model=enabled.reg_arr_d_factor_formula_enabled ng-click=\"changeStatus(\'reg_arr_d_factor_formula\');\" ng-focus=\"setFocusInput(\'reg_arr_d_factor_formula\')\"><label translate>Regional Arrival (D)</label></div><div class=col-sm-7><input id=reg_arr_d_factor_formula name=reg_arr_d_factor_formula ng-hide=!enabled.reg_arr_d_factor_formula_enabled ng-model=editable.reg_arr_d_factor_formula type=text ng-focus=\"setFocusInput(\'reg_arr_d_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=regional_departure_formula_enabled name=regional_departure_formula_enabled type=checkbox ng-model=enabled.regional_departure_formula_enabled ng-click=\"changeStatus(\'regional_departure_formula\');\" ng-focus=\"setFocusInput(\'regional_departure_formula\')\"><label translate>Regional Departure</label></div><div class=col-sm-7><input id=regional_departure_formula name=regional_departure_formula ng-model=editable.regional_departure_formula ng-hide=!enabled.regional_departure_formula_enabled type=text ng-focus=\"setFocusInput(\'regional_departure_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=reg_dep_d_factor_formula_enabled name=reg_dep_d_factor_formula_enabled type=checkbox ng-model=enabled.reg_dep_d_factor_formula_enabled ng-click=\"changeStatus(\'reg_dep_d_factor_formula\');\" ng-focus=\"setFocusInput(\'reg_dep_d_factor_formula\')\"><label translate>Regional Departure (D)</label></div><div class=col-sm-7><input id=reg_dep_d_factor_formula name=reg_dep_d_factor_formula ng-model=editable.reg_dep_d_factor_formula ng-hide=!enabled.reg_dep_d_factor_formula_enabled type=text ng-focus=\"setFocusInput(\'reg_dep_d_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=regional_overflight_formula_enabled name=regional_overflight_formula_enabled type=checkbox ng-model=enabled.regional_overflight_formula_enabled ng-click=\"changeStatus(\'regional_overflight_formula\');\" ng-focus=\"setFocusInput(\'regional_overflight_formula\')\"><label translate>Regional Overflight</label></div><div class=col-sm-7><input id=regional_overflight_formula name=regional_overflight_formula ng-model=editable.regional_overflight_formula ng-hide=!enabled.regional_overflight_formula_enabled type=text ng-focus=\"setFocusInput(\'regional_overflight_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=reg_ovr_d_factor_formula_enabled name=reg_ovr_d_factor_formula_enabled type=checkbox ng-model=enabled.reg_ovr_d_factor_formula_enabled ng-click=\"changeStatus(\'reg_ovr_d_factor_formula\');\" ng-focus=\"setFocusInput(\'reg_ovr_d_factor_formula\')\"><label translate>Regional Overflight (D)</label></div><div class=col-sm-7><input id=reg_ovr_d_factor_formula name=reg_ovr_d_factor_formula ng-hide=!enabled.reg_ovr_d_factor_formula_enabled ng-model=editable.reg_ovr_d_factor_formula type=text ng-focus=\"setFocusInput(\'reg_ovr_d_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=international_arrival_formula_enabled name=international_arrival_formula_enabled type=checkbox ng-model=enabled.international_arrival_formula_enabled ng-click=\"changeStatus(\'international_arrival_formula\');\" ng-focus=\"setFocusInput(\'international_arrival_formula\')\"><label translate>International Arrival</label></div><div class=col-sm-7><input id=international_arrival_formula name=international_arrival_formula ng-model=editable.international_arrival_formula ng-hide=!enabled.international_arrival_formula_enabled type=text ng-focus=\"setFocusInput(\'international_arrival_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=int_arr_d_factor_formula_enabled name=int_arr_d_factor_formula_enabled type=checkbox ng-model=enabled.int_arr_d_factor_formula_enabled ng-click=\"changeStatus(\'int_arr_d_factor_formula\');\" ng-focus=\"setFocusInput(\'int_arr_d_factor_formula\')\"><label translate>International Arrival (D)</label></div><div class=col-sm-7><input id=int_arr_d_factor_formula name=int_arr_d_factor_formula ng-hide=!enabled.int_arr_d_factor_formula_enabled ng-model=editable.int_arr_d_factor_formula type=text ng-focus=\"setFocusInput(\'int_arr_d_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=international_departure_formula_enabled name=international_departure_formula_enabled type=checkbox ng-model=enabled.international_departure_formula_enabled ng-click=\"changeStatus(\'international_departure_formula\');\" ng-focus=\"setFocusInput(\'international_departure_formula\')\"><label translate>International Departure</label></div><div class=col-sm-7><input id=international_departure_formula name=international_departure_formula ng-hide=!enabled.international_departure_formula_enabled ng-model=editable.international_departure_formula type=text ng-focus=\"setFocusInput(\'international_departure_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=int_dep_d_factor_formula_enabled name=int_dep_d_factor_formula_enabled type=checkbox ng-model=enabled.int_dep_d_factor_formula_enabled ng-click=\"changeStatus(\'int_dep_d_factor_formula\');\" ng-focus=\"setFocusInput(\'int_dep_d_factor_formula\')\"><label translate>International Departure (D)</label></div><div class=col-sm-7><input id=int_dep_d_factor_formula name=int_dep_d_factor_formula ng-model=editable.int_dep_d_factor_formula ng-hide=!enabled.int_dep_d_factor_formula_enabled type=text ng-focus=\"setFocusInput(\'int_dep_d_factor_formula\')\"></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=international_overflight_formula_enabled name=international_overflight_formula_enabled type=checkbox ng-model=enabled.international_overflight_formula_enabled ng-click=\"changeStatus(\'international_overflight_formula\');\" ng-focus=\"setFocusInput(\'international_overflight_formula\')\"><label translate>International Overflight</label></div><div class=col-sm-7><input id=international_overflight_formula name=international_overflight_formula ng-hide=!enabled.international_overflight_formula_enabled ng-model=editable.international_overflight_formula type=text ng-focus=\"setFocusInput(\'international_overflight_formula\')\"></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=int_ovr_d_factor_formula_enabled name=int_ovr_d_factor_formula_enabled type=checkbox ng-model=enabled.int_ovr_d_factor_formula_enabled ng-click=\"changeStatus(\'int_ovr_d_factor_formula\');\" ng-focus=\"setFocusInput(\'int_ovr_d_factor_formula\')\"><label translate>International Overflight (D)</label></div><div class=col-sm-7><input id=int_ovr_d_factor_formula name=int_ovr_d_factor_formula ng-hide=!enabled.int_ovr_d_factor_formula_enabled ng-model=editable.int_ovr_d_factor_formula type=text ng-focus=\"setFocusInput(\'int_ovr_d_factor_formula\')\"></div></div></div><div class=row><div class=col-xs-6><h6 class=underline translate>Charge-based Projections</h6></div><div class=col-xs-6><h6 class=underline translate>Volume-based Projections</h6></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input i d=charges_aerodrome_enabled name=charges_aerodrome_enabled type=checkbox ng-model=enabled.charges_aerodrome_enabled ng-click=\"changeStatus(\'charges_aerodrome\');\" ng-focus=setFocusInput(null)><label translate>Aerodrome Charges (%)</label></div><div class=col-sm-7><input id=charges_aerodrome name=charges_aerodrome ng-model=editable.charges_aerodrome ng-hide=!enabled.charges_aerodrome_enabled type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=charges_vol_flights_enabled name=charges_vol_flights_enabled type=checkbox ng-model=enabled.charges_vol_flights_enabled ng-click=\"changeStatus(\'charges_vol_flights\');\" ng-focus=setFocusInput(null)><label translate>Total Flights (%)</label></div><div class=col-sm-7><input id=charges_vol_flights name=charges_vol_flights ng-hide=!enabled.charges_vol_flights_enabled ng-model=editable.charges_vol_flights type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=charges_approach_enabled name=charges_approach_enabled type=checkbox ng-model=enabled.charges_approach_enabled ng-click=\"changeStatus(\'charges_approach\');\" ng-focus=setFocusInput(null)><label translate>Approach Charges (%)</label></div><div class=col-sm-7><input id=charges_approach name=charges_approach ng-model=editable.charges_approach ng-hide=!enabled.charges_approach_enabled type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=charges_vol_passengers_enabled name=charges_vol_passengers_enabled type=checkbox ng-model=enabled.charges_vol_passengers_enabled ng-click=\"changeStatus(\'charges_vol_passengers\');\" ng-focus=setFocusInput(null)><label translate>Total Passengers (%)</label></div><div class=col-sm-7><input id=charges_vol_passengers name=charges_vol_passengers ng-model=editable.charges_vol_passengers ng-hide=!enabled.charges_vol_passengers_enabled type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=charges_late_arrival_enabled name=charges_late_arrival_enabled type=checkbox ng-model=enabled.charges_late_arrival_enabled ng-click=\"changeStatus(\'charges_late_arrival\');\" ng-focus=setFocusInput(null)><label translate>Late Arrival Charges (%)</label></div><div class=col-sm-7><input id=charges_late_arrival name=charges_late_arrival ng-model=editable.charges_late_arrival ng-hide=!enabled.charges_late_arrival_enabled type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=charges_late_departure_enabled name=charges_late_departure_enabled type=checkbox ng-model=enabled.charges_late_departure_enabled ng-click=\"changeStatus(\'charges_late_departure\', enabled.charges_late_departure_enabled);\" ng-focus=setFocusInput(null)><label translate>Late Departure Charges (%)</label></div><div class=col-sm-7><input id=charges_late_departure name=charges_late_departure ng-model=editable.charges_late_departure ng-hide=!enabled.charges_late_departure_enabled type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div></div><div class=\"row no-top\"><div class=\"form-group col-xs-6 no-bottom\"><div class=col-sm-5><input id=charges_passenger_enabled name=charges_passenger_enabled type=checkbox ng-model=enabled.charges_passenger_enabled ng-click=\"changeStatus(\'charges_passenger\');\" ng-focus=setFocusInput(null)><label translate>Passenger Charges (%)</label></div><div class=col-sm-7><input id=charges_passenger name=charges_passenger ng-model=editable.charges_passenger ng-hide=!enabled.charges_passenger_enabled type=number class=center-number min=-500 max=500 style=\"width: 40%\" ng-focus=setFocusInput(null)></div></div></div><div class=row><div class=col-xs-6><h6 class=underline translate>Revenue Projection Settings</h6></div></div><div class=\"row no-top\"><div class=col-sm-4><label translate>Projection Period *</label><select ng-focus=setFocusInput(null) id=time_period name=time_period class=form-control ng-model=editable.time_period required><option translate value=MONTH>Month</option><option translate value=QUARTER>Quarter</option><option translate value=YEAR>Year</option><option translate value=DECADE>Decade</option></select></div><div class=col-sm-4><label translate>Include Only Selected Parameters?</label><select ng-focus=setFocusInput(null) id=modified_only name=modified_only class=form-control ng-model=editable.modified_only ng-change=setMonthlyDates() required><option translate value=yes>Yes</option><option translate value=no>No</option></select></div></div><div class=row><div class=col-xs-12><button title=\"{{ \'Reset form to current settings\' | translate }}\" type=button class=\"btn btn-primary\" translate ng-click=\"reset(); clearForm(); getFormulas();\" ng-disabled=\"processing === true\">Reset</button> <button title=\"{{ \'Clear all form settings\' | translate }}\" type=button class=\"btn btn-primary\" translate ng-click=\"reset(); clearForm();\" ng-disabled=\"processing === true\">Clear</button> <button title=\"{{ \'Generate PDF of projections\' | translate }}\" type=button class=\"btn btn-primary\" translate ng-click=\"doGenerate(\'PDF\');\" ng-disabled=\"form.$invalid || !canGenerate || editable.upper_limit <= 0 || processing === true\">PDF</button> <button title=\"{{ \'Generate XLSX of projection\' | translate }}\" type=button class=\"btn btn-primary\" translate ng-click=\"doGenerate(\'XLSX\');\" ng-disabled=\"form.$invalid || !canGenerate || editable.upper_limit <= 0 || processing === true\">XLSX</button> <button title=\"{{ \'Validate enroute formulas\' | translate }}\" type=button class=\"btn btn-primary\" translate ng-click=validate(); ng-disabled=\"form.$invalid || !canGenerate || editable.upper_limit <= 0 || processing === true\">Validate</button></div></div><div ng-show=validated><div class=row><div class=col-xs-12><h6 class=underline translate>Validation Results</h6></div></div><div class=row><div class=col-xs-9><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th class=text-left translate>Formula Name</th><th class=text-center translate>Result</th><th class=text-left translate>Issues</th></tr></thead><tbody><tr ng-repeat=\"item in data_results\" ng-show=item.formula><td class=\"text-nowrap text-left\">{{ item.name | translate }}</td><td class=\"text-nowrap text-center\"><i class=\"fa fa-check-circle\" ng-show=item.formula_valid></i> <i class=\"fa fa-times-circle\" ng-show=!item.formula_valid></i></td><td class=\"text-nowrap text-left\" ng-bind-html=getTrustedHtml(item.issue)></td></tr></tbody></table></div></div></div></div></div></div><div class=col-xs-3 style=\"padding: 0px\"><div class=box-container><box-header icon=\"\'dollar\'\" title=\"{{ \'Formula Toolbox\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><uib-accordion close-others=false><div uib-accordion-group class=panel-default heading=\"{{\'Operators\' | translate}}\" is-open=true><button ng-click=\"addToFormula(\'+\', \'op\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Addition\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-addition>+</button> <button ng-click=\"addToFormula(\'-\', \'op\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Subtraction\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-subtraction>-</button> <button ng-click=\"addToFormula(\'*\', \'op\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Multiplication\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-multiplication>*</button> <button ng-click=\"addToFormula(\'/\', \'op\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Division\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-division>/</button> <button ng-click=\"addToFormula(\'(\', \'op\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Left Bracket\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-leftBracket>(</button> <button ng-click=\"addToFormula(\')\', \'op\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Right Bracket\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-rightBracket>)</button> <button ng-click=\"addToFormula(\'&Sqrt;( )\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Square Root\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-sqrt>&Sqrt;</button></div><div uib-accordion-group class=panel-default heading=\"{{\'Parameters\' | translate}}\" is-open=true><button ng-click=\"addToFormula(\'[MTOW]\', \'param\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Maximum Take-off Weight\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-mtow>[MTOW]</button> <button ng-click=\"addToFormula(\'[AvgMassFactor]\', \'param\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Average Mass Factor\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-amf>[AvgMassFactor]</button> <button ng-click=\"addToFormula(\'[CrossDist]\', \'param\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'FIR Crossing Distance\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-xdst>[CrossDist]</button> <button ng-click=\"addToFormula(\'[AccountDiscount]\', \'param\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Discount Percentage\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-dsct>[AccountDiscount]</button> <button ng-click=\"addToFormula(\'[EntriesNumber]\', \'param\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Number of FIR Entry Points\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-pnts>[EntriesNumber]</button> <button ng-click=\"addToFormula(\'[FirEntryFee]\', \'param\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Cost per FIR Entry\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-ceny>[FirEntryFee]</button></div><div uib-accordion-group class=panel-default heading=\"{{\'Functions\' | translate}}\" is-open=true><button ng-click=\"addToFormula(\'sqr(#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Square of Number\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-sqr>[SQR]</button> <button ng-click=\"addToFormula(\'abs(#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Absolute Value\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[ABS]</button> <button ng-click=\"addToFormula(\'round(#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Round to Nearest Integer\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[ROUND]</button> <button ng-click=\"addToFormula(\'trunc(#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Integral Number\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[TRUNC]</button> <button ng-click=\"addToFormula(\'pow(#,#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Raise Number to Power\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[POW]</button> <button ng-click=\"addToFormula(\'min(#,#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Smaller of Two Numbers\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[MIN]</button> <button ng-click=\"addToFormula(\'max(#,#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Larger of Two Numbers\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[MAX]</button> <button ng-click=\"addToFormula(\'ceil(#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Smallest Integer Greater than Number\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[CEILING]</button> <button ng-click=\"addToFormula(\'floor(#)\', \'func\')\" ng-disabled=\"!formula || processing\" title=\"{{ \'Return Largest Integer Smaller than Number\' | translate}}\" type=button class=\"btn btn-primary\" id=btn-d>[FLOOR]</button></div></uib-accordion></div></div><div class=row ng-show=formulaError><div class=col-xs-12><div class=\"alert alert-dismissible alert-danger alert-icon\"><button type=button ng-click=\"formulaError = null\" class=close>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <span>{{ formulaError }}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-account-management/sc-account-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'key\'\" title=\"{{ \'Accounts\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><button ng-click=refresh() class=\"btn btn-primary pull-right\" translate>Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=accounts-filter>Accounts</label><select id=accounts-filter ng-init=\"filter = \'true\'\" class=form-control ng-change=refresh() ng-model=filter><option translate value=\"\">All</option><option translate value=true>Active</option><option translate value=false>Not Active</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=accounts-type>Accounts Type</label><select id=accounts-type class=form-control ng-init=\"accountTypeFilter = \'\'\" ng-change=refresh() ng-model=accountTypeFilter><option translate value=true>Cash Accounts</option><option translate value=false>Credit Accounts</option><option translate value=\"\">All Accounts</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=filter>Invoice</label><select id=filter class=form-control ng-model=accountFilter ng-change=refresh()><option translate value=\"\"></option><option translate value=outstanding>Outstanding Invoices</option><option translate value=overdue>Overdue Invoices</option><option translate value=credit-limit>Credit Facilities</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=nationality-filter>Nationality</label><select id=nationality-filter empty-to-null class=form-control ng-change=refresh() ng-model=nationality><option translate value=\"\">All</option><option translate value=NA>National</option><option translate value=FO>Foreign</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div></div><div class=row ng-show=\"hasPermission(\'self_care_admin\')\"><div class=\"col-xs-12 col-md-3\"><input id=self-care-accounts type=checkbox ng-init=\"selfCareAccounts = true\" ng-model=selfCareAccounts ng-change=refresh()><label translate for=self-care-accounts>Self-care portal accounts</label></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=scAccountManagementService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th class=text-nowrap translate sort=name>Account Name</th><th class=text-nowrap translate sort=icaoCode>ICAO Code</th><th class=text-nowrap translate sort=iataCode>IATA Code</th><th class=text-nowrap translate sort=aviationBillingContactPersonName>Contact Name</th><th class=text-nowrap translate ng-show=\"needAdminApproval && hasPermission(\'self_care_access\') && (item.sc_request_type === \'create\' || !item.sc_request_type)\">Status</th><th class=text-nowrap translate sort=document>Document</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); editOverride(item);saveOldValue(); checkCreditLimit();\" ng-class=\"{\'highlight\': editable.name === item.name}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.name | translate }}</td><td class=text-nowrap>{{ item.icao_code }}</td><td class=text-nowrap>{{ item.iata_code }}</td><td class=text-nowrap>{{ item.aviation_billing_contact_person_name }}</td><td class=text-nowrap ng-show=\"needAdminApproval && hasPermission(\'self_care_access\') && item.sc_request_type === \'create\'\">{{ \'create pending\' | translate }}</td><td class=text-nowrap ng-show=\"needAdminApproval && hasPermission(\'self_care_access\') && !item.sc_request_type\">{{ \'approved\' | translate }}</td><td class=text-center><download-oauth2 ng-show=item.uploaded_document_name url=\"accounts/{{ item.id }}/download\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td></tr><tr ng-show=!list.length><td translate class=text-center colspan=6>There are no Accounts data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'key\'\" title=\"{{ \'Create an Account\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'key\'\" title=\"{{ \'Edit an Account\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=name>Account Name *</label><input id=name name=name class=form-control type=text ng-model=editable.name ng-disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\" required></div><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-contact-person-name>Aviation Billing Contact Person Name</label><input id=aviation-billing-contact-person-name name=aviationBillingContactPersonName class=form-control type=text ng-model=editable.aviation_billing_contact_person_name></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-person-phone-number>Aviation Billing Phone Number</label><input id=aviation-billing-person-phone-number name=aviationBillingPhoneNumber class=form-control type=text ng-model=editable.aviation_billing_phone_number></div><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-mailing-address>Aviation Billing Mailing Address</label><input id=aviation-billing-mailing-address name=aviationBillingMailingAddress class=form-control type=text ng-model=editable.aviation_billing_mailing_address></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-person-email>Aviation Billing Email Address</label><input id=aviation-billing-person-email name=aviationBillingEmailAddress class=form-control type=email ng-model=editable.aviation_billing_email_address pattern=[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+$></div><div class=\"col-xs-12 col-md-6\"><label translate for=aviation-billing-sms-number>Aviation Billing Telephone Number</label><input id=aviation-billing-sms-number name=aviationBillingSmsNumber class=form-control type=text ng-model=editable.aviation_billing_sms_number></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=nationality><span translate>Nationality</span> *</label><select id=nationality-filter class=form-control ng-model=editable.nationality required><option translate value=NA>National</option><option translate value=FO>Foreign</option></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=payment-terms>Payment Terms (days) *</label><input id=payment-terms name=paymentTerms class=form-control type=number step=1 min=0 pattern=\\d+ ng-model=editable.payment_terms required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=iata-code>IATA Code</label><input id=iata-code name=iataCode class=form-control type=text maxlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false ng-model=editable.iata_code ng-disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\" uppercase-input empty-to-null></div><div class=\"col-xs-12 col-md-6\"><label translate for=icao-code>ICAO Code</label><input id=icao-code name=icaoCode class=form-control type=text maxlength=3 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false ng-model=editable.icao_code ng-disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\" uppercase-input empty-to-null></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=account-type>Account Type *</label><dynamic-service-dropdown ng-model=editable.account_type id=account-type name=accountType class=text-capitalize dropdown-type=single service=::typesService disabled=\"!hasPermission(\'self_care_admin\')\" is-required=::true options=\"item as (item.name | translate) for item in list track by item.id\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=invoice-currency><span translate>Account Currency</span> *</label><dynamic-service-dropdown ng-model=editable.invoice_currency id=invoice-currency query-string=\"filter=active\" name=invoiceCurrency disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\" dropdown-type=single service=::currencyManagementService is-required=::true options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in list.content track by item.currency_code\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=invoice-delivery-format>Invoice Delivery Format *</label><select id=invoice-delivery-format name=invoiceDeliveryFormat type=text class=form-control ng-model=editable.invoice_delivery_format ng-disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\" required><option translate value=docx>docx</option><option translate value=xlsx>xlsx</option><option translate value=pdf>pdf</option></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=invoice-delivery-method>Invoice Delivery Method *</label><select id=invoice-delivery-method name=invoiceDeliveryMethod ng-model=editable.invoice_delivery_method class=form-control ng-disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\" required><option translate value=email>Email</option><option translate value=paper>Paper</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=cash-account>Cash Account</label><boolean-text id=cash-account class=form-control name=cash_account ng-model=editable.cash_account ng-disabled=\"!hasPermission(\'self_care_admin\')\" ng-change=checkCreditLimit() required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label for=credit-limit><span translate>Credit Limit</span>&nbsp;({{ ::anspCurrency }})&nbsp;*</label><input id=credit-limit name=creditLimit class=form-control type=number ng-disabled=\"!hasPermission(\'self_care_admin\')\" min={{minCreditLimit}} max={{maxCreditLimit}} ng-model=editable.credit_limit required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=blacklisted-indicator>Blacklisted Indicator</label><boolean-text id=blacklisted-indicator class=form-control name=blackListedIndicator ng-model=editable.black_listed_indicator ng-disabled=true></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=blacklisted-override>Blacklisted Override *</label><boolean-text id=blacklisted-override class=form-control name=blackListedOverride ng-model=editable.black_listed_override ng-disabled=\"!hasPermission(\'self_care_admin\')\"></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=approved-flight-school-indicator>Approved Flight School *</label><boolean-text class=form-control name=approvedFlightSchoolIndicator id=approved-flight-school-indicator ng-disabled=\"!hasPermission(\'self_care_admin\')\" ng-model=editable.approved_flight_school_indicator required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=iata-member>IATA Member *</label><boolean-text class=form-control name=iataMember id=iata-member ng-model=editable.iata_member ng-disabled=\"!hasPermission(\'self_care_admin\')\" required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=monthly-overdue-penalty-rate>Monthly Overdue Penalty Rate (%) *</label><input id=monthly-overdue-penalty-rate name=monthlyOverduePenaltyRate class=form-control min=0 type=number ng-disabled=\"!hasPermission(\'self_care_admin\')\" ng-model=editable.monthly_overdue_penalty_rate required></div><div class=\"col-xs-12 col-md-6\"><label translate for=notes>Notes</label><input id=notes class=form-control name=notes ng-model=editable.notes ng-disabled=\"!hasPermission(\'self_care_admin\') && editable.id != null\"></div></div><div class=row ng-show=\"hasPermission(\'self_care_admin\')\"><div class=\"col-xs-12 col-md-6\"><label for=self-care-account><span translate>Self-Care Account</span> *</label><boolean-text id=self-care-account class=form-control name=selfCareAccount ng-model=editable.is_self_care required ng-disabled=true></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=account_users>Self-Care Account Users</label><multiselect id=account_users name=account_users translated-value=name search=false extra-settings=\"{ displayProp: \'name\', idProp: \'id\', externalIdProp: \'\', scrollableHeight: auto }\" options=selfCareUserList model=editable.account_users></multiselect></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button ng-disabled=false class=\"btn btn-primary btn-reset\" ng-click=\"reset(); setDefaultFields(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=\"form.$invalid || !editable.document_filename\" ng-show=\"editable.id !== null || editable.id === null && editable.sc_request_id\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateOverride(editable, editable.id); form.$setUntouched();\">Update</button> <button ng-if=\"hasPermission(\'self_care_admin\') && editable.is_self_care && editable.id !== null\" class=\"btn btn-primary btn-delete\" translate popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id);>Delete</button> <button ng-if=\"editable.id === null && !editable.sc_request_id\" class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || !editable.document_filename\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/sc-aircraft-registration/sc-aircraft-registration.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'paper-plane\'\" title=\"{{ \'Aircraft Registrations\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button ng-click=refreshOverride() class=\"btn btn-primary pull-right\" translate>Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=scAircraftRegistrationService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=registrationNumber>Registration Number</th><th translate class=text-nowrap sort=registrationStartDate>Start Date</th><th translate class=text-nowrap sort=registrationExpiryDate>Expiry Date</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=aircraftType.aircraftType>Aircraft Type</th><th class=\"text-nowrap text-right\" sort=mtowOverride><span>{{ \'MTOW Override\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th translate class=text-nowrap sort=createdBySelfCare>Created By Self-Care</th><th translate class=text-nowrap ng-show=\"needAdminApproval && hasPermission(\'self_care_access\')\">Status</th><th class=text-nowrap translate sort=document>Document</th></tr></thead><tbody><tr ng-click=\"setEditable(item, $index)\" ng-class=\"{\'highlight\': editableIndex === $index}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.registration_number }}</td><td class=text-nowrap>{{ item.registration_start_date | dateConverter }}</td><td class=text-nowrap>{{ item.registration_expiry_date | dateConverter }}</td><td class=text-nowrap>{{ item.account.name | translate }}</td><td class=text-nowrap>{{ item.aircraft_type.aircraft_type }}</td><td class=text-right>{{ item.mtow_override | weightConverter }}</td><td>{{ item.created_by_self_care | translate }}</td><td class=text-nowrap ng-show=\"needAdminApproval && hasPermission(\'self_care_access\')\">{{ setStatus(item) | translate }}</td><td class=text-center><download-oauth2 disable=item.sc_request_type ng-show=item.uploaded_document_name url=\"aircraft-registrations/{{ item.id }}/download\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td></tr><tr ng-show=!list.length><td class=text-center translate colspan=10>There are no Aircraft Registration data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Register an Aircraft\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'fighter-jet\'\" title=\"{{ \'Edit an Aircraft\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=col-xs-12><p class=notification><span translate>{{ ::notification_text }}</span><br><br><input id=notification type=checkbox ng-model=notification><label translate for=notification>I agree</label></p></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=registration-number>Registration Number *</label><input id=registration-number name=registrationNumber class=\"form-control text-uppercase\" type=text ng-model=editable.registration_number ng-blur=\"getAircraftTypeByLatestRegistrationNumber(editable.registration_number); getCountryByRegistrationNumberPrefix(editable.registration_number)\" minlength=2 maxlength=7 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account id=account name=account dropdown-type=single service=::scAccountManagementService method=getSCActiveAccounts is-required=::true options=\"account as account.name for account in list track by account.id\"></dynamic-service-dropdown></div></div><div class=row><date-range control=control is-required=::true start-name=\"Start Date *\" end-name=\"Expiry Date *\" format=\"{{ customDate }}\"><!-- Datepickers --></date-range></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft-type>Aircraft Type *</label><dynamic-service-dropdown ng-model=editable.aircraft_type id=aircraft-type name=aircraftType dropdown-type=single service=::aircraftTypeManagementService is-required=::true options=\"item as item.aircraft_type for item in list.content | orderBy: \'aircraft_type\' track by item.id\" ng-change=convertMtowProperty(editable.aircraft_type)></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=mtow-override><span>{{ \'MTOW Override\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }}) *</span></label><unit-conversion-input id=mtow-override name=mtowOverride ng-model=editable.mtow_override measurement-type=weight required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=country-of-registration>Country of Registration *</label><dynamic-service-dropdown ng-model=editable.country_of_registration id=country-of-registration name=countryOfRegistration dropdown-type=single service=::countryManagementService is-required=::true ng-change=setLocal(editable.country_of_registration) options=\"item as (item.country_name | translate) for item in list.content track by item.id\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=country-override>Override Country of Registration</label><boolean-text ng-disabled=countryMatch name=countryOverride ng-model=editable.country_override class=form-control id=country-override ng-init=\"editable.country_override = false\"></boolean-text></div></div><div class=row><date-range control=control_coa is-required=::false format=\"{{ customDate }}\" start-name=\"Coa Issue Date\" end-name=\"Coa Expiry Date\"><!-- Datepickers --></date-range></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aircraft-service-date><span translate>Aircraft Service Date</span> <span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=aircraft-service-date name=aircraftServiceDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=editable.aircraft_service_date is-open=aircraftServiceDate.open ng-attr-title=\"{{editable.aircraft_service_date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"aircraftServiceDate.open = !aircraftServiceDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=is-local><span translate>Local</span></label><boolean-text name=isLocal ng-model=editable.is_local class=form-control id=is-local required></boolean-text></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><ng-include required src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler-sc.template.html\'\"></ng-include></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"form.$setUntouched(); reset()\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=\"form.$invalid || editable.account.id === null || editable.aircraft_type.id === null || editable.country_of_registration.id === null || !(editable.country_override || countryMatch) || !notification || !editable.uploaded_document_name\" ng-show=\"editable.id !== null && editable.sc_request_type !==\'delete\' || editable.id === null && editable.sc_request_id\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, control, control_coa); form.$setUntouched();\" convert-to-tons property=mtow_override>Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null && !editable.sc_request_type\" ng-disabled=!notification popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id)>Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-show=\"editable.id === null && !editable.sc_request_id\" ng-disabled=\"form.$invalid || !editable.uploaded_document_name || editable.account.id === null || editable.country_of_registration.id === null || editable.aircraft_type.id === null\" convert-to-tons property=mtow_override conversion-complete=\"create(convertedEditable || editable, control, control_coa); form.$setUntouched();\">Create</button></div></div></form></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'fighter-jet\'\" title=\"{{ \'Upload Aircraft Registrations\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\')\" ng-disabled=!editable.document_filename>Upload</button><upload-file-format format={{pattern}} mtow={{mtowUnitOfMeasure}} template=app/partials/aircraft-registration/aircraft-registration.template.html></upload-file-format></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-approval-request/sc-approval-request.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'unlock\'\" title=\"{{ \'Approval Request\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode === 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-3\"><label translate for=object-type>Object Type</label><select id=object-type class=form-control ng-change=refreshOverride() ng-model=objectType><option translate value=\"\"></option><option translate value=account>Account</option><option translate value=\"aircraft registration\">Aircraft Registration</option><option translate value=\"flight schedule\">Flight Schedule</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=account>Account</label><dynamic-service-dropdown ng-model=account id=account name=account dropdown-type=single service=::accountsService method=findAllMinimalReturn allow-empty=true ng-change=refreshOverride() options=\"item.id as item.name for item in list\"></dynamic-service-dropdown></div><div class=\"col-xs-6 col-md-3\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=status>Status</label><select id=status class=form-control ng-init=\"status = \'all\'\" ng-change=refreshOverride() ng-model=status><option translate value=all>All</option><option translate value=open>Open</option><option translate value=approved>Approved</option><option translate value=rejected>Rejected</option></select></div><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\' \"><!--Datepickers --></date-range></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=scApprovalRequestService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=\"text-center text-nowrap middle\">Select</th><th translate class=text-nowrap sort=status>Status</th><th translate class=text-nowrap sort=createdAt>Date/Time of Request</th><th translate class=text-nowrap sort=requestType>Request Type</th><th translate class=text-nowrap sort=requestDataset>Request Dataset</th><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap sort=user>User</th><th translate class=text-nowrap sort=objectId>Object Id</th><th translate class=text-nowrap sort=respondersName>Responders Name</th><th translate class=text-nowrap sort=responseDate>Response Date</th><th translate class=text-nowrap sort=responseText>Response Text</th></tr></thead><tbody><tr ng-click=\"edit(item); form.$setUntouched()\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-center><input ng-disabled=\"item.status !== \'open\'\" ng-click=getSelected() type=checkbox id=checkbox_{{item.id}} ng-model=selectedRequests[item.id]></td><td class=text-nowrap>{{ item.status | translate }}</td><td class=text-nowrap>{{ item.created_at | dateConverter : \'HHmm\' }}</td><td class=text-nowrap>{{ item.request_type | translate }}</td><td class=text-nowrap>{{ item.request_dataset | translate }}</td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.user.name }}</td><td class=text-nowrap>{{ item.object_id }}</td><td class=text-nowrap>{{ item.responders_name }}</td><td class=text-nowrap>{{ item.response_date | dateConverter : \'HHmm\' }}</td><td class=text-nowrap>{{ item.response_text | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Approval Request</td></tr></tbody></table></div><pagination-display></pagination-display><div ng-show=showErrorOnTableForm><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div><div class=row><div class=col-xs-12><button class=\"btn btn-primary btn-approve pull-left\" translate ng-disabled=\"!selected || !selected.length || !approvalResponse\" popup popup-text=\"Are you sure you want to approve this request(s)?\" popup-confirm=\"approveSelected(approvalResponse); form.$setUntouched();\">Approve</button><div class=col-xs-6><input id=approval-response name=approvalResponse class=form-control type=text ng-model=approvalResponse></div></div></div><div class=row><div class=col-xs-12><button class=\"btn btn-primary btn-reject pull-left\" translate ng-disabled=\"!selected || !selected.length || !rejectionResponse\" popup popup-text=\"Are you sure you want to reject this request(s)?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"rejectSelected(rejectionResponse); form.$setUntouched();\">Reject</button><div class=col-xs-6><input id=rejection-response name=rejectionResponse class=form-control type=text ng-model=rejectionResponse></div></div></div><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'unlock\'\" title=\"{{ \'Approval Request\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=account>{{ \'Account\' | translate }}</label><input id=account name=account class=form-control type=text ng-value=editable.account.name readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label for=user>{{ \'User\' | translate }}</label><input id=user name=user class=form-control type=text ng-value=editable.user.name required readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=created-at>{{ \'Date/Time of Request\' | translate }}</label><input id=created-at name=createdAt class=form-control type=text ng-value=date required readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label for=request-type>{{ \'Request Type\' | translate }}</label><input id=request-type name=requestType class=form-control type=text ng-value=\"editable.request_type | translate\" required readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=request-dataset>{{ \'Request Dataset\' | translate }}</label><input id=request-dataset name=requestDataset class=form-control type=text ng-value=\"editable.request_dataset | translate\" required readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label for=status>{{ \'Status\' | translate }}</label><input id=status name=status class=form-control type=text ng-value=\"editable.status | translate\" required readonly=readonly></div></div><div class=row ng-hide=\"editable.status === \'open\'\"><div class=\"col-xs-12 col-md-6\"><label for=responders-name>{{ \"Responders Name\" | translate }}</label><input id=responders-name name=respondersName class=form-control type=text ng-value=editable.responders_name readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label for=response-date>{{ \'Response Date and Time\' | translate }}</label><input id=response-date name=response-date class=form-control type=text ng-value=responseDate readonly=readonly></div></div><div class=row ng-hide=\"editable.status === \'open\'\"><div class=\"col-xs-12 col-md-12\"><label for=response-text>{{ \'Response Text\' | translate }}</label><input id=response-text name=responseText class=form-control type=text ng-value=editable.response_text readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><label for=request-text>{{ \'Request\' | translate }}:</label></div></div><div class=row><div class=\"col-xs-12 col-md-6\" ng-show=\"value !== null && key !== \'version\' && key !== \'id\'\" ng-repeat=\"(key, value) in requestText\"><div class=\"row col-xs-12\"><label class=text-capitalize>{{ formatNameAndTranslate(key) }}</label><input class=form-control type=text ng-value=\"value | translate\" readonly=readonly></div></div></div><div ng-show=showErrorOnDataForm><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div><div class=row ng-show=\"editable.id !== null && editable.status === \'open\'\"><div class=col-xs-12><button class=\"btn btn-primary btn-approve pull-left\" translate ng-disabled=\"form.$invalid || editable.status !== \'open\' || !approvalResponse\" popup popup-text=\"Are you sure you want to approve this request?\" popup-confirm=\"approve(editable, approvalResponse); form.$setUntouched();\">Approve</button><div class=\"col-xs-12 col-md-8\"><input id=approval-response name=approvalResponse class=form-control type=text ng-model=approvalResponse></div></div></div><div class=row ng-show=\"editable.id !== null && editable.status === \'open\'\"><div class=col-xs-12><button class=\"btn btn-primary btn-reject pull-left\" translate ng-show=\"editable.id !== null\" ng-disabled=\"form.$invalid || editable.status !== \'open\' || !rejectionResponse\" popup popup-text=\"Are you sure you want to reject this request?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"reject(editable, rejectionResponse); form.$setUntouched();\">Reject</button><div class=\"col-xs-12 col-md-8\"><input id=rejection-response name=rejectionResponse class=form-control type=text ng-model=rejectionResponse></div></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/sc-credit-payment/sc-credit-payment.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=credit-payment icon=\"\'credit-card\'\" title=\"{{ \'Credit Payment\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-2 pull-right\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=scCreditPaymentService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=transactionTime>Transaction Time</th><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap sort=requestorIp>Requestor IP</th><th translate class=text-nowrap sort=request>Request</th><th translate class=text-nowrap sort=response>Response</th><th translate class=text-nowrap sort=responseStatus>Response Status</th><th translate class=text-nowrap sort=responseDescription>Response Descrtiption</th></tr></thead><tbody><tr ng-click=edit(item) ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.transaction_time }}</td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.requestor_ip }}</td><td class=text-nowrap>{{ item.request }}</td><td class=text-nowrap>{{ item.response }}</td><td class=text-nowrap>{{ item.response_status }}</td><td class=text-nowrap>{{ item.response_description }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=7 translate>There are no credit payment transactions</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'credit-card\'\" title=\"{{ \'Make a payment\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12 ng-show=configurationWarning><div class=error-handling-container><div class=\"alert alert-dismissible alert-warning alert-icon\" role=alert><span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Credit Payment Configuration</strong><p translate>Cannot make a credit transaction because one or more credit configurations is invalid.</p></div></div></div></div><div class=row><div class=col-xs-12 ng-show=paymentSuccessMessage><div class=error-handling-container><div class=\"alert alert-dismissible alert-success alert-icon\" role=alert><button id=error_button type=button ng-click=\"paymentSuccessMessage = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Payment Success</strong><p>{{ payment[\'result-text\'] }}<br>Amount: ${{ payment.amount | abs }} USD<br>Confirmation: {{ payment[\'transaction-id\'] }}</p></div></div></div></div><div class=row><div class=col-xs-12 ng-show=paymentDeclinedMessage><div class=error-handling-container><div class=\"alert alert-dismissible alert-danger alert-icon\" role=alert><button id=error_button type=button ng-click=\"paymentDeclinedMessage = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Payment Declined</strong><p translate>{{ payment[\'result-text\'] }}</p></div></div></div></div><form novalidate action=# name=form onsubmit=\"return false\"><fieldset><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown allow-empty=true empty-to-null ng-model=account_id id=account name=account dropdown-type=single service=::scAccountManagementService method=getSCWhiteListAccounts required disabled=configurationWarning options=\"account.id as account.name for account in list track by account.id\" ng-change=\"sendNonSensitiveDataToCreditGateway(payment_amount, account_id)\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=payment-amount>Payment Amount (USD) *</label><input ng-disabled=configurationWarning id=payment-amount name=paymentAmount type=number class=form-control ng-model=payment_amount ng-model-options=\"{ debounce: 500 }\" ng-change=\"sendNonSensitiveDataToCreditGateway(payment_amount, account_id)\" min=1 required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form><br><form action=\"{{ trustSrc(formUrl) }}\" method=post name=paymentForm><!-- \n                        For tesing, use the following values\n                        4111111111111111\n                        1025 \n                        999 \n                    --><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=credit-card-number>Credit Card Number *</label><i class=\"fa fa-cc-discover fa-2x pull-right\" aria-hidden=true></i> <i class=\"fa fa-cc-amex fa-2x pull-right\" aria-hidden=true></i> <i class=\"fa fa-cc-mastercard fa-2x pull-right\" aria-hidden=true></i> <i class=\"fa fa-cc-visa fa-2x pull-right\" aria-hidden=true></i> <input ng-disabled=!formUrl id=credit-card-number name=billing-cc-number class=form-control ng-model=cc only-numbers required></div><div class=\"col-xs-12 col-md-6\"><label translate for=expiration-date>Expiration Date *</label><input ng-disabled=!formUrl placeholder=MMYY id=expiration-date name=billing-cc-exp class=form-control ng-model=cc_exp only-numbers maxlength=4 required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=cvv>CVV *</label><input ng-disabled=!formUrl id=cvv name=cvv class=form-control ng-model=cc_cvv only-numbers maxlength=4 minlength=3 required></div><div class=\"col-xs-12 col-md-6\" ng-show=formUrl><h6><strong>Total: ${{ amountToBePaid }} USD</strong></h6></div></div><div class=row><div class=col-xs-12><input class=\"btn btn-primary pull-right\" ng-disabled=\"!formUrl || paymentForm.$invalid\" type=submit value=Submit></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></form></div></div></div></div>");
$templateCache.put("app/partials/sc-flight-cost-calculation/sc-flight-cost-calculation.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header icon=\"\'calculator\'\" title=\"Flight Cost Calculation\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-4\"><label for=aircraft-type><span translate>Aircraft Type</span> *</label><dynamic-service-dropdown ng-model=editable.aircraft_type dropdown-type=single service=::aircraftTypeManagementService options=\"item.aircraft_type as item.aircraft_type for item in list.content\" required></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-4\"><label for=registration-number><span translate>Registration Number</span></label><input id=registration-number name=registration-number maxlength=20 ng-pattern=/^[a-zA-Z0-9]*$/ class=form-control type=text ng-model=editable.registration_number uppercase-input></div><div class=\"col-xs-12 col-md-4\"><label for=speed><span translate>Speed</span> (Knnnn/Nnnnn/Mnnn) <span ng-show=\"editable.dep_aerodrome === editable.dest_aerodrome && editable.dep_aerodrome !== null\">*</span></label><input id=speed name=speed maxlength=5 minlength=4 ng-pattern=/^([kK][0-9]{4})|([mM][0-9]{3})|([nN][0-9]{4})$/ class=form-control type=text ng-model=editable.speed ng-required=\"editable.dep_aerodrome && editable.dest_aerodrome && editable.dep_aerodrome === editable.dest_aerodrome ? true : false\" uppercase-input></div></div><div class=row><div class=\"col-xs-12 col-md-4\"><label for=estimated-elapsed-time><span translate>Estimated Elapsed Time </span>(<span tranlate>HHmm</span>) <span ng-show=\"editable.dep_aerodrome === editable.dest_aerodrome && editable.dep_aerodrome !== null\">*</span></label><input id=estimated-elapsed-time name=estimated-elapsed-time class=form-control type=text minlength=4 maxlength=4 ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers ng-model=editable.estimated_elapsed_time ng-required=\"editable.dep_aerodrome && editable.dest_aerodrome && editable.dep_aerodrome === editable.dest_aerodrome ? true : false\"></div><div class=\"col-xs-12 col-md-4\"><label for=dep-aerodrome><span translate>Departure_Aerodrome</span> *</label><input id=dep-aerodrome name=dep-aerodrome class=form-control maxlength=4 only-letters type=text ng-model=editable.dep_aerodrome uppercase-input required></div><div class=\"col-xs-12 col-md-4\"><label for=dest-aerodrome><span translate>Destination_Aerodrome</span> *</label><input id=dest-aerodrome name=dest-aerodrome class=form-control maxlength=4 only-letters type=text ng-model=editable.dest_aerodrome uppercase-input></div></div><div class=row><div class=col-xs-12><label for=route><span translate>Route</span> *</label><input id=route name=route class=form-control type=text ng-model=editable.route uppercase-input required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button ng-disabled=false class=\"btn btn-primary btn-reset\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || !showButton\" ng-click=\"calculate(editable); form.$setUntouched();\">Calculate</button></div></div></form><!-- Recaptcha Widget --><div class=row><div class=col-xs-12><recaptcha ng-class=\"{\'disabled-captcha\': form.$invalid}\"></recaptcha></div></div></div></div></div><div class=\"col-xs-12 col-md-12 margin-top-20\" ng-show=cost><div class=box-container><div class=box-content><div class=row><div class=col-xs-12><span class=\"btn btn-xs pull-right\" ng-click=\"cost = false\">X</span><h5><span class=col-md-4 translate>Flight Summary</span></h5><br><span class=col-md-2 translate>Aircraft Type</span><span>{{ cost.aircraft_type }}</span><br><span ng-if=cost.item18_reg_num><span class=col-md-2 translate>Registration Number</span><span>{{ cost.item18_reg_num }}</span><br></span><span ng-if=cost.cruising_speed_or_mach_number><span class=col-md-2 translate>Speed</span><span>{{ cost.cruising_speed_or_mach_number }}</span><br></span><span ng-if=cost.estimated_elapsed_time><span class=col-md-2 translate>Estimated Elapsed Time</span><span>{{ cost.estimated_elapsed_time }}</span><br></span><span class=col-md-2 translate>Departure Aerodrome</span><span>{{ cost.dep_ad }}</span><br><span class=col-md-2 translate>Destination Aerodrome</span><span>{{ cost.dest_ad }}</span><br><span class=col-md-2 translate>Route</span><span>{{ cost.fpl_route }}</span><br><br></div><div class=col-xs-12 ng-show=!noBillableRoute><h5><span class=col-md-3 translate>Cost Calculation</span></h5><br><span class=col-md-2>{{ \'Actual distance\' | translate }}&nbsp;({{ distanceUnitOfMeasure | translate }})</span> <span>{{ cost.fpl_crossing_distance | distanceConverter | number : \'2\' }}</span><br><span class=col-md-2>{{ \'Total distance to pay\' | translate }}&nbsp;({{ distanceUnitOfMeasure | translate }})</span> <span>{{ cost.billable_crossing_dist | distanceConverter | number : \'2\' }}</span><br><span class=col-md-2>{{ \'MTOW\' | translate }}&nbsp;({{ mtowUnitsOfMeasure | translate }})</span> <span>{{ cost.actual_mtow | weightConverter }}</span><br><span class=col-md-2>{{ \'ADAP charges\' | translate }} ({{ \'USD\' | translate }})</span> <span>{{ adapCharges | number : \'2\' }}</span><br><span class=col-md-2>{{ \'Enroute charges\' | translate }} ({{ \'USD\' | translate }})</span> <span>{{ cost.enroute_charges | number : \'2\' }}</span><br><span class=col-md-2>{{ \'Total flight cost\' | translate }} ({{ \'USD\' | translate }})</span> <span>{{ totalCostUSD | number : \'2\' }}</span><br><span ng-if=totalCostAnsp><span class=col-md-2>{{ \'Total flight cost\' | translate }}&nbsp;({{ anspCurrency }})</span> <span>{{ totalCostAnsp | number : \'2\' }}</span></span></div><div class=col-xs-12 ng-show=noBillableRoute><h5><span class=col-md-3 translate>No billable route</span></h5></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-flight-schedules/sc-flight-schedules.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'calendar\'\" title=\"{{ \'Flight Schedules\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-4\"><label translate for=account>Account</label><select ng-model=accountId id=account name=account class=form-control ng-change=refreshOverride() ng-options=\"item.id as item.name for item in accountsWithFlightSchedules\"></select></div><div class=\"col-xs-12 col-md-4\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=scFlightSchedulesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=activeIndicator>Active</th><th translate class=text-nowrap sort=flightServiceNumber>Flight Service Number</th><th translate class=text-nowrap sort=depAd>Dep Ad</th><th translate class=text-nowrap sort=depTime>Dep Time</th><th translate class=text-nowrap sort=destAd>Dest Ad</th><th translate class=text-nowrap sort=destTime>Dest Time</th><th translate class=text-nowrap sort=dailySchedule>Daily Schedule</th><th translate class=text-nowrap sort=selfCare>Self-Care</th><th translate class=text-nowrap sort=startDate>Start Date</th><th translate class=text-nowrap sort=endDate>End Date</th><th class=text-nowrap translate ng-show=\"needAdminApproval && hasPermission(\'self_care_access\')\">Status</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item); editable.index = $index\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.index === $index}\"><td class=\"text-nowrap text-capitalize\">{{ item.active_indicator | translate }}</td><td class=text-nowrap>{{ item.flight_service_number }}</td><td class=text-nowrap>{{ item.dep_ad }}</td><td class=text-nowrap>{{ item.dep_time }}</td><td class=text-nowrap>{{ item.dest_ad }}</td><td class=text-nowrap>{{ item.dest_time }}</td><td class=text-nowrap>{{ formatDailySchedules( item.daily_schedule, \',\' ) }}</td><td class=\"text-nowrap text-capitalize\">{{ item.self_care | translate }}</td><td class=text-nowrap>{{ item.start_date | dateConverter }}</td><td class=text-nowrap>{{ item.end_date | dateConverter }}</td><td class=text-nowrap ng-show=\"needAdminApproval && hasPermission(\'self_care_access\')\">{{ setStatus(item) | translate }}</td></tr><tr ng-show=!list.length><td translate class=text-center colspan=11>There are no Flight Schedules data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div ng-show=!toggle class=\"row col-xs-12\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div><div class=\"row margin-top-20\"><div ng-class=\"{\'col-md-6 col-split-xs-6\': toggle, \'col-xs-3\': !toggle}\" ng-show=\"editable.missing_flight_movements.length > 0\"><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Missing Flights\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th class=text-nowrap><span translate>Flight</span>&nbsp; {{ editable.flight_service_number }}</th></tr></thead><tbody><tr ng-repeat=\"flightmovement in editable.missing_flight_movements\"><td class=text-nowrap>{{ flightmovement.date_of_flight | dateConverter }}</td></tr></tbody></table></div></div></div></div></div></div><div ng-class=\"{\'col-md-6 col-split-xs-6\': toggle, \'col-xs-3\': !toggle}\" ng-show=\"editable.unexpected_flights.length > 0\"><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Unexpected Flights\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th class=text-nowrap><span translate>Flight</span>&nbsp; {{ editable.flight_service_number }}</th></tr></thead><tbody><tr ng-repeat=\"flightmovement in editable.unexpected_flights\"><td class=text-nowrap>{{ flightmovement.date_of_flight | dateConverter }}</td></tr></tbody></table></div></div></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Create a Flight Schedule\' | translate }}\" ng-show=\"editable.id === null\"></box-header><box-header icon=\"\'plane\'\" title=\"{{ \'Edit a Flight Schedule\' | translate }}\" ng-show=\"editable.id !== null\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account name=accountId dropdown-type=single service=::scAccountManagementService method=getSCActiveAccounts is-required=::true options=\"item as item.name for item in list track by item.name\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight-service-number>Flight Service Number *</label><input id=flight-service-number name=flightServiceNumber class=form-control type=text ng-model=editable.flight_service_number uppercase-input required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=dep-ad>Departure Aerodrome *</label><input id=dep-ad name=depAd class=form-control type=text ng-model=editable.dep_ad aerodrome-identifiers minlength=4 ng-trim=false required></div><div class=\"col-xs-12 col-md-6\"><label translate for=destination-aerodrome>Destination Aerodrome *</label><input id=destination-aerodrome name=destAd class=form-control type=text ng-model=editable.dest_ad aerodrome-identifiers minlength=4 ng-trim=false required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=dep-time>Departure Time *</label><input id=dep-time name=depTime class=form-control type=text ng-model=editable.dep_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.dep_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div><div class=\"col-xs-12 col-md-6\"><label translate for=dest-time>Destination Time *</label><input id=dest-time name=destTime class=form-control type=text ng-model=editable.dest_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.dest_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=daily-schedule>Daily Schedule *</label><multiselect events=\"{ onSelectionChanged: addDaysToSchedule }\" translated-value=name extra-settings=\"{ displayProp: \'name\', idProp: \'name\', externalIdProp: \'\' }\" options=listOfDays id=daily-schedule is-required=true name=days model=days></multiselect></div><div class=\"col-xs-12 col-md-6\"><label translate for=active>Active *</label><select id=active name=active class=form-control ng-model=editable.active_indicator required><option translate value=active>active</option><option translate value=inactive>inactive</option></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=start_date>Start Date *</label><p class=input-group><date-picker id=start_date name=startDate type=text ng-change=\"dateChanged(\'start\', editable.start)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.start_date is-open=startDate.open ng-attr-title=\"{{editable.start ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDate.open = !startDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label translate for=end-date>End Date</label><p class=input-group><date-picker id=end_date name=endDate type=text ng-change=\"dateChanged(\'end\', editable.end)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.end_date is-open=endDate.open ng-attr-title=\"{{editable.end ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDate.open = !endDate.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=self-care>Created by Self-Care</label><input id=self-care name=selfCare class=\"form-control text-capitalize\" ng-value=\"editable.self_care | translate\" readonly=readonly></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || editable.daily_schedule === null || editable.daily_schedule === \'\'\" ng-show=\"editable.id === null && !editable.sc_request_id\" ng-click=\"create(editable); form.$setUntouched(); reset();\">Create</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=form.$invalid ng-show=\"editable.id !== null && editable.sc_request_type !==\'delete\' || editable.id === null && editable.sc_request_id\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched(); reset();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.self_care && editable.id !== null && !editable.sc_request_type\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button></div></div></form></div></div><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Upload a Flight Schedule\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=\"col-xs-12 col-md-6 schedule-start-date\"><label translate for=start>Start Date *</label><p class=input-group><date-picker ng-init=\"start = null\" id=start name=start type=text ng-change=\"dateChanged(\'start\', start)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=start is-open=start.open ng-attr-title=\"{{start ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"start.open = !start.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=\"preUploadSchedules(start.toISOString(), editable.document)\" ng-disabled=\"!editable.document_filename || !start\">Upload</button><upload-file-format format={{pattern}} template=app/partials/flight-schedule-management/flight-schedule-management.template.html></upload-file-format></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-flight-search/sc-flight-search.html","<div class=row><div class=col-xs-12><div class=box-container><box-header icon=\"\'plane\'\" title=\"{{ \'Flight Search\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=flight-id-filter>Flight Id</label><input id=flight-id-filter class=form-control type=text ng-model=flightIdFilter empty-to-null uppercase-input ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-3\"><label translate for=icao-code-filter>ICAO Code</label><input id=icao-code-filter class=form-control type=text ng-model=icaoCodeFilter empty-to-null uppercase-input ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-6 col-md-3\"><label translate for=account-filter>Account</label><dynamic-service-dropdown ng-model=accountFilter id=account-filter dropdown-type=single allow-empty=true service=::scAccountManagementService is-required=false method=getSCAccounts options=\"item.id as (item.name | translate) for item in list\" ng-change=refreshOverride()></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><button ng-click=refreshOverride() class=\"btn btn-primary pull-right\" translate>Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format=\"{{ customDate }}\" ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\'\"><!--Datepickers --></date-range></div></div><div class=row ng-if=\"accountFilter && accountBalance\"><div class=col-xs-12><label for=account-balance><strong>{{\'Account balance\' | translate}}:</strong></label><strong>{{accountBalance}}</strong></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true sort-query-string=getSortQueryString() service=scFlightSearchService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th class=text-nowrap sort=accountName>{{\'Account\' | translate}}</th><th class=text-nowrap sort=item18RegNum>{{\'Registration Number\' | translate}}</th><th class=text-nowrap sort=flightId>{{\'Flight Id\' | translate}}</th><th class=text-nowrap sort=dateOfFlight>{{\'Date of Flight\' | translate}}</th><th class=text-nowrap sort=status>{{\'Status\' | translate}}</th><th class=text-nowrap sort=depTime>{{\'Departure Time\' | translate}}</th><th class=text-nowrap sort=depAd>{{\'Departure_Aerodrome\' | translate}}</th><th class=text-nowrap sort=destAd>{{\'Destination_Aerodrome\' | translate}}</th><th class=text-nowrap>{{\'Flight Movement Cost\' | translate}} ({{\'USD\' | translate}})</th><th class=text-nowrap sort=flightNotes>{{\'Flight Notes\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.account_name }}</td><td class=text-nowrap>{{ item.item18_reg_num }}</td><td class=text-nowrap>{{ item.flight_id }}</td><td class=text-nowrap>{{ item.date_of_flight | dateConverter }}</td><td class=text-nowrap>{{ item.status }}</td><td class=text-nowrap>{{ item.dep_time }}</td><td class=text-nowrap>{{ item.dep_ad }}</td><td class=text-nowrap>{{ item.dest_ad }}</td><td class=text-nowrap>{{ item.total_charges_usd | number: 2}}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!list.length><td class=text-center translate colspan=10>There are no Flight data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-home-page/sc-home-page.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header icon=\"\'home\'\" title=Welcome></box-header><div class=box-content><div class=row><div class=\"col-sm-12 col-md-4\"><img alt=\"CAA Botswana\" src=assets/images/logo.png></div><div class=\"col-sm-12 col-md-4 text-center\"><h1><bold translate>Welcome</bold></h1><h3 translate>to the ARMS Self-Care Portal</h3></div><div class=\"col-sm-12 col-md-1 col-md-offset-3\"></div></div></div></div></div><div class=\"col-xs-12 margin-top-20\"><div class=box-container><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-md-4 col-md-offset-4\"><a ng-hide=\"loginFromBilling === false\" class=\"btn btn-primary btn-block\" ui-sref=main.sc-login translate>Login </a><a class=\"btn btn-primary btn-block\" ui-sref=main.sc-query-submission translate>Query Submission </a><a ng-hide=\"loginFromBilling === false\" class=\"btn btn-primary btn-block\" ui-sref=main.sc-user-registration translate>User Registration </a><a class=\"btn btn-primary btn-block\" ui-sref=main.sc-flight-cost-calculation translate>Flight Cost Calculation</a></div></div><div class=row></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-inactivity-expiry-notice/sc-inactivity-expiry-notice.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'exclamation-circle\'\" title=\"{{ \'Inactivity and Expiry Notices\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode === 13 && refreshOverride()\"></div><div class=\"col-xs-6 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=scInactivityExpiryNoticeService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap sort=noticeType>Notice Type</th><th translate class=text-nowrap sort=dateTime>Date/Time</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); editOverride(item);\" ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.notice_type | translate }}</td><td class=text-nowrap>{{ item.date_time | dateConverter : \'HH:mm\' }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=3 translate>There are no Inactivity or Expiry Notices</td></tr></tbody></table></div><pagination-display></pagination-display><div ng-show=showErrorOnTableForm><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'unlock\'\" title=\"{{ \'Approval Request\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=account>{{ \'Account\' | translate }}</label><input id=account name=account class=form-control type=text ng-model=editable.account.name readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label for=notice-type>{{ \'Notice Type\' | translate }}</label><input id=notice_type name=noticeType class=form-control type=text ng-value=noticeType readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=date-time>{{ \'Date/Time of Notice\' | translate }}</label><input id=date_time name=dateTime class=form-control type=text ng-value=dateTime readonly=readonly></div></div><div class=row><div class=col-xs-12><label for=message-text>{{\'Message Text\' | translate}}</label><textarea id=message_text name=messageText class=form-control type=text ng-model=editable.message_text readonly=readonly>\n                            </textarea></div></div><div ng-show=showErrorOnDataForm><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></form></div></div></div></div>");
$templateCache.put("app/partials/sc-invoices/sc-invoices.html","<div class=row><div class=col-xs-12><div class=box-container><box-header icon=\"\'book\'\" title=\"{{ \'Invoices\' | translate }}\"></box-header><div class=box-content><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-4><label translate for=account-filter>Account</label><dynamic-service-dropdown ng-model=accountFilter id=account-filter dropdown-type=single allow-empty=true service=::scAccountManagementService is-required=false method=getSCAccounts options=\"item.id as item.name for item in list track by item.name\" ng-change=refresh()></dynamic-service-dropdown></div><div class=col-xs-2><label translate for=filter>Invoice Status</label><select id=filter class=form-control ng-model=filter ng-change=refresh()><option translate value=\"\"></option><option translate value=unapproved>Unapproved Invoices</option><option translate value=unpublished>Unpublished Invoices</option><option translate value=unpaid>Unpaid Invoices</option><option translate value=overdue>Overdue Invoices</option><option translate value=paid>Paid Invoices</option><option translate value=void>Void Invoices</option></select></div><div class=\"col-xs-12 col-md-6 col-lg-2\" ng-show=\"hasPermission(\'self_care_admin\')\"><label translate for=user-filter>User</label><select id=user-filter class=form-control empty-to-null ng-model=userFilter ng-change=refresh() ng-options=\"item.id as item.name for item in usersList\"><option translate value=\"\"></option></select></div><div class=\"col-xs-12 col-md-6 col-lg-2\"><label translate for=billing-centre>Billing Centre</label><dynamic-service-dropdown ng-model=billingCentreFilter id=billing-centre dropdown-type=single allow-empty=true service=::billingCentreManagementService is-required=false method=findAllMinimalReturn options=\"item.id as item.name for item in list\" ng-change=refresh()></dynamic-service-dropdown></div><div ng-class=\"{\'col-md-4\': !hasPermission(\'self_care_admin\'), \'col-md-2\' : hasPermission(\'self_care_admin\')}\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><!-- invoices data grid filters --><div class=row><div class=col-xs-4><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6 col-lg-2\"><label translate for=flight-id>Flight Id/Registration Number</label><input id=flight-id class=form-control type=text empty-to-null ng-model=flightIdOrRegistration uppercase-input ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=col-xs-4><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refresh() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refresh() : \'\'\"><!--Datepickers --></date-range></div></div><div class=row><div class=col-xs-12><div id=invoices class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=scInvoicesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh() grid-pages=10><thead><tr><th translate>Actions</th><th translate sort=account.name>Account</th><th translate sort=invoiceNumber>Invoice Number</th><th translate sort=invoicePeriodOrDate>Invoice Date</th><th translate sort=invoiceType>Invoice Type</th><th translate sort=invoiceStateType>Status</th><th translate sort=paymentDueDate>Payment Due Date</th><th translate sort=user.name>Created By</th><th translate sort=invoiceAmount class=text-right>Invoice Amount</th><th translate sort=invoiceCurrency.currencyCode>Invoice Currency</th><th translate class=\"text-nowrap text-right\" sort=invoiceExchangeToUsd>Exchange USD</th><th translate sort=invoiceDateOfIssue>Invoice Date of Issue</th><th translate sort=billingCentre.name>Billing Centre</th><th translate sort=exported>Exported</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td class=text-center><download-oauth2 url=/billing-ledgers/{{item.id}}/download? error=error></download-oauth2></td><td class=underline>{{ item.account.name }}</td><td class=text-nowrap>{{ item.invoice_number }}</td><td class=text-nowrap>{{ item.invoice_period_or_date | dateConverter}}</td><td class=text-nowrap>{{ item.invoice_type.replace(\'-\', \'_\').toUpperCase() | translate }}</td><td>{{ item.invoice_state_type | translate }}</td><td>{{ item.payment_due_date | dateConverter }}</td><td>{{ item.user }}</td><td class=text-right>{{ item.invoice_amount | number: 2 }}</td><td>{{ item.invoice_currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item.invoice_exchange : item.invoice_exchange) | evenRound: 5 | number: 5}}</td><td>{{ item.invoice_date_of_issue | dateConverter }}</td><td class=text-nowrap>{{ item.billing_center.name }}</td><td>{{ item.exported | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=14 translate>There are no Invoices data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div ng-show=\"editable.id && lineItems && editable.invoice_type === \'non-aviation\'\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=\"{{ \'Invoice Line Items\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!lineItems.length || lineItems === undefined\"><span translate>There are no Line Items related to this invoice</span></div><div ng-if=\"lineItems.length > 0\"><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Amount</th><th translate class=text-nowrap>Category</th><th translate class=text-nowrap>Charge Class</th><th translate class=text-nowrap>Description</th></tr></thead><tbody><tr ng-repeat=\"item in lineItems\"><td class=\"text-nowrap text-right\">{{ item.amount | number: 2 }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.category }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.charge_class }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.description }}</td></tr></tbody></table></div></div></div></div></div></div><div ng-show=\"editable.id !== null && listTransactionPayments !== null\" class=\"box-container margin-top-20\"><box-header icon=\"\'exchange\'\" title=\"{{ \'Transaction Payments\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!listTransactionPayments.length || listTransactionPayments === undefined\"><span translate>There are no Transaction Payments related to this invoice</span></div><div ng-if=\"listTransactionPayments.length > 0\"><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Amount</th><th translate class=text-nowrap>Invoice Number</th><th translate class=text-nowrap>Currency</th><th translate class=text-nowrap>Exchange USD</th><th translate class=text-nowrap>Exchange ANSP</th><th translate class=text-nowrap>Account Credit</th></tr></thead><tbody><tr ng-repeat=\"item in listTransactionPayments\"><td class=\"text-nowrap text-right\">{{ item.amount | abs | number: 2 }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_number }}</td><td class=\"text-nowrap text-right\">{{ item.currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5}}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-nowrap translate>{{ item.is_account_credit }}</td></tr></tbody></table></div></div></div></div></div></div><div ng-show=\"editable.id !== null && listTransactionPayments !== null\" class=\"box-container margin-top-20\"><box-header icon=\"\'exchange\'\" title=\"{{ \'Transactions\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!listTransactionPayments.length || !listTransactionPayments\"><span translate>There are no Transactions related to this invoice</span></div><div ng-if=listTransactionPayments.length><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Receipt</th><th translate class=text-nowrap>Account</th><th translate class=text-nowrap>Date/Time</th><th translate class=text-nowrap>Description</th><th translate class=text-nowrap>Type</th><th translate class=\"text-nowrap text-right\">Amount</th><th translate class=text-nowrap>Currency</th><th translate class=\"text-nowrap text-right\">Exchange USD</th><th translate class=\"text-nowrap text-right\">Exchange ANSP</th><th translate class=\"text-nowrap text-right\">Balance</th><th translate class=\"text-nowrap text-right\">Payment Reference Number</th><th translate class=\"text-nowrap text-right\">Payment Mechanism</th><th translate class=text-nowrap>Exported</th></tr></thead><tbody><tr ng-repeat=\"item in listTransactionPayments\"><td class=text-center><download-oauth2 url=\"/reports/transaction-receipt?transactionId={{item.transaction.id}}\" error=error></download-oauth2></td><td class=text-nowrap>{{item.transaction.account.name}}</td><td>{{ item.transaction.transaction_date_time | dateConverter: \'HHmm\' }}</td><td class=word-break-break-all>{{ item.transaction.description }}</td><td translate>{{ item.transaction.transaction_type.name }}</td><td class=text-right>{{ item.transaction.amount }}</td><td>{{ item.transaction.currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item.transaction.exchange_rate : item.transaction.exchange_rate) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ (inverseExchange ? item.transaction.exchange_rate_to_ansp : 1 / item.transaction.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ item.transaction.balance }}</td><td>{{ item.transaction.payment_reference_number }}</td><td translate>{{ item.transaction.payment_mechanism }}</td><td translate>{{ item.transaction.exported }}</td></tr></tbody></table></div></div></div></div></div></div><div ng-show=\"editable.id !== null && listFlightMovements !== null && editable.invoice_type !== \'non-aviation\'\" class=\"box-container margin-top-20\"><box-header icon=\"\'plane\'\" title=\"{{ \'Flight Movements\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!listFlightMovements.content.length || !listFlightMovements.content\"><span translate>There are no Flight Movements related to this invoice</span></div></div><div ng-if=\"listFlightMovements.content.length > 0\"><flight-movement-table><!-- Flight Movement Table --></flight-movement-table></div><div class=col-xs-12><ul uib-pagination total-items=listFlightMovements.total_elements ng-change=\"getFlightMovementsByInvoiceId(editable.id, listFlightMovements.number)\" max-size=::20 items-per-page=listFlightMovements.size ng-model=listFlightMovements.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-login/sc-login.html","<div id=page-sc-login><div class=container-fluid><div class=row><div class=\"col-xs-push-0 col-xs-12 col-sm-10 col-sm-push-1 col-md-8 col-md-push-2 col-lg-6 col-lg-push-3\"><form ng-show=!recoveryForm novalidate name=loginForm onsubmit=\"return false\" class=box-container><div class=form-group><label for=username translate>Username</label><input ng-model=user.username type=text class=form-control id=username></div><div class=form-group><label for=password translate>Password</label><input ng-model=user.password type=password ng-paste=$event.preventDefault(); class=form-control id=password></div><div class=\"form-group text-center\"><button ng-disabled=\"loginForm.$invalid || !user.username || !user.password || timeoutDelay > 0 || !showButton\" ng-click=\"submit(user.username, user.password)\" type=submit class=\"btn btn-primary\" translate>SIGN IN</button></div><!-- Recaptcha Widget --><recaptcha class=form-group></recaptcha><div class=form-group ng-show=\"warning || timeoutDelay > 0\"><uib-alert ng-show=timeoutDelay type=warning ng-click=\"warning = false\"><span translate>A number of failed attempts have occurred. Please wait</span> <span>{{ timeoutDelay }}</span> <span translate>seconds to retry</span></uib-alert></div><div class=form-group ng-show=error><uib-alert ng-show=\"error === 400 || error === 401\" translate>Invalid username and/or password. Please try again</uib-alert><uib-alert ng-show=\"error !== 400 && error !== 401\">{{ offlineServerError }}</uib-alert></div><div class=form-group ng-show=browserWarning><div class=\"alert alert-dismissible alert-danger alert-icon\" role=alert><button id=browser-warning type=button ng-click=\"browserWarning = false\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <span translate>Unsupported browser detected. For the best experience, use:</span><span> Chrome(>52), Firefox(>47), Edge</span></div></div><div><button translate type=button class=\"btn-link link btn-forgot-password\" ng-click=passwordRecoveryForm()>Forgot password?</button></div></form><!-- Recovery password form --><form ng-show=recoveryForm novalidate name=loginForm onsubmit=\"return false\" class=box-container><div class=form-group ng-show=!tempPaswordSent><label for=email translate>Please enter you email</label><input ng-model=email type=text class=form-control id=email autocomplete=off></div><div class=\"form-group text-center\" ng-show=!tempPaswordSent><button ng-click=recoverPassword(email) type=submit class=\"btn btn-primary\" ng-disabled=!email translate>Next</button> <button ng-click=closeRecoveryForm() type=submit class=\"btn btn-primary\" translate>Cancel</button></div><div class=\"form-group text-center\" ng-show=tempPaswordSent translate>The temporary password has been sent to your email. Please update your password when you login.</div><div class=\"form-group text-center\" ng-show=tempPaswordSent><button ng-click=showLogin() type=submit class=\"btn btn-primary\" translate>Login</button></div><div ng-show=error><uib-alert ng-show=error translate>{{ error.error.error_description ? error.error.error_description : error.error.error }}</uib-alert></div></form></div></div></div></div>");
$templateCache.put("app/partials/sc-passenger-service-charge-return/sc-passenger-service-charge-return.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=flight-data.passenger-service-charge-return-management icon=\"\'retweet\'\" title=\"{{ \'Passenger Service Charge Return\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-5\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-10 col-md-5\"><label translate for=charge-returns>Service Charge Returns</label><select id=charge-returns ng-init=\"chargeReturnFilter = \'false\'\" class=form-control ng-change=refresh() ng-model=chargeReturnFilter><option translate value=false>All</option><option translate value=true>Orphan</option></select></div><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=scPassengerServiceChargeReturnService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh() canned-sort=cannedSort><thead><tr><th translate class=\"text-nowrap text-center\">Action</th><th translate class=text-nowrap sort=flightId>Flight Id</th><th translate class=text-nowrap sort=account>Account</th><th translate class=text-nowrap sort=dayOfFlight>Day of Flight</th><th translate class=text-nowrap sort=departureTime>Dep Time</th><th translate class=\"text-nowrap text-right\" sort=joiningPassengers>Join Pass</th><th translate class=\"text-nowrap text-right\" sort=transitPassengers>Trans Pass</th><th translate class=\"text-nowrap text-right\" sort=chargeableItlPassengers>Charge Int Pass</th><th translate class=\"text-nowrap text-right\" sort=chargeableDomesticPassengers>Charge Dom Pass</th><th translate class=\"text-nowrap text-right\" sort=children>Children</th><th translate class=\"text-nowrap text-right\" sort=createdBySelfCare>Self-Care</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-center><download-oauth2 ng-show=item.has_image url=\"sc-passenger-service-charge-return/{{ item.id }}/image\"></download-oauth2></td><td class=text-nowrap>{{ item.flight_id }}</td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.day_of_flight | dateConverter }}</td><td class=text-nowrap>{{ item.departure_time }}</td><td class=text-right>{{ item.joining_passengers }}</td><td class=text-right>{{ item.transit_passengers }}</td><td class=text-right>{{ item.chargeable_itl_passengers }}</td><td class=text-right>{{ item.chargeable_domestic_passengers }}</td><td class=text-right>{{ item.children }}</td><td class=text-right>{{ item.created_by_self_care }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=11 translate>There are no Passenger Service Charge Return data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=row><div class=col-xs-12><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'retweet\'\" title=\"{{ \'Create a Passenger Service Charge Return\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'retweet\'\" title=\"{{ \'Edit a Passenger Service Charge Return\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset><div class=row><div class=\"col-xs-12 col-md-6\"><label for=flight-id>{{ \'Flight Identifier\' | translate }} *</label><input id=flight-id name=flightId class=form-control type=text ng-model=editable.flight_id maxlength=10 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input required></div><div class=\"col-xs-12 col-md-6\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account id=account name=account dropdown-type=single service=::scAccountManagementService method=getSCActiveAccounts is-required=::true options=\"account as account.name for account in list track by account.id\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=day-of-flight>{{ \'Day of Flight\' | translate }} ({{ dateFormat | translate }}) *</label><p class=input-group><date-picker id=day-of-flight type=text name=dayOfFlight pad-hours=true show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.day_of_flight is-open=expiry.open close-text=Close ng-attr-title=\"{{editable.day_of_flight ? \'\' : \'Please fill out this field\' | translate}}\" required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"expiry.open = !expiry.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=departure_time>{{ \'Departure Time\' | translate }} ({{ \'HHmm\' | translate}})</label><input id=departure_time class=form-control name=departureTime type=text minlength=4 maxlength=4 ng-model=editable.departure_time ng-attr-title=\"{{editable.departure_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ ></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=joining-passengers>{{ \'Joining Passengers\' | translate }}</label><input id=joining-passengers name=joiningPassengers class=form-control min=0 type=number ng-model=editable.joining_passengers pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=transit-passengers>{{ \'Transit Passengers\' | translate }}</label><input id=transit-passengers name=transitPassengers class=form-control min=0 type=number ng-model=editable.transit_passengers pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=chargeable-international>{{ \'Chargeable International Passengers\' | translate }}</label><input id=chargeable-international name=chargeableItlPassengers class=form-control min=0 type=number ng-model=editable.chargeable_itl_passengers pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=chargeable-domestic>{{ \'Chargeable Domestic Passengers\' | translate }}</label><input id=chargeable-domestic name=chargeableDomesticPassengers class=form-control min=0 type=number ng-model=editable.chargeable_domestic_passengers pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=children>{{ \'Children\' | translate }}</label><input id=children name=children class=form-control type=number min=0 ng-model=editable.children pattern=\\d+></div></div><div ng-show=extendedPassengerInformation><div class=row><div class=\"col-xs-12 col-md-6\"><label for=arriving-pax-domestic-airport>{{ \'Arriving Passengers At Domestic Airport\' | translate }}</label><input id=arriving-pax-domestic-airport name=arrivingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.arriving_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=landing-pax-domestic-airport>{{ \'Landing Passengers At Domestic Airport\' | translate }}</label><input id=landing-pax-domestic-airport name=landingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.landing_pax_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=transfer-pax-domestic-airport>{{ \'Transfer Passengers At Domestic Airport\' | translate }}</label><input id=transfer-pax-domestic-airport name=transferPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.transfer_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=departing-pax-domestic-airport>{{ \'Departing Passengers From Domestic Airport\' | translate }}</label><input id=departing-pax-domestic-airport name=departingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.departing_pax_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=arriving-child-domestic-airport>{{ \'Arriving Children At Domestic Airport\' | translate }}</label><input id=arriving-child-domestic-airport name=arrivingChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.arriving_child_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=landing-child-domestic-airport>{{ \'Landing Children At Domestic Airport\' | translate }}</label><input id=landing-child-domestic-airport name=landingChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.landing_child_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=transfer-child-domestic-airport>{{ \'Transfer Children At Domestic Airport\' | translate }}</label><input id=transfer-child-domestic-airport name=transferChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.transfer_child_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=departing-child-domestic-airport>{{ \'Departing Children From Domestic Airport\' | translate }}</label><input id=departing-child-domestic-airport name=departingChildDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.departing_child_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exempt-arriving-pax-domestic-airport>{{ \'Exempt Arriving Passengers At Domestic Airport\' | translate }}</label><input id=exempt-arriving-pax-domestic-airport name=exemptArrivingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_arriving_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=exempt-landing-pax-domestic-airport>{{ \'Exempt Landing Passengers At Domestic Airport\' | translate }}</label><input id=exempt-landing-pax-domestic-airport name=exemptLandingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_landing_pax_domestic_airport pattern=\\d+></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=exempt-transfer-pax-domestic-airport>{{ \'Exempt Transfer Passengers At Domestic Airport\' | translate }}</label><input id=exempt-transfer-pax-domestic-airport name=exemptTransferPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_transfer_pax_domestic_airport pattern=\\d+></div><div class=\"col-xs-12 col-md-6\"><label for=exempt-departing-pax-domestic-airport>{{ \'Exempt Departing Passengers From Domestic Airport\' | translate }}</label><input id=exempt-departing-pax-domestic-airport name=exemptDepartingPaxDomesticAirport class=form-control min=0 max=999 type=number ng-model=editable.exempt_departing_pax_domestic_airport pattern=\\d+></div></div></div><div ng-show=extendedCargoInformation><div class=row><div class=\"col-xs-12 col-md-6\"><label for=loaded-goods>{{ \'Loaded Goods\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=loaded-goods name=loadedGoods ng-model=editable.loaded_goods measurement-type=cargo></div><div class=\"col-xs-12 col-md-6\"><label for=discharged-goods>{{ \'Discharged Goods\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=discharged-goods name=dischargedGoods ng-model=editable.discharged_goods measurement-type=cargo></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=loaded-mail>{{ \'Loaded Mail\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=loaded-mail name=loadedMail ng-model=editable.loaded_mail measurement-type=cargo></div><div class=\"col-xs-12 col-md-6\"><label for=discharged-mail>{{ \'Discharged Mail\' | translate }} ({{ cargoDisplayUnits | translate }})</label><unit-conversion-input id=discharged-mail name=dischargedMail ng-model=editable.discharged_mail measurement-type=cargo></div></div></div><div class=row><div class=col-xs-12><p class=input-group><label for=document_filename2>{{ \'Image File\' | translate}} (*.jpg, *.gif, *.png, *.pdf)</label><input id=document_filename2 name=document_filename2 class=form-control type=text readonly=readonly ng-model=editable.document_filename2> <span class=input-group-btn><button type=button class=\"btn btn-default\" ngf-select=\"parse($file, \'document_filename2\');\" ngf-accept=\"\'.jpg,.gif,.png,.pdf\'\" ngf-multiple=false ng-click=\"image_expiry.open = !image_expiry.open\"><i class=\"fa fa-upload\" aria-hidden=true></i></button></span></p></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid convert-to-tons properties=loaded_goods,discharged_goods,loaded_mail,discharged_mail popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"uploadNew(convertedEditable || editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-to-tons properties=loaded_goods,discharged_goods,loaded_mail,discharged_mail conversion-complete=\"uploadNew(convertedEditable || editable); form.$setUntouched(); reset();\">Create</button></div></div></fieldset></form></div></div><div class=\"row margin-top-20\" ng-show=\"editable.id === null\"><div class=col-xs-12><div class=box-container><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset><box-header icon=\"\'retweet\'\" title=\"{{ \'Upload a Passenger Service Charge Return\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><div class=row><div class=col-xs-12><summary-upload upload-job=uploadJob></summary-upload></div></div><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=!editable.document_filename ng-click=\"upload(\'PUT\', null, null, \'list\', {search: search, size: pageSize}); form.$setUntouched(); reset();\">Upload</button><upload-file-format format={{pattern}} template=app/partials/sc-passenger-service-charge-return/sc-passenger-service-charge-return.template.html></upload-file-format></div></div></div></fieldset></form></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-passenger-service-charge-return/sc-passenger-service-charge-return.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12><span class=text-center><h5>{{ \'Passenger Service Charge Return File\' | translate }}</h5></span><ul><li>{{ \'Format\' | translate }}: {{ format }}</li><li>{{ \'Top\' | translate }} 6 {{ \'rows are ignored\' | translate }}</li><li>{{ \'No column header\' | translate }}</li></ul><span>{{ \'Columns\' | translate }}:</span><ul><li>#1 - {{ \'Account Name\' | translate }}</li><li>#2 - {{ \'Day of Flight\' | translate }} ({{ \'dd/MM/yyyy\' | translate }})</li><li>#3 - {{ \'Flight Identifier\' | translate }}</li><li>#4 - {{ \'empty\' | translate }}</li><li>#5 - {{ \'Transit Passengers\' | translate }}</li><li>#6 - {{ \'Joining Passengers\' | translate }}</li><li>#7 - {{ \'Children\' | translate }}</li><li>#8 - {{ \'Chargeable International Passengers\' | translate }}</li><li>#9 - {{ \'Chargeable Domestic Passengers\' | translate }}</li></ul><span><strong>{{ \'NOTE\' | translate }}:</strong> {{ \'If you are creating a file in Excel, the first row must contain non-blank data otherwise Excel will remove any completely empty rows or columns\' | translate }}</span></div></div><div class=\"row margin-top-20\"><div class=text-center><button translate type=button class=\"btn btn-primary\" ng-click=confirm()>Close</button></div></div></div>");
$templateCache.put("app/partials/sc-query-submission/sc-query-submission.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header icon=\"\'envelope\'\" title=\"Query Submission\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-5\"><label for=sender-email>{{ \'From\' | translate }}:</label><input id=sender-email class=form-control placeholder=\"your email...\" translate translate-attr-placeholder=\"your email...\" type=email ng-model=editable.sender_email required></div></div><div class=row><div class=\"col-xs-12 col-md-5\"><label for=subject>{{ \'Subject\' | translate}}:</label><input id=subject class=form-control placeholder=\"email subject...\" translate translate-attr-placeholder=\"email subject...\" type=text ng-model=editable.subject required></div></div><div class=row><div class=\"col-xs-12 col-md-12\"><label for=message>{{ \'Message\' | translate}}:</label><textarea class=textarea ng-model=editable.message required></textarea></div></div><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-discard\" ng-click=\"discard(); form.$setUntouched();\">Discard</button> <button translate class=\"btn btn-primary btn-send\" ng-disabled=\"form.$invalid || !showButton\" ng-click=\"send(editable); form.$setUntouched();\">Send</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div ng-show=messageSent class=row><div class=col-xs-5><div class=row><div class=\"col-xs-12 col-md-6\"><p class=feedback><span translate>The email has been successfully sent</span> <span class=\"btn btn-xs pull-right\" ng-click=\"messageSent = false\">X</span></p></div></div></div></div></form><!-- Recaptcha Widget --><div class=row><div class=col-xs-12><recaptcha ng-class=\"{\'disabled-captcha\': form.$invalid}\"></recaptcha></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-report-generation/sc-report-generation.html","<div class=row><div class=col-xs-12><div class=box-container><box-header icon=\"\'file-text\'\" title=\"{{ \'Report Generation\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-3\"><label for=report>{{\'Report\' | translate}} *</label><select id=report class=form-control ng-model=editable.report ng-init=\"editable.report=\'prepayment\'\" required><option translate value=prepayment>Prepayment</option><option translate value=actualFlight>Actual flight report</option><option translate value=transaction>Transaction report</option><option translate ng-if=\"hasPermission(\'self_care_admin\')\" value=accountBalance>Account balance report</option><option translate ng-if=\"hasPermission(\'self_care_admin\')\" value=newRregistrations>New registrations report</option><option translate ng-if=\"hasPermission(\'self_care_admin\')\" value=declinedFlights>Declined flights report</option></select></div><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report !=\'accountBalance\' && editable.report !=\'newRregistrations\' \n                            && editable.report !=\'declinedFlights\'\"><label for=accounts>{{\'Accounts\' | translate}} *</label><multiselect id=accounts name=accounts extra-settings=\"{ displayProp: \'name\' }\" options=accountsList model=selectedAccounts events=\"{ onSelectionChanged: addAccountToList }\"></multiselect></div><div class=\"col-xs-12 col-md-2\" ng-if=\"editable.report ==\'accountBalance\'\"><label>{{\'Account Status\' | translate}} *</label><select id=account-status class=form-control ng-model=editable.account_status ng-init=\"editable.account_status = \'\'\"><option translate value=\"\">All</option><option translate value=ACTIVE>Active</option><option translate value=ACTIVE,INACTIVE>Unexpired</option><option translate value=\"INACTIVE \">Inactive</option><option translate value=EXPIRED>Expired</option></select></div><div class=\"col-xs-12 col-md-5\"><date-range control=control start-name=\"Start Date *\" end-name=\"End Date *\" format=\"{{ customDate }}\" is-required=true><!--Datepickers --></date-range></div></div><div class=row><div class=\"col-xs-12 col-md-3\" ng-if=\"editable.report ==\'declinedFlights\'\"><input id=group-by-account type=checkbox ng-init=\"editable.group_by_account = false\" ng-model=editable.group_by_account><label translate for=group-by-account>{{\'Group by account\' | translate}}</label></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-clean\" ng-click=\"setClear(editable); form.$setUntouched();\">Clear</button><!-- Prepayment Report --><download-oauth2 ng-if=\"editable.report ===\'prepayment\'\" url=reports/generic/sc_prepayment_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        csvExport: true,\n                                        report: editable.report,\n                                        output_format: \'xlsx\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"form.$invalid || !selectedAccounts.length\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report ===\'prepayment\'\" url=reports/generic/sc_prepayment_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        report: editable.report,\n                                        output_format: \'pdf\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\" disable=\"form.$invalid || !selectedAccounts.length\"></preview-oauth2><!-- Actual flight Report --><download-oauth2 ng-if=\"editable.report ===\'actualFlight\'\" url=reports/generic/sc_actual_flight_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        csvExport: true,\n                                        report: editable.report,\n                                        output_format: \'xlsx\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"form.$invalid || !selectedAccounts.length\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report ===\'actualFlight\'\" url=reports/generic/sc_actual_flight_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        report: editable.report,\n                                        output_format: \'pdf\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\" disable=\"form.$invalid || !selectedAccounts.length\"></preview-oauth2><!-- Transaction Report --><download-oauth2 ng-if=\"editable.report ===\'transaction\'\" url=reports/generic/sc_transaction_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        csvExport: true,\n                                        report: editable.report,\n                                        output_format: \'xlsx\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=\"form.$invalid || !selectedAccounts.length\" hide-icon=true request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report ===\'transaction\'\" url=reports/generic/sc_transaction_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        report: editable.report,\n                                        output_format: \'pdf\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" request-method=POST body-params=\"{ account_id: accountIdsWithBrackets }\" disable=\"form.$invalid || !selectedAccounts.length\"></preview-oauth2><!-- Account Balance Report --><download-oauth2 ng-if=\"editable.report ===\'accountBalance\'\" url=reports/generic/sc_account_balance_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        csvExport: true,\n                                        report: editable.report,\n                                        output_format: \'xlsx\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=form.$invalid hide-icon=true request-method=POST body-params=\"{ account_state: returnFilteredActiveStatus(editable.account_status) }\"></download-oauth2><preview-oauth2 ng-if=\"editable.report ===\'accountBalance\'\" url=reports/generic/sc_account_balance_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        report: editable.report,\n                                        output_format: \'pdf\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" request-method=POST body-params=\"{ account_state: returnFilteredActiveStatus(editable.account_status) }\" disable=form.$invalid></preview-oauth2><!-- New Registrations Report --><download-oauth2 ng-if=\"editable.report ===\'newRregistrations\'\" url=reports/generic/sc_new_registrations_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        csvExport: true,\n                                        report: editable.report,\n                                        output_format: \'xlsx\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=form.$invalid hide-icon=true request-method=POST></download-oauth2><preview-oauth2 ng-if=\"editable.report ===\'newRregistrations\'\" url=reports/generic/sc_new_registrations_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        report: editable.report,\n                                        output_format: \'pdf\',\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" request-method=POST disable=form.$invalid></preview-oauth2><!-- Declined Flight Report --><download-oauth2 ng-if=\"editable.report ===\'declinedFlights\'\" url=reports/generic/sc_declined_flight_report error=error class-used=\"btn btn-primary btn-generate\" params=\"{ text: \'Generate\',\n                                        csvExport: true,\n                                        report: editable.report,\n                                        output_format: \'xlsx\',\n                                        group_by_account: editable.group_by_account,\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" disable=form.$invalid hide-icon=true request-method=POST></download-oauth2><preview-oauth2 ng-if=\"editable.report ===\'declinedFlights\'\" url=reports/generic/sc_declined_flight_report error=$parent.error height=\"\'670px\'\" params=\"{ text: \'Preview\',\n                                        report: editable.report,\n                                        output_format: \'pdf\',\n                                        group_by_account: editable.group_by_account,\n                                        fromdate: returnFilteredDate(control.getUTCStartDate()),\n                                        todate: returnFilteredDate(control.getUTCEndDate()) }\" request-method=POST disable=form.$invalid></preview-oauth2></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/sc-transactions/sc-transactions.html","<div class=row><div class=col-xs-12><div class=box-container><box-header icon=\"\'exchange\'\" title=\"{{ \'Transactions\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshList()\"></div><div class=\"col-xs-6 col-md-3\"><label translate for=account-filter>Account</label><dynamic-service-dropdown ng-model=accountFilter id=account-filter dropdown-type=single allow-empty=true service=::scAccountManagementService is-required=false method=getSCAccounts options=\"item.id as (item.name | translate) for item in list\" ng-change=refreshList()></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-4\"><date-range is-required=false control=control format=\"{{ customDate }}\" ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\"><!--Datepickers --></date-range></div><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refreshList() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div id=transactions class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=scTransactionsService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshList()><thead><tr><th translate class=text-nowrap>Receipt</th><th translate class=text-nowrap sort=receiptNumber>Number</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=transactionDateTime>Date/Time</th><th translate class=text-nowrap sort=description>Description</th><th translate class=text-nowrap sort=transactionType.name>Type</th><th translate class=\"text-nowrap text-right\" sort=amount>Amount</th><th translate class=text-nowrap sort=currency.currencyCode>Currency</th><th translate class=\"text-nowrap text-right\" sort=exchangeRateToUsd>Exchange USD</th><th translate class=\"text-nowrap text-right\" sort=exchangeRateToAnsp>Exchange ANSP</th><th translate class=\"text-nowrap text-right\" sort=balance>Balance</th><th translate class=\"text-nowrap text-right\" sort=paymentReferenceNumber>Payment Reference Number</th><th translate class=\"text-nowrap text-right\" sort=paymentMechanism>Payment Mechanism</th><th translate class=text-nowrap sort=exported>Exported</th><th translate class=\"text-nowrap text-center\">Approval Document</th><th translate class=\"text-nowrap text-center\">Supporting Document</th></tr></thead><tbody><tr ng-click=\"edit(item); editable.amount = (editable.amount | abs); \n                                        editable.payment_amount = (editable.payment_amount | abs); \n                                        getInvoicesByTransactionId(item.id)\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-center><div ng-if=item.has_receipt_document><download-oauth2 url=\"reports/transaction-receipt?transactionId={{item.id}}\" error=error></download-oauth2></div></td><td class=text-nowrap>{{ item.receipt_number }}</td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.transaction_date_time | dateConverter: \'HH:mm\' }}</td><td class=text-nowrap>{{ item.description }}</td><td class=text-capitalize>{{ item.transaction_type.name | translate }}</td><td class=text-right>{{ item.amount | abs | number : 2 }}</td><td>{{ item.currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ item.balance | number : 2 }}</td><td>{{ item.payment_reference_number }}</td><td class=text-nowrap>{{ item.payment_mechanism | translate }}</td><td>{{ item.exported | translate }}</td><td class=text-center><download-oauth2 ng-show=item.has_approval_document url=\"transactions/{{ item.id }}/download/approval\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td><td class=text-center><download-oauth2 ng-show=item.has_supporting_document url=\"transactions/{{ item.id }}/download/supporting\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td></tr><tr ng-show=!list.length><td class=text-center colspan=16 translate>There are no Transactions data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshList() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div ng-show=\"editable.id && listOfInvoices\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=\"Transaction Payments\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!listOfInvoices.content.length || !listOfInvoices.content\"><span translate>There are no Transaction Payments related to this transaction</span></div><div ng-if=listOfInvoices.content.length><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Amount</th><th translate class=text-nowrap>Invoice Number</th><th translate class=text-nowrap>Currency</th><th translate class=text-nowrap>Exchange USD</th><th translate class=text-nowrap>Exchange ANSP</th><th translate class=text-nowrap>Account Credit</th></tr></thead><tbody><tr ng-repeat=\"item in listOfInvoices.content\"><td class=\"text-nowrap text-right\">{{ item.amount | abs | number: 2 }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_number }}</td><td class=\"text-nowrap text-right\">{{ item.currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5 }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-nowrap>{{ item.is_account_credit | translate }}</td></tr></tbody></table></div></div><ul uib-pagination total-items=listOfInvoices.total_elements ng-change=\"refresh({ filter: filter, page: listOfInvoices.number }, getSortQueryString())\" max-size=::20 items-per-page=listOfInvoices.size ng-model=listOfInvoices.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div ng-show=\"editable.id && listOfInvoices\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=Invoices></box-header><div class=box-content><div class=row><div class=col-xs-12><div translate ng-if=\"!listOfInvoices.content.length || !listOfInvoices.content\">There are no Invoices related to this transaction</div><div ng-if=listOfInvoices.content.length><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Actions</th><th translate class=text-nowrap>Account</th><th translate class=text-nowrap>Invoice Number</th><th translate class=text-nowrap>Invoice Date</th><th translate class=text-nowrap>Invoice Type</th><th translate class=text-nowrap>Status</th><th translate class=text-nowrap>Payment Due Date</th><th translate class=text-nowrap>Created By</th><th translate class=text-nowrap>Invoice Amount</th><th translate class=text-nowrap>Invoice Currency</th><th translate class=text-nowrap>Exchange USD</th><th translate class=text-nowrap>Invoice Date of Issue</th><th translate class=text-nowrap>Exported</th></tr></thead><tbody><tr ng-repeat=\"item in listOfInvoices.content\"><td class=text-center><download-oauth2 url=/billing-ledgers/{{item.billing_ledger.id}}/download? error=error></download-oauth2></td><td class=text-nowrap>{{ item.billing_ledger.account.name }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_number }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_period_or_date | dateConverter}}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_type.replace(\'-\', \'_\').toUpperCase() | translate }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_state_type.toUpperCase() | translate }}</td><td class=text-nowrap>{{ item.billing_ledger.payment_due_date | dateConverter }}</td><td class=text-nowrap>{{ item.billing_ledger.user.name }}</td><td class=\"text-nowrap text-right\">{{ item.billing_ledger.invoice_amount | number: 2 }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / item.billing_ledger.invoice_exchange : item.billing_ledger.invoice_exchange) | evenRound: 5 | number: 5 }}</td><td class=text-nowrap>{{ item.billing_ledger.invoice_date_of_issue | dateConverter }}</td><td class=text-nowrap>{{ item.billing_ledger.exported | translate }}</td></tr></tbody></table></div></div><ul uib-pagination total-items=listOfInvoices.total_elements ng-change=\"refresh({ filter: filter, page: listOfInvoices.number }, getSortQueryString())\" max-size=::20 items-per-page=listOfInvoices.size ng-model=listOfInvoices.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-user-management/sc-user-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle icon=\"\'user\'\" title=\"{{ \'Users\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=scUserManagementService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate sort=name>User Name</th><th translate sort=login>User Login</th><th translate sort=jobTitle>Job Title</th><th translate sort=email>Email Address</th><th translate sort=userRoles.id>Groups</th><th ng-if=\"hasPermission(\'self_care_admin\')\" translate sort=registrationStatus>Registration Status</th></tr></thead><tbody><tr ng-click=\"resetPassword(); form.$setUntouched(); edit(item);saveOldValue();\" ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.name }}</td><td class=text-nowrap>{{ item.login }}</td><td class=text-nowrap>{{ item.job_title }}</td><td class=text-nowrap>{{ item.email }}</td><td class=text-nowrap><span ng-repeat=\"(key, val) in item.roles\">{{ val.name | translate }}{{ key != item.roles.length - 1 ? \',\' : \'\' }}</span></td><td ng-if=\"hasPermission(\'self_care_admin\')\" class=\"text-nowrap text-capitalize\" translate>{{ item.registration_status }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=6 translate>There are no Users data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=editable.id icon=\"\'user\'\" title=\"{{ \'Edit a User\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=userlogin>User Login *</label><input id=userlogin name=login class=\"form-control disabled\" type=text minlength=4 ng-value=editable.login disabled=disabled></div><div class=\"col-xs-12 col-md-6\"><label translate for=username>User Name *</label><input id=username name=name class=form-control type=text maxlength=100 ng-model=editable.name required></div></div><password reset-pass=resetPass required=!editable.id password=editable.password></password><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=email-address>Email Address *</label><input id=email-address name=email class=form-control type=email ng-model=editable.email pattern=[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+$ required></div><div class=\"col-xs-12 col-md-6\"><label translate for=sms_number>Telephone Number</label><input id=sms_number name=sms_number class=form-control type=text ng-model=editable.sms_number empty-to-null></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=contact-information>Contact Information *</label><input id=contact-information name=contactInformation class=form-control type=text ng-model=editable.contact_information required></div><div class=\"col-xs-12 col-md-6\"><label translate for=job-title>Job Title</label><input id=job-title name=jobTitle class=form-control type=text ng-model=editable.job_title></div></div><div class=row ng-if=\"hasPermission(\'self_care_admin\')\"><div class=\"col-xs-12 col-md-6\"><label for=registration-status><span translate>Registration Status</span></label><boolean-text id=registration-status name=registrationStatus class=form-control ng-model=editable.registration_status ng-disabled=true></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label for=force-password-change translate>Force Password Change</label><boolean-text id=force-password-change name=forcePasswordChange class=form-control ng-model=editable.force_password_change required></boolean-text></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button ng-if=\"hasPermission(\'self_care_admin\') && editable.id !== null\" translate type=button class=\"btn btn-primary\" ng-click=\"resetPassword(); reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-disabled=form.$invalid ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary\" ng-if=\"editable.id !== null && hasPermission(\'self_care_admin\')\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id)>Delete</button></div></div></form></div></div></div></div>");
$templateCache.put("app/partials/sc-user-registration/sc-user-registration-activate.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header icon=\"\'user\'\" title=\"Activating User Registration\"></box-header><div class=box-content><div ng-init=activate()></div><div class=row ng-if=activated><div class=\"col-xs-6 col-xs-offset-3\"><div class=\"alert text-center infoAlert\"><span translate>THANK YOU FOR SINGING UP. YOU MAY LOGIN NOW</span><div class=\"col-xs-12 col-md-12\"><div class=row><div class=\"col-md-4 col-md-offset-4\"><a class=\"btn btn-primary btn-block\" ui-sref=main.sc-login>Login</a></div></div></div></div></div></div><div class=row ng-if=!activated><div class=\"col-xs-6 col-xs-offset-3\"><div class=\"alert text-center infoAlert\"><span translate>SORRY, YOUR ACTIVATION KEY IS NO LONGER AVAILABLE</span></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/sc-user-registration/sc-user-registration.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header icon=\"\'user\'\" title=\"User Registration\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=userlogin>User Login *</label><input id=userlogine name=login class=form-control type=text minlength=4 ng-model=editable.login required></div><div class=\"col-xs-12 col-md-6\"><label translate for=username>User Name *</label><input id=username name=name class=form-control type=text maxlength=100 ng-model=editable.name required></div></div><password reset-pass=resetPass error=true required=true password=editable.password></password><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=email-address>Email Address *</label><input id=email-address name=email class=form-control type=email ng-model=editable.email pattern=[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+$ required></div><div class=\"col-xs-12 col-md-6\"><label translate for=sms_number>Telephone Number</label><input id=sms_number name=sms_number class=form-control type=text ng-model=editable.sms_number ng-change=\"!editable.sms_number ? editable.sms_number = null : editable.sms_number\"></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=contact-information>Contact Information *</label><input id=contact-information name=contactInformation class=form-control type=text ng-model=editable.contact_information required></div><div class=\"col-xs-12 col-md-6\"><label translate for=job-title>Job Title</label><input id=job-title name=jobTitle class=form-control type=text ng-model=editable.job_title></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button ng-disabled=\"processing === true\" class=\"btn btn-primary btn-reset\" ng-click=\"resetPassword(); reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"form.$invalid || !showButton || processing === true\" ng-click=\"createOverride(editable); form.$setUntouched();\">Create</button></div></div></form><!-- Recaptcha Widget --><div class=row><div class=col-xs-12><recaptcha ng-class=\"{\'disabled-captcha\': form.$invalid}\"></recaptcha></div></div><div class=row ng-show=\"userCreated && requireEmail\"><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-md-6\"><p class=wideFeedback><span translate>User has been created, please verify it within 24 hours by clicking the activation link that has been send to your email</span> <span class=\"btn btn-xs pull-right\" ng-click=\"userCreated = false\">X</span></p></div></div></div></div><div class=row ng-show=\"userCreated && !requireEmail\"><div class=col-xs-6><div class=row><div class=\"col-xs-12 col-md-6\"><p class=wideFeedback><span translate>User has been created</span> <span class=\"btn btn-xs pull-right\" ng-click=\"userCreated = false\">X</span></p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/service-outages/service-outages.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=exemptions.aerodrome-service-outage-management icon=\"\'adjust\'\" title=\"{{ \'Aerodrome Service Outages\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=service-type>Service Type</label><select id=service-type empty-to-null class=form-control ng-change=refresh() ng-model=serviceType ng-options=\"item.service_name as (item.service_name | translate) for item in aerodromeServiceTypes\"><option translate value=\"\">All</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=aerodrome-status>Aerodrome Status</label><select id=aerodrome-status class=form-control ng-change=refresh() ng-model=aerodromeStatus ng-init=\"aerodromeStatus = \'all\'\"><option translate value=all>All With Services</option><option translate value=withOutagesOnly>All With Service Outages</option></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=aerodrome-name>Aerodrome Name</label><select id=aerodrome-name empty-to-null class=form-control ng-change=refresh() ng-model=aerodromeName ng-options=\"item.aerodrome_name as item.aerodrome_name for item in aerodromeWithServices\"><option translate value=\"\"></option></select></div><div class=\"col-xs-12 col-md-3\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label for=start-date-filter><span translate>Start Date</span>&nbsp;<span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=start-date-filter name=startDateFilter type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=startDateFilter is-open=startDateFilter.open close-text=Close ng-change=\"clearTime(\'start\', startDateFilter); refresh()\"></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDateFilter.open = !startDateFilter.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-3\"><label for=start-time-filter><span translate>Start Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=start-time-filter name=startTimeFilter class=form-control type=text ng-model=startTimeFilter minlength=4 maxlength=4 ng-attr-title=\"{{startTimeFilter < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers ng-disabled=!startDateFilter ng-change=refresh()></div><div class=\"col-xs-12 col-md-3\"><label for=end-date-filter><span translate>End Date</span>&nbsp;<span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=end-date-filter name=endDateFilter type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=endDateFilter is-open=endDateFilter.open close-text=Close ng-change=\"clearTime(\'end\', endDateFilter); refresh()\"></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDateFilter.open = !endDateFilter.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-3\"><label for=end-time-filter><span translate>End Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=end-time-filter name=endTimeFilter class=form-control type=text ng-model=endTimeFilter minlength=4 maxlength=4 ng-attr-title=\"{{endTimeFilter < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers ng-disabled=!endDateFilter ng-change=refresh()></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode === 13 && refresh()\"></div></div><div class=row><div ng-class=\"{ \'col-xs-12\': !outages, \'col-xs-4\': outages }\"><div class=table-responsive export-table sort-query-string=getMapSortQueryString() query-string=filterParameters back-end-export=true service=serviceOutagesService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getMapSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=aerodrome>Aerodrome</th><th translate class=text-nowrap sort=aerodromeServiceType>Aerodrome Service Type</th></tr></thead><tbody><tr ng-click=\"showOutages(item, $index); form.$setUntouched()\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editableIndexAerodrome === $index}\"><td class=text-nowrap>{{ item.aerodrome }}</td><td translate class=text-nowrap>{{ item.aerodrome_service_type }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=2 translate>There are no Aerodrome Services data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements max-size=::20 items-per-page=pagination.size ng-change=refresh() ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div><div ng-show=outages><div class=col-xs-8><div class=table-responsive style=\"max-height: 25vh; margin-bottom: 10px\"><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=startDateTime>Start Date/Time</th><th translate class=text-nowrap sort=endDateTime>End Date/Time</th><th translate class=text-nowrap sort=approachDiscountType>Approach Discount Type</th><th translate class=\"text-nowrap text-right\" sort=approachDiscountAmount>Approach Discount Amount</th><th translate class=text-nowrap sort=aerodromeDiscountType>Aerodrome Discount Type</th><th translate class=\"text-nowrap text-right\" sort=aerodromeDiscountAmount>Aerodrome Discount Amount</th><th translate class=text-nowrap sort=flightNotes>Flight Notes</th></tr></thead><tbody><tr ng-click=\"editOutages(item, $index)\" ng-repeat=\"item in outages\" ng-class=\"{\'highlight\':editableIndex === $index}\"><td class=text-nowrap>{{ item.start_date_time | dateConverter: \'HH:mm\' }}</td><td class=text-nowrap>{{ item.end_date_time | dateConverter: \'HH:mm\' }}</td><td class=text-nowrap>{{ item.approach_discount_type | translate }}</td><td class=\"text-nowrap text-right\">{{ item.approach_discount_amount }}</td><td class=text-nowrap>{{ item.aerodrome_discount_type | translate }}</td><td class=\"text-nowrap text-right\">{{ item.aerodrome_discount_amount }}</td><td class=text-nowrap>{{ item.flight_notes }}</td></tr><tr ng-show=!outages.length><td colspan=7 translate>There are no Aerodrome Services Outages data</td></tr></tbody></table></div></div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'adjust\'\" title=\"{{ \'Create an Aerodrome Service Outage\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'adjust\'\" title=\"{{ \'Edit an Aerodrome Service Outage\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'aerodrome_service_outage_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome>{{ \'Aerodrome\' | translate }} *</label><select id=aerodrome name=aerodrome class=form-control ng-options=\"item.aerodrome_name as item.aerodrome_name for item in aerodromeWithServices\" ng-model=editable.aerodrome ng-disabled=editable.id ng-change=getAerodromeServiceTypes(editable.aerodrome) required></select></div><div class=\"col-xs-12 col-md-6\"><label for=aerodrome-service-type>{{ \'Aerodrome Service Type\' | translate }} *</label><select id=aerodrome-service-type name=aerodromeServiceType class=form-control ng-options=\"item.service_name as item.service_name for item in aerodromeServiceTypes\" ng-disabled=\"!editable.aerodrome || editable.id\" ng-model=editable.aerodrome_service_type ng-change=setDefaultData(editable.aerodrome_service_type) required></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=start-date><span translate>Start Date</span> *&nbsp;<span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=start-date name=startDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=start_date is-open=startDate.open ng-attr-title=\"{{start_date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"startDate.open = !startDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=start_time><span translate>Start Time</span>&nbsp;(<span tranlate>HHmm</span>) *</label><input id=start_time name=startTime class=form-control type=text ng-model=start_time minlength=4 maxlength=4 ng-attr-title=\"{{start_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=end-date><span translate>End Date</span> *&nbsp;<span translate>({{ ::customDate }})</span></label><p class=input-group><date-picker id=end-date name=endDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=end_date is-open=endDate.open ng-attr-title=\"{{end_date ? \'\' : \'Please fill out this field\' | translate}}\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"endDate.open = !endDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=end_time><span translate>End Time</span>&nbsp;(<span tranlate>HHmm</span>) *</label><input id=end_time name=endTime class=form-control type=text ng-model=end_time minlength=4 maxlength=4 ng-attr-title=\"{{end_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ only-numbers required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=approach-discount-type>{{ \'Approach Discount Type\' | translate }} *</label><select id=approach-discount-type name=approachDiscountType class=form-control ng-model=editable.approach_discount_type required><option translate value=fixed>Fixed Amount</option><option translate value=percentage>Percentage</option></select></div><div class=\"col-xs-12 col-md-6\"><label for=approach-discount-amount>{{ \'Approach Discount Amount\' | translate }} *</label><input id=approach-discount-amount name=approachDiscountAmount class=form-control type=number ng-model=editable.approach_discount_amount min=0 step=0.01 max=\"{{editable.approach_discount_type === \'percentage\' ? \'100\' : \'\'}}\" required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=aerodrome-discount-type>{{ \'Aerodrome Discount Type\' | translate }} *</label><select id=aerodrome-discount-type name=aerodromeDiscountType class=form-control ng-model=editable.aerodrome_discount_type required><option translate value=fixed>Fixed Amount</option><option translate value=percentage>Percentage</option></select></div><div class=\"col-xs-12 col-md-6\"><label for=aerodrome-discount-amount>{{ \'Aerodrome Discount Amount\' | translate }} *</label><input id=aerodrome-discount-amount name=aerodromeDiscountAmount class=form-control type=number ng-model=editable.aerodrome_discount_amount min=0 step=0.01 max=\"{{editable.aerodrome_discount_type === \'percentage\' ? \'100\' : \'\'}}\" required></div></div><div class=row><div class=col-xs-12><label for=flight-notes>{{ \'Flight Notes\' | translate }} *</label><textarea id=flight-notes name=flightNotes class=form-control type=text ng-model=editable.flight_notes required ng-attr-title=\"{{editable.flight_notes ? \'\' : \'Please indicate which fees have discount and why\' | translate}}\">\n                                </textarea></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id, start_date, start_time, end_date, end_time); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched();\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable, start_date, start_time, end_date, end_time); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/sso-providers/sso-providers.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=security.sso-providers icon=\"\'server\'\" title=\"{{ \'sso-providers\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=ssoProvidersService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=name>Name</th><th translate sort=active>Active</th></tr></thead><tbody><tr ng-click=\"form.$setUntouched(); edit(item);saveOldValue();\" ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.name }}</td><td class=text-nowrap>{{ item.active }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=5 translate>there-are-no-sso-providers-data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'server\'\" title=\"{{ \'create-sso-provider\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'server\'\" title=\"{{ \'edit-sso-provider\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'user_modify\')\"><div class=row><div class=col-xs-12><label translate for=name>Name *</label><input id=name name=name class=form-control type=text ng-minlength=3 maxlength=100 ng-model=editable.name required></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label for=type><span translate>Type</span><span> *</span></label><select ng-model=editable.type ng-disabled=\"editable.id !== null\" id=type name=protocol class=form-control size=1 required><!-- <option ng-repeat=\"(key, value) in availableProviderTypes\" id=\"{{key}}\">{{value}}</option> --><option ng-repeat=\"value in availableProviderTypes\">{{value}}</option></select></div><div class=\"col-xs-12 col-md-3\"><input id=active name=active ng-model=editable.active type=checkbox><label translate for=active>Active</label></div><div class=\"col-xs-12 col-md-6\"><input id=perform-provider-logout name=performProviderLogout ng-model=editable.perform_provider_logout type=checkbox><label for=perform-provider-logout><span translate>perform-provider-logout</span> *</label></div></div><div class=row><div class=col-xs-12><label for=client-id><span translate>client-id</span> *</label><input id=client-id name=clientId class=form-control type=text maxlength=100 ng-model=editable.client_id required></div></div><div class=row><div class=col-xs-12><label for=client-secret><span translate>client-secret</span> *</label><input id=client-secret name=clientSecret class=form-control type=text maxlength=100 ng-model=editable.client_secret required></div></div><div class=row ng-if=hasBaseUrl><div class=\"col-xs-12 col-md-6\"><label for=base-url><span translate>base-url</span> *</label><input id=base-url name=baseUrl class=form-control type=text maxlength=100 ng-model=editable.base_url required></div><div class=\"col-xs-12 col-md-6\"><input id=ignore-ssl name=ignoreSSL ng-model=editable.ignore_ssl type=checkbox><label for=ignore-ssl><span translate>ignore-ssl</span> *</label></div></div><div class=row ng-if=hasRealm><div class=col-xs-12><label for=realm><span translate>realm</span> *</label><input id=realm name=realm class=form-control type=text maxlength=100 ng-model=editable.realm required></div></div><div class=row ng-if=\"editable.id !== null\"><div class=col-xs-12><label translate for=link-url>link-url</label><input id=link-url name=linkUrl class=form-control type=text maxlength=100 ng-model=editable.link_url ng-disabled=true></div></div><div class=row><div class=col-xs-12><label for=success-url><span translate>success-url</span> *</label><input id=success-url name=successUrl class=form-control type=text maxlength=100 ng-model=editable.success_url required></div></div><div class=row><div class=col-xs-12><label for=failure-url><span translate>failure-url</span> *</label><input id=failure-url name=failureUrl class=form-control type=text maxlength=100 ng-model=editable.failure_url required></div></div><div class=row><div class=col-xs-12><label for=post-logout-url><span translate>logout-url</span> *</label><input id=post-logout-url name=postLogoutUrl class=form-control type=text maxlength=100 ng-model=editable.post_logout_url required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || editable.linkUrl === null\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id)>Delete</button> <button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || editable.linkUrl === null\" ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/system-configuration/system-configuration.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=management.system-configuration-management icon=\"\'cog\'\" title=\"{{ \'System Configuration\' | translate }}\"></box-header><div class=box-content><form novalidate name=form action=# onsubmit=\"return false\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter></div></div><fieldset ng-disabled=\"!hasPermission(\'sys_config_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><button class=\"btn btn-primary btn-update\" translate ng-disabled=\"!isDisabledWL()\n                                        || (\n                                            !hasPermission(\'sys_config_logging_modify\') &&\n                                            !hasPermission(\'sys_config_password_modify\') &&\n                                            !hasPermission(\'sys_config_system_modify\') &&\n                                            !hasPermission(\'sys_config_data_modify\') &&\n                                            !hasPermission(\'sys_config_email_modify\') &&\n                                            !hasPermission(\'sys_config_sms_modify\') &&\n                                            !hasPermission(\'sys_config_ansp_modify\') &&\n                                            !hasPermission(\'sys_config_external_modify\') &&\n                                            !hasPermission(\'sys_config_default_modify\') &&\n                                            !hasPermission(\'sys_config_deletion_modify\') &&\n                                            !hasPermission(\'sys_config_crossing_modify\') &&\n                                            !hasPermission(\'sys_config_workflow_modify\') &&\n                                            !hasPermission(\'sys_config_upload_modify\') &&\n                                            !hasPermission(\'sys_config_cron_modify\') &&\n                                            !hasPermission(\'sys_config_self-care_modify\') &&\n                                            !hasPermission(\'sys_config_whitelist_modify\') &&\n                                            !hasPermission(\'sys_config_creditcard_modify\') &&\n                                            !hasPermission(\'sys_config_Unified Tax_modify\')\n                                            )\" type=button unit-converter unit-to-convert=distance popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateAndReloadLang(convertedList || list);\">Update Record</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><uib-accordion close-others=\"!textFilter || textFilter.length === 0\"><div uib-accordion-group class=panel-default ng-repeat=\"(className, items) in groupedItems\" ng-if=\"filteredItems(items).length > 0\" is-open=collapsed[className]><uib-accordion-heading ng-click=toggleAccordion(className)><i class=\"pull-right fa\" ng-class=\"{\'fa-chevron-right\': !collapsed[className], \'fa-chevron-down\': collapsed[className]}\"></i><h6 translate class=text-uppercase>{{ className }}</h6></uib-accordion-heading><div class=\"row d-flex flex-wrap\" ng-click=$event.stopPropagation()><div class=\"col-xs-12 col-sm-6 col-md-4 d-flex\" ng-repeat=\"item in filteredItems(items)\"><div><system-configuration-item item=item crossing=crossing list=items ng-class=\"{\'disabled-section\': !hasPermission(\'sys_config_\' + item.item_class.name + \'_modify\')}\">></system-configuration-item></div></div></div></div></uib-accordion></div></div><div class=\"notification notification-responsive\" ng-show=\"systemConfigurationUpdated === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #4caf50; color: white;\n                                            padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Successfully updated System Configuration</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"systemConfigurationUpdated = false\">X</span></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/system-summary/system-summary.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=data-analysis-and-statistics.system-summary icon=\"\'bar-chart\'\" title=\"{{ \'System Summary\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-12\"><button translate class=\"btn btn-primary btn-refresh pull-right\" ng-click=refresh()>Refresh</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-bordered table-striped table-condensed\"><thead><tr><th colspan=6 translate>Flight Movements</th></tr></thead><tbody ng-repeat=\"item in list | limitTo: 1 : 0\"><tr ng-repeat=\"category in item\"><td class=\"col-md-2 text-capitalize\">{{ formatName((category.category_name | translate)) }}</td><td class=\"col-md-2 text-right\">{{ category.flight_movement_vo.total }}</td><td translate class=col-md-2>Resolved</td><td class=\"col-md-2 text-right\">{{ category.flight_movement_vo.val }}</td><td translate class=col-md-2>Percent Resolved</td><td class=\"col-md-2 text-nowrap text-right\">{{ category.flight_movement_vo.percent | number: 2 }}%</td></tr><tr><td class=system-summary colspan=2></td></tr><tr><td class=col-md-2>{{ data.flight_movement_inside.name | translate }}</td><td class=\"col-md-2 text-right\">{{ data.flight_movement_inside.total }}</td><td translate class=col-md-2>Percent of All Flights</td><td class=\"col-md-2 text-nowrap text-right\">{{ data.flight_movement_inside.percent | number: 2 }}%</td></tr><tr><td class=col-md-2>{{ data.flight_movement_outside.name | translate }}</td><td class=\"col-md-2 text-right\">{{ data.flight_movement_outside.total }}</td><td translate class=col-md-2>Percent of All Flights</td><td class=\"col-md-2 text-nowrap text-right\">{{ data.flight_movement_outside.percent | number: 2 }}%</td></tr><tr><td class=col-md-2>{{ data.flight_movement_all.name | translate }}</td><td class=\"col-md-2 text-right\">{{ data.flight_movement_all.total }}</td></tr></tbody></table></div></div></div><div class=row ng-if=\"shouldShowCharge(\'parking\')\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th colspan=6 translate>Movements with Parking Time</th></tr></thead><tbody><tr ng-repeat=\"item in list | limitTo: 3 : 4 \"><td class=\"col-md-2 text-capitalize\">{{ formatName((item.name | translate)) }}</td><td class=\"col-md-2 text-right\">{{ item.total }}</td><td translate class=col-md-2>Parking</td><td class=\"col-md-2 text-right\">{{ item.val }}</td><td translate class=col-md-2>Percent Parking</td><td class=\"col-md-2 text-right\">{{ item.percent | number: 2 }}%</td></tr></tbody></table></div></div></div><div class=row><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th colspan=6 translate>Aircraft Types Resolved</th></tr></thead><tbody><tr ng-repeat=\"item in list | limitTo: 1 : 7\"><td class=col-md-2>{{ item.name | translate }}</td><td class=\"col-md-2 text-right\">{{ item.total }}</td><td translate class=col-md-2>Resolved</td><td class=\"col-md-2 text-right\">{{ item.val }}</td><td translate class=col-md-2>Percent Resolved</td><td class=\"col-md-2 text-right\">{{ item.percent | number: 2 }}%</td></tr><tr><td class=\"col-md-2 text-capitalize\">{{ formatName((data.flight_movement_unknown_aircraft_type.name | translate)) }}</td><td class=\"col-md-2 text-right\">{{ data.flight_movement_unknown_aircraft_type.total }}</td></tr></tbody></table></div></div></div><div class=row><div class=col-xs-8><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th colspan=4 translate>Blacklistings</th></tr></thead><tbody><tr ng-repeat=\"item in list | limitTo: 2 : 9\"><td class=col-md-2>{{ item.name | translate }}</td><td class=\"col-md-2 text-right\">{{ item.total }}</td><td translate class=col-md-2>Percent Blacklisted</td><td class=\"col-md-2 text-right\">{{ item.percent | number: 2 }}%</td></tr></tbody></table></div><div class=row><div class=col-xs-6><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th colspan=2 translate>Active Accounts</th></tr></thead><tbody><tr ng-repeat=\"item in list | limitTo: 2 : 11\"><td class=col-md-2>{{ item.name | translate }}</td><td class=\"col-md-2 text-right\">{{ item.total }}</td></tr></tbody></table></div></div></div><div class=row><div class=col-xs-6><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th translate class=col-md-2>{{ data.flight_movement_rejected.name | translate }}</th><td class=\"col-md-2 text-right\">{{ data.flight_movement_rejected.total }}</td></tr></thead></table></div></div></div><div class=row><div class=col-xs-6><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th translate class=col-md-2>{{ data.outstanding_bill.name | translate }}</th><td class=\"col-md-2 text-right\">{{ data.outstanding_bill.total }}</td></tr></thead></table></div></div></div><div class=row><div class=col-xs-6><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th translate class=col-md-2>{{ data.overdue_bill.name | translate }}</th><td class=\"col-md-2 text-right\">{{ data.overdue_bill.total }}</td></tr></thead></table></div></div></div><div class=row><div class=col-xs-6><div class=table-responsive><table class=\"table table-striped table-bordered table-condensed\"><thead><tr><th translate class=col-md-2>{{ data.flight_movement_latest.name | translate }}</th><td class=\"col-md-2 text-right\">{{ data.flight_movement_latest.date | dateConverter }}</td></tr></thead></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/partials/tower-movement-logs/tower-movement-logs.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><!-- tower movement logs container --><div class=box-container><box-header toggle=toggle page-name=flight-data.tower-movement-log-management icon=\"\'tasks\'\" title=\"{{ \'Tower Movement Logs\' | translate }}\"></box-header><div class=box-content><!-- tower movement logs data grid filters --><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode === 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshOverride() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshOverride() : \'\' \"><!--Datepickers --></date-range></div><!-- tower movement logs data grid actions --><div class=\"col-xs-12 col-md-2\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><!-- tower movement logs data grid --><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=towerMovementLogsService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() canned-sort=cannedSort><thead><tr><th translate class=text-nowrap sort=dayOfFlight>Day of Flight</th><th translate class=text-nowrap sort=departureTime>Dep Time</th><th translate class=text-nowrap sort=dateOfContact>Date of Contact</th><th translate class=text-nowrap sort=flightId>Flight Id</th><th translate class=text-nowrap sort=registration>Reg Number</th><th translate class=text-nowrap sort=aircraftType>A/C Type</th><th translate class=text-nowrap sort=operatorName>Operator Identifier</th><th translate class=text-nowrap sort=departureAerodrome>Dep Ad</th><th translate class=text-nowrap sort=departureContactTime>Dep Contact Time</th><th translate class=text-nowrap sort=destinationAerodrome>Dest Ad</th><th translate class=text-nowrap sort=destinationContactTime>Dest Contact Time</th><th translate class=text-nowrap sort=route>Route</th><th translate class=text-nowrap sort=flightLevel>Flight Level</th><th translate class=text-nowrap sort=flightCrew>Flight Crew</th><th translate class=text-nowrap sort=passengers>Passengers</th><th translate class=text-nowrap sort=flightCategory>Flight Category</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td class=text-nowrap>{{ item.day_of_flight | dateConverter }}</td><td>{{ item.departure_time }}</td><td class=text-nowrap>{{ item.date_of_contact | dateConverter }}</td><td>{{ item.flight_id }}</td><td>{{ item.registration }}</td><td>{{ item.aircraft_type }}</td><td>{{ item.operator_name }}</td><td>{{ item.departure_aerodrome }}</td><td>{{ item.departure_contact_time }}</td><td>{{ item.destination_aerodrome }}</td><td>{{ item.destination_contact_time }}</td><td class=text-nowrap>{{ item.route }}</td><td>{{ item.flight_level }}</td><td>{{ item.flight_crew }}</td><td>{{ item.passengers }}</td><td>{{ matchCategoryToCategoryListValue(item.flight_category) | translate }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=16 translate>There are no Tower Movement Logs data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><!-- create/edit tower movement log container --><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'tasks\'\" title=\"{{ \'Create a Tower Movement Log\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'tasks\'\" title=\"{{ \'Edit a Tower Movement Log\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_log_modify\')\"><!-- tower movement log form fields --><div class=row><div class=\"col-xs-12 col-md-6\"><label for=day_of_flight><span translate>Day of Flight</span>&nbsp;<span translate>({{ ::dateFormat }})</span></label><p class=input-group><date-picker id=day_of_flight name=dayOfFlight type=text ng-change=\"dateChanged(\'day_of_flight\', editable.day_of_flight)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.day_of_flight ng-blur=\"resolveAircraftType(editable.registration, editable.day_of_flight || editable.date_of_contact)\" is-open=towerDayFlight.open ng-attr-title=\"{{editable.day_of_flight ? \'\' : \'Please fill out this field\' | translate}}\" ng-disabled=\"editable.id !== null\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"towerDayFlight.open = !towerDayFlight.open\" ng-disabled=\"editable.id !== null\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=departure_time><span translate>Departure Time</span>&nbsp;<span translate>(<span tranlate>HHmm</span>)</span></label><input id=departure_time name=departureTime class=form-control type=text ng-model=editable.departure_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.departure_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^([01]\\d|2[0-3])?([0-5]\\d)$/ ng-disabled=\"editable.id !== null\" only-numbers></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=date_of_contact><span translate>Date of Contact</span> (<span translate>{{ ::dateFormat }}</span>)*</label><p class=input-group><date-picker id=date_of_contact name=dateOfContact type=text ng-change=\"dateChanged(\'date_of_contact\', editable.date_of_contact)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.date_of_contact ng-blur=\"resolveAircraftType(editable.registration, editable.day_of_flight || editable.date_of_contact)\" is-open=towerDateContact.open ng-attr-title=\"{{editable.date_of_contact ? \'\' : \'Please fill out this field\' | translate}}\" ng-disabled=\"editable.id !== null\" close-text=Close required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"towerDateContact.open = !towerDateContact.open\" ng-disabled=\"editable.id !== null\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_id>Flight Identifier *</label><input id=flight_id name=flightId class=form-control type=text ng-model=editable.flight_id maxlength=10 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input ng-model-options=\"{allowInvalid: true}\" ng-disabled=\"editable.id !== null\" required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=registration>Registration</label><input id=registration name=registration class=form-control ng-model=editable.registration type=text maxlength=7 minlength=2 ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false uppercase-input ng-model-options=\"{allowInvalid: true}\" ng-blur=\"resolveAircraftType(editable.registration, editable.day_of_flight || editable.date_of_contact)\"></div><div class=\"col-xs-12 col-md-6\"><label translate for=aircraft_type>{{\'Aircraft Type\' | translate}} *</label><dynamic-service-dropdown name=aircraftType ng-model=editable.aircraft_type id=aircraft_type dropdown-type=single service=::aircraftTypeManagementService method=findAllMinimalReturn is-required=::true options=\"item.aircraft_type as item.aircraft_type for item in list\"></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=operator_name><span translate>Operator Identifier</span></label><input id=operator_name name=operatorName class=form-control type=text ng-model=editable.operator_name maxlength=100 ng-trim=false uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label translate for=departure_aerodrome>Departure Aerodrome *</label><input id=departure_aerodrome name=departureAerodrome type=text class=form-control ng-model=editable.departure_aerodrome maxlength=100 ng-trim=false ng-model-options=\"{allowInvalid: true}\" ng-disabled=\"editable.id !== null\" only-letters uppercase-input required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=departure_contact_time><span translate>Departure Contact Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=departure_contact_time name=departureContactTime class=form-control type=text ng-model=editable.departure_contact_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.departure_contact_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^([01]\\d|2[0-3])?([0-5]\\d)$/ only-numbers></div><div class=\"col-xs-12 col-md-6\"><label translate for=destination_aerodrome>Destination Aerodrome *</label><input id=destination_aerodrome name=destinationAerodrome type=text class=form-control ng-model=editable.destination_aerodrome maxlength=100 ng-trim=false ng-model-options=\"{allowInvalid: true}\" only-letters uppercase-input required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=destination_contact_time><span translate>Destination Contact Time</span>&nbsp;(<span tranlate>HHmm</span>)</label><input id=destination_contact_time name=destinationContactTime class=form-control type=text ng-model=editable.destination_contact_time minlength=4 maxlength=4 ng-attr-title=\"{{editable.destination_contact_time < 2359 ? \'\' : \'Invalid time format\' | translate}}\" ng-pattern=/^([01]\\d|2[0-3])?([0-5]\\d)$/ only-numbers></div><div class=\"col-xs-12 col-md-6\"><label translate for=route>Route</label><input id=route class=form-control name=route ng-model=editable.route type=text uppercase-input></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label for=flight_level><span translate>Flight Level</span>&nbsp;<span translate>(<span tranlate>Fnnn</span>)</span></label><input id=flight_level class=form-control name=flightLevel type=text ng-model=editable.flight_level uppercase-input></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_crew>Flight Crew *</label><input id=flight_crew class=form-control name=flightCrew type=number ng-model=editable.flight_crew required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=passengers>Passengers *</label><input id=passengers class=form-control name=passengers type=number ng-model=editable.passengers required></div><div class=\"col-xs-12 col-md-6\"><label translate for=flight_category>Flight Category *</label><select id=flight_category name=flightCategory class=form-control ng-model=editable.flight_category ng-options=\"item.value as (item.name | translate) for item in flightCategories\" required></select></div></div><!-- tower movement log form errors --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><!-- tower movement log form actions --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div><!-- upload tower movement logs container --><div class=\"row margin-top-20\"><div class=col-xs-12><div class=box-container><box-header icon=\"\'tasks\'\" title=\"{{ \'Upload a Tower Movement Log\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=uploadForm onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'flight_log_modify\')\"><!-- tower movement logs upload fields --><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div><!-- tower movement logs upload feedback --><div class=row><div class=col-xs-12><upload-feedback><!-- Upload Feedback --></upload-feedback></div></div><!-- tower movement logs upload actions --><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-disabled=\"!editable.document_filename || !acceptedFileType\" ng-click=\"upload(\'PUT\', null, null, \'refreshOverride\'); form.$setUntouched(); reset();\">Upload</button></div></div></fieldset></form></div></div></div></div></div></div>");
$templateCache.put("app/partials/transactions/transactions.html","<div class=row ng-show=toggle><div class=col-xs-12><div class=box-container><box-header page-name=billing.transaction-management.form icon=\"\'exchange\'\" title=\"{{ editable.id !== null ? \'View a Transaction\' : \'Create a Transaction\' | translate }}\"></box-header><div class=box-content><form novalidate ng-hide=showInvoices action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"editable.id || !hasPermission(\'transaction_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-3\"><label translate for=account>Account *</label><dynamic-service-dropdown ng-model=editable.account id=account name=account dropdown-type=single service=::accountsService method=listAllCreditWorkflow is-required=::true options=\"account as account.name for account in list track by account.id\" ng-change=\"getAccountInvoicesAndTotal(editable.account.id); getCurrencyListByAccountId(editable.account.id)\" disabled=transactionFromInvoice></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><label translate for=description>Description *</label><input id=description name=description class=form-control type=text ng-model=editable.description required></div><div class=\"col-xs-12 col-md-3\"><label translate for=transaction-type>Transaction Type *</label><dynamic-service-dropdown ng-model=editable.transaction_type id=transaction-type name=transactionType dropdown-type=single class=text-capitalize service=::transactionTypesService is-required=true options=\"item as (item.name | translate) for item in list track by item.id\" ng-change=onTransactionTypeChange(editable) disabled=transactionFromInvoice></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-currency>Payment Currency</label><span ng-show=\"editable.payment_mechanism !== \'adjustment\'\">*</span><select id=payment-currency name=paymentCurrency class=form-control ng-model=editable.payment_currency ng-model-options=\"{ debounce: 400 }\" ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in fullCurrencyList | filter:{active:true} track by item.currency_code\" ng-change=\"updateExchangeRate(editable, true);\" ng-disabled=\"editable.payment_mechanism === \'adjustment\'\" ng-required=\"editable.payment_mechanism !== \'adjustment\'\"></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-amount>Payment Amount</label><span ng-show=\"editable.payment_mechanism !== \'adjustment\'\">*</span> <input id=payment-amount name=paymentAmount class=form-control type=number step=0.01 min=0 ng-model=editable.payment_amount ng-change=updateLocalAmount(); ng-disabled=\"editable.payment_mechanism === \'adjustment\' || transactionFromInvoice\" ng-required=\"editable.payment_mechanism !== \'adjustment\'\"></div><div class=\"col-xs-12 col-md-3\"><label translate for=currency>Invoice Currency *</label><select id=currency name=currency class=form-control ng-model=editable.currency ng-model-options=\"{ debounce: 400 }\" ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in currencyList track by item.currency_code\" ng-change=\"updateExchangeRate(editable, true);\" ng-disabled=transactionFromInvoice required></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-exchange-rate>Exchange Rate</label><input id=payment-exchange-rate name=paymentExchangeRate class=form-control type=text ng-model=paymentExchangeRate ng-required=\"editable.payment_mechanism !== \'adjustment\'\" disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=amount>Invoice Amount</label><input id=amount name=amount class=form-control type=number step=0.01 min=0 ng-model=editable.amount ng-change=updatePaymentAmount(); ng-required=\"editable.payment_mechanism !== \'adjustment\'\" ng-disabled=\"editable.payment_mechanism === \'adjustment\' || transactionFromInvoice\"></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-mechanism>Payment Mechanism *</label><select id=payment-mechanism name=paymentMechanism class=\"form-control text-capitalize\" ng-model=editable.payment_mechanism ng-options=\"(payment | translate) for payment in paymentMechanisms | filter : showPaymentMechanism\" ng-disabled=\"editable.transaction_type.name === \'debit\'\" ng-change=onPaymentMechanismChange(editable) required></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-reference-number>Payment Reference Number</label><span ng-show=\"editable.transaction_type.name !== \'debit\' && editable.payment_mechanism !== \'cash\' && editable.payment_mechanism !== \'adjustment\'\">*</span> <input id=payment-reference-number name=paymentReferenceNumber class=\"form-control text-capitalize\" type=text ng-model=editable.payment_reference_number ng-disabled=\"editable.transaction_type.name === \'debit\' || editable.payment_mechanism === \'cash\' || editable.payment_mechanism === \'adjustment\'\" autocomplete=cc-csc required></div><div class=\"col-xs-12 col-md-3\" ng-if=activeOrg.isKcaa><label translate for=kra_clerk_name>KRA Clerk\'s Name</label><span ng-show=\"editable.payment_mechanism === \'cash\'\">*</span> <input id=kra_clerk_name name=kra_clerk_name class=form-control type=text ng-model=editable.kra_clerk_name ng-required=\"editable.payment_mechanism === \'cash\' ? true : false\" ng-disabled=\"editable.payment_mechanism === \'adjustment\'\"></div><div class=\"col-xs-12 col-md-3\" ng-if=activeOrg.isKcaa><label translate for=kra_receipt_number>KRA Receipt Number</label><span ng-show=\"editable.payment_mechanism === \'cash\'\">*</span> <input id=kra_receipt_number name=kra_receipt_number class=form-control type=text ng-model=editable.kra_receipt_number ng-required=\"editable.payment_mechanism === \'cash\' ? true : false\" ng-disabled=\"editable.payment_mechanism === \'adjustment\'\"></div><div class=\"col-xs-12 col-md-3\" ng-if=isBankAccountSupported><label for=bank-account><span translate>Bank Account</span> <span ng-show=\"isPaymentMechanism(\'wire\', \'cheque\')\">*</span></label><input ng-if=\"editable.id !== null\" id=bank-account name=bankAccount class=form-control type=text value=\"{{ getBankAccountLabel(editable.bank_account_name, editable.bank_account_number) }}\" ng-required=\"isPaymentMechanism(\'wire\', \'cheque\')\"><dynamic-service-dropdown ng-if=\"editable.id === null\" id=bank-account name=bankAccount dropdown-type=single allow-empty=true empty-to-null service=::bankAccountManagementService method=getList options=\"item as $parent.$parent.getBankAccountLabel(item.name, item.number) for item in list track by item.id\" ng-model=editable.bank_account is-required=\"isPaymentMechanism(\'wire\', \'cheque\')\" disabled=\"!isPaymentMechanism(\'wire\', \'cheque\')\" ng-change=setEditableBankAccount(editable.bank_account)></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\" ng-if=isPaymentDateSupported><label for=payment-date><span translate>Payment Date</span> <span>({{ ::dateFormat | translate }})</span></label><p class=input-group><date-picker id=payment-date name=paymentDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=editable.payment_date is-open=payment_date.open ng-disabled=\"!isPaymentMechanism(\'wire\', \'cheque\')\" ng-change=\"updateExchangeRate(editable, true);\" close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"payment_date.open = !payment_date.open\" ng-disabled=\"!isPaymentMechanism(\'wire\', \'cheque\')\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p></div><div class=\"col-xs-12 col-md-3\"><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div></fieldset><fieldset ng-disabled=\"!hasPermission(\'transaction_modify\')\"><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button ng-if=!transactionFromInvoice translate class=\"btn btn-primary btn-create\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"showCreateWizard(editable); form.$setUntouched()\">Create</button> <button ng-if=transactionFromInvoice translate class=\"btn btn-primary btn-create\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched()\">Create</button></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form><div ng-show=\"showInvoices && !showCharges\"><div class=row><div class=col-xs-12><button translate class=\"btn btn-default btn-cancel pull-right\" ng-disabled=isDisabled ng-click=hideCreateWizard()>Cancel</button><!-- Not Adjusting, complete transaction --> <button translate ng-if=\"editable.payment_mechanism !== \'adjustment\'\" class=\"btn btn-primary btn-complete pull-right\" ng-disabled=\"isDisabled || (amountAvailable > 0 && data.total_elements > 0 && selectedInvoiceIds.length !== data.total_elements)\" ng-click=\"create(editable); form.$setUntouched();\">Complete</button><!-- Adjusting, continue after selecting item for adjustment --> <button translate ng-if=\"editable.payment_mechanism === \'adjustment\' && !excessToBePaid\" class=\"btn btn-primary btn-complete pull-right\" ng-click=\"showChargeWizard(editable); invoiceAdjusted.invoice_type !== \'non-aviation\' ? getFlightMovementsByInvoiceId(invoiceAdjusted.id)  : getLineItemsByInvoiceId(invoiceAdjusted.id); form.$setUntouched();\n                                invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type === \'unified-tax\' ? getAircraftRegistrationByBillingLedgerId(invoiceAdjusted.id)  : getLineItemsByInvoiceId(invoiceAdjusted.id)\" ng-disabled=!invoiceChecked>Continue</button><!-- Adjusting, unpaid invoices selected, complete adjustment --> <button class=\"btn btn-primary btn-complete pull-right\" ng-click=\"createNote(editable, charge); form.$setUntouched();\" ng-if=\"editable.payment_mechanism === \'adjustment\' && excessToBePaid\" ng-disabled=\"isDisabled || (amountAvailable > 0 && data.total_elements > 0 && selectedInvoiceIds.length !== data.total_elements)\">Complete</button></div></div><div class=row><div class=col-xs-12><p ng-if=\"editable.payment_mechanism !== \'adjustment\' || excessToBePaid\"><span translate>Account:</span> <b>{{ editable.account.name }}</b><br><span translate>Transaction Amount:</span> <b>{{ editable.amount | abs | number : editable.currency.decimal_places }} {{ editable.currency.currency_code }}</b><br><span translate>Total Outstanding {{ editable.currency.currency_code }}:</span> <b>{{ (totalAmountForAllInvoices - amountOwed) | number : editable.currency.decimal_places }}</b><br><span ng-if=\"(editable.amount | abs) < totalAmountForAllInvoices && !excessToBePaid\" class=text-warning><span translate>The payment amount of</span> <span>{{ editable.amount | abs }}</span> <span translate>does not total the amount of outstanding invoices</span> </span><span ng-if=\"(editable.amount | abs) > totalAmountForAllInvoices && !excessToBePaid\" class=text-warning><span translate>A payment amount of</span> <span>{{ editable.amount | abs | number : editable.currency.decimal_places }}</span> <span translate>exceeds the total amount of outstanding invoices.</span><br><span translate>The surplus will be applied to the account balance.</span> </span><span ng-if=\"(editable.amount | abs) > (totalAmountForAllInvoices - amountOwed) && excessToBePaid\" class=text-warning><span translate>The excess adjustment amount of</span> <span>{{ editable.amount | abs | number : editable.currency.decimal_places }}</span> <span translate>exceeds the total amount of outstanding invoices.</span><br><span translate>The surplus will be applied to the account balance.</span> </span><span ng-if=\"(editable.amount | abs) < (totalAmountForAllInvoices - amountOwed) && excessToBePaid\"><span translate>Please apply the excess adjustment amount of</span> <span>{{ editable.amount | abs | number : editable.currency.decimal_places }}</span> <span translate>to any outstanding invoices</span></span></p><p ng-if=\"editable.payment_mechanism === \'adjustment\' && !excessToBePaid\"><b><span translate>Select an invoice to adjust</span></b><br><span translate>Account:</span> <b>{{ editable.account.name }}</b><br><span translate>Total Outstanding:</span> <b>{{ totalAmountForAllInvoices | number : editable.currency.decimal_places }}</b><br></p><hr><p></p><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getInvoiceListSortQueryString table-sort=\"refreshInvoiceList(editable.account.id, editable.currency.id, data.number)\"><thead><tr><th translate class=text-nowrap>Select</th><th translate class=text-nowrap sort=invoiceNumber>Invoice Number</th><th translate class=text-nowrap sort=invoicePeriodOrDate>Invoice Date</th><th translate class=text-nowrap sort=invoiceType>Invoice Type</th><th translate class=text-nowrap sort=invoiceStateType>Status</th><th translate class=text-nowrap sort=paymentDueDate>Due Date</th><th translate class=\"text-right text-nowrap\" sort=invoiceAmount>Invoice Amount</th><th translate class=\"text-right text-nowrap\" sort=invoiceAmount>Invoice Currency</th><th translate class=\"text-right text-nowrap\" sort=amountOwing>Amount Owed</th><th ng-if=\"editable.payment_mechanism !== \'adjustment\' || excessToBePaid\" class=\"text-right text-nowrap\" translate>Amount to Apply</th></tr></thead><tbody><tr ng-repeat=\"invoice in invoices | orderBy:invoiceMatchFirst\" ng-class=\"{\'invoice-highlight\': invoiceMatchFirst(invoice) === 0}\"><td ng-if=\"editable.payment_mechanism !== \'adjustment\' || excessToBePaid\"><input type=checkbox ng-model=invoice.checked ng-checked=\"amounts !== undefined && amounts !== null && amounts[invoice.id] !== undefined\" ng-click=\"calculatePayments(invoice.id, invoice.amount_owing)\" ng-disabled=\"amountAvailable <= 0 && !amounts[invoice.id]\"></td><td ng-if=\"editable.payment_mechanism === \'adjustment\' && !excessToBePaid\"><input type=checkbox ng-model=invoice.checked ng-click=\"getCheckbox($index, invoice.id, invoice.checked, invoice.amount_owing); getInvoiceAdjusted(invoice.id);\"></td><td class=text-nowrap>{{ invoice.invoice_number }}</td><td class=text-nowrap>{{ invoice.invoice_period_or_date | dateConverter }}</td><td class=text-capitalize>{{ invoice.invoice_type.replace(\'-\', \'_\').toUpperCase() | translate }}</td><td class=text-capitalize>{{ invoice.invoice_state_type | translate }}</td><td>{{ invoice.payment_due_date | dateConverter }}</td><td class=text-right>{{ invoice.invoice_amount | number : editable.currency.decimal_places }}</td><td class=text-nowrap>{{invoice.invoice_currency.currency_code}}</td><td class=text-right>{{ invoice.amount_owing | number : editable.currency.decimal_places }}</td><td ng-if=\"editable.payment_mechanism !== \'adjustment\' || excessToBePaid\" class=\"text-right text-success\">{{ amounts[invoice.id] | abs | number : editable.currency.decimal_places }}</td></tr><tr ng-if=!invoices.length><td colspan=9><span translate>There are no active</span> {{ ::editable.currency.currency_name | translate }} ({{ ::editable.currency.currency_code}}) <span translate>invoices associated with this account.</span></td></tr></tbody></table></div><ul uib-pagination total-items=data.total_elements max-size=::20 items-per-page=data.size class=pagination-sm boundary-link-numbers=::true ng-change=\"refreshInvoiceList(editable.account.id, editable.currency.id, data.number)\" ng-model=data.number></ul></div></div></div><div ng-show=showCharges><div class=row><div class=col-xs-12><!-- Cancel an adjustment --> <button translate class=\"btn btn-default btn-cancel pull-right\" ng-click=hideCreateWizard()>Cancel</button><!-- Complete an adjustment, no excess amount available --> <button translate class=\"btn btn-primary btn-complete pull-right\" ng-click=\"createNote(editable, charge)\" ng-if=\"total <= amountOwed || editable.transaction_type.name == \'debit\'\" ng-disabled=disableCreateNote(charges)>Complete</button><!-- During adjustment, if excess amount, continue to list of unpaid invoices --> <button translate class=\"btn btn-primary pull-right\" ng-if=\"editable.payment_mechanism === \'adjustment\' && editable.transaction_type.name === \'credit\' && total > amountOwed\" ng-disabled=\"charges.length < 1\" ng-click=showExcessWizard(editable)>Continue</button></div></div><!-- Debit/Credit adjustment --><div class=row><div class=col-xs-12><p><span translate>Invoice #:</span> <b>{{ invoiceAdjusted.invoice_number }}</b><br><span translate>Amount Owed:</span> <b>{{ amountOwed | number : 2 }}</b><br><span translate>Operator:</span> <b>{{ editable.account.name }}</b><br><span translate>Adjustment Type:</span> <b class=text-capitalize>{{ editable.transaction_type.name | translate }}</b><br><span translate>Adjustment Amount:</span> <b>{{ total | number : 2 }}</b><br></p><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate ng-if=\"invoiceAdjusted.invoice_type === \'non-aviation\'\" class=text-nowrap>Aerodrome</th><th translate ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type !== \'unified-tax\'\" class=text-nowrap>Flight Id</th><th translate ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type === \'unified-tax\'\" class=text-nowrap>Registration Number</th><th translate class=text-nowrap>Description</th><th class=\"text-right text-nowrap\"><span translate>Charges</span> {{ invoiceAdjusted.invoice_currency.currency_code }}</th></tr></thead><tbody><tr ng-click=\"editCharges(item, $index)\" ng-repeat=\"item in charges track by $index\"><td ng-if=\"invoiceAdjusted.invoice_type === \'non-aviation\'\">{{ item.aerodrome }}</td><td ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type !== \'unified-tax\'\">{{ item.flight_id }}</td><td ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type === \'unified-tax\'\">{{item.registration_number}}</td><td>{{ item.charge_description | translate }}</td><td class=text-right>{{ item.charge_amount | number : 2 }}</td></tr><tr><td class=text-right colspan=2>Total:</td><td class=text-right>{{ getTotal() | number : 2 }}</td></tr></tbody></table></div><form novalidate action=# name=chargesForm onsubmit=\"return false\"><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><!-- Aviation invoice adjustment --><div class=row ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type !== \'unified-tax\'\"><div class=\"col-xs-12 col-md-6\"><label translate for=flight_id>Flight Id *</label><input id=flight_id name=flight_id class=form-control type=text ng-model=charge.flight_id uppercase-input required ng-disabled=\"editable.transaction_type.name === \'credit\'\"></div><div class=\"col-xs-12 col-md-6\"><label for=charge-amount><span translate>Charge Amount</span> ({{ invoiceAdjusted.invoice_currency.currency_code }}) *</label><input id=charge-amount name=charge-amount class=form-control type=number min=0 ng-model=charge.charge_amount required></div></div><div class=row ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type !== \'unified-tax\'\"><div class=\"col-xs-12 col-md-6\"><label translate for=charge-description>Charge Type *</label><select id=charge-description class=form-control required ng-model=charge.charge_description ng-change=setExternalSystemIdentifiers(charge.charge_description) ng-options=\"item.description as (item.description | translate) for item in chargeTypes\" ng-disabled=\"editable.transaction_type.name === \'credit\' && editable.payment_mechanism === \'adjustment\' && !charge.flight_id\"></select></div><div class=\"col-xs-12 col-md-6\"><label for=other-description><span translate>Description for Other Charges</span> <span ng-show=\"charge.charge_description === \'Other charges\'\">*</span></label><input id=other-description name=other-description class=form-control type=text ng-model=charge.other_description ng-required=\"charge.charge_description === \'Other charges\'\" ng-disabled=\"charge.charge_description !== \'Other charges\'\"></div></div><!-- Unified-Tax invoice adjustment --><div class=row ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\' && invoiceAdjusted.invoice_type === \'unified-tax\'\"><div class=\"col-xs-12 col-md-6\"><label translate for=registration_number>Registration Number *</label><input id=registration_number name=registration_number class=form-control type=text ng-model=aircraftRegistration.registration_number uppercase-input required ng-disabled=\"invoiceAdjusted.invoice_type != \'unified-tax\' && editable.transaction_type.name === \'credit\'\"></div><div class=\"col-xs-12 col-md-6\"><label for=charge-amount><span translate>Charge Amount</span> ({{ invoiceAdjusted.invoice_currency.currency_code }}) *</label><input id=charge-amount name=charge-amount class=form-control type=number min=0 ng-model=charge.charge_amount required></div></div><div class=row ng-if=\"invoiceAdjusted.invoice_type !== \'non-aviation\'&& invoiceAdjusted.invoice_type === \'unified-tax\'\"><div class=\"col-xs-12 col-md-6\"><label translate for=charge-description>Charge Type *</label><select id=charge-description class=form-control required ng-model=charge.charge_description ng-change=setExternalSystemIdentifiers(charge.charge_description) ng-options=\"item.description as (item.description | translate) for item in chargeTypes\" ng-disabled=\"editable.transaction_type.name === \'credit\' && editable.payment_mechanism === \'adjustment\' && (invoiceAdjusted.invoice_type != \'unified-tax\' && !charge.flight_id)\"></select></div></div><!-- Non-Aviation invoice adjustment --><div class=row ng-if=\"invoiceAdjusted.invoice_type === \'non-aviation\'\"><div ng-if=\"invoiceAdjusted.invoice_type === \'non-aviation\'\" class=\"col-xs-12 col-md-3\"><label translate for=aerodrome>Aerodrome *</label><input id=aerodrome name=aerodrome class=form-control type=text ng-model=charge.aerodrome maxlength=4 uppercase-input only-letters required ng-disabled=true></div><div class=\"col-xs-12 col-md-6\"><label translate for=charge-description>Description *</label><input id=charge-description class=form-control required ng-model=charge.charge_description ng-disabled=true></div><div class=\"col-xs-12 col-md-3\"><label for=charge-amount><span translate>Charge Amount</span> ({{ invoiceAdjusted.invoice_currency.currency_code }}) *</label><input id=charge-amount name=charge-amount class=form-control type=number min=0 ng-model=charge.charge_amount required></div></div><div class=row ng-show=\"invoiceAdjusted.id && (listFlightMovements || lineItems)\"><div class=\"col-xs-12 col-md-6 col-lg-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text empty-to-null ng-model=invoiceAdjustedTextFilter></div></div><!-- Flight Movements for Aviation invoice adjustment --><div class=row ng-show=\"invoiceAdjusted.id && listFlightMovements.length && invoiceAdjusted.invoice_type !== \'non-aviation\'\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=\"text-center text-nowrap middle\" sort=flightId>Flight Id</th><th translate class=\"text-center text-nowrap middle\" sort=dateOfFlight>Day of Flight</th><th translate class=\"text-center text-nowrap middle\" sort=depTime>Dep Time</th><th translate class=\"text-center text-nowrap middle\" sort=item18RegNum>Reg Number</th><th translate class=\"text-center text-nowrap middle\" sort=depAd>Dep Ad</th><th translate class=\"text-center text-nowrap middle\" sort=destAd>Dest Ad</th></tr></thead><tbody><tr ng-click=setFlightId(item) ng-repeat=\"item in listFlightMovements | filter: invoiceAdjustedTextFilter\"><td class=middle>{{ item.flight_id }}</td><td class=middle>{{ item.date_of_flight | dateConverter }}</td><td class=middle>{{ item.dep_time }}</td><td class=middle>{{ item.item18_reg_num }}</td><td class=middle>{{ item.dep_ad }}</td><td class=middle>{{ item.dest_ad }}</td></tr></tbody></table></div></div></div><!-- Aircraft Registration for Unified-Tax invoice adjustment --><div class=row ng-show=\"invoiceAdjusted.id &&  invoiceAdjusted.invoice_type === \'unified-tax\'\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=registrationNumber>Registration Number</th><th translate class=text-nowrap sort=registrationStartDate>Start Date</th><th translate class=text-nowrap sort=registrationExpiryDate>Expiry Date</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=aircraftType.aircraftType>Aircraft Type</th><th class=\"text-nowrap text-right\" sort=mtowOverride><span>{{ \'MTOW Override\' | translate }}&nbsp;({{ mtowUnitOfMeasure | translate }})</span></th><th translate class=text-nowrap sort=createdBySelfCare>Created By Self-Care</th></tr></thead><tbody><tr ng-click=setAircraftRegistration(item) ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in listAircraftRegstration\"><td class=text-nowrap>{{ item.registration_number }}</td><td class=text-nowrap>{{ item.registration_start_date | dateConverter }}</td><td class=text-nowrap>{{ item.registration_expiry_date | dateConverter }}</td><td class=text-nowrap>{{ item.account.name | translate }}</td><td class=text-nowrap>{{ item.aircraft_type.aircraft_type }}</td><td class=text-right>{{ item.mtow_override | weightConverter }}</td><td>{{ item.created_by_self_care }}</td></tr><tr ng-show=!list.length><td class=text-center translate colspan=7>There are no Aircraft Registration data</td></tr></tbody></table></div></div></div><!-- Line Items for Non-Aviation invoice adjustment --><div class=row ng-show=\"invoiceAdjusted.id && lineItems.length && invoiceAdjusted.invoice_type === \'non-aviation\'\"><div class=col-xs-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Aerodrome</th><th translate class=\"text-nowrap text-right\">Amount</th><th translate class=text-nowrap>Category</th><th translate class=text-nowrap>Charge Class</th><th translate class=text-nowrap>Description</th></tr></thead><tbody><tr ng-click=setAerodrome(item) ng-repeat=\"item in lineItems | filter: invoiceAdjustedTextFilter\"><td class=text-nowrap>{{ item.aerodrome.aerodrome_name }}</td><td class=\"text-nowrap text-right\">{{ item.amount | number: 2 }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.category }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.charge_class }}</td><td class=text-nowrap>{{ item.service_charge_catalogue.description }}</td></tr></tbody></table></div></div></div><!-- Add adjustment charges --><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"resetCharges(); chargesForm.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=chargesForm.$invalid ng-click=\"addCharges(charge); chargesForm.$setUntouched();\">Create</button> <button class=\"btn btn-primary btn-update\" translate ng-disabled=\"chargesForm.$invalid || chargeIndex === undefined\" ng-click=\"updateCharges(charge); chargesForm.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-disabled=\"chargesForm.$invalid || chargeIndex === undefined\" ng-click=\"deleteCharges(); chargesForm.$setUntouched();\">Delete</button></div></div></form></div></div></div></div></div></div></div><div class=row ng-class=\"{\'margin-top-20\': toggle}\" ng-hide=showCharges><div class=col-xs-12><div class=box-container><box-header toggle=toggle page-name=billing.transaction-management icon=\"\'exchange\'\" title=\"{{ \'Transactions\' | translate }}\"></box-header><div class=box-content><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\" ng-hide=toggle><!-- Error Handling --></ng-include><div class=row ng-show=exportSuccess><div class=col-xs-12><div class=\"alert alert-dismissible alert-icon alert-success\" role=alert><button type=button ng-click=\"exportSuccess = false\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-ok-sign icon\" aria-hidden=true></span> <strong translate>Response:</strong> <span translate>Successfully completed batch export!</span></div></div></div><div class=row><div class=\"col-xs-12 col-md-3\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text empty-to-null ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refreshList()\"></div><div class=\"col-xs-6 col-md-3\"><label translate for=account-filter>Account</label><dynamic-service-dropdown ng-model=accountFilter id=account-filter dropdown-type=single allow-empty=true service=::accountsService is-required=false method=findAllMinimalReturn options=\"item.id as (item.name | translate) for item in list\" ng-change=refreshList()></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-4\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\"><!--Datepickers --></date-range></div><div class=\"col-xs-12 col-md-2\"><form action=# name=formAction onsubmit=\"return false\" novalidate><div class=row><div class=col-xs-12><fieldset class=pull-right><legend class=sr-only translate>List Action</legend><button translate class=\"btn btn-primary\" ng-click=refreshList()>Refresh</button></fieldset><fieldset class=pull-right ng-disabled=\"!hasPermission(\'transaction_modify\')\" ng-if=exportSupport><legend class=sr-only translate>Transaction Action</legend><div class=\"dropdown export-dropdown\" ng-class=\"{\'open\': toggleExportDropdown}\" ng-init=\"toggleExportDropdown = false\"><button class=\"btn btn-primary dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=true ng-click=\"toggleExportDropdown = !toggleExportDropdown\" ng-disabled=exportInProcess><span translate>Export</span> <span class=caret></span></button><ul class=dropdown-menu role=button><li><a ng-click=\"exportAllTransactions(); toggleExportDropdown = false;\">All non-exported</a></li><li ng-class=\"{ \'disabled\': !isSelectedItems(selectedItems) }\"><a ng-click=\"!isSelectedItems(selectedItems) || exportSelectedTransactions(selectedItems); toggleExportDropdown = false;\">Selected only</a></li></ul></div></fieldset></div></div></form></div></div><div class=row ng-show=exportSupport><div class=\"col-xs-12 form-group-inline\"><div class=checkbox><label><input id=exported-filter type=checkbox ng-model=exportedFilter ng-change=refreshList()> <span translate>Show only non-exported transactions</span></label></div></div></div><div class=row ng-show=interestInvoiceError.length><div class=col-xs-12><div class=error-handling-container><div class=\"alert alert-dismissible alert-danger alert-icon\" role=alert><button id=error_button type=button ng-click=\"interestInvoiceError = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <span translate>Could not create an interest invoice due to missing data</span><div ng-repeat=\"item in interestInvoiceError\"><div><span translate>Overdue invoice number</span>: {{item.invoice_number}}</div><ul><li ng-show=item.missing_interest_rate_on_date>{{\'No interest rate found on\' | translate}} {{item.missing_interest_rate_on_date}}</li><li ng-show=item.missing_exchange_rate_on_date>{{\'No exchange rate found between\' | translate}} {{item.from_currency}} {{\'and\' | translate}} {{item.to_currency}} {{\'on\' | translate}} {{item.missing_exchange_rate_on_date}}</li></ul></div></div></div></div></div><div class=row><div class=col-xs-12><div id=transactions class=\"table-responsive scroll-maintain-position\" export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=transactionsService box-header=1><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshList()><thead><tr><th translate class=\"text-nowrap text-center\" ng-if=exportSupport>Select</th><th translate class=\"text-nowrap text-center\">Receipt</th><th translate class=text-nowrap sort=receiptNumber>Number</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=transactionDateTime>Date/Time</th><th translate class=text-nowrap sort=description>Description</th><th translate class=text-nowrap sort=transactionType.name>Type</th><th translate class=\"text-nowrap text-right\" sort=amount>Amount</th><th translate class=text-nowrap sort=currency.currencyCode>Currency</th><th translate class=\"text-nowrap text-right\" sort=exchangeRate>Exchange USD</th><th translate class=\"text-nowrap text-right\" sort=exchangeRateToAnsp>Exchange ANSP</th><th translate class=\"text-nowrap text-right\" sort=balance>Balance</th><th translate class=\"text-nowrap text-center\" sort=balance>Balance Currency</th><th translate class=\"text-nowrap text-right\" sort=paymentReferenceNumber>Payment Reference Number</th><th translate class=\"text-nowrap text-right\" sort=paymentMechanism>Payment Mechanism</th><th translate class=text-nowrap sort=bankAccountName,bankAccountNumber ng-if=isBankAccountSupported export-table-suffix=Name,Number>Bank Account</th><th translate class=text-nowrap sort=exported ng-if=exportSupport>Exported</th><th translate class=\"text-nowrap text-center\">Approval Document</th><th translate class=\"text-nowrap text-center\">Supporting Document</th></tr></thead><tbody><tr ng-click=edit(item) ng-class=\"{\'highlight\': editable.id === item.id}\" ng-init=setExportSupportMechanism(item.payment_mechanism) ng-repeat-start=\"item in list\"><td class=text-center ng-if=exportSupport><input type=checkbox title=\"{{ \'select for export\' | translate }}\" ng-model=selectedItems[item.id] ng-disabled=isExported(item) ng-if=isExportSupport(item)></td><td class=\"text-center text-nowrap\"><download-oauth2 url=\"reports/transaction-receipt?transactionId={{item.id}}\" error=error ng-if=item.has_receipt_document></download-oauth2></td><td class=text-nowrap>{{ item.receipt_number }}</td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.transaction_date_time | dateConverter: \'HH:mm\' }}</td><td class=text-nowrap><span ng-if=\"item.description && item.description.split(\';\')[1] && item.description.split(\';\')[1].trim().length > 0\" style=\"cursor:pointer; display:inline-block; margin-right:6px\" ng-click=\"toggleNoteRow(item); $event.stopPropagation();\"><i class=fa ng-class=\"openedNoteRow === item.id ? \'fa-info-circle\' : \'fa-info\'\" style=\"color: #2196f3; font-size: 14px; vertical-align: middle\"></i> </span>{{ item.description ? item.description.split(\';\')[0] : \'\' }}</td><td class=text-capitalize>{{ item.transaction_type.name | translate }}</td><td class=text-right>{{ item.amount | abs | number : 2 }}</td><td>{{ item.currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-right>{{ item.balance | number : 2 }}</td><td class=text-right>{{ item.currency.currency_code}}</td><td>{{ item.payment_reference_number }}</td><td class=text-nowrap>{{ item.payment_mechanism | translate }}</td><td class=text-nowrap ng-if=isBankAccountSupported>{{ ::getBankAccountLabel( item.bank_account_name , item.bank_account_number ) }}</td><td ng-if=exportSupport>{{ isExportSupport(item) ? isExported(item) : \'\' | translate }}</td><td class=text-center><download-oauth2 ng-show=item.has_approval_document url=\"transactions/{{ item.id }}/download/approval\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td><td class=text-center><download-oauth2 ng-show=item.has_supporting_document url=\"transactions/{{ item.id }}/download/supporting\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td></tr><tr ng-if=\"openedNoteRow === item.id && item.description && item.description.split(\';\')[1] && item.description.split(\';\')[1].trim().length > 0\" ng-repeat-end><td colspan=4></td><td colspan=1 class=note-drawer><div class=note-bubble><button class=\"btn btn-xs btn-default pull-right\" ng-click=toggleNoteRow(item)>Close</button><div class=note-title><i class=\"fa fa-info-circle\"></i></div><div class=note-content>{{ item.description.split(\';\')[1] }}</div></div></td><td colspan=14></td></tr><tr ng-show=!list.length><td class=text-center colspan=\"{{ 16 + (exportSupport ? 1 : 0) + (isBankAccountSupported ? 1: 0) }}\" translate>There are no Transactions data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshList() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div ng-show=\"editable.id !== null && listOfApprovals !== null\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=\"Related Approvals\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=!listOfApprovals.length><span translate>There are no Transaction Approvals related to this transaction</span></div><div ng-if=listOfApprovals.length><div id=transaction-approvals class=\"table-responsive scroll-maintain-position\" export-table service=transactionsService box-header=2 back-end-export=true endpoint-param=/getTransactionApprovalsByTransactionId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=action>Action</th><th translate class=text-nowrap sort=approverName>Approver Name</th><th translate class=text-nowrap sort=approvalLevel>Approval Level</th><th translate class=text-nowrap sort=approvalDateTime>Approval Date/Time</th><th translate class=text-nowrap sort=approvalNotes>Approval Notes</th></tr></thead><tbody><tr ng-repeat=\"item in listOfApprovals | orderBy:\'approval_date_time\'\"><td translate>{{ item.action }}</td><td>{{ item.approver_name }}</td><td>{{ item.approval_level }}</td><td>{{ item.approval_date_time | dateConverter: \'HH:mm\' }}</td><td>{{ item.approval_notes }}</td></tr></tbody></table></div></div></div></div></div></div><div ng-show=\"editable.id !== null && listOfTransactionPayments !== null\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=\"Transaction Payments\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-if=\"!listOfTransactionPayments.content.length || listOfTransactionPayments.content === undefined\"><span translate>There are no Transaction Payments related to this transaction</span></div><div ng-if=listOfTransactionPayments.content.length><div id=transaction-payments class=\"table-responsive scroll-maintain-position\" export-table box-header=3 service=transactionsService back-end-export=true endpoint-param=/getTransactionPaymentsByTransactionId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=billingLedger.invoiceNumber>Invoice Number</th><th translate class=\"text-nowrap text-right\" sort=amount>Amount</th><th translate class=\"text-nowrap text-right\" sort=currency.currencyCode>Currency</th><th translate class=\"text-nowrap text-right\" sort=exchangeRate>Exchange USD</th><th translate class=\"text-nowrap text-right\" sort=exchangeRateToAnsp>Exchange ANSP</th><th translate class=text-nowrap sort=isAccountCredit>Account Credit</th></tr></thead><tbody><tr ng-repeat=\"item in listOfTransactionPayments.content\"><td class=text-nowrap>{{ item.billing_ledger.invoice_number }}</td><td class=\"text-nowrap text-right\">{{ item.amount | abs | number: 2 }}</td><td class=\"text-nowrap text-right\">{{ item.currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / item.exchange_rate : item.exchange_rate) | evenRound: 5 | number: 5 }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? item.exchange_rate_to_ansp : 1 / item.exchange_rate_to_ansp) | evenRound: 5 | number: 5 }}</td><td class=text-nowrap>{{ item.is_account_credit | translate }}</td></tr></tbody></table></div></div><ul ng-show=listOfTransactionPayments.content.length uib-pagination total-items=listOfTransactionPayments.total_elements ng-change=\"refresh({ filter: filter, page: listOfInvoices.number }, getSortQueryString())\" max-size=::20 items-per-page=listOfTransactionPayments.size ng-model=listOfTransactionPayments.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div ng-show=\"editable.id !== null && listOfInvoices !== null\" class=\"box-container margin-top-20\"><box-header icon=\"\'book\'\" title=Invoices></box-header><div class=box-content><div class=row><div class=col-xs-12><div translate ng-if=\"!listOfInvoices.content.length || listOfInvoices.content === undefined\">There are no Invoices related to this transaction</div><div ng-if=listOfInvoices.content.length><div id=invoices class=\"table-responsive scroll-maintain-position\" export-table back-end-export=true box-header=4 service=transactionsService endpoint-param=/getBillingLedgersByTransactionId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap>Actions</th><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=invoiceNumber>Invoice Number</th><th translate class=text-nowrap sort=invoicePeriodOrDate>Invoice Date</th><th translate class=text-nowrap sort=invoiceType>Invoice Type</th><th translate class=text-nowrap sort=invoiceStateType>Status</th><th translate class=text-nowrap sort=paymentDueDate>Payment Due Date</th><th translate class=text-nowrap sort=user.name>Created By</th><th translate class=\"text-nowrap text-right\" sort=invoiceAmount>Invoice Amount</th><th translate class=text-nowrap sort=invoiceCurrency.currencyCode>Invoice Currency</th><th translate class=\"text-nowrap text-right\" sort=invoiceExchange>Exchange USD</th><th translate class=text-nowrap sort=invoiceDateOfIssue>Invoice Date of Issue</th><th translate class=text-nowrap sort=exported>Exported</th></tr></thead><tbody><tr ng-repeat=\"item in listOfInvoices.content\"><td class=text-center><download-oauth2 url=/billing-ledgers/{{item.id}}/download? error=error></download-oauth2></td><td class=text-nowrap>{{ item.account.name }}</td><td class=text-nowrap>{{ item.invoice_number }}</td><td class=text-nowrap>{{ item.invoice_period_or_date | dateConverter}}</td><td class=text-nowrap>{{ item.invoice_type.replace(\'-\', \'_\').toUpperCase() | translate }}</td><td class=text-nowrap>{{ item.invoice_state_type.toUpperCase() | translate }}</td><td class=text-nowrap>{{ item.payment_due_date | dateConverter }}</td><td class=text-nowrap>{{ item.user.name }}</td><td class=\"text-nowrap text-right\">{{ item.invoice_amount | number: 2 }}</td><td class=text-nowrap>{{ item.invoice_currency.currency_code }}</td><td class=\"text-nowrap text-right\">{{ (inverseExchange ? 1 / item.invoice_exchange : item.invoice_exchange) | evenRound: 5 | number: 5 }}</td><td class=text-nowrap>{{ item.invoice_date_of_issue | dateConverter }}</td><td class=text-nowrap>{{ item.exported | translate }}</td></tr></tbody></table></div></div><ul ng-show=listOfInvoices.content.length uib-pagination total-items=listOfInvoices.total_elements ng-change=refreshList() max-size=::20 items-per-page=listOfInvoices.size ng-model=listOfInvoices.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/transactions-pending/transactions-pending.html","<div class=row ng-show=toggle><div class=col-xs-12><!-- edit pending transaction container --><div class=box-container><box-header icon=\"\'exchange\'\" title=\"{{ \'Edit a Pending Transaction\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><!-- pending transaction form fields --><fieldset ng-disabled=\"!hasPermission(\'transaction_pending_modify\')\"><legend class=sr-only translate>Edit a Pending Transaction</legend><div class=\"row row-responsive\"><!-- modification of main fields are not allowed --><div class=\"col-xs-12 col-md-3\"><label translate for=account>Account</label><dynamic-service-dropdown ng-model=editable.account id=account name=account dropdown-type=single service=::accountsService method=listAllCreditWorkflow options=\"account as account.name for account in list track by account.id\" disabled=true></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><label translate for=description>Description</label><input id=description name=description class=form-control type=text ng-model=editable.description disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=transaction-type>Transaction Type</label><dynamic-service-dropdown ng-model=editable.transaction_type id=transaction-type name=transactionType dropdown-type=single disabled=true class=text-capitalize service=::transactionTypesService options=\"item as (item.name | translate) for item in list track by item.id\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-currency>Payment Currency</label><select id=payment-currency name=paymentCurrency class=form-control ng-model=editable.payment_currency disabled=disabled ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in currencyList | filter:{active:true} track by item.currency_code\"></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-amount>Payment Amount</label><input id=payment-amount name=paymentAmount class=form-control type=number ng-value=absoluteValue(editable.payment_amount) disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=currency>Local Currency</label><select id=currency name=currency class=form-control ng-model=editable.local_currency disabled=disabled ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in currencyList track by item.currency_code\"></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-exchange-rate>Exchange Rate</label><input id=payment-exchange-rate name=paymentExchangeRate class=form-control type=text ng-model=editable.payment_exchange_rate disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=amount>Local Amount</label><input id=amount name=amount class=form-control type=number step=0.01 min=0 ng-value=absoluteValue(editable.local_amount) disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-mechanism>Payment Mechanism</label><select id=payment-mechanism name=paymentMechanism class=\"form-control text-capitalize\" ng-model=editable.payment_mechanism ng-options=\"(payment | translate) for payment in paymentMechanisms\" disabled=disabled></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-reference-number>Payment Reference Number</label><input id=payment-reference-number name=paymentReferenceNumber class=\"form-control text-capitalize\" type=text disabled=disabled ng-model=editable.payment_reference_number></div><!-- KRA fields do not exist on pending transactions but should be shown anyway for continuity --><div class=\"col-xs-12 col-md-3\" ng-if=activeOrg.isKcaa><label translate for=kra_clerk_name>KRA Clerk\'s Name</label><input id=kra_clerk_name name=kra_clerk_name class=form-control type=text disabled=disabled></div><div class=\"col-xs-12 col-md-3\" ng-if=activeOrg.isKcaa><label translate for=kra_receipt_number>KRA Receipt Number</label><input id=kra_receipt_number name=kra_receipt_number class=form-control type=text disabled=disabled></div><!-- supporting document is the only editable field if permissions permit --><div class=\"col-xs-12 col-md-3\"><ng-include src=\"\'app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html\'\"></ng-include></div></div></fieldset><!-- pending transaction form actions --><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-reset\" ng-click=\"resetForm(); form.$setUntouched();\">Clear</button> <button translate type=button class=\"btn btn-primary btn-update\" ng-disabled=\"!editable.id || !editable.document || form.$invalid\" ng-show=\"hasPermission(\'transaction_pending_modify\')\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"upload(\'PUT\', [editable.id], editable, \'refresh\'); resetForm(); form.$setUntouched();\">Update</button></div></div><!-- pending transaction form errors --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></form></div></div></div></div><div class=row ng-class=\"{\'margin-top-20\': toggle}\"><div class=col-xs-12><!-- pending transactions container --><div class=box-container><box-header page-name=billing.pending-transaction-management toggle=toggle icon=\"\'exchange\'\" title=\"{{ \'Pending Transactions\' | translate }}\"></box-header><div class=box-content><!-- pending transactions approval fields --><div class=row><div class=\"col-xs-12 col-lg-6\"><fieldset ng-disabled=\"!approval_document_required || !hasPermission(\'transaction_pending_modify\')\"><legend class=sr-only translate>Approval document required</legend><label for=approval-document-filename><span>{{ \'Select an approval document to attach to the transaction\' | translate }} ({{pattern}})</span> <span ng-show=approval_document_required>*</span></label><div class=input-group><input id=approval-document-filename class=form-control ng-model=approval_document_filename type=text> <span class=input-group-btn><button type=button class=\"btn btn-default\" ngf-select=parseApprovalDocument($file) ngf-accept=\"\'{{ pattern }}\'\"><i class=\"fa fa-upload\" aria-hidden=true></i></button></span></div><!-- check \'approvalDocumentAcceptedFileType\' explicitly for false because value is undefined or null on page load --><p ng-if=\"approval_document && approvalDocumentAcceptedFileType === false\" class=text-danger><span translate>Invalid file type: File must be a</span> <span>{{pattern}}</span> <span translate>file.</span></p></fieldset></div><div class=\"col-xs-12 col-lg-6\"><label for=notes><span translate>Notes</span></label><input id=notes name=notes class=form-control ng-model=notes></div></div><!-- pending transactions approval actions --><div class=row><div class=col-xs-12><button translate class=\"btn btn-primary\" ng-click=approve(notes) ng-disabled=\"!can_approve || (approval_document_required && (!approval_document || !approval_document_filename || approvalDocumentAcceptedFileType === false)) \n                || !hasPermission(\'transaction_pending_modify\')\">Approve</button> <button ng-if=notes translate class=\"btn btn-primary\" ng-click=reject(notes) ng-disabled=\"!can_reject || !hasPermission(\'transaction_pending_modify\')\">Reject</button> <button ng-if=!notes translate class=\"btn btn-primary\" ng-click=showWarning() ng-disabled=\"!can_reject || !hasPermission(\'transaction_pending_modify\')\">Reject</button></div></div><!-- pending transactions approval errors --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\" ng-show=!toggle><!-- Error Handling --></ng-include><!-- pending transactions data grid filters and actions --><div class=row><div class=col-xs-4><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=col-xs-4><label translate for=filter>Approval Level Filter</label><select id=filter class=form-control ng-model=filter ng-change=refresh() ng-options=\"l.approval_name as (l.approval_name | translate)  for l in levels\"><option translate value=\"\"></option></select></div><div class=col-xs-4><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><!-- pending transactions data grid --><div class=row><div class=col-xs-12><div id=pending-transactions class=\"table-responsive scroll-maintain-position\" export-table sort-query-string=getSortQueryString() service=transactionsPendingService box-header=1 query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=description>Description</th><th translate class=text-nowrap sort=transactionDateTime>Date / Time</th><th translate class=text-nowrap sort=transactionType.name>Type</th><th translate class=\"text-nowrap text-right\" sort=paymentAmount>Amount</th><th translate class=text-nowrap sort=currency>Currency</th><th translate class=\"text-nowrap text-right\" sort=exchangeRateToUsd>Exchange USD</th><th translate class=text-nowrap sort=paymentReferenceNumber>Payment Ref. Number</th><th translate class=text-nowrap sort=paymentMechanism>Payment Mechanism</th><th translate class=text-nowrap sort=currentApprovalLevel.approvalName>Approval Level</th><th translate class=text-nowrap sort=previousApprovalLevel.approvalName>Previous Action</th><th translate class=\"text-nowrap text-center\">Approval Document</th><th translate class=\"text-nowrap text-center\">Supporting Document</th></tr></thead><tbody><tr ng-class=\"{ \'highlight\': editable.id === item.id }\" ng-click=\"edit(item); selectedItem(item);\" ng-repeat=\"item in list\"><td>{{ item.account.name }}</td><td>{{ item.description }}</td><td class=text-nowrap>{{ item.transaction_date_time | dateConverter: \'HH:mm\' }}</td><td translate class=text-capitalize>{{ item.transaction_type.name }}</td><td class=text-right>{{ item.payment_amount | customRound: roundingAv | number: item.payment_currency.decimal_places }}</td><td>{{ item.payment_currency.currency_code}}</td><td class=text-right>{{ (inverseExchange ? 1 / item.exchange_rate_to_usd : item.exchange_rate_to_usd) | evenRound: 5 | number: 5}}</td><td>{{ item.payment_reference_number }}</td><td translate class=text-capitalize>{{ item.payment_mechanism }}</td><td translate class=text-capitalize>{{ item.current_approval_level.approval_name }}</td><td>{{ item.previous_approval_level.approval_name || \'N/A\' }}</td><td class=text-center><download-oauth2 ng-show=item.approval_document_name url=\"pending-transactions/{{ item.id }}/download/approval\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td><td class=text-center><download-oauth2 ng-show=\" item.supporting_document_name\" url=\"pending-transactions/{{ item.id }}/download/supporting\" class-used=\"btn btn-primary btn-generate btn-sm\"></download-oauth2></td></tr><tr ng-show=!list.length><td translate class=text-center colspan=12>There are no Pending Transactions</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div class=row ng-if=selected style=\"margin-top: 10px\"><div class=col-xs-12><!-- pending transaction related approvals container --><div class=box-container><box-header icon=\"\'map-pin\'\" title=\"{{ \'Related Approvals\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-show=!approvals.length><span translate>There are no Related Approvals</span></div><div ng-show=approvals.length id=transaction-approvals class=\"table-responsive scroll-maintain-position\" export-table service=transactionsPendingService box-header=2 back-end-export=true endpoint-param=/getTransactionApprovalsByPendingTransactionId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=action>Action</th><th translate class=text-nowrap sort=approverName>Approver Name</th><th translate class=text-nowrap sort=approvalLevel>Approval Level</th><th translate class=text-nowrap sort=approvalDateTime>Approval Date/Time</th><th translate class=text-nowrap sort=approvalNotes>Approval Notes</th></tr></thead><tbody><tr ng-repeat=\"item in approvals | orderBy:\'approval_date_time\'\"><td translate>{{ item.action }}</td><td>{{ item.approver_name }}</td><td>{{ item.approval_level }}</td><td>{{ item.approval_date_time | dateConverter: \'HH:mm\' }}</td><td>{{ item.approval_notes }}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=row ng-if=selected style=\"margin-top: 10px\"><div class=col-xs-12><!-- pending transaction related invoices container --><div class=box-container><box-header icon=\"\'map-pin\'\" title=\"{{ \'Related Invoices\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-show=!invoices.length><span translate>There are no Related Invoices</span></div><div ng-show=invoices.length class=\"table-responsive scroll-maintain-position\" export-table box-header=3 service=transactionsPendingService back-end-export=true endpoint-param=/getInvoicesByPendingTransactionId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=account.name>Account</th><th translate class=text-nowrap sort=invoiceNumber>Invoice Number</th><th translate class=text-nowrap sort=invoicePeriodOrDate>Invoice Date</th><th translate class=text-nowrap sort=invoiceType>Invoice Type</th><th translate class=text-nowrap sort=invoiceStateType>Status</th><th translate class=text-nowrap sort=invoiceAmount>Invoice Amount</th><th translate class=text-nowrap sort=invoiceCurrency.currencyCode>Invoice Currency</th><th translate class=\"text-nowrap text-right\" sort=invoiceExchange>Exchange USD</th><th translate class=text-nowrap sort=invoiceDateOfIssue>Invoice Date of Issue</th></tr></thead><tbody><tr ng-repeat=\"item2 in invoices | limitTo : pagination.size : (invoices.number * pagination.size) - pagination.size\"><td>{{ item2.account.name }}</td><td>{{ item2.invoice_number }}</td><td>{{ item2.invoice_period_or_date | dateConverter }}</td><td>{{ item2.invoice_type }}</td><td>{{ item2.invoice_state_type | translate }}</td><td>{{ item2.invoice_amount | number: item2.invoice_currency.decimal_places }}</td><td>{{ item2.invoice_currency.currency_code }}</td><td class=text-right>{{ (inverseExchange ? 1 / item2.invoice_exchange : item2.invoice_exchange) | evenRound: 5 | number: 5}}</td><td>{{ item2.invoice_date_of_issue | dateConverter }}</td></tr></tbody></table></div><ul uib-pagination total-items=invoices.length max-size=::20 items-per-page=pagination.size ng-model=invoices.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div><div class=row ng-if=selected style=\"margin-top: 10px\"><div class=col-xs-12><!-- pending transaction charge adjustments container --><div class=box-container><box-header icon=\"\'map-pin\'\" title=\"{{ \'Charges Adjustments\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-12><div ng-show=!charges.length><span translate>There are no Charges Adjustments</span></div><div ng-show=charges.length class=\"table-responsive scroll-maintain-position\" export-table box-header=4 service=transactionsPendingService back-end-export=true endpoint-param=/getChargesAdjustmentsByPendingTransactionId/{{editable.id}}><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=text-nowrap sort=date>Date of Flight</th><th translate class=text-nowrap sort=flightId>Flight ID</th><th translate class=text-nowrap sort=aerodrome>Aerodrome</th><th translate class=text-nowrap sort=invoiceType>Charge Type</th><th translate class=text-nowrap sort=chargeDescription>Details</th><th translate class=text-nowrap sort=chargeAmount>Charge Amount</th></tr></thead><tbody><tr ng-repeat=\"item3 in charges | limitTo : pagination.size : (charges.number * pagination.size) - pagination.size\"><td>{{ (item3.date | dateConverter) || \'N/A\' }}</td><td>{{ item3.flight_id || \'N/A\' }}</td><td>{{ item3.aerodrome }}</td><td>{{ item3.invoice_type | translate }}</td><td>{{ item3.charge_description | translate }}</td><td>{{ item3.charge_amount | number: decimalPlaces }}</td></tr></tbody></table></div><ul uib-pagination total-items=charges.length max-size=::20 items-per-page=pagination.size ng-model=charges.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div></div>");
$templateCache.put("app/partials/transactions-workflow/transactions-workflow.html","<div class=row><div class=col-xs-12><div class=box-container><box-header page-name=management.transaction-workflow-management icon=\"\'exchange\'\" title=\"{{ \'Transaction Approval Workflow Steps\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-3><label translate for=steps>Number of Steps</label><select ng-disabled=\"!hasPermission(\'approval_workflow_modify\')\" id=steps name=steps class=form-control ng-model=newSteps ng-options=\"l as l for l in [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21]\"></select></div><div class=col-xs-3><button ng-disabled=\"!hasPermission(\'approval_workflow_modify\')\" translate class=\"btn btn-primary\" property=upper_limit popup popup-text=\"Are you sure? This will delete any existing Transaction Workflow Steps.\" popup-confirm=createNewWorkflow(newSteps);>Create</button></div></div></div></div></div></div><div class=row style=\"margin-top: 20px\"><div class=col-xs-12><div class=box-container><box-header ng-if=!createNew icon=\"\'exchange\'\" title=\"{{ \'Edit Existing Transaction Approval Workflow Steps\' | translate }}\"></box-header><box-header ng-if=createNew icon=\"\'exchange\'\" title=\"{{ \'Create New Transaction Approval Workflow Steps\' | translate }}\"></box-header><div class=box-content><div class=row><div class=col-xs-8><button ng-disabled=\"list.length > 20 || !hasPermission(\'approval_workflow_modify\')\" translate class=\"btn btn-primary\" ng-click=addNewLevel();>Add Level</button> <button ng-disabled=\"list.length < 3 || !hasPermission(\'approval_workflow_modify\')\" translate class=\"btn btn-primary\" ng-click=removeExistingLevel();>Remove Level</button> <button ng-disabled=\"!hasPermission(\'approval_workflow_modify\')\" translate class=\"btn btn-primary\" ng-click=refreshAll();>Reload Levels</button></div><div class=col-xs-4><label translate for=aircraft-type>Require Approval Document</label><select id=approval_document_level name=approval_document_level class=form-control ng-model=approval_document_level ng-options=\"item as item.approval_name for item in list track by item.level\" ng-disabled=\"!hasPermission(\'approval_workflow_modify\')\" ng-change=updateApprovalDocumentLevel(approval_document_level)><option value=\"\" translate>None Required</option></select></div></div><div class=row><div class=col-xs-12><div class=table-responsive><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'approval_workflow_modify\')\"><div class=table-responsive export-table sort-query-string=getSortQueryString() service=transactionsWorkflowService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate class=\"text-center text-nowrap\">Level</th><th translate class=\"text-center text-nowrap\">Status Type</th><th translate class=\"text-center text-nowrap\">Approval Name</th><th translate class=\"text-center text-nowrap\">Approval Group</th><th translate class=\"text-center text-nowrap\">Threshold Amount</th><th translate class=\"text-center text-nowrap\">Threshold Currency</th><th translate class=\"text-center text-nowrap\">Approval Under</th><th translate class=\"text-center text-nowrap\">Approval Equal Or Over</th><th translate class=\"text-center text-nowrap\">Rejected</th><th translate class=\"text-center text-nowrap\">Delete Rejected</th></tr></thead><tbody><tr ng-repeat=\"item in list track by $index\" ng-class=\"{\'highlight--danger\': erroredLevel.includes(item.level) }\"><td class=text-center>{{ item.level }}</td><td class=text-center>{{ item.status_type | translate }}</td><td class=text-justify><input id=approval_name name=approval_name class=form-control ng-model=item.approval_name type=text></td><td class=text-justify><select id=approval_group name=approval_group class=form-control ng-model=item.approval_group.id ng-options=\"role.id as role.name for role in roles\" ng-change=\"updateItemData(roles, \'approval_group\', item.approval_group.id, $index);\"></select></td><td class=text-right><input ng-if=\"$index < steps-1\" id=threshold_amount name=threshold_amount class=form-control ng-model=item.threshold_amount type=number min=0></td><td class=text-justify><select ng-if=\"$index < steps-1\" id=threshold_currency name=threshold_currency class=form-control ng-model=item.threshold_currency.id ng-options=\"c.id as ((c.currency_name | translate) + \' (\' + c.currency_code + \')\') for c in fullCurrencyList | filter:{active:true}\" ng-change=\"updateItemData(fullCurrencyList, \'threshold_currency\', item.threshold_currency.id, $index);\"></select></td><td class=text-justify><select ng-if=\"$index < steps-1 && list[$index].threshold_amount >= 0\" style=\"width: 75%\" id=approval_under_level name=approval_under_level class=form-control ng-model=item.approval_under_level ng-options=\"l.level as l.approval_name for l in list | hideLower: $index\" ng-change=\"updateItemApproval(\'approval_under_level\', item.approval_under_level, $index);\"></select></td><td class=text-justify><select ng-if=\"$index < steps-1 && list[$index].threshold_amount >= 0\" id=approval_over_level name=approval_over_level class=form-control ng-model=item.approval_over_level ng-options=\"l.level as l.approval_name for l in list | hideLower: $index\" ng-change=\"updateItemApproval(\'approval_over_level\', item.approval_over_level, $index);\"></select></td><td class=text-justify><select id=rejected_level name=rejected_level class=form-control ng-model=item.rejected_level ng-options=\"l.level as l.approval_name for l in list | hideHigher: $index\" ng-change=\"updateItemApproval(\'rejected_level\', item.rejected_level, $index);\" ng-disabled=\"item.delete === true\"></select></td><td class=text-center><input type=checkbox id=delete name=delete ng-model=item.delete ng-change=\"item.rejected_level = null\"></td></tr><tr ng-show=!list.length><td class=text-center colspan=10 translate>There are no Transaction Approval Workflow Steps</td></tr></tbody></table></div></fieldset></form></div></div></div><div class=row><div class=col-xs-12><button ng-if=createNew ng-disabled=\"!list.length || !hasPermission(\'approval_workflow_modify\')\" translate class=\"btn btn-primary\" ng-click=createWorkflowItems();>Save</button> <button ng-if=!createNew ng-disabled=\"!hasPermission(\'approval_workflow_modify\')\" translate class=\"btn btn-primary\" popup popup-text=\"Are you sure?\" popup-confirm=updateWorkflowItems();>Save</button></div></div><div class=row><div class=col-xs-12><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div></div></div></div></div></div>");
$templateCache.put("app/partials/unified-tax-management/unified-tax-management.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header page-name=charges-and-formulas.unified-tax-managment toggle=toggle icon=\"\'check-square-o\'\" title=\"{{ \'Unified Tax Management\'  | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-keyup=\"$event.keyCode == 13 && refreshOverride()\" ng-model=search></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=\"col-xs-12 col-md-4\"><div class=table-responsive export-table sort-query-string=getSortQueryString() query-string=filterParameters back-end-export=true service=unifiedTaxValidityManagementService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverrideUnifiedTaxValidity()><thead><tr><th translate class=text-nowrap sort=from_validity_year>Start</th><th translate class=text-nowrap sort=to_validity_year>End</th></tr></thead><tbody><tr ng-click=showTaxes(item); ng-repeat=\"item in listUnifiedTaxValidity\" ng-class=\"{\'highlight\': editableValidity.id === item.id}\"><td class=text-nowrap>{{ ::item.from_validity_year | dateConverter | date: \'yyyy\' }}</td><td class=text-nowrap>{{ ::item.to_validity_year | dateConverter | date: \'yyyy\' }}</td></tr><tr ng-show=!listUnifiedTaxValidity.length><td translate class=text-center colspan=6>There are no Unified Tax data</td></tr></tbody></table></div></div><div class=\"col-xs-12 col-md-8\"><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverrideUnifiedTax()><thead><tr><!--                                     <th translate class=\"text-nowrap\" sort=\"id\">id</th> --><th translate class=text-nowrap sort=from_manufacture_year>From (Year)</th><th translate class=text-nowrap sort=to_manufacture_year>To (Year)</th><th translate class=text-nowrap sort=charge_formula>Unified Tax Formula</th></tr></thead><tbody><tr ng-click=editTax(item); ng-repeat=\"item in listUnifiedTax\" ng-class=\"{\'highlight\': editableTax.id === item.id}\"><!--                                     <td class=\"text-nowrap\">{{ ::item.id }}</td> --><td class=text-nowrap>{{ ::item.from_manufacture_year | dateConverter | date: \'yyyy\' }}</td><td class=text-nowrap>{{ ::item.to_manufacture_year | dateConverter | date: \'yyyy\' }}</td><td class=text-nowrap>{{ ::item.charge_formula }}</td></tr><tr ng-show=!listUnifiedTax.length><td translate class=text-center colspan=6>There are no Unified Tax data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editableValidity.id === null\" icon=\"\'check-square-o\'\" title=\"{{ \'Add a Unified Tax \' | translate }}\"></box-header><box-header ng-show=\"editableValidity.id !== null\" icon=\"\'check-square-o\'\" title=\"{{ \'Edit a Unified Tax\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=formValidity onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'unified_tax_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-6\"><label for=from_validity_year>{{ \'Start Period *\' | translate }} (<span translate>yyyy</span>)</label><p class=input-group><input ng-model-options=\"{ timezone: \'UTC\' }\" id=from_validity_year name=from_validity_year type=text class=form-control uib-datepicker-popup=yyyy ng-model=editableValidity.from_validity_year is-open=openfromValidityYear datepicker-options=\"{ formatYear: \'yyyy\', startingDay: 1, minMode: \'year\' }\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"openfromValidityYear = !openfromValidityYear\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=to_validity_year>{{ \'End Period *\' | translate }} (<span translate>yyyy</span>)</label><p class=input-group><input ng-model-options=\"{ timezone: \'UTC\' }\" id=to_validity_year name=to_validity_year type=text class=form-control uib-datepicker-popup=yyyy ng-model=editableValidity.to_validity_year is-open=opentoValidityYear datepicker-options=\"{ formatYear: \'yyyy\', startingDay: 1, minMode: \'year\' }\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"opentoValidityYear =!opentoValidityYear\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"resetValidity(); formValidity.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editableValidity.id !== null\" ng-disabled=\"formValidity.$invalid || !validateValidityDates(editableValidity.from_validity_year, editableValidity.to_validity_year)\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateValidity(editableValidity, editableValidity.id); formValidity.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editableValidity.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteValidity(editableValidity.id); formValidity.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"formValidity.$invalid || !validateValidityDates(editableValidity.from_validity_year, editableValidity.to_validity_year)\" ng-show=\"editableValidity.id === null\" ng-click=\"createValidity(editableValidity); formValidity.$setUntouched();\">Create</button></div></div></fieldset></form></div></div><div class=\"box-container margin-top-20\"><box-header ng-show=\"editableTax.id === null\" icon=\"\'check-square-o\'\" title=\"{{ \'Add a Unified Tax item\' | translate }}\"></box-header><box-header ng-show=\"editableTax.id !== null\" icon=\"\'check-square-o\'\" title=\"{{ \'Edit a Unified Tax item\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=formTax onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'unified_tax_modify\')\"><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-6\"><label for=from_manufacture_year>{{ \'From A/C Manufacturing Year *\' | translate }} (<span translate>yyyy</span>)</label><p class=input-group><input ng-model-options=\"{ timezone: \'UTC\' }\" id=from_manufacture_year name=from_manufacture_year type=text class=form-control uib-datepicker-popup=yyyy ng-model=editableTax.from_manufacture_year is-open=openfromManufactureYear datepicker-options=\"{ formatYear: \'yyyy\', startingDay: 1, minMode: \'year\' }\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"openfromManufactureYear = !openfromManufactureYear\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=to_manufacture_year>{{ \'To A/C Manufacturing Year *\' | translate }} (<span translate>yyyy</span>)</label><p class=input-group><input ng-model-options=\"{ timezone: \'UTC\' }\" id=to_manufacture_year name=to_manufacture_year type=text class=form-control uib-datepicker-popup=yyyy ng-model=editableTax.to_manufacture_year is-open=opentoManufactureYear datepicker-options=\"{ formatYear: \'yyyy\', startingDay: 1, minMode: \'year\' }\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"opentoManufactureYear =!opentoManufactureYear\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-6\"><label for=chargeFormula>{{ \'Applicable Unified Tax *\' | translate }}</label><input id=chargeFormula name=chargeFormula class=form-control ng-model=editableTax.charge_formula ng-change=onChangeFormula() required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"resetTax(); formTax.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editableTax.id !== null\" ng-disabled=\"formTax.$invalid || !validateTaxDates(editableTax.from_manufacture_year, editableTax.to_manufacture_year)\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateTax(editableTax, editableTax.id); formTax.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editableTax.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteTax(editableTax.id); formTax.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=\"formTax.$invalid || !validateTaxDates(editableTax.from_manufacture_year, editableTax.to_manufacture_year)\" ng-show=\"editableTax.id === null\" ng-click=\"createTax(editableTax); formTax.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div><div class=\"col-xs-12 col-md-12 margin-top-20\" ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'flask\'\" title=\"{{ \'Create Formulas\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'flask\'\" title=\"{{ \'Edit Formulas\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'unified_tax_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><uib-accordion close-others=oneAtATime><div uib-accordion-group class=panel-default heading=\"{{\'Parameters\' | translate}}\" is-open=status.isFirstOpen is-disabled=status.isFirstDisabled><table><tr><td class=col-md-1><button translate type=button class=\"btn btn-primary btn-block\" id=btn-mtow ng-click=\"addToFormula(\'[MTOW]\')\">[MTOW]</button></td><td translate>Maximum Take Off Weight</td></tr></table></div><div uib-accordion-group class=panel-default heading=\"{{\'Operators\' | translate}}\" is-open=status.open><button type=button class=\"btn btn-primary\" id=btn-addition ng-click=\"addToFormula(\' + \')\">+</button> <button type=button class=\"btn btn-primary\" id=btn-subtraction ng-click=\"addToFormula(\' - \')\">-</button> <button type=button class=\"btn btn-primary\" id=btn-multiplication ng-click=\"addToFormula(\' * \')\">*</button> <button type=button class=\"btn btn-primary\" id=btn-division ng-click=\"addToFormula(\' / \')\">/</button> <button type=button class=\"btn btn-primary\" id=btn-leftBracket ng-click=\"addToFormula(\'(\')\">(</button> <button type=button class=\"btn btn-primary\" id=btn-rightBracket ng-click=\"addToFormula(\')\')\">)</button> <button type=button class=\"btn btn-primary\" id=btn-comma ng-click=\"addToFormula(\',\')\">,</button> <button type=button class=\"btn btn-primary\" id=btn-dot ng-click=\"addToFormula(\'.\')\">.</button></div></uib-accordion></div><div class=\"col-xs-12 col-md-6\"><uib-accordion close-others=oneAtATime><div uib-accordion-group class=panel-default heading=\"{{\'Math Functions\' | translate}}\" is-open=status.open><table class=col-md-12><tr><th translate class=col-md-1>Name</th><th translate class=col-md-1>Usage</th><th translate class=col-md-1>Result</th><th>Description</th></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-sqrt ng-click=\"addToFormula(\'sqrt\')\">sqrt</button></td><td translate class=col-md-1>sqrt(4)</td><td class=col-md-1>2</td><td translate>Returns the square root of a number</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-round ng-click=\"addToFormula(\'round\')\">round</button></td><td translate class=col-md-1>round(3.222,2)</td><td class=col-md-1>3.22</td><td translate>Rounds a value to the nearest integer or specified number of decimal places</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-pow ng-click=\"addToFormula(\'pow\')\">pow</button></td><td translate class=col-md-1>pow(3, 2)</td><td class=col-md-1>9</td><td translate>Returns a specified number raised to the specified power</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-ceiling ng-click=\"addToFormula(\'ceiling\')\">ceiling</button></td><td translate class=col-md-1>ceiling(1.5)</td><td class=col-md-1>2</td><td translate>Returns the smaller integer greater than or equal to the specified number</td></tr><tr><td><button translate type=button class=\"btn btn-primary btn-block\" id=btn-floor ng-click=\"addToFormula(\'floor\')\">floor</button></td><td translate class=col-md-1>floor(1.5)</td><td class=col-md-1>1</td><td translate>Returns the largest integer less than or equal to the specified number</td></tr></table></div></uib-accordion></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/unspecified-dep-dest-locations/unspecified-dep-dest-locations.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=operations.unspecified-departure-and-destination-location-management icon=\"\'map-pin\'\" title=\"{{ \'Unspecified Departure and Destination Locations\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters sort-query-string=getSortQueryString() back-end-export=true service=unspecifiedDepDestLocationsService><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=textIdentifier>Text Identifier</th><th translate class=text-nowrap sort=name>Name</th><th translate class=text-nowrap sort=maintained>Maintained</th><th translate class=text-nowrap sort=aerodromeIdentifier>Ad Name</th><th translate class=text-nowrap sort=countryCode>Country Code</th><th translate class=text-nowrap sort=status>Status</th><th translate class=\"text-nowrap text-right\" sort=latitude>Latitude</th><th translate class=\"text-nowrap text-right\" sort=longitude>Longitude</th></tr></thead><tbody><tr ng-click=\"edit(item); saveOldValue();\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.text_identifier }}</td><td>{{ item.name }}</td><td>{{ item.maintained | translate }}</td><td>{{ item.aerodrome_identifier }}</td><td>{{ item.country_code.country_code }}</td><td class=text-nowrap>{{ item.status ? item.status.toUpperCase() : item.status | translate }}</td><td class=\"text-right text-nowrap\">{{ item.latitude | latitudeConverter }}</td><td class=\"text-right text-nowrap\">{{ item.longitude | longitudeConverter }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=8 translate>There are no Unspecified Departure and Destination Locations data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'map-pin\'\" title=\"{{ \'Create an Unspecified Departure or Destination\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'map-pin\'\" title=\"{{ \'Edit an Unspecified Departure or Destination\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'zzzz_locations_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text_identifier>Text Identifier *</label><input id=text-identifier name=textIdentifier class=form-control ng-model=editable.text_identifier uppercase-input type=text required></div><div class=\"col-xs-12 col-md-6\"><label translate for=name>Name *</label><input id=name name=name class=form-control ng-model=editable.name type=text required></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=aerodrome_identifier>Aerodrome Identifier</label><dynamic-service-dropdown ng-model=editable.aerodrome_identifier id=aerodrome_identifier name=aerodromeIdentifier dropdown-type=single service=::aerodromesService is-required=::false allow-empty=true options=\"item.aerodrome_name as item.aerodrome_name for item in list.content\"></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-6\"><label for=aerodrome_identifier><span translate>Country</span> *</label><dynamic-service-dropdown ng-model=editable.country_code id=country-code name=countryCode dropdown-type=single service=::countryManagementService selected={{country}} object=editable field=country_code selected-value=defaultCounty model=country_code options=\"country as country.country_name for country in list.content track by country.country_name\" is-required=true></dynamic-service-dropdown></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=maintained>Maintained *</label><boolean-text id=maintained name=maintained class=form-control ng-model=editable.maintained required></boolean-text></div><div class=\"col-xs-12 col-md-6\"><label translate for=status>Status</label><input translate id=status name=status class=form-control ng-value=\"editable.status.toUpperCase() | translate\" readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=latitude>Latitude ({{ ::getLatLabel() }}) *</label><input id=latitude name=latitude class=form-control ng-model=editable.latitude type=text ng-pattern=latitudeRegex input-format=\"DD.ddddd or DD°MM′SS″L or DD MM SSL\" required></div><div class=\"col-xs-12 col-md-6\"><label translate for=longitude>Longitude ({{ ::getLonLabel() }}) *</label><input id=longitude name=longitude class=form-control ng-model=editable.longitude type=text ng-pattern=longitudeRegex input-format=\"DD.ddddd or DDD°MM′SS″L or DDD MM SSL\" required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" ng-disabled=form.$invalid convert-coordinates latitude=latitude longitude=longitude popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(convertedEditable || editable, editable.id); form.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button> <button translate class=\"btn btn-primary\" ng-disabled=form.$invalid ng-show=\"editable.id === null\" convert-coordinates latitude=latitude longitude=longitude conversion-complete=\"create(convertedEditable || editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/user-event-log/user-event-log.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=security.user-event-log icon=\"\'server\'\" title=\"{{ \'User Event Log\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6\"><button class=\"btn btn-secondary\" ng-click=\"filterSectionVisible = !filterSectionVisible\">{{ filterSectionVisible ? \'Hide Filters\' : \'Show Filters\' }}</button></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refreshOverride() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row ng-show=filterSectionVisible><div class=\"col-xs-12 col-md-3\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=search empty-to-null ng-keyup=\"$event.keyCode == 13 && refreshOverride()\"></div><div class=\"col-xs-12 col-md-6 col-lg-6\"><date-range is-required=false control=control format={{customDate}} ng-click=\"control.getUTCStartDate() !== null && control.getUTCEndDate() !== null ? refreshList() : \'\'\" ng-keyup=\"control.getUTCStartDate() === null && control.getUTCEndDate() === null ? refreshList() : \'\'\"><!--Datepickers --></date-range></div><div class=\"col-xs-12 col-md-6 col-lg-3\"><label translate for=user-filter>User</label><select id=user-filter class=form-control empty-to-null ng-model=userFilter ng-change=refreshList() ng-options=\"item.id as item.name for item in usersList\"><option translate value=\"\"></option></select></div></div><fieldset ng-disabled=\"!hasPermission(\'user_event_modify\')\"><div class=row><div class=col-xs-12><div class=table-responsive export-table query-string=filterParameters back-end-export=true service=userEventLogService><table class=\"table table-striped table-bordered table-hover\" sort-query-string=getSortQueryString table-sort=refreshOverride()><thead><tr><th translate class=text-nowrap sort=dateTime>Date / Time</th><th translate class=text-nowrap sort=userName>User Name</th><th translate class=text-nowrap sort=uniqueRecordId>Dataset Name</th><th translate class=text-nowrap sort=eventType>Event Type</th><th translate class=text-nowrap sort=oldValue>Old Value</th><th translate class=text-nowrap sort=newValue>New Value</th><th translate class=text-nowrap sort=ipAddress>IP Address</th><th translate class=text-nowrap sort=recordPrimaryKey>Record Primary Key</th><!-- To be implemented at a later date --><!-- <th translate class=\"text-nowrap\" sort=\"modifiedColumnNamesValues\">Modified Column Names and Values</th> --></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.date_time | dateConverter: \'HH:mm\' }}</td><td class=text-capitalize>{{ item.user_name }}</td><td class=\"text-capitalize text-nowrap\">{{ item.unique_record_id | translate }}</td><td class=\"text-capitalize text-nowrap\">{{ item.event_type | translate }}</td><td class=\"text-capitalize text-nowrap\" ng-bind-html=formatStringWithLineBreaks(item.old_value)></td><td class=\"text-capitalize text-nowrap\" ng-bind-html=formatStringWithLineBreaks(item.new_value)></td><td>{{ item.ip_address }}</td><td>{{ item.record_primary_key }}</td><!-- <td>{{ item.modified_column_names_values }}</td> --></tr></tbody></table></div></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refreshOverride() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></fieldset></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header icon=\"\'server\'\" title=\"{{ \'View a User Event Log\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'avg_mtow_factor_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=user>User</label><input id=user name=user class=form-control type=text ng-model=editable.user_name readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label for=end-date><span translate>Date / Time</span>&nbsp;(<span translate>{{ customDate }}</span> <span tranlate>HHmm</span>)</label><input id=date-time name=dateTime class=form-control type=text ng-value=\"editable.date_time | dateConverter: \'HH:mm\'\" readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=ip-address>IP Address</label><input id=ip-address name=IpAddress class=form-control type=text ng-model=editable.ip_address readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label translate for=event-type>Event Type</label><input id=event-type name=eventType class=\"form-control text-capitalize\" type=text ng-value=\"editable.event_type | translate\" readonly=readonly></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=record-primary-key>Record Primary Key</label><input id=record-primary-key name=recordPrimaryKey class=form-control type=text ng-model=editable.record_primary_key readonly=readonly></div><div class=\"col-xs-12 col-md-6\"><label translate for=unique-record-id>Dataset Name</label><input id=unique-record-id name=uniqueRecordId class=form-control type=text ng-value=\"editable.unique_record_id | translate\" readonly=readonly></div></div><!-- For future user story --><!-- <div class=\"row\">\n                            <div class=\"col-xs-12\">\n                                <label translate for=\"modified-column-names-values\">Modified Column Names and Values</label>\n                                <input id=\"modified-column-names-values\" name=\"modifiedColumnNamesValues\" class=\"form-control\"\n                                       type=\"text\"\n                                       ng-model=\"editable.modified_column_names_values\"/>\n                            </div>\n                        </div> --><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/users/users.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=security.users icon=\"\'user\'\" title=\"{{ \'Users\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-4\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-4\"><label translate for=users-filter>Users</label><select id=users-filter ng-init=\"userType = \'false\'\" class=form-control ng-change=refresh() ng-model=userType><option translate value=all>All</option><option translate value=internal>Internal users</option><option translate value=selfcare>Web portal users</option><option translate value=provider ng-hide=!hasProviders>SSO_PROVIDER_USER</option></select></div><div class=\"col-xs-12 col-md-4\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() service=usersService query-string=filterParameters back-end-export=true><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate sort=name>User Name</th><th translate sort=login>User Login</th><th translate sort=jobTitle>Job Title</th><th translate sort=email>Email Address</th><th translate sort=userRoles.id>Groups</th></tr></thead><tbody><tr ng-click=\"resetPassword(); form.$setUntouched(); edit(item);saveOldValue();\" ng-class=\"{\'highlight\': editable.id === item.id}\" ng-repeat=\"item in list\"><td class=text-nowrap>{{ item.name }}</td><td class=text-nowrap>{{ item.login }}</td><td class=text-nowrap>{{ item.job_title }}</td><td class=text-nowrap>{{ item.email }}</td><td class=text-nowrap><span ng-repeat=\"(key, val) in item.roles\">{{ val.name }}{{ key != item.roles.length - 1 ? \',\' : \'\' }}</span></td></tr><tr ng-show=!list.length><td class=text-center colspan=5 translate>There are no Users data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'user\'\" title=\"{{ \'Create a User\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'user\'\" title=\"{{ \'Edit a User\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'user_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=email-address>Email Address *</label><input id=email-address name=email class=form-control type=email ng-model=editable.email pattern=[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]+$ required></div><div class=\"col-xs-12 col-md-6\"><label translate for=userlogin>User Login *</label><input ng-disabled=editable.id id=userlogin name=login class=form-control type=text minlength=4 ng-model=editable.login required></div></div><div class=row><div class=col-xs-12><label translate for=username>User Name *</label><input id=username name=name class=form-control type=text maxlength=100 ng-model=editable.name required></div></div><password ng-if=\"editable.is_provider_user === false\" error=error reset-pass=resetPass required=\"editable.id === null && minLength > 0\" password=editable.password></password><div ng-if=\"minLength === 0 && editable.is_selfcare_user === false && editable.is_provider_user === false\" class=row><div class=col-xs-12><button translate id=empty-password class=\"btn btn-primary\" ng-class=\"{ \'active\': setZeroLength }\" ng-click=resetPassword(!setZeroLength) ng-model=setZeroLength>Set password to zero length password</button></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=contact-information>Contact Information *</label><input id=contact-information name=contactInformation class=form-control type=text ng-model=editable.contact_information required></div><div class=\"col-xs-12 col-md-6\"><label for=sms-number><span translate>Telephone Number</span>&nbsp;<span ng-if=\"editable.is_selfcare_user === false && editable.is_provider_user === false\">*</span></label><input id=sms-number name=smsNumber class=form-control type=text ng-model=editable.sms_number ng-required=\"editable.is_selfcare_user === false && editable.is_provider_user === false\" empty-to-null></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=roles>Groups</label><multiselect id=roles name=roles options=\"editable.is_selfcare_user === false ? rolesListForNotSelfCare : rolesList\" model=editable.roles extra-settings=\"{ displayProp: \'name\' }\" disabled=editable.is_selfcare_user></multiselect></div><div class=\"col-xs-12 col-md-6\"><label for=billing-centre><span translate>Billing Centre</span>&nbsp;<span ng-if=\"editable.is_selfcare_user === false\">*</span></label><dynamic-service-dropdown ng-model=editable.billing_center id=billing-centre name=billingCenter dropdown-type=single service=::billingCentreManagementService is-required=\"editable.is_selfcare_user === false\" options=\"centre as centre.name for centre in list.content track by centre.id\" disabled=editable.is_selfcare_user></dynamic-service-dropdown></div></div><div class=row><div class=col-xs-12><label translate for=job-title>Job Title</label><input id=job-title name=jobTitle class=form-control type=text ng-model=editable.job_title maxlength=100></div></div><div class=row><div class=\"col-xs-12 col-md-4\"><label for=selfcare-user><span translate>Self-Care User</span> *</label><boolean-text id=selfcare-user name=selfcareUser class=form-control ng-model=editable.is_selfcare_user ng-disabled=\"editable.id !== null\" ng-change=checkSelfCareUser() required></boolean-text></div><div class=\"col-xs-12 col-md-4\"><label translate for=provider-user>SSO_PROVIDER_USER</label><boolean-text id=provider-user name=providerUser class=form-control ng-model=editable.is_provider_user ng-change=checkProviderUser() ng-disabled=\"editable.id == null || editable.is_selfcare_user === true || is_provider_user_source === false\"></boolean-text></div><div class=\"col-xs-12 col-md-4\"><label translate for=force-password-change>Force Password Change</label><boolean-text id=force-password-change name=forcePasswordChange class=form-control ng-model=editable.force_password_change ng-disabled=\"editable.is_provider_user === true\" required></boolean-text></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || (editable.password === null && editable.is_provider_user === false)\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary\" ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=delete(editable.id)>Delete</button> <button translate class=\"btn btn-primary\" ng-disabled=\"form.$invalid || ((editable.password === null || editable.password === undefined) && editable.is_provider_user === false)\" ng-show=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/utilities-schedules/utilities-schedules.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=charges-and-formulas.utilities-schedule-managment icon=\"\'flash\'\" title=\"{{ \'Utilities Schedules\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=schedule-filter>Utility Type</label><select id=schedule-filter ng-init=\"filter = \'\'\" class=form-control ng-change=\"refresh(); reset()\" ng-model=filter ng-options=\"item.value as (item.name | translate) for item in scheduleTypes\"><option translate value=\"\">All</option></select></div><div class=\"col-xs-6 col-md-5\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-6 col-md-1\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=utilitiesSchedulesService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=\"text-nowrap text-right\" sort=scheduleId>Schedule Identifier</th><th translate class=text-nowrap sort=scheduleType>Schedule Type</th><th translate class=\"text-nowrap text-right\" sort=minimumCharge>Minimum Charge</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); resetRange(item);\" ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.schedule_id === item.schedule_id}\"><td class=text-right>{{ item.schedule_id }}</td><td>{{ ::getScheduleTypeName(item.schedule_type ) | translate}}</td><td class=text-right>{{ item.minimum_charge }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=3 translate>There are no Utilities Schedules data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div><div class=\"box-container margin-top-20\" ng-show=\"editable.schedule_id !== null\"><box-header icon=\"\'flash\'\">Associated Data</box-header><div class=box-content><div class=row><div class=col-md-6><label translate for=schedule-filter>Schedule Range Brackets</label></div><div class=col-md-6><label translate for=text-filter>Towns and Villages</label></div></div><div class=row><div class=col-md-6><div ng-show=\"ranges.length > 0 && editable.schedule_id !== null\"><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>Top Range</th><th translate class=text-right>Unit Price</th></tr></thead><tbody><tr ng-click=editRange(range); ng-repeat=\"range in ranges | orderBy: \'unit_price\'\" ng-class=\"{\'highlight\': editableRangeBracket.id === range.id}\"><td>{{ range.range_top_end }}</td><td class=text-right>{{ range.unit_price }}</td></tr></tbody></table></div><div translate ng-show=\"!ranges.length && editable.schedule_id !== null\">No associated schedule brackets</div></div><div class=col-md-6><div ng-show=\"editable.utilities_water_towns_and_village.length > 0 && editable.schedule_id !== null\"><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>Name</th></tr></thead><tbody><tr ng-repeat=\"town in editable.utilities_water_towns_and_village | orderBy: \'town_or_village_name\'\"><td>{{ town.town_or_village_name }}</td></tr></tbody></table></div><div translate ng-show=\"!editable.utilities_water_towns_and_village.length && editable.schedule_id !== null\">No associated towns and villages</div></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.schedule_id === null\" icon=\"\'flash\'\" title=\"{{ \'Create Utilities Schedule\' | translate }}\"></box-header><box-header ng-show=\"editable.schedule_id !== null\" icon=\"\'flash\'\" title=\"{{ \'Edit Utilities Schedule\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'utilities_schedule_modify\')\"><div class=row><div class=col-md-12><label translate for=schedule_id>Schedule Identifier</label><input id=schedule_id name=scheduleId class=form-control type=number ng-model=editable.schedule_id readonly=readonly></div></div><div class=row><div class=col-md-6><label translate for=schedule_type>Schedule Type *</label><select id=schedule_type name=scheduleType class=form-control ng-model=editable.schedule_type ng-options=\"item.value as (item.name | translate) for item in scheduleTypes\" required></select></div><div class=col-md-6><label translate for=minimum-charge>Minimum Charge *</label><input id=minimum-charge name=minimumCharge min=0 step=0.01 class=form-control type=number ng-model=editable.minimum_charge required></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.schedule_id !== null\" ng-disabled=form.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.schedule_id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.schedule_id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.schedule_id); form.$setUntouched()\">Delete</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-click=\"create(editable); form.$setUntouched();\" ng-show=\"editable.schedule_id === null\">Create</button></div></div></fieldset></form></div></div><div class=\"box-container margin-top-20\" ng-show=\"editable.schedule_id !== null\"><box-header icon=\"\'flash\'\">Create Range Bracket</box-header><div class=box-content><form novalidate action=# name=form2 onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'utilities_schedule_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=range_top_end>Top Range *</label><input id=range_top_end name=rangeTopEnd class=form-control min=0 step=0.01 type=number ng-model=editableRangeBracket.range_top_end required></div><div class=\"col-xs-12 col-md-6\"><label translate for=unit_price>Unit Price *</label><input id=unit_price name=unitPrice class=form-control min=0 step=0.01 type=number ng-model=editableRangeBracket.unit_price required></div></div><div class=row><div class=col-xs-12><button translate type=button class=\"btn btn-primary btn-resetbracket\" ng-click=\"resetRange(); form2.$setUntouched();\">Clear</button> <button translate class=\"btn btn-primary btn-updatebracket\" ng-show=\"editableRangeBracket.id !== null && editableRangeBracket.range_top_end !== null\" ng-disabled=form2.$invalid popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"updateRange(editableRangeBracket); form2.$setUntouched();\">Update</button> <button translate class=\"btn btn-primary btn-deletebracket\" ng-show=\"editableRangeBracket.id !== null && editableRangeBracket.range_top_end !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"deleteRange(editableRangeBracket.id); form2.$setUntouched()\">Delete</button> <button translate class=\"btn btn-primary btn-createbracket\" ng-disabled=form2.$invalid ng-click=\"createRange(editable.schedule_id, editableRangeBracket); form2.$setUntouched();\" ng-show=\"editableRangeBracket.id === null\">Create</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/utilities-towns/utilities-towns.html","<div class=row><div class=\"col-xs-12 col-md-12\" ng-class=\"{\'col-md-6 col-split-xs-12\': toggle}\"><div class=box-container><box-header toggle=toggle page-name=charges-and-formulas.utilities-town-and-village-managment icon=\"\'tint\'\" title=\"{{ \'Utilities Towns and Villages\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=text-filter>Filter</label><input id=text-filter class=form-control type=text ng-model=textFilter empty-to-null ng-model=textFilter ng-keyup=\"$event.keyCode == 13 && refresh()\"></div><div class=\"col-xs-12 col-md-6\"><button translate ng-click=refresh() class=\"btn btn-primary pull-right\">Refresh</button></div></div><div class=row><div class=col-xs-12><div class=table-responsive export-table sort-query-string=getSortQueryString() back-end-export=true service=utilitiesTownsService query-string=filterParameters><table class=\"table table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refresh()><thead><tr><th translate class=text-nowrap sort=townOrVillageName>Town or Village Name</th><th translate class=\"text-nowrap text-right\" sort=waterUtilitySchedule>Water Utility Schedule</th><th translate class=\"text-nowrap text-right\" sort=commercialElectricityUtilitySchedule.scheduleId>Commercial Electricity Schedule</th><th translate class=\"text-nowrap text-right\" sort=residentialElectricityUtilitySchedule.scheduleId>Residential Electricity Schedule</th></tr></thead><tbody><tr ng-click=edit(item);saveOldValue(); ng-repeat=\"item in list\" ng-class=\"{\'highlight\': editable.id === item.id}\"><td>{{ item.town_or_village_name }}</td><td class=\"text-right text-nowrap\"><span translate>Schedule:</span>&nbsp;{{ item.water_utility_schedule.schedule_id }} / <span translate>Charge:</span>&nbsp;{{ item.water_utility_schedule.minimum_charge }}</td><td class=\"text-right text-nowrap\"><span translate>Schedule:</span>&nbsp;{{ item.commercial_electricity_utility_schedule.schedule_id }} / <span translate>Charge:</span>&nbsp;{{ item.commercial_electricity_utility_schedule.minimum_charge }}</td><td class=\"text-right text-nowrap\"><span translate>Schedule:</span>&nbsp;{{ item.residential_electricity_utility_schedule.schedule_id }} / <span translate>Charge:</span>&nbsp;{{ item.residential_electricity_utility_schedule.minimum_charge }}</td></tr><tr ng-show=!list.length><td class=text-center colspan=4 translate>There are no Utilities Towns and Villages data</td></tr></tbody></table></div><pagination-display></pagination-display><ul uib-pagination total-items=pagination.total_elements ng-change=refresh() max-size=::20 items-per-page=pagination.size ng-model=pagination.number class=pagination-sm boundary-link-numbers=::true></ul></div></div></div></div></div><div id=crud-second-container ng-show=toggle><div class=box-container><box-header ng-show=\"editable.id === null\" icon=\"\'tint\'\" title=\"{{ \'Add Town or Village Utilities Schedules\' | translate }}\"></box-header><box-header ng-show=\"editable.id !== null\" icon=\"\'tint\'\" title=\"{{ \'Edit Town or Village Utilities Schedules\' | translate }}\"></box-header><div class=box-content><form novalidate action=# name=form onsubmit=\"return false\"><fieldset ng-disabled=\"!hasPermission(\'utilities_towns_modify\')\"><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=town-village-name>Town or Village Name *</label><input id=town-village-name name=townOrVillageName class=form-control type=text ng-model=editable.town_or_village_name required></div><div class=\"col-xs-12 col-md-6\"><label translate for=water-utility-schedule>Water Schedule *</label><select class=form-control name=waterUtilitySchedule id=water-utility-schedule ng-options=\"schedule as optionLabel(schedule) for schedule in waterSchedules | orderBy:\'schedule.schedule_id\' track by optionLabel(schedule)\" ng-model=editable.water_utility_schedule required></select></div></div><div class=row><div class=\"col-xs-12 col-md-6\"><label translate for=electric-comm-schedule>Commercial Electrity Schedule *</label><select class=form-control name=commercialElectricityUtilitySchedule id=electric-comm-schedule ng-options=\"schedule as optionLabel(schedule) for schedule in commElectricitySchedules | orderBy:\'schedule.schedule_id\' track by optionLabel(schedule)\" ng-model=editable.commercial_electricity_utility_schedule required></select></div><div class=\"col-xs-12 col-md-6\"><label translate for=electric-res-schedule>Residential Electrity Schedule *</label><select class=form-control name=residentialElectricityUtilitySchedule id=electric-res-schedule ng-options=\"schedule as optionLabel(schedule) for schedule in resElectricitySchedules | orderBy:\'schedule.schedule_id\' track by optionLabel(schedule)\" ng-model=editable.residential_electricity_utility_schedule required></select></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include><div class=row><div class=col-xs-12><button type=button class=\"btn btn-primary btn-reset\" translate ng-click=\"reset(); form.$setUntouched();\">Clear</button> <button class=\"btn btn-primary btn-update\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to update this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on update\" popup-confirm=\"update(editable, editable.id); form.$setUntouched();\">Update</button> <button class=\"btn btn-primary btn-create\" translate ng-disabled=form.$invalid ng-if=\"editable.id === null\" ng-click=\"create(editable); form.$setUntouched();\">Create</button> <button class=\"btn btn-primary btn-delete\" translate ng-show=\"editable.id !== null\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=\"delete(editable.id); form.$setUntouched()\">Delete</button></div></div></fieldset></form></div></div></div></div>");
$templateCache.put("app/partials/welcome-page/welcome-page.html","<div class=row><div class=\"col-xs-12 col-md-12\"><div class=box-container><box-header page-name=introduction icon=\"\'globe\'\" title=\"{{ \'Welcome\' | translate }}\"></box-header><div class=box-content><div class=row><div class=\"col-sm-12 col-md-12 col-lg-6\"><img class=logo alt=\"{{ logoName }}\" ng-src=\"{{ logoUrl }}\" style=\"max-width: 100%; height: auto;  max-height: 400px;  object-fit: contain\"></div><div class=\"col-sm-12 col-md-12 col-lg-6\"><h1><bold translate>Welcome</bold></h1><h5 translate>AVIATION REVENUE MANAGEMENT SYSTEM</h5></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/boolean-text/boolean-text.html","<select ng-options=\"o.v as o.n for o in booleanList\"></select>");
$templateCache.put("app/components/directives/export-pdf/export-pdf.html","<a><button ng-click=exportPdf() ng-disabled=disable class=\"btn btn-primary\"><span translate>{{text}}</span></button> </a>");
$templateCache.put("app/components/directives/download-oauth2/download-oauth2.html","<button title=\"{{ \'Download\' | translate}}\" ng-click=generate() ng-disabled=disable class={{classUsed}}><span translate>{{params.text}}</span> <i ng-hide=hideIcon class=\"fa fa-floppy-o fa-1x\" aria-hidden=true></i></button>");
$templateCache.put("app/components/directives/export-table/export-table-warning.template.html","<div class=\"confirm-popup padding-20 ng-scope\"><div class=row><div class=\"col-xs-12 ng-binding\" translate>Too much data, only the first 10 pages will be downloaded.</div></div><div class=\"row margin-top-20\"><div class=col-xs-12><button translate=\"\" type=button class=\"btn btn-primary ng-scope\" ng-click=close()>OK</button></div></div></div>");
$templateCache.put("app/components/directives/export-table/export-table.html","<div ng-class=\"{\'open\': toggleDropdown}\" class=dropdown><div ng-show=\"formats.length > 1\" ng-click=\"toggleDropdown = !toggleDropdown\" class=dropdown-toggle title=\"{{ \'Download Data\' | translate }}\" id=download-button data-toggle=dropdown aria-haspopup=true aria-expanded=true><a class=savePNG><i class=\"fa fa-download fa-lg\"></i></a></div><ul ng-click=\"toggleDropdown = false\" class=dropdown-menu aria-labelledby=download-button><li><a ng-show=\"formats.indexOf(\'csv\') !== -1\" ng-click=\"exportCsv(\'csv\'); toggleDropdown = false; $event.stopPropagation()\">CSV</a> <a ng-show=\"formats.indexOf(\'pdf\') !== -1\" ng-click=\"exportPdf(); toggleDropdown = false; $event.stopPropagation()\">PDF</a> <a ng-show=\"formats.indexOf(\'xls\') !== -1\" ng-click=\"exportCsv(\'xls\'); toggleDropdown = false; $event.stopPropagation()\">XLS</a></li></ul><!-- Calling the method that creates csv file on the frontend --><div ng-show=\"formats.length === 1 && formats.includes(\'csv\') && !backEndExport\" ng-click=\"exportCsv(\'csv\'); $event.stopPropagation()\" title=\"{{ \'Download Data\' | translate }}\" id=download-button aria-haspopup=true aria-expanded=true><a class=savePNG><i class=\"fa fa-download fa-lg\"></i></a></div><!-- Calling the method that creates csv file on the backend --><div ng-show=\"formats.length === 1 && formats.includes(\'csv\') && backEndExport\" ng-click=\"getCsvFromBackend(); $event.stopPropagation()\" title=\"{{ \'Download Data\' | translate }}\" id=download-button aria-haspopup=true aria-expanded=true><a class=savePNG><i class=\"fa fa-download fa-lg\"></i></a></div><div ng-show=\"formats.length === 1 && formats.includes(\'pdf\')\" ng-click=\"exportPdf(); $event.stopPropagation()\" title=\"{{ \'Download Data\' | translate }}\" id=download-button aria-haspopup=true aria-expanded=true><a class=savePNG><i class=\"fa fa-download fa-lg\"></i></a></div><div ng-show=\"formats.length === 1 && formats.includes(\'xls\')\" ng-click=\"exportCsv(\'xls\'); $event.stopPropagation()\" title=\"{{ \'Download Data\' | translate }}\" id=download-button aria-haspopup=true aria-expanded=true><a class=savePNG><i class=\"fa fa-download fa-lg\"></i></a></div></div>");
$templateCache.put("app/components/directives/external-database-input/external-database-input.template.html","<form name=form><div class=error-container><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></div><input name=permitNumber callback=addAdhocFeeToList ng-model=permitNumber ng-blur=queryExternalDatabase() class=\"form-control text-left\" ng-required=required ng-disabled=!supported ng-style=\"!supported && { \'background-color\': \'lightgray\' }\"></form>");
$templateCache.put("app/components/directives/flight-movement-form/flight-movement-form.directive.html","<div id=flight-movement-form class=form-group><div class=row><div class=col-xs-12 ng-show=showAccountMismatchError><div class=error-handling-container><div class=\"alert alert-dismissible alert-warning alert-icon\" role=alert><button id=error_button type=button ng-click=\"showAccountMismatchError = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Account</strong><p translate>Account and FLIGHT ID or REGISTRATION NUMBER do not match.</p></div></div></div><div class=col-xs-12 ng-show=showAircraftTypeMismatchError><div class=error-handling-container><div class=\"alert alert-dismissible alert-warning alert-icon\" role=alert><button id=error_button type=button ng-click=\"showAircraftTypeMismatchError = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Aircraft Type</strong><p translate>Aircraft Type and REGISTRATION NUMBER do not match.</p></div></div></div><div class=col-xs-12 ng-show=showBillingCentreMismatchError><div class=error-handling-container><div class=\"alert alert-dismissible alert-warning alert-icon\" role=alert><button id=error_button type=button ng-click=\"showBillingCentreMismatchError = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Billing Centre</strong><p translate>User BILLING CENTRE and Flight BILLING CENTRE do not match.</p></div></div></div></div><div class=\"row row-responsive\"><!-- Calling getDataByIdentifier() when an element has lost focus - US#96849--><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=flight-id><span translate>Flight ID *</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.flight_id>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=flight-id class=form-control type=text ng-model=flightMovement.flight_id name=flightId maxlength=10 ng-disabled=\"flightMovement.source !== \'manual\' && !hasPermission(\'flight_movement_key_modify\')\" uppercase-input required ng-blur=getDataByIdentifier()></div><!-- Calling getDataByIdentifier() when an element has lost focus - US#96849--><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=reg-num><span translate>Registration Number</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_reg_num>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=reg-num class=form-control type=text ng-model=flightMovement.item18_reg_num name=item18RegNum ng-blur=getDataByIdentifier() maxlength=20 ng-disabled=\"flightMovement.source !== \'manual\' && !hasPermission(\'flight_movement_key_modify\')\" uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=date-of-flight><span translate>Date of Flight</span>&nbsp;({{ dateFormat | translate }})&nbsp;<span>*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.date_of_flight>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><p class=input-group><date-picker id=date-of-flight type=text ng-change=\"dateChanged(\'expiry\', expiry.date)\" ng-blur=getDataByIdentifier() pad-hours=true show-button-bar=false class=form-control max-date=expiry.maxDate min-date=expiry.minDate uib-datepicker-popup=\"{{ dateFormat }}\" ng-model=flightMovement.date_of_flight is-open=expiry.open close-text=Close name=dateOfFlight ng-disabled=\"flightMovement.source !== \'manual\' && !hasPermission(\'flight_movement_key_modify\')\" required></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"expiry.open = !expiry.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=dep-time><span translate>Departure Time</span>&nbsp;(<span tranlate>HHmm</span>) * <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.dep_time>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=dep-time minlength=4 maxlength=4 ng-attr-title=\"{{flightMovement.dep_time < 2359 ? \'\' : \'Invalid time format\'| translate}}\" ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ class=form-control type=text ng-model=flightMovement.dep_time name=depTime ng-disabled=\"flightMovement.source !== \'manual\' && !hasPermission(\'flight_movement_key_modify\')\" only-numbers required></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=actual-departure-time><span translate>Actual Departure Time</span>&nbsp;(<span tranlate>HHmm</span>) <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.actual_departure_time>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=actual-departure-time minlength=4 maxlength=4 ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ class=form-control type=text ng-model=flightMovement.actual_departure_time name=actualDepartureTime ng-disabled=\"flightMovement.source !== \'manual\' && !hasPermission(\'flight_movement_key_modify\')\" only-numbers></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=dep-aerodrome><span translate>Departure Aerodrome *</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.dep_ad>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=dep-aerodrome name=depAd class=form-control type=text ng-model=flightMovement.dep_ad ng-change=\"flightMovement.dep_ad !== \'ZZZZ\' && flightMovement.dep_ad !== \'AFIL\' ? flightMovement.item18_dep = \'\' : \'\';\" ng-blur=checkBillingCentreMismatch(flightMovement) ng-disabled=\"flightMovement.source !== \'manual\' && !hasPermission(\'flight_movement_key_modify\')\" maxlength=4 only-letters uppercase-input required></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=aircraft-type><span translate>{{\'Aircraft Type\' | translate}} *</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.aircraft_type>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><select class=form-control name=aircraftType id=aircraft-type ng-model=flightMovement.aircraft_type ng-options=\"item.aircraft_type as item.aircraft_type for item in $parent.aircraftTypesList\" ng-change=checkAircraftTypeMatchIdentifier(flightMovement.aircraft_type); required></select></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=dest-aerodrome><span translate>Destination Aerodrome *</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.dest_ad>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=dest-aerodrome name=destAd class=form-control type=text ng-model=flightMovement.dest_ad ng-change=\"flightMovement.dest_ad !== \'ZZZZ\' ? flightMovement.item18_dest = \'\' : \'\';\" ng-blur=checkBillingCentreMismatch(flightMovement) maxlength=4 only-letters uppercase-input required></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=flight-type><span translate>Flight Type *</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.flight_type>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><select id=flight-type name=flightType class=\"form-control text-capitalize\" ng-model=flightMovement.flight_type required><option value=S>S</option><option value=N>N</option><option value=G>G</option><option value=M>M</option><option value=X>X</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=account><span translate>Account</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.associated_account_id>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><dynamic-service-dropdown ng-model=flightMovement.associated_account_id id=account name=account dropdown-type=single service=::accountsService method=findAllActiveMinimalReturn is-required=::false options=\"item.id as item.name for item in list\" disabled=disabled.account allow-empty=true ng-change=checkAccountMatchIdentifier(flightMovement.associated_account_id)></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=arrival-aerodrome><span translate>Arrival Aerodrome</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.arrival_ad>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=arrival-aerodrome name=arrivalAd class=form-control type=text ng-model=flightMovement.arrival_ad only-letters uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=arrival-time><span translate>Actual Arrival Time</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.arrival_time>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=arrival-time minlength=4 maxlength=4 ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ class=form-control type=text ng-model=flightMovement.arrival_time name=arrivalTime only-numbers></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=user-crossing-distance><span translate>User Crossing Distance</span>&nbsp;<span>({{ distanceUnitOfMeasure }})</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.user_crossing_distance>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><unit-conversion-input id=user-crossing-distance name=userCrossingDistance ng-model=flightMovement.user_crossing_distance></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=flight-status><span translate>Item 18 Status</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_status>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=flight-status name=item18Status class=form-control type=text ng-model=flightMovement.item18_status></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=item18-rmk><span translate>Item 18 Remarks</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_rmk>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=item18-rmk name=item18Rmk class=form-control type=text ng-model=flightMovement.item18_rmk></div><!--if departure aerodrome is ZZZZ, item 18 DEP/ is mandatory. If it is not ZZZZ item 18 DEP/ should be empty--><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=item18-dep><span translate>Item 18 Departure Aerodrome</span> <span ng-show=\"flightMovement.dep_ad === \'ZZZZ\' || flightMovement.dep_ad === \'AFIL\'\">*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_dep>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=item18-dep name=item18Dep class=form-control type=text ng-model=flightMovement.item18_dep ng-required=\"flightMovement.dep_ad === \'ZZZZ\' || flightMovement.dep_ad === \'AFIL\' ? true : false\" ng-disabled=\"flightMovement.dep_ad !== \'ZZZZ\' && flightMovement.dep_ad !== \'AFIL\' ? true : false\" ng-blur=checkBillingCentreMismatch(flightMovement) uppercase-input></div><!--if destination aerodrome is ZZZZ, item 18 DEST/ is mandatory. If it is not ZZZZ item 18 DEST/ should be empty--><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=item18-dest><span translate>Item 18 Destination Aerodrome</span> <span ng-show=\"flightMovement.dest_ad === \'ZZZZ\'\">*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_dest>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=item18-dest name=item18Dest class=form-control type=text ng-model=flightMovement.item18_dest ng-required=\"flightMovement.dest_ad === \'ZZZZ\' ? true : false\" ng-disabled=\"flightMovement.dest_ad !== \'ZZZZ\' ? true : false\" ng-blur=checkBillingCentreMismatch(flightMovement) uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=item18-aircraft><span translate>Item 18 Aircraft Type</span> <span ng-show=\"flightMovement.aircraft_type === \'ZZZZ\'\">*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_aircraft_type>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=item18-aircraft name=item18Aircraft class=form-control type=text ng-model=flightMovement.item18_aircraft_type ng-disabled=\"flightMovement.aircraft_type !== \'ZZZZ\' ? true : false\" ng-required=\"flightMovement.aircraft_type === \'ZZZZ\'? true : false\" uppercase-input></div><!--if departure ad/dest ad are not ZZZZ and are the same, speed is mandatory--><!--if item 18 DEP/ and item 18 DEST/ are not blank, and are the same, speed is mandatory--><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=cruising-speed-or-mach-number><span translate>Cruising Speed</span>&nbsp;(Knnnn/Nnnnn/Mnnn) <span ng-show=\"flightMovement.dep_ad !== \'ZZZZ\' && flightMovement.dep_ad !== \'AFIL\'\n                    && flightMovement.dest_ad !== \'ZZZZ\' && flightMovement.dep_ad === flightMovement.dest_ad\n                    || flightMovement.item18_dest !== null && flightMovement.item18_dep !== null\n                    && flightMovement.item18_dest !== \'\' && flightMovement.item18_dep !== \'\'\n                    && flightMovement.item18_dest === flightMovement.item18_dep\">*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.cruising_speed_or_mach_number>&nbsp;<i class=\"fa fa-flag\"></i></span></label><input id=cruising-speed-or-mach-number class=form-control type=text maxlength=5 minlength=4 ng-model=flightMovement.cruising_speed_or_mach_number ng-pattern=/^([kK][0-9]{4})|([mM][0-9]{3})|([nN][0-9]{4})$/ name=cruisingSpeedOrMachNumber ng-required=\"flightMovement.dep_ad !== \'ZZZZ\' && flightMovement.dep_ad !== \'AFIL\'\n                        && flightMovement.dest_ad !== \'ZZZZ\' && flightMovement.dep_ad === flightMovement.dest_ad\n                        || flightMovement.item18_dest !== null && flightMovement.item18_dep !== null\n                        && flightMovement.item18_dest !== \'\' && flightMovement.item18_dep !== \'\'\n                        && flightMovement.item18_dest === flightMovement.item18_dep ? true : false\" uppercase-input></div><!--if departure ad/dest ad are not ZZZZ and are the same, eet is mandatory--><!--if item 18 DEP/ and item 18 DEST/ are not blank, and are the same, eet is mandatory--><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=estimated-elapsed-time><span translate>Elapsed Time</span>&nbsp;(<span tranlate>HHmm</span>) <span ng-show=\"flightMovement.dep_ad !== \'ZZZZ\' && flightMovement.dep_ad !== \'AFIL\'\n                    && flightMovement.dest_ad !== \'ZZZZ\' && flightMovement.dep_ad === flightMovement.dest_ad\n                    || flightMovement.item18_dest !== null && flightMovement.item18_dep !== null\n                    && flightMovement.item18_dest !== \'\' && flightMovement.item18_dep !== \'\'\n                    && flightMovement.item18_dest === flightMovement.item18_dep || domesticDestAd\">*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.estimated_elapsed_time>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=estimated-elapsed-time minlength=4 maxlength=4 class=form-control type=text empty-to-null ng-model=flightMovement.estimated_elapsed_time ng-pattern=/^(?:2[0-3]|[0-1]?[0-9])?:?[0-5]?[0-9]$/ name=estimatedElapsedTime ng-required=\"flightMovement.dep_ad !== \'ZZZZ\' && flightMovement.dep_ad !== \'AFIL\'\n                    && flightMovement.dest_ad !== \'ZZZZ\' && flightMovement.dep_ad === flightMovement.dest_ad\n                    || flightMovement.item18_dest !== null && flightMovement.item18_dep !== null\n                    && flightMovement.item18_dest !== \'\' && flightMovement.item18_dep !== \'\'\n                    && flightMovement.item18_dest === flightMovement.item18_dep || domesticDestAd ? true : false\"></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-if=\"shouldShowCharge(\'parking\')\"><label for=parking-time><span translate>Parking Time</span>&nbsp;(<span translate>hours</span>) <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.parking_time>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=parking-time name=parkingTime class=form-control type=number ng-model=flightMovement.parking_time></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-if=showPassengerCounts><label for=passengers-chargeable-intern><span translate>Chargeable International Passengers</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.passengers_chargeable_intern>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=passengers-chargeable-intern name=passengersChargeableIntern class=form-control type=number min=0 ng-model=flightMovement.passengers_chargeable_intern></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-if=showPassengerCounts><label for=passengers-chargeable-domestic><span translate>Chargeable Domestic Passengers</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.passengers_chargeable_domestic>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=passengers-chargeable-domestic name=passengersChargeableDomestic class=form-control type=number min=0 ng-model=flightMovement.passengers_chargeable_domestic></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-if=showPassengerCounts><label for=passengers-child><span translate>Children</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.passengers_child>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=passengers-child name=passengersChild class=form-control type=number min=0 ng-model=flightMovement.passengers_child></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-if=\"shouldShowCharge(\'TASP\')\"><label translate for=tasp-charge>{{ taspLabel }} Charge</label><input id=tasp-charge name=taspCharge class=form-control type=number min=0 ng-model=flightMovement.tasp_charge ng-disabled=flightMovement.disableTaspFees></div><div class=\"col-xs-12 col-md-4 col-lg-2\" ng-if=\"shouldShowCharge(\'TASP\')\"><label translate for=tasp-charge-currency>{{ taspLabel }} Charge Currency</label><select id=tasp-charge-currency name=taspChargeCurrency class=form-control ng-model=flightMovement.tasp_charge_currency ng-options=\"item as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in $parent.taspCurrenciesList.content track by item.id\"></select></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label translate for=flight-rule>Flight Rule</label><select id=flight-rule name=flightRule class=form-control ng-model=flightMovement.flight_rules><option value=\"\"></option><option value=I>I - Instrumental Flight Rules</option><option value=V>V - Visual Flight Rules</option><option value=Y>Y - Initially operating under IFR,followed by one or more changes of flight rules</option><option value=Z>Z - Initially operating under VFR,followed by one or more changes of flight rules</option></select></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=flight-level><span translate>Flight Level</span>&nbsp;(<span tranlate>Fnnn</span>) <span ng-show=flightLevelRequired>*</span> <span title=\"{{ \'Manually Changed Field\' | translate }}\" ng-show=manual.flight_level>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=flight-level name=flightLevel class=form-control ng-model=flightMovement.flight_level maxlength=5 ng-pattern=/^(?:[fF|aA]\\d{3}|[sS|mM]\\d{4})$/ ng-required=flightLevelRequired uppercase-input></div><div class=\"col-xs-12 col-md-4 col-lg-2\"><label for=item18-operator><span translate>Item 18 Operator</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.item18_operator>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><input id=item18-operator name=item18Operator class=form-control type=text ng-model=flightMovement.item18_operator ng-blur=getDataByIdentifier() uppercase-input></div><div class=col-xs-12><label for=fpl-route><span translate>Route</span> <span ng-show=!flightMovement.radar_route_text>*</span> <span title=\"{{ \'Manually Changed Field\' | translate}}\" ng-show=manual.fpl_route>&nbsp;<i class=\"fa fa-flag\" aria-hidden=true></i></span></label><div ng-class=\"{\'input-group\': verifyRouteEnabled}\"><input id=fpl-route name=fplRoute class=form-control ng-model=flightMovement.fpl_route ng-change=\"verifyResult = null; verifyInProgress = false\" uppercase-input ng-required=!flightMovement.radar_route_text ng-class=\"{\n           \'border-success\': verifyResult === true && !verifyInProgress,\n           \'border-danger\': verifyResult === false && !verifyInProgress\n               }\"> <span class=input-group-btn ng-if=verifyRouteEnabled><button ng-click=\"verifyRoute(flightMovement.dep_ad, flightMovement.fpl_route, flightMovement.dest_ad)\" class=\"btn btn-item-verify\" ng-class=\"verifyResult !== null && !verifyInProgress ? (verifyResult === true ? \'btn-success\' : \'btn-danger\') : \'btn-primary\'\" ng-disabled=!flightMovement.fpl_route><span translate>Verify</span> <span class=fa ng-class=\"{ \'fa-spinner fa-spin\': verifyInProgress, \'fa-close\': verifyResult === false && !verifyInProgress, \'fa-check\': verifyResult && !verifyInProgress }\" ng-show=\"verifyInProgress || verifyResult || verifyResult === false\"></span></button></span></div></div><div class=col-xs-12 ng-if=\"showRadarRoute && flightMovement.radar_route_text\"><label translate for=radar-route-text>Radar Route</label><input id=radar-route-text name=radarRouteText class=form-control ng-model=flightMovement.radar_route_text readonly=readonly></div><div class=col-xs-12 ng-if=\"showFlightNotes && flightMovement.flight_notes\"><label for=flight-notes><span translate>Flight Notes</span></label><input id=flight-notes name=flightNotes class=form-control ng-model=flightMovement.flight_notes readonly=readonly></div><div class=col-xs-12 ng-if=flightMovement.status_notes><label for=status-notes><span translate>Status Notes</span></label><input id=status-notes name=statusNotes class=form-control ng-model=flightMovement.status_notes readonly=readonly></div><div class=col-xs-12 ng-if=\"showDeletionReason && flightMovement.status !== \'DELETED\' && flightMovement.id && isFmCopied === false\"><label for=deletion-reason><span translate>Deletion Reason</span></label><input id=deletion-reason name=deletionReason class=form-control ng-model=flightMovement.deletion_reason></div><div class=col-xs-12 ng-if=\"flightMovement.status === \'DELETED\'\"><label for=undeletion-reason><span translate>Undeletion Reason</span></label><input id=undeletion-reason name=undeletionReason class=form-control ng-model=flightMovement.undeletion_reason></div></div><div class=row><div class=col-xs-12 ng-show=showErrors><div class=error-modal-overlay><div class=\"alert alert-dismissible alert-danger alert-icon\" role=alert><button id=error_button type=button ng-click=\"showErrors = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <strong translate>Error</strong><div ng-repeat=\"e in errorsList track by $index\">{{ e }}</div></div></div></div></div></div>");
$templateCache.put("app/components/directives/flight-movement-table/flight-movement-table.directive.html","<div class=col-xs-12><div class=table-scroll-top style=\"overflow-x: auto\"><div class=table-scroll-inner style=\"height: 1px\"></div></div><div class=\"table-responsive fm-table\" ng-class=\"{ \'show-duplicate-missing\': showDuplicateMissing }\" export-table service=flightMovementManagementService box-header=flightMovementTableCtrl.exportTableOptions.boxHeader back-end-export=true query-string=filterParameters sort-query-string=getSortQueryString() endpoint-param={{flightMovementTableCtrl.exportTableOptions.endpoint}}><table class=\"table table-fixed table-striped table-bordered table-hover table-condensed\" sort-query-string=getSortQueryString table-sort=refreshOverride() disable-sort=\"listFlightMovements || showDuplicateMissing ? true : false\" canned-sort=cannedSort><thead><tr><th ng-if=!listFlightMovements class=\"text-center text-nowrap middle\"><span translate>Select</span></th><th translate class=\"text-center text-nowrap middle\">Action</th><th translate class=\"text-center text-nowrap middle\" sort=dateOfFlight>Day of Flight</th><th translate class=\"text-center text-nowrap middle\" sort=depTime>Dep Time</th><th translate class=\"text-center text-nowrap middle\" sort=\"{{ showActualDepDestAd ? \'actualDepAd\' : \'depAd\' }}\">Dep Ad</th><th translate class=\"text-center text-nowrap middle\" sort=\"{{ showActualDepDestAd ? \'actualDestAd\' : \'destAd\' }}\">Dest Ad</th><th translate class=\"text-center text-nowrap middle\" sort=flightId>Flight Id</th><th translate class=\"text-center text-nowrap middle\" sort=item18RegNum>Reg Number</th><th translate class=\"text-center text-nowrap middle\" ng-show=isEANS sort=ifplId>Ifpl Id</th><th translate class=\"text-center text-nowrap middle\" sort=account.name>Account Name</th><th translate class=\"text-center text-nowrap middle\" sort=status>Status</th><th translate class=\"text-center text-nowrap middle\">A/C Number</th><th translate class=\"text-center text-nowrap middle\" sort=aircraftType>A/C Type</th><th translate class=\"text-center text-nowrap middle\" sort=wakeTurb>WTC</th><th class=\"text-center text-nowrap middle\" sort=actualMtow><span>{{ \'MTOW\' | translate }}&nbsp;({{ flightMovementTableCtrl.mtowUnitOfMeasure | translate }})</span></th><th translate class=\"text-center text-nowrap middle\" sort=flightCategoryType>Type</th><th translate class=\"text-center text-nowrap middle\" sort=flightCategoryNationality>Nationality</th><th translate class=\"text-center text-nowrap middle\" sort=flightCategoryScope>Scope</th><th translate class=\"text-center text-nowrap middle\" sort=cruisingSpeedOrMachNumber>Speed</th><th translate class=\"text-center text-nowrap middle\" sort=flightRules>Flight Rules</th><th translate class=\"text-center text-nowrap middle\" sort=flightCategoryScope>Flight Type</th><th translate class=\"text-center text-nowrap middle\" sort=flightmovementCategoryName>Category Name</th><th translate class=\"text-center text-nowrap middle\">Blacklisted</th><th translate class=\"text-center text-nowrap middle\" sort=enrouteChargesBasis>Enroute Basis</th><th translate class=\"text-center text-nowrap middle\" sort=billableEntryPoint>Entry Point</th><th translate class=\"text-center text-nowrap middle\" sort=billableExitPoint>Exit Point</th><th translate class=\"text-center text-nowrap middle\" sort=entryTime>Entry Time</th><th translate class=\"text-center text-nowrap middle\" sort=exitTime>Exit Time</th><th translate class=\"text-center text-nowrap middle\" sort=flightLevel>Flight Level</th><th class=\"text-center text-nowrap middle\" sort=billableCrossingDist>{{ \'Billable Cros Dist\' | translate }} &nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</th><th translate class=\"text-center text-nowrap middle\" sort=enrouteCharges>Enroute Charges</th><th translate class=\"text-center text-nowrap middle\" sort=approachCharges>{{ flightMovementTableCtrl.approachLabel }} Charges</th><th translate class=\"text-center text-nowrap middle\" sort=aerodromeCharges ng-show=::!flightMovementTableCtrl.isADAP>Aerodrome Charges</th><th class=\"text-center text-nowrap middle\" sort=domesticPassengerCharges><span>{{ \'Dom PAX\' | translate }}&nbsp;({{ flightMovementTableCtrl.domCurrencyInHeader | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=internationalPassengerCharges><span>{{ \'Intl PAX\' | translate }}&nbsp;({{ flightMovementTableCtrl.intlCurrencyInHeader | translate }})</span></th><th translate class=\"text-center text-nowrap middle\" sort=lateArrivalCharges ng-if=\"shouldShowCharge(\'arrival\')\">Late Arr</th><th translate class=\"text-center text-nowrap middle\" ng-if=\"shouldShowCharge(\'arrival\')\">Late Arr Currency</th><th translate class=\"text-center text-nowrap middle\" sort=lateDepartureCharges ng-if=\"shouldShowCharge(\'departure\')\">Late Dep</th><th translate class=\"text-center text-nowrap middle\" ng-if=\"shouldShowCharge(\'departure\')\">Late Dep Currency</th><th translate class=\"text-center text-nowrap middle\" sort=extendedHoursSurcharge ng-if=\"shouldShowCharge(\'extendedHours\')\">Extended Hours</th><th translate class=\"text-center text-nowrap middle\" ng-if=\"shouldShowCharge(\'extendedHours\')\">Extended Hours Currency</th><th class=\"text-center text-nowrap middle\" sort=parkingCharges ng-if=\"shouldShowCharge(\'parking\')\"><span>{{ \'Parking\' | translate }}&nbsp;({{ flightMovementTableCtrl.anspCurrency | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=prepaidAmount><span translate>Prepaid</span></th><th class=\"text-center text-nowrap middle\" sort=fplCrossingDistance><span>{{ \'Sched Dist\' | translate }}&nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=radarCrossingDistance><span>{{ \'Radar Dist\' | translate }}&nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=nominalCrossingDistance><span>{{ \'Nominal Dist\' | translate }}&nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=atcCrossingDistance><span>{{ \'ATC Dist\' | translate }}&nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=towerCrossingDistance><span>{{ \'Tower Dist\' | translate }}&nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</span></th><th class=\"text-center text-nowrap middle\" sort=userCrossingDistance><span>{{ \'User Dist\' | translate }}&nbsp;({{ flightMovementTableCtrl.distanceUnitOfMeasure | translate }})</span></th><th translate class=\"text-center text-nowrap middle\">Resolution Errors</th></tr></thead><tbody><tr ng-click=\"edit(item);saveOldValue(); markManualInputs(item);clearVerify();\" ng-repeat=\"item in {true: listFlightMovements.content, false: list}[listFlightMovements !== undefined] | filter: textFilter\" ng-class=\"{\n                        \'highlight\': editable.id === item.id,\n                        \'marked-duplicate\': item.marked_as_duplicate,\n                        \'marked-missing-before-this\': item.marked_as_missing_before_this,\n                        \'marked-first-missing\': item.marked_as_first_missing,\n                        \'marked-last-missing\': item.marked_as_last_missing }\"><td ng-if=!listFlightMovements class=\"text-center checkbox-center\"><input ng-click=countSelected() type=checkbox id=checkbox_{{item.id}} ng-model=selectedFlightMovements[item.id] ng-checked=selectedFlightMovements[item.id]></td><td><table class=\"table table-fixed table-striped table-hover table-condensed\"><tr><td class=no-line><button ng-click=showFlightMovementOnMap(item) class=\"btn btn-primary btn-sm\"><i class=\"fa fa-map-pin\"></i></button></td><td class=no-line><button uib-tooltip=FPL ng-click=\" addFlightMovementToPlan(item);open();\" ng-disabled=!item.initial_fpl_data class=\"btn btn-primary btn-sm\"><i class=\"fa fa-file-text\"></i></button></td><td class=no-line><button uib-tooltip=Copy ng-disabled=\"item.status === \'DELETED\'\" ng-click=\" copyFlightMovementToForm(item); $event.stopPropagation();\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-clone\"></i></button></td></tr></table></td><td class=\"middle text-nowrap\">{{ item.date_of_flight | dateConverter }}</td><td class=middle>{{ item.dep_time }}</td><td class=middle>{{ showActualDepAd ? item.actual_dep_ad : item.dep_ad }}</td><td class=middle>{{ showActualDestAd ? item.actual_dest_ad : item.dest_ad }}</td><td class=middle>{{ item.flight_id }}</td><td class=middle>{{ item.item18_reg_num }}</td><td class=middle ng-show=isEANS>{{ item.ifpl_id }}</td><td class=\"middle text-nowrap\">{{ item.associated_account }}</td><td class=middle>{{ item.status | translate }}</td><td class=\"middle text-center\" ng-show=item.initial_fpl_data>{{ parseSecondLine(item.initial_fpl_data, item.aircraft_type) }}</td><td class=\"middle text-center\" ng-show=\"!item.initial_fpl_data && item.ac_number\">{{ item.ac_number }}</td><td class=\"middle text-center\" ng-show=\"!item.initial_fpl_data && !item.ac_number\"></td><td class=\"middle text-center\">{{ item.aircraft_type }}</td><td class=\"middle text-center\">{{ item.wake_turb | translate }}</td><td class=\"text-right middle\">{{ item.actual_mtow | weightConverter }}</td><td class=\"middle text-center\">{{ item.flight_category_type | translate}}</td><td class=\"middle text-center\">{{ item.flight_category_nationality | translate}}</td><td class=\"middle text-center\">{{ item.flight_category_scope | translate}}</td><td class=\"middle text-center\">{{ item.cruising_speed_or_mach_number }}</td><td class=\"middle text-center\">{{ item.flight_rules }}</td><td class=\"middle text-center\">{{ item.flight_type }}</td><td class=\"middle text-nowrap text-center text-capitalize\">{{ (item.flightmovement_category_name | translate).toLowerCase() }}</td><td class=\"middle text-center\">{{ item.associated_account_black_listed_indicator && !item.associated_account_black_listed_override ? (\'Yes\'| translate) : (\'No\' | translate) }}</td><td class=\"middle text-nowrap text-capitalize\">{{ item.enroute_charges_basis | translate }}</td><td class=\"middle text-nowrap\">{{ item.billable_entry_point }}</td><td class=\"middle text-nowrap\">{{ item.billable_exit_point }}</td><td class=\"middle text-nowrap\">{{ item.entry_time | dateConverter: \'HH:mm\' }}</td><td class=\"middle text-nowrap\">{{ item.exit_time | dateConverter: \'HH:mm\' }}</td><td class=\"middle text-nowrap\">{{ item.flight_level }}</td><td class=\"text-right middle\">{{ item.billable_crossing_dist | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{item.enroute_charges != null ? item.enroute_result_currency.currency_code : \'\' }} {{ item.enroute_charges | number: 2 }}</td><td class=\"text-right middle\">{{ item.approach_charges != null ? item.approach_charges_currency.currency_code : \'\' }} {{ item.approach_charges | number: 2 }}</td><td class=\"text-right middle\" ng-if=::!flightMovementTableCtrl.isADAP>{{ item.aerodrome_charges != null ? item.aerodrome_charges_currency.currency_code : \'\' }} {{ item.aerodrome_charges | number: 2 }}</td><td class=\"text-right middle\">{{ item.domestic_passenger_charges | number: 2 }}</td><td class=\"text-right middle\">{{ item.international_passenger_charges | number: 2 }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_charges | number: 2 }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'arrival\')\">{{ item.late_arrival_charges != null ? item.late_arrival_departure_charges_currency.currency_code : \'\' }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_charges | number: 2 }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'departure\')\">{{ item.late_departure_charges != null ? item.late_arrival_departure_charges_currency.currency_code : \'\' }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours_surcharge | number: 2 }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'extendedHours\')\">{{ item.extended_hours_surcharge != null ? item.extended_hours_surcharge_currency.currency_code : \'\' }}</td><td class=\"text-right middle\" ng-if=\"shouldShowCharge(\'parking\')\">{{ item.parking_charges | number: 2 }}</td><td class=\"text-right middle\">{{ item.prepaid_amount | number: 2 }}</td><td class=\"text-right middle\">{{ item.fpl_crossing_distance | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{ item.radar_crossing_distance | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{ item.nominal_crossing_distance | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{ item.atc_crossing_distance | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{ item.tower_crossing_distance | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{ item.user_crossing_distance | distanceConverter | number: 2 }}</td><td class=\"text-right middle\">{{ translateResolutionErrors(item.resolution_errors_set) }}</td></tr><tr ng-show=!list.length><td colspan=44 translate>There are no Flight Movements data</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/directives/line-items-table/line-items-table.directive.html","<div class=table-responsive ng-if=hasLocalInputs()><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate ng-show=!isNonAvi class=text-center>Action</th><th translate ng-show=isNonAvi class=text-nowrap>Start Date</th><th translate ng-show=isNonAvi class=text-nowrap>End Date</th><th translate class=text-nowrap>Charge Description</th><th translate ng-show=!isNonAvi class=text-nowrap>Details</th><th ng-if=\"isWater || isElectric\" class=text-nowrap><span translate>Town</span></th><th translate class=text-nowrap><input translate id=any-aerodrome type=checkbox ng-click=checkAll() ng-model=selectAll>Select any aerodrome</th><th translate class=text-nowrap>Aerodrome</th><th ng-if=isAccountExternalSystemIdentifier class=text-nowrap><span translate>External Account Identifier</span></th><th translate ng-hide=isFixed class=\"text-nowrap text-right\">Unit Amount</th><th translate class=text-nowrap>Price Per Unit</th><th translate class=\"text-nowrap text-right\">Amount</th><th translate class=text-nowrap>Currency</th></tr></thead><tbody><tr ng-show=lineItems ng-repeat=\"item in lineItems | filter: isLocalInput\"><td ng-show=!isNonAvi class=text-center><button class=\"btn btn-primary btn-sm\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=removeChargeItem(lineItems.indexOf(item))><i class=\"fa fa-close\"></i></button></td><td ng-show=isNonAvi>{{ item.recurring_charge.start_date | dateConverter }}</td><td ng-show=isNonAvi>{{ item.recurring_charge.end_date | dateConverter }}</td><td>{{ item.service_charge_catalogue.description }}</td><td ng-show=!isNonAvi><input ng-model=item.user_description class=form-control type=text maxlength=100></td><td ng-if=\"isWater || isElectric\"><select ng-model=item.user_town id=town name=town class=form-control ng-options=\"town as town.town_or_village_name for town in townsList.content\" ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode); getUtility($index, item, item.user_unit_amount)\" ng-show=\"item.service_charge_catalogue.charge_basis === \'water\' || item.service_charge_catalogue.charge_basis === \'commercial-electric\' || item.service_charge_catalogue.charge_basis === \'residential-electric\'\"></select></td><td class=text-left><input id=any-aerodrome type=checkbox ng-model=item.any_aerodrome ng-change=itemCheck()></td><td ng-show=!item.any_aerodrome><select ng-model=item.aerodrome id=aerodrome name=aerodrome class=form-control ng-options=\"aerodrome as aerodrome.aerodrome_name for aerodrome in aerodromeList track by aerodrome.id\" ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode)\"><option></option></select></td><td ng-show=item.any_aerodrome><select ng-model=item.aerodrome id=aerodrome name=aerodrome class=form-control ng-options=\"aerodrome as aerodrome.aerodrome_name for aerodrome in aerodromeListAll track by aerodrome.id\" ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode)\"><option></option></select></td><td ng-if=isAccountExternalSystemIdentifier><select id=account-external-system-identifier name=accountExternalSystemIdentifier class=form-control ng-options=\"identifier.external_system_identifier as identifier.external_system_identifier for identifier in (lineItemAccountExternalChargeCategories[$index] = getAccountExternalChargeCategories(item)) track by identifier.external_system_identifier\" ng-model=item.account_external_system_identifier ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode)\" ng-show=\"lineItemAccountExternalChargeCategories[$index].length > 1\"></select></td><td ng-hide=isFixed><input ng-show=\"item.service_charge_catalogue.charge_basis !== \'fixed\'\" ng-model=item.user_unit_amount class=\"form-control text-right\" type=number min=0 ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode); getUtility($index, item, item.user_unit_amount)\"></td><td class=text-right>{{ item.price_per_unit | number: \'2\' }} {{item.price_per_unit ? (item.service_charge_catalogue.currency.currency_code) : \'\'}}</td><td class=text-right><span ng-show=\"item.service_charge_catalogue.charge_basis !== \'discount\' && (!lineItemError[$index] || lineItemError[$index] === null)\">{{ item.amount | number: \'2\' }} </span><span class=text-danger ng-if=lineItemError[$index]>{{ lineItemError[$index] }}</span></td><td>{{ params.currencyCode }}</td></tr><tr ng-show=\"!lineItems || !lineItems.length\"><td class=text-center colspan=12 translate>No line items available for selected month and account</td></tr></tbody></table></div><div class=table-responsive ng-if=hasExternalInputs()><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate ng-show=!isNonAvi class=text-center>Action</th><th translate class=text-nowrap>Charge Description</th><th translate ng-show=!isNonAvi class=text-nowrap>Details</th><th translate class=text-nowrap><input translate id=any-aerodrome type=checkbox ng-click=checkAll() ng-model=selectAll>Select any aerodrome</th><th translate class=text-nowrap>Aerodrome</th><th ng-if=isAccountExternalSystemIdentifier class=text-nowrap><span translate>External Account Identifier</span></th><th translate class=text-nowrap>Document identifier</th><th translate class=\"text-nowrap text-right\">Amount</th><th translate class=text-nowrap>Currency</th></tr></thead><tbody><tr ng-show=lineItems ng-repeat=\"item in lineItems | filter: isExternalDatabaseInput\"><td ng-show=!isNonAvi class=text-center><button class=\"btn btn-primary btn-sm\" popup popup-text=\"Are you sure you want to delete this?\" popup-local-storage-enable=\"SystemConfiguration:Require confirmation on delete\" popup-confirm=removeChargeItem(lineItems.indexOf(item))><i class=\"fa fa-close\"></i></button></td><td>{{ item.service_charge_catalogue.description }}</td><td ng-show=!isNonAvi><input ng-model=item.user_description class=form-control type=text maxlength=100></td><td class=text-left><input id=any-aerodrome type=checkbox ng-model=item.any_aerodrome ng-change=itemCheck()></td><td ng-show=!item.any_aerodrome><select ng-model=item.aerodrome id=aerodrome name=aerodrome class=form-control ng-options=\"aerodrome as aerodrome.aerodrome_name for aerodrome in aerodromeList track by aerodrome.id\" ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode)\"><option></option></select></td><td ng-show=item.any_aerodrome><select ng-model=item.aerodrome id=aerodrome name=aerodrome class=form-control ng-options=\"aerodrome as aerodrome.aerodrome_name for aerodrome in aerodromeListAll track by aerodrome.id\" ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode)\"><option></option></select></td><td ng-if=isAccountExternalSystemIdentifier><select id=account-external-system-identifier name=accountExternalSystemIdentifier class=form-control ng-options=\"identifier.external_system_identifier as identifier.external_system_identifier for identifier in (lineItemAccountExternalChargeCategories[$index] = getAccountExternalChargeCategories(item)) track by identifier.external_system_identifier\" ng-model=item.account_external_system_identifier ng-change=\"validateInvoiceLineItem($index, item, params.currencyCode)\" ng-show=\"lineItemAccountExternalChargeCategories[$index].length > 1\"></select></td><td><external-database-input item=item error=error currency-code=params.currencyCode></td><td class=text-right><span ng-show=\"item.service_charge_catalogue.charge_basis !== \'discount\' && (!lineItemError[$index] || lineItemError[$index] === null)\">{{ item.amount | number: \'2\' }} </span><span class=text-danger ng-if=lineItemError[$index]>{{ lineItemError[$index] }}</span></td><td>{{ item.requisition.req_currency || params.currencyCode }}</td></tr><tr ng-show=\"!lineItems || !lineItems.length\"><td class=text-center colspan=8 translate>No line items available for selected month and account</td></tr></tbody></table></div>");
$templateCache.put("app/components/directives/multiselect/multiselect.template.html","<div id=\"{{ id }}\" ng-dropdown-multiselect name=\"{{ name }}\" extra-settings=settings options=options selected-model=model ng-model=model events=events is-required=\"{{ isRequired }}\" disabled=disabled></div>");
$templateCache.put("app/components/directives/pagination-display/pagination-display.html","<p><span ng-show=\"selectedRecords >= 0\"><span translate>Selected</span>:&nbsp;{{ selectedRecords || 0 }} |</span> <span translate>Filtered</span>:&nbsp;{{ pagination.total_elements || 0 }} | <span translate>Total</span>:&nbsp;{{ pagination.total_items || 0 }}&nbsp;</p>");
$templateCache.put("app/components/directives/payment/payment.html","<form name=form><div class=\"row row-responsive\"><div class=\"col-xs-12 col-md-3\"><label translate for=currency>Invoice Currency *</label><input id=currency name=currency class=form-control type=text ng-model=paymentCurrency required disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label for=amount><span translate>Invoice Amount</span> *</label><input id=amount name=amount class=form-control type=text ng-value=\"payment.amount | number: 2\" required disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-currency>Payment Currency *</label><select id=payment-currency name=paymentCurrency class=form-control ng-model=payment.payment_currency ng-model-options=\"{ debounce: 400 }\" ng-options=\"item as (item.currency_name + \' (\' + item.currency_code + \')\') for item in fullCurrencyList | filter:{active:true} track by item.currency_code\" ng-change=\"updateExchangeRate(payment.payment_currency, payment.currency)\" required></select></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-amount>Payment Amount *</label><input id=payment-amount name=paymentAmount class=form-control type=text ng-value=\"payment.payment_amount | number: 2\" required disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-exchange-rate>Exchange Rate</label><input id=payment-exchange-rate name=paymentExchangeRate class=form-control type=text ng-model=paymentExchangeRate required disabled=disabled></div><div class=\"col-xs-12 col-md-3\"><label translate for=description>Description *</label><input id=description name=description class=form-control type=text ng-model=payment.description required></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-mechanism>Payment Mechanism *</label><dynamic-service-dropdown id=payment-mechanism name=paymentMechanism ng-model=payment.payment_mechanism options=\"(item | translate) for item in list | filter:listFilter\" is-required=true list-filter=filterPaymentMechanism dropdown-type=single service=::transactionsService method=getPaymentMechanismList ng-change=onPaymentMechanismChange(payment)></dynamic-service-dropdown></div><div class=\"col-xs-12 col-md-3\"><label translate for=payment-reference-number>Payment Reference Number *</label><input id=payment-reference-number name=payment-reference-number class=\"form-control text-capitalize\" type=text ng-model=payment.payment_reference_number ng-disabled=\"payment.payment_mechanism === \'cash\' || payment.payment_mechanism === \'adjustment\'\" required></div><div class=\"col-xs-12 col-md-3\" ng-show=\"activeOrg.isKcaa && (workflow === \'cash\' || (workflow === \'mixed\' && cashAccount))\"><label translate for=kra_clerk_name>KRA Clerk\'s Name<span ng-show=\"payment.payment_mechanism === \'cash\'\"> *</span></label><input id=kra_clerk_name name=kra_clerk_name class=form-control type=text ng-model=payment.kra_clerk_name ng-required=\"activeOrg.isKcaa && (workflow === \'cash\' || (workflow === \'mixed\' && cashAccount))\"></div><div class=\"col-xs-12 col-md-3\" ng-show=\"activeOrg.isKcaa && (workflow === \'cash\' || (workflow === \'mixed\' && cashAccount))\"><label translate for=kra_receipt_number>KRA Receipt Number<span ng-show=\"payment.payment_mechanism === \'cash\'\"> *</span></label><input id=kra_receipt_number name=kra_receipt_number class=form-control type=text ng-model=payment.kra_receipt_number ng-required=\"activeOrg.isKcaa && (workflow === \'cash\' || (workflow === \'mixed\' && cashAccount))\"></div><div class=\"col-xs-12 col-md-3\" ng-if=isBankAccountSupported><label for=bank-account><span translate>Bank Account</span> <span ng-show=\"isPaymentMechanism(\'wire\', \'cheque\')\">*</span></label><dynamic-service-dropdown id=bank-account name=bankAccount dropdown-type=single allow-empty=true empty-to-null service=::bankAccountManagementService method=getList options=\"item as $parent.$parent.getBankAccountLabel(item.name, item.number) for item in list track by item.id\" ng-model=payment.bank_account is-required=\"isPaymentMechanism(\'wire\', \'cheque\')\" disabled=\"!isPaymentMechanism(\'wire\', \'cheque\')\" ng-change=setPaymentBankAccount(payment.bank_account)></dynamic-service-dropdown></div></div><ng-include src=\"\'app/angular-ids-project/src/components/errorHandling/errorHandling.template.html\'\"><!-- Error Handling --></ng-include></form>");
$templateCache.put("app/components/directives/preview-oauth2/preview-oauth2.html","<button id=\"{{ paramId }}\" ng-click=getPreview() ng-disabled=disable class=\"{{ classUsed }}\"><span translate>{{params.text}}</span></button><div class=row ng-hide=hide><div class=\"col-sm-12 preview-oauth2-container\"><button class=\"btn btn-xs preview-oauth2-close\" style=\"right: 16px; top: 4px; position: absolute\" ng-show=showButton ng-click=\"hide = true\"><i class=\"fa fa-close\"></i></button><div ng-bind-html=preview><!-- iframe renders in here --></div></div></div>");
$templateCache.put("app/components/directives/rejected-records/rejected-records.directive.html","<div class=wideFeedback ng-show=\"uploadJob && uploadJob.length !== 0\"><b translate>Rejected Records</b> <span class=\"btn btn-sm pull-right\" ng-click=\"uploadJob = null\">X</span><br><hr><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>Id</th><th translate>Details</th><th translate>Error Message</th><th translate>File Name</th></tr></thead><tbody><tr ng-repeat=\"item in uploadJob\"><td>{{ item.id }}</td><td>{{ item.details }}</td><td>{{ item.error_messages }}</td><td>{{ item.filename }}</td></tr></tbody></table></div></div>");
$templateCache.put("app/components/directives/summary-upload/summary-upload.directive.html","<div class=wideFeedback ng-show=\"uploadJob && uploadJob.length !== 0\"><div><span class=\"btn btn-xs pull-right\" ng-click=\"uploadJob = null\">X</span><h6 translate>Summary</h6><p><span translate>Total Records</span>:<span> {{ uploadJob.processed.length }}</span></p><p><span translate>Records Added/Updated</span>:<span> {{ uploadJob.processed.length - uploadJob.rejected.length }}</span></p><p><span translate>Records Rejected</span>:<span>{{ uploadJob.rejected.length }}</span></p></div><div ng-if=uploadJob.rejected.length><h6 translate>Rejected Records</h6><div class=table-responsive><table class=\"table table-striped table-bordered table-hover table-condensed\"><thead><tr><th translate>Id</th><th translate>Details</th><th translate>Error Message</th></tr></thead><tbody><tr ng-repeat=\"item in uploadJob.rejected\"><td>{{ item.id }}</td><td>{{ item.details | translate }}</td><td>{{ item.error_messages | translate }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/directives/system-configuration-item/system-configuration-item.template.html","<div class=\"form-group system-configuration-item-group\" ng-class=\"{ \'has-error\': validationError || verifyResult === false, \'has-success\': !validationError && verifyResult && !verifyInProgress }\"><label ng-if=\"item.item_name !== \'Exempt Flight Routes: include route segments\'\" translate ng-attr-for=\"{{ \'item-\' + item.id }}\" ng-class=\"{ \'text-danger\': validationError || verifyResult === false, \'text-success\': !validationError && verifyResult && !verifyInProgress }\">{{ (item.item_name | translate) + \' \' + (item.display_units | translate) }}</label><label ng-if=\"isEANA && item.item_name === \'Exempt Flight Routes: include route segments\'\" translate ng-attr-for=\"{{ \'item-\' + item.id }}\" ng-class=\"{ \'text-danger\': validationError || verifyResult === false, \'text-success\': !validationError && verifyResult && !verifyInProgress }\">{{ (item.item_name | translate) + \' \' + (item.display_units | translate) }}</label><input class=custom-checkbox type=checkbox ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-if=\"item.data_type.name === \'boolean\' && item.item_name !== \'Exempt Flight Routes: include route segments\'\" ng-click=\"item.current_value === \'t\' ? item.current_value = \'f\' : item.current_value = \'t\'\" ng-checked=\"item.current_value === \'t\'\" ng-model=item.current_value> <input class=custom-checkbox type=checkbox ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-if=\"item.data_type.name === \'boolean\' && isEANA && item.item_name === \'Exempt Flight Routes: include route segments\'\" ng-click=\"item.current_value === \'t\' ? item.current_value = \'f\' : item.current_value = \'t\'\" ng-checked=\"item.current_value === \'t\'\" ng-model=item.current_value><div ng-if=\"item.data_type.name !== \'boolean\'\" ng-class=\"{ \'input-group\': item.system_validation_type }\"><p class=input-group ng-if=\"item.data_type.name === \'date\'\"><date-picker name=dataTypeDate type=text ng-pattern=datePickerRegex show-button-bar=false class=form-control uib-datepicker-popup=\"{{ customDate }}\" ng-model=item.current_value is-open=dataTypeDate.open close-text=Close></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"dataTypeDate.open = !dataTypeDate.open\"><i class=\"glyphicon glyphicon-calendar\" aria-hidden=true></i></button></span></p><input type=string ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-if=\"item.data_type.name === \'timestamp\'\" pattern=\\d{4}-[0-1]\\d-[0-3]\\d\\s[0-2]\\d:[0-5]\\d:[0-5]\\d class=form-control ng-model=item.current_value> <input type=number ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-if=\"item.data_type.name === \'float\' || item.data_type.name === \'int\'\" ng-pattern=\"item.data_type.name === \'float\' ? \'^-?[0-9]+([\\.,][0-9]+)?\' : \'^-?[0-9]+\'\" class=form-control ng-model=item.current_value max=\"{{ (item.range.split(\',\')[1] === \'maxint\' ? 2147483647 : item.range.split(\',\')[1]) }}\" min=\"{{ item.range.split(\',\')[0] }}\"><div ng-if=\"item.data_type.name === \'string\' || item.data_type.name === \'filename\' || item.data_type.name === \'blob\'\"><div ng-if=\"item.range !== null && item.item_name !== \'Crossing distance precedence\' && !item.item_name.includes(\'Language\')\"><select class=form-control ng-model=item.current_value ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-options=\"k as v | translate for (k,v) in mapRange(item)\"></select></div><div ng-if=\"item.range === null && item.item_name !== \'ANSP currency\' && item.item_name !== \'Country code\' && item.data_type.name !== \'blob\'\"><input type=text class=form-control ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-model=item.current_value maxlength=100></div><div class=input-group ng-if=\"item.data_type.name === \'blob\'\"><input type=text class=form-control ng-model=item.current_value readonly=readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ngf-select=\"handleFileInput($file, item)\" ngf-accept=\"\'.jpg,.gif,.png\'\" ngf-multiple=false><i class=\"fa fa-upload\"></i></button> </span><img ng-if=\"item.blob_value !== null\" ng-src={{$parent.blob_url_string}} class=logo alt={{item.current_value}} width=160 height=80 style=\"margin-left: 10px\"></div><div ng-if=\"item.item_name === \'Country code\'\"><dynamic-service-dropdown ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-model=item.current_value dropdown-type=single service=::countryManagementService options=\"country.country_code as ((country.country_code) + \' - \' + (country.country_name | translate)) for country in list.content\"></dynamic-service-dropdown></div><div ng-if=\"item.item_name === \'ANSP currency\'\"><dynamic-service-dropdown ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-model=item.current_value dropdown-type=single service=::currencyManagementService options=\"item.currency_code as ((item.currency_name | translate) + \' (\' + item.currency_code + \')\') for item in list.content\"></dynamic-service-dropdown></div><div ng-if=\"item.item_name === \'Crossing distance precedence\'\"><multiselect class=col-xs-9 name=crossing-distance-precedence extra-settings=\"{ displayProp: \'label\' }\" options=CDPRange model=CDPModel translated-value=label events=\"{ onSelectionChanged: addCDPToList }\"></multiselect><div class=col-xs-3><ol><li ng-repeat=\"item in CDP\">{{ item | translate }}</li></ol></div></div><div ng-if=\"item.item_name.includes(\'Language\')\"><select ng-if=\"item.item_name && item.item_name.toLowerCase().includes(\'selection\')\" class=form-control ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-model=item.current_value ng-options=\"k as v for (k, v) in languageMap(item)\"></select><div ng-if=\"item.item_name.toLowerCase().includes(\'supported\')\"><div class=col-xs-12 ng-attr-id=\"{{ \'item-\' + item.id }}\" ng-dropdown-multiselect name=language-options options=languageOptions selected-model=supportedLanguages events=\"{onSelectionChanged: updateSupportedLanguages}\"></div></div></div></div><span class=input-group-btn ng-if=item.system_validation_type><button ng-if=\"item.system_validation_type === \'CONNECTION_URL\'\" ng-if=\"\" ng-click=itemValidation(item) class=\"btn btn-item-verify\" ng-class=\"verifyResult !== null && !verifyInProgress ? (verifyResult === true ? \'btn-success\' : \'btn-danger\') : \'btn-primary\'\" ng-disabled=\"!item.current_value || verifyInProgress\"><span translate>Verify</span> <span class=fa ng-class=\"{ \'fa-spinner fa-spin\': verifyInProgress, \'fa-close\': verifyResult === false && !verifyInProgress, \'fa-check\': verifyResult && !verifyInProgress }\" ng-show=\"verifyInProgress || verifyResult || verifyResult === false\"></span></button></span></div><p class=help-block translate ng-show=validationError>{{ validationError.error }}</p><div class=\"notification notification-responsive\" ng-show=\"systemConfigurationUpload === true\" style=\"position: fixed; top: 10%; left: 50%; transform: translateX(-50%); background-color: #ec0909; color: rgb(248, 246, 246);\n                                            padding: 10px; border-radius: 5px; text-align: center; width: 100%; max-width: 300px; z-index: 1000\"><span translate>Error: upload only .png, .jpeg or .gif image</span> <span class=\"btn btn-xs btn-close pull-right\" ng-click=\"systemConfigurationUpload = false\">X</span></div></div>");
$templateCache.put("app/components/directives/unit-conversion-input/unitConversionInput.template.html","<input id=\"{{ id }}\" name=\"{{ name }}\" class=form-control min=\"{{ min }}\" max=\"{{ max }}\" step=\"{{ step }}\" ng-pattern=pattern type=number>");
$templateCache.put("app/components/directives/upload-feedback/upload-feedback.directive.html","<div class=feedback ng-show=uploadJob><u>Upload result</u> <span class=\"btn btn-sm pull-right\" ng-click=\"uploadJob = null\">X</span><br><p>Total Records: {{ uploadJob.total }}<br>Records Added/Updated: {{ uploadJob.successfully_processed }}<br>Records Rejected: {{ uploadJob.rejected }}</p><p>Flight Movements Added: {{ uploadJob.fpl_added }}<br>Flight Movements Updated: {{ uploadJob.fpl_updated }}</p></div>");
$templateCache.put("app/angular-ids-project/src/components/boxHeader/boxHeader.html","<div class=box-header><h4><i class=\"fa fa-{{::icon}}\"></i> <span translate>{{title}}</span> <a ng-if=pageUrl title=\"{{ \'Open Manual\' | translate }}\" target=_blank ng-href={{pageUrl}}><i class=\"fa fa-info-circle pull-right\"></i></a> <input ng-show=\"::toggle !== null\" class=pull-right id=form-toggle type=checkbox ng-model=toggle><label ng-show=\"::toggle !== null\" class=pull-right for=form-toggle translate>Show Form</label><div ng-hide=suppressDownload class=\"pull-right export-button\"><!-- Export Table Button --></div><div ng-show=showClose ng-click=closeFunc() class=\"btn btn-sm btn-primary btn-header-close pull-right\">X</div></h4></div>");
$templateCache.put("app/angular-ids-project/src/components/dateRange/dateRange.html","<div class=date-range ng-form name=dateRangeForm><!-- Start datepicker --><div class=\"col datepicker\"><label for=end-date><span translate>{{startName}}</span>&nbsp;(<span translate>{{format}}</span>)</label><p class=input-group><date-picker id=start-date type=text ng-change=\"dateChanged(\'start\', start.date)\" ng-pattern=datePickerRegex show-button-bar=false class=form-control datepicker-options=dateOptions uib-datepicker-popup=\"{{ format || dateFormat }}\" ng-model=start.date is-open=start.open ng-required=isRequired close-text=Close ng-attr-title=\"{{start.date ? \'\' : \'Please fill out this field\' | translate}}\"></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"start.open = !start.open\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><!-- End datepicker --><div class=\"col datepicker\"><label for=end-date><span translate>{{endName}}</span>&nbsp;(<span translate>{{format}}</span>)</label><p class=input-group><date-picker name=end id=end-date type=text ng-change=\"dateChanged(\'end\', end.date)\" pad-hours=true ng-pattern=datePickerRegex show-button-bar=false class=form-control datepicker-options=dateOptions uib-datepicker-popup=\"{{ format || dateFormat }}\" ng-model=end.date is-open=end.open ng-required=isRequired close-text=Close ng-attr-title=\"{{end.date ? \'\' : \'Please fill out this field\' | translate}}\"></date-picker><span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"end.open = !open.end\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div>");
$templateCache.put("app/angular-ids-project/src/components/download/download.html","<div ng-class=\"{\'open\': toggleDropdown}\" class=dropdown><button ng-click=\"toggleDropdown = !toggleDropdown\" class=\"btn btn-primary dropdown-toggle\" type=button id=download-button data-toggle=dropdown aria-haspopup=true aria-expanded=true><span ng-transclude><!-- text --></span> <span class=caret></span></button><ul ng-click=\"toggleDropdown = false\" class=dropdown-menu aria-labelledby=download-button><li ng-repeat=\"type in types\"><a ng-show=\"notImplementedTypes.indexOf(type) !== -1\" not-implemented target=_blank href=\"{{ url }}&format={{ type }}\">{{type.toUpperCase()}}</a> <a ng-show=\"notImplementedTypes.indexOf(type) === -1\" target=_blank href=\"{{ url }}&format={{ type }}\">{{type.toUpperCase()}}</a></li></ul></div>");
$templateCache.put("app/angular-ids-project/src/components/dynamicServiceDropdown/dynamicServiceDropdown.html","<div class=dynamic-service-dropdown><div ng-if=\"dropdownType === \'single\'\"><select ng-class=class ng-disabled=disabled class=form-control ng-model=ngModel.$viewValue ng-options=\"{{ ngOptions }}\" ng-required=isRequired><option translate ng-if=allowEmpty value=\"\"></option></select></div><div ng-if=\"dropdownType === \'multiple\'\"></div></div>");
$templateCache.put("app/angular-ids-project/src/components/dynamicChart/dynamicChart.html","<div class=dynamic-chart><div bind-html-compile=chart></div></div>");
$templateCache.put("app/angular-ids-project/src/components/errorHandling/errorHandling.html","<div ng-show=\"error && error.data && (error.data.error || error.data.error_description || error.data.form_errors.length)\" ng-class=\"{\n        \'error-handling-container\': !(error.data.error && error.data.error.startsWith(\'Route\')),\n        \'error-handling-modal\': error.data.error && error.data.error.startsWith(\'Route\')\n     }\"><div class=\"alert alert-dismissible alert-danger alert-icon\" role=alert><button id=error_button type=button ng-click=\"error = null\" class=close data-dismiss=alert>×</button> <span class=\"glyphicon glyphicon-exclamation-sign icon\" aria-hidden=true></span> <span ng-show=\"error.data.error || error.data.error_description\"><strong translate>Error:</strong> <span class=error-text translate>{{ error.data.error ? error.data.error : \'Unknown error\' }}</span><p ng-show=\"error.data.error_description || error.data.message\"><strong translate>Description:</strong> <span translate>{{ error.data.error_description ? error.data.error_description : error.data.message ? error.data.message : \'Unknown error\' }}</span></p></span><p ng-if=\"error.data.form_errors || error.data.field_errors.length\"><strong ng-hide=error.data.hide_subtitle>{{\'Field errors\' | translate}}:</strong></p><p ng-repeat=\"item in error.data.form_errors\"><span translate>{{ item.field }}</span>: <span translate>{{ item.message }}</span></p><p ng-repeat=\"item in error.data.field_errors\"><span translate>{{ item.field }}</span>: <span translate>{{ item.message || \'Missing or duplicate value\' }}</span></p><p></p></div></div>");
$templateCache.put("app/angular-ids-project/src/components/errorHandling/errorHandling.template.html","<div ng-if=\"error && error.error\" class=row><div class=col-xs-12><error-handling error=error.error><!-- Error Handling --></error-handling></div></div>");
$templateCache.put("app/angular-ids-project/src/components/footer/footer.html","<div class=footer><div class=footer-bg></div><div class=\"footer-content text-muted\"><p class=\"text-left pull-left\"><span id=footer-detail><span>&copy; {{ ::serverTime | date : \'yyyy\' }} - IDS AirNav <i class=\"fa fa-clock-o\"></i> <span>{{ serverTime | dateConverter : \'HH:mm\' }}</span></span></span></p><p class=text-right>{{ \'Version\' | translate }} {{ ::buildVersion }}</p></div></div>");
$templateCache.put("app/angular-ids-project/src/components/headerBar/headerBar.html","<div id=header-bar><a ng-click=toggleSideBar() class=\"hamburger-menu visible-xs-inline\" href=# onclick=\"return false\"><span class=\"glyphicon glyphicon-menu-hamburger\" aria-hidden=true></span> </a><a ui-sref=main.home></a> <img class=logo alt=\"{{ logoName }}\" ng-src=\"{{ logoUrl }}\"><h1>ARMS</h1><a ui-sref=main.home></a><div ng-class=\"{\'open\': openDropdown}\" class=\"dropdown pull-right hidden-xs\"><button ng-click=\"openDropdown = !openDropdown\" class=\"btn btn-default dropdown-toggle\" type=button id=header-drop-menu data-toggle=dropdown aria-haspopup=true aria-expanded=false><span>{{ user.login }}</span> <span class=caret></span></button><ul ng-mouseleave=\"openDropdown = false\" class=dropdown-menu aria-labelledby=header-drop-menu><li class=text-center ng-show=user.login><div class=btn-group ng-click=onButtonGroupClick($event)><button ng-click=\"changeMode(\'map-mode\')\" class=\"btn btn-default\" ng-class=\"{ \'active\' : mode == \'map-mode\' }\"><i class=\"fa fa-globe\"></i></button> <button ng-click=\"changeMode(\'split-mode\')\" class=\"btn btn-default\" ng-class=\"{ \'active\' : mode == \'split-mode\' }\"><i class=\"fa fa-clone\"></i></button> <button ng-click=\"changeMode(\'content-mode\')\" class=\"btn btn-default\" ng-class=\"{ \'active\' : mode == \'content-mode\' }\"><i class=\"fa fa-edit\"></i></button></div></li><span ng-show=language.enabled><li role=separator class=divider></li><li class=text-center><div class=btn-group ng-click=onButtonGroupClick($event)><button ng-class=\"{ \'active\' : language.selected.code === lang.code }\" ng-repeat=\"lang in language.supported\" ng-click=changeLanguage(lang) class=\"btn btn-default\">{{lang.code}}</button></div></li></span><li role=separator class=divider></li><li ng-show=user.login><a href ng-click=logout()><i class=\"fa fa-sign-out\"></i> <span translate class=bg-scope>Logout</span></a></li></ul></div><div class=\"dropdown pull-right hidden-xs\" style=\"padding-top: 10px; padding-right: 15px\" ng-if=!isSelfCare>AMHS Activity Status</div><div class=\"dropdown pull-right hidden-xs\" style=\"padding-top: 10px; padding-right: 15px\" ng-if=!isSelfCare><i class=\"fa fa-exchange fa-sm circle circle-green\" aria-hidden=true uib-tooltip=\"Connection Ok\" tooltip-append-to-body=true tooltip-placement=bottom ng-show=\"agent_status.started && agent_status.installed\"></i> <i class=\"fa fa-exchange fa-sm circle circle-grey\" aria-hidden=true uib-tooltip=\"No Connection\" tooltip-append-to-body=true tooltip-placement=bottom ng-show=\"((!agent_status.started && agent_status.installed) || (agent_status.started && !agent_status.installed) || (!agent_status.started && !agent_status.installed))\"></i></div><div class=\"dropdown pull-right hidden-xs\" style=\"padding-top: 10px;padding-right: 15px\" ng-if=!isSelfCare>Operations</div><div class=\"dropdown pull-right hidden-xs\" style=\"padding-top: 10px; padding-right: 15px\" ng-if=!isSelfCare><i class=\"fa fa-gears fa-sm circle-custom\" ng-class=\"{\n            \'circle-custom-green blink\': isBlinking === true,\n            \'circle-custom-grey\': isBlinking === false\n        }\" ng-click=\"getLastOperation(); openModal(); stopBlinking()\"></i></div><div id=last-operations-modal-holder ng-if=!isSelfCare><!-- Last Operation Modal --></div></div>");
$templateCache.put("app/angular-ids-project/src/components/headerBar/jobs.template.html","<modal-movable class=modal-movable><div><div class=modal-header><h5 class=\"modal-title text-center\" id=modal-title translate>Last Operations</h5></div><div id=modal-body><div><table class=\"table table-fixed table-bordered table-hover table-condensed\"><thead><tr><th>Flight ID</th><th>User</th><th>Started</th><th>Status</th><th>Processed</th><th>Updated</th></tr></thead><tbody><tr ng-repeat=\"jobForNotification in listOperations\" ng-class=\"{\n                            \'bg-success\': jobForNotification.job_execution_status === \'COMPLETED\',\n                            \'bg-danger\': jobForNotification.job_execution_status === \'CANCELED\' || jobForNotification.job_execution_status === \'BLOCKED\' || jobForNotification.job_execution_status === \'FAILED\'\n                        }\"><td>{{ getFlightIdsAsString(jobForNotification.job_parameters) || \'Recalculation from Aviation Billing\'}}</td><td>{{ jobForNotification.job_parameters.split(\';\')[1].split(\'=\')[1] }}</td><td>{{ jobForNotification.start_time | dateConverter: \'HH:mm\' }}</td><td>{{ jobForNotification.job_execution_status | translate }}</td><td>{{ jobForNotification.total_steps }}</td><td>{{ jobForNotification.steps_completed + job.steps_aborted }}</td></tr></tbody></table></div></div></div></modal-movable>");
$templateCache.put("app/angular-ids-project/src/components/input/input.tooltip.html","<span class=errors><span ng-messages=errorTooltip role=alert><div ng-message=\"{{ key }}\" ng-repeat=\"(key, value) in errorMessages\"><!-- translatable value of error tooltip --> <span translate>{{ ::value }}</span>\\<!-- additional dynamic tooltip parameters --> <span ng-if=\"errorTooltip.patternFormat && key === \'patternFormat\'\">({{ ::errorTooltip.patternFormat }})</span> <span ng-if=\"minLength && (key === \'minlength\' || key === \'pwcheck-minlength\')\">({{ ::minLength }})</span></div></span></span>");
$templateCache.put("app/angular-ids-project/src/components/password/password.html","<div class=row><div class=\"col-xs-12 col-md-6\"><label for=password1 translate>{{ name1 }}</label><input id=password1 ng-paste=$event.preventDefault(); class=form-control name=password type=password min-length=\"{{ minLength }}\" ng-blur=\"checkPasswords(password1, password2)\" ng-change=\"checkPasswords(password1, password2)\" ng-model=password1 autocomplete=new-password ng-model-options=\"{ allowInvalid: true }\"></div><div class=\"col-xs-12 col-md-6\"><label for=password2 translate>{{ name2 }}</label><input id=password2 ng-paste=$event.preventDefault(); class=form-control name=passwordConfirm type=password min-length=\"{{ minLength }}\" ng-blur=\"checkPasswords(password1, password2)\" ng-change=\"checkPasswords(password1, password2)\" ng-model=password2 autocomplete=new-password ng-model-options=\"{ allowInvalid: true }\"></div></div>");
$templateCache.put("app/angular-ids-project/src/components/popup/popup.template.html","<div class=\"confirm-popup padding-20\"><div class=row><div class=col-xs-12>{{text | translate}}<div ng-if=saveAs><input class=form-control type=text ng-model=$parent.inputText ng-change=setName($parent.inputText)></div></div></div><div class=row ng-if=createWarning><div class=\"col-xs-12 warning\">{{createWarning | translate}}</div></div><div class=row ng-if=updateWarning><div class=\"col-xs-12 warning\">{{updateWarning | translate}}</div></div><div class=row ng-if=deleteWarning><div class=\"col-xs-12 warning\">{{deleteWarning | translate}}</div></div><div class=\"row margin-top-20\"><div class=col-xs-12><button translate type=button class=\"btn btn-primary\" ng-disabled=\"saveAs && !$parent.inputText\" ng-click=confirm()>Confirm</button> <button translate type=button class=\"btn btn-primary\" ng-click=close()>Cancel</button></div></div></div>");
$templateCache.put("app/angular-ids-project/src/components/recaptcha/recaptcha.html","<div class=margin-top-20 ng-if=\"requireCaptcha && loginFromBilling !== false\"><div vc-recaptcha key=publicKey on-success=setResponse(response) on-expire=recaptchaExpire() on-create=onWidgetCreate(widgetId)></div></div>");
$templateCache.put("app/angular-ids-project/src/components/sideBar/sideBarCategory.html","<li ng-class=\"{ active: SideBarCategory.active, open: SideBarCategory.categoryOpen }\" ng-click=\"SideBarCategory.categoryOpen = !SideBarCategory.categoryOpen\"><span><i class=\"fa fa-{{ SideBarCategory.icon }}\"></i> <span translate>{{SideBarCategory.text}}</span></span><ul class=dropdown-menu ng-transclude></ul></li>");
$templateCache.put("app/angular-ids-project/src/components/sideBar/sideBarLink.html","<li ng-class=\"{\'active\': SideBarLink.active}\" ng-click=\"SideBarLink.goTo(); $event.stopPropagation();\"><span><i class=\"fa fa-{{ SideBarLink.icon }}\"></i> <span translate>{{ SideBarLink.category }}</span></span></li>");
$templateCache.put("app/angular-ids-project/src/components/uploadFileFormat/uploadFileFormat.html","<button class=\"btn btn-primary\" ng-click=showFileFormat();>{{ \'Format\' | translate }}</button>");
$templateCache.put("app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler-sc.template.html","<label for=document_filename><span ng-show=patternSc>{{ fileUploadLabel | translate }} ({{patternSc}})</span> <span ng-show=!patternSc>{{ fileUploadLabel | translate }}</span> <span ng-if=fileUploadRequired>*</span></label><div class=input-group><input id=document_filename class=form-control ng-model=editable.uploaded_document_name type=text ng-disabled=fileUploadDisabled> <span class=input-group-btn><button type=button class=\"btn btn-default\" ngf-select=parseSc($file); ngf-accept=\"\'{{ patternSc }}\'\" ngf-multiple=\"{{ multiple }}\" ng-click=\"file_expiry.open = !file_expiry.open\" ng-disabled=fileUploadDisabled><i class=\"fa fa-upload\"></i></button></span></div><!-- check \'acceptedFileType\' explicitly for false because value is undefined or null on page load --><p ng-if=\"editable.uploaded_document_name && acceptedFileTypeAircraftRegistration === false\" class=text-danger><span translate>Invalid file type: File must be a</span> <span>{{patternSc}}</span> <span translate>file.</span></p>");
$templateCache.put("app/angular-ids-project/src/helpers/controllers/crud-file-handler/crud-file-handler.template.html","<label for=document_filename><span ng-show=pattern>{{ fileUploadLabel | translate }} ({{pattern}})</span> <span ng-show=!pattern>{{ fileUploadLabel | translate }}</span> <span ng-if=fileUploadRequired>*</span></label><div class=input-group><input id=document_filename class=form-control ng-model=editable.document_filename type=text ng-disabled=fileUploadDisabled> <span class=input-group-btn><button type=button class=\"btn btn-default\" ngf-select=parse($file); ngf-accept=\"\'{{ pattern }}\'\" ngf-multiple=\"{{ multiple }}\" ng-click=\"file_expiry.open = !file_expiry.open\" ng-disabled=fileUploadDisabled><i class=\"fa fa-upload\"></i></button></span></div><!-- check \'acceptedFileType\' explicitly for false because value is undefined or null on page load --><p ng-if=\"editable.uploaded_document_name && acceptedFileTypeAircraftRegistration === false\" class=text-danger><span translate>Invalid file type: File must be a</span> <span>{{pattern}}</span> <span translate>file.</span></p>");
$templateCache.put("app/angular-ids-project/src/helpers/controllers/crud-file-handler/preview.template.html","<div class=box-container style=\"position: fixed; top: 40px; left: 50%; transform: translateX(-50%); z-index: 9999; background: white; padding: 20px; border: 1px solid #ccc; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.5); max-width: 90%; max-height: 85vh; overflow: hidden\"><button type=button ng-click=close() style=\"position: absolute; top: 10px; right: 10px; background: transparent; border: none; font-size: 24px; cursor: pointer\">&times;</button><box-header icon=\"\'cloud\'\" title=\"{{ \'Preview Air Navigation Charges File\' | translate }}\"></box-header><div class=box-content style=\"overflow-y: auto; max-height: 70vh; margin-top: 20px\"><div class=row><div class=\"col-xs-12 table-responsive\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr ng-repeat=\"i in text.headers\"><th translate class=text-center ng-repeat=\"j in i\" colspan={{j.width}}>{{j.title | translate}}</th></tr></thead><tbody><tr ng-repeat=\"i in text.data\"><td class=text-center ng-repeat=\"j in i track by $index\">{{j}}</td></tr></tbody></table></div></div></div></div>");}]);